const _ = {
  T_50_XYL_2NBCL_BLOODMOON_SKYBOX: "Tsukuyomi ব্যাকগ্রাউন্ড",
  BR_WORKSHOP_INVALID_PERFORMANCE_COST: "অতিরিক্ত সিন অ্যাসেট-এর কারণে পাবলিশ করতে ব্যর্থ হয়েছে। অনুগ্রহ করে কিছু অ্যাসেট ডিলিট করুন এবং আবার ট্রাই করুন।",
  BR_WORKSHOP_NO_PERMISSION_PUB_MONETIZATION_MAP: "বর্তমানে মেম্বারশিপ-রিলেটেড ফিচারগুলোতে অ্যাক্সেস করার অনুমতি নেই",
  T_12_I_GIFT_SENDER_BELL: "বেল",
  T_12_L_ACCESSORY_COS_MOTORHELMET_DESC: `Now you see him, now you don'
t. [FFB300](Hides Helmet)[-]`,
  T_12_L_ACCESSORY_COS_SANTAHEAD: "Old Man's Mask",
  T_12_L_COS_PINKMAN: "Pink Dino",
  T_12_L_COS_POLAR: "Polar Bear",
  T_12_L_COS_RENDER: "Rainbow Dino",
  T_12_L_COS_TIGER: "Tiger Suit",
  T_12_L_MALE_BOTTOM_COS_ELF: "Winter Elf (Bottom)",
  T_12_L_MALE_COS_SANTA: "গ্রাম্পি বুড়ো মানুষ",
  T_12_L_MALE_HAIR_COS_ELF: "Winter Elf (Head)",
  T_12_L_MALE_SHOE_COS_ELF: "Winter Elf (Shoes)",
  T_12_L_MALE_TOP_COS_ELF: "Winter Elf (Top)",
  T_12_O_CAT_NAME: "কিটি",
  T_12_O_M1014_CHRISTMAS_NAME: "M1014-উইন্টারল্যান্ডস",
  T_12_O_MACHETE_GOLD_NAME: "গোল্ডেন ব্লেড",
  T_12_O_PET_TITLE: "পেট",
  T_12_Q_ITEM_AN94: "AN94",
  T_12_Q_ITEM_DOUBLEJUMPSHOE: "জাম্পিং জুতা",
  T_12_Q_ITEM_DOUBLEJUMPSHOE_DESC: "আধুনিক প্রযুক্তিতে তৈরি জুতা। মানুষকে দ্বিগুন-জাম্প করতে সাহায্য করে।",
  T_12_Q_ITEM_FLYSHOE: "জেট প্যাক জুতা",
  T_12_Q_ITEM_FLYSHOE_DESC: "এমন জুতা, যা ব্যবহারকারীকে উড়তে সাহায্য করে। শূন্যে উড়ার সময় খেয়াল রাখুন যেনো  জ্বালানি না ফুরিয়ে যায়।",
  T_12_Q_ITEM_STOCK1: "স্টক লেভেল 1",
  T_12_Q_ITEM_STOCK2: "স্টক লেভেল 2",
  T_12_Q_ITEM_STOCK3: "স্টক লেভেল 3",
  T_12_Q_ITEM_TREATMENTGUN: "হিল পিস্তল",
  T_12_Q_ITEM_VEST4: "ভেস্ট লেভেল 4",
  T_12_R_CHARACTER_GANGLEADER_NAME: "আন্তোনিও",
  T_12_R_CHARACTER_MONKEYGOD_NAME: "উকং",
  T_12_R_EMOTE_SHOOTDANCE_NAME: "Shoot Dance",
  T_12_R_EMOTE_WAVE_NAME: "Arm Wave",
  T_12_R_SKILL_NAME_GANGLEADER: "গ্যাংস্টারে'র আত্মা",
  T_12_R_SKILL_NAME_MONKEYGOD: "ছদ্মবেশ",
  T_13_I_COLLECTION_V_AMPHIBIAN: "Amphibian Car",
  T_13_I_COLLECTION_V_JEEP: "Jeep",
  T_13_I_COLLECTION_V_MONSTER: "মনস্টার ট্রাক",
  T_13_I_COLLECTION_V_MOTOBIKE: "মোটরবাইক",
  T_13_I_COLLECTION_V_ROADSTER: "Sports Car",
  T_13_I_COLLECTION_V_SUV: "Pickup Truck",
  T_13_I_COLLECTION_V_TUTU: "Tu Tu Car",
  T_13_L_MALE_ACCESSORY_COS_BJD: "Arctic Blue (Mask)",
  T_13_L_MALE_BOTTOM_COS_VALENTINE: "Love in the Air (Bottom)",
  T_13_L_MALE_HAIR_COS_BJD: "Arctic Blue (Head)",
  T_13_L_MALE_TOP_COS_VALENTINE: "Love in the Air (Top)",
  T_13_M_PVE_MATCH_SUMMARY_WEAPON: "অস্ত্র",
  T_13_O_PETSKIN_OCELOT_CAT_NAME: "পেট স্কিন: গোয়েন্দা কিটি",
  T_13_O_SCAR_VALENTINE_NAME: "SCAR- কিউপিড",
  T_13_R_CHARACTER_HACKERGIRL_NAME: "মোকো",
  T_13_R_EMOTE_BABYSHARK_NAME: "Baby Shark",
  T_13_R_EMOTE_BOMBSQUAD_NAME: "Push-up",
  T_13_R_EMOTE_EGYPT_NAME: "Mummy Dance",
  T_13_R_PVE_WEAPON_SLOT: "ওয়েপন স্লট",
  T_13_R_PVE_WEAPONSKIN_RANGE: "কার্যকরী রেঞ্জ",
  T_13_R_PVE_WEAPONSKIN_SPEED: "ফায়ার রেট",
  T_13_R_SKILL_DESC_HACKERGIRL: "ট্যাগ প্রতিপক্ষদের[FFB300]{0}s[-] এর হিট করে। তথ্য টিমমেটদের সাথে শেয়ার করা হবে।",
  T_13_R_SKILL_NAME_HACKERGIRL: "হ্যাকারে'র চোখ",
  T_13_Z_KICKOFF_BAN: "ব্যান",
  T_13_Z_ROOM_MORNING: "দিন",
  T_13_Z_ROOM_NIGHT: "রাত",
  T_14_G_ITEM_KATANA: "কাটানা",
  T_14_I_HEADPIC_SONGKRAN_NAME: "SPLASH!",
  T_14_L_ACCESSORY_COS_EASTERHEAD2: "Cubic Bunny",
  T_14_L_COS_EASTER: "Observer 1937",
  T_14_L_FEMALE_SHOE_COS_FIREFIGHTERS: "Lady of Flame (Shoes)",
  T_14_L_MALE_ACCESSORY_COS_EASTERRABBIT: "Bunny Warrior (Mask)",
  T_14_O_AK_WATERSPLASHING_NAME: "AK47- ওয়াটার বেলুন",
  T_14_O_DOG_NAME: "মেকানিক্যাল পাপ",
  T_14_O_PETSKIN_IRON_DOG_NAME: "পেট স্কিন: সম্পূর্ণ স্টিলের কুকুরছানা",
  T_14_O_PETSKIN_LIGNTNING_DOG_NAME: "পেট স্কিন: লাইটনিং পাপ",
  T_14_O_PETSKIN_MAGNETIC_DOG_NAME: "পেট স্কিন: ম্যাগনেটিক পাপ",
  T_14_O_PETSKIN_NIGHT_CAT_NAME: "পেট স্কিন: নাইট কিটি",
  T_14_O_SCAR_BLOODMOON_NAME: "SCAR- ব্লাড মুন",
  T_14_O_SCAR_SHARK_NAME: "SCAR- শার্ক অ্যাটাক",
  T_14_Q_ITEM_RGS50: "RGS50",
  T_14_R_CHARACTER_SAMURAI_NAME: "হায়াতো",
  T_14_R_SKILL_DESC_SAMURAI: "প্রতি [FFB300]{0}%[-] HP হ্রাসের সাথে, আর্মর পেনেট্রেশন [FFB300]{1}%[-] বৃদ্ধি পায়।",
  T_14_R_SKILL_NAME_SAMURAI: "বুশিদো",
  T_15_L_MALE_ACCESSORY_COS_FAIM: "Hunger Strike (Mask)",
  T_15_L_MALE_ACCESSORY_COS_PESTILENCE: "Venom Touch (Mask)",
  T_15_L_MALE_BOTTOM_COS_FAIM: "Hunger Strike (Bottom)",
  T_15_L_MALE_BOTTOM_COS_PESTILENCE: "Venom Touch (Bottom)",
  T_15_L_MALE_SHOE_COS_FAIM: "Hunger Strike (Shoes)",
  T_15_L_MALE_SHOE_COS_PESTILENCE: "Venom Touch (Shoes)",
  T_15_L_MALE_TOP_COS_FAIM: "Hunger Strike (Top)",
  T_15_L_MALE_TOP_COS_PESTILENCE: "Venom Touch (Top)",
  T_15_L_TOP_COS_MOTHERSDAY: "Best Mom",
  T_15_O_AN94_APOCALYPSE_NAME: "AN94- ক্যাটাক্লিজম",
  T_15_O_BASEBALLBAT_VIKING_NAME: "দ্য ভাইকিং",
  T_15_O_M1014_APOCALYPSE_NAME: "M1014- ক্যাটাক্লিজম",
  T_15_O_M4A1_APOCALYPSE_NAME: "M4A1- ক্যাটাক্লিজম",
  T_15_O_PANTHER_NAME: "নাইট প্যান্থার",
  T_15_O_PETSKIN_CAPTAIN_PANTHER_NAME: "পেট স্কিন: ক্যাপ্টেন",
  T_15_O_PETSKIN_GOLDEN_PANTHER_NAME: "পেট স্কিন: গোল্ডেন লিওপার্ড",
  T_15_O_PETSKIN_PURPLE_PANTHER_NAME: "পেট স্কিন: আধিপত্য",
  T_15_O_SKS_DEATH_NAME: "SKS- ডিথ উইশ",
  T_15_O_UMP_APOCALYPSE_NAME: "UMP- ক্যাটাক্লিজম",
  T_15_Q_ITEM_CG15: "CG15",
  T_15_Q_ITEM_GATLING: "গ্যাটলিং",
  T_15_R_CHARACTER_AGENT_NAME: "লরা",
  T_15_R_EMOTE_LETSGROOVE_NAME: "Shake With Me",
  T_15_R_SKILL_DESC_AGENT: "স্কোপ করার সময় অ্যাক্যুরেসি [FFB300]{0}%[-] বৃদ্ধি পায়।",
  T_15_R_SKILL_NAME_AGENT: "শার্প শুটার",
  T_15_W_BACKPACK_MECHGIRL_NAME: "Purple Wings",
  T_16_B_ITEM_GRAPPLINGHOOK: "হুক",
  T_16_B_ITEM_GRAPPLINGHOOKGUN: "হুক গান",
  T_16_L_MALE_COS_LEGO: "Mad Brickman",
  T_16_L_MALE_SHOE_COS_SUMMER: "Summer Holidays (Shoes)",
  T_16_P_MANUAL_MONSTER: "মনস্টার ট্রাক",
  T_16_P_MANUAL_MUSHROOM1: "মাশরুম লেভেল1",
  T_16_P_MANUAL_MUSHROOM2: "মাশরুম লেভেল2",
  T_16_P_MANUAL_MUSHROOM3: "মাশরুম লেভেল3",
  T_16_P_MANUAL_MUSHROOM4: "মাশরুম লেভেল4",
  T_16_P_MANUAL_ROADSTER_DESC: "স্টাইলিশ স্পোর্টস কার। এর HP কম, কিন্তু অবিশ্বাস্য সর্বোচ্চ গতি রয়েছে। 2 জন পর্যন্ত প্লেয়ারকে বহন করতে পারে।",
  T_16_P_MANUAL_STROP: "জিপলাইন",
  T_16_P_MANUAL_SUV: "ট্রাক পিকআপ করুন",
  T_16_P_MANUAL_SUV_DESC: "এটি Free Fire এর শ্রেষ্ট গাড়ি। মাঝারি বর্ম এবং সর্বোচ্চ গতি। 2 জন পর্যন্ত প্লেয়ারকে বহন করতে পারে।",
  T_16_P_MANUAL_TUTU_DESC: "কম HP এবং ধীর গতির একটি গাড়ি। 3 জন পর্যন্ত প্লেয়ারকে বহন করতে পারে।",
  T_16_P_MANUAL_WEAPON_AR: "রাইফেল",
  T_16_P_MANUAL_WEAPON_BOMB: "গ্রেনেড",
  T_16_P_MANUAL_WEAPON_PISTOL: "পিস্তল",
  T_16_P_MANUAL_WEAPON_SG: "শটগান",
  T_16_P_MANUAL_WEAPON_SMG: "SMG",
  T_16_P_MANUAL_WEAPON_SR: "স্নাইপার",
  T_16_Q_MINISENTRY: "মিনি টারেট",
  T_16_Q_MINISENTRY_DESC: "আধুনিক প্রযুক্তিতে তৈরি অটো টারেট। এটি স্ক্যান করবে এবং কাছাকাছি থাকা প্রতিপক্ষদের আক্রমণ করবে।",
  T_16_R_EMOTE_DESERT_NAME: "Furious Slam",
  T_16_R_EMOTE_EPHUNTER_NAME: "Battle Dance",
  T_16_R_EMOTE_EPHUNTER2_NAME: "High Five",
  T_16_R_EMOTE_KICKTHEMOON_NAME: "মুন ফ্লিপ",
  T_16_R_EMOTE_WIGGLEWALK_NAME: "উইগেল ওয়াক",
  T_16_W_AK_FIRE_NAME: "AK47- ফ্লেমিং রেড",
  T_16_W_SCAR_LLENN_NAME: "SCAR- পিঙ্ক ডেভিল",
  T_16_W_SCAR_WATER_NAME: "SCAR- ওয়াটার ইলিমেন্টাল",
  T_16_Y_CHARACTER_HITMAN_NAME: "রাফায়েল",
  T_16_Y_PANDA_NAME: "গোয়েন্দা পান্ডা",
  T_16_Y_PETSKIN_BROWN_PANDA_NAME: "পেট স্কিন: ওয়াইল্ড পান্ডা",
  T_16_Y_PETSKIN_SKELETON_PANDA_NAME: "পেট স্কিন: স্কাল পান্ডা",
  T_16_Y_PETSKIN_THOR_PANDA_NAME: "পেট স্কিন: লাইটনিং পান্ডা",
  T_17_B_CS_MODE_NAME: "ক্ল্যাশ স্কোয়াড",
  T_17_C_SKILL_NAME_PLAYBOY: "নাটি মুভমেন্ট",
  T_17_L_FEMALE_ACCESSORY_COS_JOKER_ROYAL: "Royal Jester (Mask)",
  T_17_L_FEMALE_ACCESSORY_COS_VAMPIRE: "Bloody Mistress (Mask)",
  T_17_L_FEMALE_BOTTOM_COS_VAMPIRE: "Bloody Mistress (Bottom)",
  T_17_L_FEMALE_HAIR_COS_SELVEDGEWORK: "ম্যাজিকাল ফক্স (হেড)",
  T_17_L_FEMALE_SHOE_COS_VAMPIRE: "Bloody Mistress (Shoes)",
  T_17_L_FEMALE_TOP_COS_VAMPIRE: "Bloody Mistress (Top)",
  T_17_L_MALE_ACCESSORY_COS_VAMPIRE: "Vampire's Revenge (Mask)",
  T_17_L_MALE_BOTTOM_COS_BOSOZOKU: "Street Thug (Bottom)",
  T_17_L_MALE_BOTTOM_COS_VAMPIRE: "Vampire's Revenge (Bottom)",
  T_17_L_MALE_HAIR_COS_FFUNIT: "Purple Shade (Head)",
  T_17_L_MALE_SHOE_COS_INDEPENDENCE: "The Gentleman (Shoes)",
  T_17_L_MALE_SHOE_COS_VAMPIRE: "Vampire's Revenge (Shoes)",
  T_17_L_MALE_TOP_COS_VAMPIRE: "Vampire's Revenge (Top)",
  T_17_L_MALE_TOP_COS_YINYANG_GOLD: "Golden Shade (Top)",
  T_17_O_PETSKIN_ANNIVERSARY_CAT_NAME: "পেট স্কিন: মিয়ু রাজকুমারী",
  T_17_O_PETSKIN_EARTHDRAGON_SHIBA_NAME: "পেট স্কিন: গোল্ডেন টেইল",
  T_17_O_PETSKIN_ELECTRICDRAGON_SHIBA_NAME: "পেট স্কিন: গভীর নীল",
  T_17_O_PETSKIN_GREENDRAGON_SHIBA_NAME: "পেট স্কিন: লাকি গ্রীন",
  T_17_O_SHIBA_NAME: "শিবা",
  T_17_Q_FOLDWINGS: "গ্লাইডার",
  T_17_Q_FOLDWINGS_DESC: "আপনাকে উঁচু ভূখণ্ড থেকে নিচে নামতে দেয়।",
  T_17_Q_SUPERHEAT: "প্লাজমা",
  T_17_R_EMOTE_PARTYDANCE_NAME: "Party Dance",
  T_17_W_FAMAS_VAMPIRE_NAME: "FAMAS- ভ্যাম্পায়ার",
  T_17_W_SCAR_ASSASSIN_NAME: "SCAR- ফ্যান্টম অ্যাসাসিন",
  T_17_W_SCAR_PLAYBOY_NAME: "SCAR- ওল্ড ফ্যাশনড",
  T_17_Y_CHARACTER_MADEMANA_NAME: "এ124",
  T_17_Y_CHARACTER_PLAYBOY_NAME: "জোসেফ",
  T_17_Z_CS_NAME: "নাম",
  T_17_Z_ROOM_JUMP_SWITCH: "লাফের উচ্চতা",
  T_17_Z_ROOM_SPEED_SWITCH: "মুভমেন্ট স্পিড",
  T_18_B_THROWINGKNIFE_NAME: "FF ছুরি",
  T_18_C_DUMMY_NAME: "ডিকয় গ্রেনেড",
  T_18_C_SKILL_DESC_DJMALE: "একটি [FFB300]{1}m[-] আভা তৈরি করে, যা মুভমেন্ট স্পিড [FFB300]{3}%[-] বৃদ্ধি করে এবং [FFB300]{0}s[-] ব্যাপী [FFB300]{2} HP/s[-] রিস্টোর করে৷ ইফেক্টগুলো স্ট্যাক করেনা।  কুলডাউন: [FFB300]{4}s[-].",
  T_18_C_SKILL_NAME_DJMALE: "ড্রপ দ্য বিট",
  T_18_C_SKILL_NAME_JUNKENGINEER: "গিয়ার রিসাইকেল",
  T_18_L_COS_INDIANEWYEAR: "Diwali Dino",
  T_18_L_HAIR_COS_HALLOWEEN2019: "Frowny Face",
  T_18_L_MALE_ACCESSORY_COS_BJD2_MAGMA: "Flaming Red (Mask)",
  T_18_O_FOX_NAME: "স্পিরিট ফক্স",
  T_18_O_PETSKIN_BLACKFOX_NAME: "পেট স্কিন: ব্যাটেল ফক্স",
  T_18_O_PETSKIN_BLUEFOX_NAME: "পেট স্কিন: নীল শিয়াল",
  T_18_O_PETSKIN_HALLOWEEN_SHIBA_NAME: "পেট স্কিন: লাভা পাম্পকিন",
  T_18_O_PETSKIN_PINKFOX_NAME: "পেট স্কিন: রেড ফক্স",
  T_18_O_PETSKIN_SPIRIT_PANTHER_NAME: "পেট স্কিন: স্পিরিট",
  T_18_U_WEAPON_M1887_NAME: "M1887",
  T_18_W_M4A1_FIRESKELETON_N: "M4A1- ফ্লেমিং স্কাল",
  T_18_W_UMP_GEISHA_N: "UMP- আর্ট অফ ওয়ার",
  T_18_Y_CHARACTER_DJMALE_N: "আলোক",
  T_18_Y_CHARACTER_JUNKENGINEER_N: "শানি",
  T_19_B_HB_NAME: "বৈদ্যুতিক সার্ফবোর্ড",
  T_19_C_ICE_GUN_NAME: "আইস-গান",
  T_19_C_SKILL_DESC_DEMOLITIONIST: "বিস্ফোরক ওয়েপন ড্যামেজ [FFB300]{0}%[-] বৃদ্ধি পায়, ড্যামেজ রেঞ্জ [FFB300]{1}%[-] বৃদ্ধি পায়।",
  T_19_C_SKILL_DESC_TOMBOY: "ড্রাইভিং এর সময়,  ভেহিক্যালে থাকা প্রত্যেকের জন্য [FFB300]{1} HP[-] প্রতি [FFB300]{0}s[-] রিস্টোর করে। সর্বাধিক [FFB300]{2}[-] HP পর্যন্ত।",
  T_19_C_SKILL_NAME_DEMOLITIONIST: "ধ্বংসের শিল্প",
  T_19_C_SKILL_NAME_TOMBOY: "রেসারে'র আশীর্বাদ",
  T_19_I_EVENT_INFI_ITEM: "আনলিমিটেড",
  T_19_L_A_ICEFESTIVAL19_B: "সর্বশেষ হাসি",
  T_19_L_F_S_ICEFESTIVAL: "Snowy Servitude (Shoes)",
  T_19_L_MALE_BOTTOM_COS_DISCOMAN: "Disco Fiasco (Bottom)",
  T_19_L_MALE_HAIR_COS_DISCOMAN: "Disco Fiasco (Head)",
  T_19_L_MALE_TOP_COS_DISCOMAN: "Disco Fiasco (Top)",
  T_19_O_PETSKIN_NAME: "পেট স্কিন: ডিফল্ট",
  T_19_O_PETSKIN_PANDA_TRAPRAP_NAME: "পেট স্কিন: হিপহপ পান্ডা",
  T_19_O_PETSKIN_PANDA_WINTERFELL_NAME: "পেট স্কিন: পোলার পান্ডা",
  T_19_O_PETSKIN_ROBOT_PHARAOH_NAME: "পেট স্কিন: ফারাও এর রোবো",
  T_19_O_PETSKIN_ROBOT_SPRING_NAME: "পেট স্কিন: বসন্ত উৎসব রোবো",
  T_19_O_PETSKIN_ROBOT_WINTERFELL_NAME: "পেট স্কিন: তুষারময় রোবো",
  T_19_O_PETSKIN_SHIBA_TRAPRAP_NAME: "পেট স্কিন: হিপহপ শিবা",
  T_19_O_ROBOT_NAME: "রোবো",
  T_19_O_TDM_NAME: "টিম ডেথম্যাচ",
  T_19_R_EMOTE_MIGUEL_NAME: "Break dance",
  T_19_S_SECOND_WEAPON_TITLE: "সেকেন্ডারি অস্ত্র",
  T_19_S_VEST_TITLE: "বুলেটপ্রুফ ভেস্ট",
  T_19_U_DOUBLEMAGEZINE_ATTACHMENT_NAME: "ডাবল ম্যাগাজিন",
  T_19_W_GROZA_TAGGERCREW_N: "GROZA- ট্যাগার এর বিদ্রোহ",
  T_19_W_M60_ICEFESTIVAL_N: "M60- সান্টার পছন্দ",
  T_19_W_MP40_PARK_N: "MP40- কার্নিভাল হত্যাকাণ্ড",
  T_19_W_SCAR_CNNEWYEAR19_N: "SCAR- অরোস ড্রাগন",
  T_19_X_PVE_SAMURAINAME: "গার্ডিয়ান সামুরাই",
  T_19_Y_CHARACTER_DEMOLITIONIST_N: "আলভারো",
  T_19_Y_CHARACTER_TOMBOY_N: "নটোরা",
  T_20_C_INHALER_NAME: "ইনহেলার",
  T_20_C_SKILL_DESC_PARKOURGUY: "বন্দুক ব্যবহার করার সময়, প্রতিপক্ষকে আঘাত করলে ব্যবহারকারীর জন্য কিছু HP পুনরুদ্ধার হয়, প্রতিপক্ষকে ছিটকে দিলে ব্যবহারকারীর জন্য [FFB300]{0}%[-] HP রিকোভার হয়।",
  T_20_C_SKILL_NAME_GRAFFITIST: "আঁকা আশ্রয়",
  T_20_C_SKILL_NAME_KELLY_AWAKENING: "মারাত্মক বেগ",
  T_20_C_SKILL_NAME_PARKOURGUY: "টেকসই অভিযান",
  T_20_L_A_APRILFOOL2020: "Doggo",
  T_20_L_F_A_METALHEAD_RED: "Ms. Fiery Imp-Head (Mask)",
  T_20_L_F_B_THAIGIRL: "Phoenix Accession (Bottom)",
  T_20_L_F_H_KILLERCUPID: "Sweetheart Cupid (Head)",
  T_20_L_F_H_THAIGIRL: "Phoenix Accession (Head)",
  T_20_L_F_S_THAIGIRL: "Phoenix Accession (Shoes)",
  T_20_L_F_T_METALHEAD_RED: "Ms. Fiery Imp-Head (Top)",
  T_20_L_F_T_THAIGIRL: "Phoenix Accession (Top)",
  T_20_L_JEANDINO: "Denim Dino",
  T_20_L_M_A_METALHEAD_RED: "Mr. Fiery Imp-Head (Mask)",
  T_20_L_M_T_METALHEAD_RED: "Mr. Fiery Imp-Head (Top)",
  T_20_L_M_T_STOCKING: "Gentle-man (Top)",
  T_20_O_PETSKIN_LOVERFOX_NAME: "পোষা প্রাণীর ত্বক: ভ্যালেন্টাইন'স ফক্স",
  T_20_P_CHANNEL_G: "গিল্ড",
  T_20_P_WORLD_SSPEAKER: "লাউডস্পিকার",
  T_20_S_CSROOM_COIN: "ডিফল্ট কয়েন",
  T_20_U_SHIELD_GUN_NAME: "শিল্ড-গান",
  T_20_W_AN94_METALHEAD_N: "AN94- ক্যারট ইম্প-হেড",
  T_20_W_P90_EVILBONE_N: "P90- শাস্তিদাতা",
  T_20_Y_CHARACTER_GRAFFITIST_N: "স্টেফি",
  T_20_Y_CHARACTER_KELLY_AWAKENING_N: 'কেলি "দ্য সুইফট"',
  T_20_Y_CHARACTER_PARKOURGUY_N: "জোটা",
  T_21_B_SMOKEGRENADE_DESC: "ধোঁয়া উৎপন্ন করে, স্ক্রীনিং এবং কৌশলগত লড়াইয়ের জন্য দুর্দান্ত",
  T_21_B_SMOKEGRENADE_NAME: "স্মোক গ্রেনেড",
  T_21_C_AUTOPICKUP_AVERAGE: "ডিফল্ট",
  T_21_C_SKILL_DESC_KPOPSINGER: "একজন টিমমেটকে সাহায্য করার সময়, উল্লিখিত টিমমেট একটি [FFB300]{0} HP[-] শিল্ড এবং [FFB300]{1}%[-] মুভমেন্ট স্পিড বুস্ট করে৷ সফল হেল্প-আপের পরে বুস্ট ইফেক্টগুলো [FFB300]{2}s[-] এর মধ্যে হ্রাস পায়৷ নক-ডাউন হওয়া টিমমেটদের ব্লিডিং স্পিড [FFB300]{3}%[-] কমিয়ে দেয়। ইফেক্টগুলো স্ট্যাক করে না।",
  T_21_C_SKILL_DESC_SOCCERSTAR: "প্রতিটি এলিমিনেশন ম্যাক্স. HP বৃদ্ধি করে [FFB300]{0}[-]. ম্যাক্স. বুস্ট: [FFB300]{1}[-].",
  T_21_C_SKILL_NAME_KPOPSINGER: "হিলিং গান",
  T_21_C_SKILL_NAME_SOCCERSTAR: "হ্যাট্রিক",
  T_21_L_ANGELICAL: "Angel Dino",
  T_21_L_S_VNSLIPPER: "Vietnam Slippers",
  T_21_O_OTTER_NAME: "ওটেরো",
  T_21_O_PETSKIN_OTTER_GREY_NAME: "পেট স্কিন: তেজস্ক্রিয় ওটেরো",
  T_21_O_PETSKIN_OTTER_PINK_NAME: "পেট স্কিন: সাকুরা ওটেরো",
  T_21_O_PETSKIN_OTTER_PURPLE_NAME: "পেট স্কিন: নিয়ন ওটেরো",
  T_21_O_PETSKIN_ROBOT_DEATH_NAME: "পেট স্কিন: মাস্টার অফ ডেথ",
  T_21_O_PETSKIN_SPINE_PANTHER_NAME: "পেট স্কিন: লাইটনিং বোল্ট",
  T_21_R_EMOTE_SORROW_NAME: "Why? Oh Why?",
  T_21_U_WEAPON_THOMPSON_NAME: "থম্পসন",
  T_21_W_BACKPACK_SPINE_N: "Punkster Backpack",
  T_21_W_BASEBALLPOLE_DEATH2020_N: "মৃত্যুর ফাইনাল স্ট্রাইক",
  T_21_W_M79_RABBITKILLER_N: "M79- হিপস্টার বানি",
  T_21_W_PAN_VOLCANO_N: "প্যান- ভলক্যানিক ফিউরি",
  T_21_W_XM8_RAINBOW_N: "XM8- অ্যাবিসাল",
  T_21_Y_CHARACTER_KPOPSINGER_N: "কাপেলা",
  T_21_Y_CHARACTER_SOCCERSTAR_N: "লুকুয়েটা",
  T_22_C_BLT_NAME: "M82B",
  T_22_C_SKILL_DESC_DETECTIVE: "[FFB300]{0}m[-] এর মধ্যে প্রতিপক্ষদের অবস্থান সনাক্ত করুন যারা প্রবণ বা স্কোয়াট অবস্থানে নেই। টিমমেটদের সাথে প্রতিপক্ষের পজিশন শেয়ার করা হয়। [FFB300]{1}s[-] পর্যন্ত স্থায়ী হয়।  কুলডাউন: [FFB300]{2}s[-]।",
  T_22_C_SKILL_NAME_DETECTIVE: "ট্রেসিং পদক্ষেপ",
  T_22_C_SKILL_NAME_STREAMERGUY: "লাইমলাইট",
  T_22_L_F_H_COLLEGE: "Bloodshot Junior (Head)",
  T_22_L_F_S_SUMMER20: "Summer Darling (Shoes)",
  T_22_L_M_A_GREENCOAT: "Lush Clubber (Mask)",
  T_22_L_M_A_PINKFUR: "Sakura Clubber (Mask)",
  T_22_L_M_A_PLAGUE2: "Plague Phantom (Mask)",
  T_22_L_M_B_FAIM2: "Famine Felon (Bottom)",
  T_22_L_M_B_GREENCOAT: "Lush Clubber (Bottom)",
  T_22_L_M_B_PINKFUR: "Sakura Clubber (Bottom)",
  T_22_L_M_B_PLAGUE2: "Plague Phantom (Bottom)",
  T_22_L_M_B_REDPANTS: "Trendy Clubber (Bottom)",
  T_22_L_M_B_TIGERSTRIPE: "Tiger Clubber (Bottom)",
  T_22_L_M_H_COLLEGE: "Bloodshot Senior (Head)",
  T_22_L_M_H_FAIM2: "Famine Felon (Head)",
  T_22_L_M_H_GREENCOAT: "Lush Clubber (Head)",
  T_22_L_M_H_PINKFUR: "Sakura Clubber (Head)",
  T_22_L_M_H_PLAGUE2: "Plague Phantom (Head)",
  T_22_L_M_H_REDPANTS: "Trendy Clubber(Head)",
  T_22_L_M_H_TIGERSTRIPE: "Tiger Clubber (Head)",
  T_22_L_M_S_FAIM2: "Famine Felon (Shoes)",
  T_22_L_M_S_PLAGUE2: "Plague Phantom (Shoes)",
  T_22_L_M_T_FAIM2: "Famine Felon (Top)",
  T_22_L_M_T_GREENCOAT: "Lush Clubber (Top)",
  T_22_L_M_T_PINKFUR: "Sakura Clubber (Top)",
  T_22_L_M_T_PLAGUE2: "Plague Phantom (Top)",
  T_22_L_M_T_REDPANTS: "Trendy Clubber (Top)",
  T_22_L_M_T_TIGERSTRIPE: "Tiger Clubber (Top)",
  T_22_LC_KAR98K_COLLEGE_N: "কার৯৭- রিবেল একাডেমি",
  T_22_LC_PAN_CAPTAINBUBBLE_N: "প্যান- ওয়াটারমেলন",
  T_22_LC_SCAR_HERMIT_N: "SCAR- মিস্টিক সিকার",
  T_22_LC_TREATMENTGUN_APOCALYPSE2_N: "হিল পিস্তল- লাইফবিম",
  T_22_O_HAWK_NAME: "ফ্যালকো",
  T_22_O_PETSKIN_FOX_APOCALYPSE_NAME: "পেট স্কিন: অ্যাপোক্যালিপস ফক্স",
  T_22_O_PETSKIN_HAWK_FIRE_NAME: "পেট স্কিন: হেলফায়ার ফ্যালকো",
  T_22_O_PETSKIN_HAWK_NATURE_NAME: "পেট স্কিন: চিরসবুজ ফ্যালকো",
  T_22_O_PETSKIN_SHIBA_SUMMER_NAME: "পেট স্কিন: সানশাইন শিবা",
  T_22_Q_BOMB_PLIERS: "বিস্ফোরণ পিলার",
  T_22_R_EMOTE_SHIMMY_NAME: "শিমি",
  T_22_U_GOLD_AWM_N: "AWM-Y",
  T_22_U_WPNSKN_BITE: "আর্মর পেনেট্রেশন",
  T_22_U_WPNSKN_SPEED_RUN: "মুভমেন্ট স্পিড",
  T_22_Y_CHARACTER_DETECTIVE_N: "ক্লু",
  T_22_Y_CHARACTER_STREAMERGUY_N: "ওলফ্রাহ",
  T_23_B_CARDIAC_NAME: "হরাইজ্যালাইন",
  T_23_C_SKILL_NAME_HAYATO_AWAKENING: "ব্লেডের শিল্প",
  T_23_C_SKILL_NAME_SWATGUY: "রাগিং রিলোড",
  T_23_D_CHARACTER_HAYATO_AWAKENING_N: 'হায়াতো "ফায়ারব্র্যান্ড"',
  T_23_D_CHARACTER_SWATGUY_N: "জয়",
  T_23_L_F_B_GANGSTERRAP_GOLD: "Big Bucks Vibe (Bottom)",
  T_23_L_F_B_MIKOGIRL: "Arcticfire Priestess (Bottom)",
  T_23_L_F_B_NAVYGIRL: "Navy Girl (Bottom)",
  T_23_L_F_H_GANGSTERRAP_GOLD: "Big Bucks Vibe (Head)",
  T_23_L_F_H_MIKOGIRL: "Arcticfire Priestess (Head)",
  T_23_L_F_H_NAVYGIRL: "Navy Girl (Head)",
  T_23_L_F_S_MIKOGIRL: "Arcticfire Priestess (Shoes)",
  T_23_L_F_S_ORDERCHALLENGER: "Heist Mastermind (Shoes)",
  T_23_L_F_T_GANGSTERRAP_GOLD: "Big Bucks Vibe (Top)",
  T_23_L_F_T_MIKOGIRL: "Arcticfire Priestess (Top)",
  T_23_L_F_T_NAVYGIRL: "Navy Girl (Top)",
  T_23_L_M_A_GANGSTERRAP_GOLD: "Big Bucks Rapper (Mask)",
  T_23_L_M_B_FOXGUY: "Arcticfire Priest (Bottom)",
  T_23_L_M_B_GANGSTERRAP_GOLD: "Big Bucks Rapper (Bottom)",
  T_23_L_M_H_FOXGUY: "Arcticfire Priest (Head)",
  T_23_LC_SKS_GEMINI_N: "SKS-হিস্টেরিয়া",
  T_23_O_PENGUIN_NAME: "মিঃ ওয়াগর",
  T_23_O_PETSKIN_PENGUIN_A_NAME: "পেট স্কিন: পার্টি ওয়াগর",
  T_23_O_PETSKIN_PENGUIN_C_NAME: "পেট স্কিন: সাইবার ওয়াগর",
  T_23_O_PETSKIN_PENGUIN_G_NAME: "পেট স্কিন: গোল্ড ওয়াগর",
  T_23_T_ANNI3_LOBBY_NODENAME20: "ক্ল্যাশ স্কোয়াড",
  T_23_T_ANNI3_LOBBY_NODENAME5: "ক্যারেক্টার",
  T_23_U_AUG: "AUG",
  T_23_Z_R_UID: "ইউআইডি",
  T_24_AD_ADSPACE_WARNING: "সতর্কীকরণ",
  T_24_C_FLAMETHROWER_NAME: "ফ্লেমথ্রোয়ার",
  T_24_C_SKILL_DESC_PROFESSOR: "ম্যাক্স. EP [FFB300]{0}[-] দ্বারা বৃদ্ধি পায়। Jiu-jitsu মোড : সহযোগীরা  [FFB300]{2}m[-]  মধ্যে EP কনভার্শন রেটে [FFB300]{1}%[-] বৃদ্ধি পায়৷ Psychology মোড: প্রতি [FFB300]{4}s[-] এ, সর্বোচ্চ [FFB300]{5} EP[-] পর্যন্ত রিকোভার করুন।  মোড সুইচ কুলডাউন: [FFB300]{3}s[-]।",
  T_24_C_SKILL_NAME_PARTYGIRL: "পার্টি চলছে",
  T_24_C_SKILL_NAME_PROFESSOR: "মাস্টার অফ অল",
  T_24_D_CHARACTER_PARTYGIRL_N: "দাশা",
  T_24_D_CHARACTER_PROFESSOR_N: "কে",
  T_24_L_B_MAXPANTS: "MAX Pants",
  T_24_L_H_PUMPKIN2020_A: "Twisted Pumpkin (Head)",
  T_24_L_T_TSHIRT_COMEDIAN: "Last Shot Hero",
  T_24_LC_MP5_RICHBOXER_N: "MP5- চ্যাম্পিয়ন বক্সার",
  T_24_LC_SCAR_PARTYGIRL_N: "SCAR- পার্টি অ্যানিমাল",
  T_24_LC_SVD_WARRINGSTATES_N: "SVD- সোর্ডসম্যান কিংবদন্তি",
  T_24_U_M21A5: "উডপেকার",
  T_24_U_PARAFAL: "প্যারাফল",
  T_24_V_TRAINING_AIMBOT_GAMESCORE: "সর্বমোট স্কোর",
  T_24_V_TRAINING_BOX_ATTACH: "অ্যাটাচমেন্টস",
  T_24_V_TRAINING_BOX_WEAPON: "অস্ত্রসমূহ",
  T_24_W_ARMORY: "ওয়েপন",
  T_24_W_ARMOTY_MELEE: "মেলি",
  T_24_W_ARMOTY_PISTOL: "পিস্তল",
  T_24_W_ARMOTY_RIFLE: "রাইফেল",
  T_24_W_ARMOTY_SHOTGUN: "শটগান",
  T_24_W_ARMOTY_SNIPER: "স্নাইপার",
  T_24_W_ARMOTY_SPECIAL: "অন্যান্য",
  T_24_W_ARMOTY_SUBMACHINE: "সাব-মেশিন গান",
  T_24_W_PETSKIN_PANDA_BOOYAHDAY_N: "পেটস্কিন: Booyah পান্ডা",
  T_24_W_PETSKIN_RACCOON_BRIGHT_N: "পেটস্কিন: কঙ্কাল রকি",
  T_24_W_PETSKIN_RACCOON_MECH_N: "পেটস্কিন: পার্টি রকি",
  T_24_W_PETSKIN_RACCOON_UNDEAD_N: "পেটস্কিন: অমর রকি",
  T_24_W_RACCOON_N: "রকি",
  T_25_C_SKILL_NAME_BOUNTYHUNTER: "টাইম টার্নার",
  T_25_D_CHARACTER_BOUNTY_N: "ক্রোনো",
  T_25_E_HUD_01: "প্রিসেট 1",
  T_25_E_HUD_02: "প্রিসেট 2",
  T_25_L_F_B_DEMONKILLER: "Frenzy Junior (Bottom)",
  T_25_L_F_H_DEMONKILLER: "Frenzy Junior (Head)",
  T_25_L_F_S_DEMONKILLER: "Frenzy Junior (Shoes)",
  T_25_L_F_T_DEMONKILLER: "Frenzy Junior (Top)",
  T_25_L_HA_FP_EVIL: "ইভিল (ফেসপেইন্ট)",
  T_25_L_M_H_ANIMEHAIR: "Breezy (Hair)",
  T_25_L_S_MAXSNEAKERS: "MAX Sneakers",
  T_25_LC_BASEBALLBAT_BOUNTY_N: "সাইবার সুইং",
  T_25_LC_GLOO_WINTERFEST2020_N: "গ্লু ওয়াল- উইন্টারল্যান্ডস ২০২০",
  T_25_LC_M1887_WINTERFEST2020_N: "M1887- উইন্টারল্যান্ডস ২০২০",
  T_25_LC_MACHETE_BOUNTY_N: "সাইবার ব্লেড",
  T_25_LC_P90_MUSICFALL_GREEN_N: "P90- টিউন ব্লাস্টার গ্রিন",
  T_25_LC_P90_MUSICFALL_RED_N: "P90- টিউন ব্লাস্টার লাল",
  T_25_LC_PAN_BOUNTY_N: "প্যান- সাইবার বাউন্টি হান্টার",
  T_25_R_LEGEND_REMIND: "রিমাইন্ডার",
  T_25_U_MAG7: "ম্যাগ-7",
  T_25_U_SICKLE: "স্কাইথ",
  T_25_U_VECTOR: "ভেক্টর",
  T_25_W_BABOON_N: "বিস্টন",
  T_25_W_PETSKIN_BABOON_FROZEN_N: "পেটস্কিন: গ্লেসিয়ার বিস্টন",
  T_25_W_PETSKIN_BABOON_HELL_N: "পেটস্কিন: ব্লেজিং বিস্টন",
  T_25_W_PETSKIN_BABOON_PURE_N: "পেটস্কিন: গ্রেট হোয়াইট বিস্টন",
  T_25_W_PETSKIN_PANTHER_WINTERFEST2020_N: "পেটস্কিন: স্নো প্যান্থার",
  T_25_Z_R_SIMULATOR_OFF: "নিষেধ করুন",
  T_26_C_SKILL_DESC_SUPERSTAR: "[FFB300]{0}m[-] এর জন্য একটি সোনিক তরঙ্গকে সামনে আনে, যার ফলে হিট ব্যারিয়ারগুলো বিস্ফোরিত হয় এবং [FFB300]{2}s[-] সেকেন্ডের জন্য [FFB300]{1}m[-]  ব্যাসার্ধের মধ্যে গ্লু ওয়ালের ড্যামেজ হয়৷ কুলডাউন: [FFB300]{3}s[-]।",
  T_26_C_SKILL_NAME_SUPERSTAR: "রিপ্টাইড রিদম",
  T_26_D_CHARACTER_DELIVERY_N: "শিরু",
  T_26_D_CHARACTER_SUPERSTAR_N: "স্কাইলার",
  T_26_ET_CELLPHONE_NAME: "ইউএভি-লাইট",
  T_26_L_A_FLAMING_PREM: "Infernal Soldier (Mask)",
  T_26_L_A_SANTAMODE: "Snowman Bob (Mask)",
  T_26_L_B_SANTAMODE: "Snowman Bob (Bottom)",
  T_26_L_F_B_WATERFEST21_A: "Summer Breeze (Bottom)",
  T_26_L_F_H_WATERFEST21_A: "Summer Breeze (Head)",
  T_26_L_F_S_WATERFEST21_A: "Summer Breeze (Shoes)",
  T_26_L_F_T_WATERFEST21_A: "Summer Breeze (Top)",
  T_26_L_M_A_EGGDAY2021: "Cyber Bunny (Mask)",
  T_26_L_M_B_EGGDAY2021: "Cyber Bunny (Bottom)",
  T_26_L_M_B_PAIRING: "Dynamic Duo M (Bottom)",
  T_26_L_M_B_WATERFEST21_A: "Summer Wave (Bottom)",
  T_26_L_M_H_EGGDAY2021: "Cyber Bunny (Head)",
  T_26_L_M_H_PAIRING: "Dynamic Duo M (Head)",
  T_26_L_M_H_WATERFEST21_A: "Summer Wave (Head)",
  T_26_L_M_S_EGGDAY2021: "Cyber Bunny (Shoes)",
  T_26_L_M_S_PAIRING: "Dynamic Duo M (Shoes)",
  T_26_L_M_S_WATERFEST21_A: "Summer Wave (Shoes)",
  T_26_L_M_T_EGGDAY2021: "Cyber Bunny (Top)",
  T_26_L_M_T_PAIRING: "Dynamic Duo M (Top)",
  T_26_L_M_T_WATERFEST21_A: "Summer Wave (Top)",
  T_26_L_S_SANTAMODE: "Snowman Bob (Shoes)",
  T_26_L_T_SANTAMODE: "Snowman Bob (Top)",
  T_26_LC_AWM_KOICARP_N: "AWM- লাকি কোই",
  T_26_LC_KATANA_VALENTINE2021_N: "কাটানা- সিজন অফ পিঙ্ক",
  T_26_LC_VEHICLE_ROADSTER_COBRA_N: "Sports Car- Cobra",
  T_26_P_SKILL_NAME_DELIVERY: "ক্ষতি ডেলিভারি",
  T_26_V_TRAINING_BHH: "অভিনব হাতুড়ি",
  T_26_V_TRAINING_DICE: "দানবীয় ডাইস",
  T_26_W_DRAGON_N: "ড্রেকি",
  T_26_W_PETSKIN_DRAGON_EVIL_N: "পেটস্কিন: স্প্ল্যাশি ড্রেকি",
  T_26_W_PETSKIN_DRAGON_GOLDEN_N: "পেটস্কিন: জ্যাপিং ড্রেকি",
  T_26_W_PETSKIN_DRAGON_PURPLE_N: "পেটস্কিন: গ্যালাক্সি ড্রেকি",
  T_26_W_PETSKIN_PENGUIN_VALENTINE2021_N: "পেট স্কিন: ওয়াগর ইন লাভ",
  T_26_XL_SETTING_TEAMMATE_INFO: "টিমমেটের তথ্য",
  T_26_YP_HISTORY_WIN: "বিজয়",
  T_26_YP_SOCIAL_GENDER_FEMALE: "মেয়ে",
  T_26_YP_SOCIAL_GENDER_MALE: "ছেলে",
  T_26_YP_SOCIAL_NAME: "ডাকনাম",
  T_27_C_SKILL_DESC__RACERGIRL: "ড্রাইভিং গতি [FFB300]{0}%[-] বৃদ্ধি পায়৷  গাড়িতে থাকাকালীন, এই ক্যারেক্টারকে টার্গেট করা কঠিন, এবং গ্রহণযোগ্য ড্যামেজ [FFB300]{1}%[-] হ্রাস পেয়েছে৷",
  T_27_C_SKILL_DESC_BOUNTYHUNTER: "একটি দুর্ভেদ্য ফোর্স ফিল্ড তৈরি করে যা [FFB300]{0} DMG[-] ব্লক করে।  মাঠের মধ্যে থেকে বাইরের প্রতিপক্ষদের আক্রমণ করতে অক্ষম।  সমস্ত প্রভাব [FFB300]{1}s[-] পর্যন্ত স্থায়ী হয়। কুলডাউন: [FFB300]{2}s[-].",
  T_27_C_SKILL_DESC_FALCONER: "দূরত্বের সাথে ড্যামেজ বাড়ে, [FFB300]{0}%[-] পর্যন্ত।  চিহ্নিত প্রতিপক্ষদের ড্যামেজ [FFB300]{1}%[-] বৃদ্ধি পায়।",
  T_27_C_SKILL_DESC_HAYATO_AWAKENING: "অ্যাওয়েকেনিং: প্রতি [FFB300]{0}%[-] HP হ্রাসের জন্য ফ্রন্টাল ড্যামেজ কমায় [FFB300]{1}%[-]।",
  T_27_C_SKILL_DESC_KELLY_AWAKENING: "অ্যাওকেনিং: অ্যাক্টিভেট করার জন্য [FFB300]{0}s[-] স্প্রিন্ট করুন।  অ্যাক্টিভেট করা হলে, টার্গেটে প্রথম  [FFB300]{2}[-]টি গুলি করলে [FFB300]{1}%[-] ড্যামেজ প্রদান করে৷  [FFB300]{3}s[-] সময় স্থায়ী হয়।",
  T_27_C_SKILL_NAME_FALCONER: "ফ্যালকন ফেভার",
  T_27_C_SKILL_NAME_XTREME: "এক্সট্রিম এনকাউন্টার",
  T_27_D_CHARACTER_ANDREW_AWAKENING_N: 'অ্যান্ড্রু "দ্য ফিয়ার্স"',
  T_27_D_CHARACTER_FALCONER_N: "মারো",
  T_27_D_CHARACTER_XTREME_N: "জেইন",
  T_27_F_EAP_PKG3_D: "ব্যাটল ইন স্টাইল।",
  T_27_HYL_SKILLBOARD_HP: "এইচপি",
  T_27_L_A_CARDBOARD_MID2: "Tiger Papercut (Mask)",
  T_27_L_B_CARDBOARD_REG: "Grizzly Papercut (Bottom)",
  T_27_L_M_S_KAZAKHSTAN: "The Baghatur (Shoes)",
  T_27_L_S_CARDBOARD_REG: "Grizzly Papercut (Shoes)",
  T_27_L_T_CARDBOARD_REG: "Grizzly Papercut (Top)",
  T_27_LC_VECTOR_FFWS2021_N: "ভেক্টর- FFWS 2021",
  T_27_LC_VEHICLE_MONSTER_FFWS2021_N: "Monster Truck- FFWS 2021",
  T_27_LC_VEHICLE_MOTOBIKE_BOXER_N: "মোটরবাইক- K.O. নাইট",
  T_27_LC_VEHICLE_ROADSTER_FASTBREAKING_N: "Sports Car- Emerald Flash",
  T_27_LC_VEHICLE_SUV_DRAGON_N: "Pickup Truck- Flame Draco",
  T_27_P_SKILL_NAME_HITMAN_RE: "ডেড সাইলেন্ট",
  T_27_R_EMOTE_GREETING_NAME: "Greetings",
  T_27_R_VEHICLE_ACCELERATION: "Acceleration",
  T_27_R_VEHICLE_HP: "Durability",
  T_27_R_VEHICLE_SPEED: "Top Speed",
  T_27_U_KORD: "কর্ড",
  T_27_U_M1917: "এম1917",
  T_27_U_SKILL_DESC_ANDREW_AWAKENING: "অ্যাওকেনিং: আর্মারের ড্যামেজ হ্রাস [FFB300]{0}%[-] বৃদ্ধি পেয়েছে৷ প্রতিটি টিমমেটের কাছ থেকে অতিরিক্ত [FFB300]{1}%[-] ড্যামেজ হ্রাস [FFB300]{2}মি[-] এর মধ্যে।",
  T_27_U_SKILL_NAME_ANDREW_AWAKENING: "উলফ প্যাক",
  T_27_U_WSP: "USP-2",
  T_27_W_ALIEN_N: "মুনি",
  T_27_W_ARMOTY_DMR: "মার্কসম্যান রাইফেল",
  T_27_W_PETSKIN_ALIEN_CRYSTAL_N: "পেটস্কিন: ক্রিস্টাল মুনি",
  T_27_W_PETSKIN_ALIEN_GAMER_N: "পেটস্কিন: গেমার মুনি",
  T_27_W_PETSKIN_ALIEN_HIPSTER_N: "পেটস্কিন: হিপস্টার মুনি",
  T_27_W_PETSKIN_DOG_FFWS2021_N: "পেট স্কিন: FFWS 2021 কুকুরছানা",
  T_27_W_PETSKIN_PANDA_FFWS2021_N: "পেট স্কিন: FFWS 2021 পান্ডা",
  T_27_XC_REPLAY_DIE: "মৃত্যু",
  T_27_XC_REPLAY_KILL: "কিল",
  T_27_XL_WEREWOLVES_INGAME_REPAIR: "মেরামত করুন",
  T_28_C_G_ICE_NAME: "ফ্ল্যাশ ফ্রিজ",
  T_28_C_SKILL_DESC_STREETBEAT: "মুভিং অবস্থায় ফায়ার করার সময়, মুভমেন্ট স্পিড [FFB300]{0}%[-] বৃদ্ধি পায়, অ্যাক্যুরেসি [FFB300]{1}%[-] বৃদ্ধি পায়।",
  T_28_C_SKILL_NAME_STREETBEAT: "বুলেট বিটস",
  T_28_D_CHARACTER_STREETBEAT_N: "ডি-বি",
  T_28_HI_UZI: "মিনি ইউজি",
  T_28_L_B_BRJERSEY_A: "No.23 Soccer Jersey (Bottom)",
  T_28_L_B_BRJERSEY_B: "No.10 Soccer Jersey (Bottom)",
  T_28_L_B_BRJERSEY_C: "No.24 Soccer Jersey (Bottom)",
  T_28_L_B_BRJERSEY_D: "No.30 Soccer Jersey (Bottom)",
  T_28_L_B_BRJERSEY_E: "No.1 Soccer Jersey (Bottom)",
  T_28_L_B_BRJERSEY_F: "No.20 Soccer Jersey (Bottom)",
  T_28_L_F_B_FOURSYMBOLS_C: "Vermilion Whirlwind (Bottom)",
  T_28_L_F_H_FOURSYMBOLS_C: "Vermilion Whirlwind (Head)",
  T_28_L_F_HA_FOURSYMBOLS_C: "Vermilion Whirlwind (Facepaint)",
  T_28_L_F_S_FOURSYMBOLS_C: "Vermilion Whirlwind (Shoes)",
  T_28_L_F_T_FOURSYMBOLS_C: "Vermilion Whirlwind (Top)",
  T_28_L_HA_THUNDER: "Lightning Eye (Facepaint)",
  T_28_L_M_A_SPORTSUIT: "Ballsy Skaterboi (Mask)",
  T_28_L_M_B_FOURSYMBOLS_D: "Shadow Earthshaker (Bottom)",
  T_28_L_M_B_SPORTSUIT: "Ballsy Skaterboi (Bottom)",
  T_28_L_M_H_FOURSYMBOLS_D: "Shadow Earthshaker (Head)",
  T_28_L_M_H_SPORTSUIT: "Ballsy Skaterboi (Head)",
  T_28_L_M_S_FOURSYMBOLS_D: "Shadow Earthshaker (Shoes)",
  T_28_L_M_S_SPORTSUIT: "Ballsy Skaterboi (Shoes)",
  T_28_L_M_T_FALLWINTER: "Sauce Swagger (Top)",
  T_28_L_M_T_FOURSYMBOLS_D: "Shadow Earthshaker (Top)",
  T_28_L_M_T_SPORTSUIT: "Ballsy Skaterboi (Top)",
  T_28_L_T_BRJERSEY_A: "No.23 Soccer Jersey (Top)",
  T_28_L_T_BRJERSEY_B: "No.10 Soccer Jersey (Top)",
  T_28_L_T_BRJERSEY_C: "No.24 Soccer Jersey (Top)",
  T_28_L_T_BRJERSEY_D: "No.30 Soccer Jersey (Top)",
  T_28_L_T_BRJERSEY_E: "No.1 Soccer Jersey (Top)",
  T_28_L_T_BRJERSEY_F: "No.20 Soccer Jersey (Top)",
  T_28_LC_AN94_CRIMSONBRIDE_N: "AN94- রুবি ব্রাইড",
  T_28_LC_GLOO_FALLWINTER_N: "গ্লু ওয়াল- সস সোয়াগার",
  T_28_LC_GLOO_FOURSYMBOLS_N: "গ্লু ওয়াল- স্টর্মব্রিংগার",
  T_28_LC_KORD_SHINOBI_N: "কর্ড- কিলসপার্ক শিনোবি",
  T_28_LC_M21A5_FANTASYEYE_N: "উডপিকার- মার্সিলেস নেক্রোম্যান্সার",
  T_28_LC_MAG7_WHITESHARK_N: "ম্যাগ -7 - লিথাল ফিনস্টুথ",
  T_28_LC_PAN_FOURSYMBOLS_N: "প্যান- আর্থশেকার স্টম্প",
  T_28_LC_VEHICLE_JEEP_FOURSYMBOLS_N: "Jeep- Stormbringer",
  T_28_T_WS_ITEM1: "স্কোয়ার বক্স",
  T_28_T_WS_ITEM10: "কুঁড়েঘর",
  T_28_T_WS_ITEM11: "গার্ড টাওয়ার",
  T_28_T_WS_ITEM12: "আউটপোস্ট",
  T_28_T_WS_ITEM13: "হাউজ A",
  T_28_T_WS_ITEM14: "হাউজ B",
  T_28_T_WS_ITEM15: "হাউজ C",
  T_28_T_WS_ITEM16: "বালির গঠন",
  T_28_T_WS_ITEM17: "ঝর্ণা",
  T_28_T_WS_ITEM18: "চেরির মুকুল",
  T_28_T_WS_ITEM19: "কলা গাছ",
  T_28_T_WS_ITEM2: "দীর্ঘ বক্স",
  T_28_T_WS_ITEM20: "টয়লেট বোল!",
  T_28_T_WS_ITEM21: "বেড়া",
  T_28_T_WS_ITEM3: "ঝোপঝাড়",
  T_28_T_WS_ITEM4: "খড়ের গাদা",
  T_28_T_WS_ITEM5: "গাড়ি",
  T_28_T_WS_ITEM6: "বাস",
  T_28_T_WS_ITEM7: "কন্টেনার A",
  T_28_T_WS_ITEM8: "কন্টেনার B",
  T_28_T_WS_ITEM9: "কন্টেনার C",
  T_28_T_WS_TYPE1: "অবজেক্টসমূহ",
  T_28_T_WS_TYPE4: "সাজসজ্জা",
  T_28_W_DUCK_N: "ডাঃ বিয়ানি",
  T_28_W_PETSKIN_DRAGON_FOURSYMBOLS_N: "পেটস্কিন: মাইথস ড্রেকি",
  T_28_W_PETSKIN_DUCK_ARMY_N: "পেটস্কিন: সার্জেন্ট বিয়ানি",
  T_28_W_PETSKIN_DUCK_BLACK_N: "পেটস্কিন: গ্যাংস্টার বিয়ানি",
  T_28_W_PETSKIN_DUCK_SHINY_N: "পেটস্কিন: ডিজে বেনি",
  T_28_YF_AR15: "কিংফিশার",
  T_29_C_SKILL_DESC_MOCO_AWAKENING: "অ্যাওকেনিং: হিট প্রতিপক্ষদের উপর চিহ্নগুলি দীর্ঘস্থায়ী হয় যখন প্রতিপক্ষরা চলে যায়,  [FFB300]{0}s[-] পর্যন্ত।",
  T_29_C_SKILL_NAME_MOCO_AWAKENING: "এনিগমা'স চোখ",
  T_29_C_SKILL_NAME_MUSICBRO_BLACK: "ভাইটাল ভাইবস",
  T_29_C_SKILL_NAME_MUSICBRO_WHITE: "হিলিং হার্টবিট",
  T_29_D_CHARACTER_AMOCO_N: 'মোকো "এনিগমা"',
  T_29_D_CHARACTER_MUSICBRO1_N: "দিমিত্রি",
  T_29_D_CHARACTER_MUSICBRO2_N: "থিভা",
  T_29_HI_MINI14: "এসি80",
  T_29_L_B_TRJERSEY: "Striped Soccer Jersey (Bottom)",
  T_29_L_M_A_FALCONER_C: "Moody Lavisher (Mask)",
  T_29_L_M_A_JUNGLE_GREEN: "Camou War-Turtle (Mask)",
  T_29_L_M_B_FALCONER_C: "Moody Lavisher (Bottom)",
  T_29_L_M_B_JUNGLE_GREEN: "Camou War-Turtle (Bottom)",
  T_29_L_M_H_FALCONER_C: "Moody Lavisher (Head)",
  T_29_L_M_H_JUNGLE_GREEN: "Camou War-Turtle (Head)",
  T_29_L_M_S_FALCONER_C: "Moody Lavisher (Shoes)",
  T_29_L_M_S_JUNGLE_GREEN: "Camou War-Turtle (Shoes)",
  T_29_L_M_T_FALCONER_C: "Moody Lavisher (Top)",
  T_29_L_M_T_JUNGLE_GREEN: "Camou War-Turtle (Top)",
  T_29_L_T_TRJERSEY: "Striped Soccer Jersey (Top)",
  T_29_M_WS_ITEM22: "এবড়োথেবড়ো কন্টেইনার",
  T_29_M_WS_ITEM23: "এবড়োথেবড়ো বেড়া",
  T_29_M_WS_ITEM24: "স্পন পয়েন্ট A",
  T_29_M_WS_ITEM25: "স্পন পয়েন্ট B",
  T_29_M_WS_TYPE5: "ইন্টারেক্টিভস",
  T_29_W_PETSKIN_BROWN_TIGER_N: "পেট স্কিন: আর্থ সেনসেই টিগ",
  T_29_W_PETSKIN_FIRE_TIGER_N: "পেট স্কিন: ফায়ার সেনসেই টিগ",
  T_29_W_PETSKIN_HAWK_MOCOMONTH_N: "পেট স্কিন: সাইবার ফ্যালকো",
  T_29_W_PETSKIN_PANDA_MUSICFEST_N: "পেট স্কিন: পার্টি পান্ডা",
  T_29_W_PETSKIN_WHITE_TIGER_N: "পেট স্কিন: আইস সেন্সেই টিগ",
  T_29_W_TIGER_NINJA_N: "সেনসেই টিগ",
  T_29_YF_MACHETE_MUSICFEST_N: "সাউন্ডওয়েভ থ্র্যাসার",
  T_29_YF_MAGEZINE_CHAIN_N: "AR ম্যাগাজিন",
  T_29_YF_MUZZLE_CRASH_N: "SMG মাজল",
  T_29_YF_MUZZLE_WIDE_N: "শটগান মাজল",
  T_29_YF_SPAS12_MOCOMONTH_N: "স্পাস- কসমিক টেলিপোর্টিয়া",
  T_29_YF_UZI_GOLDENWING_N: "মিনি উজি- অ্যাম্বার মেগাসাইফার",
  T_29_YF_VEHICLE_MONSTER_SKELETONTRUCK_N: "Monster Truck- Gnawing Rager",
  T_30_AD_RP_ROUNDEND: "রাউন্ডের সমাপ্তি",
  T_30_AD_TRAINING_SNOWBALL: "স্নোবল",
  T_30_AD_TRAINING_SNOWBALL_DES: "চলুন একটা স্নোবল লড়াই করার জন্য",
  T_30_C_SKILL_DESC_BOOYAHGUY: "অ্যাটাক পাওয়ার [FFB300]{0}s[-] পর, [FFB300]{1}HP[-]/s এর জন্য [FFB300]{2}s[-] রিকোভার করুন",
  T_30_C_SKILL_NAME_BOOYAHGUY: "বুজার বিটার",
  T_30_C_SKILL_NAME_MUERTOGUY: "মেমোরি মিস্ট",
  T_30_D_CHARACTER_BOOYAHGUY_N: "লিওন",
  T_30_D_CHARACTER_MUERTOGUY_N: "অথো",
  T_30_JMF_SKILLCHIP_NAME_SWATGUY: "Jai's Microchip",
  T_30_L_A_BRMASCOT_ADULT: "Angry Chick Head",
  T_30_L_A_BRMASCOT_KIDS: "Adorable Chick Head",
  T_30_L_A_SUGARSKULL21_BANDANA: "Death Bite Mask",
  T_30_L_B_BRFOOTBALL_BLACK: "CBF Soccer Jersey - Black (Bottom)",
  T_30_L_B_BRFOOTBALL_GREEN: "CBF Soccer Jersey - Green (Bottom)",
  T_30_L_B_BRFOOTBALL_GREY: "CBF Soccer Jersey - Gray (Bottom)",
  T_30_L_B_BRUNIFORM: "Little Canary (Bottom)",
  T_30_L_F_A_SUGARSKULL21: "Goldrim Queen (Mask)",
  T_30_L_F_B_SUGARSKULL21: "Goldrim Queen (Bottom)",
  T_30_L_F_B_THASIAN: "Coral Trouble (Bottom)",
  T_30_L_F_H_CATEARS: "Kawaii Ears",
  T_30_L_F_H_SUGARSKULL21: "Goldrim Queen (Head)",
  T_30_L_F_H_THASIAN: "Coral Trouble (Head)",
  T_30_L_F_S_SUGARSKULL21: "Goldrim Queen (Shoes)",
  T_30_L_F_S_THASIAN: "Coral Trouble (Shoes)",
  T_30_L_F_T_SUGARSKULL21: "Goldrim Queen (Top)",
  T_30_L_F_T_THASIAN: "Coral Trouble (Top)",
  T_30_L_H_CHILDRENSDAY_BLUE: "Dolphin Head",
  T_30_L_H_CHILDRENSDAY_RED: "Elephant Head",
  T_30_L_H_CLOWNHAT: "Circus Hat - Yellow",
  T_30_L_H_ZASCARF: "Bold Gold Scarf",
  T_30_L_M_A_LIGHTFEST_GANGSTER: "Desi Gangster (Mask)",
  T_30_L_M_A_SUGARSKULL21: "Goldrim King (Mask)",
  T_30_L_M_B_LIGHTFEST_GANGSTER: "Desi Gangster (Bottom)",
  T_30_L_M_B_PKCRICKET: "Champ In Green (Bottom)",
  T_30_L_M_B_SUGARSKULL21: "Goldrim King (Bottom)",
  T_30_L_M_B_SUGARSKULL21_CASUAL: "Wind Racer (Bottom)",
  T_30_L_M_B_THASIAN: "Coral Rebel (Bottom)",
  T_30_L_M_H_LIGHTFEST_GANGSTER: "Desi Gangster (Head)",
  T_30_L_M_H_SUGARSKULL21: "Goldrim King (Head)",
  T_30_L_M_H_SUGARSKULL21_CASUAL: "Wind Racer (Head)",
  T_30_L_M_H_THASIAN: "Coral Rebel (Head)",
  T_30_L_M_HA_BOOYAHDAY21_YELLOW: "Alpha Flameborn (Facepaint)",
  T_30_L_M_S_LIGHTFEST_GANGSTER: "Desi Gangster (Shoes)",
  T_30_L_M_S_PKCRICKET: "Champ In Green (Shoes)",
  T_30_L_M_S_SUGARSKULL21: "Goldrim King (Shoes)",
  T_30_L_M_S_SUGARSKULL21_CASUAL: "Wind Racer (Shoes)",
  T_30_L_M_S_THASIAN: "Coral Rebel (Shoes)",
  T_30_L_M_T_LIGHTFEST_GANGSTER: "Desi Gangster (Top)",
  T_30_L_M_T_PKCRICKET: "Champ In Green (Top)",
  T_30_L_M_T_SUGARSKULL21: "Goldrim King (Top)",
  T_30_L_M_T_SUGARSKULL21_CASUAL: "Wind Racer (Top)",
  T_30_L_M_T_THASIAN: "Coral Rebel (Top)",
  T_30_L_S_BRUNIFORM: "Little Canary (Shoes)",
  T_30_L_T_BRFOOTBALL_BLACK: "CBF Soccer Jersey - Black (Top)",
  T_30_L_T_BRFOOTBALL_GREEN: "CBF Soccer Jersey - Green (Top)",
  T_30_L_T_BRFOOTBALL_GREY: "CBF Soccer Jersey - Gray (Top)",
  T_30_L_T_BRUNIFORM: "Little Canary (Top)",
  T_30_M_WS_PARTY_MODE: "প্লেগ্রাউন্ড",
  T_30_R_EMOTE_BATTLEINSTYLE_NAME: "BATTLE IN STYLE",
  T_30_R_EMOTE_BOOYAHDAY21_PROVOCATION_NAME: "Challenger",
  T_30_R_EMOTE_MAX_NAME: "Rap Swag",
  T_30_R_LEGEND_HALO_NAME: "হিট বৃত্ত",
  T_30_T_WS_DEFAULTDESCRIPTION: "Free Fire ক্রাফটল্যান্ডে চমৎকার একটি ম্যাপ",
  T_30_T_WS_ITEM26: "টায়ার",
  T_30_T_WS_ITEM27: "অগোছালো টায়ার A",
  T_30_T_WS_ITEM28: "অগোছালো টায়ার B",
  T_30_T_WS_ITEM29: "অগোছালো টায়ার C",
  T_30_T_WS_ITEM30: "বাম্পার গাড়ি",
  T_30_T_WS_ITEM31: "উভচর গাড়ি",
  T_30_T_WS_ITEM32: "জিপ",
  T_30_T_WS_ITEM33: "আবর্জনার ক্যান",
  T_30_T_WS_ITEM34: "ছায়া",
  T_30_T_WS_ITEM35: "চিকিৎসা তাবু",
  T_30_T_WS_ITEM36: "গ্যারেজ",
  T_30_T_WS_ITEM37: "রঙিন দেয়াল",
  T_30_T_WS_ITEM38: "টোরি",
  T_30_T_WS_ITEM39: "আইরন প্ল্যাটফর্ম",
  T_30_T_WS_ITEM40: "সাইট হাট",
  T_30_T_WS_ITEM41: "ট্রেইলার",
  T_30_T_WS_ITEM42: "দেয়াল A",
  T_30_T_WS_ITEM43: "দেয়াল B",
  T_30_T_WS_ITEM44: "দেয়াল C",
  T_30_T_WS_ITEM45: "দেয়াল D",
  T_30_T_WS_ITEM46: "দেয়াল E",
  T_30_T_WS_ITEM47: "দেয়াল F",
  T_30_U_ATTACHMENT_1: "শিল্ড বুস্টার",
  T_30_U_ATTACHMENT_4: "ভেস্ট এনলার্জার",
  T_30_U_ATTACHMENT_5: "হেলমেট থিকেনার",
  T_30_U_ATTACHMENT_6: "ভেস্ট থিকেনার",
  T_30_W_PETSKIN_BABOON_SUGARSKULL21_N: "পেট স্কিন: স্কাল বিস্টন",
  T_30_W_PETSKIN_PENGUIN_EVILRHYTHM_N: "পেট স্কিন: পাঙ্ক ওয়াগর",
  T_30_W_PETSKIN_RABBIT_BULLSEYE_N: "পেট স্কিন: বুলসআই এজেন্ট হপ",
  T_30_W_PETSKIN_RABBIT_CLOWN_N: "পেট স্কিন: কার্নিভাল এজেন্ট হপ",
  T_30_W_PETSKIN_RABBIT_URBAN_N: "পেট স্কিন: সাইবার এজেন্ট হপ",
  T_30_W_PETSKIN_ROBOT_TRNAZAR_N: "পেট স্কিন: ন্যাজার রোবো",
  T_30_W_PETSKIN_ROBOT_VNDRINK_N: "পেট স্কিন: গ্রিন ফ্রিজ রোবো",
  T_30_W_RABBIT_N: "এজেন্ট হপ",
  T_30_XH_PCMAP_P17: "ফ্যাক্টরি",
  T_30_YF_GLOO_BOOYAHDAY21_N: "গ্লু ওয়াল- Booyah ডে 2021",
  T_30_YF_GRENADE_BOOYAHDAY21_N: "গ্রেনেড- BOOYAH ডে ২০২১",
  T_30_YF_Healinggun_Sniper_N: "হিল স্নাইপার",
  T_30_YF_MINI_LIGHTFEST_N: "এসি৮০ - রয়্যাল ওয়ারিয়র",
  T_30_YF_PARAFAL_ZATRIBAL_N: "প্যারাফাল- ক্রিমসন হিয়ার।",
  T_30_YF_SCAR_LIGHTFEST_N: "SCAR - রয়্যাল ওয়ারিয়র",
  T_30_YF_THOMPSON_SUGARSKULL21_N: "Thompson- Goldrim Tribute",
  T_30_YF_VEHICLE_ROADSTER_EVILRHYTHM_N: "Sports Car- Skull Punker",
  T_31_C_SKILL_NAME_WINTERGUY: "আইস আইরন",
  T_31_HQ_BASEBALLBAT_WINTERFEST21_N: "উইন্টার বাশার",
  T_31_HQ_GLOO_EAGLE_N: "গ্লু ওয়াল- হিটবাউন্ড ডেসার্ট",
  T_31_HQ_HEALINGSNIPER_WINTERFEST21_N: "হিল স্নাইপার- আইস বোনস",
  T_31_HQ_KATANA_WINTERFEST21_N: "কাটানা- স্নো ডুম",
  T_31_HQ_PAN_WINTERFEST21_N: "প্যান- স্নো ডুম",
  T_31_HQ_PETSKIN_OTTER_WINTERFEST21_N: "পেট স্কিন স্নো ওটেরো",
  T_31_HQ_PETSKIN_PENGUIN_WINTERFEST21_N: "পেট স্কিন: ওয়াগর অন আইস",
  T_31_HQ_PETSKIN_YETI_GREEN_N: "পেট স্কিন: ট্রাইবাল ইয়েতি",
  T_31_HQ_PETSKIN_YETI_RED_N: "পেট স্কিন: ফেইরি ইয়েতি",
  T_31_HQ_SICKLE_WINTERFEST21_N: "সাইথ অফ স্নো",
  T_31_HQ_VEHICLE_MOTOBIKE_NEWYEAR21_N: "মোটরবাইক - আইস ব্লজমস",
  T_31_HQ_YETI_N: "ইয়েতি",
  T_31_KK_WINTER_BUJIX: "সাপ্লাই ক্রেট",
  T_31_KK_WINTER_SANJITOU: "হেলমেট",
  T_31_L_A_BDCRICKET: "Victory Batter (Mask)",
  T_31_L_A_WINTERFEST21: "Reindeer Cover",
  T_31_L_B_BDCRICKET: "Victory Batter (Bottom)",
  T_31_L_B_MEJERSEY_10: "No. 10 Ruby Jersey (Bottom)",
  T_31_L_B_MEJERSEY_11: "No. 11 Red Jersey (Bottom)",
  T_31_L_B_MEJERSEY_13: "No. 13 White Jersey (Bottom)",
  T_31_L_B_MEJERSEY_18G: "No. 18 Green Jersey (Bottom)",
  T_31_L_B_MEJERSEY_18R: "No. 18 Maroon Jersey (Bottom)",
  T_31_L_B_MEJERSEY_7: "No. 7 Basil Jersey (Bottom)",
  T_31_L_F_B_RUMUSICIAN: "Strapped Trance (Bottom)",
  T_31_L_F_B_THAGENT: "Night Provocateur (Bottom)",
  T_31_L_F_H_REGGAETON_HEADWEAR: "Up Here (F)",
  T_31_L_F_H_RUMUSICIAN: "Strapped Trance (Head)",
  T_31_L_F_H_THAGENT: "Night Provocateur (Head)",
  T_31_L_F_HA_RUMUSICIAN: "Strapped Trance (Facepaint)",
  T_31_L_F_S_RUMUSICIAN: "Strapped Trance (Shoes)",
  T_31_L_F_S_THAGENT: "Night Provocateur (Shoes)",
  T_31_L_F_T_RUMUSICIAN: "Strapped Trance (Top)",
  T_31_L_F_T_THAGENT: "Night Provocateur (Top)",
  T_31_L_HA_RUMUSICIAN_MU: "Strap Trap (Facepaint)",
  T_31_L_HA_WINTERFEST21_BLUE: "Frozen Clown Facepaint",
  T_31_L_HA_WINTERFEST21_PINK: "Pink Firesparks Facepaint",
  T_31_L_M_A_REGGAETON_B: "Everything Goes (Mask)",
  T_31_L_M_A_REGGAETON_P: "Prismatic Energy (Mask)",
  T_31_L_M_A_RUMUSICIAN: "Strapped Trap (Mask)",
  T_31_L_M_A_THAGENT: "Night Scouter (Mask)",
  T_31_L_M_B_PKCOSTUME: "Smart in Green (Bottom)",
  T_31_L_M_B_REGGAETON_B: "Everything Goes (Bottom)",
  T_31_L_M_B_REGGAETON_P: "Prismatic Energy (Bottom)",
  T_31_L_M_B_RUMUSICIAN: "Strapped Trap (Bottom)",
  T_31_L_M_B_THAGENT: "Night Scouter (Bottom)",
  T_31_L_M_H_GREENCAP: "Winner Cap",
  T_31_L_M_H_PKCOSTUME: "Smart in Green (Head)",
  T_31_L_M_H_REGGAETON_B: "Everything Goes (Head)",
  T_31_L_M_H_REGGAETON_HEADWEAR: "Up Here (M)",
  T_31_L_M_H_REGGAETON_P: "Prismatic Energy (Head)",
  T_31_L_M_H_RUMUSICIAN: "Strapped Trap (Head)",
  T_31_L_M_H_THAGENT: "Night Scouter (Head)",
  T_31_L_M_S_PKCOSTUME: "Smart in Green (Shoes)",
  T_31_L_M_S_REGGAETON_B: "Everything Goes (Shoes)",
  T_31_L_M_S_REGGAETON_P: "Prismatic Energy (Shoes)",
  T_31_L_M_S_RUMUSICIAN: "Strapped Trap (Shoes)",
  T_31_L_M_S_THAGENT: "Night Scouter (Shoes)",
  T_31_L_M_T_PKCOSTUME: "Smart in Green (Top)",
  T_31_L_M_T_REGGAETON_B: "Everything Goes (Top)",
  T_31_L_M_T_REGGAETON_P: "Prismatic Energy (Top)",
  T_31_L_M_T_REGGAETON_TATOO: "This Is Me",
  T_31_L_M_T_RUMUSICIAN: "Strapped Trap (Top)",
  T_31_L_M_T_THAGENT: "Night Scouter (Top)",
  T_31_L_S_BDCRICKET: "Victory Batter (Shoes)",
  T_31_L_T_BDCRICKET: "Victory Batter (Top)",
  T_31_L_T_BRBANK: "Maroon Bomber",
  T_31_L_T_MEJERSEY_10: "No. 10 Ruby Jersey (Top)",
  T_31_L_T_MEJERSEY_11: "No. 11 Red Jersey (Top)",
  T_31_L_T_MEJERSEY_13: "No. 13 White Jersey (Top)",
  T_31_L_T_MEJERSEY_18G: "No. 18 Green Jersey (Top)",
  T_31_L_T_MEJERSEY_18R: "No. 18 Maroon Jersey (Top)",
  T_31_L_T_MEJERSEY_7: "No. 7 Basil Jersey (Top)",
  T_31_L_T_PKMOBILE: "Infinix T-shirt",
  T_31_L_T_REGGAETON_HOOD: "For My People",
  T_31_MF_CHARACTER_WINTERGUY_N: "নাইরি",
  T_31_R_EMOTE_FALCONER_NAME: "Number 1",
  T_31_RW_COMBINEMACHINE_2: "আকিম্বো অ্যাক্টিভেটর (অত্যাধুনিক)",
  T_31_RW_VIBRATION_EXPLOSION: "বিস্ফোরণ",
  T_31_RW_VIBRATION_MELEEWEAPONS: "স্বল্প- রেঞ্জের বন্দুক",
  T_31_RW_VIBRATION_OTHERWEAPONS: "অন্যান্য বন্দুক",
  T_31_T_WS_1PLAYERTEAM: "একক",
  T_31_T_WS_2PLAYERTEAM: "দ্বৈত",
  T_31_T_WS_3PLAYERTEAM: "ত্রিপাক্ষিক",
  T_31_T_WS_4PLAYERTEAM: "স্কোয়াড",
  T_31_T_WS_5PLAYERTEAM: "বনাম 5",
  T_31_T_WS_6PLAYERTEAM: "বনাম 6",
  T_31_T_WS_BUFFTIME_TITLE: "রিফ্রেশ টাইম (s)",
  T_31_T_WS_BUFFTYPE_AMMO: "অ্যামো",
  T_31_T_WS_BUFFTYPE_ARMOR: "আর্মর",
  T_31_T_WS_BUFFTYPE_HP: "HP",
  T_31_T_WS_BUFFTYPE_RANDOM: "র‍্যানডম",
  T_31_T_WS_BUFFTYPE_TITLE: "বাফ টাইপ",
  T_31_T_WS_DESC48: "আপনাকে অন্য একটি স্থানে নিয়ে যায়, মিলিসেকেন্ডের মধ্যে",
  T_31_T_WS_DESC49: "পিয়ানো কী'র ধ্বনি সৃষ্টি করে",
  T_31_T_WS_DESC51: "ড্রামের ধ্বনি সৃষ্টি করে",
  T_31_T_WS_DESC53: "ড্রামের ধ্বনি সৃষ্টি করে",
  T_31_T_WS_DESC59: "একটি ডিভাইস যা পর্যায়ক্রমে একটি বাফ তৈরি করে। সংশ্লিষ্ট একটি উন্নতি পেতে এটি পিক আপ করুন",
  T_31_T_WS_DRUMTYPE_CLAPS: "হাততালি",
  T_31_T_WS_DRUMTYPE_HIHATS: "হাই-হ্যাট",
  T_31_T_WS_DRUMTYPE_KICK: "কিক ড্রাম",
  T_31_T_WS_DRUMTYPE_OPENHIHATS: "হাই-হ্যাট খোলা হচ্ছে",
  T_31_T_WS_DRUMTYPE_RIDES: "সাইম্বাল চালান",
  T_31_T_WS_DRUMTYPE_SNARES: "স্নেয়ার ড্রাম",
  T_31_T_WS_EARLYSHRINK: "দ্রুত সংকোচন",
  T_31_T_WS_ITEM48: "পোর্টাল",
  T_31_T_WS_ITEM49: "পিয়ানো চাবি",
  T_31_T_WS_ITEM51: "ড্রাম চাবি",
  T_31_T_WS_ITEM53: "কম্বো চাবি A",
  T_31_T_WS_ITEM55: "কম্বো চাবি B",
  T_31_T_WS_ITEM57: "কম্বো চাবি C",
  T_31_T_WS_ITEM59: "বাফ জেনারেটর",
  T_31_T_WS_LATESHRINK: "দেরিতে সংকোচন",
  T_31_T_WS_ME_DAMAGE: "ড্যামেজ সাধিত",
  T_31_T_WS_ME_DAMAGED: "প্রদত্ত ড্যামেজ",
  T_31_T_WS_ME_DEFAULTEPPERCENT: "প্রাথমিক EP অনুপাত",
  T_31_T_WS_ME_DEFAULTSAFERADIUS: "প্রথম সেইফ জোনের ব্যাসার্ধ",
  T_31_T_WS_ME_EPQUICKRESTORE: "দ্রুত EP পুনরুদ্ধার",
  T_31_T_WS_ME_FLOW: "মোড",
  T_31_T_WS_ME_GENERALSETTING: "সাধারণ",
  T_31_T_WS_ME_INRANDOMSPAWN: "র‍্যানডম স্পন পয়েন্ট",
  T_31_T_WS_ME_KILLSCORE: "কিল বোনাস",
  T_31_T_WS_ME_MAXEP: "সর্বোচ্চ EP",
  T_31_T_WS_ME_MAXHP: "সর্বোচ্চ HP",
  T_31_T_WS_ME_NEARTEAM: "নিকটবর্তী টিমমেট",
  T_31_T_WS_ME_REBIRTH: "রি-স্পন ওয়েটিং টাইম",
  T_31_T_WS_ME_REBIRTHLOCATION: "রি-স্পন লোকেশন",
  T_31_T_WS_ME_SAFEZONESHRINKTIME: "জোন সঙ্কোচনের সময়",
  T_31_T_WS_ME_WINSCORE: "বিজয়ের স্কোর",
  T_31_T_WS_MINIZONE: "মিনি জোন",
  T_31_T_WS_MUSICTYPE_TITLE: "মিউজিক টাইপ",
  T_31_T_WS_UNLIMITEDAMMO: "অসীম সংখ্যক অ্যামো",
  T_31_WT_WS_DESC1: "একটি বর্গাকার কাঠের বাক্স যা স্ট্যাক করা যায়",
  T_31_WT_WS_DESC10: "উপরে ওঠার জন্য কাঠের সিঁড়ি সহ একটি রান-ডাউন কুঁড়েঘর",
  T_31_WT_WS_DESC11: "শ্যুটিং-এর উদ্দেশ্যে অনেকগুলো জানালাসহ বানানো হয়েছে",
  T_31_WT_WS_DESC12: "ধাতব-তৈরি এবং এতে দরজা, জানালা রয়েছে",
  T_31_WT_WS_DESC13: "দরজা, জানালাসহ একটি একতলা বাড়ি",
  T_31_WT_WS_DESC14: "বারান্দাসহ একটি দু'তলা বাড়ি",
  T_31_WT_WS_DESC15: "সিল করা ছাদ সহ একটি দোতলা বাড়ি",
  T_31_WT_WS_DESC16: "সাজসজ্জা - একটি হৃদয় আকৃতির বালি মূর্তি",
  T_31_WT_WS_DESC17: "সাজসজ্জা - স্ফটিক-স্বচ্ছ জলের ফোয়ারা",
  T_31_WT_WS_DESC18: "সাজসজ্জা - একটি গোলাপী ফুলের গাছ",
  T_31_WT_WS_DESC19: "কলা ছাড়া ছোট একটি কলা গাছসাজসজ্জা -",
  T_31_WT_WS_DESC2: "একটি বর্গাকার কাঠের বাক্স যা স্ট্যাক করা যায়",
  T_31_WT_WS_DESC20: "বাথরুমের সাদা একটি আসবাবপত্র, যা বাড়ির ভিতরে স্থাপন করা যায়",
  T_31_WT_WS_DESC21: "একটি ছোট বেড়া যা এলাকা ভাগ করতে ব্যবহার করা যায়",
  T_31_WT_WS_DESC22: "এই কন্টেনারটির পাশের কাঠ বোর্ডটি শক্তি ব্যবহার করে ভেঙে ফেলা যায়",
  T_31_WT_WS_DESC23: "একটি ছোট বেড়া যেটাকে শক্তি ব্যবহার করে ভেঙে ফেলা যায়",
  T_31_WT_WS_DESC24: "টিম A-এর জন্য স্পন এলাকা (শুধুমাত্র ক্ল্যাশ স্কোয়াড, টিম ডেথম্যাচ এবং প্লেগ্রাউন্ড মোডে কার্যকর)",
  T_31_WT_WS_DESC25: "টিম B-এর স্পন এরিয়া (শুধুমাত্র ক্ল্যাশ স্কোয়াড, টিম ডেথম্যাচ এবং প্লেগ্রাউন্ড মোডে কার্যকর)",
  T_31_WT_WS_DESC26: "প্লেয়াররা যেদিকে ফিরে থাকে অল্প দূরত্বের জন্য তাদেরকে সেদিকে বাউন্স করে",
  T_31_WT_WS_DESC27: "প্লেয়ারদেরকে তাদের পূর্বনির্ধারিত দিকে অল্প দূরত্বের জন্য বাউন্স করে",
  T_31_WT_WS_DESC28: "প্লেয়ারদেরকে তাদের পূর্বনির্ধারিত দিকে মাঝামাঝি দূরত্বের জন্য বাউন্স করে",
  T_31_WT_WS_DESC29: "প্লেয়ারদের তাদের পূর্বনির্ধারিত দিকে দীর্ঘ দূরত্বের জন্য বাউন্স করে",
  T_31_WT_WS_DESC3: "লাল এবং হলুদ ফুল দিয়ে সজ্জিত যা আপনার যুদ্ধক্ষেত্রকে আলোকিত করতে পারে",
  T_31_WT_WS_DESC30: "চালানো যায় এমন একটি বাম্পার গাড়ি",
  T_31_WT_WS_DESC31: "চালানো যায় এমন একটি উভচর গাড়ি",
  T_31_WT_WS_DESC32: "চালানো যায় এমন একটি জিপ গাড়ি",
  T_31_WT_WS_DESC33: "আবর্জনায় পূর্ণ। মানুষের চেয়ে ছোট কিন্তু কিছু্টা কভার দিতে পারে",
  T_31_WT_WS_DESC34: "খোলামেলা, একটি ধাতব রেস ট্র্যাক আশ্রয়",
  T_31_WT_WS_DESC35: "দুটি দরজা সহ কিন্তু কোনো জানালাবিহীন একটি মাঝারি আকারের তাঁবু",
  T_31_WT_WS_DESC36: "ইট দিয়ে তৈরি একটি বড় গ্যারেজ",
  T_31_WT_WS_DESC37: "বড় একটি ইটের দেয়াল, যেটা এলাকা ভাগ করতে ব্যবহার করা যায়",
  T_31_WT_WS_DESC38: "খুবই কাজের একটি ল্যান্ডমার্ক",
  T_31_WT_WS_DESC39: "একটি বড় ধাতব প্ল্যাটফর্ম যা মূল লড়াইয়ের ফাঁদ হিসাবে ব্যবহার করা যেতে পারে",
  T_31_WT_WS_DESC4: "মানুষের চেয়ে লম্বা এবং তাই কভার হিসেবে কাজ করতে পারে",
  T_31_WT_WS_DESC40: "একটি বিনোদনমূলক যানবাহনের মতো দেখতে এবং একাধিক দরজা, জানালা রয়েছে৷",
  T_31_WT_WS_DESC41: "একটি বিনোদনমূলক যানবাহনের মতো দেখতে, যেটাতে একটি দরজা, একাধিক জানালা রয়েছে৷",
  T_31_WT_WS_DESC42: "প্রবেশদ্বার সহ এক সাইডের একটি দেয়াল",
  T_31_WT_WS_DESC43: "সাধারণ একটি এক সাইডের দেয়াল",
  T_31_WT_WS_DESC44: "একটি ওয়াল কর্ণার",
  T_31_WT_WS_DESC45: "একটি অসমান ওয়াল কর্ণার",
  T_31_WT_WS_DESC46: "একটি অসমান ওয়াল কর্ণার",
  T_31_WT_WS_DESC47: "জানালাসহ একটি ওয়াল কর্ণার",
  T_31_WT_WS_DESC5: "একটি পরিত্যক্ত গাড়ি যা মানুষের চেয়ে সামান্য ছোট কিন্তু কিছুটা কভার দিতে পারে",
  T_31_WT_WS_DESC6: "মানুষের চেয়ে লম্বা এবং তাই কভার হিসেবে কাজ করতে পারে",
  T_31_WT_WS_DESC7: "উভয় প্রান্তে খোলা এবং পথ সৃষ্টি বা এলাকা বিভক্ত করার ক্ষেত্রে ব্যবহার করা যেতে পারে",
  T_31_WT_WS_DESC8: "এক প্রান্তে খোলা এবং এলাকা ভাগ করতে ব্যবহার করা যায়",
  T_31_WT_WS_DESC9: "উভয় প্রান্তেই আটকানো এবং পথ সৃষ্টি বা এলাকা বিভক্ত করার ক্ষেত্রে ব্যবহার করা যেতে পারে",
  T_31_YF_MAC10_N: "ম্যাক10",
  T_31_YM_PIN_VEHICLE: "ভেহিক্যাল",
  T_31_Z_OB_UAV: "UAV",
  T_32_C_SKILL_DESC_YAKUZA: "[FFB300]{0}s[-] এর জন্য দ্রুত গতিতে ড্যাশ করে। প্রতিটি ব্যবহারের মধ্যে একটি[FFB300]{3}s[-] কুলডাউন সহ এই স্কিল  [FFB300]{2} পর্যন্ত ব্যবহারের জন্য [-] সঞ্চিত হতে পারে। ড্যাশ পুনরায় পূরণ করার সময়: [FFB300]{1}s[-].",
  T_32_C_SKILL_NAME_YAKUZA: "রিবেল রাশ",
  T_32_HQ_AUG_VNSTREET_N: "AUG- রোরিং গানফাইটার",
  T_32_HQ_BACKPACK_REDDRAGON_N: "ডনলিট ড্রাগো ব্যাকপ্যাক",
  T_32_HQ_BLT_VALENTINE2022_N: "M82B- ভ্যাম্পায়ার মেলিভোলেন্স",
  T_32_HQ_GLOO_DUNHUANG_N: "গ্লু ওয়াল- ফ্রো্জেন প্লাটিনাম",
  T_32_HQ_GLOO_HURRICANE_2_N: "গ্লু ওয়াল- অরোরা কোর",
  T_32_HQ_GRENADE_HURRICANE_N: "গ্রেনেড- ব্রাসি মাইক",
  T_32_HQ_MAC10_DUNHUANG_N: "MAC10- ফ্রো্জেন প্লাটিনাম",
  T_32_HQ_PETSKIN_DUCK_RED_N: "পেটস্কিন: রেড বিয়ানি",
  T_32_HQ_PETSKIN_TORTOISE_BLUE_N: "পেটস্কিন: সাইবার ফ্ল্যাশ",
  T_32_HQ_PETSKIN_TORTOISE_GREEN_N: "পেটস্কিন: গেমার ফ্ল্যাশ",
  T_32_HQ_PETSKIN_TORTOISE_RED_N: "পেটস্কিন: ফেসটিভ ফ্ল্যাশ",
  T_32_HQ_TORTOISE_N: "ফ্ল্যাশ",
  T_32_HQ_VEHICLE_ROADSTER_UNDERTAKER_N: "স্পোর্টস কার- বারিড পার্পলডাস্ট",
  T_32_L_F_A_PHARAOH: "গোল্ডকোটেড ক্লিও (মাস্ক)",
  T_32_L_F_B_PHARAOH: "গোল্ডকোটেড ক্লিং(বটম)",
  T_32_L_F_H_PHARAOH: "গোল্ডকোটেড ক্লিং (হেড)",
  T_32_L_F_HA_PHARAOH: "গোল্ডকোটেড ক্লেও (ফেইসপ্রিন্ট)",
  T_32_L_F_S_PHARAOH: "গোল্ডকোটেড ক্লেও (সুজ)",
  T_32_L_F_T_PHARAOH: "গোল্ডকোটেড ক্লিও (টপ)",
  T_32_L_M_A_JUNKFOOD: "বার্গার লাড (মাস্ক)",
  T_32_L_M_A_PHARAOH: "গোল্ডলাইন মামি (মাস্ক)",
  T_32_L_M_B_JUNKFOOD: "বার্গার লেড (বটম)",
  T_32_L_M_B_PHARAOH: "গোল্ডলাইন মাম্মি (বটম)",
  T_32_L_M_H_JUNKFOOD: "বার্গার লেড (হেড)",
  T_32_L_M_H_PHARAOH: "গোল্ডলাইন মাম্মি (বটম)",
  T_32_L_M_S_JUNKFOOD: "বার্গার লেড (সুজ)",
  T_32_L_M_S_PHARAOH: "গোল্ডলাইনড মাম্মি (সুজ)",
  T_32_L_M_T_JUNKFOOD: "বার্গার লেড (টপ)",
  T_32_L_M_T_PHARAOH: "গোল্ডলাইনড মাম্মি (টপ)",
  T_32_L_T_WHITESWEATER: "সাদা টার্টেলনেক",
  T_32_LC_NEWVAULT_EMOTE: "ইমোট",
  T_32_LO_WS_IMMORTAL: "ইর্মোটাল জোন",
  T_32_LO_WS_ITEM60: "পাইপ",
  T_32_LO_WS_ITEM60_DESC: "একটি হাঁটার যোগ্য টানেল",
  T_32_LO_WS_ITEM61: "টি পাইপ",
  T_32_LO_WS_ITEM61_DESC: "একটি হাঁটার যোগ্য টি টানেল",
  T_32_LO_WS_ITEM62: "পাইপের ছেদ",
  T_32_LO_WS_ITEM62_DESC: "একটি ছেদকারী হাঁটার যোগ্য টানেল",
  T_32_LO_WS_ITEM63: "পাইপ কর্নার",
  T_32_LO_WS_ITEM63_DESC: "একটি হাঁটার যোগ্য কোণযুক্ত টানেল",
  T_32_LO_WS_ITEM64: "ফুড ট্রাক",
  T_32_LO_WS_ITEM64_DESC: "একটি কামড় দিতে এখানে থামুন",
  T_32_LO_WS_ITEM65: "মাস শেড",
  T_32_LO_WS_ITEM65_DESC: "একটি বড় মাশরুম যা একটি মানুষ বহন করতে পারে",
  T_32_LO_WS_ITEM66: "হাঙ্গার",
  T_32_LO_WS_ITEM66_DESC: "সাধারণত আবাসিক এলাকায় দেখা যায়",
  T_32_LO_WS_ITEM67: "কাঠের তক্তা",
  T_32_LO_WS_ITEM67_DESC: "একটি সহজ কাঠের সেতু তৈরি করতে ব্যবহার করুন",
  T_32_LO_WS_ITEM68: "জাল স্ক্রিন",
  T_32_LO_WS_ITEM68_DESC: "প্রাচ্য অনুভূতি",
  T_32_LO_WS_ITEM69: "পিলার",
  T_32_LO_WS_ITEM69_DESC: "সাধারণত নির্মাণ সাইটগুলিতে দেখা যায়",
  T_32_LO_WS_ITEM70: "ক্যাকটাস",
  T_32_LO_WS_ITEM70_DESC: "শক্তিশালী বড় কিন্তু স্টিং করে না",
  T_32_LO_WS_ITEM71: "পাতাবিহীন গাছ",
  T_32_LO_WS_ITEM71_DESC: "এমন একটি গাছ যা শত শত বছর ধরে বেঁচে আছে",
  T_32_LO_WS_ITEM72: "পাথর লণ্ঠন",
  T_32_LO_WS_ITEM72_DESC: "রাজকীয় বাগানগুলিতে দর্শনীয় সাজ",
  T_32_LO_WS_ITEM73: "স্ট্রিট ল্যাম্প",
  T_32_LO_WS_ITEM73_DESC: "সাধারণত রাস্তায় দেখা যায়",
  T_32_LO_WS_ITEM74: "সোলার প্যানেল",
  T_32_LO_WS_ITEM74_DESC: "সূর্যালোক থেকে শক্তি শোষণ করে",
  T_32_LO_WS_ITEM75: "এয়ার কন্ডিশনার A",
  T_32_LO_WS_ITEM75_DESC: "গরমে ঠান্ডা থাকুন",
  T_32_LO_WS_ITEM76: "ফ্যান",
  T_32_LO_WS_ITEM77: "ফ্লাই প্যান",
  T_32_LO_WS_ITEM78: "কিউব",
  T_32_LO_WS_ITEM79: "রিং",
  T_32_LO_WS_ITEM80: "হ্যামার",
  T_32_LO_WS_ITEM81: "বোর্ড",
  T_32_LO_WS_ITEM82: "শুটিং টার্গেট",
  T_32_LO_WS_ITEM83: "ফ্লেক্স ওয়াল",
  T_32_LO_WS_ITEM84AMMO: "অ্যামো লুট পয়েন্ট",
  T_32_LO_WS_ITEM84AMMO_DESC: "যখন স্থাপন করা হয়, নির্বাচিত অ্যামো টাইপ(গুলি) সেখানে স্পন হবে",
  T_32_LO_WS_ITEM84AR: "আর্মর লুট পয়েন্ট",
  T_32_LO_WS_ITEM84AR_DESC: "যখন স্থাপন করা হয়, নির্বাচিত অ্যামো টাইপ(গুলি) সেখানে স্পন হবে",
  T_32_LO_WS_ITEM84ARLV1: "আর্মর লেভেল 1",
  T_32_LO_WS_ITEM84ARLV2: "আর্মর লেভেল 2",
  T_32_LO_WS_ITEM84ARLV3: "আর্মর লেভেল 3",
  T_32_LO_WS_ITEM84CO: "কনজিউম করার মতো লুট পয়েন্ট",
  T_32_LO_WS_ITEM84CO_DESC: "যখন স্থাপন করা হয়, নির্বাচিত কনজিউম করার মতো টাইপ (গুলি) সেখানে স্পন হবে",
  T_32_LO_WS_ITEM84JA: "নিক্ষেপযোগ্য লুট পয়েন্ট",
  T_32_LO_WS_ITEM84JA_DESC: "যখন স্থাপন করা হয়, নির্বাচিত নিক্ষেপযোগ্য টাইপ (গুলি) সেখানে স্পন হবে",
  T_32_LO_WS_ITEM84TE: "সুযোগের লুট পয়েন্ট",
  T_32_LO_WS_ITEM84TE_DESC: "স্থাপন করা হলে, নির্বাচিত সুযোগপ্রকার(গুলি) সেখানে স্পন হবে",
  T_32_LO_WS_ITEM84W: "অস্ত্রের লুট পয়েন্ট",
  T_32_LO_WS_ITEM84W_DESC: "স্থাপন করা হলে, নির্বাচিত অস্ত্রের ধরণ(গুলি) সেখানে স্প্যান করবে",
  T_32_LO_WS_ITEM85: "ডুম/ইমোর্টাল জোন",
  T_32_LO_WS_ITEM85_DESC: "স্থাপন করা হলে, ট্রিগার জোনে প্রবেশকারী খেলোয়াড়রা ইমোর্টাল বা ধ্বংসের একটি নির্দিষ্ট ইফেক্ট অনুভব করবে। (ক্ল্যাশ স্কোয়াড, টিম ডেথম্যাচ এবং প্লে-গ্রাউন্ড মোডে কার্যকর নয়)",
  T_32_LO_WS_ITEM85CP: "চেকপয়েন্ট",
  T_32_LO_WS_ITEM85CP_DESC: "পার্কোর মোডে গেমপ্লে তৈরি করতে ব্যবহৃত একটি আইটেম। চূড়ান্ত চেকপয়েন্ট উপস্থিত হওয়ার জন্য, খেলোয়াড়দের একে একে প্রতিটি চেকপয়েন্ট দিয়ে যেতে হবে। যখন বাদ দেওয়া হয় এবং রিস্পন করা হয়, প্লেয়ার তাদের শেষ চেকপয়েন্টে পুনরায় রিস্পন করতে বেছে নিতে পারে। (ক্ল্যাশ স্কোয়াড, টিম ডেথম্যাচ এবং প্লে-গ্রাউন্ড মোডে কার্যকর নয়)",
  T_32_LO_WS_ITEM85TM: "ফিনিশিং পয়েন্ট",
  T_32_LO_WS_ITEM85TM_DESC: "পার্কোর মোডে গেম-প্লে তৈরি করতে ব্যবহৃত একটি আইটেম। লক্ষ্যটি সম্পূর্ণ করার জন্য খেলোয়াড়দের অবশ্যই ফিনিশিং লাইনের ভিতরে পৌঁছাতে হবে। (ক্ল্যাশ স্কোয়াড, টিম ডেথম্যাচ এবং প্লে-গ্রাউন্ড মোডে কার্যকর নয়)",
  T_32_LO_WS_ITEM86: "স্পন পয়েন্ট",
  T_32_LO_WS_ITEM86_DESC: "এই পয়েন্টে কোন নির্দিষ্ট টিম নিয়োগ করা হবে না। স্থাপন করা হলে, একটি র‍্যানডম টিম স্পন করবে। (ক্ল্যাশ স্কোয়াড, টিম ডেথম্যাচ এবং প্লে-গ্রাউন্ড  মোডে কার্যকর নয়)",
  T_32_LO_WS_ITEM86L: "বড় স্পন পয়েন্ট",
  T_32_LO_WS_ITEM86L_DESC: "পার্কুর মোডের জন্য একটি বৃহৎ স্পন পয়েন্ট সুপারিশ করা হয়েছে, যেখানে সমস্ত খেলোয়াড় একটি সারিতে স্পন করবে। (ক্ল্যাশ স্কোয়াড, টিম ডেথম্যাচ এবং প্লে-গ্রাউন্ড মোডে কার্যকর নয়)",
  T_32_LO_WS_ITEM87: "ব্লক",
  T_32_LO_WS_ITEM87_DESC: "সাইজ কাস্টমাইজেশন সক্রিয় করে",
  T_32_LO_WS_ITEM88: "কিউবয়েড & স্লোপ",
  T_32_LO_WS_ITEM88_DESC: `একটি কিউবয়েড বা স্লোপ 
যেটার সাইজ অ্যাডজাস্ট করা যায়`,
  T_32_LO_WS_ITEMLINE: "শিফট",
  T_32_LO_WS_ITEMMOVE: "ট্রিগার সেটিং",
  T_32_LO_WS_ITEMROT: "ট্রান্সফর্ম",
  T_32_LO_WS_ITEMSCALE: "স্কেল",
  T_32_LO_WS_KILLZONE: "ডোম জোন",
  T_32_LO_WS_LOOT_AMMOTYPE: "অ্যামো",
  T_32_LO_WS_LOOT_ARTYPE: "আর্মর",
  T_32_LO_WS_LOOT_COTYPE: "কনজিউম করার মতো",
  T_32_LO_WS_LOOT_JATYPE: "নিক্ষেপণ যোগ্য",
  T_32_LO_WS_LOOT_RANDOM: "র‍্যান্ডম",
  T_32_LO_WS_LOOT_TETYPE: "স্কোপ",
  T_32_LO_WS_LOOT_WEAPONTYPE: "বন্দুক",
  T_32_LO_WS_SCALEX: "দৈর্ঘ্য",
  T_32_LO_WS_SCALEY: "উচ্চতা",
  T_32_LO_WS_SCALEZ: "প্রস্থ",
  T_32_LO_WS_TRIGGERH: "লুকানো",
  T_32_LO_WS_TRIGGERHORP: "ট্রিগারগুলি দেখান/লুকান",
  T_32_LO_WS_TRIGGERP: "দেখান",
  T_32_LO_WS_TRIGGERTYPE: "ট্রিগার টাইপ",
  T_32_M_WS_MODE_ANNIHILATE: "ওয়াইপ আউপ",
  T_32_M_WS_MODE_SCORE: "পয়েন্টস গ্র‍্যাব",
  T_32_M_WS_MODE_SPEED: "পার্কুর",
  T_32_M_WS_MULTIPLETEAMS: "মাল্টি-টিম যুদ্ধ",
  T_32_M_WS_ROUNDS: "রাউন্ডস",
  T_32_R_EMOTE_HURRICANE_BLUE_NAME: "স্যুইচিং পদক্ষেপ",
  T_32_RW_WEAPON_M1887TD_NAME: "M1887-X",
  T_32_T_WS_ME_BLUECIRCLE: "ডেঞ্জার জোন",
  T_32_T_WS_ME_BLUECIRCLEDAMAGE: "ড্যামেজ",
  T_32_T_WS_ME_BLUECIRCLESETTING: "ডেঞ্জার জোন",
  T_32_T_WS_ME_CUSTOM: "কাস্টমাইজ",
  T_32_T_WS_ME_ENDTYPE1: "ওয়াইপ আউট",
  T_32_T_WS_ME_ENDTYPE2: "পয়েন্টস গ্র‍্যাব",
  T_32_T_WS_ME_ENDTYPE3: "পার্কুর",
  T_32_T_WS_ME_ENDTYPEDESC1: "সার্ভাইভ করা শেষ টিম হোন",
  T_32_T_WS_ME_ENDTYPEDESC2: `একটি পয়েন্ট-ভিত্তিক মোড, যেখানে টার্গেট স্কোরে প্রথম পৌঁছানো টিমই বিজয়ী হবে।
আপনি ইচ্ছেমতো গেমপ্লের রুলস সেট এবং প্যারামিটার এডিট করতে পারেন, যার মধ্যে এলিমিনেশনের জন্য কত স্কোর দেওয়া হবে তা সেট করা।`,
  T_32_T_WS_ME_ENDTYPEDESC3: `একটি পার্কুর মোড যেখানে যে টিমের সকল সদস্য আগে ফিনিশিং পয়েন্টে পৌঁছায় তারাই জয়ী হয়।
আপনি ইচ্ছেমতো গেমপ্লের রুলস, পথের অবজেক্ট এবং ফিনিশিং লাইন সেট করতে পারেন।`,
  T_32_T_WS_ME_MATCHTIME: "ম্যাচ টাইম",
  T_32_T_WS_ME_MECHANIC: "ম্যকানিজম",
  T_32_T_WS_ME_NEARCHECKPOINT: "চেকপয়েন্টের কাছে",
  T_32_T_WS_ME_PLAYERNUMLIMIT: "মোট 12 জনের বেশি খেলোয়াড় থাকতে অসমর্থ",
  T_32_T_WS_ME_PREGAMETIME: "প্রস্তুতির সময়",
  T_32_T_WS_ME_RESPAWN: "রিস্পনস",
  T_32_T_WS_ME_RESPAWNSETTING: "রিস্পনস",
  T_32_T_WS_ME_ROUNDNUM: "রাউন্ডের সংখ্যা",
  T_32_T_WS_ME_ROUNDOPEN: "একাধিক রাউন্ড সক্রিয় করুন",
  T_32_T_WS_ME_ROUNDRESET: "রাউন্ড রিসেটস",
  T_32_T_WS_ME_ROUNDSETTING: "রাউন্ডস",
  T_32_T_WS_ME_SAFEZONESHRINKTIME2: "জোন স্রিংকের সময়কাল",
  T_32_T_WS_ME_SCORESETTING: "স্কোর",
  T_32_T_WS_ME_TEAMMATENUM: "প্রতি টিমে মেম্বার্স",
  T_32_T_WS_ME_TEAMNUM: "টিমের সংখ্যা",
  T_32_T_WS_ME_TEAMSETTING: "টিম",
  T_32_U_ATTACHMENT_8: "ব্যাগ পাউচ",
  "T_32_U_GOLD_FAMAS-I": "ফামাস-I",
  "T_32_U_GOLD_FAMAS-II": "ফামাস-II",
  "T_32_U_GOLD_FAMAS-III": "ফামাস-III",
  T_32_U_GOLD_HEATGUN_I: "প্লাজমা-I",
  T_32_U_GOLD_HEATGUN_II: "প্লাজমা-II",
  T_32_U_GOLD_HEATGUN_III: "প্লাজমা-III",
  T_32_U_GOLD_KAR98K_I: "Kar98k-I",
  T_32_U_GOLD_KAR98K_II: "Kar98k-II",
  T_32_U_GOLD_KAR98K_III: "Kar98k-III",
  T_32_U_GOLD_M14_I: "M14-I",
  T_32_U_GOLD_M14_II: "M14-II",
  T_32_U_GOLD_M14_III: "M14-III",
  "T_32_U_GOLD_M4A1-I": "M4A1-I",
  "T_32_U_GOLD_M4A1-II": "M4A1-II",
  "T_32_U_GOLD_M4A1-III": "M4A1-III",
  T_32_U_GOLD_M60_I: "M60-I",
  T_32_U_GOLD_M60_II: "M60-II",
  T_32_U_GOLD_M60_III: "M60-III",
  T_32_U_GOLD_MP5_I: "MP5-I",
  T_32_U_GOLD_MP5_II: "MP5-II",
  T_32_U_GOLD_MP5_III: "MP5-III",
  T_32_U_GOLD_VSS_I: "VSS-I",
  T_32_U_GOLD_VSS_II: "VSS-II",
  T_32_U_GOLD_VSS_III: "VSS-III",
  T_32_U_REPLACER: "আপগ্রেড চিপ",
  T_32_WT_WS_BARRIER: "বাধাগুলো",
  T_32_WT_WS_BDS: "ভবনগুলো",
  T_32_WT_WS_MMINVALIDERROR: "অগ্রহণযোগ্য ম্যাপ কোড",
  T_32_WT_WS_TRGS: "ট্রিগারস",
  T_32_YF_CHARGESHOT_N: "চার্জ বুস্টার",
  T_32_YF_GOLD_GROZA_N: "গ্রোজা-X",
  T_32_YF_GOLD_M249_N: "M249-X",
  T_32_YF_GOLD_SVD_N: "SVD-Y",
  T_32_YS_WEAPON_TAG_18: "অতিরিক্ত ড্যামেজ",
  T_32_YS_WEAPON_TAG_3: "রেট অফ ফায়ার",
  T_32_YS_WEAPON_TAG_36: "আর্মর ভেদনক্ষমতা",
  T_32_YS_WEAPON_TAG_39: "আকিম্বো সাপোর্ট করে",
  T_32_YS_WEAPON_TAG_42: "আইস ওয়াল",
  T_33_C_SKILL_DESC_GRAFFITIST: "একটি [FFB300]{0}m[-] এলাকা তৈরি করে, যেখানে নিক্ষেপযোগ্য কোনো কিছু ভেদ করতে পারে না। এলাকার মিত্ররা প্রতি সেকেন্ডে  [FFB300]{1}%[-] আর্মর স্থায়িত্ব রিস্টোর করবে এবং প্রাপ্ত অ্যামো ড্যামেজ [FFB300]{2}%[-] কমবে৷ স্থায়ী হয় [FFB300]{3}s[-] পর্যন্ত। ইফেক্টগুলো স্ট্যাক করে না।কুলডাউন: [FFB300]{4}s[-]।",
  T_33_C_SKILL_DESC_HITMAN: "স্নাইপার এবং মার্কসম্যান রাইফেলস ব্যবহার করার সময়, ফায়ারিং সাউন্ড নিঃশব্দ করা হয় এবং সফল শটগুলো প্রতিপক্ষদের [FFB300]{0}%[-] দ্রুত রক্তপাত ঘটাতে পারে।",
  T_33_C_SKILL_DESC_KENTA: "[FFB300]{0}m[-] প্রস্থের একটি শিল্ড তৈরি করে যা সামনে থেকে আসা ওয়েপন ড্যামেজ [FFB300]{1}%[-] কমায়৷ গুলি চালানোর সময়, ড্যামেজ হ্রাস [FFB300]{2}%[-] এ কমে যায়। স্থায়ী হয় [FFB300]{3}s[-] পর্যন্ত। কুলডাউন: [FFB300]{4}s[-]।",
  T_33_C_SKILL_DESC_MADEMANA: "একটি [FFB300]{0}m[-] মি ইলেক্ট্রোম্যাগনেটিক তরঙ্গ আনে যা এনিমিদের স্কিল এক্টিভিশন নিষ্ক্রিয় করে দেয়, [FFB300]{3}DMG[-] প্রদান করে এবং তাদের ইন্টারেকশন কাউন্টডাউনে বাধা দেয়। [FFB300]{1}s[-] পর্যন্ত স্থায়ী হয়। কুলডাউন: [FFB300]{2}s[-]।",
  T_33_C_SKILL_NAME_BODYGUARD: "ফায়ারআর্মস এক্সপার্ট",
  T_33_C_SKILL_NAME_KENTA: "সোর্ডসম্যান র‍্যাথ",
  T_33_C_SKILL_NAME_MADEMANA: "লড়াইয়ের রোমাঞ্চ",
  T_33_DY_AXOLOTL_N: "জ্যাসিল",
  T_33_DY_PETSKIN_AXOLOTL_GREY_N: "পেটস্কিন: ফ্রুটি জ্যাসিল",
  T_33_DY_PETSKIN_DUCK_FFWS03_N: "পেটস্কিন: FFWS বিয়ানি",
  T_33_DY_PETSKIN_HAWK_FASTBREAKING22_N: "পেটস্কিন: ব্লুমিং ফ্যালকো",
  T_33_HQ_BASEBALLBAT_APRILFOOL22_N: "মারাত্মক ব্যাগুয়েট",
  T_33_HQ_EMOTE_SONGKRAN_N: "আসুন এবং ডান্স করুন",
  T_33_HQ_G18_CYBERTHIEF_N: "G18- হাইপারকোর ব্লু",
  T_33_HQ_GRENADE_CYBERTHIEF_N: "গ্রেনেড- হাইপারকোর ব্লু",
  T_33_HQ_M14_SPIDERLILY_N: "M14- বার্নিং লিলি",
  T_33_HQ_MAG7_FFUNIT2_N: "MAG-7- শ্যাডো রজ",
  T_33_HQ_MP40_FFWS03_N: "MP40- হেভেন ওয়ারিওর",
  T_33_HQ_SCAR_FFWS03_N: "স্কার- হেভেন ওয়ারিওর",
  T_33_HQ_SICKLE_FASTBREAKING22_N: "এমারাল্ড পাওয়ার স্কাইথ",
  T_33_HQ_THROWINGKNIFE_FFWS03_N: "হেভেন ওয়ারিয়র ডেগার",
  T_33_HQ_VECTOR_CYBERTHIEF_N: "ভেক্টর- হাইপারকোর ব্লু",
  T_33_HQ_VEHICLE_JEEP_FASTBREAKING22_N: "জিপ- এমারাল্ড শিমার",
  T_33_HQ_VEHICLE_MONSTER_LION_RED_N: "মনস্টার ট্রাক- বোনব্রুজার স্কর্চ",
  T_33_HQ_VEHICLE_SUV_FFWS03_N: "পিকআপ ট্রাক- হেভেন গার্ডিয়ান",
  T_33_LO_WS_BHPARA_A: "একটিভ",
  T_33_LO_WS_BHPARA_ATKMODE: "অ্যাটাক টাইপ",
  T_33_LO_WS_BHPARA_GROUP: "টিম",
  T_33_LO_WS_BHPARA_NA: "কোন আক্রমণ নেই",
  T_33_LO_WS_BHPARA_P: "প্যাসিভ",
  T_33_LO_WS_DICE_DESC: "একটি ডাইস যা আপনার জাম্পকে উন্নত করে এবং বিভিন্ন গেমপ্লেতে ব্যবহার করা যেতে পারে",
  T_33_LO_WS_DICEVXZ: "হরিজন্টাল স্পিড",
  T_33_LO_WS_DICEVY: "ভার্টিকাল স্পিড",
  T_33_LO_WS_DTOWER: "টাওয়ার",
  T_33_LO_WS_DTOWER_DESC: "প্রতিরক্ষামূলক কাঠামো থেকে একটি নির্দিষ্ট দূরত্বের মধ্যে থাকা শত্রুদের অটোমেটিক্যালি আক্রমণ করে। যদি এর HP শূন্যে পৌঁছায় তবে ডিসাবেল করা হয়েছে। (ক্ল্যাশ স্কোয়াড, টিম ডেথম্যাচ এবং প্লে-গ্রাউন্ড মোডে কার্যকর নয়)",
  T_33_LO_WS_FORT: "দুর্গ",
  T_33_LO_WS_FORT_DESC: "ক্রিটিকাল স্ট্রাকচার থেকে একটি নির্দিষ্ট দূরত্বের মধ্যে থাকা শত্রুদের অটোমেটিক্যালি আক্রমণ করে। যদি এর HP শূন্যে পৌঁছায় তবে ডিসেবেল করা হয়েছে। (ক্ল্যাশ স্কোয়াড, টিম ডেথম্যাচ এবং প্লে-গ্রাউন্ড মোডে কার্যকর নয়)",
  T_33_LO_WS_ITEM89: "রিফাইনারী ট্যাংক",
  T_33_LO_WS_ITEM89_DESC: "একটি পানি-সংরক্ষণের কাঠামো",
  T_33_LO_WS_ITEM90: "কুকুরের বাড়ি",
  T_33_LO_WS_ITEM90_DESC: "কুকুরছানাদের জন্য একটি বাড়ি",
  T_33_LO_WS_ITEM91: "বাস স্টপ",
  T_33_LO_WS_ITEM91_DESC: "একটি সাধারণ বাস স্টপ",
  T_33_LO_WS_ITEM92: "গ্রাফিতি ওয়াল",
  T_33_LO_WS_ITEM92_DESC: "স্প্রেপেইন্ট দিয়ে সজ্জিত একটি ওয়াল",
  T_33_LO_WS_ITEM93: "স্টেবল",
  T_33_LO_WS_ITEM93_DESC: "বেসিক খড়-তৈরি কাঠামো",
  T_33_LO_WS_ITEM94: "বেঞ্চ",
  T_33_LO_WS_ITEM94_DESC: "পার্ক বেঞ্চ",
  T_33_LO_WS_ITEM95: "পাথরের সেতু",
  T_33_LO_WS_ITEM95_DESC: "পাথর দিয়ে নির্মিত একটি সেতু",
  T_33_LO_WS_ITEM96: "সান শেড",
  T_33_LO_WS_ITEM96_DESC: "ছাতার নীচে সূর্য-পোড়া প্রতিরোধ করুন",
  T_33_LO_WS_ITEM97: "লাইন আর্চ শেষ করুন",
  T_33_LO_WS_ITEM97_DESC: "সমাপ্তি রেখাটি নির্দেশ করুন",
  T_33_LO_WS_ITEM98: "বিজ্ঞাপন বোর্ড",
  T_33_LO_WS_ITEM98_DESC: "বিজ্ঞাপনের জন্য একটি নিয়মিত ব্যানার",
  T_33_LO_WS_PARA_DM: "ড্যামেজ",
  T_33_LO_WS_PARA_HP: "HP",
  T_33_LO_WS_PARA_RANGE: "শত্রু স্ক্যানের দূরত্ব",
  T_33_LO_WS_PARA_SP: "স্পিড",
  T_33_LO_WS_ZBPARA_AMOUNT: "জম্বিদের প্রতি ঢেউ",
  T_33_LO_WS_ZBPARA_INTERVAL: "ওয়েভ ইন্টারভাল (s)",
  T_33_LO_WS_ZBPARA_ROUND: "# তরঙ্গ",
  T_33_LO_WS_ZBSPAWNER: "জম্বি স্পন",
  T_33_LO_WS_ZBSPAWNER_DESC: "কনফিগারেশন অনুযায়ী স্বয়ংক্রিয়ভাবে জম্বিদের স্পন করে। তাদের আচরণ ড্রপ-ডাউন মেনু ব্যবহার করে কনফিগার করা যেতে পারে। (ক্ল্যাশ স্কোয়াড, টিম ডেথম্যাচ এবং প্লে-গ্রাউন্ড মোডে কার্যকর নয়)",
  T_33_MF_CHARACTER_BLACKSMITH_N: "কেন্টা",
  T_33_PD_ZOMBIE_LEVELUP: "লেভেল আপ",
  T_33_RW_SKILL_DESC_GANGGIRL: "ফায়ারিং রেট [FFB300]{0}%[-] বৃদ্ধি করে৷ যখন ব্যবহারকারী কোনো প্রতিপক্ষকে আঘাত করে, তখন গুলি চালানোর সর্বোচ্চ [FFB300]{1}%[-] মুভমেন্ট স্পিডে রূপান্তরিত হয়, এবং যখন ব্যবহারকারী যুদ্ধে বেঁচে যায় তখন কনভার্শন রিসেট করে।",
  T_33_RW_SKILL_NAME_GANGGIRL: "ফাইট-অথবা-ফ্লাইট",
  T_33_WT_WS_BASICSET1: "বেসিক",
  T_33_WT_WS_QCEPRTIP: "EPকে দ্রুত HPতে রূপান্তর করুন",
  T_33_WT_WS_SKILLSET_TAG: "আনলিমিটেড স্কিল",
  T_33_WT_WS_SKILLSET1: "স্কিল সেটিংস",
  T_33_WT_WS_SKILLSET10: "টাইম টার্নার (Chrono)",
  T_33_WT_WS_SKILLSET11: "রিপটাইড রিদম (Skyler)",
  T_33_WT_WS_SKILLSET12: "এক্সট্রিম এনকাউন্টার (Xayne)",
  T_33_WT_WS_SKILLSET13: "হিলিং হার্টবিট (Dimitri)",
  T_33_WT_WS_SKILLSET2: "প্যাসিভ স্কিল",
  T_33_WT_WS_SKILLSET2_TIP: "প্যাসিভ স্কিল চালু/বন্ধ করুন",
  T_33_WT_WS_SKILLSET3: "একটিভ স্কিল (নীচে কুলডাউন সময় এডজাস্ট করতে চালু করুন)",
  T_33_WT_WS_SKILLSET3_TIP: "একটিভ স্কিল চালু/বন্ধ করুন। যদি চালু থাকে তবে বিভিন্ন একটিভ স্কিল কুলডাউন সময় নীচে কনফিগার করা যেতে পারে।",
  T_33_WT_WS_SKILLSET4: "ছদ্মবেশ (Wukong)",
  T_33_WT_WS_SKILLSET5: "যুদ্ধের রোমাঞ্চ (A124)",
  T_33_WT_WS_SKILLSET6: "ড্রপ দ্যা বিট (Alok)",
  T_33_WT_WS_SKILLSET7: "পেইন্টেড রিফিউজি (Steffie)",
  T_33_WT_WS_SKILLSET8: "ট্রেসিং ধাপ (Clu)",
  T_33_WT_WS_SKILLSET9: "মাস্টার অফ অল (K)",
  T_33_WT_WS_UNIT_HPSECOND: "HP/সে",
  T_33_WT_WS_UNIT_METER: "m",
  T_33_WT_WS_UNIT_SECOND: "সেক",
  T_33_YF_G36_N: "G36",
  T_33_YS_B_RAINCOAT: "রেইনডল (মাস্ক)",
  T_33_YS_H_ONIGIRI: "ওনিগিরি হোড",
  T_33_YS_H_RAINCOAT: "রেইনডল (হেড)",
  T_33_YS_HA_CRYINGFACE: "ক্রায়িং ইসোট (ফেসপেইন্ট)",
  T_33_YS_M_H_FROGKING: "ব্যাঙ রাজা ক্যাপ",
  T_33_YS_S_RAINCOAT: "রেইনডল (সুজ)",
  T_33_YS_T_BLACKHOLE: "ডপলার শিফট হুডি",
  T_33_YS_T_RAINCOAT: "রেইনডল (টপ)",
  T_33_YS_T_SOCCER_GREEN: "ইলেকট্রিফাইড কিক (জার্সি)",
  T_33_YS_T_SOCCER_YELLOW: "এনার্জাইড কিক (জার্সি)",
  T_33_YS_T_WIFI: "নেট এন' পরবর্তী টি-শার্ট",
  T_34_C_SKILL_DESC_STREAMERGUY: `প্রতিটি এলিমিনেশন বা স্পেকটেটর থেকে ওয়ান স্ট্যাক করে ইফেক্ট পাওয়া যায়। প্রতিটি স্ট্যাক এনিমির হেডশট ড্যামেজ থেকে প্রাপ্ত ড্যামেজ [FFB300]{0}%[-] হ্রাস পায় (ম্যাক্স. [FFB300]{1}%[-])
এবং এনিমিকে দেওয়া হেডশট ড্যামেজ [FFB300]{2}%[-] বৃদ্ধি পায় (ম্যাক্স. [FFB300]{3}%[-])।`,
  T_34_C_SKILL_DESC_TRACKER: "একটি [FFB300]100m[-] সম্মুখ দূরত্বের মধ্যে নিকটতম শত্রুর দিকে একটি ড্রোন ছেড়ে দেয়, একটি [FFB300]{5}মি-ব্যাস[-] পালস বিস্ফোরণ তৈরি করে যা [FFB300]{0}%[-] দ্বারা মুভমেন্ট স্পিড হ্রাস করে এবং ফায়ারিং স্পিড [FFB300]{1}%[-]। [FFB300]{3}s[-] পর্যন্ত স্থায়ী হয়। ডিল করে [FFB300]{2} DMG[-]। কুলডাউন: [FFB300]{4}s[-]।",
  T_34_C_SKILL_NAME_TRACKER: "শকওয়েভ সেন্স করে",
  T_34_DY_PETSKIN_SURFSHARK_ENERGY_N: "পেট স্কিন: এংরি সার্ফার ফিন",
  T_34_DY_PETSKIN_SURFSHARK_SEA_N: "পেট স্কিন: ডিপ ওশ্যান ফিন",
  T_34_DY_PETSKIN_SURFSHARK_STORM_N: "পেট স্কিন: থান্ডারস্টোর্ম ফিন",
  T_34_DY_PETSKIN_TIGER_BIS_N: "পেট স্কিন: ডিজিটাল টিগ",
  T_34_DY_SURFSHARK_N: "ফিন",
  T_34_HQ_EMOTE_BIS_COMMAND_N: "গ্রেট কন্ডাক্টর",
  T_34_HQ_EMOTE_RAMPAGE4_BLUE_N: "এনার্জেটিক",
  T_34_HQ_EMOTE_RIDICULE_N: "উপহাস",
  T_34_HQ_VEHICLE_SUV_CRAZYSCIENTIST_N: "পিকআপ ট্রাক- এভিল ইঞ্জিনিয়ার",
  T_34_HQ_VEHICLE_TUTU_WINTERDOG_N: "টুক টুক- হাস্কি পাপ",
  T_34_JL_EAGLE_RAMPAGE4_N: "ডেজার্ট ঈগল- হাইব্রিড এক্সপ্লোশন",
  T_34_JL_G36_MADBIONIC_N: "G36- ফ্লেয়ারিং বায়োনিকা",
  T_34_JL_GRENADE_BIS_N: "গ্রেনেড- সোলজার পিক্সেল",
  T_34_JL_MACHETE_RAMPAGE4_N: "নাইট ব্লেড",
  T_34_JL_THROWINGKNIFE_BANANA_N: "ব্যানানা ডিগার",
  T_34_JL_UMP45_BIS_N: "UMP- ডিজিটাল ড্যাশার",
  T_34_LY_WS_ABS_DESC: "এই নাম্বারের পরম মান অর্জন করুন",
  T_34_LY_WS_ADD_DESC: "একটি লিস্টের শেষে একটি নতুন উপাদান যোগ করুন",
  T_34_LY_WS_AUTO_A: "অটো স্ক্যান এনিমি",
  T_34_LY_WS_BOT: "রেগুলার",
  T_34_LY_WS_BOT_PATH: "পাথ",
  T_34_LY_WS_BOT_TYPE: "টাইপ",
  T_34_LY_WS_BOT4: "কুড়াল",
  T_34_LY_WS_BOT5: "টসিং",
  T_34_LY_WS_BOT6: "সেলফ-এক্সপ্লোড",
  T_34_LY_WS_BOT8: "শিল্ডেড",
  T_34_LY_WS_COL_DESC: "একটি রঙ বাছাই করুন",
  T_34_LY_WS_DEL_DESC: "লিস্টে একটি মনোনীত ইনডেক্সের সংশ্লিষ্ট ইলিমেন্টটি ডিলিট করুন",
  T_34_LY_WS_DF_PER: "ডিফেন্স %",
  T_34_LY_WS_FORT_INTERVAL: "অ্যাটাক ইন্টারভাল টাইম (s)",
  T_34_LY_WS_GET: "অর্জন করুন",
  T_34_LY_WS_GET_DESC: "একটি লিস্টে একটি মনোনীত সূচকের সংশ্লিষ্ট ইলিমেন্ট অর্জন করুন",
  T_34_LY_WS_GLEN_ARR_DESC: "বর্তমান লিস্টের উপাদান সংখ্যা অর্জন করুন",
  T_34_LY_WS_GLEN_DESC: "টেক্সটের এই স্ট্রিংটির দৈর্ঘ্য অর্জন করুন",
  T_34_LY_WS_GVX: "x ভেক্টর কম্পোনেন্ট অর্জন করুন",
  T_34_LY_WS_GVX_DESC: "একটি ভেক্টর প্রথম উপাদান অর্জন করুন",
  T_34_LY_WS_GVY: "y ভেক্টর কম্পোনেন্ট অর্জন করুন",
  T_34_LY_WS_GVY_DESC: "একটি ভেক্টরের দ্বিতীয় উপাদানটি অর্জন করুন",
  T_34_LY_WS_GVZ: "z ভেক্টর কম্পোনেন্ট সেট করুন",
  T_34_LY_WS_GVZ_DESC: "একটি ভেক্টরের তৃতীয় কম্পোনেন্ট অর্জন করুন",
  T_34_LY_WS_INDEX: "ইনডেক্স",
  T_34_LY_WS_JOIN: "সংযুক্ত করুন",
  T_34_LY_WS_NEG_DESC: "এই সংখ্যার ঋণাত্মক মান অর্জন করুন",
  T_34_LY_WS_PATH: "পাথ সেটার",
  T_34_LY_WS_PATH_DESC: "বিশেষ জীবন্ত আইটেমের ভ্রমণ পথ যোগ/মুছে ফেলতে ব্যবহার করুন। (ক্ল্যাশ স্কোয়াড, টিম ডেথম্যাচ এবং প্লে-গ্রাউন্ড মোডে কার্যকর নয়)",
  T_34_LY_WS_POINT: "মার্কার",
  T_34_LY_WS_POINT_DESC: "বর্তমান অবস্থান চিহ্নিত করতে ব্যবহার করুন। (ক্ল্যাশ স্কোয়াড, টিম ডেথম্যাচ এবং প্লে-গ্রাউন্ড মোডে কার্যকর নয়)",
  T_34_LY_WS_RANGE_F: "দূরে",
  T_34_LY_WS_RANGE_M: "মধ্যম",
  T_34_LY_WS_RANGE_N: "নিকটে",
  T_34_LY_WS_RNDF_DESC: "একটি ইন্টারভাল থেকে একটি র‍্যানডম ডেসিমাল জেনারেট করুন",
  T_34_LY_WS_RNDI_DESC: "একটি ব্যবধান থেকে একটি র‍্যানডম পূর্ণসংখ্যা তৈরি করুন",
  T_34_LY_WS_SET: "মোডিফাই",
  T_34_LY_WS_SET_DESC: "একটি লিস্টে একটি মনোনীত ইনডেক্সের সংশ্লিষ্ট ইলিমেন্ট সেট করুন",
  T_34_LY_WS_SQRT_DESC: "এই সংখ্যার বর্গমূল অর্জন করুন",
  T_34_LY_WS_STRC_DESC: "টেক্সটের দুটি স্ট্রিং সংযুক্ত করুন",
  T_34_LY_WS_SVX: "x ভেক্টর কম্পোনেন্ট সেট করুন",
  T_34_LY_WS_SVX_DESC: "একটি ভেক্টরের প্রথম কম্পোনেন্ট সেট করুন",
  T_34_LY_WS_SVY: "y ভেক্টর কম্পোনেন্ট সেট করুন",
  T_34_LY_WS_SVY_DESC: "একটি ভেক্টরের দ্বিতীয় কম্পোনেন্ট সেট করুন",
  T_34_LY_WS_SVZ: "z ভেক্টর কম্পোনেন্ট সেট করুন",
  T_34_LY_WS_SVZ_DESC: "একটি ভেক্টরের তৃতীয় উপাদান সেট করুন",
  T_34_LY_WS_VADD: "ভেক্টর সংযোজন",
  T_34_LY_WS_VADD_DESC: "দুইটি ভেক্টর যোগ করুন",
  T_34_LY_WS_VAL_DESC: "দৃশ্যকল্প অনুযায়ী একটি পূর্ণসংখ্যা বা দশমিক ইনপুট করুন",
  T_34_LY_WS_VANG_DESC: "দুটি ভেক্টরের মধ্যে কোণ গণনা করুন",
  T_34_LY_WS_VCP: "ক্রস প্রোডাক্ট",
  T_34_LY_WS_VCP_DESC: "দুটি ভেক্টরের ক্রস প্রোডাক্ট গণনা করুন",
  T_34_LY_WS_VDIS_DESC: "দুটি ভেক্টরের মধ্যে দূরত্ব গণনা করুন",
  T_34_LY_WS_VDP: "ডট প্রোডাক্ট",
  T_34_LY_WS_VDP_DESC: "দুটি ভেক্টরের ডট প্রোডাক্ট গণনা করুন",
  T_34_LY_WS_VFX1: "গোলাকার",
  T_34_LY_WS_VFX2: "বেলনাকৃতির",
  T_34_LY_WS_VFX3: "রিং",
  T_34_LY_WS_VFX4: "বুম",
  T_34_LY_WS_VFX5: "পিক্সেল",
  T_34_LY_WS_VFX6: "স্পার্কস",
  T_34_LY_WS_VMOD_DESC: "একটি ভেক্টরের মাত্রা গণনা করুন",
  T_34_LY_WS_VMUL: "ভেক্টরের গুণন",
  T_34_LY_WS_VMUL_DESC: "দুটি ভেক্টর গুণ করুন",
  T_34_LY_WS_VNOR_DESC: "একটি ভেক্টরকে স্বাভাবিক করুন",
  T_34_LY_WS_VSUB: "ভেক্টর বিয়োগ",
  T_34_LY_WS_VSUB_DESC: "দুইটি ভেক্টর বিয়োগ করুন",
  T_34_M_WS_ANGLE: "রোটেট অ্যাঙ্গেল",
  T_34_M_WS_ARRAY: "লিস্ট",
  T_34_M_WS_ATT: "প্রপার্টি",
  T_34_M_WS_BOOL: "বুলিয়ান",
  T_34_M_WS_COLORARRAY: "কালার অ্যারে",
  T_34_M_WS_COLOUR: "রঙ",
  T_34_M_WS_CONFRONBANNER: "ব্যাটেল ব্যানার",
  T_34_M_WS_COORDINATE: "কোঅর্ডিনেটস",
  T_34_M_WS_CUSTOMINF: "কাস্টম HUD",
  T_34_M_WS_CUSTOMMODEDESC: `একটা ফাঁকা এবং সম্পূর্ণ কাস্টমাইজযোগ্য মোড যেখানে কোনো প্রিসেট গেমপ্লে নেই, যেখানে আপনি নিজের নিয়মে ক্রিয়েট এবং প্লে করতে পারবেন।
নতুন ম্যাপ ক্রিয়েটরদের জন্য এটা কিছুটা কঠিন হতে পারে।`,
  T_34_M_WS_DAMAGETYPE: "ড্যামেজ টাইপ",
  T_34_M_WS_DAMAGETYPEDESC: "ড্যামেজের টাইপ বর্তমানে সিস্টেম কর্তৃক নির্ধারিত",
  T_34_M_WS_DESCTEXT: "বর্ণনামূলক টেক্সট",
  T_34_M_WS_DURACTION: "স্থায়ীত্ব",
  T_34_M_WS_ECAMODE: "কাস্টমাইজ মোড",
  T_34_M_WS_ENDPHASEDESC: "অবিলম্বে বর্তমান পর্যায়টি শেষ করুন এবং পরবর্তীটিতে যান",
  T_34_M_WS_ENTITY: "এনটিটি",
  T_34_M_WS_FLOAT: "ডেসিমাল",
  T_34_M_WS_GAME: "গেম",
  T_34_M_WS_GAMERESULTS: "ম্যাচ রেজাল্ট",
  T_34_M_WS_GETCONTROL2: "এনটিটির প্রপার্টি (ডিজাইন, রঙ, কন্টেন্ট ইত্যাদি সহ) সম্পাদনা করতে প্লেয়ার ইন্টারফেস থেকে একটি কন্ট্রোল  এনটিটি অর্জন করুন",
  T_34_M_WS_HEIGHT: "উচ্চতা",
  T_34_M_WS_HUDBUTTONWIDGET: "বাটন কন্ট্রোল",
  T_34_M_WS_HUDEMPTYWIDGET: "খালি এনটিটি",
  T_34_M_WS_HUDIMAGEWIDGET: "ইমেজ কন্ট্রোল",
  T_34_M_WS_HUDINPUTWIDGET: "টেক্সট বক্স কন্ট্রোল",
  T_34_M_WS_HUDLABELWIDGET: "টেক্সট কন্ট্রোল",
  T_34_M_WS_ICON: "আইকন",
  T_34_M_WS_ICON_AIM: "লক্ষ্য",
  T_34_M_WS_ICON_ARROW: "তীর",
  T_34_M_WS_ICON_BLAST: "ব্লাস্ট",
  T_34_M_WS_ICON_CIRCULAR: "সার্কেল",
  T_34_M_WS_ICON_CLOTH: "পাম",
  T_34_M_WS_ICON_COLLIMATION: "ক্রসহেয়ার",
  T_34_M_WS_ICON_CORPSE: "জোম্বি",
  T_34_M_WS_ICON_CROSS: "ক্রস",
  T_34_M_WS_ICON_DAY: "সূর্য",
  T_34_M_WS_ICON_DEFENSE: "শিল্ড",
  T_34_M_WS_ICON_DIALOGUE: "ডায়লগ",
  T_34_M_WS_ICON_DIAMONDS: "ডায়মন্ড",
  T_34_M_WS_ICON_EXCLAMATIONMARK: "বিস্ময়সূচক চিহ্ন",
  T_34_M_WS_ICON_FLAG: "পতাকা",
  T_34_M_WS_ICON_FOLDER: "ফোল্ডার",
  T_34_M_WS_ICON_GLASSES: "চোখ",
  T_34_M_WS_ICON_GUN: "বন্দুক",
  T_34_M_WS_ICON_HEART: "হার্ট",
  T_34_M_WS_ICON_HEXAGON: "হেক্সাগন",
  T_34_M_WS_ICON_HOURGLASS: "ঘন্টাঘড়ি",
  T_34_M_WS_ICON_HOUSE: "বাড়ি",
  T_34_M_WS_ICON_KEY: "চাবি",
  T_34_M_WS_ICON_LIGHTNING: "বিদ্যুতের ঝলক",
  T_34_M_WS_ICON_LOCK: "লক করুন",
  T_34_M_WS_ICON_LOOP: "লুপ",
  T_34_M_WS_ICON_MAGNIFIER: "আতশী কাচ",
  T_34_M_WS_ICON_MONEY: "অর্থ",
  T_34_M_WS_ICON_MONTH: "চাঁদ",
  T_34_M_WS_ICON_OPENFOLDER: "ফোল্ডার খুলুন",
  T_34_M_WS_ICON_PLUS: "প্লাস",
  T_34_M_WS_ICON_QUADRI: "কোয়াড্রিলেটারাল",
  T_34_M_WS_ICON_QUESTIONMARK: "প্রশ্নবোধক চিহ্ন",
  T_34_M_WS_ICON_RECYCLING: "পুনর্ব্যবহার",
  T_34_M_WS_ICON_REFRESH: "রিফ্রেশ",
  T_34_M_WS_ICON_REST: "বিশ্রাম",
  T_34_M_WS_ICON_RETURN: "ফিরে যান",
  T_34_M_WS_ICON_RIGHTTRAPEZOID: "ডানদিকের ট্র্যাপিজয়েড",
  T_34_M_WS_ICON_SCISSORS: "কাঁচি",
  T_34_M_WS_ICON_SETUP: "সেটিং",
  T_34_M_WS_ICON_SIGN: "চিহ্ন",
  T_34_M_WS_ICON_SIGNOUT: "প্রস্থান",
  T_34_M_WS_ICON_SQUARE: "স্কোয়ার",
  T_34_M_WS_ICON_STAR: "তারকা",
  T_34_M_WS_ICON_STONE: "পাথর",
  T_34_M_WS_ICON_SWIMMINGCIRCLE: "স্যুইম রিং",
  T_34_M_WS_ICON_TAGGING: "পিন",
  T_34_M_WS_ICON_THESWORD: "তরবারী",
  T_34_M_WS_ICON_TRAPEZOID: "ট্র্যাপিজয়েড",
  T_34_M_WS_ICON_TRASHCAN: "আবর্জনার ক্যান",
  T_34_M_WS_ICON_TRIANGLE: "ত্রিভুজ",
  T_34_M_WS_ICON_TROPHY: "ট্রফি",
  T_34_M_WS_ICON_UP: "থাম্বস আপ",
  T_34_M_WS_ICON_WRONG: "দুঃখিত",
  T_34_M_WS_ICON_YES: "ডান",
  T_34_M_WS_ICONNAME: "আইকনের নাম",
  T_34_M_WS_INT: "পূর্ণসংখ্যা",
  T_34_M_WS_KILLZONE: "ডুম জোন",
  T_34_M_WS_LEFTCOLOR: "বাম দিকের রঙ",
  T_34_M_WS_LEFTTEAMINDEX: "বামদিকের টিম ইনডেক্স",
  T_34_M_WS_LEFTTEAMSCORE: "বামদিকের টিম স্কোর",
  T_34_M_WS_LOCSWITCH: "স্থানীয়করণ সুইচ",
  T_34_M_WS_MAX: "ম্যাক্সিমাম",
  T_34_M_WS_MIN: "ম্যাক্সিমাম",
  T_34_M_WS_NUMBER: "নাম্বার",
  T_34_M_WS_OBJECT: "এনটিটি",
  T_34_M_WS_OPEN: "অন",
  T_34_M_WS_OPENSATUS: "স্ট্যাটাস অন করুন",
  T_34_M_WS_PICTURE: "গ্রাফিক্স",
  T_34_M_WS_RANKARRAY: "র‍্যাংক অ্যারে",
  T_34_M_WS_RESULTS: "ফলাফল",
  T_34_M_WS_RIGHTCOLOR: "ডান দিকের কালার",
  T_34_M_WS_RIGHTTEAMINDEX: "ডান দিকের টিম ইনডেক্স",
  T_34_M_WS_RIGHTTEAMSCORE: "ডানপক্ষের টিম স্কোর",
  T_34_M_WS_ROUNDBANNER: "রাউন্ড ব্যানার",
  T_34_M_WS_ROUNDDESC: "রাউন্ড বিবরণ",
  T_34_M_WS_ROUNDHUD: "রাউন্ড নাম্বার",
  T_34_M_WS_ROUNDPARAMS: "রাউন্ড নাম্বার অ্যারে",
  T_34_M_WS_SAME_NAME: "নামের পুণরাবৃত্তি। নতুন একটি চেষ্টা করুন।",
  T_34_M_WS_SCOREARRAY: "স্কোর অ্যারে",
  T_34_M_WS_SCORINGTYPE: "স্কোর টাইপ",
  T_34_M_WS_SCORINGTYPEDECS: "খেলোয়াড়েরা যে ধরনের স্কোর পেতে পারে। স্কোর কাস্টমাইজেশন সমর্থন করে।",
  T_34_M_WS_SCUFFLESCORING: "মাল্টি-টিম স্কোর",
  T_34_M_WS_SETATTRIBUTES: "প্রপার্টি সেটিংস",
  T_34_M_WS_SHUT: "অফ",
  T_34_M_WS_SOUND: "সাউন্ড ইফেক্টস",
  T_34_M_WS_SOUNDCLICK: "ক্লিক করা হচ্ছে",
  T_34_M_WS_SOUNDDD: "কাউন্টডাউন",
  T_34_M_WS_SOUNDFEMALEA: "আহত (মহিলা)",
  T_34_M_WS_SOUNDM: "গানফায়ার",
  T_34_M_WS_SOUNDMALEA: "আহত (পুরুষ)",
  T_34_M_WS_SOUNDUAV: "বিস্ফোরণ",
  T_34_M_WS_ST_ASSISTCOUNT: "অ্যাসিস্টসমূহ",
  T_34_M_WS_ST_CHECKPROGRESS: "চেকপয়েন্ট প্রগ্রেস",
  T_34_M_WS_ST_DAMAGESUM: "ড্যামেজ",
  T_34_M_WS_ST_FINISHCOUNT: "লক্ষ্যের পরিমাণ অর্জিত হয়েছে",
  T_34_M_WS_ST_FINISHORDER: "লক্ষ্যের ক্রম অর্জিত হয়েছে",
  T_34_M_WS_ST_FINISHTIME: "লক্ষ্যের সময় অর্জিত হয়েছে",
  T_34_M_WS_ST_KILLCOUNT: "কিলসমূহ",
  T_34_M_WS_ST_MAINSCORE: "টার্গেট স্কোর",
  T_34_M_WS_ST_RANKSCORE: "র‍্যাংক স্কোর",
  T_34_M_WS_ST_SURVIVALDURACTION: "সারভাইভাল টাইম",
  T_34_M_WS_ST_UNKOWN: "অজানা",
  T_34_M_WS_STARTBANNER: "শুরুর ব্যানার",
  T_34_M_WS_STARTTIME: "শুরুর সময়",
  T_34_M_WS_STRING: "টেক্সট",
  T_34_M_WS_STUDIO: "স্টুডিও",
  T_34_M_WS_TEAMARRAY: "টিম অ্যারে",
  T_34_M_WS_TEXTCONTENT: "কন্টেন্ট",
  T_34_M_WS_THEMECOLOR: "থিম কালার",
  T_34_M_WS_TIME: "কাউন্টডাউন HUD",
  T_34_M_WS_TITLETEXT: "টাইটেল টেক্সট",
  T_34_M_WS_TYPE: "টাইপ",
  T_34_M_WS_UODATETYPE: "টাইপ আপডেট করুন",
  T_34_M_WS_VARNAME: "ভ্যারিয়েবলের নাম",
  T_34_M_WS_VECTOR: "ভেক্টর",
  T_34_M_WS_VFX: "ভিজ্যুয়াল ইফেক্টস",
  T_34_M_WS_WIDTH: "প্রশস্ততা",
  T_34_MF_CHARACTER_TRACKER_N: "হোমার",
  T_34_PD_FlagBattle_HYPE_1: "আগুন",
  T_34_SP_WS_BLOCK1_NAME: "স্টেজ সুইচ করুন",
  T_34_SP_WS_BLOCK1_NAMEDESC: "একটি পছন্দসই পর্যায়ে (বা রাউন্ড) প্রবেশ করতে একটি ম্যাচের স্টেজ পরিবর্তন করুন। রাউন্ডেরও স্টেজ সূচক থাকে এবং এটি একটি বিশেষ ধরনের স্টেজ।",
  T_34_SP_WS_BLOCK1_PARAM1_NAMEDESC: "টার্গেট স্টেজের ইনডেক্স",
  T_34_SP_WS_BLOCK10_NAME: "ভিজ্যুয়াল ইফেক্ট তৈরি করুন",
  T_34_SP_WS_BLOCK10_NAMEDESC: "মনোনীত ভিজ্যুয়াল ইফেক্ট ব্যবহার করে একটি আইকন তৈরি করুন। ভিজ্যুয়াল ইফেক্টের আরও বৈশিষ্ট্য ভিজ্যুয়াল ইফেক্ট এনটিটির প্রপার্টিজ এডজাস্ট করে কনফিগার করা যেতে পারে।",
  T_34_SP_WS_BLOCK10_PARAM3_NAME: "ভিজুয়াল ইফেক্ট",
  T_34_SP_WS_BLOCK10_PARAM3_NAMEDESC: "যেসকল ভিজুয়াল ইফেক্ট এপ্লাই করা যাবে তার ধরণ",
  T_34_SP_WS_BLOCK12_NAME: "ভিজুয়াল ইফেক্ট ডিলিট করুন",
  T_34_SP_WS_BLOCK12_NAMEDESC: "মনোনীত ভিজ্যুয়াল ইফেক্টটি ডিলিট করুন",
  T_34_SP_WS_BLOCK12_PARAM1_NAME: "ভিজুয়াল ইফেক্টস এনটিটি",
  T_34_SP_WS_BLOCK12_PARAM1_NAMEDESC: "যে ভিজুয়াল ইফেক্ট এনটিটি ডিলিট করা লাগবে",
  T_34_SP_WS_BLOCK13_NAMEDESC: "ভিজ্যুয়াল ইফেক্ট খেলতে ক্লায়েন্টকে অর্ডার দিন",
  T_34_SP_WS_BLOCK13_PARAM1_NAME: "প্লেয়ার লিস্ট",
  T_34_SP_WS_BLOCK13_PARAM1_NAMEDESC: "মেসেজ পাবেন এমন প্লেয়ারদের তালিকা",
  T_34_SP_WS_BLOCK13_PARAM2_NAME: "রিসোর্স পাথ",
  T_34_SP_WS_BLOCK13_PARAM2_NAMEDESC: "সিস্টেম রিসোর্স পাথ হলো ইন:পাথ। কাস্টম রিসোর্স পাথ হলো আউট:পাথ। ডিফল্টরূপেই খালি।",
  T_34_SP_WS_BLOCK13_PARAM3_NAMEDESC: "RGBA চ্যানেল, প্রতিটি চ্যানেল 0 থেকে 255 এর মধ্যে একটি মান নিয়ে int32 এ সংরক্ষিত। ডিফল্ট রঙ সাদা (255,255,255,255)।",
  T_34_SP_WS_BLOCK13_PARAM4_NAME: "জুম",
  T_34_SP_WS_BLOCK13_PARAM4_NAMEDESC: "জুম স্কেল; ডিফল্ট হলো 1",
  T_34_SP_WS_BLOCK13_PARAM5_NAMEDESC: "বৈশ্বিক স্থানাঙ্কে প্রদর্শিত ডিসপ্লে পজিশন। ডিফল্টরূপে ভেক্টর3(0)।",
  T_34_SP_WS_BLOCK14_NAME: "সাউন্ড ইফেক্ট প্লে করুন",
  T_34_SP_WS_BLOCK14_NAMEDESC: "সাউন্ড ইফেক্ট প্লে করতে ক্লায়েন্টকে অর্ডার দিন",
  T_34_SP_WS_BLOCK15_NAME: "আউটপুট লগ",
  T_34_SP_WS_BLOCK15_NAMEDESC: "লগ ইন্টারফেসে আউটপুট কন্টেন্ট",
  T_34_SP_WS_BLOCK2_NAMEDESC: `সেইফ জোনের বাইরের খেলোয়াড়দের 
ড্যামেজ সক্ষম করতে চালু করুন`,
  T_34_SP_WS_BLOCK2_PARAM1_NAMEDESC: "সেইফ জোনের কেন্দ্রীয় পয়েন্ট",
  T_34_SP_WS_BLOCK2_PARAM2_NAME: "পরিধি",
  T_34_SP_WS_BLOCK2_PARAM2_NAMEDESC: "সেইফ জোনের পরিধি",
  T_34_SP_WS_BLOCK2_PARAM3_NAMEDESC: "সেইফ জোন সংকোচনের কাউন্টডাউন শুরুর কাউন্টডাউন",
  T_34_SP_WS_BLOCK2_PARAM4_NAMEDESC: "সেইফ জোন সংকোচনের স্থায়ীত্ব",
  T_34_SP_WS_BLOCK2_PARAM5_NAMEDESC: "সেইফ জোনের বাইরে থাকাকালীন ড্যামেজের পরিমাণ",
  T_34_SP_WS_BLOCK3_NAMEDESC: "ডেঞ্জার জোন যখন বন্ধ করা থাকে, যেসকল প্লেয়ার সেইফ জোনের বাইরে থাকবে তারা ড্যামেজ পাবে না",
  T_34_SP_WS_BLOCK4_NAMEDESC: "একটি নির্দিষ্ট সময়ের জন্য পরবর্তী অ্যাকশন বিলম্ব করতে ব্যবহার করুন",
  T_34_SP_WS_BLOCK4_PARAM1_NAMEDESC: "অপেক্ষা করার স্থায়ীত্ব, মিলিসেকেন্ডে পরিমাপ হয়",
  T_34_SP_WS_BLOCK5_NAMEDESC: "পরবর্তী অ্যাকশনটি পরের ফ্রেমে স্থগিত করতে ব্যবহার করুন",
  T_34_SP_WS_BLOCK6_NAME: "কাস্টম HUD তৈরি করুন",
  T_34_SP_WS_BLOCK6_NAMEDESC: "মনোনীত একটি কাস্টম HUD তৈরি করুন",
  T_34_SP_WS_BLOCK6_PARAM1_NAMEDESC: "একটি নাম যা একটি HUD এনটিটি তৈরি করতে ব্যবহৃত হয়। এটি যে স্থানীয় পরিবর্তনশীলটির সাথে সঙ্গতিপূর্ণ তা হল HUD এর এনটিটি।",
  T_34_SP_WS_BLOCK6_PARAM2_NAME: "প্লেয়ার",
  T_34_SP_WS_BLOCK6_PARAM2_NAMEDESC: "একটি নির্দিষ্ট খেলোয়াড়ের সত্তা। শুধুমাত্র উল্লিখিত প্লেয়ারের কাছে দৃশ্যমান।",
  T_34_SP_WS_BLOCK6_PARAM3_NAMEDESC: "একটি HUD এর ইউনিক ইনডেক্স",
  T_34_SP_WS_BLOCK7_NAMEDESC: "একটি ডিফল্ট HUD তৈরি করুন, যা শুধুমাত্র মনোনীত প্লেয়ারদের কাছে দৃশ্যমান হয়",
  T_34_SP_WS_BLOCK8_NAMEDESC: "ডিলিট করা হলে, ডিফল্ট HUD ক্লায়েন্টে দেখা যাবে না (হয় লুকানো বা বাতিল)",
  T_34_SP_WS_BLOCK8_PARAM1_NAME: "HUD এনটিটি",
  T_34_SP_WS_BLOCK8_PARAM1_NAMEDESC: "যে HUD এনটিটি ডিলিট করা হবে",
  T_34_SP_WS_BLOCK9_NAMEDESC: "ডিলিট করা হলে, কাস্টম HUD ক্লায়েন্টে দেখা যাবে না (হয় লুকানো বা বাতিল)",
  T_34_T_WS_BLOCK1_NAMEDESC: "ম্যাচ শুরু হলে ইনসিডেন্ট ট্রিগার হয়",
  T_34_T_WS_BLOCK10_NAMEDESC: "কোনো প্লেয়ারকে নির্মূল করা হলে ইনসিডেন্ট ট্রিগার হয়",
  T_34_T_WS_BLOCK10_PARAM1_DESC: "নির্মূলকৃত সে প্লেয়ার, যে ইনসিডেন্টটি ট্রিগার করবে",
  T_34_T_WS_BLOCK13_NAMEDESC: "যখন কোনো প্লেয়ার অন্য প্লেয়ারকে সহায়তা করে, তখন ইনসিডেন্ট ট্রিগার করে",
  T_34_T_WS_BLOCK13_PARAM2_DESC: "যে প্লেয়ারকে নির্মূল করা হয়েছে",
  T_34_T_WS_BLOCK14_NAMEDESC: "কোনো একজন প্লেয়ার ড্যামেজ ডিল করলে ইনসিডেন্ট ট্রিগার হয়",
  T_34_T_WS_BLOCK14_PARAM2_DESC: "যে প্লেয়ার ড্যামেজ গ্রহণ করে",
  T_34_T_WS_BLOCK14_PARAM3_DESC: "যে ধরণের ড্যামেজ প্রদান করা হচ্ছে",
  T_34_T_WS_BLOCK14_PARAM4_DESC: "প্রদত্ত ড্যামেজের পরিমাণ",
  T_34_T_WS_BLOCK15_NAMEDESC: "যখন কোনো প্লেয়ার অন্য প্লেয়ারকে নির্মূল করে, তখন ইনসিডেন্ট ট্রিগার হয়",
  T_34_T_WS_BLOCK15_PARAM2_DESC: "যে প্লেয়ারকে নির্মূল করা হয়েছে",
  T_34_T_WS_BLOCK15_PARAM3_DESC: "যার ফলে নির্মূল হয়, তার ধরণ",
  T_34_T_WS_BLOCK16_NAMEDESC: "কোনো প্লেয়ার ম্যাচে যোগ দিলে ইনসিডেন্ট ট্রিগার হয়",
  T_34_T_WS_BLOCK17_NAMEDESC: "কোনো প্লেয়ার রিভাইভ হলে ইনসিডেন্ট ট্রিগার হয়",
  T_34_T_WS_BLOCK18_NAMEDESC: "কোনো টিমকে রিমোভ করা হলে ইনসিডেন্ট ট্রিগার হয়",
  T_34_T_WS_BLOCK19_NAMEDESC: "কোনো টিম যোগ করা হলে ইনসিডেন্ট ট্রিগার হয়",
  T_34_T_WS_BLOCK2_NAMEDESC: "ম্যাচ শেষ হলেই ইনসিডেন্ট ট্রিগার হয়",
  T_34_T_WS_BLOCK20_NAMEDESC: "যখন কোনো টিমকে নিশ্চিহ্ন করে দেয়া হয়, তখন ইনসিডেন্ট ট্রিগার হয়",
  T_34_T_WS_BLOCK3_NAMEDESC: "প্রতিটি রাউন্ড শুরু হলে ইনসিডেন্ট ট্রিগার হয়",
  T_34_T_WS_BLOCK3_PARAM1_DESC: "রাউন্ড নাম্বার 0 থেকে শুরু হয়",
  T_34_T_WS_BLOCK3_PARAM1_NAME: "রাউন্ড ইনডেক্স",
  T_34_T_WS_BLOCK4_NAMEDESC: "প্রত্যেক রাউন্ড সমাপ্ত হলে ইনসিডেন্ট ট্রিগার হয়",
  T_34_T_WS_BLOCK5_NAMEDESC: "স্টেজ শুরু হলে, তখন ইনসিডেন্ট ট্রিগার হয়",
  T_34_T_WS_BLOCK5_PARAM1_DESC: "স্টেজ নাম্বার 0 থেকে শুরু হয়",
  T_34_T_WS_BLOCK5_PARAM1_NAME: "স্টেজ এনটিটি",
  T_34_T_WS_BLOCK6_NAMEDESC: "স্টেজটি সমাপ্ত হলে ইনসিডেন্ট ট্রিগার হয়",
  T_34_T_WS_BLOCK7_NAMEDESC: "কোনো প্লেয়ার ম্যাচ ছেড়ে গেলে ইনসিডেন্ট ট্রিগার হয়",
  T_34_T_WS_BLOCK7_PARAM1_DESC: "যে প্লেয়ার ইনসিডেন্ট ট্রিগার করবে",
  T_34_T_WS_BLOCK7_PARAM1_NAME: "ট্রিগারকারী প্লেয়ার",
  T_34_T_WS_BLOCK8_NAMEDESC: "যখন কোনো প্লেয়ারের স্কোর পরিবর্তিত হয়, তখন ইনসিডেন্ট ট্রিগার হয়",
  T_34_T_WS_BLOCK8_PARAM2_DESC: "পরিবর্তিত স্কোরের ধরণ",
  T_34_T_WS_BLOCK8_PARAM3_DESC: "পরিবর্তনের পরে স্কোর ভ্যাল্যু",
  T_34_T_WS_BLOCK9_NAMEDESC: "কোনো টিমের স্কোর পরিবর্তিত হলে  ইনসিডেন্ট ট্রিগার হয়",
  T_34_T_WS_BLOCK9_PARAM1_DESC: "যে টিম ইনসিডেন্ট ট্রিগার করবে",
  T_34_WT_WS_BORNENTITY_PARAM1: "স্পন পয়েন্ট",
  T_34_WT_WS_BORNENTITY_PARAM2: "উপলব্ধ কো-অরডিনেট",
  T_34_WT_WS_BORNENTITY_PARAM3: "ডিফল্ট স্পন পয়েন্ট হিসেবে সেট করুন",
  T_34_WT_WS_BORNENTITY_PARAM4: "প্রদীপ্ত সীমানা",
  T_34_WT_WS_BORNENTITY_PARAM5: "ব্যবহার হচ্ছে বা হচ্ছে না",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM1: "চেকপয়েন্ট HUD",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM2: "স্ট্যাটাস খুলুন",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM1: "স্ট্যাটাস ট্রিগার",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM2: "এলিমিনেশন ট্রিগার অথবা না",
  T_34_WT_WS_ENTITY_PARAM1: "গেম এনটিটি",
  T_34_WT_WS_ENTITY_PARAM10: "টিমসমূহের #",
  T_34_WT_WS_ENTITY_PARAM11: "টিম মেম্বারদের #",
  T_34_WT_WS_ENTITY_PARAM12: "প্রতি রাউন্ডে সরঞ্জাম রিসেট হয়",
  T_34_WT_WS_ENTITY_PARAM13: "আউট-অফ-জোন ড্যামেজ চালু করুন",
  T_34_WT_WS_ENTITY_PARAM14: "জোন সাইড",
  T_34_WT_WS_ENTITY_PARAM15: "জোনের সংকোচন শুরুর সময়",
  T_34_WT_WS_ENTITY_PARAM16: "জোন সংকোচন স্থায়ীত্ব",
  T_34_WT_WS_ENTITY_PARAM17: "আউট-অফ-জোন ড্যামেজ",
  T_34_WT_WS_ENTITY_PARAM18: "টার্গেট স্কোর",
  T_34_WT_WS_ENTITY_PARAM19: "এলিমিনেশন স্কোর",
  T_34_WT_WS_ENTITY_PARAM2: "অগ্রহণযোগ্য স্ট্যাটাস",
  T_34_WT_WS_ENTITY_PARAM20: "রিভাইভাল টাইপ",
  T_34_WT_WS_ENTITY_PARAM21: "রাউন্ড স্কোর র‍্যাংকিং ক্রাইটেরিয়া (প্লেয়ার)",
  T_34_WT_WS_ENTITY_PARAM22: "ক্রাইটেরিয়া গুরুত্ব (প্লেয়ার)",
  T_34_WT_WS_ENTITY_PARAM23: "রাউন্ড স্কোর র‍্যাংকিং ক্রাইটেরিয়া (টিম)",
  T_34_WT_WS_ENTITY_PARAM24: "ক্রাইটেরিয়ার গুরুত্ব (টিম)",
  T_34_WT_WS_ENTITY_PARAM25: "স্কোর র‍্যাঙ্কিং মানদণ্ড (MVP)",
  T_34_WT_WS_ENTITY_PARAM26: "ক্রাইটেরিয়া গুরুত্ব (MVP)",
  T_34_WT_WS_ENTITY_PARAM27: "রাউন্ট র‍্যাংকিং স্কোর",
  T_34_WT_WS_ENTITY_PARAM28: "রেজাল্ট পেজে ক্রাইটেরিয়া প্রদর্শন করুন",
  T_34_WT_WS_ENTITY_PARAM29: "মোট রাউন্ড # সংখ্যা",
  T_34_WT_WS_ENTITY_PARAM3: "গেম টাইম",
  T_34_WT_WS_ENTITY_PARAM4: "বর্তমান রাউন্ড ইনডেক্স",
  T_34_WT_WS_ENTITY_PARAM5: "বর্তমান স্টেজ ইনডেক্স",
  T_34_WT_WS_ENTITY_PARAM6: "মোড টেম্পলেট আইডি",
  T_34_WT_WS_ENTITY_PARAM7: "প্লেয়ার রিভাইভাল সচল করুন",
  T_34_WT_WS_ENTITY_PARAM8: "বট রিভাইভাল সচল করুন",
  T_34_WT_WS_ENTITY_PARAM9: "রিভাইভাল টাইম",
  T_34_WT_WS_ENTITY1_NAME: "বর্তমান এনটিটি",
  T_34_WT_WS_ENTITY1_NAMEDESC: "বর্তমান এনটিটিতে ফিরে আসুন",
  T_34_WT_WS_ENTITY10_NAME: "আইকন রিমুভ করুন",
  T_34_WT_WS_ENTITY10_NAMEDESC: "মনোনীত একটি আইকন রিমোভ করুন",
  T_34_WT_WS_ENTITY10_PARAM1DESC: "যে আইকনটি রিমোভ করতে চান, সেটি নির্বাচন করুন",
  T_34_WT_WS_ENTITY11_NAME: "টেক্সট রিমোভ করুন",
  T_34_WT_WS_ENTITY11_NAMEDESC: "একটি টেক্সট এনটিটি রিমোভ করুন",
  T_34_WT_WS_ENTITY11_PARAM2ESC: "যে টেক্সটটি রিমোভ করতে চান, সেটি সিলেক্ট করুন",
  T_34_WT_WS_ENTITY12_NAMEDESC: "একজন মনোনীত প্লেয়ারের জন্য একটি আইটেম যুক্ত করুন",
  T_34_WT_WS_ENTITY12_PARAM1DESC: "যেসকল প্লেয়ার(রা) আইটেমটি পাবেন",
  T_34_WT_WS_ENTITY12_PARAM2DESC: "নির্দিষ্ট আইটেম আইডি অর্জন করা হবে",
  T_34_WT_WS_ENTITY12_PARAM2DESC3: "প্রদান করতে হবে এমন আইটেমের পরিমাণ",
  T_34_WT_WS_ENTITY12_PARAM3: "পরিমাণ",
  T_34_WT_WS_ENTITY13_PARAM1: "টাইপ",
  T_34_WT_WS_ENTITY13_PARAM2: "অবস্থান",
  T_34_WT_WS_ENTITY13_PARAM2DESC: "অবজেক্টের স্পন অবস্থানের স্থানাঙ্ক",
  T_34_WT_WS_ENTITY13_PARAM4: "অবজেক্ট",
  T_34_WT_WS_ENTITY14_NAME: "অবজেক্ট রিমোভ করুন",
  T_34_WT_WS_ENTITY14_NAMEDESC: "মনোনীত একটি অবজেক্ট রিমোভ করুন",
  T_34_WT_WS_ENTITY14_PARAM1DESC: "অবজেক্টটি ডিলিট করুন",
  T_34_WT_WS_ENTITY15_NAMEDESC: "সব প্লেয়ার এনটিটি অর্জন করুন",
  T_34_WT_WS_ENTITY16_NAMEDESC: "সব টিমের এনটিটি অর্জন করুন",
  T_34_WT_WS_ENTITY17_NAMEDESC: "মনোনীত খেলোয়াড়দের জন্য নির্ধারিত পরিমাণ HP রিকোভার করুন। যদি রিকোভার এর পরিমাণ সর্বাধিক HP কে ছাড়িয়ে যায়, তবে HP শুধুমাত্র সর্বাধিক পরিমাণ রিকোভার করবে।",
  T_34_WT_WS_ENTITY17_PARAM1DESC: "সেসব প্লেয়ার যাদের HP ওঠানামা কনফিগার করা হচ্ছে",
  T_34_WT_WS_ENTITY17_PARAM2DESC: "যে নির্দিষ্ট পরিমাণ HP রিকোভার করতে হবে",
  T_34_WT_WS_ENTITY18_NAME: "র‍্যানডম স্পন কো-অর্ডিনেটস অর্জন করুন",
  T_34_WT_WS_ENTITY18_NAMEDESC: "মনোনীত প্লেয়ারদের যে স্থান থেকে স্পন করতে হবে এবং ফিরে যেতে হবে সেটি কনফিগার করুন",
  T_34_WT_WS_ENTITY18_PARAM1DESC: "যেসব প্লেয়ার এলোমেলোভাবে এই অবস্থান থেকে স্পন করবে",
  T_34_WT_WS_ENTITY18_RETURNDESC: "প্লেয়ারকে যেখানে নিয়োগ করা হবে সে অবস্থানের স্থানাঙ্ক",
  T_34_WT_WS_ENTITY19_NAME: "প্লেয়ার স্কোর অর্জন করুন।",
  T_34_WT_WS_ENTITY19_NAMEDESC: "মনোনীত খেলোয়াড়দের নির্দিষ্ট স্কোর অর্জন করুন",
  T_34_WT_WS_ENTITY19_PARAM1DESC: "এই প্লেয়ারের(দের) স্কোর এনটিটি অর্জন করুন",
  T_34_WT_WS_ENTITY19_PARAM2DESC: "স্কোরের টাইপ অর্জন করুন",
  T_34_WT_WS_ENTITY19_RETURNDESC: "যেই নির্দিষ্ট স্কোর ভ্যাল্যু অর্জন করতে হবে",
  T_34_WT_WS_ENTITY2_NAME: "প্রপার্টি সেট করুন",
  T_34_WT_WS_ENTITY2_NAMEDESC: "একটি প্রপার্টি ভ্যাল্যু কনফিগার করুন, যেখানে প্রপার্টির ধরন ইতোমধ্যেই নির্বাচন করা হয়েছে",
  T_34_WT_WS_ENTITY2_PARAM1: "এনটিটি",
  T_34_WT_WS_ENTITY2_PARAM1DESC: "গেম এনটিটির প্রপার্টি ভ্যাল্যু",
  T_34_WT_WS_ENTITY2_PARAM3: "প্রপার্টি",
  T_34_WT_WS_ENTITY2_PARAM3DESC: "এই গেম এনটিটির একটি নির্দিষ্ট প্রপার্টি",
  T_34_WT_WS_ENTITY2_PARAM4: "ভ্যাল্যু",
  T_34_WT_WS_ENTITY2_PARAM4DESC: "একটি  প্রপার্টির একটি নির্দিষ্ট মান। নিশ্চিত করুন যে প্রপার্টির প্রকারটি নির্বাচিত একটির সাথে সারিবদ্ধ এবং সম্পর্কিত ব্লকগুলিতে কনফিগার করা প্রকারের সাথে মেলে।",
  T_34_WT_WS_ENTITY20_NAMEDESC: "মনোনীত প্লেয়ারদের নির্দিষ্ট স্কোর কনফিগার করুন",
  T_34_WT_WS_ENTITY20_PARAM1DESC: "এই প্লেয়ার(গুলোর) এর স্কোর সত্তা কনফিগার করুন",
  T_34_WT_WS_ENTITY20_PARAM2DESC: "স্কোরের ধরণ কনফিগার করুন",
  T_34_WT_WS_ENTITY20_PARAM3: "স্কোর",
  T_34_WT_WS_ENTITY20_PARAM3DESC: "নির্দিষ্ট স্কোর ভ্যাল্যু সেট করা হচ্ছে",
  T_34_WT_WS_ENTITY21_NAME: "টিম টোটাল স্কোর অর্জন করুন",
  T_34_WT_WS_ENTITY21_NAMEDESC: "মনোনীত টিমগুলোর নির্দিষ্ট টোটাল স্কোর অর্জন করুন",
  T_34_WT_WS_ENTITY21_PARAM1: "টিম",
  T_34_WT_WS_ENTITY21_PARAM1DESC: "এই টিম(গু্লো) এর স্কোর এনটিটি অর্জন করুন",
  T_34_WT_WS_ENTITY22_NAME: "টিমের বর্তমান রাউন্ড স্কোর সেট করুন",
  T_34_WT_WS_ENTITY22_NAMEDESC: "মনোনীত টিমের নির্দিষ্ট বর্তমান রাউন্ড স্কোর কনফিগার করুন",
  T_34_WT_WS_ENTITY22_PARAM1DESC: "এই টিম(গুলোর) স্কোর(গুলো) কনফিগার করুন",
  T_34_WT_WS_ENTITY23_NAME: "প্লেয়ার রাউন্ড স্কোর অর্জন করুন",
  T_34_WT_WS_ENTITY23_NAMEDESC: "মনোনীত খেলোয়াড়দের জন্য একটি নির্দিষ্ট রাউন্ডের নির্দিষ্ট স্কোর অর্জন করুন",
  T_34_WT_WS_ENTITY23_PARAM1DESC: "এই প্লেয়ায়ের রাউন্ড স্কোর অর্জন করুন",
  T_34_WT_WS_ENTITY23_PARAM2: "রাউন্ড",
  T_34_WT_WS_ENTITY23_PARAM2DESC: "এই রাউন্ড থেকে স্কোর অর্জন করুন",
  T_34_WT_WS_ENTITY24_NAME: "টিম রাউন্ড স্কোর অর্জন করুন",
  T_34_WT_WS_ENTITY24_NAMEDESC: "মনোনীত টিমের জন্য একটি নির্দিষ্ট রাউন্ডের নির্দিষ্ট স্কোর অর্জন করুন",
  T_34_WT_WS_ENTITY25_NAME: "টেলিপোর্ট",
  T_34_WT_WS_ENTITY25_NAMEDESC: "মনোনীত খেলোয়াড়দের একটি নির্দিষ্ট স্থানে টেলিপোর্ট করুন",
  T_34_WT_WS_ENTITY25_PARAM1DESC: "যেসকল প্লেয়ারকে(দের) টেলিপোর্ট করা হবে",
  T_34_WT_WS_ENTITY25_PARAM2DESC: "যেখানে প্লেয়ার(দের) টেলিপোর্ট করা হবে তার স্থানাঙ্ক",
  T_34_WT_WS_ENTITY26_NAMEDESC: "মনোনীত টার্গেটে ড্যামেজ করতে মনোনীত খেলোয়াড়দের সক্ষম করুন। যদি কোনো আক্রমণকারী খেলোয়াড় নির্বাচন না করা হয়, মনোনীত লক্ষ্যগুলি সিস্টেম থেকে ক্ষতিগ্রস্থ হবে।",
  T_34_WT_WS_ENTITY26_PARAM2DESC: "যেসকল সত্তা এই ড্যামেজ গ্রহণ করবে",
  T_34_WT_WS_ENTITY26_PARAM4DESC: "ডিলকৃত ড্যামেজের পরিমাণ",
  T_34_WT_WS_ENTITY28_NAMEDESC: "মনোনীত প্লেয়ারদের রিভাইভ করুন",
  T_34_WT_WS_ENTITY28_PARAM1DESC: "যেসকল প্লেয়ার এনটিটিকে রিভাইভ করা যাবে",
  T_34_WT_WS_ENTITY3_NAMEDESC: "ব্লকের টাইপ কনফিগার করুন",
  T_34_WT_WS_ENTITY3_PARAM1: "মতো",
  T_34_WT_WS_ENTITY4_NAME: "প্রপার্টি অর্জন করুন",
  T_34_WT_WS_ENTITY4_NAMEDESC: "একটি সত্তার একটি নির্দিষ্ট সম্পত্তি অর্জন করুন",
  T_34_WT_WS_ENTITY4_PARAM1DESC: "প্রপার্টি ভ্যাল্যু্র নির্দিষ্ট গেম এনটিটি অর্জন করুন",
  T_34_WT_WS_ENTITY4_RETURNDESC: "যেই নির্দিষ্ট প্রপার্টি ভ্যাল্যু অর্জন করতে হবে",
  T_34_WT_WS_ENTITY5_NAMEDESC: "সমস্ত খেলোয়াড়ের জন্য মুভ করার ক্ষমতা কনফিগার করুন",
  T_34_WT_WS_ENTITY6_NAME: "আইকন তৈরি করুন",
  T_34_WT_WS_ENTITY6_PARAM1: "আইকন",
  T_34_WT_WS_ENTITY6_PARAM1DESC: "HUD-তে প্রদর্শিত একটি ইমেজ। বিভিন্ন ডিজাইন থেকে নির্বাচন করুন।",
  T_34_WT_WS_ENTITY6_PARAM4DESC: "আইকনটি নির্বাচন করুন যার উপর ডিজাইনটি এপ্লাই করা উচিত",
  T_34_WT_WS_ENTITY7_NAMEDESC: "মনোনীত খেলোয়াড়দের জন্য একটি HUD আইকন তৈরি করুন। যদি কোনো খেলোয়াড় এনটিটি নির্বাচন না করা হয়, তাহলে HUD সকল খেলোয়াড়ের জন্য তৈরি করা হবে।",
  T_34_WT_WS_ENTITY7_PARAM1: "প্লেয়ার",
  T_34_WT_WS_ENTITY7_PARAM1DESC: `বাছাইকৃত প্লেয়ারদের জন্য একটি HUD  
আইকন তৈরি করুন`,
  T_34_WT_WS_ENTITY8_NAME: "টেক্সট তৈরি করুন",
  T_34_WT_WS_ENTITY8_PARAM1: "টেক্সট",
  T_34_WT_WS_ENTITY8_PARAM1DESC: "এই কমান্ড থেকে যেসব নির্দিষ্ট টেক্সট  তৈরি করা হবে",
  T_34_WT_WS_ENTITY8_PARAM3DESC: "বর্তমানে যে টেক্সট এনটিটি তৈরি করা হচ্ছে",
  T_34_WT_WS_ENTITY9_NAMEDESC: "মনোনীত খেলোয়াড়দের জন্য HUD পাঠ্যের একটি লাইন যোগ করুন। যদি কোনো খেলোয়াড় এনটিটি নির্বাচন না করা হয়, তাহলে সমস্ত খেলোয়াড়ের HUD-এ পাঠ্য তৈরি করা হবে।",
  T_34_WT_WS_ENTITY9_PARAM1DESC: "বাছাইকৃত প্লেয়ারদের জন্য একটি HUD  টেক্সট সিলেক্ট করুন",
  T_34_WT_WS_ICONENTITY_PARAM1: "আইকন সত্তা",
  T_34_WT_WS_ICONENTITY_PARAM2: "ডিজাইন",
  T_34_WT_WS_ICONENTITY_PARAM3: "রঙ",
  T_34_WT_WS_ICONENTITY_PARAM4: "স্কেল",
  T_34_WT_WS_ICONENTITY_PARAM5: "ডিসপ্লের পজিশন",
  T_34_WT_WS_ICONENTITY_PARAM6: "টার্গেট ফলো করুন",
  T_34_WT_WS_ICONENTITY_PARAM7: "ওয়ালের মধ্য দিয়ে দৃশ্যমান",
  T_34_WT_WS_ICONENTITY_PARAM8: "স্ক্রিন সবসময় চালু",
  T_34_WT_WS_ONETEAM_TAG: "সিঙ্গেল টিম",
  T_34_WT_WS_PHASEENTITY_PARAM1: "স্টেজ এনটিটি",
  T_34_WT_WS_PHASEENTITY_PARAM2: "স্টেজ ইনডেক্স",
  T_34_WT_WS_PHASEENTITY_PARAM3: "শুরুর সময়",
  T_34_WT_WS_PHASEENTITY_PARAM4: "সমাপ্তির সময়",
  T_34_WT_WS_PHASEENTITY_PARAM5: "স্থায়ীত্ব",
  T_34_WT_WS_PLAYERENTITY_PARAM1: "প্লেয়ায়র এনটিটি",
  T_34_WT_WS_PLAYERENTITY_PARAM10: "রিভাইভাল পয়েন্ট",
  T_34_WT_WS_PLAYERENTITY_PARAM12: "ওয়েপন রেশিও",
  T_34_WT_WS_PLAYERENTITY_PARAM13: "ক্যারেক্টার থ্রিডি মডেল",
  T_34_WT_WS_PLAYERENTITY_PARAM17: "পরিচয়",
  T_34_WT_WS_PLAYERENTITY_PARAM18: "বর্তমান HP",
  T_34_WT_WS_PLAYERENTITY_PARAM2: "ম্যাক্স এইচপি",
  T_34_WT_WS_PLAYERENTITY_PARAM3: "কৃত্রিম বুদ্ধিমত্তা",
  T_34_WT_WS_PLAYERENTITY_PARAM4: "প্লেয়ার স্ট্যাটাস",
  T_34_WT_WS_PLAYERENTITY_PARAM5: "সারভাইভাল টাইম",
  T_34_WT_WS_PLAYERENTITY_PARAM6: "অভেদ্য",
  T_34_WT_WS_PLAYERENTITY_PARAM7: "টিম",
  T_34_WT_WS_PLAYERENTITY_PARAM8: "টার্গেট চেকপয়েন্ট আইডি",
  T_34_WT_WS_PLAYERENTITY_PARAM9: "স্পন পয়েন্ট",
  T_34_WT_WS_PROCIRCLE_ICON: "আইকন",
  T_34_WT_WS_PVEDESC1: "যদি অন্তত একজন খেলোয়াড় সময় ফুরিয়ে যাওয়ার আগে ফিনিশিং লাইনে পৌঁছায়, সে টিম জিতে যাবে। যদি একই সময়ে সমস্ত খেলোয়াড়কে নির্মূল করে দেওয়া হয়, তখন গেম সমাপ্ত হবে।",
  T_34_WT_WS_PVEDESC2: `জয়ের জন্য একটি নির্দিষ্ট সময়ের জন্য সারভাইভ করুন। যদি একই সময়ে সমস্ত খেলোয়াড়কে নির্মূল করা যায়, 
তাহলে গেম সমাপ্ত হবে।`,
  T_34_WT_WS_PVENAME1: "জোরপূর্বক প্রবেশ",
  T_34_WT_WS_PVENAME2: "সহনশীলতা",
  T_34_WT_WS_RUNCHECKENTITY_PARAM1: "বর্তমান চেকপয়েন্ট আইডি",
  T_34_WT_WS_RUNCHECKENTITY_PARAM2: "পার্কুর মোড চেকআউট নাম্বার",
  T_34_WT_WS_SKILLSET14: "সোর্ডসম্যান'স র‍্যাথ (কেন্টা)",
  T_34_WT_WS_TEAMENTITY_PARAM1: "টিম এনটিটি",
  T_34_WT_WS_TEAMENTITY_PARAM2: "টেক্কা",
  T_34_WT_WS_TEAMENTITY_PARAM3: "সব মেম্বার",
  T_34_WT_WS_TRIGGERNTITY_PARAM1: "স্বাভাবিক ট্রিগার",
  T_34_WT_WS_TRIGGERNTITY_PARAM2: "উপস্থিতির ধরণ",
  T_34_WT_WS_TXTENTITY_PARAM1: "টেক্সট এনটিটি",
  T_34_WT_WS_TXTENTITY_PARAM2: "কন্টেন্ট",
  T_34_WT_WS_VFXENTITY_PARAM1: "ভিজুয়াল ইফেক্টস এনটিটি",
  T_34_WZ_WS_LOGIC10_NAME: "পরবর্তী টাতে চালিয়ে যান",
  T_34_WZ_WS_LOGIC10_NAMEDESC: "বর্তমান লুপ পুনরাবৃত্তিটি এড়িয়ে যান এবং পরবর্তীটি চালু করুন",
  T_34_WZ_WS_LOGIC11_NAME: "ফিরে যান",
  T_34_WZ_WS_LOGIC11_NAMEDESC: "বর্তমান সঞ্চালন বন্ধ করে এবং মূল প্রোগ্রামে ফিরে আসে। ফিরে আসার সময় ডেটা ফেরত পাঠানোর অনুমতি দেয়।",
  T_34_WZ_WS_LOGIC11_PARAM1_NAME: "রিটার্ন ভ্যালু",
  T_34_WZ_WS_LOGIC11_PARAM1_NAMEDESC: "ডেটা মূল প্রোগ্রামে ফেরত পাঠাতে হবে",
  T_34_WZ_WS_LOGIC2_NAME: "তুলনা করুন",
  T_34_WZ_WS_LOGIC2_NAMEDESC: "একটি মনোনীত অপারেটর ব্যবহার করে 2টি মান তুলনা করুন",
  T_34_WZ_WS_LOGIC2_PARAM1_NAME: "বামপক্ষের ভ্যাল্যু",
  T_34_WZ_WS_LOGIC2_PARAM1_NAMEDESC: "তুলনার জন্য ব্যবহৃত বাম পাশের ভ্যাল্যু",
  T_34_WZ_WS_LOGIC2_PARAM2_NAME: "তুলনা ফাংশন",
  T_34_WZ_WS_LOGIC2_PARAM2_NAMEDESC: "আপনি কিভাবে ভ্যাল্যুর তুলনা চান সিলেক্ট করুন। সাপোর্টেড  অপারেটরগুলি হল: >, ≥, ==, ≠, ≤, <, AND (শুধুমাত্র বুলিয়ান), OR (শুধুমাত্র বুলিয়ান)",
  T_34_WZ_WS_LOGIC2_PARAM3_NAME: "ডানদিকের ভ্যালু",
  T_34_WZ_WS_LOGIC2_PARAM3_NAMEDESC: "তুলনা করার জন্য ব্যবহৃত ডান পাশের মান",
  T_34_WZ_WS_LOGIC2_PARAM4_NAMEDESC: "তুলনার ফলাফল",
  T_34_WZ_WS_LOGIC3_NAME: "NOT",
  T_34_WZ_WS_LOGIC3_NAMEDESC: "একটি লজিক্যাল ভ্যাল্যুর বিপরীতটি দেয়",
  T_34_WZ_WS_LOGIC3_PARAM1_NAMEDESC: "NOT অপারেশনে যে ভ্যাল্যুটি আপনি ব্যবহার করতে চান",
  T_34_WZ_WS_LOGIC3_PARAM2_NAMEDESC: "NOT অপারেশনের রেজাল্ট",
  T_34_WZ_WS_LOGIC4_NAME: "শুন্যস্থান চেক করুন",
  T_34_WZ_WS_LOGIC4_NAMEDESC: "একটি এনটিটি empty/null কিনা তা পরীক্ষা করুন",
  T_34_WZ_WS_LOGIC4_PARAM1_NAME: "সত্তা",
  T_34_WZ_WS_LOGIC4_PARAM1_NAMEDESC: "শূন্যতা পরীক্ষা করার জন্য সত্তা",
  T_34_WZ_WS_LOGIC4_PARAM2_NAMEDESC: "সত্তা খালি থাকুক বা না থাকুক",
  T_34_WZ_WS_LOGIC5_NAME: "যদি",
  T_34_WZ_WS_LOGIC5_NAMEDESC: "শর্ত পূরণ করা হচ্ছে কিনা সে অনুযায়ী সম্পাদন করে। সাব-প্রসেসগুলো পরবর্তী লজিক্যাল শাখাগুলোর মতোই।",
  T_34_WZ_WS_LOGIC5_PARAM1_NAME: "ভ্যাল্যু",
  T_34_WZ_WS_LOGIC5_PARAM1_NAMEDESC: "শর্তের সংখ্যা এবং সাব-প্রসেসের সংখ্যা (লজিক শাখা) অবশ্যই এক হতে হবে",
  T_34_WZ_WS_LOGIC6_NAME: "পূর্ণসংখ্যা রেঞ্জের লুপ",
  T_34_WZ_WS_LOGIC6_NAMEDESC: "z এর একটি ধাপ দ্বারা x থেকে y পর্যন্ত লুপ করুন। লুপটি নিজেই সেই সাব-প্রসেস।",
  T_34_WZ_WS_LOGIC6_PARAM1_NAMEDESC: "লুপ ইনডেক্সের নাম যেটি স্থানীয় ভ্যারিয়েবলের লুপ সূচকের মান বের করতে ব্যবহার করা যেতে পারে",
  T_34_WZ_WS_LOGIC6_PARAM2_NAME: "শুরুর মান",
  T_34_WZ_WS_LOGIC6_PARAM2_NAMEDESC: "যে মান থেকে লুপ শুরু হয়",
  T_34_WZ_WS_LOGIC6_PARAM3_NAME: "শেষের মান",
  T_34_WZ_WS_LOGIC6_PARAM3_NAMEDESC: "যে মানটিতে লুপ শেষ হয়",
  T_34_WZ_WS_LOGIC6_PARAM4_NAME: "স্টেপ",
  T_34_WZ_WS_LOGIC6_PARAM4_NAMEDESC: "প্রতিটি লুপের স্টেপ। যখন শুরুর মান শেষ মানের থেকে কম হয়, তখন ধাপটি 0-এর থেকে বেশি হওয়া উচিত। যখন শুরুর মান শেষ মানের থেকে বেশি হয়, তখন ধাপটি 0-এর থেকে কম হওয়া উচিত।",
  T_34_WZ_WS_LOGIC7_NAME: "প্রতিটি ইলিমেন্ট লুপ",
  T_34_WZ_WS_LOGIC7_NAMEDESC: "প্রতিটি সাব-ইলিমেন্ট বের করতে একটি ডেটা কন্টেইনারের ট্রাভার্সাল সক্ষম করে। লুপটি নিজেই সেই সাব-প্রসেস।",
  T_34_WZ_WS_LOGIC7_PARAM1_NAME: "ইলিমেন্ট",
  T_34_WZ_WS_LOGIC7_PARAM1_NAMEDESC: "এই নামটি অতিক্রম করলে স্থানীয় ভ্যারিয়েবলের সাব-ইলিমেন্টের মান বের করা হবে",
  T_34_WZ_WS_LOGIC7_PARAM3_NAME: "ডেটা কন্টেনার",
  T_34_WZ_WS_LOGIC7_PARAM3_NAMEDESC: "ট্রাভার্স করার জন্য ডেটা কন্টেইনার। বর্তমানে লিস্ট টাইপও সাপোর্ট করে।",
  T_34_WZ_WS_LOGIC8_NAME: "কন্ডিশনাল লুপ",
  T_34_WZ_WS_LOGIC8_NAMEDESC: "একটি শর্ত পূরণ না হওয়া পর্যন্ত একটি শর্তাধীন লুপ পুনরাবৃত্তি হয়। শর্ত False হলে লুপ বন্ধ হয়ে যায়।",
  T_34_WZ_WS_LOGIC8_PARAM1_NAME: "শর্ত",
  T_34_WZ_WS_LOGIC8_PARAM1_NAMEDESC: "শর্ত সত্য হলে লুপের পুনরাবৃত্তি ঘটে এবং শর্ত মিথ্যা না হওয়া পর্যন্ত চলমান থাকে",
  T_34_WZ_WS_LOGIC9_NAME: "ব্রেক লুপ",
  T_34_WZ_WS_LOGIC9_NAMEDESC: "বর্তমান লুপ প্রক্রিয়া বন্ধ করে এবং লুপ থেকে বেরিয়ে যায়",
  T_34_Y_B_DINOSAURS: "ডাইনোসর ইল্যুশন (বটম)",
  T_34_YF_M24_N: "M24",
  T_34_YS_F_B_ANGEL_BW: "খাঁটি এঞ্জেল (F)",
  T_34_YS_F_B_PANDACATTLE: "মু জু (বটম)",
  T_34_YS_F_B_RAMPAGE4_RAIN: "অ্যাকুয়া রজ (বটম)",
  T_34_YS_F_H_RAMPAGE4_RAIN: "অ্যাকুয়া রজ (হেড)",
  T_34_YS_F_HA_RAMPAGE4_RAIN: "অ্যাকুয়া রজ (ফেসপেইন্ট)",
  T_34_YS_F_S_PANDACATTLE: "মু জু (জুতা)",
  T_34_YS_F_S_RAMPAGE4_RAIN: "অ্যাকুয়া রজ (জুতা)",
  T_34_YS_F_T_PANDACATTLE: "মু জু (টপ)",
  T_34_YS_F_T_RAMPAGE4_RAIN: "অ্যাকুয়া রজ (টপ)",
  T_34_YS_M_B_ANGEL_BW: "খাঁটি এঞ্জেল (M)",
  T_34_YS_M_B_PANDACATTLE: "পান্ডা পায়জামা (বটম)",
  T_34_YS_M_H_PANDACATTLE: "পান্ডা পায়জামা (হেড)",
  T_34_YS_M_S_PANDACATTLE: "পান্ডা পায়জামা (জুতা)",
  T_34_YS_M_T_PANDACATTLE: "পান্ডা পায়জামা (টপ)",
  T_34_YZY_CHARACTER_RHYTHMGIRL_N: "অ্যা-পেট্রোয়া",
  T_35_C_SKILL_DESC_BRAZILSOLDIER: "কোনো প্রতিপক্ষকে নক-ডাউন করে [FFB300]{0} EP[-] অর্জন করুন",
  T_35_DY_PET_OWL_N: "হুট",
  T_35_DY_PETSKIN_ALIEN_DIGITALUNIVERSE_N: "পেট স্কিন: স্পেসশিপ মুনি",
  T_35_DY_PETSKIN_CATEAM_AXOLOTL_N: "পেট স্কিন: অ্যাজুলক্রেমা ট্রেইস জ্যাসিল",
  T_35_DY_PETSKIN_CATEAM_HAWK_N: "পেট স্কিন: আগুই ব্লু",
  T_35_DY_PETSKIN_OWL_FIRE_N: "পেট স্কিন: হুট অন ফায়ার",
  T_35_DY_PETSKIN_OWL_NIGHT_N: "পেট স্কিন: নকচার্নাল হুট",
  T_35_DY_PETSKIN_OWL_STORM_N: "পেট স্কিন: ফ্রস্টি হুট",
  T_35_JL_KNOCKEDDOWN: "নকড ডাউন হয়েছে",
  T_35_JL_SKILL_DESC_CRAZYGIRL: "[FFB300]{1}s[-] জন্য, গ্লু-ওয়ালে সফলভাবে গুলি চালানো প্রতিপক্ষদের [FFB300]{3}m[-] এর মধ্যে চিহ্নিত করবে এবং চিহ্নিত প্রতিপক্ষদের ড্যামেজ করার জন্য গ্লু ওয়ালে পেনেট্রেট করবে (ড্যামেজ স্বাভাবিকের চেয়ে কম হবে)। সর্বাধিক [FFB300]{0}[-] টি গ্লু-ওয়ালে কার্যকর। কুলডাউন: [FFB300]{2}s[-]।",
  T_35_JL_SKILL_NAME_CRAZYGIRL: "ওয়াল ব্রোল",
  T_35_KY_INFECTION_MAPNAME: "ওয়াস্টল্যান্ড",
  T_35_M_WS_BUTTONCLICKDESC: "সংশ্লিষ্ট বাটনটি ট্যাপ করলে এই ইনসিডেন্টটি চালু হবে। প্যারামিটার ব্যবহার করে ট্রিগার প্লেয়ারকে অর্জন করা যেতে পারে।",
  T_35_M_WS_GETTEAMMATEPOS: "নিকটস্থ টিমমেটদের লোকেশন পান",
  T_35_M_WS_ROUND2: "বর্তমান ওয়েভ",
  T_35_PD_Infection_HUMANSELECT: "অস্ত্র সিলেক্ট করুন",
  T_35_PD_INFECTION_MODENAME: "ড্রয়েড অ্যাপোকেলিপ্স",
  T_35_QX_WS_ICONTYPE_ITEM: "অবজেক্ট",
  T_35_QX_WS_ICONTYPE_NATURE: "প্রকৃতির আকার",
  T_35_QX_WS_ICONTYPE_SHAPE: "জ্যামিতিক",
  T_35_QX_WS_ICONTYPE_SYMBOL: "প্রতীক",
  T_35_QX_WS_SOUNDTYPE_WEAPON: "ওয়েপন",
  T_35_R_EMOTE_TAG_MUSIC_N: "মিউজিক",
  T_35_RW_SKILL_DESC_Singers: "স্কিল ইউজার এবং মিত্ররা তাদের EP ব্যবহার করে [FFB300]{0}m[-] এর মধ্যে [FFB300]{1}%[-] ড্যামেজ ব্লক করতে পারে। এই ক্ষেত্রে, মিত্রদের কাছ থেকে কাটা EP-এর পরিমাণ দক্ষতা ব্যবহারকারীর EP-তে যোগ করা হবে।",
  T_35_RW_SKILL_NAME_Singers: "সাইলেন্ট সেন্টিনেল",
  T_35_SP_WS_COMMENTKEY_01: "উপযুক্ত জটিলতা",
  T_35_SP_WS_COMMENTKEY_02: "সৃজনশীল",
  T_35_SP_WS_COMMENTKEY_03: "আকর্ষণীয় গেম-প্লে",
  T_35_SP_WS_COMMENTKEY_04: "বারবার খেলা যায়",
  T_35_SP_WS_COMMENTKEY_05: "চমকপ্রদ কাহিনী",
  T_35_SP_WS_COMMENTKEY_06: "সুন্দর-ভারসাম্যপূর্ণ",
  T_35_SP_WS_COMMENTKEY_07: "মনোমুগ্ধকর অভিজ্ঞতা",
  T_35_SP_WS_COMMENTKEY_08: "নমনীয়",
  T_35_SP_WS_COMMENTKEY_09: "নান্দনিকভাবে আনন্দদায়ক",
  T_35_SP_WS_COMMENTKEY_10: "খুব বেশি জটিল",
  T_35_SP_WS_COMMENTKEY_11: "খুবই সহজ",
  T_35_SP_WS_COMMENTKEY_12: "বিরক্তিকর",
  T_35_SP_WS_COMMENTKEY_13: "খুব বড়",
  T_35_SP_WS_COMMENTKEY_14: "ভারসাম্যহীন",
  T_35_SP_WS_COMMENTKEY_15: "অপ্রীতিকর অভিজ্ঞতা",
  T_35_SP_WS_IMAGE03: "গঠনবিন্যাস",
  T_35_SP_WS_IMAGE04: "ফ্রেম",
  T_35_SY_CHARGESHOT_TEARS_N: "চার্জ বুস্টার- লাভা লাস্টার",
  T_35_SY_GRENADE_DIGITALUNIVERSE_01_N: "গ্রেনেড- ক্রিস্টাল ইয়ারি",
  T_35_SY_GRENADE_PIRATES_N: "গ্রেনেড- রাউডি সীরুলার",
  T_35_SY_GRENADE_RIDERS_N: "গ্রেনেড- গ্রীম রাইডার",
  T_35_SY_M24_KUN_N: "M24- রিভারডাস্ট স্প্ল্যাশার",
  T_35_SY_SCAR_PARKOUR_N: "স্কার- গাস্টো ফ্রিরানার",
  T_35_SY_VEHICLE_JEEP_PANTOMIME_N: "জিপ- মোনোক্রোম জিগসাও",
  T_35_SY_VEHICLE_MONSTER_DIGITALUNIVERSE_D: "সেলিব্রেশনটাকে উদযাপন করুন!",
  T_35_SY_VEHICLE_MOTOBIKE_DIGITALUNIVERSE_N: "মোটরবাইক- ক্রিস্টাল সিমেট্রি",
  T_35_WT_WS_PREFAB_MENUBAR_1: "কাঠামো এবং সজ্জা",
  T_35_WT_WS_PREFAB_MENUBAR_1_1: "কাঠামো",
  T_35_WT_WS_PREFAB_MENUBAR_1_6: "বিবিধ",
  T_35_WT_WS_PREFAB_MENUBAR_2: "স্থাপত্য",
  T_35_WT_WS_PREFAB_MENUBAR_2_1: "বড় ঘর-বাড়ি",
  T_35_WT_WS_PREFAB_MENUBAR_2_2: "মাঝারি ঘর-বাড়ি",
  T_35_WT_WS_PREFAB_MENUBAR_3: "ফাংশনাল অবজেক্টস",
  T_35_WT_WS_PREFAB_MENUBAR_3_1: "মোড আবশ্যিকতা",
  T_35_WT_WS_PREFAB_MENUBAR_3_6: "মিউজিক",
  T_35_WT_WS_PVEMODE_TAG: "সার্ভাইভাল মোড",
  T_35_WZY_WS_BECRE_NAMEDESC: "এই এনটিটি তৈরি হলে ট্রিগার করে",
  T_35_WZY_WS_BEKILL_NAMEDESC: 'যখন এই এনটিটি নির্মূল করা হয় তখন ট্রিগার করে। আক্রমণের উৎস "ট্রিগার এনটিটি" ব্যবহার করে সনাক্ত করা যেতে পারে। এবং আক্রমণের ধরন "ড্যামেজের ধরণ" ব্যবহার করে সনাক্ত করা যেতে পারে।',
  T_35_WZY_WS_BEKILL_PARAM1_NAMEDESC: "যে এনটিটি ঘটনাটি ঘটায়",
  T_35_WZY_WS_CREPROP_NAMEDESC: "একটি নির্দিষ্ট স্থানে একটি আইটেম বা আইটেমের সেট তৈরি করুন। এক ধরনের আইটেম তৈরি করার সময়, পরিমাণ হল সেই আইটেমের সংখ্যা। আইটেমগুলির একটি সেট তৈরি করার সময়, পরিমাণ হল সেই পরিমাণ তালিকা যা আইটেম তালিকার সাথে মিলে যায়। তৈরি করা আইটেমগুলি ম্যাপের ইউনিটগুলির উপর নির্ভর করবে৷",
  T_35_WZY_WS_CREPROP_PARAM1_NAMEDESC: "একটি তালিকা যাতে যেসকল আইটেম তৈরি করা হবে তা অন্তর্ভুক্ত রয়েছে. এতে একটি একক আইটেমও অন্তর্ভুক্ত হতে পারে।",
  T_35_WZY_WS_CREPROP_PARAM2_NAMEDESC: "একটি অ্যামাউন্ট লিস্ট যার আইটেম লিস্টের সাথে সামঞ্জস্যতা আছে। এটিতে শুধুমাত্র একটি আইটেম টাইপের অ্যামাউন্ট থাকতে পারে।",
  T_35_WZY_WS_DAMTYPE_CAR: "ভেহিক্যাল",
  T_35_WZY_WS_DAMTYPE_FALL: "পতন",
  T_35_WZY_WS_DAMTYPE_FIREARMS: "বন্দুক",
  T_35_WZY_WS_DAMTYPE_GRENADE: "গ্রেনেড",
  T_35_WZY_WS_DAMTYPE_MELEE: "মেলি",
  T_35_WZY_WS_DAMTYPE_ZONE: "আউট-অফ-জোন",
  T_35_WZY_WS_DELPROP_NAMEDESC: "নির্দিষ্ট প্লেয়ারের একটি নির্দিষ্ট সংখ্যক আইটেম মুছুন",
  T_35_WZY_WS_ENTERTRIGGER_NAME: "ট্রিগার এলাকায় প্রবেশ করুন",
  T_35_WZY_WS_ENTERTRIGGER_NAMEDESC: 'ট্রিগার হয় যখন একটি "ট্রিগার এনটিটি" একটি ট্রিগার এলাকায় প্রবেশ করে',
  T_35_WZY_WS_ENTITYPLAYER_DESC: "যে প্লেয়ারের এনটিটি অর্জন করতে হবে। প্লেয়ারের সাথে লিঙ্ক করা হলে, এনটিটির তথ্য শুধুমাত্র সেই প্লেয়ারের জন্য আপডেট করা হবে। যখন কোনো খেলোয়াড় লিঙ্ক না থাকে, তখন সমস্ত খেলোয়াড় এনটিটির তথ্য পাবেন।",
  T_35_WZY_WS_FIGHTENTITY_NAME: "ব্যাটেল এনটিটি",
  T_35_WZY_WS_GETALLOB_NAMEDESC: "একটি নির্দিষ্ট ধরনের সব অবজেক্ট প্রাপ্ত.। রিটার্ন আসা রেজাল্ট হলো একটি লিস্ট।",
  T_35_WZY_WS_GETALLOB_PARAM1_NAMEDESC: "অবজেক্ট টাইপ",
  T_35_WZY_WS_HUDWIDGET_NAME: "UI কন্ট্রোল",
  T_35_WZY_WS_HURT_NAMEDESC: 'যখন এই এনটিটি ড্যামেজ প্রাপ্ত হয়, তখন ট্রিগার করে। "ট্রিগার এনটিটি" ব্যবহার করে আক্রমণের উৎস চিহ্নিত করা যেতে পারে।',
  T_35_WZY_WS_ITEMSTYPE_NAMEDESC: "আইটেমের ধরণ",
  T_35_WZY_WS_LEVELOBJECT_NAME: "স্টেজ অবজেক্ট",
  T_35_WZY_WS_OBKILL_NAMEDESC: 'যখন এই এনটিটি অন্য এনটিটিকে নির্মূল করে তখন ট্রিগার করে। নির্মূল করা এনটিটির ধরন "নির্মূলকৃত এনটিটি" ব্যবহার করে চিহ্নিত করা যেতে পারে।',
  T_35_WZY_WS_OBKILL_PARAM1_NAMEDESC: "যেই সত্তাকে নির্মূল করা হয়েছে",
  T_35_WZY_WS_ONHURT_NAMEDESC: "কোনো এনটিটি ড্যামেজ সৃষ্টি করলে ট্রিগার হয়",
  T_35_WZY_WS_ONHURT_PARAM1_DESC: "যে এনটিটি ড্যামেজ ডিল করছে",
  T_35_WZY_WS_ONHURT_PARAM1_NAME: "টার্গেট এনটিটি",
  T_35_WZY_WS_PREFABID_NAME: "টেমপ্লেট ID",
  T_35_WZY_WS_PROPERTY_EPNOW: "বর্তমান EP",
  T_35_WZY_WS_PROPERTY_JUMP: "জাম্প হাইট",
  T_35_WZY_WS_QUITTRIGGER_NAME: "ট্রিগার এলাকা ত্যাগ করুন",
  T_35_WZY_WS_QUITTRIGGER_NAMEDESC: 'ট্রিগার হয় যখন একটি "ট্রিগার এনটিটি" একটি ট্রিগার এলাকা থেকে প্রস্থান করে',
  T_35_WZY_WS_REMOVEELEMENT_NAMEDESC: "একটি লিস্ট থেকে একটি নির্দিষ্ট ইলিমেন্ট সরান। [লিস্ট] হলো যে তালিকায় ইলিমেন্টটি থাকে। [ইলিমেন্ট] হলো যে উপাদানটি রিমুভ করা হবে।",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAME: "ইলিমেন্ট ভ্যাল্যু",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAMEDESC: "যে উপাদানটির মান অপসারণ করতে হবে",
  T_35_WZY_WS_ROUNDENTITY_NAME: "রাউন্ড এনটিটি",
  T_35_WZY_WS_TOWER_PARAM1: "টাওয়ার এবং দূর্গসমূহ",
  T_35_WZY_WS_TOWER_PARAM2: "টিম ID",
  T_35_WZY_WS_TOWER_PARAM3: "বর্তমান HP",
  T_35_WZY_WS_TOWER_PARAM4: "ম্যাক্স. HP",
  T_35_WZY_WS_TOWER_PARAM5: "ড্যামেজ",
  T_35_WZY_WS_TOWER_PARAM6: "অ্যাটাক ইন্টারভাল",
  T_35_WZY_WS_TOWER_PARAM7: "অ্যাটাকের রেঞ্জ",
  T_35_WZY_WS_TOWER_PARAM8: "ডিফেন্স %",
  T_35_XYL_PDM_REVENGE: "প্রতিশোধ নেয়া হয়েছে",
  T_35_XYL_WS_BISPARTERRE: "গ্রাফিতি ফ্লাওয়ারবেড",
  T_35_XYL_WS_BISPARTERRE_DESC: "একটি ব্যাটেল-ইন-স্টাইল-থিমযুক্ত স্টোন ফ্লাওয়ারবেড",
  T_35_XYL_WS_BISWALL: "গ্রাফিতি ওয়াল",
  T_35_XYL_WS_BISWALL_DESC: "একটি ব্যাটেল-ইন-স্টাইল-থিমযুক্ত প্রাচীর যেটাকে একত্রিত করা যাবে",
  T_35_XYL_WS_BOTDROP: "লুট ড্রপ চালু করুন/বন্ধ করুন",
  T_35_XYL_WS_CUSTOMTRIGGER: "কাস্টম ট্রিগার",
  T_35_XYL_WS_CUSTOMTRIGGER_DESC: "একটি অবজেক্ট প্লেস করুন, যেটা একটি নির্দিষ্ট কাস্টমাইজড স্পেশাল ইফেক্ট ট্রিগার করে, যখন একজন খেলোয়াড় এটিকে সক্রিয় করে। ইফেক্টটি স্ক্রিপ্টে কনফিগার করা আবশ্যক। (শুধুমাত্র FF ক্রাফটমেট মোডে উপস্থিত হয়)",
  T_35_XYL_WS_DOUBLEDOOR: "দরজা",
  T_35_XYL_WS_DOUBLEDOOR_DESC: "একটি দরজা যা ফাটল দিয়ে খোলা হয়েছে",
  T_35_XYL_WS_RESET: "প্রতি রাউন্ডে রিসেট করুন",
  T_35_XYL_WS_RESETN: "না",
  T_35_XYL_WS_RESETY: "হ্যাঁ",
  T_35_XYL_WS_ROADBLOCK: "রোডব্লক A",
  T_35_XYL_WS_ROADBLOCK_DESC: "পাশ দিয়ে যাওয়া থেকে বিরত রাখে",
  T_35_XYL_WS_STAIRS: "সিঁড়ি",
  T_35_XYL_WS_STAIRS_DESC: "এমন একটি প্ল্যাটফর্ম যেটাকে সিঁড়ি দিয়ে কম্বাইন করা যেতে পারে",
  T_35_XYL_WS_STAIRSL: "ল্যান্ডিং B",
  T_35_XYL_WS_STAIRSL_DESC: "এমন একটি প্ল্যাটফর্ম যেটাকে সিঁড়ি দিয়ে কম্বাইন করা যেতে পারে",
  T_35_XYL_WS_STAIRSZ: "ল্যান্ডিং A",
  T_35_XYL_WS_STAIRSZ_DESC: "এমন একটি প্ল্যাটফর্ম যেটাকে সিঁড়ি দিয়ে কম্বাইন করা যেতে পারে",
  T_35_XYL_WS_TBOOTH: "ফোন বুথ",
  T_35_XYL_WS_TBOOTH_DESC: "সচরাসচর রাস্তাঘাটে দেখা যায়",
  T_35_YF_PP19_N: "বিজন",
  T_35_YS_A_CATEAM_HW: "অ্যাগুই",
  T_35_YS_A_CUBBY: "ক্লাব মাস্ক",
  T_35_YS_F_A_PANTOMIME: "দুই-টনের গ্রীফ (মাস্ক)",
  T_35_YS_F_A_RIDERS: "ফ্যাটাল রাইডার (মাস্ক)",
  T_35_YS_F_B_DIGITALUNIVERSE2: "বিউটি রি-ইউনিটার (বটম)",
  T_35_YS_F_B_GOLDCHAIN: "আর্মর অফ রিচেস (বটম)",
  T_35_YS_F_B_PANTOMIME: "দুই-টনের গ্রীফ (বটম)",
  T_35_YS_F_B_RIDERS: "ফ্যাটাল রাইডার (বটম)",
  T_35_YS_F_H_BEAR_HW: "কাব ক্যাপ",
  T_35_YS_F_H_DIGITALUNIVERSE2: "বিউটি রি-ইউনিটার (হেড)",
  T_35_YS_F_H_GOLDCHAIN: "আর্মর অফ রিচেস (হেড)",
  T_35_YS_F_H_PANTOMIME: "দুই-টনের গ্রীফ (হেড)",
  T_35_YS_F_H_RIDERS: "ফ্যাটাল রাইডার (হেড)",
  T_35_YS_F_HA_GOLDCHAIN: "আর্মর অফ রিচেস (ফেসপেইন্ট)",
  T_35_YS_F_S_DIGITALUNIVERSE2: "বিউটি রি-ইউনিটার (জুতা)",
  T_35_YS_F_S_GOLDCHAIN: "আর্মর অফ রিচেস (জুতা)",
  T_35_YS_F_S_PANTOMIME: "দুই-টনী গ্রীফ (জুতা)",
  T_35_YS_F_S_RIDERS: "ফ্যাটাল রাইডার (জুতা)",
  T_35_YS_F_T_DIGITALUNIVERSE2: "বিউটি রি-ইউনিটার (টপ)",
  T_35_YS_F_T_GOLDCHAIN: "আর্মর অফ রিচেস (টপ)",
  T_35_YS_F_T_PANTOMIME: "দুই-টনের গ্রীফ (টপ)",
  T_35_YS_F_T_RIDERS: "ফ্যাটাল রাইডার (টপ)",
  T_35_YS_ITEM_SUPERFAK: "সুপার মেড",
  T_35_YS_M_A_GOLDCHAIN: "চেইনজ অফ লাক্স (মাস্ক)",
  T_35_YS_M_A_RIDERS: "গ্রীম রাইডার (মাস্ক)",
  T_35_YS_M_B_GOLDCHAIN: "চেইনজ অফ লাক্স (বটম)",
  T_35_YS_M_B_RIDERS: "গ্রীম রাইডার (বটম)",
  T_35_YS_M_H_BEAR_HW: "কাব ক্যাপ",
  T_35_YS_M_H_GOLDCHAIN: "চেইনজ অফ লাক্স (হেড)",
  T_35_YS_M_H_RIDERS: "গ্রীম রাইডার (হেড)",
  T_35_YS_M_S_GOLDCHAIN: "চেইনড অফ লাক্স (জুতা)",
  T_35_YS_M_S_RIDERS: "গ্রীম রাইডার (জুতা)",
  T_35_YS_M_T_GOLDCHAIN: "চেইনজ অফ লাক্স (টপ)",
  T_35_YS_M_T_RIDERS: "গ্রীম রাইডার (টপ)",
  T_35_YS_T_CHAMPION: "চ্যাম্পিয়ন টী",
  T_35_YS_T_PAINTING: "স্কুইজ টি",
  T_35_YZY_CHARACTER_CRAZYGIRL_N: "আইরিস",
  T_35_YZY_CHARACTER_SINGERS_N: "জে. বিবস",
  T_36_JH_WS_BASEMONEY: "ম্যাচ শুরু হলে কয়েন অর্জন করুন",
  T_36_JH_WS_CESAYCLOSE: "ম্যানুয়াল ক্লোজিং ডিজেবল করবেন কী না",
  T_36_JH_WS_CHOOSEEDITSHOP: "এডিটের জন্য স্টোর সিলেক্ট করুন",
  T_36_JH_WS_CHOOSESHOP: "একটি স্টোর সিলেক্ট করুন",
  T_36_JH_WS_COINCOUNT: "কারেন্সি অ্যামাউন্ট",
  T_36_JH_WS_COINHUD: "কয়েন অ্যামাউন্ট ডিসপ্লে করবেন কি না",
  T_36_JH_WS_CRAFTSHOP: "স্টোর এডিট করুন",
  T_36_JH_WS_CREATEGOLD: "কয়েন জেনারেটর",
  T_36_JH_WS_CSHOPENTITY: "স্টোর এনটিটি বাইন্ড করুন",
  T_36_JH_WS_CSHOPHUD: "স্টোর ইন্টারফেস",
  T_36_JH_WS_CURRENTLIMIT: "অবশিষ্ট ক্রয় লিমিট",
  T_36_JH_WS_ECONOMIC: "ইকোনমি",
  T_36_JH_WS_INGAMEECONOMI: "গেম ইকোনমি",
  T_36_JH_WS_ITEMINDEXID: "মার্চেন্ডাইস নাম্বার",
  T_36_JH_WS_KILLMONEY: "এলিমিনেশনের জন্য কয়েন অর্জন করুন",
  T_36_JH_WS_KILLMONEYTIP: "রাশ মোড এবং এন্ডুরেন্স মোডে জম্বিদের এলিমিনেট করার জন্য যে পরিমাণ কয়েন উপার্জন করতে হবে",
  T_36_JH_WS_LISTINDEX: "মার্চেন্ডাইজ টাইপের লিস্ট",
  T_36_JH_WS_NULL: "খালি",
  T_36_JH_WS_NUMBER: "পরিমাণ",
  T_36_JH_WS_OPTIONNAME: "ড্রয়েড অ্যাপোকেলিপস মোড এক্সক্লুসিভ",
  T_36_JH_WS_REALSHOPENTITY: "স্টোর এনটিটি",
  T_36_JH_WS_SEEORHIDE: "ভেন্ডিং মেশিন ডিসপ্লে করুন",
  T_36_JH_WS_SHOPFRONT: "স্টোর",
  T_36_JH_WS_SHOPITEMLIST: "মার্চেন্ডাইজ টাইপ",
  T_36_JH_WS_SHOPOPENCON: "স্ট্যাটাস খুলুন",
  T_36_JH_WS_SSHOPNAME: "স্টোরের নাম",
  T_36_JH_WS_TOTALLIMIT: "ক্রয়ের লিমিট",
  T_36_JH_WS_TRIGGERWIDE: "রেঞ্জ ট্রিগার করুন",
  T_36_JH_WS_VENDMACHINE: "ভেন্ডিং মেশিন",
  T_36_JH_WS_WINMONEY: "বিজয় থেকে কয়েন পান",
  T_36_JH_WS_WORTH: "মূল্যমান",
  T_36_JL_FOREGRIP_MR_N: "মার্কসম্যান গ্রিপ",
  T_36_JL_GOLD_SCAR_I_N: "স্কার-I",
  T_36_JL_GOLD_SCAR_II_N: "স্কার-II",
  T_36_JL_GOLD_SCAR_III_N: "স্কার-III",
  T_36_JL_STOCK_SG_N: "শটগান স্টক",
  T_36_JL_STOCK_SR_N: "স্নাইপার স্টক",
  T_36_KK_WS_MONTSTERDES: "উচ্চ স্থায়িত্ব সহ একটি 4-সিটের ট্রাক এবং কঠিন ভূখণ্ডের মধ্য দিয়ে ট্রাভেল করতে পারে",
  T_36_M_WS_SETTEMPVAR: "অস্থায়ী ভেরিয়েবল সেট করুন",
  T_36_M_WS_TEMPVAR: "টেম্পরারি ভ্যারিয়েবল",
  T_36_SY_AK47_MAMBAS_N: "AK47- মাম্বা ন্যাউ",
  T_36_SY_AN94_MAMBAS_N: "AN94- মাম্বা Gnaw",
  T_36_SY_AR15_MAMBAS_N: "কিংফিশার- মাম্বা ন্যাউ",
  T_36_SY_AUG_MAMBAS_N: "AUG- মাম্বা ন্যাউ",
  T_36_SY_AWM_MAMBAS_N: "AWM- মাম্বা ন্যাউ",
  T_36_SY_BLT_MAMBAS_N: "M82B- মাম্বা ন্যাউ",
  T_36_SY_CHARGESHOT_MAMBAS_N: "চার্জ বুস্টার- মাম্বা ন্যাউ",
  T_36_SY_EAGLE_MAMBAS_N: "ডেজার্ট ঈগল- মাম্বা ন্যাউ",
  T_36_SY_FAMAS_MAMBAS_N: "ফামাস- মাম্বা ন্যাউ",
  T_36_SY_G18_MAMBAS_N: "G18- মাম্বা ন্যাউ",
  T_36_SY_G36_MAMBAS_N: "G36- মাম্বা ন্যাউ",
  T_36_SY_GRENADE_FESTIVAL_TU_N: "গ্রেনেড নেভি ফেস্টিভিটি",
  T_36_SY_GROZA_MAMBAS_N: "গ্রোজা- মাম্বা ন্যাউ",
  T_36_SY_HAND_CANNON_MAMBAS_N: "হ্যান্ড ক্যানন- মাম্বা ন্যাউ",
  T_36_SY_HEALINGSNIPER_MAMBAS_N: "হিল স্নাইপার- মাম্বা ন্যাউ",
  T_36_SY_ICE_GUN_MAMBAS_N: "আইস গান- মাম্বা ন্যাউ",
  T_36_SY_KAR98K_MAMBAS_N: "Kar98k- মাম্বা ন্যাউ",
  T_36_SY_KORD_MAMBAS_N: "কর্ড- মাম্বা ন্যাউ",
  T_36_SY_M1014_MAMBAS_N: "M1014- মাম্বা ন্যাউ",
  T_36_SY_M14_MAMBAS_N: "M14- মাম্বা ন্যাউ",
  T_36_SY_M1873_MAMBAS_N: "M1873- মাম্বা ন্যাউ",
  T_36_SY_M1887_MAMBAS_N: "M1887- মাম্বা ন্যাউ",
  T_36_SY_M1917_MAMBAS_N: "M1917- মাম্বা ন্যাউ",
  T_36_SY_M21A5_MAMBAS_N: "উডপেকার- মাম্বা ন্যাউ",
  T_36_SY_M24_MAMBAS_N: "M24- মাম্বা ন্যাউ",
  T_36_SY_M249_MAMBAS_N: "M249- মাম্বা ন্যাউ",
  T_36_SY_M4A1_MAMBAS_N: "M4A1- মাম্বা ন্যাউ",
  T_36_SY_M500_MAMBAS_N: "M500- মাম্বা ন্যাউ",
  T_36_SY_M60_MAMBAS_N: "M60- মাম্বা ন্যাউ",
  T_36_SY_M79_MAMBAS_N: "M79- মাম্বা ন্যাউ",
  T_36_SY_MAC10_MAMBAS_N: "MAC10- মাম্বা ন্যাউ",
  T_36_SY_MAG7_MAMBAS_N: "MAG-7- মাম্বা ন্যাউ",
  T_36_SY_MINI_MAMBAS_N: "AC80- মাম্বা ন্যাউ",
  T_36_SY_MP40_MAMBAS_N: "MP40- মাম্বা ন্যাউ",
  T_36_SY_MP5_MAMBAS_N: "MP5- মাম্বা ন্যাউ",
  T_36_SY_P90_MAMBAS_N: "P90- মাম্বা ন্যাউ",
  T_36_SY_PARAFAL_MAMBAS_N: "প্যারাফল- মাম্বা ন্যাউ",
  T_36_SY_PP19_MAMBAS_N: "বিজন- মাম্বা ন্যাউ",
  T_36_SY_PP19_POLICEMAN_N: "বিজন- র‍্যাথ পেট্রল",
  T_36_SY_SCAR_MAMBAS_N: "স্কার- মাম্বা ন্যাউ",
  T_36_SY_SKS_MAMBAS_N: "SKS- মাম্বা ন্যাউ",
  T_36_SY_SPAS12_MAMBAS_N: "SPAS12- মাম্বা ন্যাউ",
  T_36_SY_SUPERHEAT_GUN_MAMBAS_N: "প্লাজমা- মাম্বা ন্যাউ",
  T_36_SY_SVD_MAMBAS_N: "SVD- মাম্বা ন্যাউ",
  T_36_SY_THOMPSON_MAMBAS_N: "থম্পসন- মাম্বা ন্যাউ",
  T_36_SY_THROWINGKNIFE_MAMBAS_N: "মাম্বা ড্যাগার",
  T_36_SY_THROWINGKNIFE_MENA_N: "বোহো ড্যাগার",
  T_36_SY_TREATMENTGUN_MAMBAS_N: "হিল পিস্তল- মাম্বা ন্যাউ",
  T_36_SY_UMP45_MAMBAS_N: "UMP- মাম্বা ন্যাউ",
  T_36_SY_USP45_MAMBAS_N: "USP- মাম্বা ন্যাউ",
  T_36_SY_UZI_MAMBAS_N: "মিনি Uzi- মাম্বা ন্যাউ",
  T_36_SY_VECTOR_MAMBAS_N: "ভেক্টর- মাম্বা ন্যাউ",
  T_36_SY_VEHICLE_MONSTER_TRUCK_BDK_N: "মনস্টার ট্রাক- ব্লাইন্ডিং গোল্ড",
  T_36_SY_VEHICLE_MOTOBIKE_SUGARSKULL22_N: "মোটরবাইক- স্পেকট্রাল রাইড",
  T_36_SY_VEHICLE_ROADSTER_BDK_N: "স্পোর্টস কার- স্পিড এইসার",
  T_36_SY_VEHICLE_TUTU_POLICEMAN_N: "টুক টুক- নেথারওয়ার্ল্ড রাইড",
  T_36_SY_VSS_MAMBAS_N: "VSS- মাম্বা ন্যাউ",
  T_36_SY_XM8_MAMBAS_N: "XM8- মাম্বা ন্যাউ",
  T_36_WZY_AFTERACCUMULATOR: "ব্যাক অ্যাকুমুলেটর",
  T_36_WZY_AVAILAB: "এনাবলড",
  T_36_WZY_BACKANDFORTH: "রাউন্ড-ট্রিপ",
  T_36_WZY_BASEMULTIPLIER: "বেসিক মাল্টিপ্লায়্যার",
  T_36_WZY_BASIC: "বেসিক টাইপ",
  T_36_WZY_BEFORACCUMULATOR: "সামনের সারির সঞ্চয়কারী",
  T_36_WZY_CYLIC: "সার্কেল-ব্যাক",
  T_36_WZY_GUNPRO_PARAM1: "বেসিক ড্যামেজ",
  T_36_WZY_GUNPRO_PARAM10: "বুলেট স্প্রেড শুরু",
  T_36_WZY_GUNPRO_PARAM11: "ম্যাক্স. স্প্রেড এরিয়া",
  T_36_WZY_GUNPRO_PARAM12: "বার্স্ট",
  T_36_WZY_GUNPRO_PARAM2: "ম্যাগাজিনে বুলেট",
  T_36_WZY_GUNPRO_PARAM3: "প্রাথমিক ম্যাগাজিন নাম্বার",
  T_36_WZY_GUNPRO_PARAM4: "ফায়ারিং বিরতি",
  T_36_WZY_GUNPRO_PARAM7: "ম্যাক্স ড্যামেজের জন্য দূরত্ব",
  T_36_WZY_GUNPRO_PARAM8: "ন্যুনতম দূরত্বের জন্য দূরত্ব",
  T_36_WZY_GUNPRO_PARAM9: "ন্যূনতম ড্যামেজ",
  T_36_WZY_MULTIPLIR: "গুণক",
  T_36_WZY_PRICE: "মূল্য",
  T_36_WZY_SUMMULTIPLIER: "গুণক সঞ্চয়কারী",
  T_36_WZY_WS_3DZOOM: "3D জুম",
  T_36_WZY_WS_ABSRES: "পরম ভ্যালু রেজাল্ট",
  T_36_WZY_WS_ADDALLELE_NAMEDESC: "[উৎস তালিকা] থেকে [টার্গেট লিস্ট] এর নীচে সমস্ত উপাদান যোগ করুন",
  T_36_WZY_WS_ADDALLELE_PARAM1_DESC: "উপাদান যোগ করার টার্গেট লিস্ট",
  T_36_WZY_WS_ADDALLELE_PARAM2_DESC: "সোর্স লিস্ট যেখানে কোন উপাদানগুলো যোগ করতে হবে, তা অন্তর্ভুক্ত আছে",
  T_36_WZY_WS_ADDCURR_NAMEDESC: "একটি মনোনীত ওয়ালেটে নির্দিষ্ট পরিমাণ নির্দিষ্ট কারেন্সি যোগ করুন",
  T_36_WZY_WS_ADDCURR_PARAM1_NAME: "ওয়ালেট",
  T_36_WZY_WS_ADDCURR_PARAM1_NAMEDESC: "যে ওয়ালেটে কারেন্সি যোগ করা হবে",
  T_36_WZY_WS_ADDSUB: "ভ্যালু যোগ বা বিয়োগ করুন",
  T_36_WZY_WS_AIENTITY: "AI এনটিটি",
  T_36_WZY_WS_ALLSHOP_DESC: "একটি লিস্ট, যেটা স্টোর এনটিটি নিয়ে তৈরি",
  T_36_WZY_WS_ANGLE_DESC: "কোণ টির মাপ",
  T_36_WZY_WS_ANYTYPE: "যেকোনো ধরণের",
  T_36_WZY_WS_ARILEFT: "এই অপারেশনের বাম ভ্যাল্যু",
  T_36_WZY_WS_ARIRES: "অপারেশন রেজাল্ট",
  T_36_WZY_WS_ARIRIGHT: "অপারেশনে সঠিক ভ্যালু",
  T_36_WZY_WS_ARITHMETIC_NAME: "4টি গাণিতিক অপারেশন",
  T_36_WZY_WS_ARITHMETIC_NAMEDESC: "মৌলিক পূর্ণসংখ্যা অপারেশনগুলো যোগ, বিয়োগ, গুণ, ভাগ এবং ভাগশেষকে সাপোর্ট করে। ফ্লোট অপারেশন যোগ, বিয়োগ, গুণ এবং ভাগ সাপোর্ট করে।",
  T_36_WZY_WS_ARRAY_DESC: "টার্গেট লিস্ট",
  T_36_WZY_WS_ARRCONELE_NAMEDESC: "একটি তালিকায় একটি মনোনীত উপাদান রয়েছে কিনা তা পরীক্ষা করুন। ফেরত দেওয়া মান হল বুলিয়ান।",
  T_36_WZY_WS_ARRCONELE_PARAM1_DESC: "মনোনীত তালিকা",
  T_36_WZY_WS_ARRCONELE_PARAM2_DESC: "তালিকায় যে উপাদানটি খুঁজতে হবে",
  T_36_WZY_WS_ARRCONELERES: "একটি তালিকায় একটি মনোনীত উপাদান বিদ্যমান কিনা তার ফলাফল। মান হল বুলিয়ান।",
  T_36_WZY_WS_ATTACK: "পেট্রল এবং অ্যাটাক",
  T_36_WZY_WS_BEKNODOWN_NAMEDESC: "প্লেয়ার যখন নক ডাউন হয়, তখন ট্রিগার করে",
  T_36_WZY_WS_BIGFLOAT: "বড় ডেসিমাল",
  T_36_WZY_WS_BIGTOYBALL: "ডাইস",
  T_36_WZY_WS_BOOLLIST: "বুলিয়ান লিস্ট",
  T_36_WZY_WS_CEIL_NAME_DESC: "একটি ভ্যাল্যুকে এর নিজের থেকে বড় ক্ষুদ্রতম পূর্ণসংখ্যাতে রাউন্ডেড করুন",
  T_36_WZY_WS_CEIL_PARAM1_NAMEDESC: "যে ভ্যালু রাউন্ড আপ করা হবে",
  T_36_WZY_WS_CEILRES: "রাউন্ডিং-আপ রেজাল্ট",
  T_36_WZY_WS_CHASEENT_NAMEDESC: "নির্বাচিত AI দূরত্ব নির্বিশেষে এই সত্তাকে তাড়া করবে। [চেজড এনটিটি] যেকোনো সত্তা হতে পারে। যখন [চেজড এনটিটি]-এর কোনো HP প্রপার্টি থাকে না, তখন AI সত্তা কোনো ড্যামেজ করবে না।",
  T_36_WZY_WS_CHASEENT_PARAM1_NAMEDESC: "যে সত্তা ধাওয়া করে যাচ্ছে",
  T_36_WZY_WS_CHASEENT_PARAM2_NAMEDESC: "যে টার্গেট সত্তাকে তাড়া করা হচ্ছে। এটা যে কোনো সত্তা হতে পারে।",
  T_36_WZY_WS_CLONEOBJ_PARAM1_DESC: "ক্লোনিং অবজেক্টের জন্য টেমপ্লেট। কার্সার ব্যবহার করে নির্বাচন করুন। ক্লোনের সম্পত্তি এবং স্ক্রিপ্ট নির্বাচিত বস্তুর মতোই হতে হবে।",
  T_36_WZY_WS_CLONEOBJ_PARAM2_DESC: "যেই অবজেক্ট এনটিটি ক্লোন করা হবে",
  T_36_WZY_WS_CONDITION: "কন্ডিশন",
  T_36_WZY_WS_CONDITIONLIST: "কন্ডিশন লিস্ট",
  T_36_WZY_WS_CONOFHUD: "HUD এনটিটি যেটিতে কন্ট্রোল বিদ্যমান",
  T_36_WZY_WS_CONTROL_DESC: "কোনো কন্ট্রোলের একমাত্র ইনডেক্স",
  T_36_WZY_WS_COS_NAMEDESC: "একটি কোণের cosine নির্ণয় করুন",
  T_36_WZY_WS_COSRES: "কোণের কোসাইন",
  T_36_WZY_WS_CREABLEOB: "তৈরীযোগ্য অবজেক্ট",
  T_36_WZY_WS_CREOBJ_NAMEDESC: "একটি নির্দিষ্ট স্থানে একটি অবজেক্ট এনটিটি তৈরি করুন। (পরীক্ষামূলক সংস্করণ)",
  T_36_WZY_WS_CREOBJ_PARAM1_DESC: "অবজেক্টের কো-অর্ডিনেটস তৈরি করতে হবে",
  T_36_WZY_WS_CREOBJ_PARAM2_DESC: "যে ধরনের অবজেক্ট তৈরি করতে হবে",
  T_36_WZY_WS_CREOBJ_PARAM3_DESC: "যে অবজেক্টের এনটিটি তৈরি করা হবে",
  T_36_WZY_WS_CREPROD_PARAM2_NAME: "কারেন্সি",
  T_36_WZY_WS_CREPROD_PARAM4_NAME: "মার্চেন্ডাইজ এনটিটি",
  T_36_WZY_WS_CREPROD_PARAM4_NAMEDESC: "একটি মার্চেন্ডাইজ এনটিটি তৈরি করুন",
  T_36_WZY_WS_CREWALL_NAMEDESC: "একটি ওয়ালেট এনটিটি তৈরি করুন। [বাইন্ড প্লেয়ার] হল সেই প্লেয়ার, যে এই ওয়ালেটটি দেখতে পারে। [মালিক] হল সেই প্লেয়ার, যার কাছে ওয়ালেটটি রয়েছে। একটি ওয়ালে ইতিমধ্যে বিদ্যমান থাকলে তা অকার্যকর হবে৷",
  T_36_WZY_WS_CREWALL_PARAM1_NAME: "প্লেয়ার বাইন্ড হয়েছে",
  T_36_WZY_WS_CREWALL_PARAM1_NAMEDESC: "যে প্লেয়ারটির কাছে ওয়ালেটটি দৃশ্যমান। কোনো সেটিংস কনফিগার করা না থাকলে, ওয়ালেটটি সবার কাছে দৃশ্যমান হবে৷",
  T_36_WZY_WS_CREWALL_PARAM2_NAMEDESC: "এই ওয়ালেটের মালিক",
  T_36_WZY_WS_CREWALL_PARAM3_NAME: "ওয়ালেট এনটিটি",
  T_36_WZY_WS_CREWALL_PARAM3_NAMEDESC: "ওয়ালেট এনটিটি তৈরি করা হবে",
  T_36_WZY_WS_CURRAMT: "কারেন্সি অ্যামাউন্ট",
  T_36_WZY_WS_DATA_TYPE1: "প্যারামিটার যোগ হয়েছে",
  T_36_WZY_WS_DATA_TYPE2: "বেসিক এবং লজিক ক্যালকুলেশন",
  T_36_WZY_WS_DATA_TYPE3: "লিস্ট ম্যানিপুলেশন",
  T_36_WZY_WS_DATA_TYPE4: "ভেক্টর ক্যালকুলেশন",
  T_36_WZY_WS_DESTITEM_NAME: "প্লেয়ার আইটেম ধ্বংস করুন",
  T_36_WZY_WS_DESTITEM_NAMEDESC: "একটি মনোনীত প্লেয়ারের জন্য একটি মনোনীত ধরনের আইটেম ধ্বংস করুন",
  T_36_WZY_WS_DESTITEM_PARAM1_NAMEDESC: "যে আইটেমগুলি ধ্বংস করা যায় তা হল অস্ত্র, ভেস্ট এবং হেলমেট",
  T_36_WZY_WS_DESTITEM_PARAM2_NAMEDESC: "নির্বাচিত আইটেমের প্রকারের স্লট ইনডেক্স৷ ওয়েপন ইনডেক্স হল [1,3] এবং ভেস্ট এবং হেলমেট ডিফল্টভাবে 1।",
  T_36_WZY_WS_DESTITEM_WHELOSTEQU: "এলিমিনেশনে ইকুইপমেন্ট হারান",
  T_36_WZY_WS_DESTOBJ: "ধ্বংসযোগ্য অবজেক্টসমূহ",
  T_36_WZY_WS_DIRPOINT: "ডিরেকশন পয়েন্ট",
  T_36_WZY_WS_DIRPOINTDESC: "যে ডিরেকশন পয়েন্ট তৈরি করতে হবে",
  T_36_WZY_WS_ELEFINDRES: "একটি উপাদানের প্রথম অবস্থানের সূচক",
  T_36_WZY_WS_ELEFIRINDEX_NAMEDESC: 'একটি তালিকার একটি উপাদানের প্রথম অবস্থানের সূচক অর্জন করুন। যদি টার্গেট উপাদানটি তালিকায় বিদ্যমান না থাকে, ফলাফলটি "-1" নিয়ে ফিরে আসবে৷',
  T_36_WZY_WS_ELEFIRINDEX_PARAM2_DESC: "লিস্টে যে উপাদানটি খুঁজতে হবে",
  T_36_WZY_WS_ELELASINDEX_NAMEDESC: 'একটি তালিকার একটি উপাদানের শেষ অবস্থানের ইনডেক্স পান। যদি টার্গেট ইলিমেন্ট লিস্টে বিদ্যমান না থাকে, রেজাল্টটি "-1" নিয়ে ফিরে আসবে৷',
  T_36_WZY_WS_ELELINDRES: "একটি উপাদানের সর্বশেষ পজিশনের ইনডেক্স",
  T_36_WZY_WS_ELEMENTSNUM: "লিস্টে থাকা উপাদানের #",
  T_36_WZY_WS_ENTCOLLIDE_NAMEDESC: "ট্রিগার হয় যখন [ট্রিগারিং এনটিটি] এই ট্রিগারের সাথে সংঘর্ষ হয়",
  T_36_WZY_WS_ENTCOLLIDE_PARAM1_NAMEDESC: "এই ট্রিগারটি যে সত্তার সাথে সংঘর্ষ হয়",
  T_36_WZY_WS_ENTDRIVEH_NAMEDESC: "যখন একটি [ট্রিগারিং সত্তা] ভেহিক্যাল ড্রাইভ করে তখন ট্রিগার হয়",
  T_36_WZY_WS_ENTDRIVEH_PARAM1_NAMEDESC: "যে এনটিটি ভেহিক্যালটি ড্রাইভ করছে",
  T_36_WZY_WS_ENTERTRI_NAMEDESC: "কোনো প্লেয়ার ট্রিগারটিতে প্রবেশ করলে ট্রিগার করে",
  T_36_WZY_WS_ENTERTRI_PARAM1_DESC: "প্রবেশ করার ট্রিগার",
  T_36_WZY_WS_ENTGETOFFVEH_NAMEDESC: "ট্রিগার হয় যখন একটি [ট্রিগারিং সত্তা] গাড়ি থেকে বেরিয়ে যায়",
  T_36_WZY_WS_ENTGETOFFVEH_PARAM1_NAMEDESC: "যে সত্তা ভেহিক্যাল প্রস্থান করে",
  T_36_WZY_WS_ENTGETONVEH_NAMEDESC: "ট্রিগার হয় যখন একটি [ট্রিগারিং এনটিটি] ভেহিক্যালে প্রবেশ করে",
  T_36_WZY_WS_ENTGETONVEH_PARAM1_NAMEDESC: "যে সত্তাটি ভেহিক্যালে প্রবেশ করে",
  T_36_WZY_WS_ENTITY_TYPE1: "সাধারণত ব্যবহৃত",
  T_36_WZY_WS_ENTITY_TYPE2: "প্রপার্টিজ",
  T_36_WZY_WS_ENTITY_TYPE3: "অবজেক্ট এবং আইটেমসমূহ",
  T_36_WZY_WS_ENTITY_TYPE4: "AI",
  T_36_WZY_WS_ENTITY2_PARAM4_DESC: "যেই ইলিমেন্ট পরিবর্তন করতে হবে",
  T_36_WZY_WS_ENTITY7_PARAM1_DESC: "টার্গেট প্লেয়ার",
  T_36_WZY_WS_ENTITYLIST: "এনটিটি লিস্ট",
  T_36_WZY_WS_ENTKNOFLY_NAMEDESC: "ট্রিগার হয় যখন একটি [ট্রিগারিং এনটিটি] টায়ার থেকে বাউন্স করে",
  T_36_WZY_WS_ENTKNOFLY_PARAM1_NAMEDESC: "যেই এনটিটি টায়ারের বাইরে বাউন্স করে",
  T_36_WZY_WS_ENTTP_NAMEDESC: "যখন একটি [ট্রিগারিং সত্তা] পোর্টালে প্রবেশ করে এবং টেলিপোর্ট করা হয় তখন ট্রিগার হয়",
  T_36_WZY_WS_ENTTP_PARAM1_NAMEDESC: "যেই এনটিটি টেলিপোর্ট হবে",
  T_36_WZY_WS_EQUARMOR_PARAM2_DESC: "ভেস্ট, হেলমেট এবং ব্যাকপ্যাক সহ সজ্জিত আর্মরের ধরণ",
  T_36_WZY_WS_EQUWEAP_NAMEDESC: "একজন প্লেয়ার সফলভাবে ওয়েপন ইকুইপ করলে ট্রিগার হয়। [ট্রিগার প্লেয়ার] হল সেই প্লেয়ার, যে সফলভাবে একটি ওয়েপন ইকুইপ করে। [ওয়েপন এনটিটি] হল সেই ওয়েপন, যা প্লেয়ার ইকুইপ করে।",
  T_36_WZY_WS_EQUWEAP_PARAM2_DESC: "যে ওয়েপন এনটিটি ইকুইপ হয়েছে",
  T_36_WZY_WS_EQUWEAP_PARAM2_NAME: "ওয়েপন টাইপ",
  T_36_WZY_WS_EULERANGLE: "ইউলার এঙ্গেল",
  T_36_WZY_WS_FACECAMERA: "সবসময় ফেইস ক্যামেরা",
  T_36_WZY_WS_FLOATLIST: "ফ্লোট লিস্ট",
  T_36_WZY_WS_FLOOR_NAME_DESC: "একটি মানকে নিজের থেকে ছোট করে সবচেয়ে বড় পূর্ণসংখ্যাতে পরিণত করুন",
  T_36_WZY_WS_FLOOR_PARAM1_NAMEDESC: "যে ভ্যালু রাউন্ড ডাউন করা হবে",
  T_36_WZY_WS_FLOORRES: "রাউন্ডিং ডাউনের রেজাল্ট",
  T_36_WZY_WS_FORMUENT: "প্রপার্টি প্রণয়ন-সক্ষম সত্তা",
  T_36_WZY_WS_FORMUFACT: "প্রপার্টি ফর্মুলা ফ্যাক্টরের ধরণ",
  T_36_WZY_WS_GAME_TYPE2: "গেম-প্লে",
  T_36_WZY_WS_GAME_TYPE3: "স্পেশাল ইফেক্টস",
  T_36_WZY_WS_GENENT_NAMEDESC: "একটি জেনারেটর যখন ইউনিট তৈরি করে তখন ট্রিগার হয়। [ইউনিট এনটিটি লিস্ট] হল জেনারেটর দ্বারা তৈরি ইউনিটগুলির তালিকা। [# তম ওয়েভ] হলো জেনারেশনের দ্বারা উদ্ভূত তরঙ্গের সংখ্যা।",
  T_36_WZY_WS_GENENT_PARAM1_NAME: "ইউনিট এনটিটি",
  T_36_WZY_WS_GENENT_PARAM1_NAMEDESC: "একটি তালিকা যা একটি জেনারেটর দ্বারা তৈরি ইউনিট সত্তা নিয়ে গঠিত",
  T_36_WZY_WS_GENENT_PARAM2_NAMEDESC: "একটি জেনারেটর যে তরঙ্গ তৈরি করে তার সংখ্যা",
  T_36_WZY_WS_GETALLSHOP_NAMEDESC: "ম্যাচের সবগুলো স্টোর অর্জন করুন। যে ভ্যালুটি রিটার্ন করবে, তা হলো এমন  একটি লিস্ট, যেটা স্টোর এনটিটি নিয়ে তৈরি।",
  T_36_WZY_WS_GETCOLOR_NAMEDESC: "একটি কালার অর্জন করতে RGB ব্যবহার করুন",
  T_36_WZY_WS_GETCURRAMT_NAMEDESC: "একটি নির্দিষ্ট ওয়ালেটে একটি নির্দিষ্ট পরিমাণ মুদ্রা পান",
  T_36_WZY_WS_GETCURRAMT_PARAM1_NAMEDESC: "যে ওয়ালেট থেকে কারেন্সি অ্যামাউন্ট অর্জন করা হবে",
  T_36_WZY_WS_GETCURRAMT_PARAM2_NAMEDESC: "কারেন্সি অ্যামাউন্টের যে কারেন্সি টাইপ অর্জন করতে হবে",
  T_36_WZY_WS_GETENTTYPE_NAMEDESC: "একটি টার্গেট এনটিটির এনটিটি টাইপ অর্জন করুন",
  T_36_WZY_WS_GETENTTYPE_PARAM1_DESC: "যেই সত্তাটির ধরণ অর্জন করতে হবে'",
  T_36_WZY_WS_GETENTTYPERES: "টার্গেট এনটিটির এনটিটি টাইপ",
  T_36_WZY_WS_GETFOR_NAME: "ডিরেকশন কো-অর্ডিনেটস অর্জন করুন",
  T_36_WZY_WS_GETFOR_NAMEDESC: "একটি মনোনীত ডিরেকশন পয়েন্টের ভেক্টর অর্জন করুন",
  T_36_WZY_WS_GETFORRES: "ডিরেকশন পয়েন্টের ভেক্টর",
  T_36_WZY_WS_GETMONEYENT_NAMEDESC: "ওয়ালেটে একটি নির্দিষ্ট কারেন্সি টাইপের কারেন্সি এনটিটি পান",
  T_36_WZY_WS_GETMONEYENT_PARAM1_DESC: "যে ওয়ালেটে কারেন্সি এনটিটি রয়েছে",
  T_36_WZY_WS_GETPOS_NAME: "কো-অর্ডিনেটস অর্জন করবে",
  T_36_WZY_WS_GETPOS_NAMEDESC: "একটি মনোনীত দিক বিন্দুর স্থানাঙ্ক অর্জন করুন",
  T_36_WZY_WS_GETPOS_PARAM1_DESC: "মনোনীত ডিরেকশন পয়েন্ট",
  T_36_WZY_WS_GETPROP_PARAM2_NAME: "ইকুইপমেন্ট টাইপ",
  T_36_WZY_WS_GETWALLET_NAME: "ওয়ালেট অর্জন করুন",
  T_36_WZY_WS_GETWALLET_NAMEDESC: "সিলেক্ট করা মালিকের ওয়ালেট অর্জন করুন",
  T_36_WZY_WS_GETWALLET_PARAM2_NAMEDESC: "একটা বাইন্ড ওয়ালেট আছে কী না",
  T_36_WZY_WS_GETWALLETRES: "মালিকের ওয়ালেট এনটিটি",
  T_36_WZY_WS_HUDCONTROL_DESC: "একটি HUD এর নিয়ন্ত্রণ এনটিটি",
  T_36_WZY_WS_HUDTYPE: "HUD টাইপ",
  T_36_WZY_WS_INCIDENT_TYPE1: "গ্লোবাল ইনসিডেন্ট",
  T_36_WZY_WS_INCIDENT_TYPE2: "এনটিটি ইনসিডেন্ট",
  T_36_WZY_WS_INDEX_DESC: "তালিকার একটি সূচক মান। 0 থেকে শুরু হয়।",
  T_36_WZY_WS_INTLIST: "পূর্ণসংখ্যার লিস্ট",
  T_36_WZY_WS_JENTSUBCL_NAMEDESC: "একটি এনটিটি টাইপ নির্দিষ্ট সাব-ক্যাটাগরির অন্তর্গত কিনা তা চেক করুন। ফিরে আসা রেজাল্টটি হলো বুলিয়ান।",
  T_36_WZY_WS_JENTSUBCL_PARAM2_NAMESESC: "এই এনটিটি এটার অন্তর্গত কিনা তা চেক করার জন্য প্যারেন্ট ক্যাটাগরি",
  T_36_WZY_WS_JENTSUBCLRES: "প্যারেন্ট ক্যাটাগরি চেকের রেজাল্ট",
  T_36_WZY_WS_JENTTYPE_NAMEDESC: "একটি সত্তা একটি নির্দিষ্ট সত্তা প্রকারের অন্তর্গত কিনা তা পরীক্ষা করুন। ফিরে আসা ফলাফল হল বুলিয়ান।",
  T_36_WZY_WS_JENTTYPE_PARAM1_NAMEDESC: "যে এনটিটি চেক করতে হবে",
  T_36_WZY_WS_JENTTYPE_PARAM2_NAMEDESC: "এর মানে হল যে এটি এনটিটি টাইপ হিসাবে একই",
  T_36_WZY_WS_JENTTYPERES: "এনটিটি চেক এর রেজাল্ট",
  T_36_WZY_WS_JUSTPATROL: "শুধুমাত্র পেট্রোল",
  T_36_WZY_WS_LEAVETRI_NAMEDESC: "কোনো প্লেয়ার ট্রিগারটিকে প্রস্থান করলে ট্রিগার করে",
  T_36_WZY_WS_LEAVETRI_PARAM1_DESC: "প্রস্থান করার ট্রিগার",
  T_36_WZY_WS_LEVELOBLIST: "অবজেক্ট লিস্ট",
  T_36_WZY_WS_LEVOBJSLIST: "এই ম্যাচের সমস্ত ম্যাপ অবজেক্টের একটি তালিকা",
  T_36_WZY_WS_LEVOBTYPE: "অবজেক্ট টাইপ",
  T_36_WZY_WS_LISTT: "যেকোনো লিস্ট",
  T_36_WZY_WS_LOGCONTEXT_DESC: "যে কন্টেন্ট প্রিন্ট করতে হবে",
  T_36_WZY_WS_LOGIC2_PARAM1_NAMEDESC: "বাম স্ট্রিং সংযুক্ত করা হবে",
  T_36_WZY_WS_LOGIC2_PARAM3_NAMEDESC: "সংযোগ করার জন্য ডান স্ট্রিং",
  T_36_WZY_WS_LOGIC5_PARAM1_NAMEDESC: "যে ইলিমেন্ট ভ্যাল্যু যোগ করতে হবে",
  T_36_WZY_WS_LOGOPER: "লজিক অপারেশন পরিচালনা করার সময় (এবং এবং বা): যদি এবং অপারেশন ব্যবহার করে এবং দুটি বুলিয়ান মান সত্য হয়, ফলাফলটি সত্য, এবং যদি বা অপারেশন ব্যবহার করে এবং দুটি বুলিয়ান মান উভয়ই মিথ্যা না হয়, ফলাফলটি সত্য।",
  T_36_WZY_WS_LOOTPOINT: "লুট পয়েন্ট",
  T_36_WZY_WS_MAINWEAP: "বর্তমান ওয়েপন",
  T_36_WZY_WS_MAX_DESC: "জেনারেট হওয়া পূর্ণসংখ্যার উর্ধ্বসীমা (ওপেন ইন্টার্ভাল)",
  T_36_WZY_WS_MIN_DESC: "উৎপন্ন পূর্ণসংখ্যার নিম্ন-রেঞ্জ (ক্লোজড ইন্টার্ভাল)",
  T_36_WZY_WS_MODGUNPRO_PARAM1_NAME: "ওয়েপন এনটিটি",
  T_36_WZY_WS_MONENT: "কারেন্সি এনটিটি",
  T_36_WZY_WS_MONTYPE: "কারেন্সি টাইপ",
  T_36_WZY_WS_MOVETO_NAMEDESC: "AI-কে একটি লক্ষ্য বিন্দুর দিকে নিয়ে যান। AI তার আসল অবস্থানে ফিরে আসবে কিনা তা নির্বাচন করতে [রিটার্ন করবে কী না] ব্যবহার করুন। এআই তার পথে প্রতিপক্ষদের জন্য স্ক্যান করবে কিনা তা নির্বাচন করতে [আক্রমণ করবে কী না] ব্যবহার করুন।",
  T_36_WZY_WS_MOVETO_PARAM1_NAMEDESC: "যে AI এনটিটি ট্রাভেল করবে",
  T_36_WZY_WS_MOVETO_PARAM2_NAMEDESC: "লক্ষ্যস্থান",
  T_36_WZY_WS_MOVETO_PARAM3_NAMEDESC: "গন্তব্যে পৌঁছানোর পরে AI আসল অবস্থানে ফিরে আসবে কিনা তা সেট করতে ব্যবহার করুন। TRUE মানে প্রত্যাবর্তন; FALSE মানে ফিরে আসবেন না।",
  T_36_WZY_WS_MOVETO_PARAM4_NAME: "অ্যাটাক করবেন কী না",
  T_36_WZY_WS_MOVETO_PARAM4_NAMEDESC: "AI পথে কাছাকাছি থাকা প্রতিপক্ষকে আক্রমণ করবে কিনা তা সেট করতে ব্যবহার করুন। TRUE মানে প্রতিপক্ষদের জন্য স্ক্যান করা; মিথ্যা মানে প্রতিপক্ষদের জন্য স্ক্যান করবেন না।",
  T_36_WZY_WS_MULVALUE: "স্কেলার",
  T_36_WZY_WS_MULVEC: "স্কেলার মাল্টিপ্লিকেশন ভেক্টর",
  T_36_WZY_WS_NEGRES: "নেগেটিভ ভ্যালু রেজাল্ট",
  T_36_WZY_WS_NEUTRAL: "নিরপেক্ষ",
  T_36_WZY_WS_NEXTVAWE_NAMEDESC: "পরবর্তী তরঙ্গ তৈরি করতে মনোনীত জেনারেটরকে বাধ্য করে। জেনারেটরে জোম্বি স্প্যান এবং আইটেম স্প্যান অন্তর্ভুক্ত।",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAME: "জেনারেটর এনটিটি",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAMEDESC: "মনোনীত জেনারেটর এনটিটি, যেমন জম্বি স্পন এবং আইটেম স্পন",
  T_36_WZY_WS_OBJENT: "অবজেক্ট এনটিটি",
  T_36_WZY_WS_OBTITEM_NAMEDESC: "একটি আইটেম পাওয়া গেলে ট্রিগার করে। [আইটেম টাইপ] হলো প্রাপ্ত আইটেমের ধরন।",
  T_36_WZY_WS_OBTWEAP_NAMEDESC: "একটি ওয়েপন পাওয়া গেলে ট্রিগার করে। [ওয়েপন এনটিটি] হলো যে অস্ত্রটি অর্জিত হয়েছে।",
  T_36_WZY_WS_ONEWAY: "এক-দিকের",
  T_36_WZY_WS_OPENSTATE: "স্ট্যাটাস",
  T_36_WZY_WS_OPERMETHOD_NAME: "অপারেশন",
  T_36_WZY_WS_OPERMETHOD_NAMEDESC: "মৌলিক গাণিতিক অপারেশন। বর্তমানে, পূর্ণসংখ্যার অপারেশনের মধ্যে যোগ, বিয়োগ, গুণ, ভাগ এবং অবশিষ্ট রয়েছে এবং ফ্লোট অপারেশনগুলির মধ্যে যোগ, বিয়োগ, গুণ এবং ভাগ অন্তর্ভুক্ত রয়েছে।",
  T_36_WZY_WS_OWNERENT_DESC: "যেই এনটিটির ওয়ালেট অর্জন করতে হবে",
  T_36_WZY_WS_PERCENTAGE: "পার্সেন্টেইড সমন্বয়",
  T_36_WZY_WS_PLACOLLIDE_NAME: "প্লেয়ার যখন এই ট্রিগারে সংঘর্ষ করে",
  T_36_WZY_WS_PLACOLLIDE_NAMEDESC: "ট্রিগার হয় যখন [ট্রিগার প্লেয়ার] এই ট্রিগারের সাথে সংঘর্ষ হয়",
  T_36_WZY_WS_PLACOLLIDE_PARAM1_NAMEDESC: "যে প্লেয়ার ট্রিগারের সাথে সংঘর্ষ করেছে",
  T_36_WZY_WS_PLACOLLIDE_PARAM2_NAMEDESC: "যে বস্তুর সত্তার সাথে প্লেয়ার সংঘর্ষ হয়",
  T_36_WZY_WS_PLADRIVEH_NAME: "যখন প্লেয়ার ভেহিক্যাল ড্রাইভ করে",
  T_36_WZY_WS_PLADRIVEH_NAMEDESC: "যখন [ট্রিগার প্লেয়ার] ভেহিক্যাল ড্রাইভ করে, তখন ট্রিগার হয়",
  T_36_WZY_WS_PLADRIVEH_PARAM1_NAMEDESC: "যে প্লেয়ার ভেহিক্যালটি ড্রাইভ করছে",
  T_36_WZY_WS_PLADRIVEH_PARAM2_NAMEDESC: "যেই প্লেয়ার ড্রাইভ করছেন, তার ভেহিক্যাল আইডেন্টিটি",
  T_36_WZY_WS_PLAGETOFFVEH_NAME: "যখন প্লেয়ার ভেহিক্যাল প্রস্থান করে",
  T_36_WZY_WS_PLAGETOFFVEH_NAMEDESC: "ট্রিগার হয় যখন [ট্রিগার প্লেয়ার] একটি ভেহিক্যাল থেকে বেরিয়ে যায়",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM1_NAMEDESC: "প্লেয়ার যে ভেহিক্যাল থেকে প্রস্থান করছে",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM2_NAMEDESC: "প্লেয়ার যেই ভেহিক্যাল এনটিটি থেকে বেরিয়ে আসছে",
  T_36_WZY_WS_PLAGETONVEH_NAME: "প্লেয়ার যখন ভেহিক্যালে প্রবেশ করে",
  T_36_WZY_WS_PLAGETONVEH_NAMEDESC: "ট্রিগার হয় যখন [ট্রিগার প্লেয়ার] একটি ভেহিক্যালে প্রবেশ করে",
  T_36_WZY_WS_PLAGETONVEH_PARAM2_NAMEDESC: "প্লেয়ার যে ভেহিক্যালে প্রবেশ করছে তার ভেহিক্যাল এনটিটি",
  T_36_WZY_WS_PLAKNOFLY_NAME: "প্লেয়ার যখন টায়ারের উপর বাউন্স করে",
  T_36_WZY_WS_PLAKNOFLY_NAMEDESC: "ট্রিগার হয় যখন [ট্রিগার প্লেয়ার] একটি টায়ার বাউন্স করে",
  T_36_WZY_WS_PLAKNOFLY_PARAM1_NAMEDESC: "যে প্লেয়ার একটি টায়ারে বাউন্স অফ করে",
  T_36_WZY_WS_PLAKNOFLY_PARAM2_NAMEDESC: "অবজেক্ট এনটিটি, যার উপর প্লেয়ার বাউন্স অফ করে",
  T_36_WZY_WS_PLATP_NAME: "প্লেয়ারকে টেলিপোর্ট করার পর",
  T_36_WZY_WS_PLATP_PARAM1_NAMEDESC: "যে প্লেয়ার পোর্টাল ব্যবহার করে",
  T_36_WZY_WS_PLATP_PARAM2_NAMEDESC: "পোর্টাল এনটিটি, যেটি প্লেয়ার ব্যবহার করেছে",
  T_36_WZY_WS_PLAYERLIST_DESC: "এই ম্যাচে থাকা সকল প্লেয়ারের লিস্ট",
  T_36_WZY_WS_POINTPICKER: "পাথ পিভট",
  T_36_WZY_WS_PORTALENT: "পোর্টাল এনটিটি",
  T_36_WZY_WS_PREFAB: "টেমপ্লেট",
  T_36_WZY_WS_PRODLIST: "মার্চেন্ডাইস লিস্ট",
  T_36_WZY_WS_PRODSORT_PARAM3_NAME: "ক্রমানুসারে সাজান",
  T_36_WZY_WS_PROPMOD: "প্রপার্টি পরিবর্তনের মেথড",
  T_36_WZY_WS_RANKABLEE: "র‍্যাংক-যোগ্য এনটিটি",
  T_36_WZY_WS_REDCURR_NAMEDESC: "একটি মনোনীত ওয়ালেটে নির্দিষ্ট পরিমাণে নির্ধারিত কারেন্সি ব্যবহার করুন",
  T_36_WZY_WS_REDCURR_PARAM1_NAMEDESC: "যে ওয়ালেট থেকে কারেন্সি ব্যয় করা হবে",
  T_36_WZY_WS_REDCURR_PARAM2_NAMEDESC: "ভোগকৃত কারেন্সির ধরণ",
  T_36_WZY_WS_REDCURR_PARAM3_NAMEDESC: "যে পরিমাণ কারেন্সি ভোগ করা হয়েছে",
  T_36_WZY_WS_RNDFRES: "র‍্যানডম জেনারেটকৃত ফ্লোট",
  T_36_WZY_WS_RNDIRES: "র‍্যানডম ইন্টিজার জেনারেশনের রেজাল্ট",
  T_36_WZY_WS_ROUND_NAME_DESC: "একটি ভ্যাল্যুকে নিকটতম পূর্ণসংখ্যায় রাউন্ড করুন",
  T_36_WZY_WS_ROUND_PARAM1_NAMEDESC: "রাউন্ড করার মান",
  T_36_WZY_WS_ROUNDRES: "রাউন্ডিং এর রেজাল্ট",
  T_36_WZY_WS_RUNAI_NAMEDESC: "সিলেক্টেড AI যেই বিহেভিয়ার ট্রি কার্যকর করবে",
  T_36_WZY_WS_RUNAI_PARAM1_NAMEDESC: "ইউনিট সত্তা যা একটি ডিফল্ট আচরণ ট্রি বন্ধ/চালনা করে",
  T_36_WZY_WS_SCOREABLEE: "স্কোর-যোগ্য এনটিটি",
  T_36_WZY_WS_SCORECHANGE_NAMEDESC: "স্কোর পরিবর্তন হলে ট্রিগার হয়। [স্কোর টাইপ] হলো পরিবর্তিত স্কোরের ধরন। [স্কোর] হল নতুন স্কোর।",
  T_36_WZY_WS_SETDIRPOINT_NAME: "একটি ডিরেকশন পয়েন্ট তৈরি করুন",
  T_36_WZY_WS_SETDIRPOINT_NAMESESC: "নতুন তৈরি হওয়া একটি ডিরেকশন পয়েন্ট অর্জন করুন। পয়েন্টের কো-অর্ডিনেটস সেট করতে [অবস্থান] এবং ডিরেকশনের ভেক্টর সেট করতে [ডিরেকশন] ব্যবহার করুন।",
  T_36_WZY_WS_SETDIRPOINT_PARAM1_NAMEDESC: "ডিরেকশন পয়েন্টের কো-অর্ডিনেটস",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAME: "দিক",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAMEDESC: "ডিরেকশন পয়েন্টের ভেক্টর",
  T_36_WZY_WS_SETPATH_NAMEDESC: "AI এনটিটিগুলো এখানে সেট করা অর্ডার অনুযায়ী ট্রাভেল করবে। উপলব্ধ ট্রাভেল টাইপ হল সার্কেল-ব্যাক, ওয়ান-ওয়ে এবং রাউন্ড-ট্রিপ। AI তার পথে প্রতিপক্ষদের জন্য স্ক্যান করবে কিনা তাও আপনি সিলেক্ট করতে পারেন।",
  T_36_WZY_WS_SETPATH_PARAM2_NAMEDESC: "একটি তালিকা যেখানে AI-এর ট্রাভেল করা উচিত এমন পয়েন্টগুলোকে নিয়ে গঠিত৷",
  T_36_WZY_WS_SETPATH_PARAM3_NAME: "ভ্রমণের ধরণ",
  T_36_WZY_WS_SETPATH_PARAM3_NAMEDESC: "এগুলি হল ভ্রমণের ধরন। গন্তব্যে পৌঁছানোর পরে AI-এর জন্য একমুখী যাত্রা বন্ধ করে দেওয়া। সার্কেল-ব্যাক হল AI-এর গন্তব্যে পৌঁছানোর পর ফেরার পথ খুঁজতে। রাউন্ড-ট্রিপ হল AI-এর জন্য পথ তালিকার পিছনের ক্রম অনুসারে আসল অবস্থানে ফিরে আসা।",
  T_36_WZY_WS_SHOPECON: "স্টোর এবং ইকোনমি",
  T_36_WZY_WS_SHOWFLO_NAMEDESC: "স্ক্রিনে ভাসমান নোটিফিকেশনগুলো ডিসপ্লে করতে ব্যবহার করুন৷ [Text] ব্যবহার করে কনটেন্ট কনফিগার করুন, [Color] ব্যবহার করে টেক্সট রঙ এবং [Duration] ব্যবহার করে প্রদর্শনের সময়কাল (ইউনিট হল মিলিসেকেন্ড)।",
  T_36_WZY_WS_SHOWFLO_PARAM1_DESC: "ফ্লোটিং নোটিফিকেশনের কন্টেন্ট",
  T_36_WZY_WS_SHOWFLO_PARAM2_DESC: "ফ্লোটিং নোটিফিকেশনের রঙ",
  T_36_WZY_WS_SHOWFLO_PARAM3_DESC: "ভাসমান নোটিফিকেশন প্রদর্শনের সময়কাল, মিলিসেকেন্ডে",
  T_36_WZY_WS_SIN_NAMEDESC: "একটি কোণের sine নির্ণয় করুন",
  T_36_WZY_WS_SINRES: "কোণের Sine",
  T_36_WZY_WS_SKIPKNODOWN: "নকডাউন এ এলিমিনেট হবে কি না",
  T_36_WZY_WS_SQRTRES: "স্কোয়ার রুট রেজাল্ট",
  T_36_WZY_WS_STRCONRES: "স্ট্রিং সংযোগের ফলাফল",
  T_36_WZY_WS_STRINGLIST: "স্ট্রিং লিস্ট",
  T_36_WZY_WS_STRLEN: "স্ট্রিং দৈর্ঘ্য",
  T_36_WZY_WS_STRVAL: "স্ট্রিং রেজাল্ট",
  T_36_WZY_WS_TAN_NAMEDESC: "একটি কোণের স্পর্শক নির্ণয় করুন",
  T_36_WZY_WS_TANRES: "কোণের স্পর্শক",
  T_36_WZY_WS_TEAMLIST: "টিম লিস্ট",
  T_36_WZY_WS_TEAMLIST_DESC: "এই ম্যাচে সব টিমের তালিকা",
  T_36_WZY_WS_TIMETWEENTIPS: "কাউন্টডাউন নোটিফিকেশন এনটিটি",
  T_36_WZY_WS_TOSTRING_NAMEDESC: "টার্গেট ভ্যাল্যুকে একটি স্ট্রিংয়ে রূপান্তর করুন",
  T_36_WZY_WS_TOSTRING_PARAM1_DESC: "একটি স্ট্রিং এ রূপান্তর করার টার্গেট ভ্যাল্যু",
  T_36_WZY_WS_TOSTRINGRES: "স্ট্রিং কনভার্শনের রেজাল্ট",
  T_36_WZY_WS_TOWERCAMP_DESC: "সাইড নম্বর এবং টিম নম্বর একই। নিরপেক্ষ টাওয়ার এবং দুর্গগুলো এর রেঞ্জের মধ্যে থাকা সকল প্লেয়ার এবং AI-দের অ্যাটাক করে।",
  T_36_WZY_WS_TRACURR_NAMEDESC: "এক ওয়ালেট থেকে অন্য ওয়ালেটে নির্দিষ্ট পরিমাণে নির্ধারিত কারেন্সি স্থানান্তর করুন",
  T_36_WZY_WS_TRACURR_PARAM1_NAMEDESC: "যে মানিব্যাগ থেকে কারেন্সি ট্রান্সফার করা হবে",
  T_36_WZY_WS_TRACURR_PARAM2_NAMEDESC: "ট্রানজেকশনে থাকা কারেন্সির ধরণ",
  T_36_WZY_WS_TRACURR_PARAM3_NAMEDESC: "ট্রানজেকশনে থাকা কারেন্সির অ্যামাউন্ট",
  T_36_WZY_WS_TRACURR_PARAM4_NAMEDESC: "যে ওয়ালেটে কারেন্সি ইনফো ট্রান্সফার করা হবে",
  T_36_WZY_WS_TWEENTIPS: "ভাসমান নোটিফিকেশন এনটিটি",
  T_36_WZY_WS_TYPEENUM: "এনাম টাইপ",
  T_36_WZY_WS_USEPROP_NAMEDESC: "কোনো খেলোয়াড় কোনো আইটেম ব্যবহার করলে ট্রিগার হয়। [ট্রিগারি প্লেয়ার] হল সেই খেলোয়াড় যে একটি আইটেম ব্যবহার করে। [আইটেমের ধরন] প্লেয়ার ব্যবহার করা আইটেম।",
  T_36_WZY_WS_USEPROP_PARAM2_DESC: "প্লেয়ারদের দ্বারা যে ধরণের আইটেম ব্যবহৃত হয়",
  T_36_WZY_WS_VECADDLEFT: "ভেক্টর অ্যাডিশনের বাম পাশের ভ্যালু",
  T_36_WZY_WS_VECADDRES: "ভেক্টর যোগের ফলাফল",
  T_36_WZY_WS_VECADDRIGHT: "ভেক্টর যোগের সঠিক ভ্যালু",
  T_36_WZY_WS_VECANGLEFT: "ভেক্টর কোণের বাম ভ্যালু",
  T_36_WZY_WS_VECANGRES: "2 টি ভেক্টরের মধ্যকার কোণ",
  T_36_WZY_WS_VECANGRIGHT: "ভেক্টর কোণের ডান পাশের ভ্যালু",
  T_36_WZY_WS_VECCROLEFT: "ক্রস প্রোডাক্টের বাম ভ্যাল্যু",
  T_36_WZY_WS_VECCRORES: "ক্রস প্রোডাক্টের রেজাল্ট",
  T_36_WZY_WS_VECCRORIGHT: "ক্রস প্রোডাক্টের ডান ভ্যালু",
  T_36_WZY_WS_VECDISLEFT: "ভেক্টর দূরত্বের বাম ভ্যালু",
  T_36_WZY_WS_VECDISRES: "2টি ভেক্টরের মধ্যে দূরত্ব",
  T_36_WZY_WS_VECDISRIGHT: "ভেক্টর দূরত্বের সঠিক ভ্যাল্যু",
  T_36_WZY_WS_VECDOCLEFT: "ডট প্রোডাক্টের বাম ভ্যালু",
  T_36_WZY_WS_VECDOCRES: "ডট প্রোডাক্টের রেজাল্ট",
  T_36_WZY_WS_VECDOCRIGHT: "ডট প্রোডাক্টের ডান ভ্যালু",
  T_36_WZY_WS_VECMULRES: "স্কেলার মাল্টিপ্লিকেশনের রেজাল্ট",
  T_36_WZY_WS_VECNORRES: "স্বাভাবিককৃত ভেক্টর",
  T_36_WZY_WS_VECSIZERES: "একটি ভেক্টরের মাত্রা",
  T_36_WZY_WS_VECSUBLEFT: "ভেক্টর বিয়োগের বাম ভ্যালু",
  T_36_WZY_WS_VECSUBRES: "ভেক্টর সাবট্র্যাকশন রেজাল্ট",
  T_36_WZY_WS_VECSUBRIGHT: "ভেক্টর বিয়োগের ডান পাশের ভ্যালু",
  T_36_WZY_WS_VECTORLIST: "ভেক্টর লিস্ট",
  T_36_WZY_WS_VECX: "x কম্পোনেন্ট",
  T_36_WZY_WS_VECY: "y কম্পোনেন্ট",
  T_36_WZY_WS_VECZ: "z কম্পোনেন্ট",
  T_36_WZY_WS_VEHENT: "ভেহিক্যাল এনটিটি",
  T_36_WZY_WS_WALLCONT: "ওয়ালেট কন্টেন্ট",
  T_36_WZY_WS_ZOMBIESPERWAVE: "চলমান",
  T_36_XYL_WS_AIBOT: "ইউনিট",
  T_36_XYL_WS_AIGENERATOR: "ইউনিট জেনারেটর",
  T_36_XYL_WS_AIGENERATOR_DESC: "একটি জেনারেটর যা ক্রমাগত মনোনীত ইউনিট তৈরি করতে পারে (যেমন জম্বি)",
  T_36_XYL_WS_AIWAVE: "ওয়েভে # জেনারেটেড ইউনিট",
  T_36_XYL_WS_ARROW: "নির্দেশনা প্রতীক",
  T_36_XYL_WS_ARROW_DESC: "একটি নিশানা, যা কোনো একটি দিকে নির্দেশ করে",
  T_36_XYL_WS_BREAKBOX: "ভঙ্গুর বক্স",
  T_36_XYL_WS_BREAKBOX_DESC: "একটি কাঠের বাক্স যা আক্রমণ করলে ভেঙে যেতে পারে",
  T_36_XYL_WS_FENCE: "লৌহ বেস্টনী",
  T_36_XYL_WS_FENCE_DESC: "এমন একটি বেস্টনী, যা বুলেটকে এর ভেতর দিয়ে উড়ে যেতে দেয়",
  T_36_XYL_WS_STAIRI: "ল্যান্ডিং C",
  T_36_XYL_WS_STAIRI_DESC: "একটি প্ল্যাটফর্ম যা সিঁড়ির সাথে মিলিত হতে পারে",
  T_36_XYL_WS_ZOMBIEAI: "জম্বি",
  T_36_XYL_WS_ZOMBIEAI_DESC: "একটি জম্বি যা কাস্টমাইজ করা যেতে পারে এবং ইউনিট জেনারেটরে একটি প্রাপ্ত এবং নকল বিষয় হতে পারে",
  T_36_YF_CORRODE_GRENADE_N: "গ্লু মেল্টার",
  T_36_YF_SETTING_TYPE3: "প্রিসেট 3",
  T_36_YS_B_BRFOOTBALL_BLUE01: "CBF ওশ্যান জার্সি (বটম)",
  T_36_YS_B_BRFOOTBALL_YELLOW01: "CBF সানশাইন জার্সি (বটম)",
  T_36_YS_F_A_GHOSTHUNTER: "ফিন্ডিশ ফক্সটেইল (মাস্ক)",
  T_36_YS_F_B_GHOSTHUNTER: "ফিন্ডিশ ফক্সটেইল (বটম)",
  T_36_YS_F_H_GHOSTHUNTER: "ফিন্ডিশ ফক্সটেইল (হেড)",
  T_36_YS_F_S_GHOSTHUNTER: "ফ্লেন্ডিশ ফক্সটেইল (জুতা)",
  T_36_YS_SETTING_GRENADE: "থ্রো-এবলস",
  T_36_YS_SETTING_MOVE: "মুভমেন্ট",
  T_36_YS_T_BRFOOTBALL_BLUE01: "CBF ওশান জার্সি (টপ)",
  T_36_YS_T_BRFOOTBALL_YELLOW01: "CBF সানশাইন জার্সি (টপ)",
  T_36_YZY_CHARACTER_GANGGIRL_N: "লুনা",
  T_36_YZY_CHARACTER_YAKUZA_N: "তাতসুয়া",
  T_36_YZY_PET_WOLF_N: "ফ্যাং",
  T_36_YZY_PETSKIN_AXOLOTL_GRIZA_N: "পেট স্কিন: পার্পল জ্যাসিল",
  T_36_YZY_PETSKIN_HAWK_BDK_N: "পেট স্কিন: লাইটনিং ফ্যালকো",
  T_36_YZY_PETSKIN_WOLF_FIRE_N: "পেট স্কিন: লাভা ফ্যাং",
  T_36_YZY_PETSKIN_WOLF_SUGARSKULL22_N: "পেট স্কিন: স্পেক্ট্রাল গাইড",
  T_36_YZY_PETSKIN_WOLF_WINTER_N: "পেট স্কিন: আর্কটিক ফ্যাং",
  T_37_B_WS_HIDE: "হাইড এন্ড সিক",
  T_37_HZ_WS_CATMODEDESC1: "হাইড এন্ড সিক",
  T_37_JH_WS_CREATEGOLD_DESC: "একটি ভেন্ডিং মেশিন যেখানে থেকে প্লেয়াররা আইটেমগুলো কিনতে পারেন। (ক্ল্যাশ স্কোয়াড, টিম ডেথম্যাচ, প্লে-গ্রাউন্ড এবং ড্রয়েড অ্যাপোক্যালিপস মোডে কার্যকর নয়)",
  T_37_JH_WS_NAME1: "FF নাইফ (ড্রয়েড অ্যাপোকেলিপ্স)",
  T_37_JH_WS_NAME10: "M1887-X (ড্রয়েড অ্যাপোকেলিপ্স)",
  T_37_JH_WS_NAME11: "SPAS12 (ড্রয়েড অ্যাপোকেলিপ্স)",
  T_37_JH_WS_NAME12: "M1014 (ড্রয়েড অ্যাপোকেলিপ্স)",
  T_37_JH_WS_NAME13: "MP40 (ড্রয়েড অ্যাপোকেলিপ্স)",
  T_37_JH_WS_NAME14: "MP5-III (ড্রয়েড অ্যাপোকেলিপ্স)",
  T_37_JH_WS_NAME15: "P90 (ড্রয়েড অ্যাপোক্যালিপ্স)",
  T_37_JH_WS_NAME16: "M60-III (ড্রয়েড অ্যাপোকেলিপ্স)",
  T_37_JH_WS_NAME17: "থম্পসন (ড্রয়েড অ্যাপোকেলিপ্স)",
  T_37_JH_WS_NAME18: "UMP (ড্রয়েড অ্যাপোকেলিপ্স)",
  T_37_JH_WS_NAME19: "SVD (ড্রয়েড অ্যাপোকেলিপ্স)",
  T_37_JH_WS_NAME2: "গ্রোজা (ড্রয়েড অ্যাপোকেলিপ্স)",
  T_37_JH_WS_NAME20: "AWM (ড্রয়েড অ্যাপোকেলিপ্স)",
  T_37_JH_WS_NAME21: "M82B (ড্রয়েড অ্যাপোকেলিপ্স)",
  T_37_JH_WS_NAME22: "M249-X (ড্রয়েড অ্যাপোকেলিপ্স)",
  T_37_JH_WS_NAME23: "Kar98k-III (ড্রয়েড অ্যাপোকেলিপ্স)",
  T_37_JH_WS_NAME3: "AK47 (ড্রয়েড অ্যাপোকেলিপ্স)",
  T_37_JH_WS_NAME4: "M4A1-III (ড্রয়েড অ্যাপোকেলিপ্স)",
  T_37_JH_WS_NAME5: "SCAR (ড্রয়েড অ্যাপোক্যালিপস)",
  T_37_JH_WS_NAME6: "M14-III (ড্রয়েড অ্যাপোকেলিপস)",
  T_37_JH_WS_NAME7: "প্যারাফল (ড্রয়েড অ্যাপোকেলিপ্স)",
  T_37_JH_WS_NAME8: "XM8 (ড্রয়েড অ্যাপোকেলিপ্স)",
  T_37_JH_WS_NAME9: "MAG-7 (ড্রয়েড অ্যাপোকেলিপ্স)",
  T_37_JH_WS_VENDMACHINE_DESC: "ম্যাপের চারপাশে তোলা যেতে পারে এমন গোল্ড। (ক্ল্যাশ স্কোয়াড, টিম ডেথ-ম্যাচ, প্লে-গ্রাউন্ড এবং ড্রয়েড অ্যাপোক্যালিপস মোডে কার্যকর নয়)",
  T_37_JH_WS_X: "X অক্ষ",
  T_37_JH_WS_Y: "Y অক্ষ",
  T_37_JH_WS_Z: "Z অক্ষ",
  T_37_JL_FOOTBALL_TIE: "টাই",
  T_37_JL_GOLD_M1014_I_N: "M1014-I",
  T_37_JL_GOLD_M1014_II_N: "M1014-II",
  T_37_JL_GOLD_M1014_III_N: "M1014-III",
  T_37_JL_M1216_N: "ট্রোগন",
  T_37_KK_WS_SNOWMAN: "ওয়েগর স্নোম্যান",
  T_37_LC_BP_ENTRANCE_GIFT: "গিফট!",
  T_37_M_WS_MISSING: "মিসিং সোর্স",
  T_37_M_WS_NAMEERROR: "সংবেদনশীল ক্যারেক্টার রয়েছে। পরিবর্তন করুন।",
  T_37_PD_HuntingGround_BOSSTITLE: "কসাই",
  T_37_QL_JUMPPAD_DES: "মাটিতে একটি জাম্প প্যাড তৈরি করে। এটি বাতাসে উচ্চ লাফ দিতে ব্যবহার করা যেতে পারে এবং এয়ার ফায়ারিং সক্ষম করে।",
  T_37_QL_JUMPPAD_NAME: "ট্রেম্পোলিন",
  T_37_R_TAILOR_LIMIT: "লিমিটেড টাইম",
  T_37_RW_LOADOUT_BORNFIRETAG: "ম্যাচের শুরুতে 2টি বনফায়ার পান। বনফায়ার [FFBA00]প্রতি সেকেন্ডে 5 HP এবং 20 EP রিজেনারেট করে[-] (10 সেকেন্ড পর্যন্ত) এলাকার মধ্যে আপনার এবং আপনার টিমমেটদের জন্য। বনফায়ার প্রভাব স্ট্যাক করে না।",
  T_37_RW_PROPCATAPULT_DESC: "যখন স্ফীত হয়, লঞ্চ প্যাডটি একজন প্লেয়ারকে বাতাসে প্রজেক্ট করতে ব্যবহার করা যেতে পারে। তবে সেফ জোনে থাকতে ভুলবেন না!",
  T_37_RW_PROPCATAPULT_NAME: "লঞ্চ প্যাড",
  T_37_SP_WS_COLOR_02: "রঙ",
  T_37_SP_WS_COLOR_03: "আবির্ভাব",
  T_37_SP_WS_LOG_ENTITY_IS_EMPTY: "অর্জন করার সময় বা এর প্রপার্টি সেটিং করার সময় এই এনটিটি খালি থাকে",
  T_37_SP_WS_LOG_PHASE_END: "স্টেজ {0} সমাপ্ত।",
  T_37_SP_WS_LOG_PHASE_START: "স্টেজ {0} শুরু হচ্ছে",
  T_37_SP_WS_LOG_ROUND_END: "রাউন্ড {0} সমাপ্ত।",
  T_37_SP_WS_LOG_ROUND_START: "রাউন্ড {0} শুরু হয়েছে।",
  T_37_SP_WS_LOG_VAR_ASSIGNMENT_OPERATOR_MISMATCH: "ভেরিয়েবলে একটি মান নির্ধারণ করার সময় মিসম্যাচ হওয়া টাইপ। প্রয়োজনীয় টাইপ: {0}। বর্তমান টাইপ: {1}।",
  T_37_SP_WS_LOG_VAR_UNDEFINED_OR_OUT_OF_SCOPE: "ডিফাইনকৃত নয় অথবা আউট-অফ-স্কোপ লোকাক ভেরিয়েবল {0}",
  T_37_SP_WS_MAPACCESS_08: "এডিট",
  T_37_SP_WS_RACEMODE_01: "কাউন্টডাউন মোড",
  T_37_SP_WS_RACEMODE_02: "কাউন্টডাউন্ট টাইম",
  T_37_SP_WS_RACEMODE_04: "যখন চালু হবে, একটি কাউন্টডাউন হবে যখন একটি সম্পূর্ণ টিম সমাপ্তির পয়েন্টে পৌঁছাবে। কাউন্টডাউন শেষ হলে গেম শেষ হয়।",
  T_37_SY_AR15_KABUKI_N: "কিংফিশার- সং অফ হানা",
  T_37_SY_BACKPACK_STRAW_N: "স্ট্র হ্যাট ব্যাকপ্যাক",
  T_37_SY_GRENADE_FFWS2022_01_N: "গ্রেনেড- নেভি স্টারসী",
  T_37_SY_GROUPANIM_BLACKHOLE_N: "ব্ল্যাক হোল",
  T_37_SY_M1216_MAMBAS_N: "ট্রোগন- মাম্বা ন্যাও",
  T_37_SY_PET_FLYINGCREATURE_N: "অ্যাভ্রন",
  T_37_SY_PETSKIN_DUCK_WINTERFEST22_N: "পেট স্কিন: গ্ল্যামার বিনি",
  T_37_SY_PETSKIN_FLYINGCREATURE_BLUE_N: "পেট স্কিন: অ্যাশ অ্যাভ্রন",
  T_37_SY_PETSKIN_FLYINGCREATURE_ORANGE_N: "পেট স্কিন: গ্যালাক্সি অ্যাভরন",
  T_37_SY_PETSKIN_FLYINGCREATURE_PURPLE_N: "পেট স্কিন: ফায়ারমিথ আরভন",
  T_37_SY_PETSKIN_TORTOISE_SOCCER22_N: "পেট স্কিন: ফুটি ফ্ল্যাশ",
  T_37_SY_PETSKIN_YETI_NEWYEAR22_N: "পেট স্কিন: উইন্টারল্যান্ডস ইয়েতি",
  T_37_SY_VEHICLE_JEEP_WINTERFEST22_N: "জিপ- রকিং' ফেস্টিভাল রাইড",
  T_37_SY_VEHICLE_SUV_FFWS2022_N: "পিকআপ ট্রাক- স্টারসী বীস্ট",
  T_37_WT_WS_PVE2DESC: `একটি জোম্বি সার্ভাইভাল মোড, যেখানে প্লেয়াররা নির্দিষ্ট সময়সীমার মধ্যে একটি নির্দিষ্ট সংখ্যক জোম্বিকে এলিমিনেট করে অথবা শেষ পর্যন্ত সার্ভাইভ করে বিজয়ী হয়।
আপনি ইচ্ছেমতো গেমপ্লের রুলস সেট করতে এবং জোম্বিদের সেটিংস অ্যাডজাস্ট করতে পারবেন, যার মধ্যে কতগুলো জোম্বি  এলিমিনেট করতে হবে তাও নির্ধারণ করা।`,
  T_37_WT_WS_RULEDESC: "জয়ের জন্য টার্গেট সংখতক জোম্বিদের এলিমিনেট করুন।",
  T_37_WT_WS_RULETITLE: "গোল",
  T_37_WT_WS_TXT1: "জোম্বি এলিমিনেট করুন",
  T_37_WT_WS_TXT1DESC: "যখন চালু থাকে, প্লেয়াররা নির্দিষ্ট সংখ্যক জম্বিগুলিকে এলিমিনেট করে বিজয়ী হয়। বন্ধ থাকলে, প্লেয়াররা শেষ অবধি সার্ভাইভ করার মাধ্যমে বিজয়ী হয়।",
  T_37_WT_WS_TXT2: "এলিমিনেশন অ্যামাউন্ট",
  T_37_WZY_FRIDPLA: "ফ্রেন্ডলি প্লেয়ার",
  T_37_WZY_FRIDSIDE: "ফ্রেন্ডলি ফ্যাকশন",
  T_37_WZY_FRIDTEAM: "ফ্রেন্ডলি টিম",
  T_37_WZY_HOSTPLA: "এনিমি প্লেয়ার",
  T_37_WZY_HOSTSIDE: "এনিমি ফ্যাকশন",
  T_37_WZY_WS_ACCFRAMES: "সমন্বিত ফ্রেমসমুহ",
  T_37_WZY_WS_ADDITEMTOPROD_NAMEDESC: "আইটেমগুলো মার্চেন্ডাইজে যোগ করুন। আপনি একটি একক আইটেম বা আইটেমের গ্রুপ যোগ করতে পারেন। পরিমাণটি পৃথক পৃথকভাবে আইটেম সংখ্যা বা এই পরিমাণের আইটেম নিয়ে গঠিত একটি তালিকাও হতে পারে।",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM1_DESC: "আইটেম যোগ করার জন্য মার্চেন্ডাইজ এনটিটি",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM2_DESC: "যেসব আইটেম যোগ করতে হবে। আপনি একটি সিঙ্গেল আইটেম বা আইটেমের গ্রুপ যোগ করতে পারবেন।",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM3_DESC: "যোগ করার জন্য পৃথক আইটেমের পরিমাণ বা এই পরিমাণের আইটেমগুলি নিয়ে গঠিত একটি তালিকা।",
  T_37_WZY_WS_ADDLABEL_NAMEDESC: "নির্বাচিত এনটিটির জন্য একটি ট্যাগ যোগ করুন",
  T_37_WZY_WS_ADDLABEL_PARAM1_DESC: "যে এন্টিটিতে ট্যাগ যোগ করতে হবে",
  T_37_WZY_WS_ADDLABEL_PARAM2_DESC: "যেই টেক্সট কন্টেন্ট যোগ করতে হবে",
  T_37_WZY_WS_AIMABLEENT: "এইম-অ্যাবল এনটিটি",
  T_37_WZY_WS_AIMASSISTTYPE: "এইম অ্যাসিস্ট টাইপ",
  T_37_WZY_WS_ALLOWDROP_NAME: "আইটেম ড্রপ এনাবল/ডিজেবল করুন",
  T_37_WZY_WS_ALLOWDROP_NAMEDESC: "কোনো প্লেয়ার আইটেম ড্রপ করতে পারবে কী না",
  T_37_WZY_WS_ALLOWDROP_PARAM1_DESC: "আইটেম ড্রপ করতে হবে কিনা তা কনফিগার করার জন্য প্লেয়ার এনটিটি",
  T_37_WZY_WS_ALLOWDROP_PARAM2_DESC: "একজন খেলোয়াড় আইটেম ড্রপ করতে পারবে কিনা। এটি বুলিয়ান মান।",
  T_37_WZY_WS_ALLOWPICKUP_NAME: "এনাবল/ডিজেবল আইটেম পিক-আপ",
  T_37_WZY_WS_ALLOWPICKUP_NAMEDESC: "একজন প্লেয়ার পিক-আপ করতে পারবেন কি না",
  T_37_WZY_WS_ALLOWPICKUP_PARAM1_DESC: "আইটেম বাছাই করা হবে কিনা তা কনফিগার করার জন্য প্লেয়ার এনটিটি",
  T_37_WZY_WS_ALLOWPICKUP_PARAM2_DESC: "কোনো প্লেয়ার আইটেম তুলতে পারে কিনা। এটি বুলিয়ান মান।",
  T_37_WZY_WS_AMBIENTCOLOR: "বাতাবরণ হালকা রঙ",
  T_37_WZY_WS_AMRORTOOL: "আর্মর মেরামত করুন",
  T_37_WZY_WS_ATTACK: "অ্যাটাক",
  T_37_WZY_WS_BACKTONOR_NAMEDESC: "প্লেয়ারের ছদ্মবেশ বাতিল করুন যাতে তারা তাদের স্বাভাবিক চেহারায় ফিরে আসে",
  T_37_WZY_WS_BACKTONOR_PARAM1_DESC: "প্লেয়ার এনটিটি যার ছদ্মবেশ বাতিল করতে হবে",
  T_37_WZY_WS_BALLADDV_NAMEDES: "একটি ফুটবলের স্পিড বুস্ট করুন",
  T_37_WZY_WS_BALLADDV_PARAM1_DESC: "যে ফুটবলের জন্য স্পিড বুস্ট করা হবে",
  T_37_WZY_WS_BALLADDV_PARAM2_DESC: "বুস্টের স্পিড ফ্যাক্টর",
  T_37_WZY_WS_BALLKICKED_NAMEDESC: "ট্রিগার করে যখন ফুটবল শুটার ফুটবলে আঘাত করে। [প্লেয়ার এনটিটি] হলো সেই প্লেয়ার, যিনি ফুটবল শুটারের মালিক। [স্পিড বুস্ট] হলো আঘাতের পর ফুটবলের যোগ করা স্পিড।",
  T_37_WZY_WS_BALLKICKED_PARAM1_DESC: "যে প্লেয়ার ফুটবল শুটারের অধিকারী",
  T_37_WZY_WS_BALLKICKED_PARAM2_DESC: "আঘাত লাগার পর ফুটবলের স্পিড ভেক্টর",
  T_37_WZY_WS_BALLKNOCKED_NAMEDESC: "যখন ফুটবল কোন সত্তার সাথে সংঘর্ষ হয় এবং বলের গতি বৃদ্ধি পায়, তখন ট্রিগার হয়। [Colliding entity] হল সেই সত্তা যেটা ফুটবলের সাথে সংঘর্ষ হয়। [Speed boost] হল সংঘর্ষের পর ফুটবলের যোগ করা গতি।",
  T_37_WZY_WS_BALLKNOCKED_PARAM1_DESC: "ফুটবলের সাথে যেই এনটিটি সংঘর্ষ করে",
  T_37_WZY_WS_BALLKNOCKED_PARAM2_DESC: "সংঘর্ষের সময় ফুটবলে যে স্পিড ভেক্টর যোগ করা হয়",
  T_37_WZY_WS_BEAIMED_NAMEDESC: "কোনো প্লেয়ার দ্বারা এনটিটিকে এইম করা হলে ট্রিগার করে",
  T_37_WZY_WS_BEAIMED_PARAM1_DESC: "যেই প্লেয়ার ঐ এনটিটির দিকে এইম করছে",
  T_37_WZY_WS_BEHAVIORSTAT: "প্লেয়ারের আচরণ স্ট্যাটাস",
  T_37_WZY_WS_BEHIT_PARAM1_DESC: "যে ওয়েপন এনটিটি এই এনটিটিকে আঘাত করে",
  T_37_WZY_WS_BLOODBARENT: "হেলথ বার এনটিটি",
  T_37_WZY_WS_BOMBEND: "বিস্ফোরণের আগে",
  T_37_WZY_WS_BOMBSTART: "বোম্ব নির্দেশক",
  T_37_WZY_WS_CHANENT: "চ্যানেল এনটিটি",
  T_37_WZY_WS_CHEER: "চিয়ার",
  T_37_WZY_WS_CHELABEL_NAMEDESC: "একটি নির্বাচিত এনটিটি মনোনীত ট্যাগ আছে কিনা পরীক্ষা করুন",
  T_37_WZY_WS_CHELABEL_PARAM1_DESC: "ট্যাগ আছে কিনা তা পরীক্ষা করার জন্য এনটিটি",
  T_37_WZY_WS_CHELABEL_PARAM2_DESC: "যে ট্যাগ যাচাই করতে হবে",
  T_37_WZY_WS_CHELABELRES: "ট্যাগ চেক ফলাফল। এটি একটি বুলিয়ান মান।",
  T_37_WZY_WS_CJERSEY_NAME: "জার্সি বদলান",
  T_37_WZY_WS_CJERSEY_PARAM1_DESC: "যেই প্লেয়ারের জার্সি পরিবর্তন করতে হবে",
  T_37_WZY_WS_CJERSEY_PARAM2: "জার্সি ডিজাইন",
  T_37_WZY_WS_CJERSEY_PARAM2_DESC: "যেই ডিজাইনটি চেঞ্জ করতে হবে",
  T_37_WZY_WS_CJERSEY_PARAM3_DESC: "জার্সিতে থাকা পার্ট 1 এর রঙ",
  T_37_WZY_WS_CJERSEY_PARAM4_DESC: "জার্সিতে থাকা পার্ট 2 এর রঙ",
  T_37_WZY_WS_CJERSEY_PARAM5_DESC: "জার্সিতে থাকা পার্ট 3 এর রঙ",
  T_37_WZY_WS_CJERSEYTYPE1: "ডিজাইন 1",
  T_37_WZY_WS_CJERSEYTYPE2: "ডিজাইন 2",
  T_37_WZY_WS_CJERSEYTYPE3: "ডিজাইন 3",
  T_37_WZY_WS_CLEAR_ARR_DESC: "লিস্টে থাকা সকল ইলিমেন্ট ক্লিয়ার করুন",
  T_37_WZY_WS_CREABLEOB_DESC: "অবজেক্টের ধরন যা ব্লক ব্যবহার করে তৈরি করা যায়",
  T_37_WZY_WS_CREPROD_NAMEDESC: "একটি কাস্টমাইজযোগ্য মার্চেন্ডাইজ তৈরি করুন এবং একটি মার্চেন্ডাইজ এনটিটি ফেরত দিন৷ মার্চেন্ডাইজ কন্টেন্ট সেটিংসের মাধ্যমে কনফিগার করা যেতে পারে।",
  T_37_WZY_WS_CRESHELVES_NAMEDESC: "একটি কাস্টমাইজযোগ্য মার্চেন্ডাইজ লিস্ট তৈরি করুন এবং একটি মার্চেন্ডাইজ লিস্ট এনটিটি রিটার্ন করুন৷ এই লিস্টের   কন্টেন্টগুলো প্রপার্টি সেটিংসের মাধ্যমে পরিবর্তন করা যেতে পারে।",
  T_37_WZY_WS_CRESHELVES_PARAM1_DESC: "যে মার্চেন্ডাইজ লিস্ট এন্টিটি তৈরি করা হবে",
  T_37_WZY_WS_CRESIDE_NAMEDESC: "একটি ফ্যাকশন এনটিটি",
  T_37_WZY_WS_CRESIDE_PARAM1_DESC: "যেই ফ্যাকশন এনটিটি তৈরি করতে হবে",
  T_37_WZY_WS_CRESTORE_NAMEDESC: "একটি কাস্টমাইজযোগ্য স্টোর তৈরি করুন এবং একটি স্টোর এনটিটি ফেরত দিন। স্টোরের কন্টেন্ট প্রপার্টি সেটিংসের মাধ্যমে পরিবর্তন করা যেতে পারে।",
  T_37_WZY_WS_CRESTORE_PARAM2_DESC: "তৈরিকৃত স্টোর এনটিটি",
  T_37_WZY_WS_CSKYBOX_NAMEDESC: "খেলায় আকাশের পরিবেশ পরিবর্তন করুন। অপশনগুলোর মধ্যে দিন, সন্ধ্যা এবং রাত অন্তর্ভুক্ত।",
  T_37_WZY_WS_CSKYBOX_PARAM1_DESC: "যে আকাশের ধরন পরিবর্তন করতে হবে। অপশনের মধ্যে দিন, সন্ধ্যা এবং রাত অন্তর্ভুক্ত।",
  T_37_WZY_WS_DARKNESS: "সর্বোপরি ডার্কনেস",
  T_37_WZY_WS_DELENT_NAMEDESC: "একটি মনোনীত এনটিটিকে ডিলিট করুন। বর্তমানে আইকন এনটিটি, টেক্সট এনটিটি, HUD এনটিটি, ভিজ্যুয়াল এফেক্ট এনটিটি, ওয়েপন এনটিটি এবং অন্যান্য অবজেক্ট এনটিটি সাপোর্ট করে।",
  T_37_WZY_WS_DELENT_PARAM1_DESC: "যেই এনটিটি ডিলিট করতে হবে",
  T_37_WZY_WS_DROP: "ভুল",
  T_37_WZY_WS_DROPITEMS_NAMEDESC: "প্লেয়ার যখন একটি আইটেম ড্রপ করে তখন ট্রিগার করে। [Item type] হলো, যেসব আইটেম টাইপ বাদ দেওয়া হয়।",
  T_37_WZY_WS_DROPITEMS_PARAM1_DESC: "বাদ দেওয়া আইটেমের টাইপ ID",
  T_37_WZY_WS_DROPWEAP_NAMEDESC: "প্লেয়ার কোনো ওয়েপন ড্রপ করে তখন ট্রিগার করে। [Weapon entity] হলো যে ওয়েপনটি ড্রপ করা হচ্ছে।",
  T_37_WZY_WS_DROPWEAP_PARAM1_DESC: "যে ওয়েপনটি ড্রপ করা হয়েছে",
  T_37_WZY_WS_DUMMYLEOBJ: "রেগুলার স্টেইজ অবজেক্ট",
  T_37_WZY_WS_DUST: "সন্ধ্যা",
  T_37_WZY_WS_EMPTYCH: "ডিফল্ট শূন্য চ্যানেল",
  T_37_WZY_WS_EMPTYCH1: "খালি চ্যানেল 1",
  T_37_WZY_WS_EMPTYCH2: "খালি চ্যানেল 2",
  T_37_WZY_WS_EMPTYCH3: "খালি চ্যানেল 3",
  T_37_WZY_WS_EMPTYCH4: "খালি চ্যানেল 4",
  T_37_WZY_WS_EMPTYCH5: "খালি চ্যানেল 5",
  T_37_WZY_WS_EMPTYCH6: "খালি চ্যানেল 6",
  T_37_WZY_WS_ENTFILTER_NAMEDESC: '3টি শর্ত পূরণ করে এমন সমস্ত এনটিটি রয়েছে এমন একটি তালিকা পান। "সবগুলো অন্তর্ভুক্ত", "বাদ" এবং "অন্তর্ভুক্ত" একটি সিঙ্গেল কম্পোনেন্ট টাইপ বা কম্পোনেন্ট টাইপের তালিকা। এর রিটার্ন ভ্যাল্যু হলো এনটিটির এমন একটি তালিকা যা শর্তগুলো পূরণ করে।',
  T_37_WZY_WS_ENTFILTER_PARAM1_DESC: "ফিল্টার-আউট করা সত্তাগুলিতে অবশ্যই এই অ্যারে থেকে সমস্ত উপাদান থাকতে হবে৷",
  T_37_WZY_WS_ENTFILTER_PARAM2_DESC: "ফিল্টার আউট করা এনটিটিগুলোতে এই অ্যারে থেকে মনোনীত উপাদান থাকা উচিত নয়৷",
  T_37_WZY_WS_ENTFILTER_PARAM3_DESC: "ফিল্টার আউট করা এনটিটিগুলিতে এই অ্যারে থেকে কমপক্ষে একটি উপাদান থাকতে হবে৷",
  T_37_WZY_WS_ENTITY2_PARAM3_DESC: "এই এনটিটির প্রপার্টি টাইপ পরিবর্তন করতে হবে",
  T_37_WZY_WS_ENTITY2_PARAM4_DESC: "প্রপার্টি ভ্যালু যে পর্যন্ত বদলাতে হবে",
  T_37_WZY_WS_EXITCHAN_NAMEDESC: "প্লেয়ারকে বর্তমান চ্যানেল ছেড়ে যেতে দিন যাতে তারা কোনও চ্যানেলে না থাকে",
  T_37_WZY_WS_EXITCHAN_PARAM1_DESC: "যে প্লেয়ার এই চ্যানেলটি ত্যাগ করবে",
  T_37_WZY_WS_FAKEENT: "ডিসগাইজ এনটিটি",
  T_37_WZY_WS_FIND_STR_DESC: "একটি স্ট্রিং এর মধ্যে একটি মনোনীত টেক্সটের অবস্থান খুঁজুন",
  T_37_WZY_WS_FINDSTR_PARAM1DESC: "যেই ক্যারেক্টারটি খুঁজতে হবে",
  T_37_WZY_WS_FINDSTR_PARAM2DESC: "প্রারম্ভিক অবস্থান থেকে একটি স্ট্রিং খুঁজুন, যা 0 থেকে শুরু হয়।",
  T_37_WZY_WS_FINDSTRRES: "স্ট্রিং প্রদর্শিত প্রথম অবস্থান. 0 থেকে শুরু হয়।",
  T_37_WZY_WS_FOGCOLOR: "ফগ কালার",
  T_37_WZY_WS_FRICTIONCON: "রেগুলার ফ্রিকশন মাল্টিপ্লায়ার",
  T_37_WZY_WS_FRICTIONIMP: "সংঘর্ষের ফ্রিকশন মাল্টিপ্লায়ার",
  T_37_WZY_WS_FROMDEATH: "রিইভাইভাল",
  T_37_WZY_WS_FROMKNODOWN: "হেল্প-আপ",
  T_37_WZY_WS_GETCHAN_NAMEDESC: "নির্দেশিত প্লেয়ার যে চ্যানেলে অবস্থান করছে, সেটি অর্জন করুন",
  T_37_WZY_WS_GETCHAN_PARAM1_DESC: "প্লেয়ার এনটিটি, যার চ্যানেলটিকে অর্জন করতে হবে",
  T_37_WZY_WS_GETCHANRES: "প্লেয়ারটি বর্তমানে যেই চ্যানেলে অবস্থান করছেন",
  T_37_WZY_WS_GETEMPTYCH_NAMEDES: "চ্যানেল আইডি 1 থেকে 8 অনুযায়ী, খেলার শুরুতে ডিফল্টরূপে তৈরি করা খালি চ্যানেলটি পান",
  T_37_WZY_WS_GETEMPTYCH_PARAM1_DESC: "ডিফল্ট খালি চ্যানেলের ID",
  T_37_WZY_WS_GETEMPTYCH_RES: "অর্জনকৃত চ্যানেল এনটিটি",
  T_37_WZY_WS_GETFAKEENT_NAMEDESC: "একজন প্লেয়ারের ডিসগাইজ এনটিটি অর্জন করুন।",
  T_37_WZY_WS_GETFAKEENT_PARAM1_DESC: "যে অবজেক্টের ডিসগাইজ এনটিটি অর্জন করতে হবে",
  T_37_WZY_WS_GETGAMEENT_NAME: "গ্লোবাল হোন",
  T_37_WZY_WS_GETGAMEENT_NAMEDESC: "এই ম্যাচের গেম এনটিটি অর্জন করুন",
  T_37_WZY_WS_GETHOSTPLA_NAME: "আক্রমণযোগ্য প্লেয়ার অর্জন করুন",
  T_37_WZY_WS_GETHOSTSIDE_PARAM1: "ফ্যাকশন এনটিটি",
  T_37_WZY_WS_GOAL_NAMEDESC: "কোনো ফুটবল গোলে প্রবেশ করলে ট্রিগার হয়। [Goal] হলো এই ফুটবল যে গোলে প্রবেশ করে। [Scorer] হলো  শেষ খেলোয়াড় যিনি বলের সংস্পর্শে এসেছেন। [Assist] হলো দ্বিতীয় থেকে শেষ খেলোয়াড় যিনি বলের সংস্পর্শে এসেছেন।",
  T_37_WZY_WS_GOAL_PARAM1_DESC: "যে গোলে এই ফুটবল প্রবেশ করে",
  T_37_WZY_WS_GOAL_PARAM2_DESC: "বলের সংস্পর্শে আসা শেষ খেলোয়াড়",
  T_37_WZY_WS_GOAL_PARAM3_DESC: "দ্বিতীয় থেকে শেষ খেলোয়াড় বলের সংস্পর্শে এসেছেন",
  T_37_WZY_WS_HEARTBEAT: "হার্টবীট",
  T_37_WZY_WS_HEAVYWEAPON: "হেভি ওয়েপন",
  T_37_WZY_WS_HIHGSHOOTANGLE: "ক্ষুদ্রতম ভলি এঙ্গেল",
  T_37_WZY_WS_HOSTPLA: "অ্যাটাকযোগ্য প্লেয়ারদের তালিকা",
  T_37_WZY_WS_HOSTSIDE: "আক্রমণযোগ্য ফ্যাকশনগুলোর একটি লিস্ট",
  T_37_WZY_WS_HOSTTEAM: "আক্রমণযোগ্য টিমগুলোর একটা লিস্ট",
  T_37_WZY_WS_ICON_CLOCK: "কাউন্টডাউন",
  T_37_WZY_WS_ICON_CLOTHES: "পোশাকসমূহ",
  T_37_WZY_WS_ICON_QUIT: "প্রস্থান",
  T_37_WZY_WS_INSERT_ARR_DESC: "তালিকার একটি নির্দিষ্ট স্থানে একটি নতুন উপাদান ইনসার্ট করুন",
  T_37_WZY_WS_INTERCEPT_STR_DESC: "ইনডেক্স লোকেশন থেকে শুরু করে একটি নির্দিষ্ট দৈর্ঘ্যের একটি স্ট্রিং বের করুন। নিষ্কাশন দৈর্ঘ্য স্ট্রিং দৈর্ঘ্য অতিক্রম করলে, এটি স্ট্রিংটির শেষ পর্যন্ত কন্টেন্ট নিষ্কাশন করবে।",
  T_37_WZY_WS_INTERCEPTSTR_PARAM1DESC: "নিষ্কাশন দৈর্ঘ্য",
  T_37_WZY_WS_INTERCEPTSTRRES_DESC: "যে স্ট্রিংটি বের করা হয়েছিল",
  T_37_WZY_WS_INTORINTL: "ইন্টিজার বা ইন্টিজার লিস্ট",
  T_37_WZY_WS_JOINSIDE_NAMEDESC: "একজন খেলোয়াড়কে একটি মনোনীত দলে যোগ দিতে দিন",
  T_37_WZY_WS_JOINSIDE_PARAM2_DESC: "প্লেয়ার যেই ফ্যাকশনে যোগ দেবে",
  T_37_WZY_WS_JUMP: "জাম্প",
  T_37_WZY_WS_LABEL: "ট্যাগ",
  T_37_WZY_WS_LENSFLARE: "লেন্স ফ্লেয়ার",
  T_37_WZY_WS_LENTH: "দৈর্ঘ্য",
  T_37_WZY_WS_LIGHTATTACK: "সফল হিট",
  T_37_WZY_WS_LIGHTCOLOR: "আলোক উৎসের রঙ",
  T_37_WZY_WS_LIGHTINTENSITY: "আলোক উৎসের উজ্জ্বলতা",
  T_37_WZY_WS_LOADSCENE_NAMEDESC: "নতুন একটি সিনারি লোড করুন",
  T_37_WZY_WS_LOADSCENE_PARAM1_DESC: "যেই দৃশ্যটা লোড করতে হবে",
  T_37_WZY_WS_MOROBJECT: "ছদ্মবেশী অবজেক্ট",
  T_37_WZY_WS_MOVEAXISX: "x অক্ষ ধরে মুভ করছে",
  T_37_WZY_WS_MOVEAXISY: "y অক্ষ ধরে মুভ করুন",
  T_37_WZY_WS_MOVEAXISZ: "z অক্ষ বরাবর সরান",
  T_37_WZY_WS_MOVEDISTITLE: "মুভমেন্টের দুরত্ব",
  T_37_WZY_WS_MUTEQUICKCHAT_NAME: "কুইক মেসেজ অন/অফ টোগোল",
  T_37_WZY_WS_MUTEQUICKCHAT_NAMEDESC: "কুইক মেসেজ চালু বা বন্ধ করুন। বন্ধ থাকলে, কুইক মেসেজ HUD ব্যবহার করা যাবে না এবং খেলোয়াড়রা কুইক মেসেজ পাঠাতে বা গ্রহণ করতে সক্ষম হবে না।",
  T_37_WZY_WS_MUTEQUICKCHAT_PARAM1_DESC: "যেই প্লেয়ারের জন্য কুইক মেসেজ চালু/বন্ধ করতে হবে",
  T_37_WZY_WS_MUTEVOICE_NAME: "ভয়েস চ্যাট অন/অফ টোগোল",
  T_37_WZY_WS_MUTEVOICE_NAMEDESC: "ভয়েস চ্যাট চালু বা বন্ধ করুন। বন্ধ থাকা অবস্থায় ভয়েস HUD ব্যবহার করা যাবে না এবং প্লেয়াররা ভয়েস বার্তা পাঠাতে বা গ্রহণ করতে পারবে না।",
  T_37_WZY_WS_MUTEVOICE_PARAM1_DESC: "যে প্লেয়ারের জন্য ভয়েস চ্যাট চালু/বন্ধ করতে হবে",
  T_37_WZY_WS_MUTEVOICE_PARAM2_DESC: "বুলিয়ান। সত্য মানে অফ; মিথ্যা মানে অন।",
  T_37_WZY_WS_NIGHTMODE: "নাইট মোড",
  T_37_WZY_WS_ONAIM_NAMEDESC: "ট্রিগার হয় যখন প্লেয়ার একটি এইম-অ্যাবল এনটিটিকে এইম করে। [টার্গেট এনটিটি] হল যেই এনটিটিকে এইম করা হচ্ছে। যখন কোন এনটিটি এইম করা হচ্ছে না, রিটার্ন মান শূন্য।",
  T_37_WZY_WS_ONAIM_PARAM1_NAME: "লক্ষ্য এনটিটি",
  T_37_WZY_WS_ONHIT_PARAM1_DESC: "ওয়েপনটি যেই এনটিটিকে আঘাত করেছে",
  T_37_WZY_WS_ONSCENELOADING_NAMEDESC: "সিনারি সফলভাবে লোড হলে ট্রিগার করে",
  T_37_WZY_WS_ONSCENELOADING_PARAM1_DESC: "লোড করার দৃশ্যের নাম। এটি একটি স্ট্রিং।",
  T_37_WZY_WS_ONSCENESWITCH_NAMEDESC: "দৃশ্যাবলী সফলভাবে পরিবর্তন হলে ট্রিগার হয়",
  T_37_WZY_WS_ONSCENESWITCH_PARAM1_DESC: "নতুন দৃশ্যের নাম। এটি একটি স্ট্রিং।",
  T_37_WZY_WS_OUTJERSEY_NAMEDESC: "প্লেয়ারের পোশাককে তার ডিফল্ট চেহারায় ফিরিয়ে আনুন",
  T_37_WZY_WS_OUTJERSEY_PARAM1_DESC: "প্লেয়ার যার ডিফল্ট পোশাক পুনরুদ্ধার করতে হবে",
  T_37_WZY_WS_PETSET: "পেট সেটিং",
  T_37_WZY_WS_PETSKILL: "পেট স্কিলস",
  T_37_WZY_WS_PETSWITCH2: "পেট স্কিল ব্যবহার করা যাবে কীনা",
  T_37_WZY_WS_PLAMOVE_PARAM2_DESC: "প্লেয়ার মুভমেন্ট সক্ষম কিনা। এটি একটি বুলিয়ান মান।",
  T_37_WZY_WS_PLAYERBEHAVIOR: "প্লেয়ারের আচরণের ধরণ",
  T_37_WZY_WS_PRESS: "জেন্টল ক্লিক",
  T_37_WZY_WS_PROGRESS: "বর্তমান অগ্রগতি",
  T_37_WZY_WS_PROGRESSBAR: "প্রগ্রেস HUD এনটিটি",
  T_37_WZY_WS_RANKDOWN: "র‍্যাংক ডাউন",
  T_37_WZY_WS_REMLABEL_NAMEDESC: "সিলেক্টকৃত এনটিটি থেকে একটি ট্যাগ রিমুভ করুন",
  T_37_WZY_WS_REMLABEL_PARAM1_DESC: "যে টেক্সট কন্টেন্ট রিমুভ করতে হবে",
  T_37_WZY_WS_REPLACE_STR_DESC: "একটি নির্দিষ্ট কন্টেন্ট দিয়ে একটি স্ট্রিং এর কন্টেন্ট প্রতিস্থাপন করুন",
  T_37_WZY_WS_REPLACESTR_PARAM1DESC: "যেই ক্যারেক্টারটি রিপ্লেস করা হবে",
  T_37_WZY_WS_REPLACESTR_PARAM2DESC: "নতুন যে ক্যারেক্টারটি রিপ্লেস করা হবে",
  T_37_WZY_WS_REVERSE_ARR_DESC: "এই লিস্টে থাকা সবগুলো ইলিমেন্ট রিভার্স করুন",
  T_37_WZY_WS_REVIVEHERE: "এই রিভাইভাল পয়েন্টে যেই প্লেয়ার তার টিমমেটদেরকে রিভাইভ করছে",
  T_37_WZY_WS_REVIVEHERE_NAMEDESC: "এই রিভাইভাল পয়েন্টে কোনো প্লেয়ার যখন কাউকে রিভাইভ করে তখন ট্রিগার করে",
  T_37_WZY_WS_REVIVEWAYDESC: "যে পদ্ধতির মাধ্যমে একজন প্লেয়ারকে রিভাইভ করা হয় বা এলিমিনেট দেওয়া বা নক ডাউন পাওয়া থেকে সাহায্য করা হয়",
  T_37_WZY_WS_SATBEHAVIOR_NAMEDESC: "প্লেয়ারদের বিভিন্ন আচরণের স্ট্যাটাস কনফিগার করুন। ডিজেবল করা হলে, HUD-এর সংশ্লিষ্ট বাটনগুলো ব্যবহার করা যাবে না এবং ম্যানুয়াল এবং অটোমেটিক মুভমেন্টের অনুমতি নেই। লুকানো অবস্থায়, সংশ্লিষ্ট বাটনগুলো HUD-এ প্রদর্শিত হবে না, এবং অটোমেটিক মুভমেন্টের অনুমতি থাকা অবস্থায় ম্যানুয়াল মুভমেন্টের অনুমতি নেই। এনাবল করা হলে, সংশ্লিষ্ট বাটনগুলো HUD-এ প্রদর্শিত হবে এবং ম্যানুয়াল এবং অটোমেটিক মুভমেন্টের অনুমতি থাকবে।",
  T_37_WZY_WS_SATBEHAVIOR_PARAM1_DESC: "যেই প্লেয়ারের জন্য আচরণ স্ট্যাটাস সেট করতে হবে",
  T_37_WZY_WS_SATBEHAVIOR_PARAM2_DESC: "প্লেয়ারের আচরণ, মুভমেন্ট, আক্রমণ, লাফানো এবং স্প্রিন্টিং সহ",
  T_37_WZY_WS_SATBEHAVIOR_PARAM3_DESC: "স্ট্যাটাসের মধ্যে ডিজেবলকৃত, হিডেন এবং এনাবলডগুলোও অন্তর্ভুক্ত রয়েছে। লুকানো অবস্থায়, সংশ্লিষ্ট বাটনগুলি HUD-এ প্রদর্শিত হবে না, এবং স্বয়ংক্রিয় মুভমেন্টের অনুমতি থাকা অবস্থায় ম্যানুয়াল মুভমেন্টের অনুমতি নেই। সক্রিয় করা হলে, সংশ্লিষ্ট বাটনগুলি HUD-এ প্রদর্শিত হবে এবং ম্যানুয়াল এবং স্বয়ংক্রিয় মুভমেন্টের অনুমতি থাকবে।",
  T_37_WZY_WS_SETBALL_PARAM2_DESC: "ফুটবলের কো-অর্ডিনেটস",
  T_37_WZY_WS_SETBALL_PARAM3_DESC: "ফুটবল তার প্রি-কনফিগারেশন গতি বজায় রাখা উচিত কিনা। এটি একটি বুলিয়ান মান।",
  T_37_WZY_WS_SETPLAHOST_NAME: "প্লেয়ার অ্যাটাক সেটিং",
  T_37_WZY_WS_SETPLAHOST_NAMEDESC: "[সেটিং প্লেয়ার] [টার্গেট প্লেয়ার] আক্রমণ করতে পারবে কিনা তা কনফিগার করুন। ডিফল্ট সেটিং টার্গেট প্লেয়ার এমন একটি টিম বা ফ্যাকশন যাকে আক্রমণ করা যেতে পারে কিনা, তার ভিত্তিতে নির্ধারণ করা হয়। এই সেটিংটি টিম/ফ্যাকশনের সেটিং থেকে উচ্চ অগ্রাধিকার পায়।",
  T_37_WZY_WS_SETPLAHOST_PARAM1_DESC: "প্রতিপক্ষদের কনফিগার করার জন্য প্লেয়ার",
  T_37_WZY_WS_SETPLAHOST_PARAM2_DESC: "যেই প্লেয়ার প্রতিপক্ষ",
  T_37_WZY_WS_SETPLAHOST_PARAM3: "অ্যাটাকযোগ্য কী না",
  T_37_WZY_WS_SETPLAHOST_PARAM3_DESC: "হ্যাঁ মানে হলো 'আক্রমণযোগ্য'; না মানে হলো 'আক্রমণযোগ্য নয়'। টার্গেট প্লেয়ার  আক্রমণযোগ্য টিম বা ফ্যাকশন কি না, তার উপর ভিত্তি করেই ডিফল্ট সেটিং হয়।",
  T_37_WZY_WS_SETSIDEHOST_PARAM3_DESC: "হ্যাঁ মানে আক্রমণযোগ্য এবং না মানে আক্রমণযোগ্য নয়",
  T_37_WZY_WS_SHADOWSTRENGTH: "শ্যাডো",
  T_37_WZY_WS_SHOOTANGLE: "সবচেয়ে ক্ষুদ্র শ্যুটিং এঙ্গেল",
  T_37_WZY_WS_SKYBOX: "আকাশ",
  T_37_WZY_WS_SKYBOXENT: "স্কাই এনটিটি",
  T_37_WZY_WS_SKYBOXTYPE: "বেসিক স্কাই টাইপ",
  T_37_WZY_WS_STEPPED: "ট্রিগারে স্টেপ করুন",
  T_37_WZY_WS_SWCHAN_NAMEDESC: "প্লেয়ারের ভয়েস চ্যাট চ্যানেল স্যুইচ করুন",
  T_37_WZY_WS_SWCHAN_PARAM1_DESC: "যেই প্লেয়ার চ্যানেল সুইচ করবে",
  T_37_WZY_WS_SWCHAN_PARAM2_DESC: "যে চ্যানেলে সুইচ করতে হবে",
  T_37_WZY_WS_SWITCHSCENE_NAMEDESC: "মনোনীত একটি সিনারিতে সুইচ করুন",
  T_37_WZY_WS_SWITCHSCENE_PARAM1_DESC: "যে সিনারিতে সুইচ করতে হবে তার নাম",
  T_37_WZY_WS_TARGETSTR_DESC: "টার্গেট স্ট্রিং",
  T_37_WZY_WS_TEAMASIDE: "টিম এবং ফ্যাকশন",
  T_37_WZY_WS_TELEPORTN_AUTO: "অটোমেটিক",
  T_37_WZY_WS_TELEPORTN_AVAILABLE: "টেলিপোর্ট হবে কী না",
  T_37_WZY_WS_TELEPORTN_MANUAL: "ম্যানুয়াল",
  T_37_WZY_WS_TELEPORTN_NO: "না",
  T_37_WZY_WS_TELEPORTN_TITLE: "টেলিপোর্ট মেথড",
  T_37_WZY_WS_TELEPORTN_YES: "হ্যাঁ",
  T_37_WZY_WS_TERRAINWET: "ভূখণ্ডের আর্দ্রতা",
  T_37_WZY_WS_TRANSFORM_NAMEDESC: "একটি [Player entity]  এর চেহারাকে একটি [Scenery object] এর সাথে প্রতিস্থাপন করুন",
  T_37_WZY_WS_TRANSFORM_PARAM1_DESC: "যেই প্লেয়ার এনটিটির বেশভুষা বদলাতে হবে",
  T_37_WZY_WS_TRANSFORM_PARAM2_DESC: "যে প্লেয়ারের ডিসগাইজ এনটিটি অর্জন করতে হবে",
  T_37_WZY_WS_TRANSP: "ট্রান্সপারেন্সি",
  T_37_WZY_WS_UNLOADSCENE_NAMEDESC: "একটি মনোনিত সিনারি আন-ইনস্টল করুন",
  T_37_WZY_WS_UNLOADSCENE_PARAM1_DESC: "যেই সিনারিটি আন-ইনস্টল করতে হবে, তার নাম",
  T_37_WZY_WS_VFX1: "প্রতীকী",
  T_37_WZY_WS_VFX2: "ধোঁয়াটে",
  T_37_WZY_WS_VFX3: "কার্স এক্সপ্লোশন",
  T_37_WZY_WS_VFX5: "বরফাচ্ছাদিত",
  T_37_WZY_WS_VFX6: "স্পটলাইট",
  T_37_WZY_WS_VFX7: "ঊর্ধ্বমুখী হাঙ্গামা",
  T_37_WZY_WS_VFX8: "বায়ুমণ্ডল বিস্ফোরণ",
  T_37_WZY_WS_VISABLE: "দৃশ্যমানতা",
  T_37_WZY_WS_WEAOPEN: "ধীর কী না",
  T_37_WZY_WS_WEAPONENT: "ওয়েপন এনটিটি",
  T_37_WZY_WS_WEATARGETED: "এইম অ্যাসিস্ট দিয়ে টার্গেট করা যাবে কি না",
  T_37_XYL_CUSTOMJERSEY: "জার্সি মেশিন",
  T_37_XYL_CUSTOMJERSEY_DESC: "আপনার পছন্দের জার্সি তৈরি করতে জার্সি মেশিন ব্যবহার করুন",
  T_37_XYL_FOOTGUN: "ফুটবল শ্যুটার",
  T_37_XYL_SOCCER: "ফুটবল",
  "T_37_XYL_SOCCER_ RADIUS": "রেডিয়াস",
  T_37_XYL_SOCCER_DESC: "এমন একটি ফুটবল, যার প্রপার্টি কাস্টমাইজ করা যায়",
  T_37_XYL_SOCCER_HIGHT1: "নিয়মিত এঙ্গেল",
  T_37_XYL_SOCCER_HIGHT2: "ভলি অ্যাঞ্জেল",
  T_37_XYL_SOCCER_RESET: "একটা গোল এর পর টাইম রিসেট করুন (s)",
  T_37_XYL_SOCCER_RESIST1: "ফ্রিকশন (কিক মোড)",
  T_37_XYL_SOCCER_RESIST2: "ফ্রিকশন (গান মোড)",
  T_37_XYL_SOCCERGOAL: "গোল",
  T_37_XYL_SOCCERGOAL_DESC: "এটাই লক্ষ্য। গোল স্কোর করার জন্য ফুটবলটিকে শ্যুট করুন। (শুধুমাত্র পয়েন্ট গ্র্যাবে কার্যকর।)",
  T_37_XYL_SOCCERITEM: "আইটেম স্পন",
  T_37_XYL_SOCCERITEM_DESC: "স্থাপন করা হলে, এটি নির্বাচিত আইটেম তৈরি করবে",
  T_37_XYL_SPAWN_PEOPLE: "প্লেয়ারদের #",
  T_37_XYL_WS_AIRCONDITIONER001: "এয়ার কন্ডিশনার B",
  T_37_XYL_WS_AMMUCHEST: "ওয়ার চেস্ট A",
  T_37_XYL_WS_BAFFLE001: "বাঁধা A",
  T_37_XYL_WS_BARREL001: "ব্যারেল",
  T_37_XYL_WS_BARREL001_DES: "সাধারণত বৃত্তাকার কাঠের ব্যারেল দেখা যায়",
  T_37_XYL_WS_BOARD001: "Ad বোর্ড B",
  T_37_XYL_WS_BOOK001: "A বইয়ের গাঁদা",
  T_37_XYL_WS_BOOK002: "বোর্ড গেম A",
  T_37_XYL_WS_BOUGAINVILLEA: "বুগেনভিলা",
  T_37_XYL_WS_BOUGAINVILLEA_DES: "ডেকোর - স্থান উজ্জ্বল করে!",
  T_37_XYL_WS_BOX001: "বাক্সের স্তূপ A",
  T_37_XYL_WS_BOX002: "ছোট বক্স",
  T_37_XYL_WS_BUSHCOVER: "বুশ",
  T_37_XYL_WS_BUSHCOVER_DES: "একটি ঝোপ যা লুকানোর জন্য ব্যবহার করা যেতে পারে",
  T_37_XYL_WS_CABINET001: "ড্রওয়ার্স A",
  T_37_XYL_WS_CHAIR001: "চেয়ার A",
  T_37_XYL_WS_COCONUTTREE: "নারিকেল গাছ",
  T_37_XYL_WS_COCONUTTREE_DES: "সাজান - একটা সৈকতময় ভাইবে!",
  T_37_XYL_WS_COMPUTER001: "কম্পিউটার A",
  T_37_XYL_WS_DAMAGERATIO: "ড্যামেজ অনুপাত",
  T_37_XYL_WS_FIREEX: "অগ্নিনির্বাপক",
  T_37_XYL_WS_GUIDEPOSE: "ডিরেকশন পোস্ট",
  T_37_XYL_WS_HUGEHOUSE001: "3-তলা বাড়ি B",
  T_37_XYL_WS_HUGEHOUSE002: "2-তলা বাড়ি B",
  T_37_XYL_WS_JACKSTRAW: "কাকতাড়ুয়া",
  T_37_XYL_WS_LADDER001: "ল্যাডার A",
  T_37_XYL_WS_OILDRUM: "জেরি ক্যান",
  T_37_XYL_WS_ORNAMENT001: "ফুলদানি A",
  T_37_XYL_WS_PACKBOX: "সাপ্লাই কন্টেইনার",
  T_37_XYL_WS_PILLA001: "কনক্রিট পিলার",
  T_37_XYL_WS_PRESENT: "গিফট বক্স",
  T_37_XYL_WS_PRESENT_DES: "হলিডে গিফট অন্তর্ভুক্ত রয়েছে",
  T_37_XYL_WS_PUMPKIN: "স্কোয়ার জ্যাক-ও ল্যান্টার্ন",
  T_37_XYL_WS_PUMPKINCUT: "জ্যাক-ও-ল্যানটার্ন",
  T_37_XYL_WS_PUMPKINCUT_DES: "একটি ভুতুড়ে উত্সবের জন্য একটি সাধারণ সজ্জা৷",
  T_37_XYL_WS_ROADBLOCK001: "রোডব্লক B",
  T_37_XYL_WS_SHELF001: "বুকশেলফ A",
  T_37_XYL_WS_SOFA001: "সোফা A",
  T_37_XYL_WS_SPAWNTEAM: "সকল টিম",
  T_37_XYL_WS_SUPPLYBOX: "অ্যামো ক্রেট",
  T_37_XYL_WS_TABLE001: "টেবিল A",
  T_37_XYL_WS_TABLE002: "টেবিল B",
  T_37_XYL_WS_TARGET001: "টার্গেট",
  T_37_XYL_WS_TEAMID_1: "1",
  T_37_XYL_WS_TEAMID_10: "10",
  T_37_XYL_WS_TEAMID_11: "11",
  T_37_XYL_WS_TEAMID_12: "12",
  T_37_XYL_WS_TEAMID_2: "2",
  T_37_XYL_WS_TEAMID_3: "3",
  T_37_XYL_WS_TEAMID_4: "4",
  T_37_XYL_WS_TEAMID_5: "5",
  T_37_XYL_WS_TEAMID_6: "6",
  T_37_XYL_WS_TEAMID_7: "7",
  T_37_XYL_WS_TEAMID_8: "8",
  T_37_XYL_WS_TEAMID_9: "9",
  T_37_XYL_WS_TELEPORTEND: "পোর্টাল ফিনিশ পয়েন্ট",
  T_37_XYL_WS_TELEPORTNEW: "পোর্টাল A",
  T_37_XYL_WS_TELEPORTNEW_DESC: "এমন একটি পোর্টাল, যা প্লেয়ারকে পোর্টালের ফিনিশিং পয়েন্টে টেলিপোর্ট করতে পারে",
  T_37_XYL_WS_TIRES001: "টায়ার A",
  T_37_XYL_WS_TOOLRACK: "টুল শেলফ",
  T_37_XYL_WS_WALL001: "ওয়াল",
  T_37_XYL_WS_WOOD001: "কাটা কাঠ",
  T_37_XYL_WS_YELLOWDUCK001: "ডাকি ফ্লোট",
  T_37_XYL_WS_YELLOWDUCK001_DES: "হাঁসের আকারে একটি স্ফীত সাঁতারের রিং",
  T_37_YM_BOMBSQUAD_DEFUSER: "ডিফিউজার",
  T_37_YS_B_BRFOOTBALL_WHITE: "CBF হোয়াইট জার্সি (বটম)",
  T_37_YS_F_B_VN_STREET: "ক্রিমসন অসপিশন (বটম)",
  T_37_YS_F_H_VN_STREET: "ক্রিমসন অসপিশন (হেড)",
  T_37_YS_F_S_VN_STREET: "ক্রিমসন অসপিশন (জুতা)",
  T_37_YS_F_T_VN_STREET: "ক্রিমসন অসপিশন (টপ)",
  T_37_YS_M_A_CRICKET_BLACK: "বাম্বলবী ক্রিকেটার (মাস্ক)",
  T_37_YS_M_A_THKOL: "ব্লেইজ ব্যানিশ (মাস্ক)",
  T_37_YS_M_B_CRICKET_BLACK: "বাম্বলবী ক্রিকেটার (বটম)",
  T_37_YS_M_B_SILVERERA: "ফিয়ারলেস গ্রেহাউন্ড (বটম)",
  T_37_YS_M_B_THKOL: "ব্লেইজ ব্যানিশ (বটম)",
  T_37_YS_M_H_SILVERERA: "ফিয়ারলেস গ্রেহাউন্ড (হেড)",
  T_37_YS_M_H_THKOL: "ব্লেইজ ব্যানিশ (হেড)",
  T_37_YS_M_S_CRICKET_BLACK: "বাম্বলবী ক্রিকেটার (জুতা)",
  T_37_YS_M_S_SILVERERA: "ফিয়ারলেস গ্রেহাউন্ড (জুতা)",
  T_37_YS_M_S_THKOL: "ব্লেইজ ব্যানিশ (জুতা)",
  T_37_YS_M_T_CRICKET_BLACK: "বাম্বল বী ক্রেকেটার (টপ)",
  T_37_YS_M_T_SILVERERA: "ফিয়ারলেস গ্রেগার্ড (টপ)",
  T_37_YS_M_T_THKOL: "ব্লেইজ ব্যানিশ (টপ)",
  T_37_YS_T_BRFOOTBALL_WHITE: "CBF হোয়াইট জার্সি (টপ)",
  T_37_ZF_ROOM_UGC_MINPLAYER: "ন্যূনতম প্লেয়ার",
  T_38_BQ_SKILL_NAME_DUMMY1: "স্টান্ট ডাবল",
  T_38_BQ_SKILL_NAME_DUMMY2: "শেপ স্প্লিটার",
  T_38_CJ_F_B_STREAMER_MUSIC: "ই-হার্টসিকার (বটম)",
  T_38_CJ_F_H_STREAMER_MUSIC: "ই-হার্টসিকার (হেড)",
  T_38_CJ_F_S_STREAMER_MUSIC: "ই-হার্টসিকার (জুতা)",
  T_38_CJ_F_T_STREAMER_MUSIC: "ই-হার্টসিকার (টপ)",
  T_38_JH_WS_CM1: "নিয়ম ক্লিয়ার করুন",
  T_38_JH_WS_CM2: "অস্পষ্ট নিয়ম",
  T_38_JH_WS_CM3: "ফ্রিকোয়েন্ট কুইট আউটস",
  T_38_JL_M79_AMMO_N: "M79 অ্যামো",
  T_38_JMF_SKILLCHIP_NAME_SINGER: "জে. বিবস-এর মাইক্রোচিপ",
  T_38_M_WS_VECTOR2: "2D ভেক্টর",
  T_38_R_TACTICS_N: "প্রিসেট",
  T_38_RW_NIW_NIWNAME: "গ্লু মেকার",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CALLSTACKCOUNTMAX: "ব্লকের অনেক বেশি লেয়ার। বর্তমান: {0}। ম্যাক্স: {1}।",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CREATEITEMCOUNTMAXPERMATCHKEY: "আপনার তৈরি করা আইটেমের সংখ্যা ({0}) লিমিট অতিক্রম করেছে ({1})।",
  T_38_SP_WS_LOG_EXCEED_LIMIT_DISPATCHEVENTMAXCOUNTPERFRAME: "একই ফ্রেমের মধ্যে প্রাপ্ত ইনসিডেন্ট সংখ্যা ({0}) লিমিট অতিক্রম করেছে ({1})।",
  T_38_SP_WS_LOG_EXCEED_LIMIT_ENTITIESCREATEDPERFRAMEMAX: "প্রতি-ফ্রেম ডায়নামিক এনটিটি তৈরির সীমা পূর্ণ হয়েছে ({0}); {1} বার তৈরির চেষ্টা বাতিল করা হয়েছে।",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LISTINITLENGTHMAX: "প্রারম্ভিক তালিকার দৈর্ঘ্য ({0}) সীমা অতিক্রম করেছে ({1})। একটি ম্যাক্স ক্যাপাসিটি লিস্ট অটো-ক্রিয়েট করে।",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LOOPTIMESMAX: "লুপের সংখ্যা ({0}) লিমিট অতিক্রম করেছে ({1})। লুপ বাধাপ্রাপ্ত",
  T_38_SP_WS_LOG_EXCEED_LIMIT_PERSCOPECOROUTINECONCURRENCYMAX: "কোরোটিন স্কোপে সমসাময়িক কোরোটিনের সংখ্যা ({0}) লিমিট অতিক্রম করেছে ({1})।",
  T_38_SP_WS_LOG_LIST_APPEND_IS_NIL: "তালিকায় এলিমেন্ট যোগ করতে ব্যর্থ হয়েছে। তালিকা {0} খালি",
  T_38_SP_WS_LOG_VAR_ARITHMETIC_FAILED: "মৌলিক গাণিতিক অপারেশন সম্পাদন করার সময় ভ্যাল্যু টাইপে মিস-ম্যাচ ধরা পরেছে। বাম ভ্যাল্যু টাইপ হলো {0} এবং ডান ভ্যাল্যু টাইপ হলো {1}৷",
  T_38_SP_WS_LOG_VAR_REPEATED_DEF_IN_SCOPE: "রিপিটেড টেম্পোরারি ভ্যারিয়েবল। ভ্যারিয়েবলের নাম: {0}।",
  T_38_SP_WS_REVIEW_01: "টক্সিক",
  T_38_SP_WS_REVIEW_02: "অশ্লীল",
  T_38_SP_WS_REVIEW_03: "অসম্মানজনক",
  T_38_SP_WS_REVIEW_04: "খুবই টক্সিক",
  T_38_SP_WS_REVIEW_05: "ভীতিপ্রদর্শনমূলক",
  T_38_SP_WS_REVIEW_06: "অসম্মানজনক",
  T_38_SP_WS_REVIEW_07: "রিভিউয়ের আওতাধীন",
  T_38_SP_WS_REVIEW_08: "{0} নামটি {1} নিয়মের সাথে সামঞ্জস্যপূর্ণ নয়। {2}",
  T_38_SP_WS_REVIEW_09: "স্ট্রিং",
  T_38_SP_WS_REVIEW_10: "স্টোর",
  T_38_SP_WS_REVIEW_11: "ভেরিয়েবল",
  T_38_SP_WS_REVIEW_12: "ফাংশন",
  T_38_SP_WS_REVIEW_13: "অবজেক্ট",
  T_38_SP_WS_REVIEW_14: "ডেফিনিশনে যান।",
  T_38_SP_WS_REVIEW_15: "অবজেক্ট ম্যানেজ করতে যান।",
  T_38_SP_WS_REVIEW_16: "কোনো রিডিরেকশন নেই।",
  T_38_SP_WS_REVIEW_17: "ম্যাপের নাম",
  T_38_SP_WS_REVIEW_18: "বর্ণনা",
  T_38_SP_WS_REVIEW_19: "কভার ইমেজ",
  T_38_SP_WS_REVIEW_20: "টেক্সটে সংবেদনশীল শব্দ রয়েছে।",
  T_38_SP_WS_REVIEW_21: "সেভ ব্যার্থ হয়েছে। রিভিউ করা যাচ্ছে না।",
  T_38_SP_WS_REVIEW_22: "রিভিউ কুলডাউনে আছে।",
  T_38_SY_BASEBALLBAT_KITCHEN_N: "মেইহ্যাম ব্যাট",
  T_38_SY_CHARACTER_DESIGNER_N: "সান্টিয়ানো",
  T_38_SY_PET_CACTUS_N: "ক্যাকটাস",
  T_38_SY_PETSKIN_CACTUS_BLACK_N: "পেট স্কিন: ঘোস্ট ক্যাকটাস",
  T_38_SY_PETSKIN_CACTUS_PINK_N: "পেট স্কিন: নিয়ন ক্যাকটাস",
  T_38_SY_PETSKIN_CACTUS_YELLOW_N: "পেট স্কিন: পাম ড্রিম ক্যাকটাস",
  T_38_SY_PETSKIN_FLYINGCREATURE_ES_N: "পেট স্কিন: পার্টি আরভন",
  T_38_SY_PETSKIN_RACCOON_MO_N: "পেট স্কিন: ট্রেন্ডি রকি",
  T_38_SY_SCAR_ELDERGODS_N: "SCAR- নাইটফায়ার কামি",
  T_38_SY_SICKLE_ES_N: "Pop-Pow সিকল",
  T_38_SY_VEHICLE_SUV_KITCHEN_N: "মোচি ফুড ট্রাক",
  T_38_WT_WS_MUITLEVEL: "মাল্টি-লেভেল",
  T_38_WT_WS_SKILLSET15: "থ্রিল অফ ব্যাটেল (A124)",
  T_38_WT_WS_SKILLSET16: "সেন্সেস শকওয়েভ (হোমার)",
  T_38_WT_WS_SKILLSET17: "ওয়াল ব্রোল (আইরিস)",
  T_38_WT_WS_SKILLSET18: "রিবেল রাশ (তাতসুয়া)",
  T_38_WZY_WS_ACTIVEA: "দৃশ্যাবলীতে ব্যবহারযোগ্য কি না",
  T_38_WZY_WS_ACTIVEB: "লজিক রিফ্রেশ চালু করবেন কি না",
  T_38_WZY_WS_ACTIVEVALUE: "অ্যাক্টিভিটি স্ট্যাটাস",
  T_38_WZY_WS_AIR: "এয়ার",
  T_38_WZY_WS_ALLOWMOVE: "স্থানান্তরযোগ্য কী না",
  T_38_WZY_WS_AMMOAMOUNT: "অ্যামো অ্যামাউন্ট",
  T_38_WZY_WS_AMMONAME: "অ্যামো এনটিটি",
  T_38_WZY_WS_ARMOR_DAMRED: "DMG হ্রাস মাল্টিপ্লায়ার",
  T_38_WZY_WS_ARMOR_DAMRED_EXP: "এক্সপ্লোশন DMG রিডাকশন মাল্টিপ্লায়ার",
  T_38_WZY_WS_ARMOR_DURABILITY: "বর্তমান স্থায়ীত্ব",
  T_38_WZY_WS_ARMOR_DURABILITYMAX: "ম্যাক্স. স্থায়ীত্ব",
  T_38_WZY_WS_ARMOR_ISDAMAGE: "ড্যামেজেবল কী না",
  T_38_WZY_WS_ARMOR_ISDESTROY: "ধ্বংসযোগ্য কি না",
  T_38_WZY_WS_ARMOR_LEVEL: "লেভেল",
  T_38_WZY_WS_ASSCONZOM: "জোম্বি এলিমিনেশন অ্যাসিস্ট.",
  T_38_WZY_WS_BAGNAME: "ব্যাকপ্যাক ক্যাপাসিটি",
  T_38_WZY_WS_BAGSPACEEX: "অ্যাডিশনাল ব্যাকপ্যাক স্পেস",
  T_38_WZY_WS_BRIDGING: "ব্রিজ রেন্ডার কম্পোনেন্ট",
  T_38_WZY_WS_BUBBLE: "বাবল",
  T_38_WZY_WS_CLEARBAG_NAMEDESC: "[প্লেয়ার এনটিট] ব্যাকপ্যাকের সবগুলো আইটেম ক্লিয়ার করুন",
  T_38_WZY_WS_CLEARMAP_NAMEDESC: "ম্যাপের চারপাশে পড়ে থাকা অবাঞ্ছিত আইটেমগুলি সাফ করুন, যেমন লুট, থ্রোয়েবলসের অবশিষ্টাংশ এবং লুট বক্স",
  T_38_WZY_WS_CLEARPRO: "সিঙ্গেল প্রপার্টি ফ্যাক্টর ক্লিয়ার করুন",
  T_38_WZY_WS_CLONEOBJ_NAMEDESC: "একটি [প্লেয়ার এনটিটি]-এর অবস্থানে একটি [সিনারি অবজেক্ট] এনটিটি ক্লোন করুন এবং [ডিসগাইজ এনটিটি] রিটার্ন দিন",
  T_38_WZY_WS_COMPONENT: "কম্পোনেন্ট",
  T_38_WZY_WS_COSTAMMO: "কনজিউম অ্যামো",
  T_38_WZY_WS_CRECREMA_NAMEDESC: "একটি ক্যামেরা তৈরি করুন এবং একটি [ক্যামেরা এনটিটি] ফেরত দিন, যার প্রপার্টিজগুলো,  প্রপার্টি সেটিংসের মাধ্যমে পরিবর্তন করা যেতে পারে৷",
  T_38_WZY_WS_CYCLES: "যতবার প্লে হয়েছে",
  T_38_WZY_WS_CYLINDERJUD_NAMEDESC: "কোনো [এনটিটি] একটি সার্কুলার পোল স্কোপের ভিতরে আছে কিনা তা চেক করুন। [কেন্দ্র] হল মেরুটির কেন্দ্র, [ব্যাসার্ধ] হল বৃত্তাকার পৃষ্ঠের ব্যাসার্ধ, [উচ্চতা] হল মেরুটির উচ্চতা, [অয়লার অ্যাঙ্গেল] হল মেরুটির 3D অরিয়েন্টেশন কোণ।",
  T_38_WZY_WS_CYLINDERJUD_RES: "সার্কুলার পোল স্কোপ চেক এর রেজাল্ট।এটি একটি বুলিয়ান মান।",
  T_38_WZY_WS_DAMSUMZOM: "জোম্বিদের প্রদত্ত ড্যামেজ",
  T_38_WZY_WS_DARKNESS: "ডার্কনেস",
  T_38_WZY_WS_DIFCOLOR: "সার্ফেস কালার",
  T_38_WZY_WS_DIFTEXTURE: "সার্ফেস টেক্সচার",
  T_38_WZY_WS_DRUMMUSIC: "কম্পোনেন্ট টাইপ: ড্রামস",
  T_38_WZY_WS_ENTITY_PLAYERDISDESC: "যে প্লেয়ার ডিসকানেক্ট হয়েছিলো",
  T_38_WZY_WS_ENTITY_PLAYERRECDESC: "যেই প্লেয়ার রিকানেক্ট করছে",
  T_38_WZY_WS_EUIANCHOR: "HUD অ্যাংকর টাইম এন্যুমারেশন",
  T_38_WZY_WS_FEATHER: "পালক",
  T_38_WZY_WS_FLAMEAMMO: "ফ্লেমথ্রোয়ার অ্যামো",
  T_38_WZY_WS_FLOWER: "ফুল",
  T_38_WZY_WS_FOLLOW_NAMEDESC: "সর্বদা [ফলোড এনটিটি] অনুসরণ করার জন্য [এনটিটি] সেট করুন। [অফসেট কোঅর্ডিনেটস] হলো দুটি এনটিটির মধ্যকার দূরত্ব।",
  T_38_WZY_WS_FOLLOWENT: "ফলো করা এনটিটি",
  T_38_WZY_WS_GETCURCAM_NAMEDESC: "বর্তমানে একটি [প্লেয়ার এনটিটি] দ্বারা ব্যবহৃত ক্যামেরা এনটিটি অর্জন করুন",
  T_38_WZY_WS_GETCURCAMDESC: "যে ক্যামেরাটি বর্তমানে প্লেয়ার ব্যবহার করছে",
  T_38_WZY_WS_GETITEMNUM_NAMEDESC: "একজন [প্লেয়ার] মালিকানাধীন [মনোনীত আইটেম টাইপ] আইটেমের পরিমাণ পান",
  T_38_WZY_WS_GETITEMNUM_RES: "খেলোয়াড়ের মালিকানাধীন মনোনীত আইটেমের পরিমাণ",
  T_38_WZY_WS_GETVEC_NAME: "ভেক্টর অর্জন করুন",
  T_38_WZY_WS_GETVEC_NAMEDESC: "স্থানাঙ্কের একটি সেটের x, y এবং z উপাদান ব্যবহার করে একটি ভেক্টর পান",
  T_38_WZY_WS_GETVECRES: "x, y, এবং z কম্পোনেন্ট থেকে প্রাপ্ত ভেক্টর",
  T_38_WZY_WS_GHOST: "ঘোস্ট",
  T_38_WZY_WS_GRENADEFROZENNAME: "ফ্ল্যাশ ফ্রিজ এনটিটি",
  T_38_WZY_WS_GRENADEFROZENPARAM1: "ফ্রিজ জোন রেডিয়াস",
  T_38_WZY_WS_GRENADEFROZENPARAM2: "ফ্রিজ স্থায়ীত্ব",
  T_38_WZY_WS_GRENADENAME: "গ্রেনেড এনটিটি",
  T_38_WZY_WS_GRENADEPARAM1: "মিনিমাম ড্যামেজ",
  T_38_WZY_WS_GRENADEPARAM2: "ম্যাক্স. DMG",
  T_38_WZY_WS_GRENADEPARAM4: "এক্সপ্লোশন রেঞ্জ",
  T_38_WZY_WS_GRENADEPARAM5: "নিক্ষেপ গতি",
  T_38_WZY_WS_GRENADEPARAM6: "বিস্ফোরণ বিলম্ব",
  T_38_WZY_WS_GRENADEPARAM7: "সেলফ ড্যামেজ মাল্টিপ্লায়ার",
  T_38_WZY_WS_GRENADEPARAM8: "অ্যালাই DMG মাল্টিফায়ার",
  T_38_WZY_WS_GRENADEPARAM9: "ভেহিক্যাল DMG মাল্টিপ্লায়ার",
  T_38_WZY_WS_GUNFIRE: "গানফায়ার",
  T_38_WZY_WS_GUNPRO_PARAM2: "রিলোড স্পিড",
  T_38_WZY_WS_GUNPRO_PARAM3: "বডি শটস DMG অনুপাত",
  T_38_WZY_WS_GUNPRO_PARAM4: "হেডশট ড্যামেজ রেশিও",
  T_38_WZY_WS_GUNPRO_PARAM5: "লিম্ব শটস ড্যামেজ অনুপাত",
  T_38_WZY_WS_GUNPRO_PARAM7: "এক্সট্রা ড্যামেজ",
  T_38_WZY_WS_HELMET_NAME: "হেলমেট এনটিটি",
  T_38_WZY_WS_ICON1: "মুকুট",
  T_38_WZY_WS_ICON2: "ডুয়েল",
  T_38_WZY_WS_INITPOS: "প্রাথমিক লোকেশন",
  T_38_WZY_WS_ISRESET: "রেসিপ্রোকেটিং মোশন",
  T_38_WZY_WS_KILLCONZOM: "এলিমিনেটকৃত জোম্বি সংখ্যা",
  T_38_WZY_WS_KILLENT_NAMEDESC: "নির্বাচিত [এনটিটি] এলিমিনেট করুন, যা অবশ্যই একটি ব্যাটেল এনটিটি টাইপ হতে হবে। অভেদ্য স্ট্যাটাস উপেক্ষা করে।",
  T_38_WZY_WS_LABELPARAM: "টেক্সট কন্টেন্ট প্যারামিটার লিস্ট",
  T_38_WZY_WS_LEADMUSICA: "কম্পোনেন্ট টাইপ: পিয়ানো (ট্রেবল)",
  T_38_WZY_WS_LEADMUSICB: "কম্পোনেন্ট টাইপ: পিয়ানো (অল্টো)",
  T_38_WZY_WS_LEADMUSICC: "কম্পোনেন্ট টাইপ: পিয়ানো (বেস)",
  T_38_WZY_WS_LINE: "লাইন",
  T_38_WZY_WS_LIQUID: "তরলপদার্থ",
  T_38_WZY_WS_LOCALKEY: "অনুদিত কী",
  T_38_WZY_WS_LOCALPOS: "রিলেটিভ লোকেশন",
  T_38_WZY_WS_LOOKAT_NAMEDESC: "সর্বদা [এইমড এনটিটি] এর মুখোমুখি হওয়ার জন্য একটি [এনটিটি] সেট করুন। [অফসেট কোঅর্ডিনেটস] হল এইমকৃত পয়েন্ট এবং এনটিটির অবস্থানের কো-অর্ডিনেট পার্থক্য।",
  T_38_WZY_WS_MAINWEAPONA: "মেইন ওয়েপন 1",
  T_38_WZY_WS_MAINWEAPONB: "মেইন ওয়েপন 2",
  T_38_WZY_WS_MOTIONTIME: "মুভমেন্ট স্থায়ীত্ব",
  T_38_WZY_WS_MOTIONTYPE: "মুভমেন্ট মেথড",
  T_38_WZY_WS_MUSHROOM_EPMODIFY: "মোডিফাইড EP",
  T_38_WZY_WS_MUSHROOMNAME: "মাশরুম এনটিটি",
  T_38_WZY_WS_OBFACTION: "ফ্যাকশন স্পেকটেট করুন",
  T_38_WZY_WS_OBGLOBAL: "সবাইকে স্পেকটেট করুন",
  T_38_WZY_WS_OBSERVER: "স্পেকটেটর অপশন্স",
  T_38_WZY_WS_OBTEAM: "টিম স্পেকটেট করুন",
  T_38_WZY_WS_OFFSETVEC: "অফসেট কো-অর্ডিনেটস",
  T_38_WZY_WS_ONBUY_NAMEDESC: "একজন প্লেয়ার এই ভেন্ডিং মেশিন থেকে আইটেম কিনলে ট্রিগার হয়। [প্লেয়ার এনটিটি] হলো সেই প্লেয়ার যে ক্রয় করে। [মার্চেন্ডাইজ এনটিটি] ক্রয়কৃত আইটেম।",
  T_38_WZY_WS_ONEQUIPED_NAMEDESC: "[প্লেয়ার এনটিটি] দ্বারা ইকুইপ হলে ট্রিগার হয়",
  T_38_WZY_WS_ONJUMP_NAMEDESC: "প্লেয়ার যখন জাম্পিং অ্যাকশন সম্পূর্ণ করে তখন ট্রিগার হয়",
  T_38_WZY_WS_ONLIE_NAMEDESC: "প্লেয়ার যখন নত অবস্থান সম্পূর্ণ করে তখন ট্রিগার করে",
  T_38_WZY_WS_ONRELOAD_NAMEDESC: "ওয়েপন রিলোড হলে ট্রিগার করে",
  T_38_WZY_WS_ONSPRINT_NAMEDESC: "প্লেয়ার যখন স্প্রিন্টিং অ্যাকশন সম্পূর্ণ করে তখন ট্রিগার হয়",
  T_38_WZY_WS_ONSQUAT_NAMEDESC: "প্লেয়ার ক্রাউচিং অ্যাকশন সম্পূর্ণ করলে ট্রিগার হয়",
  T_38_WZY_WS_ONWAEPKILL_NAMEDESC: "ট্রিগার হয় যখন ওয়েপন কোনো ইউনিট এলিমিনেট করে। [এলিমিনেটকৃত এনটিটি] হল সেই একক যাকে এলিমিনেট করা হয়েছিল।",
  T_38_WZY_WS_ONWEAPDAMAGE_NAMEDESC: "ট্রিগার হয় যখন ওয়েপনটি কোনো ব্যাটেল এনটিটির ড্যামেজ প্রদান করে। [হিট টার্গেট] হলো সেই ব্যাটেল এনটিটি। [ড্যামেজ] হলো যে ড্যামেজ প্রদান করা হচ্ছে।",
  T_38_WZY_WS_OWNER: "মালিক",
  T_38_WZY_WS_PARAMLIST: "প্যারামিটার লিস্ট",
  T_38_WZY_WS_PARTICALMAP: "পার্টিকেল ম্যাপিং",
  T_38_WZY_WS_PAUSEMOTE_NAMEDESC: 'একটি [খেলোয়াড় এনটিটি] জন্য বর্তমান ইমোট পজ করুন বা রিজিউম করুন। [পজ কি না] একটি বুলিয়ান মান। "হ্যাঁ" মানে বিরতি। "না" মানে রিজিউম।',
  T_38_WZY_WS_PLAENTTRI_DESC: "ট্রিগারে প্রবেশের সময় প্লেয়ারের দ্বারা চালু হয়",
  T_38_WZY_WS_PLAQUITTRI_DESC: "ট্রিগারে ছেড়ে যাওয়ার সময় প্লেয়ারের দ্বারা চালু হয়",
  T_38_WZY_WS_PLAYEMOTE_NAMEDESC: "[প্লেয়ার এনটিটি] কে মনোনীত [ইমোট] একবার খেলতে বাধ্য করুন এবং শেষ হয়ে গেলে আসল অবস্থানে ফিরে যান",
  T_38_WZY_WS_PLAYSPEED: "প্লেব্যাক স্পিড পারসেন্টেজ",
  T_38_WZY_WS_PREHUD_NAME: "প্রিসেট আইকন",
  T_38_WZY_WS_QUITFACTION_NAMEDESC: "[player entity] কে তার বর্তমান ফ্র্যাকশন ছেড়ে যেতে দিন",
  T_38_WZY_WS_RESETENT: "প্রতি রাউন্ডে কম্পোনেন্ট রিসেট করুন",
  T_38_WZY_WS_RESUUID: "রিসোর্স UUID",
  T_38_WZY_WS_RIMCOLOR: "বর্ডার কালার",
  T_38_WZY_WS_RIMTEXTURE: "বর্ডার টেক্সচার",
  T_38_WZY_WS_SECTORJUD_NAMEDESC: "একটি [এনটিটি] একটি কোন এর ভিতরে আছে কিনা তা পরীক্ষা করুন। [কেন্দ্র] এবং [ব্যাসার্ধ] হল কোণের কেন্দ্র এবং ব্যাসার্ধ। [নিষ্কৃত ব্যাসার্ধ] হল কোণের মধ্যে ছোট সেক্টরের ব্যাসার্ধ। উচ্চতা হল 3D কাঠামোর উচ্চতা। [কোণ] হল কোণের কেন্দ্রীয় কোণ। [ডিরেকশন কোণ] কেন্দ্রীয় অক্ষের দিক ভেক্টর।",
  T_38_WZY_WS_SECTORJUD_RES: "ফ্যান-আকৃতির স্কোপ চেকের ফলাফল। এটি একটি বুলিয়ান মান।",
  T_38_WZY_WS_SETACTIVE_NAMEDESC: "একটি [টার্গেট এনটিটি] এর অ্যাক্টিভিটি স্ট্যাটাস সেট করুন। [অ্যাক্টিভিটি স্ট্যাটাস] হল একটি বুলিয়ান মান এবং এটি ঐ এনটিটির প্রাপ্যতা, দৃশ্যমানতা এবং সংঘাতকে প্রভাবিত করে।",
  T_38_WZY_WS_SETROUNDSCORE: "প্লেয়ারের রাউন্ড স্কোর সেট করুন",
  T_38_WZY_WS_SHOOTANGMAX: "ম্যাক্স. শ্যুটিং অ্যাঙ্গেল",
  T_38_WZY_WS_SHOWMAPINFO: "একই ফ্যাকশনের জন্য ম্যাপ ডিসপ্লে করুন",
  T_38_WZY_WS_SHOWNAMEHUD: "একই ফ্যাকশনের জন্য নামের HUD ডিসপ্লে করুন",
  T_38_WZY_WS_SOUND1: "গতিবেগ বৃদ্ধি",
  T_38_WZY_WS_SOUND10: "স্টেজ স্টার্ট",
  T_38_WZY_WS_SOUND11: "জোম্বি",
  T_38_WZY_WS_SOUND12: "হরর",
  T_38_WZY_WS_SOUND13: "রূপান্তর",
  T_38_WZY_WS_SOUND14: "পাউন্ডিং হার্ট",
  T_38_WZY_WS_SOUND15: "মিডিয়াম হার্টবিট",
  T_38_WZY_WS_SOUND16: "স্লো হার্টবিট",
  T_38_WZY_WS_SOUND17: "রাশ টাইম",
  T_38_WZY_WS_SOUND18: "ক্লিক",
  T_38_WZY_WS_SOUND19: "স্কিল রিকোভার",
  T_38_WZY_WS_SOUND2: "ডিজেপ্যায়ার নোটিফিকেশন",
  T_38_WZY_WS_SOUND20: "গেমে জয়েন করুন",
  T_38_WZY_WS_SOUND3: "ভিজুয়াল ইফেক্টস",
  T_38_WZY_WS_SOUND4: "রাতের কিচিরমিচির",
  T_38_WZY_WS_SOUND5: "হিট (ব্লান্ট)",
  T_38_WZY_WS_SOUND6: "রিঅ্যাকশন",
  T_38_WZY_WS_SOUND7: "সারপ্রাইজ ফাইন্ড",
  T_38_WZY_WS_SOUND8: "আবির্ভাব",
  T_38_WZY_WS_SOUNDENT: "মিউজিক এনটিটি",
  T_38_WZY_WS_SPAWNPOS: "পুরোনো স্পন পয়েন্ট",
  T_38_WZY_WS_SPHERENAME: "বেসিক স্পেয়ার",
  T_38_WZY_WS_SPHERERADIUS: "স্ফেয়ার রেডিয়াস",
  T_38_WZY_WS_SPHERICALJUD_NAMEDESC: "কোনো [এনটিটি] গোলাকার স্কোপের ভিতরে আছে কিনা তা চেক করুন। [কেন্দ্র] এবং [ব্যাসার্ধ] হল গোলাকার কাঠামোর কেন্দ্র এবং ব্যাসার্ধ।",
  T_38_WZY_WS_SPHERICALJUD_RES: "গোলাকার স্কোপ চেকের রেজাল্ট। এটি একটি বুলিয়ান মান।",
  T_38_WZY_WS_SQUAREJUD_NAMEDESC: "একটি [এনটিটি] একটি কিউব স্কোপের মধ্যে আছে কিনা তা চেক করুন। [কেন্দ্র] হল কিউবটির কেন্দ্র, [দৈর্ঘ্য], [প্রস্থ] এবং [উচ্চতা] হলো ঘনকের দৈর্ঘ্য, প্রস্থ এবং উচ্চতা, এবং [ইউলার কোণ] হলো ঐ কিউবটির 3D অরিয়েন্টেশন কোণ।",
  T_38_WZY_WS_SQUAREJUD_RES: "কিউবিক স্কোপ চেক রেজাল্ট। এটি একটি বুলিয়ান মান।",
  T_38_WZY_WS_STARTGENTIME: "স্পন টাইম শুরু",
  T_38_WZY_WS_STAYTIME: "পজ স্থায়ীত্ব",
  T_38_WZY_WS_SWITCHCAM_NAMEDESC: "একজন প্লেয়ারের ক্যামেরা [ক্যামেরা এনটিটি] তে স্যুইচ করুন। [সুইচ মোড] হতে পারে কোনো অ্যানিমেশন বা প্রগ্রেসিভ মুভমেন্ট। [সুইচ টাইম] হলো প্রগ্রেসিভ মোডে স্যুইচ করার সংখ্যা।",
  T_38_WZY_WS_SWITCHCAM_PARAM3_DESC: "ক্যামেরা মোড পরিবর্তন করুন। আপনি কোন অ্যানিমেশন এবং প্রগ্রেসিভ মুভমেন্টের মধ্যে নির্বাচন করতে পারেন।",
  T_38_WZY_WS_SWITCHCAM_PARAM4_DESC: 'প্রগ্রেসিভ মুভমেন্ট মোডের ক্ষেত্রে সুইচ টাইম। "কোনো অ্যানিমেশন নয়" নির্বাচিত হলে, এই সেটিংটি অকার্যকর।',
  T_38_WZY_WS_TEXTHUD: "HUD টেক্সট কম্পোনেন্ট",
  T_38_WZY_WS_TEXTTYPE: "ফন্ট সাইজ",
  T_38_WZY_WS_TEXTUREID: "টেক্সচার টাইপ",
  T_38_WZY_WS_TRANDIST: "ম্যাক্স. দূরত্ব",
  T_38_WZY_WS_TWEENERENABLED: "UITweener স্ক্রিপ্ট চালু করবেন কী না",
  T_38_WZY_WS_TYPELIST: "টাইপ লিস্ট",
  T_38_WZY_WS_TYPELISTORLIST: "টাইপ অথবা টাইপ লিস্ট",
  T_38_WZY_WS_VEST_NAME: "ভেস্ট এনটিটি",
  T_38_WZY_WS_VFX1: "হাইডার এলিমিনেশন",
  T_38_WZY_WS_VFX10: "সাইক্লিক কমবাশন",
  T_38_WZY_WS_VFX11: "পয়জন গ্যাস",
  T_38_WZY_WS_VFX13: "হার্ট",
  T_38_WZY_WS_VFX15: "দরজা",
  T_38_WZY_WS_VFX2: "র‍্যাম্পেজ",
  T_38_WZY_WS_VFX3: "ক্লোন এলিমিনেশন",
  T_38_WZY_WS_VFX4: "হিট ফিডব্যাক",
  T_38_WZY_WS_VFX5: "ক্লোন",
  T_38_WZY_WS_VFX6: "ডিসগাইজ",
  T_38_WZY_WS_VFX7: "ফ্ল্যাশব্যাং স্পার্কস",
  T_38_WZY_WS_VFX8: "মোশন ট্রায়াল",
  T_38_WZY_WS_VFX9: "ফায়ার চার্জ",
  T_38_WZY_WS_VFXENT: "VFX ইনস্টান্স",
  T_38_WZY_WS_VFXTYPEA_NAME: "কাস্টমাইজেবল ম্যাপিং VFX",
  T_38_WZY_WS_VFXTYPEB_NAME: "নন-কাস্টমাইজেবল ম্যাপিং VFX",
  T_38_WZY_WS_VISIBILITY: "ভিজিবিলিটি টাইপ",
  T_38_WZY_WS_VOLUME: "ভলিউম",
  T_38_WZY_WS_WEAPONGEN: "ওয়েপন জেনারেটর",
  T_38_WZY_WS_WHECYCLE: "রি-প্লে",
  T_38_XXJ_WS_BLOCKMODE: "ব্লকড মোড",
  T_38_XXJ_WS_CUSTOMCAMARA: "কাস্টম ক্যামেরা",
  T_38_XXJ_WS_FFCLASSIC: "ক্লাসিক FF (শ্যুটিং)",
  T_38_XXJ_WS_FOV: "ফিল্ড অফ ভিউ",
  T_38_XXJ_WS_FOVDESC: "এই ফিল্ড অফ ভিউ হলো ক্যামেরার পর্যবেক্ষণযোগ্য রেঞ্জ।",
  T_38_XXJ_WS_FPS: "ফার্স্ট পার্সন (শ্যুটিং)",
  T_38_XXJ_WS_HORIZONTALANGLE: "হরাইজন্টাল অ্যাঙ্গেল",
  T_38_XXJ_WS_INVISICAM: "সেমি-ট্রান্সপারেন্ট",
  T_38_XXJ_WS_OFFSET: "অফসেট",
  T_38_XXJ_WS_ORTHOGRAPHIC: "অর্থোগ্রাফিক",
  T_38_XXJ_WS_PERSPECTIVE: "দৃষ্টিকোণ",
  T_38_XXJ_WS_PROJECTIONMODE: "প্রজেকশন মোড",
  T_38_XXJ_WS_STABLE: "নির্ধারিত",
  T_38_XXJ_WS_STARTCAMERA: "ডিফল্ট ক্যামেরা",
  T_38_XXJ_WS_STARTCAMERAMODE: "ডিফল্ট ক্যামেরা মোড",
  T_38_XXJ_WS_THIRD: "ক্যামেরা চেইজ করুন",
  T_38_XXJ_WS_TOPVIEW: "হাই অ্যাঙ্গেল",
  T_38_XXJ_WS_TPS: "তৃতীয় পক্ষ",
  T_38_XXJ_WS_TRANSVERSE: "হরাইজন্টাল মুভমেন্ট",
  T_38_XXJ_WS_VERTICALANGLE: "ভার্টিকাল অ্যাঙ্গেল",
  T_38_XXJ_WS_ZOOM: "জুম",
  T_38_XYL_WS_AISTARTTIME: "শুরুর সময় (s)",
  T_38_XYL_WS_ARMORDESTROY: "আর্মোর ড্যামেজ বৃদ্ধিকারক",
  T_38_XYL_WS_BONFIRE: "বনফায়ার",
  T_38_XYL_WS_CANDLE01: "ক্যান্ডেল A",
  T_38_XYL_WS_CANNON01: "মেকানিক্যাল ক্যানন",
  T_38_XYL_WS_CLIPAMMOSIZE: "ম্যাগাজিন স্টোরেজ",
  T_38_XYL_WS_DAMAGEDTRUCK: "ড্যামেজড ট্রাক",
  T_38_XYL_WS_DOLL01: "এইরি ডল",
  T_38_XYL_WS_ENTERANCEHOUSE01: "ব্ল্যাক হাউজ A",
  T_38_XYL_WS_FENCE002: "আয়রন ফেন্স B",
  T_38_XYL_WS_FIREWORK01: "ফায়ারওয়ার্কস A",
  T_38_XYL_WS_GENERATOR: "জেনারেটর",
  T_38_XYL_WS_GRAVITY: "গ্র্যাভিটেশনাল অ্যাক্সিলারেশন",
  T_38_XYL_WS_GRAVITYAREA: "অ্যাবনর্মাল গ্র্যাভ জোন",
  T_38_XYL_WS_GRAVITYAREA_DESC: "এমন একটি রিজিয়ন যেখানে প্লেয়াররা গ্র্যাভিটি চেঞ্জ করতে পারে",
  T_38_XYL_WS_HOLDWEAPON: "ওয়েপন হোল্ড",
  T_38_XYL_WS_INDOORFURNITURE: "ইনডোর ফার্নিচার",
  T_38_XYL_WS_LIGHTTUBE001: "টিউব লাইট A",
  T_38_XYL_WS_LOVEBALLOON01: "ভ্যালেন্টাইন বেলুন A",
  T_38_XYL_WS_LOVELAMP01: "হার্ট স্ট্রিটলাইট",
  T_38_XYL_WS_LOVESIGN01: "লাভ নিয়নলাইটস",
  T_38_XYL_WS_OILDRUM_DAMAGE: "ওয়েল ব্যারেল ড্যামেজ রেশিও",
  T_38_XYL_WS_OUTDOORPROPS: "আউটডোর আইটেম",
  T_38_XYL_WS_PIPEANDBOX: "পাইপ এবং কন্টেনার",
  T_38_XYL_WS_PLANT: "প্ল্যান্টস",
  T_38_XYL_WS_ROSE01: "গোলাপ",
  T_38_XYL_WS_ROSEN: "রোজ বাকেট",
  T_38_XYL_WS_SMALLBUILDING: "ছোট বিল্ডিং",
  T_38_XYL_WS_SOFA002: "সোফা B",
  T_38_XYL_WS_TOWNHOUSE01: "পুরাতন 2-তলা বাড়ি",
  T_38_XYL_WS_TV001: "ওল্ড টিভি",
  T_38_ZP_CC_EXCHANGESTATUS: "স্ট্যাটাস",
  T_39_BQ_SKILL_NAME_VILLAIN: "ক্রিমসন ক্রাশ",
  T_39_CJ_A_BURN: "ভিক্টোরি গ্লিন্টমার্ক",
  T_39_HJ_WS_Arrow002: "অ্যারো 2",
  T_39_HJ_WS_LIKERATE2: "{0} মিনিট",
  T_39_HJ_WS_LIKERATE3: "{0} - {1} মিনিট",
  T_39_HJ_WS_SOUND10: "স্টেপ",
  T_39_HJ_WS_SOUND11: "মিশন কমপ্লিট 1",
  T_39_HJ_WS_SOUND13: "ড্যাঞ্জার অ্যালার্ট 1",
  T_39_HJ_WS_SOUND14: "ড্যাঞ্জার অ্যালার্ট 2",
  T_39_HJ_WS_SOUND15: "কাউন্টডাউন 3",
  T_39_HJ_WS_SOUND16: "টিপস সাউন্ড",
  T_39_HJ_WS_SOUND17: "ক্রো কাউ",
  T_39_HJ_WS_SOUND18: "একটি ভুল এরিয়াতে টেলিপোর্টিং এর সাউন্ড",
  T_39_HJ_WS_SOUND19: "একটি সঠিক এলাকায় টেলিপোর্ট করার শব্দ",
  T_39_HJ_WS_SOUND2: "কাউন্টডাউন 1",
  T_39_HJ_WS_SOUND20: "টেলিপোর্ট",
  T_39_HJ_WS_SOUND21: "ইলেকট্রিক শক",
  T_39_HJ_WS_SOUND23: "আইটেম অর্জন করুন",
  T_39_HJ_WS_SOUND24: "ইলেকট্রনিক & কিউট BGM",
  T_39_HJ_WS_SOUND25: "ক্যাজুয়াল গেম BGM",
  T_39_HJ_WS_SOUND4: "মেকানিক্যাল ডিভাইস ইকো",
  T_39_HJ_WS_SOUND5: "মশা",
  T_39_HJ_WS_SOUND6: "ডিং ডিং ডিং 1",
  T_39_HJ_WS_SOUND7: "ডিং ডিং ডিং 2",
  T_39_HJ_WS_SOUND8: "গিয়ার সুইচড অন",
  T_39_HJ_WS_SOUND9: "চার্জ 1",
  T_39_HJ_WS_UNLIMITEDGLOOWALL: "আনলিমিটেড গ্লু ওয়াল",
  T_39_HJ_WS_UNLIMITEDTHROWABLES: "আনলিমিটেড থ্রোয়েবলস",
  T_39_HQ_EVOGUN2_SOUNDEQUIP3: "স্পেশাল ফায়ারিং সাউন্ড",
  T_39_HQ_UGC_CUSTOMRES: "কাস্টম রিসোর্সেস",
  T_39_M_ACCOUNTID: "অ্যাকাউন্ট",
  T_39_M_WS_BUTTON_DOUBLECLICKDESC: "ডাবল চেক করে এক্সিকিউট করুন",
  T_39_MF_SKILLTAG_4: "মুভমেন্ট",
  T_39_PD_HuntingGroundSnow_MYNAME: "মি. V",
  T_39_QL_SKILL_OTHO_DES: "প্রতিপক্ষকে নকডাউন দেওয়ার পর, নকডাউন হওয়া প্রতিপক্ষের [FFB300]{0}m[-] এর মধ্যে প্রতিপক্ষদের চিহ্নিত করে এবং তাদের মুভমেন্ট স্পিড [FFB300]{1}%[-] কমিয়ে দেয়।  [FFB300]{2}s[-] পর্যন্ত স্থায়ী হয়। কাছাকাছি থাকা কোনো এনিমি দ্বারা নক ডাউন হলে, আক্রমণকারী এবং তাদের টিমমেটদের চিহ্নিত করে এবং স্পিড কমিয়ে দেয়।",
  T_39_QL_SKILL_WOLFRAHH_DES: "প্রতিপক্ষকে নক-ডাউন করার পরে, হাইলাইট মোডে প্রবেশ করুন, যা রেট অফ ফায়ার [FFB300]{0}%[-] এবং মুভমেন্ট স্পিড [FFB300]{1}%[-] বৃদ্ধি করে কিন্তু তারপর দ্রুত ক্ষয় হয়৷ [FFB300]{2}s[-] পর্যন্ত স্থায়ী হয়। হাইলাইট মোড চলাকালীন, ক্রমাগত প্রতিপক্ষদের নকডাউন দিলে কাউন্টডাউন রিসেট হবে এবং রেট অফ ফায়ার আরও [FFB300]{3}%[-] এবং মুভমেন্ট স্পিড [FFB300]{4}%[-] বৃদ্ধি পাবে।",
  T_39_QL_SKILL_XAYNE_DES1: "এক্সট্রিম মোড: [FFB300]{1}s[-] এর জন্য  [FFB300]{0} অস্থায়ী HP[-] পান৷ এই সময়ে, HP-হিলিং ইফেক্ট [FFB300]{2}%[-] বৃদ্ধি পায়। কুলডাউন: [FFB300]{3}s[-]।",
  T_39_RW_GM_DEFEAT: "ব্যর্থ",
  T_39_RW_SKILL_DESC_FORD: "ড্যামেজ নেয়ার সময় [FFB300]{0}s[-] এর জন্য [FFB300]{1} HP/s[-] লাভ করুন৷ কোনো একটি অ্যাক্টিভ স্কিল রিলিজ করার পরে, এই প্যাসিভ স্কিলটি অবিলম্বে রিসেট করা হবে। কুলডাউন: [FFB300]{2}s[-].",
  T_39_SP_WS_ITEMENTITY_01: "আইটেম এনটিটি",
  T_39_SY_CHARACTER_ALVARO_AWAKENING_N: 'অ্যালভারো "রেজব্লাস্ট"',
  T_39_SY_CHARACTER_VILLAIN_N: "ওরিয়ন",
  T_39_SY_KATANA_FASTBREAKING23_N: "কাটানা- 1001 নাইটস",
  "T_39_SY_PETSKIN_FLYINGCREATURE_FB23 _N": "পেট স্কিন: গ্রীন ইম্প অ্যাভরন",
  "T_39_SY_PETSKIN_TIGER_BDFEST _N": "পেট স্কিন: রয়্যাল টিগ",
  "T_39_SY_PETSKIN_WOLF_SCARLET _N": "পেট স্কিন: স্কোর্পিও ফ্যাং",
  T_39_SY_VEHICLESKIN_MONSTER_TRUCK_FASTBREAKING23_N: "মনস্টার ট্রাক- গ্রীন জায়ান্ট",
  T_39_SY_VEHICLESKIN_TUTU_BDFEST_N: "টুক টুক - ফ্লোরাল চ্যারিওট",
  T_39_WH_SKILL_DESC_GRENADESPLIT: "অ্যাওয়েকেনিং: বিস্ফোরণের [FFB300]{0}s[-] আগে, গ্রেনেডটি [FFB300]{1}[-] এক্সট্রা গ্রেনেডে বিভক্ত হয়ে যাবে, যা এর আসলটির [FFB300]{2}%[-] ড্যামেজ করতে পারে।",
  T_39_WH_SKILL_NAME_GRENADESPLIT: "স্প্লিট ব্লিটজ",
  T_39_WT_WS_EMPTYMAP_TAG: "খালি স্পেস",
  T_39_WT_WS_FEMAPMODE: "মোড টাইটেল",
  T_39_WT_WS_FEMAPTAG: "ম্যাপ টোকেন",
  T_39_WT_WS_MAPPLAYER: "প্লেয়ারের সংখ্যা",
  T_39_WT_WS_MEDENTERNUM: "মিড-গেমে যোগদানকারী প্লেয়ার লিমিট",
  T_39_WT_WS_MIDENTER: "মিড-গেম জয়েনিং",
  T_39_WT_WS_MIDENTERCOUNT: "মিড-গেম জয়েনিং এর কোটা",
  T_39_WT_WS_MIDENTERTIME1: "মিড-গেমে জয়েন করার টাইম-লিমিটেড",
  T_39_WT_WS_MIDENTERTIME2: "মিড-গেম জয়েনিং এর স্থায়িত্ব",
  T_39_WT_WS_MIDENTERTIMETIP: "যখন ম্যাপ প্লেয়ারের সংখ্যা সীমা পৌঁছে না যায়, ম্যাচ শুরু হওয়ার পরে খেলোয়াড়দের N সেকেন্ডের মধ্যে যোগদান করতে এনাবল করুন। প্লেয়ারেরা N সেকেন্ডের পরে যোগ দিতে পারবেন না।",
  T_39_WT_WS_MIDENTERTIP: "এনাবল করা হলে, প্লেয়াররা এই ম্যাপে গেমের মাঝামাঝি যোগ দিতে পারে",
  T_39_WT_WS_PLAYERCOUNT: "প্রাথমিক প্লেয়ার নাম্বার",
  T_39_WT_WS_PLAYERCOUNTTIP: "ম্যাচ শুরু হলে প্লেয়ার নম্বর। আরও প্লেয়াররা খেলার মাঝখানে যোগ দিতে পারে যতক্ষণ না এটি ঐ ম্যাপ লিমিটে পৌঁছায়।",
  T_39_WT_WS_TAG1: "ফ্রি ফর অল",
  T_39_WT_WS_TAG10: "সহজ",
  T_39_WT_WS_TAG11: "মধ্যম",
  T_39_WT_WS_TAG12: "কঠিন",
  T_39_WT_WS_TAG13: "বেশ চ্যালেঞ্জিং",
  T_39_WT_WS_TAG14: "পলায়ন",
  T_39_WT_WS_TAG16: "ভিআইপি",
  T_39_WT_WS_TAG17: "কাস্টম রিসোর্সসমূহ",
  T_39_WT_WS_TAG18: "ধাঁধাঁ",
  T_39_WT_WS_TAG19: "রেসিং",
  T_39_WT_WS_TAG2: "গান ফাইট",
  T_39_WT_WS_TAG20: "মিউজিক",
  T_39_WT_WS_TAG21: "MOBA",
  T_39_WT_WS_TAG22: "অ্যাডভেঞ্চার",
  T_39_WT_WS_TAG23: "জোম্বি হান্ট",
  T_39_WT_WS_TAG24: "PvP",
  T_39_WT_WS_TAG25: "পার্টি গেম",
  T_39_WT_WS_TAG26: "টিম ডেথম্যাচ",
  T_39_WT_WS_TAG27: "টারেট ডিফেন্স",
  T_39_WT_WS_TAG28: "ট্রেনিং",
  T_39_WT_WS_TAG3: "গান কিং",
  T_39_WT_WS_TAG4: "রিস্পন",
  T_39_WT_WS_TAG5: "স্নাইপার",
  T_39_WT_WS_TAG6: "সার্ভাইভাল",
  T_39_WT_WS_TAG7: "সলো",
  T_39_WT_WS_TAG8: "ভৌতিক",
  T_39_WT_WS_TAG9: "ক্যাজুয়াল",
  T_39_WT_WS_TAGMAXTIP: "সর্বোচ্চ {0}টি পর্যন্ত ট্যাগ সিলেক্ট করুন",
  T_39_WT_WS_TAGTYPE1: "গেমপ্লে টাইপ",
  T_39_WT_WS_TAGTYPE2: "ম্যাপ টাইপ",
  T_39_WT_WS_TAGTYPE3: "মোড টাইপ",
  T_39_WT_WS_TAGTYPE4: "টিম সাইজ",
  T_39_WZY_WS_ACCSPEED: "অ্যাক্সিলারেশন",
  T_39_WZY_WS_ADDSCRIPT_NAMEDESC: "[Entity]-এর জন্য স্ক্রিপ্ট [Script Name] যোগ করুন",
  T_39_WZY_WS_ASC: "ঊর্ধ্বগামী",
  T_39_WZY_WS_ASCIGZERO: "উর্ধগামী ব্যবহার করলে জিরো কে এড়িয়ে যান",
  T_39_WZY_WS_BALLISTMOVENT: "ব্যালিস্টিক মোশন এনটিটি",
  T_39_WZY_WS_BEUSED_NAMEDESC: "[প্লেয়ার এনটিটি] আইটেমটি ব্যবহার করলে ইভেন্টটি ট্রিগার করে",
  T_39_WZY_WS_BODYSCALE: "বডি স্কেল",
  T_39_WZY_WS_BRAKETORQUE: "ব্রেক হর্সপাওয়ার",
  T_39_WZY_WS_CAMTRANTYPE: "ক্যামেরা ট্রানজিশন টাইপ",
  T_39_WZY_WS_CARVEHICLE: "4-হুইলার",
  T_39_WZY_WS_CHECKSCRIPT_NAMEDESC: "একটি নির্দিষ্ট স্ক্রিপ্ট [Script Name] [Entity]-এ বিদ্যমান কিনা তা পরীক্ষা করুন। (প্রত্যাবর্তিত মান বুলিয়ান হবে)",
  T_39_WZY_WS_CHECKSCRIPT_RES: "এনটিটির নির্দিষ্ট স্ক্রিপ্টের রেজাল্ট আছে কিনা তা চেক করুন (বুলিয়ান)",
  T_39_WZY_WS_COMBINEALL: "ডুয়েল-ওয়েল্ডিং (ভিন্ন গান)",
  T_39_WZY_WS_COMBINESELF: "ডুয়েল-ওয়েল্ডিং (একই গান)",
  T_39_WZY_WS_CONENAME: "বেসিক কোন",
  T_39_WZY_WS_COORSYS: "কো-অর্ডিনেট সিস্টেম",
  T_39_WZY_WS_CRASHMAXD: "ম্যাক্স ক্রাশ ড্যামেজ",
  T_39_WZY_WS_CRASHMIND: "মিনিমাম ক্রাশ ড্যামেজ",
  T_39_WZY_WS_CRAWLSPEED: "মুভমেন্ট স্পিড পার্সেন্টেজ (প্রোন)",
  T_39_WZY_WS_CREBALLISTMOV_NAMEDESC: "[টার্গেট এনটিটি] এর জন্য ব্যালিস্টিক মোশন তৈরি করুন। টার্গেট এনটিটির জন্য প্রাথমিক গতির দিকে সঞ্চিত [প্রাথমিক স্পিড], [অ্যাক্সিলারেশন] এবং [সর্বোচ্চ দূরত্ব] এডিট করতে পারে এবং [ব্যালিস্টিক মোশন এনটিটি] রিটার্ন হয়।",
  T_39_WZY_WS_CRETWEEN_NAME: "ইন্টারপোলেশন মোশন সৃষ্টি করুন",
  T_39_WZY_WS_CRETWEEN_NAMEDESC: "[সময়ের] মধ্যে [শুরু ভ্যাল্যু] থেকে [টার্গেট ভ্যাল্যু] এ সত্তার [অ্যাট্রিবিউট] সহ [এনটিটি] এর জন্য একটি ইন্টারপোলেশন মোশন তৈরি করুন। [মেথড] [একমুখী], [পিংপং], [কার্ভ] সহ গতির পথকে প্রতিনিধিত্ব করে। [বক্ররেখা] গতির বক্ররেখা। এবং [ইন্টারপোলেশন মোশন এনটিটি] গতি তৈরি করার পরে রিটার্ন আসে।",
  T_39_WZY_WS_CURVE: "বাঁক",
  T_39_WZY_WS_CUSTRESULT: "কাস্টম ম্যাচ রেজাল্ট",
  T_39_WZY_WS_CYLINDERNAME: "বেসিক সিলিন্ডার",
  T_39_WZY_WS_DEFAULT: "কোনো অ্যানিমেশন নয় (ডিফল্ট)",
  T_39_WZY_WS_DESC: "অবতরণ",
  T_39_WZY_WS_DIFFUSEALPHA: "সার্ফেসের স্বচ্ছতা",
  T_39_WZY_WS_DISCONNECT: "ডিসকানেক্ট",
  T_39_WZY_WS_DOUBLEJUMPSHOE_ENERGYRECOVERY: "প্রতি সেকেন্ডে এনার্জি রিকোভারি",
  T_39_WZY_WS_DOUBLEJUMPSHOE_JUMCONSUME: "এনার্জি ব্যয় করুন",
  T_39_WZY_WS_DOUBLEJUMPSHOE_MAXJUMPH: "ম্যাক্স দ্বিতীয় জাম্প হাইট",
  T_39_WZY_WS_ENABLEJOIN: "মাঝপথে যোগদানের অনুমতি দিন",
  T_39_WZY_WS_ENDPOS: "সমাপ্তি পয়েন্ট কো-অর্ডিনেটস",
  T_39_WZY_WS_ENGINETORQUE: "ইঞ্জিন হর্সপাওয়ার",
  T_39_WZY_WS_EXPLODED: "এক্সপ্লোশন ড্যামেজ",
  T_39_WZY_WS_FEELDSPEED: "মুভমেন্ট স্পিড পার্সেন্টেজ (ডাউনড)",
  T_39_WZY_WS_FLASH_CFLASHTIME: "সেন্টার ফ্ল্যাশ টাইম",
  T_39_WZY_WS_FLASH_CRANGE: "কেন্দ্রীয় রেঞ্জ",
  T_39_WZY_WS_FLASH_EFLASHTIME: "এজ ফ্ল্যাশ গেম",
  T_39_WZY_WS_FLASH_HITEFFECTSWITCH: "ফ্ল্যাশমব হিট ইফেক্ট",
  T_39_WZY_WS_FLASH_RANGE: "এক্সপ্লোশন রেঞ্জ",
  T_39_WZY_WS_FOLDWINGS_FALLSPEED: "হ্রাসমান গতি",
  T_39_WZY_WS_FOLDWINGS_FLYMAXH: "সর্বোচ্চ উচ্চতা",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDH: "অনুভূমিক গ্লাইড স্পিড",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDV: "ভার্টিকাল গ্লাইড স্পিড",
  T_39_WZY_WS_FOLDWINGS_MINENDH: "ন্যূনতম শেষ উচ্চতা",
  T_39_WZY_WS_FOLDWINGS_MINFLYH: "ন্যূনতম টেকঅফ উচ্চতা",
  T_39_WZY_WS_FOLDWINGS_OVERHFALLSPEED: "অতি উচ্চতার পর অবতরণের গতি",
  T_39_WZY_WS_FOLDWINGS_TURNSPEED: "টার্নিং স্পিড",
  T_39_WZY_WS_FOLMOVENT: "মোশন এনটিটিকে অনুসরণকৃত পজিশন",
  T_39_WZY_WS_GETSKILLLIST_NAMEDESC: "[প্লেয়ার এনটিটি] এর স্কিল লিস্ট অর্জন করুন",
  T_39_WZY_WS_HB_BOOSTCD: "স্প্রিন্ট কুলডাউন",
  T_39_WZY_WS_HB_BOOSTDURATION: "স্প্রিন্ট স্থায়িত্ব",
  T_39_WZY_WS_HB_BOOSTINITIAL: "স্কাইবোর্ডে স্প্রিন্ট কুলডাউন",
  T_39_WZY_WS_HB_BOOSTINITIALSWITCH: "স্কাইবোর্ডে স্প্রিন্ট কুলডাউন",
  T_39_WZY_WS_HB_BOOSTSPEED: "স্প্রিন্ট স্পিড",
  T_39_WZY_WS_HB_HOVERBCD: "স্কাইবোর্ড কুলডাউন",
  T_39_WZY_WS_HB_JUMPCD: "জাম্প কুলডাউন",
  T_39_WZY_WS_HB_JUMPH: "স্কাইবোর্ড জাম্প হাইট",
  T_39_WZY_WS_HEADSCALE: "হেড স্কেল",
  T_39_WZY_WS_HEADSHOTDESCALE: "হেডশট ড্যামেজ রিডাকশন",
  T_39_WZY_WS_INTITALSPEED: "প্রাথমিক গতি",
  T_39_WZY_WS_INVENTORYBASE: "বেসিক আইটেম টাইপ",
  T_39_WZY_WS_JETSHOE_BASEENERGYCOST: "প্রতি সেকেন্ডে এনার্জি কস্ট",
  T_39_WZY_WS_JETSHOE_BASEHSPEED: "মৌলিক অনুভূমিক গতি",
  T_39_WZY_WS_JETSHOE_BASEVSPEED: "বেসিক ভার্টিক্যাল স্পিড",
  T_39_WZY_WS_JETSHOE_DASHENERGYCOST: "প্রতি সেকেন্ডে ড্যাশ এনার্জি ব্যয়",
  T_39_WZY_WS_JETSHOE_DASHHSPEED: "স্প্রিন্ট হরিজন্টাল স্পিড",
  T_39_WZY_WS_JETSHOE_RUSHDIS: "স্প্রিন্ট দূরত্ব",
  T_39_WZY_WS_JETSHOE_RUSHENERGYCOST: "প্রতি সেকেন্ডে রাশ এনার্জি খরচ",
  T_39_WZY_WS_JETSHOE_RUSHVSPEED: "স্প্রিন্ট ভার্টিক্যাল স্পিড",
  T_39_WZY_WS_JETSHOE_UPENERGYCOST: "প্রতি সেকেন্ডে আপওয়ার্ড এনার্জি কস্ট",
  T_39_WZY_WS_LANDMINE_CANBEATTACK: "অ্যাটাকযোগ্য",
  T_39_WZY_WS_LANDMINE_CANSELFTRIGGER: "সেলফ-ট্রিগারেবল",
  T_39_WZY_WS_LANDMINE_CANTEAMTRIGGER: "মিত্রদের দ্বারা ট্রিগার করা যাবে কিনা",
  T_39_WZY_WS_LANDMINE_CANVEHICLETRIGGER: "ভেহিক্যাল দিয়ে ট্রিগারযোগ্য",
  T_39_WZY_WS_LANDMINE_LIFETIME: "স্থায়িত্ব",
  T_39_WZY_WS_LANDMINE_STARTTIME: "অ্যাক্টিভেশন টাইম",
  T_39_WZY_WS_LANDMINE_TRIGGERRADIUS: "ট্রিগার রেডিয়াস",
  T_39_WZY_WS_LANDMINE_TRIGGERTIME: "ট্রিগার টাইম",
  T_39_WZY_WS_LEAVE: "বর্জন",
  T_39_WZY_WS_LIMBSCALE: "অঙ্গ-প্রত্যঙ্গের স্কেল",
  T_39_WZY_WS_LISTLOCSTR: "স্থানীয়কৃত টেক্সট লিস্ট",
  T_39_WZY_WS_LOADRESULT_NAME: "আপলোড ব্যাটেল রেজাল্ট",
  T_39_WZY_WS_LOADRESULT_NAMEDESC: "[র‍্যাংক], [রেজাল্ট], [স্কোর নাম], [স্কোর ভ্যাল্যু] সহ [প্লেয়ার] এর ব্যাটেল রেজাল্ট আপলোড করুন। রেজাল্টের টাইপ হবে পূর্ণসংখ্যা। জয়ের জন্য 1, পরাজয়ের জন্য 2, Booyah এর জন্য 3 এবং ড্রয়ের জন্য 4",
  T_39_WZY_WS_LOOKMOVENT: "গেইজ-ফলোয়িং মোশন এনটিটি",
  T_39_WZY_WS_MAXCOUNT: "সর্বোচ্চ পরিমাণ",
  T_39_WZY_WS_MAXDISTANCE: "সর্বোচ্চ দূরত্ব",
  T_39_WZY_WS_MINISENTRY_ANGELDOWN: "টারেট ডিপ্রেশন অ্যাঙ্গেল",
  T_39_WZY_WS_MINISENTRY_ANGELSPEED: "টারেট অ্যাংগুলার স্পিড",
  T_39_WZY_WS_MINISENTRY_ANGELUP: "টারেট এলিভেশন অ্যাঙ্গেল",
  T_39_WZY_WS_MINISENTRY_DAM: "টারেট ড্যামেজ",
  T_39_WZY_WS_MINISENTRY_DEFENSE: "ড্যামেজ রিডাকশন রেট",
  T_39_WZY_WS_MINISENTRY_FIREANGLE: "ফায়ারিং অ্যাঙ্গেল",
  T_39_WZY_WS_MINISENTRY_HITCHANCE: "টারেট হিট রেট",
  T_39_WZY_WS_MINISENTRY_INTERVAL: "টারেট অ্যাটাক ইন্টারভল",
  T_39_WZY_WS_MINISENTRY_MAXCOUNT: "ম্যাক্স টারেট নাম্বার",
  T_39_WZY_WS_MINISENTRY_RANGE: "টারেট অ্যাটাক রেঞ্জ",
  T_39_WZY_WS_MOVEENT: "মোশন এনটিটি",
  T_39_WZY_WS_NOCOMBINE: "দ্বৈত-চালিত নয়",
  T_39_WZY_WS_ONCE: "একবার",
  T_39_WZY_WS_ONDROP_NAMEDESC: "[প্লেয়ার এনটিটি] আইটেমটি বাতিল করলে ইভেন্টটি ট্রিগার করে",
  T_39_WZY_WS_ONEQUIP_NAMEDESC: "আইটেমটি [প্লেয়ার এনটিটি] দ্বারা ইকুইপ করা হলে ইভেন্টটি ট্রিগার করে",
  T_39_WZY_WS_ONGRAPFIRE_NAMEDESC: "যখন হুক গান ফায়ার করে, তখন ইনসিডেন্ট ট্রিগার করে",
  T_39_WZY_WS_ONLANDSTART_NAMEDESC: "ল্যান্ডমাইন অ্যাক্টিভেট করা হলে ইভেন্টটি ট্রিগার করে",
  T_39_WZY_WS_ONLANDTRIGGER_NAMEDESC: "[প্লেয়ার এনটিটি] দ্বারা ল্যান্ডমাইন ট্রিগার হলে ইভেন্টটি ট্রিগার করে",
  T_39_WZY_WS_ONMOTIONPAUSE_NAMEDESC: "এনটিটি মোশন থেমে যায় তখন ট্রিগার হয়",
  T_39_WZY_WS_ONMOTIONREATART_NAMEDESC: "যখন এনটিটি পজ থেকে রিস্টার্ট করে তখন ট্রিগার হয়",
  T_39_WZY_WS_ONMOTIONSTART_NAMEDESC: "কোনো এনটিটি মুভিং শুরু করলে ট্রিগার করে",
  T_39_WZY_WS_ONPICKUP_NAMEDESC: "[প্লেয়ার এন্টিটি] আইটেমটি পিক-আপ করা হলে ইভেন্টটি ট্রিগার করে",
  T_39_WZY_WS_ONTHROWHIT_NAMEDESC: "থ্রোয়েবল যখন টার্গেট হিট করে তখন ইনসিডেন্ট ট্রিগার করে",
  T_39_WZY_WS_OPENATTACK: "অ্যাটাক এনাবল করা হবে কি না",
  T_39_WZY_WS_PAUSEMOV_NAMEDESC: "মোশন এনটিটি বা মোশন এনটিটি লিস্ট পজ করুন",
  T_39_WZY_WS_PAUSESOUND_NAME: "সাউন্ড ইফেক্ট পজ করুন",
  T_39_WZY_WS_PAUSESOUND_NAMEDESC: "সাউন্ড এনটিটি বা সাউন্ড এনটিটি লিস্ট পজ করুন",
  T_39_WZY_WS_PIANOTYPE: "মিউজিক কম্পোনেন্ট টাইপ",
  T_39_WZY_WS_PINGPONG: "পিংপং",
  T_39_WZY_WS_PLAYABLELIST: "মোশন এনটিটি লিস্ট",
  T_39_WZY_WS_PLAYINGSTATUE: "স্ট্যাটাস",
  T_39_WZY_WS_PLAYMOV_NAMEDESC: "পজ করা মোশন এন্টিটি বা মোশন এন্টিটি লিস্ট রিস্টোর করুন। পুনরায় শুরু বা রিস্টার্ট করতে বেছে নিতে পারেন।",
  T_39_WZY_WS_PLAYSOUND_NAME: "সাউন্ড ইফেক্ট প্লে করুন",
  T_39_WZY_WS_PLAYSOUND_NAMEDESC: "পজ করা সাউন্ড এন্টিটি বা সাউন্ড এন্টিটি লিস্ট রিস্টোর করুন। পুনরায় শুরু বা পুনরায় চালু করতে বেঁছে নিতে পারেন",
  T_39_WZY_WS_PROCIRCLE_NAME: "প্রগ্রেস সার্কেল",
  T_39_WZY_WS_RAYINSPCON_NAMEDESC: "[প্রাথমিক স্থানাঙ্ক] থেকে [ডিরেকশন] বরাবর একটি রশ্মি নির্গত করে, [দূরত্ব] এর মধ্যে প্রথম এনটিটি হিট শনাক্ত করে এবং [আঘাতপ্রাপ্ত এনটিটি লিস্ট] এবং [আঘাতপ্রাপ্ত কোঅর্ডিনেটস লিস্ট] রিটার্ন করে।",
  T_39_WZY_WS_RAYINSPSIN_NAMEDESC: "[প্রাথমিক কোঅর্ডিনেটস] থেকে [ডিরেকশন] বরাবর একটি রশ্মি নির্গত করে, [দূরত্ব] এর মধ্যে প্রথম এনটিটি হিট শনাক্ত করে এবং [এনটিটি হিট] এবং [কোঅর্ডিনেট হিট] রিটার্ন করে",
  T_39_WZY_WS_REAHEALHP: "আর্মর রিকোভারি ভ্যাল্যু",
  T_39_WZY_WS_REAHEALTIME: "ইন-ইফেক্ট টাইম ইন্টারভাল",
  T_39_WZY_WS_RELATCOORSYS: "রিলেটিভ কোঅর্ডিনেট সিস্টেম",
  T_39_WZY_WS_REPAIRARM: "রিপেয়ার কিট",
  T_39_WZY_WS_REVERSE: "রিভার্স",
  T_39_WZY_WS_RIMALPHA: "প্রান্তভাগের স্বচ্ছতা",
  T_39_WZY_WS_SCORENAME: "স্কোরের নাম",
  T_39_WZY_WS_SENDSIGN_NAMEDESC: "টার্গেট এন্টিটিতে একটি সংকেত পাঠান, আপলোড করা প্যারামিটারগুলো পূর্বনির্ধারিত সংকেত প্যারামিটার দ্বারা সংজ্ঞায়িত করা হয়। সংজ্ঞার সময় এনটিটির ধরন নির্বাচন সংশ্লিষ্ট সংকেত গ্রহণ ইভেন্ট তৈরি করবে।",
  T_39_WZY_WS_SETFOLMOV_NAMEDESC: "[টার্গেট এনটিটি] এর জন্য গতি অনুসরণ করে একটি পজিশন তৈরি করুন। [টার্গেট এনটিটি] অনুসরণ করে [অনুসরণকারী সত্তা]। [অফসেট স্থানাঙ্ক] হল [টার্গেট এনটিটি] এবং [অনুসরণকারী এনটিটি]-এর মধ্যে স্থানাঙ্ক অফসেট। [কোঅর্ডিনেট সিস্টেম] অনুসরণকারী এনটিটির অভিযোজনের উপর ভিত্তি করে ওয়ার্ল্ড কোঅর্ডিনেট সিস্টেম এবং আপেক্ষিক সমন্বয় ব্যবস্থা সিলেক্ট করতে পারে। মোশন তৈরি করার পর [মোশন এনটিটি অনুসরণকারী পজিশন] রিটার্ন করা হবে।",
  T_39_WZY_WS_SETLOOKMOV_NAMEDESC: "[টার্গেট এন্টিটি]-এর জন্য একটি দৃষ্টি-অনুসরণকারী মোশন তৈরি করুন। [টার্গেট এন্টিটি] অনুসরণ করে [অনুসরণকারী সত্তা]। [অফসেট কোঅর্ডিনেটস] হল [টার্গেট এন্টিটি] এবং [অনুসরণকারী সত্তা]-এর মধ্যে কোঅর্ডিনেট অফসেট। [কোঅর্ডিনেট সিস্টেম] অনুসরণকারী সত্তার অভিযোজনের উপর ভিত্তি করে ওয়ার্ল্ড কোঅর্ডিনেট সিস্টেম এবং আপেক্ষিক কোঅর্ডিনেট সিস্টেম সিলেক্ট করতে পারে। মোশন তৈরি করার পর [গেজ-ফলোয়িং মোশন এন্টিটি] ফিরিয়ে দেওয়া হবে।",
  T_39_WZY_WS_SHOE_FALLDAMSCALE: "ফলিং ড্যামেজ পার্সেন্টেজ",
  T_39_WZY_WS_SHOE_MAXENERGY: "ম্যাক্স. এনার্জি",
  T_39_WZY_WS_SKILLLIST: "স্কিল লিস্ট",
  T_39_WZY_WS_SKILLTYPE: "ক্যারেক্টার স্কিল",
  T_39_WZY_WS_SMOKEG_EFFECTTIME: "স্মোক ইফেক্ট ডিউরেশন",
  T_39_WZY_WS_SMOOTH: "ক্যামেরা স্যুইচ",
  T_39_WZY_WS_SOUNDENTL: "সাউন্ড ইফেক্ট এনটিটি লিস্ট",
  T_39_WZY_WS_SOUNDENTLORSENT: "সাউন্ড ইফেক্ট এনটিটি বা লিস্ট",
  T_39_WZY_WS_SPRINTSPEED: "স্প্রিন্ট স্পিড পার্সেন্টেজ",
  T_39_WZY_WS_SQUATSPEED: "মুভমেন্ট স্পিড পার্সেন্টেজ (স্কোয়াট)",
  T_39_WZY_WS_STARTCOO: "প্রাথমিক কোঅর্ডিনেটস",
  T_39_WZY_WS_STATE: "প্লে স্ট্যাটাস",
  T_39_WZY_WS_TARGETVAL: "টার্গেট ভ্যাল্যু",
  T_39_WZY_WS_THROWSPEED: "হুক ফ্লায়িং স্পিড",
  T_39_WZY_WS_TOWER_PARAM10: "রোটেশন অ্যাঙ্গেল",
  T_39_WZY_WS_TOWER_PARAM11: "টারেট স্ট্যাটাস",
  T_39_WZY_WS_TOWER_PARAM12: "এনটিটি আইডি",
  T_39_WZY_WS_TOWER_PARAM9: "অ্যাটাক টার্গেট",
  T_39_WZY_WS_TOWSPEED: "প্লেয়ার ট্রাভেলিং স্পিড",
  T_39_WZY_WS_TWEENCURVE_NAME: "কাস্টম কার্ভ",
  T_39_WZY_WS_TWEENCURVE_NAMEDESC: "ইন্টারপোলেশন মোশনের জন্য কাস্টম কার্ভ ব্যবহার করা যেতে পারে",
  T_39_WZY_WS_TWEENENT: "ইন্টারপোলেশন মোশন এনটিটি",
  T_39_WZY_WS_TWEENPLAYST_NAME: "মোশন মেথডসমূহ",
  T_39_WZY_WS_TWEENPLAYST_NAMEDESC: "ইন্টারপোলেশন মোশনের মেথড",
  T_39_WZY_WS_TWEENSTYLE: "মেথড",
  T_39_WZY_WS_UNLOADSCRIPT_NAMEDESC: "[এন্টিটি]-এর জন্য স্ক্রিপ্ট [স্ক্রিপ্টের নাম] ডিলিট করুন",
  T_39_WZY_WS_UPSET_NAMEDESC: "লিস্টে থাকা ইলিমেন্টগুলো র‍্যান্ডমাইজ করুন",
  T_39_WZY_WS_VISIBLEONBACK: "পেছনে দৃশ্যমান",
  T_39_WZY_WS_WEAPCOMBINET: "ডুয়েল-উইল্ডিং ওয়েপন টাইপ",
  T_39_WZY_WS_WEAPON_KNOCKDOWNDAM: "যাদের ডাউন করা হয়েছে, তাদের এক্সট্রা ড্যামেজ",
  T_39_WZY_WS_WEAPON_ONCEAMMO: "সিঙ্গেল শট বুলেট নাম্বার",
  T_39_WZY_WS_WEAREPLAY: "মোশন রিস্টার্ট করবেন?",
  T_39_WZY_WS_WORLDCOORSYS: "ওয়ার্ল্ড কোঅর্ডিনেট সিস্টেম",
  T_39_XXJ_WS_ADDFRIEND: "ফ্রেন্ড এড করুন",
  T_39_XXJ_WS_ALLOWZ: "প্লেয়ার x-অক্ষ মুভমেন্ট এনাবল করুন",
  T_39_XXJ_WS_BLOCKMODEDESC: "ক্যামেরা এবং টার্গেটের মাঝে কোনো একটি অবজেক্ট থাকলে ক্যামেরা মোশন",
  T_39_XXJ_WS_CAMERADISTANCE: "টার্গেট থেকে দূরত্ব",
  T_39_XXJ_WS_CAMERATYPEDESC: "একাধিক ধরনের প্রিসেট এবং কাস্টম ক্যামেরা দেওয়া হয়",
  T_39_XXJ_WS_CAMERAUSER: "ক্যামেরা ইউজার",
  T_39_XXJ_WS_CURENTCAMERA: "ব্যবহৃত ক্যামেরা",
  T_39_XXJ_WS_DETAILS: "ম্যাচ বিস্তারিত",
  T_39_XXJ_WS_FFECONOMY: "ইকোনোমি",
  T_39_XXJ_WS_FOCUSTARGET: "অবজার্ভকৃত টার্গেট",
  T_39_XXJ_WS_FOLLOWTARGET: "অনুসরণকৃত টার্গেট",
  T_39_XXJ_WS_GAMERESULT: "ম্যাচ রেজাল্ট",
  T_39_XXJ_WS_GAMETITLE1: "ম্যাচ 1",
  T_39_XXJ_WS_GAMETITLE2: "ম্যাচ 2",
  T_39_XXJ_WS_GIFT: "গিফট",
  T_39_XXJ_WS_HORIZONTALANGLEDESC: "ক্যামেরার অনুভূমিক রোটেশন অ্যাংগেল",
  T_39_XXJ_WS_INVISICAM: "স্বচ্ছ",
  T_39_XXJ_WS_INVISICAMDESC: "ক্যামেরা এবং টার্গেটের মধ্যবর্তী অবজেক্টটি স্বচ্ছ হয়ে যায়",
  T_39_XXJ_WS_LEFTSCORE: "বাম টিমের স্কোর",
  T_39_XXJ_WS_LIKE: "লাইক",
  T_39_XXJ_WS_LOBBY: "লবি",
  T_39_XXJ_WS_MAINSCORENAME: "সর্বমোট স্কোরের নাম",
  T_39_XXJ_WS_MAINSCORENUM: "মোট স্কোর নাম্বার",
  T_39_XXJ_WS_MAPEVALUATE: "ম্যাপ রেটিং",
  T_39_XXJ_WS_MULTITEAMRESULTHUD: "একাধিক টিমের রেজাল্ট",
  T_39_XXJ_WS_MVP1: "MVP 1",
  T_39_XXJ_WS_MVP2: "MVP 2",
  T_39_XXJ_WS_OFFSET2: "অবজারভেশন পয়েন্ট অফসেট",
  T_39_XXJ_WS_OFFSET2DESC: "সাধারণত প্লেয়ারের আসল অবস্থানের সাথে সম্পর্কিত ক্যামেরা ফোকাস পয়েন্টের অফসেটকে বোঝায়। (অর্থ ক্যামেরার ধরন অনুসারে পরিবর্তিত হয়)",
  T_39_XXJ_WS_OFFSETDESC: "সাধারণত প্লেয়ারের আসল অবস্থানের তুলনায় ক্যামেরা অবস্থানের অফসেটকে বোঝায়। (অর্থ ক্যামেরার ধরন অনুসারে পরিবর্তিত হয়)",
  T_39_XXJ_WS_ORTHOGONAL: "অর্থোগোনাল",
  T_39_XXJ_WS_ORTHOGONALDESC: "ক্যামেরা একই সাইজ হিসাবে দূরবর্তী এবং কাছাকাছি টার্গেটগুলোকে চিত্রিত করে",
  T_39_XXJ_WS_PERSPECTIVE: "দৃষ্টিকোণ",
  T_39_XXJ_WS_PERSPECTIVEDESC: "ক্যামেরা টার্গেট সেভ করতে পারস্পেকটিভ প্রজেকশন ব্যবহার করে",
  T_39_XXJ_WS_PROJECTIONMODEDESC: "রেন্ডারিং এর সময় ক্যামেরার ইমেজ ফর্মেশন",
  T_39_XXJ_WS_RANK1: "টিম র‍্যাংক",
  T_39_XXJ_WS_RANK2: "প্লেয়ার র‍্যাংক",
  T_39_XXJ_WS_REPORT: "রিপোর্ট",
  T_39_XXJ_WS_REVIEW: "রিপ্লে",
  T_39_XXJ_WS_RIGHTSCORE: "ডান টিমের স্কোর",
  T_39_XXJ_WS_SCORENUM1: "স্কোর 1",
  T_39_XXJ_WS_SCORENUM2: "স্কোর 2",
  T_39_XXJ_WS_SCORENUM3: "স্কোর 3",
  T_39_XXJ_WS_SCORENUM4: "স্কোর 4",
  T_39_XXJ_WS_SCORENUM5: "স্কোর 5",
  T_39_XXJ_WS_SCORETITLELIST: "স্কোর নাম লিস্ট",
  T_39_XXJ_WS_SHARE: "শেয়ার",
  T_39_XXJ_WS_SPECTATORSWITCH: "দর্শক",
  T_39_XXJ_WS_STABLE: "স্থির",
  T_39_XXJ_WS_STABLEDESC: "ক্যামেরা এবং অনুসরণ করা এনটিটির মধ্যে কোনো অবজেক্ট থাকলে ক্যামেরা স্থিতিশীল থাকে",
  T_39_XXJ_WS_TEAMNAME1: "বাদিকের টিমের নাম",
  T_39_XXJ_WS_TEAMNAME2: "ডান টিমের নাম",
  T_39_XXJ_WS_TEAMRANK: "টিম র‍্যাংক",
  T_39_XXJ_WS_TRANSITIONTIME: "ক্যামেরা ট্রানজিশন টাইম",
  T_39_XXJ_WS_TRANSITIONTYPE: "ক্যামেরা ট্রানজিশন টাইপ",
  T_39_XXJ_WS_TWOTEAMRESULTHUD: "2 টিমের রেজাল্ট",
  T_39_XXJ_WS_VERTICALANGLEDESC: "ক্যামেরার ভার্টিক্যাল রোটেশন অ্যাঙ্গেল",
  T_39_XXJ_WS_ZOOM: "জুম",
  T_39_XXJ_WS_ZOOMDESC: "ক্যামেরা এবং অনুসরণ করা এনটিটির মধ্যে কোনো অবজেক্ট থাকলে ক্যামেরা জুম ইন করে৷",
  T_39_XYL_WS_LIGHTINTENSITY: "হালকা ঘনত্ব",
  T_39_XYL_WS_LIGHTRANGE: "লাইট রেঞ্জ",
  T_39_XYL_WS_POINTLIGHT: "পয়েন্টলাইট",
  T_39_XYL_WS_WATERZONE: "কাস্টম ওয়াটার জোন",
  T_40_B_DISABLE_RECONNECT: "অটো-রিকানেকশন ডিজেবল করুন",
  T_40_CJ_T_SHUTTLECOCK_BLACK: "মিডনাইট জার্সি",
  T_40_CJ_T_SHUTTLECOCK_RED2: "আর্কটিক ব্লেইজ জার্সি",
  T_40_CJ_T_SHUTTLECOCK_REDBLACK: "চেরি কোল জার্সি",
  T_40_CJ_T_SHUTTLECOCK_YELLOW: "সানি স্কাই জার্সি",
  T_40_CJ_T_SPORTSWEAR_FIRE: "ফ্লেইম আপ জার্সি",
  T_40_DYEING_CLEAR: "কালারিং স্ট্যাটাস ক্লিয়ার করুন",
  T_40_HJ_WS_EFFECT32: "স্নিকার্স",
  T_40_HJ_WS_EFFECT33: "বিস্ফোরণ",
  T_40_HJ_WS_EFFECT34: "স্পনপয়েন্ট",
  T_40_HJ_WS_EFFECT35: "লেজার",
  T_40_HJ_WS_EFFECT36: "অ্যামো",
  T_40_HJ_WS_EFFECT37: "হিট ইফেক্ট",
  T_40_HJ_WS_EFFECT38: "ফায়ারিং ইফেক্ট",
  T_40_HJ_WS_EFFECT43: "স্পাইডার ওয়েব",
  T_40_HJ_WS_EFFECT44: "একটি স্কিল রিলিজ হচ্ছে",
  T_40_HJ_WS_SOUND69: "একটি বক্স ওপেন করছেন",
  T_40_HJ_WS_SOUND70: "লেভেল-আপ",
  T_40_HJ_WS_SOUND71: "লেভেল ম্যাক্সড",
  T_40_HJ_WS_SOUND72: "একটি বাটন ট্যাপ করছেন",
  T_40_HJ_WS_SOUND73: "কাউন্টডাউন 1",
  T_40_HJ_WS_SOUND74: "হুইসেল",
  T_40_HJ_WS_SOUND75: "গেম ওভার",
  T_40_HJ_WS_SOUND76: "ফরোয়ার্ড",
  T_40_HJ_WS_SOUND77: "Booyah",
  T_40_HJ_WS_SOUND78: "চেকপয়েন্ট",
  T_40_HJ_WS_SOUND79: "কাউন্টডাউন 2",
  T_40_HJ_WS_SOUND80: "গেম শুরু",
  T_40_HJ_WS_SOUND81: "অনেক কয়েন অর্জন করেছেন",
  T_40_HJ_WS_SOUND82: "অর্জনকৃত কয়েন",
  T_40_HJ_WS_SOUND83: "কিছু কয়েন অর্জিত",
  T_40_HJ_WS_SOUND84: "গেমে জয়েন করেছে",
  T_40_HJ_WS_SOUND85: "গিল্ড সাপ্লাই ওপেন করা হচ্ছে",
  T_40_HJ_WS_SOUND86: "হর্ণ",
  T_40_HJ_WS_SOUND87: "একজন বসকে এলিমিনেট করা হয়েছে",
  T_40_HJ_WS_SOUND88: "ওয়ার চেস্ট ওপেন হচ্ছে",
  T_40_HJ_WS_SOUND89: "এক্সপ্লোসিভ পেইন্ট স্কিল",
  T_40_HJ_WS_SOUND90: "বুলেট হিটিং",
  T_40_HJ_WS_SOUND91: "পেইন্ট শিল্ড স্কিল",
  T_40_HJ_WS_SOUND92: "একটি ডিজেবল্ড বাটন ট্যাপ করা হচ্ছে",
  T_40_HJ_WS_SOUND93: "স্কিল চার্জিং সম্পন্ন",
  T_40_HJ_WS_SOUND95: "লেজার স্কিল",
  T_40_HJ_WS_SOUND96: "পান আইটেম 2",
  T_40_HJ_WS_SOUND97: "গেম ওভার 2",
  T_40_HJ_WS_SOUND98: "এলিমিনেশন নোটিফিকেশন",
  T_40_HJ_WS_SOUNDTYPE_BMG: "ব্যাকগ্রাউন্ড মিউজিক",
  T_40_HJ_WS_SOUNDTYPE_INGAME: "ইন-ম্যাচ সাউন্ড ইফেক্ট",
  T_40_HJ_WS_SOUNDTYPE_UI: "UI উইজেট সাউন্ড ইফেক্ট",
  T_40_JH_WS_MAPTAG1: "কালার গেম",
  T_40_JH_WS_MAPTAG10: "কালার হাইড N সিক",
  T_40_JH_WS_MAPTAG11: "অ্যানিভার্সারি",
  T_40_JH_WS_MAPTAG12: "রোল-প্লে",
  T_40_JH_WS_MAPTAG13: "সিলুলেশন",
  T_40_JH_WS_MAPTAG14: "অ্যাসিমেট্রিক্যাল",
  T_40_JH_WS_MAPTAG15: "রিসোর্স ব্যাটেল",
  T_40_JH_WS_MAPTAG16: "কার্ট এসকর্ট",
  T_40_JH_WS_MAPTAG17: "অফিশিয়াল ম্যাপ",
  T_40_JH_WS_MAPTAG18: "মিনি গেম",
  T_40_JH_WS_MAPTAG19: "স্পিড চ্যালেঞ্জ",
  T_40_JH_WS_MAPTAG2: "কালার স্প্রে",
  T_40_JH_WS_MAPTAG20: "রৌঘলাইক",
  T_40_JH_WS_MAPTAG3: "কালার ফাইট",
  T_40_JH_WS_MAPTAG4: "কালার গানফাইট",
  T_40_JH_WS_MAPTAG5: "কালার প্লেগ্রাউন্ড",
  T_40_JH_WS_MAPTAG6: "প্লেগ্রাউন্ড কালার",
  T_40_JH_WS_MAPTAG7: "কালার পার্টি",
  T_40_JH_WS_MAPTAG8: "কালার পার্কুর",
  T_40_JH_WS_MAPTAG9: '"Spider-Verse" পার্কুর',
  T_40_JH_WS_TAG30: "টাইকুন",
  T_40_JH_WS_TAG31: "হোম-র‍্যাক হ্যাভক",
  T_40_JH_WS_TAG32: "মাস্টারি টাউন",
  T_40_JH_WS_TAG33: "ডৌন ক্রাইসিস",
  T_40_JH_WS_TAG34: "ডেথ আপরাইজিং",
  T_40_JH_WS_TAG35: "ফিস্ট ফাইট",
  T_40_JH_WS_TAG36: "পুরাতন ফ্যাক্টরি ছাদ",
  T_40_JH_WS_UGCTOKENNAME: "ক্রাফটল্যান্ড টোকেন",
  T_40_L_QUICKMESSAGE_MODE2: "ক্ল্যাশ স্কোয়াড",
  T_40_M_WS_HIS: "এর",
  T_40_SP_WS_DYEING: "কালার",
  T_40_SP_WS_DYEING_AREA: "এরিয়া কালারিং",
  T_40_SP_WS_DYEING_COLOR: "কালার নাম্বার",
  T_40_SP_WS_DYEING_COUNT: "কালারিং কাউন্ট",
  T_40_SP_WS_DYEING_DIR: "কালারিং ডিরেকশন",
  T_40_SP_WS_DYEING_DIS: "কালারিং ডিসট্যান্স",
  T_40_SP_WS_DYEING_FIXEDDYEINGRANGE: "কালারিং এরিয়া ফিক্সড হয়েছে",
  T_40_SP_WS_DYEING_NORMAL: "নরমাল",
  T_40_SP_WS_DYEING_PLANE: "প্লেইন এরিয়া কালারিং",
  T_40_SP_WS_DYEING_POSITION: "কো-অর্ডিনেট",
  T_40_SP_WS_DYEING_RANDOMDECAY: "র‍্যান্ডম কালারিং রেট ডিকে",
  T_40_SP_WS_DYEING_RANDOMRATIO: "র‍্যান্ডম কালারিং রেট",
  T_40_SP_WS_DYEING_RANGE: "কালারিং এরিয়া",
  T_40_SP_WS_DYEING_STATE: "কালারিং স্ট্যাটাস",
  T_40_SP_WS_FACTIONTIPS_11: "বেগুনি",
  T_40_SP_WS_SHOE_CURENERGY: "বর্তমান এনার্জি",
  T_40_SW_SKILL_Name_Nanoscientist: "ন্যানো লাইফশিল্ড",
  T_40_SY_AK47_PENGUIN_W_N: "AK47- ওয়েগর্স ওয়ান্ডার",
  T_40_SY_CHARACTER_DJMALE_AWAKENING_N: "অ্যাওয়েকেন্ড আলোক",
  T_40_SY_CHARACTER_NANOSCIENTIST_N: "সোনিয়া",
  T_40_SY_FAMAS_PENGUIN_W_N: "ফামাস- ওয়েগার্স ওয়ান্ডার",
  T_40_SY_M1014_PENGUIN_W_N: "M1014- ওয়েগার্স ওয়ান্ডার",
  T_40_SY_M24_PENGUIN_W_N: "M24- ওয়েগার্স ওয়ান্ডার",
  T_40_SY_MINI_PENGUIN_W_N: "AC80- ওয়েগার্স ওয়ান্ডার",
  T_40_SY_PET_PUG_N: "পাগ",
  T_40_SY_PETSKIN_ALIEN_TIGHTGUY_N: 'পেট স্কিন: "Spider-Verse" মুনি',
  T_40_SY_PETSKIN_FLYINGCREATURE_ME_N: "পেট স্কিন: ইলেক্ট্রিক আরভন",
  T_40_SY_PETSKIN_PUG_BLACK_N: "পেট স্কিন: লেজার আইস পাগ",
  T_40_SY_PETSKIN_PUG_GREEN_N: "পেট স্কিন: আলোহা পাগ",
  T_40_SY_PETSKIN_PUG_ORANGE_N: "পেট স্কিন: টাইগারস্ট্রাইপ পাগ",
  T_40_SY_SCAR_PENGUIN_W_N: "স্কার- ওয়েগার্স ওয়ান্ডার",
  T_40_SY_THOMPSON_PENGUIN_W_N: "থম্পসন- ওয়েগর্স ওয়ান্ডার",
  T_40_SY_UMP45_PENGUIN_W_N: "UMP- ওয়েগার্স ওয়ান্ডার",
  T_40_SY_USP45_PENGUIN_W_N: "USP- ওয়েগার্স ওয়ান্ডার",
  T_40_SY_UZI_PENGUIN_W_N: "মিনি Uzi- ওয়েগার্স ওয়ান্ডার",
  T_40_V_WS_INPUT_TEXT_ACTIVE: "টেক্সট কনটেন্ট অ্যাক্টিভেট করুন",
  T_40_V_WS_INPUT_TEXT_DEFAULT: "প্লেসহোল্ডার টেক্সট কনটেন্ট",
  T_40_W_DJMALE_AWAKENING_D: "অ্যাওয়েকেনিং: এই আভা সক্রিয় থাকাকালীন, মিউজিক নোটগুলি যেগুলি [FFB300]{2}s[-] স্থায়ী হয় প্রতি [FFB300]{0}s[-] এ স্কিল ইউজারের থেকে [FFB300]{1}m[-] পিছিয়ে পড়ে৷ টিমমেটরা যারা এই মিউজিক নোট পিক-আপ করে তারা অরার মতো একই ইফেক্ট পাবে।",
  T_40_W_DJMALE_AWAKENING_N: "পার্টি রিমিক্স",
  T_40_W_NURSE_D: "[FFB300]{0}%[-] ব্যবহারকারীর সিঙ্গেল-টার্গেট হিলিং ইফেক্টস (স্কিল, মেড-কিট, হিল গান, ইত্যাদি) ব্যবহারকারীর [FFB300]{1}m[-] এর মধ্যে থাকা টিমমেটদের মধ্যে ছড়িয়ে দিন।",
  T_40_WH_MP_BOXING_NAME: "বক্সিং ম্যাচ",
  T_40_WH_MP_C_PACK: "আনলফুল ব্যাকপ্যাক",
  T_40_WH_MP_EXCH_COIN: "ক্যাশ",
  T_40_WH_MP_EXCH_TEMPCOIN: "বেআইনি অর্থ",
  T_40_WH_MP_PAYCHECK: "মজুরি",
  T_40_WT_SKILL_DESC_MUSICBRO_BLACK: "টিমমেটদের হেলপ-আপ স্পিড [FFB300]{0}%[-] বৃদ্ধি পেয়েছে৷ কুলডাউন: [FFB300]{3}s[-]। সাহায্য করা টিমমেট [FFB300]{1}s[-] এর মধ্যে [FFB300]{2} HP[-] রিকোভার করে৷",
  T_40_WT_SKILL_DESC_MUSICBRO_WHITE2: "একটি [FFB300]{0}m-ব্যসার্ধ[-] বিশিষ্ট হিলিং জোন তৈরি করে৷ ভিতরে, ব্যবহারকারী এবং সহযোগীরা [FFB300]{1} HP/s[-] রিকোভার করে। যখন প্রয়োজন হবে তখন হেল্প-আপ স্বয়ংক্রিয়ভাবে ট্রিগার করা হবে। জোন [FFB300]{2}s[-] পর্যন্ত স্থায়ী হয়। টিমমেটদের সাহায্য করার ইফেক্টগুলো অন্যান্য স্কিল দ্বারা উন্নত করা যেতে পারে। কুলডাউন: [FFB300]{3}s[-]।",
  T_40_WT_WS_ICONENTITY_PARAM6: "ডিসপ্লে মেথড",
  T_40_WZY_WS_CUSTOMTRIGGER_CAPSULE: "ক্যাপসুল",
  T_40_WZY_WS_CUSTOMTRIGGER_HEIGHT: "উচ্চতা",
  T_40_WZY_WS_CUSTOMTRIGGER_RADIUS: "ব্যসার্ধ",
  T_40_WZY_WS_CUSTOMTRIGGER_SPHERE: "স্ফেয়ার",
  T_40_WZY_WS_FONT_FF_CN_T: "FZLanTingHei-R-BIG5",
  T_40_WZY_WS_FONT_HINDSILIGURI: "হিন্দ শিলিগুড়ি",
  T_40_WZY_WS_FONT_NOTONASTALIQURDU: "নোটো নাস্তালিয়া উর্দু",
  T_40_WZY_WS_FONT_NOTOSANS: "GFF দেভনাগরি",
  T_40_WZY_WS_FONT_SIMPBDO: "সরলীকৃত আরবি",
  T_40_WZY_WS_FONT_SUPERMARKET: "সুপারমার্কেট",
  T_40_WZY_WS_ICONENTITY_COLOR: "কালার",
  T_40_WZY_WS_ICONENTITY_FILLED: "প্রগ্রেসিভ",
  T_40_WZY_WS_ICONENTITY_ICONTYPE: "ইমেজ রিসোর্সসমূহ",
  T_40_WZY_WS_ICONENTITY_NAME: "আইকন অবজেক্ট",
  T_40_WZY_WS_ICONENTITY_RENDERTYPE: "মেথড অফ ডিসপ্লে",
  T_40_WZY_WS_ICONENTITY_SIMPLE: "সিম্পল",
  T_40_WZY_WS_ICONENTITY_SLICED: "9-গ্রিড",
  T_40_WZY_WS_ICONENTITY_TILED: "টাইটেলস",
  T_40_WZY_WS_NEWMAPTAG: "নতুন ম্যাপ আইকন",
  T_40_WZY_WS_NEWVFX1: "হালো",
  T_40_WZY_WS_NEWVFX10: "অভিশাপ",
  T_40_WZY_WS_NEWVFX11: "ফ্রিজ জোন",
  T_40_WZY_WS_NEWVFX12: "কোল্ড এয়ার",
  T_40_WZY_WS_NEWVFX13: "তুষারপাত",
  T_40_WZY_WS_NEWVFX14: "ফ্লেইম",
  T_40_WZY_WS_NEWVFX15: "লাইট বিম",
  T_40_WZY_WS_NEWVFX16: "পয়জন গ্যাসের বিস্তার",
  T_40_WZY_WS_NEWVFX17: "পয়জন গ্যাস",
  T_40_WZY_WS_NEWVFX18: "এক্সপ্লোসিভ ব্লেইজ",
  T_40_WZY_WS_NEWVFX19: "লাইফ ইফেক্ট",
  T_40_WZY_WS_NEWVFX2: "বাবল",
  T_40_WZY_WS_NEWVFX20: "স্টার",
  T_40_WZY_WS_NEWVFX3: "অ্যাশ",
  T_40_WZY_WS_NEWVFX4: "স্টোন স্প্ল্যাশ",
  T_40_WZY_WS_NEWVFX5: "লাইন",
  T_40_WZY_WS_NEWVFX6: "Flicker",
  T_40_WZY_WS_NEWVFX7: "রিং",
  T_40_WZY_WS_NEWVFX8: "রাইজিং পার্টিক্যাল",
  T_40_WZY_WS_NEWVFX9: "ধোঁয়া",
  T_40_WZY_WS_PRESENTTXT_FONTSIZE: "ফন্ট সাইজ",
  T_40_WZY_WS_PRESENTTXT_FONTSTYLE: "ফন্ট স্টাইল",
  T_40_WZY_WS_TEXTENTITY_FONTTYPE: "ফন্ট",
  T_40_WZY_WS_TEXTENTITY_NAME: "টেক্সট অবজেক্ট",
  T_40_WZY_WS_UIFONT_LATIN: "এজেন্সি FB",
  T_40_WZY_WS_UIFONT_LATIN_BOLD: "GFF ল্যাটিন",
  T_40_XXJ_WS_ACTIONHUD: "ইন্টারেকশন বাটন HUD কম্পোনেন্ট",
  T_40_XXJ_WS_ACTIVEINHIERARCHY_DESCKEY: 'এটাকে সিনারিতে ব্যবহার করা যাবে কিনা। এটি রিড অনলি এবং এটি নির্ভর করে "প্যারেন্ট উপলব্ধ কিনা" এবং "অ্যাক্টিভিটি স্ট্যাটাসের" উপর।',
  T_40_XXJ_WS_ACTIVEPARENT_DESCKEY: "সব অভিভাবক অ্যাক্টিভ কিনা। এটি রিড-অনলি এবং প্লেয়ারদের কাছে দৃশ্যমান নয়।",
  T_40_XXJ_WS_ACTIVEPARENT_NAMEKEY: "প্যারেন্ট উপলব্ধ কি না",
  T_40_XXJ_WS_ACTIVESELF_DESCKEY: "ওপেন স্ট্যাটাস সত্য হলে ডিসপ্লে হয়, অন্যথায় বন্ধ হয়",
  T_40_XXJ_WS_ACTIVESELF1_DESCKEY: 'এটি নিজের উপর অ্যাক্টিভেট হতে পারে কিনা। সিনারিতে ব্যবহার করতে, আপনাকে অবশ্যই  "সিনারিতে অ্যাক্টিভেট হবে কিনা"ব্যবহার করতে হবে। এটি একটি রিড-অনলি এবং একটি API ব্যবহার করে কনফিগার করা হয়।',
  T_40_XXJ_WS_ADDORREMOVECAMERACULLINGMASK_DESCKEY: "ক্যামেরার কুলিংমাস্ক একটি নির্দিষ্ট লেয়ারে দৃশ্যমান কিনা",
  T_40_XXJ_WS_ADDTOKENATPOSITION_DESCKEY: "একটি নির্দিষ্ট জায়গায় টোকেন জেনারেট করুন",
  T_40_XXJ_WS_ADDTOKENTOPLAYER_DESCKEY: "প্লেয়ারকে দেওয়ার মতো লুটযোগ্য আইটেম",
  T_40_XXJ_WS_AFORWARD_DESCKEY: "প্লেয়ারের বর্তমান অরিয়েন্টেশন",
  T_40_XXJ_WS_AFORWARD_NAMEKEY: "দিক",
  T_40_XXJ_WS_AIREALATTACKENTITY_DESCKEY: "AI এই এনটিটিকে অ্যাটাক করছে",
  T_40_XXJ_WS_AITARGET_DESCKEY: "অ্যাটাকিং AI",
  T_40_XXJ_WS_ALIGNMENT_DESCKEY: "অ্যালাইন স্টাইল",
  T_40_XXJ_WS_ALIGNMENT_NAMEKEY: "অনুভূমিক সারিবদ্ধ",
  T_40_XXJ_WS_ALIGNMENTVERTICAL_NAMEKEY: "ভার্টিক্যাল অ্যালাইন",
  T_40_XXJ_WS_ALPHA_DESCKEY: "ট্রান্সপারেন্সি",
  T_40_XXJ_WS_AMMOINCLIP_DESCKEY: "অবশিষ্ঠ অ্যামো কাউন্ট",
  T_40_XXJ_WS_AMMOINCLIP_NAMEKEY: "অবশিষ্ঠ অ্যামো",
  T_40_XXJ_WS_ANCHORMAX: "ম্যাক্সিমাম অ্যাংকর",
  T_40_XXJ_WS_ANCHORMIN: "ন্যূনতম অ্যাংকর",
  T_40_XXJ_WS_APOSITION_DESCKEY: "এই প্লেয়ারের বর্তমান ভার্সন",
  T_40_XXJ_WS_APOSITION_NAMEKEY: "পজিশন",
  T_40_XXJ_WS_ARMORHUD_NAMEKEY: "আর্মর HUD সুইচ",
  T_40_XXJ_WS_ASSETCONFIGID_NAMEKEY: "অ্যাসেট ID কনফিগার করুন",
  T_40_XXJ_WS_ASSETID_NAMEKEY: "অ্যাসেট ID",
  T_40_XXJ_WS_ATTACKENTITY_NAMEKEY: "অ্যাটাকের টার্গেট",
  T_40_XXJ_WS_ATTACKGRENADE_NAMEKEY: "অ্যাটাক থ্রোয়েবলস",
  T_40_XXJ_WS_ATTACKTARGET_DESCKEY: "এই এনটিটি যেটি AI কর্তৃক অ্যাটাকপ্রাপ্ত হচ্ছে",
  T_40_XXJ_WS_ATTACKTARGET_NAMEKEY: "অ্যাটাককৃত টার্গেট",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_DESCKEY: "স্পনপয়েন্টের উপলব্ধ কো-অর্ডিনেটস",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_NAMEKEY: "উপলব্ধ কোঅর্ডিনেটস",
  T_40_XXJ_WS_BACKGROUND_DESCKEY: "বটম ইমেজ",
  T_40_XXJ_WS_BACKGROUND_NAMEKEY: "ব্যাকগ্রাউন্ড",
  T_40_XXJ_WS_BAGHUD_NAMEKEY: "ব্যাকপ্যাক",
  T_40_XXJ_WS_BGALPHA_NAMEKEY: "ব্যাকগ্রাউন্ড ট্রান্সপারেন্সি",
  T_40_XXJ_WS_BGCOLOR_DESCKEY: "ব্যাকগ্রাউন্ড কালার",
  T_40_XXJ_WS_BGCOLOR_NAMEKEY: "ব্যাকগ্রাউন্ড কালার",
  T_40_XXJ_WS_BGFILL_DESCKEY: "ব্যাকগ্রাউন্ড পূরণ করতে হবে কি না",
  T_40_XXJ_WS_BGFILL_NAMEKEY: "ব্যাকগ্রাউন্ড ফিল",
  T_40_XXJ_WS_BGNAME_DESCKEY: "ব্যাকগ্রাউন্ড নেইম",
  T_40_XXJ_WS_BGNAME_NAMEKEY: "ব্যাকগ্রাউন্ড নাম",
  T_40_XXJ_WS_BGSIZEDELTA_DESCKEY: "ব্যাকগ্রাউন্ড সাইজ ডেল্টা",
  T_40_XXJ_WS_BGSIZEDELTA_NAMEKEY: "ব্যাকগ্রাউন্ড সাইজ ডেল্টা",
  T_40_XXJ_WS_BLUE: "ব্লু",
  T_40_XXJ_WS_BODY_DESCKEY: "টর্সো",
  T_40_XXJ_WS_BODY_NAMEKEY: "টর্সো",
  T_40_XXJ_WS_BONESCALE_NAMEKEY: "স্কেলেটন স্কেল",
  T_40_XXJ_WS_BORNPOSITIONVEC3_DESCKEY: "এই প্লেয়ারের স্পনপয়েন্ট",
  T_40_XXJ_WS_BORNPOSITIONVEC3_NAMEKEY: "স্পন পয়েন্ট",
  T_40_XXJ_WS_BOTH: "হয়তো",
  T_40_XXJ_WS_BUTTONNAME: "বাটন কম্পোনেন্ট নাম",
  T_40_XXJ_WS_CAMERA_DESCKEY: "ক্যামেরা",
  T_40_XXJ_WS_CAMERADIR_DESCKEY: "ক্লায়েন্ট ক্যামেরা যে দিকে মুখ করে থাকে",
  T_40_XXJ_WS_CAMERAPOS_DESCKEY: "ক্লায়েন্ট ক্যামেরার লোকেশন",
  T_40_XXJ_WS_CAMERARAYCASTHUD_DESCKEY: "ক্লায়েন্টের ক্যামেরা লাইন সনাক্ত করুন",
  T_40_XXJ_WS_CAMERARAYCASTHUD_NAMEKEY: "ক্যামেরা রে ডিটেকশন",
  T_40_XXJ_WS_CANCELDRAGIFFITS_DESCKEY: "ভিউপোর্টের সাথে মিলে যাওয়ার ড্র্যাগ করে আনা বন্ধ করুন",
  T_40_XXJ_WS_CANCELDRAGIFFITS_NAMEKEY: "ফিট হলে ড্র্যাগ ত্যাগ করুন",
  T_40_XXJ_WS_CAPSULEHEIGHT_DESCKEY: "পিল (বড়ির) আকৃতির অর্ধবৃত্তের কেন্দ্রের মধ্যকার দূরত্ব। এটি গোলকের ব্যাসার্ধের দ্বিগুণের চেয়ে ছোট হতে পারে না।",
  T_40_XXJ_WS_CELLSIZE_DESCKEY: "সেল সাইজ",
  T_40_XXJ_WS_CELLSIZE_NAMEKEY: "চাইল্ড সেল হাইট",
  T_40_XXJ_WS_CELLVALUE: "একটি নির্দিষ্ট সেল এ থাকা কন্টেন্ট পড়ুন এবং একটি অবজেক্ট রিটার্ন করুন",
  T_40_XXJ_WS_CENTER_DESCKEY: "যে ওয়ার্ড কোঅর্ডিনেটর মিনিম্যাপের সেন্টারের সাথে মিলে যায়। ডিফল্টরূপে 0।",
  T_40_XXJ_WS_CENTER_NAMEKEY: "মিনিম্যাপ সেন্টার",
  T_40_XXJ_WS_CENTEROFFSET_DESCKEY: "এই বাটনের পজিশনের অফসেট",
  T_40_XXJ_WS_CENTEROFFSET_NAMEKEY: "পজিশন অফসেট",
  T_40_XXJ_WS_CENTEROFMASS_DESCKEY: "লোকাল কোঅর্ডিনেটসের সাপেক্ষে ম্যাস সেন্টার",
  T_40_XXJ_WS_CENTEROFMASS_NAMEKEY: "ভরকেন্দ্র",
  T_40_XXJ_WS_CENTRALLINEACTIVE_DESCKEY: "মধ্যম লাইনটি ডিসপ্লে করা হবে কিনা",
  T_40_XXJ_WS_CENTRALLINEACTIVE_NAMEKEY: "মাঝের নাম প্রদর্শিত হবে কি না",
  T_40_XXJ_WS_CENTRALLINEPOS_DESCKEY: "মিডল লাইন পজিশন [0,1]",
  T_40_XXJ_WS_CENTRALLINEPOS_NAMEKEY: "মিডল লাইন পজিশন",
  T_40_XXJ_WS_CHASERANGE: "চেজ ভিসিনিটি",
  T_40_XXJ_WS_CHASETARGET_DESCKEY: "যে এনটিটিকে AI দ্বারা চেজ করা হচ্ছে",
  T_40_XXJ_WS_CHASETARGET_NAMEKEY: "টার্গেট চেইজ করা হয়েছে",
  T_40_XXJ_WS_CHILD_DESCKEY: "চাইল্ড এনটিটি",
  T_40_XXJ_WS_CHILDINDEX_NAMEKEY: "প্যারেন্টস চিলড্রেন",
  T_40_XXJ_WS_CHITPOS_DESCKEY: "যে পয়েন্টে ক্যামেরার লাইনে আঘাত লাগে",
  T_40_XXJ_WS_CHOOSECARHUD: "কার্ড HUD এনটিটি সিলেক্ট করুন",
  T_40_XXJ_WS_CLAMP_DESCKEY: "যদি প্যারামিটারটি ন্যূনতম এবং সর্বোচ্চ মানের মধ্যে সংখ্যাসূচক সীমার মধ্যে থাকে, তাহলে ফাংশনটি প্যারামিটারের মান প্রদান করবে; যদি প্যারামিটারটি রেঞ্জের চেয়ে বড় হয়, ফাংশনটি সর্বাধিক মান প্রদান করবে; আর্গুমেন্ট রেঞ্জের চেয়ে কম হলে, ফাংশনটি সর্বনিম্ন মান প্রদান করবে",
  T_40_XXJ_WS_CLEARALLCHILDREN_DESCKEY: "শুধুমাত্র ট্রান্সফর্ম কম্পোনেন্ট আছে এমন এনটিটিগুলো সাপোর্ট করে। বর্তমানে সব অবজেক্টে সীমাবদ্ধ।",
  T_40_XXJ_WS_CLICKSIZE_DESCKEY: "ক্লিক এরিয়ার সাইজ",
  T_40_XXJ_WS_CLICKSIZE_NAMEKEY: "ক্লিক সাইজ",
  T_40_XXJ_WS_CLIPPINGTYPE_DESCKEY: "ক্লিপিং টেপ",
  T_40_XXJ_WS_CLIPPINGTYPE_NAMEKEY: "ক্লিপিং টেপ",
  T_40_XXJ_WS_CLONEENT_D: "আসল প্যারেন্ট রেখে নির্বাচিত এনটিটি এবং এর অ্যাট্রিবিউটগুলোকে ক্লোন করুন৷ যদি লেভেল অবজেক্ট সিলেক্ট করা হয় তবে এটি লেভেল অবজেক্ট তৈরির উপর ভিত্তি করে তৈরি হবে।",
  T_40_XXJ_WS_CLOTHES_DESCKEY: "আউটফিটের লিস্ট",
  T_40_XXJ_WS_CLOTHID_DESCKEY: "আউটফিট ID",
  T_40_XXJ_WS_CLOTHID_NAMEKEY: "আউটফিট ID",
  T_40_XXJ_WS_CLOTHID1_DESCKEY: "আউটফিট ID",
  T_40_XXJ_WS_COL_DESC: "যে কলাম রিড করতে হবে।",
  T_40_XXJ_WS_COLNAME_DESC: "যে কলামটি রিড করতে হবে তার নাম।",
  T_40_XXJ_WS_COLOR_DESCKEY: "কালার",
  T_40_XXJ_WS_COLOR_NAMEKEY: "ভ্যালু",
  T_40_XXJ_WS_COLOR1_DESCKEY: "RGBA কালার চ্যানেল ব্যবহার করে কালার চ্যানেল যোগ করুন। একটি চ্যানেলের ভ্যালু 0 এবং 255 এর মধ্যে থাকে এবং একটি Int32 এ স্টোর করা হয়। ডিফল্টরূপে সাদা (255, 255, 255, 255)।",
  T_40_XXJ_WS_COLOR2_DESCKEY: "প্রগ্রেস বারের কালার",
  T_40_XXJ_WS_COLOR3_DESCKEY: "RGBA কালার চ্যানেলের টাইপ, যা 0 থেকে 255 পর্যন্ত রেঞ্জ করবে",
  T_40_XXJ_WS_COLOR4_DESCKEY: "টেক্সটের কালার",
  T_40_XXJ_WS_COLOR5_DESCKEY: "এই HUD এর কালার",
  T_40_XXJ_WS_COLOR6_DESCKEY: "লাইটিং এর কালার",
  T_40_XXJ_WS_COLORA_DESCKEY: "A কালার ভ্যালু",
  T_40_XXJ_WS_COLORB_DESCKEY: "B কালার ভ্যাল্যু",
  T_40_XXJ_WS_COLORBAR_NAMEKEY: "প্রগ্রেস বার কালার",
  T_40_XXJ_WS_COLORDRUM_DESCKEY: "কালার ব্যারেল",
  T_40_XXJ_WS_COLORDRUM_NAMEKEY: "কালার ব্যারেল",
  T_40_XXJ_WS_COLORG_DESCKEY: "G কালার ভ্যালু",
  T_40_XXJ_WS_COLORGETCHANNEL_DESCKEY: "RGBA চ্যানেল অর্জন করুন",
  T_40_XXJ_WS_COLORGUN: "রেইনবো স্প্রে রাইফেল",
  T_40_XXJ_WS_COLORGUN_01: "রেইনবো স্প্রে রাইফেল (রেড)",
  T_40_XXJ_WS_COLORGUN_02: "রেইনবো স্প্রে রাইফেল (ইয়েলো)",
  T_40_XXJ_WS_COLORGUN_03: "রেইনবো স্প্রে রাইফেল (ব্লু)",
  T_40_XXJ_WS_COLORGUN_04: "রেইনবো স্প্রে রাইফেল (গ্রীন)",
  T_40_XXJ_WS_COLORGUN_05: "রেইনবো স্প্রে রাইফেল (পার্পল)",
  T_40_XXJ_WS_COLORR_DESCKEY: "R কালার ভ্যাল্যু",
  T_40_XXJ_WS_COLORTEXT_NAMEKEY: "টেক্সট কালার",
  T_40_XXJ_WS_COLVALUE: "কলাম কনটেন্ট",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_DESCKEY: "একটি সাধারণ HUD সুইচের HUD এনটিটি",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_NAMEKEY: "সাধারণ HUD সুইচের HUD এনটিটি",
  T_40_XXJ_WS_CONSTRAINT_DESCKEY: "সীমাবদ্ধতা",
  T_40_XXJ_WS_CONSTRAINT_NAMEKEY: "সীমাবদ্ধতা",
  T_40_XXJ_WS_CONSTRAINTCOUNT_DESCKEY: "সীমাবদ্ধতার সংখ্যা",
  T_40_XXJ_WS_CONSTRAINTCOUNT_NAMEKEY: "সীমাবদ্ধতার সংখ্যা",
  T_40_XXJ_WS_CONTENTORIGIN_DESCKEY: "অরিজিনাল কন্টেন্ট",
  T_40_XXJ_WS_CONTENTORIGIN_NAMEKEY: "ডিফল্ট ডিরেকশন",
  T_40_XXJ_WS_CONTENTORIGIN2_DESCKEY: "স্ক্রোল এর স্টার্টিং পয়েন্ট। ডিফল্টরূপে উপরের দিকে বাম কোণে অবস্থান করে।",
  T_40_XXJ_WS_CREATEMAPBITENTITY_DESCKEY: "ম্যাপে একটি নির্দিষ্ট অবজেক্টের জন্য একটি স্ট্যাটিক পিক্সেল তৈরি করুন। এই পিক্সেল অবজেক্টের সাথে মুভ করবে না।",
  T_40_XXJ_WS_CREATEMAPICONENTITY_DESCKEY: "একটি মিনিম্যাপ আইকন ক্রিয়েট করুন",
  T_40_XXJ_WS_CREATETIMESTAMPLOCSTRING_DESCKEY: "একটি টাইমস্ট্যাম্পের জন্য একটি লোকাল স্ট্রিং ডিফাইন করুন",
  T_40_XXJ_WS_CREATEUIWIDGET_D: "মনোনীত কাস্টম HUD এবং প্যারেন্ট কম্পোনেন্টে একটি কাস্টম UI উপাদান তৈরি করুন",
  T_40_XXJ_WS_CREEP_NAMEKEY: "ক্রাউল",
  T_40_XXJ_WS_CROUCH_DESCKEY: "সত্য হলে ডিসপ্লে হবে, অন্যথায় ক্লোজড হয়ে যাবে",
  T_40_XXJ_WS_CROUCH_NAMEKEY: "ক্রাউচ",
  T_40_XXJ_WS_CULLINGMASK_DESCKEY: "এটি ক্যামেরার কলিং মাস্ক রেন্ডার লেয়ার। আপনি দৃশ্যমান লেয়ারের লেভেল ব্যবহার করে রেন্ডার এনটিটি ফিল্টার করতে পারেন।",
  T_40_XXJ_WS_CULLINGMASK_NAMEKEY: "কুলিংমাস্ক",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_DESCKEY: "শীর্ষ ID",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_NAMEKEY: "শীর্ষ",
  T_40_XXJ_WS_CUSTOMCLOTHFACEID_DESCKEY: "ফেসপেইন্ট ID",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_DESCKEY: "জুতার ID",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_NAMEKEY: "জুতা",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_DESCKEY: "হেড ID",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_NAMEKEY: "হেড",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_DESCKEY: "ফেসপেইন্ট ID",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_NAMEKEY: "মাস্ক",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_DESCKEY: "বটম ID",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_NAMEKEY: "বটম",
  T_40_XXJ_WS_CUSTOMCLOTHMAKEUP_NAMEKEY: "ফেসপেইন্ট",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_DESCKEY: "বান্ডেল ID",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_NAMEKEY: "ওয়ান্সআই",
  T_40_XXJ_WS_CUSTOMXY_DESCKEY: "xy ডিরেকশনে ড্র্যাগ অ্যামাউন্ট",
  T_40_XXJ_WS_CUSTOMXY_NAMEKEY: "XY ড্র্যাগ",
  T_40_XXJ_WS_DB: "টেবিল ভ্যালু রিড করুন",
  T_40_XXJ_WS_DB_DESC: "ডাটাবেসের একটি নির্দিষ্ট টেবিলে একটি নির্দিষ্ট শনাক্তকারীর সংশ্লিষ্ট ভ্যালু রিড করুন।",
  T_40_XXJ_WS_DBDELETE_DESC: "ডাটাবেসের একটি নির্দিষ্ট টেবিলে একটি নির্দিষ্ট শনাক্তকারীর একটি সংশ্লিষ্ট ভ্যালু ডিলিট করুন।",
  T_40_XXJ_WS_DBKEY_DESCKEY: "ডেটা সনাক্ত করতে ব্যবহৃত একটি কাস্টম নাম",
  T_40_XXJ_WS_DBKEY_NAMEKEY: "সনাক্তকারী",
  T_40_XXJ_WS_DBTABLENAME: "ডেটাবেজ টেবিলের নাম",
  T_40_XXJ_WS_DBTABLENAME_DESC: "একটি ডেটাবেজে থাকা টেবিলের নাম",
  T_40_XXJ_WS_DBVALUE_DESCKEY: "যেই ভ্যালু রাইট করতে হবে",
  T_40_XXJ_WS_DBWRITE: "টেবিল ভ্যাল্যু রাইট করুন",
  T_40_XXJ_WS_DBWRITE_DESC: "ডাটাবেসের একটি নির্দিষ্ট টেবিলে একটি নির্দিষ্ট শনাক্তকারীর একটি সংশ্লিষ্ট ভ্যালু লিখুন।",
  T_40_XXJ_WS_DEFENCEGRENADE_NAMEKEY: "ডিফেন্স থ্রোয়েবলস",
  T_40_XXJ_WS_DEFULT: "ডিফল্ট",
  T_40_XXJ_WS_DELETELEADERBOARD_DESC: "ডাটাবেসের একটি নির্দিষ্ট লিডারবোর্ড টেবিলে একটি নির্দিষ্ট কী এর একটি সংশ্লিষ্ট ভ্যাল্যু ডিলিট করুন।",
  T_40_XXJ_WS_DELETELEADERBOARD2_DESC: "ডাটাবেসের একটি নির্দিষ্ট লিডারবোর্ড টেবিলে একটি নির্দিষ্ট র‍্যাংকের একটি সংশ্লিষ্ট ভ্যালু ডিলিট করুন।",
  T_40_XXJ_WS_DEPTH: "HUD লেয়ার",
  T_40_XXJ_WS_DEPTH_D: "এই HUD এর বেসিক লেয়ার",
  T_40_XXJ_WS_DICTANDLIST: "লিস্ট এবং ডিকশনারি",
  T_40_XXJ_WS_DICVALUE_DESCKEY: "টার্গেটকৃত ডিকশনারির ভ্যাল্য",
  T_40_XXJ_WS_DIFFUSEALPHA_DESCKEY: "এই সার্ফেসের ট্রান্সপারেন্সি",
  T_40_XXJ_WS_DIR_DESCKEY: "ভেক্টর",
  T_40_XXJ_WS_DIRECTPOSVEC3_DESCKEY: "একটি বিন্দু যা প্রদান করা হয়েছে এবং একটি রিভাইভাল পয়েন্ট হিসাবে ব্যবহার করা যেতে পারে, ইত্যাদি।",
  T_40_XXJ_WS_DIRECTPOSVEC3_NAMEKEY: "কোঅর্ডিনেটস",
  T_40_XXJ_WS_DISABLEALL: "সবগুলো আন-সিলেক্ট করুন",
  T_40_XXJ_WS_DISABLECOLOR_NAMEKEY: "ডিজেবলকৃত কালার",
  T_40_XXJ_WS_DISTANT_DESCKEY: "ক্যামেরা লাইন সনাক্তকরণের দূরত্ব",
  T_40_XXJ_WS_DISTANT_NAMEKEY: "দূরত্ব প্রজেক্ট করা হচ্ছে",
  T_40_XXJ_WS_DRAGEFFECT_DESCKEY: "মাল্টিপল ড্র্যাগিং ডিরেকশন সাপোর্ট করে",
  T_40_XXJ_WS_DRAGEFFECT_NAMEKEY: "ড্র্যাগ ইফেক্ট",
  T_40_XXJ_WS_DRIVER_DESCKEY: "এই ভেহিক্যালের ড্রাইভার",
  T_40_XXJ_WS_DRIVER_NAMEKEY: "ড্রাইভার",
  T_40_XXJ_WS_EDITVALUE_DESCKEY: "একটি ভ্যাল্যু মোডিফাই করুন",
  T_40_XXJ_WS_EFFECTACTIVE_DESCKEY: "স্পেশাল ইফেক্টস ডিসপ্লে করুন",
  T_40_XXJ_WS_EFFECTACTIVE_NAMEKEY: "স্পেশাল ইফেক্টস ডিসপ্লে করুন",
  T_40_XXJ_WS_EFFECTCOLOR_NAMEKEY: "ইফেক্টস কালার",
  T_40_XXJ_WS_EFFECTENTITY_DESCKEY: "স্পেশাল ইফেক্টস এনটিটি মূলত যে স্পেশাল ইফেক্টটি ডিসপ্লে করা হবে তার প্রতিনিধিত্ব করে",
  T_40_XXJ_WS_EFFECTENTITYGENERATOR_DESCKEY: "স্পেশাল ইফেক্টস অবজেক্ট",
  T_40_XXJ_WS_EMOTIONHUD_NAMEKEY: "ইমোজি HUD সুইচ",
  T_40_XXJ_WS_ENABLEALL: "সবগুলো সিলেক্ট করুন",
  T_40_XXJ_WS_ENABLELOGIC_DESCKEY: "লজিক আপডেট চালু করতে হবে কিনা। বন্ধ থাকলে, এই এনটিটির ব্লকগুলি প্রতিটি ফ্রেম আপডেট করা বন্ধ করবে।",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_DESCKEY: "ওয়েপন অ্যাট্রিবিউটগুলোতে লিখা হলে, ওয়েপনের বেসিক স্ট্যাটিস্টিক্সগুলো ওয়েপন স্কিন দ্বারা প্রভাবিত হবে",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_NAMEKEY: "ওয়েপন স্কিন অ্যাট্রিবিউট লিখুন",
  T_40_XXJ_WS_ENTITY_DESCKEY: "এনটিটি হলো এমন একটি জাহাজ যেখানে সব ধরণের কম্পোনেন্ট ধারণ করে, যা অ্যাক্টিভেট করার জন্য এনটিটিগুলোতে যোগ করতে হবে",
  T_40_XXJ_WS_ENTITY_NAMEKEY: "এনটিটি টাইপ",
  T_40_XXJ_WS_ENTITY1_DESCKEY: "একটি এনটিটির মৌলিক উপাদান। সমস্ত উপাদান এই উপাদানের সাথে একত্রিত হবে।",
  T_40_XXJ_WS_ENTITYVARNAME_DESCKEY: "যে এনটিটিকে ট্রান্সফর্ম করা হবে",
  T_40_XXJ_WS_ENTITYVARNAME11_DESCKEY: "নতুন যোগ করা কাস্টম UI কন্ট্রোলের এনটিটিকে উপস্থাপন করতে কোডে ব্যবহৃত প্যারামিটারের নাম। এর সংশ্লিষ্ট স্থানীয় ভ্যারিয়েবল ভ্যালু হলো নতুন যোগ করা কাস্টম UI কন্ট্রোলের এনটিটি",
  T_40_XXJ_WS_ENTITYVARNAME12_DESCKEY: "এনটিটি ভ্যারিয়েবলসের নাম",
  T_40_XXJ_WS_ENTITYVARNAME13_DESCKEY: "তৈরিকরা আইকনের এনটিটিকে উপস্থাপন করতে কোডে ব্যবহৃত প্যারামিটারের নাম। এর সংশ্লিষ্ট লোকাল ভ্যারিয়েবল ভ্যালু হলো ক্রিয়েট করা আইকনের এনটিটি।",
  T_40_XXJ_WS_EPITEMHUD_NAMEKEY: "EP বার HUD সুইচ",
  T_40_XXJ_WS_EULERANGLES_DESCKEY: "অয়লার অ্যাঙ্গেল",
  T_40_XXJ_WS_FACINFECTION: "ফ্যাকশন (ড্রয়েড অ্যাপোকেলিপ্স)",
  T_40_XXJ_WS_FACINFECTION_DESC: "এই লেয়ার ফ্যাকশন। . 1 = মানুষ, 2= ড্রয়েড।",
  T_40_XXJ_WS_FEMALE: "নারী",
  T_40_XXJ_WS_FILLDIRECTION_DESCKEY: "ডিরেকশন পূরণ করুন",
  T_40_XXJ_WS_FILLDIRECTION_NAMEKEY: "সর্ট ডিরেকশন",
  T_40_XXJ_WS_FIRE_NAMEKEY: "ফায়ার",
  T_40_XXJ_WS_FLOATVALUE_DESCKEY: "এই ফ্লোট এর ভ্যালু",
  T_40_XXJ_WS_FOLLOWTARGET_DESCKEY: "যে টার্গেট এনটিটিকে ফলো করতে হবে। ডিফল্ট হিসেবে শূন্য।",
  T_40_XXJ_WS_FONTSIZE_DESCKEY: "টেক্সটের সাইজ",
  T_40_XXJ_WS_FONTSIZE_NAMEKEY: "ফন্ট সাইজ",
  T_40_XXJ_WS_FONTSTYLE_DESCKEY: "ফন্ট স্টাইল",
  T_40_XXJ_WS_FOOTBALLGLOOWALL: "ফুটবল গ্লু-ওয়াল",
  T_40_XXJ_WS_FORMATSTYLE_DESCKEY: "ফরম্যাটিং স্টাইল",
  T_40_XXJ_WS_FORWARD_DESCKEY: "এই প্লেয়ারের ডিরেকশন",
  T_40_XXJ_WS_FORWARD1_DESCKEY: "টেলিপোর্ট করার ডিরেকশন",
  T_40_XXJ_WS_FREE_DESCKEY: "একটি ক্যামেরা যা প্লেয়ার দ্বারা নিয়ন্ত্রণযোগ্য এবং অবাধে সরানো যায়",
  T_40_XXJ_WS_FREE_NAMEKEY: "ফ্রি ক্যামেরা",
  T_40_XXJ_WS_GENDER: "লিঙ্গ",
  T_40_XXJ_WS_GENDER_DESCKEY: "লিঙ্গ",
  T_40_XXJ_WS_GENDERTYPE_DESCKEY: "জেন্ডার এনাম",
  T_40_XXJ_WS_GETCAMERACULLINGMASK_DESCKEY: "ক্যামেরার কুলিংমাস্ক অর্জন করুন",
  T_40_XXJ_WS_GETCHILDBYINDEX_DESCKEY: "শুধুমাত্র ট্রান্সফর্ম কম্পোনেন্ট আছে এমন এনটিটিগুলো সাপোর্ট করে। বর্তমানে সব অবজেক্টে সীমাবদ্ধ।",
  T_40_XXJ_WS_GETCHILDREN_DESCKEY: "শুধুমাত্র ট্রান্সফর্ম কম্পোনেন্ট আছে এমন এনটিটি সাপোর্ট করে। বর্তমানে সব অবজেক্টে সীমাবদ্ধ।",
  T_40_XXJ_WS_GETPARENT_DESCKEY: "শুধুমাত্র ট্রান্সফর্ম কম্পোনেন্ট আছে এমন এনটিটি সাপোর্ট করে। বর্তমানে সমস্ত অবজেক্টের জন্য সীমাবদ্ধ।",
  T_40_XXJ_WS_GETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "এই প্লেয়ারের আউটফিট ID অর্জন করুন",
  T_40_XXJ_WS_GETPLAYERRANK: "প্লেয়ার র‍্যাংক অর্জন করুন",
  T_40_XXJ_WS_GETPLAYERRANK_D: "প্লেয়ার টোটাল র‍্যাংক অর্জন করুন",
  T_40_XXJ_WS_GETPLAYERROUNDRANK: "প্লেয়ার রাউন্ড র‍্যাংক অর্জন করুন",
  T_40_XXJ_WS_GETPLAYERROUNDRANK_D: "প্লেয়ার স্পেসিফিক রাউন্ড র‍্যাংক অর্জন করুন",
  T_40_XXJ_WS_GETPLAYERTOKENNUM_DESCKEY: "প্লেয়ারের টোকেনের ডেটা অনুসন্ধান করুন৷",
  T_40_XXJ_WS_GETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "এই প্লেয়ারের ওয়েপন স্কিনটি অর্জন করুন",
  T_40_XXJ_WS_GETRANDOMSPAWNPOSVEC3_DESCKEY: "কোঅর্ডিনেটসের একটি সেট পান, যা র‍্যানডম স্প্যানপয়েন্ট দ্বারা দখল করা হয়নি",
  T_40_XXJ_WS_GETSCENESKYBOX_DESCKEY: "একটি সিনারির স্কাই বক্সটি অর্জন করুন",
  T_40_XXJ_WS_GETSERVERREGION_DESCKEY: "একটি সার্ভারের রিজিয়ন অর্জন করুন",
  T_40_XXJ_WS_GETSERVERTIME_DESCKEY: "একটি সার্ভারের টাইমস্ট্যাম্প অর্জন করুন",
  T_40_XXJ_WS_GETTEAMMATENEARPOSVEC3_DESCKEY: "টিমমেটের কাছাকাছি একটি অবস্থানে যান, এমন জায়গাগুলি এড়িয়ে যান যেখানে প্লেয়ারেরা থাকে না",
  T_40_XXJ_WS_GETTEAMRANK: "টিম র‍্যাংক অর্জন করুন",
  T_40_XXJ_WS_GETTEAMRANK_D: "টিম সর্বমোট র‍্যাংক অর্জন করুন",
  T_40_XXJ_WS_GETTEAMROUNDRANK: "টিম রাউন্ড র‍্যাংক অর্জন করুন",
  T_40_XXJ_WS_GETTEAMROUNDRANK_D: "টিম স্পেসিফিক রাউন্ড র‍্যাংক অর্জন করুন",
  T_40_XXJ_WS_GREEN: "গ্রীন",
  T_40_XXJ_WS_HALFEXTENTS_DESCKEY: "একটি 3-মাত্রিক আকৃতির ডাইমেনশনের অর্ধেক",
  T_40_XXJ_WS_HEAD_DESCKEY: "হেড",
  T_40_XXJ_WS_HEAD_NAMEKEY: "হেড",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_DESCKEY: "হার্টবিট ইফেক্ট এনটিটি",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_NAMEKEY: "হার্টবিট ইফেক্ট এনটিটি",
  T_40_XXJ_WS_HEIGHT_DESCKEY: "উচ্চতা",
  T_40_XXJ_WS_HINTBUTTONHUD_DESCKEY: "হিন্ট বাটন",
  T_40_XXJ_WS_HINTBUTTONHUD_NAMEKEY: "টিপস বাটন",
  T_40_XXJ_WS_HITPOINTEFFECT_DESCKEY: "টার্গেট লোকেশনে প্রদর্শিত এনটিটি",
  T_40_XXJ_WS_HITPOINTEFFECT_NAMEKEY: "টার্গেটকৃত এনটিটি",
  T_40_XXJ_WS_HITPOS_DESCKEY: "যে স্পটে আঘাত করা হয়",
  T_40_XXJ_WS_HORIZONTALBAR_DESCKEY: "অনুভূমিক ডিসপ্লে টাইপ",
  T_40_XXJ_WS_HORIZONTALBAR_NAMEKEY: "অনুভূমিক ডিসপ্লে টাইপ",
  T_40_XXJ_WS_HOSTENTITYFOLLOW_DESCKEY: "একটি এনটিটি যা অন্য একটি এনটিটিকে ফলো করছে",
  T_40_XXJ_WS_HOSTENTITYLOOK_DESCKEY: "কোনো এনটিটি যেটি অন্য এনটিটির দিকে তাকিয়ে আছে",
  T_40_XXJ_WS_HPITEMHUD_NAMEKEY: "হেলথ বার HUD স্যুইচ",
  T_40_XXJ_WS_HUDEMPTYPANEL_DESCKEY: "HUD সন্নিবেশ এনটিটি। এটি এমন HUD যা প্লেয়ারেরা এডিটর থেকে পরিবর্তন করে।",
  T_40_XXJ_WS_HUDEMPTYPANEL_NAMEKEY: "খালি HUD প্যানেল কম্পোনেন্ট",
  T_40_XXJ_WS_HUDENTITY_DESCKEY: "এটি যে HUD এনটিটির অন্তর্গত৷",
  T_40_XXJ_WS_HUDGRID_DESCKEY: "HUD ইনসার্শন এনটিটি। এটি একটি HUD, যা প্লেয়ার এডিটর ব্যবহার করে এডিট করে।",
  T_40_XXJ_WS_HUDGRID_NAMEKEY: "HUD গ্রীড কম্পোনেন্ট",
  T_40_XXJ_WS_HUDPANEL_DESCKEY: "HUD সন্নিবেশ এনটিটি। এটি HUD যা প্লেয়ার এডিটর ব্যবহার করে এডিট করে।",
  T_40_XXJ_WS_HUDPANEL_NAMEKEY: "HUD প্যানেল কম্পোনেন্ট",
  T_40_XXJ_WS_HUDSCROLLVIEW_DESCKEY: "HUD ইনসার্শন এনটিটি। এটি হলো একটি HUD যা প্লেয়ার কোনো একটি এডিটর ব্যবহার করে এডিট করে।",
  T_40_XXJ_WS_HUDSCROLLVIEW_NAMEKEY: "HUD স্ক্রল ভিউ কম্পোনেন্ট",
  T_40_XXJ_WS_HUMANMODELID_NAMEKEY: "হিউম্যান মিডেল ID",
  T_40_XXJ_WS_ICON_DESCKEY: "আইকনের রিসোর্স নাম",
  T_40_XXJ_WS_ICON_NAMEKEY: "আইকন",
  T_40_XXJ_WS_ICON1_DESCKEY: "একটি আইকন সিলেক্ট করুন",
  T_40_XXJ_WS_ICONENTITY_DESCKEY: "যে আইকন এনটিটি প্রদর্শন করতে হবে, সেটিকে প্রতিনিধিত্ব করে",
  T_40_XXJ_WS_ICONPATH_DESCKEY: "একটি রিসোর্স পাথ. বিল্ট-ইন রিসোর্স in:path. কাস্টম রিসোর্স out:path. ডিফল্টরূপে খালি।",
  T_40_XXJ_WS_ICONSPRITENAME_DESCKEY: "আইকন নাম",
  T_40_XXJ_WS_ICONSPRITENAME_NAMEKEY: "আইকনের নাম",
  T_40_XXJ_WS_ICONTYPE_DESCKEY: "রিসোর্স পাথ। ডিফল্টভাবে খালি থাকে।",
  T_40_XXJ_WS_INCLUDETRIGGER_DESCKEY: "এটি ট্রিগারের জন্য স্ক্যান করতে পারে কিনা",
  T_40_XXJ_WS_INDEX_DESCKEY: "প্যারেন্টের অধীনে থাকা চাইল্ড ইনডেক্স",
  T_40_XXJ_WS_INITIALVALUE_NAMEKEY: "প্রাথমিক ভ্যাল্যু [0, 1]",
  T_40_XXJ_WS_INTVALUE_DESCKEY: "পূর্ণসংখ্যার ভ্যাল্যু",
  T_40_XXJ_WS_IS3D: "3D সাউন্ড ইফেক্ট",
  T_40_XXJ_WS_ISBILLBOARD_DESCKEY: "সবসময় ক্যামেরার সম্মুখীন হয়ে আছেন",
  T_40_XXJ_WS_ISBOLD_NAMEKEY: "বোল্ড",
  T_40_XXJ_WS_ISBYORDER_D: "প্লেয়ারদের কালানুক্রমিক ক্রমে লেভেল অবজেক্ট ট্রিগার করা উচিত কিনা তা সনাক্ত করুন",
  T_40_XXJ_WS_ISFEBUTTON_NAMEKEY: "Is FirEditor বাটন",
  T_40_XXJ_WS_ISHIT_DESCKEY: "ক্যামেরা লাইন এই এনটিটিকে আঘাত করেছে কিনা",
  T_40_XXJ_WS_ISINCULLINGMASK_DESCKEY: "নির্দিষ্ট লেয়ারে এটি দৃশ্যমান হবে কিনা",
  T_40_XXJ_WS_ISITALIC_NAMEKEY: "ইতালিক",
  T_40_XXJ_WS_ISSHOWSCAN_DESCKEY: "স্ক্যান করার ফলে মার্ক করা হবে কিনা",
  T_40_XXJ_WS_ISSHOWSCAN_NAMECKEY: "স্ক্যান করা হয়েছে কি না",
  T_40_XXJ_WS_ISSHOWTAG_DESCKEY: "পিন বাটন দ্বারা চিহ্নিত কিনা",
  T_40_XXJ_WS_ISTRIGGER: "হলো ট্রিগার",
  T_40_XXJ_WS_ISUNDERLINE_NAMEKEY: "আন্ডারলাইনকৃত",
  T_40_XXJ_WS_ITEMID_DESCKEY: "এই এনটিটির সংশ্লিষ্ট আইটেম ID",
  T_40_XXJ_WS_ITEMID_NAMEKEY: "আইটেম ID",
  T_40_XXJ_WS_ITEMID1_DESCKEY: "আইটেম ID (বর্তমান ভার্সনে শুধুমাত্র ওয়েপন ID উপলব্ধ)",
  T_40_XXJ_WS_ITEMID2_DESCKEY: "এই ওয়েপনের আইটেম ID",
  T_40_XXJ_WS_ITEMID3_DESCKEY: "আইটেম ID",
  T_40_XXJ_WS_JAILBREAKAREA_DESCKEY: "মেট্রোপলিস এরিয়া",
  T_40_XXJ_WS_JAILBREAKAREA_NAMEKEY: "মেট্রোপলিস এরিয়া",
  T_40_XXJ_WS_JUMP_NAMEKEY: "জাম্প",
  T_40_XXJ_WS_KEY_DESCKEY: "এই কী-এর ভ্যালু",
  T_40_XXJ_WS_KEY_NAMEKEY: "কী",
  T_40_XXJ_WS_KEYNAME_DESCKEY: "ট্রাভার্স করার চাবির নাম। আপনি একটি লোকাল ভেরিয়েবলে একটি কী এর ভ্যাল্যু পেতে এটি ব্যবহার করতে পারেন।",
  T_40_XXJ_WS_KILLINGTIPS_NAMEKEY: "এলিমিনেশন অ্যানাউন্সমেন্ট",
  T_40_XXJ_WS_LABELCOLOR_NAMEKEY: "টেক্সট কালার",
  T_40_XXJ_WS_LANDMINEOBJ: "ল্যান্ডমাইন ক্রিয়েশনের পর এনটিটি",
  T_40_XXJ_WS_LAYERMASK_DESCKEY: "কলিড লেয়ারের মাস্ক। নির্বাচিত না হওয়া লেয়ারগুলো স্ক্যানে অন্তর্ভুক্ত করা হবে না। খালি থাকা অবস্থায়, সবগুলো লেয়ারই স্ক্যানে অন্তর্ভুক্ত করা হবে।",
  T_40_XXJ_WS_LAYERSEDIT: "লেয়ার এডিট করুন",
  T_40_XXJ_WS_LAYERSETTING: "ভিজিবল লেয়ার সেটিংস",
  T_40_XXJ_WS_LAYERTYPE_DESCKEY: "ক্যামেরা লাইন সনাক্তকরণের কলিশন লেয়ার",
  T_40_XXJ_WS_LAYERTYPE_NAMEKEY: "লেয়ার",
  T_40_XXJ_WS_LAYOUTTYPE_DESCKEY: "লেআউট টাইপ",
  T_40_XXJ_WS_LAYOUTTYPE_NAMEKEY: "লেআউট টাইপ",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD: "স্কোরবোর্ড HUD কম্পোনেন্ট",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD_D: "স্কোরবোর্ডের HUD এনটিটি। এই এনটিটির প্রপার্টিজ পরিবর্তন করা সংশ্লিষ্ট UI-তে প্রদর্শিত কন্টেন্টকে প্রভাবিত করবে৷",
  T_40_XXJ_WS_LEADERBOARDNAME: "লিডারবোর্ড নাম",
  T_40_XXJ_WS_LEADERBOARDNAME_DESC: "ডাটাবেসে থাকা লিডারবোর্ড টেবিলের নাম।",
  T_40_XXJ_WS_LEAVEACCELERATION_DESCKEY: "সুইংগিং এর উপর অ্যাক্সিলারেশন",
  T_40_XXJ_WS_LEAVEACCELERATION_NAMEKEY: "অ্যাক্সিলারেশন ত্যাগ করুন",
  T_40_XXJ_WS_LEFTARM_DESCKEY: "বাম আর্ম",
  T_40_XXJ_WS_LEFTARM_NAMEKEY: "বাম পক্ষ",
  T_40_XXJ_WS_LEFTCOLOR_DESCKEY: "বাম দিকের কালার",
  T_40_XXJ_WS_LEFTCOLOR_NAMEKEY: "বাম কালার",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_DESCKEY: "বাম দিকে স্পেশাল ইফেক্টস প্রদর্শন করা হবে কিনা",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_NAMEKEY: "বাম ইফেক্ট ডিসপ্লে করা হবে কিনা",
  T_40_XXJ_WS_LEFTFOOT_DESCKEY: "বাম পা",
  T_40_XXJ_WS_LEFTFOOT_NAMEKEY: "বাম পা",
  T_40_XXJ_WS_LEFTHAND_DESCKEY: "বাম পক্ষ",
  T_40_XXJ_WS_LEFTHAND_NAMEKEY: "বাম পক্ষ",
  T_40_XXJ_WS_LEFTICON_DESCKEY: "বাম আইকন",
  T_40_XXJ_WS_LEFTICON_NAMEKEY: "বাম আইকন",
  T_40_XXJ_WS_LEFTLEG_DESCKEY: "বাম পা",
  T_40_XXJ_WS_LEFTLEG_NAMEKEY: "বাম পা",
  T_40_XXJ_WS_LEFTSCORETEXT_DESCKEY: "বামদিকের স্কোর টেক্সট",
  T_40_XXJ_WS_LEFTSCORETEXT_NAMEKEY: "বাম স্কোর টেক্সট",
  T_40_XXJ_WS_LEFTTEXT_DESCKEY: "বাম দিকের টেক্সট",
  T_40_XXJ_WS_LEFTTEXT_NAMEKEY: "বামদিকের টেক্সট",
  T_40_XXJ_WS_LERP_DESCKEY: 't 0 এবং 1 এর মধ্যে থাকে। যখন t=0, রিটার্ন করে "থেকে"। যখন t=1, "এ" রিটার্ন করুন। যখন t=0.5, তখন "থেকে"-এর মানের গড় ফেরত দিন। এবং "প্রতি"।',
  T_40_XXJ_WS_LEVELOBJECT: "স্টেজ অবজেক্ট",
  T_40_XXJ_WS_LINESPACING_NAMEKEY: "লাইন স্পেসিং",
  T_40_XXJ_WS_LISTFINDMAX_DESCKEY: "একটি তালিকার ভ্যাল্যুগুলোকে তুলনা করুন এবং সবচেয়ে ভ্যালুটি রিটার্ন করুন",
  T_40_XXJ_WS_LISTFINDMIN_DESCKEY: "একটি তালিকার মান তুলনা করুন এবং সবচেয়ে ছোটটি রিটার্ন করুন",
  T_40_XXJ_WS_LISTORMAP_NAMEKEY: "লিস্ট নাকি ডিক্ট",
  T_40_XXJ_WS_LOCALPOSITION: "লোকাল পজিশন",
  T_40_XXJ_WS_LOCALROTA: "লোকাল ইউলার অ্যাঙ্গেল",
  T_40_XXJ_WS_LOCALROTATIONQ: "লোকাল কোয়াটার্নিয়ন রোটেশন",
  T_40_XXJ_WS_LOCALSACLE: "লোকাল স্কেল",
  T_40_XXJ_WS_LOCSWITCH_NAMEKEY: "লোকালাইজেশন সুইচ",
  T_40_XXJ_WS_LOOPRANGE_DESCKEY: "যেই কন্টেনার ভেদ করতে হবে",
  T_40_XXJ_WS_MALE: "পুরুষ",
  T_40_XXJ_WS_MAPCLEAR_DESCKEY: "ডিকশনারি রিমুভ করুন",
  T_40_XXJ_WS_MAPGETLENGTH_DESCKEY: "ডিকশনারির দৈর্ঘ্য জানুন",
  T_40_XXJ_WS_MAPGETVALUE_DESCKEY: "ডিকশনারি এলিমেন্টে মনোনীত কী টির ভ্যালু অর্জন করুন",
  T_40_XXJ_WS_MAPREMOVEVALUE_DESCKEY: "ডিকশনারিতে মনোনীত কী-ভ্যাল্যু জোড়া রিমুভ করুন",
  T_40_XXJ_WS_MAPSETVALUE_DESCKEY: "ডিকশনারিতে একটি মনোনীত কী এর ভ্যালু কনফিগার করুন",
  T_40_XXJ_WS_MAPSIZE_DESCKEY: "এই মিনিম্যাপের সাইজ। এর প্রশস্থতা এবং উচ্চতা সমান।",
  T_40_XXJ_WS_MAPSIZE_NAMEKEY: "ম্যাপ সাইজ",
  T_40_XXJ_WS_MAPT: "Dict টেম্পলেট",
  T_40_XXJ_WS_MAPT_D: "dict-এর জন্য ডেটা টেমপ্লেট। আপনি T1 এবং T2 এর মাধ্যমে কন্টেন্ট টাইপ নির্ধারণ করতে পারেন।",
  T_40_XXJ_WS_MAPVALUE_D: "এই ডিক্টের জন্য একটি ডেটা কন্টেনার। এই এলিমেন্ট হলো একটি জোড়া, যা একটি কী এবং একটি ভ্যালু নিয়ে গঠিত।",
  T_40_XXJ_WS_MAPVALUE_DESCKEY: "টার্গেট ডিকশনারি",
  T_40_XXJ_WS_MAPVALUE_NAMEKEY: "ডিক্ট",
  T_40_XXJ_WS_MASKNAME_DESCKEY: "মাস্ক টাইপ হলো মাস্কিং এর সময় ব্যবহৃত ইমেজের নাম",
  T_40_XXJ_WS_MASKNAME_NAMEKEY: "মাস্ক নাম",
  T_40_XXJ_WS_MASS_DESCKEY: "ভর (কেজিতে)",
  T_40_XXJ_WS_MASS_NAMEKEY: "ভর (kg)",
  T_40_XXJ_WS_MAX_DESCKEY: "2টি ভ্যালু তুলনা করুন এবং বড়টি রিটার্ন দিন",
  T_40_XXJ_WS_MAXLENGTH_NAMEKEY: "ম্যাক্স. দৈর্ঘ্য",
  T_40_XXJ_WS_MAXNUM_DESCKEY: "ম্যাক্সিমাম ভ্যাল্যু",
  T_40_XXJ_WS_MAXWIDGETID_DESCKEY: "সবচেয়ে বড় কম্পোনেন্ট ID",
  T_40_XXJ_WS_MAXWIDGETID_NAMEKEY: "ম্যাক্স. উইজেট ID",
  T_40_XXJ_WS_MEDICALPROPSHUD_NAMEKEY: "হিলিং আইটেমসমূহ",
  T_40_XXJ_WS_MIN_DESCKEY: "2টি ভ্যালুকে তুলনা করুন এবং ছোটটি রিটার্ন করুন",
  T_40_XXJ_WS_MINIMAP_NAMEKEY: "মিনিম্যাপ কম্পোনেন্ট",
  T_40_XXJ_WS_MINIMAPBIT_NAMEKEY: "মিনিম্যাপ পিক্সেল",
  T_40_XXJ_WS_MINIMAPICON_NAMEKEY: "মিনিম্যাপ আইকন",
  T_40_XXJ_WS_MINMAPHUD_NAMEKEY: "মিনিম্যাপ",
  T_40_XXJ_WS_MINNUM_DESCKEY: "ন্যুনতম ভ্যালু",
  T_40_XXJ_WS_MOMENTUMAMOUNT_DESCKEY: "ভরবেগের ফ্যাক্টর। এর ভ্যাল্যু যত বড় হবে, স্ক্রল করার সময় ভরবেগ তত বেশি হবে।",
  T_40_XXJ_WS_MOMENTUMAMOUNT_NAMEKEY: "মোমেন্টাম ফ্যাক্টর",
  T_40_XXJ_WS_MOVINGJOYSTICK_NAMEKEY: "মুভমেন্ট জয়স্টিক",
  T_40_XXJ_WS_MRESULT_DESCKEY: "ম্যাচ রেজাল্ট",
  T_40_XXJ_WS_NEWENTITY_D: "সৃষ্টির পর নতুন আইটেম এনটিটি (খালি হতে পারে)",
  T_40_XXJ_WS_NEWMAP_DESCKEY: "নতুন একটি ডিকশনারি তৈরি করুন",
  T_40_XXJ_WS_NEWMAP_NAMEKEY: "নতুন ডিক্ট",
  T_40_XXJ_WS_NORMAL1_DESCKEY: "আঘাতের স্বাভাবিক রূপ",
  T_40_XXJ_WS_NORMALIZEDPOSITION_DESCKEY: "HUD পজিশন [0,1]",
  T_40_XXJ_WS_NORMALIZEDPOSITION_NAMEKEY: "HUD পজিশন",
  T_40_XXJ_WS_NUMLIST_DESCKEY: "সূচকগুলিকে সংখ্যায় রূপান্তরের তালিকা",
  T_40_XXJ_WS_OBJECT_DESCKEY: "স্প্রে বন্দুক যে অবজেক্টে আঘাত করে",
  T_40_XXJ_WS_OBSOLETE: "ডিলিট করা হয়েছে, নিরাপত্তার কারণে এই ব্লকটি প্রতিস্থাপন করুন।",
  T_40_XXJ_WS_OFFSET_DESCKEY: "ডিসপ্লে পজিশন। যখন একটি অনুসরণ করা টার্গেট থাকে, তখন এটি নতুন অবস্থান এবং মূল অবস্থানের মধ্যে অফসেট। যখন কোন অনুসরণ করা টার্গেট থাকে না, তখন এটি হল স্ক্রীন কো-অর্ডিনেটস (ডিফল্ট হল Vector3(0))।",
  T_40_XXJ_WS_OFFSET2_DESCKEY: "স্ক্রিন কো-অর্ডিনেটস (ডিফল্ট ভেক্টর3(0))।",
  T_40_XXJ_WS_OFFSET3_DESCKEY: "ডিসপ্লের অবস্থান। যখন একটি অনুসরণ করা টার্গেট থাকে, তখন এটি নতুন অবস্থান এবং মূল অবস্থানের মধ্যে একটি অফসেট। যখন কোন অনুসরণ করা লক্ষ্য থাকে না, তখন এটি হল স্ক্রীন কোঅর্ডিনেটস (ডিফল্টরূপে Vector3(0))।",
  T_40_XXJ_WS_OFFSET4_DESCKEY: "ডিসপ্লে পজিশন (অ্যাঙ্করটি উপরের ডানদিকে রয়েছে)",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_DESCKEY: "অনুভূমিক অফসেট",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_NAMEKEY: "হরাইজন্টাল অফসেট",
  T_40_XXJ_WS_OFFSETUPDOWN_DESCKEY: "ভার্টিক্যাল অফসেট",
  T_40_XXJ_WS_OFFSETUPDOWN_NAMEKEY: "ভার্টিক্যাল অফসেট",
  T_40_XXJ_WS_OK_DESCKEY: "রূপান্তর সফল",
  T_40_XXJ_WS_ONAISTARTATTACK_DESCKEY: "এনটিটি যখন অ্যাটাক এরিয়ার আশেপাশে প্রবেশ করে তখন এই ইভেন্টটি ট্রিগার করুন৷",
  T_40_XXJ_WS_ONAISTARTCHASE_DESCKEY: "যখন এনটিটি চেজ ভিসিনিটির আশেপাশে প্রবেশ করে তখন এই ইভেন্টটি ট্রিগার করুন৷",
  T_40_XXJ_WS_ONAISTOPATTACK_DESCKEY: "যখন এনটিটি অ্যাটাক ভিসিনিটির বাইরে চলে যায়, তখন এই ইভেন্টটি ট্রিগার করুন",
  T_40_XXJ_WS_ONAISTOPCHASE_DESCKEY: "যখন এনটিটি চেজ করা এরিয়াটা ত্যাগ করে যায়, তখন এই ইভেন্টটি ট্রিগার করুন",
  T_40_XXJ_WS_ONCLIENTCAMERARAYCAST_DESCKEY: "ক্লায়েন্টের মাধ্যমে একটি ক্যামেরা লাইন ডিটেকশন ট্রিগার করুন",
  T_40_XXJ_WS_ONCOLLISION_D: "শুধুমাত্র কোলাইডার উপাদান সংযুক্ত এনটিটিগুলোই এই ইভেন্ট সাপোর্ট করে",
  T_40_XXJ_WS_ONSPRAYENTITY_DESCKEY: "স্প্রে গান যখন কোনো এনটিটিকে আঘাত করে তখন এই ইভেন্টটিকে ট্রিগার করুন",
  T_40_XXJ_WS_ONSTOPFIRE_DESCKEY: "ফায়ারিং যখন থামে",
  T_40_XXJ_WS_ONSWITCHPLAYERAREA_DESCKEY: "যখন একজন প্লেয়ার তার সিনারি এলাকা পরিবর্তন করে",
  T_40_XXJ_WS_OPENSTATE_DESCKEY: "ওপেন স্ট্যাটাস সত্য হলে ডিসপ্লে হয়, , অন্যথায় ক্লোজ হয়ে যায়",
  T_40_XXJ_WS_OPENSTATE_NAMEKEY: "স্ট্যাটাস ওপেন করুন",
  T_40_XXJ_WS_ORANGE: "ওরেঞ্জ",
  T_40_XXJ_WS_ORDER_DESC: "লিডারবোর্ডে থাকা র‍্যাংক",
  T_40_XXJ_WS_ORDER1: "প্রারম্ভিক র‍্যাংক",
  T_40_XXJ_WS_ORDER2: "ফিনিশিং র‍্যাংক",
  T_40_XXJ_WS_ORIGINAL: "অরিজিনাল লজিক বজায়",
  T_40_XXJ_WS_OVERFLOW_NAMEKEY: "ওভারফ্লো মেথড",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_DESCKEY: "যখন অগ্রাধিকার দেওয়া হয়, প্লেয়ারের ওয়েপনের অ্যাট্রিবিউটগুলো সেসব ওয়েপনের অ্যাট্রিবিউটগুলোকে প্রতিস্থাপন করবে",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_NAMEKEY: "প্লেয়ার ওয়েপন স্কিন অগ্রাধিকার দিন",
  T_40_XXJ_WS_OWNER_DESCKEY: "যে প্লেয়ারের কাছে এই এনটিটি রয়েছে",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_DESCKEY: "চাইল্ড সিনারির গ্লোবাল UID এটির অন্তর্গত",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_NAMEKEY: "চাইল্ড সিনারির GUID",
  T_40_XXJ_WS_PARENT_DESCKEY: "প্যারেন্ট এনটিটি",
  T_40_XXJ_WS_PARENT_NAMEKEY: "প্যারেন্ট",
  T_40_XXJ_WS_PARENTENTITYID_NAMEKEY: "প্যারেন্ট কম্পোনেন্ট এনটিটি ID",
  T_40_XXJ_WS_PARENTWIDGETFILEID_DESCKEY: "প্যারেন্ট কম্পোনেন্টের ফাইল ID",
  T_40_XXJ_WS_PASSENGERS_DESCKEY: "এই ভেহিক্যালে থাকা সকল প্যাসেঞ্জার",
  T_40_XXJ_WS_PASSENGERS_NAMEKEY: "প্যাসেঞ্জার",
  T_40_XXJ_WS_PHYSICALLAYER: "ফিজিক্যাল লেয়ার",
  T_40_XXJ_WS_PHYSICALLAYERMATRIX: "ফিজিক্যাল লেয়ার ম্যাট্রিক্স",
  T_40_XXJ_WS_PHYSICALTIP1: "এই নামটি ইতোমধ্যেই রয়েছে",
  T_40_XXJ_WS_PHYSICALTIP2: "একটি লেয়ারের নাম অদৃশ্যমান করুন এবং ফিজিক্যাল লেয়ার ম্যাট্রিক্স এবং লেয়ার এনামে অদৃশ্য করে তুলুন, তবে সেই লেয়ারের মধ্যে থাকা এনটিটি অবজেক্টগুলোকে প্রভাবিত হবে না।",
  T_40_XXJ_WS_PHYSICS: "ফিজিক্স",
  T_40_XXJ_WS_PICKUPLISTHUD_NAMEKEY: "লুট লিস্ট HUD সুইচ",
  T_40_XXJ_WS_PLAYABLE_DESCKEY: "একটি প্লে-অ্যাবল এনটিটি",
  T_40_XXJ_WS_PLAYABLELOOKAT_DESCKEY: "একটি এনটিটি সবসময় অন্য এনটিটির মুখোমুখি হয়",
  T_40_XXJ_WS_PLAYABLEPOSFOLLOW_DESCKEY: "একটি এনটিটি অন্য এনটিটিকে অনুসরণ করে",
  T_40_XXJ_WS_PLAYABLETRAJECTORY_DESCKEY: "বুলেট ট্রেইল অ্যানিমেশন হলো বুলেট ট্রেইলের একটি সিমুলেটেড অ্যানিমেশন",
  T_40_XXJ_WS_PLAYER1_DESCKEY: "যে প্লেয়ার মেসেজ রিসিভ করবে",
  T_40_XXJ_WS_PLAYERAVATAR_DESCKEY: "প্লেয়ারের দ্বারা ব্যবহারকৃত অ্যাভাটার",
  T_40_XXJ_WS_PLAYERAVATARINFO_DESCKEY: "প্লেয়ারের দ্বারা ইকুইপ করা আউটফিট",
  T_40_XXJ_WS_PLAYERAVATARINFO_NAMEKEY: "প্লেয়ার আউটফিট",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_DESCKEY: "এই প্লেয়ারের HUD টাইপ",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_NAMEKEY: "প্লেয়ার HUD টাইপ",
  T_40_XXJ_WS_PLAYERIDINFAC: "ফ্যাকশন সিরিয়াল নম্বর.",
  T_40_XXJ_WS_PLAYERLOG_DESCKEY: "যে প্লেয়ারের লগ রেকর্ড করা হবে",
  T_40_XXJ_WS_PLAYERREMOVETOKEN_DESCKEY: "একটি নির্দিষ্ট প্লেয়ারের টোকেন গ্রহণ করুন৷",
  T_40_XXJ_WS_PLAYERSKILLS_DESCKEY: "প্লেয়ারের স্কিলগুলোর লিস্ট",
  T_40_XXJ_WS_PLAYERSTATETYPE_DESCKEY: "একজন প্লেয়ারের স্ট্যাটাস: জীবিত, নক ডাউন হওয়া বা এলিমিনেটেড",
  T_40_XXJ_WS_PLAYSPEED_DESCKEY: "প্লেব্যাক স্পিড",
  T_40_XXJ_WS_PLAYSPEED_NAMEKEY: "প্লে-ব্যাক স্পিড",
  T_40_XXJ_WS_PLAYSPEED1_DESCKEY: "উদাহরণস্বরূপ, 1.25 মানে আসল গতির চেয়ে 25% দ্রুত",
  T_40_XXJ_WS_POS_DESCKEY: "যে কোঅর্ডিনেটসগুলোকে টেলিপোর্ট করতে হবে",
  T_40_XXJ_WS_PRESENTEFFECTTEXTYPE_DESCKEY: "স্পেশাল ইফেক্টস স্টিকারের ধরণ",
  T_40_XXJ_WS_PRESSEDCOLOR_NAMEKEY: "প্রেস এ কালার",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_DESCKEY: "কী-ভ্যালু জোড়া পেতে একটি পাত্রের একটি ট্রাভার্সাল চালায়। একটি চাইল্ড প্রসেস অন্তর্ভুক্ত, যা একটি লুপ।",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_NAMEKEY: "লুপ ডিক্ট ভিজিট",
  T_40_XXJ_WS_PROGRESS_DESCKEY: "প্রগ্রেস [0,1]",
  T_40_XXJ_WS_PROGRESS_NAMEKEY: "প্রগ্রেস [0,1]",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_DESCKEY: "স্কিল প্রগ্রেসের বাটন",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_NAMEKEY: "স্কিল প্রগ্রেস বাটন",
  T_40_XXJ_WS_QUATERNION: "কোয়াটার্নিয়ন রোটেশন",
  T_40_XXJ_WS_QUICKCHATHUD_NAMEKEY: "কুইক মেসেজ HUD সুইচ",
  T_40_XXJ_WS_QUICKCHATSHOWHUD_NAMEKEY: "টিম লিস্টের পাশে মেসেজ",
  T_40_XXJ_WS_RADIUS_DESCKEY: "একটি পিল (বড়ির) আকৃতির দুটি অর্ধবৃত্তের ব্যাসার্ধ",
  T_40_XXJ_WS_READCELL: "একটি সেল রিড করুন",
  T_40_XXJ_WS_READCSV: "টেবিল কন্টেন্ট রিড করুন",
  T_40_XXJ_WS_READCSV_DESC: "পুরো টেবিলের কন্টেন্ট পড়ুন। একটি দ্বি-মাত্রিক অ্যারে রিটার্ন করুন।",
  T_40_XXJ_WS_READCSVCELL: "সারি # এবং কলামের নাম দ্বারা রিড করুন",
  T_40_XXJ_WS_READCSVCOL_DESC: "টেবিলে একটি নির্দিষ্ট কলামের কন্টেন্ট পড়ুন। একটি অ্যারে রিটার্ন করে।",
  T_40_XXJ_WS_READCSVROW_DESC: "টেবিলে একটি নির্দিষ্ট সারির কন্টেন্ট পড়ুন। একটি অ্যারে প্রদান করে।",
  T_40_XXJ_WS_READLEADERBOARD: "লিডারবোর্ড ভ্যালু পড়ুন",
  T_40_XXJ_WS_READLEADERBOARD_DESC: "ডাটাবেসের একটি লিডারবোর্ড টেবিলে একটি নির্দিষ্ট শনাক্তকারীর একটি সংশ্লিষ্ট ভ্যালু পড়ুন।",
  T_40_XXJ_WS_READLEADERBOARD2: "র‍্যাংক রেঞ্জ দিয়ে রিড করুন",
  T_40_XXJ_WS_READLEADERBOARD2_DESC: "একটি ডাটাবেসে লিডারবোর্ডে একটি নির্দিষ্ট র‍্যাংক থেকে একটি নির্দিষ্ট র‍্যাংকের মধ্যে পার্থক্যের ভ্যালু রিড করুন।",
  T_40_XXJ_WS_RED: "রেড",
  T_40_XXJ_WS_RELOAD: "রিলোড",
  T_40_XXJ_WS_RENDERTYPE_DESCKEY: "ডিসপ্লে মেথড",
  T_40_XXJ_WS_RESETPLAYERCLOTHES_DESCKEY: "প্লেয়ারের ডিফল্ট পোশাক রিস্টোর করুন",
  T_40_XXJ_WS_RESETPLAYERWEAPONSKINBYWEAPONID_DESCKEY: "প্লেয়ারের ডিফল্ট ওয়েপন স্কিন রিস্টোর করুন",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_DESCKEY: "ড্র্যাগিং করে আনা ভিউপোর্টে সীমাবদ্ধ কিনা। ডিফল্টভাবেই সিলেক্টেড।",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_NAMEKEY: "ড্র্যাগ সীমাবদ্ধ করবেন কিনা",
  T_40_XXJ_WS_RESULT_DESCKEY: "দ্য রেজাল্ট অফ দ্য রেড",
  T_40_XXJ_WS_RESULT_NAMEKEY: "রেজাল্ট",
  T_40_XXJ_WS_RESULT1_DESCKEY: "তালিকায় সবচেয়ে বড় সংখ্যা খুঁজে পাওয়া যাবে কিনা",
  T_40_XXJ_WS_RESULT2_DESCKEY: "তালিকায় সবচেয়ে ছোট সংখ্যাটি খুঁজে বের করতে হবে কিনা",
  T_40_XXJ_WS_RESULTVALUE_DESCKEY: "একটি লিস্ট থেকে সবচেয়ে ছোট সংখ্যাটিকে খুঁজে বের করুন",
  T_40_XXJ_WS_RESULTVALUE1_DESCKEY: "একটি তালিকায় সবচেয়ে বড় সংখ্যা খুঁজুন",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_DESCKEY: "একজন প্লেয়ারের রিভাইভাল পয়েন্ট। যদি কোন চেকপয়েন্ট না থাকে, একটি স্প্যানপয়েন্ট ব্যবহার করুন। অন্যথায় চেকপয়েন্ট ব্যবহার করুন।",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_NAMEKEY: "রিভাইভাল পয়েন্ট",
  T_40_XXJ_WS_RIGHTARM_DESCKEY: "ডান আর্ম",
  T_40_XXJ_WS_RIGHTARM_NAMEKEY: "ডান পক্ষ",
  T_40_XXJ_WS_RIGHTCOLOR_DESCKEY: "ডানদিকের কালার",
  T_40_XXJ_WS_RIGHTCOLOR_NAMEKEY: "ডান কালার",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_DESCKEY: "ডান দিকে স্পেশাল ইফেক্টস প্রদর্শন করা হবে কিনা",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_NAMEKEY: "ডান ইফেক্ট ডিসপ্লে হবে কিনা",
  T_40_XXJ_WS_RIGHTFOOT_DESCKEY: "ডান পা",
  T_40_XXJ_WS_RIGHTFOOT_NAMEKEY: "ডান পা",
  T_40_XXJ_WS_RIGHTHAND_DESCKEY: "ডান পক্ষ",
  T_40_XXJ_WS_RIGHTHAND_NAMEKEY: "ডান পক্ষ",
  T_40_XXJ_WS_RIGHTICON_DESCKEY: "ডান আইকন",
  T_40_XXJ_WS_RIGHTICON_NAMEKEY: "ডান আইকন",
  T_40_XXJ_WS_RIGHTLEG_DESCKEY: "ডান পা",
  T_40_XXJ_WS_RIGHTLEG_NAMEKEY: "ডান পা",
  T_40_XXJ_WS_RIGHTSCORETEXT_DESCKEY: "ডানদিকের স্কোর টেক্সট",
  T_40_XXJ_WS_RIGHTSCORETEXT_NAMEKEY: "ডানদিকের স্কোর টেক্সট",
  T_40_XXJ_WS_RIGHTTEXT_DESCKEY: "ডান টেক্সট",
  T_40_XXJ_WS_RIGHTTEXT_NAMEKEY: "ডান টেক্সট",
  T_40_XXJ_WS_RIGIDBODY_DESCKEY: "অনমনীয় বডি টাইপের উপাদান",
  T_40_XXJ_WS_RIGIDBODY_NAMEKEY: "রিজিড বডি কম্পোনেন্ট",
  T_40_XXJ_WS_RIGIDBODYTYPE_DESCKEY: "রিজিড বডি টাইপের প্রকার",
  T_40_XXJ_WS_RIGIDBODYTYPE_NAMEKEY: "রিজিড বডি টাইপ এনাম",
  T_40_XXJ_WS_ROW_DECS: "যেই সারিটি রিড করতে হবে।",
  T_40_XXJ_WS_ROWVALUE: "আদি কন্টেন্ট",
  T_40_XXJ_WS_SCALE_DESCKEY: "এই অবজেক্টের জুম স্কেল কনফিগার করুন",
  T_40_XXJ_WS_SCALE_NAMEKEY: "স্কেল",
  T_40_XXJ_WS_SCALE0_DESCKEY: "বিশ্বের কোঅর্ডিনেট সিরিজের জুম স্কেল",
  T_40_XXJ_WS_SCALE1_DESCKEY: "জুম স্কেল। ডিফল্টভাবে 1.",
  T_40_XXJ_WS_SCALECALUE_DESCKEY: "স্কেল ভ্যালু",
  T_40_XXJ_WS_SCENENAME_DESCKEY: "এই এরিয়ার নাম",
  T_40_XXJ_WS_SCOREBARHUD_DESCKEY: "স্কোরবার",
  T_40_XXJ_WS_SCOREBARHUD_NAMEKEY: "স্কোর বার",
  T_40_XXJ_WS_SCROLLDIRECTION_DESCKEY: "মোবাইল স্ক্রলিং ডিরেকশন্স সাপোর্ট করে",
  T_40_XXJ_WS_SCROLLDIRECTION_NAMEKEY: "স্ক্রল ডিরেকশন",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_DESCKEY: "স্ক্রলের ফ্যাক্টর। ভ্যালু যতো বড় হবে, স্ক্রোলিং তত দ্রুত হবে।",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_NAMEKEY: "স্ক্রল ফ্যাক্টর",
  T_40_XXJ_WS_SETCAMERACULLINGMASK_DESCKEY: "ক্যামেরার কুলিংমাস্ক কনফিগার করুন",
  T_40_XXJ_WS_SETGLOBAL: "গ্লোবাল সেট করুন",
  T_40_XXJ_WS_SETPARENT_D: "যেসব এনটিটির ট্রান্সফর্ম কম্পোনেন্ট আছে শুধুমাত্র সেগুলো সাপোর্ট করে",
  T_40_XXJ_WS_SETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "প্লেয়ারের আউটফিট ID কনফিগার করুন",
  T_40_XXJ_WS_SETPLAYERCLOTHIDS_DESCKEY: "একাধিক প্লেয়ারের আউটফিট মোডিফাই করুন",
  T_40_XXJ_WS_SETPLAYERFORWAR: "প্লেয়ার ডিরেকশন সেট করুন",
  T_40_XXJ_WS_SETPLAYERHUBSWITCH_DESCKEY: "একজন প্লেয়ারের HUD সুইচ কনফিগার করুন",
  T_40_XXJ_WS_SETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "প্লেয়ারের ওয়েপন স্কিন কনফিগার করুন",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_DESCKEY: "টার্গেট লোকেশনে এনটিটিগুলোকে ডিসপ্লে করতে হবে কিনা",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_NAMEKEY: "টার্গেটে থাকা ডিসপ্লে এনটিটি",
  T_40_XXJ_WS_SHOWPLAYER: "ডিসপ্লে এনটিটি",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD: "সিঙ্গেল-প্লেয়ার ম্যাচের বিবরণ HUD এনটিটি",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD_D: "সিঙ্গেল-প্লেয়ার ম্যাচের জন্য একটি HUD এনটিটি। এই এনটিটির প্রপার্টিজ পরিবর্তন করা সংশ্লিষ্ট UI-তে প্রদর্শিত কন্টেন্টকে প্রভাবিত করবে৷",
  T_40_XXJ_WS_SIZEDELTA: "অ্যাংকর বক্স এবং কম্পোনেন্টের",
  T_40_XXJ_WS_SKELETON: "কঙ্কাল",
  T_40_XXJ_WS_SKELETON_D: "স্কেলেটন মাস্ক অ্যাক্সেস করতে ব্যবহৃত পিভট",
  T_40_XXJ_WS_SKELETONPART_NAMEKEY: "স্কেলেটন পার্ট",
  T_40_XXJ_WS_SKILLBUTTONHUD: "স্কিল বাটন HUD এনটিটি",
  T_40_XXJ_WS_SLOT_DESCKEY: "দ্য ওয়েপন্স স্লট",
  T_40_XXJ_WS_SMOOTHDRAGSTART_DESCKEY: "সিলেক্ট করা হলে, ড্র্যাগ করে আনার সময় একটি ধীর মুভমেন্ট থাকবে। আনসিলেক্ট হলে, ড্র্যাগ করার গতি মাউসের গতির সাথে সংশ্লিষ্ট হবে।",
  T_40_XXJ_WS_SMOOTHDRAGSTART_NAMEKEY: "মোশন স্মুথ হবে কিনা",
  T_40_XXJ_WS_SOFTNESS_DESCKEY: "কোমলতা",
  T_40_XXJ_WS_SOFTNESS_NAMEKEY: "কোমলতা",
  T_40_XXJ_WS_SOUNDNTITY_NAMEKEY: "সাউন্ড এনটিটি",
  T_40_XXJ_WS_SPACE_DESCKEY: "স্পেস",
  T_40_XXJ_WS_SPACE_NAMEKEY: "চাইল্ড সেল স্পেসিং",
  T_40_XXJ_WS_SPAWNPOSVEC3_DESCKEY: "AI-এর স্পনপয়েন্টের কোঅর্ডিনেটস",
  T_40_XXJ_WS_SPAWNPOSVEC3_NAMEKEY: "স্পন পয়েন্ট কোঅর্ডিনেটস",
  T_40_XXJ_WS_SPEED_DESCKEY: "স্পিড",
  T_40_XXJ_WS_SPEED_NAMEKEY: "স্পিড",
  T_40_XXJ_WS_SPEEDUP_NAMEKEY: "স্প্রিন্ট",
  T_40_XXJ_WS_SPHERERADIUS_DESCKEY: "গোলকটির ব্যাসার্ধ",
  T_40_XXJ_WS_SPRAYCOLOR_DESCKEY: "স্প্রেটির রঙ",
  T_40_XXJ_WS_SPRAYCOLOR_NAMEKEY: "স্প্রে কালার",
  T_40_XXJ_WS_SPRAYRESULTHUD_DESCKEY: "স্প্রে রেজাল্ট",
  T_40_XXJ_WS_SPRAYRESULTHUD_NAMEKEY: "স্প্রে রেজাল্ট",
  T_40_XXJ_WS_SPRAYRIFLE_DESCKEY: "দ্য স্প্রে গান (অ্যাসল্ট রাইফেল)",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY: "স্প্রে রাইফেল",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY_01: "প্রাথমিক গতিবেগ",
  T_40_XXJ_WS_SPRITEFLIP_NAMEKEY: "ফ্লিপ স্টিকার",
  T_40_XXJ_WS_SPRITEID: "স্প্রাইট অ্যাসিস্ট ID",
  T_40_XXJ_WS_SPRITEID_D: "স্প্রাইট রিসোর্স বর্ণনা করতে ব্যবহৃত আইডি",
  T_40_XXJ_WS_SPRITETYPE_NAMEKEY: "স্টিকার টাইপ",
  T_40_XXJ_WS_STARGETENTITY_DESCKEY: "একটি স্ট্যাটিক পিক্সেল তৈরি করার টার্গেট এনটিটি",
  T_40_XXJ_WS_STARTPOSITION_D: "এই আকৃতির জ্যামিতিক কেন্দ্রের কো-অর্ডিনেটস",
  T_40_XXJ_WS_STAY_D: "বর্তমান বিশ্বের অবস্থান, ঘূর্ণন, এবং শিশুর স্কেলিং ধরে রাখবেন? এটি সাধারণত সত্য হিসাবে সেট করা হয়, এবং UI সেটিংস এই অপশনটির জন্য অকার্যকর।",
  T_40_XXJ_WS_STRING_NAMEKEY: "স্ট্রিং",
  T_40_XXJ_WS_STRING2FLOAT_DESCKEY: "একটি স্ট্রিংকে ফ্লোটে রূপান্তর করুন",
  T_40_XXJ_WS_STRING2INT_DESCKEY: "কোনো একটি স্ট্রিং-কে একটি পূর্ণসংখ্যাতে কনভার্ট  করুন",
  T_40_XXJ_WS_STYLE_DESCKEY: "ইন্টারপোলেশনের খেলার পদ্ধতি। অপশনগুলোর মধ্যে রয়েছে একবার খেলা, লুপ করা এবং আবার খেলা।",
  T_40_XXJ_WS_SWITCHPLAYERAREA_DESCKEY: "প্লেয়ারের এরিয়া সুইচ করুন",
  T_40_XXJ_WS_SWITCHVALUE_DESCKEY: "সুইচ ভ্যাল্যু",
  T_40_XXJ_WS_SWITCHWEAPONBYSLOT_DESCKEY: "প্লেয়ারের স্লট অনুযায়ী ওয়েপন সুইচ করুন",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_DESCKEY: "আইটেম স্লটটিকে সুইচ করুন",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_NAMEKEY: "আইটেম সুইচ",
  T_40_XXJ_WS_TABLENAME_DESC: "টেবিল নাম হিসাবে প্রদর্শিত কিন্তু আসলে UID",
  T_40_XXJ_WS_TABLEVALUE: "টেবিল কন্টেন্ট",
  T_40_XXJ_WS_TAGSLIST_DESCKEY: "ট্যাগের তালিকা",
  T_40_XXJ_WS_TARGET_DESCKEY: "ম্যাপ পিক্সেল তৈরি করার টার্গেট এনটিটি। ডিফল্টরূপে খালি।",
  T_40_XXJ_WS_TARGET_NAMEKEY: "ম্যাপ পিক্সেল ক্রিয়েট করার এনটিটি",
  T_40_XXJ_WS_TARGETATK_DESCKEY: "টার্গেট অ্যাটাক করুন",
  T_40_XXJ_WS_TARGETENTITY_DESCKEY: "টার্গেট এনটিটি",
  T_40_XXJ_WS_TARGETENTITY_NAMEKEY: "এনটিটি",
  T_40_XXJ_WS_TARGETENTITY1_DESCKEY: "কাস্টমাইজড ফাংশনটি যেই এনটিটিতে রয়েছে",
  T_40_XXJ_WS_TARGETENTITYAPLAYER_DESCKEY: "যেই এনটিটি AI দ্বারা আঘাতপ্রাপ্ত হয়েছে",
  T_40_XXJ_WS_TARGETENTITYFOLLOW_DESCKEY: "যেই টার্গেট এনটিটি ফলো করা হবে",
  T_40_XXJ_WS_TARGETENTITYITEM_DESCKEY: "আইটেম এনটিটি (খালি থাকতে পারে)",
  T_40_XXJ_WS_TARGETENTITYLOOK_DESCKEY: "যে টার্গেট এনটিটির দিকে লক্ষ্য করতে হবে",
  T_40_XXJ_WS_TARGETENTITYSOUND_DESCKEY: "যেই সাউন্ড এনটিটি পজ করা হয়েছে",
  T_40_XXJ_WS_TARGETENTITYSOUND2_DESCKEY: "পজ রাখার পর প্লে করার মতো সাউন্ড এনটিটি",
  T_40_XXJ_WS_TARGETENTITYSOUND3_DESCKEY: "যে সাউন্ড এনটিটি ডিলিট করতে হবে",
  T_40_XXJ_WS_TEAMMATESINFO_NAMEKEY: "টিমমেটদের ইনফো",
  T_40_XXJ_WS_TELEPORTA_D: "প্লেয়ারকে একটি নির্দিষ্ট দিকনির্দেশ সহ একটি নির্দিষ্ট স্থানে টেলিপোর্ট করুন",
  T_40_XXJ_WS_TEXT_NAMEKEY: "টিপ টেক্সট",
  T_40_XXJ_WS_TEXTCOLOR_NAMEKEY: "নোটিফিকেশন টেক্সট কালার",
  T_40_XXJ_WS_TEXTENTITY_DESCKEY: "টেক্সট এনটিটি যেসব টেক্সট ডিসপ্লে করতে হবে তার প্রতিনিধিত্ব করে",
  T_40_XXJ_WS_TEXTKEY_DESCKEY: "যে টেক্সট কী-গুলো ডিসপ্লে করতে হবে",
  T_40_XXJ_WS_TEXTKEY_NAMEKEY: "টেক্সট কী",
  T_40_XXJ_WS_TIMESTAMP_DESCKEY: "টাইমস্ট্যাম্প",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_DESCKEY: "একটি স্থানীয়কৃত স্ট্রিং এর ডিসপ্লে স্টাইল",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_NAMEKEY: "টাইমস্ট্যাম্প ডিসপ্লে স্টাইল",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_DESCKEY: "একটি টাইমস্ট্যাম্পের অনুবাদকৃত স্ট্রিং",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_NAMEKEY: "Loc স্ট্রিং টাইমস্ট্যাম্প",
  T_40_XXJ_WS_TIPHUD_DESCKEY: "হিন্ট",
  T_40_XXJ_WS_TIPHUD_NAMEKEY: "টিপ",
  T_40_XXJ_WS_TOKENCOUNT_DESCKEY: "লুটপাটযোগ্য আইটেমের পরিমাণ",
  T_40_XXJ_WS_TOKENID_DESCKEY: "একটি লুটযোগ্য আইটেম ID",
  T_40_XXJ_WS_TOWSPEED_DESCKEY: "একজন প্লেয়ারের টো স্পিড",
  T_40_XXJ_WS_TRANSITIONTYPE_NAMEKEY: "ট্রান্সেলশন টাইপ",
  T_40_XXJ_WS_TWEENENTITY_DESCKEY: "ইন্টারপোলেশন অ্যানিমেশন এনটিটি",
  T_40_XXJ_WS_TYPE_DESCKEY: 'এটা হলো বর্ণনার ধরন। "typeof" ব্যবহার হলে তা এটার টাইপ রিটার্ট করে দেবে।',
  T_40_XXJ_WS_TYPE_NAMEKEY: "রিজিড বডি টাইপ",
  T_40_XXJ_WS_TYPE2_DESCKEY: "বিভিন্ন ধরণের অনমনীয় বডিগুলোর বিভিন্ন কাজ রয়েছে",
  T_40_XXJ_WS_TYPE3_DESCKEY: "বর্তমান সংস্করণে শুধুমাত্র মৌলিক মুদ্রাগুলো সাপোর্ট করে",
  T_40_XXJ_WS_USEDEPTHMAP_DESCKEY: "মিনিম্যাপ গভীরতা প্রদর্শন সক্রিয় করা হবে কিনা",
  T_40_XXJ_WS_USEDEPTHMAP_NAMEKEY: "ডেপথ ম্যাপ ব্যবহার করুন",
  T_40_XXJ_WS_USEGRAVITY_DESCKEY: "এটি মহাকর্ষীয় নিয়ম অনুসরণ করে কিনা",
  T_40_XXJ_WS_USEGRAVITY_NAMEKEY: "মাধ্যাকর্ষণ আছে কিনা",
  T_40_XXJ_WS_UUID_DESCKEY: "একজন প্লেয়ারের স্বতন্ত্র শনাক্তকারী",
  T_40_XXJ_WS_UUID_NAMEKEY: "UUID",
  T_40_XXJ_WS_VALUE_DESCKEY: "দ্য ভ্যাল্যু",
  T_40_XXJ_WS_VALUE_NAMEKEY: "ভ্যাল্যু",
  T_40_XXJ_WS_VALUE01_NAMEKEY: "ভ্যালু [0, 1]",
  T_40_XXJ_WS_VALUE1_DESCKEY: "প্রথম ভ্যালু",
  T_40_XXJ_WS_VALUE2_DESCKEY: "দ্য সেকেন্ড ভ্যাল্যু",
  T_40_XXJ_WS_VALUE6_DESCKEY: "ভ্যাল্যু [0,1]",
  T_40_XXJ_WS_VALUEA_DESCKEY: "প্রারম্ভিক ভ্যাল্যু",
  T_40_XXJ_WS_VALUEB_DESCKEY: "টার্গেট ভ্যালু",
  T_40_XXJ_WS_VALUENAME_DESCKEY: "অতিক্রম করার ভ্যাল্যুর নাম। আপনি একটি লোকাল ভেরিয়েবলের ভ্যাল্যু পেতে এটি ব্যবহার করতে পারেন।",
  T_40_XXJ_WS_VALUET_DESCKEY: "ইন্টারপোলেশন অগ্রগতি। 0 এবং 1 এর মধ্যে রয়েছে।",
  T_40_XXJ_WS_VARTYPE_NAMEKEY: "ভ্যারিয়েবল টাইপ",
  T_40_XXJ_WS_VERTICALBAR_DESCKEY: "ভার্টিকাল ডিসপ্লে টাইপ",
  T_40_XXJ_WS_VERTICALBAR_NAMEKEY: "ভার্টিক্যাল ডিসপ্লে টাইপ",
  T_40_XXJ_WS_VISIBILITYLAYER_DESCKEY: "একটি বস্তুর দৃশ্যমানতার লেভেল",
  T_40_XXJ_WS_VISIBILITYLAYER_NAMEKEY: "দৃশ্যমান প্লেয়ার",
  T_40_XXJ_WS_WARDROBETYPE_DESCKEY: "পোশাকের মধ্যে রয়েছে বান্ডেল, হেড, মাস্ক, ফেসপেইন্ট, টপ, বটম এবং জুতা",
  T_40_XXJ_WS_WARDROBETYPE_NAMEKEY: "আউটফিট টাইপ",
  T_40_XXJ_WS_WARDROBETYPE6_DESCKEY: "আউটফিট স্লট",
  T_40_XXJ_WS_WEAPONHUD_NAMEKEY: "ওয়েপন্স",
  T_40_XXJ_WS_WEAPONSKINID_DESCKEY: "ওয়েপন স্কিন ID",
  T_40_XXJ_WS_WEAPONSKINID_NAMEKEY: "ওয়েপন স্কিন ID",
  T_40_XXJ_WS_WEAPONSKINID1_DESCKEY: "ওয়েপন স্কিনের ID",
  T_40_XXJ_WS_WEAPONSKINID6_DESCKEY: "এই প্লেয়ারের ওয়েপন স্কিন",
  T_40_XXJ_WS_WIDGETTYPEENUM: "কম্পোনেন্ট টাইপ এনাম",
  T_40_XXJ_WS_WIDTH_DESCKEY: "প্রশস্ততা",
  T_40_XXJ_WS_WORDWRAP_NAMEKEY: "ওয়ার্ড ওয়ার্প",
  T_40_XXJ_WS_WRITELEADERBOARD: "লিডারবোর্ড ভ্যাল্যু লিখুন",
  T_40_XXJ_WS_WRITELEADERBOARD_DESC: "ডাটাবেসের একটি নির্দিষ্ট লিডারবোর্ড টেবিলে একটি নির্দিষ্ট কী-এর সংশ্লিষ্ট মান লিখুন।",
  T_40_XYL_WS_BUMPERFACTORY: "বাম্পার কার ফ্যাক্টরি",
  T_40_XYL_WS_BURNDAMAGE: "দহনজনিত ড্যামেজ",
  T_40_XYL_WS_BURNINTERVAL: "কমবাশন ড্যামেজ ইন্টারভাল (s)",
  T_40_XYL_WS_BURNTIME: "বিস্ফোরণের পর দহনের সময়",
  T_40_XYL_WS_COLORFULSKY: "বর্নিল আকাশ",
  T_40_XYL_WS_CRANEMACHINE: "ক্লো ক্রেইন",
  T_40_XYL_WS_CRASHMAXDAMAGE: "ম্যাক্সিমাম ক্র্যাশ ড্যামেজ",
  T_40_XYL_WS_CRASHMAXSPEED: "ক্র্যাশ ড্যামেজের সর্বোচ্চ গতি সীমা",
  T_40_XYL_WS_CRASHMESS: "সংঘর্ষের সময় থাকা ম্যাস প্যারামিটার",
  T_40_XYL_WS_CRASHMINDAMAGE: "মিনিমাম ক্র্যাশ ড্যামেজ",
  T_40_XYL_WS_DISPLAYBOARD: "বিলবোর্ড",
  T_40_XYL_WS_EXPLODEDAMAGE: "এক্সপ্লোশন ড্যামেজ",
  T_40_XYL_WS_EXPLODEDELAY: "এক্সপ্লোশন ডিলে টাইম",
  T_40_XYL_WS_EXPLODERANGE: "এক্সপ্লোশন রেঞ্জ",
  T_40_XYL_WS_FERRISWHEEL: "ফেরিস হুইল",
  T_40_XYL_WS_FOODTRUCK002: "ফুড ট্রাক B",
  T_40_XYL_WS_GEARSHIFTDELAY: "গিয়ার চেঞ্জিং টাইম (s)",
  T_40_XYL_WS_ICAROUSEL001: "মেরি-গো-রাউন্ড কম্পোনেন্ট A",
  T_40_XYL_WS_ICAROUSEL002: "মেরি-গো-রাউন্ড কম্পোনেন্ট B",
  T_40_XYL_WS_ICAROUSEL003: "মেরি-গো-রাউন্ড",
  T_40_XYL_WS_ICEDANCEDOOL: "ব্লু ডল",
  T_40_XYL_WS_IDLEBRAKEINPUT: "অনিয়ন্ত্রিত পার্কিং হর্সপাওয়ার অনুপাত",
  T_40_XYL_WS_LOLLIPOP: "জায়ান্ট ললিপপ",
  T_40_XYL_WS_NEWHOOKGUN: "সুপার হুক গান",
  T_40_XYL_WS_OPENSWING: "সুইং বাটন",
  T_40_XYL_WS_OPENTRACTION: "টো বাটন",
  T_40_XYL_WS_PODIUM: "পোডিয়াম",
  T_40_XYL_WS_SKYCITY: "সিটি",
  T_40_XYL_WS_SKYSCRAPER_A001: "স্কাইস্ক্র্যাপার A কম্পোনেন্ট A",
  T_40_XYL_WS_SKYSCRAPER_A002: "স্কাইস্ক্র্যাপার A কম্পোনেন্ট B",
  T_40_XYL_WS_SKYSCRAPER_A003: "স্কাইস্ক্র্যাপার A কম্পোনেন্ট C",
  T_40_XYL_WS_SKYSCRAPER_B001: "স্কাইস্ক্র্যাপার B কম্পোনেন্ট A",
  T_40_XYL_WS_SKYSCRAPER_B002: "স্কাইস্ক্র্যাপার B কম্পোনেন্ট B",
  T_40_XYL_WS_SKYSCRAPER_B003: "স্কাইস্ক্র্যাপার B কম্পোনেন্ট C",
  T_40_XYL_WS_SKYSCRAPER_C001: "স্কাইস্ক্র্যাপার C কম্পোনেন্ট A",
  T_40_XYL_WS_SKYSCRAPER_C002: "স্কাইস্ক্র্যাপার C কম্পোনেন্ট B",
  T_40_XYL_WS_SKYSCRAPER_C003: "স্কাইস্ক্র্যাপার C কম্পোনেন্ট C",
  T_40_XYL_WS_SKYSCRAPER_D001: "স্কাইস্ক্র্যাপার D কম্পোনেন্ট A",
  T_40_XYL_WS_SKYSCRAPER_D002: "স্কাইস্ক্র্যাপার D কম্পোনেন্ট B",
  T_40_XYL_WS_SKYSCRAPER_D003: "স্কাইস্ক্র্যাপার D কম্পোনেন্ট C",
  T_40_XYL_WS_SKYSCRAPER_E001: "স্কাইস্ক্র্যাপার E কম্পোনেন্ট A",
  T_40_XYL_WS_SKYSCRAPER_E002: "স্কাইস্ক্র্যাপার E কম্পোনেন্ট B",
  T_40_XYL_WS_SKYSCRAPER_E003: "স্কাইস্ক্র্যাপার E কম্পোনেন্ট C",
  T_40_XYL_WS_STEERANGLE: "হাই-স্পিড টার্নিং রেডিয়াস",
  T_40_XYL_WS_STEERSPEED: "হাই-স্পিড টার্নিং এর সময় ম্যাক্সিমাম স্পিড",
  T_40_XYL_WS_SWINGSPEED: "সুইং স্পিড",
  T_40_XYL_WS_TARGETOBJECT: "মোশন অ্যাংকর",
  T_40_XYL_WS_TRACTIONSPEED: "টো স্পিড",
  T_40_XYL_WS_TRIGGERCAPSULE: "কাস্টম ক্যাপসুল ট্রিগার",
  T_40_XYL_WS_TRIGGERSPHERE: "কাস্টম স্ফেয়ার ট্রিগার",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT: "কাস্টম অবজেক্ট",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT_DESC: "একটি খালি অবজেক্ট কম্পোনেন্ট, যা রেন্ডার কম্পোনেন্ট এবং কলিশন কম্পোনেন্টের সাথে ব্যবহার করা যেতে পারে।",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER: "কাস্টম রেন্ডার কম্পোনেন্ট",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER_DESC: "একটি কাস্টম রেন্ডারিং কম্পোনেন্ট, কাস্টম মডেল রিসোর্সগুলোর সাথে রেন্ডারিংয়ের জন্য ব্যবহৃত হয়।",
  T_41_B_SKILL_DESC_ASSASSINGIRL: "আপনার এনিমি মার্কিং এর বাউন্টি ভ্যালু আছে। মিত্র টিমের যে কেউ একজন চিহ্নিত এনিমিকে এলিমিনেট করে [FFB300]{0} ইন-ম্যাচ কারেন্সি[-] অর্জন করবে। এনিমিকে এলিমিনেট করার জন্য আপনি অতিরিক্ত [FFB300]100[-] উপার্জন করবেন। BR ম্যাচগুলিতে কয়েন মেশিন থেকে অতিরিক্ত [FFB300]{1} FF কয়েন[-] পান।",
  T_41_B_SKILL_NAME_ASSASSINGIRL: "মানি মার্ক",
  T_41_CJ_A_ESPORTS_TH: "FFTC দ্য প্রো (মাস্ক)",
  T_41_CJ_B_ESPORTS_TH: "FFTC দ্য প্রো (বটম)",
  T_41_CJ_H_ESPORTS_TH: "FFTC দ্য প্রো (হেড)",
  T_41_CJ_S_ESPORTS_TH: "FFTC দ্য প্রো (জুতা)",
  T_41_CJ_T_ESPORTS_TH: "FFTC দ্য প্রো (টপ)",
  T_41_CJ_T_FFSI: "FFSI চ্যাম্পিয়ন জার্সি",
  T_41_CJ_T_FOOTBALL_EU01: "সানব্রাস্ট জার্সি",
  T_41_CJ_T_FOOTBALL_EU02: "বোল্ড রেড জার্সি",
  T_41_CJ_T_FOOTBALL_EU03: "ম্যাজেস্টিক ক্রাউন জার্সি",
  T_41_CJ_T_FOOTBALL_EU04: "রিগ্যাল টাইটান জার্সি",
  T_41_H_CHARACTER_ASSASSINGIRL_N: "সুজি",
  T_41_LXW_TabName_Items: "আইটেম",
  T_41_R_CD_COIL: "জোন সংকোচন",
  T_41_SJ_WS_SPECIALITEM_ENABLE_DES: "এই ডিভাইসটি অ্যাক্টিভেট করতে হবে কিনা",
  T_41_SJ_WS_SPECIALITEM_NAME: "ডিভাইস",
  T_41_SW_SKILL_DESC_DELIVERY: "[FFB300]{0}m[-] এর মধ্যে থেকে কোনো এনিমি কর্তৃক আঘাত প্রাপ্ত হলে, আক্রমণকারীকে [FFB300]{1}s[-] এর জন্য চিহ্নিত করা হয় (ইন্টেল টিমমেটদের সাথে শেয়ার করা হয়)। সর্বোচ্চ [FFB300]{2} টি মার্কিং[-]।",
  T_41_SW_SKILL_DESC_GANGLEADER: "ম্যাচের শুরুতে [FFB300]{0} এক্সট্রা শিল্ড পয়েন্ট[-] পান। কোনো কমব্যাটে সার্ভাইভ করার পরে শিল্ড পয়েন্ট রিকোভার করে।",
  T_41_SW_SKILL_DESC_JUNKENGINEER: "একটি অ্যাক্টিভ স্কিল ব্যবহার করার সময়, [FFB300]{1} শিল্ড পয়েন্ট[-] দেয় [FFB300]{0}m[-] এর মধ্যে নিজেকে এবং টিমমেটদের। শিল্ড পয়েন্টগুলো [FFB300]{2}s[-] এর পরে বিলুপ্ত হয়, এর পরে প্লেয়ারেরা আবার ইফেক্টগুলো অর্জন করতে পারে। কুলডাউন: [FFB300]{3}s[-]।",
  T_41_SW_SKILL_DESC_WINTERGUY: "আঘাত করার সময় প্রতি সেকেন্ডে ডিপ্লয় করা গ্লু-ওয়ালগুলো [FFB300]{0}[-] স্থায়িত্ব রিস্টোর করে, এই সময়ে [FFB300]{1}m[-] এর মধ্যে থাকা টিমমেটরা [FFB300]{2} HP/s[-] রিস্টোর করে। প্রতিটি গ্লু-ওয়াল থেকে প্রতি টিমমেটের জন্য  সর্বোচ্চ [FFB300]{3} HP[-] নির্ধারিত।",
  T_41_SY_PETSKIN_CACTUS_SUGARSKULL23_N: "পেট স্কিন: রিকালেক্টিভ ক্যাকটাস",
  T_41_SY_PETSKIN_HAWK_INKPAINTING_N: "পেট স্কিন: ইংকড ফ্যালকো",
  T_41_WCL_CREDITSCORE_PENALTY_HISTORY_TYPE: "টাইপ",
  T_41_WT_SKILL_DESC_FIREBOY: "একটি ফ্লেমিং স্ক্রিন স্থাপন করুন যা [FFB300]{1}m[-] প্রশস্ত যা [FFB300]{0}s[-] স্থায়ী হয় এবং [FFB300]{2}m/s[-] গতিতে [FFB300]{3}s[-] পর্যন্ত এগিয়ে যাবে। ইফেক্ট চলাকালীন, স্কিল আবার ব্যবহার করে স্ক্রীন থামানো যাবে। [FFB300]যেসব এনিমি (অথবা গ্লু ওয়াল)[-] এর সংস্পর্শে আসবে তারা তৎক্ষণাত [FFB300]{4} (অথবা{5})DMG[-] গ্রহণ করবে এবং তারপর [FFB300]{6} (অথবা {7}) DMG[-]/s[-] গ্রহণ করবে। [FFB300]{8}s[-] স্থায়ী হয়। কুলডাউন: [FFB300]{9}s[-]। সর্বোচ্চ [FFB300]{10}[-] বার স্কিল ব্যবহার স্টোর করা যাবে, এবং প্রতিটা ব্যবহারের মধ্যে [FFB300]{11}s[-] কুলডাউন থাকবে।",
  T_41_WT_SKILL_NAME_FIREBOY: "ফ্লেইম মিরেজ",
  T_41_WZY_WS_CHARGEMAX: "ম্যাক্স. গ্লু মেকার চার্জ",
  T_41_WZY_WS_CROSSBOWNAME: "ক্রসবো",
  T_41_WZY_WS_DECELERATIONRATIO: "পানিতে গতি হ্রাসের %",
  T_41_WZY_WS_DEICEWALLPARAM1: "গলিত এরিয়ার ব্যসার্ধ",
  T_41_WZY_WS_DEICEWALLPARAM2: "গলিত সময়কাল",
  T_41_WZY_WS_EXPPERCHIP: "গ্লু চিপ থেকে EXP",
  T_41_WZY_WS_EXPPERDAMAGE: "ডিল করা DMG থেকে EXP",
  T_41_WZY_WS_EXPPERMOVEMILE: "ট্রাভেলকৃত প্রতি মিটারে EXP",
  T_41_WZY_WS_EXPPERSECOND: "প্রতি সেকেন্ডে EXP",
  T_41_WZY_WS_GRENADEEXPTIME: "এক্সপ্লোশন ডিলে",
  T_41_WZY_WS_GRENADELAUNCHNAME: "এক্সপ্লোসিভ",
  T_41_WZY_WS_GRENADEMAX: "ম্যাক্সিমাম DMG",
  T_41_WZY_WS_GRENADEMIN: "মিনিমাম DMG",
  T_41_WZY_WS_GRENADERANGE: "এক্সপ্লোশন রেঞ্জ",
  T_41_WZY_WS_GRENADERATIOCEHICLE: "ভেহিক্যালে DMG কো-ইফিশেন্ট",
  T_41_WZY_WS_GRENADERATIOSELF: "নিজের উপর DMG কো-ইফিশেন্ট",
  T_41_WZY_WS_GRENADERATIOTEAMMATE: "টিমমেটদের উপর DMG কো-ইফিশেন্ট",
  T_41_WZY_WS_GRENADTHROWSPEED: "এক্সপ্লোসিভ ট্রাভেল স্পিড",
  T_41_WZY_WS_HANDCANNONNAME: "হ্যান্ড ক্যানন",
  T_41_XXJ_WS_ACCELERATION: "অ্যাক্সিলারেশন",
  T_41_XXJ_WS_ACCELERATION_D: "মনোনীত একটি অ্যাক্সিলারেশন ইফেক্ট তৈরি করুন",
  T_41_XXJ_WS_ACTION: "অ্যাকশন নোড",
  T_41_XXJ_WS_ACTION_D: "অ্যাকশন পিভট",
  T_41_XXJ_WS_ADDHP: "হিলিং আইটেম",
  T_41_XXJ_WS_ADDPLAYERMAXHP: "ম্যাক্স. HP এড করুন",
  T_41_XXJ_WS_AICASTSKILL_D: "AI রিলিজ স্কিল",
  T_41_XXJ_WS_AIMASSISTCENTEROFFSET: "এইম অ্যাসিস্ট সেন্টার অফসেট",
  T_41_XXJ_WS_AIMASSISTDISTANCE: "এইম অ্যাসিস্ট দূরত্ব",
  T_41_XXJ_WS_AIMASSISTENTITY: "এইম অ্যাসিস্ট এনটিটি",
  T_41_XXJ_WS_AIMASSISTENTITY_D: "এমন এনটিটি যেটিকে এইম অ্যাসিস্ট করা যাবে",
  T_41_XXJ_WS_AISKILLTYPE: "জোম্বি স্কিল টাইপ",
  T_41_XXJ_WS_AISKILLTYPE_D: "জোম্বি স্কিল টাইপ",
  T_41_XXJ_WS_ALLITEMGOODSTYPE: "সকল আইটেম",
  T_41_XXJ_WS_ALLITEMGOODSTYPE_D: "সকল আইটেম",
  T_41_XXJ_WS_AMMOCLIPSIZE: "ম্যাগাজিন সাইজ মোডিফাই করুন",
  T_41_XXJ_WS_AMMOCLIPSIZE_D: "ম্যাগাজিনে থাকা বুলেট",
  T_41_XXJ_WS_ANCHORPOSITION_D: "এই অ্যাংকর প্যারেন্টদের সম্পর্কের মধ্যে সমন্বয় সাধন করে",
  T_41_XXJ_WS_ANGLE_D: "z অক্ষ রোটেশন অ্যাংগেল",
  T_41_XXJ_WS_ANGULARDRAG: "কৌণিক ড্র্যাগ",
  T_41_XXJ_WS_ANGULARVELOCITY: "কৌণিক বেগ",
  T_41_XXJ_WS_ANIMATIONCLIP: "অ্যানিমেশন স্টেট",
  T_41_XXJ_WS_ANIMATIONCONTROLLER: "অ্যানিমেশন কন্ট্রোলার",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE: "অ্যানিমেশন এনটিটি",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE_D: "অ্যানিমেশন কন্ট্রোলার পরিচালনা করতে ব্যবহৃত ফাইল এবং রিসোর্স",
  T_41_XXJ_WS_ANIMATIONCONTROLLERRESUUID: "অ্যানিমেশন কন্ট্রোলার রিসোর্স UUID",
  T_41_XXJ_WS_ANIMATIONOVERRIDELOOPTYPE: "লুপ টাইপ এনাম",
  T_41_XXJ_WS_ANIMATIONSTATE: "অ্যানিমেশন অবস্থা",
  T_41_XXJ_WS_ARITHMETICTYPE_D: "এমন অপারেশন, যেখানে সমস্ত ধরণের মান নিয়োগ সমর্থিত, এবং ডিজিটাল টাইপগুলো স্ব-বৃদ্ধি, স্ব-বিয়োগ, স্ব-গুণ এবং স্ব-বিভাজন সমর্থন করে।",
  T_41_XXJ_WS_ATTACHMENT: "অ্যাটাচমেন্ট",
  T_41_XXJ_WS_ATTACHMENT_D: "অ্যাটাচমেন্ট",
  T_41_XXJ_WS_ATTACHTARGET: "লিংকড এনটিটি",
  T_41_XXJ_WS_BAG: "ব্যাকপ্যাক",
  T_41_XXJ_WS_BAG_D: "ব্যাকপ্যাক কম্পোনেন্ট",
  T_41_XXJ_WS_BANNERID: "ব্যানার ID",
  T_41_XXJ_WS_BANNERID_D: "ব্যানার ID",
  T_41_XXJ_WS_BEHAVIOURTREE: "বিহেভিয়ার ট্রি",
  T_41_XXJ_WS_BEHAVIOURTREE_D: "বিহেভিয়ার ট্রি",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE: "বিহেভিয়ার-মাউন্টেবল ট্রি এনটিটি",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE_D: "এমন একটি বিহেভিয়ার ট্রি, যা মাউন্ট করা যায়",
  T_41_XXJ_WS_BEHAVIOURTREENODE: "বিহেভিয়ার ট্রি কাস্টম নোড",
  T_41_XXJ_WS_BEHAVIOURTREENODE_D: "বিহেভিয়ার ট্রি কাস্টম পিভট",
  T_41_XXJ_WS_BODY: "বডি",
  T_41_XXJ_WS_BORDERLR: "বর্ডার (বাম & ডান)",
  T_41_XXJ_WS_BORDERLR_D: "বাম এবং ডান বর্ডার",
  T_41_XXJ_WS_BORDERTB: "বর্ডার (টপ & বটম)",
  T_41_XXJ_WS_BORDERTB_D: "শীর্ষ এবং পাদদেশের বর্ডার",
  T_41_XXJ_WS_BRPEAKRANK: "সর্বোচ্চ BR র‍্যাংক",
  T_41_XXJ_WS_BRPEAKRANK_D: "সর্বোচ্চ BR র‍্যাংক",
  T_41_XXJ_WS_BRRANK: "BR র‍্যাংক",
  T_41_XXJ_WS_BRRANK_D: "BR র‍্যাংক",
  T_41_XXJ_WS_BTCUSTOMNODETYPE: "বিহেভিয়ার ট্রি নোড টাইপ",
  T_41_XXJ_WS_BTCUSTOMNODETYPE_D: "বিহেভিয়ার ট্রি পিভট টাইপ",
  T_41_XXJ_WS_BTREE: "বিহেভিয়ার ট্রি",
  T_41_XXJ_WS_BTREENODESTATE: "বিহেভিয়ার ট্রি নোড স্টেট",
  T_41_XXJ_WS_BTREENODESTATE_D: "বিহেভিয়ার ট্রি পিভট অপারেটিং স্ট্যাটাস",
  T_41_XXJ_WS_BUFFABLEENTITY: "বাফ-এনাবলড এনটিটি",
  T_41_XXJ_WS_BUFFABLEENTITY_D: "বাফ যোগ করা, বাফ অপসারণ এবং বাফ তালিকা যোগ করা এনাবল করে",
  T_41_XXJ_WS_BUILDINGICEWALL: "গ্লু ওয়াল",
  T_41_XXJ_WS_CAMOUFLAGE: "ফাংশনাল আইটেমসমূহ",
  T_41_XXJ_WS_CAMOUFLAGE_D: "স্কাইবোর্ড, ক্যামোফ্লেজ...",
  T_41_XXJ_WS_CAPICITY_D: "প্রাথমিক ক্যাপাসিটি",
  T_41_XXJ_WS_CENTERINVISIBLE: "কেন্দ্রে অদৃশ্য",
  T_41_XXJ_WS_CENTERINVISIBLE_D: "কেন্দ্রে দৃশ্যমান নয়",
  T_41_XXJ_WS_COLOR: "কালার",
  T_41_XXJ_WS_COLOR_D: "কালার",
  T_41_XXJ_WS_CONDITION: "কন্ডিশন নোড",
  T_41_XXJ_WS_CONDITION_D: "শর্ত একটি বিশেষ বুলিয়ান টাইপ",
  T_41_XXJ_WS_CONDITION1_D: "কন্ডিশন পিভট",
  T_41_XXJ_WS_CONSTRAIN: "RigidBody কনস্ট্রেন্ট",
  T_41_XXJ_WS_CONSTRAIN_D: "RigidBody-এ সীমাবদ্ধতা যোগ করুন। এটি RigidBody কন্সট্রেন্ট টাইপের একটি সংকলন।",
  T_41_XXJ_WS_COUNT_D: "এমাউন্ট",
  T_41_XXJ_WS_CROSSBOW_D: "ক্রসবো",
  T_41_XXJ_WS_CSPEAKRANK: "সর্বোচ্চ CS র‍্যাংক",
  T_41_XXJ_WS_CSPEAKRANK_D: "সর্বোচ্চ CS র‍্যাংক",
  T_41_XXJ_WS_CSRANK: "CS র‍্যাংক",
  T_41_XXJ_WS_CSRANK_D: "CS র‍্যাংক",
  T_41_XXJ_WS_CSVNAME_D: "SceneData এর অধীনে থাকা csv ফাইল যা এই মোডের সাথে সংশ্লিষ্ট। .csv-এ শেষ হয়। হেডারগুলো ছোট হাতের অক্ষরে লিখিত।",
  T_41_XXJ_WS_CURCAPACITY: "ব্যবহৃত ক্যাপাসিটি",
  T_41_XXJ_WS_CURPROGRESS: "বর্তমান প্রগ্রেস",
  T_41_XXJ_WS_CURRENTCLIP: "বর্তনাম ক্লিপ",
  T_41_XXJ_WS_CURRENTCLIPPROGRESS: "বর্তমান ক্লিপ প্রগ্রেস",
  T_41_XXJ_WS_CURRENTSTATE: "বর্তমান অবস্থা",
  T_41_XXJ_WS_CUSTOMHUDID: "কাস্টম HUD ID",
  T_41_XXJ_WS_CUSTOMHUDID_D: "একটি কাস্টম HUD রিসোর্স বর্ণনা করতে ব্যবহৃত ID",
  T_41_XXJ_WS_DASHATTACK: "ড্যাশ অ্যাটাক",
  T_41_XXJ_WS_DEBUG: "ডিবাগিং শুরু করুন",
  T_41_XXJ_WS_DEBUG_D: "ফিক্স করুন",
  T_41_XXJ_WS_DECELERATIONRATIO_D: "হ্রাস %: যখন একটি অবজেক্ট পানিতে থাকে তখন হ্রাস হয় (সীমা সাময়িকভাবে 0-100 হিসাবে সেট করা হয়)",
  T_41_XXJ_WS_DEPTH_D: "গভীরতা",
  T_41_XXJ_WS_DRAG: "ড্র্যাগ কো-ইফিশেন্ট",
  T_41_XXJ_WS_DRAG_D: "কো-ইফিশেন্ট যতো বড় হবে, মুভমেন্ট স্পিড হ্রাস ততোই দ্রুততম হবে",
  T_41_XXJ_WS_DUMMY: "ডামি",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE: "লো-গ্রাফিক্স মোড এনাবল করুন",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE_D: "যখন কম fps চালু থাকে, গেমটি 15 fps-এ চলবে; অন্যথায় 30 fps",
  T_41_XXJ_WS_ENTITYLIST: "রিটার্ন এনটিটি লিস্ট ক্রিয়েট করা হয়েছে",
  T_41_XXJ_WS_ENTITYNAME: "অবজেক্টের নাম",
  T_41_XXJ_WS_ENTITYNAME_D: "প্লেয়ারের দ্বারা কাস্টমাইজকৃত অবজেক্ট নাম",
  T_41_XXJ_WS_ENTITYORPREFABID_D: "লজিক্যাল এনটিটি বা প্রিফেব ID",
  T_41_XXJ_WS_EQUIPANDBAG: "আর্মর এন্ড ব্যাকপ্যাক",
  T_41_XXJ_WS_EQUIPMENTSLOT: "ইকুইপমেন্ট স্লট এনাম",
  T_41_XXJ_WS_EQUIPMENTSLOT_D: "ইকুইপমেন্ট স্লট এনাম",
  T_41_XXJ_WS_EXPLODE: "সেলফ-এক্সপ্লোড",
  T_41_XXJ_WS_EXPLOSIVEWEAPON_D: "বিস্ফোরক ওয়েপন",
  T_41_XXJ_WS_FASTAUTORELOADSPEED: "অটো রিলোড স্পিড",
  T_41_XXJ_WS_FILEID: "ইন্টারনাল ID",
  T_41_XXJ_WS_FILEID_D: "প্রিফেবে থাকা কন্ট্রোলের ইন্টারনাল ID",
  T_41_XXJ_WS_FILLAMOUNT: "ফিল অ্যামাউন্ট",
  T_41_XXJ_WS_FILLAMOUNT_D: "ফিল ভ্যালু",
  T_41_XXJ_WS_FILLDIR: "ডিরেকশন ফিল করুন",
  T_41_XXJ_WS_FILLDIR_D: "পূরণ করার ডিরেকশন",
  T_41_XXJ_WS_FILLDIR_D1: "ডিরেকশন এনাম পূরণ করুন",
  T_41_XXJ_WS_FILLTYPE: "ফিল টাইপ",
  T_41_XXJ_WS_FILLTYPE_D: "ফিল টাইপ",
  T_41_XXJ_WS_FILLTYPE_D1: "টাইপ এনাম পূরণ করুন",
  T_41_XXJ_WS_FINDSTRAIGHTPATH_D: "পাথ খুঁজুন",
  T_41_XXJ_WS_FINISH: "সম্পন্ন",
  T_41_XXJ_WS_FIREINTERVAL: "ফায়ারিং ইন্টারভাল",
  T_41_XXJ_WS_FIREINTERVAL_D: "অ্যাটাক ইন্টারভাল",
  T_41_XXJ_WS_FLIP: "ফ্লিপ মেথড",
  T_41_XXJ_WS_FLIP_D: "ফ্লিপ মেথড",
  T_41_XXJ_WS_FLYBOMBBEE: "ফ্লায়িং জোম্বি",
  T_41_XXJ_WS_FORCE: "শক্তি",
  T_41_XXJ_WS_FORCE_D: "মনোনীত তীব্রতার একটি ফোর্স তৈরি করুন",
  T_41_XXJ_WS_FORCETYPE: "ফোর্স টাইপ",
  T_41_XXJ_WS_FORCETYPE_D: "RigidBody-এর উপর ফোর্সের ভিন্ন ভিন্ন টাইপ। পুনশ্চ. শুধুমাত্র ডায়নামিক RigidBody টাইপের উপর কার্যকর।",
  T_41_XXJ_WS_FREEZEALL: "মুভমেন্ট এবং রোটেশন ফ্রিজ করুন",
  T_41_XXJ_WS_FREEZEPOSITION: "লিনিয়ার মুভমেন্ট ফ্রিজ করুন",
  T_41_XXJ_WS_FREEZEPOSITIONX: "x অক্ষ ফ্রিজ করুন",
  T_41_XXJ_WS_FREEZEPOSITIONY: "y অ্যাক্সিস ফ্রিজ করুন",
  T_41_XXJ_WS_FREEZEPOSITIONZ: "z অক্ষ ফ্রিজ করুন",
  T_41_XXJ_WS_FREEZEROTATION: "সব রোটেশন ফ্রিজ করুন",
  T_41_XXJ_WS_FREEZEROTATIONX: "x রোটেশন ফ্রিজ করুন",
  T_41_XXJ_WS_FREEZEROTATIONY: "y রোটেশন ফ্রিজ করুন",
  T_41_XXJ_WS_FREEZEROTATIONZ: "ফ্রিজ z রোটেশন",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE: "ম্যাক্স. ড্যামজের জন্য দূরত্ব",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE_D: "ম্যাক্স. ড্যামেজের জন্য দূরত্ব",
  T_41_XXJ_WS_GAMEID_D: "মিশন ID",
  T_41_XXJ_WS_GIVEJAILBREAKITEM_D: "একটি মেট্রোপলিস আইটেম প্রদান করুন",
  T_41_XXJ_WS_GRADIENT: "গ্রেডিয়েন্ট",
  T_41_XXJ_WS_GRADIENT_D: "দ্য গ্রেডিয়েন্ট",
  T_41_XXJ_WS_GRADIENTBOTTOM: "সর্বনিন্ম গ্রেডিয়েন্ট",
  T_41_XXJ_WS_GRADIENTBOTTOM_D: "সবার উপরে থাকা গ্রেডিয়েন্ট",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA: "সবার উপরে স্বচ্ছতা",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA_D: "বটম ট্রান্সপারেন্সি",
  T_41_XXJ_WS_GRADIENTTOP: "গ্র্যাডিয়েন্ট অ্যাট টপ",
  T_41_XXJ_WS_GRADIENTTOP_D: "একদম উপরে গ্র্যাডিয়েন্ট",
  T_41_XXJ_WS_GRADIENTTOPALPHA: "সবার উপরে স্বচ্ছতা",
  T_41_XXJ_WS_GRADIENTTOPALPHA_D: "টপ ট্রান্সপারেন্সি",
  T_41_XXJ_WS_GRAPHID: "স্ক্রিপ্ট ID",
  T_41_XXJ_WS_GRAPHID_D: "একটি স্ক্রিপ্ট অ্যাসেট বর্ণনা করতে ব্যবহৃত ID",
  T_41_XXJ_WS_GRENADEDEICEWALL_D: "গ্লু মেল্টার কম্পোনেন্ট",
  T_41_XXJ_WS_GRENADEEXPLOSIONTIME_D: "এক্সপ্লোশন বিলম্ব",
  T_41_XXJ_WS_GRENADELAUNCHER_D: "থ্রোয়েবল",
  T_41_XXJ_WS_GRENADEMAXDAMAGE_D: "ম্যাক্স. DMG",
  T_41_XXJ_WS_GRENADEMINDAMAGE_D: "মিনিমান ড্যামেজ",
  T_41_XXJ_WS_GRENADERANGE_D: "এক্সপ্লোশন রেঞ্জ",
  T_41_XXJ_WS_GRENADERATIOSELF_D: "সেলফ DMG মাল্টিপ্লায়ার",
  T_41_XXJ_WS_GRENADERATIOTEAMMATE_D: "মিত্রদের DMG মাল্টিপ্লায়ার",
  T_41_XXJ_WS_GRENADERATIOVEHICLE_D: "ভেহিক্যাল DMG মাল্টিপ্লায়ার",
  T_41_XXJ_WS_GRENADETHROWSPEED_D: "থ্রোয়িং স্পিড",
  T_41_XXJ_WS_GRENADEWEAPON: "থ্রোয়েবল ক্যাটাগরি",
  T_41_XXJ_WS_GRENADEWEAPON_D: "বেসিক থ্রোয়েবল টাইপ",
  T_41_XXJ_WS_HANDCANNON_D: "থ্রোয়েবলস",
  T_41_XXJ_WS_HEAD: "হেড",
  T_41_XXJ_WS_HEADID: "অ্যাভাটার ID",
  T_41_XXJ_WS_HEADID_D: "অ্যাভাটার ID",
  T_41_XXJ_WS_HEAVYWEAPON_D: "ভারী ওয়েপন",
  T_41_XXJ_WS_HELMET_D: "বর্তমান হেলমেট",
  T_41_XXJ_WS_HELMET1_D: "হেলমেট",
  T_41_XXJ_WS_HELMET2_D: "হেলমেট এনটিটি",
  T_41_XXJ_WS_HITBODYPART_D: "যেই বডি পার্টে আঘাত করা হয়েছে",
  T_41_XXJ_WS_HITBPDYPART: "আঘাতপ্রাপ্ত বডি পার্ট",
  T_41_XXJ_WS_HITENTITY_D: "হিট এনটিটি",
  T_41_XXJ_WS_HOSTHUDENTITY_D: "এটি যে HUD এনটিটির অন্তর্গত৷",
  T_41_XXJ_WS_HUD3DCONTAINER: "3D কনটেন্ট কন্টেনার",
  T_41_XXJ_WS_HUD3DCONTAINER_D: "HUD 3D কন্টেইনার এনটিটি। এটি HUD যা প্লেয়ারেরা এডিটর থেকে পরিবর্তন করে।",
  T_41_XXJ_WS_HUDGRID: "কাস্টম লেআউট(প্যানেল) কন্ট্রোল",
  T_41_XXJ_WS_HUDLAYOUT: "লেআউট কন্ট্রোল",
  T_41_XXJ_WS_HUDLAYOUT_D: "HUD সন্নিবেশ এনটিটি। এটি এমন একটি HUD যা প্লেয়ারেরা এডিটর থেকে পরিবর্তন করে।",
  T_41_XXJ_WS_HUDPROFILEINFO: "কাস্টম অ্যাভাটার কন্ট্রোল",
  T_41_XXJ_WS_HUDPROFILEINFO_D: "HUD প্রোফাইল ইনফো এনটিটি। এটি HUD যা প্লেয়ারেরা এডিটর থেকে পরিবর্তন করে।",
  T_41_XXJ_WS_HUDTEXTURE: "টেক্সচার কন্ট্রোল",
  T_41_XXJ_WS_HUDTEXTURE_D: "HUD টেক্সচার এনটিটি। এটি এমন HUD যা প্লেয়ারেরা এডিটর থেকে পরিবর্তন করে।",
  T_41_XXJ_WS_HUDTRANSFORM: "UIট্রান্সফর্ম কন্ট্রোল কম্পোনেন্ট",
  T_41_XXJ_WS_HUDTRANSFORM_D: "UITransform কন্ট্রোল এনটিটি",
  T_41_XXJ_WS_IMPULSE: "স্ট্রাইক",
  T_41_XXJ_WS_IMPULSE_D: "একটি মনোনীত তীব্রতার স্ট্রাইক ক্রিয়েট করুন",
  T_41_XXJ_WS_INITIALWORLDPOS: "প্রাথমিক ওয়ার্ল্ড কো-অর্ডিনেটস",
  T_41_XXJ_WS_INTERNALBUFFTYPE: "বাফ এনাম",
  T_41_XXJ_WS_INTERNALBUFFTYPE_D: "BuffData.csv-এর আইডি কলামের সাথে সংশ্লিষ্ট। নতুন কনটেন্ট যোগ করার আগে, অনুগ্রহ করে প্রথমে GPP-এর সাথে সামঞ্জস্যপূর্ণতা চেক করুন।",
  T_41_XXJ_WS_INVERTFILL: "ইনভার্ট ফিল",
  T_41_XXJ_WS_INVERTFILL_D: "ফিল কে ইনভার্ট করুন",
  T_41_XXJ_WS_ISLOOP: "Is ল্যুপ",
  T_41_XXJ_WS_ISLOOP_D: "লুপ করতে হবে কি না। ডিফল্ট ভাবে এটি মিথ্যা।",
  T_41_XXJ_WS_ISNAVMESHSTATIC: "স্ট্যাটিক NavMesh জেনারেশন",
  T_41_XXJ_WS_ISNAVMESHSTATIC_D: "স্ট্যাটিক লোডিং অবজেক্টের সময় শুধুমাত্র স্ট্যাটিক NavMesh জেনারেশন চেক করতে ব্যবহৃত হয়",
  T_41_XXJ_WS_ISSUCCESS_D: "ধ্বংসপ্রাপ্ত কিনা",
  T_41_XXJ_WS_ITEMENTITY_D: "আইটেম এনটিটি",
  T_41_XXJ_WS_ITEMID: "আইটেম ID",
  T_41_XXJ_WS_ITEMID_D: "আইটেম ID",
  T_41_XXJ_WS_ITEMID_D1: "অ্যাটাচমেন্টের সংশ্লিষ্ট আইটেম ID",
  T_41_XXJ_WS_ITEMLIST: "আইটেম লিস্ট",
  T_41_XXJ_WS_ITEMTYPE_D: "আইটেম টাইপ",
  T_41_XXJ_WS_JUMPATTACK: "জাম্প অ্যাটাক",
  T_41_XXJ_WS_LANDMINE: "ল্যান্ডমাইন",
  T_41_XXJ_WS_LENGTH: "ক্লিপ দৈর্ঘ্য",
  T_41_XXJ_WS_LENGTH_D: "প্রগ্রেস বারের দৈর্ঘ্য। ডিফল্ট মান হল প্রিফ্যাব UI এর দৈর্ঘ্য।",
  T_41_XXJ_WS_LIMB: "অঙ্গ",
  T_41_XXJ_WS_LISTLENGTHOVERLIMIT: "এই লিস্টের দৈর্ঘ্য ধারণক্ষমতা অতিক্রম করার কারণে উপাদান যোগ করতে ব্যর্থ হয়েছে৷",
  T_41_XXJ_WS_LISTT_INTERNALBUFFTYPE: "বাফ লিস্ট",
  T_41_XXJ_WS_LOOP: "লুপ",
  T_41_XXJ_WS_LOOP_D: "লুপ",
  T_41_XXJ_WS_MAXCAPACITY: "ক্যাপাসিটি",
  T_41_XXJ_WS_MAXCAPACITY_D: "ব্যাকপ্যাক ক্যাপাসিটি",
  T_41_XXJ_WS_MAXPROGRESS: "ম্যাক্স. প্রগ্রেস",
  T_41_XXJ_WS_MELEEWEAPON_D: "মেলি ওয়েপন",
  T_41_XXJ_WS_MINDAMAGEDISTANCE: "মিনিমাম ড্যামেজের দূরত্ব",
  T_41_XXJ_WS_MINDAMAGEDISTANCE_D: "মিনিমাম ড্যামেজের জন্য দূরত্ব",
  T_41_XXJ_WS_MINISENTRY: "অটো টারেট",
  T_41_XXJ_WS_NAME: "নাম",
  T_41_XXJ_WS_NAME_D: "স্কিল বাটনের নাম। OnClick ইনসিডেন্টের সময় প্যারামিটার পাঠানোর জন্য ব্যবহৃত হয়, তাই স্বতন্ত্রতা নিশ্চিত করা আবশ্যক।",
  T_41_XXJ_WS_NAME1_D: "মার্চেন্ডাইজ নাম",
  T_41_XXJ_WS_NAME2_D: "মার্চেন্ডাইজ লিস্ট নাম",
  T_41_XXJ_WS_NAME3_D: "ভেন্ডিং মেশিনের নাম",
  T_41_XXJ_WS_NICKNAME: "ডাকনাম",
  T_41_XXJ_WS_NICKNAME_D: "প্লেয়ারের নাম",
  T_41_XXJ_WS_NOCHANGE: "কোনো পরিবর্তন নেই",
  T_41_XXJ_WS_NONE: "কোনো বাঁধা নেই",
  T_41_XXJ_WS_NONE1: "কোনোটাই নয়",
  T_41_XXJ_WS_OFFSET: "অফসেট",
  T_41_XXJ_WS_OFFSET_D: "অফসেট",
  T_41_XXJ_WS_OFFSET1_D: "রিটেন অফসেট ভ্যালু",
  T_41_XXJ_WS_ONCE: "একবার",
  T_41_XXJ_WS_ONCE_D: "একবার",
  T_41_XXJ_WS_ONHIDE: "ইন্টারফেজটি যখন ক্লোজড থাকে",
  T_41_XXJ_WS_ONHIDE_D: "ইন্টারফেসটি যখন ক্লোজড হয়ে যায়",
  T_41_XXJ_WS_ONNODEENTER_D: "অক্ষ(পিভট) যখন প্রবেশ করছে",
  T_41_XXJ_WS_ONSHOW: "ইন্টারফেস যখন ওপেন থাকে",
  T_41_XXJ_WS_ONSHOW_D: "ইন্টারফেস যখন উন্মুক্ত থাকে",
  T_41_XXJ_WS_ONSYNCINPUTTEXT_D: "ট্রিগার হয়, যখন টেক্সট বক্সটি পরিবর্তিত হয়",
  T_41_XXJ_WS_PERSONALUAV: "UAV-লাইট",
  T_41_XXJ_WS_PINID: "পিন ID",
  T_41_XXJ_WS_PINID_D: "পিন ID",
  T_41_XXJ_WS_PLAYERBAG: "প্লেয়ার ব্যাকপ্যাক এনটিটি",
  T_41_XXJ_WS_PLAYERBAG_D: "প্লেয়ারের ব্যাকপ্যাক এনটিটি",
  T_41_XXJ_WS_PLAYERBAGENTITY: "প্লেয়ার ব্যাকপ্যাক",
  T_41_XXJ_WS_PLAYERBAGENTITY_D: "প্লেয়ারের ব্যাকপ্যাক",
  T_41_XXJ_WS_PLAYERSPEEDFACTORAIMING: "স্কোপড-ইন এর সময় স্পিডের মোডিফাইড কো-ইফিশিয়েন্ট",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING: "ফায়ারিং এর সময় মুভমেন্ট স্পিডের প্রভাব",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING_D: "ফায়ারিং এর সময় মুভমেন্ট স্পিডের প্রভাব",
  T_41_XXJ_WS_PREFABID: "প্রিফেব ID",
  T_41_XXJ_WS_PREFABID_D: "একটি প্রিফ্যাব অ্যাসেট বর্ণনা করতে ব্যবহৃত ID",
  T_41_XXJ_WS_PREFABID1_D: "এমন HUD টেমপ্লেট, যা এই ID রিপ্রেজেন্ট করে",
  T_41_XXJ_WS_PRIMARYWEAPON1_D: "প্রধান ওয়েপন 1",
  T_41_XXJ_WS_PRIMARYWEAPON2_D: "প্রধান ওয়েপন 2",
  T_41_XXJ_WS_PROFILEINFO: "প্লেয়ার প্রোফাইল",
  T_41_XXJ_WS_PROFILEINFO_D: "প্লেয়ার বায়ো",
  T_41_XXJ_WS_PROGRESSICON_D: "প্রগ্রেস বার",
  T_41_XXJ_WS_PROGRESSICONSPRITENAME: "প্রগ্রেস আইকন নাম",
  T_41_XXJ_WS_QUITJAILBREAKMINIGAME_D: "মেট্রোপলিস মিনিগেম ত্যাগ করুন",
  T_41_XXJ_WS_RANGE: "ফায়ারিং রেঞ্জ",
  T_41_XXJ_WS_RANGE_D: "অ্যাটাক রেঞ্জ",
  T_41_XXJ_WS_RANGE_D1: "এক্সপ্লোশন রেঞ্জ",
  T_41_XXJ_WS_RANGE_D2: "টারেট রেঞ্জ",
  T_41_XXJ_WS_READCSVDATAALLOVERMODE_D: "সমগ্র টেবিলের কনটেন্ট রিড করুন। একটি দ্বি-মাত্রিক অ্যারে রিটার্ন করুন।",
  T_41_XXJ_WS_READCSVDATACELLOVERMODE_D: "নির্দিষ্ট একটি সেল থেকে কনটেন্ট রিড করুন",
  T_41_XXJ_WS_READCSVDATACOLOVERMODE_D: "নির্দিষ্ট একটি কলাম থেকে কনটেন্ট রিড করুন। একটি অ্যারে রিটার্ন হয়।",
  T_41_XXJ_WS_READCSVDATAROWOVERMODE_D: "নির্দিষ্ট একটি সারি থেকে কনটেন্ট রিড করুন। একটি অ্যারে রিটার্ন হয়।",
  T_41_XXJ_WS_READDBACCUMULATEDDATA: "সমন্বিত ডেটাবেজ রিড করুন",
  T_41_XXJ_WS_READDBACCUMULATEDDATA_D: "জমে থাকা ডাটাবেসের একটি টেবিলের একটি কী-এর সাথে সম্পর্কিত ভ্যালু রিড করুন",
  T_41_XXJ_WS_RECOVERPLAYERHP: "প্রতিনিয়ত HP রিকোভার করুন",
  T_41_XXJ_WS_RELOADSPEED: "রিলোড স্পিড",
  T_41_XXJ_WS_RELOADSPEED_D: "রিলোড স্পিড (বেসিক স্পিড x মাল্টিপ্লায়ার)",
  T_41_XXJ_WS_RESOURCEID: "রিসোর্স UUID",
  T_41_XXJ_WS_RESOURCEID_D: "রিসোর্স UUID",
  T_41_XXJ_WS_RESUUID: "রিসোর্স ID",
  T_41_XXJ_WS_RESUUID_D: "রেন্ডার করার জন্য মনোনীত রিসোর্স UUID",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE: "RigidBody কনস্ট্রেন্ট টাইপ",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE_D: "প্রতিটি সীমাবদ্ধতা একটি বিট মার্কিং দ্বারা সংজ্ঞায়িত করা হয় এবং একটি কম্বিনেশন হিসাবে ব্যবহার করা যেতে পারে",
  T_41_XXJ_WS_ROTATION: "রোটেশন",
  T_41_XXJ_WS_ROTATION_D: "পৃথিবীর ঘূর্ণন কোণ সমন্বয় করে। x, y, z যথাক্রমে ইয়াও, পিচ এবং রোলকে বোঝায়।",
  T_41_XXJ_WS_ROTATION1_D: "রোটেশন",
  T_41_XXJ_WS_RUNNING: "রানিং",
  T_41_XXJ_WS_SCALE: "স্কেল",
  T_41_XXJ_WS_SCALE_D: "স্কেল",
  T_41_XXJ_WS_SCALE1_D: "একটি নির্দিষ্ট অক্ষ বরাবর দাঁড়িপাল্লা। তিনটি অক্ষের সমন্বয় হতে পারে।",
  T_41_XXJ_WS_SCATTERMAX: "ম্যাক্স. বুলেট স্কেটার",
  T_41_XXJ_WS_SCATTERMAX_D: "বুলেট স্প্রেড যেখান থেকে শুরু হয় সেই ভ্যালু",
  T_41_XXJ_WS_SCATTERMOVE1: "মুভিং এর সময় স্প্রেড সাইজ",
  T_41_XXJ_WS_SCATTERRECOVERSPEED: "স্প্রেড রিকোভারির গতি",
  T_41_XXJ_WS_SCATTERRECOVERSPEED_D: "স্প্রেড রিকোভারির গতি",
  T_41_XXJ_WS_SCATTERSPEED: "বিস্তারের গতি বৃদ্ধি পায়",
  T_41_XXJ_WS_SCATTERSPEED_D: "স্প্রেড বৃদ্ধির স্পিড (0.1 = প্রতিটি বিস্ফোরণ বৃদ্ধির জন্য ক্রসহেয়ার 10% বড় হয়)",
  T_41_XXJ_WS_SCATTERSPEEDCROUCHCREEP: "নত অবস্থান এবং ক্রাউচের উপর কম ছড়িয়ে পড়ে",
  T_41_XXJ_WS_SECONDARYWEAPON_D: "সেকেন্ডারি ওয়েপন",
  T_41_XXJ_WS_SHADERNAME: "শেডারের নাম",
  T_41_XXJ_WS_SHADERNAME_D: "শেডারের নাম",
  T_41_XXJ_WS_SHIELDBROKEN: "শিল্ড-শ্যাটার অ্যাটাক",
  T_41_XXJ_WS_SHIELDUP: "শিল্ড অ্যাটাক",
  T_41_XXJ_WS_SHOCKWAVE: "শকওয়েভ",
  T_41_XXJ_WS_SHOWNAME: "ডাকনাম ডিসপ্লে করুন",
  T_41_XXJ_WS_SHOWNAME_D: "ডিসপ্লে ডাকনাম",
  T_41_XXJ_WS_SHOWPIN: "ডিসপ্লে পিন",
  T_41_XXJ_WS_SHOWPIN_D: "ডিসপ্লে পিন",
  T_41_XXJ_WS_SHOWRANK: "র‍্যাংক ডিসপ্লে করুন",
  T_41_XXJ_WS_SHOWRANK_D: "ডিসপ্লে র‍্যাংক",
  T_41_XXJ_WS_SHOWTYPE: "ডিজাইন",
  T_41_XXJ_WS_SHOWTYPE_D: "টাইপ",
  T_41_XXJ_WS_SHRINKSPEED: "স্পিড সংকোচন",
  T_41_XXJ_WS_SIGHTAIMASSIST: "স্কোপের সময় এইম অ্যাসিস্ট এনাবল করুন",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTFALLOFF: "দূরত্বের ক্ষেত্রে এইম অ্যাসিস্ট ক্রসহেয়ার সেনসিটিভিটি (0-1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOCOEF: "এইম অ্যাসিস্টের জন্য দূরত্বকে অগ্রাধিকার দেওয়ার সময় সহগ (≥ 1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMAX: "এইম অ্যাসিস্টের জন্য দূরত্বকে অগ্রাধিকার দিতে সর্বোচ্চ দূরত্ব",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMIN: "লক্ষ্য সহায়তার জন্য দূরত্বকে অগ্রাধিকার দিতে সর্বনিম্ন দূরত্ব",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIORITY: "লক্ষ্য সহায়তার জন্য দূরত্বকে অগ্রাধিকার দিন",
  T_41_XXJ_WS_SIGHTAIMASSISTSNAPRANGE: "এইম অ্যাসিস্ট ক্রসহেয়ার সেন্সিভিটি (0-1)",
  T_41_XXJ_WS_SIGHTAMPLIFYRATIO: "স্কোপ জুম-ইন ফ্যাকটর",
  T_41_XXJ_WS_SIGHTFOVAMPLIFYRATIO: "FOV জুম-ইন ফ্যাক্টর",
  T_41_XXJ_WS_SIGHTROTSENSITIVENESS: "স্কোপ রোটেশন সেন্সিটিভিটি কো-এফিশিয়েন্ট",
  T_41_XXJ_WS_SIGHTSHOOTMINDAMAGE: "মিনিমাম স্কোপড-ইন DMG এর মোডিফাইড কো-ইফিশিয়েন্ট",
  T_41_XXJ_WS_SIGHTUIACTIONEXPAND: "ফায়ারিং UI জুম ইন টাইম",
  T_41_XXJ_WS_SIGHTUIACTIONRATIO: "স্কোপড ইন ফায়ারিং UI জুম ইন ফ্যাক্টর",
  T_41_XXJ_WS_SIGHTUIACTIONRECOVERY: "স্কোপড ইন ফায়ারিং UI পুনরায় শুরু করার সময়",
  T_41_XXJ_WS_SPEED: "প্লেব্যাক স্পিড",
  T_41_XXJ_WS_SPEEQUIP: "ফাংশনাল ইকুইপমেন্ট",
  T_41_XXJ_WS_SPEITEM: "ডিভাইস",
  T_41_XXJ_WS_STATICGRAPHID: "স্ট্যাটিক স্ক্রিপ্ট ID",
  T_41_XXJ_WS_STATICGRAPHID_D: "একটি স্ট্যাটিক স্ক্রিপ্ট অ্যাসেট বর্ণনা করতে ব্যবহৃত ID",
  T_41_XXJ_WS_STATICWAINING: "স্ট্যাটিক রিজিডবডি টাইপ পরিবর্তন করতে ব্যর্থ হয়েছে",
  T_41_XXJ_WS_TARGETTREE: "বিহেভিয়ার ট্রি এনটিটি",
  T_41_XXJ_WS_TARGETTREE_D: "বিহেভিয়ার ট্রি এনটিটি",
  T_41_XXJ_WS_TEAMINDEX: "টিম সিরিয়াল নং.",
  T_41_XXJ_WS_TEAMINDEX_D: "টিম ইনডেক্স, যা এই রুমের টিম ইনডেক্সের সাথে মিলে যায়",
  T_41_XXJ_WS_TEAMINDEX_D1: "টিম ফ্যাকশন নাম্বার",
  T_41_XXJ_WS_TEMPLATEPREFABID: "টেম্পলেট প্রিফেব ID",
  T_41_XXJ_WS_TEXT_D: "কনটেন্ট",
  T_41_XXJ_WS_TEXTURENAME: "টেক্সচার নাম",
  T_41_XXJ_WS_TEXTURENAME_D: "টেক্সচারের নাম",
  T_41_XXJ_WS_THROWATTACK: "গ্রেনেড",
  T_41_XXJ_WS_TICKINTERVAL: "ইন্টারভাল রিফ্রেশ করুন",
  T_41_XXJ_WS_TICKINTERVAL_D: "রিফ্রেশ ইন্টারভাল। সংখ্যা যত বড় হবে, রিফ্রেশ হতে তত বেশি সময় লাগবে।",
  T_41_XXJ_WS_TOGGLESPECIALITEMSTATE_D: "প্লেয়ারের ব্যাকপ্যাকে স্পেশাল ডিভাইস এনাবল করুন",
  T_41_XXJ_WS_UVRECTWH: "UV প্রস্থ & উচ্চতা",
  T_41_XXJ_WS_UVRECTWH_D: "UV প্রস্থ এবং উচ্চতা",
  T_41_XXJ_WS_UVRECTXY: "UV অফসেট",
  T_41_XXJ_WS_UVRECTXY_D: "UV অফসেট",
  T_41_XXJ_WS_VELOCITY: "বেগ",
  T_41_XXJ_WS_VELOCITY_D: "সরাসরি RigidBody-এর স্পিড পরিবর্তন থেকে বিরত থাকুন। সংশ্লিষ্ট API ব্যবহার করে আপনি এটি পরিবর্তন করতে পারবেন।",
  T_41_XXJ_WS_VEST_D: "বর্তমান ভেস্ট",
  T_41_XXJ_WS_VEST1_D: "ভেস্ট",
  T_41_XXJ_WS_WIDGETID: "কন্ট্রোল ID",
  T_41_XXJ_WS_WIDGETID_D: "ইন্টারফেস অ্যাসেটে একটি কন্ট্রোল বর্ণনা করতে ব্যবহৃত ID। এটি একটি ইউনিক কন্ট্রোল আইডির সাথে সামঞ্জস্যপূর্ণ তা নিশ্চিত করার জন্য এটি একটি কাস্টম HUD ID এর সাথে পেয়ার করা আবশ্যক৷",
  T_41_XXJ_WS_WINDATTACK: "টর্নেডো অ্যাটাক",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET: "সমন্বিত ডেটাবেস অফসেট লিখুন",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET_D: "সমন্বিত ডাটাবেসের একটি টেবিলে একটি কী এর সাথে সম্পর্কিত অফসেটটি লিখুন",
  T_41_XXJ_WS_ZONEDURATION_D: "ফ্রিজ স্থায়িত্ব",
  T_41_XXJ_WS_ZONEDURATION1_D: "গ্লু মেল্টার স্থায়িত্ব",
  T_41_XXJ_WS_ZONERADIUS_D: "ফ্রিজ জোন রেডিয়াস",
  T_41_XXJ_WS_ZONERADIUS1_D: "গ্লু মেল্টার ব্যসার্ধ",
  T_41_XYL_WS_BOT12: "আর্থ ড্রিলার",
  T_41_XYL_WS_BOT9: "মিউচুয়েটেড টোসিং জোম্বি",
  T_41_XYL_WS_ITEM262: "ফ্রোজেন স্টিল প্যানেল A",
  T_41_XYL_WS_ITEM263: "ফ্রোজেন কন্টেইনার A",
  T_41_XYL_WS_ITEM264: "ফ্রোজেন সাপ্লাই কন্টেইনার",
  T_41_XYL_WS_ITEM265: "ফ্রোজেন মেটাল গেট",
  T_41_XYL_WS_ITEM266: "ফ্রোজেন কন্টেইনার B",
  T_41_XYL_WS_ITEM267: "ফ্রোজেন স্টোন A",
  T_41_XYL_WS_ITEM268: "ফ্রোজেন স্টোন B",
  T_41_XYL_WS_ITEM269: "ফ্রোজেন স্টোন C",
  T_41_XYL_WS_ITEM270: "ফ্রোজেন স্টোন D",
  T_41_XYL_WS_ITEM271: "পরিত্যক্ত সাবওয়ে গাড়ি",
  T_41_XYL_WS_MODELMATCHNAME: "কনটেস্ট ক্যানভাস",
  T_41_XYL_WS_NAVMESH: "ডায়নামিক নাভমেশ",
  T_41_XYL_WS_REFCUBE: "রিফ্লেকটিভ কিউব",
  T_41_XYL_WS_SNOWSKY: "ফ্রস্ট গ্যালাক্সি",
  T_41_XYL_WS_TOYCUBE: "খেলুন কিউব",
  T_42_CJ_F_B_VOCATIONAL: "গিয়ারিং ব্লুপ্রিন্ট (বটম)",
  T_42_CJ_F_H_VOCATIONAL: "গিয়ারিং ব্লুপ্রিন্ট (হেড)",
  T_42_CJ_F_S_VOCATIONAL: "গিয়ারিং ব্লুপ্রিন্ট (জুতা)",
  T_42_CJ_F_T_VOCATIONAL: "গিয়ারিং ব্লুপ্রিন্ট (টপ)",
  T_42_CJ_HA_THUNDER_GOLD: "লাইটনিং ফেসপেইন্ট",
  T_42_CJ_M_B_VOCATIONAL: "মেকানিক মাস্টারপ্ল্যান (বটম)",
  T_42_CJ_M_H_VOCATIONAL: "মেকানিক মাস্টারপ্ল্যান (হেড)",
  T_42_CJ_M_S_VOCATIONAL: "মেকানিক মাস্টারপ্ল্যান (জুতা)",
  T_42_CJ_M_T_VOCATIONAL: "মেকানিক মাস্টারপ্ল্যান (টপ)",
  T_42_H_CHARACTER_SUPERTEEN_N: "ইগনিস",
  T_42_H_GLOO_EVOTIGER_N: "গ্লু ওয়াল- টাইগার'স ফ্যুরি",
  T_42_H_GRENADE_SMUDGE_N: "গ্রেনেড- ফেলাইন শ্যাডো",
  T_42_H_M1917_EMPIRE_N: "M1917- ক্রাউনড কনকারার (বটম)",
  T_42_HJ_WS_VFX_INK: "ইংক",
  T_42_JH_WS_BANMATCHMAKING: "এই ম্যাপের জন্য ম্যাচমেকিং অনুমোদিত নয়",
  T_42_JH_WS_BANROOMCREATE: "একটি রুম তৈরি করতে ব্যর্থ",
  T_42_JH_WS_FPS: "FPS",
  T_42_JH_WS_SKILLSETALOKAWAKEN: "পার্টি রিমিক্স (আলোক)",
  T_42_JH_WS_SKILLSETFIREWALL: "ওয়াল অফ ফ্লেইম (ইগনিস)",
  T_42_JH_WS_SKILLSETSANTINO: "শেপ স্প্লিটার (স্যান্টিনো)",
  T_42_JH_WS_SKILLSETSONIA: "ন্যানো লাইফশিল্ড (সোনিয়া)",
  T_42_JH_WS_TAG1: "ফ্রোস্ট ব্রাউল",
  T_42_JH_WS_TAG10: "ইনফিনিটি রেসার",
  T_42_JH_WS_TAG11: "রেইস রাশ",
  T_42_JH_WS_TAG12: "কার রেসিং",
  T_42_JH_WS_TAG13: "জনপ্রিয় থেকে বাদ দিন",
  T_42_JH_WS_TAG14: "ফ্রন্টলাইন",
  T_42_JH_WS_TAG15: "জোম্বি ওয়ার",
  T_42_JH_WS_TAG16: "লিগেসি লিজেন্ড",
  T_42_JH_WS_TAG2: "সোশ্যাল আইল্যান্ড 1.0",
  T_42_JH_WS_TAG3: "সোশ্যাল আইল্যান্ড 2.0",
  T_42_JH_WS_TAG4: "একসাথে পার্টি",
  T_42_JH_WS_TAG5: "র‍্যিউন সার্ভাইভর",
  T_42_JH_WS_TAG6: "প্রেয়িং পার্টি",
  T_42_JH_WS_TAG7: "প্রেয়িং পার্টি",
  T_42_JH_WS_TAG8: "ফোর্ট ফিউড 2.0",
  T_42_JH_WS_TAG9: "বাউন্টি হান্টিং",
  T_42_RW_PORTALSFORPERSONAL_DESC: "যে কোন জায়গায় একটি পোর্টাল রাখুন এবং দূরে টেলিপোর্ট করুন!",
  T_42_RW_PORTALSPERSONAL_NAME: "পোর্টাল গো",
  T_42_SJ_WS_ACCESSORIESITEM: "ইকুইপ অ্যাটাচমেন্ট",
  T_42_SJ_WS_AUTOPLAY: "অটো প্লে",
  T_42_SJ_WS_CLIMB: "ক্লাইম্ব ওভার",
  T_42_SJ_WS_CLOCK_EVENTS: "ইভেন্ট কম্পিলেশন",
  T_42_SJ_WS_CLOCK_IS_COUNTDOWN: "কাউন্টডাউন হবে কিনা",
  T_42_SJ_WS_CLOCK_LOOP_COUNT: "ল্যুপসমূহ",
  T_42_SJ_WS_CLOCK_PAUSE_EVENT: "ইভেন্ট পজ করুন",
  T_42_SJ_WS_CLOCK_START_EVENT: "ইভেন্ট শুরু করুন",
  T_42_SJ_WS_CLOCK_START_TIME: "কাউন্টডাউন স্টার্ট টাইম",
  T_42_SJ_WS_CLOCK_STATE: "স্টপওয়াচ স্ট্যাটাস",
  T_42_SJ_WS_CLOCK_STOP_EVENT: "ইভেন্ট থামান",
  T_42_SJ_WS_DAMRATIOHEAD: "হেডশট DMG কো-এফিশিয়েন্ট পরিবর্তন",
  T_42_SJ_WS_DAMRATIOLIMB: "লিম্ব DMG কো-এফিশিয়েন্ট পরিবর্তন",
  T_42_SJ_WS_DAMREDUCEXPLODE: "এক্সপ্লোসিভ DMG থেকে রিডাকশন কো-এফিশিয়েন্ট",
  T_42_SJ_WS_DRIVE: "ড্রাইভ করুন",
  T_42_SJ_WS_ENTITYITEXT_DEPTH: "ডিসপ্লে লেয়ারসমূহ",
  T_42_SJ_WS_EXTRABAGCAPACITY: "এক্সট্রা ব্যাকপ্যাক ক্যাপাসিটি",
  T_42_SJ_WS_EXTRAHPRATIO: "HP রেশিও",
  T_42_SJ_WS_GETOFF_DRIVE: "ভেহিক্যাল প্রস্থান করুন",
  T_42_SJ_WS_GETON_DRIVE: "ভেহিক্যালে প্রবেশ করুন",
  T_42_SJ_WS_KNIFEITEM: "ড্যাগার",
  T_42_SJ_WS_KNIFEITEMPICK: "ড্যাগার (গ্রাউন্ড লুট)",
  T_42_SJ_WS_MARKBTNHUD: "HUD-এ থাকা পিন বাটন",
  T_42_SJ_WS_MARKBTNHUD_D: "আপনি চাইলে পিন বাটনটি এনাবল অথবা ডিজেবল করতে পারেন",
  T_42_SJ_WS_MAXDISTANCE: "ম্যাক্স. দূরত্ব",
  T_42_SJ_WS_MAXDURARATIO: "ম্যাক্স. স্থায়িত্ব রেশিও",
  T_42_SJ_WS_MICBTNHUD: "HUD এ থাকা মাইক সুইচ",
  T_42_SJ_WS_MICBTNHUD_D: "আপনি চাইলে মাইক বাটনটি এনাবল বা ডিজেবল করতে পারেন",
  T_42_SJ_WS_MINDISTANCE: "ন্যুনতম দূরত্ব",
  T_42_SJ_WS_OPE_VEHICLE: "ভেহিক্যাল অপারেট করুন",
  T_42_SJ_WS_PLANE_DESC: "এমন একটি বেসিক ম্যাশ, যেটার সাইজ যেমনখুশি অ্যাডজাস্ট করা যায়",
  T_42_SJ_WS_PLANENAME: "বেসিক প্লেন",
  T_42_SJ_WS_PRIORITY: "অগ্রাধিকার",
  T_42_SJ_WS_REPLACEPRIORITY: "প্রায়োরিটি রিপ্লেস করুন",
  T_42_SJ_WS_SETBTNHUD: "HUD-এ থাকা সেটিংস বাটন",
  T_42_SJ_WS_SETBTNHUD_D: "আপনি চাইলে সেটিংস বাটনটি এনাবল বা ডিজেবল করতে পারেন",
  T_42_SJ_WS_SIGNALBTNHUD: "HUD-এ থাকা নেটওয়ার্ক কানেকশন বাটন",
  T_42_SJ_WS_SIGNALBTNHUD_D: "আপনি চাইলে নেটওয়ার্ক কানেকশন বাটনটি এনাবল বা ডিজেবল করতে পারেন",
  T_42_SJ_WS_SPEAKERBTNHUD: "HUD এ থাকা হর্ন বাটন",
  T_42_SJ_WS_SPEAKERBTNHUD_D: "আপনি চাইলে ভেহিক্যালের হর্ন বাটনটি এনাবল অথবা ডিজেবল করতে পারেন",
  T_42_SJ_WS_START_TIME: "শুরুর সময় (s)",
  T_42_SW_SKILL_DESC_ARMSDEALER: "গ্রেনেড লঞ্চার বাদে একটি অতিরিক্ত [FFB300]{0}[-] ব্যাকপ্যাকের ক্ষমতা পান। ([FFB300]{1}[-] AR অ্যামো, [FFB300]{2}[-] SMG অ্যামো, [FFB300]{3}[-] স্নাইপার অ্যামো, [FFB300]{4}[-] SG অ্যামো)",
  T_42_SW_SKILL_DESC_Bodyguard: "রিলোডের স্পিড [FFB300]{0}%[-] বৃদ্ধি পায়। প্রতিবার স্কিল ইউজার এনিমিকে আঘাত করলে, টার্গেট একটি [FFB300]{1}%[-] হিলিং ডিডাকশন পাবে যা [FFB300]{3}s[-] পর্যন্ত স্থায়ী হয় (ম্যাক্স. ডিডাকশন: [FFB300]{2} %[-])।",
  T_42_SW_SKILL_DESC_Playboy: "কিছু ডিসরাপ্টিভ ইফেক্ট (যেমন, স্লো-ডাউন, মার্কিং, স্কিল-সাইলেন্সিং) থেকে প্রতিরোধী হয়ে উঠুন এবং [FFB300]{2}s[-] এর জন্য [FFB300]{1}%[-] মুভমেন্ট স্পিড বুস্ট লাভ করুন। কুলডাউন: [FFB300]{0}s[-]।",
  T_42_SW_SKILL_DESC_SwatGuy: "কোনো এনিমিকে নক-ডাউন দেওয়ার পরে বা অ্যাক্টিভ স্কিল ব্যবহার করার পরে, বন্দুকের [FFB300]{0}%[-] ম্যাগাজিন স্বয়ংক্রিয়ভাবে রিলোড হয়",
  T_42_SW_SKILL_NAME_Playboy: "সিলভার স্পুন",
  T_42_SY_BACKPACK_EMPIRE_N: "ক্রাউনড রোর ব্যাকপ্যাক",
  T_42_SY_PETSKIN_RABBIT_WINTERFEST23_N: "পেট স্কিন: আইসি হপ",
  T_42_SY_VEHICLESKIN_MOTOBIKE_URBAN_BW_N: "মোটরবাইক- আরবান স্কুটার",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_AFF_N: "Aventador Ultimae Booyah",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_ASILVER_N: "Aventador Ultimae Grigio Nimbus",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VBLACK_N: "ম্যাট ব্ল্যাক Veneno",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VRED_N: "গোলাপী লাল রঙের Veneno",
  T_42_TYC_CST_LOSE_MONEY_1: "একটি এক-রাউন্ড লুজিং স্ট্রীক উপর প্রাপ্ত CS ক্যাশ পরিমাণ",
  T_42_TYC_CST_LOSE_MONEY_2: "একটি 2-রাউন্ড লুজিং স্ট্রীকের উপর প্রাপ্ত CS ক্যাশ পরিমাণ",
  T_42_TYC_CST_LOSE_MONEY_3: "একটি 3-রাউন্ড লুজিং স্ট্রীকের উপর প্রাপ্ত CS ক্যাশ পরিমাণ",
  T_42_WH_ITEM_HEALUAV: "হিল UAV-Lite",
  T_42_WH_ITEM_HEALUAV_DESC: "একটি UAV-Lite স্থাপন করে যা সামনে উড়ে যায় এবং নিচের রেঞ্জে থাকা টিমমেটদের ক্রমাগত হিল করে",
  T_42_WH_ITEM_SKILLCARD: "স্কিল: {0}",
  T_42_WH_ITEM_SKILLCARD_DESC: `[ffba00]{0}[-]: [ffba00]{1}[-] এর অ্যাক্টিভ স্কিল রিলিজ করতে ব্যবহার করুন.
{2}`,
  T_42_XXJ_WS_AMMOTYPE: "অ্যামো টাইপ",
  T_42_XXJ_WS_AMMOTYPE_D: "অ্যামো টাইপ",
  T_42_XXJ_WS_ASSETCONFIGID: "স্কিন ID",
  T_42_XXJ_WS_ASSETCONFIGID_D: "স্কিন",
  T_42_XXJ_WS_ATTACKSTATUS: "অ্যাটাক স্ট্যাটাস",
  T_42_XXJ_WS_AUTOPLAY: "অটো প্লে",
  T_42_XXJ_WS_AUTOPLAY_D: "অটো প্লে",
  T_42_XXJ_WS_AVATARABLE: "মোডিফাইযোগ্য অ্যাপেয়ারেন্স কম্পোনেন্ট",
  T_42_XXJ_WS_AVATARABLE_D: "অংশ অনুসারে চেহারা পরিবর্তন করুন",
  T_42_XXJ_WS_AVATARRESUUID: "এপেয়ারেন্স রিসোর্স UUID",
  T_42_XXJ_WS_AXISANGLETOQUATERNION_D: "একটি রোটেশনের অক্ষ-কোণ উপস্থাপনাকে কোয়াটার্নিয়ন-এ কনভার্ট করুন",
  T_42_XXJ_WS_B_D: "B কালার ভ্যাল্যু",
  T_42_XXJ_WS_BASEVALUE_D: "লগারিদমের বেইজ",
  T_42_XXJ_WS_BEZIERCURVE: "Bézier কার্ভ",
  T_42_XXJ_WS_BEZIERCURVE_D: "দ্য Bézier কার্ভ",
  T_42_XXJ_WS_BOTDIFFICULTY: "বট ডিফিকাল্টি",
  T_42_XXJ_WS_BOUNCE_COMBINE: "বাউন্সিনেসের কম্বিনেশন মেথড",
  T_42_XXJ_WS_BOUNCINES: "বাউন্সিনেস",
  T_42_XXJ_WS_BTREEID: "বিহেভিয়ার ট্রি ID",
  T_42_XXJ_WS_BTREEID_D: "বিহেভিয়ার ট্রি",
  T_42_XXJ_WS_CANPURCHAS: "ক্রয়যোগ্য কিনা",
  T_42_XXJ_WS_CANPURCHAS_D: "ক্রয়যোগ্য কিনা",
  T_42_XXJ_WS_CLIMBSTATUS: "ক্লাইম্বিং বিহেভিয়ার",
  T_42_XXJ_WS_CLOCK: "টাইমার অবজেক্ট",
  T_42_XXJ_WS_CLOCK_D: "টাইমার অবজেক্ট",
  T_42_XXJ_WS_CLOCK_D1: "টাইমার",
  T_42_XXJ_WS_CONTAINER: "কন্টেনার",
  T_42_XXJ_WS_CONTROLPOINTS: "কন্ট্রোল পয়েন্টসমূহ",
  T_42_XXJ_WS_CONTROLPOINTS_D: "কন্ট্রোল পয়েন্টসমূহ",
  T_42_XXJ_WS_COROUTINEID: "করোটিন হ্যান্ডেল",
  T_42_XXJ_WS_COROUTINEID_D: "এই করোটিন ID দ্বারা একটি নির্দিষ্ট করোটিনের হ্যান্ডেলকে বোঝায়। এটি হ্যান্ডেলটিকে বিভিন্ন অপারেশন করার অনুমতি দেয়।",
  T_42_XXJ_WS_CREATESELFRELATIVE_D: "একটি সেলফ-রিলেটিভ তৈরি করুন",
  T_42_XXJ_WS_CREATESELFRELATIVEFRAME_D: "একটি সেলফ-রিলেটিভ তৈরি করুন",
  T_42_XXJ_WS_CREATESOUND: "সাউন্ড ইফেক্ট ক্রিয়েট করুন",
  T_42_XXJ_WS_CREATESOUND_D: "মনোনীত সাউন্ড ইফেক্ট চালান। সেট করার জন্য আরও প্রপার্টিজ থাকলে, আপনি এটির এনটিটি প্রপার্টিজ কনফিগার করে তা করতে পারেন।",
  T_42_XXJ_WS_CUSTOMMISSIONCOMPLETE_D: "কমপ্লিট কাস্টম মিশন",
  T_42_XXJ_WS_DAMAGELIST_D: "DMG ইনক্রিমেন্ট লিস্ট",
  T_42_XXJ_WS_DAMAGERATIOHEAD_D: "হেডশট DMG রেশিও",
  T_42_XXJ_WS_DAMAGEREDUCTIONFACTOREXPLODE_D: "এক্সপ্লোশন DMG রিডাকশন মাল্টিপ্লায়ার",
  T_42_XXJ_WS_DEFAULT_PHYMAT: "ডিফল্ট ফিজিক্স ম্যাটারিয়াল",
  T_42_XXJ_WS_DEFAULTFIST_D: "ডিফল্ট ফিস্ট",
  T_42_XXJ_WS_DELTA: "ডেল্টা",
  T_42_XXJ_WS_DELTA_D: "ডেল্টা",
  T_42_XXJ_WS_DELTATIME: "লজিক ফ্রেম ইন্টারভাল",
  T_42_XXJ_WS_DELTATIME_D: "GS-এর 2 লজিক ফ্রেম আপডেটের মধ্যে ব্যবধান",
  T_42_XXJ_WS_DEPTH: "লেয়ার",
  T_42_XXJ_WS_DEPTH_D: "আইকনে থাকা ডিসপ্লে লেয়ারসমূহ",
  T_42_XXJ_WS_DISABLEPICKUPITEMS: "ডিজেবল্ড গ্রাউন্ড লুটের তালিকা",
  T_42_XXJ_WS_DISABLEPICKUPITEMS_D: "যেসকল আইটেম গ্রাউন্ড লুট নয় তাদের লিস্ট",
  T_42_XXJ_WS_DRIVER: "ড্রাইভারের সিট",
  T_42_XXJ_WS_DRIVINGSTATUS: "ড্রাইভ",
  T_42_XXJ_WS_DURATION_D1: "সেকেন্ডের হিসেবে কাউন্টডাউন স্থায়িত্ব",
  T_42_XXJ_WS_DURATION_D2: "সেকেন্ডের হিসেবে স্থায়িত্ব",
  T_42_XXJ_WS_DURATION_D3: "স্থায়িত্ব",
  T_42_XXJ_WS_DURATION_D4: "সেকেন্ডের হিসেবে অভেদ্যতার সময়কাল",
  T_42_XXJ_WS_DURATIONTIMES: "সময়ের স্থায়িত্ব",
  T_42_XXJ_WS_DURATIONTIMES_D: "সেকেন্ডের হিসেবে স্থায়ীত্ব",
  T_42_XXJ_WS_DYNAMIC_FRICTION: "ডায়নামিক ফ্রিকশন",
  T_42_XXJ_WS_EASY: "খুব সহজ",
  T_42_XXJ_WS_ENDTIMES: "সমাপ্তির সময়",
  T_42_XXJ_WS_ENDTIMES_D: "সেকেন্ডের হিসেবে টাইমারে থাকা সমাপ্তির সময়",
  T_42_XXJ_WS_ENERGYTHRESHOLD: "গ্লোবাল এনার্জি থ্রেশহোল্ড",
  T_42_XXJ_WS_ENTITYVARNAME_D: "সেলফ-রিলেটিভ এনটিটি",
  T_42_XXJ_WS_EQUIPMENTATTACHMENT_D: "ইকুইপ অ্যাটাচমেন্ট",
  T_42_XXJ_WS_EULERANGLETOQUATERNION_D: "প্রদত্ত অয়লার অ্যাংগেলগুলোকে কোয়াটার্নিয়নে কনভার্ট করুন",
  T_42_XXJ_WS_EXPONENTIATION_D: "সূচক",
  T_42_XXJ_WS_EXTRABAGCAPACITY_D: "এক্সট্রা ব্যাকপ্যাক ক্যাপাসিটি",
  T_42_XXJ_WS_FIST: "ফিস্ট",
  T_42_XXJ_WS_FONTTYPE: "ফন্ট এনাম",
  T_42_XXJ_WS_FONTTYPE_D: "ফন্ট এনাম",
  T_42_XXJ_WS_FORCESYNCVALUE: "ফোর্স সিংক GS স্ট্যাটাস",
  T_42_XXJ_WS_FORCESYNCVALUE_D: "ফোর্স সিংক ভ্যাল্যু",
  T_42_XXJ_WS_FORCESYNCVALUE_D1: "GS ফোর্স সিংক থেকে লোকেশন ইনফো.",
  T_42_XXJ_WS_FORCESYNCVALUE1: "ফোর্স সিংক থেকে লোকেশন ইনফো",
  T_42_XXJ_WS_FORMULABLEENTITY_D: "এমন একটি এনটিটি যেটি প্রপার্টিজ ফর্মুলেট করতে পারে",
  T_42_XXJ_WS_FORWARD_D: "ডিরেকশন ভেক্টর",
  T_42_XXJ_WS_FRICTION_COMBINE: "ফ্রিকশন কম্বিনেশন পদ্ধতি",
  T_42_XXJ_WS_FUNCPOINT: "ফাংশন পয়েন্টার",
  T_42_XXJ_WS_FUNCPOINT_D: "একটি পয়েন্টার যে একটি ফাংশন একটি উদাহরণ নির্দেশ করে. এটি ভার্চুয়াল ফাংশন বা প্রতিনিধি প্রক্রিয়া বাস্তবায়ন করতে ব্যবহৃত হয়।",
  T_42_XXJ_WS_GETMAPID_D: "ম্যাপ ID পান",
  T_42_XXJ_WS_GETOFFVEHICLESTATUS: "ভেহিক্যাল প্রস্থান করুন",
  T_42_XXJ_WS_GETONASDRIVERSTATUS: "ভেহিক্যালে প্রবেশ করুন (ড্রাইভার)",
  T_42_XXJ_WS_GETONASPASSENGERSTATUS: "ভেহিক্যালে প্রবেশ করুন (প্যাসেঞ্জার)",
  T_42_XXJ_WS_GETPLAYERTOKENCOUNTTODAY_D: "আজকের প্লেয়ার টোকেন ডেটার জন্য সার্চ করুন",
  T_42_XXJ_WS_GRAVITY: "গ্লোবাল গ্র্যাভিটি",
  T_42_XXJ_WS_HANDHELDITEM: "বর্তমান হ্যান্ডহেল্ড",
  T_42_XXJ_WS_HANDHELDITEM_D: "বর্তমান হ্যান্ডহেল্ড",
  T_42_XXJ_WS_HARD: "কঠিন",
  T_42_XXJ_WS_HASCOMPONENT_D: "কোনো কম্পোনেন্ট আছে কিনা",
  T_42_XXJ_WS_HEIGHTLIST_D: "হাইট ইনক্রিমেন্ট লিস্ট",
  T_42_XXJ_WS_INDEXLIST_D: "এই স্ট্রিং এর ইনডেক্স লিস্ট অ্যাক্সেস করুন",
  T_42_XXJ_WS_INSCENE: "দৃশ্যপটে",
  T_42_XXJ_WS_INSCENE_D: "সিন এ থাকা",
  T_42_XXJ_WS_IS3D_D: "এটা কোনো 3D মিউজিক কিনা",
  T_42_XXJ_WS_ISCOUNTDOWN_D: "কাউন্টডাউন অথবা স্টপওয়াচ",
  T_42_XXJ_WS_ISLOOP: "লুপ কি না",
  T_42_XXJ_WS_ISLOOP_D: "IsLoop কমান্ড",
  T_42_XXJ_WS_ISREPLAY_D: "একেবারে সূচনা থেকেই শুরু করবেন কিনা",
  T_42_XXJ_WS_ISSWITCH_D: "এটি true-তে সেট করা হলে, এটি আপেক্ষিক গতির সাথে মিলিত হতে পারে। false-তে সেট করা হলে, এটি পরম গতির সাথে মিলিত হতে পারে।",
  T_42_XXJ_WS_JEEP: "জিপ",
  T_42_XXJ_WS_JUMPSTATUS: "জাম্প স্ট্যাটাস",
  T_42_XXJ_WS_LEFTVALUE: "বাম ভ্যাল্যু",
  T_42_XXJ_WS_LEFTVALUE_D: "বেজ",
  T_42_XXJ_WS_LOGARITHM_D: "লগারিদম",
  T_42_XXJ_WS_LOOPABLE: "ল্যুপেবল",
  T_42_XXJ_WS_LOOPABLE_D: "ল্যুপেবল",
  T_42_XXJ_WS_MAPGETALLKEYS_D: "এই ডিক্ট থেকে সবগুলো কী অর্জন করুন",
  T_42_XXJ_WS_MAPVALUE_D: "টার্গেট ডিক্ট",
  T_42_XXJ_WS_MARKBTNHUD: "HUD এ থাকা পিন বাটন",
  T_42_XXJ_WS_MATHE: "e",
  T_42_XXJ_WS_MATHPI: "পাই",
  T_42_XXJ_WS_MAXDISTANCE_D: "সর্বোচ্চ দূরত্ব",
  T_42_XXJ_WS_MICROPHONEBTNHUD: "HUD-এ থাকা মাইক সুইচ",
  T_42_XXJ_WS_MINDISTANCE_D: "ন্যুনতম দূরত্ব",
  T_42_XXJ_WS_MISSIONID_D: "মিশন ID",
  T_42_XXJ_WS_MISSIONPROGRESS_D: "প্রগ্রেস (এটা কোনো নেগেটিভ নাম্বার হতে পারে না)",
  T_42_XXJ_WS_MODERATE: "মডারেট",
  T_42_XXJ_WS_MONSTERTRUCK: "মনস্টার ট্রাক",
  T_42_XXJ_WS_MOTORBIKE: "মোটর বাইক",
  T_42_XXJ_WS_MOVEMENTSTATUS: "মুভমেন্ট স্ট্যাটাস",
  T_42_XXJ_WS_MULTIPLYQUATERNION_D: "দুইটি কোয়াটার্নিয়নের মাল্টিপ্লিকেশন (রোটেশন সুপারপজিশনের প্রতিনিধিত্ব করে)",
  T_42_XXJ_WS_NORMAL: "নরমাল",
  T_42_XXJ_WS_OBSOLETE: "ডিসকার্ড হয়েছে",
  T_42_XXJ_WS_OPENPLAYERVIEW: "প্লেয়ার পার্সপেক্টিভ এনাবল করুন",
  T_42_XXJ_WS_OPENPLAYERVIEW_D: "প্লেয়ার পার্সপেক্টিভ এনাবল করুন",
  T_42_XXJ_WS_ORIGINWEAPONTYPE: "ওয়েপন টাইপ",
  T_42_XXJ_WS_ORIGINWEAPONTYPE_D: "ওয়েপন টাইপ",
  T_42_XXJ_WS_OVERLOADPLAYERSKIN: "প্রায়োরিটাইজ প্লেয়ার কনফিগ.",
  T_42_XXJ_WS_PARAMSARRAY: "প্যারামিটার্স অ্যারে",
  T_42_XXJ_WS_PARAMSARRAY_D: "প্যারামিটার অ্যারে আউটপুটে জড়িত পরামিতিগুলির একটি তালিকা। ফরম্যাটের বিবরণে এটি %v সংখ্যার সাথে মিলতে হবে।",
  T_42_XXJ_WS_PARAMSARRAY_D1: "কাস্টম ফাংশনে পাস করা প্রকৃত প্যারামিটারের তালিকা।",
  T_42_XXJ_WS_PARTVISABLEMASK1: "পার্ট ভিজিবিলিটি মাস্ক 1",
  T_42_XXJ_WS_PARTVISABLEMASK2: "পার্ট ভিজিবিলিটি মাস্ক",
  T_42_XXJ_WS_PARTVISABLEMASK3: "পার্ট ভিজিবিলিটি মাস্ক 3",
  T_42_XXJ_WS_PARTVISABLEMASK4: "পার্ট ভিজিবিলিটি মাস্ক 4",
  T_42_XXJ_WS_PASSENGER1: "পেসেঞ্জার সিট 1",
  T_42_XXJ_WS_PASSENGER2: "প্যাসেঞ্জার সিট 2",
  T_42_XXJ_WS_PASSENGER3: "পেসেঞ্জার সিট 3",
  T_42_XXJ_WS_PHYMAT: "ফিজিক্স ম্যাটারিয়াল",
  T_42_XXJ_WS_PLAYABLEENTITIES_D: "এনটিটি",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME: "প্রতি ফ্রেমে সেলফ-রিলেটিভ মোশন",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME_D: "প্রতি ফ্রেমে সেলফ-রিলেটিভ মোশন",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE: "সেলফ-রিলেটিভ মোশন",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE_D: "সেলফ-রিলেটিভ মোশন",
  T_42_XXJ_WS_PLAYER_D: "যে প্লেয়ারটিকে গাড়িতে প্রবেশ করতে হবে",
  T_42_XXJ_WS_PLAYERBEHAVIOR: "প্লেয়ার বিহেভিয়ার রিসোর্স সিংক এর এনটিটি",
  T_42_XXJ_WS_PLAYERBEHAVIOR_D: "প্লেয়ার বিহেভিয়ার প্রপার্টি সিংকের এনটিটি",
  T_42_XXJ_WS_PRIORITY_D: "প্রাধান্য",
  T_42_XXJ_WS_PROPID_D: "প্রপার্টি ID",
  T_42_XXJ_WS_QUATERNION: "কোয়াটার্নিয়ন",
  T_42_XXJ_WS_QUATERNION_D: "কোয়াটার্নিয়ন হলো একটি বিশেষ চার-মাত্রিক ভেক্টর যা শুধুমাত্র একটি রোটেশন প্রতিনিধিত্ব করতে ব্যবহৃত হয়",
  T_42_XXJ_WS_QUATERNIONTOAXISANGLE_D: "প্রদত্ত কোয়াটারনিয়নগুলিকে অ্যাক্সিস-অ্যাংগেল রিপ্রেজেন্টেশনে কনভার্ট করুন",
  T_42_XXJ_WS_QUATERNIONTOEULERANGLE_D: "প্রদত্ত কোয়াটার্নিয়নকে অয়লার অ্যাংগেল এ কনভার্ট করুন। কোয়াটার্নিয়নগুলো স্ট্যান্ডার্ড পূরণ না করলে, (0,0,0) রিটার্ন করে।",
  T_42_XXJ_WS_REPEATTIMES_D: "যতবার খেলা হয়েছে। ডিফল্ট হল 1।",
  T_42_XXJ_WS_RESETPLAYABLE_D: "রিসেট",
  T_42_XXJ_WS_RIGHTVALUE: "ডানদিকের ভ্যালু",
  T_42_XXJ_WS_RIGHTVALUE_D: "পাওয়ার",
  T_42_XXJ_WS_SEATTYPE: "ভেহিক্যাল সিট এনাম",
  T_42_XXJ_WS_SEPSTR_D: "বিভাজনের জন্য ব্যবহৃত স্ট্রিং",
  T_42_XXJ_WS_SETPLAYERFALLINGDAMAGE_D: "প্লেয়ার ফল DMG সেট করুন",
  T_42_XXJ_WS_SETTINGSBTNHUD: "এই HUD-এ থাকা সেটিংস বাটন",
  T_42_XXJ_WS_SHOWPOSITION: "লোকেশন প্রদর্শন",
  T_42_XXJ_WS_SHOWPOSITION_D: "লোকেশন প্রদর্শন করুন",
  T_42_XXJ_WS_SIGNALICOHUD: "HUD তে থাকা নেটওয়ার্ক কানেকশন বাটন",
  T_42_XXJ_WS_SIMPLE: "সহজ",
  T_42_XXJ_WS_SLERPQUATERNION_D: "A থেকে B পর্যন্ত গোলাকার কোয়াটার্নিয়নের ইন্টারপোলেশন",
  T_42_XXJ_WS_SOUNDENTITY_D: "সাউন্ড ইফেক্ট এনটিটি এমন একটি সাউন্ড ইফেক্টকে প্রতিনিধিত্ব করে, যেটি প্লে করা হচ্ছে",
  T_42_XXJ_WS_SPEAKERBTNHUD: "HUD এ থাকা হর্ন বাটন",
  T_42_XXJ_WS_SPLITSTRING_D: "একটি স্লাইস মধ্যে স্ট্রিং বিভক্ত একটি বিভাজক হিসাবে একটি নির্দিষ্ট স্ট্রিং ব্যবহার করুন",
  T_42_XXJ_WS_SPORTSCAR: "স্পোর্টস কার",
  T_42_XXJ_WS_SPRINTSTATUS: "স্প্রিন্ট স্ট্যাটাস",
  T_42_XXJ_WS_SRCVAL_D: "সোর্স ভ্যাল্যু",
  T_42_XXJ_WS_STARTTICKCOUNT: "এমন একটি মুহূর্ত, যখন GS স্টারগুলো টিক টিক শুরু করে",
  T_42_XXJ_WS_STARTTICKCOUNT_D: "যে মুহূর্ত GS টিক টিক শুরু করে",
  T_42_XXJ_WS_STARTTIME_D: "শুরুর সময়",
  T_42_XXJ_WS_STARTTIME_D1: "শুরুর সময়",
  T_42_XXJ_WS_STATE_D: "একজন প্লেয়ারের স্ট্যাটাস: অ্যাক্টিভ, নক-ডাউন নাকি এলিমিনেটেড",
  T_42_XXJ_WS_STATE_D1: "এই সাউন্ড ইফেক্টটি প্লে হচ্ছে কিনা চেক করুন",
  T_42_XXJ_WS_STATIC_FRICTION: "স্ট্যাটিক ফ্রিকশন",
  T_42_XXJ_WS_STRELEMS_D: "টার্গেট স্ট্রিং সেট",
  T_42_XXJ_WS_STRINGFINDAT_D: "ইনডেক্স লিস্ট অনুযায়ী ফাইনাল কম্বাইনড স্ট্রিং রিটার্ন করে",
  T_42_XXJ_WS_STRINGJOIN_D: "একটি নির্দিষ্ট আইডেন্টিফায়ার ব্যবহার করে স্ট্রিংগুলো জয়েন করুন",
  T_42_XXJ_WS_STRINGLOWER_D: "স্ট্রিংয়ের সমস্ত অক্ষরকে ছোট হাতের অক্ষরে রূপান্তর করুন",
  T_42_XXJ_WS_STRINGSTRIP_D: "স্ট্রিংয়ের উভয় দিক থেকে হোয়াইটস্পেস অক্ষরগুলি রিমুভ করুন",
  T_42_XXJ_WS_STRINGUPPER_D: "স্ট্রিংয়ের সমস্ত অক্ষরকে বড় হাতের অক্ষরে রূপান্তর করুন",
  T_42_XXJ_WS_STYLE_D: "যেভাবে এটি খেলা হয়",
  T_42_XXJ_WS_SUV: "পিকআপ ট্রাক",
  T_42_XXJ_WS_SWITCH: "স্যুইচ",
  T_42_XXJ_WS_SWITCH_D: "এটি true-তে সেট করা হলে, এটি আপেক্ষিক গতির সাথে মিলিত হতে পারে। আবার false-তে সেট করা হলে, এটি অবশ্যই পরম গতির সাথে মিলিত হতে হবে, অন্যথায় ফিচারগুলো সঠিকভাবে কার্যকর হবে না৷",
  T_42_XXJ_WS_TARGETENTITY_D: "টার্গেট এনটিটি",
  T_42_XXJ_WS_TEAMROUNDSCOREBANNERHUD: "টিম রাউন্ড স্কোর ব্যানার",
  T_42_XXJ_WS_TEAMSEQ_D: "টিম সিরিয়াল নম্বর, যা টিম এনটিটির সিরিয়াল নম্বর প্রপার্টির সাথে মিলে যায়৷",
  T_42_XXJ_WS_TEMPORARYSHIELD: "টেম্পোরারি শিল্ড পয়েন্টস",
  T_42_XXJ_WS_TEMPORARYSHIELD_D: "টেম্পোরারি শিল্ড পয়েন্টস",
  T_42_XXJ_WS_TEXT_D: "একটি প্রোফিনিটি ফিল্টার পারফর্ম করার অরিজিনাল টেক্সট",
  T_42_XXJ_WS_THREESTATESWITCH: "3-স্ট্যাটাস সুইচ",
  T_42_XXJ_WS_THROWINGKNIFE_D: "ড্যাগার (গ্রাউন্ড লুট)",
  T_42_XXJ_WS_THROWINGKNIFEBR_D: "ড্যাগার",
  T_42_XXJ_WS_TUKTUK: "টুক টুক",
  T_42_XXJ_WS_TWOTEAMLEADERBOARDHUD: "টিমস ম্যাচ বিস্তারিত",
  T_42_XXJ_WS_UNIQUEID: "ইউনিক ID",
  T_42_XXJ_WS_UNIQUEID_D: "ইউনিক ID",
  T_42_XXJ_WS_VALUE_D: "ভ্যাল্যু",
  T_42_XXJ_WS_VECTOR3TOEULERANGLES_D: "অয়লার অ্যাংগেলে ডিরেকশন ভেক্টর",
  T_42_XXJ_WS_VEHICLEID: "ভেহিক্যাল ID",
  T_42_XXJ_WS_VEHICLESKINID: "ভেহিক্যাল স্কিন ID",
  T_42_XXJ_WS_VERYHARD: "খুব কঠিন",
  T_42_XXJ_WS_VOLUME_D: "এটা হলো সাউন্ড ভলিউম। ডিফল্টভাবে 50।",
  T_42_XXJ_WS_WEAPONTYPE_D: "ওয়েপন'স মেইন টাইপ",
  T_42_XXJ_WS_WORKSHOPCODE: "ম্যাপ কোড",
  T_42_XXJ_WS_WORKSHOPCODE_D: "ম্যাপ কোড, যা ডাটাবেসের একটি ডেটার সাথে সংশ্লিষ্ট",
  T_42_XXJ_WS_WORLDPOSITION: "ওয়ার্ল্ড কোঅর্ডিনেটস",
  T_42_XXJ_WS_WORLDPOSITION_D: "ওয়ার্ল্ড কোঅর্ডিনেটস",
  T_42_XYL_WS_ITEM275: "তেলের ট্যাংক",
  T_42_XYL_WS_ITEM276: "স্যান্ড ব্যাগ A",
  T_42_XYL_WS_ITEM277: "স্যান্ড ব্যাগ B",
  T_42_XYL_WS_ITEM278: "স্যান্ড ব্যাগ C",
  T_42_XYL_WS_ITEM279: "স্যান্ড ব্যাগ",
  T_42_XYL_WS_ITEM280: "ডাবল ডেক ভিলা",
  T_42_XYL_WS_ITEM281: "আর্মস ফ্যাক্টরি",
  T_42_XYL_WS_ITEM282: "স্টোন ওয়াল A",
  T_42_XYL_WS_ITEM283: "স্টোন ওয়াল B",
  T_42_XYL_WS_ITEM284: "স্টোন ওয়াল C",
  T_42_XYL_WS_ITEM285: "স্টোন ওয়াল D",
  T_42_XYL_WS_ITEM286: "মিলিটারি সাপ্লাই বক্স A",
  T_42_XYL_WS_ITEM287: "কপার কয়েন",
  T_42_XYL_WS_ITEM288: "সিলভার কয়েন",
  T_42_XYL_WS_ITEM289: "গোল্ড কয়েন",
  T_42_XYL_WS_ITEM290: "ডায়মন্ড",
  T_42_XYL_WS_ITEM291: "ডায়মন্ড শার্ডস",
  T_42_XYL_WS_ITEM292: "রুবি",
  T_42_XYL_WS_ITEM293: "এমারাল্ড",
  T_42_XYL_WS_ITEM294: "স্যাফায়ার",
  T_42_XYL_WS_ITEM295: "সতর্কীকরণ সংকেত",
  T_42_XYL_WS_ITEM297: "র‍্যিউন",
  T_42_XYL_WS_ITEM297TRUE: "কন্ট্রোল ডিভাইস",
  T_42_XYL_WS_ITEM298: "সাপ্লাই কন্টেইনার B",
  T_42_XYL_WS_ITEM299: "স্নো পাইল",
  T_42_XYL_WS_ITEM300: "হাই-টেক ওয়াল A",
  T_42_XYL_WS_ITEM301: "হাই-টেক ওয়াল B",
  T_42_XYL_WS_ITEM302: "ফ্রোজেন স্টোন F",
  T_42_XYL_WS_ITEM303: "ফ্রোজেন স্টোন E",
  T_42_XYL_WS_ITEM304: "হাই-টেক প্লাটফর্ম A",
  T_42_XYL_WS_ITEM305: "হাই-টেক স্টেয়ারকেইজ A",
  T_42_XYL_WS_ITEM306: "এক্সপ্লোরেশন ল্যাম্প A",
  T_42_XYL_WS_ITEM307: "রুইন ব্যাফেল A",
  T_42_XYL_WS_ITEM308: "রুইন ব্যাফেল B",
  T_42_XYL_WS_ITEM309: "রুইন স্টিল ব্র্যাকেট A",
  T_42_XYL_WS_ITEM310: "রুইন স্টোন A",
  T_42_XYL_WS_ITEM311: "রুইন স্টোন B",
  T_42_XYL_WS_ITEM312: "রিউন স্টোন C",
  T_42_XYL_WS_ITEM313: "ফ্ল্যাশলাইট A",
  T_42_XYL_WS_ITEM314: "রিউন রেবার A",
  T_42_XYL_WS_LOGICALOBJECT: "লজিক",
  T_42_XYL_WS_THEMEHIGHTECH: "ফিউচারিস্টিক",
  T_42_XYL_WS_THEMEICE: "বরফময়",
  T_42_XYL_WS_THEMEMILITARY: "মিলিটারি",
  T_42_XYL_WS_THEMEOBJECTS: "থিম অবজেক্ট",
  T_42_XYL_WS_TIMERCONTINUE: "টাইমার রিজিউমিং ইনসিডেন্ট",
  T_42_XYL_WS_TIMERCYCLE: "লুপ কাউন্ট",
  T_42_XYL_WS_TIMERDOWN: "কাউন্টডাউন",
  T_42_XYL_WS_TIMEREND: "টাইমার এন্ডিং ইনসিডেন্ট",
  T_42_XYL_WS_TIMEREVENT: "কাস্টমাইজড টাইমার ইনসিডেন্ট",
  T_42_XYL_WS_TIMEREVENT1: "টাইমার কন্ট্রোল করুন",
  T_42_XYL_WS_TIMEREVENT2: "টাইমার ইনসিডেন্টস সেট করুন",
  T_42_XYL_WS_TIMERORDER: "টাইমিং মেথড",
  T_42_XYL_WS_TIMERPAUSE: "টাইমার পজিং ইনসিডেন্ট",
  T_42_XYL_WS_TIMERSTART1: "টাইমার স্টার্ট টাইম",
  T_42_XYL_WS_TIMERSTART2: "টাইমার স্টার্টিং ইনসিডেন্ট",
  T_42_XYL_WS_TIMERUP: "কাউন্ট আপ",
  T_42_XYL_WS_TRIGGERTIME_MS: "ট্রিগার টাইম (মিলিসেকেন্ডে)",
  T_42_ZZ_GUILDWAR_AIRCRAFTDESC: "এমন একটি স্কাইউইং, যা একাধিক প্লেয়ারকে ধরে রাখতে পারে।",
  T_42_ZZ_GUILDWAR_PERSONALSCORE: "স্বতন্ত্র স্কোর",
  T_42_ZZ_GUILDWAR_SCORE: "স্কোর",
  T_43_B_SKILL_DESC_MONKEYGOD: "একটি ঝোপে রূপান্তরিত হয়, যা [FFB300]{1}s[-] পর্যন্ত স্থায়ী হয়। কুলডাউন: [FFB300]{0}s[-]। উকং অ্যাটাক করলে রূপান্তর শেষ হয়। উকং কোনো এনিমিকে ডাউন করলে CD  রিসেট হয়।",
  T_43_B_SKILL_DESC_Nanoscientist: "মারাত্মক ড্যামেজ পাওয়ার পরে, [FFB300]{0}s[-] এর জন্য একটি অদম্য এবং অচল অবস্থায় প্রবেশ করুন। তারপর, একটি [FFB300]{1} HP শিল্ড[-] অর্জন করুন যা [FFB300]{2}s[-] পর্যন্ত স্থায়ী হয়। শিল্ড অদৃশ্য হয়ে গেলে স্কিল ইউজারকে এলিমিনেটেড করা হবে।কুলডাউন: [FFB300]{3}s[-]।",
  T_43_B_SKILL_DESC_ORION: "EP কে [FFB300]{0} ক্রিমসন এনার্জি[-] দিয়ে প্রতিস্থাপন করে। এর প্রোটেকশন সক্রিয় করতে [FFB300]{1} ক্রিমসন এনার্জি[-] ব্যবহার করে, যার সময় আপনি এনিমিদের ড্যামেজ দিতে বা আক্রমণ করতে পারবেন না এবং [FFB300]{4} HP[-] (এনিমি শিল্ড পয়েন্ট উপেক্ষা করে) [FFB300'-এর মধ্যে থাকা এনিমিদের কাছ থেকে শোষণ করবেন ]{3}মি[-]। [FFB300]{2}s[-] পর্যন্ত স্থায়ী হয়, এই সময়ে আপনার মুভমেন্ট স্পিড [FFB300]{6}%[-] কমে যাবে। কুলডাউন: [FFB300]{5}s[-]।",
  T_43_CJ_F_A_RACER: "ভেলোসিটি রেসার (মাস্ক)",
  T_43_CJ_F_B_RACER: "ভেলোসিটি রেসার (বটম)",
  T_43_CJ_F_H_RACER: "ভেলোসিটি রেসার (হেড)",
  T_43_CJ_F_HA_RACER: "ভেলোসিটি রেসার (ফেসপেইন্ট)",
  T_43_CJ_F_S_RACER: "ভেলোসিটি রেসার (জুতা)",
  T_43_CJ_F_T_RACER: "ভেলোসিটি রেসার (টপ)",
  T_43_CJ_M_A_RACER: "টার্বো রেসার (মাস্ক)",
  T_43_CJ_M_B_MACHINERY: "টারকুইজ টেক (বটম)",
  T_43_CJ_M_B_RACER: "টার্বো রেসার (বটম)",
  T_43_CJ_M_H_MACHINERY: "টারকুইজ টেক (হেড)",
  T_43_CJ_M_H_RACER: "টার্বো রেসার (হেড)",
  T_43_CJ_M_HA_MACHINERY: "টারকুইজ টেক (ফেসপেইন্ট)",
  T_43_CJ_M_S_MACHINERY: "টারকুইজ টেক (জুতা)",
  T_43_CJ_M_S_RACER: "টার্বো রেসার (জুতা)",
  T_43_CJ_M_T_MACHINERY: "টারকুইজ টেক (টপ)",
  T_43_CJ_M_T_RACER: "টার্বো রেসার (টপ)",
  T_43_H_CHARACTER_GEEK_N: "রাইডেন",
  T_43_H_VSK94_MAMBAS_N: "VSK94 - মাম্বা নিয়াও",
  T_43_HJ_WS_OPTION8: "অন্যান্য",
  T_43_HJ_WS_TEXTURE_BAMBOO: "ব্যাম্বো",
  T_43_HJ_WS_TEXTURE_BEACH: "সৈকত",
  T_43_HJ_WS_TEXTURE_BRICK1: "ইটের দেয়াল A",
  T_43_HJ_WS_TEXTURE_BRICK2: "ইটের ওয়াল B",
  T_43_HJ_WS_TEXTURE_BRICK3: "ইটের ওয়াল C",
  T_43_HJ_WS_TEXTURE_CEMENT: "কনক্রিট ফ্লোর",
  T_43_HJ_WS_TEXTURE_CEMENT2: "কনক্রিট",
  T_43_HJ_WS_TEXTURE_CRYSTAL: "ক্রিস্টাল",
  T_43_HJ_WS_TEXTURE_GLASSLAND1: "ঘাস A",
  T_43_HJ_WS_TEXTURE_GLASSLAND2: "ঘাস B",
  T_43_HJ_WS_TEXTURE_ICE: "আইস ব্লক",
  T_43_HJ_WS_TEXTURE_IRON: "মেটাল ফ্লোর",
  T_43_HJ_WS_TEXTURE_IRON2: "কন্টেনার",
  T_43_HJ_WS_TEXTURE_LAVA: "লাভা",
  T_43_HJ_WS_TEXTURE_MARBLE: "মার্বেল ফ্লোর",
  T_43_HJ_WS_TEXTURE_NONE: "খালি",
  T_43_HJ_WS_TEXTURE_STONE: "স্টোন",
  T_43_HJ_WS_TEXTURE_TEXTILE1: "টেবিলক্লথ A",
  T_43_HJ_WS_TEXTURE_TEXTILE2: "টেবিলক্লথ B",
  T_43_HJ_WS_TEXTURE_WOOD: "কাঠ",
  T_43_HJ_WS_TEXTURE_WOODEN: "কাষ্ঠল ফ্লোর A",
  T_43_HJ_WS_TEXTURE_WOODEN2: "কাষ্ঠল ফ্লোর B",
  T_43_JH_WS_MAPTAG1: "নিউবি-ফ্রেন্ডলি",
  T_43_JH_WS_MAPTAG10: "বোরিং নতুন কন্টেন্ট",
  T_43_JH_WS_MAPTAG11: "ক্ষুদ্র সেন্স অফ প্রগ্রেস",
  T_43_JH_WS_MAPTAG12: "রিওয়ার্ড ভারসাম্যহীনতা",
  T_43_JH_WS_MAPTAG13: "দুর্বল সেন্স অফ প্রগ্রেস",
  T_43_JH_WS_MAPTAG14: "নিউবি-আনফ্রেন্ডলি",
  T_43_JH_WS_MAPTAG15: "কনফিউজিং টিউটোরিয়াল",
  T_43_JH_WS_MAPTAG16: "ল্যাক অফ টিউটোরিয়ালস",
  T_43_JH_WS_MAPTAG17: "প্লেয়াররা অনেকটাই ছেড়ে দিয়েছে",
  T_43_JH_WS_MAPTAG18: "কমপ্লিকেটেড কন্ট্রোলস",
  T_43_JH_WS_MAPTAG19: "ক্লাটার্ড UI",
  T_43_JH_WS_MAPTAG2: "কাংক্ষিত নতুন কন্টেন্ট",
  T_43_JH_WS_MAPTAG20: "খারাপ ম্যাপ ডিজাইন",
  T_43_JH_WS_MAPTAG21: "থ্রিলিং শ্যুটার",
  T_43_JH_WS_MAPTAG22: "ফেস-পেসড",
  T_43_JH_WS_MAPTAG23: "ওপেন ওয়ার্ল্ড",
  T_43_JH_WS_MAPTAG24: "স্টোরি-রিচ",
  T_43_JH_WS_MAPTAG25: "প্রগ্রেশন সিস্টেম",
  T_43_JH_WS_MAPTAG26: "স্পোর্টস সিমুলেশন",
  T_43_JH_WS_MAPTAG27: "কো-অপ মিশন",
  T_43_JH_WS_MAPTAG28: "সোশ্যাল",
  T_43_JH_WS_MAPTAG29: "বৈচিত্র্যময় উদাহরণ",
  T_43_JH_WS_MAPTAG3: "অ্যাক্টিভ প্লেয়ার",
  T_43_JH_WS_MAPTAG30: "ফ্রি এক্সপ্লোরেশন",
  T_43_JH_WS_MAPTAG31: "র‍্যাংকিং চ্যালেঞ্জ",
  T_43_JH_WS_MAPTAG32: "অ্যাচিভমেন্ট",
  T_43_JH_WS_MAPTAG33: "কারেন্সি রিডিম",
  T_43_JH_WS_MAPTAG4: "ভালো-ডিজাইনের ম্যাপ",
  T_43_JH_WS_MAPTAG40: "অসংখ্য রিওয়ার্ডস",
  T_43_JH_WS_MAPTAG41: "সন্তোষজনক প্রগ্রেশন",
  T_43_JH_WS_MAPTAG42: "পপুলার ট্রেনিং গ্রাউন্ডস",
  T_43_JH_WS_MAPTAG43: "পপুলার সোলো টাওয়ার",
  T_43_JH_WS_MAPTAG44: "পপুলার ওয়ার জোন",
  T_43_JH_WS_MAPTAG5: "স্টাটারিং",
  T_43_JH_WS_MAPTAG6: "হার্ড কো-অপ",
  T_43_JH_WS_MAPTAG7: "বাগি",
  T_43_JH_WS_MAPTAG8: "অল্প আপডেটস",
  T_43_JH_WS_MAPTAG9: "বোরিং ইন-ম্যাচ ইভেন্টস",
  T_43_JH_WS_SKILLSETAUTOPATHBOMB: "স্পাইডার ট্র্যাপ (রাইডেন)",
  T_43_SJ_WS_AIRDROP_ITEMS: "ড্রপ আইটেমসমূহ",
  T_43_SJ_WS_AIRDROP_NAME: "এয়ারড্রপ",
  T_43_SJ_WS_AIRDROP_TIME: "ড্রপ টাইম শুরু করুন",
  T_43_SJ_WS_AIRDROP_UI_ITEM: "আইটেম ড্রপ করুন'",
  T_43_SJ_WS_ANITRIGGER_AUTO: "অটো-প্লে কিনা",
  T_43_SJ_WS_ANITRIGGER_CENTER: "সেন্টার পজিশন কিনা",
  T_43_SJ_WS_ANITRIGGER_CLIP: "অ্যানিমেশন ক্লিপ ID",
  T_43_SJ_WS_ANITRIGGER_LOOP: "লুপ কিনা",
  T_43_SJ_WS_ANITRIGGER_NAME: "অ্যানিমেশন ট্রিগার HUD",
  T_43_SJ_WS_RESET_ROUND: "প্রতি রাউন্ডে রিসেট",
  T_43_SJ_WS_START_DROPTIME: "ড্রপ টাইম শুরু করুন (ms)",
  T_43_SJ_WS_TRIGGER_ANIMA: "অ্যানিমেশন ট্রিগার",
  T_43_SY_PETSKIN_AXOLOTL_WATERFEST24_N: "পেট স্কিন: Meow Meow Zasil",
  T_43_SY_VEHICLESKIN_MOTOBIKE_FIGHTER_N: "মোটরবাইক - ইনকার্নেশনাল স্পিড",
  T_43_WH_ITEM_SUPPLYBOX_DESC: "যুদ্ধের প্রয়োজনীয় সামগ্রী যেমন গোলাবারুদ এবং চিকিৎসা সামগ্রী রয়েছে",
  T_43_WH_ITEM_SUPPLYBOX_NAME: "সাপ্লাই বক্স",
  T_43_WT_SKILL_DESC_DUMMY_REWORK: "একটি [FFB300]{1} HP[-] ম্যানেকুইন তৈরি করুন যা নিজের ইচ্ছেমতো[FFB300]{0}s[-] ট্রাভেল করে। যখন ম্যানেকুইন [FFB300]{3}m[-] এর মধ্যে থাকে, তখন এটির সাথে অবস্থান পরিবর্তন করতে দক্ষতাটি আবার ব্যবহার করুন। আপনি শুধুমাত্র একবার [FFB300]{4}s[-] এর মধ্যে স্যুইচ করতে পারেন, মোট [FFB300]{2}বার[-] পর্যন্ত। যে প্লেয়ার ম্যানকুইনটি ধ্বংস করবে তাকে [FFB300]{5}s[-] এর জন্য চিহ্নিত করা হবে। কুলডাউন: [FFB300]{6}s[-]।",
  T_43_WT_W_VSK94: "VSK94",
  T_43_XXJ_WS_ACTIVITYSKILL: "অ্যাক্টিভ স্কিল",
  T_43_XXJ_WS_AIRDROP: "এয়ারড্রপ এবং জোম্বি",
  T_43_XXJ_WS_ALPHA: "আলফা",
  T_43_XXJ_WS_ALPHA_D: "HUD এর সামগ্রিক স্বচ্ছতা, যার রেঞ্জ 0 থেকে 1 পর্যন্ত।",
  T_43_XXJ_WS_ANIMATIONCTRLID: "অ্যানিমেশন কন্ট্রোলার ID",
  T_43_XXJ_WS_ANIMATIONCTRLID_D: "একটি অ্যানিমেশন কন্ট্রোলার অ্যাসেট বর্ণনা করতে ব্যবহৃত আইডি",
  T_43_XXJ_WS_AUDIOID: "অডিও ID",
  T_43_XXJ_WS_AUDIOID_D: "একটি অডিও অ্যাসেট বর্ণনা করার জন্য ব্যবহৃত ID",
  T_43_XXJ_WS_BACKGRCOLOR: "ব্যাকগ্রাউন্ড কালার",
  T_43_XXJ_WS_BACKGRCOLOR_D: "হেলথ বার বোর্ডারের রঙ এবং ঝাপসা ব্যাকগ্রাউন্ড",
  T_43_XXJ_WS_BURNING: "বার্নিং",
  T_43_XXJ_WS_CSVID: "CSV ID",
  T_43_XXJ_WS_CSVID_D: "একটি কনফিগারেশন টেবিল অ্যাসেট বর্ণনা করতে ব্যবহৃত ID",
  T_43_XXJ_WS_CURRENTHP: "বর্তমান HP",
  T_43_XXJ_WS_CURRENTHP_D: "বর্তমান HP ভ্যাল্যু",
  T_43_XXJ_WS_DAMAGEMAKER_D: "যে গেম এনটিটি ড্যামেজ ডিল করে",
  T_43_XXJ_WS_DAMAGEZONE: "ড্যামেজ জোন",
  T_43_XXJ_WS_DEFAULT: "ডিফল্ট",
  T_43_XXJ_WS_DEFAULT_D: "ডিফল্ট",
  T_43_XXJ_WS_EFFECTID: "ইফেক্ট ID",
  T_43_XXJ_WS_EFFECTID_D: "একটি স্পেশাল ইফেক্ট অ্যাসেট বর্ণনা করতে ব্যবহৃত আইডি",
  T_43_XXJ_WS_FIGHTINGENTITY_D: "এমন একটি এনটিটি, যা ফাইট করতে পারে (যেমন- অ্যাটাক লঞ্চ করা, অ্যাটাক পাওয়া, কিংবা এলিমিনেটেড হওয়া)",
  T_43_XXJ_WS_FOLLOWTARGET: "টার্গেট ফলো করুন",
  T_43_XXJ_WS_FOLLOWTARGET_D: "একটি ট্রান্সফর্ম কম্পোনেন্টসহ একটি এনটিটি অনুসরণ করতে হবে",
  T_43_XXJ_WS_GAINHPCOLOR: "অর্জন করুন HP কালার",
  T_43_XXJ_WS_GAINHPCOLOR_D: "HP এর বর্ধিত অংশ অল্প সময়ের জন্য এই রঙে দেখাবে",
  T_43_XXJ_WS_ISNOFALLDAMAGE: "নো ফল ড্যামেজ কিনা",
  T_43_XXJ_WS_ISOPENTWEEN: "ওপেন টুইন কিনা",
  T_43_XXJ_WS_ISOPENTWEEN_D: "বিভিন্ন রঙে HP পরিবর্তনগুলি দেখাতে এটি এনাবল করুন৷",
  T_43_XXJ_WS_KNOCKDOWN_D1: "এই প্লেয়ার নকডাউন স্টেট এ রয়েছেন",
  T_43_XXJ_WS_KNOCKDOWN_D2: "এলিমিনেটেড হলে নকডাউন অবস্থায় প্রতিক্রিয়ার জন্য সেটিংস",
  T_43_XXJ_WS_KNOCKDOWN_D3: "রিভাইভাল সোর্স টাইপ। নকডাউন হয়ে গেলে একজন প্লেয়ারকে রিভাইভ করা যায়।",
  T_43_XXJ_WS_KNOCKDOWNSTATE: "নকডাউন স্টেট",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE: "নকডাউন স্টেট টাইপ",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE_D: "নকডাউন অবস্থার প্রতিক্রিয়া: ডিফল্ট লজিক বজায় রাখুন, নকডাউন অবস্থা এড়িয়ে যান বা নকডাউনে জোর করুন।",
  T_43_XXJ_WS_LEVEL: "লেভেল",
  T_43_XXJ_WS_LEVEL_D: "লেভেল",
  T_43_XXJ_WS_LEVEL_D1: "বর্তমান জোম্বি লেভেল",
  T_43_XXJ_WS_LINESPACING: "লাইন স্পেসিং",
  T_43_XXJ_WS_LINESPACING_D: "দুটি বিভাজকের মধ্যে HP ভাগ করলে ≤ 0 প্রদর্শিত হয় না",
  T_43_XXJ_WS_LOSEHPCOLOR: "হারান HP কালার",
  T_43_XXJ_WS_LOSEHPCOLOR_D: "HP এর হ্রাসকৃত অংশ অল্প সময়ের জন্য এই রঙে দেখাবে",
  T_43_XXJ_WS_MAINCOLOR: "মূল কালার",
  T_43_XXJ_WS_MAINCOLOR_D: "HP, লেভেল, এবং আউটলাইনের জন্য কালার",
  T_43_XXJ_WS_MINISENTRY: "টারেট",
  T_43_XXJ_WS_MINISENTRYATTACKTARGETTYPE_D: "কোনো একটি টারেট আক্রমণ করতে পারে ধরণের টার্গেটের জন্য enum",
  T_43_XXJ_WS_MISSILEEXPLODE: "মিসাইল এক্সপ্লোড",
  T_43_XXJ_WS_MUSTKNOCKDOWN: "আবশ্যক নকডাউন",
  T_43_XXJ_WS_MUSTKNOCKDOWN_D: "জোরপূর্বক নকডাউন",
  T_43_XXJ_WS_OFFSET: "অফসেট",
  T_43_XXJ_WS_OFFSET_D: "অনুসরণ করা টার্গেটের তুলনায় অফসেট",
  T_43_XXJ_WS_OILDRUMEXPLODE: "ওয়েল ড্রাম এক্সপ্লোড",
  T_43_XXJ_WS_ONCONTROLLERCOLLIDERHIT_D: "শুধুমাত্র যখন কন্ট্রোলার মুভমেন্ট শুরু করে তখনই ট্রিগার হয়",
  T_43_XXJ_WS_PLAYER_D: "ইন-গেম প্লেয়ার এনটিটি। প্রতিটি প্লেয়ারের একটি আছে।",
  T_43_XXJ_WS_PLAYERHEADHUD: "প্লেয়ার হেড HUD",
  T_43_XXJ_WS_PLAYERHEADHUD_D: "প্লেয়ারের মাথার উপরে প্রদর্শিত তথ্য",
  T_43_XXJ_WS_PLAYERNAME: "প্লেয়ারের নাম",
  T_43_XXJ_WS_PLAYERNAME_D: "বর্তমান হেলথ বার মালিকের নাম প্রদর্শন করে৷",
  T_43_XXJ_WS_PLAYERORVEHICLE: "প্লেয়ার নাকি ভেহিক্যাল",
  T_43_XXJ_WS_PLAYERORVEHICLE_D: "প্লেয়ার/ভেহিক্যাল এনটিটি টাইপের উপনাম",
  T_43_XXJ_WS_SCALE: "স্কেল",
  T_43_XXJ_WS_SCALE_D: "সামগ্রিক HUD স্কেলের সাইজ নির্ধারণ করে, পাশাপাশি ফন্ট ম্যাচ করার জন্য স্কেল করে।",
  T_43_XXJ_WS_SHOWDAMAGENUMBER: "ড্যামেজ নাম্বার প্রদর্শন",
  T_43_XXJ_WS_SHOWDAMAGENUMBER_D: "ডিফল্টভাবেই True । এটা ড্যামেজ নাম্বার ডিসপ্লে করে।",
  T_43_XXJ_WS_SKIPKNOCKDOWN: "নকডাউন স্কিপ করুন",
  T_43_XXJ_WS_SKIPKNOCKDOWN_D: "নকডাউন অবস্থা এড়িয়ে যান এবং অবিলম্বে এলিমিনেটেড হয়ে যান",
  T_43_XXJ_WS_SKIPSTAGGERANIMATION: "স্কিপ স্ট্যাগার অ্যানিমেশন কিনা",
  T_43_XXJ_WS_TEAM_D: "(অবমূল্যায়িত। অনুগ্রহপূর্বক টিম ID ব্যবহার করুন।)",
  T_43_XXJ_WS_TERRAIN: "ভূখন্ড",
  T_43_XXJ_WS_TERRAIN_D: "একটি ভূখণ্ডের উপাদান, যার বৈশিষ্ট্যগুলি পরিবর্তন করা যাবে না৷ শুধুমাত্র ফাংশন টেস্ট করতে ব্যবহৃত হয়।",
  T_43_XXJ_WS_TOTALHP: "সর্বমোট HP",
  T_43_XXJ_WS_TOTALHP_D: "সর্বমোট HP ভ্যাল্যু",
  T_43_XXJ_WS_TWEENENTITY: "টুইন এনটিটি",
  T_43_XXJ_WS_VEHICLEEXPLODE: "ভেহিক্যাল এক্সপ্লোড",
  T_43_XXJ_WS_WIDTH: "প্রস্থ",
  T_43_XXJ_WS_WIDTH_D: "প্রদর্শিত হেলথ বারের প্রস্থ",
  T_43_XXJ_WS_ZOMBIE: "জোম্বি",
  T_43_XYL_WS_DROIDFIST: "ফিস্ট (ড্রয়েড অ্যাপোকেলিপ্স)",
  T_43_XYL_WS_DROIDFLAME: "ফ্লেমথ্রোয়ার (ড্রয়েড অ্যাপোকেলিপ্স)",
  T_43_XYL_WS_JAPANESE: "জাপানিজ-স্টাইল",
  T_43_YU_WS_ADDGAMEEVENTLOGMAP_D: "ম্যাচ ইভেন্ট লগ কাস্টমাইজ করুন। ইউজার এক্সপেরিয়েন্স বিশ্লেষণের জন্য ব্যবহৃত হয়।",
  T_43_YU_WS_AIRDROPSTATE: "এয়ারড্রপ স্টেট",
  T_43_YU_WS_AIRDROPSTATE_D: "এয়ারড্রপ অবস্থা (1: প্রস্তুত, 2: ড্রপিং, 3: ল্যান্ডেড)",
  T_43_YU_WS_ANIMATIONCLIPID: "অ্যানিমেশন ক্লিপ ID",
  T_43_YU_WS_ANIMATIONCLIPID_D: "কাস্টমাইজ অ্যানিমেশন ক্লিপ ID",
  T_43_YU_WS_ASKBUYTARGET: "চান কিনুন টার্গেট করুন",
  T_43_YU_WS_ASKBUYTARGET_D: "টার্গেট নির্দিষ্ট করে এবং পার্চেজ রিকুয়েস্ট পাঠায়",
  T_43_YU_WS_ASKEDLIST: "চাহিদাকৃত লিস্ট",
  T_43_YU_WS_ASKEDLIST_D: "রিকুয়েস্টকৃত আইটেমগুলো লিস্ট",
  T_43_YU_WS_BACKGROUNDCOLOR1: "ব্যাকগ্রাউন্ড কালার 1",
  T_43_YU_WS_BACKGROUNDCOLOR1_D: "উপরের ব্যাকগ্রাউন্ডের কালার",
  T_43_YU_WS_BACKGROUNDCOLOR2: "ব্যাকগ্রাউন্ড কালার 2",
  T_43_YU_WS_BACKGROUNDCOLOR2_D: "একদম নীচে থাকা ব্যাকগ্রাউন্ড কালার",
  T_43_YU_WS_BATCHCOMBINERENDER: "ব্যাচ কম্বাইন রেন্ডার",
  T_43_YU_WS_BINDMONEYENTITYLIST: "মানি এনটিটি লিস্ট বাইন্ড করুন",
  T_43_YU_WS_BINDMONEYENTITYLIST_D: "বাউন্ড কারেন্সি এনটিটির লিস্ট",
  T_43_YU_WS_BINDWALLETENTITYID: "ওয়ালেট এনটিটি ID বাইন্ড করুন",
  T_43_YU_WS_BINDWALLETENTITYID_D: "বাউন্ড ওয়ালেট এনটিটির ID",
  T_43_YU_WS_CENTEROFFSET: "সেন্টার অফসেট",
  T_43_YU_WS_CENTEROFFSET_D: "ক্যাপসুল কোলাইডারের জন্য অফসেট ভ্যাল্যু",
  T_43_YU_WS_COLLECTIONID: "কালেকশন ID",
  T_43_YU_WS_COLLECTIONID_D: "অ্যাসেট ইনফরমেশন কালেকশনে ব্যবহৃত কালেকশন ID",
  T_43_YU_WS_CREATEAIRDROPENTITY_D: "একটি এয়ারড্রপ তৈরি করুন",
  T_43_YU_WS_CREATEUGCDAMAGENUM_D: "একটি ড্যামেজ নাম্বার ক্রিয়েট করুন",
  T_43_YU_WS_CROSSPLATFORM_D: "সিলেক্টেড অবস্থায়, সার্ভারে কল করা হলে ক্লায়েন্টকে সেন্ড করুন এবং এর বিপরীত।",
  T_43_YU_WS_CSROUNDRESULTHUD: "CS রাউন্ড রেজাল্ট HUD",
  T_43_YU_WS_CSROUNDRESULTHUD_D: "প্রতি রাউন্ডের শেষে ডিসপ্লে করা রেজাল্টসমূহ",
  T_43_YU_WS_CURRENTEMOTECLIP: "বর্তমান ইমোট ক্লিপ",
  T_43_YU_WS_CURRENTEMOTECLIP_D: "বর্তমান ইমোট ক্লিপের ID",
  T_43_YU_WS_DAMAGE_D: "আউট-অফ-জোন ড্যামেজ",
  T_43_YU_WS_DICTIONARY: "ডিকশনারি",
  T_43_YU_WS_DIRECTIONRULERHUD: "ডিরেকশন রুলার HUD",
  T_43_YU_WS_DIRECTIONRULERHUD_D: "একদম উপরে থাকা কম্পাস",
  T_43_YU_WS_DOTWEEN_D: "টুইন অ্যানিমেশন করতে হবে কিনা",
  T_43_YU_WS_DROPITEMS_D: "এয়ারড্রপে থাকা আইটেমসমূহ",
  T_43_YU_WS_DURATION: "স্থায়িত্ব",
  T_43_YU_WS_ENERGY: "এনার্জি",
  T_43_YU_WS_ENERGY_D: "EP মোডিফিকেশন ভ্যাল্যু",
  T_43_YU_WS_EPHYSXPOSE_CREEPING: "প্রবণ",
  T_43_YU_WS_EPHYSXPOSE_CROUCHING: "ক্রাউচ",
  T_43_YU_WS_EPHYSXPOSE_DASHING: "স্প্রিন্টিং",
  T_43_YU_WS_EPHYSXPOSE_STANDING: "স্ট্যান্ড",
  T_43_YU_WS_EVENTID: "ইভেন্ট ID",
  T_43_YU_WS_EVENTID_D: "একটি ইভেন্ট রিপ্রেজেন্ট করে",
  T_43_YU_WS_FACTION: "ফ্যাকশন",
  T_43_YU_WS_FACTION_D: "ফ্যাকশন এনটিটি",
  T_43_YU_WS_FACTION_D1: "ক্রয়ের ক্ষেত্রে সাহায্যের জন্য ফ্যাকশনে আহ্বান করুন",
  T_43_YU_WS_FINALRADIUS_D: "সেফ জোনের ফাইনাল রেডিয়াস",
  T_43_YU_WS_FIRSTAIDKIT: "মেডকিট",
  T_43_YU_WS_FIRSTAIDKIT_D: "মেড কিট",
  T_43_YU_WS_FIRSTPERSONMODEL: "ফার্স্ট পারসন মডেল",
  T_43_YU_WS_FIRSTPERSONMODEL_D: "ফার্স্ট-পারসন ক্যামেরা",
  T_43_YU_WS_FONTCOLOR_D: "ফন্ট কালার",
  T_43_YU_WS_FONTSIZE_D: "ফন্ট সাইজ",
  T_43_YU_WS_FORBIDEN: "নিষিদ্ধ",
  T_43_YU_WS_FORBIDEN_D: "পার্চেজ রিকুয়েস্টের জন্য HUD ডিজেবক করুন",
  T_43_YU_WS_FREEZINGTIME: "ফ্রিজিং টাইম",
  T_43_YU_WS_FREEZINGTIME_D: "যে সময়কালের জন্য হিট টার্গেট হিমায়িত থাকে",
  T_43_YU_WS_GRAVITY: "গ্র্যাভিটি",
  T_43_YU_WS_GRAVITY_D: "মহাকর্ষীয় ত্বরণ। শুধুমাত্র প্লেয়ার কন্ট্রোলারকে প্রভাবিত করে।",
  T_43_YU_WS_HANDCATAPULT: "লঞ্চ প্যাড",
  T_43_YU_WS_HANDCATAPULT_D: "লঞ্চ প্যাড",
  T_43_YU_WS_HEALTH: "হেলথ",
  T_43_YU_WS_HEALTH_D: "আর্মর ডিউরাবিলিটির জন্য রিকোভারি ভ্যাল্যু",
  T_43_YU_WS_HEIGHT: "উচ্চতা",
  T_43_YU_WS_HELPEDPLAYER_D: "যে প্লেয়ারকে হেল্প করা হয়েছে",
  T_43_YU_WS_HELPPLAYER_D: "এই ক্রয়ের ক্ষেত্রে সাহায্যকারী প্লেয়ার",
  T_43_YU_WS_HORIZONTALMAXANGLE: "হরাইজন্টাল ম্যাক্স. অ্যাংগেল",
  T_43_YU_WS_HORIZONTALMINANGLE: "হরাইজন্টাল মিনি অ্যাংগেল",
  T_43_YU_WS_HUDTOGGLE: "HUD টোগল",
  T_43_YU_WS_HUDTOGGLE_D: "HudToggle এনটিটি, যেটিকে প্লেয়ারেরা HUD এডিটরে এডিট করতে পারে৷",
  T_43_YU_WS_INHALER: "ইনহেলার",
  T_43_YU_WS_INHALER_D: "ইনহেলার",
  T_43_YU_WS_INITRADIUS_D: "সেফ জোনের প্রারম্ভিক ব্যাসার্ধ",
  T_43_YU_WS_INT64: "Int64",
  T_43_YU_WS_INT64_D: "একটি 64-বিট স্বাক্ষরিত পূর্ণসংখ্যা",
  T_43_YU_WS_ISAPPLYSHADOW: "শ্যাডো এপ্লাই করে কিনা",
  T_43_YU_WS_ISBOTTOMCOLLIDING: "বটম কোলাইডিং কিনা",
  T_43_YU_WS_ISCURRENTEMOTELOOP: "বর্তমান ইমোট লুপ",
  T_43_YU_WS_ISCURRENTEMOTELOOP_D: "বর্তমান ইমোট অ্যানিমেশন লুপে সেট করবেন কিনা",
  T_43_YU_WS_ISSIDECOLLIDING: "সাইড কোলাইডিং করছে কিনা",
  T_43_YU_WS_ISSLIDING: "স্লাইডিং কিনা",
  T_43_YU_WS_ISTOPCOLLIDING: "টপ কোলাইডিং কিনা",
  T_43_YU_WS_ITEM331: "ফিউচারিস্টিক ডিভাইস A",
  T_43_YU_WS_ITEM332: "গ্লোয়িং রক A",
  T_43_YU_WS_ITEM333: "ফিউচারিস্টিক স্ক্রিন A",
  T_43_YU_WS_ITEM334: "ফিউচারিস্টিক কন্টেনার A",
  T_43_YU_WS_ITEM335: "ফিউচারিস্টিক কন্টেনার A",
  T_43_YU_WS_ITEM336: "স্টোন সোফা A",
  T_43_YU_WS_ITEM337: "ফিউচারিস্টিক সুইচ A",
  T_43_YU_WS_ITEM338: "ফিউচারিস্টিক পাইপ A",
  T_43_YU_WS_ITEM339: "মেটাল প্লাটফর্ম A",
  T_43_YU_WS_ITEM340: "ফিউচারিস্টিক টেবিল A",
  T_43_YU_WS_ITEM341: "ফিউচারিস্টিক টেবিল B",
  T_43_YU_WS_ITEM342: "ফিউচারিস্টিক টেবিল C",
  T_43_YU_WS_ITEM343: "ফিউচারিস্টিক কম্পিউটার A",
  T_43_YU_WS_ITEM344: "স্টোন A",
  T_43_YU_WS_ITEM345: "স্টোন B",
  T_43_YU_WS_ITEM346: "স্টোন C",
  T_43_YU_WS_ITEM347: "স্টোন D",
  T_43_YU_WS_ITEM348: "স্টোন E",
  T_43_YU_WS_ITEM349: "স্টোন F",
  T_43_YU_WS_ITEM350: "স্টোন G",
  T_43_YU_WS_ITEM351: "জাপানিজ-স্টাইল পর্দা A",
  T_43_YU_WS_ITEM352: "জাপানিজ-স্টাইল পর্দা B",
  T_43_YU_WS_ITEM353: "জাপানিজ-স্টাইল কার্টেন পর্দা C",
  T_43_YU_WS_ITEM354: "জাপানিজ-স্টাইল সিঁড়ি A",
  T_43_YU_WS_ITEM355: "জাপানিজ-স্টাইল বেড়া A",
  T_43_YU_WS_ITEM356: "জাপানিজ-স্টাইল বেড়া B",
  T_43_YU_WS_ITEM357: "জাপানিজ-স্টাইল বেড়া C",
  T_43_YU_WS_ITEM358: "জাপানিজ-স্টাইল প্লাটফর্ম A",
  T_43_YU_WS_ITEM359: "জাপানিজ-স্টাইল ওয়াল B",
  T_43_YU_WS_ITEM360: "জাপানিজ-স্টাইল গেইট B",
  T_43_YU_WS_ITEM361: "ফিউচারিস্টিক ওয়াল D",
  T_43_YU_WS_ITEM362: "ফিউচারিস্টিক ওয়াল B",
  T_43_YU_WS_ITEM363: "ফিউচারিস্টিক অ্যাংগেলড বেইজবোর্ড",
  T_43_YU_WS_LEFTCOLOR: "বামদিকের কালার",
  T_43_YU_WS_LEFTCOLOR_D: "বামদিকের কালার",
  T_43_YU_WS_LEFTPLAYERARRAY: "বামদিকের প্লেয়ার অ্যারে",
  T_43_YU_WS_LEFTPLAYERARRAY_D: "বামদিকের প্লেয়ার অ্যারে",
  T_43_YU_WS_LEFTSCORE: "বামদিকের স্কোর",
  T_43_YU_WS_LEFTSCORE_D: "বামদিকের স্কোর",
  T_43_YU_WS_LEFTSCOREAFTER: "বামপক্ষের পরবর্তী স্কোর",
  T_43_YU_WS_LEFTSCOREAFTER_D: "বাম পাশের ফাইনাল স্কোর। স্কোর ট্রানজিশন অ্যানিমেশনে ব্যবহৃত হয়।",
  T_43_YU_WS_LEVELOBJECTID: "লেভেল অবজেক্ট ID",
  T_43_YU_WS_LEVELOBJECTID_D: "অবজেক্ট টাইপ বর্ণনা করে। লোডিং  করার আগে SceneEditPrefab কনফিগারেশন টেবিলের মাধ্যমে পার্সিং করা প্রয়োজন।",
  T_43_YU_WS_LOCALPOSITION_D: "লোকাল কো-অর্ডিনেট সিস্টেমে থাকা কোঅর্ডিনেটস",
  T_43_YU_WS_LOCALPOSITION_D1: "রিলেটিভ পজিশন",
  T_43_YU_WS_LOCALPOSITION_D2: "নীচের ডানদিকের অ্যাঙ্করের সাথে সম্পর্কিত পজিশন",
  T_43_YU_WS_LOCALPOSITION_D3: "অ্যাংকরের সাথে রিলেটিভ পজিশন",
  T_43_YU_WS_LOCALROTATION_D: "লোকাল কোঅর্ডিনেট সিস্টেমে থাকা রোটেশন অ্যাংগেল(X: yaw, Y: পিচ, এবং Z: রোল)",
  T_43_YU_WS_LOCALROTATIONQ_D: "লোকাল কোঅর্ডিনেট সিস্টেমে থাকা চতুর্ভুজ",
  T_43_YU_WS_LOCALSCALE_D: "ওয়ার্ল্ড কোঅর্ডিনেট সিস্টেমে থাকা স্কেল সাইজ",
  T_43_YU_WS_MASS: "ম্যাস",
  T_43_YU_WS_MATERIALS: "উপাদানসমূহ",
  T_43_YU_WS_MATERIALS_D: "রেন্ডারিং এর জন্য ব্যবহৃত উপাদানগুলোর লিস্ট",
  T_43_YU_WS_MAXSPEED: "ম্যাক্স. স্পিড",
  T_43_YU_WS_MAXSPEED_D: "সর্বাধিক গতিতে পৌঁছানোর পরে আর কোনও হর্সপাওয়ার উৎপন্ন হবে না, তবে গাড়ির স্পিড লিমিট ছাড়িয়ে যেতে পারে (যেমন পাহাড়ের নিচে যাওয়ার সময় অ্যাক্সিলারেশনের মাধ্যমে)।",
  T_43_YU_WS_MESHID: "মেশ ID",
  T_43_YU_WS_MESHID_D: "ম্যাশ টাইপ বর্ণনা করে",
  T_43_YU_WS_MESHID1: "মেশ ID",
  T_43_YU_WS_MESHID1_D: "রেন্ডারিংয়ের জন্য ব্যবহার করা জাল",
  T_43_YU_WS_MINMOVEDISTANCE: "মিনি. মুভ ডিসট্যান্স",
  T_43_YU_WS_MINMOVEDISTANCE_D: "এই মানের চেয়ে কম দূরত্ব সহ মুভমেন্ট চালানো হবে না। বিশেষ প্রয়োজনীয়তা না থাকলে এটি 0 এ সেট করার পরামর্শ দেওয়া হয়।",
  T_43_YU_WS_MODULE_AI: "AI",
  T_43_YU_WS_MODULE_AIRDROP: "এয়ারড্রপ",
  T_43_YU_WS_MODULE_ANIMATION: "অ্যানিমেশন",
  T_43_YU_WS_MODULE_AVATAR: "অ্যাভাটার",
  T_43_YU_WS_MODULE_BASEATTRIBUTES: "বেজ অ্যাট্রিবিউটস",
  T_43_YU_WS_MODULE_BEHAVIOURTREE: "বিহেভিয়ার ট্রি",
  T_43_YU_WS_MODULE_BUFF: "বাফ",
  T_43_YU_WS_MODULE_CAMERA: "ক্যামেরা",
  T_43_YU_WS_MODULE_CHATCHANNEL: "চ্যাট চ্যানেল",
  T_43_YU_WS_MODULE_CHECKPOINT: "চেকপয়েন্ট",
  T_43_YU_WS_MODULE_COLLECTION: "কালেকশন",
  T_43_YU_WS_MODULE_COMBAT: "কমব্যাট",
  T_43_YU_WS_MODULE_COMPONENT: "কম্পোনেন্ট",
  T_43_YU_WS_MODULE_CONVERT: "কনভার্ট",
  T_43_YU_WS_MODULE_CUSTOMIZEROOMPARAMETERS: "রুম প্যারামিটার কাস্টমাইজ করুন",
  T_43_YU_WS_MODULE_DATABASE: "ডেটা স্টোরেজ",
  T_43_YU_WS_MODULE_DYEING: "ডায়িং",
  T_43_YU_WS_MODULE_DYNAMICNAVMESH: "ডায়নামিক NavMesh",
  T_43_YU_WS_MODULE_ECONOMY: "ইকোনোমি",
  T_43_YU_WS_MODULE_FF_PLATFORM: "FF প্লাটফর্ম",
  T_43_YU_WS_MODULE_FOOTBALL: "ফুটবল",
  T_43_YU_WS_MODULE_FRAMERATEMODE: "ফ্রেম রেট মোড",
  T_43_YU_WS_MODULE_GAMERESULT: "গেম রেজাল্টস",
  T_43_YU_WS_MODULE_GLOBAL: "গ্লোবাল",
  T_43_YU_WS_MODULE_GLOBALSCRIPTS: "গ্লোবাল স্ক্রিপ্টস",
  T_43_YU_WS_MODULE_HANGUPANDCHEAT: "AFK & চিটিং",
  T_43_YU_WS_MODULE_HUD: "HUD",
  T_43_YU_WS_MODULE_INPUTSYSTEM: "ইনপুট সিস্টেম",
  T_43_YU_WS_MODULE_ITEMS: "আইটেমসমূহ",
  T_43_YU_WS_MODULE_LEVELOBJECT: "লেভেল অবজেক্ট",
  T_43_YU_WS_MODULE_LIST: "লিস্ট",
  T_43_YU_WS_MODULE_MAP: "ম্যাপ",
  T_43_YU_WS_MODULE_MATCHING: "ম্যাচ",
  T_43_YU_WS_MODULE_MATH: "ম্যাথ",
  T_43_YU_WS_MODULE_MECHANISM: "মেকানিজম প্যারামিটার্স",
  T_43_YU_WS_MODULE_MINIMAP: "মিনিম্যাপ",
  T_43_YU_WS_MODULE_MORPH: "মর্ফ",
  T_43_YU_WS_MODULE_OTHER: "অন্যান্য",
  T_43_YU_WS_MODULE_PET: "পেট",
  T_43_YU_WS_MODULE_PHYSICS: "ফিজিক্স",
  T_43_YU_WS_MODULE_PLAYABLE: "খেলার যোগ্য",
  T_43_YU_WS_MODULE_PLAYER: "প্লেয়ার",
  T_43_YU_WS_MODULE_PLAYERSCRIPTS: "প্লেয়ার স্ক্রিপ্টস",
  T_43_YU_WS_MODULE_PRESETCHARACTER: "প্রিসেট ক্যারেক্টার",
  T_43_YU_WS_MODULE_PROFILE: "প্রোফাইল",
  T_43_YU_WS_MODULE_PROPERTYFORMULA: "প্রোপার্টি ফর্মুলা",
  T_43_YU_WS_MODULE_SAFEZONE: "সেফ জোন",
  T_43_YU_WS_MODULE_SCENE: "দৃশ্য",
  T_43_YU_WS_MODULE_SKILL: "স্কিল",
  T_43_YU_WS_MODULE_STATICSCRIPTS: "স্ট্যাটিক স্ক্রিপ্টস",
  T_43_YU_WS_MODULE_STATISTICALREPORT: "রিপোর্ট",
  T_43_YU_WS_MODULE_STDLIBRARY: "STD লাইব্রেরি",
  T_43_YU_WS_MODULE_STRINGS: "স্ট্রিংস",
  T_43_YU_WS_MODULE_TEAM: "টিম",
  T_43_YU_WS_MODULE_WORKFLOW: "ওয়ার্কফ্লো",
  T_43_YU_WS_MONEYICON: "মানি আইকন",
  T_43_YU_WS_MONEYICON_D: "কারেন্সি আইকন",
  T_43_YU_WS_MONEYICONCOLOR: "মানি আইকন কালার",
  T_43_YU_WS_MONEYICONCOLOR_D: "কারেন্সি আইকন কালার",
  T_43_YU_WS_MOVESAFEZONE_D: "মসৃণভাবে সেফ জোনটিকে তার শুরুর অবস্থান থেকে শেষ অবস্থানে নিয়ে যায়। জোনের বাইরে থাকা প্লেয়ারদের একটি নির্দিষ্ট পরিমাণ ড্যামেজ হবে।",
  T_43_YU_WS_NEWVECTOR2: "নিউ ভেক্টর2",
  T_43_YU_WS_NEWVECTOR2_D: "পেয়ে যান একটি নতুন 2D ভেক্টর",
  T_43_YU_WS_OFFSET_D: "টার্গেট এনটিটির সাপেক্ষে ওয়ার্ল্ড পজিশন অফসেট",
  T_43_YU_WS_ONSHOPREQUESTFILLED_D: "প্লেয়ারের পার্চেজ রিকুয়েস্ট পূরণ করা হয়",
  T_43_YU_WS_ONSHOPREQUESTPURCHASE_D: "কোনো প্লেয়ার যখন স্টোরে পার্চেজের মাধ্যমে হেল্প রিকুয়েস্ট করে",
  T_43_YU_WS_ONTOGGLECHANGE_D: "টগল কম্পোনেন্ট স্টেট পরিবর্তন হলে ট্রিগার করুন",
  T_43_YU_WS_OPENSTATE: "ওপেন স্টেট",
  T_43_YU_WS_OPENSTATE_D: "যখন সত্য তে সেট করা হবে তখন ডিসপ্লে হবে, অন্যথায় হবে না",
  T_43_YU_WS_PACEMAKER: "হরাইজলাইন",
  T_43_YU_WS_PACEMAKER_D: "হরাইজলাইন",
  T_43_YU_WS_PARAMS_D: "প্যারামিটারের লিস্ট",
  T_43_YU_WS_PARENT_D: "সিরিয়ালাইজেশনের সময় রেকর্ড করা এনটিটি ID",
  T_43_YU_WS_PHYSICALCCT: "ফিজিক্যাল CCT",
  T_43_YU_WS_PHYSICALCCT_D: "ফিজিক্যাল ইফেক্টগুলোর সাথে প্লেয়ার কন্ট্রোলার",
  T_43_YU_WS_PLAYER_D: "পার্চেজিং প্লেয়ার",
  T_43_YU_WS_PLAYERDATAID: "প্লেয়ার ডেটা ID",
  T_43_YU_WS_PLAYERDATAID_D: "ক্যারেক্টার অ্যাসেট ID কাস্টমাইজ করুন",
  T_43_YU_WS_PLAYERPHYSXPOSETYPE: "প্লেয়ার PhysX পোজ টাইপ",
  T_43_YU_WS_POSITION: "পজিশন",
  T_43_YU_WS_POSITION_D: "ওয়ার্ল্ড কোঅর্ডিনেট সিস্টেমে থাকা কো-অর্ডিনেটস",
  T_43_YU_WS_POSITION_D1: "ওয়ার্ল্ড কোঅর্ডিনেট সিস্টেমে থাকা কো-অর্ডিনেটস। শুধুমাত্র 3D মিউজিকের জন্য কার্যকর।",
  T_43_YU_WS_PRESSEDSPRITE: "প্রেসড স্প্রাইট",
  T_43_YU_WS_PRESSEDSPRITE_D: "প্রেসড স্প্রাইট",
  T_43_YU_WS_PRESSEDSPRITETYPE: "প্রেসড স্পিরিট টাইপ",
  T_43_YU_WS_PRESSEDSPRITETYPE_D: "প্রেসড স্প্রাইট টাইপ",
  T_43_YU_WS_PRETIME: "প্রিটাইম",
  T_43_YU_WS_RADIUS: "ব্যাসার্ধ",
  T_43_YU_WS_RANDOMRANGE_D: "একটি র‍্যানডম রেঞ্জের উপর ভিত্তি করে সেট পজিশন সংশোধন করুন",
  T_43_YU_WS_REQUESTPURCHASETYPE: "রিকুয়েস্ট পার্চেজ টাইপ",
  T_43_YU_WS_REQUESTPURCHASETYPE_D: "স্টোরে পার্চেজ রিকুয়েস্ট",
  T_43_YU_WS_REQUESTTYPE: "রিকুয়েস্ট টাইপ",
  T_43_YU_WS_REQUESTTYPE_D: "বর্তমান HUD প্লেয়ারের রিকুয়েস্টকৃত টার্গেটের ধরণ",
  T_43_YU_WS_RESPLAYERUUID: "প্রিসেট প্লেয়ার টাইপ",
  T_43_YU_WS_RESPLAYERUUID_D: "প্লেয়ার অ্যাসেট ID",
  T_43_YU_WS_RESUUID: "অ্যাসেট UUID",
  T_43_YU_WS_RESUUID_D: "যেসব ব্যাচ অ্যাসেট রেন্ডার করা হবে সেগুলো সুনির্দিষ্ট করে",
  T_43_YU_WS_RIGHTCOLOR: "ডানদিকের কালার",
  T_43_YU_WS_RIGHTCOLOR_D: "ডানদিকের কালার",
  T_43_YU_WS_RIGHTPLAYERARRAY: "ডানদিকের প্লেয়ার অ্যারে",
  T_43_YU_WS_RIGHTPLAYERARRAY_D: "ডানদিকের প্লেয়ারের অ্যারে",
  T_43_YU_WS_RIGHTSCORE: "ডানদিকের স্কোর",
  T_43_YU_WS_RIGHTSCORE_D: "ডান পক্ষের স্কোর",
  T_43_YU_WS_RIGHTSCOREAFTER: "পরে থাকা ডানপাশের স্কোর",
  T_43_YU_WS_RIGHTSCOREAFTER_D: "ডান দিকের চূড়ান্ত স্কোর। স্কোর ট্রানজিশন অ্যানিমেশনে ব্যবহৃত হয়।",
  T_43_YU_WS_ROTATIONQ_D: "ওয়ার্ল্ড কো-অর্ডিনেট সিস্টেমে থাকা চতুর্ভুজ",
  T_43_YU_WS_ROUNDINFOHUD: "রাউন্ড ইনফো HUD",
  T_43_YU_WS_ROUNDINFOHUD_D: "একটি রাউন্ডের শুরুতে প্রদর্শিত তথ্য",
  T_43_YU_WS_SELECTEDCOLOR: "সিলেক্টেড কালার",
  T_43_YU_WS_SELECTEDCOLOR_D: "সিলেক্টেড স্প্রাইট কালার",
  T_43_YU_WS_SELECTEDSPRITE: "সিলেক্টেড স্প্রাইট",
  T_43_YU_WS_SELECTEDSPRITE_D: "সিলেক্টেড স্প্রাইট",
  T_43_YU_WS_SELECTEDTYPE: "সিলেক্টেড টাইপ",
  T_43_YU_WS_SELECTEDTYPE_D: "সিলেক্টেড স্প্রাইট টাইপ",
  T_43_YU_WS_SHADOWCOLOR: "শ্যাডো কালার",
  T_43_YU_WS_SHADOWOFFSET: "শ্যাডো অফসেট",
  T_43_YU_WS_SHOWTAG: "ট্যাগ শো করুন",
  T_43_YU_WS_SHOWTAG_D: "টিম/ফ্যাকশনের মার্কিং শো করুন",
  T_43_YU_WS_SHRINKDURATION_D: "সেফ জোন সংকোচনের স্থায়িত্ব",
  T_43_YU_WS_SIMPLERENDER_D: "বিল্ট-ইন মডেলের সাথে রেন্ডারিংয়ের জন্য ব্যবহৃত ব্রিজিং রেন্ডারিং উপাদান",
  T_43_YU_WS_SKINWIDTH: "স্কিন উইডথ",
  T_43_YU_WS_SKINWIDTH_D: "ক্যাপসুলের মধ্যে পেনেট্রেশনের গভীরতা, যাতে ক্যারেক্টারটি আটকে না যায় বা জটলা না যায়",
  T_43_YU_WS_SLOPELIMIT: "স্লোপ লিমিট",
  T_43_YU_WS_SLOPELIMIT_D: "এই কোণ অতিক্রম করে ঢালের উপর স্থাপন করা অবজেক্টগুলো নীচে স্লাইড করবে",
  T_43_YU_WS_SPEED: "স্পিড",
  T_43_YU_WS_STARTDROPTIME_D: "এয়ারড্রপ অ্যারাইভাল টাইম মিলিসেকেন্ডে",
  T_43_YU_WS_STARTPOS_D: "সেফ জোনের শুরুর অবস্থান",
  T_43_YU_WS_STATICICONCOLORS: "স্ট্যাটিক আইকন কালার্স",
  T_43_YU_WS_STATICICONCOLORS_D: "রুলার এ প্রদর্শিত আইকন কালারসমূহ",
  T_43_YU_WS_STATICICONS: "স্ট্যাটিক আইকনসমূহ",
  T_43_YU_WS_STATICICONS_D: "রুলার্স এ প্রদর্শিত আইকনসমূহ",
  T_43_YU_WS_STEPOFFSET: "স্টেপ অফসেট",
  T_43_YU_WS_STEPOFFSET_D: "শুধুমাত্র এই উচ্চতা অতিক্রম করা বাধাগুলির একটি ব্লকিং ইফেক্ট থাকবে",
  T_43_YU_WS_SUBTITLE: "সাবটাইটেল",
  T_43_YU_WS_SUBTITLE_D: "সাবটাইটেল",
  T_43_YU_WS_TARGET: "টার্গেট",
  T_43_YU_WS_TARGET_D: "ডিসপ্লেকৃত ড্যামেজ নাম্বারের জন্য টার্গেট এনটিটি",
  T_43_YU_WS_TARGETICONCOLORS: "টার্গেট আইকন কালার্স",
  T_43_YU_WS_TARGETICONCOLORS_D: "চিহ্নিত টার্গেট দ্বারা প্রদর্শিত আইকনের রং",
  T_43_YU_WS_TARGETICONS: "টার্গেট আইকনসমূহ",
  T_43_YU_WS_TARGETICONS_D: "চিহ্নিত টার্গেট দ্বারা প্রদর্শিত আইকন",
  T_43_YU_WS_TARGETPOS_D: "সেফ জোনের টার্গেট এবং সমাপ্তি পজিশন",
  T_43_YU_WS_TEAM: "টিম",
  T_43_YU_WS_TEAM_D: "গেমে থাকা টিম এনটিটি। প্রতিটি টিমেরই একটি এনটিটি রয়েছে।",
  T_43_YU_WS_TEAM_D1: "ক্রয়ের ক্ষেত্রে সাহায্যের জন্য টিমে আহ্বান করুন",
  T_43_YU_WS_TIMEOFSTAY_D: "ডিসপ্লে ডিউরেশন মিলিসেকেন্ডে",
  T_43_YU_WS_TITLE: "টাইটেল",
  T_43_YU_WS_TITLE_D: "মেইন টাইটেল",
  T_43_YU_WS_TRANSFORM_D: "রোটেশন, স্কেলিং, এবং প্যারেন্ট-চাইল্ড রেকর্ড",
  T_43_YU_WS_UNSELECTEDCOLOR: "আনসিলেক্টেড কালার",
  T_43_YU_WS_UNSELECTEDCOLOR_D: "আনসিলেক্টেড স্প্রাইট কালার",
  T_43_YU_WS_UNSELECTEDSPRITE: "আনসিলেক্টেড স্প্রাইট",
  T_43_YU_WS_UNSELECTEDSPRITE_D: "আনসিলেক্টেড স্প্রাইট",
  T_43_YU_WS_UNSELECTEDTYPE: "আনসিলেক্টেড টাইপ",
  T_43_YU_WS_UNSELECTEDTYPE_D: "আনসিলেক্টেড স্প্রাইট টাইপ",
  T_43_YU_WS_USEPHYSICALCCT: "ফিজিক্যাল CCT ব্যবহার করুন",
  T_43_YU_WS_VALUE_D: "ডিসপ্লেকৃত কনটেন্ট",
  T_43_YU_WS_VECTOR2ADD: "ভেক্টর2 যোগ করুন",
  T_43_YU_WS_VECTOR2GETX: "ভেক্টর2 পান X",
  T_43_YU_WS_VECTOR2GETY: "ভেক্টর2 পান Y",
  T_43_YU_WS_VECTOR2SCALE: "ভেক্টর2 স্কেল",
  T_43_YU_WS_VECTOR2SETX: "ভেক্টর2 সেট X",
  T_43_YU_WS_VECTOR2SETY: "ভেক্টর2 সেট Y",
  T_43_YU_WS_VECTOR2SUB: "ভেক্টর2 সাব",
  T_43_YU_WS_VELOCITY: "দ্রুতি",
  T_43_YU_WS_VERTICALMAXANGLE: "ভার্টিক্যাল ম্যাক্স অ্যাংগেল",
  T_43_YU_WS_VERTICALMINANGLE: "ভার্টিক্যাল মিনি. অ্যাংগেল",
  T_43_YU_WS_VISIBILITY_D: "ভিজিবিলিটি সেট করা যাবে কিনা নির্দেশ করে",
  T_43_YU_WS_VISIBLE_D: "দৃশ্যমানতা সেটিং। অদৃশ্যমান হিসেবে সেট করা হলে, ক্লায়েন্ট টার্গেট রেন্ডার করা বন্ধ করে দেয়।",
  T_43_YU_WS_X: "X",
  T_43_YU_WS_X_D: "X",
  T_43_YU_WS_Y: "Y",
  T_43_YU_WS_Y_D: "Y",
  T_43_ZY_WS_ITEM319: "ফিউচারিস্টিক ওয়াল A",
  T_43_ZY_WS_ITEM320: "ফিউচারিস্টিক ওয়াল C",
  T_43_ZY_WS_ITEM321: "ফিউচারিস্টিক উইন্ডো",
  T_43_ZY_WS_ITEM322: "ফিউচারিস্টিক দরজা",
  T_43_ZY_WS_ITEM323: "ফিউচারিস্টিক অ্যাংগেল্ড রুফ",
  T_43_ZY_WS_ITEM324: "ফিউচারিস্টিক সার্কুলার রুফ",
  T_43_ZY_WS_ITEM325: "ফিউচারিস্টিক বেজবোর্ড",
  T_43_ZY_WS_ITEM326: "ফিউচারিস্টিক সার্কুলার বেজবোর্ড",
  T_43_ZY_WS_ITEM327: "ফিউচারিস্টিক সিঁড়ি",
  T_43_ZY_WS_ITEM328: "ফিউচারিস্টিক ডেকোরেশন A",
  T_43_ZY_WS_ITEM329: "ফিউচারিস্টিক বিল্ডিং A",
  T_43_ZY_WS_ITEM330: "ফিউচারিস্টিক বিল্ডিং B",
  T_44_CJ_M_B_SPORT_TH: "জিম ইউনিফর্ম (বটম)",
  T_44_CJ_M_H_SPORT_TH: "জিম ইউনিফর্ম (হেড)",
  T_44_CJ_M_S_SPORT_TH: "জিম ইউনিফর্ম (জুতা)",
  T_44_CJ_M_T_SPORT_TH: "জিম ইউনিফর্ম (টপ)",
  T_44_CJ_W_AIRBURST: "M590",
  T_44_H_CHARACTER_DUALMAN_N: "কাইরোস",
  T_44_H_M24_ONIMUSHA_N: "M24 - অ্যাটাক-o'-দ্য-উইস্প",
  T_44_H_USP45_CARNIVORE_N: "USP - পয়জন টুথ",
  T_44_H_VEHICLESKIN_MOTOBIKE_COLLAGE_N: "মোটরবাইক - থান্ডারস্ট্রোকস",
  "T_44_HH_GOLD_AUG-I": "AUG-I",
  "T_44_HH_GOLD_AUG-II": "AUG-II",
  "T_44_HH_GOLD_AUG-III": "AUG-III",
  T_44_JH_WS_CLHALF1: "ন্যূনতম সংখ্যক প্লেয়ার নিয়ে জোরপূর্বক চালু",
  T_44_JH_WS_HALFWAYKEY1: "সম্পূর্ণ টিম নিয়ে স্টার্ট প্রায়োরিটাইজ করুন",
  T_44_PD_PVE_DRAGON_NAME: "মেচাড্রেক",
  T_44_QL_GRENADE_DRAGON: "ড্রাগন ফ্রিজ",
  T_44_QL_GRENADE_DRAGON_DES: "একটি আপগ্রেড করা ফ্ল্যাশ ফ্রিজ, যা প্রভাবে পরপর তিনবার বিস্ফোরিত হবে",
  T_44_QL_JUMPSHOESX: "ড্রাগন স্প্রিন্টার্স",
  T_44_QL_JUMPSHOESX_DES: "এক জোড়া স্পেশাল জাম্পিং জুতা, যা ডাবল জাম্পের সময় বাতাসে স্প্রিন্ট করার সুযোগ দেয়",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME: "সেইফ জোন ক্লোজ টাইম",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME_D: "যখন সেইফ জোন অদৃশ্য হয়ে যায় সে সময়। সেইফ জোন ক্লোজ টাইম যদি সেইফ জোন স্টার্ট টাইম থেকে কম হয়, তাহলে কোনও সেইফ জোন তৈরি হবে না।",
  T_44_SJ_WS_SAFEZONE_COLOR: "সেইফ জোন কালার",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME: "ড্যামেজ ইন্টার্ভাল",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME_D: "ড্যামেজ ইন্টার্ভাল",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE: "ড্যামেজ ভ্যাল্যু",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE_D: "এক মুহুর্তেই আউট-অফ-জোনে থাকা কোনো এক প্লেয়ারের উপর ডিলকৃত ড্যামেজ",
  T_44_SJ_WS_SAFEZONE_DESC: "প্রতিস্থাপনযোগ্য একটি আউট-অফ-জোন অবজেক্ট",
  T_44_SJ_WS_SAFEZONE_END_RADIUS: "আউট-অফ-জোন সমাপ্তি ব্যাসার্ধ",
  T_44_SJ_WS_SAFEZONE_END_RADIUS_D: "আউট-অফ-জোন এলাকার সমাপ্তি ব্যাসার্ধ",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS: "সেইফ জোন প্লেয়ার লিস্ট",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS_D: "সেইফ জোনে থাকা প্লেয়ারদের একটি লিস্ট পান",
  T_44_SJ_WS_SAFEZONE_NAME: "আউট-অফ-জোন এরিয়া",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME: "সংকোচনের স্থায়িত্ব (s)",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME_D: "জোন সংকোচনের জন্য যত সময় প্রয়োজন তার দৈর্ঘ্য",
  T_44_SJ_WS_SAFEZONE_START_RADIUS: "আউট-অফ-জোন প্রারম্ভিক ব্যাসার্ধ",
  T_44_SJ_WS_SAFEZONE_START_RADIUS_D: "আউট-অফ-জোন এলাকার প্রারম্ভিক ব্যাসার্ধ",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME: "সংকোচন টাইম শুরু",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME_D: "জোন সংকোচন শুরু হওয়ার সময়",
  T_44_SJ_WS_SAFEZONE_STARTTIME: "সেইফ জোন স্টার্ট টাইম",
  T_44_SJ_WS_SAFEZONE_STARTTIME_D: "প্রতিটি রাউন্ড ইন-ম্যাচের সময় যখন সেইফ জোন প্রদর্শিত হয়। ডিফল্ট হলো 0।",
  T_44_WT_W_FGG: "FGL-24",
  T_44_WT_W_REWORKHEAT_NAME_X: "প্লাজমা-X",
  T_44_XXJ_WS_ACTIVATEDALPHA: "আলফা অ্যাক্টিভেট হয়েছে",
  T_44_XXJ_WS_ACTIVATEDALPHA_D: "আলফা অ্যাক্টিভেটেড হয়েছে",
  T_44_XXJ_WS_ACTIVESKILLBTNHUD: "অ্যাক্টিভ স্কিল বাটন HUD",
  T_44_XXJ_WS_ADDCOMPONENT_D: "একটি এনিটিটির সাথে একটি কম্পোনেন্ট যোগ করুন। শুধুমাত্র কাস্টম কম্পোনেন্ট সাপোর্ট করে। (কোনো একটি কম্পোনেন্ট যদি ইতোমধ্যেই বিদ্যমান থাকে, তবে এটি আবার যোগ করা হবে না।)",
  T_44_XXJ_WS_ALLMEMBERS: "সকল মেম্বারগণ",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE: "প্লেসড আউটসাইড অনুমতি দিন",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE_D: "নির্ধারিত এলাকার বাইরে ট্রিগার করার অনুমতি দিন",
  T_44_XXJ_WS_ARROWIMAGE: "অ্যারো ইমেজ",
  T_44_XXJ_WS_ARROWIMAGE_D: "অ্যারো ইমেজ",
  T_44_XXJ_WS_ARROWOFFSET: "অ্যারো অফসেট",
  T_44_XXJ_WS_ARROWOFFSET_D: "অ্যারো অফসেট",
  T_44_XXJ_WS_ARROWSIZE: "অ্যারো সাইজ",
  T_44_XXJ_WS_ARROWSIZE_D: "অ্যারো সাইজ",
  T_44_XXJ_WS_AUTOPLAY_D: "ক্রিয়েশনের সময় অটোমেটিক্যালি প্লে করুন",
  T_44_XXJ_WS_BACKGROUNDIMAGE: "ব্যাকগ্রাউন্ড ইমেজ",
  T_44_XXJ_WS_BACKGROUNDIMAGE_D: "বেইজ ইমেজ",
  T_44_XXJ_WS_BACKGROUNDRADIUS: "ব্যাকগ্রাউন্ড ব্যাসার্ধ",
  T_44_XXJ_WS_BACKGROUNDRADIUS_D: "বেজ ব্যাসার্ধ",
  T_44_XXJ_WS_BAGSKINID: "ব্যাকপ্যাক স্কিন ID",
  T_44_XXJ_WS_BAGSKINID_D: "ব্যাকপ্যাক স্কিন ID",
  T_44_XXJ_WS_BONEPOSITION: "বোন পজিশন",
  T_44_XXJ_WS_BONEPOSITION_D: "বোন নোডের ওয়ার্ল্ড কো-অর্ডিনেটস",
  T_44_XXJ_WS_CCTMOVE: "CCT মুভ করুন",
  T_44_XXJ_WS_COLLIDER: "কলিডার",
  T_44_XXJ_WS_COLLIDERCOLLECTION: "কলিডার কালেকশন",
  T_44_XXJ_WS_COLLIDERCOLLECTION_D: "কলিশন শেইপকে বর্ণনা করার জন্য ব্যবহৃত কম্পোনেন্ট",
  T_44_XXJ_WS_COLOR: "কালার",
  T_44_XXJ_WS_CONTENT: "কনটেন্ট",
  T_44_XXJ_WS_CONTENT_D: "ওয়ালেট কনটেন্ট হলো অনেকগুলো মুদ্রার কালেকশন",
  T_44_XXJ_WS_CONTEXT_D: "যেই কনটেন্ট প্রিন্ট দিতে হবে",
  T_44_XXJ_WS_CROSSHAIRSHUD: "ক্রসহেয়ার্স HUD",
  T_44_XXJ_WS_CURVE_D: "কার্ভ",
  T_44_XXJ_WS_EFFECTCOLOR_D: "সার্ফেস টেক্সচারের কালার",
  T_44_XXJ_WS_ENABLE: "সচল করুন",
  T_44_XXJ_WS_ENTITY_D: "এনটিটি",
  T_44_XXJ_WS_GETBAGSKINID_D: "প্লেয়ার ব্যাকপ্যাক স্কিন কনফিগারেশন পান",
  T_44_XXJ_WS_GETFACTION_D: "ফ্যাকশন পান",
  T_44_XXJ_WS_GETLOADEDSCENE_D: "যেসকল লোডেড সিনগুলো এখনও আনইন্সটল করা হয়নি, সেগুলো পান",
  T_44_XXJ_WS_GETLOCALPLAYER_D: "লোকাল প্লেয়ারকে নিন",
  T_44_XXJ_WS_GROUPID: "গ্রুপ ID",
  T_44_XXJ_WS_GROUPID_D: "ইনটার্নাল লজিকের জন্য",
  T_44_XXJ_WS_HUDJOYSTICK: "HUD জয়স্টিক উইজেট",
  T_44_XXJ_WS_HUDJOYSTICK_D: "জয়স্টিক এনটিটি। প্লেয়ারেরা HUD এডিটরের মাধ্যমে HUD এডিট করতে পারে।",
  T_44_XXJ_WS_HUDTOUCHPAD: "HUD টাচপ্যাড উইজেট",
  T_44_XXJ_WS_HUDTOUCHPAD_D: "এমন একটি HUD টাচপ্যাড উইজেট যা প্লেয়ারেরা HUD এডিটরে এডিট করতে পারে৷",
  T_44_XXJ_WS_HUDWIDGETORCUSTOMHUD: "কাস্টম HUD অথবা HUD উইজেট",
  T_44_XXJ_WS_ICON: "আইকন",
  T_44_XXJ_WS_ICONISALWAYSSHOWN: "সবসময় মার্ক শো করান",
  T_44_XXJ_WS_ICONISALWAYSSHOWN_D: "কম্পাসে থাকা মার্কগুলো সবসময় প্রদর্শন করবে",
  T_44_XXJ_WS_INACTIVATEDALPHA: "আলফা আন-অ্যাক্টিভেটেড",
  T_44_XXJ_WS_INACTIVATEDALPHA_D: "আন-অ্যাক্টিভেটেড আলফা",
  T_44_XXJ_WS_INVOKE_ARGS_MISMATCH: "কল করার সময়, প্রকৃত প্যারামিটারের সংখ্যা আনুষ্ঠানিক প্যারামিটারগুলোর সাথে ম্যাচ করে না। প্রত্যাশিত সংখ্যাটি হলো {0}, প্রকৃত সংখ্যা হলো {1}৷",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE: "ডায়নামিক অবস্ট্যাকল কিনা",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE_D: "NavMesh এর জন্য একটি ডায়নামিক প্রতিবন্ধকতা কিনা",
  T_44_XXJ_WS_ISEND: "Is End",
  T_44_XXJ_WS_ISEND_D: "IsEnd",
  T_44_XXJ_WS_ISSERVERDRIVEN: "সার্ভার-ড্রিভেন কিনা",
  T_44_XXJ_WS_ISSERVERDRIVEN_D: "মিথ্যা হলে, কাস্টম অবজেক্ট API দ্বারা নিয়ন্ত্রিত করা যাবে না।",
  T_44_XXJ_WS_ISSUC_D: "এক্সিকিউশন রেজাল্ট ফেরত আনুন",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS: "জয়স্টিক ড্র্যাগ ব্যাসার্ধ",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS_D: "জয়স্টিক ড্র্যাগ ব্যাসার্ধ",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE: "জয়স্টিক ড্যামেজ",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE_D: "জয়স্টিক ইমেজ",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS: "জয়স্টিক ব্যসার্ধ",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS_D: "জয়স্টিক ব্যসার্ধ",
  T_44_XXJ_WS_LISTT_PLAYERSKILLID: "ক্যারেক্টার স্কিল ID লিস্ট",
  T_44_XXJ_WS_LOOPTYPE_D: "লুপ টাইপ",
  T_44_XXJ_WS_MIDGAMEEXITCONFIG: "মিডওয়ে কনফিগ ত্যাগ করুন",
  T_44_XXJ_WS_MOUNTABLE: "অনুক্রমিক",
  T_44_XXJ_WS_MOUNTABLE_D: "এনটিটি চাইল্ড নোডগুলো মাউন্ট করতে সক্ষম",
  T_44_XXJ_WS_MOVEMENT: "মুভমেন্ট",
  T_44_XXJ_WS_NAME_D: "নাম",
  T_44_XXJ_WS_NATURALCONST: "ন্যাচারাল কনস্ট্যান্ট",
  T_44_XXJ_WS_NATURALCONST_D: "অপ্রয়োজনীয় ডেফিনিশন্স কমাতে ন্যাচারাল ধ্রুবকের enum",
  T_44_XXJ_WS_NOTIFYICONANIMATION_D: "আইকন অ্যানিমেশন প্লে করুন",
  T_44_XXJ_WS_OFFSET_D: "ডিফল্ট বেইজ অফসেট",
  T_44_XXJ_WS_ONFIRE_D: "প্লেয়ার যখনই শ্যুট করে, ফিস্ট দিয়ে আক্রমণ করে, বা মেলি ওয়েপন দিয়ে অ্যাটাক করে তখন ইভেন্টটিকে ট্রিগার করে।",
  T_44_XXJ_WS_ONPLAYERSTANDUP_D: "প্লেয়ার যখন নতজানু/ক্রুচিং থেকে উঠে দাঁড়ায় তখন ইভেন্টটি ট্রিগার করে",
  T_44_XXJ_WS_ONSTARTFIRE_D: "প্লেয়ার যখন ফায়ার বাটনে ট্যাপ করে তখন ইভেন্টটি ট্রিগার করে",
  T_44_XXJ_WS_OPTION: "অপশনসমূহ",
  T_44_XXJ_WS_PASSIVESKILLHUD: "প্যাসিভ স্কিল HUD",
  T_44_XXJ_WS_PHYSICALMOVER: "ফিজিক্যাল মুভার",
  T_44_XXJ_WS_PHYSICALMOVER_D: "এই প্ল্যাটফর্মের প্লেয়ারেরা স্বয়ংক্রিয়ভাবে মুভমেন্ট এবং রোটেশন অনুসরণ করবে",
  T_44_XXJ_WS_PHYSICALOBJECT: "ফিজিক্যাল অবজেক্ট",
  T_44_XXJ_WS_PHYSICALOBJECT_D: "এতে ফোর্স এপ্লাই করতে পারেন",
  T_44_XXJ_WS_PI: "Pi",
  T_44_XXJ_WS_PI_D: "গাণিতিক ধ্রুবক π (Pi)",
  T_44_XXJ_WS_PLAYERS: "প্লেয়ার লিস্ট",
  T_44_XXJ_WS_PLAYERS_D: "প্লেয়ার লিস্ট",
  T_44_XXJ_WS_PLAYERSKILLID: "ক্যারেক্টার স্কিল ID",
  T_44_XXJ_WS_PLAYERSKILLID_D: "AvatarSkill.csv এ থাকা  ক্যারেক্টার স্কিল ID",
  T_44_XXJ_WS_PREPHYSXPOSE_D: "প্লেয়ার উঠে দাঁড়ানোর আগে আগের পোজ",
  T_44_XXJ_WS_PRINT: "প্রিন্ট করুন",
  T_44_XXJ_WS_PRINTERROR: "প্রিন্ট এরর",
  T_44_XXJ_WS_PRINTERROR_D: "কনসোলে একটি ত্রুটি হিসাবে টার্গেট ডেটা মুদ্রণ করুন",
  T_44_XXJ_WS_PRINTWARNING: "প্রিন্ট ওয়ার্নিং",
  T_44_XXJ_WS_PRINTWARNING_D: "কনসোলে সতর্কতা হিসাবে টার্গেট ডেটা মুদ্রণ করুন",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN: "প্লেয়ার স্কিন কনফিগ অগ্রাধিকার দিন",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN_D: "ম্যাচের বাইরে থাকা প্লেয়ার স্কিন কনফিগারেশনকে অগ্রাধিকার দিন",
  T_44_XXJ_WS_READCSVROWBYKEY_D: "কলাম নম্বর এবং কী দ্বারা একটি সারির কক্ষে থাকা কনটেন্ট পড়ুন",
  T_44_XXJ_WS_REMOVEBAGSKINID_D: "প্লেয়ার ব্যাকপ্যাক স্কিন কনফিগারেশন ক্লিয়ার করুন",
  T_44_XXJ_WS_REMOVECOMPONENT_D: "একটি এনটিটি থেকে একটি কম্পোনেন্ট রিমুভ করুন. শুধুমাত্র কাস্টম কম্পোনেন্ট সাপোর্ট করে।",
  T_44_XXJ_WS_RESETBAGSKINID_D: "প্লেয়ার ব্যাকপ্যাক স্কিন কনফিগারেশনকে এর ম্যাচের বাইরের কনফিগারেশনে রিসেট করুন",
  T_44_XXJ_WS_SETBAGSKINID_D: "প্লেয়ার ব্যাকপ্যাক স্কিন কনফিগারেশন সেট করুন",
  T_44_XXJ_WS_SETPARENTCLIENT_D: "ট্রান্সফর্ম, স্কেলেটন পার্ট, প্লেয়ার এবং মাউন্টপয়েন্ট কম্পোনেন্টগুলো সমর্থনকারী এনটিটি",
  T_44_XXJ_WS_SHOWBACKGROUND: "ব্যাকগ্রাউন্ড প্রদর্শন করুন",
  T_44_XXJ_WS_SKINID_D: "ব্যাকপ্যাক স্কিন আইডি এবং স্কিন কনফিগারেশন",
  T_44_XXJ_WS_SPEED_D: "প্লেব্যাক স্পিড",
  T_44_XXJ_WS_TARGET: "টার্গেট",
  T_44_XXJ_WS_TARGET_D: "টার্গেট অবজেক্ট",
  T_44_XXJ_WS_TITLE: "টাইটেল",
  T_44_XXJ_WS_TYPEID_D: "কম্পোনেন্ট টাইপ আইডি।শুধুমাত্র কাস্টম কম্পোনেন্ট সাপোর্ট করে।",
  T_44_XXJ_WS_UPLOADMATCHRESULT_D: "কাস্টম ম্যাচ রেজাল্টস আপলোড করুন",
  T_44_XXJ_WS_WARNINGCSVTYPE: "টাইপ মেলেনি. টেবিলে থাকা কনটেন্ট পড়া যাচ্ছে না।",
  T_44_XXJ_WS_X_D: "X-অক্ষ কোঅর্ডিনেট",
  T_44_XXJ_WS_Y_D: "Y-অক্ষ কোঅর্ডিনেট",
  T_44_XYL_WS_CTZSAFEZONE: "কাস্টম সেইফ জোন",
  T_44_XYL_WS_CTZSAFEZONEDESC: "আগে থেকে সেট করা পজিশন এবং প্রপার্টিজের উপর ভিত্তি করে একটি সেইফ জোনের শুরু এবং শেষ পয়েন্ট তৈরি করে",
  T_44_XYL_WS_HEMISPHERICALSHELL: "হেমিস্ফেরিক্যাল শেল",
  T_44_XYL_WS_QUARTERCYLINDER: "কোয়ার্টার সিলিন্ডার",
  T_44_XYL_WS_SQUAREPYRAMID: "বর্গাকৃতির পিরামিড",
  T_44_XYL_WS_TORUS: "টোরাস",
  T_44_XYL_WS_TRIANGULARPYRAMID: "ত্রিকোণাকার পিরামিড",
  T_44_YU_WS_ADDGAMEEVENTLOGMAP: "গেম ইভেন্ট লগ ম্যাপ যোগ করুন",
  T_44_YU_WS_ADDUSEREVENTLOGMAP: "ইউজার ইভেন্ট লগ যোগ করুন",
  T_44_YU_WS_ADDUSEREVENTLOGMAP_D: "UX ডেটা বিশ্লেষণের জন্য ব্যবহৃত কাস্টম ম্যাচ ইভেন্ট লগ",
  T_44_YU_WS_ITEM366: "মিলিটারি ওয়াল A",
  T_44_YU_WS_ITEM367: "মিলিটারি ওয়াল B",
  T_44_YU_WS_ITEM368: "মিলিটারি ওয়াল C",
  T_44_YU_WS_ITEM369: "মিলিটারি ওয়াল D",
  T_44_YU_WS_ITEM370: "মিলিটারি জানালা A",
  T_44_YU_WS_ITEM371: "মিলিটারি উইন্ডো B",
  T_44_YU_WS_ITEM372: "মিলিটারি জানালা C",
  T_44_YU_WS_ITEM373: "মিলিটারি দরজা A",
  T_44_YU_WS_ITEM374: "মিলিটারি দরজা B",
  T_44_YU_WS_ITEM375: "মিলিটারি কৌণিক ছাদ A",
  T_44_YU_WS_ITEM376: "মিলিটারি কৌণিক ছাদ B",
  T_44_YU_WS_ITEM377: "মিলিটারি সিঁড়ি A",
  T_44_YU_WS_ITEM378: "মিলিটারি সিঁড়ি B",
  T_44_YU_WS_ITEM379: "মিলিটারি পিলার A",
  T_44_YU_WS_ITEM380: "মিলিটারি হ্যান্ড্রেল A",
  T_45_C_WEAPON_CUST_ENTRANCE: "কাস্টমাইজ",
  T_45_CJ_TREATMENTGUN_Y_N: "হিল পিস্তল-Y",
  T_45_H_CHARACTER_ELECTRICGIRL_N: "ক্যাসি",
  T_45_H_EMOTE_MVPDANCE_N: "চ্যাম্পিয়ন'স ওয়াক",
  "T_45_HH_GOLD_MAC10-I": "MAC10-I",
  "T_45_HH_GOLD_MAC10-II": "MAC10-II",
  "T_45_HH_GOLD_MAC10-III": "MAC10-III",
  T_45_HJ_CAMERA_INSPECTOR: "পরিদর্শন",
  T_45_HL_Moderation_fail_1: "দুর্ভাগ্যবশত, আপনার জমা দেওয়া প্রকল্প পর্যালোচনা পাস করেনি.",
  T_45_HL_Moderation_fail_2: "অন্তর্ভুক্ত করে",
  T_45_HL_Moderation_fail_3: "অন্তর্ভুক্ত কারণসমূহ:",
  T_45_HL_Moderation_fail_Location_1: "গেম কনটেন্ট",
  T_45_HL_Moderation_fail_reason_1: "টক্সিক কনটেন্ট",
  T_45_HL_Moderation_fail_reason_10: "কমিউনিটি গাইডলাইন ভায়োলেশন",
  T_45_HL_Moderation_fail_reason_11: "ইন-গেম অর্থনীতি এবং ভার্চুয়াল প্রোপার্টি লঙ্ঘনের উপর নেতিবাচক প্রভাব",
  T_45_HL_Moderation_fail_reason_2: "অনুপযুক্ত কনটেন্ট",
  T_45_HL_Moderation_fail_reason_3: "রাজনৈতিকভাবে স্পর্শকাতরতা",
  T_45_HL_Moderation_fail_reason_4: "মিথ্যা তথ্য",
  T_45_HL_Moderation_fail_reason_5: "কপিরাইট লঙ্ঘন",
  T_45_HL_Moderation_fail_reason_6: "প্রাইভেসি ভায়োলেশন",
  T_45_HL_Moderation_fail_reason_7: "নিরাপত্তা সংক্রান্ত উদ্বেগ",
  T_45_HL_Moderation_fail_reason_8: "ঘৃণামূলক বক্তব্য",
  T_45_HL_Moderation_fail_reason_9: "স্প্যাম",
  T_45_HL_Moderation_fail_reason_999: "অন্যান্য ইস্যু",
  T_45_JH_WS_CLEMPTYOBJECT: "অবজেক্ট গ্রুপ",
  T_45_JH_WS_PETSWITCH1: "ম্যাচে পেটস প্রদর্শন করা হবে কিনা",
  T_45_QL_CSFPP_DES: "এই স্পেশাল CS মোডে ফার্স্ট-পার্সন দৃষ্টিকোণের মাধ্যমে সকল প্রতিপক্ষকে এলিমিনেট করুন!",
  T_45_QL_CSFPP_NAME: "ক্ল্যাশ স্কোয়াড: FPP",
  T_45_QL_CSFPP_RANKNAME: "ফার্স্ট-পার্সন",
  T_45_SJ_WS_REVIEW_23: "গেম কনটেন্ট",
  T_45_SJ_WS_REVIEW_24: "{0} জড়িত {1}",
  T_45_SJ_WS_REVIEW_25: "{0} {1} জড়িত {2}",
  T_45_SJ_WS_REVIEW_26: "[FFBA00]বিস্তারিত দেখতে ট্যাপ করুন >>[-]",
  T_45_SJ_WS_REVIEW_27: "এপ্রোভ করা হয়নি",
  T_45_SJ_WS_REVIEW_28: "রিভিউ ফিডব্যাক",
  T_45_SJ_WS_REVIEW_29: "এই কনটেন্টে {0} টি ভায়োলেশন রয়েছে",
  T_45_SJ_WS_REVIEW_31: "এপ্রোভ করা হয়নি",
  T_45_SJ_WS_REVIEW_32: "সার্ভার ব্যতিক্রমগুলির কারণে রিভিউ ব্যর্থ হয়েছে৷",
  T_45_SJ_WS_REVIEW_TITLE: "ভায়োলেশন এর বিস্তারিত",
  T_45_SJ_WS_VAULTTRIGGER_DES: "ভল্টিং ট্রিগার করে (বাধা অতিক্রম করে জাম্পিং এ)",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE: "ভল্ট দূরত্ব",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE_DES: "ভল্টিংয়ের দূরত্ব মোডিফাই করে",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT: "ভল্ট হাইট",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT_DES: "ভল্ট করার সময় উপরে এবং নিচে যাওয়ার উচ্চতা নিয়ন্ত্রণ করে",
  T_45_SJ_WS_VAULTTRIGGER_NAME: "ভল্ট ট্রিগার",
  T_45_TYC_CL_TEMPLATE_WS: `একটি এলিমিনেশন মোড যেখানে প্লেয়াররা বিজয়ী হওয়ার জন্য বিশৃঙ্খল ব্যাটেলে সকল প্রতিপক্ষ টিমকে পরাজিত করে।
আপনি ইচ্ছেমতো গেমপ্লের রুলস সেট করতে এবং প্যারামিটার এডিট করতে পারেন।`,
  T_45_W_SPEEDMODE_FLIGHT_N: "স্কাইব্লাস্টার",
  T_45_XXJ_WS_ACTIONTYPE_D: "0 = অটো অ্যাটাক, 1 = ডিফেন্সিভ অ্যাটাক, 2 = অ্যাটাক করবেন না",
  T_45_XXJ_WS_ADDFRIEND: "ফ্রেন্ড এড করুন",
  T_45_XXJ_WS_API: "API",
  T_45_XXJ_WS_AUTO: "অটো",
  T_45_XXJ_WS_BASEDATA: "বেইজ ডেটা",
  T_45_XXJ_WS_BOTH: "উভয়ই",
  T_45_XXJ_WS_BYHIERARCHY: "অনুক্রম দ্বারা",
  T_45_XXJ_WS_BYPRIORITYHIGHTOLOW: "প্রায়োরিটি উচ্চ থেকে নিন্ম ভিত্তিতে",
  T_45_XXJ_WS_BYPRIORITYLOWTOHIGH: "প্রায়োরিটি নিন্ম থেকে উচ্চ ভিত্তিতে",
  T_45_XXJ_WS_CAMERA: "ক্যামেরা",
  T_45_XXJ_WS_CAMERATYPE: "ক্যামেরা টাইপ",
  T_45_XXJ_WS_CENTERINVISIBLE: "সেন্টার অদৃশ্যমান",
  T_45_XXJ_WS_CLIENT: "ক্লায়েন্ট",
  T_45_XXJ_WS_COLLIDERID: "কোলাইডার আইডি",
  T_45_XXJ_WS_COLLIDERID_D: "কলাইডার আইডি",
  T_45_XXJ_WS_COMPONENT: "কম্পোনেন্ট",
  T_45_XXJ_WS_CURRENTCAMERA: "বর্তমান ক্যামেরা",
  T_45_XXJ_WS_CUSTOMPUSHFORCE: "কাস্টম পুশ ফোর্স",
  T_45_XXJ_WS_DOUBLE: "ডাবল",
  T_45_XXJ_WS_DUMP: "থ্রো",
  T_45_XXJ_WS_ENABLEMOVEINMIDAIR: "মিডএয়ারে মুভ এনাবল করুন",
  T_45_XXJ_WS_ENABLEROTATEWITHGRAVITY: "মাধ্যাকর্ষণ দিয়ে রোটেট এনাবল করুন",
  T_45_XXJ_WS_ENUM: "এনাম",
  T_45_XXJ_WS_EVENT: "ইভেন্ট",
  T_45_XXJ_WS_FILLAMOUNT: "ফিল অ্যামাউন্ট",
  T_45_XXJ_WS_FILLDIR: "ডিরেকশন ফিল করুন",
  T_45_XXJ_WS_FIRETYPE: "ফায়ার টাইপ",
  T_45_XXJ_WS_FIRETYPE_D: "ফায়ারিং টাইপ",
  T_45_XXJ_WS_FIXEDDELTATIME: "ফিক্সড ডেল্টা টাইম",
  T_45_XXJ_WS_FIXEDDELTATIME_D: "মিলিসেকেন্ডে ফ্রেম আপডেটের জন্য নির্দিষ্ট সময়ের ব্যবধান",
  T_45_XXJ_WS_FORWARD: "ফরোয়ার্ড",
  T_45_XXJ_WS_FORWARD_D: "লোকাল কোঅর্ডিনেট সিস্টেমে z-অক্ষের ডিরেকশন",
  T_45_XXJ_WS_FUNCTIONTYPE: "ফাংশন টাইপ",
  T_45_XXJ_WS_FUNCTIONTYPE_D: "ফাংশন টাইপ",
  T_45_XXJ_WS_GETLOCALAIMDIRECTION_D: "লোকাল প্লেয়ারের এইমিং ডিরেকশন",
  T_45_XXJ_WS_GETLOCALTIMESTAMP_D: "লোকাল টাইমস্ট্যাম্প অর্জন করুন",
  T_45_XXJ_WS_GRADIENT: "গ্র্যাডিয়েন্ট",
  T_45_XXJ_WS_GRADIENTBOTTOM: "গ্র্যাডিয়েন্ট বটম",
  T_45_XXJ_WS_GRADIENTBOTTOMALPHA: "গ্র্যাডিয়েন্ট বটম আলফা",
  T_45_XXJ_WS_GRADIENTTOP: "গ্র্যাডিয়েন্ট টপ",
  T_45_XXJ_WS_GRADIENTTOPALPHA: "গ্র্যাডিয়েন্ট টপ আলফা",
  T_45_XXJ_WS_HITPOSITION_D: "বুলেট দ্বারা আঘাত করা টার্গেটের ওয়ার্ল্ড পজিশন",
  T_45_XXJ_WS_HUDSOCIALBUTTONWIDGET: "UI সোশ্যাল বাটন উইজেট",
  T_45_XXJ_WS_INVERTFILL: "ইনভার্ট ফিল",
  T_45_XXJ_WS_ISGROUNDED: "গ্রাউন্ডেড কিনা",
  T_45_XXJ_WS_ISSILENCE: "সাইলেন্স কিনা",
  T_45_XXJ_WS_ISSILENCE_D: "এটা কী সাইলেন্সড আছে কিনা",
  T_45_XXJ_WS_ISSINGLESHOT: "সিংগেল শট কিনা",
  T_45_XXJ_WS_ISSINGLESHOT_D: "এটা কী সিংগেল শট কিনা",
  T_45_XXJ_WS_JUMPHEIGHT: "জাম্প হাইট",
  T_45_XXJ_WS_JUMPHEIGHT_D: "জাম্প হাইট",
  T_45_XXJ_WS_LAYOUTSORTTYPE: "লে-আউট সর্ট টাইপ",
  T_45_XXJ_WS_LIGHT_D: "লাইটস",
  T_45_XXJ_WS_LOCAL: "লোকাল",
  T_45_XXJ_WS_MAXMULTIJUMPNUM: "ম্যাক্স. জাম্প কাউন্ট",
  T_45_XXJ_WS_MODULE: "মডিউল",
  T_45_XXJ_WS_NONE: "কোনোটাই নয়",
  T_45_XXJ_WS_ONBEFOREHURT_D: "এই এনটিটি ড্যামেজ ডিল করার আগে প্রতিবার কমান্ডটি কার্যকর করুন",
  T_45_XXJ_WS_ONDISABLE_D: "এই এনটিটি যখন ডিজেবল করা থাকে, তখন এক্সিকিউট করুন",
  T_45_XXJ_WS_ONEACHLOOP_D: "প্রতিবার চালানোর যোগ্য লুপ করা হলে এক্সিকিউট করুন। শুধুমাত্র সাউন্ড ইফেক্ট এবং স্পেশাল ইফেক্টের মতো এনটিটির জন্য ক্লায়েন্টের পক্ষে কার্যকর।",
  T_45_XXJ_WS_ONENABLE_D: "এই এনটিটি যখন এনাবল করা থাকে, তখন এক্সিকিউট করুন",
  T_45_XXJ_WS_ONFIXEDUPDATE_D: "একটি ফ্রেমে 30 FPS এর একটি নির্দিষ্ট হারে প্রবেশ করার সময়",
  T_45_XXJ_WS_ONFRIENDRELATIONCHANGE_D: "ক্লায়েন্ট ইভেন্ট ট্রিগার করে যখন প্লেয়ার একটি বন্ধুকে যোগ করে বা ডিলিট করে দেয়",
  T_45_XXJ_WS_ONGAMEPAUSE_D: "উক্ত API এর কারণে গেমে পজ দিলে ইভেন্টটি ট্রিগার করুন",
  T_45_XXJ_WS_ONGAMERESUME_D: "কথিত API এর কারণে গেমটি পুনরায় শুরু হলে ইভেন্টটি ট্রিগার করুন",
  T_45_XXJ_WS_ONPLAYERSTOPDASH_D: "প্লেয়ার যখন স্প্রিন্টিং বন্ধ করে দেয়",
  T_45_XXJ_WS_ONPLAYERSTOPSWIMSURFING_D: "প্লেয়ার যখন সার্ফিং বন্ধ করে দেয়",
  T_45_XXJ_WS_ONPLAYERSWIMSURFING_D: "প্লেয়ার যখন সার্ফিং করছে",
  T_45_XXJ_WS_PHYSICALLAYER_D: "0 থেকে 31 এর মধ্যে কাস্টম ফিজিক্যাল লেয়ার",
  T_45_XXJ_WS_PLATFORMTYPE: "প্লাটফর্ম টাইপ",
  T_45_XXJ_WS_PLATFORMTYPE_D: "প্লাটফর্ম টাইপ",
  T_45_XXJ_WS_PLAYER: "প্লেয়ার",
  T_45_XXJ_WS_PLAYERCCT: "প্লেয়ার CCT",
  T_45_XXJ_WS_PLAYERCCT_D: "ফিজিক্যাল ইফেক্টসহ একটি ক্যারেক্টার কন্ট্রোলার এবং শুধুমাত্র Free Fire ক্যারেক্টারগুলোর জন্য ব্যবহৃত হয়",
  T_45_XXJ_WS_PRIORITY: "অগ্রাধিকার",
  T_45_XXJ_WS_REMAINMULTINUM: "জাম্প কাউন্টে অবস্থান বজায় রাখুন",
  T_45_XXJ_WS_REPORT: "রিপোর্ট",
  T_45_XXJ_WS_RIGHT: "ডান",
  T_45_XXJ_WS_RIGHT_D: "লোকাল কোঅর্ডিনেট সিস্টেমে x-অক্ষের ডিরেকশন",
  T_45_XXJ_WS_SERVER: "সার্ভার",
  T_45_XXJ_WS_SINGLE: "সিংগেল",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE: "স্পেশাল বাটন স্টাইল টাইপ",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE_D: "সোশ্যাল বাটন স্টাইল",
  T_45_XXJ_WS_SOCIALBUTTONTYPE: "স্পেশাল বাটন টাইপ",
  T_45_XXJ_WS_SOCIALBUTTONTYPE_D: "সোশ্যাল বাটন টাইপ",
  T_45_XXJ_WS_SORTTYPE_D: "সাজানোর ধরন: অ-শূন্য আরোহী, অবরোহ এবং আরোহী",
  T_45_XXJ_WS_SPEEDWHILEAIMING: "ADS এর সময় মুভস্পিড",
  T_45_XXJ_WS_SPEEDWHILEAIMING_D: "দৃষ্টিসীমার নিচের দিকে এইমিং করার সময় মুভমেন্ট স্পিড",
  T_45_XXJ_WS_STRINGORLOCSTRING: "স্ট্রিং অথবা স্থানীয়কৃত স্ট্রিং",
  T_45_XXJ_WS_TRIPLE: "ট্রিপল",
  T_45_XXJ_WS_UP: "আপ",
  T_45_XXJ_WS_UP_D: "লোকাল কোঅর্ডিনেট সিস্টেমে y-অক্ষের ডিরেকশন",
  T_45_XXJ_WS_USECUSTOMPUSHFORCE: "কাস্টম পুশ ফোর্স ব্যবহার করুন",
  T_45_XXJ_WS_Z: "Z",
  T_45_XXJ_WS_Z_D: "Z",
  T_45_ZD_VEHICLEDROP_R_DESC: "র‍্যানডম একটি ভেহিক্যাল সমন করে আনতে নির্ধারিত এলাকার দিকে একটি সিগন্যাল ফ্লেয়ার নিক্ষেপ করুন",
  T_45_ZD_VEHICLEDROP_R_NAME: "মিস্ট্রি ভেহিক্যাল",
  T_46_H_CHARACTER_MISCHIEFGIRL_N: "লীলা",
  T_46_HJ_SHARE_GAMEDURATION: "যতবার প্লে করা হয়েছে",
  T_46_HJ_WS_SHAREBY: "দ্বারা {0}",
  T_46_HJ_WS_SHAREGAMEMODE: "গেম মোড",
  T_46_HJ_WS_SHARETEAM: "টিম",
  T_46_HJ_WS_SHARETEAMVS: "{0} vs {1}",
  T_46_HX_B_SCHOOL_VN: "টপ অফ ক্লাস (বটম)",
  T_46_HX_H_SCHOOL_VN: "টপ অফ ক্লাস (হেড)",
  T_46_HX_S_SCHOOL_VN: "টপ অফ ক্লাস (সুজ)",
  T_46_HX_T_SCHOOL_VN: "টপ অফ ক্লাস (টপ)",
  T_46_JH_WS_CLGUIDE_TUTORIAL: "টিউটোরিয়াল",
  T_46_LYF_RANKBOARD_TIPS_OTHERS: "অন্যান্য",
  T_46_XXJ_WS_ACTUALPOSITION: "প্রকৃত পজিশন",
  T_46_XXJ_WS_ADDSPECIALFOLLOW_D: "দৃষ্টি সীমার বাহিরে AOI সিঙ্ক্রোনাইজেশনের সাথে মনিটর করার জন্য অবজেক্ট যোগ করুন",
  T_46_XXJ_WS_APPEARANCE: "অ্যাপিয়ার‍্যান্স",
  T_46_XXJ_WS_APPEARANCERES: "অ্যাপিয়ার‍্যান্স রিসোর্স",
  T_46_XXJ_WS_BECOME: "অ্যাক্টিভেট",
  T_46_XXJ_WS_BRAKETORQUE_D: "ব্রেক/রিভার্স ব্যবহার করার সময় গাড়িকে হর্সপাওয়ার দেওয়া হয়",
  T_46_XXJ_WS_CAMERAVIEWINGANGLERESTRICTIONTYPE: "ক্যামেরা রোটেট অ্যাঙ্গেল রেস্ট্রিকশন টাইপ",
  T_46_XXJ_WS_CLEANSPECIALFOLLOW_D: "টার্গেটের সকল অবজারভ মনিটর ক্লিয়ার করুন",
  T_46_XXJ_WS_CRASHMAXDAMAGE_D: "ড্যামেজ হিসাবের জন্য ব্যবহৃত মিনিমাম ক্র্যাশ ড্যামেজ",
  T_46_XXJ_WS_CRASHMAXSPEED: "ক্র্যাশ ম্যাক্স. স্পিড",
  T_46_XXJ_WS_CRASHMAXSPEED_D: "ক্র্যাশ ড্যামেজ গণনার জন্য ব্যবহৃত হয়। একবার এই স্পিড অতিক্রম করলে, আর কোন ড্যামেজ যোগ হবে না।",
  T_46_XXJ_WS_CRASHMESSFACTOR: "ক্র্যাশ ম্যাস ফ্যাক্টর",
  T_46_XXJ_WS_CRASHMESSFACTOR_D: "ক্র্যাশ ড্যামেজ গণনার জন্য ড্যামেজ ফর্মুলা ব্যবহৃত একটি প্যারামিটার",
  T_46_XXJ_WS_CRASHMINDAMAGE_D: "ড্যামেজ হিসাব করার জন্য ব্যবহার করুন মিনিমাম ক্র্যাশ ড্যামেজ",
  T_46_XXJ_WS_DB_OVERLIMIT_D: "ডেটা স্টোরেজের পড়া এবং লেখার লিমিট অতিক্রম করা হয়েছে",
  T_46_XXJ_WS_DB_PARAMERROR_D: "প্যারামিটার এক্সসেপশন",
  T_46_XXJ_WS_DB_TIMEOUT_D: "ডেটা স্টোরেজ টাইমআউট। এটি প্রধানত এখন পড়া এবং লেখার ক্ষেত্রে প্রযোজ্য।",
  T_46_XXJ_WS_DELTA: "ডেল্টা",
  T_46_XXJ_WS_EDITNPCCOLLIDERTIPS: "অ্যাপিয়ার‍্যান্স এডিট করুন",
  T_46_XXJ_WS_ENDVALUE_D: "ডেস্টিনেশন ভ্যালু",
  T_46_XXJ_WS_ENGINETORQUE_D: "গ্যাস প্যাডেল ব্যবহার করার সময় গাড়িকে হর্সপাওয়ার দেওয়া হয়",
  T_46_XXJ_WS_ERRORCODE_D: "এরার কোড ইনাম",
  T_46_XXJ_WS_EULARANGLETOVECTOR3: "ডিম্বাকৃতির কোণ থেকে ভেক্টর3",
  T_46_XXJ_WS_EULARANGLETOVECTOR3_D: "ইউলার অ্যাঙ্গেল 3D ভেক্টরে কনভার্ট করুন",
  T_46_XXJ_WS_EXPIRE: "মেয়াদোত্তীর্ণ",
  T_46_XXJ_WS_FEMALEAVATAR: "ফিমেল ক্যারেক্টার",
  T_46_XXJ_WS_GETPREMIUMEXPIREDATE: "মেম্বারশিপ এক্সপায়ার ডেট পান",
  T_46_XXJ_WS_HASSPECIALFOLLOW_D: "অবজারভার একটি অবজেক্টকে মনিটরিং করছে কিনা",
  T_46_XXJ_WS_HELICOPTER: "স্কাইব্লাস্টার",
  T_46_XXJ_WS_HELICOPTER_D: "এক প্রকার ফ্লাইং ভেহিকেল",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE: "হাই স্পিড স্টিয়ার এঞ্জেল",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE_D: "হাই-স্পিড অবস্থায় থাকাকালীন সর্বাধিক স্টিয়ারিং  অ্যাঙ্গেল",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED: "স্পিড অনুযায়ী হাই-স্পিড স্টিয়ার অ্যাঙ্গেল",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED_D: "সর্বাধিক হাই-স্পিড স্টিয়ারিং অ্যাঙ্গেল এর জন্য স্পিডের থ্রেশহোল্ড",
  T_46_XXJ_WS_IDLE: "আইডল অ্যানিমেশন",
  T_46_XXJ_WS_IDLEBRAKEINPUT: "আইডল ব্রেক ইনপুট",
  T_46_XXJ_WS_IDLEBRAKEINPUT_D: "যখন গাড়ি চালানো হচ্ছে না, তখন এটি (আইডল ব্রেক ইনপুট) x (ব্রেক টর্ক) দ্বারা ধীরে ধীরে থামান।",
  T_46_XXJ_WS_INTTOFLOAT: "Int থেকে ফ্লোট",
  T_46_XXJ_WS_INTTOFLOAT_D: "একটি পূর্ণসংখ্যাকে একটি ভাসমান পয়েন্ট সংখ্যায় কনভার্ট করুন",
  T_46_XXJ_WS_ISPREMIUM: "মেম্বারশিপ কিনা",
  T_46_XXJ_WS_LEADERBOARDNAME_D: "ডাটাবেসে থাকা লিডারবোর্ডের নাম",
  T_46_XXJ_WS_MALEAVATAR: "মেল ক্যারেক্টার",
  T_46_XXJ_WS_MODULE_AICHARACTOR: "AI পারসোনা",
  T_46_XXJ_WS_NEWUMAAPPEARANCE: "নতুন UMA অ্যাপিয়ার‍্যান্স",
  T_46_XXJ_WS_NONE_D: "কোনো ত্রুটি নেই",
  T_46_XXJ_WS_NPC: "NPC",
  T_46_XXJ_WS_NPC_D: "NPC অবজেক্ট",
  T_46_XXJ_WS_NPCCOLLIDERTIPS: "টিপস: হিউম্যানয়েড NPC-তে সাধারণত 1.4 মিটার উঁচু এবং 0.25 মিটার ব্যাসার্ধের ক্যাপসুলের সাথে একটি কলিশন মডেল থাকে। পেট NPC-তে সাধারণত 1 মিটার উঁচু এবং 0.4 মিটার ব্যাসার্ধের ক্যাপসুল সহ একটি কলিশন মডেল থাকে।",
  T_46_XXJ_WS_OBSERVER_D: "যেই অবজারভার অবজেক্ট মনিটরিং করছে",
  T_46_XXJ_WS_ONPLAYERENTERPREMIUMCENTER: "অন এন্টার ক্রাফটল্যান্ড মেম্বারশিপ",
  T_46_XXJ_WS_ONPLAYERLEAVEPREMIUMCENTER: "অন কুইট ক্রাফটল্যান্ড মেম্বারশিপ",
  T_46_XXJ_WS_OPENPREMIUMCENTER: "ক্রাফটল্যান্ড মেম্বারশিপ উন্মুক্ত করুন",
  T_46_XXJ_WS_PERSONA: "পার্সোনা",
  T_46_XXJ_WS_PERSONACENTER: "পার্সোনা সেন্টার",
  T_46_XXJ_WS_PET: "পেট",
  T_46_XXJ_WS_PLAYERORTRANSFORM: "প্লেয়ার বা ট্রান্সফর্ম",
  T_46_XXJ_WS_PLAYERORTRANSFORM_D: "প্লেয়ার এবং ট্রান্সফর্ম এন্টিটির জন্য একটি উপনাম",
  T_46_XXJ_WS_PREMIUM: "মেম্বারশিপ",
  T_46_XXJ_WS_PREMIUMSTATUS: "মেম্বারশিপ স্ট্যাটাস",
  T_46_XXJ_WS_PROXYOBSERVER: "প্রক্সি অবজারবার",
  T_46_XXJ_WS_PROXYOBSERVER_D: "প্রক্সি অবজারভার",
  T_46_XXJ_WS_REMOVESPECIALFOLLOW_D: "মনিটরকৃত অবজেক্ট রিমুভ করে ফেলুন এবং দৃষ্টি সীমার বাহিরে AOI সিঙ্ক্রোনাইজেশন বাতিল করুন",
  T_46_XXJ_WS_RENEWAL: "রিনিউ",
  T_46_XXJ_WS_ROTATEVECTOR: "রোটেট ভেক্টর",
  T_46_XXJ_WS_ROTATEVECTOR_D: "কোয়াটারনিয়ন ভিত্তিতে একটি ভেক্টর ঘোরান",
  T_46_XXJ_WS_SKIN: "গিয়ার",
  T_46_XXJ_WS_STARTVALUE_D: "সোর্স ভ্যালু",
  T_46_XXJ_WS_STATUS: "স্ট্যাটাস",
  T_46_XXJ_WS_SWITCHUSERPROXYOBSERVER_D: "ইউজারের প্রক্সি অবজারবার পরিবর্তন করুন",
  T_46_XXJ_WS_TARGET_D: "যে টার্গেট পর্যবেক্ষণ কর হচ্ছে",
  T_46_XXJ_WS_USER_D: "ইউজার",
  T_46_XXJ_WS_VALUE: "ভ্যালু",
  T_46_XXJ_WS_VALUE_D: "ভেক্টর",
  T_46_XYL_WS_CTZSAFEZONEEND: "সেফ জোন এন্ড পয়েন্ট",
  T_46_XYL_WS_RESOURCETYPE1: "বেসিক কাঠামো",
  T_46_XYL_WS_RESOURCETYPE1_1: "জিওমেট্রিক্স",
  T_46_XYL_WS_RESOURCETYPE1_2: "ভিজ্যুয়াল এবং অডিও",
  T_46_XYL_WS_RESOURCETYPE2: "দৃশ্যমান আইটেম",
  T_46_XYL_WS_RESOURCETYPE2_2: "ব্যাটেল সাপ্লাইজ",
  T_46_XYL_WS_RESOURCETYPE3: "প্রকৃতি",
  T_46_XYL_WS_RESOURCETYPE4: "মডুলার কম্পোনেন্ট",
  T_46_XYL_WS_TYPEOTHERPROP: "বিবিধ",
  T_46_XYL_WS_TYPEOTHERPROPBOX: "কন্টেনার এবং বক্সসমূহ",
  T_47_CJ_FOREGRIP_SOFT_N: "লাইট ফোরগ্রিপ",
  T_47_CJ_MAGEZINE_FAST_N: "ফাস্ট Mag",
  T_47_CJ_STOCK_FAST_N: "পাওয়ার স্টক",
  T_47_GT_WS_USERMANUAL: "ইউজার ম্যানুয়াল",
  T_47_HJ_WS_VFX_FOG: "ফগ VFX",
  T_47_HJ_WS_VFX_LIGHTING: "লাইটিং VFX",
  T_47_HJ_WS_VFX_TRAILING: "ট্রেইলিং VFX",
  T_47_HL_CL_CREATOR_LABEL1: "কমিউনিটি ট্যালেন্ট",
  T_47_HL_CL_MAP_LABEL1: "কমিউনিটি ট্যালেন্টদের নির্বাচিত কাজসমূহ",
  T_47_JH_WS_MODERATION_REASON12: "গ্যাম্বলিং-রিলেটেড",
  T_47_RW_NB_GP_GAMEAFFIX_HINT1: "NARUTO SHIPPUDEN কোলাবরেশন",
  T_47_SD_RES_MATERIAL: "ম্যাটারিয়াল ফাইল",
  T_47_SD_RES_MESH: "মেশ",
  T_47_SD_WS_MAPTAG_AI: "AI ম্যাপ জেনারেট",
  T_47_WT_W_NB_GP_KA_EXPLODE_DESC: "একটি স্পেশাল নাইফ যা থ্রো-এর পরে ইমপ্যাক্ট পয়েন্ট-এ আটকে থাকে এবং স্বল্প বিলম্বের পরে একটি ফায়ারি এক্সপ্লোশন ঘটে, যা এনিমিকে বার্ন ড্যামেজ প্রদান করে।",
  T_47_WT_W_NB_GP_KA_EXPLODE_NAME: "ফায়ারি কুনাই",
  T_47_WT_W_NB_GP_KA_THUNDER_DESC: "এমন একটা স্পেশাল নাইফ, যা থ্রো-এর পরে ইমপ্যাক্ট পয়েন্ট-এ আটকে থাকে এবং স্বল্প বিলম্বের পর একটা লাইটনিং স্ট্রাইক ঘটে, যা টার্গেটকে প্যারালাইজ করে দেয়।",
  T_47_WT_W_NB_GP_KA_THUNDER_NAME: "লাইটনিং কুনাই",
  T_47_WT_W_NB_GP_KA_WIND_DESC: "এমন একটা স্পেশাল নাইফ, যা থ্রো-এর পরে ইমপ্যাক্ট পয়েন্ট-এ আটকে থাকে, যা এর কেন্দ্রের দিকে চলমান টার্গেটকে স্লো করে ডাউন করতে অল্প বিলম্বের পর একটা ঝড়ো হাওয়া শুরু করে।",
  T_47_WT_W_NB_GP_KA_WIND_NAME: "উইন্ড কুনাই",
  T_47_WT_W_NB_GP_SRK_HEAVY_DESC: "মিড থেকে লং-রেঞ্জের কমব্যাটের জন্য উপযুক্ত এক ধরনের Shuriken। একটি থ্রোতে এক টুকরো দ্রুত ছোড়া হয়, যা অনেক বেশি পরিমাণে ড্যামেজ ডিল করে।",
  T_47_WT_W_NB_GP_SRK_HEAVY_NAME: "ভারী Shuriken",
  T_47_WT_W_NB_GP_SRK_LIGHT_DESC: "দুটি অ্যাটাক মোড সহ ক্লোজ-টু-মিড-রেঞ্জ কমব্যট-এর জন্য উপযুক্ত এক ধরনের Shuriken। একটি থ্রো তিনটি টুকরো লঞ্চ করে, যা কম পরিমাণে ড্যামেজ ডিল করে।",
  T_47_WT_W_NB_GP_SRK_LIGHT_NAME: "লাইট Shuriken",
  T_47_XXJ_WS_ACTION: "অ্যাকশন",
  T_47_XXJ_WS_AOISETTING: "AOI সেটিং",
  T_47_XXJ_WS_BAGSKINTYPE: "ব্যাকপ্যাক স্কিন টাইপ",
  T_47_XXJ_WS_CLEARMEMORY: "মেমরি ক্লিয়ার করুন",
  T_47_XXJ_WS_CLNPC: "অ্যাডভান্সড NPC",
  T_47_XXJ_WS_CLOTHTYPE: "আউটফিট স্কিন টাইপ",
  T_47_XXJ_WS_COMMON_ERROR: "সাধারণ ত্রুটি",
  T_47_XXJ_WS_CONTENT: "কনটেন্ট",
  T_47_XXJ_WS_CREATERANDOMSEED: "ক্রিয়েট র‍্যান্ডম সীড",
  T_47_XXJ_WS_ELAPSEDPERCENTAGE: "অতিবাহিত পার্সেন্টেজ",
  T_47_XXJ_WS_ENABLEUGCFOGFEATURE: "ফগ ফিচার এনাবল করুন",
  T_47_XXJ_WS_ENABLEUGCLIGHTROTATEFEATURE: "লাইট রোটেশন ফিচার সচল করুন",
  T_47_XXJ_WS_ERRORCODE: "ত্রুটিপূর্ণ কোড",
  T_47_XXJ_WS_EXPONENTIAL: "এক্সপোনেনশিয়াল",
  T_47_XXJ_WS_EXPONENTIALSQUARED: "এক্সপোনেনশিয়াল স্কোয়ারড",
  T_47_XXJ_WS_FAILED_INVALIDALLIDSONCREATE: "রুম তৈরি করতে ব্যর্থ হয়েছে: কোনো বৈধ Persona ID নেই",
  T_47_XXJ_WS_FOG: "ফগ",
  T_47_XXJ_WS_FOGDENSITY: "কুয়াশার ঘনত্ব",
  T_47_XXJ_WS_FOGENDDISTANCE: "ফগ শেষের দূরত্ব",
  T_47_XXJ_WS_FOGMODE: "ফগ মোড",
  T_47_XXJ_WS_FOGMODETYPE: "ফগ মোড টাইপ",
  T_47_XXJ_WS_FOGSTARTDISTANCE: "ফগ শুরুর দূরত্ব",
  T_47_XXJ_WS_HEIGHTSCALE: "হাইট স্কেল",
  T_47_XXJ_WS_ISVISIBLE: "দৃশ্যমান",
  T_47_XXJ_WS_JOINNEWTEAM: "নতুন টিমে যোগ দিন",
  T_47_XXJ_WS_JOINTEAM: "টিমে যোগ দিন",
  T_47_XXJ_WS_LIGHTROTATE: "লাইট রোটেশন",
  T_47_XXJ_WS_LINEAR: "লিনিয়ার",
  T_47_XXJ_WS_LLMCHATHUD: "UI Persona চ্যাট",
  T_47_XXJ_WS_NEWTEAM: "নতুন টিম",
  T_47_XXJ_WS_NEXT: "পরবর্তী",
  T_47_XXJ_WS_NPC_TIP: "আপনি NPC এর অ্যাপেয়ারেন্স এডিট করতে পারেন এবং NPC প্লে অ্যানিমেশন তৈরি করতে পারেন",
  T_47_XXJ_WS_OBSERVERS: "পর্যবেক্ষকগণ",
  T_47_XXJ_WS_ONHUDSENDMESSAGETOPERSONA: "প্লেয়ার UI Persona চ্যাট-এর মাধ্যমে মেসেজ পাঠান",
  T_47_XXJ_WS_ONPREMIUMCHANGE: "মেম্বারশিপ স্ট্যাটাস পরিবর্তন হয়েছে",
  T_47_XXJ_WS_ONRECEIVEACTIONFROMPERSONA: "Persona থেকে অন রিসিভ অ্যাকশন",
  T_47_XXJ_WS_ONRECEIVECONTENTFROMPERSONA: "Persona থেকে অন রিসিভ কনটেন্ট",
  T_47_XXJ_WS_ONRECEIVEFINISHFROMPERSONA: "Persona থেকে অন রিসিভ ফিনিশ",
  T_47_XXJ_WS_ONRECEIVESTATUSFROMPERSONA: "Persona থেকে অন রিসিভ স্ট্যাটাস",
  T_47_XXJ_WS_PARTICLESID: "পার্টিকলস ID",
  T_47_XXJ_WS_PERSONAAVATAR: "Persona অ্যাভাটার",
  T_47_XXJ_WS_PERSONAID: "পার্সোনা ID",
  T_47_XXJ_WS_PERSONANICKNAME: "Persona ডাকনাম",
  T_47_XXJ_WS_PLAYERORNPC: "প্লেয়ার বা NPC",
  T_47_XXJ_WS_PREMIUM_CLOSED: "মেম্বারশিপ ক্লোজ হয়েছে",
  T_47_XXJ_WS_RANDOM: "র‍্যান্ডম",
  T_47_XXJ_WS_SEED: "সীড",
  T_47_XXJ_WS_SENDER: "প্রেরক",
  T_47_XXJ_WS_SETPERSONAOBSERVER: "পার্সোনা অবজারভার সেট করুন",
  T_47_XXJ_WS_SETPLAYERCANQUITMIDWAY: "প্লেয়ার মিডওয়ে খেলা ছাড়তে পারবে সেট করুন",
  T_47_XXJ_WS_SHOULDREPLY: "উত্তর দেওয়া উচিত",
  T_47_XXJ_WS_SHOWSYSTEMREPLY: "সিস্টেমের উত্তর শো করুন",
  T_47_XXJ_WS_SPOTANGLE: "স্পট অ্যাঙ্গেল",
  T_47_XXJ_WS_SPOTLIGHT: "স্পটলাইট",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONA: "পারসোনায় সিস্টেম মেসেজ পাঠান",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONASTREAM: "সিস্টেম মেসেজগুলো পার্সোনায় স্ট্রিম করুন",
  T_47_XXJ_WS_TARGETTEAM: "টার্গেট টিম",
  T_47_XXJ_WS_THISENTITY: "এই এনটিটি",
  T_47_XXJ_WS_USERAVATAR: "ইউজার অ্যাভাটার",
  T_47_XXJ_WS_USERMESSAGETOPERSONA: "Persona-তে ইউজার মেসেজ পাঠান",
  T_47_XXJ_WS_USERMESSAGETOPERSONASTREAM: "ব্যবহারকারীর মেসেজগুলো Persona-তে স্ট্রিম করুন",
  T_47_XXJ_WS_USERNICKNAME: "ব্যবহারকারীর ডাকনাম",
  T_47_XXJ_WS_VEHICLESKINTYPE: "ভেহিকেল স্কিন টাইপ",
  T_47_XXJ_WS_WEAPONSKINTYPE: "ওয়েপন স্কিন টাইপ",
  T_47_XYL_NB_UGC_EFFECT001: "রাসেনগান VFX",
  T_47_XYL_NB_UGC_EFFECT002: "চিডোরি VFX",
  T_47_XYL_NB_UGC_EFFECT003: "চেরি ব্লসম ক্ল্যাশ VFX",
  T_47_XYL_NB_UGC_EFFECT004: "ফায়ারবল জুটসু VFX",
  T_47_XYL_NB_UGC_EFFECT005: "ওয়াটার ড্রাগন জুটসু VFX",
  T_47_XYL_NB_UGC_EFFECT006: "গ্রেট ব্রীচ VFX",
  T_47_XYL_NB_UGC_EFFECT007: "টেইল্ড বিস্ট বোম্ব VFX",
  T_47_XYL_NB_UGC_EFFECT008: "রিঅ্যানিমেশন অভিশাপ মার্ক VFX",
  T_47_XYL_UGC_CRAFTLANDSHOP: "অ্যাসেট স্টোর",
  T_47_XYL_UGC_DONKEYCART: "ডাঙ্কি কার্ট",
  T_47_XYL_UGC_SPOTLIGHT: "স্পটলাইট",
  T_47_XYL_UGC_SPOTLIGHTANGLE: "স্পটলাইট অ্যাঙ্গেল",
  T_48_H_EMOTE_WATERFEST25_N: "সুইফট স্টেপস",
  T_48_H_VEHICLESKIN_MOTOBIKE_WATERFEST25_N: "মোটরবাইক - সি ফোম",
  T_48_HJ_AC_STATENOTEXIST: "অ্যানিমেশন কন্ট্রোলারে স্টেট {0} বিদ্যমান নেই",
  T_48_HL_CODESCRIPT: "কোড স্ক্রিপ্ট",
  T_48_HL_GLOBAL_VAR: "গ্লোবাল ভেরিয়েবল নাম",
  T_48_HL_GRAPH: "ব্লক",
  T_48_HL_HUD: "HUD",
  T_48_HL_LEADERBOARD_NAME: "লিডারবোর্ড",
  T_48_HL_LOCAL_VAR: "স্থানীয় ভেরিয়েবল নাম",
  T_48_HL_LOCALIZATION: "লোকালাইজেশনের নাম",
  T_48_HL_OPEN_ATTRIBUTES: "অ্যাট্রিবিউট নাম খুলুন",
  T_48_HX_A_WATERFEST25: "সি ফোম (মাস্ক)",
  T_48_HX_B_WATERFEST25: "সি ফোম (বটম)",
  T_48_HX_F_B_BLACKDRESS: "অ্যান্টিম্যাটার (বটম)",
  T_48_HX_F_H_BLACKDRESS: "অ্যান্টিম্যাটার (হেড)",
  T_48_HX_F_HA_BLACKDRESS: "অ্যান্টিম্যাটার (ফেসপেইন্ট)",
  T_48_HX_F_S_BLACKDRESS: "অ্যান্টিম্যাটার (জুতা)",
  T_48_HX_F_T_BLACKDRESS: "অ্যান্টিম্যাটার (টপ)",
  T_48_HX_H_WATERFEST25: "সি ফোম (হেড)",
  T_48_HX_HA_WATERFEST25: "সি ফোম (ফেসপেইন্ট)",
  T_48_HX_M_A_BLACKDRESS: "ডার্ক ম্যাটার (মাস্ক)",
  T_48_HX_M_B_BLACKDRESS: "ডার্ক ম্যাটার (বটম)",
  T_48_HX_M_H_BLACKDRESS: "ডার্ক ম্যাটার (হেড)",
  T_48_HX_M_HA_BLACKDRESS: "ডার্ক ম্যাটার (ফেসপেইন্ট)",
  T_48_HX_M_S_BLACKDRESS: "ডার্ক ম্যাটার (জুতা)",
  T_48_HX_M_T_BLACKDRESS: "ডার্ক ম্যাটার (টপ)",
  T_48_HX_S_WATERFEST25: "সি ফোম (জুতা)",
  T_48_HX_T_WATERFEST25: "সি ফোম (টপ)",
  T_48_JH_WS_STRINGDESC: "একটি প্যারাগ্রাফ বা অন্যান্য স্ট্রিং লিখুন। কিছু উইজেট রিচ টেক্সট ডিসপ্লে করতে পারে। রিচ টেক্সট সহ টেক্সটে কালার যোগ করতে নিম্নলিখিত ফরম্যাট ব্যবহার করুন: [#XXXXXX] টেক্সট টেক্সট [-]। “#XXXXXX” হল সেই কালার যা আপনি ডিসপ্লে করতে চান। অনুগ্রহ করে মনে রাখবেন যে সংশ্লিষ্ট উইজেটের টেক্সট কালার সাদা সেট করতে হবে।",
  T_48_M_WS_P_ICON: "অ্যাভাটার",
  T_48_META_API_10001: "ID দ্বারা এনটিটি খুঁজুন",
  T_48_META_API_10001_P0: "এনটিটি ID",
  T_48_META_API_1098: "ব্যাচ রিড ডাটাবেস শিটের ভ্যালু",
  T_48_META_API_1098_D: "নির্দিষ্ট একটি ডাটাবেস শিট থেকে একাধিক ডাটা এন্ট্রি ব্যাচ আকারে পাঠ করুন, যেখানে প্রতিটি ইউনিক প্লেয়ার ID এন্ট্রি সংশ্লিষ্ট কী তালিকার সাথে একের পর এক মিলে যাবে।",
  T_48_META_API_1098_P1: "অ্যাকাউন্ট ID",
  T_48_META_API_1098_P1_D: "ইউনিক প্লেয়ার ID লিস্ট, যা কী লিস্টে একই ইনডেক্স-এ থাকা কীগুলোর সাথে সম্পর্কিত ডেটা পড়ে।",
  T_48_META_API_1098_P2: "কী",
  T_48_META_API_1098_P2_D: "কীসমূহের তালিকা, যেগুলো ID লিস্টের একই ইনডেক্সে থাকা ইউনিক প্লেয়ার আইডিগুলির সাথে সম্পর্কিত ডেটা পড়ে।",
  T_48_META_API_1098_P5: "স্ট্যাটাস কোড",
  T_48_META_API_1098_P5_D: "স্ট্যাটাস কোডের তালিকা",
  T_48_META_API_1105: "প্লট শুরু হলে নোটিফাই করুন",
  T_48_META_API_1105_D: "ট্রিগারিং প্লেয়ারের জন্য নির্দিষ্ট প্লটে প্লেয়িং শুরু করুন",
  T_48_META_API_1105_P1_D: "প্লট ID",
  T_48_META_API_1108: "লোকাল ভাষা নির্বাচন করুন",
  T_48_META_API_1500_P0: "ভেক্টর",
  T_48_META_API_1505_P1: "Z",
  T_48_META_API_3300: "বডি পার্ট ওয়েট সেট করুন",
  T_48_META_API_3300_D: "অন্যান্য নিম্ন-অগ্রাধিকার অ্যানিমেশনের সাথে ব্লেন্ডিং-এর সময় টার্গেট বডি পার্টের ওয়েট সেট করুন",
  T_48_META_API_3300_P0_D: "যে অ্যানিমেশন কন্ট্রোলার কম্পোনেন্টটি বডি পার্টের অন্তর্ভুক্ত তা যোগ করা যাবে",
  T_48_META_API_3300_P1: "বডি পার্ট নেম",
  T_48_META_API_3300_P1_D: "বডি পার্ট নেম",
  T_48_META_API_3300_P2: "ওয়েট",
  T_48_META_API_3300_P2_D: "[0, 1] ভ্যালু রেঞ্জ সহ ওয়েট, যা নিম্ন-অগ্রাধিকার অ্যানিমেশনের সাথে ব্লেন্ডারের ডিগ্রি প্রতিনিধিত্ব করে।",
  T_48_META_API_3315: "ক্যারেক্টার অ্যানিমেশন ক্লিপ ওভাররাইড করুন",
  T_48_META_API_3315_D: "গেমের ডিফল্ট অ্যানিমেশন ওভাররাইড করার অপশন সহ একটি ক্যারেক্টার অ্যানিমেশন ক্লিপ প্লে করুন",
  T_48_META_API_3315_P3: "গেমপ্লে কন্ট্রোল ওভাররাইড করুন",
  T_48_META_API_3315_P3_D: "গেমের ডিফল্ট অ্যানিমেশন ওভাররাইড করবেন কিনা",
  T_48_META_API_3316: "অ্যানিমেশন বন্ধ করুন",
  T_48_META_API_3316_D: "নির্দিষ্ট স্ট্যাটাসে টার্গেটের জন্য অ্যানিমেশন প্লে বন্ধ করুন",
  T_48_META_API_90_P1: "মিডওয়ে থেকে প্রস্থান করতে পারবেন",
  T_48_META_API_93: "পাথ বরাবর মোশন ক্রিয়েট করুন",
  T_48_META_API_93_D: "নির্দিষ্ট পাথ বরাবর অবজেক্টটিকে মুভ করতে পাথ বরাবর একটি ইন্টারপোলেটেড মুভমেন্ট তৈরি করুন।",
  T_48_META_API_93_P1: "পাথ",
  T_48_META_API_93_P1_D: "দ্য পাথ অফ মোশন",
  T_48_META_API_93_P3_D: "গতিবেগের মাত্রা",
  T_48_META_API_93_P4: "ট্যানজেন্ট ফেসিং",
  T_48_META_API_93_P4_D: "এই অবজেক্টটি তার গতির দিকে মুখ করে আছে কিনা। অবজেক্টের অভিমুখ জোরপূর্বক অন্য কোনো উপায়ে পরিবর্তন করা হলেও এই বৈশিষ্ট্যটি অপরিবর্তিত থাকে।",
  T_48_META_API_96: "ইনস্ট্যানশিয়েট প্রিফ্যাব",
  T_48_META_API_96_D: "অ্যাসিঙ্ক্রোনাসভাবে প্রসেস করার অপশন সহ একটি প্রিফ্যাব ইনস্ট্যান্স তৈরি করুন",
  T_48_META_API_96_P2: "অ্যাসিঙ্ক লোড",
  T_48_META_API_96_P2_D: "লোডিং অ্যাসিঙ্ক্রোনাস কিনা",
  T_48_META_EVT_3140: "টিম পরিবর্তন হলে অন করুন",
  T_48_META_EVT_3140_D: "বর্তমান এনটিটি টিম পরিবর্তন হওয়ার সাথে সাথেই ট্রিগার হয়",
  T_48_META_EVT_3140_P0: "সাবেক টিম",
  T_48_META_EVT_3140_P0_D: "পরিবর্তনের আগে যেই টিমে ছিলেন",
  T_48_META_EVT_3140_P1: "বর্তমান টিম",
  T_48_META_EVT_3140_P1_D: "পরিবর্তনের পর টিমে যুক্ত হয়েছেন",
  T_48_META_EVT_3141: "প্লট স্টার্ট হলে অন করুন",
  T_48_META_EVT_3141_D: "প্লট প্লে শুরু হওয়ার সাথে সাথেই ট্রিগার হয়",
  T_48_META_EVT_3141_P1: "প্লট ID",
  T_48_META_EVT_3141_P1_D: "প্লট ID",
  T_48_META_EVT_3142: "প্লট শেষ হলে অন করুন",
  T_48_META_EVT_3142_D: "প্লট শেষ হলে ট্রিগার হয়",
  T_48_META_EVT_3142_P0_D: "ট্রিগারিং প্লেয়ার",
  T_48_META_EVT_3142_P1_D: "প্লট ID",
  T_48_META_EVT_3143: "ট্রিগার প্লট অপশন অন করুন",
  T_48_META_EVT_3143_D: "প্লটে একটি অপশন সিলেক্টে করার সময় ট্রিগার হয়",
  T_48_META_EVT_3143_P1_D: "প্লট ID",
  T_48_META_EVT_3143_P2: "অপশন ID",
  T_48_META_EVT_3143_P2_D: "যে অপশন সিলেক্টেড করা হয়েছে, তার ID",
  T_48_META_TYP_409_I10: "টিম পরিবর্তন ব্যর্থ_অকার্যকর টিম",
  T_48_META_TYP_409_I11: "টিম পরিবর্তন ব্যর্থ_এলিমিনেটেড হয়েছেন",
  T_48_META_TYP_409_I12: "ভেহিকেলে_টিম পরিবর্তন করতে ব্যর্থ",
  T_48_META_TYP_409_I7: "টিম পরিবর্তন ব্যর্থ_সাপোর্টেড নয়",
  T_48_META_TYP_409_I8: "টিম পরিবর্তন ব্যর্থ_আগে থেকেই টিমে আছে",
  T_48_META_TYP_409_I9: "টিম পরিবর্তন ব্যর্থ_অকার্যকর টার্গেট",
  T_48_META_TYP_41_I19: "কোলাইডার ডিজেবল করুন",
  T_48_META_TYP_417: "পার্টিকলস",
  T_48_META_TYP_428: "প্লেয়ার ট্রান্সফর্ম বা NPC আউটফিট",
  T_48_META_TYP_431: "পাথ বরাবর মোশন",
  T_48_META_TYP_431_I1: "পাথ",
  T_48_META_TYP_432: "কাস্টম কার্ভ পাথ ওয়েপয়েন্ট",
  T_48_META_TYP_432_I0: "রোল",
  T_48_META_TYP_432_I1: "ট্যানজেন্ট",
  T_48_META_TYP_433: "কাস্টম কার্ভ পাথ টাইপ",
  T_48_META_TYP_433_I0: "লিনিয়ার",
  T_48_META_TYP_433_I1: "স্মুথ",
  T_48_META_TYP_433_I2: "কাস্টম",
  T_48_META_TYP_434: "কাস্টম কার্ভ পাথ",
  T_48_META_TYP_434_I2: "ক্লোজড লুপ",
  T_48_META_TYP_434_I3: "ওয়েপয়েন্টস",
  T_48_META_TYP_437_I5: "স্কোর টাইপের নাম",
  T_48_META_TYP_437_I6: "বামদিকে স্কোর কন্টেন্ট",
  T_48_META_TYP_437_I7: "ডানদিকে স্কোর কন্টেন্ট",
  T_48_META_TYP_438_I1: "প্লেয়ারগণ",
  T_48_META_TYP_438_I2: "র‍্যাংক",
  T_48_META_TYP_438_I3: "মোট স্কোর",
  T_48_META_TYP_438_I4: "স্কোর টাইপের নাম",
  T_48_META_TYP_438_I5: "কালার্স",
  T_48_META_TYP_438_I6: "স্কোর",
  T_48_META_TYP_439: "গ্রুপ",
  T_48_META_TYP_442_I1: "বামদিকের স্কোর",
  T_48_META_TYP_442_I10: "ডানদিকে এলিমিনেটেড আইকন",
  T_48_META_TYP_442_I2: "ডানদিকে স্কোর",
  T_48_META_TYP_442_I3: "বামদিকে অ্যালাইভ নাম্বার",
  T_48_META_TYP_442_I4: "ডানদিকে অ্যালাইভ নাম্বার",
  T_48_META_TYP_442_I5: "বামে এলিমিনেটেড নাম্বার",
  T_48_META_TYP_442_I6: "ডানে এলিমিনেটেড নাম্বার",
  T_48_META_TYP_442_I7: "বামদিকে অ্যালাইভ আইকন",
  T_48_META_TYP_442_I8: "ডানদিকে অ্যালাইভ আইকন",
  T_48_META_TYP_442_I9: "বামদিকে এলিমিনেটেড আইকন",
  T_48_META_TYP_444: "ভাষার ধরণ",
  T_48_META_TYP_444_I0: "ইংরেজি",
  T_48_META_TYP_444_I1: "সিম্প্লিফাইড চাইনিজ",
  T_48_META_TYP_444_I10: "ফ্রেঞ্চ",
  T_48_META_TYP_444_I11: "জার্মান",
  T_48_META_TYP_444_I12: "তুর্কি",
  T_48_META_TYP_444_I13: "হিন্দি",
  T_48_META_TYP_444_I14: "জাপানি",
  T_48_META_TYP_444_I15: "রোমানিয়ান",
  T_48_META_TYP_444_I16: "আরবি",
  T_48_META_TYP_444_I17: "বার্মিজ",
  T_48_META_TYP_444_I18: "উর্দু",
  T_48_META_TYP_444_I19: "বাংলা",
  T_48_META_TYP_444_I2: "ট্র্যাডিশনাল চাইনিজ",
  T_48_META_TYP_444_I3: "থাই",
  T_48_META_TYP_444_I4: "ভিয়েতনামী",
  T_48_META_TYP_444_I5: "ইন্দোনেশিয়ান",
  T_48_META_TYP_444_I6: "পর্তুগীজ",
  T_48_META_TYP_444_I7: "স্পেনীশ",
  T_48_META_TYP_444_I8: "রাশিয়ান",
  T_48_META_TYP_444_I9: "কোরিয়ান",
  T_48_SD_ERROR_DIVISOR: "ভাজক 0 হতে পারে না",
  T_48_SD_ERROR_KEY_NOTINMAP: "নির্দিষ্ট কী ম্যাপে বিদ্যমান নেই: {0}",
  T_48_SD_ERROR_LIST_OUTRANGE: "লিস্ট ইনডেক্স রেঞ্জের বাইরে: {0}",
  T_48_SD_SK_WARNING: "{0} এ {1} পাওয়া যায় নাই",
  T_48_TYC_WS_WARNING_SERVER_DRIVEN_DISABLED: 'যেহেতু ক্র্যাফটল্যান্ড ক্যারেক্টার কন্ট্রোলার {0} এর অ্যাট্রিবিউট "IsServerDriven" ডিজেবল করা হয়েছে, তাই সম্পর্কিত সার্ভার API কার্যকর হবে না।',
  T_48_XXJ_WS_PARENTERROR: "প্যারেন্ট সেট করতে ব্যর্থ",
  T_48_XXJ_WS_PERFORMANCE: "পারফরম্যান্স",
  T_48_XXJ_WS_TANGENT: "ট্যানজেন্ট",
  T_48_XXJ_WS_WAYPOINT: "ওয়েপয়েন্ট",
  T_48_XYL_UGC_COMPOSITEOJBECTLIST: "অবজেক্টের লিস্ট",
  T_48_XYL_UGC_CUSTOMIZEMINIMAP: "কাস্টম মিনিম্যাপ ব্যবহার করুন",
  T_48_XYL_UGC_HIDEMINIMAP: "মিনিম্যাপ HUD হাইড করুন",
  T_48_XYL_WS_BASICCUSTOMSURFACE: "বেসিক কাস্টম সারফেস",
  T_48_XYL_WS_BASICCYLINDERCUTOUT: "সিলিন্ডার কাটআউট",
  T_48_XYL_WS_BASICHEMISPHERE: "বেসিক হেমিস্ফিয়ার",
  T_48_XYL_WS_BASICQUARTERROUNDEDTORUS: "কোয়ার্টার টোরাস",
  T_48_XYL_WS_BASICQUARTERTORUS: "কোয়ার্টার স্কয়ার টোরাস",
  T_48_XYL_WS_BASICROUNDEDTORUS: "টোরাস",
  T_48_XYL_WS_BASICTRIANGLE: "ট্রাইঅ্যাংগল সারফেস",
  T_48_XYL_WS_MAPPLAYERSTIPS: "ম্যাচ প্লেয়ার = টিমের সংখ্যা × প্রতি টিমে প্লেয়ারের সংখ্যা। ম্যাচে প্লেয়ার যত বেশি হবে, ম্যাচমেকিংয়ে তত বেশি সময় লাগবে।",
  T_48_XYL_WS_MAPPLAYERSWARNING: "ম্যাচে প্লেয়ারের সংখ্যা বেশি হলে ম্যাচমেকিংয়ে বেশি সময় লাগতে পারে",
  T_49_HL_CL_CREATOR_LABEL2: "ক্রাফটল্যান্ড কমিউনিটি ট্যালেন্ট",
  T_49_HL_CL_MAPS_LABEL2: "ম্যাপ উইনার",
  T_49_HL_CL_MAPS_LABEL3: "গেমপ্লে উইনার",
  T_49_HX_T_TUNG: "Tung Tung Tung",
  T_49_HZY_CONTROLLER_TRAJECTORY: "গতিপথ",
  T_49_JH_WS_SKILLKASSIE: "ইলেক্ট্রো থেরাপি (ক্যাসি)",
  T_49_JH_WS_SKILLKODA: "অরোরা ভিশন (কোডা)",
  T_49_JH_WS_SKILLOSCAR: "ভ্যালিয়েন্ট ড্যাশ (অস্কার)",
  T_49_LXW_EIGHTHB_EDIT_AITRAIN_ENTRANCE: "AI দ্বারা জেনারেট করুন",
  T_49_META_API_10065: "কাস্টম ক্যামেরা সুইচ করুন",
  T_49_META_API_10067: "বর্তমান কাস্টম ক্যামেরা পান",
  T_49_META_API_10069: "কাস্টম ক্যামেরা তৈরি করুন",
  T_49_META_API_10070: "কাস্টম ক্যামেরার কালিং মাস্ক সেট করুন",
  T_49_META_API_10070_D: "সকল লেয়ার জুড়ে ভিজিবিলিটি কন্ট্রোল করার জন্য টার্গেট ক্যামেরার কালিং মাস্ক সেট করুন",
  T_49_META_API_10071: "কাস্টম ক্যামেরা কালিং মাস্ক পান",
  T_49_META_API_10071_D: "টার্গেট ক্যামেরার কালিং মাস্কটি পান",
  T_49_META_API_10072: "কাস্টম ক্যামেরার কালিং মাস্ক লেয়ার সেট করুন",
  T_49_META_API_10072_D: "একটি নির্দিষ্ট স্তরের জন্য টার্গেট ক্যামেরার ভিজিবিলিটি সেট করুন",
  T_49_META_API_10073: "স্ক্রিনশট ক্যাপচার করুন",
  T_49_META_API_10073_D: "স্ক্রিনশট ক্যাপচার করুন (অভ্যন্তরীণ পরীক্ষার জন্য)",
  T_49_META_API_106: "সার্ভার টাইমস্ট্যাম্প (ms) পান",
  T_49_META_API_106_D: "মিলিসেকেন্ড নির্ভুলতার সাথে সার্ভার টাইমস্ট্যাম্প পান",
  T_49_META_API_107: "টাইমস্ট্যাম্প থেকে লোকালাইজড স্ট্রিং (ms)",
  T_49_META_API_107_D: "নির্দিষ্ট ফরম্যাট অনুযায়ী টাইমস্ট্যাম্পগুলো (ms) স্ট্রিং-এ কনভার্ট করুন",
  T_49_META_API_107_P0: "টাইমস্ট্যাম্প (ms)",
  T_49_META_API_107_P0_D: "মিলিসেকেন্ডে একটি টাইমস্ট্যাম্প",
  T_49_META_API_108: "লার্প ভেক্টর3",
  T_49_META_API_108_D: "3D ভেক্টর A থেকে ভেক্টর B পর্যন্ত লিনিয়ার ইন্টারপোলেশন পারফর্ম করুন",
  T_49_META_API_1089_P2: "রিকুয়েস্ট ID",
  T_49_META_API_109: "কনটেক্সট পার্সোনাতে আপডেট করুন",
  T_49_META_API_109_D: "বর্তমান রুমে নির্দিষ্ট একটি পার্সোনার মডেল কনটেক্সট আপডেট করুন এবং কার্যকর হওয়ার পর মূল কনটেক্সট ওভাররাইট করুন। এই কনটেক্সট বর্তমান ডায়ালগে পার্সোনার ব্যাকগ্রাউন্ড, হিস্ট্রি বা নির্দিষ্ট কিছু প্যারামিটার বোঝার উপর প্রভাব ফেলবে।",
  T_49_META_API_109_P1: "প্রেক্ষাপট",
  T_49_META_API_109_P1_D: "প্রেক্ষাপটের বিস্তারিত",
  T_49_META_API_110: "পারসোনা রেসপন্স সম্পর্কে প্রতিক্রিয়া",
  T_49_META_API_110_D: "পার্সোনার রেসপন্স কন্টেন্টের উপর ফিডব্যাক জমা দিন, যা আমাদের মডেল অপ্টিমাইজ করতে ব্যবহৃত হবে।",
  T_49_META_API_110_P1: "পছন্দ হয়েছে",
  T_49_META_API_110_P1_D: "প্রতিক্রিয়াটি পছন্দ হয়েছে কিনা। True = like.",
  T_49_META_API_1109: "স্থানীয় প্লেয়ার পজিশন সেট করুন",
  T_49_META_API_1109_D: "যখন প্লেয়ার ক্লাসিক গেমের ক্যারেক্টার ব্যবহার করে, তখন এই API প্লেয়ার'স পজিশন নির্ধারণ করতে পারে।",
  T_49_META_API_1109_P0_D: "টার্গেট পজিশন",
  T_49_META_API_111: "স্লার্প ভেক্টর3",
  T_49_META_API_111_D: "স্মুথ রোটেশনের জন্য 3D ভেক্টর A থেকে ভেক্টর B পর্যন্ত গোলাকার ইন্টারপোলেশন পারফর্ম করুন",
  T_49_META_API_1110: "স্থানীয় প্লেয়ার ফরোয়ার্ড সেট করুন",
  T_49_META_API_1110_D: "যখন প্লেয়ার ক্লাসিক গেমের ক্যারেক্টার ব্যবহার করে, তখন এই API প্লেয়ার কোন দিকে মুখ করে আছে তা সেট করতে পারে",
  T_49_META_API_1110_P0_D: "সামনের ভেক্টর",
  T_49_META_API_112: "পারসোনা মেমোরি রোল ব্যাক করুন",
  T_49_META_API_112_D: "একটি নির্দিষ্ট রেসপন্স আইডির আগের সময়ে পার্সোনার মেমোরি রোল ব্যাক করুন। উক্ত রেসপন্সসহ পরবর্তী সব ডায়ালগের মেমোরি সাফ করা হবে।",
  T_49_META_API_113: "ওয়ান শট সাউন্ড প্লে করুন",
  T_49_META_API_113_D: "ওয়ান-শট সাউন্ড ইফেক্ট প্লে করুণ যা ভলিউম অ্যাডজাস্ট করা যায়",
  T_49_META_API_113_P0_D: "যে সাউন্ড ইফেক্ট প্লে করা হবে তার রিসোর্স ID",
  T_49_META_API_113_P1: "ভলিউম",
  T_49_META_API_113_P1_D: "সাউন্ড ইফেক্টের জন্য প্লেব্যাক ভলিউম, 0 থেকে 1 পর্যন্ত।",
  T_49_META_API_97: "স্কেলেটন পার্ট লুক-এট কন্ট্রোলার তৈরি করুন",
  T_49_META_API_97_D: "একটি স্কেলেটন পার্ট লুক-অ্যাট কন্ট্রোলার এনটিটি তৈরি করার পর, আপনি এই এনটিটিকে ব্যবহার করে নির্দিষ্ট স্কেলেটন পার্টটি কন্ট্রোল করতে পারবেন এবং সেটিকে সবসময় একটি নির্দিষ্ট টার্গেটের দিকে ফেস করে রাখতে পারবেন।",
  T_49_META_API_97_P0_D: "স্কেলেটন-এর 'লুক-এট' কন্ট্রোলার এন্টিটি। যদি এই এন্টিটি ধ্বংস হয়ে যায়, তবে 'লুক-এট' ফাংশনালিটিও বন্ধ হয়ে যাবে।",
  T_49_META_API_97_P1_D: "স্কেলেটন এর যে পার্ট কন্ট্রোল করা হচ্ছে",
  T_49_META_API_97_P2_D: "যে টার্গেটের দিকে তাকানো হচ্ছে",
  T_49_META_API_98: "প্রজেকশন",
  T_49_META_API_98_D: "ভেক্টর A ভেক্টর B এর উপর প্রজেকশন ক্যালকুলেট করুন",
  T_49_META_API_99: "লোকাল টাইমস্ট্যাম্প (ms) পান",
  T_49_META_API_99_D: "মিলিসেকেন্ড নির্ভুলতার সাথে স্থানীয় টাইমস্ট্যাম্প পান",
  T_49_META_EVT_16_P1_D: "0 থেকে শুরু করে, প্রতিটি আউটগোয়িং রিকোয়েস্ট একটি সিকোয়েনশিয়াল নাম্বার ID ব্যবহার করবে, যেমনঃ রুম তৈরি করা এবং মেমরি ক্লিয়ার করা।",
  T_49_META_EVT_16_P2: "প্রতিক্রিয়া ID",
  T_49_META_EVT_16_P2_D: "প্রতিটা কমপ্লিট প্রতিক্রিয়ার একটি ইউনিক ID থাকবে",
  T_49_META_TYP_122_I19: "কাস্টম ম্যাটেরিয়াল",
  T_49_META_TYP_122_I19_D: "একটি কাস্টম উপাদান দিয়ে স্কাইবক্স রিপ্লেস করার অনুমতি দিন",
  T_49_META_TYP_14_I78_D: "প্লেয়ারের ক্লায়েন্ট বর্তমানে সিন রেন্ডার করছে, এমন ক্যামেরা এনটিটি অর্জন করুন বা সেট করুন। নোটঃ ক্যামেরা এনটিটি মূলত ক্লায়েন্ট-সাইড ক্যামেরা কন্ট্রোলিং-এর কনফিগারেশন ডেটা প্রতিনিধিত্ব করে।",
  T_49_META_TYP_335_I9: "অতিবাহিত সময় (ms)",
  T_49_META_TYP_335_I9_D: "মিলিসেকেন্ডে সাউন্ড ইফেক্টের প্লেব্যাক সময়কাল। এই ফিচারটি শুধুমাত্র ক্লায়েন্ট সাইডে অ্যাক্সেস করা যেতে পারে।",
  T_49_META_TYP_409_I13: "LLM_ওকে",
  T_49_META_TYP_409_I13_D: "LLM_ওকে",
  T_49_META_TYP_409_I14: "LLM_ব্যর্থ",
  T_49_META_TYP_409_I14_D: "LLM_ব্যর্থ",
  T_49_META_TYP_409_I15: "LLM_টাইমআউট",
  T_49_META_TYP_409_I15_D: "LLM_টাইমআউট",
  T_49_META_TYP_409_I16: "LLM_অকার্যকর_পার্সোনা",
  T_49_META_TYP_409_I16_D: "LLM_অকার্যকর_পার্সোনা বা রুম",
  T_49_META_TYP_409_I17: "LLM_টোকেন_লিমিট",
  T_49_META_TYP_409_I17_D: "LLM_টোকেন_লিমিট",
  T_49_META_TYP_409_I18: "LLM_ভায়োলেশন",
  T_49_META_TYP_409_I18_D: "LLM_ঘন ঘন_রিকুয়েস্ট",
  T_49_META_TYP_409_I19: "LLM_ঘন ঘন_রিকুয়েস্ট",
  T_49_META_TYP_409_I19_D: "LLM_ঘন ঘন_রিকুয়েস্ট",
  T_49_META_TYP_441: "পারফরম্যান্স ID",
  T_49_META_TYP_445: "প্লেয়েবল কন্ট্রোলার ID",
  T_49_META_TYP_446: "প্লেয়েবল কন্ট্রোলার অ্যাটাচেবল",
  T_49_META_TYP_446_I0: "প্লেয়েবল কন্ট্রোলার",
  T_49_META_TYP_447: "স্কেলেটন পার্ট কন্ট্রোলার",
  T_49_META_TYP_448: "স্কেলেটন পার্ট লুক-এট কন্ট্রোলার",
  T_49_META_TYP_448_I0: "নিয়ন্ত্রিত টার্গেট",
  T_49_META_TYP_448_I1: "লুক-এট টার্গেট",
  T_49_META_TYP_449: "কাস্টম ক্যামেরা",
  T_49_META_TYP_449_I2: "অর্থোগ্রাফিক সাইজ",
  T_49_META_TYP_449_I2_D: "ক্যামেরায় দৃশ্যমান এরিয়ার সাইজ কন্ট্রোল করুন",
  T_49_META_TYP_450: "টাইমস্ট্যাম্প লোকালাইজড স্ট্রিং (ms)",
  T_49_META_TYPE_449_D: "একটি কাস্টম ক্যামেরা সম্পূর্ণভাবে ডেভেলপার দ্বারা নিয়ন্ত্রিত হয় এবং গেমপ্লে চলাকালীন প্লেয়ার কী দেখবে তা নির্ধারণ করে",
  T_49_META_TYPE_450_D: "মিলিসেকেন্ড-লেভেল টাইমস্ট্যাম্পকে একটি পাঠযোগ্য টেক্সট ফরম্যাটে রূপান্তর করুন",
  T_49_SD_SEARCH_ICONDESC: "স্মার্ট অ্যাসোসিয়েশন",
  T_49_SD_SEARCHKEY_ACTION: "অ্যাকশন",
  T_49_SD_SEARCHKEY_ANICLIPID: "অ্যানিমেশন ক্লিপ ID",
  T_49_SD_SEARCHKEY_AS: "যেমন",
  T_49_SD_SEARCHKEY_ATTACHMENTENUM: "অ্যাটাচমেন্ট ID",
  T_49_SD_SEARCHKEY_AUDIOENUM: "সাউন্ড ইফেক্ট টাইপ",
  T_49_SD_SEARCHKEY_BAGSKINID: "ব্যাকপ্যাক - স্কিন ID",
  T_49_SD_SEARCHKEY_BEZIER: "বেজিয়ার কার্ভ",
  T_49_SD_SEARCHKEY_BOOL: "বুলিয়ান",
  T_49_SD_SEARCHKEY_BREAK: "ব্রেক",
  T_49_SD_SEARCHKEY_BTREEID: "বিহেভিয়ার ট্রি ID",
  T_49_SD_SEARCHKEY_BUTTONCLICK: "বাটন ক্লিক করার সময়",
  T_49_SD_SEARCHKEY_BUTTONDOUBLECLICK: "অন বাটনে ডাবল ক্লিক করা হয়েছে",
  T_49_SD_SEARCHKEY_BUTTONPRESS: "বাটন প্রেস করার সময়",
  T_49_SD_SEARCHKEY_BUTTONRELEASE: "বাটন রিলিজের ক্ষেত্রে",
  T_49_SD_SEARCHKEY_CLOTHENUM: "আউটফিট টাইপ",
  T_49_SD_SEARCHKEY_COLOR: "কালার",
  T_49_SD_SEARCHKEY_COMMENT: "কমেন্ট নোট",
  T_49_SD_SEARCHKEY_COMPARER: "= > < ≠",
  T_49_SD_SEARCHKEY_COMPONENTENUM: "কম্পোনেন্ট এনাম",
  T_49_SD_SEARCHKEY_CONCANT: "সংযোগ",
  T_49_SD_SEARCHKEY_CONTINUE: "চালিয়ে যান",
  T_49_SD_SEARCHKEY_CUSTOMHUD: "কাস্টম HUD",
  T_49_SD_SEARCHKEY_CUSTOMHUDWIDGET: "কাস্টম hud উইজেট",
  T_49_SD_SEARCHKEY_DYNAMICITEMENUM: "ডায়নামিক লেভেল অবজেক্ট টাইপ তৈরি করুন",
  T_49_SD_SEARCHKEY_E: "E",
  T_49_SD_SEARCHKEY_EFFECTENUM: "ভিজ্যুয়াল ইফেক্ট টাইপ",
  T_49_SD_SEARCHKEY_ENTITY: "সিনের অবজেক্ট সিলেক্ট করুন",
  T_49_SD_SEARCHKEY_FLOAT: "ফ্লোট",
  T_49_SD_SEARCHKEY_FOR: "ইন্ডেক্সের জন্য",
  T_49_SD_SEARCHKEY_FOREACH: "প্রতিটির জন্য",
  T_49_SD_SEARCHKEY_FUNCTION: "ফাংশন",
  T_49_SD_SEARCHKEY_GETCSV: "CSV পান",
  T_49_SD_SEARCHKEY_GETREGISTERED: "কী দ্বারা রেজিস্টার্ড অ্যাসেট পান",
  T_49_SD_SEARCHKEY_GETVALUE: "প্রপার্টির ভ্যালু পান",
  T_49_SD_SEARCHKEY_GLOBALVARGET: "গ্লোবাল ভেরিয়েবল সেট করুন",
  T_49_SD_SEARCHKEY_GLOBALVARSET: "গ্লোবাল ভেরিয়েবল সেট করুন",
  T_49_SD_SEARCHKEY_IF: "যদি",
  T_49_SD_SEARCHKEY_IFELSE: "অন্যথায়",
  T_49_SD_SEARCHKEY_IMGENUM: "স্প্রাইট টাইপ",
  T_49_SD_SEARCHKEY_INT: "পূর্ণসংখ্যা",
  T_49_SD_SEARCHKEY_INTERNALHUD: "HUD টাইপ",
  T_49_SD_SEARCHKEY_ITEMENUM: "আইটেম টাইপ",
  T_49_SD_SEARCHKEY_LISTAPPEND: "লিস্টে যুক্ত করুন",
  T_49_SD_SEARCHKEY_LISTAPPENDRANGE: "লিস্টে রেঞ্জ যুক্ত করুন",
  T_49_SD_SEARCHKEY_LISTCLEAR: "লিস্ট ক্লেয়ার",
  T_49_SD_SEARCHKEY_LISTCLONE: "লিস্ট ক্লোন",
  T_49_SD_SEARCHKEY_LISTCONTAIN: "লিস্টে রয়েছে",
  T_49_SD_SEARCHKEY_LISTCREATE: "লিস্ট ক্রিয়েট করুন",
  T_49_SD_SEARCHKEY_LISTDELETE: "লিস্ট ডিলিট করুন",
  T_49_SD_SEARCHKEY_LISTGET: "লিস্ট পান",
  T_49_SD_SEARCHKEY_LISTINDEXOF: "লিস্টের ইনডেক্স",
  T_49_SD_SEARCHKEY_LISTINSERT: "লিস্ট ইনসার্ট করুন",
  T_49_SD_SEARCHKEY_LISTLASTINDEXOF: "লিস্টের শেষ ইনডেক্স",
  T_49_SD_SEARCHKEY_LISTLENGTH: "লিস্টের দৈর্ঘ্য",
  T_49_SD_SEARCHKEY_LISTREVERSE: "লিস্ট রিভার্স",
  T_49_SD_SEARCHKEY_LISTSET: "লিস্ট সেট করুন",
  T_49_SD_SEARCHKEY_LISTSHUFFLE: "লিস্ট শাফেল",
  T_49_SD_SEARCHKEY_LOCALKEY: "স্থানীয়কৃত কী",
  T_49_SD_SEARCHKEY_LOCALVAR: "লোকাল ভেরিয়েবল",
  T_49_SD_SEARCHKEY_LOGICAL: "এবং অথবা",
  T_49_SD_SEARCHKEY_LOGINFO: "লগ ইনফো প্রিন্ট করুন",
  T_49_SD_SEARCHKEY_MAPALLKEYS: "dict-এর সকল keyপান ম্যাপের সকল key পান",
  T_49_SD_SEARCHKEY_MAPCLEAR: "dict ক্লিয়ার, ম্যাপ ক্লিয়ার",
  T_49_SD_SEARCHKEY_MAPCONTAIN: "dict কনটেইন key, ম্যাপ কনটেইন key",
  T_49_SD_SEARCHKEY_MAPCREATE: "ডিক্ট তৈরি করুন, ম্যাপ তৈরি করুন",
  T_49_SD_SEARCHKEY_MAPGET: "কী দ্বারা dict ভ্যালু পান কী দ্বারা ম্যাপ ভ্যালু পান",
  T_49_SD_SEARCHKEY_MAPLENGTH: "dict লেংথ, ম্যাপ লেংথ",
  T_49_SD_SEARCHKEY_MAPREMOVE: "dict রিমুভ করুন, ম্যাপ রিমুভ করুন",
  T_49_SD_SEARCHKEY_MAPSET: "dict ভ্যালু সেট করুন, ম্যাপ ভ্যালু সেট করুন",
  T_49_SD_SEARCHKEY_MATH: "যোগ, বিয়োগ, গুণ, ভাগ,",
  T_49_SD_SEARCHKEY_NEWLIST: "নতুন লিস্ট",
  T_49_SD_SEARCHKEY_NULL: "খালি",
  T_49_SD_SEARCHKEY_NUMTOSTRING: "স্ট্রিং থেকে সংখ্যা",
  T_49_SD_SEARCHKEY_PARTICLESENUM: "পার্টিকল প্রপার্টিজ",
  T_49_SD_SEARCHKEY_PERSONA: "পার্সোনা",
  T_49_SD_SEARCHKEY_PI: "PI",
  T_49_SD_SEARCHKEY_PLAYERDATAID: "প্লেয়ার ডেটা ID",
  T_49_SD_SEARCHKEY_PLAYERSKILLENUM: "ক্যারেক্টার স্কিল টাইপ",
  T_49_SD_SEARCHKEY_PREEFFECT: "স্পেশাল স্টিকার টাইপ",
  T_49_SD_SEARCHKEY_PREFAB: "প্রিফ্যাব",
  T_49_SD_SEARCHKEY_RAWID: "র ID",
  T_49_SD_SEARCHKEY_READSTATIS: "জমা হওয়া ডেটা পড়ুন",
  T_49_SD_SEARCHKEY_RESOURCEENUM: "রিসোর্স uuid",
  T_49_SD_SEARCHKEY_RETURN: "ফিরে যান",
  T_49_SD_SEARCHKEY_SCENEENUM: "সিন ফাইল",
  T_49_SD_SEARCHKEY_SCRIPTID: "স্ক্রিপ্ট",
  T_49_SD_SEARCHKEY_SETVALUE: "প্রপার্টির ভ্যালু সেট করুন",
  T_49_SD_SEARCHKEY_SPECIALITEMENUM: "স্পেশাল আইটেম ID টাইপ",
  T_49_SD_SEARCHKEY_TEXT: "টেক্সট",
  T_49_SD_SEARCHKEY_TEXTUREID: "টেক্সচার টাইপ",
  T_49_SD_SEARCHKEY_THISENTITY: "এই এনটিটি",
  T_49_SD_SEARCHKEY_TIMELINE: "টাইমলাইন",
  T_49_SD_SEARCHKEY_TYPEENUM: "যেকোনো ধরণের",
  T_49_SD_SEARCHKEY_V2VCREATE: "ভেক্টর2 ক্রিয়েট করুন",
  T_49_SD_SEARCHKEY_V2VGET: "ভেক্টর2 কম্পোনেন্ট পান",
  T_49_SD_SEARCHKEY_V2VOPERATION: "Vector2 অপারেশন যোগ, বিয়োগ, মাল্টিপ্লাই, ডট প্রোডাক্ট, ডিস্ট্যান্স, অ্যাঙ্গেল",
  T_49_SD_SEARCHKEY_V2VSET: "ভেক্টর2 কম্পোনেন্ট সেট করুন",
  T_49_SD_SEARCHKEY_V3VCREATE: "ভেক্টর3 ক্রিয়েট করুন",
  T_49_SD_SEARCHKEY_V3VGET: "ভেক্টর3 কম্পোনেন্ট পান",
  T_49_SD_SEARCHKEY_V3VOPERATION: "Vector3 অপারেশন যোগ, বিয়োগ, মাল্টিপ্লাই, ডট প্রোডাক্ট, ক্রস প্রোডাক্ট, ডিস্ট্যান্স, অ্যাঙ্গেল",
  T_49_SD_SEARCHKEY_V3VSET: "ভেক্টর3 কম্পোনেন্ট সেট করুন",
  T_49_SD_SEARCHKEY_VEHICLEENUM: "ভেহিকেল স্কিন ID",
  T_49_SD_SEARCHKEY_WEAPONSKINENUM: "ওয়েপন স্কিন ID",
  T_49_SD_SEARCHKEY_WHILE: "যখন",
  T_49_SD_SEARCHKEY_WRITESTATIS: "জমা হওয়া ডেটাবেস অফসেট লিখুন",
  T_49_SD_SEARCHKEY_WRITESTATISCROSS: "ম্যাপ কোড দ্বারা জমা হওয়া ডেটাবেস অফসেট লিখুন",
  T_49_XXJ_WS_DURATIONS: "সময়কাল",
  T_49_XXJ_WS_EDITPERFORMANCE: "পারফরম্যান্স এডিট করুন",
  T_49_XXJ_WS_PERFORMANCE: "পারফরম্যান্স",
  T_49_XXJ_WS_PERFORMANCE_DELETE: "পারফরম্যান্স ডিলিট করুন",
  T_49_XXJ_WS_PERFORMANCE_DELETECONFIRM: `ডিলিট করা পারফরম্যান্স 
আর রিস্টোর করা যাবে না, চালিয়ে যেতে চান?`,
  T_49_XXJ_WS_PERFORMANCE_EDITING: "{0} এডিট করা হচ্ছে",
  T_49_XXJ_WS_PERFORMANCE_NAME_EXCEPTION: "এই নামটি ইতিমধ্যে ব্যবহার করা হয়েছে, অনুগ্রহ করে নামটি পরিবর্তন করুন এবং আবার ট্রাই করুন।",
  T_49_XXJ_WS_PERFORMANCENAME: "পারফরম্যান্স নাম",
  T_49_XXJ_WS_TIMELINE_ADD_KEYFRAME: "কী ফ্রেম যোগ করুন",
  T_49_XXJ_WS_TIMELINE_ADD_SUB_TRACK: "সাব-ট্র্যাক যোগ করুন",
  T_49_XXJ_WS_TIMELINE_ADD_TRACK: "ট্র্যাক যোগ করুন",
  T_49_XXJ_WS_TIMELINE_DEL_TRACK: "ট্র্যাক ডিলিট করুন",
  T_49_XXJ_WS_TIMELINE_ENTITY_TRACK: "অ্যাক্টর ট্র্যাক",
  T_49_XXJ_WS_TIMELINE_EVENT_TRACK: "ইভেন্ট ট্র্যাক",
  T_49_XXJ_WS_TIMELINE_EXISTED_KEYFRAME: "কী ফ্রেম ইতিমধ্যেই বিদ্যমান",
  T_49_XXJ_WS_TIMELINE_EXISTED_TRACK: "যথাযথ অ্যাক্টর ট্র্যাকটি ইতিমধ্যেই বিদ্যমান",
  T_49_XXJ_WS_TIMELINE_FRAME_SETTING: "কন্টেন্ট",
  T_49_XXJ_WS_TIMELINE_NAME_EXCEPTION: "একই নামের একাধিক ট্র্যাক সনাক্ত হয়েছে। অনুগ্রহ করে তাদের নাম পরিবর্তন করুন এবং আবার ট্রাই করুন।",
  T_49_XXJ_WS_TIMELINE_OPEN_RECORD: "অনুগ্রহ করে রেকর্ডিং শুরু করুন অথবা প্রথমে একটি কী ফ্রেম বেঁছে নিন",
  T_49_XXJ_WS_TIMELINE_RECORDING: "রেকর্ডিং...",
  T_49_XXJ_WS_TIMELINE_REMOVE_KEYFRAME: "কী ফ্রেম ডিলিট করুন",
  T_49_XXJ_WS_TIMELINE_SCENE_EDIT_MODE: "সিন ভিউ",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP: "ট্র্যাক তৈরি করতে একটি অবজেক্ট নির্বাচন করুন অথবা ডিরেক্টলি অ্যাড-ট্র্যাক বাটনে ট্যাপ করুন",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP_1: "নতুন ট্র্যাক তৈরি করতে অ্যাড-ট্র্যাক বাটনে ট্যাপ করুন",
  T_49_XXJ_WS_TIMELINE_SUB_TRACK_TITLE: "সাব-ট্র্যাক",
  T_49_XXJ_WS_TIMELINE_TRACK: "ট্র্যাক",
  T_49_XXJ_WS_TIMELINE_TRACK_EDIT_MODE: "ট্র্যাক ভিউ",
  T_49_XYL_WS_DAILYPROPS: "বেসিক",
  T_49_XYL_WS_STOREGAMPLAY: "গেমপ্লে",
  T_49_YU_QCITEM_ALL_11: "Tung Tung Tung Sahur!",
  T_50_H_M4A1_VA_N: "M4A1 - ট্রাবল একাডেমি",
  T_50_H_MACHETE_VA_N: "প্যারাং - ট্রাবল একাডেমি",
  T_50_HJ_LEADERBOARD_SETTING_HEADER: "লিডারবোর্ড ফিল্ডসমূহ",
  T_50_HJ_OVERFLOW_RESIZEFREELY: "ওভারফ্লো",
  T_50_HJ_OVERFLOW_RESIZEHEIGHT: "চারপাশে র‍্যাপ করুন",
  T_50_HJ_OVERFLOW_SHRINKCONTENT: "ফন্ট সংকুচিত করুন",
  T_50_HJ_SEARCHKEY_TUPLECREATE: "টুপল তৈরি করুন",
  T_50_HJ_SEARCHKEY_TUPLEGET: "টুপল অর্জন করুন",
  T_50_HJ_SEARCHKEY_TUPLESET: "টুপল সেট করুন",
  T_50_HJ_TEXTOBGJ_H: "উচ্চতা",
  T_50_HJ_TEXTOBGJ_OVERFLOW: "ওভারফ্লো অপশন",
  T_50_HJ_TEXTOBGJ_W: "প্রস্থ",
  T_50_HZY_REVIEW_TEXTOBJ: "টেক্সট অবজেক্ট কনটেন্ট",
  T_50_JH_WS_HIDEMAPERROR: "কাস্টম কভার ইমেজ ব্যতীত মিনিম্যাপ হাইড করা যাবে না",
  T_50_JH_WS_HIDEMAPTIP: "যখন মিনিম্যাপ হাইড থাকে, তখন এটি আর কভার ইমেজ হিসেবে ব্যবহার করা হবে না",
  T_50_JH_WS_HIDEMINIMAP: "মিনিম্যাপ হাইড করুন",
  T_50_META_API_10073_P0: "ফাইলের নাম",
  T_50_META_API_10073_P0_D: "ফাইলের নাম",
  T_50_META_API_10073_P1_D: "কার্যকর করার ফলাফল। স্ট্যাটাস কোড এনাম চেক করুন।",
  T_50_META_API_1102: "ডাটাবেস শিট কলামের ভ্যালু রিড করুন",
  T_50_META_API_1102_D: "একটি প্রদত্ত কী এর জন্য স্ট্যান্ডার্ড ডাটাবেস টেবিল থেকে একটি নির্দিষ্ট কলামের ভ্যালু রিট্রিভ করুন",
  T_50_META_API_1102_P3: "কলাম ইনডেক্স",
  T_50_META_API_1102_P3_D: "ডাটাবেস টেবিলের কলাম ইনডেক্স (0 = প্রথম কলাম)",
  T_50_META_API_1106: "পারফরম্যান্স তৈরি করুন",
  T_50_META_API_1106_D: "একটি পারফর্ম্যান্স এন্টিটি তৈরি করুন",
  T_50_META_API_1106_P0_D: "দ্য পারফরম্যান্স অ্যাসেট",
  T_50_META_API_1111: "ডাটাবেস লিডারবোর্ড অ্যাসোসিয়েশন ভ্যালু পড়ুন",
  T_50_META_API_1111_D: "ডাটাবেসে লিডারবোর্ড টেবিল এবং সংশ্লিষ্ট টেবিল থেকে ভ্যালুর কম্বিনেশন পড়ুন",
  T_50_META_API_1111_P5: "অ্যাসোসিয়েশন স্ট্যাটাস কোড",
  T_50_META_API_1111_P5_D: "অ্যাসোসিয়েশন ত্রুটি কোড",
  T_50_META_API_1112: "রেঞ্জ অনুযায়ী ডাটাবেস লিডারবোর্ড অ্যাসোসিয়েশন ভ্যালু পড়ুন",
  T_50_META_API_1112_D: "একটি নির্দিষ্ট র‍্যাংক রেঞ্জ-এর মধ্যে লিডারবোর্ড টেবিল থেকে ভ্যালু পড়ুন, সংশ্লিষ্ট টেবিল থেকে রিট্রিভ করা কী দিয়ে সম্পর্কিত ভ্যালু পড়ুন এবং সেগুলো কম্বাইন করুন।",
  T_50_META_API_1112_P6: "অ্যাসোসিয়েশন স্ট্যাটাস কোড",
  T_50_META_API_1112_P6_D: "অ্যাসোসিয়েশন ত্রুটি কোড",
  T_50_META_API_1113: "ডাটাবেস লিডারবোর্ড অ্যাসোসিয়েশন ভ্যালু লিখুন",
  T_50_META_API_1113_D: "লিডারবোর্ড টেবিলে একটি প্রদত্ত কী-এর ভ্যালু এবং ডাটাবেসে এর সাথে সংশ্লিষ্ট টেবিল লিখুন",
  T_50_META_API_1113_P5: "অ্যাসোসিয়েশন স্ট্যাটাস কোড",
  T_50_META_API_1113_P5_D: "অ্যাসোসিয়েশন ত্রুটি কোড",
  T_50_META_API_114_D: "কাস্টম UI তৈরি  করুন",
  T_50_META_API_114_P0_D: "একটি UI এন্টিটি তৈরির জন্য প্যারামিটারের নাম হিসেবে কোডটি ব্যবহার করা হয় এবং এর সংশ্লিষ্ট স্থানীয় ভ্যারিয়েবল মান তৈরি হওয়া UI এন্টিটিকে প্রতিনিধিত্ব করে।",
  T_50_META_API_114_P1_D: "এটি যে প্লেয়ার এন্টিটির সাথে অন্তর্গত, শুধুমাত্র সেই প্লেয়ারের কাছেই দৃশ্যমান।",
  T_50_META_API_114_P2: "UI অ্যাসেট ID",
  T_50_META_API_114_P2_D: "কাস্টম UI অ্যাসেট ID",
  T_50_META_API_115_D: "নির্দিষ্ট কাস্টম UI তৈরি করুন",
  T_50_META_API_116: "লেভেল অবজেক্ট হাইলাইট সেট করুন",
  T_50_META_API_116_D: "অবজেক্টের হাইলাইট স্ট্যাটাস সেট করুন। এটি অন্যান্য ইন-গেম লজিক দ্বারা অ্যাফেক্টেড হতে পারে।",
  T_50_META_API_116_P0_D: "টার্গেট অবজেক্ট",
  T_50_META_API_116_P1_D: "হাইলাইট স্ট্যাটাস",
  T_50_META_API_117: "বিটওয়াইজ কমন",
  T_50_META_API_117_D: "বিটওয়াইজ অ্যান্ড/অথবা/xor/বাম শিফট/ডান শিফট",
  T_50_META_API_117_P0_D: "লেফট ভ্যালু",
  T_50_META_API_117_P1_D: "সঠিক ভ্যালু",
  T_50_META_API_117_P2_D: "অপারেশন টাইপ",
  T_50_META_API_118: "বিটওয়াইজ নট",
  T_50_META_API_118_D: "বিটওয়াইজ নট, যা বিটওয়াইজ কমপ্লিমেন্ট নামেও পরিচিত।",
  T_50_META_API_118_P0_D: "ভ্যালু",
  T_50_META_API_119: "বিটওয়াইজ তালিকা থেকে Int",
  T_50_META_API_119_D: "তালিকার সকল উপাদানের উপর বিটওয়াইজ বা অপারেশন করুন এবং আউটপুটকে একটি পূর্ণসংখ্যা মানে রূপান্তর করুন।",
  T_50_META_API_119_P0: "বিট অ্যারে",
  T_50_META_API_119_P0_D: "বিটওয়াইজ অ্যারে",
  T_50_META_API_120: "বিটওয়াইজ Int থেকে লিস্ট করুন",
  T_50_META_API_120_D: "একটি পূর্ণসংখ্যার বাইনারি আকারে অবস্থান 1-এ বিট দ্বারা প্রতিনিধিত্ব করা দশমিক মানগুলোকে একটি তালিকায় রূপান্তর করুন",
  T_50_META_API_120_P0_D: "পূর্ণসংখ্যা",
  T_50_META_API_121: "কোয়াটারনিয়ন অ্যাঙ্গেল",
  T_50_META_API_121_D: "দুইটি কোয়াটার্নিয়নের মধ্যে অ্যাঙ্গেল ক্যালকুলেট করুন",
  T_50_META_API_121_P0_D: "কোয়াটারনিয়ন 1",
  T_50_META_API_121_P1_D: "কোয়াটারনিয়ন 2",
  T_50_META_API_122: "কোয়াটারনিয়ন ডট",
  T_50_META_API_122_D: "দুইটি কোয়াটার্নিয়নের ডট প্রোডাক্ট ক্যালকুলেট করুন",
  T_50_META_API_123: "কোয়াটারনিয়ন ইনভার্স",
  T_50_META_API_123_D: "একটি কোয়াটার্নিয়নের ইনভার্স ক্যালকুলেট করুন",
  T_50_META_API_123_P0_D: "কোয়াটারনিয়ন",
  T_50_META_API_124: "কোয়াটার্নিয়ন ফ্রম-টু রোটেশন",
  T_50_META_API_124_D: '"from" থেকে "to" পর্যন্ত রোটেশন কোয়াটার্নিয়ন ক্যালকুলেট করুন',
  T_50_META_API_124_P0_D: "স্টার্ট পয়েন্ট",
  T_50_META_API_124_P1_D: "শেষ পয়েন্ট",
  T_50_META_API_125: "কোয়াটার্নিয়ন রোটেট টুয়ার্ডস",
  T_50_META_API_125_D: `"from" থেকে "to" পর্যন্ত রোটেশন কোয়াটার্নিয়ন ক্যালকুলেট করুন।
ম্যাক্স. ডিগ্রি ডেল্টা হলো ম্যাক্স. রোটেশন অ্যাঙ্গেল।`,
  T_50_META_API_125_P0: "থেকে",
  T_50_META_API_125_P0_D: "প্রাথমিক কোয়াটার্নিয়ন",
  T_50_META_API_125_P1: "থেকে",
  T_50_META_API_125_P1_D: "টার্গেট কোয়াটারনিয়ন",
  T_50_META_API_125_P2: "ম্যাক্স. ডিগ্রী ডেল্টা",
  T_50_META_API_125_P2_D: "ম্যাক্স. রোটেশন অ্যাঙ্গেল",
  T_50_META_API_126: "জাইরোস্কোপ ওরিয়েন্টেশন পান",
  T_50_META_API_126_D: "3D স্পেসে ডিভাইসের অরিয়েন্টেশন, যা তিনটি অক্ষের চারপাশে রোটেশন অ্যাঙ্গেল নির্দেশ করে।",
  T_50_META_API_127: "জাইরোস্কোপ গ্র্যাভিটি পান",
  T_50_META_API_127_D: "আপনার ডিভাইসের সেন্সর দ্বারা সনাক্ত করা গ্র্যাভিটি কম্পোনেন্ট",
  T_50_META_API_128: "জাইরোস্কোপ রোটেশন রেট পান",
  T_50_META_API_128_D: "এটি একটি ডিভাইসের রোটেশন রেটকে বোঝায়। এটি জাইরোস্কোপ সেন্সরের সাথে সম্পর্কিত একটি শব্দ, যা ত্রিমাত্রিক স্থানে ডিভাইসটির রোটেশনাল মুভমেন্ট স্পিড বর্ণনা করে।",
  T_50_META_API_129: "জাইরোস্কোপ রোটেশন আনবায়াসড পান",
  T_50_META_API_129_D: "ডিভাইসের রোটেশন রেট বর্ণনা করে এবং ডিভাইসের সেন্সরের Noise বা Bias সমন্বয় করে আরও নির্ভুল ফলাফল প্রদান করে।",
  T_50_META_API_130: "জাইরোস্কোপ ইউজার অ্যাকসেলারেশন পান",
  T_50_META_API_130_D: "ডিভাইসের এক্সিলারেশন পার্ট যেখানে গ্র্যাভিটি কম্পোনেন্ট রিমুভ করা হয়েছে, যা ব্যবহারকারীর অ্যাকশন বা বাহ্যিক শক্তির কারণে সৃষ্ট ত্বরণ।",
  T_50_META_API_131: "টাচ ইনফো পান",
  T_50_META_API_131_D: "নির্দিষ্ট ইনডেক্সের স্ক্রিন টাচ তথ্য পান (থাকছে পজিশন, ডিসপ্লেসমেন্ট, অ্যান্ড চেঞ্জ টাইম)।",
  T_50_META_API_131_P0_D: "0 থেকে শুরু করে টাচ পয়েন্ট ID বিতরণ করুন",
  T_50_META_API_131_P1_D: "টাচ পজিশন",
  T_50_META_API_131_P2: "ডেল্টা পজিশন",
  T_50_META_API_131_P2_D: "শেষ ফ্রেমের তুলনায় পজিশনের পরিবর্তন",
  T_50_META_API_131_P3: "ডেল্টা টাইম",
  T_50_META_API_131_P3_D: "শেষ ফ্রেমের পর থেকে অতিবাহিত হওয়া সময়",
  T_50_META_API_132: "স্ক্রিন টাচ কাউন্ট পান",
  T_50_META_API_132_D: "স্ক্রিনে টাচ পয়েন্টের বর্তমান সংখ্যা দেখা যাবে",
  T_50_META_API_133: "ভাইব্রেট ডিভাইস",
  T_50_META_API_133_D: "ডিভাইসটি একবার ভাইব্রেট করুন",
  T_50_META_API_134_D: "অডিও প্লে করার জন্য টার্গেট প্লেয়ার ডিভাইসকে অবহিত করুন",
  T_50_META_API_134_P0_D: "দ্য টার্গেট প্লেয়ার",
  T_50_META_API_134_P1_D: "অডিও অ্যাসেট",
  T_50_META_API_134_P2_D: "প্লেব্যাক স্পিড (ভ্যালিড রেঞ্জ: 0.1~3.0; 1 = নরমাল, <1 = স্লো ডাউন, >1 = স্পিড আপ)",
  T_50_META_API_135_D: "ওয়ান-টাইম অডিও ফাইল প্লে করুন",
  T_50_META_API_135_P0_D: "অডিও রিসোর্স",
  T_50_META_API_135_P1_D: "প্লে স্পিড",
  T_50_META_API_136: "স্ট্রিং ফরম্যাট করুন",
  T_50_META_API_136_D: "স্ট্রিং ফরম্যাট করুন",
  T_50_META_API_136_P0_D: "Go ফরম্যাটিং ভার্ব কন্ট্রোল ব্যবহার করে গঠিত ফরম্যাটেড স্ট্রিংস",
  T_50_META_API_136_P1: "প্যারামিটার অ্যারে",
  T_50_META_API_136_P1_D: "প্যারামিটার লিস্ট",
  T_50_META_API_137: "পেস্ট কম্পোনেন্ট",
  T_50_META_API_137_D: "কম্পোনেন্ট ডেটা কপি করুন বা যোগ করুন",
  T_50_META_API_137_P0: "সোর্স",
  T_50_META_API_137_P0_D: "সোর্স এন্টিটি",
  T_50_META_API_137_P1_D: "টার্গেট এনটিটি",
  T_50_META_API_137_P2: "কম্পোনেন্ট টাইপ",
  T_50_META_API_137_P2_D: "কম্পোনেন্ট টাইপ",
  T_50_META_API_137_P3: "সফল হয়েছে কিনা",
  T_50_META_API_137_P3_D: "সফল হোক বা না হোক",
  T_50_META_API_138: "নেক্সট ফ্রেমে রিভাইভ করুন",
  T_50_META_API_138_D: "নেক্সট ফ্রেমে রিভাইভ করুন",
  T_50_META_API_139: "নেক্সট ফ্রেমে এলিমিনেট করুন",
  T_50_META_API_139_D: "নেক্সট ফ্রেমে ব্যাটেল এন্টিটি এলিমিনেট করুন",
  T_50_META_API_139_P0_D: "দ্য ব্যাটেল এন্টিটি",
  T_50_META_API_140: "নেক্সট ফ্রেমে গেম থেকে বেরিয়ে যান",
  T_50_META_API_140_D: "পরবর্তী ফ্রেমে গেম থেকে প্রস্থান করুন",
  T_50_META_API_141: "মাইক্রোফোন ভলিউম পান",
  T_50_META_API_141_D: "মাইক্রোফোন ভলিউম অর্জন করুন। প্লেয়ারের মাইক্রোফোন অফ থাকলে বা অ্যাক্সেস না পেলে স্ট্যাটাসটি রিটার্ন করুন।",
  T_50_META_API_141_P0: "ভলিউম",
  T_50_META_API_141_P0_D: "মাইক্রোফোনের ভলিউম",
  T_50_META_API_141_P1_D: "মাইক্রোফোন টার্ন অন বা অফ আছে",
  T_50_META_API_142: "রেন্ডার কোয়ালিটি পান",
  T_50_META_API_142_D: "বর্তমান রেন্ডারিং কোয়ালিটি পান (এনাম: লো/মিডিয়াম/হাই/আল্ট্রা)",
  T_50_META_API_143: "রেন্ডার রেজোলিউশন পান",
  T_50_META_API_143_D: "বর্তমান রেন্ডার রেজোলিউশন অর্জন করুন",
  T_50_META_API_144: "কাস্টম প্লেয়ার বাইন্ড করুন",
  T_50_META_API_144_D: "এই প্লেয়ারটি যে টার্গেটে বাইন্ড হবে তা ডায়নামিকভাবে সেট করুন, যা বিদ্যমান থাকা বাইন্ডগুলোকে ওভাররাইড করবে। ব্যর্থ হলে ফলাফল False প্রদান করে।",
  T_50_META_API_144_P0: "কাস্টম প্লেয়ার",
  T_50_META_API_144_P0_D: "এই কাস্টম প্লেয়ারটিকে প্লেয়ারের সাথে বাইন্ড করার পর, অবস্থান এবং দিকনির্দেশনার মতো ডেটা স্বয়ংক্রিয়ভাবে সিঙ্ক হবে",
  T_50_META_API_144_P1_D: "টার্গেট প্লেয়ার",
  T_50_META_API_145: "কাস্টম প্লেয়ার আনবাইন্ড করুন",
  T_50_META_API_145_D: "বাইন্ডিং বাতিল করুন। ব্যর্থ হলে ফলাফল False প্রদান করে।",
  T_50_META_API_145_P0: "কাস্টম প্লেয়ার",
  T_50_META_API_145_P0_D: "এই টার্গেট করার জন্য সকল বাইন্ডিং ক্লেয়ার করুন। আনবাইন্ড করার পরে, অবস্থান এবং দিকনির্দেশের মতো ডেটা আর স্বয়ংক্রিয়ভাবে সিঙ্ক হবে না।",
  T_50_META_API_146_P0_D: "একজন কাস্টম প্লেয়ার",
  T_50_META_API_147: "কাস্টম প্লেয়ার স্টেট সেট করুন",
  T_50_META_API_147_D: "সার্ভারে অটোমেটিক্যালি আপলোড হয় এবং সকল ক্লায়েন্টের সাথে সিঙ্ক হয়। ব্যর্থ হলে ফলাফল False প্রদান করে।",
  T_50_META_API_147_P0: "কাস্টম প্লেয়ার",
  T_50_META_API_147_P1: "স্টেট",
  T_50_META_API_147_P1_D: "সাধারণত অ্যানিমেশন স্টেট সেভ করার জন্য ব্যবহৃত হয়। গেট কাস্টম প্লেয়ার স্টেট-এর সাথে সিঙ্ক করা স্টেট পান",
  T_50_META_API_148: "কাস্টম প্লেয়ার স্টেট পান",
  T_50_META_API_148_D: "স্টেট ডেটা স্বয়ংক্রিয়ভাবে সার্ভারের সাথে সিঙ্ক হয়ে যায়। ব্যর্থ হলে ফলাফল False প্রদান করে।",
  T_50_META_API_148_P0: "কাস্টম প্লেয়ার",
  T_50_META_API_148_P1: "স্টেট",
  T_50_META_API_148_P1_D: "সেট কাস্টম প্লেয়ার স্টেট এর সাহায্যে স্টেট সেট করুন",
  T_50_META_API_149: "ডিস্ট্যান্স ভলিউম সেট করুন",
  T_50_META_API_149_D: "প্লেয়ারদের মধ্যকার দূরত্ব অনুযায়ী অডিও ভলিউম স্বয়ংক্রিয়ভাবে নির্ধারণ করতে রেঞ্জ সেট করুন।",
  T_50_META_API_149_P0: "ডিস্ট্যান্স লিস্ট",
  T_50_META_API_149_P0_D: "একটি ডিস্ট্যান্স রেঞ্জের তালিকা, যেখানে প্রতিটি রেঞ্জ ভলিউম তালিকার একটি উপাদানের সাথে সম্পর্কিত।",
  T_50_META_API_149_P1: "ভলিউম লিস্ট",
  T_50_META_API_149_P1_D: "দূরত্ব তালিকার একটি উপাদানের সাথে সম্পর্কিত প্রতিটি ভলিউমের একটি তালিকা।",
  T_50_META_API_150: "বন্ধুদের পান",
  T_50_META_API_150_D: "প্লেয়ার'স ফ্রেন্ড IDs লিস্ট অর্জন করুন",
  T_50_META_API_151: "ডিফল্ট UI তথ্য পান",
  T_50_META_API_151_D: "প্লেয়ারের ডিফল্ট UI লোকেশন পান",
  T_50_META_API_151_P0_D: "ডিফল্ট ইন্টারফেস",
  T_50_META_API_151_P1_D: "স্ট্যাটাস",
  T_50_META_API_151_P2_D: "UI পজিশন",
  T_50_META_API_151_P3: "সাইজ",
  T_50_META_API_151_P3_D: "UI সাইজ",
  T_50_META_API_152: "কাস্টম ইভেন্ট ব্রডকাস্ট করুন",
  T_50_META_API_152_D: "যেকোনো এন্টিটির জন্য একটি কাস্টম ইভেন্ট ব্রডকাস্ট করুন যাতে তারা এই ইভেন্টটি পেতে (শুনতে পারে) পারে।",
  T_50_META_API_153: "ইনটিটিতে ইভেন্ট পাঠান",
  T_50_META_API_153_D: "কাস্টম ইভেন্টটি টার্গেট এন্টিটিতে পাঠান",
  T_50_META_EVT_17: "অন স্ক্রিনে টাচ শুরু করুন",
  T_50_META_EVT_17_D: "স্ক্রিনে টাচ করে ইভেন্ট শুরু করুন",
  T_50_META_EVT_17_P0: "টাচ ইনডেক্স",
  T_50_META_EVT_17_P0_D: "টাচ পয়েন্ট ইন্ডেক্স",
  T_50_META_EVT_17_P1_D: "টাচ পজিশন",
  T_50_META_EVT_18: "অন স্ক্রিন টাচ এন্ড",
  T_50_META_EVT_18_D: "স্ক্রিনে টাচ করে ইভেন্টটি শেষ করুন",
  T_50_META_EVT_18_P0: "টাচ ইনডেক্স",
  T_50_META_EVT_18_P0_D: "টাচ পয়েন্ট ইন্ডেক্স",
  T_50_META_EVT_18_P1_D: "স্ক্রিনে টাচ পজিশন",
  T_50_META_EVT_19: "রিসিভ হওয়ার পর পার্সোনা ক্রিয়েট রুম রেজাল্ট",
  T_50_META_EVT_19_D: "পারসোনা চ্যাট রুম তৈরি করতে ব্যর্থ হলে সংশ্লিষ্ট ফলাফলটি রিসিভ করুন",
  T_50_META_EVT_19_P1: "রুম ID",
  T_50_META_EVT_19_P1_D: "রুম ID",
  T_50_META_EVT_20: "ইউজার প্রস্থান করলে বা ম্যাচ শেষ হলে",
  T_50_META_EVT_20_D: "ব্যবহারকারী যখন ম্যাচটি ছেড়ে দেয় অথবা ম্যাচটি শেষ হয়ে যায় তখন ট্রিগার করে",
  T_50_META_TYP_11_I44: "ডিস্ট্যান্স ভলিউম",
  T_50_META_TYP_11_I44_D: "প্লেয়ারদের মাঝে দূরত্ব অনুযায়ী অডিও ভলিউম স্বয়ংক্রিয়ভাবে অ্যাডজাস্ট করুন",
  T_50_META_TYP_22_I9_D: "UI তৈরি করার জন্য ব্যবহৃত অ্যাসেট আইডি",
  T_50_META_TYP_244_I12_D: "টেক্সট বক্স এর প্রস্থ",
  T_50_META_TYP_244_I13_D: "টেক্সট বক্সের উচ্চতা",
  T_50_META_TYP_244_I14_D: "ওভারফ্লো টাইপ",
  T_50_META_TYP_335_I10_D: "প্লেব্যাক স্পিড (ভ্যালিড ভ্যালু > 0, ডিফল্ট = 1)",
  T_50_META_TYP_409_I20: "IO_ফাইল_তৈরি করতে_ব্যর্থ",
  T_50_META_TYP_409_I20_D: "IO অপারেশন ব্যর্থ হয়েছে: ফাইল তৈরি করার সময় একটি ত্রুটি হয়েছে।",
  T_50_META_TYP_409_I21: "IO_অকার্যকর_ফাইলের_নাম",
  T_50_META_TYP_409_I21_D: "IO অপারেশন ব্যর্থ হয়েছে। অকার্যকর ফাইল নাম।",
  T_50_META_TYP_448_I0_D: "নিয়ন্ত্রিত স্কেলেটন পার্ট",
  T_50_META_TYP_448_I1_D: "স্কেলেটন পার্ট যেদিকে তাকিয়ে আছে, সেটিই টার্গেট",
  T_50_META_TYP_451: "ওভারফ্লো টাইপ",
  T_50_META_TYP_451_D: "টেক্সট ওভারফ্লো পরিচালনার পদ্ধতি",
  T_50_META_TYP_452: "কাস্টম UI অ্যাসেট ID",
  T_50_META_TYP_452_D: "কাস্টম HUD অ্যাসেট বর্ণনা করে এমন ID",
  T_50_META_TYP_453: "রেন্ডার কোয়ালিটি টাইপ",
  T_50_META_TYP_453_D: "রেন্ডারিং কোয়ালিটির এনাম",
  T_50_META_TYPE_448_D: "এই এনটিটি টার্গেটের দিকে লুক করার জন্য স্কেলেটন পার্ট নিয়ন্ত্রণ করতে ব্যবহার করা হয়",
  T_50_SD_WS_MAPTAG_AI3DGEN: "3D অবজেক্ট ম্যাপ জেনারেট করুন",
  T_50_SD_WS_MAPTAG_AIRACING: "রেসিং AI ম্যাপ জেনারেট করুন",
  T_50_XXJ_WS_ANIMATIONSTATENAME: "অ্যানিমেশন স্টেট নাম এনাম",
  T_50_XXJ_WS_DISABLEFOOTSTEP: "ফুটস্টেপস ভাইব্রেশন বন্ধ করুন",
  T_50_XXJ_WS_NOPERFORMANCE: "এখনও কোনো পারফর্ম্যান্স ফাইল নেই",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS: "বেটা ভার্সন",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS_DESC: "প্রিয় ক্রিয়েটরস, পারফরম্যান্স এডিটর এখনও টেস্টিং পর্যায়ে রয়েছে। এতে বাগ থাকতে পারে বা গুরুত্বপূর্ণ কিছু ফিচার অনুপস্থিত থাকতে পারে। অনুগ্রহ করে সাবধানতার সাথে এটি ব্যবহার করুন।",
  T_50_XXJ_WS_PERFORMANCE_NEW: "পারফরম্যান্স যোগ করুন",
  T_50_XXJ_WS_TIMELINE_ADD_KEYCLIP: "কী ক্লিপ যোগ করুন",
  T_50_XXJ_WS_TIMELINE_ALONGPATH_TRACK: "পাথ ট্র্যাক বরাবর",
  T_50_XXJ_WS_TIMELINE_ANIMATION_CLIP: "অ্যানিমেশন",
  T_50_XXJ_WS_TIMELINE_ANIMATION_TRACK: "অ্যানিমেশন ট্র্যাক",
  T_50_XXJ_WS_TIMELINE_AUDIO_TRACK: "অডিও ট্র্যাক",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_HOLD: "হোল্ড করুন",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_LOOPFOREVER: "লুপ ফরএভার",
  T_50_XXJ_WS_TIMELINE_DURATION: "স্থায়িত্ব: {0}s",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_AVATAR: "অ্যানিমেশন এবং মডেল-এর মধ্যে অমিল",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_CLIP_OVERLAP: "কী ক্লিপ ওভারল্যাপ",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_ENTITY_MISSING: "বাউন্ড এন্টিটি মিসিং",
  T_50_XXJ_WS_TIMELINE_NAME_EMPTY: "ট্র্যাক নাম খালি রাখা যাবে না",
  T_50_XXJ_WS_TIMELINE_NPC_TRACK: "NPC ট্র্যাক",
  T_50_XXJ_WS_TIMELINE_PROP_TRACK: "প্রপার্টি ট্র্যাক",
  T_50_XXJ_WS_TIMELINE_REMOVE_KEYCLIP: "কী ক্লিপ রিমুভ করুন",
  T_50_XXJ_WS_TIMELINE_TIME_SUFFIX: "{0}s",
  T_50_XXJ_WS_TIMELINE_TRACK_MAX_LIMIT: "ট্র্যাক কাউন্ট লিমিট অতিক্রম করেছে",
  T_50_XYL_WS_AIGETERATESHOW: "বিল্ডিং ব্লকস",
  T_50_YU_F_B_VA_WITCH: "মিস্টিক ট্রাবল (বটম)",
  T_50_YU_F_H_VA_WITCH: "মিস্টিক ট্রাবল (হেড)",
  T_50_YU_F_HA_VA_WITCH: "মিস্টিক ট্রাবল (ফেসপেইন্ট)",
  T_50_YU_F_S_VA_WITCH: "মিস্টিক ট্রাবল (জুতা)",
  T_50_YU_F_T_VA_WITCH: "মিস্টিক ট্রাবল (টপ)",
  T_50_ZCS_CLCUSTOMEVE_CUSTOMEVENT: "কাস্টম ইভেন্ট",
  T_51_GT_WS_BASIC: "বেসিক",
  T_51_GT_WS_GLOBALEVENT: "গ্লোবাল ইভেন্ট",
  T_51_GT_WS_PRIVATEEVENT: "প্রাইভেট ইভেন্ট",
  T_51_GT_WS_STORY: "Story",
  T_51_GT_WS_UI: "UI",
  T_51_JH_WS_MINTIP1: "",
  T_51_META_API_1114: "User Message To Persona Voice Response",
  T_51_META_API_1114_D: "পার্সোনা ইউজারে'র মেসেজ পাঠান এবং পার্সোনা থেকে ভয়েস প্রতিক্রিয়া পান",
  T_51_META_API_1114_P2_D: "If true, the voice response will automically play when received; else, an API is required to play it",
  T_51_META_API_1115: "System Message To Persona Voice Response",
  T_51_META_API_1115_D: "Send persona system message and get a voice response from persona",
  T_51_META_API_1116: "Play Stored Voice From Persona",
  T_51_META_API_1116_D: "Play stored voice reponses from persona. Can store up to 10 responses.",
  T_51_META_API_144_P2_D: "Whether the execution is successful",
  T_51_META_API_154: "Get Type Name",
  T_51_META_API_154_D: "Return the name of the target object's type",
  T_51_META_API_154_P0_D: "টাইপ নাম পাওয়ার জন্য টার্গেট অবজেক্ট",
  T_51_META_API_155: "Get Bounding Box",
  T_51_META_API_155_D: "Get the Bounding Box of the scene object",
  T_51_META_API_155_P0_D: "The scene object to get the bounding box for",
  T_51_META_API_155_P1_D: "বাউন্ডিং বক্স-এর কেন্দ্র",
  T_51_META_API_155_P2: "Size",
  T_51_META_API_155_P2_D: "বাউন্ডিং বক্স-এর সাইজ",
  T_51_META_API_156: "Create Entity",
  T_51_META_API_156_D: "Create an entity. You can specify an owner (a specific player client). In combination with the AddComponent API, you can synchronize data targeted to that particular client.",
  T_51_META_API_156_P0_D: "The target entity to be created",
  T_51_META_API_156_P1_D: "তৈরি করা কাস্টম উপাদানের প্রকার",
  T_51_META_API_156_P2_D: "এন্টিটির ওনার",
  T_51_META_API_156_P3: "Flag",
  T_51_META_API_156_P3_D: "Entity flag. See Entity Flag enum for more details. Can be used in combination.",
  T_51_META_API_157: "Set Material Property",
  T_51_META_API_157_D: "This API allows you to modify certain properties of an object's material.",
  T_51_META_API_157_P0_D: "The target object to get the material property for",
  T_51_META_API_157_P1: "Property Name",
  T_51_META_API_157_P1_D: "প্রপার্টির নাম সেট করুন",
  T_51_META_API_157_P2: "Property Value",
  T_51_META_API_157_P2_D: "Set the value of the property",
  T_51_META_API_157_P3: "Success",
  T_51_META_API_157_P3_D: "Set whether it's successful or not",
  T_51_META_API_158: "Clear Material Property",
  T_51_META_API_158_D: "Clear the set properties",
  T_51_META_API_158_P0_D: "মেটেরিয়াল প্রপার্টি ক্লিয়ার করার জন্য টার্গেট অবজেক্ট",
  T_51_META_EVT_21: "On Custom Property Change",
  T_51_META_EVT_21_D: "When a monitored custom property changes, this event will trigger. Note: if a custom property is modified multiple times within a single frame, this event is only triggered once. When the server modifies a custom property, the event is sent to both endpoints; when a client modifies a local entity's custom property, the event is only delivered locally.",
  T_51_META_EVT_21_P0: "প্রপার্টি ইনডেক্স",
  T_51_META_EVT_21_P0_D: "প্রপার্টি'র ইনডেক্স",
  T_51_META_EVT_21_P1_D: "The property's new value",
  T_51_META_EVT_22: "On Custom Player State Changed",
  T_51_META_EVT_22_D: "This event will trigger when the state of the custom player changes",
  T_51_META_EVT_22_P0: "কাস্টম প্লেয়ার স্টেট",
  T_51_META_EVT_22_P0_D: "The state of the custom player",
  T_51_META_EVT_23: "পার্সোনা থেকে ভয়েস রেসপন্স পান",
  T_51_META_EVT_23_D: "Trigger this event when persona's voice response is received",
  T_51_META_EVT_24: "On Play Voice Finish From Persona",
  T_51_META_EVT_24_D: "পার্সোনা ভয়েস রেসপন্স প্লে শেষ হলে এই ইভেন্টটি ট্রিগার করুন",
  T_51_META_TYP_14_I79: "Bound Custom Player",
  T_51_META_TYP_14_I79_D: "যখন একটি কাস্টম প্লেয়ারের সাথে বাউন্ড করা হয়, তখন ক্লাসিক ক্যারেক্টার মডেলটি হাইড থাকে এবং  টার্গেট অবজেক্টের পজিশন, রোটেশন (ফেসিং) এবং অন্যান্য ডেটা এর সাথে সিঙ্ক্রোনাইজ করা হয়।",
  T_51_META_TYP_15_I6: "টিমমেটের নাম শো করবেন কি?",
  T_51_META_TYP_15_I6_D: "Whether to show teammates' names on the top of their heads",
  T_51_META_TYP_247_I31: "Help Up",
  T_51_META_TYP_247_I31_D: "Help Up",
  T_51_META_TYP_247_I32: "হাল ছেড়ে দিন",
  T_51_META_TYP_247_I32_D: "হাল ছেড়ে দিন",
  T_51_META_TYP_247_I33: "Attack 2",
  T_51_META_TYP_247_I33_D: "Attack 2",
  T_51_META_TYP_247_I34: "Combine Weapon",
  T_51_META_TYP_247_I34_D: "Combine Weapon",
  T_51_META_TYP_247_I35: "Surfboard",
  T_51_META_TYP_247_I35_D: "Surfboard",
  T_51_META_TYP_313_I2_D: "Out-of-zone damage per second",
  T_51_META_TYP_409_I22: "প্যারামিটার ত্রুটি",
  T_51_META_TYP_409_I22_D: "প্যারামিটার ত্রুটি",
  T_51_META_TYP_440_I1_D: "Performance asset ID",
  T_51_META_TYP_454: "Material Property",
  T_51_META_TYP_454_D: "একটি অবজেক্টের জন্য মেটেরিয়াল প্রপার্টি সেট করতে ব্যবহার করুন",
  T_51_META_TYP_455: "এনটিটি ফ্ল্যাগ",
  T_51_META_TYP_455_D: "একটি নির্দিষ্ট এন্টিটির জন্য প্রপার্টি ফ্ল্যাগ, কম্বিনেশনে ব্যবহার করা যেতে পারে",
  T_51_META_TYP_455_I0_D: "Default property",
  T_51_META_TYP_455_I1: "স্ট্যাটিক",
  T_51_META_TYP_455_I1_D: "স্ট্যাটিক এনটিটি",
  T_51_META_TYP_455_I2: "Local",
  T_51_META_TYP_455_I2_D: "Localy entity",
  T_51_META_TYP_455_I3: "শুধুমাত্র রেন্ডার করুন",
  T_51_META_TYP_455_I3_D: "শুধুমাত্র রেন্ডার করুন",
  T_51_MX_WS_ACTION_BITE: "Crispy Bite",
  T_51_MX_WS_ACTION_BOUNCE: "",
  T_51_MX_WS_ACTION_DOOR_CREAK: "",
  T_51_MX_WS_ACTION_FALL_HIT: "Ground Slam",
  T_51_MX_WS_ACTION_GULP: "",
  T_51_MX_WS_ACTION_RUNAWAY_DUST: "",
  T_51_MX_WS_ACTION_RUNNING_STEPS: "",
  T_51_MX_WS_ACTION_SPIN_LOOP: "",
  T_51_MX_WS_ACTION_STOMACH_GROWL: "Stomach Growling",
  T_51_MX_WS_AMBIENT_BIRDS: "Bird Chirping",
  T_51_MX_WS_AMBIENT_CAFE_AMBIENCE: "Cafe Atmosphere",
  T_51_MX_WS_AMBIENT_CLASSROOM_OFFICE: "Classroom Ambience",
  T_51_MX_WS_AMBIENT_NIGHT_CRICKETS: "",
  T_51_MX_WS_AMBIENT_RAIN: "Raining",
  T_51_MX_WS_AMBIENT_STREET_TRAFFIC: "Street Traffic",
  T_51_MX_WS_AMBIENT_WAVES: "",
  T_51_MX_WS_ATMOSPHERE_APPLAUSE_LAUGH: "",
  T_51_MX_WS_ATMOSPHERE_BASS_DRUM: "",
  T_51_MX_WS_ATMOSPHERE_BELL: "Bell Ringing",
  T_51_MX_WS_ATMOSPHERE_JINGLE: "Bell Jingling",
  T_51_MX_WS_ATMOSPHERE_WIND: "Howling Wind",
  T_51_MX_WS_COMEDY_AIR_WHIP: "",
  T_51_MX_WS_COMEDY_CAMERA_CLICK: "Camera Click",
  T_51_MX_WS_COMEDY_FAIL_WAHWAH: "",
  T_51_MX_WS_COMEDY_FART: "Funny Fart",
  T_51_MX_WS_COMEDY_FUNNY_LAUGH: "Laughter",
  T_51_MX_WS_COMEDY_HEAD_SLAP: "",
  T_51_MX_WS_COMEDY_IDEA_DING: "",
  T_51_MX_WS_COMEDY_RECORD_SCRATCH: "",
  T_51_MX_WS_COMEDY_VICTORY_DING: "",
  T_51_MX_WS_EMOTION_AWKWARD: "",
  T_51_MX_WS_EMOTION_BLINK_SWITCH: "",
  T_51_MX_WS_EMOTION_CONFIDENT_VICTORY: "",
  T_51_MX_WS_EMOTION_CONFUSED: "",
  T_51_MX_WS_EMOTION_HAPPY_NOTIFICATION: "",
  T_51_MX_WS_EMOTION_HEARTBEAT_LOVE: "Heart Beating",
  T_51_MX_WS_EMOTION_PHONE_VIBRATION: "",
  T_51_MX_WS_EMOTION_SIGH_SAD: "Sigh",
  T_51_MX_WS_EMOTION_SNORT: "",
  T_51_MX_WS_EMOTION_SPARKLE: "",
  T_51_MX_WS_EMOTION_SURPRISE_SHOCK: "",
  T_51_MX_WS_EMOTION_TEETH_CHATTER: "Teeth Chattering",
  T_51_MX_WS_FANTASY_MAGIC_CAST: "",
  T_51_MX_WS_FANTASY_TRANSFORM: "",
  T_51_MX_WS_FX_EXPLOSION: "Explosion Impace",
  T_51_MX_WS_FX_FIRE_BURN: "Crackling Flames",
  T_51_MX_WS_FX_ICE_CRACK: "",
  T_51_MX_WS_FX_LIGHTNING: "লাইটনিং",
  T_51_MX_WS_FX_SPLASH: "Splash",
  T_51_MX_WS_MECHANIC_BOX_OPEN: "Unboxing",
  T_51_MX_WS_MECHANIC_GEAR_SPIN: "Gear Rotating",
  T_51_MX_WS_MECHANIC_LOCK_UNLOCK: "",
  T_51_MX_WS_MECHANIC_OPEN_CLOSE: "",
  T_51_MX_WS_MECHANIC_POURING: "",
  T_51_MX_WS_RHYTHM_BREAK_BEAT: "",
  T_51_MX_WS_RHYTHM_CLAP: "Clapping",
  T_51_MX_WS_RHYTHM_DRUM_BEAT: "",
  T_51_MX_WS_SOUNDTYPE_INTERACTION: "",
  T_51_MX_WS_TRANSITION_GLITCH: "",
  T_51_MX_WS_TRANSITION_POPUP: "Window Pop-up",
  T_51_MX_WS_TRANSITION_REVERSE_SUCTION: "",
  T_51_MX_WS_TRANSITION_WHOOSH: "",
  T_51_MX_WS_TRANSPORT_AIRCRAFT: "",
  T_51_MX_WS_TRANSPORT_BIKE_SKATE: "",
  T_51_MX_WS_TRANSPORT_CAR_DRIVE: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHDECEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOOP: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWDECEL: "",
  T_51_MX_WS_TRANSPORT_STREAM_FLOW: "Rushing Water",
  T_51_MX_WS_TRANSPORT_TRAIN_BEEP: "",
  T_51_MX_WS_UI_ACHIEVEMENT_UNLOCK: "",
  T_51_MX_WS_UI_BUTTON_CLICK: "Button Click",
  T_51_MX_WS_UI_CANCEL: "",
  T_51_MX_WS_UI_CONFIRM: "",
  T_51_MX_WS_UI_LIST_SCROLL: "",
  T_51_MX_WS_UI_LOADING: "Loading Progress",
  T_51_TYC_API_OUTLINE: "Set Entity Outline",
  T_51_TYC_API_OUTLINE_ALPHA: "Outline Transparency",
  T_51_TYC_API_OUTLINE_ALPHA_D: "Value between 0 and 1 (0 = fully transparent,1 = fully opaque)",
  T_51_TYC_API_OUTLINE_COLOR: "Outline Color",
  T_51_TYC_API_OUTLINE_COLOR_D: "The color used for drawing the outline",
  T_51_TYC_API_OUTLINE_D: "Specifies an entity to highlight its edges. Supported types include Player, Custom Render, NPC, Appearance, and Basic Appearance.",
  T_51_TYC_API_OUTLINE_TARGET: "Target Entity",
  T_51_TYC_API_OUTLINE_TARGET_D: "The entity to be outlined",
  T_51_TYC_API_OUTLINE_TOPMOST: "Always on Top",
  T_51_TYC_API_OUTLINE_TOPMOST_D: "Makes the outline render through all objects, always visible on top.",
  T_51_TYC_API_OUTLINE_WIDTH: "Outline Width",
  T_51_TYC_API_OUTLINE_WIDTH_D: "Value between 0 and 1 (0 = no outline, 1 = max. outline thickness)",
  T_51_XJ_WS_BASIC_SETTING: "Basic Settings",
  T_51_XJ_WS_GAME_START_TIME_UNIT: "Second",
  T_51_XJ_WS_GMSTART_TIME: "গেম শুরু হওয়ার আগে প্রিপারেশন টাইম",
  T_51_ZCS_SPAWNPOINT_NAME: "",
  T_OB47_M_WS_READ: "রিড-অনলি প্রপার্টি",
  TXT_AVATAR_FEMALE_JACKET_BLACK: "Black Leather Jacket (Female)",
  TXT_AVATAR_FEMALE_PANTS_MARIO: "Mushroom hunter",
  TXT_AVATAR_FEMALE_SHOE_COS_HOODSHIRT_BLACK: "Black Activewear (Shoes)",
  TXT_AVATAR_FEMALE_SHORTPANT_COS_GSL_BLACK: "GW2018 Hotpants (Female)",
  TXT_AVATAR_FEMALE_SKIRT_COS_GSL_BLACK: "GW2018 Skirt (Female)",
  TXT_AVATAR_FEMALE_TOP_COS_HOODSHIRT_BLACK: "Black Activewear (Hoodie)",
  TXT_AVATAR_FEMALE_TOP_COS_SONGKRAN_2018: "Songkran Top (black)",
  TXT_AVATAR_FEMALE_TSHIRT_MARIO: "Plumber top (female)",
  TXT_AVATAR_FEMALE_VEST_COS_GSL_BLACK: "GW2018 Singlet (Female)",
  TXT_AVATAR_MALE_BOTTOM_COS_CNY_RED: "White Prosperity (Bottom)",
  TXT_AVATAR_MALE_BOTTOM_COS_GANGS_BLACK: "Black Trackpants (Male)",
  TXT_AVATAR_MALE_BOTTOM_COS_MOB_YELLOW: "Poacher",
  TXT_AVATAR_MALE_BOTTOM_COS_OUTDOOR_BLACK: "Survivor Pants",
  TXT_AVATAR_MALE_PANTS_MARIO: "Mamamia",
  TXT_AVATAR_MALE_SHOE_COS_CANVAS_BLACK: "Survivor Shoes",
  TXT_AVATAR_MALE_SHOE_RED: "Red Boots (Male)",
  TXT_AVATAR_MALE_TOP_COS_CNY_RED: "White Prosperity (Top)",
  TXT_AVATAR_MALE_TOP_COS_GANGS_BLACK: "Black Baseball Jersey (Male)",
  TXT_AVATAR_MALE_TOP_COS_HOODIE_BRICKR: "Rebel Hoodie",
  TXT_AVATAR_MALE_TOP_COS_HOODSHIRT_BLACK: "Cool Activewear (Hoodie)",
  TXT_AVATAR_MALE_TOP_COS_MOB_DGREEN: "Skull King Vest",
  TXT_AVATAR_MALE_TOP_COS_OUTDOOR_GREY: "Survivor Shirt",
  TXT_AVATAR_MALE_TSHIRT_MARIO: "Plumber top (male)",
  TXT_AVATAR_OB10_LZW_FEMALE_TOP_COS_SPONSOR: "Racer Jacket (Female)",
  TXT_AVATAR_OB10_LZW_MALE_HAIR_COS_CLOWN: "Night Clown (Head)",
  TXT_AVATAR_OB10_LZW_MALE_TOP_COS_SPONSOR: "Racer Jacket (Male)",
  TXT_AVATAR_OB10_LZW_TOP_SLEEVELESS: "Sleeveless Jacket (Green)",
  TXT_AVATAR_OB11_LZW_COS_NYARUKO: "মিঃ স্কুইডো",
  TXT_AVATAR_OB11_LZW_MALE_ACCESSORY_COS_ZOMBIE: "Zombified Samurai (Mask)",
  TXT_AVATAR_OB11_LZW_MALE_TOP_COS_PINK_JAZZ: "Full Arm Tattoo",
  "TXT_AVATAR_OB7_LZW_FEMALE_A-SKIRT_BLACK": "Embrace",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_CNY_RED_OBT7TH: "Victoria",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "স্টাইলিশ এন্ড রেট্রো",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_JAPANESESTYLE_PINK: "Kitsune Bottom",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_COS_JAPANESESTYLE_PINK: "Kitsune Footwear",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_SPORTS_08: "Sports Shoes (Blue)",
  TXT_AVATAR_OB7_LZW_FEMALE_SHORTPANTS_FLAP_BLUE: "Denim Shorts (Female)",
  TXT_AVATAR_OB7_LZW_FEMALE_TOP_COS_JAPANESESTYLE_PINK: "Kitsune Robe",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_BATTLE_BROWN: "Combat Pants (Male)",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "অ্যাঞ্জেলিক প্যান্টস",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_JAPANESESTYLE_PURPLE: "Bushido Bottom",
  TXT_AVATAR_OB7_LZW_MALE_HOODIE_ZIPPER_GREY: "Grey Zipper Hoodie",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_CASUAL: "Hipster shoes",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_JAPANESESTYLE_PURPLE: "Bushido Footwear",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_TECHWEAR_OBT7TH: "অ্যাস্ট্রো জুতা",
  TXT_AVATAR_OB7_LZW_MALE_SHORTPANTS_FLAP_BLUE: "Denim Shorts (Male)",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_BATTLE_BROWN: "Combat Vest (Male)",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_CASUAL: "Hipster Top",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_JAPANESESTYLE_PURPLE: "Way of the Bushido",
  TXT_AVATAR_OB8_LZW_BALLPANTS_WHITE: "White Hurricane",
  TXT_AVATAR_OB8_LZW_FEMALE_BOTTOM_COS_BASEBALL_GREEN: "Baseballer (Tights)",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_ASUS_JACKET: "Rider Jacket (Female)",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_COS_BASEBALL_GREEN: "Baseballer (Jacket)",
  TXT_AVATAR_OB8_LZW_MALE_BOTTOM_COS_BASEBALL_YELLOW: "Cool Captain (Pants)",
  "TXT_AVATAR_OB8_LZW_MALE_HAIR_COS_HIP-HOP": "The Streets (Head)",
  TXT_AVATAR_OB8_LZW_MALE_SHOE_COS_BASEBALL_YELLOW: "Cool Captain (Shoes)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_ASUS_JACKET: "Rider Jacket (Male)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_BASEBALL_YELLOW: "Cool Captain (Jacket)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_DINOSAUR_GREEN: "Dino",
  TXT_AVATAR_OB8_LZW_SHOE_SOCCER_SILVER: "সিলভার বুট",
  TXT_AVATAR_OB8_LZW_TSHIRT_ENGLAND_B: "Three Lions",
  TXT_AVATAR_OB9_LZW_MALE_ACCESSORY_COS_TUXEDO: "Tuxedo (Mask)",
  TXT_AVATAR_OB9_LZW_MALE_HAIR_COS_TUXEDO: "Tuxedo (Head)",
  TXT_AVATAR_PARACHUTE_8: "Smiley",
  TXT_AVATAR_SHIRT_PLAID_2: "Programmers' Favorite (Red)",
  TXT_AVATAR_SHOES_1: "Sneakers (White)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_2: "Schoolgirl (Orange)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_3: "Schoolgirl (Red)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_4: "Schoolgirl (Yellow)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_5: "Schoolgirl (Pink)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_6: "Schoolgirl (Jasmine)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_7: "Schoolgirl (Blue)",
  TXT_AVATAR_TSHIRT_WEEK_007: "STARRY SUN",
  TXT_BANNER_NAME_MISHA: "Speed",
  TXT_CHARACTER_ADAM_NAME: "প্রিমিস",
  TXT_CHARACTER_BODYGUARD_NAME: "নিকিতা",
  TXT_CHARACTER_COP_NAME: "অ্যান্ড্রু",
  TXT_CHARACTER_EVA_NAME: "নুলা",
  TXT_CHARACTER_NURSE_NAME: "অলিভিয়া",
  TXT_CHARACTER_RACERGIRL_NAME: "মিশা",
  TXT_CHARACTER_RUNNER_NAME: "কেলি",
  TXT_CHARACTER_SEAMAN_NAME: "ফোর্ড",
  TXT_CLAN_NAME: "নাম",
  TXT_COLLECTION_DESCRIPTION: "বর্ণনা",
  TXT_COLLECTION_HEADPORTRAIT: "অ্যাভাটার",
  TXT_INVENTORY_TITLE_EQUIPMENT: "যন্ত্রপাতি",
  TXT_ITEM_AK: "AK47",
  TXT_ITEM_ARAMMO: "AR অ্যামো",
  TXT_ITEM_AWM: "AWM",
  TXT_ITEM_BAG1: "ব্যাগ লেভেল1",
  TXT_ITEM_BAG2: "ব্যাগ লেভেল2",
  TXT_ITEM_BAG3: "ব্যাগ লেভেল3",
  TXT_ITEM_BASEBALLPOLE: "ব্যাট",
  TXT_ITEM_BOWAMMO: "ক্রসবো বোল্ট",
  TXT_ITEM_CHANGUO: "প্যান",
  TXT_ITEM_CROSSBOW: "ক্রসবো",
  TXT_ITEM_DESC_FLASH: "একটি বিস্ফোরক যন্ত্র যা প্রতিপক্ষের ইন্দ্রিয়কে সাময়িকভাবে বিভ্রান্ত করতে পারে।",
  TXT_ITEM_EAGLE: "ডেজার্ট ঈগল",
  TXT_ITEM_FAK: "মেড কিট",
  TXT_ITEM_FAMAS: "ফামাস",
  TXT_ITEM_FIST: "ফিস্ট",
  TXT_ITEM_FLASH: "ফ্ল্যাশব্যাং",
  TXT_ITEM_FOREGRIP1: "ফোরগ্রিপ লেভেল1",
  TXT_ITEM_FOREGRIP2: "ফোরগ্রিপ লেভেল2",
  TXT_ITEM_FOREGRIP3: "ফোরগ্রিপ লেভেল3",
  TXT_ITEM_G18: "G18",
  TXT_ITEM_GRENADE: "গ্রেনেড",
  TXT_ITEM_GROZA: "গ্রোজা",
  TXT_ITEM_HANDCANNON: "হ্যান্ড ক্যানন",
  TXT_ITEM_HEATSIGHT: "থার্মাল স্কোপ",
  TXT_ITEM_HELMET1: "হেলমেট লেভেল1",
  TXT_ITEM_HELMET2: "হেলমেট লেভেল2",
  TXT_ITEM_HELMET3: "হেলমেট লেভেল3",
  TXT_ITEM_HGAMMO: "HG অ্যামো",
  TXT_ITEM_KAR98K: "কার98কে",
  TXT_ITEM_LANUNCHERAMMO: "40mmSR",
  TXT_ITEM_M1014: "M1014",
  TXT_ITEM_M14: "M14",
  TXT_ITEM_M1873: "M1873",
  TXT_ITEM_M249: "M249",
  TXT_ITEM_M4A1: "M4A1",
  TXT_ITEM_M500: "M500",
  TXT_ITEM_M79: "M79",
  TXT_ITEM_MACHETE: "প্যারাং",
  TXT_ITEM_MAGEZINE1: "ম্যাগাজিন লেভেল1",
  TXT_ITEM_MAGEZINE2: "ম্যাগাজিন লেভেল2",
  TXT_ITEM_MAGEZINE3: "ম্যাগাজিন লেভেল3",
  TXT_ITEM_MP40: "MP40",
  TXT_ITEM_MP5: "MP5",
  TXT_ITEM_MUZZLE1: "মাজল লেভেল1",
  TXT_ITEM_MUZZLE2: "মাজল লেভেল2",
  TXT_ITEM_MUZZLE3: "মাজল লেভেল3",
  TXT_ITEM_SCAR: "স্কার",
  TXT_ITEM_SGAMMO: "SG অ্যামো",
  TXT_ITEM_SIGHT2: "2x স্কোপ",
  TXT_ITEM_SIGHT4: "4x স্কোপ",
  TXT_ITEM_SILENCER1: "সাইলেন্সার",
  TXT_ITEM_SKS: "SKS",
  TXT_ITEM_SMGAMMO: "SMG অ্যামো",
  TXT_ITEM_SNAMMO: "স্নাইপার অ্যামো",
  TXT_ITEM_SPAS12: "SPAS12",
  TXT_ITEM_SVD: "SVD",
  TXT_ITEM_UMP: "UMP",
  TXT_ITEM_USP: "USP",
  TXT_ITEM_VEST1: "ভেস্ট লেভেল1",
  TXT_ITEM_VEST2: "ভেস্ট লেভেল2",
  TXT_ITEM_VEST3: "ভেস্ট লেভেল3",
  TXT_ITEM_VSS: "VSS",
  TXT_ITEM_XM8: "XM8",
  TXT_MATCHRESULT_TITLE: "রেজাল্ট",
  TXT_MESSAGEBOX_ERROR: "ত্রুটি",
  TXT_OB10_HQW_ITEM_BIPOD: "বাইপড",
  TXT_OB10_HQW_ITEM_M60: "M60",
  TXT_OB10_JRW_CAMOUFLAGE_OILDRUM_NAME: "তেলের ব্যারেল",
  TXT_OB10_JRW_CHARACTER_BRAZILSOLDIER_NAME: "মিগুয়েল",
  TXT_OB10_JRW_SKILL_NAME_BRAZILSOLDIER: "ক্রেজি স্লেয়ার",
  TXT_OB10_ZXR_BASEBALLBAT_CORN_NAME: "মেক্সিকান গ্রিলড কর্ন",
  TXT_OB10_ZXR_GRENADESKIN_RANGE: "বিস্ফোরণ পরিসীমা",
  TXT_OB10_ZXR_MACHETE_RANKMASTER_NAME: "দ্য এক্সিকিউশনার",
  TXT_OB11_HQW_ITEM_MGL140: "MGL140",
  TXT_OB11_HQW_ITEM_P90: "P90",
  TXT_OB11_HQW_LANDMINE: "ল্যান্ডমাইন",
  TXT_OB11_HQW_LANDMINE_DESC: "এমন একটি মাইন যা মাটিতে স্থাপন করা যেতে পারে। সতর্কবাণী, নিজেই আবার এটাতে পা দেবেন না!",
  TXT_OB11_JRW_CHARACTER_RICHGIRL_NAME: "ক্যারোলিন",
  TXT_OB11_JRW_EMOTE_CLAP_NAME: "Applause",
  TXT_OB11_JRW_EMOTE_DAB_NAME: "Dab",
  TXT_OB11_JRW_EMOTE_FUNKYCHICKEN_NAME: "Chicken",
  TXT_OB11_JRW_EMOTE_HELLO_NAME: "Hello!",
  TXT_OB11_JRW_EMOTE_LOL_NAME: "LOL",
  TXT_OB11_JRW_EMOTE_PROVOKE_NAME: "Provoke",
  TXT_OB11_JRW_SKILL_DESC_RICHGIRL: "একটি শটগান ধারণ করার সময়, মুভমেন্ট স্পিড [FFB300]{0}%[-] বৃদ্ধি পায়।",
  TXT_OB11_JRW_SKILL_NAME_RICHGIRL: "তত্পরতা",
  TXT_OB11_ZXR_SCAR_CHEETAH_NAME: "চিতাহ: ফ্যাং",
  TXT_OB11_ZXR_SCAR_TOPGAMER_NAME: "ভবিষ্যতবাদী",
  TXT_OB16_Q_ITEM_ARMORREPAIR: "মেরামত কিট",
  TXT_OB5_HISTORY_HEADSHOOT: "হেডশটস",
  TXT_OB5_HISTORY_LIVE: "সার্ভাইভাল",
  TXT_OB7_JRW_CHARACTER_FOODIEBOY_NAME: "ম্যাক্সিম",
  TXT_OB7_JRW_SKILL_DESC_FOODIEBOY: "মাশরুম খাওয়া এবং মেড-কিট ব্যবহার [FFB300]{0}%[-] দ্রুততর করুন",
  TXT_OB7_JRW_SKILL_NAME_FOODIEBOY: "Gluttony",
  TXT_OB7_ZC_CLAN_NICKNAME: "ডাকনাম",
  TXT_OB7_ZJS_HISTORY_TIME: "সময়",
  TXT_OB8_HQW_NEWLOADOUT_BONFIRE: "বনফায়ার",
  TXT_OB8_JYF_PARACHUTE_THUNDER_NAME: "Bolt",
  TXT_OB8_SQ_CHARACTER_THAIBOXER_NAME: "ক্লা",
  TXT_OB8_SQ_SKILL_DESC_THAIBOXER: "ফিস্ট ড্যামেজ [FFB300]{0}%[-] বৃদ্ধি পায়।",
  TXT_OB8_SQ_SKILL_NAME_THAIBOXER: "মুয়ে থাই",
  TXT_OB8_ZXR_AWM_CAMO_NAME: "পার্পল মিডাউজ",
  TXT_OB8_ZXR_G18_CAMO_NAME: "এটম স্প্লিটার",
  TXT_OB8_ZXR_M249_CAMO_NAME: "হুইথার্ড",
  TXT_OB8_ZXR_M79_CAMO_NAME: "স্কাইস্প্লিটার",
  TXT_OB8_ZXR_USP_CAMO_NAME: "স্নো লিওপার্ড",
  TXT_OB9_JRW_CHARACTER_ARMSDEALER_NAME: "পালোমা",
  TXT_OB9_JRW_SKILL_NAME_ARMSDEALER: "অস্ত্র-লেনদেন",
  TXT_OB9_JYF_SKYBOARD_BOOYAH_NAME: "Green Star",
  TXT_OB9_SQ_ITEM_GLOOSHIELD: "গ্লু ওয়াল",
  TXT_OB9_ZXR_AK47_DIGI_CAMO_NAME: "ডিজিটাল ক্যামোফ্লেজ",
  TXT_OB9_ZXR_FAMAS_RED_NAME: "ব্লাডি মেরি",
  TXT_OB9_ZXR_G18_CAMO_02_NAME: "ডেসার্ট হান্টার",
  TXT_OB9_ZXR_GROZA_CAMO_NAME: "ব্লু ফ্লেম",
  TXT_OB9_ZXR_M1014_CAMO_02_NAME: "পার্পল প্যারেড",
  TXT_OB9_ZXR_M14_CAMO_NAME: "জীবন প্রবাহ",
  TXT_OB9_ZXR_M1873_NAME: "ডিপ ব্লু সি",
  TXT_OB9_ZXR_MACHETE_FISH_NAME: "সোর্ডফিশ",
  TXT_OB9_ZXR_MP5_CAMO_NAME: "হারভেস্টার",
  TXT_OB9_ZXR_SCAR_CAMO_BLUE_NAME: "পার্পল কোয়ার্টজ",
  TXT_OB9_ZXR_SKS_CAMO_NAME: "ঝলসিত পৃথিবী",
  TXT_OPTION_HIGH_BRIGHTNESS: "ব্রাইট",
  TXT_PLAYER_RANK: "র‍্যাংক",
  TXT_ROOM_LOBBY_ID: "আইডি",
  TXT_ROOM_MAP_PARADISE: "বারমুডা",
  TXT_SETTING_CHANGEWEAPON: "দ্রুত ওয়েপন সুইচ বাটন",
  TXT_SETTING_OB4_NOTREAL: "কালো",
  TXT_SKILL_DESC_COP: "আর্মর স্থায়িত্ব হ্রাস [FFB300]{0}%[-] কমে যায়৷",
  TXT_SKILL_DESC_RUNNER: "স্প্রিন্টিং গতি [FFB300]{0}%[-] বৃদ্ধি পায়৷",
  TXT_SKILL_NAME_COP: "আর্মার বিশেষজ্ঞ",
  TXT_SKILL_NAME_NURSE: "হিলিং স্পর্শ",
  TXT_SKILL_NAME_RACERGIRL: "আফটারবার্নার",
  TXT_SKILL_NAME_RUNNER: "ড্যাশ",
  TXT_SKILL_NAME_SEAMAN: "লোহা হবে",
  TXT_TUTORIAL_HUD: "HUD",
  TXT_TUTORIAL_HUD_LABEL10: "স্প্রিন্ট",
  TXT_TUTORIAL_PICKUP_LABEL0: "অস্ত্র",
  T_34_M_WS_VFXTYPE: "VFX টাইপ",
  T_40_XXJ_WS_MONSTERATTACKTARGETTYPE_NAMEKEY: "আক্রমণের লক্ষ্য",
  T_40_XXJ_WS_PLAYERUISWITCHTYPE_NAMEKEY: "প্লেয়ার UI টাইপ",
  T_41_XXJ_WS_MONSTERSKILLTYPE: "মনস্টার স্কিল টাইপ",
  T_45_META_WS_DESCRIPTIVECOLOR: "বর্ণনামূলক রঙ",
  T_45_META_WS_GAMETIME: "গেম টাইম",
  T_45_META_WS_PROPERTY: "প্রপার্টি",
  T_45_XXJ_WS_UISOCIALBUTTONSTYLETYPE: "বোতামের স্টাইলের ধরন",
  T_45_XXJ_WS_UISOCIALBUTTONTYPE: "বোতামের ধরন",
  T_46_META_WS_A_A: "A",
  T_46_META_WS_A_ACCELERATION: "ট্রিগার",
  T_46_META_WS_A_ACCOUNTID: "সম্পদ",
  T_46_META_WS_A_ACTIONTYPE: "ডান মান",
  T_46_META_WS_A_ACTIVE: "অবস্থান",
  T_46_META_WS_A_ANGLE: "কোণ",
  T_46_META_WS_A_ANY: "যেকোনো",
  T_46_META_WS_A_APPEARANCEGROUP: "লক্ষ্য অবস্থান",
  T_46_META_WS_A_ASSERTIONEXPRESSION: "দাবি অভিব্যক্তি",
  T_46_META_WS_A_ATTACHMENT: "উচ্চতা",
  T_46_META_WS_A_ATTACHMENTS: "দৈর্ঘ্য",
  T_46_META_WS_A_ATTACKABLE: "বস্তু",
  T_46_META_WS_A_ATTACKER: "আক্রমণকারী",
  T_46_META_WS_A_ATTACKTARGET: "আক্রমণ লক্ষ্য",
  T_46_META_WS_A_AUTOPLAY: "স্বাভাবিক",
  T_46_META_WS_A_AXIS: "যেকোনো",
  T_46_META_WS_A_B: "B",
  T_46_META_WS_A_BASE: "ভিত্তি",
  T_46_META_WS_A_BOUNDTARGET: "বাউন্ড লক্ষ্য",
  T_46_META_WS_A_BTREE: "আচরণ গাছ",
  T_46_META_WS_A_BUFF: "সূচক",
  T_46_META_WS_A_CAMERA: "মিশন আইডি",
  T_46_META_WS_A_CAPICITY: "ধারণক্ষমতা",
  T_46_META_WS_A_CENTER: "কেন্দ্র",
  T_46_META_WS_A_CHANGEROTATION: "মান খুঁজুন",
  T_46_META_WS_A_CHANNEL: "চ্যানেল",
  T_46_META_WS_A_CHASEENEMY: "বাম মান",
  T_46_META_WS_A_CHILD: "বি",
  T_46_META_WS_A_COLOR: "রঙ",
  T_46_META_WS_A_COLUMN: "বাম",
  T_46_META_WS_A_COLUMNNAME: "ডান",
  T_46_META_WS_A_COMEBACK: "ফিরে আসুন",
  T_46_META_WS_A_COMPONENT: "উপাদান",
  T_46_META_WS_A_CONTENT: "বিষয়বস্তু",
  T_46_META_WS_A_COORDINATESYSTEM: "ফিল্টার প্রকার",
  T_46_META_WS_A_COUNT: "সংখ্যা",
  T_46_META_WS_A_COUNTS: "গণনা",
  T_46_META_WS_A_CREATEDENTITY: "তৈরি করা সত্তা",
  T_46_META_WS_A_CROSSPLATFORM: "ক্রস প্ল্যাটফর্ম",
  T_46_META_WS_A_CULLINGMASK: "কুলিং মাস্ক",
  T_46_META_WS_A_CURVE: "দিক",
  T_46_META_WS_A_CUSTOMTAG: "সংখ্যা",
  T_46_META_WS_A_CUTRADIUS: "কাট ব্যাসার্ধ",
  T_46_META_WS_A_DAMAGE: "ক্ষতি",
  T_46_META_WS_A_DAMAGESEGMENTS: "ক্ষতি সেগমেন্ট",
  T_46_META_WS_A_DEGREE: "ডিগ্রি",
  T_46_META_WS_A_DELTA: "মান বি",
  T_46_META_WS_A_DEPTH: "গভীরতা",
  T_46_META_WS_A_DESTVAL: "আর",
  T_46_META_WS_A_DIFFICULTY: "কঠিনতা",
  T_46_META_WS_A_DIRECTION: "দিকনির্দেশনা",
  T_46_META_WS_A_DISABLE: "ব্যাসার্ধ",
  T_46_META_WS_A_DISPLACEMENT: "ওয়ালেট",
  T_46_META_WS_A_DISTANCE: "বিষয়বস্তু",
  T_46_META_WS_A_DIVINGMAXSPEED: "ডাইভিং সর্বাধিক গতি",
  T_46_META_WS_A_DOTWEEN: "টুইন করুন",
  T_46_META_WS_A_DURATION: "সময়কাল (সেকেন্ড)",
  T_46_META_WS_A_EMOTE: "অভিব্যক্তি",
  T_46_META_WS_A_ENABLE: "সক্রিয় করুন",
  T_46_META_WS_A_ENDAREACENTER: "শেষ এলাকা কেন্দ্র",
  T_46_META_WS_A_ENDAREARANGE: "শেষ এলাকা পরিসীমা",
  T_46_META_WS_A_ENDPOSITION: "শেষ অবস্থান",
  T_46_META_WS_A_ENDRANK: "শেষ র্যাংক",
  T_46_META_WS_A_EQUIPMENTS: "ঘূর্ণন",
  T_46_META_WS_A_EVENTID: "ইভেন্ট আইডি",
  T_46_META_WS_A_EXPONENT: "সূচক",
  T_46_META_WS_A_FACTION: "লক্ষ্য",
  T_46_META_WS_A_FACTORTYPE: "ফ্যাক্টর প্রকার",
  T_46_META_WS_A_FILTERTYPE: "ফিল্টার প্রকার",
  T_46_META_WS_A_FINALRADIUS: "চূড়ান্ত ব্যাসার্ধ",
  T_46_META_WS_A_FINDVALUE: "মান খুঁজুন",
  T_46_META_WS_A_FIXEDRANGE: "ইঙ্গিত",
  T_46_META_WS_A_FOLLOWTARGET: "লক্ষ্য অনুসরণ করুন",
  T_46_META_WS_A_FONTCOLOR: "ফন্টের রঙ",
  T_46_META_WS_A_FONTSIZE: "ফন্ট সাইজ",
  T_46_META_WS_A_FOOTBALL: "স্তরের বস্তু",
  T_46_META_WS_A_FORCE: "প্রপার্টি",
  T_46_META_WS_A_FORCEDPARACHUTEHEIGHT: "বাধ্যতামূলক প্যারাশুট উচ্চতা",
  T_46_META_WS_A_FORCEMODE: "পরিবর্তন প্রকার",
  T_46_META_WS_A_FORWARD: "দিকনির্দেশনা",
  T_46_META_WS_A_G: "G",
  T_46_META_WS_A_GAMEID: "উইজেট আইডি",
  T_46_META_WS_A_HALFEXTENTS: "প্রপার্টি আইডি",
  T_46_META_WS_A_HEIGHT: "উচ্চতা",
  T_46_META_WS_A_HEIGHTSEGMENTS: "উচ্চতা সেগমেন্ট",
  T_46_META_WS_A_HITDISTANCE: "হিট দূরত্ব",
  T_46_META_WS_A_HITDISTANCES: "উপাদান",
  T_46_META_WS_A_HITENTITIES: "স্টাইল",
  T_46_META_WS_A_HITENTITY: "হিট এন্টিটি",
  T_46_META_WS_A_HITNORMAL: "হিট পয়েন্টের স্বাভাবিক",
  T_46_META_WS_A_HITNORMALS: "ইভেন্ট আইডি",
  T_46_META_WS_A_HITPOINTS: "অবস্থান",
  T_46_META_WS_A_HITPOSITION: "হিট অবস্থান",
  T_46_META_WS_A_INCLUDETRIGGER: "ফিরে আসা",
  T_46_META_WS_A_INDEX: "সূচক",
  T_46_META_WS_A_INDEXS: "সূচক",
  T_46_META_WS_A_INITIALVELOCITY: "অফসেট",
  T_46_META_WS_A_INITRADIUS: "প্রাথমিক ব্যাসার্ধ",
  T_46_META_WS_A_INWALLET: "ইন ওয়ালেট",
  T_46_META_WS_A_ISBOTTOMCOLLIDING: "ভিতরে ওয়ালেট",
  T_46_META_WS_A_ISEXIST: "অস্তিত্ব",
  T_46_META_WS_A_ISLOOP: "প্রারম্ভিক অবস্থান",
  T_46_META_WS_A_ISMAPPEDINSCREEN: "স্ক্রীনে ম্যাপড কিনা",
  T_46_META_WS_A_ISPAUSE: "বিরতি",
  T_46_META_WS_A_ISSIDECOLLIDING: "বাইরে ওয়ালেট",
  T_46_META_WS_A_ISSUCCESS: "সফল কিনা",
  T_46_META_WS_A_ISTOPCOLLIDING: "অর্থের ধরন",
  T_46_META_WS_A_ITEM: "আইটেম",
  T_46_META_WS_A_ITEMID: "বিরতি কিনা",
  T_46_META_WS_A_ITEMS: "আইটেম",
  T_46_META_WS_A_ITEMTYPE: "ইমোট",
  T_46_META_WS_A_JERSEYTYPE: "জার্সি প্রকার",
  T_46_META_WS_A_KEEPVELOCITY: "টোকেন আইডি",
  T_46_META_WS_A_KEY: "কী",
  T_46_META_WS_A_KEYCOLUMN: "মান এ",
  T_46_META_WS_A_KEYS: "প্রস্থ",
  T_46_META_WS_A_LAYER: "স্তর",
  T_46_META_WS_A_LAYERMASK: "স্লট",
  T_46_META_WS_A_LEFT: "বাম",
  T_46_META_WS_A_LEFTVALUE: "বাম মান",
  T_46_META_WS_A_LENGTH: "দৈর্ঘ্য",
  T_46_META_WS_A_LEVELOBJECT: "স্তর বস্তু",
  T_46_META_WS_A_LOG: "কোণ",
  T_46_META_WS_A_LOOKATTARGET: "বস্তু",
  T_46_META_WS_A_LOOPTYPE: "ক্ষতি",
  T_46_META_WS_A_MAINCOLOR1: "পর্ব সূচক",
  T_46_META_WS_A_MAINCOLOR2: "অবস্থা",
  T_46_META_WS_A_MAPCODE: "রঙ",
  T_46_META_WS_A_MAPPEDPOSITION: "ম্যাপড অবস্থান",
  T_46_META_WS_A_MAX: "সর্বাধিক",
  T_46_META_WS_A_MAXDISPLACEMENT: "আক্রমণকারী",
  T_46_META_WS_A_MAXDISTANCE: "ফ্যাক্টর টাইপ",
  T_46_META_WS_A_MIN: "সর্বনিম্ন",
  T_46_META_WS_A_MISSIONID: "মিশন আইডি",
  T_46_META_WS_A_MISSIONPROGRESS: "মিশন অগ্রগতি",
  T_46_META_WS_A_MODIFYTYPE: "পরিবর্তন প্রকার",
  T_46_META_WS_A_MONEYTYPE: "মুদ্রার প্রকার",
  T_46_META_WS_A_MUST: "অবশ্যই",
  T_46_META_WS_A_NAME: "মালিক",
  T_46_META_WS_A_NEWVALUE: "নতুন মান",
  T_46_META_WS_A_NODE: "নোড",
  T_46_META_WS_A_NORMAL: "স্বাভাবিক",
  T_46_META_WS_A_NOT: "না",
  T_46_META_WS_A_OBSERVER: "পর্যবেক্ষক",
  T_46_META_WS_A_OFFSET: "অফসেট",
  T_46_META_WS_A_OLDVALUE: "পুরানো মান",
  T_46_META_WS_A_OPERATIOMETHOD: "অপারেশন পদ্ধতি",
  T_46_META_WS_A_OPTIONS: "বিকল্প",
  T_46_META_WS_A_OTHERCOLOR: "তৈরি করা সত্তা",
  T_46_META_WS_A_OUTFIT: "প্রারম্ভিক সূচক",
  T_46_META_WS_A_OUTFITS: "বিচ্ছেদ",
  T_46_META_WS_A_OUTWALLET: "আউট ওয়ালেট",
  T_46_META_WS_A_OWNER: "মালিক",
  T_46_META_WS_A_PARACHUTINGMAXSPEED: "প্যারাশুটিং সর্বাধিক গতি",
  T_46_META_WS_A_PARAMS: "পরামিতি",
  T_46_META_WS_A_PARENT: "জি",
  T_46_META_WS_A_PARENTWIDGET: "আক্রমণের লক্ষ্য",
  T_46_META_WS_A_PATH: "প্রাথমিক ব্যাসার্ধ",
  T_46_META_WS_A_PATHPOINTS: "পথ পয়েন্ট",
  T_46_META_WS_A_PHASEINDEX: "ধাপ সূচক",
  T_46_META_WS_A_PLATFORM: "প্ল্যাটফর্ম",
  T_46_META_WS_A_PLAYER: "অবস্থান",
  T_46_META_WS_A_PLAYSPEED: "সময়কাল (s)",
  T_46_META_WS_A_POSITION: "অবস্থান",
  T_46_META_WS_A_POSITIONS: "অবস্থান",
  T_46_META_WS_A_POSTION: "অবস্থান",
  T_46_META_WS_A_PREFAB: "দৃশ্য আইডি",
  T_46_META_WS_A_PROPERTY: "সম্পত্তি",
  T_46_META_WS_A_PROPERTYID: "সম্পত্তি আইডি",
  T_46_META_WS_A_PURSUITTARGET: "অনুসরণ লক্ষ্য",
  T_46_META_WS_A_R: "R",
  T_46_META_WS_A_RADIUS: "ব্যাসার্ধ",
  T_46_META_WS_A_RANDOMDECAY: "কী",
  T_46_META_WS_A_RANDOMRANGE: "এলোমেলো পরিসীমা",
  T_46_META_WS_A_RANDOMRATIO: "প্যারামিটার",
  T_46_META_WS_A_RANGE: "অপ্রত্যাশিত প্রকাশ",
  T_46_META_WS_A_RANK: "স্কেল",
  T_46_META_WS_A_REALCOIN: "UI আইডি",
  T_46_META_WS_A_REALNUMBER: "বাস্তব সংখ্যা",
  T_46_META_WS_A_RESET: "লক্ষ্য অনুসরণ করুন",
  T_46_META_WS_A_RESOURCE: "সম্পদ",
  T_46_META_WS_A_RESULT: "আবশ্যক",
  T_46_META_WS_A_RIGHT: "ডান",
  T_46_META_WS_A_RIGHTVALUE: "ডান মান",
  T_46_META_WS_A_ROTATION: "ঘূর্ণন",
  T_46_META_WS_A_ROW: "সর্বাধিক",
  T_46_META_WS_A_SAMPLEPOINT: "নমুনা পয়েন্ট",
  T_46_META_WS_A_SCALE: "স্কেল",
  T_46_META_WS_A_SCENEID: "দৃশ্য আইডি",
  T_46_META_WS_A_SCORE: "স্কোর",
  T_46_META_WS_A_SCORENAME: "স্কোর নাম",
  T_46_META_WS_A_SCREENPOSITION: "স্ক্রীনের অবস্থান",
  T_46_META_WS_A_SCRIPT: "চূড়ান্ত ব্যাসার্ধ",
  T_46_META_WS_A_SEAT: "আসন",
  T_46_META_WS_A_SEP: "বিভাজক",
  T_46_META_WS_A_SEPSTR: "বিভাজক",
  T_46_META_WS_A_SHEETNAME: "ন্যূনতম",
  T_46_META_WS_A_SHOPITEM: "সাফল্য কিনা",
  T_46_META_WS_A_SHOWBACKGROUND: "ব্যাকগ্রাউন্ড দেখান",
  T_46_META_WS_A_SHOWMATCHRESULT: "গণনা",
  T_46_META_WS_A_SHOWMESSAGEWHENCANCEL: "বাতিল করলে বার্তা দেখান",
  T_46_META_WS_A_SKILL: "দক্ষতা",
  T_46_META_WS_A_SKILLS: "মান",
  T_46_META_WS_A_SKILLTARGET: "দক্ষতা লক্ষ্য",
  T_46_META_WS_A_SKIN: "ব্যাকপ্যাক স্কিন",
  T_46_META_WS_A_SLOT: "স্লট",
  T_46_META_WS_A_SRCVAL: "ডিগ্রি",
  T_46_META_WS_A_SRCVALUE: "উত্স মান",
  T_46_META_WS_A_STARTAREACENTER: "শুরু এলাকা কেন্দ্র",
  T_46_META_WS_A_STARTAREARANGE: "শুরু এলাকা পরিসীমা",
  T_46_META_WS_A_STARTINDEX: "শুরু সূচক",
  T_46_META_WS_A_STARTPOSITION: "শুরু অবস্থান",
  T_46_META_WS_A_STARTRANK: "শুরুর র্যাংক",
  T_46_META_WS_A_STATE: "অপেক্ষা সময় (s)",
  T_46_META_WS_A_STATUS: "স্থিতি",
  T_46_META_WS_A_STATUSCODE: "স্ট্যাটাস কোড",
  T_46_META_WS_A_STYLE: "শৈলী",
  T_46_META_WS_A_SURFINGMAXSPEED: "সার্ফিং সর্বাধিক গতি",
  T_46_META_WS_A_TARGET: "লক্ষ্য",
  T_46_META_WS_A_TARGETPOSITION: "লক্ষ্য অবস্থান",
  T_46_META_WS_A_TEAMSEQ: "ফরোয়ার্ড",
  T_46_META_WS_A_THRESHOLD: "চ্যানেল",
  T_46_META_WS_A_TIMESTAMP: "টাইমস্ট্যাম্প",
  T_46_META_WS_A_TIPS: "পরামর্শ",
  T_46_META_WS_A_TITLE: "শিরোনাম",
  T_46_META_WS_A_TOKENCOUNT: "টোকেন সংখ্যা",
  T_46_META_WS_A_TOKENID: "টোকেন আইডি",
  T_46_META_WS_A_TORQUE: "বিদ্যমান কিনা",
  T_46_META_WS_A_TOUCHPOINT: "টাচ পয়েন্ট",
  T_46_META_WS_A_TRANSITIONTIME: "টোকেন সংখ্যা",
  T_46_META_WS_A_TRANSITIONTYPE: "মিশন অগ্রগতি",
  T_46_META_WS_A_TRIGGER: "ট্রিগার",
  T_46_META_WS_A_TYPE: "প্রকার",
  T_46_META_WS_A_UI: "ধাওয়া লক্ষ্য",
  T_46_META_WS_A_UIID: "UI আইডি",
  T_46_META_WS_A_UPWARD: "জার্সি প্রকার",
  T_46_META_WS_A_VALUE: "মান",
  T_46_META_WS_A_VALUEA: "মান A",
  T_46_META_WS_A_VALUEB: "মান B",
  T_46_META_WS_A_VALUES: "কাটা ব্যাসার্ধ",
  T_46_META_WS_A_VALUET: "না",
  T_46_META_WS_A_VALUETYPE: "মানের প্রকার",
  T_46_META_WS_A_VEHICLE: "যানবাহন",
  T_46_META_WS_A_VEHICLESKIN: "যানবাহন স্কিন",
  T_46_META_WS_A_VELOCITY: "কেন্দ্র",
  T_46_META_WS_A_VELOCITYXZ: "নতুন মান",
  T_46_META_WS_A_VELOCITYY: "পুরানো মান",
  T_46_META_WS_A_VISIBLE: "দৃশ্যমান",
  T_46_META_WS_A_WAITTIME: "অপেক্ষার সময় (সেকেন্ড)",
  T_46_META_WS_A_WALLET: "ওয়ালেট",
  T_46_META_WS_A_WEAPON: "বিভাজক",
  T_46_META_WS_A_WEAPONSKIN: "সূচক",
  T_46_META_WS_A_WIDGETID: "উইজেট আইডি",
  T_46_META_WS_A_WIDGETTYPE: "সক্ষম করুন",
  T_46_META_WS_A_WIDTH: "প্রস্থ",
  T_46_META_WS_A_WORLDPOSITION: "বিশ্বের অবস্থান",
  T_46_META_WS_A_WORLDPOSITIONSTAYS: "প্রকার",
  T_46_META_WS_A_X: "X",
  T_46_META_WS_A_Y: "Y",
  T_46_META_WS_ABS: "পরম মান",
  T_46_META_WS_ACOS: "Acos",
  T_46_META_WS_ADDAOISPECIALFOLLOW: "AOI বিশেষ অনুসরণ যোগ করুন",
  T_46_META_WS_ADDATTACHMENTS: "সংযোজন যোগ করুন",
  T_46_META_WS_ADDBUFF: "বাফ যোগ করুন",
  T_46_META_WS_ADDCOMPONENT: "উপাদান যোগ করুন",
  T_46_META_WS_ADDFOOTBALLVELOCITY: "ফুটবল গতি যোগ করুন",
  T_46_META_WS_ADDFORCE: "বল প্রয়োগ করুন",
  T_46_META_WS_ADDFORCEATPOSITION: "অবস্থানে বল প্রয়োগ করুন",
  T_46_META_WS_ADDFORMULAPROPERTYFACTOR: "সূত্র বৈশিষ্ট্য ফ্যাক্টর যোগ করুন",
  T_46_META_WS_ADDGAMEEVENTLOG: "গেম ইভেন্ট লগ যোগ করুন",
  T_46_META_WS_ADDHP: "HP যোগ করুন",
  T_46_META_WS_ADDITEM: "আইটেম যোগ করুন",
  T_46_META_WS_ADDITEMINSCENE: "দৃশ্যপটে আইটেম তৈরি করুন",
  T_46_META_WS_ADDITEMTOSHOPITEM: "আইটেমে আইটেম যোগ করুন",
  T_46_META_WS_ADDMONEY: "টাকা যোগ করুন",
  T_46_META_WS_ADDSCRIPT: "স্ক্রিপ্ট যোগ করুন",
  T_46_META_WS_ADDTAG: "ট্যাগ যোগ করুন",
  T_46_META_WS_ADDTOKEN: "টোকেন যোগ করুন",
  T_46_META_WS_ADDTORQUE: "টর্ক যোগ করুন",
  T_46_META_WS_ADDUSEREVENTLOG: "ব্যবহারকারী ইভেন্ট লগ যোগ করুন",
  T_46_META_WS_ANGEL: "কোণ",
  T_46_META_WS_APPEND: "সংযুক্ত করুন",
  T_46_META_WS_APPENDRANGE: "পরিসীমা যোগ করুন",
  T_46_META_WS_APPLYQUITMIDWAYUICONFIG: "মাঝপথে বন্ধ UI কনফিগারেশন প্রয়োগ করুন",
  T_46_META_WS_ASIN: "Asin",
  T_46_META_WS_ASSERT: "নিশ্চিত করুন",
  T_46_META_WS_ASSISTPLAYER: "সহায়ক খেলোয়াড়",
  T_46_META_WS_ATAN2: "ATan2",
  T_46_META_WS_ATTACKER: "আক্রমণকারী",
  T_46_META_WS_ATTACKTARGET: "আক্রমণ লক্ষ্য",
  T_46_META_WS_AXISANGLETOQUATERNION: "অক্ষ কোণকে কুয়ার্নিয়নে রূপান্তরিত করুন",
  T_46_META_WS_BOXCAST: "বক্স কাস্ট",
  T_46_META_WS_BOXOVERLAP: "বক্স ওভারল্যাপ",
  T_46_META_WS_BUTTONNAME: "বোতামের নাম",
  T_46_META_WS_C_ACTIONTYPE: "কাজের প্রকার",
  T_46_META_WS_C_AIMABLE: "লক্ষ্য করা যেতে পারে এমন উপাদান",
  T_46_META_WS_C_AIMASSISTABLE: "লক্ষ্য সহায়ক উপাদান",
  T_46_META_WS_C_AIMASSISTTYPE: "লক্ষ্য সহায়তা প্রকার",
  T_46_META_WS_C_AIRDROP: "এয়ারড্রপ",
  T_46_META_WS_C_AMMO: "গোলাবারুদ",
  T_46_META_WS_C_AMMOTYPE: "গোলাবারুদ টাইপ",
  T_46_META_WS_C_AMPHIBIAN: "অ্যামফিবিয়ান",
  T_46_META_WS_C_ANIMATIONCLIP: "অ্যানিমেশন ক্লিপ",
  T_46_META_WS_C_ANIMATIONCLIPID: "অ্যানিমেশন ক্লিপ আইডি",
  T_46_META_WS_C_ANIMATIONCONTROLLER: "অ্যানিমেশন কন্ট্রোলার",
  T_46_META_WS_C_ANIMATIONCONTROLLERATTACHABLE: "এনিমেশন কন্ট্রোলার সংযুক্ত করা যেতে পারে",
  T_46_META_WS_C_ANIMATIONCONTROLLERID: "অ্যানিমেশন কন্ট্রোলার আইডি",
  T_46_META_WS_C_ANIMATIONSTATE: "অ্যানিমেশন অবস্থান",
  T_46_META_WS_C_ANIMATIONTRIGGER: "অ্যানিমেশন ট্রিগার",
  T_46_META_WS_C_APPEARENCE: "উপস্থিতি",
  T_46_META_WS_C_ASSETCONFIGID: "অ্যাসেট কনফিগ আইডি",
  T_46_META_WS_C_ASSETID: "অ্যাসেট আইডি",
  T_46_META_WS_C_ATTACHMENT: "সংযোজন",
  T_46_META_WS_C_ATTACKABLETYPE: "আক্রমণযোগ্য প্রকার",
  T_46_META_WS_C_AUDIOID: "অডিও আইডি",
  T_46_META_WS_C_BACKPACK: "ব্যাকপ্যাক",
  T_46_META_WS_C_BACKPACKSKINID: "ব্যাকপ্যাক স্কিন আইডি",
  T_46_META_WS_C_BASEDATAALIAS: "বেস ডেটা উপনাম",
  T_46_META_WS_C_BASICAPPEARANCE: "মূল আউটলুক",
  T_46_META_WS_C_BASICCYLINDER: "মৌলিক সিলিন্ডার",
  T_46_META_WS_C_BASICSCALABLE: "মৌলিক স্কেলযোগ্য",
  T_46_META_WS_C_BASICSPHERE: "মৌলিক গোলক",
  T_46_META_WS_C_BATCHCOMBINERENDER: "ব্যাচ কম্বাইন রেন্ডার",
  T_46_META_WS_C_BEVTREE: "বিহেভিয়ার ট্রি",
  T_46_META_WS_C_BEVTREEATTACHABLE: "বিহেভিয়ার ট্রি সংযুক্ত করা যাবে",
  T_46_META_WS_C_BEVTREECUSTOMNODE: "বিহেভিয়ার ট্রি কাস্টম নোড",
  T_46_META_WS_C_BEVTREEID: "বিহেভিয়ার ট্রি আইডি",
  T_46_META_WS_C_BEVTREENODESTATUS: "বিহেভিয়ার ট্রি নোড স্ট্যাটাস",
  T_46_META_WS_C_BEVTREENODETYPE: "বিহেভিয়ার ট্রি নোড টাইপ",
  T_46_META_WS_C_BEZIERCURVE: "বেজিয়ার বক্ররেখা",
  T_46_META_WS_C_BOOL: "বুলিয়ান",
  T_46_META_WS_C_BOTDIFFICULTYTYPE: "বটের কঠিনতা প্রকার",
  T_46_META_WS_C_BOUNCINGTIRE: "বাউন্সিং টায়ার",
  T_46_META_WS_C_BUFFABLE: "বাফযোগ্য",
  T_46_META_WS_C_BUFFGENERATOR: "বাফ জেনারেটর",
  T_46_META_WS_C_BUFFTYPE: "বাফ প্রকার",
  T_46_META_WS_C_BUILTINRENDER: "বিল্ট-ইন রেন্ডার",
  T_46_META_WS_C_BUILTINUI: "বিল্ট-ইন UI",
  T_46_META_WS_C_BUILTINUITYPE: "বিল্ট-ইন UI প্রকার",
  T_46_META_WS_C_CAMERA: "ক্যামেরা",
  T_46_META_WS_C_CAMERABLOCKMODE: "ক্যামেরা ব্লক মোড",
  T_46_META_WS_C_CAMERAPROJECTIONMODE: "ক্যামেরা প্রকল্প মোড",
  T_46_META_WS_C_CAMERARAYCASTUI: "ক্যামেরা রে-কাস্ট UI",
  T_46_META_WS_C_CAMERATRANSITIONTYPE: "ক্যামেরা স্থানান্তর প্রকার",
  T_46_META_WS_C_CAMERATYPE: "ক্যামেরা প্রকার",
  T_46_META_WS_C_CAMERAVIEWINGANGLERESTRICTIONTYPE: "ক্যামেরার দর্শন কোণ সীমাবদ্ধতা প্রকার",
  T_46_META_WS_C_CAPSULETRIGGER: "ক্যাপসুল ট্রিগার",
  T_46_META_WS_C_CAR: "গাড়ি",
  T_46_META_WS_C_CHARACTERCONTROLLER: "চরিত্র নিয়ন্ত্রক",
  T_46_META_WS_C_CHATCHANNEL: "চ্যাট চ্যানেল",
  T_46_META_WS_C_CHATCHANNELTYPE: "চ্যাট চ্যানেলের প্রকার",
  T_46_META_WS_C_CHECKPOINTTRIGGER: "চেক পয়েন্ট ট্রিগার",
  T_46_META_WS_C_COINGENERATOR: "কয়েন জেনারেটর",
  T_46_META_WS_C_COLLECTIONID: "সংগ্রহ আইডি",
  T_46_META_WS_C_COLLIDER: "কোণার",
  T_46_META_WS_C_COLLIDERCOLLECTION: "কলাইডার শেপ",
  T_46_META_WS_C_COLLIDERCOLLECTIONID: "কলাইডার সংগ্রহ আইডি",
  T_46_META_WS_C_COLORDRUM: "রঙিন ড্রাম",
  T_46_META_WS_C_COMBATABLE: "লড়াই করা যায় এমন",
  T_46_META_WS_C_COMPONENT: "উপাদান",
  T_46_META_WS_C_CONDITION: "শর্ত",
  T_46_META_WS_C_CONTAINER: "কন্টেনার",
  T_46_META_WS_C_COORDINATESYSTEMTYPE: "সমন্বয় সিস্টেম প্রকার",
  T_46_META_WS_C_CROSSBOW: "গ্রেনেড ক্রসবো",
  T_46_META_WS_C_CSVID: "সিএসভি আইডি",
  T_46_META_WS_C_CUSTOMIZETRIGGER: "কাস্টমাইজ ট্রিগার",
  T_46_META_WS_C_CUSTOMLEVELOBJECT: "কাস্টম বস্তু",
  T_46_META_WS_C_CUSTOMPATH: "কাস্টম পাথ",
  T_46_META_WS_C_CUSTOMUI: "কাস্টম UI",
  T_46_META_WS_C_CUSTOMUIID: "কাস্টম UI আইডি",
  T_46_META_WS_C_CUSTOMUIORWIDGET: "কাস্টম UI বা উইজেট",
  T_46_META_WS_C_CUSTOMUIWIDGETID: "কাস্টম UI উইজেট আইডি",
  T_46_META_WS_C_DAMAGEDBODYPARTTYPE: "ক্ষতিগ্রস্ত শরীরের অংশের প্রকার",
  T_46_META_WS_C_DAMAGETYPE: "ক্ষতির ধরন",
  T_46_META_WS_C_DEATHORINVINCIBILITYTRIGGER: "মৃত্যু বা অদৃশ্য ট্রিগার",
  T_46_META_WS_C_DESTRUCTIBLELEVELOBJECT: "ধ্বংসযোগ্য বস্তু",
  T_46_META_WS_C_DICE: "খেলনা",
  T_46_META_WS_C_DOUBLEJUMPSHOES: "ডাবল জাম্প জুতো",
  T_46_META_WS_C_DRUMMUSIC: "ড্রাম মিউজিক",
  T_46_META_WS_C_DUALWIELDWEAPONTYPE: "দ্বৈত অস্ত্র টাইপ",
  T_46_META_WS_C_DUMMYLEVELOBJECT: "সাধারণ স্তরের বস্তু",
  T_46_META_WS_C_DYNAMICCREATELEVELOBJECTTYPE: "গতিশীলভাবে তৈরি করা স্তরের বস্তু প্রকার",
  T_46_META_WS_C_DYNAMICFENCE: "ডাইনামিক ফেন্স",
  T_46_META_WS_C_EFFECT: "প্রভাব",
  T_46_META_WS_C_EFFECTCONTAINER: "এফেক্ট কনটেইনার",
  T_46_META_WS_C_EFFECTID: "ইফেক্ট আইডি",
  T_46_META_WS_C_EMOTETYPE: "ইমোট প্রকার",
  T_46_META_WS_C_ENDPOINTTRIGGER: "এন্ড পয়েন্ট ট্রিগার",
  T_46_META_WS_C_ENTITY: "সত্তা",
  T_46_META_WS_C_ENTITYORPREFABID: "সত্তা বা প্রিফ্যাব আইডি",
  T_46_META_WS_C_EQUIPMENTATTACHMENT: "যন্ত্রপাতি আনুষাঙ্গিক",
  T_46_META_WS_C_EQUIPMENTSLOTTYPE: "সরঞ্জাম স্লট টাইপ",
  T_46_META_WS_C_EQUIPMENTTYPE: "সরঞ্জামের ধরন",
  T_46_META_WS_C_EVENTID: "ইভেন্ট আইডি",
  T_46_META_WS_C_FACTION: "পক্ষ",
  T_46_META_WS_C_FILLDIRECTIONTYPE: "পূরণের দিক প্রকার",
  T_46_META_WS_C_FILLTYPE: "পূরণের প্রকার",
  T_46_META_WS_C_FIRETYPE: "আগুনের ধরন",
  T_46_META_WS_C_FLOAT: "ভাসমান সংখ্যা",
  T_46_META_WS_C_FOLDWING: "ভাঁজযোগ্য ডানা",
  T_46_META_WS_C_FOLLOW: "অনুসরণ",
  T_46_META_WS_C_FONTTYPE: "ফন্ট প্রকার",
  T_46_META_WS_C_FOOTBALL: "ফুটবল",
  T_46_META_WS_C_FORCETYPE: "শক্তি প্রকার",
  T_46_META_WS_C_FORMULABLE: "সূত্রবদ্ধ",
  T_46_META_WS_C_FRAMESELFRELATIVE: "ফ্রেম স্ব-সম্পর্কিত",
  T_46_META_WS_C_GAMERESULTTYPE: "গেম ফলাফলের প্রকার",
  T_46_META_WS_C_GENDERTYPE: "লিঙ্গ",
  T_46_META_WS_C_GENERALSPAWNPOINT: "সাধারণ স্পাউন পয়েন্ট",
  T_46_META_WS_C_GRENADEDEICEWALL: "আইস ওয়াল ডি-গ্রেনেড",
  T_46_META_WS_C_GRENADEFLASHBANG: "ফ্ল্যাশব্যাং",
  T_46_META_WS_C_GRENADEFROZEN: "বরফে গুলি",
  T_46_META_WS_C_GRENADELAUNCHER: "গ্রেনেড লঞ্চার",
  T_46_META_WS_C_GRENADESMOKE: "ধোঁয়া গ্রেনেড",
  T_46_META_WS_C_GRENADEWEAPON: "গ্রেনেড বেস",
  T_46_META_WS_C_GRID: "গ্রিড",
  T_46_META_WS_C_HANDCANNON: "হ্যান্ডক্যানন গ্রেনেড",
  T_46_META_WS_C_HELMET: "হেলমেট",
  T_46_META_WS_C_HIERARCHICAL: "শ্রেণীবদ্ধ",
  T_46_META_WS_C_HOOKGUN: "হুক গান",
  T_46_META_WS_C_HORIZALINE: "অনুভূমিক লাইন",
  T_46_META_WS_C_HUDTRANSFORM_DEPRECATED: "UI ট্রান্সফর্ম",
  T_46_META_WS_C_HUMANMODELID: "মানব মডেল আইডি",
  T_46_META_WS_C_ICEWALL: "বরফের প্রাচীর",
  T_46_META_WS_C_ICEWALLCREATED: "তৈরি করা বরফের প্রাচীর",
  T_46_META_WS_C_ICEWALLMAKER: "আইস ওয়াল মেকার",
  T_46_META_WS_C_ICON: "আইকন এন্টিটি",
  T_46_META_WS_C_ICONTYPE: "আইকনের ধরন",
  T_46_META_WS_C_INHALER: "ইনহেলার",
  T_46_META_WS_C_INT: "পূর্ণসংখ্যা",
  T_46_META_WS_C_INT64: "64-বিট পূর্ণসংখ্যা",
  T_46_META_WS_C_INTEGERMAPTEMPLATE: "পূর্ণসংখ্যা ম্যাপ টেমপ্লেট",
  T_46_META_WS_C_INTORINTLIST: "পূর্ণসংখ্যা অথবা পূর্ণসংখ্যার তালিকা",
  T_46_META_WS_C_INVENTORYTYPE: "ইনভেন্টরি টাইপ",
  T_46_META_WS_C_ITEMBASE: "আইটেম বেস",
  T_46_META_WS_C_ITEMCONTAINER: "আইটেম কন্টেইনার",
  T_46_META_WS_C_ITEMID: "আইটেম আইডি",
  T_46_META_WS_C_ITEMIDTYPE: "আইটেম আইডি টাইপ",
  "T_46_META_WS_C_JERSEY STYLE": "জার্সি স্টাইল",
  T_46_META_WS_C_JERSEYMACHINE: "জার্সি মেশিন",
  T_46_META_WS_C_JETSHOES: "জেট জুতো",
  T_46_META_WS_C_KEYBOARD: "কিবোর্ড",
  T_46_META_WS_C_KNOCKDOWNTYPE: "নকডাউন টাইপ",
  T_46_META_WS_C_LANDMINE: "Landmine",
  T_46_META_WS_C_LANDMINECREATED: "তৈরি করা মাইন",
  "T_46_META_WS_C_LAUNCH PAD LEVEL OBJECT": "লঞ্চ প্যাড লেভেল অবজেক্ট",
  T_46_META_WS_C_LAUNCHPAD: "লঞ্চ প্যাড",
  T_46_META_WS_C_LAYOUTSORTTYPE: "লেআউট সাজানোর প্রকার",
  T_46_META_WS_C_LEAD1MUSIC: "লিড1 মিউজিক",
  T_46_META_WS_C_LEAD2MUSIC: "লিড2 মিউজিক",
  T_46_META_WS_C_LEAD3MUSIC: "লিড3 মিউজিক",
  T_46_META_WS_C_LEVELOBJECTID: "স্তর অবজেক্ট আইডি",
  T_46_META_WS_C_LEVELOBJECTTYPE: "স্তরের বস্তু প্রকার",
  T_46_META_WS_C_LIST: "তালিকা",
  T_46_META_WS_C_LISTORMAP: "তালিকা অথবা মানচিত্র",
  T_46_META_WS_C_LISTT: "তালিকা টেমপ্লেট",
  T_46_META_WS_C_LISTT_BOOL: "বুলিয়ান তালিকা",
  T_46_META_WS_C_LISTT_CONDITION: "শর্তের তালিকা",
  T_46_META_WS_C_LISTT_ENTITY: "সত্তা তালিকা",
  T_46_META_WS_C_LISTT_FLOAT: "ফ্লোট তালিকা",
  T_46_META_WS_C_LISTT_INT: "পূর্ণসংখ্যা তালিকা",
  T_46_META_WS_C_LISTT_ITEMGOODSIDTYPE: "আইটেম তালিকা",
  T_46_META_WS_C_LISTT_LEVELOBJECT: "লেভেল অবজেক্ট তালিকা",
  T_46_META_WS_C_LISTT_LOCKEY: "লোকালাইজেশন কী তালিকা",
  T_46_META_WS_C_LISTT_PLAYABLE: "খেলা যাওয়া তালিকা",
  T_46_META_WS_C_LISTT_PLAYER: "খেলোয়াড় তালিকা",
  T_46_META_WS_C_LISTT_SKILLID: "দক্ষতা আইডি তালিকা",
  T_46_META_WS_C_LISTT_SOUNDEFFECT: "শব্দ প্রভাবের তালিকা",
  T_46_META_WS_C_LISTT_STRING: "স্ট্রিং তালিকা",
  T_46_META_WS_C_LISTT_TEAM: "টিম তালিকা",
  T_46_META_WS_C_LISTT_TYPE: "টাইপ তালিকা",
  T_46_META_WS_C_LISTT_VECTOR3: "ভেক্টর3 তালিকা",
  T_46_META_WS_C_LOCKEY: "স্থানীয়করণ কী",
  T_46_META_WS_C_LOOKAT: "দেখুন",
  T_46_META_WS_C_LOOPABLE: "লুপযোগ্য",
  T_46_META_WS_C_LOOPTYPE: "লুপ টাইপ",
  T_46_META_WS_C_LOOTAMMOTYPE: "লুটের গুলির প্রকার",
  T_46_META_WS_C_LOOTARMOR: "লুটের বর্ম",
  T_46_META_WS_C_LOOTARMORTYPE: "লুটের বর্মের প্রকার",
  T_46_META_WS_C_LOOTCONSUMABLE: "লুটের ভোগ্যপণ্য",
  T_46_META_WS_C_LOOTCONSUMABLETYPE: "লুটের ভোগ্যপণ্যের প্রকার",
  T_46_META_WS_C_LOOTIAMMO: "লুটের গুলি",
  T_46_META_WS_C_LOOTITEMBOXSOCCER: "লুট ফুটবল আইটেম বক্স",
  T_46_META_WS_C_LOOTSCOPE: "লুটের স্কোপ",
  T_46_META_WS_C_LOOTSCOPETYPE: "লুটের স্কোপের প্রকার",
  T_46_META_WS_C_LOOTSOCCERTYPE: "লুট ফুটবল প্রকার",
  T_46_META_WS_C_LOOTTHROWABLE: "লুটের নিক্ষেপযোগ্য",
  T_46_META_WS_C_LOOTTHROWABLETYPE: "লুটের নিক্ষেপযোগ্য প্রকার",
  T_46_META_WS_C_LOOTWEAPON: "লুটের অস্ত্র",
  T_46_META_WS_C_LOOTWEAPONTYPE: "লুটের অস্ত্রের প্রকার",
  T_46_META_WS_C_LOWGRAVITY: "কম-গ্র্যাভিটি এলাকা",
  T_46_META_WS_C_MAP: "মানচিত্র",
  T_46_META_WS_C_MAPT: "মানচিত্র টেমপ্লেট",
  T_46_META_WS_C_MATERIALID: "উপাদান আইডি",
  T_46_META_WS_C_MEDKIT: "মেডকিট",
  T_46_META_WS_C_MESHID: "মেশ আইডি",
  T_46_META_WS_C_MIDGAMEEXITCONFIG: "মাঝারি খেলোয়াড়ের কনফিগারেশন",
  T_46_META_WS_C_MINIMAP: "মিনি-ম্যাপ",
  T_46_META_WS_C_MINIMAPICON: "মিনি-ম্যাপ আইকন",
  T_46_META_WS_C_MINIMAPPIXELRENDERER: "মিনিম্যাপ পিক্সেল রেন্ডারার",
  T_46_META_WS_C_MINISENTRY: "মিনি সেন্ট্রি",
  T_46_META_WS_C_MINISENTRYATTACKRANGETYPE: "মিনি সেন্ট্রি আক্রমণ পরিসরের প্রকার",
  T_46_META_WS_C_MINISENTRYCREATED: "মিনি সেন্ট্রি তৈরি হয়েছে",
  T_46_META_WS_C_MONEY: "অর্থ",
  T_46_META_WS_C_MONEYTYPE: "অর্থ প্রকার",
  T_46_META_WS_C_MONSTER: "দৈত্য",
  T_46_META_WS_C_MONSTERSPAWN: "মনস্টার স্পন",
  T_46_META_WS_C_MONSTERTYPE: "দৈত্যের ধরন",
  T_46_META_WS_C_MORPHABLEOBJECT: "মর্ফযোগ্য বস্তু",
  T_46_META_WS_C_MORPHOBJECT: "মর্ফযোগ্য বস্তু",
  T_46_META_WS_C_MOTOBIKE: "মোটরবাইক",
  T_46_META_WS_C_MOVEPLATFORM: "মুভ প্ল্যাটফর্ম",
  T_46_META_WS_C_MOVEPLATFORMTYPE: "মুভ প্ল্যাটফর্ম টাইপ",
  T_46_META_WS_C_MUSHROOM: "মাশরুম",
  T_46_META_WS_C_NATURALCONSTANTTYPE: "প্রাকৃতিক ধ্রুবক",
  T_46_META_WS_C_NPC: "NPC",
  T_46_META_WS_C_NUMBER: "সংখ্যা",
  T_46_META_WS_C_OBJECT: "বস্তু",
  T_46_META_WS_C_OILDRUM: "তেল ড্রাম",
  T_46_META_WS_C_OUTFITID: "পোশাকের আইডি",
  T_46_META_WS_C_OUTFITSLOTTYPE: "পোশাক স্লট প্রকার",
  T_46_META_WS_C_PATHPOINT: "পথের পয়েন্ট",
  T_46_META_WS_C_PATROLSTYLETYPE: "পেট্রোল স্টাইল টাইপ",
  T_46_META_WS_C_PATROLTYPE: "পেট্রোল টাইপ",
  T_46_META_WS_C_PERSONA: "পারসোনা",
  T_46_META_WS_C_PHASE: "পর্ব",
  T_46_META_WS_C_PHYSICALMOVER: "পদার্থগত মুভার",
  T_46_META_WS_C_PHYSICALOBJECT: "পদার্থগত বস্তু",
  T_46_META_WS_C_PLATFORMTYPE: "প্ল্যাটফর্ম প্রকার",
  T_46_META_WS_C_PLAYABLE: "খেলা যায় এমন",
  T_46_META_WS_C_PLAYABLEORPLAYABLES: "খেলাধুলা বা খেলাধুলার অ্যারে",
  T_46_META_WS_C_PLAYER: "খেলোয়াড়",
  T_46_META_WS_C_PLAYERBACKPACK: "প্লেয়ার ব্যাকপ্যাক",
  T_46_META_WS_C_PLAYERBEHAVIORSTATUSTYPE: "প্লেয়ার আচরণ অবস্থার প্রকার",
  T_46_META_WS_C_PLAYERBEHAVIORTYPE: "প্লেয়ার আচরণ প্রকার",
  T_46_META_WS_C_PLAYERCCT: "FF চরিত্রের জন্য চরিত্র নিয়ন্ত্রক",
  T_46_META_WS_C_PLAYERDATAID: "পূর্বনির্ধারিত চরিত্র প্রকার",
  T_46_META_WS_C_PLAYERORTRANSFORM: "প্লেয়ার বা রূপান্তর",
  T_46_META_WS_C_PLAYERORVEHICLE: "প্লেয়ার বা যানবাহন",
  T_46_META_WS_C_PLAYEROUTFIT: "প্লেয়ার পোশাক",
  T_46_META_WS_C_PLAYERPOSETYPE: "প্লেয়ার পোজ টাইপ",
  T_46_META_WS_C_PLAYERREVIVESOURCETYPE: "প্লেয়ার পুনরুজ্জীবন উৎসের প্রকার",
  T_46_META_WS_C_PLAYERSTATETYPE: "প্লেয়ার স্টেট টাইপ",
  T_46_META_WS_C_POINTLIGHT: "পয়েন্ট লাইট",
  T_46_META_WS_C_PORTAL: "পোর্টাল",
  T_46_META_WS_C_PREFABID: "প্রিফ্যাব আইডি",
  T_46_META_WS_C_PRESENTEFFECTGENERATOR_DEPRECATED: "প্রেজেন্ট এফেক্ট জেনারেটর",
  T_46_META_WS_C_PRESENTEFFECTTEXTURETYPE_DEPRECATED: "এফেক্ট টেক্সচার প্রকার",
  T_46_META_WS_C_PROFILEPICTUREWIDGET: "প্রোফাইল ছবি উইজেট",
  T_46_META_WS_C_PROPERTY: "সম্পত্তি",
  T_46_META_WS_C_PROPERTYFORMULA: "প্রপার্টি সূত্র",
  T_46_META_WS_C_PROPERTYFORMULAFACTORTYPE: "প্রপার্টি সূত্র ফ্যাক্টর প্রকার",
  T_46_META_WS_C_PROPERTYMODIFYTYPE: "প্রপার্টি পরিবর্তনের প্রকার",
  T_46_META_WS_C_QUATERNION: "কুয়াটার্নিয়ন",
  T_46_META_WS_C_RANKABLE: "قابل تصنيف",
  T_46_META_WS_C_RAYCASTLAYERTYPE: "রে কাস্ট স্তর প্রকার",
  T_46_META_WS_C_REPAIRKIT: "মেরামতের কিট",
  T_46_META_WS_C_RESETABLE: "রিসেটযোগ্য",
  T_46_META_WS_C_RIGIDBODY: "রিগিডবডি",
  T_46_META_WS_C_RIGIDBODYCONSTRAINTYPE: "রিগিডবডি কনস্ট্রেন প্রকার",
  T_46_META_WS_C_RIGIDBODYTYPE: "রিগিডবডি প্রকার",
  T_46_META_WS_C_ROUND: "রাউন্ড",
  T_46_META_WS_C_SAFEZONE: "সেফ জোন",
  T_46_META_WS_C_SCOREABLE: "قابل تقييم",
  T_46_META_WS_C_SCRIPTID: "স্ক্রিপ্ট আইডি",
  T_46_META_WS_C_SEATTYPE: "সিট টাইপ",
  T_46_META_WS_C_SELFRELATIVE: "স্ব-সম্পর্কিত",
  T_46_META_WS_C_SHOP: "দোকান",
  T_46_META_WS_C_SHOPITEM: "দোকানের আইটেম",
  T_46_META_WS_C_SHOPSHELF: "দোকানের শেলফ",
  T_46_META_WS_C_SKATEBOARD: "স্কেটবোর্ড",
  T_46_META_WS_C_SKELETON: "কঙ্কাল",
  T_46_META_WS_C_SKELETONPART: "অস্থি অংশ",
  T_46_META_WS_C_SKILLID: "দক্ষতা আইডি",
  T_46_META_WS_C_SKYBLASTER: "উড়ন্ত যন্ত্র",
  T_46_META_WS_C_SKYBOX: "স্কাইবক্স",
  T_46_META_WS_C_SKYBOXTYPE: "স্কাইবক্স প্রকার",
  T_46_META_WS_C_SOCIALISLANDSNOWBALL: "সামাজিক দ্বীপ তুষার বল",
  T_46_META_WS_C_SORTTYPE: "শ্রেণীবিভাগের ধরন",
  T_46_META_WS_C_SOUNDDRUMTYPE: "সাউন্ড ড্রাম টাইপ",
  T_46_META_WS_C_SOUNDEFFECT: "শব্দ প্রভাব",
  T_46_META_WS_C_SOUNDEFFECTORSOUNDEFFECTLIST: "শব্দ প্রভাব বা শব্দ প্রভাবের তালিকা",
  T_46_META_WS_C_SOUNDEFFECTTYPE: "সাউন্ড ইফেক্ট টাইপ",
  T_46_META_WS_C_SOUNDLEAD1TYPE: "সাউন্ড লিড1 টাইপ",
  T_46_META_WS_C_SOUNDLEAD2TYPE: "সাউন্ড লিড2 টাইপ",
  T_46_META_WS_C_SOUNDLEAD3TYPE: "সাউন্ড লিড3 টাইপ",
  T_46_META_WS_C_SOUNDPIANOTYPE: "সাউন্ড পিয়ানো টাইপ",
  T_46_META_WS_C_SPAWN: "উৎপন্ন করা",
  T_46_META_WS_C_SPAWNABLE: "স্পাওনযোগ্য",
  T_46_META_WS_C_SPAWNBOX: "স্পন জোন",
  T_46_META_WS_C_SPAWNPOSITION: "স্পন পয়েন্ট",
  T_46_META_WS_C_SPECIALITEMIDTYPE: "বিশেষ আইটেম আইডি টাইপ",
  T_46_META_WS_C_SPHERETRIGGER: "গোলক ট্রিগার",
  T_46_META_WS_C_SPORTSCAR: "স্পোর্টস কার",
  T_46_META_WS_C_SPRAYCOLOR: "স্প্রে রঙ",
  T_46_META_WS_C_SPRAYGUN: "স্প্রে গান",
  T_46_META_WS_C_SPRAYRESULTUI: "স্প্রে ফলাফলের UI",
  T_46_META_WS_C_SPRAYRIFLE: "স্প্রে রাইফেল",
  T_46_META_WS_C_SPRITEID: "স্প্রাইট আইডি",
  T_46_META_WS_C_STATICSCRIPTID: "স্ট্যাটিক স্ক্রিপ্ট আইডি",
  T_46_META_WS_C_STRING: "স্ট্রিং",
  T_46_META_WS_C_STRINGORLOCSTRING: "স্ট্রিং বা লোকালাইজড স্ট্রিং",
  T_46_META_WS_C_SUPPLYBOXTRIGGER: "সরবরাহ বাক্স ট্রিগার",
  T_46_META_WS_C_SWINGGUN: "সুইং গান",
  T_46_META_WS_C_SWITCHEQUIPSLOT: "স্যুইচিং সরঞ্জাম স্লট",
  T_46_META_WS_C_TEAM: "দল",
  T_46_META_WS_C_TERRAIN: "ভূখণ্ড",
  T_46_META_WS_C_TEXT: "টেক্সট এন্টিটি",
  T_46_META_WS_C_TEXTUREID: "টেক্সচার আইডি",
  T_46_META_WS_C_TEXTURETYPE: "বস্তু টেক্সচার",
  T_46_META_WS_C_TIMER: "টাইমার",
  T_46_META_WS_C_TIMESTAMPFORMATSTYLETYPE: "টাইমস্ট্যাম্প ফরম্যাট স্টাইল টাইপ",
  T_46_META_WS_C_TIMESTAMPLOCSTRING: "টাইমস্ট্যাম্প লোকালাইজেশন স্ট্রিং",
  T_46_META_WS_C_TRAJECTORY: "পথ",
  T_46_META_WS_C_TRANSFORM: "রূপান্তর",
  T_46_META_WS_C_TUKTUK: "টুক টুক",
  T_46_META_WS_C_TURRET: "টারেট",
  T_46_META_WS_C_TWEEN: "টুইন",
  T_46_META_WS_C_TWEENCURVE_DEPRECATED: "টুইন কার্ভ",
  T_46_META_WS_C_TWEENSTYLE: "টুইন স্টাইল প্রকার",
  T_46_META_WS_C_TYPE: "প্রকার",
  T_46_META_WS_C_TYPEENUM: "ধরন এনাম",
  T_46_META_WS_C_TYPEORTYPELIST: "টাইপ অথবা টাইপ তালিকা",
  T_46_META_WS_C_UIADDSCORE: "UI স্কোর যোগ করুন",
  T_46_META_WS_C_UIANITRIGGERHUD: "UI অ্যানিমেশন ট্রিগার HUD",
  T_46_META_WS_C_UIBUILTINSWITCH: "UI বিল্ট-ইন সুইচ",
  T_46_META_WS_C_UIBUILTINUISWITCHCONTROLLER: "UI বিল্ট-ইন UI সুইচ কন্ট্রোলার",
  T_46_META_WS_C_UICARDSELECTIONPANEL: "UI কার্ড নির্বাচন প্যানেল",
  T_46_META_WS_C_UICHECKPOINTINDICATOR: "UI চেক পয়েন্ট সূচক",
  T_46_META_WS_C_UICOMPASS: "UI কম্পাস",
  T_46_META_WS_C_UICOUNTDOWN5: "UI ৫-সেকেন্ড কাউন্টডাউন",
  T_46_META_WS_C_UICOUNTDOWNHINT: "UI কাউন্টডাউন ইঙ্গিত",
  T_46_META_WS_C_UICOUNTDOWNREMINDER: "UI কাউন্টডাউন রিমাইন্ডার",
  T_46_META_WS_C_UIFOLLOWHEADLTHBAR: "চরিত্রের মাথার উপরের স্বাস্থ্য বার",
  T_46_META_WS_C_UIHEALTHBAR: "UI হেলথ বার",
  T_46_META_WS_C_UIHEARTBEAT: "UI হার্টবিট",
  T_46_META_WS_C_UIICONNOTIFICATION: "UI আইকন বিজ্ঞপ্তি",
  T_46_META_WS_C_UIIDENTITYNOTIFICATION: "UI পরিচয় বিজ্ঞপ্তি",
  T_46_META_WS_C_UIINTERACTIONBUTTON: "UI ইন্টারঅ্যাকশন বোতাম",
  T_46_META_WS_C_UILEADERBOARDBUTTON: "UI লিডারবোর্ড বোতাম",
  T_46_META_WS_C_UIMATCHSUBTITLE: "UI ম্যাচ সাবটাইটেল",
  T_46_META_WS_C_UIMONSTERLEVEL: "UI মনস্টার লেভেল",
  T_46_META_WS_C_UIMONSTERUI: "UI মনস্টার UI",
  T_46_META_WS_C_UIMULTIPLETEAMLEADERBOARD: "UI বহু-দল লিডারবোর্ড",
  T_46_META_WS_C_UIMULTITEAMRESULTPANEL: "UI বহু-দল ফলাফল প্যানেল",
  T_46_META_WS_C_UIOPENINGBANNER: "UI ওপেনিং ব্যানার",
  T_46_META_WS_C_UIPANEL: "UI প্যানেল",
  T_46_META_WS_C_UIPANELEMPTY: "UI ফাঁকা প্যানেল",
  T_46_META_WS_C_UIPHASETIMER: "UI ফেজ টাইমার",
  T_46_META_WS_C_UIPROGRESSBAR: "UI প্রগ্রেস বার",
  T_46_META_WS_C_UIPROGRESSCIRCLE: "UI প্রগ্রেস সার্কেল",
  T_46_META_WS_C_UIPROGRESSSKILLBUTTON: "UI প্রগ্রেস স্কিল বোতাম",
  T_46_META_WS_C_UIREQUESTPURCHASETYPE: "UI কেনার জন্য অনুরোধ টাইপ",
  T_46_META_WS_C_UIROUNDINFOBANNER: "UI রাউন্ড ইনফো ব্যানার",
  T_46_META_WS_C_UIROUNDNUMBER: "UI রাউন্ড নম্বর",
  T_46_META_WS_C_UIROUNDRESULTBANNER: "UI রাউন্ড ফলাফল ব্যানার",
  T_46_META_WS_C_UIROUNDSTARTBANNER: "UI রাউন্ড শুরুর ব্যানার",
  T_46_META_WS_C_UIROUNDTRANSITION: "UI রাউন্ড ট্রানজিশন",
  T_46_META_WS_C_UISCOREBAR: "UI স্কোর বার",
  T_46_META_WS_C_UISCROLLPANEL: "UI স্ক্রোল প্যানেল",
  T_46_META_WS_C_UISIMPLEROUNDSCOREBANNER: "UI সাধারণ রাউন্ড স্কোর ব্যানার",
  T_46_META_WS_C_UISIMPLEROUNDSTARTBANNER: "UI সাধারণ রাউন্ড শুরুর ব্যানার",
  T_46_META_WS_C_UISIMPLETIP: "UI সাধারণ টিপ",
  T_46_META_WS_C_UISIMPLEVERSUSBANNER: "UI সাধারণ ভার্সাস ব্যানার",
  T_46_META_WS_C_UISKILLBUTTON: "UI স্কিল বোতাম",
  T_46_META_WS_C_UISOCIALBUTTONWIDGET: "সামাজিক ফাংশনের বোতাম উইজেট",
  T_46_META_WS_C_UISOLOLEADERBOARD: "UI একক লিডারবোর্ড",
  T_46_META_WS_C_UISTORE: "UI স্টোর UI",
  T_46_META_WS_C_UITEAMMATCHINFO: "UI দল ম্যাচ তথ্য",
  T_46_META_WS_C_UITEXTTIP: "UI টেক্সট টিপ",
  T_46_META_WS_C_UITIMERINFO: "UI টাইমার ইনফো",
  T_46_META_WS_C_UITIPBUTTON: "UI টিপ বোতাম",
  T_46_META_WS_C_UITITLEBANNER: "UI শিরোনাম ব্যানার",
  T_46_META_WS_C_UITWEENTIP: "UI টুইন টিপ",
  T_46_META_WS_C_UITWOTEAMBRIEFINFO: "UI দুই-দল সংক্ষিপ্ত তথ্য",
  T_46_META_WS_C_UITWOTEAMINFO: "UI দুই-দল তথ্য",
  T_46_META_WS_C_UITWOTEAMLEADERBOARD: "UI দুই-দল লিডারবোর্ড",
  T_46_META_WS_C_UITWOTEAMRESULTPANEL: "UI দুই-দল ফলাফল প্যানেল",
  T_46_META_WS_C_UITWOTEAMROUNDSCOREBANNER: "UI দুই-দল রাউন্ড স্কোর ব্যানার",
  T_46_META_WS_C_UITWOTEAMSCOREPANEL: "UI দুই-দল স্কোর প্যানেল",
  T_46_META_WS_C_UIVERSUSBANNER: "UI ভার্সাস ব্যানার",
  T_46_META_WS_C_UIWIDGET: "UI উইজেট",
  T_46_META_WS_C_UIWIDGETBUTTON: "UI উইজেট বোতাম",
  T_46_META_WS_C_UIWIDGETCONTAINER: "UI উইজেট কনটেইনার",
  T_46_META_WS_C_UIWIDGETEMPTY: "UI উইজেট ফাঁকা",
  T_46_META_WS_C_UIWIDGETIMAGE: "UI উইজেট ইমেজ",
  T_46_META_WS_C_UIWIDGETINPUTLABLE: "UI উইজেট ইনপুট লেবেল",
  T_46_META_WS_C_UIWIDGETJOYSTICK: "UI উইজেট জয়স্টিক",
  T_46_META_WS_C_UIWIDGETLABEL: "UI উইজেট লেবেল",
  T_46_META_WS_C_UIWIDGETLAYOUT: "UI উইজেট লেআউট",
  T_46_META_WS_C_UIWIDGETPROFILE: "UI উইজেট প্রোফাইল",
  T_46_META_WS_C_UIWIDGETTEXTURE: "UI উইজেট টেক্সচার",
  T_46_META_WS_C_UIWIDGETTOGGLE: "UI উইজেট টগল",
  T_46_META_WS_C_UIWIDGETTOUCHPAD: "UI উইজেট টাচপ্যাড",
  T_46_META_WS_C_UIWINORLOSEBANNER: "UI জয়-বা-পরাজয় ব্যানার",
  T_46_META_WS_C_UNITSPAWN: "ইউনিট সৃষ্টিকারী",
  T_46_META_WS_C_UUID: "UUID",
  T_46_META_WS_C_VAULTTRIGGER: "উইন্ডো ক্লাইম্বিং লজিক অবজেক্ট",
  T_46_META_WS_C_VECTOR2: "ভেক্টর2",
  T_46_META_WS_C_VECTOR3: "ভেক্টর3",
  T_46_META_WS_C_VEHICLE: "যানবাহন",
  T_46_META_WS_C_VEHICLEIDTYPE: "যানবাহন আইডি প্রকার",
  T_46_META_WS_C_VEHICLESKINID: "গাড়ির ত্বক আইডি",
  T_46_META_WS_C_VENDINGMACHINE: "ভেন্ডিং মেশিন",
  T_46_META_WS_C_VEST: "ভেস্ট",
  T_46_META_WS_C_VFXREPLACETEXTPRESENT: "VFX প্রতিস্থাপনযোগ্য টেক্সচার এন্টিটি",
  T_46_META_WS_C_VFXTEXTURE: "VFX টেক্সচার",
  T_46_META_WS_C_VISIBILITY: "দৃশ্যমানতা",
  T_46_META_WS_C_WALLET: "ওয়ালেট",
  T_46_META_WS_C_WALLETHUD: "ওয়ালেট UI",
  T_46_META_WS_C_WATERZONE: "জল এলাকা",
  T_46_META_WS_C_WAVECOUNTTYPE: "ওয়েভ গণনা প্রকার",
  T_46_META_WS_C_WAVEINTERVALTYPE: "তরঙ্গ ফাঁক প্রকার",
  T_46_META_WS_C_WEAPON: "অস্ত্র",
  T_46_META_WS_C_WEAPONGENERATOR: "অস্ত্র জেনারেটর",
  T_46_META_WS_C_WEAPONSKINID: "অস্ত্রের স্কিন আইডি",
  T_46_META_WS_C_WEAPONTYPE: "অস্ত্রের প্রকার",
  T_46_META_WS_C_WIDGETTYPE: "উইজেট প্রকার",
  T_46_META_WS_C_ZIPLINE: "জিপ লাইন",
  T_46_META_WS_CAMERADIRECTION: "ক্যামেরার দিক",
  T_46_META_WS_CAMERAPOSITION: "ক্যামেরার অবস্থান",
  T_46_META_WS_CAPSULECAST: "ক্যাপসুল কাস্ট",
  T_46_META_WS_CAPSULEOVERLAP: "ক্যাপসুল ওভারল্যাপ",
  T_46_META_WS_CEIL: "উচ্চসীমা",
  T_46_META_WS_CHATCHANNEL: "চ্যাট চ্যানেল",
  T_46_META_WS_CHECKTRIGGERBYORDER: "ক্রম অনুসারে ট্রিগার পরীক্ষা করুন",
  T_46_META_WS_CLAMP: "Clamp",
  T_46_META_WS_CLEAR: "পরিষ্কার করুন",
  T_46_META_WS_CLEARALLCHILDREN: "সমস্ত শিশু মুছে ফেলুন",
  T_46_META_WS_CLEARAOISPECIALFOLLOW: "AOI বিশেষ অনুসরণ পরিষ্কার করুন",
  T_46_META_WS_CLEARBACKPACK: "পিঠ ব্যাগ পরিষ্কার করুন",
  T_46_META_WS_CLEARFORMULAPROPERTYFACTOR: "সূত্র বৈশিষ্ট্য ফ্যাক্টর পরিষ্কার করুন",
  T_46_META_WS_CLEARRESIDUALLEVELOBJECTS: "অবশিষ্ট লেভেল অবজেক্টগুলি পরিষ্কার করুন",
  T_46_META_WS_CLIPNAME: "ক্লিপের নাম",
  T_46_META_WS_CLONE: "ক্লোন",
  T_46_META_WS_COLLIDEDENTITY: "ধাক্কা খাওয়া সত্তা",
  T_46_META_WS_COLORGET: "রঙ পান",
  T_46_META_WS_COMPLETECUSTOMMISSION: "কাস্টম মিশন সম্পূর্ণ করুন",
  T_46_META_WS_CONNECT: "সংযোগ করুন",
  T_46_META_WS_CONSUMABLEID: "আইটেম আইডি",
  T_46_META_WS_CONTAIN: "অন্তর্ভুক্ত",
  T_46_META_WS_CONTAINKEY: "কী উপস্থিত কিনা তা পরীক্ষা করুন",
  T_46_META_WS_COPYTOMORPH: "রূপান্তর জন্য কপি করুন",
  T_46_META_WS_COS: "Cos",
  T_46_META_WS_COSTMONEY: "টাকা খরচ করুন",
  T_46_META_WS_COSTTOKEN: "টোকেন ব্যয় করুন",
  T_46_META_WS_CREATEAIRDROP: "এয়ার ড্রপ তৈরি করুন",
  T_46_META_WS_CREATEBOT: "বট তৈরি করুন",
  T_46_META_WS_CREATEBUILTINUI: "বিল্ট-ইন UI তৈরি করুন",
  T_46_META_WS_CREATEBUILTINUICLIENT: "বিল্ট-ইন UI তৈরি করুন",
  T_46_META_WS_CREATECAMERA: "ক্যামেরা তৈরি করুন",
  T_46_META_WS_CREATECURVE: "কার্ভ তৈরি করুন",
  T_46_META_WS_CREATECUSTOMUI: "কাস্টম UI তৈরি করুন",
  T_46_META_WS_CREATECUSTOMUICLIENT: "কাস্টম UI তৈরি করুন",
  T_46_META_WS_CREATECUSTOMUIWIDGET: "কাস্টম UI উইজেট তৈরি করুন",
  T_46_META_WS_CREATEDAMAGENUM: "ক্ষতির সংখ্যা তৈরি করুন",
  T_46_META_WS_CREATEEFFECT: "প্রভাব তৈরি করুন",
  T_46_META_WS_CREATEEFFECTCLIENT: "প্রভাব তৈরি করুন",
  T_46_META_WS_CREATEFACTION: "গোষ্ঠী তৈরি করুন",
  T_46_META_WS_CREATEFOLLOW: "অনুসরণ তৈরি করুন",
  T_46_META_WS_CREATEFRAMESELFRELATIVE: "প্রতি ফ্রেম আপেক্ষিক তৈরি করুন",
  T_46_META_WS_CREATEFROMPREFAB: "Prefab থেকে তৈরি করুন",
  T_46_META_WS_CREATELEVELOBJECT: "লেভেল অবজেক্ট তৈরি করুন",
  T_46_META_WS_CREATELOOKAT: "দেখুন তৈরি করুন",
  T_46_META_WS_CREATEMINIMAPICON: "মিনিম্যাপ আইকন তৈরি করুন",
  T_46_META_WS_CREATEMINIMAPPIXEL: "মিনিম্যাপ পিক্সেল তৈরি করুন",
  T_46_META_WS_CREATEMONSTER: "দানব তৈরি করুন",
  T_46_META_WS_CREATEMORPH: "রূপান্তর তৈরি করুন",
  T_46_META_WS_CREATESELFRELATIVE: "নিজস্ব আপেক্ষিক তৈরি করুন",
  T_46_META_WS_CREATESHOP: "দোকান তৈরি করুন",
  T_46_META_WS_CREATESHOPITEM: "আইটেম তৈরি করুন",
  T_46_META_WS_CREATESHOPSHELF: "দোকান তাক তৈরি করুন",
  T_46_META_WS_CREATESOUND: "শব্দ তৈরি করুন",
  T_46_META_WS_CREATESOUNDCLIENT: "শব্দ তৈরি করুন",
  T_46_META_WS_CREATETOKENINSCENE: "দৃশ্যপটে টোকেন তৈরি করুন",
  T_46_META_WS_CREATETRAJECTORY: "ট্রাজেক্টরি তৈরি করুন",
  T_46_META_WS_CREATETWEEN: "Tween তৈরি করুন",
  T_46_META_WS_CREATEWALLET: "ওয়ালেট তৈরি করুন",
  T_46_META_WS_CROSS: "ক্রস",
  T_46_META_WS_CSVCOLUMNNAMETOINT: "CSV কলাম নামকে পূর্ণসংখ্যায় রূপান্তর করুন",
  T_46_META_WS_CURRENTAMMOCOUNT: "বর্তমান গুলির সংখ্যা",
  T_46_META_WS_DAMAGE: "ক্ষতি",
  T_46_META_WS_DAMAGEDBODYPART: "ক্ষতিগ্রস্ত শরীরের অংশ",
  T_46_META_WS_DAMAGEDPLAYERS: "আঘাতপ্রাপ্ত খেলোয়াড়",
  T_46_META_WS_DAMAGETYPE: "ক্ষতির ধরন",
  T_46_META_WS_DEALDAMAGE: "ক্ষতি দিন",
  T_46_META_WS_DELETE: "মুছুন",
  T_46_META_WS_DELETEAT: "নির্দিষ্ট স্থানে মুছুন",
  T_46_META_WS_DELETECUSTOMUI: "কাস্টম UI মুছুন",
  T_46_META_WS_DELETEFROMDATABASE: "ডাটাবেস থেকে মুছে ফেলুন",
  T_46_META_WS_DELETEFROMDATASTORE: "ডেটাবেস টেবিল মান মুছে ফেলুন",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYKEY: "কী দ্বারা লিডবোর্ড ডাটাবেস থেকে মুছে ফেলুন",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYRANK: "র‌্যাঙ্ক দ্বারা লিডবোর্ড ডাটাবেস থেকে মুছে ফেলুন",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYKEY: "কী দ্বারা লিডবোর্ড ডেটাবেস থেকে মুছে ফেলুন",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYRANK: "র‌্যাঙ্ক দ্বারা লিডবোর্ড ডেটাবেস থেকে মুছে ফেলুন",
  T_46_META_WS_DELETETAG: "ট্যাগ মুছুন",
  T_46_META_WS_DELTA: "ডেল্টা",
  T_46_META_WS_DESTROY: "ধ্বংস করুন",
  T_46_META_WS_DESTROYBOT: "বট ধ্বংস করুন",
  T_46_META_WS_DESTROYBUILTINUI: "বিল্ট-ইন UI ধ্বংস করুন",
  T_46_META_WS_DESTROYEQUIPMENT: "সরঞ্জাম ধ্বংস করুন",
  T_46_META_WS_DESTROYITEM: "আইটেম ধ্বংস করুন",
  T_46_META_WS_DIRECTIONTOEULERANGLE: "দিক থেকে ইউলার কোণ",
  T_46_META_WS_DISABLESAFEZONE: "নিরাপত্তা অঞ্চল অক্ষম করুন",
  T_46_META_WS_DISPATCHEVENT: "ইভেন্ট প্রেরণ করুন",
  T_46_META_WS_DISPATCHEVENTWITHPLATFORM: "প্ল্যাটফর্মের সাথে ইভেন্ট প্রেরণ করুন",
  T_46_META_WS_DISTANCE: "দূরত্ব",
  T_46_META_WS_DOT: "বিন্দু",
  T_46_META_WS_DROPITEM: "আইটেম ফেলুন",
  T_46_META_WS_DYEATAREA: "এলাকার রঙ করুন",
  T_46_META_WS_DYEATPLANE: "প্লেনে রঙ করুন",
  T_46_META_WS_DYEATPOSITION: "অবস্থানে রঙ করুন",
  T_46_META_WS_E_ABNORMALGRAVZONE: "কম গরিমা এলাকা",
  T_46_META_WS_E_AC80: "AC80",
  T_46_META_WS_E_ACCELERATION: "ত্বরান্বিত",
  T_46_META_WS_E_ACTIONNODE: "কার্যকলাপ নোড",
  T_46_META_WS_E_ACTIVE: "সক্রিয়",
  T_46_META_WS_E_ACTIVESKILL: "সক্রিয় দক্ষতা",
  T_46_META_WS_E_ADBOARD: "বিলবোর্ড",
  T_46_META_WS_E_ADD: "যোগ করুন",
  T_46_META_WS_E_ADDFRIEND: "বন্ধু যোগ করুন",
  T_46_META_WS_E_AGENCYFB: "এজেন্সি এফবি",
  T_46_META_WS_E_AIM: "লক্ষ্য করা",
  T_46_META_WS_E_AIR: "বাতাস",
  T_46_META_WS_E_AIRCONDITIONERA: "এয়ার কন্ডিশনার",
  T_46_META_WS_E_AIRDROP: "এয়ারড্রপ, জোম্বি আত্মহত্যা",
  T_46_META_WS_E_AK: "AK",
  T_46_META_WS_E_AK2: "AK2",
  T_46_META_WS_E_ALIVE: "জীবিত",
  T_46_META_WS_E_AMMO: "বুলেট VFX",
  T_46_META_WS_E_AMPHIBIANCAR: "অ্যাম্ফিবিয়ান গাড়ি",
  T_46_META_WS_E_AN94: "AN94",
  T_46_META_WS_E_APPARITION: "শিশুরা খেলছে",
  T_46_META_WS_E_AR: "রাইফেল",
  T_46_META_WS_E_AR15: "AR15",
  T_46_META_WS_E_ARAMMO: "AR গুলি",
  T_46_META_WS_E_ARMAGAZINE: "এআর ম্যাগাজিন",
  T_46_META_WS_E_ARMOR: "বর্ম",
  T_46_META_WS_E_ARMORBUFF: "আর্মার বাফ",
  T_46_META_WS_E_ARMORLV1: "আর্মার Lv1",
  T_46_META_WS_E_ARMORLV2: "আর্মার Lv2",
  T_46_META_WS_E_ARMORLV3: "আর্মার Lv3",
  T_46_META_WS_E_ARMORPIERCING: "আর্মর ভাঙ্গা",
  T_46_META_WS_E_ARMORSPECIALIST: "দক্ষতা ১",
  T_46_META_WS_E_ARROW: "তীর",
  T_46_META_WS_E_ASC: "ঊর্ধ্বক্রম",
  T_46_META_WS_E_ASCIGNOREZERO: "ঊর্ধ্বক্রমে শূন্য বাদ দিন",
  T_46_META_WS_E_ATMOSPHEREEXPLOSION: "গ্যাস বিস্ফোরণ",
  T_46_META_WS_E_ATTACHMENT1FORCOMPATIBILITY: "সামঞ্জস্যতার জন্য সংযোজন1",
  T_46_META_WS_E_ATTACHMENT4FORCOMPATIBILITY: "সামঞ্জস্যতার জন্য সংযোজন4",
  T_46_META_WS_E_ATTACHMENT5FORCOMPATIBILITY: "সামঞ্জস্যতার জন্য সংযোজন5",
  T_46_META_WS_E_ATTACHMENT6FORCOMPATIBILITY: "সামঞ্জস্যতার জন্য সংযোজন6",
  T_46_META_WS_E_ATTACHMENT8FORCOMPATIBILITY: "সামঞ্জস্যতার জন্য সংযোজন8",
  T_46_META_WS_E_ATTACK: "আক্রমণ",
  T_46_META_WS_E_ATTACKGRENADE: "আক্রমণ গ্রেনেড",
  T_46_META_WS_E_AUG: "AUG",
  T_46_META_WS_E_AUTO: "স্বয়ংক্রিয়",
  T_46_META_WS_E_AWM: "AWM",
  T_46_META_WS_E_AWM2: "AWM2",
  T_46_META_WS_E_BACK: "ফিরে আসা",
  T_46_META_WS_E_BACKANDFORTH: "পিছনে ফিরে আসা",
  T_46_META_WS_E_BAG: "ব্যাগ",
  T_46_META_WS_E_BAG1: "ব্যাগ1",
  T_46_META_WS_E_BAG2: "ব্যাগ2",
  T_46_META_WS_E_BAG3: "ব্যাগ3",
  T_46_META_WS_E_BAMBOOA: "বাঁশ A",
  T_46_META_WS_E_BANANATREE: "কলার গাছ",
  T_46_META_WS_E_BASEBALLPOLE: "BaseballPole",
  T_46_META_WS_E_BASECOEFFICIENT: "বেস সহগ",
  T_46_META_WS_E_BASIC: "মৌলিক",
  T_46_META_WS_E_BASICCONE: "মৌলিক শঙ্কু",
  T_46_META_WS_E_BASICCYLINDER: "মৌলিক সিলিন্ডার",
  T_46_META_WS_E_BASICSPHERE: "মৌলিক বল",
  T_46_META_WS_E_BATTLEINSTYLE: "স্টাইলে যুদ্ধ",
  T_46_META_WS_E_BELL: "ঘণ্টা",
  T_46_META_WS_E_BENCH: "বেঞ্চ",
  T_46_META_WS_E_BIGHEADHAMMER: "BigHeadHammer",
  T_46_META_WS_E_BILLBOARD: "বড় স্ক্রীন",
  T_46_META_WS_E_BIPOD: "বাইপড",
  T_46_META_WS_E_BISGRAFFITIWALL: "BIS থিমওয়াল",
  T_46_META_WS_E_BIZON: "Bizon",
  T_46_META_WS_E_BLACKHOLE: "ব্ল্যাকহোল বিস্ফোরণ VFX",
  T_46_META_WS_E_BLACKHOLEBOOM: "ক্রিস্টাল বল VFX",
  T_46_META_WS_E_BLAST: "বিস্ফোরণ",
  T_46_META_WS_E_BLOCK: "বর্গক্ষেত্র",
  T_46_META_WS_E_BLOODBALL: "ব্ল্যাকহোল VFX",
  T_46_META_WS_E_BLT: "BLT",
  T_46_META_WS_E_BLT2: "BLT2",
  T_46_META_WS_E_BLUE: "নীল",
  T_46_META_WS_E_BLUEDOLL: "বরফের পুতুল",
  T_46_META_WS_E_BOARD: "চলমান প্ল্যাটফর্ম",
  T_46_META_WS_E_BODY: "দেহ",
  T_46_META_WS_E_BOMBINDICATION: "বোমার সতর্কতা",
  T_46_META_WS_E_BOMBPLIERS: "বোমা প্লায়ার্স",
  T_46_META_WS_E_BONFIRE: "জ্বলন্ত আগুন",
  T_46_META_WS_E_BOOM: "বিস্ফোরণ",
  T_46_META_WS_E_BOOYAH: "বিজয়",
  T_46_META_WS_E_BOTH: "উভয়",
  T_46_META_WS_E_BOUNCETIRE: "টায়ার",
  T_46_META_WS_E_BOWAMMO: "ধনুকের গুলি",
  T_46_META_WS_E_BREAKABLEBOX: "ধ্বংসযোগ্য কাঠের বাক্স",
  T_46_META_WS_E_BREAKABLECONTAINER: "ধ্বংসযোগ্য কনটেইনার",
  T_46_META_WS_E_BREAKABLEFENCE: "ধ্বংসযোগ্য বেড়া",
  T_46_META_WS_E_BRICKA: "ইট A",
  T_46_META_WS_E_BRICKB: "ইট B",
  T_46_META_WS_E_BRICKC: "ইট C",
  T_46_META_WS_E_BRICKHOUSEA: "ছোট বাড়ি A",
  T_46_META_WS_E_BRIGHT: "হালকা",
  T_46_META_WS_E_BUBBLE: "বুদবুদ",
  T_46_META_WS_E_BUFFGENERATOR: "বাফ জেনারেটর",
  T_46_META_WS_E_BULLETBUFF: "বুলেট বাফ",
  T_46_META_WS_E_BULLETHITTING: "বুলেটের আঘাত",
  T_46_META_WS_E_BUMPERCAR: "বাম্পার কার",
  T_46_META_WS_E_BUMPERCARFACTORY: "বাম্পার গাড়ি প্রস্তুতকারক",
  T_46_META_WS_E_BURNING: "যানবাহন বিস্ফোরণের পর পোড়ানোর ক্ষতি",
  T_46_META_WS_E_BUSHES: "গুল্ম",
  T_46_META_WS_E_BUSSTOP: "বাস স্টেশন",
  T_46_META_WS_E_BUTTOM: "নিচের পোশাক",
  T_46_META_WS_E_BUTTONWIDGET: "বোতাম উইজেট",
  T_46_META_WS_E_BYHIERARCHY: "স্তরের দ্বারা",
  T_46_META_WS_E_CABINET: "ক্যাবিনেট",
  T_46_META_WS_E_CACTUS: "ক্যাকটাস",
  T_46_META_WS_E_CAMOUFLAGE: "দক্ষতা ৬",
  T_46_META_WS_E_CAPSULETRIGGER: "ক্যাপসুল ট্রিগার",
  T_46_META_WS_E_CARDIOTONIC: "কার্ডিওটনিক",
  T_46_META_WS_E_CASUALGAMEBGM: "অবসর গেম বিএজিএম",
  T_46_META_WS_E_CEMENTA: "সিমেন্ট A",
  T_46_META_WS_E_CG15: "CG15",
  T_46_META_WS_E_CHANNELA: "চ্যানেল A",
  T_46_META_WS_E_CHANNELB: "চ্যানেল B",
  T_46_META_WS_E_CHANNELC: "চ্যানেল C",
  T_46_META_WS_E_CHANNELD: "চ্যানেল D",
  T_46_META_WS_E_CHANNELE: "চ্যানেল E",
  T_46_META_WS_E_CHANNELF: "চ্যানেল F",
  T_46_META_WS_E_CHARACTERSKILL: "চরিত্রের দক্ষতা",
  T_46_META_WS_E_CHARACTOR: "চরিত্র",
  T_46_META_WS_E_CHARGE: "চার্জ ১",
  T_46_META_WS_E_CHARGEBUSTER: "ChargeBuster",
  T_46_META_WS_E_CHECKPOINT: "চেকপয়েন্ট",
  T_46_META_WS_E_CHEER: "উল্লাস",
  T_46_META_WS_E_CHERRYBLOSSOM: "চেরি ব্লসোম গাছ",
  T_46_META_WS_E_CIRCLE: "বৃত্ত",
  T_46_META_WS_E_CIRCLEBACK: "লুপ",
  T_46_META_WS_E_CIRCLEOFHEAT: "পায়ের রশ্মি",
  T_46_META_WS_E_CITY: "শহর",
  T_46_META_WS_E_CLAPS: "হাততালি",
  T_46_META_WS_E_CLEAR: "পরিষ্কার",
  T_46_META_WS_E_CLIENT: "ক্লায়েন্ট",
  T_46_META_WS_E_CLONE: "চেহারা পরিবর্তক",
  T_46_META_WS_E_CLONEKILL: "কপির মৃত্য",
  T_46_META_WS_E_CLOSE: "বন্ধ করুন",
  T_46_META_WS_E_CLOTHES: "কাপড়",
  T_46_META_WS_E_COINGENERATOR: "সোনার জেনারেটর",
  T_46_META_WS_E_COLDAIR: "কুয়াশা",
  T_46_META_WS_E_COLORBLOCK: "রঙিন ব্লক",
  T_46_META_WS_E_COLOROILBARREL: "রঙিন তেল ড্রাম",
  T_46_META_WS_E_COMBINEALL: "সবকিছু সংযুক্ত করুন",
  T_46_META_WS_E_COMBINESELF: "নিজেকে সংযুক্ত করুন",
  T_46_META_WS_E_COMBOKEYA1: "সঙ্গীতের নোট - সিনথেসাইজার A",
  T_46_META_WS_E_COMBOKEYA2: "সঙ্গীতের নোট - সিনথেসাইজার A",
  T_46_META_WS_E_COMBOKEYB1: "সঙ্গীতের নোট - সিনথেসাইজার B",
  T_46_META_WS_E_COMBOKEYB2: "সঙ্গীতের নোট - সিনথেসাইজার B",
  T_46_META_WS_E_COMBOKEYC1: "সঙ্গীতের নোট - সিনথেসাইজার C",
  T_46_META_WS_E_COMBOKEYC2: "সঙ্গীতের নোট - সিনথেসাইজার C",
  T_46_META_WS_E_CONCRETEPILLAR: "কংক্রিটের স্তম্ভ",
  T_46_META_WS_E_CONDITIONNODE: "শর্ত নোড",
  T_46_META_WS_E_CONTAINERA: "কন্টেইনার A",
  T_46_META_WS_E_CONTAINERB: "শিপিং কনটেইনার বি",
  T_46_META_WS_E_CONTAINERC: "শিপিং কনটেইনার সি",
  T_46_META_WS_E_CONTAINERWIDGET: "কন্টেইনার উইজেট",
  T_46_META_WS_E_CONTINUOUS: "ধারাবাহিক",
  T_46_META_WS_E_COUNTDOWN: "কাউন্টডাউন",
  T_46_META_WS_E_COUNTDOWNDENGDENG: "কাউন্টডাউন",
  T_46_META_WS_E_COUNTDOWNDIDI: "কাউন্টডাউন বি",
  T_46_META_WS_E_COUNTDOWNMECHANICAL: "কাউন্টডাউন",
  T_46_META_WS_E_COUNTDOWNWITHINGAME: "কাউন্টডাউন ৩",
  T_46_META_WS_E_CROSS: "ক্রস",
  T_46_META_WS_E_CROSSBOW: "ক্রসবো",
  T_46_META_WS_E_CROSSHAIR: "ক্রসহেয়ার",
  T_46_META_WS_E_CROSSHAIRS: "ক্রসহেয়ার",
  T_46_META_WS_E_CROUCH: "ঝুঁকে বসা",
  T_46_META_WS_E_CROUCHING: "বসা",
  T_46_META_WS_E_CROWCAW: "Crow কাকের শব্দ",
  T_46_META_WS_E_CROWN: "মুকুট",
  T_46_META_WS_E_CUBE: "ব্লক মেকানিজম",
  T_46_META_WS_E_CURSE: "তাবিজ",
  T_46_META_WS_E_CURSEEXPLOSION: "তাবিজ বিস্ফোরণ",
  T_46_META_WS_E_CUSTOM: "কাস্টম ক্যামেরা",
  T_46_META_WS_E_CUSTOMTRIGGER: "কাস্টম ট্রিগার",
  T_46_META_WS_E_CUSTOMWATERZONE: "কাস্টম জল দেহ",
  T_46_META_WS_E_CYCLICCOMBUSTION: "লুপে জ্বলন",
  T_46_META_WS_E_CYLIC: "চক্রাকার",
  T_46_META_WS_E_DAGGER: "থ্রোয়িং নাইফ",
  T_46_META_WS_E_DAMAGEDTRUCK: "ক্ষতিগ্রস্ত ট্রাক",
  T_46_META_WS_E_DAMAGEZONE: "ক্ষতির অঞ্চল",
  T_46_META_WS_E_DANGERALARM: "বিপদের সতর্কতা ২",
  T_46_META_WS_E_DANGERVIBRATING: "বিপদের সতর্কতা ১",
  T_46_META_WS_E_DARK: "অন্ধকার",
  T_46_META_WS_E_DARKNESS: "অন্ধকার",
  T_46_META_WS_E_DASHATTACK: "ড্যাশ অ্যাটাক",
  T_46_META_WS_E_DATASTORAGELIMITEXCEEDED: "ডেটা স্টোরেজ সীমা অতিক্রম",
  T_46_META_WS_E_DATASTORAGEPARAMETERERROR: "ডেটা স্টোরেজ প্যারামিটার ত্রুটি",
  T_46_META_WS_E_DATASTORAGETIMEOUT: "ডেটা স্টোরেজ টাইমআউট",
  T_46_META_WS_E_DATETIME: "তারিখ এবং সময়",
  T_46_META_WS_E_DAY: "দিন",
  T_46_META_WS_E_DEAD: "মৃত",
  T_46_META_WS_E_DEATH: "মৃত",
  T_46_META_WS_E_DEFAULT: "ডিফল্ট",
  T_46_META_WS_E_DEFAULTFIST: "মুষ্টি",
  T_46_META_WS_E_DEFENCEGRENADE: "প্রতিরক্ষা গ্রেনেড",
  T_46_META_WS_E_DESC: "অবনমিত ক্রম",
  T_46_META_WS_E_DIALOGUE: "সংলাপ",
  T_46_META_WS_E_DIAMOND: "হীরক",
  T_46_META_WS_E_DIRECTIONSIGN: "চিহ্ন",
  T_46_META_WS_E_DIRVEVEHICLE: "যানবাহন চালান",
  T_46_META_WS_E_DISABLE: "নিষ্ক্রিয় করুন",
  T_46_META_WS_E_DISABLED: "অক্ষম",
  T_46_META_WS_E_DISAPPEARNOTIFICATION: "অদৃশ্য হওয়ার বার্তা",
  T_46_META_WS_E_DISCONNECT: "সংযোগ বিচ্ছিন্ন",
  T_46_META_WS_E_DISGUISE: "কপির",
  T_46_META_WS_E_DOGHOUSE: "কুকুরের ঘর",
  T_46_META_WS_E_DOOR: "দরজা",
  T_46_META_WS_E_DOUBLE: "ডাবল",
  T_46_META_WS_E_DOUBLEDOOR: "ডাবল দরজা",
  T_46_META_WS_E_DOUBLEJUMPSHOE: "ডাবল জাম্প শু",
  T_46_META_WS_E_DOUBLEMAGEZINE: "ডাবল ম্যাগাজিন",
  T_46_META_WS_E_DRAW: "ড্র",
  T_46_META_WS_E_DRILLZOMBIE: "ড্রিল জম্বি",
  T_46_META_WS_E_DRIVE: "ড্রাইভ",
  T_46_META_WS_E_DRIVER: "চালক",
  T_46_META_WS_E_DROPBEAT: "দক্ষতা ৪",
  T_46_META_WS_E_DRUMKEY1: "সঙ্গীতের নোট - ড্রাম",
  T_46_META_WS_E_DRUMKEY2: "সঙ্গীতের নোট - ড্রাম",
  T_46_META_WS_E_DUEL: "যুদ্ধ",
  T_46_META_WS_E_DUMMY: "ডামি",
  T_46_META_WS_E_DUMMYGRENADE: "ডামি গ্রেনেড",
  T_46_META_WS_E_DUMP: "ডাম্প",
  T_46_META_WS_E_DUSK: "গোধূলি",
  T_46_META_WS_E_DUST: "ধোঁয়া এবং ধূলা",
  T_46_META_WS_E_DYNAMIC: "গতিশীল",
  T_46_META_WS_E_E: "প্রাকৃতিক ধ্রুবক",
  T_46_META_WS_E_EAGLE: "EAGLE",
  T_46_META_WS_E_EASY: "সহজ",
  T_46_META_WS_E_ELECTRICSHOCK: "বিদ্যুৎ শক",
  T_46_META_WS_E_ELECTRICSURFBOARD: "বৈদ্যুতিক সার্ফবোর্ড",
  T_46_META_WS_E_ELECTRICZONE: "বৈদ্যুতিক অঞ্চল",
  T_46_META_WS_E_ELECTRONICBGM: "কিউট ইলেকট্রনিক ফ্যান্টাসি বিএজিএম",
  T_46_META_WS_E_ELIMINATEDBOSS: "গিল্ড নেতা অপসারণ",
  T_46_META_WS_E_ELIMINATIONNOTIFICATION: "হত্যা সতর্কতা",
  T_46_META_WS_E_EMOTE: "অভিব্যক্তি",
  T_46_META_WS_E_ENABLE: "সক্রিয় করুন",
  T_46_META_WS_E_ENERGETIC: "শক্তিশালী",
  T_46_META_WS_E_ENTERVEHICLE: "যানবাহনে প্রবেশ করুন",
  T_46_META_WS_E_EP: "EP (এনার্জি পয়েন্ট)",
  T_46_META_WS_E_EXCLAMATIONMARK: "বিস্ময়বোধক চিহ্ন",
  T_46_META_WS_E_EXIT: "প্রস্থান",
  T_46_META_WS_E_EXITVEHICLE: "যানবাহন থেকে বেরিয়ে আসুন",
  T_46_META_WS_E_EXPLODE: "আত্ম-বিস্ফোরণ",
  T_46_META_WS_E_EXPLOSION: "বিস্ফোরণ VFX",
  T_46_META_WS_E_EXPLOSIVEBLAZE: "বিস্ফোরণ অগ্নি",
  T_46_META_WS_E_EXPLOSIVEPAINTSKILL: "এনার্জি অরব দক্ষতা",
  T_46_META_WS_E_EXPLOSIVEZOMBIE: "বিস্ফোরক জম্বি",
  T_46_META_WS_E_EYE: "চশমা",
  T_46_META_WS_E_FACEPAINT: "মুখের রঙ",
  T_46_META_WS_E_FACTION: "গোষ্ঠী",
  T_46_META_WS_E_FALLING: "পড়ে যাওয়া",
  T_46_META_WS_E_FALLINGSTAR: "ভোক্তা পাওয়া",
  T_46_META_WS_E_FALSE: "না",
  T_46_META_WS_E_FAMAS: "FAMAS",
  T_46_META_WS_E_FAN: "প্রপেলার মেকানিজম",
  T_46_META_WS_E_FAR: "দূরে",
  T_46_META_WS_E_FEATHER: "পালক",
  T_46_META_WS_E_FEMALE: "নারী",
  T_46_META_WS_E_FENCE: "বেড়া",
  T_46_META_WS_E_FGL24: "FGL24",
  T_46_META_WS_E_FIGHTINGENTITY: "লড়াইয়েরসত্তা",
  T_46_META_WS_E_FILLED: "পূর্ণ",
  T_46_META_WS_E_FINISH: "সম্পন্ন",
  T_46_META_WS_E_FINISHINGPOINT: "শেষ বিন্দু",
  T_46_META_WS_E_FINISHLINEARCH: "ফিনিশ ব্যানার",
  T_46_META_WS_E_FIRE: "আগুন",
  T_46_META_WS_E_FIRECHARGE: "আগুনের বল",
  T_46_META_WS_E_FIREWORK: "আতশবাজি",
  T_46_META_WS_E_FIRINGEFFECT: "গুলি VFX",
  T_46_META_WS_E_FIRSTPERSON: "প্রথম ব্যক্তির ক্যামেরা",
  T_46_META_WS_E_FIRSTPERSONCLASSIC: "প্রথম ব্যক্তির ক্যামেরা (FF ক্লাসিক)",
  T_46_META_WS_E_FIST: "মুষ্টি",
  T_46_META_WS_E_FIT: "ফিট",
  T_46_META_WS_E_FLAG: "পতাকা",
  T_46_META_WS_E_FLAME: "আগুন",
  T_46_META_WS_E_FLAMEGUN: "ফ্লেম গান",
  T_46_META_WS_E_FLAMETHROWER: "ফ্লেমথ্রোয়ার",
  T_46_META_WS_E_FLASH: "ফ্ল্যাশব্যাংক",
  T_46_META_WS_E_FLASHBANG: "Flashbang",
  T_46_META_WS_E_FLASHBANGSPARKS: "ফ্ল্যাশব্যাংক ধোঁয়া",
  T_46_META_WS_E_FLASHFREEZE: "ফ্ল্যাশ ফ্রিজ",
  T_46_META_WS_E_FLEXWALL: "সরানো দেওয়াল",
  T_46_META_WS_E_FLICKER: "ঝলকানি",
  T_46_META_WS_E_FLOWER: "ফুল",
  T_46_META_WS_E_FLYBOMBBEE: "উড়ন্ত বোমা মৌমাছি",
  T_46_META_WS_E_FLYPAN: "ফ্রাইং প্যান মেকানিজম",
  T_46_META_WS_E_FLYSHOE: "ফ্লাই শু",
  T_46_META_WS_E_FOLDER: "ফোল্ডার",
  T_46_META_WS_E_FOLDWINGS: "ভাঁজ করা ডানা",
  T_46_META_WS_E_FOODTRUCK: "খাদ্য ট্রাক",
  T_46_META_WS_E_FOODTRUCKB: "খাবার ট্রাক B",
  T_46_META_WS_E_FOOTBALL: "ফুটবল",
  T_46_META_WS_E_FOOTBALLGUN: "ফুটবল গান",
  T_46_META_WS_E_FOOTBALLICE: "FootballIce",
  T_46_META_WS_E_FOOTBALLSHIELD: "FootballShield",
  T_46_META_WS_E_FOOTBALLSHOOTER: "ফুটবল শুটার",
  T_46_META_WS_E_FORCE: "শক্তি",
  T_46_META_WS_E_FOREGRIP_MR: "ফোরগ্রিপ এমআর",
  T_46_META_WS_E_FOREGRIP1: "ফোরগ্রিপ1",
  T_46_META_WS_E_FOREGRIP2: "ফোরগ্রিপ2",
  T_46_META_WS_E_FOREGRIP3: "ফোরগ্রিপ3",
  T_46_META_WS_E_FORWARD: "এগিয়ে যান",
  T_46_META_WS_E_FOUNTAIN: "ফোয়ারা",
  T_46_META_WS_E_FREE: "ফ্রি ক্যামেরা",
  T_46_META_WS_E_FREEZEALL: "সবকিছু বন্ধ",
  T_46_META_WS_E_FREEZEPOSITION: "সমস্ত অবস্থান বন্ধ",
  T_46_META_WS_E_FREEZEPOSITIONX: "X অবস্থান বন্ধ",
  T_46_META_WS_E_FREEZEPOSITIONY: "Y অবস্থান বন্ধ",
  T_46_META_WS_E_FREEZEPOSITIONZ: "Z অবস্থান বন্ধ",
  T_46_META_WS_E_FREEZEROTATION: "সমস্ত ঘূর্ণন বন্ধ",
  T_46_META_WS_E_FREEZEROTATIONX: "X ঘূর্ণন বন্ধ",
  T_46_META_WS_E_FREEZEROTATIONY: "Y ঘূর্ণন বন্ধ",
  T_46_META_WS_E_FREEZEROTATIONZ: "Z ঘূর্ণন বন্ধ",
  T_46_META_WS_E_FREEZEZONE: "জমে যাওয়া এলাকা",
  "T_46_META_WS_E_FROST GALAXY": "তুষার গ্যালাক্সি",
  T_46_META_WS_E_FROZEN: "জমে যাওয়া",
  T_46_META_WS_E_FROZENGRENADE: "জমে যাওয়া গ্রেনেড",
  T_46_META_WS_E_FUNCTIONALITEMS: "কার্যকরী আইটেম",
  T_46_META_WS_E_FZLANTINGHEI: "এফজেডলানটিংহেই",
  T_46_META_WS_E_G18: "G18",
  T_46_META_WS_E_G36: "G36",
  T_46_META_WS_E_GAME: "খেলা",
  T_46_META_WS_E_GAMEOVER: "গেম ওভার ২",
  T_46_META_WS_E_GAMESTART: "খেলা শুরু",
  T_46_META_WS_E_GARAGE: "গ্যারেজ",
  T_46_META_WS_E_GATLING: "Gatling",
  T_46_META_WS_E_GEARSWITCHEDON: "যন্ত্র সক্রিয়",
  T_46_META_WS_E_GENTLETAP: "হালকা ট্যাপ",
  T_46_META_WS_E_GETITEM: "ভোক্তা ২ প্রাপ্তি",
  T_46_META_WS_E_GFFLATIN: "জিএফএফ ল্যাটিন",
  T_46_META_WS_E_GHOST: "ভূত",
  T_46_META_WS_E_GIANTDICE: "ডাইস",
  T_46_META_WS_E_GIANTLOLLIPOP: "বিশাল ললিপপ",
  T_46_META_WS_E_GIFT: "উপহার",
  T_46_META_WS_E_GLOOWALL: "গ্লু ওয়াল",
  T_46_META_WS_E_GOLD_HEATGUN_I: "GOLD_HEATGUN_I",
  T_46_META_WS_E_GOLD_HEATGUN_II: "GOLD_HEATGUN_II",
  T_46_META_WS_E_GOLD_HEATGUN_III: "GOLD_HEATGUN_III",
  T_46_META_WS_E_GOLD_M1014_I: "GOLD_M1014_I",
  T_46_META_WS_E_GOLD_M1014_II: "GOLD_M1014_II",
  T_46_META_WS_E_GOLD_M1014_III: "GOLD_M1014_III",
  T_46_META_WS_E_GOLD_SCAR_I: "GOLD_SCAR_I",
  T_46_META_WS_E_GOLD_SCAR_II: "GOLD_SCAR_II",
  T_46_META_WS_E_GOLD_SCAR_III: "GOLD_SCAR_III",
  T_46_META_WS_E_GOLDAWM: "GoldAWM",
  T_46_META_WS_E_GOLDFAMAS_I: "GoldFamas_I",
  T_46_META_WS_E_GOLDFAMAS_II: "GoldFamas_II",
  T_46_META_WS_E_GOLDFAMAS_III: "GoldFamas_III",
  T_46_META_WS_E_GOLDGROZA: "GoldGroza",
  T_46_META_WS_E_GOLDKAR98K_I: "GoldKar98K_I",
  T_46_META_WS_E_GOLDKAR98K_II: "GoldKar98K_II",
  T_46_META_WS_E_GOLDKAR98K_III: "GoldKar98K_III",
  T_46_META_WS_E_GOLDKAR98K_III_FORINFECTION: "GoldKar98K_III_ForInfection",
  T_46_META_WS_E_GOLDM14_I: "GoldM14_I",
  T_46_META_WS_E_GOLDM14_II: "GoldM14_II",
  T_46_META_WS_E_GOLDM14_III: "GoldM14_III",
  T_46_META_WS_E_GOLDM14_III_FORINFECTION: "GoldM14_III_ForInfection",
  T_46_META_WS_E_GOLDM4A1_I: "GoldM4A1_I",
  T_46_META_WS_E_GOLDM4A1_II: "GoldM4A1_II",
  T_46_META_WS_E_GOLDM4A1_III: "GoldM4A1_III",
  T_46_META_WS_E_GOLDM4A1_III_FORINFECTION: "GoldM4A1_III_ForInfection",
  T_46_META_WS_E_GOLDM60_I: "GoldM60_I",
  T_46_META_WS_E_GOLDM60_II: "GoldM60_II",
  T_46_META_WS_E_GOLDM60_III: "GoldM60_III",
  T_46_META_WS_E_GOLDM60_III_FORINFECTION: "GoldM60_III_ForInfection",
  T_46_META_WS_E_GOLDMP5_I: "GoldMP5_I",
  T_46_META_WS_E_GOLDMP5_II: "GoldMP5_II",
  T_46_META_WS_E_GOLDMP5_III: "GoldMP5_III",
  T_46_META_WS_E_GOLDMP5_III_FORINFECTION: "GoldMP5_III_ForInfection",
  T_46_META_WS_E_GOLDSVD: "GoldSVD",
  T_46_META_WS_E_GOLDVSS_I: "GoldVSS_I",
  T_46_META_WS_E_GOLDVSS_II: "GoldVSS_II",
  T_46_META_WS_E_GOLDVSS_III: "GoldVSS_III",
  T_46_META_WS_E_GRAFFITIFLOWERBED: "BIS থিম ফুলের বিছানা",
  T_46_META_WS_E_GRAFFITIWALL: "গ্রাফিতি ওয়াল",
  T_46_META_WS_E_GRAPPLINGHOOKGUN: "হুক গান",
  T_46_META_WS_E_GREATCONDUCTOR: "মহান পরিচালক",
  T_46_META_WS_E_GREEN: "সবুজ",
  T_46_META_WS_E_GRENADE: "গ্রেনেড",
  T_46_META_WS_E_GRID: "গ্রিড",
  T_46_META_WS_E_GROZA: "GROZA",
  T_46_META_WS_E_GROZA2: "GROZA2",
  T_46_META_WS_E_GUARDTOWER: "ওয়াচটাওয়ার",
  T_46_META_WS_E_GUILD: "গিল্ড",
  T_46_META_WS_E_GUN: "বন্দুক",
  T_46_META_WS_E_GUNFIRE: "গুলি",
  T_46_META_WS_E_HALO: "হ্যালো",
  T_46_META_WS_E_HAMMER: "বিশাল হাতুড়ি মেকানিজম",
  T_46_META_WS_E_HANDCANNON: "HandCannon",
  T_46_META_WS_E_HANGER: "শুকানোর র্যাক",
  T_46_META_WS_E_HARD: "কঠিন",
  T_46_META_WS_E_HATTRICK: "দক্ষতা ৮",
  T_46_META_WS_E_HAYSTACK: "ঘাসের গাদ",
  T_46_META_WS_E_HEAD: "মাথার আচ্ছাদন",
  T_46_META_WS_E_HEADSHOOT: "হেডশট",
  T_46_META_WS_E_HEALINGGUN_SNIPER: "Healinggun_Sniper",
  T_46_META_WS_E_HEALINGPISTOL_X: "HealingPistol_X",
  T_46_META_WS_E_HEALPISTOL: "হিলিং গান",
  T_46_META_WS_E_HEART: "হৃদয়",
  T_46_META_WS_E_HEARTBEAT: "হৃদস্পন্দন",
  T_46_META_WS_E_HEATGUN: "HeatGun",
  T_46_META_WS_E_HEAVYWEAPON: "ভারী অস্ত্র",
  T_46_META_WS_E_HELL: "খুব কঠিন",
  T_46_META_WS_E_HELMET: "হেলমেট",
  T_46_META_WS_E_HELMET1: "হেলমেট1",
  T_46_META_WS_E_HELMET2: "হেলমেট2",
  T_46_META_WS_E_HELMET3: "হেলমেট3",
  T_46_META_WS_E_HEXAGON: "ষড়ভুজ",
  T_46_META_WS_E_HGAMMO: "HG গুলি",
  T_46_META_WS_E_HIDEANDSEEKFLAMETHROWER: "লুকোচুরি ফ্লেমথ্রোয়ার",
  T_46_META_WS_E_HIDERKILL: "লুকানো ব্যক্তি মারা গেছে",
  T_46_META_WS_E_HIHATS: "হাইহ্যাট",
  T_46_META_WS_E_HINDSILIGURI: "হিন্দ সিলিগুড়ি ",
  T_46_META_WS_E_HITBLUNT: "ম্লান আঘাত",
  T_46_META_WS_E_HITEFFECT: "বুলেট আঘাত VFX",
  T_46_META_WS_E_HITFEEDBACK: "গুলি প্রতিক্রিয়া",
  T_46_META_WS_E_HOOK: "হুক",
  T_46_META_WS_E_HOOKGUN: "HookGun",
  T_46_META_WS_E_HOOKGUNAMMO: "হুক গান গোলাবারুদ",
  T_46_META_WS_E_HORIZALINE: "হরিজেন্টাল",
  T_46_META_WS_E_HORIZONTAL: "অনুভূমিক",
  T_46_META_WS_E_HORN: "স্পিকার",
  T_46_META_WS_E_HORROR: "ভয়াবহতা",
  T_46_META_WS_E_HOURGLASS: "বালু ঘড়ি",
  T_46_META_WS_E_HOUSE: "বাড়ি",
  T_46_META_WS_E_HOUSEA: "একতলা বাড়ি",
  T_46_META_WS_E_HOUSEB: "দুইতলা বাড়ি",
  T_46_META_WS_E_HOUSEC: "তিন তলা বাড়ি",
  T_46_META_WS_E_HP: "HP (স্বাস্থ্য)",
  T_46_META_WS_E_HPBUFF: "HP বাফ",
  T_46_META_WS_E_HUT: "কেবিন",
  T_46_META_WS_E_ICEA: "বরফ A",
  T_46_META_WS_E_ICEGUN: "IceGun",
  T_46_META_WS_E_ICEWALLMAKER: "বরফের দেয়াল নির্মাতা",
  T_46_META_WS_E_ICONOBJECT: "আইকন",
  T_46_META_WS_E_IMAGEWIDGET: "ছবি উইজেট",
  T_46_META_WS_E_IMPULSE: "প্রেরণ",
  T_46_META_WS_E_INHALER: "ইনহেলার",
  T_46_META_WS_E_INJUREDFEMALE: "আঘাতে মহিলা চিৎকার",
  T_46_META_WS_E_INJUREDMALE: "আঘাতে পুরুষ চিৎকার",
  T_46_META_WS_E_INK: "স্যুভেনির VFX",
  T_46_META_WS_E_INPUTLABLEWIDGET: "ইনপুট লেবেল উইজেট",
  T_46_META_WS_E_INSECTCHIRPING: "পোকামাকড়ের শব্দ",
  T_46_META_WS_E_INTERVAL10SECONDS: "10 সেকেন্ড",
  T_46_META_WS_E_INTERVAL15SECONDS: "15 সেকেন্ড",
  T_46_META_WS_E_INTERVAL30SECONDS: "30 সেকেন্ড",
  T_46_META_WS_E_INTERVAL3SECONDS: "3 সেকেন্ড",
  T_46_META_WS_E_INTERVAL5SECONDS: "5 সেকেন্ড",
  T_46_META_WS_E_INTERVAL9999SECONDS: "9999 সেকেন্ড",
  T_46_META_WS_E_INVISIBLE: "অদৃশ্য",
  T_46_META_WS_E_IPIPE: "পাইপ I",
  T_46_META_WS_E_IRONFENCE: "বেড়া",
  T_46_META_WS_E_IRONFENCEB: "বেড়া B",
  T_46_META_WS_E_IRONPLATFORM: "লোহার প্ল্যাটফর্ম",
  T_46_META_WS_E_ITEMENTITY: "ব্যবহৃত পদার্থ জেনারেটর",
  T_46_META_WS_E_JEEP: "জিপ",
  T_46_META_WS_E_JERRYCAN: "তেল ড্রাম",
  T_46_META_WS_E_JERSEYMACHINE: "জার্সি মেশিন",
  T_46_META_WS_E_JOINEDGAMEDULL: "যুদ্ধের মধ্যে যোগদান",
  T_46_META_WS_E_JOINGAME: "খেলায় যোগদান",
  T_46_META_WS_E_JOYSTICKWIDGET: "জয়স্টিক উইজেট",
  T_46_META_WS_E_JUMP: "লাফ",
  T_46_META_WS_E_JUMPATTACK: "লাফানোর আক্রমণ",
  T_46_META_WS_E_JUSTPATROL: "শুধুমাত্র টহল",
  T_46_META_WS_E_KAR98K: "Kar98K",
  T_46_META_WS_E_KATANA: "Katana",
  T_46_META_WS_E_KEY: "চাবি",
  T_46_META_WS_E_KICK: "বেস ড্রাম",
  T_46_META_WS_E_KILLINGTIPS: "হত্যার টিপস",
  T_46_META_WS_E_KILLZONE: "মৃত্যু অঞ্চল",
  T_46_META_WS_E_KINEMATIC: "গতিশীলতা",
  T_46_META_WS_E_KNIFE: "Knife",
  T_46_META_WS_E_KNOCKDOWN: "নিচে পড়ে গেছে",
  T_46_META_WS_E_KNOCKEDDOWN: "পড়ে যাওয়া",
  T_46_META_WS_E_KORD: "Kord",
  T_46_META_WS_E_LABELWIDGET: "লেবেল উইজেট",
  T_46_META_WS_E_LANDINGA: "সিঁড়ির স্তর A",
  T_46_META_WS_E_LANDINGB: "সিঁড়ির স্তর B",
  T_46_META_WS_E_LANDINGC: "সিঁড়ির স্তর C",
  T_46_META_WS_E_LANDMINE: "ল্যান্ডমাইন",
  T_46_META_WS_E_LANUNCHERAMMO: "লঞ্চার গোলাবারুদ",
  T_46_META_WS_E_LASER: "লেজার VFX",
  T_46_META_WS_E_LASERSKILL: "লেজার দক্ষতা",
  T_46_META_WS_E_LATTICESCREEN: "পর্দা",
  T_46_META_WS_E_LAWNA: "লন A",
  T_46_META_WS_E_LAWNB: "লন B",
  T_46_META_WS_E_LAYOUTWIDGET: "লেআউট উইজেট",
  T_46_META_WS_E_LEAD1A2: "Lead1A2",
  T_46_META_WS_E_LEAD1A2SHARP: "Lead1A2#",
  T_46_META_WS_E_LEAD1B2: "Lead1B2",
  T_46_META_WS_E_LEAD1C2: "Lead1C2",
  T_46_META_WS_E_LEAD1C2SHARP: "Lead1C2#",
  T_46_META_WS_E_LEAD1D2: "Lead1D2",
  T_46_META_WS_E_LEAD1D2SHARP: "Lead1D2#",
  T_46_META_WS_E_LEAD1E2: "Lead1E2",
  T_46_META_WS_E_LEAD1F2: "Lead1F2",
  T_46_META_WS_E_LEAD1F2SHARP: "Lead1F2#",
  T_46_META_WS_E_LEAD1G2: "Lead1G2",
  T_46_META_WS_E_LEAD1G2SHARP: "Lead1G2#",
  T_46_META_WS_E_LEAD2A2: "Lead2A2",
  T_46_META_WS_E_LEAD2A2SHARP: "Lead2A2#",
  T_46_META_WS_E_LEAD2B2: "Lead2B2",
  T_46_META_WS_E_LEAD2C2: "Lead2C2",
  T_46_META_WS_E_LEAD2C2SHARP: "Lead2C2#",
  T_46_META_WS_E_LEAD2D2: "Lead2D2",
  T_46_META_WS_E_LEAD2D2SHARP: "Lead2D2#",
  T_46_META_WS_E_LEAD2E2: "Lead2E2",
  T_46_META_WS_E_LEAD2F2: "Lead2F2",
  T_46_META_WS_E_LEAD2F2SHARP: "Lead2F2#",
  T_46_META_WS_E_LEAD2G2: "Lead2G2",
  T_46_META_WS_E_LEAD2G2SHARP: "Lead2G2#",
  T_46_META_WS_E_LEAD3A2: "Lead3A2",
  T_46_META_WS_E_LEAD3A2SHARP: "Lead3A2#",
  T_46_META_WS_E_LEAD3B2: "Lead3B2",
  T_46_META_WS_E_LEAD3C2: "Lead3C2",
  T_46_META_WS_E_LEAD3C2SHARP: "Lead3C2#",
  T_46_META_WS_E_LEAD3D2: "Lead3D2",
  T_46_META_WS_E_LEAD3D2SHARP: "Lead3D2#",
  T_46_META_WS_E_LEAD3E2: "Lead3E2",
  T_46_META_WS_E_LEAD3F2: "Lead3F2",
  T_46_META_WS_E_LEAD3F2SHARP: "Lead3F2#",
  T_46_META_WS_E_LEAD3G2: "Lead3G2",
  T_46_META_WS_E_LEAD3G2SHARP: "Lead3G2#",
  T_46_META_WS_E_LEAFLESSTREE: "মৃত গাছ",
  T_46_META_WS_E_LEVELMAXED: "সর্বাধিক স্তর",
  T_46_META_WS_E_LEVELUP: "র‍্যাঙ্ক আপ",
  T_46_META_WS_E_LEVELUPDISCARDED: "র‌্যাঙ্ক আপ",
  T_46_META_WS_E_LIGHTBEAM: "আলো রশ্মি",
  T_46_META_WS_E_LIGHTBEAMPREDISCARDED: "আলো রশ্মি",
  T_46_META_WS_E_LIGHTEFFECT: "আলো প্রভাব",
  T_46_META_WS_E_LIGHTNING: "বজ্রপাত",
  T_46_META_WS_E_LIMB: "অঙ্গ",
  T_46_META_WS_E_LINE: "লাইন",
  T_46_META_WS_E_LIQUID: "তরল",
  T_46_META_WS_E_LOCAL: "স্থানীয়",
  T_46_META_WS_E_LOCALPOSITION: "স্থানীয় স্থানাঙ্ক",
  T_46_META_WS_E_LOCK: "তালা",
  T_46_META_WS_E_LONGBOX: "লম্বা কাঠের বাক্স",
  T_46_META_WS_E_LOOP: "লুপ",
  T_46_META_WS_E_LOOTITEMBOX: "লুট অস্ত্র",
  T_46_META_WS_E_LOOTITEMBOXAMMO: "লুটের গুলি",
  T_46_META_WS_E_LOOTITEMBOXARMOR: "লুটের আর্মার",
  T_46_META_WS_E_LOOTITEMBOXCONSUMABLEITEM: "লুটযোগ্য উপকরণ",
  T_46_META_WS_E_LOOTITEMBOXPROJECTILE: "লুটযোগ্য নিক্ষেপযোগ্য সামগ্রী",
  T_46_META_WS_E_LOOTITEMBOXSIGHT: "লুট স্কোপ",
  T_46_META_WS_E_LOOTITEMBOXSOCCER: "Loot Soccer",
  T_46_META_WS_E_LOOTSOCCERICE: "বরফের গ্রেনেড",
  T_46_META_WS_E_LOOTSOCCERRANDOM: "এলোমেলো ফুটবল লুট",
  T_46_META_WS_E_LOOTSOCCERSHIELD: "ফুটবল শিল্ড লুট",
  T_46_META_WS_E_LOOTWEAPONRANDOM: "র্যান্ডম অস্ত্র লুট",
  T_46_META_WS_E_LOSE: "পরাজয়",
  T_46_META_WS_E_LOUDSPEAKER: "স্পিকার",
  T_46_META_WS_E_LOWFALLING: "কম পড়া",
  T_46_META_WS_E_M1014: "M1014",
  T_46_META_WS_E_M10142: "M10142",
  T_46_META_WS_E_M14: "M14",
  T_46_META_WS_E_M1873: "M1873",
  T_46_META_WS_E_M1887: "M1887",
  T_46_META_WS_E_M18872: "M18872",
  T_46_META_WS_E_M1887X: "M1887X",
  T_46_META_WS_E_M1917: "M1917",
  T_46_META_WS_E_M21A5: "M21A5",
  T_46_META_WS_E_M24: "M24",
  T_46_META_WS_E_M249: "M249",
  T_46_META_WS_E_M2492: "M2492",
  T_46_META_WS_E_M4A1: "M4A1",
  T_46_META_WS_E_M500: "M500",
  T_46_META_WS_E_M60: "M60",
  T_46_META_WS_E_M79: "M79",
  T_46_META_WS_E_M79AMMO: "এম৭৯ গ্রেনেড",
  T_46_META_WS_E_M79AMMO_EXCLUSIVE: "এম৭৯ বিশেষায়িত গ্রেনেড",
  T_46_META_WS_E_MAC10: "MAC10",
  T_46_META_WS_E_MACHETE: "Machete",
  T_46_META_WS_E_MACHINEGUN: "SMG",
  T_46_META_WS_E_MAG7: "MAG7",
  T_46_META_WS_E_MAG72: "MAG72",
  T_46_META_WS_E_MAGEZINE1: "ম্যাগাজিন1",
  T_46_META_WS_E_MAGEZINE2: "ম্যাগাজিন2",
  T_46_META_WS_E_MAGEZINE3: "ম্যাগাজিন3",
  T_46_META_WS_E_MAGMAA: "ম্যাগমা A",
  T_46_META_WS_E_MAGNIFYINGGLASS: "মাইক্রোস্কোপ",
  T_46_META_WS_E_MALE: "পুরুষ",
  T_46_META_WS_E_MARK: "চিহ্ন",
  T_46_META_WS_E_MARKER: "চিহ্ন",
  T_46_META_WS_E_MASK: "মুখের সাজ",
  T_46_META_WS_E_MAXVALUE: "সর্বাধিক মূল্য",
  T_46_META_WS_E_MECHANICAL: "দ্রুত ক্লিঙ্কিং ২",
  T_46_META_WS_E_MECHANICALDEVICEECHO: "যান্ত্রিক ডিভাইস প্রতিধ্বনি",
  T_46_META_WS_E_MEDICALPROPS: "চিকিৎসা সামগ্রী",
  T_46_META_WS_E_MEDICALTENT: "মেডিক্যাল টেন্ট",
  T_46_META_WS_E_MEDIUMHEARTBEAT: "মধ্যম হৃদস্পন্দন",
  T_46_META_WS_E_MEDKIT: "মেড কিট",
  T_46_META_WS_E_MELEE: "মেলি অস্ত্র",
  T_46_META_WS_E_MELEEWEAPONS: "মেলি অস্ত্র",
  T_46_META_WS_E_MGL140: "MGL140",
  T_46_META_WS_E_MICROPHONE: "মাইক্রোফোন",
  T_46_META_WS_E_MIDDLE: "মধ্যবর্তী",
  T_46_META_WS_E_MINIHANDLE: "মিনি হ্যান্ডেল",
  T_46_META_WS_E_MINIMAP: "মিনি ম্যাপ",
  T_46_META_WS_E_MINISENTRY: "মিনি সেন্ট্রি",
  T_46_META_WS_E_MINVALUE: "ন্যূনতম মূল্য",
  T_46_META_WS_E_MISSILEEXPLODE: "ক্ষেপণাস্ত্র ধরনের অস্ত্র",
  T_46_META_WS_E_MISSIONCOMPLETE: "মিশন সফলতা ১",
  T_46_META_WS_E_MISTAKE: "ভুল",
  T_46_META_WS_E_MODERATE: "মাঝারি",
  T_46_META_WS_E_MONEY: "টাকা",
  T_46_META_WS_E_MONSTER: "দৈত্য",
  T_46_META_WS_E_MONSTERSPAWN: "দানবের স্পন পয়েন্ট",
  T_46_META_WS_E_MONSTERTRUCK: "মন্সটার ট্রাক",
  T_46_META_WS_E_MOON: "চাঁদ",
  T_46_META_WS_E_MOSQUITO: "মশা",
  T_46_META_WS_E_MOTIONTRAIL: "পিছন সংঘর্ষ",
  T_46_META_WS_E_MOTOBIKE: "মোটরবাইক",
  T_46_META_WS_E_MOTORBIKE: "মোটরবাইক",
  T_46_META_WS_E_MOVE: "সরানো",
  T_46_META_WS_E_MOVEMENT: "মুভ",
  T_46_META_WS_E_MOVINGJOYSTICK: "চলমান জয়স্টিক",
  T_46_META_WS_E_MP40: "MP40",
  T_46_META_WS_E_MP402: "MP402",
  T_46_META_WS_E_MP5: "MP5",
  T_46_META_WS_E_MRV: "মিস্টার ভি",
  T_46_META_WS_E_MULTIPLIER: "গুণক",
  T_46_META_WS_E_MULTIPLY: "গুননা",
  T_46_META_WS_E_MULTIPLYACCUMULATE: "গুণ এবং সঞ্চয়",
  T_46_META_WS_E_MUSHROOM1: "মাশরুম1",
  T_46_META_WS_E_MUSHROOM2: "মাশরুম2",
  T_46_META_WS_E_MUSHROOM3: "মাশরুম3",
  T_46_META_WS_E_MUSHROOM4: "মাশরুম4",
  T_46_META_WS_E_MUSHSHADE: "বিশাল মাশরুম ক্লাস্টার",
  T_46_META_WS_E_MUSIC: "সঙ্গীত",
  T_46_META_WS_E_MUZZLE1: "মুজল1",
  T_46_META_WS_E_MUZZLE2: "মুজল2",
  T_46_META_WS_E_MUZZLE3: "মুজল3",
  T_46_META_WS_E_NEAR: "কাছাকাছি",
  T_46_META_WS_E_NIGHT: "রাত",
  T_46_META_WS_E_NOATTACK: "আক্রমণ নয়",
  T_46_META_WS_E_NODUALWIELDING: "দ্বৈত অস্ত্রবিহীন",
  T_46_META_WS_E_NOERROR: "কোন ত্রুটি নেই",
  T_46_META_WS_E_NONE: "কোন না",
  T_46_META_WS_E_NORMAL: "স্বাভাবিক",
  T_46_META_WS_E_NOSKIPKNOCKDOWN: "পড়ে যাওয়া মঞ্জুর নয়",
  T_46_META_WS_E_NOTONASTALIQURDU: "নোটো নাস্তালিক উর্দু",
  T_46_META_WS_E_NUTTYMOVEMENT: "দক্ষতা ৭",
  T_46_META_WS_E_OBTAINEDCOINS: "মাঝারি সোনার প্রাপ্তি",
  T_46_META_WS_E_OBTAINEDMANYCOINS: "বড় সোনার প্রাপ্তি",
  T_46_META_WS_E_OBTAINEDSOMECOINS: "ছোট সোনার প্রাপ্তি",
  T_46_META_WS_E_OILDRUMEXPLODE: "তেলের ড্রাম বিস্ফোরণ",
  T_46_META_WS_E_ONCE: "একবার",
  T_46_META_WS_E_ONEWAY: "একমুখী",
  T_46_META_WS_E_OPENFOLDER: "খোলা ফোল্ডার",
  T_46_META_WS_E_OPENHIHATS: "ওপেন হাইহ্যাট",
  T_46_META_WS_E_OPENINGBOX: "বাক্স খোলা",
  T_46_META_WS_E_OPENINGGUILDSUPPLY: "গিল্ড সরবরাহ",
  T_46_META_WS_E_OPENINGWARCHEST: "গুদাম সংরক্ষণ",
  T_46_META_WS_E_ORANGE: "কমলা",
  T_46_META_WS_E_ORTHOGONAL: "অরথোগোনাল",
  T_46_META_WS_E_OUTPOST: "গার্ডহাউস",
  T_46_META_WS_E_P90: "P90",
  T_46_META_WS_E_P902: "P902",
  T_46_META_WS_E_PAINTEDWALLS: "আঁকা দেওয়াল",
  T_46_META_WS_E_PAINTSHIELDSKILL: "ব্লাড পুল দক্ষতা",
  T_46_META_WS_E_PALM: "কাগজ",
  T_46_META_WS_E_PANEL: "প্যানেল",
  T_46_META_WS_E_PARAFAL: "PARAFAL",
  T_46_META_WS_E_PARAFAL2: "PARAFAL2",
  T_46_META_WS_E_PASSENGERA: "যাত্রী A",
  T_46_META_WS_E_PASSENGERB: "যাত্রী B",
  T_46_META_WS_E_PASSENGERC: "যাত্রী C",
  T_46_META_WS_E_PASSIVE: "নিষ্ক্রিয়",
  T_46_META_WS_E_PASSIVESKILL: "নিষ্ক্রিয় দক্ষতা",
  T_46_META_WS_E_PATROLWHILEATTACK: "টহল ও আক্রমণ",
  T_46_META_WS_E_PERSONALUAV: "ব্যক্তিগত UAV",
  T_46_META_WS_E_PERSPECTIVE: "দৃষ্টিকোণ",
  T_46_META_WS_E_PETTABBG: "পোষা প্রাণী",
  T_46_META_WS_E_PHASESTART: "পর্যায় শুরু",
  T_46_META_WS_E_PHONEBOOTH: "টেলিফোন বুথ",
  T_46_META_WS_E_PI: "Π",
  T_46_META_WS_E_PIANOA3: "PianoA3",
  T_46_META_WS_E_PIANOA3SHARP: "PianoA3#",
  T_46_META_WS_E_PIANOA4: "PianoA4",
  T_46_META_WS_E_PIANOA4SHARP: "PianoA4#",
  T_46_META_WS_E_PIANOB3: "PianoB3",
  T_46_META_WS_E_PIANOB4: "PianoB4",
  T_46_META_WS_E_PIANOC3: "PianoC3",
  T_46_META_WS_E_PIANOC3SHARP: "PianoC3#",
  T_46_META_WS_E_PIANOC4: "PianoC4",
  T_46_META_WS_E_PIANOC4SHARP: "PianoC4#",
  T_46_META_WS_E_PIANOD3: "PianoD3",
  T_46_META_WS_E_PIANOD3SHARP: "PianoD3#",
  T_46_META_WS_E_PIANOD4: "PianoD4",
  T_46_META_WS_E_PIANOD4SHARP: "PianoD4#",
  T_46_META_WS_E_PIANOE3: "PianoE3",
  T_46_META_WS_E_PIANOE4: "PianoE4",
  T_46_META_WS_E_PIANOF3: "PianoF3",
  T_46_META_WS_E_PIANOF3SHARP: "PianoF3#",
  T_46_META_WS_E_PIANOF4: "PianoF4",
  T_46_META_WS_E_PIANOF4SHARP: "PianoF4#",
  T_46_META_WS_E_PIANOG3: "PianoG3",
  T_46_META_WS_E_PIANOG3SHARP: "PianoG3#",
  T_46_META_WS_E_PIANOG4: "PianoG4",
  T_46_META_WS_E_PIANOG4SHARP: "PianoG4#",
  T_46_META_WS_E_PIANOKEY1: "সঙ্গীতের নোট - পিয়ানো",
  T_46_META_WS_E_PIANOKEY2: "সঙ্গীতের নোট - পিয়ানো",
  T_46_META_WS_E_PICKUPS: "জিনিসপত্র",
  T_46_META_WS_E_PICKUPTRUCK: "এসইউভি",
  T_46_META_WS_E_PILLAR: "কংক্রিট স্তম্ভ",
  T_46_META_WS_E_PIN: "মন্তব্য",
  T_46_META_WS_E_PINGPONG: "পিংপং",
  T_46_META_WS_E_PIPECORNER: "কোণ পাইপ",
  T_46_META_WS_E_PIPEINTERSECTION: "ক্রস পাইপ",
  T_46_META_WS_E_PISTOL: "পিস্তল",
  T_46_META_WS_E_PISTOLAMMO: "পিস্তল গোলাবারুদ",
  T_46_META_WS_E_PLAIDAMUSEMENTPARKCUBE: "চেকারড পার্ক ব্লক",
  T_46_META_WS_E_PLASMA_X: "PLASMA_X",
  T_46_META_WS_E_PLAYER: "খেলোয়াড়",
  T_46_META_WS_E_PLUS: "যোগ",
  T_46_META_WS_E_PODIUM: "মঞ্চ",
  T_46_META_WS_E_POISONGAS: "বিষাক্ত গ্যাস",
  T_46_META_WS_E_POISONGASPREDISCARDED: "বিষাক্ত গ্যাস",
  T_46_META_WS_E_PORTAL: "পোর্টাল",
  T_46_META_WS_E_POSTACCUMULATOR: "পোস্ট-অ্যাকুমুলেটর",
  T_46_META_WS_E_POT: "Pot",
  T_46_META_WS_E_POUNDINGHEART: "দ্রুত হৃদস্পন্দন",
  T_46_META_WS_E_PREACCUMULATOR: "পূর্ব-অ্যাকুমুলেটর",
  T_46_META_WS_E_PRIMARYWEAPONA: "প্রাথমিক অস্ত্র A",
  T_46_META_WS_E_PRIMARYWEAPONB: "প্রাথমিক অস্ত্র B",
  T_46_META_WS_E_PRIOREXPLOSION: "বোমার বিস্ফোরণের আগে",
  T_46_META_WS_E_PROFILEWIDGET: "প্রোফাইল উইজেট",
  T_46_META_WS_E_PRONE: "শুয়ে থাকা",
  T_46_META_WS_E_PUMPKIN: "কুমড়া",
  T_46_META_WS_E_PURPLE: "বেগুনি",
  T_46_META_WS_E_QUADRILATERAL: "চতুর্ভুজ",
  T_46_META_WS_E_QUESTIONMARK: "প্রশ্নবোধক চিহ্ন",
  T_46_META_WS_E_QUICKCHAT: "দ্রুত চ্যাট",
  T_46_META_WS_E_QUICKCHATSHOW: "দ্রুত চ্যাট প্রদর্শন",
  T_46_META_WS_E_RADIAL180: "রেডিয়াল 180°",
  T_46_META_WS_E_RADIAL360: "রেডিয়াল 360°",
  T_46_META_WS_E_RADIAL90: "রেডিয়াল 90°",
  T_46_META_WS_E_RAMPAGE: "রঙ্গিন",
  T_46_META_WS_E_RANDOM: "র্যান্ডম",
  T_46_META_WS_E_RANDOMBUFF: "র্যান্ডম বাফ",
  T_46_META_WS_E_RANKDOWN: "র‌্যাঙ্ক ডাউন",
  T_46_META_WS_E_REACTION: "প্রতিক্রিয়া",
  T_46_META_WS_E_RECOVER: "পুনরুদ্ধার",
  T_46_META_WS_E_RECYCLE: "পুনর্ব্যবহার",
  T_46_META_WS_E_RED: "লাল",
  T_46_META_WS_E_REFINERYTANK: "জলজগ",
  T_46_META_WS_E_REFLECTIVECUBE: "প্রতিফলিত কঠিন রঙের মৌলিক ব্লক 1",
  T_46_META_WS_E_REFRESH: "রিফ্রেশ",
  T_46_META_WS_E_RELEASINGSKILL: "দক্ষতার মুক্তি VFX",
  T_46_META_WS_E_RELOAD: "রিলোড",
  T_46_META_WS_E_REMINDER: "স্মারক",
  T_46_META_WS_E_REPAIR: "মেরামত",
  T_46_META_WS_E_REPAIREQUIP: "সরঞ্জাম মেরামত",
  T_46_META_WS_E_REPAIRKIT: "মেরামত কিট",
  T_46_META_WS_E_REPLACER: "রিপ্লেসার",
  T_46_META_WS_E_REPORT: "রিপোর্ট",
  T_46_META_WS_E_REST: "বিশ্রাম",
  T_46_META_WS_E_RG550: "RG550",
  T_46_META_WS_E_RIDES: "রাইড",
  T_46_META_WS_E_RIDICULE: "উপহাস",
  T_46_META_WS_E_RIDICULEFUNNY: "মজার উপহাস",
  T_46_META_WS_E_RIFLE: "রাইফেল",
  T_46_META_WS_E_RIFLEAMMO: "রাইফেলের গোলাবারুদ",
  T_46_META_WS_E_RIGHT: "সঠিক",
  T_46_META_WS_E_RIGHTTRAPEZOID: "সোজা কোণ ট্রাপিজিয়াম",
  T_46_META_WS_E_RING: "রিং মেকানিজম",
  T_46_META_WS_E_RINGPREDISCARDED: "রিং",
  T_46_META_WS_E_RIPTIDERHYTHM: "দক্ষতা ৯",
  T_46_META_WS_E_RISINGPARTICLE: "উর্ধ্বমুখী কণাগুলি",
  T_46_META_WS_E_ROADBLOCK: "ব্যারিকেড",
  T_46_META_WS_E_ROTATE: "ঘূর্ণন",
  T_46_META_WS_E_RUNNING: "চলমান",
  T_46_META_WS_E_RUSHTIME: "র‌্যাম্পেজ",
  T_46_META_WS_E_SAMURAI: "সামুরাই",
  T_46_META_WS_E_SANDA: "বালি A",
  T_46_META_WS_E_SANDSTRUCTURE: "বালির ভাস্কর্য",
  T_46_META_WS_E_SCALE: "স্কেল",
  T_46_META_WS_E_SCAR: "SCAR",
  T_46_META_WS_E_SCAR2: "SCAR2",
  T_46_META_WS_E_SCARECROW: "পুতুল",
  T_46_META_WS_E_SCISSORS: "কাঁচি",
  T_46_META_WS_E_SCOPE2X: "2x স্কোপ",
  T_46_META_WS_E_SCOPE4X: "4x স্কোপ",
  T_46_META_WS_E_SCROLLPANEL: "স্ক্রল প্যানেল",
  T_46_META_WS_E_SECONDARYWEAPON: "গৌণ অস্ত্র",
  T_46_META_WS_E_SENSESSHOCKWAVE: "দক্ষতা ১০",
  T_46_META_WS_E_SERVER: "সার্ভার",
  T_46_META_WS_E_SET: "পুরো শরীরের পোশাক",
  T_46_META_WS_E_SETTING: "সেটিংস",
  T_46_META_WS_E_SETTINGS: "সেটিংস",
  T_46_META_WS_E_SG: "শটগান",
  T_46_META_WS_E_SGAMMO: "SN গুলি",
  T_46_META_WS_E_SHARPMECHANICAL: "দ্রুত ক্লিঙ্কিং ১",
  T_46_META_WS_E_SHIELD: "রক্ষা",
  T_46_META_WS_E_SHIELDBROKEN: "ঢাল ভাঙা",
  T_46_META_WS_E_SHIELDGUN: "ShieldGun",
  T_46_META_WS_E_SHIELDUP: "ঢাল উপরে",
  T_46_META_WS_E_SHOCKWAVE: "শক ওয়েভ",
  T_46_META_WS_E_SHOES: "জুতো",
  T_46_META_WS_E_SHOOTINGTARGET: "চলমান লক্ষ্য",
  T_46_META_WS_E_SHORTDATE: "সংক্ষিপ্ত তারিখ",
  T_46_META_WS_E_SHORTDATETIME: "সংক্ষিপ্ত তারিখ এবং সময়",
  T_46_META_WS_E_SHORTTIME: "সংক্ষিপ্ত সময়",
  T_46_META_WS_E_SHOTGUN: "শর্টগান",
  T_46_META_WS_E_SHOTGUNAMMO: "শটগানের গুলি",
  T_46_META_WS_E_SHOTGUNMUZZLE: "শটগান মুজল",
  T_46_META_WS_E_SHOW: "প্রদর্শন করুন",
  T_46_META_WS_E_SHRUB: "গুল্ম-আবৃত লম্বা কাঠের বাক্স",
  T_46_META_WS_E_SICKLE: "Sickle",
  T_46_META_WS_E_SIDESCROLLING: "পার্শ্বীয় ক্যামেরা",
  T_46_META_WS_E_SIGNAL: "সিগন্যাল",
  T_46_META_WS_E_SIGNOUT: "প্রস্থান",
  T_46_META_WS_E_SILENCER: "সাইলেন্সার",
  T_46_META_WS_E_SIMPLE: "সহজ",
  T_46_META_WS_E_SIMPLEWIDGET: "সহজ উইজেট",
  T_46_META_WS_E_SIMPLIFIEDARABIC: "সরল আরবী",
  T_46_META_WS_E_SINGLE: "একক",
  T_46_META_WS_E_SITEHUT: "কনটেইনার বাড়ি",
  T_46_META_WS_E_SKILLCHARGINGCOMPLETE: "দক্ষতা চার্জ সম্পন্ন",
  T_46_META_WS_E_SKILLRECOVER: "দক্ষতা পুনরুদ্ধার",
  T_46_META_WS_E_SKIPKNOCKDOWN: "পড়ে যাওয়া বাদ দিন",
  T_46_META_WS_E_SKS: "SKS",
  T_46_META_WS_E_SLICED: "স্লাইসড",
  T_46_META_WS_E_SLOPE: "ঢাল",
  T_46_META_WS_E_SLOWHEARTBEAT: "ধীর হৃদস্পন্দন",
  T_46_META_WS_E_SMG: "এসএমজি",
  T_46_META_WS_E_SMGAMMO: "SMG গুলি",
  T_46_META_WS_E_SMGMUZZLE: "এসএমজি মুজল",
  T_46_META_WS_E_SMILEY: "হাস্যোজ্জ্বল মুখ",
  T_46_META_WS_E_SMOKE: "ধোঁয়া",
  T_46_META_WS_E_SMOKEGRENADE: "ধোঁয়া গ্রেনেড",
  T_46_META_WS_E_SMOKEY: "ধোঁয়া",
  T_46_META_WS_E_SMOOTH: "মসৃণ",
  T_46_META_WS_E_SNAMMO: "SN গুলি",
  T_46_META_WS_E_SNARES: "স্নেয়ার ড্রাম",
  T_46_META_WS_E_SNEAKERS: "রানিং জুতো VFX",
  T_46_META_WS_E_SNIPER: "স্নাইপার রাইফেল",
  T_46_META_WS_E_SNIPERAMMO: "স্নাইপার রাইফেলের গুলি",
  T_46_META_WS_E_SNOWA: "তুষার A",
  T_46_META_WS_E_SNOWFLAKE: "তুষারফ্লেক",
  T_46_META_WS_E_SOCCER: "ফুটবল",
  T_46_META_WS_E_SOCIALBUTTONWIDGET: "সোশ্যাল বাটন উইজেট",
  T_46_META_WS_E_SOLARPANEL: "সোলার প্যানেল",
  T_46_META_WS_E_SORTBYPRIORITYHIGHTOLOW: "উচ্চ থেকে নিম্ন অগ্রাধিকার",
  T_46_META_WS_E_SORTBYPRIORITYLOWTOHIGH: "নিম্ন থেকে উচ্চ অগ্রাধিকার",
  T_46_META_WS_E_SPAS12: "SPAS12",
  T_46_META_WS_E_SPAS122: "SPAS122",
  T_46_META_WS_E_SPAWNPOINT: "স্পন পয়েন্ট VFX",
  T_46_META_WS_E_SPEAKER: "স্পিকার",
  T_46_META_WS_E_SPECIALFIRINGSOUND: "বিশেষ বন্দুকের শব্দ",
  T_46_META_WS_E_SPECIALGUN: "বিশেষ অস্ত্র",
  T_46_META_WS_E_SPHERE: "গোলক",
  T_46_META_WS_E_SPHERETRIGGER: "গোলাকার সংঘর্ষ ট্রিগার",
  T_46_META_WS_E_SPIDERWEB: "দক্ষতা VFX",
  T_46_META_WS_E_SPORTSCAR: "স্পোর্টস কার",
  T_46_META_WS_E_SPOTLIGHT: "আলো",
  T_46_META_WS_E_SPREADOFPOISONGAS: "বিষাক্ত গ্যাস বিস্তার",
  T_46_META_WS_E_SPRINT: "দৌড়ানো",
  T_46_META_WS_E_SQUARE: "বর্গক্ষেত্র",
  T_46_META_WS_E_SQUAREBOX: "স্কোয়ার কাঠের বাক্স",
  T_46_META_WS_E_SR: "স্নাইপার রাইফেল",
  T_46_META_WS_E_STABLE: "গাছের ঘর",
  T_46_META_WS_E_STAIRS: "সিঁড়ি",
  T_46_META_WS_E_STANDING: "দাঁড়ানো",
  T_46_META_WS_E_STAR: "তারা",
  T_46_META_WS_E_STATIC: "স্থির",
  T_46_META_WS_E_STATUSTRIGGER: "মৃত্যু বা অক্ষুন্নতা ট্রিগার",
  T_46_META_WS_E_STEP: "পা রাখার শব্দ",
  T_46_META_WS_E_STEPTRIGGER: "মেকানিজম সক্রিয় করুন",
  T_46_META_WS_E_STOCK_S: "স্টক এস",
  T_46_META_WS_E_STOCK_SR: "স্টক এসআর",
  T_46_META_WS_E_STOCK1: "স্টক1",
  T_46_META_WS_E_STOCK2: "স্টক2",
  T_46_META_WS_E_STOCK3: "স্টক3",
  T_46_META_WS_E_STONE: "পাথর",
  T_46_META_WS_E_STONEBRIDGE: "পাথরের আর্ক ব্রিজ",
  T_46_META_WS_E_STONELANTERN: "রাজকীয় লণ্ঠন",
  T_46_META_WS_E_STONESPLASH: "উড়ন্ত কঙ্কাল",
  T_46_META_WS_E_STORE: "দোকান",
  T_46_META_WS_E_STREETLAMP: "রাস্তায় আলো",
  T_46_META_WS_E_STYLEA: "স্টাইল A",
  T_46_META_WS_E_STYLEB: "স্টাইল B",
  T_46_META_WS_E_STYLEC: "স্টাইল C",
  T_46_META_WS_E_SUBMACHINEGUN: "এসএমজি",
  T_46_META_WS_E_SUBMACHINEGUNAMMO: "এসএমজি গুলি",
  T_46_META_WS_E_SUCCESSFULHIT: "আঘাত",
  T_46_META_WS_E_SUN: "সূর্য",
  T_46_META_WS_E_SUNSHADE: "প্যাটিও সেট সঙ্গে ছাতা",
  T_46_META_WS_E_SUPERCAR: "স্পোর্টস কার",
  T_46_META_WS_E_SUPERMARKET: "সুপারমার্কেট",
  T_46_META_WS_E_SURPRISEFIND: "সারপ্রাইজ খুঁজে পাওয়া",
  T_46_META_WS_E_SUV: "SUV",
  T_46_META_WS_E_SVD: "SVD",
  T_46_META_WS_E_SVD2: "SVD2",
  T_46_META_WS_E_SWEAPWEAPONQUICK: "দ্রুত অস্ত্র পরিবর্তন",
  T_46_META_WS_E_SWIMRING: "সাঁতার কাটার রিং",
  T_46_META_WS_E_SWORD: "তরবারি",
  T_46_META_WS_E_SYMBOLIC: "মাটির চিহ্ন",
  T_46_META_WS_E_TANKZOMBIE: "ট্যাঙ্ক জম্বি",
  T_46_META_WS_E_TAP: "ট্যাপ",
  T_46_META_WS_E_TAPPINGBUTTON: "ট্যাপ বোতাম",
  T_46_META_WS_E_TAPPINGDISABLEDBUTTON: "ট্যাপ নিষ্ক্রিয় বোতাম",
  T_46_META_WS_E_TEAM: "দল",
  T_46_META_WS_E_TEAMMATESINFO: "টিমমেটদের তথ্য",
  T_46_META_WS_E_TELEPORT: "টেলিপোর্ট",
  T_46_META_WS_E_TELEPORTCORRECT: "সঠিক গন্তব্য সংকেত",
  T_46_META_WS_E_TELEPORTWRONG: "ভুল গন্তব্য সংকেত",
  T_46_META_WS_E_TEXT: "পাঠ্য",
  T_46_META_WS_E_TEXTOBJECT: "টেক্সট",
  T_46_META_WS_E_TEXTUREWIDGET: "টেক্সচার উইজেট",
  T_46_META_WS_E_THERMALSCOPE: "থার্মাল স্কোপ",
  T_46_META_WS_E_THIRDPERSON: "তৃতীয় ব্যক্তির ক্যামেরা",
  T_46_META_WS_E_THIRDPERSONCLASSIC: "তৃতীয় ব্যক্তির ক্যামেরা (FF ক্লাসিক)",
  T_46_META_WS_E_THIRDPERSONLOCK: "তৃতীয় ব্যক্তির ক্যামেরা (লকড)",
  T_46_META_WS_E_THOMPSON: "THOMPSON",
  T_46_META_WS_E_THOMPSON2: "THOMPSON2",
  T_46_META_WS_E_THOWINGKNIFE2FORCOMPATIBILITY: "সামঞ্জস্যতার জন্য থ্রোয়িং নাইফ2",
  T_46_META_WS_E_THRILLBATTLE: "দক্ষতা ৫",
  T_46_META_WS_E_THROWATTACK: "গ্রেনেড ছোড়া",
  T_46_META_WS_E_THROWINGKNIFE: "ThrowingKnife",
  T_46_META_WS_E_THROWREDZOMBIE: "লাল থ্রো জম্বি",
  T_46_META_WS_E_THROWZOMBIE: "থ্রো জম্বি",
  T_46_META_WS_E_THUMBSUP: "লাইক",
  T_46_META_WS_E_THUNDER: "বৈদ্যুতিক শক",
  T_46_META_WS_E_TILEA: "টাইল A",
  T_46_META_WS_E_TILEB: "টাইল B",
  T_46_META_WS_E_TILEC: "টাইল C",
  T_46_META_WS_E_TILED: "টাইল্ড",
  T_46_META_WS_E_TIPSSOUND: "টিপস দেখান",
  T_46_META_WS_E_TOGGLEWIDGET: "টগল উইজেট",
  T_46_META_WS_E_TOILETBOWL: "টয়লেট",
  T_46_META_WS_E_TONEA: "পাথর A",
  T_46_META_WS_E_TOP: "উপরের পোশাক",
  T_46_META_WS_E_TOPDOWN: "উপর থেকে নিচের দিকে ক্যামেরা",
  T_46_META_WS_E_TORII: "তোরি",
  T_46_META_WS_E_TOUCHPADWIDGET: "টাচপ্যাড উইজেট",
  T_46_META_WS_E_TOWER: "দুর্গ",
  T_46_META_WS_E_TPIPE: "পাইপ T",
  T_46_META_WS_E_TRACINGSTEPS: "দক্ষতা ৩",
  T_46_META_WS_E_TRAILER: "ট্রেলার",
  T_46_META_WS_E_TRANSFORMATION: "চেহারা পরিবর্তক",
  T_46_META_WS_E_TRANSPARENT: "স্বচ্ছ",
  T_46_META_WS_E_TRAPEZOID: "ট্রাপিজিয়াম",
  T_46_META_WS_E_TRASHCAN: "আবর্জনার বাক্স",
  T_46_META_WS_E_TRIANGLE: "ত্রিভুজ",
  T_46_META_WS_E_TRIGGERS: "ট্রিগার",
  T_46_META_WS_E_TRIPLE: "তিনগুন",
  T_46_META_WS_E_TROPHY: "ট্রফি",
  T_46_META_WS_E_TRUE: "হ্যাঁ",
  T_46_META_WS_E_TUKTUK: "টুক টুক",
  T_46_META_WS_E_TUTUCAR: "টুক টুক",
  T_46_META_WS_E_TYRANTZOMBIE: "অত্যাচারী জম্বি",
  T_46_META_WS_E_UAVLITE: "ইউএভি লাইট",
  T_46_META_WS_E_UIFINISH: "শেষ",
  T_46_META_WS_E_UITAP: "ইউআই ট্যাপ",
  T_46_META_WS_E_UMP: "UMP",
  T_46_META_WS_E_UMP2: "UMP2",
  T_46_META_WS_E_UNITGENERATOR: "ইউনিট জেনারেটর",
  T_46_META_WS_E_UPWARDTURBULENCE: "উত্তরণ বাতাস",
  T_46_META_WS_E_USP: "USP",
  T_46_META_WS_E_USP_2: "USP_2",
  T_46_META_WS_E_UZI: "UZI",
  T_46_META_WS_E_VAULTOVER: "টপকে যাওয়া",
  T_46_META_WS_E_VECTOR: "VECTOR",
  T_46_META_WS_E_VEHICLE: "যানবাহন",
  T_46_META_WS_E_VEHICLEEXPLODE: "যানবাহন বিস্ফোরণ",
  T_46_META_WS_E_VELOCITY: "গতি",
  T_46_META_WS_E_VENDINGMACHINE: "বিক্রয় মেশিন",
  T_46_META_WS_E_VERTICAL: "উল্লম্ব",
  T_46_META_WS_E_VEST: "বডি আর্মার",
  T_46_META_WS_E_VEST1: "Vest1",
  T_46_META_WS_E_VEST2: "Vest2",
  T_46_META_WS_E_VEST3: "Vest3",
  T_46_META_WS_E_VEST4: "বডি আর্মার4",
  T_46_META_WS_E_VISUALEFFECTS: "ভিজ্যুয়াল এফেক্টস",
  T_46_META_WS_E_VSK94: "VSK94",
  T_46_META_WS_E_VSS: "VSS",
  T_46_META_WS_E_WALLA: "প্রাচীর A",
  T_46_META_WS_E_WALLBRAWL: "দক্ষতা ২",
  T_46_META_WS_E_WARNING: "সতর্কতা",
  T_46_META_WS_E_WATERRING: "জল ছিটানো",
  T_46_META_WS_E_WAVE1: "তরঙ্গ1",
  T_46_META_WS_E_WAVE2: "তরঙ্গ2",
  T_46_META_WS_E_WAVE3: "তরঙ্গ3",
  T_46_META_WS_E_WEAPONGENERATOR: "অস্ত্র",
  T_46_META_WS_E_WEAPONSLOT: "অস্ত্রের স্লট",
  T_46_META_WS_E_WHISTLE: "শত্রু পরাজিত",
  T_46_META_WS_E_WIDERANGE: "প্রশস্ত পরিসর",
  T_46_META_WS_E_WIN: "বিজয়",
  T_46_META_WS_E_WINDATTACK: "বাতাসের আক্রমণ",
  T_46_META_WS_E_WOODA: "কাঠ A",
  T_46_META_WS_E_WOODCUTZOMBIE: "কাঠ কাটার জম্বি",
  T_46_META_WS_E_WOODENPLANK: "কাঠের সেতু",
  T_46_META_WS_E_WORLDPOSITION: "বিশ্বস্থানাঙ্ক",
  T_46_META_WS_E_WRECKEDBUS: "বিধ্বস্ত বাস",
  T_46_META_WS_E_WRECKEDCAR: "বিধ্বস্ত গাড়ি",
  T_46_META_WS_E_WRONG: "ভুল",
  T_46_META_WS_E_XM8: "XM8",
  T_46_META_WS_E_XM82: "XM82",
  T_46_META_WS_E_ZOMBIE: "জোম্বি",
  T_46_META_WS_E_ZOMBIES: "জোম্বি",
  T_46_META_WS_E_ZOOM: "জুম",
  T_46_META_WS_ELIMINATE: "নির্মূল করুন",
  T_46_META_WS_ELIMINATEDENTITY: "বহিষ্কৃত সত্তা",
  T_46_META_WS_ELIMINATEDPLAYER: "বহিষ্কৃত খেলোয়াড়",
  T_46_META_WS_ENABLEDEFAULTBTREE: "ডিফল্ট আচরণ গাছ সক্রিয় করুন",
  T_46_META_WS_ENABLEMOVINGSAFEZONE: "চলমান নিরাপত্তা অঞ্চল সক্ষম করুন",
  T_46_META_WS_ENABLESAFEZONE: "নিরাপত্তা অঞ্চল সক্ষম করুন",
  T_46_META_WS_ENDCURRENTPHASE: "বর্তমান ধাপ শেষ করুন",
  T_46_META_WS_ENDMORPH: "রূপান্তর শেষ করুন",
  T_46_META_WS_ENDPOSITION: "শেষ অবস্থান",
  T_46_META_WS_ENTERVEHICLE: "যানবাহনে প্রবেশ করুন",
  T_46_META_WS_ENTITY: "সত্তা",
  T_46_META_WS_EQUIPMENTID: "সরঞ্জাম আইডি",
  T_46_META_WS_EULERANGLETOQUATERNION: "ইউলার কোণকে কুয়ার্নিয়নে রূপান্তরিত করুন",
  T_46_META_WS_EXITVEHICLE: "যানবাহন থেকে বের হন",
  T_46_META_WS_EXPONENTIATION: "ঘাতক",
  T_46_META_WS_FILTERENTITY: "সত্তা ফিল্টার করুন",
  T_46_META_WS_FILTERLEVELOBJECTS: "স্তরের অবজেক্ট ফিল্টার করুন",
  T_46_META_WS_FIND: "সন্ধান করুন",
  T_46_META_WS_FINDAT: "সন্ধান করুন",
  T_46_META_WS_FINDPATH: "পথ খুঁজুন",
  T_46_META_WS_FLOOR: "নিম্নসীমা",
  T_46_META_WS_FOOTBALLGOAL: "ফুটবল গোল",
  T_46_META_WS_FORMAT: "ফরম্যাট",
  T_46_META_WS_GETALLKEYS: "সমস্ত কী পান",
  T_46_META_WS_GETALLPLAYERS: "সমস্ত প্লেয়ার পান",
  T_46_META_WS_GETALLSHOPS: "সব দোকান পান",
  T_46_META_WS_GETALLTEAMS: "সমস্ত দল পান",
  T_46_META_WS_GETATTACKABLEENTITY: "আক্রমণযোগ্য সত্তা পান",
  T_46_META_WS_GETATTACKABLEFACTIONS: "আক্রমণযোগ্য গোষ্ঠী পান",
  T_46_META_WS_GETBACKPACKSKIN: "ব্যাকপ্যাক স্কিন পান",
  T_46_META_WS_GETBLACKBOARDVALUE: "ব্ল্যাকবোর্ড মান পান",
  T_46_META_WS_GETBUFFS: "বাফ পান",
  T_46_META_WS_GETCHATCHANNEL: "চ্যাট চ্যানেল পান",
  T_46_META_WS_GETCHILDBYINDEX: "সূচক দ্বারা শিশু পান",
  T_46_META_WS_GETCHILDBYNAME: "নাম দ্বারা শিশু পান",
  T_46_META_WS_GETCHILDREN: "সমস্ত শিশু পান",
  T_46_META_WS_GETCOLORCHANNEL: "রঙ চ্যানেল পান",
  T_46_META_WS_GETCONSUMABLES: "ভোগ্যপণ্য পান",
  T_46_META_WS_GETCULLINGMASK: "কলিং মাস্ক পান",
  T_46_META_WS_GETCURRENTCAMERA: "বর্তমান ক্যামেরা পান",
  T_46_META_WS_GETCURRENTCHATCHANNEL: "বর্তমান চ্যাট চ্যানেল পান",
  T_46_META_WS_GETCUSTOMMISSIONPROGRESS: "কাস্টম মিশনের অগ্রগতি পান",
  T_46_META_WS_GETDYEDCOUNT: "রঙের সংখ্যা পান",
  T_46_META_WS_GETDYEDSTATUS: "রঙের অবস্থা পান",
  T_46_META_WS_GETEQUIPMENTS: "সরঞ্জাম পান",
  T_46_META_WS_GETFACTION: "গোষ্ঠী পান",
  T_46_META_WS_GETGLOBALSLEEPTHRESHOLD: "বৈশ্বিক ঘুমের থ্রেশহোল্ড পান",
  T_46_META_WS_GETITEMCOUNT: "আইটেমের সংখ্যা পান",
  T_46_META_WS_GETLOADEDSCENES: "লোড করা দৃশ্যগুলি পান",
  T_46_META_WS_GETLOCALAIMDIRECTION: "স্থানীয় লক্ষ্য দিক পান",
  T_46_META_WS_GETLOCALPLAYER: "স্থানীয় খেলোয়াড় পান",
  T_46_META_WS_GETLOCALTIMESTAMP: "স্থানীয় টাইমস্ট্যাম্প পান",
  T_46_META_WS_GETMAPID: "মানচিত্র আইডি পান",
  T_46_META_WS_GETMINIMAP: "মিনিম্যাপ পান",
  T_46_META_WS_GETMONEY: "টাকা পান",
  T_46_META_WS_GETMONEYCOUNT: "টাকা সংখ্যা পান",
  T_46_META_WS_GETMORPH: "রূপান্তর পান",
  T_46_META_WS_GETNODEVARIABLE: "নোড ভেরিয়েবল পান",
  T_46_META_WS_GETOUTFIT: "পোশাক পান",
  T_46_META_WS_GETOWNER: "মালিক পান",
  T_46_META_WS_GETPARENT: "পিতা-মাতা পান",
  T_46_META_WS_GETPOSITIONNEARTEAMMATE: "দলের কাছাকাছি অবস্থান পান",
  T_46_META_WS_GETRANDOMSPAWNPOSITION: "এলোমেলো স্পন অবস্থান পান",
  T_46_META_WS_GETRESULTFROMCURVE: "কার্ভ থেকে ফলাফল পান",
  T_46_META_WS_GETSCENESKYBOX: "দৃশ্যের স্কাইবক্স পান",
  T_46_META_WS_GETSERVERREGION: "সার্ভার অঞ্চল পান",
  T_46_META_WS_GETSERVERTIMESTAMP: "সার্ভার টাইমস্ট্যাম্প পান",
  T_46_META_WS_GETSKELETONPARTBYNAME: "নাম দ্বারা হাড়ের অংশ পান",
  T_46_META_WS_GETSKILLS: "দক্ষতা পান",
  T_46_META_WS_GETSLEEPTHRESHOLD: "ঘুমের থ্রেশহোল্ড পান",
  T_46_META_WS_GETTOKENCOUNT: "টোকেন সংখ্যা পান",
  T_46_META_WS_GETTOKENCOUNTTODAY: "আজকের টোকেন সংখ্যা পান",
  T_46_META_WS_GETTYPE: "প্রকার পান",
  T_46_META_WS_GETVEHICLESKIN: "যানবাহনের স্কিন পান",
  T_46_META_WS_GETWALLET: "ওয়ালেট পান",
  T_46_META_WS_GETWEAPONSKIN: "অস্ত্রের স্কিন পান",
  T_46_META_WS_GETWIDGETBYPATH: "পাথ দ্বারা উইজেট পান",
  T_46_META_WS_GETWIDGETFROMCUSTOMUI: "কাস্টম UI থেকে উইজেট পান",
  T_46_META_WS_GIVEJAILBREAKITEM: "কারাগার ভাঙার আইটেম দিন",
  T_46_META_WS_GIVEJAILBREAKREWARD: "কারাগার ভাঙার পুরস্কার দিন",
  T_46_META_WS_HASAOISPECIALFOLLOW: "AOI বিশেষ অনুসরণ আছে কিনা",
  T_46_META_WS_HASCOMPONENT: "উপাদান আছে কি",
  T_46_META_WS_HASSCRIPT: "স্ক্রিপ্ট আছে কি",
  T_46_META_WS_HASTAG: "ট্যাগ আছে কি",
  T_46_META_WS_HELPEDPLAYER: "সহায়তা প্রাপ্ত খেলোয়াড়",
  T_46_META_WS_HELPPLAYER: "সহায়ক খেলোয়াড়",
  T_46_META_WS_HIDEAPPEARANCEGROUP: "চেহারা গ্রুপ লুকান",
  T_46_META_WS_HITENTITY: "আঘাতপ্রাপ্ত সত্তা",
  T_46_META_WS_HITFLY: "উড়ান",
  T_46_META_WS_HITNORMAL: "আঘাতের সাধারণ রেখা",
  T_46_META_WS_HITOBJECT: "আঘাতপ্রাপ্ত বস্তু",
  T_46_META_WS_HITPOSITION: "আঘাতের স্থান",
  T_46_META_WS_INDEXOF: "উপাদানের প্রথম প্রদর্শনের অবস্থান পান",
  T_46_META_WS_INFECTIONZOMBIEGROWUP: "সংক্রামক জম্বি বৃদ্ধি",
  T_46_META_WS_INSERT: "সন্নিবেশ করুন",
  T_46_META_WS_ISATTACKABLE: "আক্রমণযোগ্য কি",
  T_46_META_WS_ISCHATCHANNELEMPTY: "চ্যাট চ্যানেল খালি কি",
  T_46_META_WS_ISEQUAL: "সমান কি",
  T_46_META_WS_ISFRIEND: "বন্ধু কিনা যাচাই করুন",
  T_46_META_WS_ISHIT: "আঘাতপ্রাপ্ত",
  T_46_META_WS_ISINSIDEBOX: "বাক্সের মধ্যে আছে কিনা",
  T_46_META_WS_ISINSIDECYLINDER: "সিলিন্ডারের মধ্যে আছে কিনা",
  T_46_META_WS_ISINSIDESECTOR: "সেক্টরের মধ্যে আছে কিনা",
  T_46_META_WS_ISINSIDESPHERE: "গোলকের মধ্যে আছে কিনা",
  T_46_META_WS_ISSLEEPING: "ঘুমাচ্ছে কিনা",
  T_46_META_WS_ISSUBTYPEOF: "উপ প্রকার কি",
  T_46_META_WS_ITEM: "সত্তা",
  T_46_META_WS_ITEMID: "আইটেম আইডি",
  T_46_META_WS_JOIN: "যোগ করুন",
  T_46_META_WS_JOINCHATCHANNEL: "চ্যাট চ্যানেলে যোগ দিন",
  T_46_META_WS_JOINFACTION: "গোষ্ঠীতে যোগ দিন",
  T_46_META_WS_LASTINDEXOF: "উপাদানের শেষ প্রদর্শনের অবস্থান পান",
  T_46_META_WS_LENGTH: "দৈর্ঘ্য",
  T_46_META_WS_LERP: "Lerp",
  T_46_META_WS_LOADSCENE: "দৃশ্য লোড করুন",
  T_46_META_WS_LOGARITHM: "লঘু",
  T_46_META_WS_LOGERROR: "ত্রুটি লগ করুন",
  T_46_META_WS_LOGINFO: "তথ্য লগ করুন",
  T_46_META_WS_LOGWARNING: "সতর্কবার্তা লগ করুন",
  T_46_META_WS_LOOKROTATION: "লক্ষ্যকে ঘিরে ঘূর্ণন",
  T_46_META_WS_MAGNITUDE: "মাপ",
  T_46_META_WS_MAKER: "নির্মাতা",
  T_46_META_WS_MAX: "সর্বোচ্চ",
  T_46_META_WS_MECHANISM: "যন্ত্র",
  T_46_META_WS_MIN: "ন্যূনতম",
  T_46_META_WS_MONSTERUSESKILL: "স্কিল ব্যবহার করুন",
  T_46_META_WS_MORPHOBJECT: "রূপান্তরিত বস্তু",
  T_46_META_WS_MORPHTO: "রূপান্তর করুন",
  T_46_META_WS_MORPHTOBYITEMID: "আইটেম আইডি দ্বারা রূপান্তর করুন",
  T_46_META_WS_MOVECCT: "CCT সরান",
  T_46_META_WS_MOVEPOSITION: "অবস্থান সরান",
  T_46_META_WS_MOVEROTATION: "ঘূর্ণন সরান",
  T_46_META_WS_MULTIPLYQUATERNION: "কুয়াটারনিয়ন গুণফল",
  T_46_META_WS_MULTIRAYCAST: "মাল্টি-রে কাস্ট",
  T_46_META_WS_NEGATE: "নেতিবাচক",
  T_46_META_WS_NEW: "নতুন",
  T_46_META_WS_NODENAME: "নোডের নাম",
  T_46_META_WS_NORMALIZE: "স্বাভাবিকীকরণ",
  T_46_META_WS_NOTIFYPLAYEFFECT: "প্রভাব বাজানো বিজ্ঞপ্তি",
  T_46_META_WS_NOTIFYPLAYICONANIMATION: "আইকন অ্যানিমেশন প্লে করার জন্য নোটিফাই করুন",
  T_46_META_WS_NOTIFYPLAYSOUND: "শব্দ বাজানো বিজ্ঞপ্তি",
  T_46_META_WS_NOTIFYSHOWTIPS: "টিপস দেখানোর বিজ্ঞপ্তি",
  T_46_META_WS_NUMTOSTRING: "সংখ্যা থেকে স্ট্রিং",
  T_46_META_WS_ONACCESSEQUIPMENT: "সরঞ্জামে প্রবেশ",
  T_46_META_WS_ONACCESSITEM: "আইটেমে প্রবেশ",
  T_46_META_WS_ONACCESSWEAPON: "অস্ত্র প্রবেশ",
  T_46_META_WS_ONACE: "ACE সম্পন্ন হয়েছে",
  T_46_META_WS_ONAIMED: "লক্ষ্য শেষ হয়েছে",
  T_46_META_WS_ONAIMING: "লক্ষ্য করা হয়েছে",
  T_46_META_WS_ONASSIST: "সহায়তা",
  T_46_META_WS_ONATTACK: "আক্রমণ",
  T_46_META_WS_ONATTACKSTOP: "আক্রমণ বন্ধ হয়েছে",
  T_46_META_WS_ONAWAKE: "জাগরণ",
  T_46_META_WS_ONBEKNOCKEDDOWN: "নকডাউন হয়েছে",
  T_46_META_WS_ONBOUNCEDBYTIRE: "চাকার দ্বারা বাউন্স হয়েছে",
  T_46_META_WS_ONBOUNCEENTITY: "বাউন্স সত্তা",
  T_46_META_WS_ONBUILTINBUTTONTAPPED: "ইউআই বাটন ট্যাপ হয়েছে",
  T_46_META_WS_ONBULLETHIT: "বুলেট আঘাত করেছে",
  T_46_META_WS_ONCAMERARAYCAST: "ক্যামেরা রেকাস্ট",
  T_46_META_WS_ONCHARACTERCONTROLLERHIT: "চরিত্র কন্ট্রোলার আঘাত পেয়েছে",
  T_46_META_WS_ONCHASE: "তাড়া",
  T_46_META_WS_ONCHASESTOP: "তাড়া বন্ধ হয়েছে",
  T_46_META_WS_ONCLIPEND: "ক্লিপ শেষ হয়েছে",
  T_46_META_WS_ONCOLLISIONENTER: "সংঘর্ষ শুরু",
  T_46_META_WS_ONCOLLISIONEXIT: "সংঘর্ষ শেষ",
  T_46_META_WS_ONCOUNTDOWNFINISHED: "কাউন্টডাউন শেষ হয়েছে",
  T_46_META_WS_ONCREEP: "ক্রিপ",
  T_46_META_WS_ONCROUCH: "বসা",
  T_46_META_WS_ONDEALDAMAGE: "ক্ষতি দেওয়া",
  T_46_META_WS_ONDESTROY: "ধ্বংস",
  T_46_META_WS_ONDISABLE: "অক্ষম",
  T_46_META_WS_ONDISCONNECT: "সংযোগ বিচ্ছিন্ন হয়েছে",
  T_46_META_WS_ONDOUBLETAPPED: "ডাবল-ট্যাপ হয়েছে",
  T_46_META_WS_ONDRAG: "ড্র্যাগ হয়েছে",
  T_46_META_WS_ONDRAGEND: "ড্র্যাগ শেষ হয়েছে",
  T_46_META_WS_ONDRAGSTART: "ড্র্যাগ শুরু হয়েছে",
  T_46_META_WS_ONDRIVED: "ড্রাইভ হয়েছে",
  T_46_META_WS_ONDRIVEVEHICLE: "যানবাহন চালিত হয়েছে",
  T_46_META_WS_ONDROPCONSUMABLE: "ভোগ্য সামগ্রী ফেলা হয়েছে",
  T_46_META_WS_ONDROPPED: "ফেলা হয়েছে",
  T_46_META_WS_ONDROPWEAPON: "অস্ত্র ফেলা হয়েছে",
  T_46_META_WS_ONEACHLOOP: "প্রত্যেক লুপ",
  T_46_META_WS_ONELIMINATE: "বাতিল করা",
  T_46_META_WS_ONELIMINATED: "বাতিল হয়েছে",
  T_46_META_WS_ONENABLE: "সক্ষম",
  T_46_META_WS_ONEND: "শেষ",
  T_46_META_WS_ONENTERED: "প্রবেশ করেছে",
  T_46_META_WS_ONENTERVEHICLE: "যানবাহনে প্রবেশ",
  T_46_META_WS_ONENTITYENTER: "ট্রিগার এন্টার করুন",
  T_46_META_WS_ONENTITYEXIT: "ট্রিগার ছেড়ে দিন",
  T_46_META_WS_ONEQUIPARMOR: "আর্মার পরিধান",
  T_46_META_WS_ONEQUIPED: "সজ্জিত",
  T_46_META_WS_ONEQUIPWEAPON: "অস্ত্র পরিধান",
  T_46_META_WS_ONEXPLODE: "বিস্ফোরণ হয়েছে",
  T_46_META_WS_ONFALL: "পড়ার সময়",
  T_46_META_WS_ONFALLSTOP: "পড়া শেষ হলে",
  T_46_META_WS_ONFIRE: "ফায়ার হয়েছে",
  T_46_META_WS_ONFIXEDUPDATE: "ফিক্সড আপডেট হয়েছে",
  T_46_META_WS_ONFOOTBALLCOLLIDED: "ফুটবলের সাথে সংঘর্ষ",
  T_46_META_WS_ONFRIENDSUPDATE: "বন্ধুত্বের স্থিতি আপডেট ",
  T_46_META_WS_ONGAMEEND: "গেম শেষ",
  T_46_META_WS_ONGAMEPAUSE: "গেম বিরতি",
  T_46_META_WS_ONGAMERESUME: "গেম পুনরায় শুরু",
  T_46_META_WS_ONGAMESTART: "গেম শুরু",
  T_46_META_WS_ONGOAL: "গোল",
  T_46_META_WS_ONHITBYBULLET: "বুলেট আঘাত করেছে",
  T_46_META_WS_ONHITFLY: "উড়ন্ত আঘাত",
  T_46_META_WS_ONHITFLYENTITY: "উড়ন্ত সত্তায় আঘাত",
  T_46_META_WS_ONHOOKGUNFIRE: "হুক গান ফায়ার হয়েছে",
  T_46_META_WS_ONIDLE: "অলস",
  T_46_META_WS_ONJAILBREAKAREABEGIN: "জেল ব্রেক এরিয়া শুরু হয়েছে",
  T_46_META_WS_ONJAILBREAKAREAEND: "জেল ব্রেক এরিয়া শেষ হয়েছে",
  T_46_META_WS_ONJAILBREAKPLAYERJOIN: "জেল ব্রেক প্লেয়ার যোগদান করেছে",
  T_46_META_WS_ONJAILBREAKPLAYERQUIT: "জেল ব্রেক প্লেয়ার ছেড়ে গেছে",
  T_46_META_WS_ONJOINCHATCHANNELSUCCESSFULLY: "চ্যাট চ্যানেলে সফলভাবে যোগদান",
  T_46_META_WS_ONJOYSTICKMOVE: "জয়স্টিক মুভ হয়েছে",
  T_46_META_WS_ONJOYSTICKPRESSED: "চাপা হয়েছে",
  T_46_META_WS_ONJOYSTICKRELEASED: "ছেড়ে দেওয়া হয়েছে",
  T_46_META_WS_ONJUMP: "লাফ",
  T_46_META_WS_ONJUMPSTOP: "লাফানো শেষ হলে",
  T_46_META_WS_ONLANDMINEACTIVE: "ল্যান্ডমাইন সক্রিয় হয়েছে",
  T_46_META_WS_ONLANDMINETRIGGER: "ল্যান্ডমাইন ট্রিগার হয়েছে",
  T_46_META_WS_ONLEAVECHATCHANNEL: "চ্যাট চ্যানেল ছেড়েছে",
  T_46_META_WS_ONLEAVEVEHICLE: "যানবাহন ছেড়ে গেছে",
  T_46_META_WS_ONLEFT: "ছেড়ে গেছে",
  T_46_META_WS_ONLEVELOBJECTBEMORPHED: "লেভেল অবজেক্ট মর্ফ হয়েছে",
  T_46_META_WS_ONMOVE: "চলেছে",
  T_46_META_WS_ONNODEENTER: "নোড প্রবেশ করেছে",
  T_46_META_WS_ONNODEEXIT: "নোড ছেড়েছে",
  T_46_META_WS_ONPAUSE: "বিরতি",
  T_46_META_WS_ONPHASEEND: "পর্যায় শেষ",
  T_46_META_WS_ONPHASESTART: "পর্যায় শুরু",
  T_46_META_WS_ONPICKEDUP: "তোলা হয়েছে",
  T_46_META_WS_ONPLAYERASSIST: "প্লেয়ার সাহায্য করেছে",
  T_46_META_WS_ONPLAYERBEELIMINATED: "প্লেয়ার বাতিল হয়েছে",
  T_46_META_WS_ONPLAYERBEKNOCKEDDOWN: "প্লেয়ার নকডাউন হয়েছে",
  T_46_META_WS_ONPLAYERDEALDAMAGE: "প্লেয়ার ক্ষতি করেছে",
  T_46_META_WS_ONPLAYERELIMINATE: "প্লেয়ার বাতিল করেছে",
  T_46_META_WS_ONPLAYERENTER: "প্লেয়ার প্রবেশ করেছে",
  T_46_META_WS_ONPLAYERJOIN: "প্লেয়ার যোগ দিয়েছে",
  T_46_META_WS_ONPLAYERJOINCHATCHANNELFAILURE: "চ্যাট চ্যানেলে যোগদানে ব্যর্থ",
  T_46_META_WS_ONPLAYERLEAVE: "প্লেয়ার ছেড়েছে",
  T_46_META_WS_ONPLAYERPURCHASEREQUEST: "প্লেয়ার ক্রয়ের অনুরোধ করেছে",
  T_46_META_WS_ONPLAYERQUIT: "প্লেয়ার মিডওয়ে থেকে ছেড়ে গেছে",
  T_46_META_WS_ONPLAYERRANKCHANGE: "প্লেয়ারের র‍্যাঙ্ক পরিবর্তন",
  T_46_META_WS_ONPLAYERREQUESTFORPURCHASEFULFILLED: "প্লেয়ারের ক্রয় অনুরোধ পূরণ হয়েছে",
  T_46_META_WS_ONPLAYERREVIVED: "প্লেয়ার পুনরুজ্জীবিত হয়েছে",
  T_46_META_WS_ONPLAYERREVIVEDINSPAWNPOS: "স্পন পজিশনে প্লেয়ার পুনরুজ্জীবিত হয়েছে",
  T_46_META_WS_ONPLAYERSCORECHANGE: "প্লেয়ারের স্কোর পরিবর্তন",
  T_46_META_WS_ONPLAYERSWITCHSCENE: "প্লেয়ার দৃশ্য পরিবর্তন করেছে",
  T_46_META_WS_ONPREDEALDAMAGE: "ক্ষতি দেওয়ার আগে",
  T_46_META_WS_ONPREPURCHASE: "ক্রয়ের আগে",
  T_46_META_WS_ONPRESSED: "চাপা হয়েছে",
  T_46_META_WS_ONPRETAKEDAMAGE: "ক্ষতি গ্রহণের আগে",
  T_46_META_WS_ONPURCHASE: "ক্রয়",
  T_46_META_WS_ONRANKCHANGED: "সত্তার র‍্যাঙ্ক পরিবর্তন",
  T_46_META_WS_ONRECONNECT: "পুনঃসংযোগ হয়েছে",
  T_46_META_WS_ONRELEASED: "ছেড়ে দেওয়া হয়েছে",
  T_46_META_WS_ONRELOAD: "রিলোড হয়েছে",
  T_46_META_WS_ONRESUME: "পুনরায় শুরু",
  T_46_META_WS_ONREVIVED: "পুনরুজ্জীবিত",
  T_46_META_WS_ONROUNDEND: "রাউন্ড শেষ",
  T_46_META_WS_ONROUNDSTART: "রাউন্ড শুরু",
  T_46_META_WS_ONSCENELOAD: "দৃশ্য লোড হয়েছে",
  T_46_META_WS_ONSCENESWITCH: "দৃশ্য পরিবর্তন",
  T_46_META_WS_ONSCORECHANGE: "সত্তার স্কোর পরিবর্তন",
  T_46_META_WS_ONSHOTBYFOOTBALLSHOOTER: "ফুটবল শুটার দ্বারা শ্যুট হয়েছে",
  T_46_META_WS_ONSLEEP: "ঘুমানো হয়েছে",
  T_46_META_WS_ONSPAWN: "স্পন",
  T_46_META_WS_ONSPRAY: "স্প্রে হয়েছে",
  T_46_META_WS_ONSPRAYED: "স্প্রে করা হয়েছে",
  T_46_META_WS_ONSPRINT: "স্প্রিন্ট",
  T_46_META_WS_ONSPRINTSTOP: "স্প্রিন্ট বন্ধ হয়েছে",
  T_46_META_WS_ONSTANDUP: "উঠা হয়েছে",
  T_46_META_WS_ONSTART: "শুরু",
  T_46_META_WS_ONSTARTFIRE: "আক্রমণ",
  T_46_META_WS_ONSTATEEND: "অবস্থা শেষ হয়েছে",
  T_46_META_WS_ONSURFING: "সার্ফিং",
  T_46_META_WS_ONSURFINGSTOP: "সার্ফিং বন্ধ হয়েছে",
  T_46_META_WS_ONSWITCHHANDHELD: "হ্যান্ডহেল্ড পরিবর্তন",
  T_46_META_WS_ONTAKEDAMAGE: "ক্ষতি গ্রহণ",
  T_46_META_WS_ONTAPPED: "ট্যাপ করা হয়েছে",
  T_46_META_WS_ONTEAMACE: "দল পুরোপুরি বাতিল",
  T_46_META_WS_ONTEAMADD: "দল যোগ করা হয়েছে",
  T_46_META_WS_ONTEAMREMOVE: "দল বাতিল হয়েছে",
  T_46_META_WS_ONTEAMROUNDRANKCHANGE: "রাউন্ডে দলের র‍্যাঙ্ক পরিবর্তন",
  T_46_META_WS_ONTEAMSCORECHANGE: "দলের স্কোর পরিবর্তন",
  T_46_META_WS_ONTELEPORTENTITY: "টেলিপোর্ট সত্তা",
  T_46_META_WS_ONTEXTCHANGE: "টেক্সট পরিবর্তন",
  T_46_META_WS_ONTHROWABLEEXPLODE: "থ্রোয়েবল বিস্ফোরণ হয়েছে",
  T_46_META_WS_ONTOGGLE: "টগল",
  T_46_META_WS_ONTOUCHDOWN: "টাচ ডাউন",
  T_46_META_WS_ONTOUCHUP: "টাচ আপ",
  T_46_META_WS_ONUIHIDE: "ইউআই লুকানো হয়েছে",
  T_46_META_WS_ONUISHOW: "ইউআই দেখানো হয়েছে",
  T_46_META_WS_ONUPDATE: "আপডেট হয়েছে",
  T_46_META_WS_ONUSEAVATARSKILL: "অবতার স্কিল ব্যবহার হয়েছে",
  T_46_META_WS_ONUSECONSUMABLE: "ভোগ্য সামগ্রী ব্যবহার হয়েছে",
  T_46_META_WS_ONUSED: "ব্যবহার হয়েছে",
  T_46_META_WS_ONUSEPORTAL: "পোর্টাল ব্যবহার হয়েছে",
  T_46_META_WS_ONWAKEUP: "জাগানো হয়েছে",
  T_46_META_WS_ONWEAPONBEEQUIPED: "অস্ত্র সজ্জিত হয়েছে",
  T_46_META_WS_ONWEAPONDEALDAMAGE: "অস্ত্র দ্বারা ক্ষতি হয়েছে",
  T_46_META_WS_ONWEAPONELIMINATE: "অস্ত্র বাতিল করেছে",
  T_46_META_WS_ONWEAPONSTOPFIRING: "অস্ত্র গুলি বন্ধ করেছে",
  T_46_META_WS_OWNER: "মালিক",
  T_46_META_WS_P_ACCELERATE: "গতি বৃদ্ধি",
  T_46_META_WS_P_ACCELERATION: "ত্বরণ",
  T_46_META_WS_P_ACCOUNTID: "অ্যাকাউন্ট আইডি",
  T_46_META_WS_P_ACCURACY: "সঠিকতা",
  T_46_META_WS_P_ACTIONTYPE: "কর্মের ধরন",
  T_46_META_WS_P_ACTIVATEDALPHA: "সক্রিয় আলফা",
  T_46_META_WS_P_ACTIVE: "সক্রিয়",
  T_46_META_WS_P_ACTIVEINHIERARCHY: "শৃঙ্খলার মধ্যে সক্রিয়",
  T_46_META_WS_P_ACTIVESELF: "সক্রিয় আত্ম",
  T_46_META_WS_P_ACTIVETEXT: "অ্যাক্টিভ টেক্সট",
  T_46_META_WS_P_ACTUALPOSITION: "আসল অবস্থান",
  T_46_META_WS_P_AFTERACCUMULATOR: "পরবর্তী অ্যাকুমুলেটর",
  T_46_META_WS_P_AIMASSISTCENTEROFFSET: "লক্ষ্য সহায়তা কেন্দ্র স্থানান্তর",
  T_46_META_WS_P_AIMASSISTDISTANCE: "লক্ষ্য সহায়তা দূরত্ব",
  T_46_META_WS_P_AIMASSISTTYPE: "লক্ষ্য সহায়তা",
  T_46_META_WS_P_AIRDROPSTATE: "এয়ার ড্রপ অবস্থা",
  T_46_META_WS_P_ALIGNMENTHORIZONTAL: "অনুভূমিক অ্যালাইনমেন্ট",
  T_46_META_WS_P_ALIGNMENTVERTICAL: "উল্লম্ব অ্যালাইনমেন্ট",
  T_46_META_WS_P_ALLITEMS: "সব আইটেম",
  T_46_META_WS_P_ALLMEMBERS: "সকল সদস্য",
  T_46_META_WS_P_ALLOWLOCKBYAIMASSIST: "লক্ষ্য সহায়তা দ্বারা লক করা",
  T_46_META_WS_P_ALLOWPRESSEDOUTSIDE: "বাহিরে প্রেস অনুমতি",
  T_46_META_WS_P_ALLPLAYERS: "সকল প্লেয়ার",
  T_46_META_WS_P_ALLTEAMMATES: "সব সঙ্গী",
  T_46_META_WS_P_ALPHA: "আলফা",
  T_46_META_WS_P_ALWAYSSHOWMARK: "সর্বদা মার্ক দেখান",
  T_46_META_WS_P_AMBIENTCOLOR: "পরিবেশ রঙ",
  T_46_META_WS_P_AMMOCLIPSIZE: "গোলাবারুদের আকার",
  T_46_META_WS_P_AMMOMAGSIZE: "গুলি ম্যাগ সাইজ",
  T_46_META_WS_P_AMMOPERSHOT: "প্রতি শটের গুলি",
  T_46_META_WS_P_AMMOTYPE: "গুলি প্রকার",
  T_46_META_WS_P_ANCHORMAX: "অ্যাঙ্কর ম্যাক্স",
  T_46_META_WS_P_ANCHORMIN: "অ্যাঙ্কর মিন",
  T_46_META_WS_P_ANCHOROBJECT: "নোঙ্গর বস্তু",
  T_46_META_WS_P_ANCHORPOSITION: "অ্যাঙ্কর অবস্থান",
  T_46_META_WS_P_ANCHORTYPE: "UITweener স্ক্রিপ্ট সক্রিয় করা",
  T_46_META_WS_P_ANGLE: "কোণ",
  T_46_META_WS_P_ANGLEDOWN: "কোণ নিচে",
  T_46_META_WS_P_ANGLEUP: "কোণ উপরে",
  T_46_META_WS_P_ANGULARDRAG: "অ্যাঙ্গুলার ড্র্যাগ",
  T_46_META_WS_P_ANGULARSPEED: "কোণীয় গতি",
  T_46_META_WS_P_ANGULARVELOCITY: "অ্যাঙ্গুলার ভেলোসিটি (rad/s)",
  T_46_META_WS_P_ANIMATIONCLIP: "অ্যানিমেশন নাম",
  T_46_META_WS_P_ANIMATIONCONTROLLER: "অ্যানিমেশন কন্ট্রোলার",
  T_46_META_WS_P_ANIMATIONCONTROLLERRESID: "অ্যানিমেশন কন্ট্রোলার রিসোর্স UUID",
  T_46_META_WS_P_ARMORPENETRATION: "আর্মার পেনিট্রেশন",
  T_46_META_WS_P_ARMORPENETRATIONFACTOR: "আর্মার পেনেট্রেশন ফ্যাক্টর",
  T_46_META_WS_P_ARMORTYPE: "আর্মার প্রকার",
  T_46_META_WS_P_ARROWOFFSET: "তীর অফসেট",
  T_46_META_WS_P_ARROWSIZE: "তীর আকার",
  T_46_META_WS_P_ARROWSPRITE: "তীর স্প্রাইট",
  T_46_META_WS_P_ASKBUYTARGET: "লক্ষ্য কিনতে অনুরোধ করুন",
  T_46_META_WS_P_ATTACHTARGET: "অ্যাটাচ টার্গেট",
  T_46_META_WS_P_ATTACKABLEFACTIONS: "আক্রমণযোগ্য গোষ্ঠী",
  T_46_META_WS_P_ATTACKDAMAGE: "আক্রমণ ক্ষতি",
  T_46_META_WS_P_ATTACKINTERVAL: "আক্রমণের সময়সীমা",
  T_46_META_WS_P_ATTACKRANGE: "আক্রমণ পরিসর",
  T_46_META_WS_P_ATTACKTARGET: "আক্রমণ লক্ষ্য",
  T_46_META_WS_P_ATTTACKABLETARGETS: "আক্রমণযোগ্য লক্ষ্য",
  T_46_META_WS_P_AUTOPLAY: "স্বয়ংক্রিয় প্লে স্টেটাস",
  T_46_META_WS_P_AVAILABLEPOINT: "উপলব্ধ পয়েন্ট",
  T_46_META_WS_P_AVATAR: "অবতার",
  T_46_META_WS_P_AVATARID: "অ্যাভাটার আইডি",
  T_46_META_WS_P_BACKGROUND: "পটভূমি",
  T_46_META_WS_P_BACKGROUNDALPHA: "ব্যাকগ্রাউন্ড আলফা",
  T_46_META_WS_P_BACKGROUNDCOLOR: "পটভূমির রঙ",
  T_46_META_WS_P_BACKGROUNDCOLOR1: "ব্যাকগ্রাউন্ড রঙ 1",
  T_46_META_WS_P_BACKGROUNDCOLOR2: "ব্যাকগ্রাউন্ড রঙ 2",
  T_46_META_WS_P_BACKGROUNDFILL: "ব্যাকগ্রাউন্ড পূরণ",
  T_46_META_WS_P_BACKGROUNDICONNAME: "পটভূমি আইকনের নাম",
  T_46_META_WS_P_BACKGROUNDNAME: "ব্যাকগ্রাউন্ড নাম",
  T_46_META_WS_P_BACKGROUNDOFFSET: "ব্যাকগ্রাউন্ড অফসেট",
  T_46_META_WS_P_BACKGROUNDRADIUS: "ব্যাকগ্রাউন্ড রেডিয়াস",
  T_46_META_WS_P_BACKGROUNDSIZEDELTA: "ব্যাকগ্রাউন্ড সাইজ ডেল্টা",
  T_46_META_WS_P_BACKGROUNDSPRITE: "ব্যাকগ্রাউন্ড স্প্রাইট",
  T_46_META_WS_P_BACKPACK: "খেলোয়াড়ের রুকসাক",
  T_46_META_WS_P_BACKPACKSKINID: "ব্যাকপ্যাক স্কিন আইডি",
  T_46_META_WS_P_BACKWARDSPEED: "পিছনে গতি",
  T_46_META_WS_P_BANNERID: "ব্যানার আইডি",
  T_46_META_WS_P_BASEHORIZONTALSPEED: "বেস অনুভূমিক গতি",
  T_46_META_WS_P_BASEMULTIPLIER: "বেস মাল্টিপ্লায়ার",
  T_46_META_WS_P_BASETIME: "বেস সময়",
  T_46_META_WS_P_BASEVERTICALSPEED: "বেস উল্লম্ব গতি",
  T_46_META_WS_P_BEFOREACCUMULATOR: "পূর্ববর্তী অ্যাকুমুলেটর",
  T_46_META_WS_P_BEVTREEID: "বিহেভিয়ার ট্রি আইডি",
  T_46_META_WS_P_BINDPROPERTYID: "বাইন্ড প্রপার্টি আইডি",
  T_46_META_WS_P_BODY: "ধড়",
  T_46_META_WS_P_BODYDAMAGEFACTOR: "দেহের ক্ষতির হার",
  T_46_META_WS_P_BONEPOSITION: "হাড়ের অবস্থান",
  T_46_META_WS_P_BONESCALE: "হাড়ের স্কেলিং",
  T_46_META_WS_P_BOOSTCD: "বুস্ট কুলডাউন",
  T_46_META_WS_P_BOOSTDURATION: "বুস্ট সময়কাল",
  T_46_META_WS_P_BOOSTSPEED: "বুস্ট গতি",
  T_46_META_WS_P_BORDERLR: "বর্ডার বাম ডান",
  T_46_META_WS_P_BORDERTB: "বর্ডার উপরের নীচের",
  T_46_META_WS_P_BOTTOMALPHA: "নীচের আলফা",
  T_46_META_WS_P_BOUNDWALLET: "HUD অ্যানকর প্রকার",
  T_46_META_WS_P_BRAKEHORSEPOWER: "ব্রেক হর্সপাওয়ার",
  T_46_META_WS_P_BRAKETORQUE: "ব্রেক টর্ক",
  T_46_META_WS_P_BRRANK: "BR র‌্যাংক",
  T_46_META_WS_P_BUFFTYPE: "বাফ প্রকার",
  T_46_META_WS_P_BURNDAMAGE: "জ্বলন্ত ক্ষতি",
  T_46_META_WS_P_BURNINGDAMAGEINTERVAL: "জ্বলন্ত ক্ষতি মধ্যবর্তী সময়",
  T_46_META_WS_P_BURNTIME: "জ্বলন্ত সময়",
  T_46_META_WS_P_BUTTOM: "নিম্নাংশ",
  T_46_META_WS_P_BUTTONCOLORS: "বোতামের রঙ",
  T_46_META_WS_P_BUTTONNAMES: "বোতামের নাম",
  T_46_META_WS_P_BUTTONSTYLE: "বোতামের স্টাইল",
  T_46_META_WS_P_CAMERABLOCKMODE: "ক্যামেরা ব্লক মোড",
  T_46_META_WS_P_CAMERAPROJECTIONMODE: "ক্যামেরা প্রকল্পের ধরণ",
  T_46_META_WS_P_CAMERATYPE: "ক্যামেরা",
  T_46_META_WS_P_CANCELDRAGIFFITS: "ফিট হলে টানাটানি বাতিল করুন",
  T_46_META_WS_P_CANCOSTDURABILITY: "টেকসইতার জন্য খরচ হতে পারে",
  T_46_META_WS_P_CANDAMAGED: "ক্ষতিগ্রস্ত হতে পারে",
  T_46_META_WS_P_CANDESTROY: "ধ্বংস করতে পারে",
  T_46_META_WS_P_CANDESTROYED: "ধ্বংস হতে পারে",
  T_46_META_WS_P_CANSELFTRIGGER: "নিজে সক্রিয় করা যায়",
  T_46_META_WS_P_CANTEAMTRIGGER: "দল দ্বারা সক্রিয় করা যায়",
  "T_46_META_WS_P_CANTRIGGEREDBY SELF": "নিজে দ্বারা ট্রিগার করা যেতে পারে",
  "T_46_META_WS_P_CANTRIGGEREDBY TEAM": "দল দ্বারা ট্রিগার করা যেতে পারে",
  "T_46_META_WS_P_CANTRIGGEREDBY VEHICLE": "যানবাহন দ্বারা ট্রিগার করা যেতে পারে",
  T_46_META_WS_P_CANVEHICLETRIGGER: "যানবাহন দ্বারা সক্রিয় করা যায়",
  T_46_META_WS_P_CELLSIZE: "সেল সাইজ",
  T_46_META_WS_P_CELLSPACE: "সেল স্পেস",
  T_46_META_WS_P_CENTER: "কেন্দ্র",
  T_46_META_WS_P_CENTERINVISIBLE: "কেন্দ্র অদৃশ্য",
  T_46_META_WS_P_CENTEROFFSET: "সেন্টার অফসেট",
  T_46_META_WS_P_CENTEROFMASS: "সেন্টার অফ মাস",
  T_46_META_WS_P_CENTERRANGE: "কেন্দ্রীয় পরিসীমা",
  T_46_META_WS_P_CENTRALFLASHTIME: "প্রান্ত ফ্ল্যাশ সময়",
  T_46_META_WS_P_CENTRALLINEACTIVE: "কেন্দ্রীয় লাইন সক্রিয়",
  T_46_META_WS_P_CENTRALLINEPOSITION: "কেন্দ্র লাইন অবস্থান",
  T_46_META_WS_P_CHANNELID: "চ্যাট চ্যানেল আইডি",
  T_46_META_WS_P_CHARGEMAX: "সর্বাধিক চার্জ",
  T_46_META_WS_P_CHASETARGET: "লক্ষ্য লক্ষ্য",
  T_46_META_WS_P_CHATCHANNEL: "চ্যাট চ্যানেল",
  T_46_META_WS_P_CHECKPOINTID: "চেকপয়েন্ট আইডি",
  T_46_META_WS_P_CHILDINDEX: "শিশু সূচক",
  T_46_META_WS_P_CHIPEXP: "চিপ অভিজ্ঞতা",
  T_46_META_WS_P_CLICKSIZE: "ক্লিকের আকার",
  T_46_META_WS_P_CLIPLENGTH: "ক্লিপ দৈর্ঘ্য",
  T_46_META_WS_P_CLIPPINGTYPE: "ক্লিপিং টাইপ",
  T_46_META_WS_P_COLLIDERID: "কলাইডার আইডি",
  T_46_META_WS_P_CONSTRAIN: "কনস্ট্রেইন",
  T_46_META_WS_P_CONSTRAINT: "কনস্ট্রেইন্ট",
  T_46_META_WS_P_CONSTRAINTCOUNT: "কনস্ট্রেইন্ট কাউন্ট",
  T_46_META_WS_P_CONSUMABLETYPE: "ব্যবহারযোগ্য প্রকার",
  T_46_META_WS_P_CONTENT: "বিষয়বস্তু",
  T_46_META_WS_P_CONTENTORIGIN: "কনটেন্ট অরিজিন",
  T_46_META_WS_P_CONTROLPOINTS: "নিয়ন্ত্রণ পয়েন্ট",
  T_46_META_WS_P_COORDINATESYSTEM: "সমন্বয় সিস্টেম",
  T_46_META_WS_P_COUNT: "সংখ্যা",
  T_46_META_WS_P_COUNTDOWNENDTIME: "কাউন্টডাউন শেষ সময় (s)",
  T_46_META_WS_P_COUNTDOWNKEY: "কাউন্টডাউন কী",
  T_46_META_WS_P_COUNTDOWNTIME: "কাউন্টডাউন সময়",
  T_46_META_WS_P_COUNTPERWAVE: "প্রতি ঢেউয়ের সংখ্যা",
  T_46_META_WS_P_CRASHMAXDAMAGE: "ক্র্যাশ সর্বাধিক ক্ষতি",
  T_46_META_WS_P_CRASHMAXSPEED: "ক্র্যাশ সর্বোচ্চ গতি",
  T_46_META_WS_P_CRASHMESSFACTOR: "ক্র্যাশ ম্যাস ফ্যাক্টর",
  T_46_META_WS_P_CRASHMINDAMAGE: "ক্র্যাশ সর্বনিম্ন ক্ষতি",
  T_46_META_WS_P_CRAWLSPEEDSCALE: "Crawl করার সময় গতি স্কেল",
  T_46_META_WS_P_CREATEDENTITY: "তৈরি করা সত্তা",
  T_46_META_WS_P_CROUCHWALKSPEEDSCALE: "বসে থাকার সময় গতি স্কেল",
  T_46_META_WS_P_CSRANK: "CS র‌্যাংক",
  "T_46_META_WS_P_CURRENT AMMO": "বর্তমান গুলি",
  T_46_META_WS_P_CURRENTANIMATIONRESOURCE: "বর্তমান অ্যানিমেশন সম্পদ",
  T_46_META_WS_P_CURRENTCLIP: "বর্তমান ক্লিপ",
  T_46_META_WS_P_CURRENTCLIPPROGRESS: "বর্তমান ক্লিপ অগ্রগতি",
  T_46_META_WS_P_CURRENTDURABILITY: "বর্তমান স্থায়িত্ব",
  T_46_META_WS_P_CURRENTENERGY: "বর্তমান শক্তি",
  T_46_META_WS_P_CURRENTHANDHELDITEM: "বর্তমান হাতে থাকা আইটেম",
  T_46_META_WS_P_CURRENTHP: "বর্তমান HP",
  T_46_META_WS_P_CURRENTPHASEINDEX: "বর্তমান পর্যায় সূচক",
  T_46_META_WS_P_CURRENTPROGRESS: "বর্তমান অগ্রগতি",
  T_46_META_WS_P_CURRENTROUNDINDEX: "বর্তমান রাউন্ড সূচক",
  T_46_META_WS_P_CURRENTSTATE: "বর্তমান অবস্থা",
  T_46_META_WS_P_CURRENTVALUE: "বর্তমান মান",
  T_46_META_WS_P_CURRENTWAVE: "বর্তমান ঢেউ",
  T_46_META_WS_P_CUSTOMCHARACTERRESOURCE: "কাস্টম চরিত্র সম্পদ",
  T_46_META_WS_P_CUSTOMGAMERESULT: "কাস্টম গেমের ফলাফল",
  T_46_META_WS_P_CUSTOMGRAVITY: "কাস্টম গ্র্যাভিটি",
  T_46_META_WS_P_CUSTOMPUSHFORCE: "কাস্টম পুশ ফোর্স",
  T_46_META_WS_P_CUSTOMXY: "কাস্টম XY",
  T_46_META_WS_P_DAMAGE: "ক্ষতি",
  "T_46_META_WS_P_DAMAGE RANGE": "পরিসর",
  T_46_META_WS_P_DAMAGEFACTOR: "ক্ষতির গুণফল",
  T_46_META_WS_P_DAMAGEINTERVAL: "ক্ষতির সময় অন্তর (s)",
  T_46_META_WS_P_DAMAGERADIUS: "ক্ষতির পরিসর",
  T_46_META_WS_P_DAMAGERATIOHEAD: "মাথার ক্ষতির অনুপাত",
  T_46_META_WS_P_DAMAGERATIOLIMB: "অঙ্গ ক্ষতির অনুপাত",
  T_46_META_WS_P_DAMAGEREDUCTIONFACTOR: "ক্ষতির হ্রাস সহগ",
  T_46_META_WS_P_DAMAGETAKENPCT: "ক্ষতির শতাংশ",
  T_46_META_WS_P_DAMAGETAKENPERCENT: "ক্ষতি গ্রহণের শতাংশ",
  T_46_META_WS_P_DAMAGEVALUE: "ক্ষতির মান",
  T_46_META_WS_P_DARKNESS: "অন্ধকার",
  T_46_META_WS_P_DECELERATIONPERCENT: "মন্থন শতাংশ",
  T_46_META_WS_P_DEFAULTTEXT: "ডিফল্ট টেক্সট",
  T_46_META_WS_P_DEFENSE: "প্রতিরক্ষা হার",
  T_46_META_WS_P_DEFENSERATE: "প্রতিরক্ষা হার",
  T_46_META_WS_P_DELTA: "ডেল্টা",
  T_46_META_WS_P_DELTATIME: "ডেল্টা সময়",
  T_46_META_WS_P_DELTAVALUE: "ডেল্টা মান",
  T_46_META_WS_P_DEPTH: "গভীরতা",
  T_46_META_WS_P_DESC: "বর্ণনা",
  T_46_META_WS_P_DESCRIPTION: "বর্ণনা",
  T_46_META_WS_P_DESCRIPTIONKEY: "বর্ণনা কী",
  T_46_META_WS_P_DESCRIPTIONPARAMS: "টিপস বর্ণনা প্যারামিটার",
  T_46_META_WS_P_DESTVAL: "গন্তব্য মান",
  T_46_META_WS_P_DETECTRANGE: "সনাক্তকরণের পরিসীমা",
  T_46_META_WS_P_DIFFUSEALPHA: "বিস্তার অ্যালফা",
  T_46_META_WS_P_DIFFUSECOLOR: "বিস্তার রঙ",
  T_46_META_WS_P_DIFFUSETEXTURE: "বিস্তার টেক্সচার",
  T_46_META_WS_P_DISABLECOLOR: "নিষ্ক্রিয় রং",
  T_46_META_WS_P_DISABLEFALLDAMAGE: "গরাণের ক্ষতি নিষ্ক্রিয় করুন",
  T_46_META_WS_P_DISABLEITEMDROP: "আইটেম ফেলা নিষ্ক্রিয় করুন",
  T_46_META_WS_P_DISABLEITEMPICKUP: "আইটেম উত্তোলন নিষ্ক্রিয় করুন",
  T_46_META_WS_P_DISABLEMANUALCLOSING: "ম্যানুয়াল ক্লোজিং নিষ্ক্রিয় করুন",
  T_46_META_WS_P_DISABLEQUICKCHAT: "দ্রুত চ্যাট নিষ্ক্রিয় করুন",
  T_46_META_WS_P_DISABLERECIPROCATING: "প্রতিরোধক না ব্যবহার করা",
  T_46_META_WS_P_DISABLEVOICECHAT: "ভয়েস চ্যাট নিষ্ক্রিয় করুন",
  T_46_META_WS_P_DISTANCE: "দূরত্ব",
  T_46_META_WS_P_DOUBLEGUNTYPE: "দ্বৈত অস্ত্র প্রকার",
  T_46_META_WS_P_DOWNEDCRAWLSPEEDSCALE: "ক Crawling গতির স্কেল",
  T_46_META_WS_P_DOWNSPEED: "নিচের দিকে গতি",
  T_46_META_WS_P_DRAG: "ড্র্যাগ",
  T_46_META_WS_P_DRIVER: "চালক",
  T_46_META_WS_P_DROPITEMS: "ড্রপ আইটেম",
  T_46_META_WS_P_DURABILITY: "টেকসইতা",
  T_46_META_WS_P_DURABILITYRECOVERY: "স্থায়িত্ব পুনরুদ্ধার",
  T_46_META_WS_P_DURATION: "সময়কাল",
  T_46_META_WS_P_EDGEFLASHTIME: "ফ্ল্যাশব্যাংক প্রভাব সুইচ",
  T_46_META_WS_P_EFFECTACTIVE: "প্রভাব সক্রিয়",
  T_46_META_WS_P_EFFECTCOLOR: "প্রভাবের রঙ",
  T_46_META_WS_P_EFFECTDURATION: "ট্রিগার সময়",
  T_46_META_WS_P_EFFECTIVETIMEINTERVAL: "কার্যকর সময় অন্তর",
  T_46_META_WS_P_EFFECTRESID: "প্রভাব রিসোর্স পাথ",
  T_46_META_WS_P_ENABLE: "সক্ষম করুন",
  T_46_META_WS_P_ENABLEATTACK: "আক্রমণ সক্ষম করুন",
  T_46_META_WS_P_ENABLEBOTREVIVE: "বট পুনরুদ্ধার সক্রিয় করুন",
  T_46_META_WS_P_ENABLEDEPTHMAP: "গভীরতা ম্যাপ সক্রিয় করুন",
  T_46_META_WS_P_ENABLEDROPONDEATH: "মৃত্যুর সময় ড্রপ অনুমোদন",
  T_46_META_WS_P_ENABLELOCALIZATION: "স্থানীয়করণ সক্ষম করুন",
  T_46_META_WS_P_ENABLEMOVEINMIDAIR: "এয়ারবর্ন মোভমেন্ট সক্ষম করুন",
  T_46_META_WS_P_ENABLEPLAYERREVIVE: "खिलाड़ी पुनरुद्धार सक्षम करें",
  T_46_META_WS_P_ENABLEPLAYERVIEW: "প্লেয়ার ভিউ সক্ষম করুন",
  T_46_META_WS_P_ENABLEROTATEWITHGRAVITY: "গ্রাভিটির সাথে রোটেট সক্ষম করুন",
  T_46_META_WS_P_ENABLESKINATTRIBUTES: "স্কিন বৈশিষ্ট্য সক্ষম করুন",
  T_46_META_WS_P_ENABLESWINGING: "দোল সক্রিয় করুন",
  T_46_META_WS_P_ENABLETRACTION: "টান সক্রিয় করুন",
  T_46_META_WS_P_ENDPOSITION: "শেষ অবস্থান",
  T_46_META_WS_P_ENDRADIUS: "শেষ ব্যাসার্ধ",
  T_46_META_WS_P_ENDTIME: "শেষ সময় (s)",
  T_46_META_WS_P_ENDTIMES: "শেষ সময়",
  T_46_META_WS_P_ENDVALUE: "শেষ মান",
  T_46_META_WS_P_ENERGY: "শক্তি",
  T_46_META_WS_P_ENERGYCOST: "এনার্জি খরচ",
  T_46_META_WS_P_ENERGYRECOVERY: "শক্তি পুনরুদ্ধার",
  T_46_META_WS_P_ENGINEHORSEPOWER: "ইঞ্জিন হর্সপাওয়ার",
  T_46_META_WS_P_ENGINETORQUE: "ইঞ্জিন টর্ক",
  T_46_META_WS_P_EP: "EP",
  T_46_META_WS_P_EPMAX: "সর্বাধিক EP",
  T_46_META_WS_P_EPRECOVERYAMOUNT: "EP পুনরুদ্ধারের পরিমাণ",
  T_46_META_WS_P_EVENTS: "ইভেন্টসমূহ",
  T_46_META_WS_P_EXPLODEDAMAGE: "বিস্ফোরণ ক্ষতি",
  T_46_META_WS_P_EXPLODEDAMAGEREDUCTIONFACTOR: "বিস্ফোরক ক্ষতির হ্রাস সহগ",
  T_46_META_WS_P_EXPLODEDELAY: "বিস্ফোরণ বিলম্ব",
  T_46_META_WS_P_EXPLODERANGE: "বিস্ফোরণ পরিসর",
  T_46_META_WS_P_EXPLOSIONDELAY: "কেন্দ্রীয় ফ্ল্যাশ সময়",
  T_46_META_WS_P_EXPLOSIONRANGE: "বিস্ফোরণ পরিসীমা",
  T_46_META_WS_P_EXPLOSIONTIME: "বিস্ফোরণ বিলম্ব",
  T_46_META_WS_P_EXPPERDAMAGE: "প্রতি ক্ষতিতে EXP",
  T_46_META_WS_P_EXPPERMOVEMILE: "প্রতি চলাচল মাইলে EXP",
  T_46_META_WS_P_EXPPERSECOND: "প্রতি সেকেন্ডে EXP",
  T_46_META_WS_P_EXTRABACKPACKCAPACITY: "অতিরিক্ত ব্যাকপ্যাক ক্ষমতা",
  T_46_META_WS_P_EXTRABAGCAPACITY: "অতিরিক্ত ব্যাকপ্যাক স্থান",
  T_46_META_WS_P_EXTRAHPRATIO: "অতিরিক্ত HP অনুপাত",
  T_46_META_WS_P_FACEPAINT: "মেকআপ",
  T_46_META_WS_P_FACTION: "গোষ্ঠী",
  T_46_META_WS_P_FALLINGDAMAGERATIO: "পতনের ক্ষতি অনুপাত",
  T_46_META_WS_P_FALLSPEED: "পতন গতি",
  T_46_META_WS_P_FASTAUTORELOADSPEED: "স্বয়ংক্রিয় পুনরায় লোডের গতি",
  T_46_META_WS_P_FILEID: "ফাইল আইডি",
  T_46_META_WS_P_FILL: "পূরণ",
  T_46_META_WS_P_FILLAMOUNT: "পূরণের মান",
  T_46_META_WS_P_FILLDIRECTION: "পূরণ দিক",
  T_46_META_WS_P_FILLTYPE: "পূরণের ধরন",
  T_46_META_WS_P_FIREANGLELIMIT: "শুটিং কোণ সীমা",
  T_46_META_WS_P_FIRETYPE: "ফায়ার টাইপ",
  T_46_META_WS_P_FIRSTSCOREPARAMS: "প্রথম স্কোর প্যারামিটার",
  T_46_META_WS_P_FIRSTSCORETITLE: "প্রথম স্কোর শিরোনাম",
  T_46_META_WS_P_FIRSTSCOREVALUE: "প্রথম স্কোর মান",
  T_46_META_WS_P_FIXEDDELTATIME: "স্থির ডেল্টা সময়",
  T_46_META_WS_P_FLASHBANGHITEFFECTSWITCH: "প্রভাবের সময়কাল",
  T_46_META_WS_P_FLIP: "ফ্লিপ",
  T_46_META_WS_P_FLIPTYPE: "ফ্লিপ টাইপ",
  T_46_META_WS_P_FLYMAXHEIGHT: "সর্বাধিক উড্ডয়ন উচ্চতা",
  T_46_META_WS_P_FLYSPEEDHORIZONTAL: "অনুভূমিক ফ্লাই স্পিড",
  T_46_META_WS_P_FLYSPEEDVERTICAL: "উল্লম্ব ফ্লাই স্পিড",
  T_46_META_WS_P_FOGCOLOR: "কুয়াশার রঙ",
  T_46_META_WS_P_FOLLOWTARGET: "লক্ষ্য অনুসরণ করুন",
  T_46_META_WS_P_FONT: "ফন্ট",
  T_46_META_WS_P_FONTSIZE: "ফন্ট সাইজ",
  T_46_META_WS_P_FONTSTYLE: "ফন্টের ধরন",
  T_46_META_WS_P_FONTTYPE: "ফন্টের স্টাইল",
  T_46_META_WS_P_FORCESYNCTOCLIENT: "ক্লায়েন্টের সাথে জোরপূর্বক সিঙ্ক্রোনাইজেশন",
  T_46_META_WS_P_FORWARD: "সামনে",
  T_46_META_WS_P_FORWARDSPEED: "সামনের দিকে গতি",
  T_46_META_WS_P_FOV: "দৃষ্টি ক্ষেত্র",
  T_46_META_WS_P_FREEZEDURATION: "ফ্রিজের সময়কাল (সেকেন্ড)",
  T_46_META_WS_P_FRIENDFACTIONS: "বন্ধুত্বপূর্ণ গোষ্ঠী",
  T_46_META_WS_P_FRIENDLYPLAYERS: "বন্ধুদের খেলোয়াড়",
  T_46_META_WS_P_FULLDAMAGEDISTANCE: "পূর্ণ ক্ষতির দূরত্ব",
  T_46_META_WS_P_FUNCTIONTYPE: "ফাংশন প্রকার",
  T_46_META_WS_P_GAINHPCOLOR: "HP অর্জনের রঙ",
  T_46_META_WS_P_GAMEFRAMECOUNT: "মোট ফ্রেম সংখ্যা",
  T_46_META_WS_P_GAMETIMECOUNT: "খেলা সময়",
  T_46_META_WS_P_GEARSHIFTINGDELAY: "গিয়ার শিফটিং বিলম্ব",
  T_46_META_WS_P_GENDER: "লিঙ্গ",
  T_46_META_WS_P_GETONBOOSTCD: "বুস্টে ওঠার কুলডাউন",
  T_46_META_WS_P_GETONBOOSTCDSWITCH: "বুস্টে ওঠার কুলডাউন সুইচ",
  T_46_META_WS_P_GETONSKATEBOARDCD: "স্কেটবোর্ডে ওঠার কুলডাউন",
  T_46_META_WS_P_GRADIENT: "গ্রেডিয়েন্ট",
  T_46_META_WS_P_GRADIENTBOTTOM: "নীচের গ্রেডিয়েন্ট",
  T_46_META_WS_P_GRADIENTTOP: "শীর্ষ গ্রেডিয়েন্ট",
  T_46_META_WS_P_GRAVITY: "গ্রাভিটি",
  T_46_META_WS_P_GRENADEMAXDAMAGE: "গ্রেনেড সর্বাধিক ক্ষতি",
  T_46_META_WS_P_GRENADEMINDAMAGE: "গ্রেনেড ন্যূনতম ক্ষতি",
  T_46_META_WS_P_GRENADERANGE: "গ্রেনেড পরিসীমা",
  T_46_META_WS_P_GROUPID: "গ্রুপ আইডি",
  T_46_META_WS_P_HEAD: "মাথা",
  T_46_META_WS_P_HEADDAMAGEFACTOR: "মাথার ক্ষতির হার",
  T_46_META_WS_P_HEADSHOTDAMAGEREDUCTION: "মাথায় আঘাতের ক্ষতি হ্রাস",
  T_46_META_WS_P_HEIGHT: "উচ্চতা",
  T_46_META_WS_P_HELMET: "মাথাপত্র",
  T_46_META_WS_P_HIGHESTBRRANK: "সর্বোচ্চ BR র‌্যাংক",
  T_46_META_WS_P_HIGHESTCSRANK: "সর্বোচ্চ CS র‌্যাংক",
  T_46_META_WS_P_HIGHSHOOTANGLEMIN: "সর্বনিম্ন উত্থান কোণ",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLE: "উচ্চ গতি স্টিয়ারিং সীমা",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLEATSPEED: "উচ্চ গতি স্টিয়ারিং সীমা থ্রেশহোল্ড",
  T_46_META_WS_P_HITPOINTEFFECT: "আঘাতের পয়েন্টের প্রভাব",
  T_46_META_WS_P_HORIZONTALBAR: "অনুভূমিক বার",
  T_46_META_WS_P_HORIZONTALOFFSET: "অনুভূমিক অফসেট",
  T_46_META_WS_P_HOSTILETEAMS: "শত্রু দলের সংখ্যা",
  T_46_META_WS_P_HOSTTEAM: "হোস্ট টিম",
  T_46_META_WS_P_HP: "HP",
  T_46_META_WS_P_HPMAX: "সর্বোচ্চ HP",
  T_46_META_WS_P_HPRECOVERYAMOUNT: "HP পুনরুদ্ধার পরিমাণ",
  T_46_META_WS_P_HPRECOVERYSPEED: "HP পুনরুদ্ধারের গতি (মিলিসেকেন্ড)",
  T_46_META_WS_P_ICON: "আইকন",
  T_46_META_WS_P_ICONCOLOR: "আইকনের রঙ",
  T_46_META_WS_P_ICONNAME: "আইকনের নাম",
  T_46_META_WS_P_ICONRESOURCE: "আইকন রিসোর্স",
  T_46_META_WS_P_ID: "আইডি",
  "T_46_META_WS_P_IDAMAGE NTERVAL": "ক্ষতির অন্তর্বর্তীকাল (স)",
  T_46_META_WS_P_IDLEBRAKEINPUT: "আইডল ব্রেক ইনপুট",
  T_46_META_WS_P_INACTIVATEDALPHA: "নিষ্ক্রিয় আলফা",
  T_46_META_WS_P_INDEX: "সূচক",
  T_46_META_WS_P_INITIALMAGCOUNT: "প্রাথমিক ম্যাগ সংখ্যা",
  T_46_META_WS_P_INITIALSPEED: "প্রারম্ভিক গতি",
  T_46_META_WS_P_INITIALVALUE: "প্রাথমিক মান",
  T_46_META_WS_P_INITIALWORLDPOSITION: "প্রাথমিক বিশ্ব অবস্থান",
  T_46_META_WS_P_INSCENE: "দৃশ্যের মধ্যে",
  T_46_META_WS_P_INSTANCEID: "ইনস্ট্যান্স আইডি",
  T_46_META_WS_P_INTENSITY: "তীব্রতা",
  T_46_META_WS_P_INVERTFILL: "বিপরীত পূরণ",
  T_46_META_WS_P_INVINCIBLE: "অদম্য",
  "T_46_META_WS_P_IS SHOW": "প্রদর্শন করা হচ্ছে কি না",
  T_46_META_WS_P_IS3D: "3D কিনা",
  T_46_META_WS_P_ISACE: "ACE কি",
  T_46_META_WS_P_ISACED: "একসঙ্গে ধ্বংস হয়েছে কিনা",
  T_46_META_WS_P_ISAI: "এটি AI কি?",
  T_46_META_WS_P_ISALWAYSINSCREEN: "সর্বদা পর্দায়",
  T_46_META_WS_P_ISAPPLYSHADOW: "ছায়া প্রয়োগ",
  T_46_META_WS_P_ISATTACKABLE: "আক্রমণযোগ্য",
  T_46_META_WS_P_ISAUTOCHASEENEMY: "শত্রুকে স্বয়ংক্রিয়ভাবে তাড়া করা",
  T_46_META_WS_P_ISAUTOPLAY: "অটো প্লে",
  T_46_META_WS_P_ISAUTOTELEPORT: "স্বয়ংক্রিয় টেলিপোর্ট কি না",
  T_46_META_WS_P_ISBILLBOARD: "সর্বদা ভিডিও ক্যামেরায়",
  T_46_META_WS_P_ISBOLD: "বোল্ড",
  T_46_META_WS_P_ISBOTTOMCOLLIDING: "নীচে ধাক্কা",
  T_46_META_WS_P_ISCENTERPOS: "কেন্দ্রীয় অবস্থান কি",
  T_46_META_WS_P_ISCONSUMEAMMO: "গুলি খরচ",
  T_46_META_WS_P_ISCONTINUOUS: "ধারাবাহিক কি না",
  T_46_META_WS_P_ISCOUNTDOWN: "কাউন্টডাউন কি",
  T_46_META_WS_P_ISCURRENTANIMATIONLOOP: "বর্তমান অ্যানিমেশন লুপ",
  T_46_META_WS_P_ISDEADDROP: "মৃত্যুর সমর্থন",
  T_46_META_WS_P_ISDEATHTRIGGER: "মৃত্যুর ট্রিগার কি না",
  T_46_META_WS_P_ISDEBUG: "BTree ডিবাগ সক্রিয় করুন",
  T_46_META_WS_P_ISDEFAULTSPAWNPOINT: "ডিফল্ট স্পন পয়েন্ট কি না",
  T_46_META_WS_P_ISDROPONELIMINATED: "মৃত্যুর সময় হারিয়ে যাওয়া সামগ্রী",
  T_46_META_WS_P_ISEND: "শেষ",
  T_46_META_WS_P_ISFEBUTTON: "FE বোতাম কিনা",
  T_46_META_WS_P_ISGREY: "ধূসর কি",
  T_46_META_WS_P_ISGROUNDED: "গ্রাউন্ডেড",
  T_46_META_WS_P_ISIGNOREDEPTH: "গভীরতা উপেক্ষা করুন",
  T_46_META_WS_P_ISINVINCIBLE: "অবিনশ্বর",
  T_46_META_WS_P_ISITALIC: "ইটালিক",
  T_46_META_WS_P_ISLASTROUND: "শেষ রাউন্ড কি",
  T_46_META_WS_P_ISLOCALPOS: "স্থানীয় কোঅর্ডিনেট সিস্টেম সক্রিয় করুন",
  T_46_META_WS_P_ISLOOP: "লুপিং কিনা",
  T_46_META_WS_P_ISMATCHPOINT: "ম্যাচ পয়েন্ট কি",
  T_46_META_WS_P_ISMOVEABLE: "চলতে পারে",
  T_46_META_WS_P_ISOCCUPIED: "দখলকৃত কি না",
  T_46_META_WS_P_ISOPENTWEEN: "HP পরিবর্তনের প্রভাব সক্রিয় করুন",
  T_46_META_WS_P_ISPLAYING: "প্লেয়িং অবস্থায় আছে",
  T_46_META_WS_P_ISPURCHASABLE: "দোকানের আইটেম",
  T_46_META_WS_P_ISREVERSE: "বিপরীত",
  T_46_META_WS_P_ISSERVERDRIVEN: "সার্ভার দ্বারা চালিত",
  T_46_META_WS_P_ISSHOW: "দেখান",
  T_46_META_WS_P_ISSHOWHUDNAME: "HUD নাম দেখান",
  T_46_META_WS_P_ISSHOWMAPINFO: "মানচিত্রের তথ্য দেখান",
  T_46_META_WS_P_ISSHOWQUICKMESSAGE: "দ্রুত বার্তা দেখান",
  T_46_META_WS_P_ISSHOWSCAN: "স্ক্যান দেখান",
  T_46_META_WS_P_ISSHOWTAG: "ট্যাগ দেখান",
  T_46_META_WS_P_ISSIDECOLLIDING: "পাশে ধাক্কা",
  T_46_META_WS_P_ISSILENCE: "নিরব",
  T_46_META_WS_P_ISSINGLESHOT: "একক শট",
  T_46_META_WS_P_ISSKIPSTAGGERANIMATION: "পতনের অ্যানিমেশন বাইপাস করুন",
  T_46_META_WS_P_ISSLIDING: "স্লাইডিং হচ্ছে",
  T_46_META_WS_P_ISTOPCOLLIDING: "উপরের ধাক্কা",
  T_46_META_WS_P_ISUNDERLINE: "আন্ডারলাইন",
  T_46_META_WS_P_ISVISIBLE: "দৃশ্যমান",
  T_46_META_WS_P_ITEMBACKGROUNDCOLORS: "আইটেম ব্যাকগ্রাউন্ড রঙ",
  T_46_META_WS_P_ITEMBACKGROUNDS: "আইটেম ব্যাকগ্রাউন্ডস",
  T_46_META_WS_P_ITEMCOUNTS: "কেনা যায় কি না",
  T_46_META_WS_P_ITEMDESCRIPTIONS: "আইটেম বর্ণনা",
  T_46_META_WS_P_ITEMICONS: "আইটেম আইকনস",
  T_46_META_WS_P_ITEMID: "আইটেম আইডি",
  T_46_META_WS_P_ITEMIDS: "আইটেম ID",
  T_46_META_WS_P_ITEMNAMES: "আইটেম নাম",
  T_46_META_WS_P_ITEMPICKUPBANLIST: "নিষিদ্ধ আইটেম তালিকা",
  T_46_META_WS_P_JOYSTICKDRAGRADIUS: "জয়স্টিক ক্যাপ ড্র্যাগ রেডিয়াস",
  T_46_META_WS_P_JOYSTICKIMAGE: "জয়স্টিক ক্যাপ ইমেজ",
  T_46_META_WS_P_JOYSTICKRADIUS: "জয়স্টিক ক্যাপ রেডিয়াস",
  T_46_META_WS_P_JUMPCD: "লাফ কুলডাউন",
  T_46_META_WS_P_JUMPHEIGHT: "লাফের উচ্চতা",
  T_46_META_WS_P_JUMPHEIGHTSCALE: "লাফানোর উচ্চতার স্কেল",
  T_46_META_WS_P_KNOCKDOWNDAMAGEBONUS: "পড়ার ক্ষতি বোনাস",
  T_46_META_WS_P_KNOCKDOWNSTATUS: "আঘাতের অবস্থা",
  T_46_META_WS_P_LABEL: "লেবেল",
  T_46_META_WS_P_LABELCOLOR: "লেবেল রং",
  T_46_META_WS_P_LABELKEY: "লেবেল কী",
  T_46_META_WS_P_LABELPARAMS: "লেবেল প্যারামিটার",
  T_46_META_WS_P_LASTCHECKPOINTID: "বর্তমান চেকপয়েন্ট আইডি",
  T_46_META_WS_P_LASTSURVIVALTIME: "সর্বশেষ বেঁচে থাকা সময়",
  T_46_META_WS_P_LAYERTYPE: "স্তরের ধরন",
  T_46_META_WS_P_LAYOUTTYPE: "লেআউট টাইপ",
  T_46_META_WS_P_LEFTARM: "বাম হাত",
  T_46_META_WS_P_LEFTBACKGROUNDCOLOR: "বামের পটভূমির রঙ",
  T_46_META_WS_P_LEFTCOLOR: "বামপাশের রঙ",
  T_46_META_WS_P_LEFTDESCRIPTION: "বামপাশের বর্ণনা",
  T_46_META_WS_P_LEFTEFFECTACTIVE: "বাম পাশের প্রভাব সক্রিয়",
  T_46_META_WS_P_LEFTFIRINGARCANGLE: "বাম দিকের ফায়ারিং আর্ক কোণ",
  T_46_META_WS_P_LEFTFOOT: "বাম পায়ের পাতার নিচে",
  T_46_META_WS_P_LEFTHAND: "বাম হাতের তালু",
  T_46_META_WS_P_LEFTICON: "বাম আইকন",
  T_46_META_WS_P_LEFTICONNAME: "বামের আইকনের নাম",
  T_46_META_WS_P_LEFTLEG: "বাম পা",
  T_46_META_WS_P_LEFTPLAYERS: "বাম খেলোয়াড়",
  T_46_META_WS_P_LEFTSCORE: "বাম স্কোর",
  T_46_META_WS_P_LEFTSCOREAFTER: "বাম চূড়ান্ত স্কোর",
  T_46_META_WS_P_LEFTSCORETEXT: "বাম স্কোর",
  T_46_META_WS_P_LEFTTEAM: "ডান দল",
  T_46_META_WS_P_LEFTTEAMINDEX: "বাম দলের সূচক",
  T_46_META_WS_P_LEFTTEAMMATEALIVENUM: "বাম দলের বেঁচে থাকা সংখ্যা",
  T_46_META_WS_P_LEFTTEAMMATEFLAGCOUNT: "বামপাশের দলের পতাকা সংখ্যা",
  T_46_META_WS_P_LEFTTEAMMATESTATES: "বামপাশের দলের সদস্যদের অবস্থা",
  T_46_META_WS_P_LEFTTEAMNAME: "বামপাশের দলের নাম",
  T_46_META_WS_P_LEFTTEAMSCORE: "বামপাশের দলের স্কোর",
  T_46_META_WS_P_LEFTTEXT: "বাম টেক্সট",
  T_46_META_WS_P_LENGTH: "দৈর্ঘ্য",
  T_46_META_WS_P_LENSFLARE: "লেন্স ফ্লেয়ার",
  T_46_META_WS_P_LEVEL: "স্তর",
  T_46_META_WS_P_LIFETIME: "লাইফ টাইম (স)",
  T_46_META_WS_P_LIGHTCOLOR: "প্রধান আলো রঙ",
  T_46_META_WS_P_LIGHTINTENSITY: "আলো তীব্রতা",
  T_46_META_WS_P_LIMBDAMAGEFACTOR: "অঙ্গের ক্ষতির হার",
  T_46_META_WS_P_LINESPACING: "লাইন স্পেসিং",
  T_46_META_WS_P_LOCALPOSITION: "স্থানীয় অবস্থান",
  T_46_META_WS_P_LOCALROTATION: "স্থানীয় ঘূর্ণন",
  T_46_META_WS_P_LOCALROTATIONQ: "স্থানীয় ঘূর্ণন কোঅর্টার্নিয়ন",
  T_46_META_WS_P_LOCALSCALE: "স্থানীয় স্কেল",
  T_46_META_WS_P_LOCKEY: "লোকালাইজেশন কী",
  T_46_META_WS_P_LOOPCOUNT: "লুপ সংখ্যা",
  T_46_META_WS_P_LOOTSOCCER: "লুট ফুটবল",
  T_46_META_WS_P_LOSEHPCOLOR: "HP হারানোর রঙ",
  T_46_META_WS_P_LOSEMVPS: "পরাজিত MVP তালিকা",
  T_46_META_WS_P_LOSETEXT: "পরাজয়ের টেক্সট",
  "T_46_META_WS_P_MAIN CAMERA": "প্রধান ক্যামেরা",
  T_46_META_WS_P_MAINCOLOR: "প্রধান রঙ",
  T_46_META_WS_P_MAINSCORELIST: "মূল স্কোর",
  T_46_META_WS_P_MAINSCORETITLE: "মূল স্কোর শিরোনাম",
  T_46_META_WS_P_MAINWEAPON: "প্রধান অস্ত্র",
  T_46_META_WS_P_MAPSIZE: "ম্যাপের আকার",
  T_46_META_WS_P_MASK: "মাস্ক",
  T_46_META_WS_P_MASKNAME: "মাস্ক নাম",
  T_46_META_WS_P_MASS: "ভর (kg)",
  T_46_META_WS_P_MATCHTITLELEFT: "ম্যাচ শিরোনাম বাম",
  T_46_META_WS_P_MATCHTITLERIGHT: "ম্যাচ শিরোনাম ডান",
  T_46_META_WS_P_MAXCAPACITY: "সর্বাধিক ক্ষমতা",
  T_46_META_WS_P_MAXCOUNT: "সর্বাধিক সংখ্যা",
  T_46_META_WS_P_MAXDAMAGE: "সর্বাধিক ক্ষতি",
  T_46_META_WS_P_MAXDEPRESSIONANGLE: "সর্বাধিক নিম্ন কোণ",
  T_46_META_WS_P_MAXDISPLACEMENT: "সর্বোচ্চ স্থানচ্যুতি",
  T_46_META_WS_P_MAXDISTANCE: "সর্বাধিক দূরত্ব",
  T_46_META_WS_P_MAXDURABILITY: "সর্বাধিক স্থায়িত্ব",
  T_46_META_WS_P_MAXDURABILITYRATIO: "সর্বাধিক স্থায়িত্ব অনুপাত",
  T_46_META_WS_P_MAXENERGY: "সর্বাধিক শক্তি",
  T_46_META_WS_P_MAXEP: "সর্বোচ্চ শক্তি",
  T_46_META_WS_P_MAXHP: "সর্বাধিক HP",
  T_46_META_WS_P_MAXJUMPCOUNT: "সর্বোচ্চ লাফের সংখ্যা",
  T_46_META_WS_P_MAXJUMPHEIGHT: "সর্বাধিক লাফ উচ্চতা",
  T_46_META_WS_P_MAXLENGTH: "সর্বাধিক দৈর্ঘ্য",
  T_46_META_WS_P_MAXPROGRESS: "সর্বোচ্চ অগ্রগতি",
  T_46_META_WS_P_MAXSCATTERRATIO: "সর্বাধিক স্ক্যাটার রেশিও",
  T_46_META_WS_P_MAXSPEED: "সর্বোচ্চ গতিবেগ",
  T_46_META_WS_P_MAXTURRETCOUNT: "সর্বোচ্চ টারেট সংখ্যা",
  T_46_META_WS_P_MAXVALUE: "সর্বাধিক মান",
  T_46_META_WS_P_MAXWIDGETID: "সর্বোচ্চ উইজেট আইডি",
  T_46_META_WS_P_MINDAMAGE: "সর্বনিম্ন ক্ষতি",
  T_46_META_WS_P_MINDAMAGEDISTANCE: "ন্যূনতম ক্ষতি দূরত্ব",
  T_46_META_WS_P_MINDISTANCE: "ন্যূনতম দূরত্ব",
  T_46_META_WS_P_MINELEVATIONANGLE: "সর্বনিম্ন উচ্চতা কোণ",
  T_46_META_WS_P_MINENDHEIGHT: "ন্যূনতম শেষ উচ্চতা",
  T_46_META_WS_P_MINFLYHEIGHT: "ন্যূনতম উড়ন্ত উচ্চতা",
  T_46_META_WS_P_MINMOVEDISTANCE: "ন্যূনতম সরানো দূরত্ব",
  T_46_META_WS_P_MINVALUE: "সর্বনিম্ন মান",
  T_46_META_WS_P_MISSILEMAXDAMAGE: "ক্ষেপণাস্ত্রের সর্বাধিক ক্ষতি",
  T_46_META_WS_P_MISSILEMINDAMAGE: "ক্ষেপণাস্ত্রের সর্বনিম্ন ক্ষতি",
  T_46_META_WS_P_MISSILERANGE: "ক্ষেপণাস্ত্রের পরিসর",
  T_46_META_WS_P_MODEL: "মডেল",
  T_46_META_WS_P_MODELVISIBILITY: "মডেল দৃশ্যমানতা",
  T_46_META_WS_P_MODELVISIBLE: "মডেল দৃশ্যমান",
  T_46_META_WS_P_MONEY: "অর্থ",
  T_46_META_WS_P_MONEYLIST: "অর্থের তালিকা",
  T_46_META_WS_P_MONEYS: "সংযুক্ত ওয়ালেট",
  T_46_META_WS_P_MONEYTYPE: "মুদ্রার প্রকার",
  T_46_META_WS_P_MONSTERTYPE: "দানবের ধরন",
  T_46_META_WS_P_MOTIONTYPE: "মুভমেন্ট প্রকার",
  T_46_META_WS_P_MOTIONVALUEX: "মুভমেন্ট মান X",
  T_46_META_WS_P_MOTIONVALUEY: "মুভমেন্ট মান Y",
  T_46_META_WS_P_MOTIONVALUEZ: "মুভমেন্ট মান Z",
  T_46_META_WS_P_MOVEMENTDURATION: "চলাচলের সময়কাল",
  T_46_META_WS_P_MULTIPLIER: "মাল্টিপ্লায়ার",
  T_46_META_WS_P_MUSICELEMENTTYPE: "সঙ্গীত উপাদান প্রকার",
  T_46_META_WS_P_MUZZLEVELOCITY: "নল থেকে বেরোনোর গতি",
  T_46_META_WS_P_MVP: "MVP",
  T_46_META_WS_P_NAME: "নাম",
  T_46_META_WS_P_NEXTROUNDINDEX: "পরবর্তী রাউন্ড সূচক",
  T_46_META_WS_P_NICKNAME: "ডাকনাম",
  T_46_META_WS_P_NORMALCOLOR: "সাধারণ রঙ",
  T_46_META_WS_P_NORMALIZEDPOSITION: "স্বাভাবিক অবস্থান",
  T_46_META_WS_P_NUMBERINFACTION: "ফ্র্যাকশনে নম্বর",
  T_46_META_WS_P_OBJECTID: "অবজেক্ট আইডি",
  T_46_META_WS_P_OFFSET: "অফসেট",
  T_46_META_WS_P_OPTIONS: "বিকল্পসমূহ",
  T_46_META_WS_P_OTHERDAMAGEFACTOR: "অন্যান্য ক্ষতির হার",
  T_46_META_WS_P_OUTFIT: "খেলোয়াড়ের পোশাক",
  T_46_META_WS_P_OVERFLOW: "ওভারফ্লো",
  T_46_META_WS_P_OVERHEIGHTFALLSPEED: "উচ্চতা অতিক্রমের পর পতন গতি",
  T_46_META_WS_P_OVERLOADBYPLAYERCONFIGURATION: "খেলোয়াড় কনফিগারেশন অগ্রাধিকার",
  T_46_META_WS_P_OWNER: "মালিক",
  T_46_META_WS_P_PARAMS: "প্যারামিটার",
  T_46_META_WS_P_PARENT: "পিতা-মাতা",
  T_46_META_WS_P_PARENTID: "পিতামাতা আইডি",
  T_46_META_WS_P_PARENTUI: "পিতামাতা UI",
  T_46_META_WS_P_PARENTWIDGETENTITYID: "প্যারেন্ট উইজেটের Entity ID",
  T_46_META_WS_P_PARENTWIDGETFILEID: "প্যারেন্ট উইজেট ফাইলID",
  T_46_META_WS_P_PARTMASKA: "পার্ট মাস্ক ১",
  T_46_META_WS_P_PASSENGERS: "যাত্রী",
  T_46_META_WS_P_PATHID: "পথ আইডি",
  T_46_META_WS_P_PAUSEEVENT: "ইভেন্ট বিরাম",
  T_46_META_WS_P_PERSONAID: "পারসোনা আইডি",
  T_46_META_WS_P_PHASEDURATION: "সময়কাল (ms)",
  T_46_META_WS_P_PHASEENDTIME: "শেষ সময় (ms)",
  T_46_META_WS_P_PHYSICALLAYER: "ফিজিক্যাল লেয়ার",
  T_46_META_WS_P_PINID: "পিন আইডি",
  T_46_META_WS_P_PITCH: "পিচ",
  T_46_META_WS_P_PIVOT: "পিভট",
  T_46_META_WS_P_PLAYER: "প্লেয়ার",
  T_46_META_WS_P_PLAYERAIMINGSPEEDFACTOR: "খেলোয়াড়ের লক্ষ্যগত গতি গুণক",
  T_46_META_WS_P_PLAYERLIST: "প্লেয়ার তালিকা",
  T_46_META_WS_P_PLAYERNAME: "খেলোয়াড়ের নাম",
  T_46_META_WS_P_PLAYERRANK: "প্লেয়ার র্যাঙ্ক",
  T_46_META_WS_P_PLAYERRANKS: "খেলোয়াড়ের র‌্যাংক",
  T_46_META_WS_P_PLAYERS: "খেলোয়াড়",
  T_46_META_WS_P_PLAYERSCORETYPES: "খেলোয়াড় স্কোর প্রকার",
  T_46_META_WS_P_PLAYERSPEEDFACTOR: "খেলোয়াড়ের গতি ফ্যাক্টর",
  T_46_META_WS_P_PLAYERSPEEDFACTORWHILEFIRING: "আক্রমণ করার সময় খেলোয়াড়ের গতি ফ্যাক্টর",
  T_46_META_WS_P_PLAYERSTATUS: "খেলোয়াড়ের অবস্থা",
  T_46_META_WS_P_PLAYERTRACTIONSPEED: "খেলোয়াড়ের টানের গতি",
  T_46_META_WS_P_PLAYINGSTATUS: "প্লে স্টেটাস",
  T_46_META_WS_P_PLAYSPEED: "প্লে গতি",
  T_46_META_WS_P_POINTPOSITION: "পয়েন্টের অবস্থান",
  T_46_META_WS_P_POINTS: "পয়েন্ট",
  T_46_META_WS_P_POSITION: "অবস্থান",
  T_46_META_WS_P_PREFABID: "প্রিফ্যাব আইডি",
  T_46_META_WS_P_PRESSEDCOLOR: "প্রেসড রং",
  T_46_META_WS_P_PRESSEDSPRITE: "প্রেসড স্প্রাইট",
  T_46_META_WS_P_PRESSEDSPRITETYPE: "প্রেসড স্প্রাইট টাইপ",
  T_46_META_WS_P_PRICE: "মূল্য",
  T_46_META_WS_P_PRIORITY: "অগ্রাধিকার",
  T_46_META_WS_P_PROFILEINFO: "প্রোফাইল তথ্য",
  T_46_META_WS_P_PROGRESS: "প্রগ্রেস [0,1]",
  T_46_META_WS_P_PROGRESSICON: "অগ্রগতি আইকন",
  T_46_META_WS_P_PROGRESSICONNAME: "অগ্রগতি আইকন নাম",
  T_46_META_WS_P_PROPID: "প্রোপ আইডি",
  T_46_META_WS_P_PURCHASELIMIT: "কেনার সীমা",
  T_46_META_WS_P_RADIUS: "রেডিয়াস",
  T_46_META_WS_P_RANGE: "পরিসর",
  T_46_META_WS_P_RANK: "র‌্যাংক",
  T_46_META_WS_P_RATIOSELFFACTOR: "স্ব-ক্ষতির অনুপাত",
  T_46_META_WS_P_RATIOTEAMMATEFACTOR: "সহকর্মী ক্ষতির অনুপাত",
  T_46_META_WS_P_RATIOVEHICLEFACTOR: "যানবাহন ক্ষতির অনুপাত",
  T_46_META_WS_P_REFRESHTIME: "বাফ রিফ্রেশ সময় (সেকেন্ড)",
  T_46_META_WS_P_RELOADSPEED: "পুনরায় লোডের গতি",
  T_46_META_WS_P_RELOADSPEEDFACTOR: "রিলোড গতি ফ্যাক্টর",
  T_46_META_WS_P_REMAINJUMPCOUNT: "অবশিষ্ট লাফের সংখ্যা",
  T_46_META_WS_P_REMAINQUANTITY: "অবশিষ্ট পরিমাণ",
  T_46_META_WS_P_RENDERTYPE: "রেন্ডার টাইপ",
  T_46_META_WS_P_REPEATTIMES: "পুনরাবৃত্তির সংখ্যা",
  T_46_META_WS_P_REPLACEMENTPRIORITY: "প্রতিস্থাপনের অগ্রাধিকার",
  T_46_META_WS_P_REQUESTEDITEMLIST: "ট্রিগার প্লেয়ার আইডি",
  T_46_META_WS_P_REQUESTTYPE: "অনুরোধ করা আইটেম তালিকা",
  T_46_META_WS_P_RESETPERROUND: "প্রতি রাউন্ড রিসেট",
  T_46_META_WS_P_RESETPOSITION: "রিসেট অবস্থান",
  T_46_META_WS_P_RESETTIME: "রিসেট সময়",
  T_46_META_WS_P_RESOURCE: "রিসোর্স",
  T_46_META_WS_P_RESOURCEID: "রিসোর্স আইডি",
  T_46_META_WS_P_RESTRICTWITHINPANEL: "প্যানেল ভিতরে সীমিত",
  T_46_META_WS_P_RESULT: "ফলাফল",
  T_46_META_WS_P_RESULTTYPE: "ফলাফলের প্রকার",
  T_46_META_WS_P_REVIVALPOINT: "পুনর্জন্ম পয়েন্ট",
  T_46_META_WS_P_REVIVECD: "পুনরুদ্ধারের সময়",
  T_46_META_WS_P_RIGHT: "ডান",
  T_46_META_WS_P_RIGHTARM: "ডান হাত",
  T_46_META_WS_P_RIGHTBACKGROUNDCOLOR: "ডানের পটভূমির রঙ",
  T_46_META_WS_P_RIGHTCOLOR: "ডানপাশের রঙ",
  T_46_META_WS_P_RIGHTDESCRIPTION: "ডানপাশের বর্ণনা",
  T_46_META_WS_P_RIGHTEFFECTACTIVE: "ডান পাশের প্রভাব সক্রিয়",
  T_46_META_WS_P_RIGHTFIRINGARCANGLE: "ডান দিকের ফায়ারিং আর্ক কোণ",
  T_46_META_WS_P_RIGHTFOOT: "ডান পায়ের পাতার নিচে",
  T_46_META_WS_P_RIGHTHAND: "ডান হাতের তালু",
  T_46_META_WS_P_RIGHTICON: "ডান আইকন",
  T_46_META_WS_P_RIGHTICONNAME: "ডানের আইকনের নাম",
  T_46_META_WS_P_RIGHTLEG: "ডান পা",
  T_46_META_WS_P_RIGHTPLAYERS: "ডান খেলোয়াড়",
  T_46_META_WS_P_RIGHTSCORE: "ডান স্কোর",
  T_46_META_WS_P_RIGHTSCOREAFTER: "ডান চূড়ান্ত স্কোর",
  T_46_META_WS_P_RIGHTSCORETEXT: "ডান স্কোর",
  T_46_META_WS_P_RIGHTTEAM: "শিরোনাম",
  T_46_META_WS_P_RIGHTTEAMINDEX: "ডান দলের সূচক",
  T_46_META_WS_P_RIGHTTEAMMATEALIVENUM: "ডান দলের বেঁচে থাকা সংখ্যা",
  T_46_META_WS_P_RIGHTTEAMMATEFLAGCOUNT: "ডানদিকের সহকর্মীর পতাকা সংখ্যা",
  T_46_META_WS_P_RIGHTTEAMMATESTATES: "ডানপাশের দলের সদস্যদের অবস্থা",
  T_46_META_WS_P_RIGHTTEAMNAME: "ডানপাশের দলের নাম",
  T_46_META_WS_P_RIGHTTEAMSCORE: "ডানপাশের দলের স্কোর",
  T_46_META_WS_P_RIGHTTEXT: "ডান টেক্সট",
  T_46_META_WS_P_RIMALPHA: "রিম আলফা",
  T_46_META_WS_P_RIMCOLOR: "রিম রঙ",
  T_46_META_WS_P_RIMTEXTURE: "রিম টেক্সচার",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFF: "রোলিং ঘর্ষণ সহগ",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFFRUSHING: "তড়িঘড়ি ঘর্ষণ সহগ",
  T_46_META_WS_P_ROTATION: "ঘূর্ণন",
  T_46_META_WS_P_ROTATIONANGLE: "ঘূর্ণন কোণ",
  T_46_META_WS_P_ROTATIONQ: "রোটেশন কুয়াটার্নিয়ন",
  T_46_META_WS_P_ROUNDINCOME: "রাউন্ড আয়",
  T_46_META_WS_P_ROUNDINCOMEDETAILNUMS: "রাউন্ড আয়ের বিস্তারিত সংখ্যা",
  T_46_META_WS_P_ROUNDINCOMEDETAILTITLES: "রাউন্ড আয়ের বিস্তারিত শিরোনাম",
  T_46_META_WS_P_ROUNDINCOMETITLE: "রাউন্ড আয় শিরোনাম",
  T_46_META_WS_P_ROUNDNUM: "রাউন্ড নম্বর",
  T_46_META_WS_P_ROUNDNUMKEY: "রাউন্ড নম্বর কী",
  T_46_META_WS_P_ROUNDNUMLOCKEYPARAMS: "রাউন্ড নম্বর লোক্যাল কী প্যারামিটার",
  T_46_META_WS_P_RUNSPEED: "চলাচলের গতি",
  T_46_META_WS_P_RUNSPEEDSCALE: "চলমান গতির স্কেল",
  T_46_META_WS_P_RUSHDISTANCE: "রাশ দূরত্ব",
  T_46_META_WS_P_RUSHENERGYCOST: "রাশ শক্তির খরচ",
  T_46_META_WS_P_RUSHVERTICALSPEED: "রাশ উল্লম্ব গতি",
  T_46_META_WS_P_SCALE: "স্কেল",
  T_46_META_WS_P_SCATTERINCREASESPEED: "স্ক্যাটার বৃদ্ধির গতি",
  T_46_META_WS_P_SCATTERMAX: "সর্বাধিক স্ক্যাটার",
  T_46_META_WS_P_SCATTERMULTIPLIERWHILEMOVING: "চলার সময় স্ক্যাটার মাল্টিপ্লায়ার",
  T_46_META_WS_P_SCATTERRECOVERSPEED: "স্ক্যাটার পুনরুদ্ধারের গতি",
  T_46_META_WS_P_SCATTERSPEED: "স্ক্যাটার গতি",
  T_46_META_WS_P_SCATTERSPEEDCROUCHPRONE: "স্ক্যাটার গতি যখন ঝুঁকে বসা বা শোয়া",
  T_46_META_WS_P_SCATTERTHRESHOLD: "স্ক্যাটার থ্রেশহোল্ড",
  T_46_META_WS_P_SCOPETYPE: "স্কোপ প্রকার",
  T_46_META_WS_P_SCORE: "স্কোর",
  T_46_META_WS_P_SCORES1: "পয়েন্ট তালিকা 1",
  T_46_META_WS_P_SCORES2: "পয়েন্ট তালিকা 2",
  T_46_META_WS_P_SCORES3: "পয়েন্ট তালিকা 3",
  T_46_META_WS_P_SCORES4: "স্কোর তালিকা 4",
  T_46_META_WS_P_SCORES5: "স্কোর তালিকা 5",
  T_46_META_WS_P_SCORETEXTKEY: "স্কোর টেক্সট কী",
  T_46_META_WS_P_SCORETEXTKEYPARAMS: "স্কোর টেক্সট কী প্যারামিটার",
  T_46_META_WS_P_SCROLLCONTINUITY: "স্ক্রল কন্টিনিউটি",
  T_46_META_WS_P_SCROLLDIRECTION: "স্ক্রল দিক",
  T_46_META_WS_P_SCROLLEFFECT: "স্ক্রল ইফেক্ট",
  T_46_META_WS_P_SCROLLWHEELSPEED: "স্ক্রল হুইল স্পিড",
  T_46_META_WS_P_SECONDSCORETITLE: "দ্বিতীয় স্কোর শিরোনাম",
  T_46_META_WS_P_SECONDSCOREVALUE: "দ্বিতীয় স্কোর মান",
  T_46_META_WS_P_SECONDSCOREVALUEPARAMS: "দ্বিতীয় স্কোর প্যারামিটার",
  T_46_META_WS_P_SELECTEDCOLOR: "নির্বাচিত রং",
  T_46_META_WS_P_SELECTEDINDEX: "নির্বাচিত সূচক",
  T_46_META_WS_P_SELECTEDSPRITE: "নির্বাচিত স্প্রাইট",
  T_46_META_WS_P_SELECTEDTYPE: "নির্বাচিত টাইপ",
  T_46_META_WS_P_SELF: "নিজ",
  T_46_META_WS_P_SELFDAMAGEFACTOR: "স্ব-ক্ষতি ফ্যাক্টর",
  T_46_META_WS_P_SET: "সেট",
  T_46_META_WS_P_SHADERNAME: "শেডার নাম",
  T_46_META_WS_P_SHADOWCOLOR: "ছায়া রং",
  T_46_META_WS_P_SHADOWOFFSET: "ছায়া অফসেট",
  T_46_META_WS_P_SHADOWSTRENGTH: "ছায়া শক্তি",
  T_46_META_WS_P_SHELFS: "ম্যানুয়াল বন্ধ নিষ্ক্রিয়",
  T_46_META_WS_P_SHOES: "জুতো",
  T_46_META_WS_P_SHOOTANGLEMAX: "সর্বাধিক শুটিং কোণ",
  T_46_META_WS_P_SHOOTANGLEMIN: "সর্বনিম্ন শুটিং কোণ",
  T_46_META_WS_P_SHOP: "দোকান",
  T_46_META_WS_P_SHOPITEMS: "শেলফ",
  T_46_META_WS_P_SHOWADDFRIEND: "বন্ধু যোগ করুন দেখান",
  T_46_META_WS_P_SHOWATTACKGRENADE: "আক্রমণ গ্রেনেড দেখান",
  T_46_META_WS_P_SHOWBACKGROUND: "পটভূমি দেখান",
  T_46_META_WS_P_SHOWCROUCH: "বসা দেখান",
  T_46_META_WS_P_SHOWDAMAGENUMBER: "ক্ষতি সংখ্যা প্রদর্শন",
  T_46_META_WS_P_SHOWDEFENCEGRENADE: "প্রতিরক্ষা গ্রেনেড দেখান",
  T_46_META_WS_P_SHOWECCONOMY: "অর্থনীতি দেখান",
  T_46_META_WS_P_SHOWECONOMY: "অর্থনীতি দেখান",
  T_46_META_WS_P_SHOWFIRE: "আগুন দেখান",
  T_46_META_WS_P_SHOWFRAME: "ফ্রেম দেখান",
  T_46_META_WS_P_SHOWGIFT: "উপহার দেখান",
  T_46_META_WS_P_SHOWHITPOINTEFFECT: "আঘাতের পয়েন্টের প্রভাব দেখান",
  T_46_META_WS_P_SHOWJUMP: "লাফ দেখান",
  T_46_META_WS_P_SHOWLIKE: "লাইক দেখান",
  T_46_META_WS_P_SHOWLOBBY: "লবি দেখান",
  T_46_META_WS_P_SHOWMAPEVALUATE: "মানচিত্র মূল্যায়ন দেখান",
  T_46_META_WS_P_SHOWMATCHDETAIL: "ম্যাচের বিস্তারিত দেখান",
  T_46_META_WS_P_SHOWMOVINGJOYSTICK: "মুভিং জয়স্টিক দেখান",
  T_46_META_WS_P_SHOWNAME: "নিকনেম দেখান",
  T_46_META_WS_P_SHOWPIN: "পিন দেখান",
  T_46_META_WS_P_SHOWPRONE: "শো প্রোণ",
  T_46_META_WS_P_SHOWRANK: "র‌্যাংক দেখান",
  T_46_META_WS_P_SHOWREPLAY: "পুনঃপ্লে দেখান",
  T_46_META_WS_P_SHOWREPORT: "প্রতিবেদন দেখান",
  T_46_META_WS_P_SHOWSHARE: "শেয়ার দেখান",
  T_46_META_WS_P_SHOWSPRINT: "স্প্রিন্ট দেখান",
  T_46_META_WS_P_SHOWTAG: "ট্যাগ প্রদর্শন করুন",
  T_46_META_WS_P_SHOWTEAMMATESINFO: "সহকর্মী তথ্য দেখান",
  T_46_META_WS_P_SHOWTEAMMATESTATE: "দলের সদস্যদের অবস্থা প্রদর্শন করুন",
  T_46_META_WS_P_SHOWTEAMSCORE: "দলের স্কোর প্রদর্শন করুন",
  T_46_META_WS_P_SHOWTIMETYPE: "সময়ের ধরন প্রদর্শন করুন",
  T_46_META_WS_P_SHOWTWOTEAMSCORE: "দুই দলের স্কোর প্রদর্শন করুন",
  T_46_META_WS_P_SHRINKDURATION: "সংকুচিত সময় (ms)",
  T_46_META_WS_P_SHRINKENDTIME: "সংকুচিত শেষ সময় (ms)",
  T_46_META_WS_P_SHRINKSPEED: "একত্রীকরণের হার",
  T_46_META_WS_P_SHRINKSTARTTIME: "সংকুচিত শুরু সময় (s)",
  T_46_META_WS_P_SIGHTAIMASSIST: "ADS লক্ষ্য সহায়তা অনুমোদন করুন",
  T_46_META_WS_P_SIGHTAIMASSISTDISTFALLOFF: "লক্ষ্য সহায়তার দূরত্ব ক্ষয় সহগ (0-1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOCOEF: "লক্ষ্য সহায়তার দূরত্ব প্রভাব সহগ (>=1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMAX: "লক্ষ্য সহায়তার জন্য সর্বাধিক দূরত্ব অগ্রাধিকার",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMIN: "লক্ষ্য সহায়তার জন্য সর্বনিম্ন দূরত্ব অগ্রাধিকার",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIORITY: "লক্ষ্য সহায়তার দূরত্ব প্রথমে অনুমোদন করুন",
  T_46_META_WS_P_SIGHTAIMASSISTSNAPRANGE: "লক্ষ্য সহায়তা ক্রসহেয়ারের স্ক্রীন আকর্ষণ অনুপাত (0-1)",
  T_46_META_WS_P_SIGHTAMPLIFYRATIO: "দৃষ্টির প্রশস্ততার গুণক",
  T_46_META_WS_P_SIGHTFOVAMPLIFYRATIO: "FOV বৃদ্ধি",
  T_46_META_WS_P_SIGHTROTSENSITIVENESS: "ADS ঘূর্ণন সংবেদনশীলতা",
  T_46_META_WS_P_SIGHTSHOOTMINDAMAGE: "ADS সর্বনিম্ন ক্ষতির দূরত্ব সংশোধন সহগ",
  T_46_META_WS_P_SIGHTUIACTIONEXPAND: "ADS বৃদ্ধির সময় (সেকেন্ড)",
  T_46_META_WS_P_SIGHTUIACTIONRATIO: "ADS বৃদ্ধির হার",
  T_46_META_WS_P_SIGHTUIACTIONRECOVERY: "ADS পুনরুদ্ধারের সময় (সেকেন্ড)",
  T_46_META_WS_P_SIZE: "আকার",
  T_46_META_WS_P_SIZEDELTA: "আকার ডেল্টা",
  T_46_META_WS_P_SKELETON: "হাড়",
  T_46_META_WS_P_SKIN: "جلد",
  T_46_META_WS_P_SKINID: "স্কিন আইডি",
  T_46_META_WS_P_SKINWIDTH: "স্কিন উইথ",
  T_46_META_WS_P_SKYBOXENV: "আকাশের বক্স",
  T_46_META_WS_P_SKYBOXRESOURCE: "Skybox সম্পদ",
  T_46_META_WS_P_SLOPELIMIT: "স্লোপ লিমিট",
  T_46_META_WS_P_SMOOTHSCROLLSTART: "মসৃণ স্ক্রল শুরু",
  T_46_META_WS_P_SOFTNESS: "নরমতা",
  T_46_META_WS_P_SORTTYPE: "সর্ট টাইপ",
  T_46_META_WS_P_SPAWNCOUNTPERWAVE: "প্রতি তরঙ্গের স্পন সংখ্যা",
  T_46_META_WS_P_SPAWNPOINT: "পুনরুত্পন্ন পয়েন্ট",
  T_46_META_WS_P_SPAWNPOINTCOUNT: "স্পন পয়েন্ট সংখ্যা",
  T_46_META_WS_P_SPAWNPOSITION: "স্পন অবস্থান",
  T_46_META_WS_P_SPEED: "গতি",
  T_46_META_WS_P_SPEEDWHILEAIMING: "एडीएस गति दर",
  T_46_META_WS_P_SPRAYCOLOR: "স্প্রে রঙ",
  T_46_META_WS_P_SPRINTENERGYCOST: "স্প্রিন্ট শক্তির খরচ",
  T_46_META_WS_P_SPRINTHORIZONTALSPEED: "স্প্রিন্ট অনুভূমিক গতি",
  T_46_META_WS_P_SPRINTSPEEDSCALE: "দৌড়ানোর সময় গতি স্কেল",
  T_46_META_WS_P_SPRITENAME: "স্প্রাইট আকার",
  T_46_META_WS_P_SPRITERESOURCE: "স্প্রাইট রিসোর্স",
  T_46_META_WS_P_SRCVAL: "উৎস মান",
  T_46_META_WS_P_STARTDROPTIME: "ড্রপ শুরু সময় (ms)",
  T_46_META_WS_P_STARTEVENT: "ইভেন্ট শুরু করুন",
  T_46_META_WS_P_STARTPOSITION: "শুরু অবস্থান",
  T_46_META_WS_P_STARTRADIUS: "শুরু ব্যাসার্ধ",
  T_46_META_WS_P_STARTSPAWNTIME: "স্পন শুরু সময় (সেকেন্ড)",
  T_46_META_WS_P_STARTTIME: "শুরু সময়",
  T_46_META_WS_P_STARTVALUE: "শুরু মান",
  T_46_META_WS_P_STATICICONCOLORS: "স্ট্যাটিক আইকনের রঙ",
  T_46_META_WS_P_STATICICONS: "স্ট্যাটিক আইকন",
  T_46_META_WS_P_STATUS: "মিনি সেন্ত্রি অবস্থান",
  T_46_META_WS_P_STEPOFFSET: "স্টেপ অফসেট",
  T_46_META_WS_P_STOPDURATION: "থামানোর সময়কাল",
  T_46_META_WS_P_STOPEVENT: "ইভেন্ট বন্ধ করুন",
  T_46_META_WS_P_STORE: "দোকান",
  T_46_META_WS_P_STROPID: "স্ট্রপ আইডি",
  T_46_META_WS_P_STYLE: "স্টাইল",
  T_46_META_WS_P_SUBTITLE: "সাবটাইটেল",
  T_46_META_WS_P_SUMMULTIPLIER: "সমমাল্টিপ্লায়ার",
  T_46_META_WS_P_SWINGEXITACCELERATION: "দোল থেকে বের হওয়ার ত্বরণ",
  T_46_META_WS_P_SWINGINGSPEED: "দোলের গতি",
  T_46_META_WS_P_TAGS: "ট্যাগসমূহ",
  T_46_META_WS_P_TARGETCHECKPOINTID: "লক্ষ্য চেকপয়েন্ট আইডি",
  T_46_META_WS_P_TARGETICONCOLORS: "লক্ষ্য আইকনের রঙ",
  T_46_META_WS_P_TARGETICONS: "লক্ষ্য আইকন",
  T_46_META_WS_P_TARGETID: "লক্ষ্য আইডি",
  T_46_META_WS_P_TARGETITEMID: "লক্ষ্য আইটেম আইডি",
  T_46_META_WS_P_TARGETROTATION: "লক্ষ্য ঘূর্ণন",
  T_46_META_WS_P_TARGETSCALE: "লক্ষ্য স্কেল",
  T_46_META_WS_P_TEAMCOLOR: "দলের রঙ",
  T_46_META_WS_P_TEAMCOLORS: "দলের রঙ",
  T_46_META_WS_P_TEAMINDEXS: "দলের সূচক",
  T_46_META_WS_P_TEAMMATEDAMAGEFACTOR: "সহকর্মী ক্ষতি উপাদান",
  T_46_META_WS_P_TEAMMEMBERNUM: "দলের সদস্য সংখ্যা",
  T_46_META_WS_P_TEAMNUM: "দলের সংখ্যা",
  T_46_META_WS_P_TEAMRANK: "টিম র্যাঙ্ক",
  T_46_META_WS_P_TEAMRANKDISPLAY: "টিম র্যাঙ্ক প্রদর্শন",
  T_46_META_WS_P_TEAMRANKS: "দলের র‌্যাংক",
  T_46_META_WS_P_TEAMSCORES: "দলের স্কোর",
  T_46_META_WS_P_TEAMSEQ: "টিম সিকোয়েন্স",
  T_46_META_WS_P_TEMPLATEENTITY: "টেমপ্লেট এন্টিটি",
  T_46_META_WS_P_TEMPORARYSHIELDPOINTS: "অস্থায়ী শিল্ড পয়েন্ট",
  T_46_META_WS_P_TERRAINWETNESS: "ভূমি আর্দ্রতা",
  T_46_META_WS_P_TEXT: "টেক্সট",
  T_46_META_WS_P_TEXTCOLOR: "টেক্সটের রঙ",
  T_46_META_WS_P_TEXTKEY: "টেক্সট কী",
  T_46_META_WS_P_TEXTKEYPARAMS: "টেক্সট কী প্যারামিটার",
  T_46_META_WS_P_TEXTURERESOURCE: "টেক্সচার রিসোর্স",
  T_46_META_WS_P_THEMECOLOR: "থিম কালার",
  T_46_META_WS_P_THROWABLETYPE: "নিক্ষেপযোগ্য প্রকার",
  T_46_META_WS_P_THROWINGSPEED: "নিক্ষেপের গতি",
  T_46_META_WS_P_THROWSPEED: "নিক্ষেপের গতি",
  T_46_META_WS_P_TICKINTERVAL: "টিক ইন্টারভাল",
  T_46_META_WS_P_TIMEREQUIRED: "প্রয়োজনীয় সময় (মিলিসেকেন্ড)",
  T_46_META_WS_P_TIPSTYPE: "টিপস প্রকার",
  T_46_META_WS_P_TITLE: "শিরোনাম",
  T_46_META_WS_P_TITLELIST: "শিরোনাম",
  T_46_META_WS_P_TITLES: "স্কোর 1",
  T_46_META_WS_P_TOP: "শীর্ষ",
  T_46_META_WS_P_TOPALPHA: "শীর্ষ আলফা",
  T_46_META_WS_P_TOTALHP: "মোট HP",
  T_46_META_WS_P_TOTALLEVEL: "মোট স্তর",
  T_46_META_WS_P_TOTALROUNDCOUNT: "মোট রাউন্ড সংখ্যা",
  T_46_META_WS_P_TOWSPEED: "টানের গতি",
  T_46_META_WS_P_TRANSITIONSTAGE: "ট্রানজিশন স্তর",
  T_46_META_WS_P_TRANSITIONTYPE: "ট্রানজিশন টাইপ",
  T_46_META_WS_P_TRIGGERPLAYERID: "মুদ্রা",
  T_46_META_WS_P_TRIGGERRADIUS: "ট্রিগার পরিসীমা",
  T_46_META_WS_P_TRIGGERRANGE: "ট্রিগার পরিসর",
  T_46_META_WS_P_TRIGGERTIME: "ট্রিগার সময়",
  T_46_META_WS_P_TURNSPEED: "বাঁকানো গতি",
  T_46_META_WS_P_TWEENERENABLED: "বাম দল",
  T_46_META_WS_P_TWEENSTYLE: "টুইন স্টাইল",
  T_46_META_WS_P_TYPE: "প্রকার",
  T_46_META_WS_P_UNSELECTEDCOLOR: "অদৃষ্টিত রং",
  T_46_META_WS_P_UNSELECTEDSPRITE: "অদৃষ্টিত স্প্রাইট",
  T_46_META_WS_P_UNSELECTEDTYPE: "অদৃষ্টিত টাইপ",
  T_46_META_WS_P_UP: "উপরের",
  T_46_META_WS_P_UPDATETYPE: "আপডেট টাইপ",
  T_46_META_WS_P_UPENERGYCOST: "উপরের শক্তির খরচ",
  T_46_META_WS_P_UPSPEED: "উপরের দিকে গতি",
  T_46_META_WS_P_USECUSTOMPUSHFORCE: "কাস্টম পুশ ফোর্স ব্যবহার করুন",
  T_46_META_WS_P_USECUSTOMRESOURCE: "কাস্টম রিসোর্স ব্যবহার করুন",
  T_46_META_WS_P_USEDCAPACITY: "ব্যবহৃত ক্ষমতা",
  T_46_META_WS_P_USEGRAVITY: "গ্রাভিটি ব্যবহার করুন",
  T_46_META_WS_P_USEPHYSICALCCT: "ফিজিক্যাল CCT ব্যবহার করুন",
  T_46_META_WS_P_USERUID: "ব্যবহারকারী UID",
  T_46_META_WS_P_UVOFFSET: "UV অফসেট",
  T_46_META_WS_P_UVSIZE: "UV সাইজ",
  T_46_META_WS_P_VALUE: "মান",
  T_46_META_WS_P_VAULTDISTANCE: "পার্কলিং দূরত্ব",
  T_46_META_WS_P_VAULTHEIGHT: "পার্কলিং উচ্চতা",
  T_46_META_WS_P_VEHICLEDAMAGEFACTOR: "যানবাহন ক্ষতি উপাদান",
  T_46_META_WS_P_VEHICLESKINID: "গাড়ির স্কিন আইডি",
  T_46_META_WS_P_VEHICLESKINIDS: "যানবাহনের স্কিন আইডি",
  T_46_META_WS_P_VELOCITY: "গতিবেগ (m/s)",
  T_46_META_WS_P_VELOCITYXZ: "ভেলোসিটি XZ",
  T_46_META_WS_P_VELOCITYY: "ভেলোসিটি Y",
  T_46_META_WS_P_VERTICALBAR: "উল্লম্ব বার",
  T_46_META_WS_P_VERTICALOFFSET: "উল্লম্ব অফসেট",
  T_46_META_WS_P_VEST: "বুলেটপ্রুফ ভেস্ট",
  T_46_META_WS_P_VFXTEXTURETYPE: "VFX টেক্সচার টাইপ",
  T_46_META_WS_P_VIEWINGANGLERESTRICTION: "দর্শন কোণ সীমাবদ্ধতা",
  T_46_META_WS_P_VISIBILITYLAYER: "দৃশ্যমান স্তর",
  T_46_META_WS_P_VISIBLE: "দৃশ্যমান",
  T_46_META_WS_P_VISIBLEONBACK: "পিঠে দৃশ্যমান",
  T_46_META_WS_P_VISIBLEPLAYERS: "দৃশ্যমান খেলোয়াড়",
  T_46_META_WS_P_VOLUME: "ভলিউম",
  T_46_META_WS_P_WALLETID: "ওয়ালেট আইডি",
  T_46_META_WS_P_WANDERRANGE: "ভ্রমণের পরিসীমা",
  T_46_META_WS_P_WAVECOUNT: "ঢেউয়ের সংখ্যা",
  T_46_META_WS_P_WAVEINTERVAL: "ঢেউয়ের মধ্যবর্তী সময়",
  T_46_META_WS_P_WEAPONDAMAGERATE: "অস্ত্রের ক্ষতি হারে",
  T_46_META_WS_P_WEAPONSKINIDS: "অস্ত্রের স্কিন আইডি",
  T_46_META_WS_P_WEAPONSUBTYPE: "অস্ত্র উপ প্রকার",
  T_46_META_WS_P_WEAPONTYPE: "অস্ত্রের প্রকার",
  T_46_META_WS_P_WIDTH: "প্রস্থ",
  T_46_META_WS_P_WINMVPS: "বিজয়ী MVP তালিকা",
  T_46_META_WS_P_WINTEXT: "বিজয়ের টেক্সট",
  T_46_META_WS_P_WORDWRAP: "ওয়ার্ড ওয়ার্প",
  T_46_META_WS_P_WORLDPOSITION: "বিশ্ব অবস্থান",
  T_46_META_WS_P_YAW: "ইয়াও",
  T_46_META_WS_PATROLALONG: "পেট্রল বরাবর",
  T_46_META_WS_PATROLTO: "পেট্রল করতে যান",
  T_46_META_WS_PAUSE: "বিরতি",
  T_46_META_WS_PAUSEEMOTE: "ইমোট বিরাম দিন",
  T_46_META_WS_PAUSEFIXEDUPDATE: "স্থির আপডেট বন্ধ করুন",
  T_46_META_WS_PHASE: "পর্যায়",
  T_46_META_WS_PLAY: "চালান",
  T_46_META_WS_PLAYANIMATION: "অ্যানিমেশন প্লে করুন",
  T_46_META_WS_PLAYCHARACTERANIMATIONCLIP: "চরিত্র অ্যানিমেশন ক্লিপ প্লে করুন",
  T_46_META_WS_PLAYEMOTE: "ইমোট খেলান",
  T_46_META_WS_PLAYER: "খেলোয়াড়",
  T_46_META_WS_PORTAL: "পোর্টাল",
  T_46_META_WS_POSE: "অঙ্গভঙ্গি",
  T_46_META_WS_POSITION: "অবস্থান",
  T_46_META_WS_PREPOSE: "পূর্বের অঙ্গভঙ্গি ",
  T_46_META_WS_PROFANITYFILTER: "অশ্লীলতা ফিল্টার",
  T_46_META_WS_PURSUITTARGET: "অনুসরণ লক্ষ্য",
  T_46_META_WS_QUATERNIONTOAXISANGLE: "কুয়ার্নিয়নকে অক্ষ কোণে রূপান্তরিত করুন",
  T_46_META_WS_QUATERNIONTOEULERANGLE: "কুয়ার্নিয়নকে ইউলার কোণে রূপান্তরিত করুন",
  T_46_META_WS_QUITCHATCHANNEL: "চ্যাট চ্যানেল থেকে বের হন",
  T_46_META_WS_QUITFACTION: "গোষ্ঠী ত্যাগ করুন",
  T_46_META_WS_QUITGAME: "গেম ছাড়ুন",
  T_46_META_WS_QUITJAILBREAKMINIGAME: "কারাগার ভাঙার মিনি গেম ছাড়ুন",
  T_46_META_WS_RANDOMFLOAT: "র্যান্ডম ভাসমান সংখ্যা",
  T_46_META_WS_RANDOMINT: "র্যান্ডম পূর্ণসংখ্যা",
  T_46_META_WS_RANK: "ক্রম",
  T_46_META_WS_READCSV: "CSV পড়ুন",
  T_46_META_WS_READCSVCELL: "CSV সেলের বিষয়বস্তু পড়ুন",
  T_46_META_WS_READCSVCELLBYNAME: "সারি এবং কলাম নাম দ্বারা CSV সেল পড়ুন",
  T_46_META_WS_READCSVCELLFROMSERVER: "সার্ভার থেকে CSV সেল পড়ুন",
  T_46_META_WS_READCSVCOLUMN: "CSV এর কলাম পড়ুন",
  T_46_META_WS_READCSVCOLUMNFROMSERVER: "সার্ভার থেকে CSV কলাম পড়ুন",
  T_46_META_WS_READCSVFROMSERVER: "সার্ভার থেকে CSV পড়ুন",
  T_46_META_WS_READCSVROW: "CSV এর সারি পড়ুন",
  T_46_META_WS_READCSVROWBYKEY: "কী দ্বারা CSV সারি পড়ুন",
  T_46_META_WS_READCSVROWFROMSERVER: "সার্ভার থেকে CSV সারি পড়ুন",
  T_46_META_WS_READFROMACCUMULATEDDATASTORE: "জমাকৃত ডেটাবেস থেকে পড়ুন",
  T_46_META_WS_READFROMDATASTORE: "ডেটাবেস টেবিল মান পড়ুন",
  T_46_META_WS_READFROMLEADBOARDDATASTORE: "লিডবোর্ড ডেটাবেস থেকে পড়ুন",
  T_46_META_WS_READFROMLEADBOARDDATASTOREBYRANK: "র‌্যাঙ্ক দ্বারা লিডবোর্ড ডেটাবেস থেকে পড়ুন",
  T_46_META_WS_REMOVEAOISPECIALFOLLOW: "AOI বিশেষ অনুসরণ অপসারণ করুন",
  T_46_META_WS_REMOVEBACKPACKSKIN: "ব্যাকপ্যাক স্কিন অপসারণ করুন",
  T_46_META_WS_REMOVEBUFF: "বাফ অপসারণ করুন",
  T_46_META_WS_REMOVECOMPONENT: "উপাদান সরান",
  T_46_META_WS_REMOVEFORMULAPROPERTYFACTOR: "সূত্র বৈশিষ্ট্য ফ্যাক্টর মুছুন",
  T_46_META_WS_REMOVEOUTFIT: "পোশাক অপসারণ করুন",
  T_46_META_WS_REMOVESCRIPT: "স্ক্রিপ্ট সরান",
  T_46_META_WS_REMOVEVEHICLESKIN: "যানবাহনের স্কিন অপসারণ করুন",
  T_46_META_WS_REMOVEWEAPONSKIN: "অস্ত্রের স্কিন অপসারণ করুন",
  T_46_META_WS_REPLACE: "প্রতিস্থাপন করুন",
  T_46_META_WS_REQUESTMATCHMAKING: "ম্যাচমেকিং অনুরোধ করুন",
  T_46_META_WS_RESET: "রিসেট করুন",
  T_46_META_WS_RESETBACKPACKSKIN: "ব্যাকপ্যাক স্কিন পুনরায় সেট করুন",
  T_46_META_WS_RESETDYEING: "রঙ পুনরায় সেট করুন",
  T_46_META_WS_RESETJERSEY: "জার্সি রিসেট করুন",
  T_46_META_WS_RESETOUTFIT: "পোশাক পুনরায় সেট করুন",
  T_46_META_WS_RESETVEHICLESKIN: "যানবাহনের স্কিন পুনরায় সেট করুন",
  T_46_META_WS_RESETWEAPONSKIN: "অস্ত্রের স্কিন পুনরায় সেট করুন",
  T_46_META_WS_RESUMEFIXEDUPDATE: "স্থির আপডেট পুনরায় শুরু করুন",
  T_46_META_WS_REVERSE: "উলটান",
  T_46_META_WS_REVIVALSOURCE: "পুনর্জীবনের উৎস",
  T_46_META_WS_REVIVE: "পুনরায় জীবিত করুন",
  T_46_META_WS_ROUND: "গোলাকৃতি",
  T_46_META_WS_ROUNDINDEX: "রাউন্ড সূচক",
  T_46_META_WS_SAMPLEONCURVE: "কার্ভে নমুনা নিন",
  T_46_META_WS_SCENENAME: "দৃশ্যের নাম",
  T_46_META_WS_SCORE: "স্কোর",
  T_46_META_WS_SCORER: "গোলদাতা",
  T_46_META_WS_SCORETYPE: "স্কোরের ধরন",
  T_46_META_WS_SCREENMULTIRAYCAST: "স্ক্রীন মাল্টি-রেকাস্ট",
  T_46_META_WS_SCREENSINGLERAYCAST: "স্ক্রীন সিঙ্গেল রে-কাস্ট",
  T_46_META_WS_SCREENTOUCHRAY: "স্ক্রীন টাচ রে",
  T_46_META_WS_SCREENTOWORLDPOINT: "স্ক্রীন থেকে বিশ্বে",
  T_46_META_WS_SENDEVENT: "ইভেন্ট পাঠান",
  T_46_META_WS_SETACTIVE: "সক্রিয় সেট করুন",
  T_46_META_WS_SETALLPLAYERSMOVESTATUS: "সমস্ত খেলোয়াড়ের চলমান স্থিতি সেট করুন",
  T_46_META_WS_SETATTACKABLEENTITY: "আক্রমণযোগ্য সত্তা সেট করুন",
  T_46_META_WS_SETATTACKABLEFACTION: "আক্রমণযোগ্য গোষ্ঠী সেট করুন",
  T_46_META_WS_SETATTACKABLETEAM: "আক্রমণযোগ্য টিম সেট করুন",
  T_46_META_WS_SETBACKPACKSKIN: "ব্যাকপ্যাক স্কিন সেট করুন",
  T_46_META_WS_SETBEHAVIORSTATUS: "আচরণ স্থিতি সেট করুন",
  T_46_META_WS_SETBLACKBOARDVALUE: "ব্ল্যাকবোর্ড মান সেট করুন",
  T_46_META_WS_SETBUNDLE: "Bundle সেট করুন",
  T_46_META_WS_SETCAMERAFOCUS: "ক্যামেরার ফোকাস সেট করুন",
  T_46_META_WS_SETCAMERAFOLLOW: "ক্যামেরা অনুসরণ সেট করুন",
  T_46_META_WS_SETCHARACTER: "চরিত্র সেট করুন",
  T_46_META_WS_SETCULLINGMASK: "কলিং মাস্ক সেট করুন",
  T_46_META_WS_SETCULLINGMASKLAYER: "কলিং মাস্ক লেয়ার সেট করুন",
  T_46_META_WS_SETDEFAULTUISTATUS: "ডিফল্ট UI অবস্থা সেট করুন",
  T_46_META_WS_SETDROPSTATUS: "ড্রপ অবস্থা সেট করুন",
  T_46_META_WS_SETFALLINGDAMAGE: "পতনের ক্ষতি সেট করুন",
  T_46_META_WS_SETFOOTBALLPOSITION: "ফুটবল অবস্থান সেট করুন",
  T_46_META_WS_SETFORMULAPROPERTYABSOLUTE: "সূত্র বৈশিষ্ট্য একক সেট করুন",
  T_46_META_WS_SETFORMULAPROPERTYRELATIVE: "সূত্র বৈশিষ্ট্য আপেক্ষিক সেট করুন",
  T_46_META_WS_SETFORWARD: "অগ্রভাগ সেট করুন",
  T_46_META_WS_SETGLOBALSLEEPTHRESHOLD: "বৈশ্বিক ঘুমের থ্রেশহোল্ড সেট করুন",
  T_46_META_WS_SETINVINCIBILITY: "অদম্য অবস্থা সেট করুন",
  T_46_META_WS_SETJERSEY: "জার্সি সেট করুন",
  T_46_META_WS_SETOUTFIT: "পোশাক সেট করুন",
  T_46_META_WS_SETPARENT: "পিতা-মাতা সেট করুন",
  T_46_META_WS_SETPARENTCLIENT: "পিতৃকে সেট করুন",
  T_46_META_WS_SETPICKUPSTATUS: "পিকআপ অবস্থা সেট করুন",
  T_46_META_WS_SETPLAYERQUICKMESSAGESTATUS: "খেলোয়াড়ের দ্রুত বার্তা অবস্থা সেট করুন",
  T_46_META_WS_SETPLAYERVOICESTATUS: "খেলোয়াড়ের কণ্ঠস্থ অবস্থা সেট করুন",
  T_46_META_WS_SETPROPERTYSMOOTHLY: "মসৃণভাবে সম্পত্তি সেট করুন",
  T_46_META_WS_SETSKILLS: "দক্ষতা সেট করুন",
  T_46_META_WS_SETSKYBOX: "স্কাইবক্স সেট করুন",
  T_46_META_WS_SETSLEEPTHRESHOLD: "ঘুমের থ্রেশহোল্ড সেট করুন",
  T_46_META_WS_SETSPECIALITEMSTATUS: "বিশেষ আইটেমের স্থিতি সেট করুন",
  T_46_META_WS_SETVEHICLESKIN: "যানবাহনের স্কিন সেট করুন",
  T_46_META_WS_SETWEAPONSKIN: "অস্ত্রের স্কিন সেট করুন",
  T_46_META_WS_SETWIDGETPARENT: "উইজেটের পিতা-মাতা সেট করুন",
  T_46_META_WS_SHOPITEM: "দোকানের আইটেম",
  T_46_META_WS_SHOWAPPEARANCEGROUP: "চেহারা গ্রুপ দেখান",
  T_46_META_WS_SHUFFLE: "এলোমেলো করুন",
  T_46_META_WS_SIN: "Sin",
  T_46_META_WS_SINGLERAYCAST: "একক রে কাস্ট",
  T_46_META_WS_SKILL: "দক্ষতা",
  T_46_META_WS_SLEEP: "ঘুম",
  T_46_META_WS_SLERPQUATERNION: "কুয়াটারনিয়ন ইন্টারপোলেশন",
  T_46_META_WS_SPAWNABLES: "জন্মযোগ্য বস্তু",
  T_46_META_WS_SPAWNEDITEM: "জন্ম নেওয়া আইটেম",
  T_46_META_WS_SPAWNNEXTWAVE: "পরবর্তী তরঙ্গ তৈরি করুন",
  T_46_META_WS_SPHERECAST: "গোলক কাস্ট",
  T_46_META_WS_SPHEREOVERLAP: "গোলক ওভারল্যাপ",
  T_46_META_WS_SPLIT: "ভাগ করুন",
  T_46_META_WS_SQRT: "বর্গমূল",
  T_46_META_WS_STARTPARACHUTE: "প্যারাশুট শুরু করুন",
  T_46_META_WS_STARTPOSITION: "শুরুর অবস্থান",
  T_46_META_WS_STATENAME: "অবস্থার নাম",
  T_46_META_WS_STATUS: "অবস্থা",
  T_46_META_WS_STRINGTOFLOAT: "স্ট্রিং থেকে ফ্লোট",
  T_46_META_WS_STRINGTOINT: "স্ট্রিং থেকে পূর্ণসংখ্যা",
  T_46_META_WS_STRIP: "সাদা স্থান মুছুন",
  T_46_META_WS_SUB: "বিয়োগ করুন",
  T_46_META_WS_SWITCHAOIPROXYOBSERVER: "AOI প্রোক্সি অবজারভার পরিবর্তন করুন",
  T_46_META_WS_SWITCHAPPEARANCEGROUP: "চেহারা গ্রুপ পরিবর্তন করুন",
  T_46_META_WS_SWITCHAREA: "এলাকা পরিবর্তন করুন",
  T_46_META_WS_SWITCHCAMERA: "ক্যামেরা পরিবর্তন করুন",
  T_46_META_WS_SWITCHPHASE: "ধাপ পরিবর্তন করুন",
  T_46_META_WS_SWITCHSCENE: "দৃশ্য পরিবর্তন করুন",
  T_46_META_WS_SWITCHWEAPON: "অস্ত্র পরিবর্তন করুন",
  T_46_META_WS_TAN: "Tan",
  T_46_META_WS_TARGET: "লক্ষ্য",
  T_46_META_WS_TEAM: "দল",
  T_46_META_WS_TELEPORT: "টেলিপোর্ট",
  T_46_META_WS_TELEPORTCCT: "CCT টেলিপোর্ট করুন",
  T_46_META_WS_TEXT: "পাঠ্য",
  "T_46_META_WS_TIMESTAMPTO LOCALSTRING": "টাইমস্ট্যাম্পকে লোকালাইজেশন স্ট্রিংয়ে রূপান্তর করুন",
  T_46_META_WS_TIRE: "চাকা",
  T_46_META_WS_TOLOWER: "ছোট অক্ষরে পরিবর্তন করুন",
  T_46_META_WS_TOSTRING: "স্ট্রিং এ পরিবর্তন করুন",
  T_46_META_WS_TOUPPER: "বড় অক্ষরে পরিবর্তন করুন",
  T_46_META_WS_TRANSFERMONEY: "টাকা স্থানান্তর করুন",
  T_46_META_WS_TRIGGER: "ট্রিগার",
  T_46_META_WS_TYPEIS: "প্রকার কি",
  T_46_META_WS_UNLOADSCENE: "দৃশ্য আনলোড করুন",
  T_46_META_WS_UPDATEJAILBREAKMISSION: "কারাগার ভাঙার মিশন আপডেট করুন",
  T_46_META_WS_UPLOADGAMERESULT: "গেম ফলাফল আপলোড করুন",
  T_46_META_WS_VALUE: "ক্ষতি",
  T_46_META_WS_VECTOR2ANGLE: "2D ভেক্টর কোণ",
  T_46_META_WS_VECTOR2DISTANCE: "2D ভেক্টর দূরত্ব",
  T_46_META_WS_VECTOR2DOT: "2D ভেক্টর বিন্দু",
  T_46_META_WS_VECTOR2MAGNITUDE: "2D ভেক্টর মাপ",
  T_46_META_WS_VECTOR2NORMALIZE: "2D ভেক্টর স্বাভাবিকীকরণ",
  T_46_META_WS_VECTOR2REFLECT: "2D ভেক্টর প্রতিফলন",
  T_46_META_WS_VECTOR2TOVECTOR3: "2D ভেক্টরকে 3D ভেক্টরে রূপান্তরিত করুন",
  T_46_META_WS_VECTOR3REFLECT: "3D ভেক্টর প্রতিফলন",
  T_46_META_WS_VECTOR3TOVECTOR2: "3D ভেক্টরকে 2D ভেক্টরে রূপান্তরিত করুন",
  T_46_META_WS_VEHICLE: "যানবাহন",
  T_46_META_WS_VELOCITY: "গতিবেগ",
  T_46_META_WS_WAITFORMILESECOND: "মিলিসেকেন্ড অপেক্ষা করুন",
  T_46_META_WS_WAITFORNEXTFRAME: "পরবর্তী ফ্রেমের জন্য অপেক্ষা করুন",
  T_46_META_WS_WAKEUP: "জাগ্রত করুন",
  T_46_META_WS_WAVES: "তরঙ্গ",
  T_46_META_WS_WEAPON: "অস্ত্র",
  T_46_META_WS_WORLDTOSCREENPOINT: "বিশ্ব থেকে স্ক্রীনে",
  T_46_META_WS_WRITETOACCUMULATEDDATASTORE: "জমাকৃত ডেটাবেসে লিখুন",
  T_46_META_WS_WRITETODATASTORE: "ডেটাবেসে লিখুন",
  T_46_META_WS_WRITETOLEADBOARDDATASTORE: "লিডবোর্ড ডেটাবেসে লিখুন",
  T_48_META_API_1_D: "বর্তমান গেমের সমস্ত খেলোয়াড় পান এবং প্লেয়ার তালিকায় ফিরে যান।",
  T_48_META_API_1_R_D: "প্লেয়ার তালিকা",
  T_48_META_API_10_D: "দৃশ্য বস্তু পান",
  T_48_META_API_10_P0_D: "কি ধরনের দৃশ্য বস্তু ফিল্টার",
  T_48_META_API_10_R_D: "দৃশ্য অবজেক্ট তালিকা",
  T_48_META_API_100_D: "লোডিং দৃশ্যগুলি ইতিমধ্যে লোড করা দৃশ্যগুলি স্বয়ংক্রিয়ভাবে আনলোড করবে না৷",
  T_48_META_API_100_P0_D: "লোড করার জন্য দৃশ্য আইডি",
  T_48_META_API_10000_D: "বর্তমান স্ক্রিপ্টে আবদ্ধ সত্তা ফিরিয়ে দেয়",
  T_48_META_API_10000_R_D: "বর্তমান স্ক্রিপ্টে আবদ্ধ সত্তা",
  T_48_META_API_10001_D: "সংশ্লিষ্ট সত্তাটি খুঁজে পেতে সত্তা আইডি ব্যবহার করুন এই APIটি ব্যবহারকারীর পক্ষে ব্যবহার করা তার সামঞ্জস্যের গ্যারান্টি দিতে পারে না, যেমন সরানো বা সমন্বয়৷",
  T_48_META_API_10001_P0_D: "টার্গেট সত্তা আইডি",
  T_48_META_API_10001_R_D: "সত্তা",
  T_48_META_API_10002_D: "গেমটির বিশ্বব্যাপী সত্তা পান",
  T_48_META_API_10002_R_D: "বিশ্বব্যাপী সত্তা",
  T_48_META_API_10003_D: "প্লেয়ারকে নির্দিষ্ট স্থানাঙ্কে টেলিপোর্ট করুন (অপ্রচলিত, দয়া করে টেলিপোর্ট ব্যবহার করুন)",
  T_48_META_API_10003_P0_D: "টেলিপোর্টেড প্লেয়ার",
  T_48_META_API_10003_P1_D: "টেলিপোর্টেড পয়েন্টের স্থানাঙ্ক",
  T_48_META_API_10004_D: "সতীর্থদের কাছাকাছি অবস্থান পান এবং যারা দাঁড়াতে পারে না তাদের অবস্থান এড়িয়ে চলুন (অপ্রচলিত, অনুগ্রহ করে GetTeammateNearPosition ব্যবহার করুন)",
  T_48_META_API_10004_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_10004_R_D: "সতীর্থদের কাছাকাছি স্থানাঙ্ক",
  T_48_META_API_10005_D: "সত্তার মালিক যে প্লেয়ার পান",
  T_48_META_API_10005_P0_D: "টার্গেট এন্টিটি, এন্টিটি শুধুমাত্র যে প্লেয়ারের সাথে তা সিঙ্ক্রোনাইজ করা হবে",
  T_48_META_API_10005_R_D: "খেলোয়াড় যে লক্ষ্য সত্তার অন্তর্গত",
  T_48_META_API_10006_D: "প্লেয়ারকে অজেয় করুন",
  T_48_META_API_10006_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_10006_P1_D: "অপরাজেয় প্রভাবের সময়কাল, সেকেন্ডে",
  T_48_META_API_10007_D: "নির্বাচিত সত্তা এবং এর মূল অবস্থানে এর সমস্ত বৈশিষ্ট্য ক্লোন করুন",
  T_48_META_API_10007_P0_D: "সত্তা তৈরি হয়েছে",
  T_48_META_API_10007_P1_D: "সত্তা ক্লোন করা হবে",
  T_48_META_API_10008_D: "প্লেয়ারের ক্ষতির কারণ যদি কোনো ক্ষতির উৎস নির্বাচন না করা হয়, তাহলে লক্ষ্যটি সিস্টেম থেকে ক্ষতিগ্রস্থ হবে।",
  T_48_META_API_10008_P0_D: "ক্ষতিগ্রস্ত খেলা সত্তা",
  T_48_META_API_10008_P1_D: "খেলা সত্তা যে ক্ষতির কারণ",
  T_48_META_API_10008_P2_D: "ক্ষতির ধরন",
  T_48_META_API_10008_P3_D: "ক্ষতি",
  T_48_META_API_10009_D: "মনোনীত খেলোয়াড়ের পুনরুত্থান",
  T_48_META_API_10009_P0_D: "পুনরুত্থিত খেলোয়াড়",
  T_48_META_API_1001_D: "শর্ত পূরণ করা হলে, IF এর অধীনে নোড চালানো হবে। শর্ত পূরণ না হলে, যদি ELSE থাকে, তাহলে ELSE এর নিচের নোডটি চালান, অন্যথায় IF স্টেটমেন্টটি শেষ করুন।",
  T_48_META_API_1001_P0_D: "শর্ত তালিকাটি সাব-প্রসেস তালিকার (লজিক্যাল শাখা তালিকা) সংখ্যার সাথে সামঞ্জস্যপূর্ণ হতে হবে",
  T_48_META_API_10010_D: "একটি নির্দিষ্ট স্থানে একটি আইটেম বা আইটেমের তালিকা তৈরি করে।",
  T_48_META_API_10010_P0_D: "আইটেম তৈরির অবস্থান",
  T_48_META_API_10010_P1_D: "আইটেম বা আইটেম তালিকা তৈরি করা হয়েছে",
  T_48_META_API_10010_P2_D: "আইটেম তালিকা তৈরি করার সময়, আপনাকে আইটেম তালিকার ক্রম অনুসারে আইটেম পরিমাণ তালিকা পূরণ করতে হবে।",
  T_48_META_API_10011_D: "AI সত্তা লক্ষ্য পয়েন্টে টহল দেয়",
  T_48_META_API_10011_P0_D: "লক্ষ্য এআই সত্তা",
  T_48_META_API_10011_P1_D: "চলমান লক্ষ্য বিন্দু",
  T_48_META_API_10011_P2_D: "প্রারম্ভিক বিন্দুতে ফিরে যেতে হবে কিনা",
  T_48_META_API_10011_P3_D: "টহল দেওয়ার সময় প্রতিকূল লক্ষ্যবস্তু সনাক্ত এবং আক্রমণ করতে হবে কিনা",
  T_48_META_API_10012_D: "এআই সংস্থাগুলি সমন্বয় তালিকা অনুযায়ী ক্রমানুসারে টহল দেয়",
  T_48_META_API_10012_P0_D: "লক্ষ্য এআই সত্তা",
  T_48_META_API_10012_P1_D: "স্থানাঙ্ক পয়েন্ট তালিকা সরানো",
  T_48_META_API_10012_P2_D: "প্যাট্রোল টাইপ, আপনি একক, রাউন্ড ট্রিপ বা সাইকেল বেছে নিতে পারেন",
  T_48_META_API_10012_P3_D: "টহল দেওয়ার সময় প্রতিকূল লক্ষ্যবস্তু সনাক্ত এবং আক্রমণ করতে হবে কিনা",
  T_48_META_API_10013_D: "জেনারেটর অবিলম্বে ইউনিট সত্তার পরবর্তী তরঙ্গ রিফ্রেশ করে",
  T_48_META_API_10013_P0_D: "জেনারেটর সত্তা",
  T_48_META_API_10014_D: "গণনাযোগ্য বৈশিষ্ট্যগুলির জন্য যোগ করা গণনা কারণগুলি ফ্যাক্টরগুলির সমন্বয়ে গঠিত একটি সূত্রের মাধ্যমে চূড়ান্ত ফলাফল গণনা করবে।",
  T_48_META_API_10014_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_10014_P1_D: "গণনাযোগ্য সম্পত্তির ধরন",
  T_48_META_API_10014_P2_D: "ফ্যাক্টরের ধরন গণনা করুন",
  T_48_META_API_10014_P3_D: "ফ্যাক্টর মান গণনা",
  T_48_META_API_10015_D: "গণনা করা বৈশিষ্ট্যগুলির জন্য গণনার কারণগুলি পরিষ্কার করুন",
  T_48_META_API_10015_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_10015_P1_D: "গণনাযোগ্য সম্পত্তির ধরন",
  T_48_META_API_10016_D: "লক্ষ্য সত্তার সমস্ত গণনাকৃত বৈশিষ্ট্যের জন্য সমস্ত গণনাকৃত কারণগুলি সাফ করে",
  T_48_META_API_10016_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_10017_D: "বৈশিষ্ট্য পরিবর্তন করুন",
  T_48_META_API_10017_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_10017_P1_D: "সম্পত্তির ধরন",
  T_48_META_API_10017_P2_D: "পরিবর্তন পদ্ধতি",
  T_48_META_API_10017_P3_D: "মান",
  T_48_META_API_10018_D: "একটি গণিত সম্পত্তির মান সেট করুন",
  T_48_META_API_10018_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_10018_P1_D: "সম্পত্তির ধরন",
  T_48_META_API_10018_P2_D: "মান",
  T_48_META_API_10019_D: "একটি একক গণনাকৃত সম্পত্তি পরিবর্তন সাফ করুন",
  T_48_META_API_10019_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_10019_P1_D: "সম্পত্তির ধরন",
  T_48_META_API_1002_D: "পরামিতি i সর্বনিম্ন মান থেকে শুরু হয়, এবং প্রতিবার নিম্ন নোড চালানো হলে, i সর্বোচ্চ মানের থেকে বড় বা সমান না হওয়া পর্যন্ত i ধাপের মান বাড়ায়।",
  T_48_META_API_1002_P0_D: "লুপ সূচকের নাম, যা স্থানীয় ভেরিয়েবলে লুপ সূচক মান পেতে ব্যবহার করা যেতে পারে",
  T_48_META_API_1002_P1_D: "লুপ প্রাথমিক মান",
  T_48_META_API_1002_P2_D: "লুপ শেষ মান",
  T_48_META_API_1002_P3_D: "লুপ স্টেপ সাইজ, যখন প্রারম্ভিক মান শেষ মানের থেকে কম হয়, তখন স্টেপ সাইজ 0-এর বেশি হওয়া উচিত যখন শুরুর মান শেষ মানের থেকে বেশি হয়, স্টেপ সাইজ 0-এর কম হওয়া উচিত",
  T_48_META_API_10020_D: "ফিল্টার শর্ত পূরণ করে এমন সমস্ত সত্তা গেমে পান",
  T_48_META_API_10020_P0_D: "ফিল্টার ফলাফলে এই প্যারামিটারে প্রবেশ করা টাইপ থাকতে হবে",
  T_48_META_API_10020_P1_D: "ফিল্টার ফলাফলে এই প্যারামিটারে প্রবেশ করা টাইপ থাকা উচিত নয়",
  T_48_META_API_10020_P2_D: "ফিল্টার ফলাফল এই প্যারামিটারে প্রবেশ করানো অন্তত একটি প্রকার ধারণ করে",
  T_48_META_API_10020_R_D: "ফিল্টার ফলাফল সত্তা তালিকা",
  T_48_META_API_10021_D: "ফুটবলে একটি গতি যোগ করুন একই দিকে ত্বরণের কারণে গতি পরিবর্তন হবে।",
  T_48_META_API_10021_P0_D: "গোল ফুটবল",
  T_48_META_API_10021_P1_D: "3D স্থান বেগ যোগ করা হয়েছে",
  T_48_META_API_10022_D: "নির্দিষ্ট সত্তা ধ্বংস",
  T_48_META_API_10022_P0_D: "লক্ষ্য সত্তা ধ্বংস করা হবে",
  T_48_META_API_10023_D: "সত্তা ট্যাগ যোগ করুন",
  T_48_META_API_10023_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_10023_P1_D: "কাস্টম লেবেল",
  T_48_META_API_10024_D: "সত্তা থেকে লেবেল সরান",
  T_48_META_API_10024_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_10024_P1_D: "কাস্টম লেবেল",
  T_48_META_API_10025_D: "লক্ষ্য সত্তা নির্দিষ্ট ট্যাগ রয়েছে কিনা তা নির্ধারণ করুন",
  T_48_META_API_10025_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_10025_P1_D: "কাস্টম লেবেল",
  T_48_META_API_10025_R_D: "নির্দিষ্ট ট্যাগ অন্তর্ভুক্ত করতে হবে কিনা",
  T_48_META_API_10026_D: "ফুটবল অবস্থান নির্ধারণ করুন",
  T_48_META_API_10026_P0_D: "ফুটবল সত্তা",
  T_48_META_API_10026_P1_D: "অবস্থান",
  T_48_META_API_10026_P2_D: "গতি বজায় রাখা",
  T_48_META_API_10027_D: "লক্ষ্য প্লেয়ার দ্বারা বর্তমানে ব্যবহৃত ক্যামেরা সত্তা পান",
  T_48_META_API_10027_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_10027_R_D: "বর্তমানে ব্যবহৃত ক্যামেরা সত্তা",
  T_48_META_API_10028_D: "টার্গেট প্লেয়ারের ক্যামেরা টার্গেট ক্যামেরায় স্যুইচ করুন,",
  T_48_META_API_10028_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_10028_P1_D: "লক্ষ্য ক্যামেরা",
  T_48_META_API_10028_P2_D: "স্যুইচিং মোড, আপনি মূল যুক্তি বা প্রগতিশীল রাখতে বেছে নিতে পারেন",
  T_48_META_API_10028_P3_D: "সুইচিং টাইম হল প্রগতিশীল মোডে ক্যামেরা স্যুইচ করার সময়",
  T_48_META_API_10029_D: "একটি ক্যামেরা তৈরি করুন",
  T_48_META_API_10029_P0_D: "ক্যামেরার ধরন তৈরি করা হয়েছে",
  T_48_META_API_10029_P1_D: "ক্যামেরা সত্তা তৈরি করা হয়েছে",
  T_48_META_API_1003_D: "একটি ডেটা কন্টেইনারের ট্রাভার্সাল প্রয়োগ করুন, প্রতিটি উপ-উপাদান পাবেন এবং উপ-প্রক্রিয়াগুলি ধারণ করুন।",
  T_48_META_API_1003_P0_D: "চাইল্ড এলিমেন্টের নামের দিকে যান, আপনি স্থানীয় ভেরিয়েবলে চাইল্ড এলিমেন্টের মান পেতে এটি ব্যবহার করতে পারেন",
  T_48_META_API_1003_P1_D: "লুপ সূচকের নাম, যা স্থানীয় ভেরিয়েবলে লুপ সূচক মান পেতে ব্যবহার করা যেতে পারে",
  T_48_META_API_1003_P2_D: "যে ডেটা ধারকটি ট্রাভার্স করা হবে তা বর্তমানে নিম্নলিখিত প্রকারগুলিকে সমর্থন করে: অ্যারের প্রকার৷",
  T_48_META_API_10030_D: "যুদ্ধযোগ্য সত্তাকে হত্যা করুন",
  T_48_META_API_10030_P0_D: "লক্ষ্য সত্তা, অবশ্যই একটি যুদ্ধযোগ্য সত্তা হতে হবে",
  T_48_META_API_10031_D: "লক্ষ্য সত্তা এবং এর চাইল্ড নোডের কার্যকলাপের স্থিতি সেট করুন নিষ্ক্রিয় বস্তুর প্রাপ্যতা, দৃশ্যমানতা, সংঘর্ষ ইত্যাদি বন্ধ করা হবে।",
  T_48_META_API_10031_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_10031_P1_D: "এটা সক্রিয়?",
  T_48_META_API_10032_D: "সর্বদা লক্ষ্য সত্তা অনুসরণ করতে ক্যামেরা সত্তার অবস্থান সেট করুন",
  T_48_META_API_10032_P0_D: "লক্ষ্য ক্যামেরা সত্তা",
  T_48_META_API_10032_P1_D: "লক্ষ্য সত্তা অনুসরণ করতে",
  T_48_META_API_10032_P2_D: "লক্ষ্য সত্তা স্থানাঙ্ক থেকে অফসেট",
  T_48_META_API_10032_P3_D: "অফসেট সমন্বয় সিস্টেম",
  T_48_META_API_10033_D: "ক্যামেরা সত্তাকে সবসময় লক্ষ্য সত্তার মুখোমুখি হতে সেট করুন",
  T_48_META_API_10033_P0_D: "লক্ষ্য ক্যামেরা সত্তা",
  T_48_META_API_10033_P1_D: "লক্ষ্য সত্তা",
  T_48_META_API_10033_P2_D: "লক্ষ্য স্থানাঙ্ক থেকে ফিক্সেশন পয়েন্ট অফসেট",
  T_48_META_API_10033_P3_D: "অফসেট সমন্বয় সিস্টেম",
  T_48_META_API_10034_D: "Tweens তৈরি করুন",
  T_48_META_API_10034_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_10034_P1_D: "সম্পত্তি আইডি",
  T_48_META_API_10034_P2_D: "SrcVal",
  T_48_META_API_10034_P3_D: "ডেস্টভাল",
  T_48_META_API_10034_P4_D: "শৈলী",
  T_48_META_API_10034_P5_D: "বক্ররেখা",
  T_48_META_API_10034_P6_D: "সময়কাল",
  T_48_META_API_10034_P7_D: "tween সত্তা",
  T_48_META_API_10035_D: "অভিভাবক নোড সেট করুন, পিতামাতা এবং শিশু উভয়েরই ট্রান্সফর্ম উপাদান থাকা প্রয়োজন৷",
  T_48_META_API_10035_P0_D: "প্যারেন্ট নোড",
  T_48_META_API_10035_P1_D: "শিশু নোড",
  T_48_META_API_10035_P2_D: "চাইল্ড নোডের বর্তমান বিশ্ব অবস্থান, ঘূর্ণন এবং স্কেলিং বজায় রাখতে হবে কিনা এই আইটেমটি UI সেট করার সময় অবৈধ৷",
  T_48_META_API_10036_D: "NewCurve (অপ্রচলিত, অনুগ্রহ করে CreateTweenCurve ব্যবহার করুন)",
  T_48_META_API_10036_P0_D: "কন্ট্রোলপয়েন্ট",
  T_48_META_API_10036_R_D: "TwennCurveEntity",
  T_48_META_API_10037_D: "লক্ষ্য সত্তা খেলার প্রচেষ্টা, যা অবশ্যই খেলার যোগ্য উপাদান থাকতে হবে",
  T_48_META_API_10037_P0_D: "লক্ষ্য খেলার যোগ্য সত্তা",
  T_48_META_API_10037_P1_D: `রিপ্লে করবেন কিনা
সত্য: রিপ্লে
মিথ্যা: চালিয়ে যান`,
  T_48_META_API_10038_D: "খেলার যোগ্য সত্তা বিরাম দিন",
  T_48_META_API_10038_P0_D: "লক্ষ্য খেলার যোগ্য সত্তা",
  T_48_META_API_10039_D: "ব্যালিস্টিক গতি তৈরি করুন, যা লক্ষ্য সত্তাকে একটি প্রাথমিক বেগ এবং দিকনির্দেশ সহ ত্বরণ দেবে",
  T_48_META_API_10039_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_10039_P1_D: "গতির প্রাথমিক বেগ",
  T_48_META_API_10039_P2_D: "গতি ত্বরণ",
  T_48_META_API_10039_P3_D: "সর্বোচ্চ স্থানচ্যুতি দূরত্ব",
  T_48_META_API_10039_P4_D: "ব্যালিস্টিক গতি সত্তা তৈরি",
  T_48_META_API_10039_P5_D: "সৃষ্টির পর স্বয়ংক্রিয়ভাবে বাজানো শুরু হবে কিনা",
  T_48_META_API_1004_D: "বর্তমান লুপ প্রক্রিয়া ব্যাহত করুন এবং লুপ থেকে প্রস্থান করুন",
  T_48_META_API_10040_D: "গতি অনুসরণ করে অবস্থান তৈরি করুন, লক্ষ্য সত্তা নির্দিষ্ট বস্তুর গতিবিধি অনুসরণ করবে",
  T_48_META_API_10040_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_10040_P1_D: "বস্তু সত্তা যে গতি অনুসরণ করে",
  T_48_META_API_10040_P2_D: "দূরত্ব লক্ষ্য স্থানাঙ্কের অফসেট অনুসরণ করে",
  T_48_META_API_10040_P3_D: "সমন্বয় সিস্টেম ব্যবহৃত",
  T_48_META_API_10040_P4_D: "নিম্নলিখিত গতি সত্তা তৈরি",
  T_48_META_API_10040_P5_D: "সৃষ্টির পর স্বয়ংক্রিয়ভাবে বাজানো শুরু হবে কিনা",
  T_48_META_API_10041_D: "একটি দৃষ্টি-অনুসরণীয় গতি তৈরি করুন যেখানে লক্ষ্য সত্তা নির্দিষ্ট বস্তুর মুখোমুখি থাকবে",
  T_48_META_API_10041_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_10041_P1_D: "বস্তু সত্তা দেখা হচ্ছে",
  T_48_META_API_10041_P2_D: "বস্তু সত্তা থেকে দৃষ্টি বিন্দু অফসেট",
  T_48_META_API_10041_P3_D: "সমন্বয় সিস্টেম ব্যবহৃত",
  T_48_META_API_10041_P4_D: "তৈরি করা হয়েছে দৃষ্টি-অনুসরণকারী গতি সত্তা",
  T_48_META_API_10041_P5_D: "সৃষ্টির পর স্বয়ংক্রিয়ভাবে বাজানো শুরু হবে কিনা",
  T_48_META_API_10042_D: "অবচয়",
  T_48_META_API_10042_P0_D: "খেলোয়াড় সত্তা",
  T_48_META_API_10042_P1_D: "ম্যাচের ফলাফল",
  T_48_META_API_10042_P2_D: "অবচয়",
  T_48_META_API_10042_P3_D: "অবচয়",
  T_48_META_API_10042_P4_D: "অবচয়",
  T_48_META_API_10043_D: "লক্ষ্য সত্তার বৈশিষ্ট্যগুলি মসৃণভাবে সেট করুন বৈশিষ্ট্যগুলি অবিলম্বে পরিবর্তিত হবে, তবে ক্লায়েন্ট একটি মসৃণ রূপান্তর কার্য সম্পাদন করবে৷",
  T_48_META_API_10043_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_10043_P1_D: "লক্ষ্য সত্তার একটি বৈশিষ্ট্য",
  T_48_META_API_10043_P2_D: "অ্যাট্রিবিউটটি সংজ্ঞায়িত করার সময় লক্ষ্য মানটি প্রয়োজনীয় প্রকারের সাথে সঙ্গতিপূর্ণ হওয়া প্রয়োজন।",
  T_48_META_API_10044_D: "একটি রশ্মি সনাক্তকরণ সঞ্চালন করুন এবং রশ্মির দিক থেকে আঘাতপ্রাপ্ত সত্তার জন্য একটি সংঘর্ষের উপাদান প্রয়োজন হলে, ভূখণ্ডটি সনাক্ত করা যেতে পারে।",
  T_48_META_API_10044_P0_D: "অবস্থান স্থানাঙ্ক শুরু করুন",
  T_48_META_API_10044_P1_D: "রশ্মি সনাক্তকরণের দিক",
  T_48_META_API_10044_P2_D: "রশ্মি সনাক্তকরণ দূরত্ব, শুধুমাত্র ইতিবাচক মান গ্রহণ করা হয়",
  T_48_META_API_10044_P3_D: "রশ্মি সনাক্তকরণ স্তর মাস্ক, শুধুমাত্র ভরা স্তরগুলি স্ক্যানে অংশগ্রহণ করবে, ফাঁকা রেখে মানে সমস্ত স্তর স্ক্যানে অংশগ্রহণ করবে",
  T_48_META_API_10044_P4_D: "ট্রিগার স্ক্যান করা কি সম্ভব?",
  T_48_META_API_10044_P5_D: "আঘাত সত্তা",
  T_48_META_API_10044_P6_D: "হিট পয়েন্ট স্থানাঙ্ক",
  T_48_META_API_10044_P7_D: "হিট পয়েন্ট থেকে স্টার্ট পয়েন্ট পর্যন্ত দূরত্ব",
  T_48_META_API_10044_P8_D: "হিট পৃষ্ঠ স্বাভাবিক",
  T_48_META_API_10045_D: "একটি রশ্মি সনাক্তকরণ সঞ্চালন করুন এবং রশ্মির দিক থেকে দূর পর্যন্ত আঘাত করা সমস্ত সত্তা ফিরিয়ে দিন যদি লেভেল প্যারামিটারটি ফাঁকা জায়গায় পূরণ করা হয় তবে ভূখণ্ডটি সনাক্ত করা যেতে পারে।",
  T_48_META_API_10045_P0_D: "অবস্থান স্থানাঙ্ক শুরু করুন",
  T_48_META_API_10045_P1_D: "রশ্মি সনাক্তকরণের দিক",
  T_48_META_API_10045_P2_D: "রশ্মি সনাক্তকরণ দূরত্ব, শুধুমাত্র ইতিবাচক মান গ্রহণ করা হয়",
  T_48_META_API_10045_P3_D: "লেয়ার মাস্ক, শুধুমাত্র ভরা লেয়ারগুলোই স্ক্যানে অংশ নেবে, ফাঁকা রাখলে সব লেয়ার স্ক্যানে অংশগ্রহণ করবে",
  T_48_META_API_10045_P4_D: "এটা কি ট্রিগার সনাক্ত করা সম্ভব?",
  T_48_META_API_10045_P5_D: "হিট সত্তা তালিকা",
  T_48_META_API_10045_P6_D: "হিট লিস্ট",
  T_48_META_API_10045_P7_D: "পয়েন্ট দূরত্ব শুরু বিন্দু দূরত্ব তালিকা হিট",
  T_48_META_API_10045_P8_D: "হিট পৃষ্ঠ স্বাভাবিক",
  T_48_META_API_10046_D: "prefabs ব্যবহার করে টেমপ্লেটের জন্য সত্তা তৈরি করুন",
  T_48_META_API_10046_P0_D: "সত্তা তৈরি হয়েছে",
  T_48_META_API_10046_P1_D: "প্রিফ্যাব আইডি",
  T_48_META_API_10047_D: "রঞ্জনবিদ্যা",
  T_48_META_API_10047_P0_D: "বস্তু স্বাভাবিক সেট করুন",
  T_48_META_API_10047_P1_D: "ডাইং পয়েন্ট সেট করুন",
  T_48_META_API_10047_P2_D: "রঙ",
  T_48_META_API_10048_D: "স্টেনিং অবস্থা",
  T_48_META_API_10048_P0_D: "ডাইং পয়েন্ট সেট করুন",
  T_48_META_API_10048_P1_D: "দিক নির্ধারণ করুন",
  T_48_META_API_10048_P2_D: "দূরত্ব সেট করুন",
  T_48_META_API_10048_R_D: "কালারডেস্ক",
  T_48_META_API_10049_D: "স্টেনিং পরিসংখ্যান",
  T_48_META_API_10049_P0_D: "রঙ",
  T_48_META_API_10049_R_D: "ডাইং পরিমাণ",
  T_48_META_API_1005_D: "অবশিষ্ট লুপের বিষয়বস্তু এড়িয়ে যান এবং সরাসরি পরবর্তী লুপে যান",
  T_48_META_API_10050_D: "প্ল্যানার রেঞ্জ স্টেনিং",
  T_48_META_API_10050_P0_D: "বস্তু স্বাভাবিক সেট করুন",
  T_48_META_API_10050_P1_D: "ডাইং পয়েন্ট সেট করুন",
  T_48_META_API_10050_P2_D: "রঞ্জনবিদ্যা পরিসীমা সেট করুন",
  T_48_META_API_10050_P3_D: "রঙ",
  T_48_META_API_10050_P4_D: "ডাইং পরিমাণ",
  T_48_META_API_10051_D: "এলাকার দাগ",
  T_48_META_API_10051_P0_D: "বস্তু স্বাভাবিক সেট করুন",
  T_48_META_API_10051_P1_D: "ডাইং পয়েন্ট সেট করুন",
  T_48_META_API_10051_P2_D: "রঞ্জনবিদ্যা পরিসীমা সেট করুন",
  T_48_META_API_10051_P3_D: "রঙ",
  T_48_META_API_10051_P4_D: "স্থির দাগযুক্ত এলাকা",
  T_48_META_API_10051_P5_D: "এলোমেলো সহগ",
  T_48_META_API_10051_P6_D: "র‍্যান্ডম টেন্যুয়েশন সহগ",
  T_48_META_API_10051_P7_D: "ডাইং পরিমাণ",
  T_48_META_API_10052_D: "টার্গেট প্যারেন্ট নোড সত্তার সমস্ত চাইল্ড নোড পান",
  T_48_META_API_10052_P0_D: "প্যারেন্ট নোড সত্তা",
  T_48_META_API_10052_R_D: "চাইল্ড নোডের তালিকা",
  T_48_META_API_10053_D: "সূচকের উপর ভিত্তি করে টার্গেট প্যারেন্ট নোড সত্তার নির্দিষ্ট চাইল্ড নোড পান",
  T_48_META_API_10053_P0_D: "প্যারেন্ট নোড সত্তা",
  T_48_META_API_10053_P1_D: "চাইল্ড নোড সূচক",
  T_48_META_API_10053_R_D: "চাইল্ড নোড সত্তা",
  T_48_META_API_10054_D: "লক্ষ্য চাইল্ড নোড সত্তার প্যারেন্ট নোড পান",
  T_48_META_API_10054_P0_D: "চাইল্ড নোড সত্তা",
  T_48_META_API_10054_R_D: "প্যারেন্ট নোড সত্তা",
  T_48_META_API_10055_D: "নির্দিষ্ট প্যারেন্ট নোড সত্তার অধীনে সমস্ত চাইল্ড নোড মুছুন নোডের একটি ট্রান্সফর্ম উপাদান থাকতে হবে",
  T_48_META_API_10055_P0_D: "প্যারেন্ট নোড সত্তা",
  T_48_META_API_10056_D: "নির্দিষ্ট স্থানে টেলিপোর্ট টার্গেট",
  T_48_META_API_10056_P0_D: "ইউনিট টেলিপোর্ট করা হচ্ছে",
  T_48_META_API_10056_P1_D: "টেলিপোর্ট পয়েন্ট স্থানাঙ্ক",
  T_48_META_API_10056_P2_D: "টেলিপোর্টেশনের পরে ইউনিটের অভিযোজন",
  T_48_META_API_10057_D: "এলোমেলো সতীর্থদের কাছে অবস্থান পান, সতীর্থ না থাকলে নিজের কাছাকাছি স্থানাঙ্কগুলি ফিরিয়ে দিন এবং যে খেলোয়াড়রা দাঁড়াতে পারে না তাদের অবস্থান এড়িয়ে চলুন।",
  T_48_META_API_10057_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_10057_R_D: "লক্ষ্য খেলোয়াড়ের সতীর্থদের কাছাকাছি স্থানাঙ্ক",
  T_48_META_API_10058_D: "দাগের অবস্থা পরিষ্কার করুন",
  T_48_META_API_10059_D: "নির্দিষ্ট সাউন্ড ইফেক্ট প্লে করুন যদি আরও অ্যাট্রিবিউট সেট করতে হয়, তাহলে সত্তার মাধ্যমে এর এন্টিটি অ্যাট্রিবিউট সেট করুন।",
  T_48_META_API_10059_P0_D: "কোডটি আনুষ্ঠানিক প্যারামিটারের নাম উপস্থাপন করতে ব্যবহৃত হয় যা শব্দ প্রভাব সত্তা তৈরি করে, এবং এর সংশ্লিষ্ট স্থানীয় পরিবর্তনশীল মান হল সেই সত্তা যা শব্দ প্রভাব তৈরি করে।",
  T_48_META_API_10059_P1_D: "এটি যে প্লেয়ার সত্তার, শুধুমাত্র এই প্লেয়ারের কাছে দৃশ্যমান৷",
  T_48_META_API_10059_P2_D: "সাউন্ড ইফেক্ট টাইপ, সাউন্ড ইফেক্টের ধরন যা প্লেয়াররা বেছে নিতে পারে",
  T_48_META_API_1006_D: "বর্তমান এক্সিকিউশন প্রক্রিয়াটি শেষ করুন এবং সরাসরি কলিং লোকেশনে ফিরে যান আপনি ডেটা সহ ফিরে আসতে পারেন।",
  T_48_META_API_1006_P0_D: "কলিং লোকেশনে ডেটা ফেরত দেওয়া হবে বলে আশা করা হচ্ছে",
  T_48_META_API_10060_D: "খেলা থেকে লক্ষ্য প্লেয়ার কিক",
  T_48_META_API_10060_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_10060_P1_D: "বিলিং তথ্য প্রদর্শন করতে হবে কিনা",
  T_48_META_API_10061_D: "টার্গেট প্লেয়ার নির্দিষ্ট মানচিত্রের সাথে মিলিত হওয়ার অনুরোধ করে",
  T_48_META_API_10061_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_10061_P1_D: "যুদ্ধক্ষেত্র কোড",
  T_48_META_API_10061_P2_D: "ম্যাচ বাতিল করার সময় একটি পপ-আপ উইন্ডো আপনাকে আসল গেমে ফিরে যেতে অনুরোধ করে কিনা",
  T_48_META_API_10062_D: "বাজানো শব্দ প্রভাব সত্তা বাধা",
  T_48_META_API_10062_P0_D: "সাউন্ড ইফেক্ট এন্টিটি যা পজ করা দরকার",
  T_48_META_API_10063_D: "সাউন্ড ইফেক্ট বাজানো চালিয়ে যান, আপনি শুরু থেকে বাজানো শুরু করবেন কিনা তা বেছে নিতে পারেন",
  T_48_META_API_10063_P0_D: "সাউন্ড এফেক্ট এন্টিটি যেগুলি বিরতির পরে বাজানো চালিয়ে যেতে হবে",
  T_48_META_API_10063_P1_D: "গোড়া থেকে শুরু করতে হবে কিনা",
  T_48_META_API_10064_D: "একটি এয়ারড্রপ তৈরি করুন: 1. প্রস্তুতি, 2. পতন, 3. এয়ারড্রপ বৈশিষ্ট্যগুলি শুধুমাত্র স্টেট 1 এ পরিবর্তন করা যেতে পারে৷",
  T_48_META_API_10064_P0_D: "এয়ারড্রপ বক্স সত্তা তৈরি করা হয়েছে",
  T_48_META_API_1007_D: "শর্তটি সত্য কিনা তার উপর ভিত্তি করে একটি লুপ প্রয়োগ করুন, যতক্ষণ না কন্ডিশন মিথ্যা হয় এবং লুপ শেষ হয়।",
  T_48_META_API_1007_P0_D: "যখন শর্ত সত্য হয়, লুপ চলতে থাকে, এবং যখন শর্ত মিথ্যা হয়, লুপ শেষ হয়।",
  T_48_META_API_1008_D: `পরবর্তী লজিক্যাল ফ্রেমের শুরু না হওয়া পর্যন্ত অপেক্ষা করুন
সার্ভারে, কম ফ্রেম রেট মোড চালু থাকলে অপেক্ষার মেয়াদ আরও দীর্ঘ হবে
ক্লায়েন্টের উপর, অপেক্ষার সময়টি ডিভাইসের কার্যক্ষমতা এবং বর্তমান ফ্রেমের লজিক জটিলতার দ্বারা প্রভাবিত হয়
ব্যবহার করুন এই `,
  T_48_META_API_1009_D: "একটি নির্দিষ্ট সময়ের জন্য অপেক্ষা করার পরে, এই API ব্যবহার করে ফাংশনটিকে অ্যাসিঙ্ক হিসাবে ঘোষণা করতে হবে।",
  T_48_META_API_1009_P0_D: "অপেক্ষার সময়, মিলিসেকেন্ডে",
  T_48_META_API_101_D: "নির্দিষ্ট দৃশ্য আনইনস্টল করুন",
  T_48_META_API_101_P0_D: "দৃশ্য আইডি আনইনস্টল করা হবে",
  T_48_META_API_1010: "ইভেন্ট কলব্যাক",
  T_48_META_API_1010_D: "একটি ঘটনা ঘটলে একটি কর্ম ট্রিগার হয়",
  T_48_META_API_1010_P0: "ইভেন্ট প্যারামিটারের নাম",
  T_48_META_API_1010_P0_D: "ইভেন্ট প্যারামিটারের আনুষ্ঠানিক প্যারামিটার নাম, যার মাধ্যমে স্থানীয় ভেরিয়েবলে প্রকৃত প্যারামিটার মান পাওয়া যেতে পারে",
  T_48_META_API_1011: "কোড ব্লক",
  T_48_META_API_1011_D: "কোডের একটি ব্লক যা API-এর সংমিশ্রণ বহন করে",
  T_48_META_API_1011_P0: "পরামিতি নাম",
  T_48_META_API_1011_P0_D: "ফর্মাল প্যারামিটারের নাম যখন কোড ব্লক একটি কাস্টম ফাংশন হয়",
  T_48_META_API_1012: "সিরিয়াল সহ কাস্টম API খুঁজুন এবং আহ্বান করুন",
  T_48_META_API_1012_D: "কাস্টম ফাংশনটিকে সিরিয়াল পদ্ধতিতে কল করুন যদি কাস্টম ফাংশনে অপেক্ষা করা হয় তবে কলিং লোকেশনও অপেক্ষা করবে।",
  T_48_META_API_1012_P0_D: "সত্তা যেখানে কাস্টম ফাংশন থাকে",
  T_48_META_API_1012_P1: "গ্রাফ আইডি",
  T_48_META_API_1012_P1_D: "স্ক্রিপ্ট আইডি যেখানে কাস্টম ফাংশন অবস্থিত",
  T_48_META_API_1012_P2: "ফাংশন আইডি",
  T_48_META_API_1012_P2_D: "টার্গেট দ্বারা কল করা ফাংশন আইডি",
  T_48_META_API_1012_P3_D: "কাস্টম ফাংশনে পাঠানো আর্গুমেন্টের তালিকা",
  T_48_META_API_1013: "সমান্তরাল সহ কাস্টম API খুঁজুন এবং আহ্বান করুন",
  T_48_META_API_1013_D: "একটি কাস্টম ফাংশনকে সমান্তরালভাবে কল করুন, কাস্টম ফাংশনে অপেক্ষা করা হোক না কেন, এটি অবিলম্বে কলিং অবস্থানে ফিরে আসবে এবং কার্যকর করা চালিয়ে যাবে৷",
  T_48_META_API_1013_P0_D: "সত্তা যেখানে কাস্টম ফাংশন থাকে",
  T_48_META_API_1013_P1: "গ্রাফ আইডি",
  T_48_META_API_1013_P1_D: "স্ক্রিপ্ট আইডি যেখানে কাস্টম ফাংশন অবস্থিত",
  T_48_META_API_1013_P2: "ফাংশন আইডি",
  T_48_META_API_1013_P2_D: "টার্গেট দ্বারা কল করা ফাংশন আইডি",
  T_48_META_API_1013_P3_D: "কাস্টম ফাংশনে পাঠানো আর্গুমেন্টের তালিকা",
  T_48_META_API_1014: "সিরিয়াল সহ সেল্ফ কাস্টম এপিআই খুঁজুন এবং ইনভোক করুন",
  T_48_META_API_1014_D: "সিরিয়াল মোডে বর্তমান স্ক্রিপ্টে কাস্টম ফাংশন কল করুন যদি কাস্টম ফাংশনে একটি অপেক্ষা থাকে তবে কলিং অবস্থানটিও অপেক্ষা করবে।",
  T_48_META_API_1014_P0: "ফাংশন আইডি",
  T_48_META_API_1014_P0_D: "টার্গেট দ্বারা কল করা ফাংশন আইডি",
  T_48_META_API_1014_P1_D: "কাস্টম ফাংশনে পাঠানো আর্গুমেন্টের তালিকা",
  T_48_META_API_1015: "সমান্তরাল সহ স্ব কাস্টম API খুঁজুন এবং আহ্বান করুন",
  T_48_META_API_1015_D: "একটি কাস্টম ফাংশনকে সমান্তরালভাবে কল করুন, কাস্টম ফাংশনে অপেক্ষা করা হোক না কেন, এটি অবিলম্বে কলিং অবস্থানে ফিরে আসবে এবং কার্যকর করা চালিয়ে যাবে৷",
  T_48_META_API_1015_P0: "সূচক দ্বারা স্থানীয় পরিবর্তনশীল সেট করুন",
  T_48_META_API_1015_P0_D: "টার্গেট দ্বারা কল করা ফাংশন আইডি",
  T_48_META_API_1015_P1_D: "কাস্টম ফাংশনে পাঠানো আর্গুমেন্টের তালিকা",
  T_48_META_API_1016_D: "এই API কল করার সময় লক্ষ্যের ধরন পায়",
  T_48_META_API_1016_P0_D: "টার্গেট জিজ্ঞাসা করা হচ্ছে",
  T_48_META_API_1016_R_D: "পরিবর্তনশীল প্রকার",
  T_48_META_API_1017_D: "লক্ষ্য ভেরিয়েবল নির্দিষ্ট ধরনের কিনা তা নির্ধারণ করুন",
  T_48_META_API_1017_P0_D: "টার্গেট জিজ্ঞাসা করা হচ্ছে",
  T_48_META_API_1017_P1_D: "টাইপ তুলনা করা হচ্ছে",
  T_48_META_API_1017_R_D: "এটা সামঞ্জস্যপূর্ণ?",
  T_48_META_API_1018_D: "লক্ষ্য ভেরিয়েবল একটি নির্দিষ্ট ধরনের একটি সাবক্লাস কিনা তা নির্ধারণ করুন, এবং রিটার্ন মান একটি বুলিয়ান মান",
  T_48_META_API_1018_P0_D: "লক্ষ্য পরিবর্তনশীল জিজ্ঞাসা করা হচ্ছে",
  T_48_META_API_1018_P1_D: "টাইপ তুলনা করা হচ্ছে",
  T_48_META_API_1018_R_D: "এটি একটি সাবক্লাস কিনা",
  T_48_META_API_1019_D: "নির্দিষ্ট কাস্টম ইভেন্ট ট্রিগার করতে লক্ষ্য সত্তা কারণ",
  T_48_META_API_1019_P0_D: "কাস্টম ইভেন্ট আইডি পাঠানো হয়েছে",
  T_48_META_API_1019_P1_D: "লক্ষ্য সত্তা",
  T_48_META_API_1019_P2_D: "পরামিতি তালিকা",
  T_48_META_API_102_D: "নির্দিষ্ট দৃশ্যে স্যুইচ করা অন্যান্য লোড করা দৃশ্যগুলিকে আনলোড করবে৷",
  T_48_META_API_102_P0_D: "দৃশ্য আইডিতে স্যুইচ করতে হবে",
  T_48_META_API_1020_D: "একটি কন্টেইনারের ট্রাভার্সাল প্রয়োগ করুন এবং সাব-প্রসেসগুলি সহ প্রতিটি কী-মূল্যের জোড়া প্রাপ্ত করুন।",
  T_48_META_API_1020_P0_D: "কীটির নামের দিকে যান, আপনি স্থানীয় ভেরিয়েবলের কী মান পেতে এটি ব্যবহার করতে পারেন",
  T_48_META_API_1020_P1_D: "মানের নামের কাছে যান, যা স্থানীয় ভেরিয়েবলের মান পেতে ব্যবহার করা যেতে পারে",
  T_48_META_API_1020_P2_D: "পাত্র পাড়ি",
  T_48_META_API_1021_D: "নির্দিষ্ট বটটি ধ্বংস করুন",
  T_48_META_API_1021_P0_D: "বট খেলোয়াড় যাদের ধ্বংস করা দরকার",
  T_48_META_API_1022_D: "টার্গেট প্লেয়ারকে গাড়ি ছেড়ে যেতে বাধ্য করুন",
  T_48_META_API_1022_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_1023_D: "ক্ষতি লাফ শব্দ তৈরি করুন",
  T_48_META_API_1023_P0_D: "শব্দ বিষয়বস্তু এড়িয়ে যান",
  T_48_META_API_1023_P1_D: "ফন্টের আকার",
  T_48_META_API_1023_P2_D: "হরফের রঙ",
  T_48_META_API_1023_P3_D: "মিলিসেকেন্ডে থাকার সময়কাল",
  T_48_META_API_1023_P4_D: "ক্ষতিগ্রস্থ সত্তা",
  T_48_META_API_1023_P5_D: "টার্গেট সত্তার বিশ্ব স্থানাঙ্কের সাথে সম্পর্কিত ক্ষতি জাম্প শব্দের অফসেট",
  T_48_META_API_1023_P6_D: "ক্ষতি জাম্প অবস্থানে আবার র্যান্ডম অবস্থান সংশোধনের পরিসীমা আকার",
  T_48_META_API_1023_P7_D: "টুইন অ্যানিমেশন করতে হবে কিনা",
  T_48_META_API_1024_D: "অবচয়",
  T_48_META_API_1024_P0_D: "অবচয়",
  T_48_META_API_1024_P1_D: "লক্ষ্য সত্তা",
  T_48_META_API_1024_P2_D: "নির্বাচন করার পর, সার্ভারে কল করা হলে, এটি ক্লায়েন্টের কাছে পাঠানো হবে, যদি ক্লায়েন্টে কল করা হয়, এটি সার্ভারে পাঠানো হবে।",
  T_48_META_API_1024_P3_D: "পরামিতি তালিকা",
  T_48_META_API_1025_D: "কাস্টম টাস্ক অগ্রগতি জিজ্ঞাসা করুন",
  T_48_META_API_1025_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_1025_P1_D: "কাস্টম টাস্ক আইডি",
  T_48_META_API_1025_R_D: "কাজের অগ্রগতি",
  T_48_META_API_1026_D: "লক্ষ্য খেলোয়াড়ের ব্যাকপ্যাক চামড়া পান",
  T_48_META_API_1026_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_1026_R_D: "ব্যাকপ্যাক স্কিন আইডি",
  T_48_META_API_1027_D: "লক্ষ্য প্লেয়ার এর ব্যাকপ্যাক চামড়া সেট",
  T_48_META_API_1027_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_1027_P1_D: "ব্যাকপ্যাক স্কিন আইডি",
  T_48_META_API_1028_D: "টার্গেট প্লেয়ারের ব্যাকপ্যাক স্কিন ডিফল্ট বাহ্যিক কনফিগারেশনে পুনরুদ্ধার করুন",
  T_48_META_API_1028_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_1029_D: "টার্গেট প্লেয়ারের ব্যাকপ্যাকের চামড়া পরিষ্কার করুন",
  T_48_META_API_1029_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_103_D: "গেমের স্কাইবক্স পরিবেশ শৈলী পরিবর্তন করুন, আপনি দিন, সন্ধ্যা, রাত ইত্যাদি বেছে নিতে পারেন।",
  T_48_META_API_103_P0_D: "স্কাইবক্স টাইপ",
  T_48_META_API_1030_D: "নাম দ্বারা হাড় ঝুলন্ত পয়েন্ট অবস্থান পান",
  T_48_META_API_1030_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_1030_P1_D: "হাড়ের ঝুলন্ত বিন্দুর নাম",
  T_48_META_API_1030_R_D: "স্ট্রকচার পয়েন্ট",
  T_48_META_API_1031_D: "অবজেক্ট সত্তার প্যারেন্ট নোড সেট করুন, ট্রান্সফর্ম, স্কেলেটনপার্ট, প্লেয়ার এবং মাউন্টপয়েন্ট উপাদানগুলির সাথে মাউন্ট করা সমর্থনকারী সংস্থাগুলি।",
  T_48_META_API_1031_P0_D: "প্যারেন্ট নোড",
  T_48_META_API_1031_P1_D: "শিশু নোড",
  T_48_META_API_1031_P2_D: "চাইল্ড নোডের বর্তমান বিশ্ব অবস্থান, ঘূর্ণন এবং স্কেলিং ধরে রাখতে হবে কিনা এই আইটেমটি UI দ্বারা সেট করা হলে অবৈধ৷",
  T_48_META_API_1032_D: "আইকন অ্যানিমেশন প্রভাব চালান, আইকনটি প্লেব্যাকের গতিতে শুরুর অবস্থান থেকে শেষ অবস্থানে অনুবাদ করে",
  T_48_META_API_1032_P0_D: "আইকন রিসোর্স আইডি",
  T_48_META_API_1032_P1_D: "রঙ",
  T_48_META_API_1032_P2_D: "আইকন জুম",
  T_48_META_API_1032_P3_D: "প্রারম্ভিক অবস্থান কেন্দ্র",
  T_48_META_API_1032_P4_D: "এলাকা পরিসীমা শুরু হচ্ছে",
  T_48_META_API_1032_P5_D: "শেষ অবস্থান কেন্দ্র",
  T_48_META_API_1032_P6_D: "শেষ অবস্থান পরিসীমা",
  T_48_META_API_1032_P7_D: "প্লেব্যাকের গতি হল প্রতি সেকেন্ডে যে দূরত্ব আইকনটি সরে যায়",
  T_48_META_API_1033_D: "কোণ পেতে arctangent অপারেশন সঞ্চালন",
  T_48_META_API_1033_P0_D: "Y অক্ষ স্থানাঙ্ক",
  T_48_META_API_1033_P1_D: "এক্স-অক্ষ স্থানাঙ্ক",
  T_48_META_API_1033_R_D: "কোণ, পরিসর (-180, 180]",
  T_48_META_API_1034_D: "সত্তায় উপাদান যোগ করুন শুধুমাত্র ব্যবহারকারীর তৈরি কাস্টম উপাদান সমর্থিত.",
  T_48_META_API_1034_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_1034_P1_D: "কম্পোনেন্ট টাইপ আইডি, শুধুমাত্র ব্যবহারকারীর তৈরি কাস্টম উপাদান সমর্থন করে",
  T_48_META_API_1034_P2_D: "এটি সফলভাবে যোগ করা হোক না কেন, বিদ্যমান উপাদান বা অ-কাস্টম উপাদান যোগ করা ব্যর্থ হবে।",
  T_48_META_API_1035_D: "সত্তা থেকে উপাদান সরান এবং শুধুমাত্র কাস্টম উপাদান সমর্থন",
  T_48_META_API_1035_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_1035_P1_D: "কম্পোনেন্ট টাইপ আইডি, শুধুমাত্র ব্যবহারকারীর তৈরি কাস্টম উপাদান সমর্থন করে",
  T_48_META_API_1035_P2_D: "অপসারণ সফল হোক বা না অ-বিদ্যমান উপাদান বা অ-কাস্টম উপাদান সরানো ব্যর্থ হবে।",
  T_48_META_API_1036_D: "প্লেয়ার এক্সিট ইন্টারফেস মাঝপথে কাস্টমাইজ করুন",
  T_48_META_API_1036_P0_D: "শিরোনাম",
  T_48_META_API_1036_P1_D: "বিষয়বস্তু",
  T_48_META_API_1036_P2_D: "অপশন",
  T_48_META_API_1036_P3_D: "পটভূমি প্রদর্শন করা হবে কিনা",
  T_48_META_API_1037_D: "সব বর্তমানে লোড দৃশ্য পান",
  T_48_META_API_1037_R_D: "দৃশ্য তালিকা",
  T_48_META_API_1038_D: "প্লেয়ারের স্থানীয় লক্ষ্যের দিকনির্দেশ পান",
  T_48_META_API_1038_R_D: "নিশানা দিক",
  T_48_META_API_1039_D: "স্থানীয় টাইমস্ট্যাম্প পান",
  T_48_META_API_1039_R_D: "টাইমস্ট্যাম্প",
  T_48_META_API_104_D: "প্লেয়ারটিকে নির্দিষ্ট দৃশ্যের নির্দিষ্ট অবস্থানে পরিবর্তন করুন আনলোড করা দৃশ্যগুলি স্বয়ংক্রিয়ভাবে লোড হবে এবং লোড করা দৃশ্যগুলি স্বয়ংক্রিয়ভাবে আনলোড হবে না৷",
  T_48_META_API_104_P0_D: "খেলোয়াড়",
  T_48_META_API_104_P1_D: "লোড করার জন্য দৃশ্য আইডি",
  T_48_META_API_104_P2_D: "নতুন দৃশ্যে খেলোয়াড়ের অবস্থান",
  T_48_META_API_104_P3_D: "নতুন দৃশ্যে খেলোয়াড়ের অভিযোজন",
  T_48_META_API_1040_D: "বর্তমান প্ল্যাটফর্মের স্থির ফ্রেম আপডেট বিরাম দিন, প্ল্যাটফর্মের স্থির ফ্রেম আপডেট ইভেন্ট আর ট্রিগার হবে না।",
  T_48_META_API_1041_D: "বর্তমান প্ল্যাটফর্মের স্থির ফ্রেম আপডেট পুনরায় শুরু করুন পুনরুদ্ধারের পরে, প্ল্যাটফর্মের স্থির ফ্রেম আপডেট ইভেন্ট আবার ট্রিগার হতে শুরু করে৷",
  T_48_META_API_1042_D: "টার্গেট প্লেয়ার এবং বর্তমান ক্লায়েন্ট প্লেয়ারের মধ্যে বন্ধু সম্পর্ক নির্ধারণ করুন বর্তমান ক্লায়েন্ট নিজেই বর্তমান ক্লায়েন্টের বন্ধু নয়।",
  T_48_META_API_1042_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_1042_R_D: "আপনি বর্তমান ক্লায়েন্টের সাথে বন্ধু কিনা",
  T_48_META_API_1043_D: "কাস্টম ইভেন্ট ট্রিগার করুন",
  T_48_META_API_1043_P0_D: "কাস্টম ইভেন্ট আইডি",
  T_48_META_API_1043_P1_D: "লক্ষ্য সত্তা",
  T_48_META_API_1043_P2_D: "চলমান প্ল্যাটফর্ম হল সার্ভার বা ক্লায়েন্ট",
  T_48_META_API_1043_P3_D: "পরামিতি তালিকা",
  T_48_META_API_1044_D: "স্কাইডাইভিং শুরু করুন",
  T_48_META_API_1044_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_1044_P1_D: "এই উচ্চতার নিচে প্যারাসুট খুলতে বাধ্য হবে",
  T_48_META_API_1044_P2_D: "গ্লাইডিংয়ের সময় যে গতি, X উপাদানটি অনুভূমিক গতির প্রতিনিধিত্ব করে এবং Y উপাদানটি যখন ঋণাত্মক হয়, প্লেয়ারটি নীচের দিকে যায়",
  T_48_META_API_1044_P3_D: "ডাইভিংয়ের সময় গতি, X উপাদানটি অনুভূমিক গতিকে প্রতিনিধিত্ব করে এবং Y উপাদানটি যখন ঋণাত্মক হয়, প্লেয়ারটি নীচের দিকে পড়ে",
  T_48_META_API_1044_P4_D: "ছাতা খোলার সময়, X উপাদানটি অনুভূমিক গতির প্রতিনিধিত্ব করে এবং Y উপাদানটি ঋণাত্মক হলে প্লেয়ারটি নীচের দিকে নেমে আসে",
  T_48_META_API_1045_D: "ডেটা টেবিলে নির্দিষ্ট শনাক্তকারীর সাথে সম্পর্কিত মান পড়ুন",
  T_48_META_API_1045_P0_D: "ডাটাবেসে টেবিলের নাম",
  T_48_META_API_1045_P1_D: "প্লেয়ার ইউনিক আইডি",
  T_48_META_API_1045_P2_D: "শনাক্তকারী নির্দিষ্ট করুন",
  T_48_META_API_1045_P3_D: "ফলাফল পড়ুন",
  T_48_META_API_1045_P4_D: "ডাটাবেসের সাথে সম্পর্কিত যুদ্ধক্ষেত্রের কোড, যা শূন্যস্থান পূরণ করা যেতে পারে, বর্তমান মানচিত্রের যুদ্ধক্ষেত্রের কোডকে প্রতিনিধিত্ব করে।",
  T_48_META_API_1045_P5_D: "ত্রুটি কোড",
  T_48_META_API_1046_D: "র‌্যাঙ্কিং ডেটা টেবিলে নির্দিষ্ট শনাক্তকারীর সাথে সম্পর্কিত মান পড়ুন",
  T_48_META_API_1046_P0_D: "ডাটাবেসে র‌্যাঙ্কিং টেবিলের নাম",
  T_48_META_API_1046_P1_D: "শনাক্তকারী নির্দিষ্ট করুন",
  T_48_META_API_1046_P2_D: "ফলাফল পড়ুন",
  T_48_META_API_1046_P3_D: "ডাটাবেসের সাথে সম্পর্কিত যুদ্ধক্ষেত্রের কোড, যা শূন্যস্থান পূরণ করা যেতে পারে, বর্তমান মানচিত্রের যুদ্ধক্ষেত্রের কোডকে প্রতিনিধিত্ব করে।",
  T_48_META_API_1046_P4_D: "ত্রুটি কোড",
  T_48_META_API_1047_D: "র‌্যাঙ্কিং ডেটা টেবিলে নির্দিষ্ট র‌্যাঙ্কিং ব্যবধানের মান পড়ুন",
  T_48_META_API_1047_P0_D: "ডাটাবেসে র‌্যাঙ্কিং টেবিলের নাম",
  T_48_META_API_1047_P1_D: "শুরুর র‍্যাঙ্কটি শেষ র‍্যাঙ্কের চেয়ে কম বা সমান হতে হবে এবং র‍্যাঙ্কটি ১ থেকে শুরু হবে",
  T_48_META_API_1047_P2_D: "শেষ র‌্যাঙ্কিং",
  T_48_META_API_1047_P3_D: "ফলাফল পড়ুন",
  T_48_META_API_1047_P4_D: "ডাটাবেসের সাথে সম্পর্কিত যুদ্ধক্ষেত্রের কোড, যা শূন্যস্থান পূরণ করা যেতে পারে, বর্তমান মানচিত্রের যুদ্ধক্ষেত্রের কোডকে প্রতিনিধিত্ব করে।",
  T_48_META_API_1047_P5_D: "ত্রুটি কোড",
  T_48_META_API_1048_D: "ক্রমবর্ধমান ডেটা টেবিলে নির্দিষ্ট শনাক্তকারীর সাথে সম্পর্কিত মান পড়ুন",
  T_48_META_API_1048_P0_D: "ডাটাবেসে জমে থাকা ডেটা টেবিলের নাম",
  T_48_META_API_1048_P1_D: "শনাক্তকারী নির্দিষ্ট করুন",
  T_48_META_API_1048_P2_D: "ফলাফল পড়ুন",
  T_48_META_API_1048_P3_D: "ডাটাবেসের সাথে সম্পর্কিত যুদ্ধক্ষেত্রের কোড, যা শূন্যস্থান পূরণ করা যেতে পারে, বর্তমান মানচিত্রের যুদ্ধক্ষেত্রের কোডকে প্রতিনিধিত্ব করে।",
  T_48_META_API_1048_P4_D: "ত্রুটি কোড",
  T_48_META_API_1049_D: "ডেটা টেবিলে নির্দিষ্ট শনাক্তকারীর সাথে সম্পর্কিত মানটি লিখুন",
  T_48_META_API_1049_P0_D: "ডাটাবেসে টেবিলের নাম",
  T_48_META_API_1049_P1_D: "প্লেয়ার ইউনিক আইডি",
  T_48_META_API_1049_P2_D: "শনাক্তকারী নির্দিষ্ট করুন",
  T_48_META_API_1049_P3_D: "মান লিখিত",
  T_48_META_API_1049_P4_D: "ডাটাবেসের সাথে সম্পর্কিত যুদ্ধক্ষেত্রের কোড, যা শূন্যস্থান পূরণ করা যেতে পারে, বর্তমান মানচিত্রের যুদ্ধক্ষেত্রের কোডকে প্রতিনিধিত্ব করে।",
  T_48_META_API_1049_P5_D: "ত্রুটি কোড",
  T_48_META_API_105_D: "দৃশ্যের স্কাইবক্স পান",
  T_48_META_API_105_P0_D: "দৃশ্য আইডি",
  T_48_META_API_105_R_D: "স্কাইবক্স",
  T_48_META_API_1050_D: "তালিকায় উপাদানের সংখ্যা পান",
  T_48_META_API_1050_P0_D: "লক্ষ্য তালিকা",
  T_48_META_API_1050_R_D: "উপাদানের সংখ্যা",
  T_48_META_API_1051_D: "তালিকার নির্দিষ্ট সূচকে উপাদান মান পান",
  T_48_META_API_1051_P0_D: "লক্ষ্য তালিকা",
  T_48_META_API_1051_P1_D: "সূচক মান, 0 থেকে শুরু",
  T_48_META_API_1051_R_D: "উপাদান মান",
  T_48_META_API_1052_D: "তালিকার নির্দিষ্ট সূচকের সাথে সংশ্লিষ্ট উপাদান মান সেট করে",
  T_48_META_API_1052_P0_D: "লক্ষ্য তালিকা",
  T_48_META_API_1052_P1_D: "সূচক মান, 0 থেকে শুরু",
  T_48_META_API_1052_P2_D: "উপাদান মান",
  T_48_META_API_1053_D: "তালিকার শেষে উপাদান যোগ করুন",
  T_48_META_API_1053_P0_D: "লক্ষ্য তালিকা",
  T_48_META_API_1053_P1_D: "উপাদান যোগ করার জন্য",
  T_48_META_API_1054_D: "তালিকা থেকে নির্দিষ্ট সূচকের সাথে সম্পর্কিত উপাদানটি সরিয়ে দেয়",
  T_48_META_API_1054_P0_D: "লক্ষ্য তালিকা",
  T_48_META_API_1054_P1_D: "সূচক মান, 0 থেকে শুরু",
  T_48_META_API_1055_D: "তালিকার সমস্ত উপাদান সাফ করুন",
  T_48_META_API_1055_P0_D: "লক্ষ্য তালিকা",
  T_48_META_API_1056_D: "উল্লিখিত তালিকা উল্টে তালিকার উপাদানের ক্রম বিপরীত হবে.",
  T_48_META_API_1056_P0_D: "লক্ষ্য তালিকা",
  T_48_META_API_1057_D: "একটি তালিকা অনুলিপি করুন",
  T_48_META_API_1057_P0_D: "লক্ষ্য তালিকা",
  T_48_META_API_1057_R_D: "নতুন তালিকা অনুলিপি করা হয়েছে",
  T_48_META_API_1058_D: "তালিকায় নির্দিষ্ট সূচক অবস্থানে একটি নতুন উপাদান সন্নিবেশ করান মূল সূচক অবস্থানে এবং পরের উপাদানগুলিকে এক অবস্থানে পিছনে সরানো হবে৷",
  T_48_META_API_1058_P0_D: "লক্ষ্য তালিকা",
  T_48_META_API_1058_P1_D: "সূচকের অবস্থান সন্নিবেশ করা হবে, সূচকটি 0 থেকে গণনা করা হয়",
  T_48_META_API_1058_P2_D: "সন্নিবেশ করার জন্য নতুন উপাদান মান",
  T_48_META_API_1059_D: "এলোমেলোভাবে তালিকার উপাদানগুলিকে পুনরায় সাজান",
  T_48_META_API_1059_P0_D: "লক্ষ্য তালিকা",
  T_48_META_API_1060_D: "উভয় পক্ষের পরামিতি তুলনা করুন এবং সত্য বা মিথ্যা ফেরত দিন",
  T_48_META_API_1060_P0_D: "lvalue তুলনা করার জন্য ব্যবহৃত হয়",
  T_48_META_API_1060_P1_D: "তুলনা পদ্ধতি নিম্নলিখিত পদ্ধতিগুলিকে সমর্থন করে: >,>=,==,!=,<=,<, এবং (সীমিত বুল প্রকার), অথবা (সীমিত বুল প্রকার)",
  T_48_META_API_1060_P2_D: "lvalue তুলনা করার জন্য ব্যবহৃত হয়",
  T_48_META_API_1060_R_D: "ফলাফল তুলনা করুন",
  T_48_META_API_1061_D: "চারটি মৌলিক গাণিতিক ক্রিয়াকলাপের মধ্যে রয়েছে যোগ, বিয়োগ, গুণ, ভাগ এবং অবশিষ্ট। অবশিষ্ট অপারেশন শুধুমাত্র পূর্ণসংখ্যা সমর্থন করে, এবং বাকি অপারেশন পূর্ণসংখ্যা বা দশমিক সমর্থন করে।",
  T_48_META_API_1061_P0_D: "অপারেশনের মূল্য",
  T_48_META_API_1061_P1_D: "যোগ, বিয়োগ, গুণ, ভাগ এবং অবশিষ্ট সহ চার ধরনের পাটিগণিত ক্রিয়াকলাপগুলিকে সমর্থন করে না।",
  T_48_META_API_1061_P2_D: "অপারেশন rvalue",
  T_48_META_API_1061_R_D: "গণনার ফলাফল",
  T_48_META_API_1062_D: "এলোমেলোভাবে ক্ষুদ্রতম পূর্ণসংখ্যা (অন্তর্ভুক্ত) এবং বৃহত্তম পূর্ণসংখ্যার (একচেটিয়া) মধ্যে একটি পূর্ণসংখ্যা তৈরি করে",
  T_48_META_API_1062_P0_D: "এলোমেলো পরিসরের বাম ব্যবধান, এলোমেলোভাবে ভরাট মান পর্যন্ত পৌঁছানো সম্ভব",
  T_48_META_API_1062_P1_D: "এলোমেলো পরিসরের সঠিক ব্যবধানটি ভরাট-ইন মানের সাথে এলোমেলো হবে না।",
  T_48_META_API_1062_R_D: "এলোমেলো ফলাফল, পূর্ণসংখ্যা",
  T_48_META_API_1063_D: "এলোমেলোভাবে ক্ষুদ্রতম দশমিক মান (অন্তর্ভুক্ত) এবং বৃহত্তম দশমিক মানের (একচেটিয়া) মধ্যে একটি দশমিক উৎপন্ন করে",
  T_48_META_API_1063_P0_D: "এলোমেলো পরিসরের বাম ব্যবধানে, ভরাট-ইন মান র্যান্ডম হওয়ার একটি ছোট সম্ভাবনা রয়েছে।",
  T_48_META_API_1063_P1_D: "এলোমেলো পরিসরের সঠিক ব্যবধানটি ভরাট-ইন মানের সাথে এলোমেলো হবে না।",
  T_48_META_API_1063_R_D: "এলোমেলো ফলাফল, দশমিক, 7 দশমিক স্থানে নির্ভুল",
  T_48_META_API_1064_D: "বস্তুটি খালি কিনা তা নির্ধারণ করুন",
  T_48_META_API_1064_P0_D: "বস্তু খালি বিচার করা",
  T_48_META_API_1064_R_D: "এটা কি খালি",
  T_48_META_API_1065_D: "যৌক্তিক অস্বীকার, ইনপুট মান: সত্য বা মিথ্যা, ফেরত মান: মিথ্যা বা সত্য",
  T_48_META_API_1065_P0_D: "অ-এর মান বের করতে হবে",
  T_48_META_API_1065_R_D: "নেতিবাচক ফলাফল",
  T_48_META_API_1066_D: "পরম মান নিন, পূর্ণসংখ্যা এবং দশমিক সমর্থন করে",
  T_48_META_API_1066_P0_D: "মানের পরম মান খুঁজে বের করতে হবে",
  T_48_META_API_1066_R_D: "পরম মান গ্রহণের ফলাফল",
  T_48_META_API_1067_D: "বর্গমূল গণনা করুন",
  T_48_META_API_1067_P0_D: "মানের বর্গমূল বের করতে হবে",
  T_48_META_API_1067_R_D: "বর্গমূল বের করার ফলাফল",
  T_48_META_API_1068_D: "নেতিবাচক মান গণনা করুন",
  T_48_META_API_1068_P0_D: "একটি নেতিবাচক মান খুঁজে বের করতে হবে",
  T_48_META_API_1068_R_D: "নেতিবাচক ফলাফল",
  T_48_META_API_1069_D: "দুটি স্ট্রিং একসাথে সংযুক্ত করুন",
  T_48_META_API_1069_P0_D: "স্ট্রিং lvalue",
  T_48_META_API_1069_P1_D: "স্ট্রিং rvalue",
  T_48_META_API_1069_R_D: "স্ট্রিং সংযোগের ফলাফল",
  T_48_META_API_1070_D: "স্ট্রিং দৈর্ঘ্য পান",
  T_48_META_API_1070_P0_D: "স্ট্রিং",
  T_48_META_API_1070_R_D: "স্ট্রিং দৈর্ঘ্য",
  T_48_META_API_1071_D: "নির্দিষ্ট মানটিকে নিকটতম পূর্ণসংখ্যায় পূর্ণ করে",
  T_48_META_API_1071_P0_D: "যে মানটি বৃত্তাকার করা প্রয়োজন",
  T_48_META_API_1071_R_D: "নিচে বৃত্তাকার ফলাফল",
  T_48_META_API_1072_D: "নির্দিষ্ট মানটিকে নিকটতম পূর্ণসংখ্যায় পূর্ণ করে",
  T_48_META_API_1072_P0_D: "যে মানটি রাউন্ড আপ করা দরকার",
  T_48_META_API_1072_R_D: "রাউন্ডিং আপ ফলাফল",
  T_48_META_API_1073_D: "নির্দিষ্ট মানকে একটি পূর্ণসংখ্যায় পরিণত করে",
  T_48_META_API_1073_P0_D: "বৃত্তাকার করা প্রয়োজন যে মান",
  T_48_META_API_1073_R_D: "বৃত্তাকার ফলাফল",
  T_48_META_API_1074_D: "টার্গেট স্ট্রিং-এ সমস্ত নির্দিষ্ট স্ট্রিং প্রতিস্থাপন করার পরে, নতুন স্ট্রিং আউটপুট করুন",
  T_48_META_API_1074_P0_D: "লক্ষ্য স্ট্রিং",
  T_48_META_API_1074_P1_D: "পুরানো স্ট্রিং প্রতিস্থাপন করা হবে",
  T_48_META_API_1074_P2_D: "সাথে প্রতিস্থাপন করার জন্য নতুন স্ট্রিং",
  T_48_META_API_1074_R_D: "সম্পূর্ণ স্ট্রিং প্রতিস্থাপন করুন",
  T_48_META_API_1075_D: "একটি নির্দিষ্ট স্ট্রিং প্রথম ঘটনার জন্য লক্ষ্য স্ট্রিং অনুসন্ধান করুন.",
  T_48_META_API_1075_P0_D: "লক্ষ্য স্ট্রিং",
  T_48_META_API_1075_P1_D: "খুঁজে বের করার জন্য নির্দিষ্ট স্ট্রিং",
  T_48_META_API_1075_P2_D: "প্রারম্ভিক অবস্থান থেকে স্ট্রিং খুঁজুন, স্ট্রিং অবস্থান 0 থেকে গণনা করা হয়",
  T_48_META_API_1075_R_D: "টার্গেট স্ট্রিং-এ স্ট্রিং এর প্রথম ঘটনার অবস্থান উল্লেখ করে স্ট্রিং পজিশন 0 থেকে গণনা করা হয়।",
  T_48_META_API_1076_D: "নির্দিষ্ট অবস্থান থেকে শুরু করে নির্দিষ্ট দৈর্ঘ্যের একটি স্ট্রিং আটকানোর পরে, একটি নতুন স্ট্রিং আউটপুট করুন",
  T_48_META_API_1076_P0_D: "লক্ষ্য স্ট্রিং",
  T_48_META_API_1076_P1_D: "যে অবস্থানে ইন্টারসেপশন শুরু হয় স্ট্রিং পজিশন 0 থেকে গণনা করা হয়।",
  T_48_META_API_1076_P2_D: "ডিফল্টভাবে দৈর্ঘ্য কেটে ফেলুন, এটি স্ট্রিংয়ের শেষ পর্যন্ত কাটে।",
  T_48_META_API_1076_R_D: "আটকানো স্ট্রিং",
  T_48_META_API_1077_D: "দুটি তালিকার উপাদানগুলি ঠিক একই কিনা তা তুলনা করে তালিকার ক্ষমতা তুলনা ফলাফলকে প্রভাবিত করে না৷",
  T_48_META_API_1077_P0_D: "তুলনা করার জন্য ব্যবহৃত মান তালিকা করুন",
  T_48_META_API_1077_P1_D: "তুলনা করার জন্য ব্যবহৃত rvalues তালিকা করুন",
  T_48_META_API_1077_R_D: "ফলাফলের তুলনা, বিষয়বস্তু সামঞ্জস্যপূর্ণ হলে, সত্য ফেরত দেওয়া হবে;",
  T_48_META_API_1078_D: "নির্দিষ্ট স্ট্রিংটিকে ডিলিমিটার হিসাবে ব্যবহার করে, টার্গেট স্ট্রিংটিকে কয়েকটি স্লাইসে কাটুন এবং একটি নতুন স্ট্রিং আউটপুট করুন N-1 অর্ধ-প্রস্থ স্পেস এবং আউটপুট স্ট্রিং তালিকা উপাদান হিসাবে।",
  T_48_META_API_1078_P0_D: "লক্ষ্য স্ট্রিং",
  T_48_META_API_1078_P1_D: "ডিলিমিটার স্ট্রিং",
  T_48_META_API_1078_R_D: "আউটপুট স্ট্রিং তালিকা সর্বদা একটি অর্ধ-প্রস্থ স্পেস উপাদান দিয়ে শেষ হয়।",
  T_48_META_API_1079_D: "স্ট্রিং পজিশন লিস্ট অনুযায়ী অক্ষর বের করুন এবং একটি নতুন স্ট্রিং আউটপুটে তাদের একত্রিত করুন",
  T_48_META_API_1079_P0_D: "লক্ষ্য স্ট্রিং",
  T_48_META_API_1079_P1_D: "স্ট্রিং অবস্থানের তালিকা, স্ট্রিং অবস্থানগুলি 0 থেকে শুরু করে গণনা করা হয়",
  T_48_META_API_1079_R_D: "আউটপুট স্ট্রিং",
  T_48_META_API_1080_D: "টার্গেট স্ট্রিং অক্ষরকে সব বড় হাতের অক্ষরে রূপান্তর করুন",
  T_48_META_API_1080_P0_D: "লক্ষ্য স্ট্রিং",
  T_48_META_API_1080_R_D: "আউটপুট স্ট্রিং",
  T_48_META_API_1081_D: "সমস্ত টার্গেট স্ট্রিং অক্ষরকে ছোট হাতের অক্ষরে রূপান্তর করুন",
  T_48_META_API_1081_P0_D: "লক্ষ্য স্ট্রিং",
  T_48_META_API_1081_R_D: "আউটপুট স্ট্রিং",
  T_48_META_API_1082_D: "প্রথম নন-স্পেস ক্যারেক্টারের আগে এবং টার্গেট স্ট্রিংয়ের শেষ নন-স্পেস ক্যারেক্টারের পরে সমস্ত স্পেস মুছে ফেলুন",
  T_48_META_API_1082_P0_D: "লক্ষ্য স্ট্রিং",
  T_48_META_API_1082_R_D: "আউটপুট স্ট্রিং",
  T_48_META_API_1083_D: "নির্দিষ্ট শনাক্তকারীর সাথে লিঙ্ক করার পরে একটি নতুন স্ট্রিং আউটপুট করে",
  T_48_META_API_1083_P0_D: "লক্ষ্য স্ট্রিং তালিকা",
  T_48_META_API_1083_P1_D: "স্ট্রিং সংযুক্ত করতে ব্যবহৃত নির্দিষ্ট শনাক্তকারী",
  T_48_META_API_1083_R_D: "আউটপুট স্ট্রিং",
  T_48_META_API_1084_D: "র‍্যাঙ্কিং ডেটা টেবিলে নির্দিষ্ট শনাক্তকারীর সাথে সম্পর্কিত মানটি লিখুন",
  T_48_META_API_1084_P0_D: "ডাটাবেসে র‌্যাঙ্কিং টেবিলের নাম",
  T_48_META_API_1084_P1_D: "শনাক্তকারী নির্দিষ্ট করুন",
  T_48_META_API_1084_P2_D: "মান লিখিত",
  T_48_META_API_1084_P3_D: "ডাটাবেসের সাথে সম্পর্কিত যুদ্ধক্ষেত্রের কোড, যা শূন্যস্থান পূরণ করা যেতে পারে, বর্তমান মানচিত্রের যুদ্ধক্ষেত্রের কোডকে প্রতিনিধিত্ব করে।",
  T_48_META_API_1084_P4_D: "ত্রুটি কোড",
  T_48_META_API_1085_D: "ক্রমবর্ধমান ডেটা টেবিলে নির্দিষ্ট শনাক্তকারীর সাথে সম্পর্কিত অফসেট মান লিখুন",
  T_48_META_API_1085_P0_D: "ডাটাবেসে জমে থাকা ডেটা টেবিলের নাম",
  T_48_META_API_1085_P1_D: "শনাক্তকারী নির্দিষ্ট করুন",
  T_48_META_API_1085_P2_D: "চার ধরনের গাণিতিক ক্রিয়াকলাপ",
  T_48_META_API_1085_P3_D: "অফসেট মান লেখা",
  T_48_META_API_1085_P4_D: "ডাটাবেসের সাথে সম্পর্কিত যুদ্ধক্ষেত্রের কোড, যা শূন্যস্থান পূরণ করা যেতে পারে, বর্তমান মানচিত্রের যুদ্ধক্ষেত্রের কোডকে প্রতিনিধিত্ব করে।",
  T_48_META_API_1085_P5_D: "ত্রুটি কোড",
  T_48_META_API_1086_D: "ডেটা টেবিলে নির্দিষ্ট শনাক্তকারীর সাথে সম্পর্কিত মানটি মুছুন",
  T_48_META_API_1086_P0_D: "ডাটাবেসে টেবিলের নাম",
  T_48_META_API_1086_P1_D: "প্লেয়ার ইউনিক আইডি",
  T_48_META_API_1086_P2_D: "শনাক্তকারী নির্দিষ্ট করুন",
  T_48_META_API_1086_P3_D: "ডাটাবেসের সাথে সম্পর্কিত যুদ্ধক্ষেত্রের কোড, যা শূন্যস্থান পূরণ করা যেতে পারে, বর্তমান মানচিত্রের যুদ্ধক্ষেত্রের কোডকে প্রতিনিধিত্ব করে।",
  T_48_META_API_1086_P4_D: "ত্রুটি কোড",
  T_48_META_API_1087_D: "র‍্যাঙ্কিং ডেটা টেবিলে নির্দিষ্ট শনাক্তকারীর সাথে সম্পর্কিত মানটি মুছুন",
  T_48_META_API_1087_P0_D: "ডাটাবেসে র‌্যাঙ্কিং টেবিলের নাম",
  T_48_META_API_1087_P1_D: "শনাক্তকারী নির্দিষ্ট করুন",
  T_48_META_API_1087_P2_D: "ডাটাবেসের সাথে সম্পর্কিত যুদ্ধক্ষেত্রের কোড, যা শূন্যস্থান পূরণ করা যেতে পারে, বর্তমান মানচিত্রের যুদ্ধক্ষেত্রের কোডকে প্রতিনিধিত্ব করে।",
  T_48_META_API_1087_P3_D: "ত্রুটি কোড",
  T_48_META_API_1088_D: "র‌্যাঙ্কিং ডেটা টেবিলে নির্দিষ্ট র‌্যাঙ্কিংয়ের সাথে সম্পর্কিত মানটি মুছুন",
  T_48_META_API_1088_P0_D: "ডাটাবেসে র‌্যাঙ্কিং টেবিলের নাম",
  T_48_META_API_1088_P1_D: "র‌্যাঙ্কিং উল্লেখ করুন",
  T_48_META_API_1088_P2_D: "ডাটাবেসের সাথে সম্পর্কিত যুদ্ধক্ষেত্রের কোড, যা শূন্যস্থান পূরণ করা যেতে পারে, বর্তমান মানচিত্রের যুদ্ধক্ষেত্রের কোডকে প্রতিনিধিত্ব করে।",
  T_48_META_API_1088_P3_D: "ত্রুটি কোড",
  T_48_META_API_1089_D: "Persona ব্যবহারকারী বার্তা পাঠান",
  T_48_META_API_1089_P0_D: "টার্গেট PersonaID",
  T_48_META_API_1089_P1_D: "বার্তা বিষয়বস্তু",
  T_48_META_API_1090_D: "পারসোনায় সিস্টেম বার্তা পাঠান",
  T_48_META_API_1090_P0_D: "টার্গেট PersonaID",
  T_48_META_API_1090_P1_D: "বার্তা বিষয়বস্তু",
  T_48_META_API_1091_D: "পারসোনা মেমরি পরিষ্কার করুন",
  T_48_META_API_1091_P0_D: "ত্রুটি কোড",
  T_48_META_API_1092_D: "জাগানো সদস্য কেন্দ্র",
  T_48_META_API_1092_P0_D: "ত্রুটি কোড",
  T_48_META_API_1093_D: "সদস্যতার মেয়াদ শেষ হওয়ার টাইমস্ট্যাম্প পান",
  T_48_META_API_1093_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_1093_P1_D: "টাইমস্ট্যাম্প",
  T_48_META_API_1093_P2_D: "ত্রুটি কোড",
  T_48_META_API_1094_D: "খেলোয়াড় সদস্য কিনা তা নির্ধারণ করুন",
  T_48_META_API_1094_P0_D: "ত্রুটি কোড",
  T_48_META_API_1094_P1_D: "আপনি কি একজন সদস্য?",
  T_48_META_API_1095_D: "সদস্যতার মেয়াদ শেষ হওয়ার টাইমস্ট্যাম্প পান",
  T_48_META_API_1095_P0_D: "টাইমস্ট্যাম্প",
  T_48_META_API_1095_P1_D: "ত্রুটি কোড",
  T_48_META_API_1096_D: "খেলোয়াড় সদস্য কিনা তা নির্ধারণ করুন",
  T_48_META_API_1096_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_1096_P1_D: "ত্রুটি কোড",
  T_48_META_API_1096_P2_D: "আপনি কি একজন সদস্য?",
  T_48_META_API_1097_D: "জাগানো সদস্য কেন্দ্র",
  T_48_META_API_1097_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_1097_P1_D: "ত্রুটি কোড",
  T_48_META_API_1099_D: "একটি পারসোনা পর্যবেক্ষক সেট আপ করুন, এবং পারসোনার সাথে পরবর্তী কথোপকথনগুলিও পর্যবেক্ষকের কাছে পাঠানো হবে৷",
  T_48_META_API_1099_P0_D: "টার্গেট PersonaID",
  T_48_META_API_1099_P1_D: "পর্যবেক্ষক তালিকা",
  T_48_META_API_11_D: "বর্তমান পর্বটি শেষ করুন এবং পরবর্তী পর্বে প্রবেশ করুন",
  T_48_META_API_1100_D: "স্ট্রিমিং ব্যবহার করে পারসোনায় ব্যবহারকারীর বার্তা পাঠান",
  T_48_META_API_1100_P0_D: "টার্গেট PersonaID",
  T_48_META_API_1100_P1_D: "বার্তা বিষয়বস্তু",
  T_48_META_API_1101_D: "স্ট্রিমিং ব্যবহার করে পারসোনায় সিস্টেম বার্তা পাঠান",
  T_48_META_API_1101_P0_D: "টার্গেট PersonaID",
  T_48_META_API_1101_P1_D: "বার্তা বিষয়বস্তু",
  T_48_META_API_1101_P2_D: "রিপ্লাই দেব কি না",
  T_48_META_API_1103_D: "একটি এলোমেলো বীজ তৈরি করুন",
  T_48_META_API_1103_P0_D: "বীজ",
  T_48_META_API_1103_R_D: "র্যান্ডম নম্বর জেনারেটর",
  T_48_META_API_1104_D: "নির্দিষ্ট র্যান্ডম নম্বর জেনারেটর থেকে পরবর্তী র্যান্ডম নম্বর পান, সর্বোচ্চ মান হল 32767",
  T_48_META_API_1104_P0_D: "র্যান্ডম নম্বর জেনারেটর",
  T_48_META_API_1104_P1_D: "সর্বনিম্ন পরিসীমা",
  T_48_META_API_1104_P2_D: "সর্বোচ্চ পরিসীমা",
  T_48_META_API_1104_R_D: "এলোমেলো সংখ্যা",
  T_48_META_API_1108_D: "প্লেয়ার দ্বারা ব্যবহৃত ক্লায়েন্ট ভাষা পান",
  T_48_META_API_12_D: "কনসোলে লগ প্রিন্ট করুন",
  T_48_META_API_12_P0_D: "কি প্রিন্ট করা প্রয়োজন",
  T_48_META_API_13_D: "প্যারামিটার সহ একটি স্ট্রিং আউটপুট করুন",
  T_48_META_API_13_P0_D: "একটি পরামিতি উপস্থাপন করতে %v স্থানধারক ব্যবহার করুন %v সংখ্যা এবং পরামিতিগুলির সংখ্যা সামঞ্জস্যপূর্ণ হওয়া প্রয়োজন।",
  T_48_META_API_13_P1_D: "আউটপুটে অংশগ্রহণকারী প্যারামিটার তালিকা ফরম্যাটের বিবরণে %v সংখ্যার সাথে সামঞ্জস্যপূর্ণ হওয়া প্রয়োজন।",
  T_48_META_API_13_R_D: "আউটপুট স্ট্রিং",
  T_48_META_API_14_D: "ডেথ বাক্স, তৈরি বস্তু, স্থাপন করা বস্তু, প্রক্ষিপ্ত অবশিষ্টাংশ ইত্যাদি সহ মানচিত্রের অবজেক্টের অবশিষ্টাংশগুলি পরিষ্কার করুন।",
  T_48_META_API_15_D: "ব্যবহারকারীর অভিজ্ঞতা ডেটা বিশ্লেষণের জন্য প্রতিযোগিতার পয়েন্ট লগ কাস্টমাইজ করুন",
  T_48_META_API_15_P0_D: "রিপোর্ট করা ক্ষেত্রের নামের তালিকা",
  T_48_META_API_15_P1_D: "রিপোর্ট করা ক্ষেত্র মান তালিকা",
  T_48_META_API_1500_D: "একটি ত্রিমাত্রিক ভেক্টরের X উপাদান পান",
  T_48_META_API_1500_P0_D: "3D ভেক্টর",
  T_48_META_API_1500_R_D: "ত্রিমাত্রিক ভেক্টর X উপাদান",
  T_48_META_API_1501_D: "একটি ত্রিমাত্রিক ভেক্টরের Y উপাদান পান",
  T_48_META_API_1501_P0_D: "3D ভেক্টর",
  T_48_META_API_1501_R_D: "ত্রিমাত্রিক ভেক্টর Y উপাদান",
  T_48_META_API_1502_D: "একটি ত্রিমাত্রিক ভেক্টরের Z উপাদান পান",
  T_48_META_API_1502_P0_D: "3D ভেক্টর",
  T_48_META_API_1502_R_D: "ত্রিমাত্রিক ভেক্টর Z উপাদান",
  T_48_META_API_1503_D: "একটি ত্রিমাত্রিক ভেক্টরের X উপাদান সেট করে",
  T_48_META_API_1503_P0_D: "3D ভেক্টর",
  T_48_META_API_1503_P1_D: "X উপাদান",
  T_48_META_API_1504_D: "একটি ত্রিমাত্রিক ভেক্টরের Y উপাদান সেট করে",
  T_48_META_API_1504_P0_D: "3D ভেক্টর",
  T_48_META_API_1504_P1_D: "Y উপাদান",
  T_48_META_API_1505_D: "একটি ত্রিমাত্রিক ভেক্টরের Z উপাদান সেট করে",
  T_48_META_API_1505_P0_D: "3D ভেক্টর",
  T_48_META_API_1505_P1_D: "Z উপাদান",
  T_48_META_API_1506_D: "দুটি ত্রিমাত্রিক ভেক্টর যোগ করুন",
  T_48_META_API_1506_P0_D: "বাম অপারেন্ড",
  T_48_META_API_1506_P1_D: "ডান অপারেন্ড",
  T_48_META_API_1506_R_D: "ত্রিমাত্রিক ভেক্টর সংযোজন ফলাফল",
  T_48_META_API_1507_D: "দুটি ত্রিমাত্রিক ভেক্টর বিয়োগ করুন",
  T_48_META_API_1507_P0_D: "বাম অপারেন্ড",
  T_48_META_API_1507_P1_D: "ডান অপারেন্ড",
  T_48_META_API_1507_R_D: "একটি ত্রিমাত্রিক ভেক্টরের lvalue থেকে rvalue বিয়োগ করার ফলাফল",
  T_48_META_API_1508_D: "একটি ত্রিমাত্রিক ভেক্টর স্কেলিং",
  T_48_META_API_1508_P0_D: "3D ভেক্টর স্কেল করা হবে",
  T_48_META_API_1508_P1_D: "3D ভেক্টর স্কেলিং পরিমাণ",
  T_48_META_API_1508_R_D: "3D ভেক্টর স্কেলিং ফলাফল",
  T_48_META_API_1509_D: "ডট পণ্য দুটি ত্রিমাত্রিক ভেক্টর, ডট পণ্যের ফলাফল একটি স্কেলার",
  T_48_META_API_1509_P0_D: "বাম অপারেন্ড",
  T_48_META_API_1509_P1_D: "ডান অপারেন্ড",
  T_48_META_API_1509_R_D: "ডট গুণের ফলাফল",
  T_48_META_API_1510_D: "দুইটি ত্রিমাত্রিক ভেক্টরকে ক্রস-গুণিত করার ফলাফল হল একটি ভেক্টর, যেখানে দুটি ভেক্টর অবস্থিত।",
  T_48_META_API_1510_P0_D: "বাম অপারেন্ড",
  T_48_META_API_1510_P1_D: "ডান অপারেন্ড",
  T_48_META_API_1510_R_D: "ক্রস পণ্যের ফলাফল, দিকটি সমতলের লম্ব যেখানে অপারেশনে জড়িত দুটি ভেক্টর অবস্থিত।",
  T_48_META_API_1511_D: "ত্রিমাত্রিক ভেক্টরকে স্বাভাবিক করুন",
  T_48_META_API_1511_P0_D: "3D ভেক্টর",
  T_48_META_API_1511_R_D: "একটি নতুন স্বাভাবিক ভেক্টর প্রদান করে। ছাঁচের দৈর্ঘ্য 1",
  T_48_META_API_1512_D: "একটি ত্রিমাত্রিক ভেক্টর মডিউল",
  T_48_META_API_1512_P0_D: "3D ভেক্টর",
  T_48_META_API_1512_R_D: "মডুলোর ফলাফল হল ভেক্টর মডুলাসের দৈর্ঘ্য",
  T_48_META_API_1513_D: "দুটি ত্রিমাত্রিক ভেক্টরের ইউক্লিডীয় দূরত্ব গণনা করুন",
  T_48_META_API_1513_P0_D: "বাম অপারেন্ড",
  T_48_META_API_1513_P1_D: "ডান অপারেন্ড",
  T_48_META_API_1513_R_D: "দুটি ভেক্টর বিয়োগ করার পরে, ফলে ভেক্টরের মডিউল দৈর্ঘ্য",
  T_48_META_API_1514_D: "দুটি ত্রিমাত্রিক ভেক্টরের মধ্যে কোণ গণনা করুন",
  T_48_META_API_1514_P0_D: "বাম অপারেন্ড",
  T_48_META_API_1514_P1_D: "ডান অপারেন্ড",
  T_48_META_API_1514_R_D: "ভেক্টর কোণ, কোণের পরিসীমা 0-180",
  T_48_META_API_1515_D: "একটি 3D ভেক্টর তৈরি করুন",
  T_48_META_API_1515_P0_D: "একটি ত্রিমাত্রিক ভেক্টরের X উপাদান",
  T_48_META_API_1515_P1_D: "একটি ত্রিমাত্রিক ভেক্টরের Y উপাদান",
  T_48_META_API_1515_P2_D: "একটি ত্রিমাত্রিক ভেক্টরের Z উপাদান",
  T_48_META_API_1515_R_D: "ত্রিমাত্রিক ভেক্টর তৈরি করেছে",
  T_48_META_API_1516_D: "একটি সদ্য নির্মিত দিকনির্দেশ বিন্দু পান (অপ্রচলিত, ব্যবহার করবেন না)",
  T_48_META_API_1516_P0_D: "অবস্থান",
  T_48_META_API_1516_P1_D: "দিকে",
  T_48_META_API_1516_R_D: "ডাইরেক্টপয়েন্ট",
  T_48_META_API_1517_D: "দিক বিন্দু অবস্থান পান (অপ্রচলিত, দয়া করে ব্যবহার করবেন না)",
  T_48_META_API_1517_P0_D: "দিক বিন্দু",
  T_48_META_API_1517_R_D: "অবস্থান",
  T_48_META_API_1518_D: "দিক বিন্দুর অভিযোজন পান (অপ্রচলিত, দয়া করে ব্যবহার করবেন না)",
  T_48_META_API_1518_P0_D: "দিক বিন্দু",
  T_48_META_API_1518_R_D: "ফরোয়ার্ড",
  T_48_META_API_1519_D: "একটি তালিকা তৈরি করুন",
  T_48_META_API_1519_P0_D: "তালিকার প্রাথমিক দৈর্ঘ্য প্রাথমিক ক্ষমতার কম বা সমান হতে হবে",
  T_48_META_API_1519_P1_D: "তালিকার প্রাথমিক ক্ষমতা প্রাথমিক দৈর্ঘ্যের চেয়ে বেশি বা সমান হতে হবে। ক্ষমতা গতিশীলভাবে প্রসারিত করা যেতে পারে, কিন্তু এটি একটি নির্দিষ্ট পরিমাণ কর্মক্ষমতা গ্রাস করবে নির্মাণ করার সময় এটি একটি উপযুক্ত মান সেট করার সুপারিশ করা হয়।",
  T_48_META_API_1519_R_D: "তালিকা তৈরি করা হয়েছে",
  T_48_META_API_1520_D: "তালিকায় নির্দিষ্ট উপাদান আছে কিনা তা পরীক্ষা করে",
  T_48_META_API_1520_P0_D: "লক্ষ্য তালিকা",
  T_48_META_API_1520_P1_D: "পরীক্ষা করার জন্য নির্দিষ্ট উপাদান",
  T_48_META_API_1520_R_D: "নির্দিষ্ট উপাদান ধারণ করতে হবে কিনা",
  T_48_META_API_1521_D: "লক্ষ্য তালিকার শেষে একাধিক উপাদান যুক্ত করুন",
  T_48_META_API_1521_P0_D: "লক্ষ্য তালিকা",
  T_48_META_API_1521_P1_D: "তালিকা যোগ করুন",
  T_48_META_API_1522_D: "তালিকা থেকে নির্দিষ্ট উপাদান সরিয়ে দেয়",
  T_48_META_API_1522_P0_D: "লক্ষ্য তালিকা",
  T_48_META_API_1522_P1_D: "উপাদান মান অপসারণ",
  T_48_META_API_1523_D: "পজিশন ইনডেক্স পান যেখানে তালিকার এলিমেন্টটি প্রথম দেখায় যদি তালিকায় কোন টার্গেট এলিমেন্ট না থাকে তাহলে -1 রিটার্ন করা হবে।",
  T_48_META_API_1523_P0_D: "লক্ষ্য তালিকা",
  T_48_META_API_1523_P1_D: "উপাদান মান",
  T_48_META_API_1523_R_D: "অবস্থান সূচক",
  T_48_META_API_1524_D: "তালিকায় কোন টার্গেট এলিমেন্ট না থাকলে, -1 প্রদান করা হয়।",
  T_48_META_API_1524_P0_D: "লক্ষ্য তালিকা",
  T_48_META_API_1524_P1_D: "উপাদান মান",
  T_48_META_API_1524_R_D: "অবস্থান সূচক",
  T_48_META_API_1525_D: "একটি কোণের সাইন খুঁজুন",
  T_48_META_API_1525_P0_D: "কোণ, 360 360 ডিগ্রী প্রতিনিধিত্ব করে",
  T_48_META_API_1525_R_D: "সাইন মান",
  T_48_META_API_1526_D: "একটি কোণের কোসাইন খুঁজুন",
  T_48_META_API_1526_P0_D: "কোণ, 360 360 ডিগ্রী প্রতিনিধিত্ব করে",
  T_48_META_API_1526_R_D: "কোসাইন",
  T_48_META_API_1527_D: "একটি কোণের স্পর্শক নির্ণয় কর",
  T_48_META_API_1527_P0_D: "কোণ, 360 360 ডিগ্রী প্রতিনিধিত্ব করে",
  T_48_META_API_1527_R_D: "স্পর্শক",
  T_48_META_API_1528_D: "255 এ স্থির স্বচ্ছতার সাথে একটি রঙের মান তৈরি করুন। প্রথমে প্রতিটি 8 বিট একটি চ্যানেলকে R, G, B এবং ট্রান্সপারেন্সিতে রূপান্তর করুন এটা ফেরত দাও",
  T_48_META_API_1528_P0_D: "রঙের লাল চ্যানেল মান, মান পরিসীমা হল [0,255] যদি এটি পরিসীমা অতিক্রম করে, তাহলে এটি একটি আইনি মানের সাথে আটকে যাবে।",
  T_48_META_API_1528_P1_D: "রঙের সবুজ চ্যানেল মান, মান পরিসীমা হল [0,255] যদি এটি পরিসীমা অতিক্রম করে, তাহলে এটি একটি আইনি মানের সাথে আটকে যাবে।",
  T_48_META_API_1528_P2_D: "রঙের নীল চ্যানেল মান, মান পরিসীমা হল [0,255] যদি এটি পরিসীমা অতিক্রম করে, তাহলে এটি একটি আইনি মানের সাথে আটকে যাবে।",
  T_48_META_API_1528_R_D: "নির্মিত রঙের মান",
  T_48_META_API_1529_D: "কোণ পেতে arcsine অপারেশন সঞ্চালন",
  T_48_META_API_1529_P0_D: "আর্কসিন অপারেশনের মান, মান পরিসীমা হল [-1,1]",
  T_48_META_API_1529_R_D: "কোণ",
  T_48_META_API_1530_D: "কোণ পেতে আর্ক কোসাইন অপারেশন সঞ্চালন করুন",
  T_48_META_API_1530_P0_D: "আর্ক কোসাইন অপারেশনের মান, মান পরিসীমা হল [-1,1]",
  T_48_META_API_1530_R_D: "কোণ",
  T_48_META_API_1531_D: "কোণ পেতে arctangent অপারেশন সঞ্চালন",
  T_48_META_API_1531_P0_D: "আর্কটেনজেন্ট অপারেশন সঞ্চালনের মান",
  T_48_META_API_1531_R_D: "কোণ",
  T_48_META_API_1532_D: "লক্ষ্য সত্তা নির্দিষ্ট গোলক সীমার মধ্যে আছে কিনা তা নির্ধারণ করুন যদি সত্তার একটি অবস্থান বৈশিষ্ট্য না থাকে, তাহলে মিথ্যা ফেরত দেওয়া হবে।",
  T_48_META_API_1532_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_1532_P1_D: "গোলকের কেন্দ্র নির্দিষ্ট করে",
  T_48_META_API_1532_P2_D: "গোলকের ব্যাসার্ধ নির্দিষ্ট করে",
  T_48_META_API_1532_R_D: "রায়ের ফলাফল",
  T_48_META_API_1533_D: "লক্ষ্য সত্তা নির্দিষ্ট সিলিন্ডার সীমার মধ্যে আছে কিনা তা নির্ধারণ করুন যদি সত্তার একটি অবস্থান বৈশিষ্ট্য না থাকে, তাহলে মিথ্যা ফেরত দেওয়া হবে।",
  T_48_META_API_1533_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_1533_P1_D: "সিলিন্ডারের কেন্দ্র বিন্দু নির্দিষ্ট করে",
  T_48_META_API_1533_P2_D: "সিলিন্ডারের ক্রস-বিভাগীয় ব্যাসার্ধ নির্দিষ্ট করে",
  T_48_META_API_1533_P3_D: "সিলিন্ডারের উচ্চতা নির্দিষ্ট করে",
  T_48_META_API_1533_P4_D: "কেন্দ্র বিন্দুর চারপাশে সিলিন্ডারের ঘূর্ণনের ত্রিমাত্রিক অয়লার কোণ নির্দিষ্ট করে",
  T_48_META_API_1533_R_D: "রায়ের ফলাফল",
  T_48_META_API_1534_D: "লক্ষ্য সত্তা নির্দিষ্ট ঘনক্ষেত্র পরিসরের মধ্যে কিনা তা নির্ধারণ করুন",
  T_48_META_API_1534_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_1534_P1_D: "ঘনক্ষেত্রের কেন্দ্রবিন্দু নির্দিষ্ট করে",
  T_48_META_API_1534_P2_D: "ঘনক্ষেত্রের দৈর্ঘ্য নির্দিষ্ট করে",
  T_48_META_API_1534_P3_D: "ঘনক্ষেত্রের প্রস্থ নির্দিষ্ট করে",
  T_48_META_API_1534_P4_D: "ঘনক্ষেত্রের উচ্চতা নির্দিষ্ট করে",
  T_48_META_API_1534_P5_D: "কেন্দ্র বিন্দুর চারপাশে ঘনকের ত্রিমাত্রিক ঘূর্ণন অয়লার কোণ নির্দিষ্ট করে",
  T_48_META_API_1534_R_D: "রায়ের ফলাফল",
  T_48_META_API_1535_D: "লক্ষ্য সত্তা নির্দিষ্ট সেক্টর সিলিন্ডার সীমার মধ্যে কিনা তা নির্ধারণ করুন",
  T_48_META_API_1535_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_1535_P1_D: "সেক্টর-আকৃতির সিলিন্ডারের মধ্য-বিভাগের কেন্দ্র নির্দিষ্ট করে",
  T_48_META_API_1535_P2_D: "সেক্টর-আকৃতির সিলিন্ডারের মধ্য-বিভাগের ব্যাসার্ধ নির্দিষ্ট করে",
  T_48_META_API_1535_P3_D: "সেক্টর-আকৃতির সিলিন্ডারের ক্রস-সেকশন ব্যাসার্ধ যা পরীক্ষা করা হয়নি, বৃত্তের কেন্দ্র হিসাবে কেন্দ্র বিন্দু সহ, ছোট সেক্টর-আকৃতির সিলিন্ডার এলাকা পরীক্ষা করা হবে না, শুধুমাত্র নির্দিষ্ট সেক্টর-আকৃতির সিলিন্ডারের মধ্যে পার্থক্য এবং ছোট সেক্টর আকৃতির থিম সনা",
  T_48_META_API_1535_P4_D: "সেক্টর সিলিন্ডারের উচ্চতা নির্দিষ্ট করে",
  T_48_META_API_1535_P5_D: "শনাক্তকরণের জন্য সেক্টর-আকৃতির সিলিন্ডারের অংশের কেন্দ্রীয় কোণ যদি 360-এর বেশি হয়, তাহলে এটি 0-এর কম হলে, সনাক্তকরণ এলাকার আকার 0 হবে।",
  T_48_META_API_1535_P6_D: "কেন্দ্র বিন্দুর চারপাশে সেক্টর সিলিন্ডারের ঘূর্ণনের ত্রিমাত্রিক অয়লার কোণ নির্দিষ্ট করে",
  T_48_META_API_1535_R_D: "রায়ের ফলাফল",
  T_48_META_API_1536_D: "দুটি সংখ্যার মান তুলনা করে এবং বড়টি প্রদান করে",
  T_48_META_API_1536_P0_D: "বাম অপারেন্ড",
  T_48_META_API_1536_P1_D: "ডান অপারেন্ড",
  T_48_META_API_1536_R_D: "বড় সংখ্যা",
  T_48_META_API_1537_D: "তালিকার সর্বোচ্চ মান প্রদান করে",
  T_48_META_API_1537_P0_D: "লক্ষ্য তালিকা, শুধুমাত্র তালিকা উপাদান প্রকার সংখ্যা হিসাবে গ্রহণ করে",
  T_48_META_API_1537_P1_D: "তুলনার ফলাফল তালিকায় অ-সংখ্যা থাকলে, তুলনা ব্যর্থ হয় এবং মিথ্যা দেখায়।",
  T_48_META_API_1537_P2_D: "তুলনা সফল হলে তালিকার সবচেয়ে বড় মান প্রদান করে এবং তুলনা ব্যর্থ হলে 0 প্রদান করে।",
  T_48_META_API_1538_D: "দুটি সংখ্যার মান তুলনা করে এবং ছোটটি প্রদান করে",
  T_48_META_API_1538_P0_D: "বাম অপারেন্ড",
  T_48_META_API_1538_P1_D: "ডান অপারেন্ড",
  T_48_META_API_1538_R_D: "ছোট সংখ্যা",
  T_48_META_API_1539_D: "তালিকার সর্বনিম্ন মান প্রদান করে।",
  T_48_META_API_1539_P0_D: "লক্ষ্য তালিকা, শুধুমাত্র তালিকা উপাদান প্রকার সংখ্যা হিসাবে গ্রহণ করে",
  T_48_META_API_1539_P1_D: "তুলনার ফলাফল তালিকায় অ-সংখ্যা থাকলে, তুলনা ব্যর্থ হয় এবং মিথ্যা দেখায়।",
  T_48_META_API_1539_P2_D: "তুলনা সফল হলে তালিকার ক্ষুদ্রতম মান প্রদান করে এবং তুলনা ব্যর্থ হলে 0 প্রদান করে।",
  T_48_META_API_1540_D: "রৈখিক ইন্টারপোলেশন, প্রারম্ভিক মান এবং লক্ষ্য মানের মধ্যে ইন্টারপোলেশন অগ্রগতির সাথে সম্পর্কিত মান প্রদান করে, ইন্টারপোলেশন সহগ [0,1]",
  T_48_META_API_1540_P0_D: "লিনিয়ার ইন্টারপোলেশনের প্রারম্ভিক মান যখন ইন্টারপোলেশন অগ্রগতি 0 হয় তখন এই মানটি ফেরত দেওয়া হয়।",
  T_48_META_API_1540_P1_D: "রৈখিক ইন্টারপোলেশন লক্ষ্য মান, এই মানটি ফেরত দেওয়া হয় যখন ইন্টারপোলেশন অগ্রগতি 1 হয়",
  T_48_META_API_1540_P2_D: "ইন্টারপোলেশন অগ্রগতি, মান পরিসীমা [0,1], যখন মান 0 হয়, শুরুর মান ফেরত দেওয়া হয়, যখন মান 1 হয়, লক্ষ্য মান ফেরত দেওয়া হয়, যখন মান 0.5 হয়, শুরুর মানের গড় এবং লক্ষ্য মান ফেরত দেওয়া হয়",
  T_48_META_API_1540_R_D: "লিনিয়ার ইন্টারপোলেশন রিটার্ন মান",
  T_48_META_API_1541_D: "লক্ষ্য মানের পরিসীমা সীমিত করুন এবং তিনটি ইনপুট প্যারামিটারের মধ্যে মধ্যম মান অর্জন করুন; টার্গেট মান সর্বোচ্চ মানের থেকে বড়, পরিসরে থাকাকালীন সর্বোচ্চ মান ফেরত দেওয়া হবে",
  T_48_META_API_1541_P0_D: "লক্ষ্য মান",
  T_48_META_API_1541_P1_D: "সীমিত পরিসরের সর্বনিম্ন মান",
  T_48_META_API_1541_P2_D: "সীমিত পরিসরের সর্বোচ্চ মান",
  T_48_META_API_1541_R_D: "সীমাবদ্ধতার পরে মান ফেরত দিন",
  T_48_META_API_1542_D: "লক্ষ্য রঙের চ্যানেল মান পান",
  T_48_META_API_1542_P0_D: "লক্ষ্য রঙ",
  T_48_META_API_1542_P1_D: "রঙের R মান, পরিসর [0, 255]",
  T_48_META_API_1542_P2_D: "রঙের G মান, পরিসর [0, 255]",
  T_48_META_API_1542_P3_D: "রঙের B মান, পরিসর [0, 255]",
  T_48_META_API_1542_P4_D: "রঙের একটি মান, পরিসর [0, 255]",
  T_48_META_API_1543_D: "ব্যাখ্যা",
  T_48_META_API_1543_P0_D: "ভিত্তি",
  T_48_META_API_1543_P1_D: "সূচক",
  T_48_META_API_1543_R_D: "গণনার ফলাফল",
  T_48_META_API_1544_D: "লগারিদমিক অপারেশন",
  T_48_META_API_1544_P0_D: "ভিত্তি",
  T_48_META_API_1544_P1_D: "প্রকৃত সংখ্যা",
  T_48_META_API_1544_R_D: "গণনার ফলাফল",
  T_48_META_API_1545_D: "অয়লার কোণ থেকে দিকনির্দেশ ভেক্টর",
  T_48_META_API_1545_P0_D: "দিক ভেক্টর",
  T_48_META_API_1545_R_D: "অয়লার কোণ",
  T_48_META_API_1546_D: "অয়লার কোণ ঘূর্ণন দিক ভেক্টর",
  T_48_META_API_1546_P0_D: "অয়লার কোণ",
  T_48_META_API_1546_R_D: "দিক ভেক্টর",
  T_48_META_API_1547_D: "ফ্লোটিং পয়েন্ট নম্বর থেকে পূর্ণসংখ্যা",
  T_48_META_API_1547_P0_D: "পূর্ণসংখ্যা",
  T_48_META_API_1547_R_D: "ভাসমান পয়েন্ট সংখ্যা",
  T_48_META_API_1548_D: "quaternion অনুযায়ী লক্ষ্য ভেক্টর ঘোরান",
  T_48_META_API_1548_P0_D: "লক্ষ্য ভেক্টর",
  T_48_META_API_1548_P1_D: "Quaternion ঘোরান",
  T_48_META_API_1548_R_D: "ঘোরানো ভেক্টর",
  T_48_META_API_1549_D: "টার্গেট নম্বরকে স্ট্রিংয়ে রূপান্তর করুন",
  T_48_META_API_1549_P0_D: "একটি স্ট্রিং এ রূপান্তরিত করা লক্ষ্য সংখ্যা",
  T_48_META_API_1549_P1_D: "আউটপুট সংখ্যাসূচক স্ট্রিং বিন্যাস",
  T_48_META_API_1549_R_D: "স্ট্রিং",
  T_48_META_API_1598_D: "সার্ভার টাইমস্ট্যাম্প পান",
  T_48_META_API_1598_R_D: "জানুয়ারী 1, 1970 তারিখে 0:00:00 থেকে সেকেন্ডের সংখ্যা প্রদান করে",
  T_48_META_API_1599_D: "সার্ভার এলাকা পান",
  T_48_META_API_1599_R_D: "অঞ্চলের সংক্ষিপ্ত রূপ প্রদান করে (BR, SAC, ID, NA, US, IND, SG, BD, VN, TH, ME, RU, EU, PK, TW)",
  T_48_META_API_16_D: "ব্যবহারকারীর অভিজ্ঞতা ডেটা বিশ্লেষণের জন্য কাস্টমাইজড ব্যবহারকারী ট্র্যাকিং লগ",
  T_48_META_API_16_P0_D: "খেলোয়াড়দের রিপোর্ট করা",
  T_48_META_API_16_P1_D: "রিপোর্ট করা ক্ষেত্রের নামের তালিকা",
  T_48_META_API_16_P2_D: "রিপোর্ট করা ক্ষেত্র মান তালিকা",
  T_48_META_API_1601_D: "একটি অভিধান তৈরি করুন",
  T_48_META_API_1601_R_D: "অভিধান তৈরি করেছে",
  T_48_META_API_1602_D: "অভিধানে নির্দিষ্ট কী এর সাথে সম্পর্কিত মান পান",
  T_48_META_API_1602_P0_D: "লক্ষ্য অভিধান",
  T_48_META_API_1602_P1_D: "কী",
  T_48_META_API_1602_R_D: "মান",
  T_48_META_API_1603_D: "অভিধানে নির্দিষ্ট কী-এর সাথে সম্পর্কিত মান সেট করে",
  T_48_META_API_1603_P0_D: "লক্ষ্য অভিধান",
  T_48_META_API_1603_P1_D: "কী",
  T_48_META_API_1603_P2_D: "মান",
  T_48_META_API_1604_D: "অভিধান থেকে নির্দিষ্ট কী-মান জোড়া সরান",
  T_48_META_API_1604_P0_D: "লক্ষ্য অভিধান",
  T_48_META_API_1604_P1_D: "কী",
  T_48_META_API_1605_D: "অভিধানে সমস্ত কী-মান জোড়া সাফ করুন",
  T_48_META_API_1605_P0_D: "লক্ষ্য অভিধান",
  T_48_META_API_1606_D: "অভিধানে কী-মান জোড়ার সংখ্যা পান",
  T_48_META_API_1606_P0_D: "লক্ষ্য অভিধান",
  T_48_META_API_1606_R_D: "অভিধানের দৈর্ঘ্য",
  T_48_META_API_1607_D: "অভিধানে একটি কী বিদ্যমান কিনা তা নির্ধারণ করুন",
  T_48_META_API_1607_P0_D: "লক্ষ্য অভিধান",
  T_48_META_API_1607_P1_D: "কী",
  T_48_META_API_1607_R_D: "বিদ্যমান আছে কি",
  T_48_META_API_1608_D: "অভিধানের সমস্ত কী পায়, একটি তালিকা হিসাবে ফিরে আসে",
  T_48_META_API_1608_P0_D: "লক্ষ্য অভিধান",
  T_48_META_API_1608_R_D: "সমস্ত মূল মানের তালিকা",
  T_48_META_API_17_D: "সনাক্তকরণের জন্য রৈখিক গতির একটি বাক্স-আকৃতির এলাকা ব্যবহার করুন এবং কাছাকাছি থেকে বক্স-আকৃতির অঞ্চলের রুটে সম্মুখীন হওয়া সমস্ত সত্তাগুলিকে ফিরিয়ে দিন যদি তারা প্রাথমিকভাবে বাক্স-আকৃতির সীমার মধ্যে থাকে তবে সেগুলি সনাক্ত করা হবে না; যদি অনুক্রমিক পরামিতিগুলি শূন্যস্থানে পূরণ করা হয়, সেগুলি ভূখণ্ড সনাক্ত করা যেতে পারে",
  T_48_META_API_17_P0_D: "বক্স এলাকার তিন দিকের দৈর্ঘ্যের অর্ধেক, শুধুমাত্র ইতিবাচক মান গ্রহণ করা হয়",
  T_48_META_API_17_P1_D: "বক্স এলাকার কেন্দ্র বিন্দু",
  T_48_META_API_17_P2_D: "বক্স এলাকা ঘূর্ণন",
  T_48_META_API_17_P3_D: "বক্স এলাকা ভ্রমণ দিক",
  T_48_META_API_17_P4_D: "বক্স এলাকা ভ্রমণ দূরত্ব, শুধুমাত্র ইতিবাচক মান গ্রহণ করা হয়",
  T_48_META_API_17_P5_D: "লেয়ার মাস্ক, শুধুমাত্র ভরা লেয়ারগুলোই স্ক্যানে অংশ নেবে, ফাঁকা রাখলে সব লেয়ার স্ক্যানে অংশগ্রহণ করবে",
  T_48_META_API_17_P6_D: "এটা কি ট্রিগার সনাক্ত করা সম্ভব?",
  T_48_META_API_17_P7_D: "হিট সত্তা তালিকা",
  T_48_META_API_1700_D: "নির্দিষ্ট স্ট্রিংটিকে একটি পূর্ণসংখ্যাতে রূপান্তর করুন",
  T_48_META_API_1700_P0_D: "লক্ষ্য স্ট্রিং",
  T_48_META_API_1700_P1_D: "ফলাফল পূর্ণসংখ্যা",
  T_48_META_API_1700_P2_D: "রূপান্তর সফল হয়?",
  T_48_META_API_1701_D: "নির্দিষ্ট স্ট্রিংটিকে একটি ফ্লোটিং পয়েন্ট নম্বরে রূপান্তর করুন",
  T_48_META_API_1701_P0_D: "লক্ষ্য স্ট্রিং",
  T_48_META_API_1701_P1_D: "ফলাফল ভাসা",
  T_48_META_API_1701_P2_D: "রূপান্তর সফল হয়?",
  T_48_META_API_18_D: "শনাক্তকরণের জন্য একটি সরল-রেখার চলমান গোলাকার এলাকা ব্যবহার করুন এবং গোলাকার অঞ্চলের রুটে আসা সমস্ত সত্তাগুলিকে ফিরিয়ে দিন যদি তারা প্রাথমিকভাবে গোলাকার এলাকায় থাকে, যদি লেভেল প্যারামিটারটি ফাঁকা থাকে , ভূখণ্ড সনাক্ত করা যাবে",
  T_48_META_API_18_P0_D: "গোলাকার এলাকার ব্যাসার্ধ, শুধুমাত্র ইতিবাচক মান গ্রহণ করা হয়",
  T_48_META_API_18_P1_D: "গোলাকার এলাকার কেন্দ্র বিন্দু",
  T_48_META_API_18_P2_D: "গোলাকার এলাকা ভ্রমণের দিকনির্দেশ",
  T_48_META_API_18_P3_D: "গোলাকার এলাকা দ্বারা ভ্রমণ করা দূরত্ব, শুধুমাত্র ইতিবাচক মান গ্রহণ করা হয়",
  T_48_META_API_18_P4_D: "লেয়ার মাস্ক, শুধুমাত্র ভরা লেয়ারগুলোই স্ক্যানে অংশ নেবে, ফাঁকা রাখলে সব লেয়ার স্ক্যানে অংশগ্রহণ করবে",
  T_48_META_API_18_P5_D: "এটা কি ট্রিগার সনাক্ত করা সম্ভব?",
  T_48_META_API_18_P6_D: "হিট সত্তা তালিকা",
  T_48_META_API_19_D: "সনাক্তকরণের জন্য একটি রৈখিকভাবে চলমান ক্যাপসুল এলাকা ব্যবহার করুন এবং ক্যাপসুল এলাকার রুটে সম্মুখীন হওয়া সমস্ত সত্তাগুলিকে ফিরিয়ে দিন যদি তারা প্রাথমিকভাবে ক্যাপসুল এলাকার মধ্যে থাকে, যদি স্তরের প্যারামিটারটি পূরণ করা হয়; ভূখণ্ড সনাক্ত করা যেতে পারে",
  T_48_META_API_19_P0_D: "ক্যাপসুল এলাকার উভয় প্রান্তে গোলার্ধের ব্যাসার্ধ, শুধুমাত্র ইতিবাচক মান গ্রহণ করা হয়",
  T_48_META_API_19_P1_D: "ক্যাপসুল এলাকার উভয় প্রান্তে গোলার্ধের কেন্দ্রগুলির মধ্যে দূরত্ব এই মানটি উভয় প্রান্তে গোলার্ধের ব্যাসার্ধের দ্বিগুণের বেশি হতে হবে।",
  T_48_META_API_19_P2_D: "ক্যাপসুল এলাকার কেন্দ্র বিন্দু",
  T_48_META_API_19_P3_D: "ক্যাপসুল এলাকার ঘূর্ণন",
  T_48_META_API_19_P4_D: "ক্যাপসুল এলাকার ভ্রমণের দিক",
  T_48_META_API_19_P5_D: "ক্যাপসুল এলাকার মধ্যে দূরত্ব ভ্রমণ, শুধুমাত্র ইতিবাচক মান গ্রহণ করা হয়।",
  T_48_META_API_19_P6_D: "লেয়ার মাস্ক, শুধুমাত্র ভরা লেয়ারগুলোই স্ক্যানে অংশ নেবে, ফাঁকা রাখলে সব লেয়ার স্ক্যানে অংশগ্রহণ করবে",
  T_48_META_API_19_P7_D: "এটা কি ট্রিগার সনাক্ত করা সম্ভব?",
  T_48_META_API_19_P8_D: "হিট সত্তা তালিকা",
  T_48_META_API_2_D: "বর্তমান খেলায় সব দল পান এবং দলের তালিকায় ফিরে যান।",
  T_48_META_API_2_R_D: "দলের তালিকা",
  T_48_META_API_20_D: "সনাক্তকরণের জন্য একটি স্থির বাক্স-আকৃতির এলাকা ব্যবহার করুন এবং বক্স-আকৃতির এলাকার মধ্যে সমস্ত সত্তা ফেরত দিন যদি লেভেল প্যারামিটারটি ফাঁকা জায়গায় পূরণ করা হয়, তাহলে ভূখণ্ড সনাক্ত করা যেতে পারে।",
  T_48_META_API_20_P0_D: "বক্স এলাকার তিন দিকের দৈর্ঘ্যের অর্ধেক, শুধুমাত্র ইতিবাচক মান গ্রহণ করা হয়",
  T_48_META_API_20_P1_D: "বক্স এলাকার কেন্দ্র বিন্দু",
  T_48_META_API_20_P2_D: "বক্স এলাকা ঘূর্ণন",
  T_48_META_API_20_P3_D: "লেয়ার মাস্ক, শুধুমাত্র ভরা লেয়ারগুলোই স্ক্যানে অংশ নেবে, ফাঁকা রাখলে সব লেয়ার স্ক্যানে অংশগ্রহণ করবে",
  T_48_META_API_20_P4_D: "এটা কি ট্রিগার সনাক্ত করা সম্ভব?",
  T_48_META_API_20_P5_D: "হিট সত্তা তালিকা",
  T_48_META_API_2000_D: "লক্ষ্য সত্তার অ্যাট্রিবিউট মান সেট করুন, যার জন্য অ্যাট্রিবিউটটি সংজ্ঞায়িত করা প্রয়োজন",
  T_48_META_API_2000_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_2000_P1_D: "লক্ষ্য সত্তার একটি বৈশিষ্ট্য",
  T_48_META_API_2000_P2_D: "অ্যাট্রিবিউটটি সংজ্ঞায়িত করার সময় লক্ষ্য মানটি প্রয়োজনীয় প্রকারের সাথে সঙ্গতিপূর্ণ হওয়া প্রয়োজন।",
  T_48_META_API_2000_P3_D: "অপারেশন মোড, সব ধরনের সমর্থন অ্যাসাইনমেন্ট, এবং সংখ্যাসূচক প্রকারগুলি স্ব-সংযোজন, স্ব-বিয়োগ, স্ব-গুণ, স্ব-বিভাগ এবং স্ব-অবশিষ্ট সমর্থন করে।",
  T_48_META_API_2001_D: "একটি সত্তার বৈশিষ্ট্য মান পান",
  T_48_META_API_2001_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_2001_P1_D: "সত্তার একটি অ্যাট্রিবিউট আইডি",
  T_48_META_API_2001_R_D: "বৈশিষ্ট্য মান",
  T_48_META_API_2002: "গ্রাফ প্রপার্টি সেট করুন",
  T_48_META_API_2002_D: "স্ক্রিপ্ট ভেরিয়েবল সেট করুন",
  T_48_META_API_2002_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_2002_P1: "গ্রাফ আইডি",
  T_48_META_API_2002_P1_D: "টার্গেট স্ক্রিপ্ট আইডি",
  T_48_META_API_2002_P2: "সম্পত্তি আইডি",
  T_48_META_API_2002_P2_D: "স্ক্রিপ্টে সংজ্ঞায়িত সদস্য অ্যাট্রিবিউট আইডি",
  T_48_META_API_2002_P3: "সম্পত্তির মান",
  T_48_META_API_2002_P3_D: "অ্যাট্রিবিউটটি সংজ্ঞায়িত করার সময় লক্ষ্য মানটি প্রয়োজনীয় প্রকারের সাথে সঙ্গতিপূর্ণ হওয়া প্রয়োজন।",
  T_48_META_API_2002_P4_D: "অপারেশন মোড, সব ধরনের সমর্থন অ্যাসাইনমেন্ট, এবং সংখ্যাসূচক প্রকারগুলি স্ব-সংযোজন, স্ব-বিয়োগ, স্ব-গুণ, স্ব-বিভাগ এবং স্ব-অবশিষ্ট সমর্থন করে।",
  T_48_META_API_2003: "গ্রাফ সম্পত্তি পান",
  T_48_META_API_2003_D: "স্ক্রিপ্ট ভেরিয়েবল পান",
  T_48_META_API_2003_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_2003_P1: "গ্রাফ আইডি",
  T_48_META_API_2003_P1_D: "টার্গেট স্ক্রিপ্ট আইডি",
  T_48_META_API_2003_P2: "সম্পত্তি আইডি",
  T_48_META_API_2003_P2_D: "টার্গেট অ্যাট্রিবিউট আইডি",
  T_48_META_API_2003_R_D: "বৈশিষ্ট্য মান",
  T_48_META_API_2004_D: "স্থানীয় ভেরিয়েবল সংজ্ঞায়িত করুন এবং বিবৃতি ব্লকের শেষ পর্যন্ত স্থানীয় ভেরিয়েবলের সুযোগ।",
  T_48_META_API_2004_P0_D: "পরিবর্তনশীল নাম",
  T_48_META_API_2004_P1_D: "পরিবর্তনশীল প্রাথমিক মান",
  T_48_META_API_2004_P2_D: "পরিবর্তনশীল ঘোষণার ধরন একটি মান নির্ধারণ করার সময়, এটি ঘোষিত প্রকারের সাথে সামঞ্জস্য করা প্রয়োজন।",
  T_48_META_API_2005_D: "একটি স্থানীয় ভেরিয়েবলের মান সেট করুন একটি স্থানীয় ভেরিয়েবলের সুযোগ ঘোষণার অবস্থান থেকে স্টেটমেন্ট ব্লকের শেষ পর্যন্ত।",
  T_48_META_API_2005_P0_D: "পরিবর্তনশীল নাম",
  T_48_META_API_2005_P1: "পরিবর্তনশীল মান",
  T_48_META_API_2005_P1_D: "পরিবর্তনশীল মান",
  T_48_META_API_2005_P2_D: "অপারেশন মোড, সব ধরনের সমর্থন অ্যাসাইনমেন্ট, এবং সংখ্যাসূচক প্রকারগুলি স্ব-সংযোজন, স্ব-বিয়োগ, স্ব-গুণ, স্ব-বিভাগ এবং স্ব-অবশিষ্ট সমর্থন করে।",
  T_48_META_API_2006: "স্থানীয় পরিবর্তনশীল পান",
  T_48_META_API_2006_D: "একটি স্থানীয় ভেরিয়েবলের মান নিন ঘোষণার অবস্থান থেকে স্টেটমেন্ট ব্লকের শেষ পর্যন্ত।",
  T_48_META_API_2006_P0: "পরিবর্তনশীল নাম",
  T_48_META_API_2006_P0_D: "পরিবর্তনশীল নাম",
  T_48_META_API_2006_R_D: "পরিবর্তনশীল মান",
  T_48_META_API_2009: "সিরিয়াল সহ গ্লোবাল কাস্টম API খুঁজুন এবং আহ্বান করুন",
  T_48_META_API_2009_D: "একটি সিরিয়াল পদ্ধতিতে গ্লোবাল কাস্টম ফাংশন কল করুন যদি কাস্টম ফাংশনে একটি অপেক্ষা থাকে, কলিং অবস্থানটিও অপেক্ষা করবে৷",
  T_48_META_API_2009_P0: "গ্রাফ আইডি",
  T_48_META_API_2009_P0_D: "স্ক্রিপ্ট আইডি যেখানে কাস্টম ফাংশন অবস্থিত",
  T_48_META_API_2009_P1: "ফাংশন আইডি",
  T_48_META_API_2009_P1_D: "কাস্টম ফাংশন আইডি বলা হয়",
  T_48_META_API_2009_P2_D: "কাস্টম ফাংশনে পাস করা প্যারামিটারের তালিকা",
  T_48_META_API_2010: "সমান্তরাল সহ গ্লোবাল কাস্টম API খুঁজুন এবং আহ্বান করুন",
  T_48_META_API_2010_D: "বৈশ্বিক কাস্টম ফাংশনকে সমান্তরালভাবে কল করুন, কাস্টম ফাংশনে অপেক্ষা করা হোক না কেন, এটি অবিলম্বে কলিং অবস্থানে ফিরে আসবে এবং কার্যকর করা চালিয়ে যাবে।",
  T_48_META_API_2010_P0: "গ্রাফ আইডি",
  T_48_META_API_2010_P0_D: "স্ক্রিপ্ট আইডি যেখানে কাস্টম ফাংশন অবস্থিত",
  T_48_META_API_2010_P1: "ফাংশন আইডি",
  T_48_META_API_2010_P1_D: "কাস্টম ফাংশন আইডি বলা হয়",
  T_48_META_API_2010_P2_D: "কাস্টম ফাংশনে পাস করা প্যারামিটারের তালিকা",
  T_48_META_API_2013: "সেলফ গ্রাফ প্রপার্টি সেট করুন",
  T_48_META_API_2013_D: "বর্তমান স্ক্রিপ্টের জন্য ভেরিয়েবল সেট করুন",
  T_48_META_API_2013_P0: "সম্পত্তি আইডি",
  T_48_META_API_2013_P0_D: "টার্গেট অ্যাট্রিবিউট আইডি",
  T_48_META_API_2013_P1: "সম্পত্তির মান",
  T_48_META_API_2013_P1_D: "লক্ষ্য মান",
  T_48_META_API_2013_P2_D: "অপারেশন মোড, সব ধরনের সমর্থন অ্যাসাইনমেন্ট, এবং সংখ্যাসূচক প্রকারগুলি স্ব-সংযোজন, স্ব-বিয়োগ, স্ব-গুণ, স্ব-বিভাগ এবং স্ব-অবশিষ্ট সমর্থন করে।",
  T_48_META_API_2014: "স্ব গ্রাফ সম্পত্তি পান",
  T_48_META_API_2014_D: "বর্তমান স্ক্রিপ্টের ভেরিয়েবলগুলি পান",
  T_48_META_API_2014_P0: "সম্পত্তি আইডি",
  T_48_META_API_2014_P0_D: "টার্গেট অ্যাট্রিবিউট আইডি",
  T_48_META_API_2014_R_D: "বৈশিষ্ট্য মান",
  T_48_META_API_21_D: "শনাক্তকরণের জন্য একটি স্থির গোলাকার এলাকা ব্যবহার করুন এবং গোলাকার এলাকার মধ্যে সমস্ত সত্তা ফেরত দিন যদি লেভেল প্যারামিটারটি ফাঁকা জায়গায় পূরণ করা হয়, তাহলে ভূখণ্ড সনাক্ত করা যেতে পারে।",
  T_48_META_API_21_P0_D: "গোলাকার এলাকার ব্যাসার্ধ, শুধুমাত্র ইতিবাচক মান গ্রহণ করা হয়",
  T_48_META_API_21_P1_D: "গোলাকার এলাকার কেন্দ্র বিন্দু",
  T_48_META_API_21_P2_D: "লেয়ার মাস্ক, শুধুমাত্র ভরা লেয়ারগুলোই স্ক্যানে অংশ নেবে, ফাঁকা রাখলে সব লেয়ার স্ক্যানে অংশগ্রহণ করবে",
  T_48_META_API_21_P3_D: "এটা কি ট্রিগার সনাক্ত করা সম্ভব?",
  T_48_META_API_21_P4_D: "হিট সত্তা তালিকা",
  T_48_META_API_22_D: "সনাক্তকরণের জন্য একটি স্ট্যাটিক ক্যাপসুল এলাকা ব্যবহার করুন এবং ক্যাপসুল এলাকার মধ্যে সমস্ত সত্তা ফেরত দিন যদি লেভেল প্যারামিটারটি পূরণ করা হয়, তাহলে ভূখণ্ড সনাক্ত করা যেতে পারে।",
  T_48_META_API_22_P0_D: "ক্যাপসুল এলাকার উভয় প্রান্তে গোলার্ধের ব্যাসার্ধ, শুধুমাত্র ইতিবাচক মান গ্রহণ করা হয়",
  T_48_META_API_22_P1_D: "ক্যাপসুল এলাকার উভয় প্রান্তে গোলার্ধের কেন্দ্রগুলির মধ্যে দূরত্ব এই মানটি উভয় প্রান্তে গোলার্ধের ব্যাসার্ধের দ্বিগুণের বেশি হতে হবে।",
  T_48_META_API_22_P2_D: "ক্যাপসুল এলাকার কেন্দ্র বিন্দু",
  T_48_META_API_22_P3_D: "ক্যাপসুল এলাকার ঘূর্ণন",
  T_48_META_API_22_P4_D: "লেয়ার মাস্ক, শুধুমাত্র ভরা লেয়ারগুলোই স্ক্যানে অংশ নেবে, ফাঁকা রাখলে সব লেয়ার স্ক্যানে অংশগ্রহণ করবে",
  T_48_META_API_22_P5_D: "এটা কি ট্রিগার সনাক্ত করা সম্ভব?",
  T_48_META_API_22_P6_D: "হিট সত্তা তালিকা",
  T_48_META_API_23_D: "প্লেয়ারের জন্য বিশেষ আইটেম স্থিতি সেট করুন আপনার কাছে শুধুমাত্র একটি বিশেষ আইটেম থাকতে পারে।",
  T_48_META_API_23_P0_D: "খেলোয়াড়",
  T_48_META_API_23_P1_D: "আইটেম আইডি",
  T_48_META_API_23_P2_D: "এই আইটেমটি সক্রিয় করতে হবে কিনা",
  T_48_META_API_23_P3_D: "বিশেষ আইটেম সত্তা",
  T_48_META_API_24_D: "লক্ষ্যে একটি বল প্রয়োগ করুন, যা অবশ্যই একটি শারীরিক বস্তু হতে হবে",
  T_48_META_API_24_P0_D: "লক্ষ্য শারীরিক বস্তু",
  T_48_META_API_24_P1_D: "বল ভেক্টর",
  T_48_META_API_24_P2_D: "শক্তির ধরন",
  T_48_META_API_25_D: "একটি নির্দিষ্ট বিন্দুতে একবার একটি বল প্রয়োগ করুন, লক্ষ্য অবশ্যই একটি অনমনীয় শরীর হতে হবে",
  T_48_META_API_25_P0_D: "লক্ষ্য অনমনীয় শরীর",
  T_48_META_API_25_P1_D: "বল ভেক্টর",
  T_48_META_API_25_P2_D: "বল প্রয়োগের অবস্থান",
  T_48_META_API_25_P3_D: "শক্তির ধরন",
  T_48_META_API_26_D: "লক্ষ্যে একটি টর্ক প্রয়োগ করুন, যা একটি অনমনীয় শরীর হতে হবে",
  T_48_META_API_26_P0_D: "লক্ষ্য অনমনীয় শরীর",
  T_48_META_API_26_P1_D: "টর্ক",
  T_48_META_API_26_P2_D: "ফোর্স টাইপ",
  T_48_META_API_27_D: "নির্দিষ্ট অবস্থানে লক্ষ্য অনমনীয় শরীর সরান",
  T_48_META_API_27_P0_D: "লক্ষ্য অনমনীয় শরীর",
  T_48_META_API_27_P1_D: "অবস্থান নির্দিষ্ট করুন",
  T_48_META_API_28_D: "টার্গেট অনমনীয় শরীর ঘোরান",
  T_48_META_API_28_P0_D: "লক্ষ্য অনমনীয় শরীর",
  T_48_META_API_28_P1_D: "Quaternion ঘোরান",
  T_48_META_API_29_D: "ইন্টারপোলেটেড গতি তৈরি করুন, এবং লক্ষ্য সত্তার নির্দিষ্ট বৈশিষ্ট্যগুলি সেটিংস অনুসারে মসৃণভাবে চলে যাবে",
  T_48_META_API_29_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_29_P1_D: "অ্যাট্রিবিউট আইডি যা পরিবর্তন করতে হবে",
  T_48_META_API_29_P2_D: "বৈশিষ্ট্য প্রারম্ভিক মান",
  T_48_META_API_29_P3_D: "বৈশিষ্ট্য শেষ মান",
  T_48_META_API_29_P4_D: `আপনি একক, লুপ এবং রেসিপ্রোকেটিং বেছে নিতে পারেন। 
 লুপ বলতে বোঝায় যে প্রতিটি মুভমেন্ট সম্পন্ন হওয়ার পর, সত্তাটি আবার শুরুর মান থেকে সরে যাবে। রেসিপ্রোকেটিং বলতে বোঝায় যে শুরুর মান থেকে লক্ষ্য মান পর্যন্ত মুভমেন্ট সম্পন্ন হওয়ার পর, সত্তাটি আবার লক্ষ্য মান থেকে শুরুর মান পর্যন্ত সরে যাবে, এবং তারপর প্রক্রিয়াটি পুনরাবৃত্তি করবে।`,
  T_48_META_API_29_P5_D: "Bezier বক্ররেখা নিয়ন্ত্রণ পয়েন্ট",
  T_48_META_API_29_P6_D: "পরিবর্তনের সময়কাল, মিলিসেকেন্ডে",
  T_48_META_API_29_P7_D: "ইন্টারপোলেটেড গতি সত্তা তৈরি করা হয়েছে",
  T_48_META_API_29_P8_D: "সৃষ্টির পর স্বয়ংক্রিয়ভাবে বাজানো শুরু হবে কিনা",
  T_48_META_API_3_D: "গেমটিকে লক্ষ্য পর্যায়ে পরিবর্তন করুন এবং রাউন্ডটিও একটি বিশেষ পর্যায়। একটি বাঁকের মধ্যে একটি ফেজে স্যুইচ করার সময়, পালা গণনা 0 হয়।",
  T_48_META_API_3_P0_D: "লক্ষ্য বৃত্তাকার বা পর্বের সূচক",
  T_48_META_API_30_D: "লক্ষ্য প্লেয়ারকে মনোনীত গাড়িতে প্রবেশ করতে বাধ্য করুন",
  T_48_META_API_30_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_30_P1_D: "যানবাহন সত্তা",
  T_48_META_API_30_P2_D: "আসন সংখ্যা",
  T_48_META_API_30_P3_D: "প্লেয়ারকে সফলভাবে গাড়িতে প্রবেশের অনুমতি দেওয়া হয়েছে কিনা",
  T_48_META_API_3001_D: "লক্ষ্য প্লেয়ার আইটেম ড্রপ কারণ",
  T_48_META_API_3001_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3001_P1_D: "আইটেম সত্তা",
  T_48_META_API_3002_D: "বর্তমানে উপলব্ধ র্যান্ডম স্পন পয়েন্টের মধ্যে উপলব্ধ স্থানাঙ্কগুলি পান যা সম্পূর্ণরূপে দখল করা হয়নি (অপ্রচলিত, অনুগ্রহ করে GetRandomSpawnPosition ব্যবহার করুন)",
  T_48_META_API_3002_P0_D: "যে খেলোয়াড়দের স্পন এলাকা বরাদ্দ করতে হবে",
  T_48_META_API_3002_R_D: "এলোমেলোভাবে নির্ধারিত র্যান্ডম পয়েন্ট স্থানাঙ্ক",
  T_48_META_API_3003_D: "প্লেয়ারের নির্দিষ্ট পয়েন্ট টাইপের মোট পয়েন্টের মান পান",
  T_48_META_API_3003_P0_D: "খেলোয়াড়",
  T_48_META_API_3003_P1_D: "পয়েন্ট টাইপ",
  T_48_META_API_3003_R_D: "পয়েন্ট মান",
  T_48_META_API_3004_D: "প্লেয়ার-নির্দিষ্ট পয়েন্ট প্রকারের জন্য রাউন্ড পয়েন্ট মান সেট করুন",
  T_48_META_API_3004_P0_D: "খেলোয়াড় সত্তা",
  T_48_META_API_3004_P1_D: "পয়েন্ট টাইপ",
  T_48_META_API_3004_P2_D: "পয়েন্ট মান",
  T_48_META_API_3005_D: "দলের জন্য নির্দিষ্ট পয়েন্ট প্রকারের মোট পয়েন্ট মান পান",
  T_48_META_API_3005_P0_D: "দল সত্তা",
  T_48_META_API_3005_P1_D: "পয়েন্ট টাইপ",
  T_48_META_API_3005_R_D: "পয়েন্ট মান",
  T_48_META_API_3006_D: "দলের নির্দিষ্ট পয়েন্ট টাইপের জন্য রাউন্ড পয়েন্ট মান সেট করুন",
  T_48_META_API_3006_P0_D: "দল সত্তা",
  T_48_META_API_3006_P1_D: "পয়েন্ট টাইপ",
  T_48_META_API_3006_P2_D: "পয়েন্ট মান",
  T_48_META_API_3007_D: "নির্দিষ্ট রাউন্ড এবং পয়েন্ট টাইপের জন্য প্লেয়ারের পয়েন্ট পান",
  T_48_META_API_3007_P0_D: "খেলোয়াড় সত্তা",
  T_48_META_API_3007_P1_D: "বৃত্তাকার সূচক",
  T_48_META_API_3007_P2_D: "পয়েন্ট টাইপ",
  T_48_META_API_3007_R_D: "পয়েন্ট মান",
  T_48_META_API_3008_D: "নির্দিষ্ট রাউন্ড এবং পয়েন্ট টাইপের জন্য দলের পয়েন্ট পান",
  T_48_META_API_3008_P0_D: "দল সত্তা",
  T_48_META_API_3008_P1_D: "বৃত্তাকার সূচক",
  T_48_META_API_3008_P2_D: "পয়েন্ট টাইপ",
  T_48_META_API_3008_R_D: "পয়েন্ট মান",
  T_48_META_API_3009_D: "প্লেয়ারের মোট গেম র‌্যাঙ্কিং পান",
  T_48_META_API_3009_P0_D: "খেলোয়াড় সত্তা",
  T_48_META_API_3009_R_D: "র‍্যাঙ্কিং",
  T_48_META_API_3011_D: "দলের খেলার সামগ্রিক র‌্যাঙ্কিং পান",
  T_48_META_API_3011_P0_D: "অবচয়",
  T_48_META_API_3011_R_D: "র‍্যাঙ্কিং",
  T_48_META_API_3013_D: "প্লেয়ারের নির্দিষ্ট রাউন্ড র‌্যাঙ্কিং পান",
  T_48_META_API_3013_P0_D: "খেলোয়াড় সত্তা",
  T_48_META_API_3013_P1_D: "বৃত্তাকার সূচক",
  T_48_META_API_3013_R_D: "র‍্যাঙ্কিং",
  T_48_META_API_3014_D: "দলের মনোনীত রাউন্ড র‌্যাঙ্কিং পান",
  T_48_META_API_3014_P0_D: "অবচয়",
  T_48_META_API_3014_P1_D: "বৃত্তাকার সূচক",
  T_48_META_API_3014_R_D: "র‍্যাঙ্কিং",
  T_48_META_API_3015_D: "লক্ষ্য সত্তার মানিব্যাগ পান",
  T_48_META_API_3015_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_3015_P1_D: "একটি মানিব্যাগ বিদ্যমান?",
  T_48_META_API_3015_P2_D: "ওয়ালেট সত্তা প্রাপ্ত",
  T_48_META_API_3016_D: "টার্গেট প্লেয়ারের জন্য একটি মানিব্যাগ তৈরি করুন যদি প্লেয়ারের ইতিমধ্যে একটি মানিব্যাগ থাকে তবে এটি অবৈধ হবে৷",
  T_48_META_API_3016_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3016_P1_D: "মানিব্যাগের সাথে আবদ্ধ সত্তা, মানিব্যাগের মালিক",
  T_48_META_API_3016_P2_D: "ওয়ালেট সত্তা",
  T_48_META_API_3017_D: "নির্দিষ্ট ওয়ালেটে মুদ্রা যোগ করুন",
  T_48_META_API_3017_P0_D: "লক্ষ্য মানিব্যাগ",
  T_48_META_API_3017_P1_D: "মুদ্রার ধরন যোগ করা হয়েছে",
  T_48_META_API_3017_P2_D: "বর্ধিত মুদ্রার পরিমাণ",
  T_48_META_API_3018_D: "নির্দিষ্ট ওয়ালেটের জন্য মুদ্রা হ্রাস করুন",
  T_48_META_API_3018_P0_D: "লক্ষ্য মানিব্যাগ",
  T_48_META_API_3018_P1_D: "হ্রাসকৃত মুদ্রার ধরন",
  T_48_META_API_3018_P2_D: "টাকার পরিমাণ কমে গেছে",
  T_48_META_API_3019_D: "এক ওয়ালেট থেকে অন্য ওয়ালেটে মুদ্রা স্থানান্তর করুন",
  T_48_META_API_3019_P0_D: "ওয়ালেট থেকে মুদ্রা স্থানান্তর করতে",
  T_48_META_API_3019_P1_D: "মুদ্রার ধরন স্থানান্তর",
  T_48_META_API_3019_P2_D: "মুদ্রা স্থানান্তরিত পরিমাণ",
  T_48_META_API_3019_P3_D: "কারেন্সি ট্রান্সফার করার জন্য ওয়ালেট",
  T_48_META_API_3020_D: "নির্দিষ্ট ওয়ালেটে নির্দিষ্ট ধরনের মুদ্রার পরিমাণ পান",
  T_48_META_API_3020_P0_D: "লক্ষ্য মানিব্যাগ",
  T_48_META_API_3020_P1_D: "কোয়েরি মুদ্রার ধরন",
  T_48_META_API_3020_R_D: "মুদ্রার পরিমাণ",
  T_48_META_API_3021_D: "নির্দিষ্ট ওয়ালেটে নির্দিষ্ট ধরনের মুদ্রার সত্তা পান",
  T_48_META_API_3021_P0_D: "লক্ষ্য মানিব্যাগ",
  T_48_META_API_3021_P1_D: "কোয়েরি মুদ্রার ধরন",
  T_48_META_API_3021_R_D: "আর্থিক সত্তা",
  T_48_META_API_3022_D: "গেমের সমস্ত স্টোর পান, একটি তালিকা হিসাবে ফিরে এসেছে",
  T_48_META_API_3022_R_D: "দোকান সত্তা তালিকা",
  T_48_META_API_3023_D: "নির্দিষ্ট দৃশ্য অবজেক্টের চেহারা দিয়ে লক্ষ্য প্লেয়ারের চেহারা প্রতিস্থাপন করুন",
  T_48_META_API_3023_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3023_P1_D: "প্রতিস্থাপন লক্ষ্য দৃশ্য বস্তু",
  T_48_META_API_3023_P2_D: "প্লেয়ার রূপান্তর ছদ্মবেশ উপাদান প্রতিস্থাপন পরে তৈরি",
  T_48_META_API_3024_D: "খেলোয়াড়ের ছদ্মবেশী অবস্থা বাতিল করুন",
  T_48_META_API_3024_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3025_D: "টার্গেট প্লেয়ারে দৃশ্য সত্তার একটি ক্লোন তৈরি করুন",
  T_48_META_API_3025_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3025_P1_D: "অবতারের জন্য ব্যবহৃত দৃশ্য সত্তা",
  T_48_META_API_3025_P2_D: "ক্লোন সত্তা তৈরি করা হয়েছে",
  T_48_META_API_3026_D: "প্লেয়ার এর ছদ্মবেশ সত্তা পান",
  T_48_META_API_3026_P0_D: "খেলোয়াড়",
  T_48_META_API_3026_R_D: "প্লেয়ার ছদ্মবেশী সত্তা",
  T_48_META_API_3027_D: "সূচকের উপর ভিত্তি করে চ্যাট চ্যানেল সত্তা পান",
  T_48_META_API_3027_P0_D: "চ্যাট চ্যানেল সূচক, পরিসীমা [1,8]",
  T_48_META_API_3027_R_D: "চ্যাট চ্যানেল সত্তা",
  T_48_META_API_3028_D: "নির্দিষ্ট প্লেয়ারটি বর্তমানে অবস্থিত যেখানে চ্যাট চ্যানেল সত্তা পান",
  T_48_META_API_3028_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3028_R_D: "চ্যাট চ্যানেল সত্তা",
  T_48_META_API_3029_D: "প্লেয়ারকে নির্দিষ্ট চ্যাট চ্যানেলে যোগ দিতে দিন যদি প্লেয়ার ইতিমধ্যেই অন্য চ্যাট চ্যানেলে থাকে, তাহলে সে লক্ষ্য চ্যানেলে চলে যাবে।",
  T_48_META_API_3029_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3029_P1_D: "চ্যাট চ্যানেল সত্তা",
  T_48_META_API_3030_D: "প্লেয়ারকে বর্তমান চ্যানেল থেকে প্রস্থান করতে এবং তারপরে কোনো চ্যাট চ্যানেলে না থাকার অবস্থায় থাকতে দেয়",
  T_48_META_API_3030_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3031_D: "অবচয়",
  T_48_META_API_3031_P0_D: "চ্যাট চ্যানেল সত্তা, চ্যানেলে কোনো খেলোয়াড় না থাকলে খালি",
  T_48_META_API_3032_D: "খেলোয়াড়ের আচরণের অবস্থা সেট করুন",
  T_48_META_API_3032_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3032_P1_D: "খেলোয়াড়ের আচরণের ধরন",
  T_48_META_API_3032_P2_D: `সক্রিয়: একটি HUD বোতাম রয়েছে এবং সাধারণত ব্যবহার করা যেতে পারে
অক্ষম: HUD বোতামটি নিষ্ক্রিয় এবং সক্রিয়ভাবে বা প্যাসিভভাবে আচরণগত অবস্থায় প্রবেশ করতে পারে না
শিল্ড: HUD বোতামটি লুকানো থাকে এবং সক্রিয়ভাবে আচরণগত অবস্থায় প্রবেশ করতে পারে না, তবে নিষ`,
  T_48_META_API_3033_D: "প্লেয়ারটি একটি নির্দিষ্ট দৃশ্য অবজেক্টে রূপান্তরিত হয়",
  T_48_META_API_3033_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3033_P1_D: "যে বস্তুতে রূপান্তরিত হবে",
  T_48_META_API_3033_P2_D: "রূপান্তরের পর সত্তা তৈরি হয়েছে",
  T_48_META_API_3034_D: "খেলোয়াড়রা নিজেদের একটি ক্লোন তৈরি করে",
  T_48_META_API_3034_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3034_P1_D: "ক্লোন সত্তা তৈরি করা হয়েছে",
  T_48_META_API_3035_D: "একটি কাস্টম স্টোর তৈরি করুন যেখানে দোকানের পরবর্তী স্তর হল তাক",
  T_48_META_API_3035_P0_D: "দোকান সত্তা তৈরি",
  T_48_META_API_3036_D: "একটি কাস্টম শেল্ফ তৈরি করুন শেল্ফের উপরের স্তরটি হল দোকান এবং পরবর্তী স্তরটি পণ্য৷",
  T_48_META_API_3036_P0_D: "শেলফ সত্তা তৈরি করা হয়েছে",
  T_48_META_API_3037_D: "একটি কাস্টম পণ্য তৈরি করুন যা আইটেম যোগ করতে পারে",
  T_48_META_API_3037_P0_D: "পণ্য সত্তা তৈরি",
  T_48_META_API_3038_D: "এই আদিম একাধিকবার ব্যবহার করে একটি পণ্যে একাধিক আইটেম যোগ করা যেতে পারে।",
  T_48_META_API_3038_P0_D: "পণ্য সত্তা",
  T_48_META_API_3038_P1_D: "যোগ করার জন্য আইটেম",
  T_48_META_API_3038_P2_D: "আইটেম পরিমাণ",
  T_48_META_API_3039_D: "জেলব্রেক পুরষ্কার দিন",
  T_48_META_API_3039_P0_D: "খেলোয়াড় সত্তা",
  T_48_META_API_3039_P1_D: "পরিমাণ",
  T_48_META_API_3039_P2_D: "আসল টাকা",
  T_48_META_API_3040_D: "জেলব্রেক টাস্ক আপডেট করা হয়েছে",
  T_48_META_API_3040_P0_D: "খেলোয়াড় সত্তা",
  T_48_META_API_3040_P1_D: "টাস্ক আইডি",
  T_48_META_API_3040_P2_D: "মান",
  T_48_META_API_3041_D: "র্যান্ডম স্পন পয়েন্ট স্থানাঙ্ক প্রাপ্ত করা শুধুমাত্র উপলব্ধ স্পন পয়েন্টগুলি থেকে এলোমেলো হবে যা সম্পূর্ণরূপে দখল করা হয়নি।",
  T_48_META_API_3041_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3041_R_D: "র্যান্ডম জন্ম বিন্দু স্থানাঙ্ক যদি শর্ত পূরণ করে এমন কোনো জন্ম বিন্দু না থাকে, তাহলে (0, 0, 0) এর কাছাকাছি অবস্থানটি ফেরত দেওয়া হবে।",
  T_48_META_API_3042_D: "জেলব্রেক মিনি-গেম থেকে প্রস্থান করুন",
  T_48_META_API_3042_P0_D: "খেলোয়াড় সত্তা",
  T_48_META_API_3042_P1_D: "টাস্ক আইডি",
  T_48_META_API_3043_D: "জেলব্রেক প্রপস উপর ভিত্তি করে",
  T_48_META_API_3043_P0_D: "খেলোয়াড় সত্তা",
  T_48_META_API_3043_P1_D: "প্রপ টাইপ",
  T_48_META_API_3043_P2_D: "প্রপ আইডি",
  T_48_META_API_31_D: "আপেক্ষিক স্ব-গতি তৈরি করুন, এবং লক্ষ্য সত্তা প্রতিবার তার বর্তমান অ্যাট্রিবিউট মানের তুলনায় পরিবর্তিত হয়",
  T_48_META_API_31_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_31_P1_D: "গতি পরিবর্তন প্রয়োজন যে বৈশিষ্ট্য",
  T_48_META_API_31_P2_D: "আন্দোলন প্রতি পরিবর্তন পরিমাণ",
  T_48_META_API_31_P3_D: "Bezier বক্ররেখা নিয়ন্ত্রণ পয়েন্ট",
  T_48_META_API_31_P4_D: `একক: যখন অ্যাট্রিবিউট ডেল্টার পরিমাণ পরিবর্তন করে তখন থামুন
লুপ: আন্দোলনের পুনরাবৃত্তি করুন, প্রতিবার অ্যাট্রিবিউট ডেল্টার পরিমাণ পরিবর্তন করে`,
  T_48_META_API_31_P5_D: "পরিবর্তনের সময়কাল, মিলিসেকেন্ডে",
  T_48_META_API_31_P6_D: "তৈরি আপেক্ষিক স্ব-চলমান সত্তা",
  T_48_META_API_31_P7_D: "সৃষ্টির পর স্বয়ংক্রিয়ভাবে বাজানো শুরু হবে কিনা",
  T_48_META_API_3100_D: "লক্ষ্য নির্দিষ্ট অবস্থায় অ্যানিমেশন চালায়",
  T_48_META_API_3100_P0_D: "অ্যানিমেশন চালানোর জন্য একটি অ্যানিমেশন কন্ট্রোলারের সাথে মাউন্ট করা যেতে পারে এমন একটি সত্তা উপাদান",
  T_48_META_API_3100_P1_D: "অ্যানিমেশন কন্ট্রোলারের নির্দিষ্ট অবস্থা",
  T_48_META_API_3100_P2_D: "অ্যানিমেশন প্লেব্যাক গতি স্কেলিং",
  T_48_META_API_3100_P3_D: "লুপ টাইপ, আপনি অ্যানিমেশনের আসল যুক্তি রাখতে পারেন, এটি শুধুমাত্র একবার চালাতে পারেন বা লুপে খেলতে পারেন",
  T_48_META_API_3101_D: "চরিত্র অ্যানিমেশন খেলুন এবং কাস্টম অ্যানিমেশন সংস্থান সমর্থন করুন",
  T_48_META_API_3101_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3101_P1_D: "কাস্টম অ্যানিমেশন রিসোর্স আইডি",
  T_48_META_API_3101_P2_D: "লুপ করতে হবে কিনা",
  T_48_META_API_3102_D: "নির্দিষ্ট প্লেয়ারের চরিত্র সম্পদ সেট করুন",
  T_48_META_API_3102_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3102_P1_D: "কাস্টম রোল রিসোর্স আইডি",
  T_48_META_API_3109_D: "নিরাপদ এলাকা চালু করুন যা শেষ বিন্দুতে মসৃণভাবে চলে যাবে",
  T_48_META_API_3109_P0_D: "নিরাপদ অঞ্চলের শুরুর অবস্থান",
  T_48_META_API_3109_P1_D: "নিরাপত্তা জোন শেষ অবস্থান",
  T_48_META_API_3109_P2_D: "নিরাপদ অঞ্চলের প্রাথমিক ব্যাসার্ধ",
  T_48_META_API_3109_P3_D: "নিরাপদ অঞ্চলের চূড়ান্ত ব্যাসার্ধ",
  T_48_META_API_3109_P4_D: "নিরাপদ অঞ্চলের চূড়ান্ত অবস্থায় পৌঁছানোর জন্য প্রয়োজনীয় সময়, সেকেন্ডে",
  T_48_META_API_3109_P5_D: "নিরাপদ অঞ্চলের বাইরে প্রতি সেকেন্ডে নেওয়া ক্ষতির পরিমাণ",
  T_48_META_API_3110_D: "চরিত্রের উপস্থিতি গোষ্ঠী পরিবর্তন করুন",
  T_48_META_API_3110_P0_D: "টার্গেট",
  T_48_META_API_3110_P1_D: "চেহারা গ্রুপ",
  T_48_META_API_3111_D: "চরিত্রের চেহারা গ্রুপ দেখান",
  T_48_META_API_3111_P0_D: "টার্গেট",
  T_48_META_API_3111_P1_D: "চেহারা গ্রুপ",
  T_48_META_API_3112_D: "অক্ষর চেহারা গ্রুপ লুকান",
  T_48_META_API_3112_P0_D: "টার্গেট",
  T_48_META_API_3112_P1_D: "চেহারা গ্রুপ",
  T_48_META_API_3121_D: "ক্রাফটল্যান্ড স্টুডিও পিসি পরিসংখ্যান ব্যবহারে দাবীর ফলাফল পাঠান",
  T_48_META_API_3121_P0_D: "দাবীর অভিব্যক্তি",
  T_48_META_API_3121_P1_D: "ইঙ্গিত",
  T_48_META_API_32_D: "প্লেয়ারের আজকের টোকেন ডেটা পান",
  T_48_META_API_32_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_32_P1_D: "tokenID",
  T_48_META_API_32_P2_D: "টোকেনের সংখ্যা",
  T_48_META_API_32_P3_D: "আদিম সফলভাবে বলা হয় কিনা",
  T_48_META_API_3200_D: "প্লেয়ারে আইটেম যোগ করুন এবং জারি করা আইটেমগুলির তালিকা ফেরত দিন",
  T_48_META_API_3200_P0_D: "খেলোয়াড়",
  T_48_META_API_3200_P1_D: "আইটেম আইডি",
  T_48_META_API_3200_P2_D: "আইটেম পরিমাণ",
  T_48_META_API_3200_P3_D: "প্লেয়ারের জন্য যোগ করা আইটেমগুলির তালিকা, শুধুমাত্র একটি আইটেম যোগ করা হলেও একটি তালিকা হিসাবে ফিরে আসে",
  T_48_META_API_3201_D: "রক্তের পরিমাণের উপরের সীমা অতিক্রম না করে নির্দিষ্ট প্লেয়ারের রক্তের পরিমাণ পুনরুদ্ধার করুন।",
  T_48_META_API_3201_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3201_P1_D: "প্লেয়ারে রক্ত যোগ করার মান শুধুমাত্র ইতিবাচক সংখ্যা গ্রহণ করা হয়।",
  T_48_META_API_3202_D: "লক্ষ্য খেলোয়াড়ের দক্ষতা তালিকা সেট করুন",
  T_48_META_API_3202_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3202_P1_D: "দক্ষতার তালিকা",
  T_48_META_API_3203_D: "লক্ষ্য খেলোয়াড়ের দক্ষতা তালিকা পান",
  T_48_META_API_3203_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3203_R_D: "দক্ষতার তালিকা",
  T_48_META_API_3205_D: "প্লেয়ার থেকে একটি নির্দিষ্ট সংখ্যক আইটেম মুছুন",
  T_48_META_API_3205_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3205_P1_D: "মুছে ফেলার জন্য আইটেম প্রকার",
  T_48_META_API_3205_P2_D: "মুছে ফেলার পরিমাণ, যদি এটি প্লেয়ারের রাখা পরিমাণের চেয়ে বেশি হয় তবে শুধুমাত্র রাখা আইটেমগুলি মুছে ফেলা হবে।",
  T_48_META_API_3206_D: "প্লেয়ার দ্বারা অনুষ্ঠিত নির্দিষ্ট আইটেম সংখ্যা পান",
  T_48_META_API_3206_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3206_P1_D: "আইটেম টাইপ",
  T_48_META_API_3206_R_D: "খেলোয়াড়ের হাতে থাকা পরিমাণ",
  T_48_META_API_3207_D: "প্লেয়ার বর্তমান চেকপয়েন্ট ট্রিগার করতে পারে কিনা তা পরীক্ষা করুন",
  T_48_META_API_3207_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3207_P1_D: "ট্রিগার",
  T_48_META_API_3207_R_D: "সত্য: ট্রিগার করা যায়, মিথ্যা: ট্রিগার করা যায় না",
  T_48_META_API_3208_D: "সংক্রমণ মোড জম্বি বিবর্তন",
  T_48_META_API_3208_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3209_D: "AI সত্তা ডিফল্ট আচরণ ট্রি বন্ধ/চালনা করে",
  T_48_META_API_3209_P0_D: "আচরণ বৃক্ষ লক্ষ্য সক্রিয় করতে",
  T_48_META_API_3209_P1_D: "ডিফল্ট আচরণ ট্রি চালানো হবে কিনা",
  T_48_META_API_3210_D: "AI সংস্থাগুলি নির্ধারিত লক্ষ্যগুলি তাড়া করে৷",
  T_48_META_API_3210_P0_D: "AI সত্তা যা সাধনা করে",
  T_48_META_API_3210_P1_D: "লক্ষ্য অনুসরণ করা হচ্ছে",
  T_48_META_API_3211_D: "প্লেয়ার আইটেমগুলি ধ্বংস করুন (অপ্রচলিত, DeleteEquipment ব্যবহার করুন)",
  T_48_META_API_3211_P0_D: "যে খেলোয়াড়ের আইটেমটি ধ্বংস হয়ে গেছে",
  T_48_META_API_3211_P1_D: "ধ্বংস আইটেম টাইপ",
  T_48_META_API_3211_P2_D: "অস্ত্রের স্লট, শুধুমাত্র অস্ত্রের জন্য কার্যকর",
  T_48_META_API_3212_D: "জার্সি বদলান",
  T_48_META_API_3212_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3212_P1_D: "জামাকাপড় শৈলী",
  T_48_META_API_3212_P2_D: "প্রধান রঙ এক",
  T_48_META_API_3212_P3_D: "প্রধান রং দুই",
  T_48_META_API_3212_P4_D: "কনফিগারেশন",
  T_48_META_API_3213_D: "প্লেয়ারের জার্সিকে তার আসল অবস্থায় ফিরিয়ে আনুন",
  T_48_META_API_3213_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3214_D: "প্লেয়ার ভয়েস চ্যাট চালু এবং বন্ধ করুন",
  T_48_META_API_3214_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3214_P1_D: "ভয়েস চ্যাট বন্ধ করতে হবে কিনা, সত্য: বন্ধ করুন মিথ্যা: চালু করুন",
  T_48_META_API_3215_D: "প্লেয়ার দ্রুত চ্যাট পরিবর্তন করুন",
  T_48_META_API_3215_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3215_P1_D: "দ্রুত চ্যাট বন্ধ করতে হবে কিনা, সত্য: বন্ধ মিথ্যা: খুলুন",
  T_48_META_API_3216_D: "লক্ষ্য প্লেয়ার আইটেম নিতে পারে কিনা সেট করুন",
  T_48_META_API_3216_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3216_P1_D: "আইটেম তুলতে নিষেধ করতে হবে কিনা, সত্য: আইটেম তোলা নিষিদ্ধ, মিথ্যা: তোলা যাবে",
  T_48_META_API_3217_D: "লক্ষ্য প্লেয়ার আইটেম ড্রপ করতে পারেন কিনা সেট করুন",
  T_48_META_API_3217_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3217_P1_D: "আইটেম ফেলে দেওয়া নিষিদ্ধ কিনা, সত্য: তোলা নিষিদ্ধ, মিথ্যা: তোলা যাবে",
  T_48_META_API_3218_D: "প্লেয়ারের মনোনীত স্লটে অস্ত্রটি ধ্বংস করুন",
  T_48_META_API_3218_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3218_P1_D: "ধ্বংস করার জন্য অস্ত্রের স্লট",
  T_48_META_API_3218_P2_D: "ধ্বংস করার জন্য পরিমাণ",
  T_48_META_API_3218_P3_D: "এটি সফলভাবে ধ্বংস হোক বা না হোক যদি অস্ত্রের স্লটে সজ্জিত অস্ত্র না থাকে তবে ধ্বংস ব্যর্থ হবে।",
  T_48_META_API_3219_D: "সজ্জিত আইটেম সহ টার্গেট প্লেয়ারের ব্যাকপ্যাক থেকে সমস্ত আইটেম সাফ করুন",
  T_48_META_API_3219_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3220_D: "প্লেয়ার ওরিয়েন্টেশন সেট করুন",
  T_48_META_API_3220_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3220_P1_D: "খেলোয়াড়ের দিকনির্দেশনা",
  T_48_META_API_3221_D: "(অপ্রচলিত, দয়া করে এটি ব্যবহার করবেন না। সম্পর্কিত তথ্যের জন্য, বৈশিষ্ট্য দেখুন <প্লেয়ার>:কঙ্কাল)",
  T_48_META_API_3221_P0_D: "খেলোয়াড় সত্তা",
  T_48_META_API_3221_P1_D: "জুম অংশ",
  T_48_META_API_3221_P2_D: "জুম মান",
  T_48_META_API_3222_D: "খেলাধিকারীকে একটি বাক্য প্রভাব দেয়, লক্ষ্য খেলাধিকারীটি নির্দিষ্ট গতিতে চলাচল করবে এবং বায়ুতে সংঘটন হলে বাক্য প্রভাবটি বাধা দিয়ে বন্ধ হবে।",
  T_48_META_API_3222_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3222_P1_D: "উড়ন্ত দিক",
  T_48_META_API_3222_P2_D: "নক আপ সময়কাল",
  T_48_META_API_3222_P3_D: "উড়ার সময় Y-অক্ষের প্রাথমিক বেগ",
  T_48_META_API_3222_P4_D: "উড়ে যাওয়ার সময় XZ প্লেনের প্রাথমিক বেগ",
  T_48_META_API_3222_P5_D: "খেলোয়াড়ের অভিযোজন পরিবর্তন করতে হবে কিনা",
  T_48_META_API_3223_D: "টার্গেট প্লেয়ার বা NPC এর পোশাক আইডি পান",
  T_48_META_API_3223_P0_D: "টার্গেট প্লেয়ার বা NPC",
  T_48_META_API_3223_P1_D: "পোশাকের ধরন",
  T_48_META_API_3223_R_D: "পোশাকের আইডি",
  T_48_META_API_3224_D: "টার্গেট প্লেয়ার বা NPC এর পোশাক আইডি সেট করুন",
  T_48_META_API_3224_P0_D: "টার্গেট প্লেয়ার বা NPC",
  T_48_META_API_3224_P1_D: "পোশাকের আইডি",
  T_48_META_API_3225_D: "টার্গেট প্লেয়ারের ডিফল্ট পোশাক পুনরুদ্ধার করে, যা NPC-তে প্রয়োগ করা যাবে না।",
  T_48_META_API_3225_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3226_D: "AI সত্তা আক্রমণ মনোনীত লক্ষ্য",
  T_48_META_API_3226_P0_D: "AI সত্তা যে আক্রমণটি সম্পাদন করে",
  T_48_META_API_3226_P1_D: "আক্রমণের লক্ষ্য",
  T_48_META_API_3227_D: "প্লেয়ারের অস্ত্রকে নির্দিষ্ট স্লটে অস্ত্রে স্যুইচ করুন",
  T_48_META_API_3227_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3227_P1_D: "স্যুইচ করতে অস্ত্র স্লট",
  T_48_META_API_3227_P2_D: "সুইচটি সফল হোক বা না হোক যদি অস্ত্রের স্লটে কোনো অস্ত্র না থাকে, তাহলে সুইচটি ব্যর্থ হবে।",
  T_48_META_API_3228_D: "লক্ষ্য প্লেয়ার বা NPC অস্ত্র চামড়া পান",
  T_48_META_API_3228_P0_D: "টার্গেট প্লেয়ার বা NPC",
  T_48_META_API_3228_P1_D: "অস্ত্র চামড়া আইডি",
  T_48_META_API_3228_R_D: "অস্ত্র চামড়া আইডি",
  T_48_META_API_3229_D: "লক্ষ্য প্লেয়ার বা NPC অস্ত্র চামড়া সেট",
  T_48_META_API_3229_P0_D: "টার্গেট প্লেয়ার বা NPC",
  T_48_META_API_3229_P1_D: "অস্ত্র চামড়া আইডি",
  T_48_META_API_3230_D: "টার্গেট প্লেয়ারের ডিফল্ট অস্ত্রের ত্বক পুনরুদ্ধার করে, যা NPC-তে প্রয়োগ করা যাবে না।",
  T_48_META_API_3230_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3230_P1_D: "অস্ত্র আইডি",
  T_48_META_API_3231_D: "প্লেয়ারের পোশাক সেট আপ করুন",
  T_48_META_API_3231_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3231_P1_D: "পোশাক তালিকা",
  T_48_META_API_3232_D: "টার্গেট প্লেয়ার বা NPC থেকে নির্দিষ্ট পোশাকের ধরণের সমস্ত পোশাক সরিয়ে দেয়",
  T_48_META_API_3232_P0_D: "টার্গেট প্লেয়ার বা NPC",
  T_48_META_API_3232_P1_D: "পোশাকের ধরন",
  T_48_META_API_3233_D: "প্লেয়ার বা NPC দ্বারা নির্দিষ্ট অস্ত্রের চামড়া সরান",
  T_48_META_API_3233_P0_D: "টার্গেট প্লেয়ার বা NPC",
  T_48_META_API_3233_P1_D: "অস্ত্র আইডি",
  T_48_META_API_3234_D: "টার্গেট বাফ যোগ করুন",
  T_48_META_API_3234_P0_D: "লক্ষ্য সত্তা অবশ্যই এমন একটি সত্তা হতে হবে যা বাফ যোগ করতে পারে",
  T_48_META_API_3234_P1_D: "বাফ আইডি",
  T_48_META_API_3235_D: "লক্ষ্য থেকে বাফ সরান",
  T_48_META_API_3235_P0_D: "লক্ষ্য সত্তা অবশ্যই এমন একটি সত্তা হতে হবে যা বাফ যোগ করতে পারে",
  T_48_META_API_3235_P1_D: "বাফ আইডি",
  T_48_META_API_3236_D: "লক্ষ্য এর বর্তমান বাফ পান",
  T_48_META_API_3236_P0_D: "লক্ষ্য সত্তা অবশ্যই এমন একটি সত্তা হতে হবে যা বাফ যোগ করতে পারে",
  T_48_META_API_3236_R_D: "বাফ তালিকা",
  T_48_META_API_3237_D: "লক্ষ্য খেলোয়াড়ের ব্যাকপ্যাকের তালিকায় আইটেমগুলি পান",
  T_48_META_API_3237_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3237_P1_D: "প্রপস তালিকা",
  T_48_META_API_3238_D: "নির্দিষ্ট স্লটে আনুষাঙ্গিক যোগ করুন যেগুলি ম্যাচিং করতে ব্যর্থ হবে কিন্তু প্লেয়ারের ব্যাকপ্যাকে আসল আনুষাঙ্গিকগুলি পাঠানো হবে৷ , আসল আনুষাঙ্গিক প্লেয়ারের বর্তমান অবস্থানে ড্রপ করা হবে",
  T_48_META_API_3238_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3238_P1_D: "সরঞ্জাম স্লট",
  T_48_META_API_3238_P2_D: "আনুষাঙ্গিক",
  T_48_META_API_3238_P3_D: `আনুষঙ্গিকটি সফলভাবে যোগ করা হয়েছে কিনা
সত্য: অনুষঙ্গটি সংশ্লিষ্ট স্লটে অস্ত্রের সাথে সজ্জিত করা হয়েছে
মিথ্যা: আনুষঙ্গিক যোগ করা যায়নি এবং প্লেয়ারের ব্যাকপ্যাকে প্রদর্শিত হবে না`,
  T_48_META_API_3238_P4_D: "আনুষাঙ্গিক যোগ করা হয়েছে, ব্যর্থ হলে খালি",
  T_48_META_API_3239_D: "ব্যাকপ্যাক সরঞ্জাম কলামে সরঞ্জাম পান",
  T_48_META_API_3239_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3239_P1_D: "সরঞ্জাম স্লট",
  T_48_META_API_3239_P2_D: "নির্দিষ্ট স্লটে ইকুইপমেন্ট না থাকলে খালি থাকবে।",
  T_48_META_API_3239_P3_D: "এই সরঞ্জাম জন্য সমস্ত আনুষাঙ্গিক",
  T_48_META_API_3240_D: "একটি দ্বি-মাত্রিক ভেক্টরের X উপাদান নিন",
  T_48_META_API_3240_P0_D: "2D ভেক্টর",
  T_48_META_API_3240_R_D: "দ্বি-মাত্রিক ভেক্টর X উপাদান",
  T_48_META_API_3241_D: "একটি দ্বি-মাত্রিক ভেক্টরের Y উপাদান নিন",
  T_48_META_API_3241_P0_D: "2D ভেক্টর",
  T_48_META_API_3241_R_D: "দ্বি-মাত্রিক ভেক্টর Y উপাদান",
  T_48_META_API_3242_D: "2D ভেক্টর X কম্পোনেন্ট সেট করে",
  T_48_META_API_3242_P0_D: "2D ভেক্টর",
  T_48_META_API_3242_P1_D: "দ্বি-মাত্রিক ভেক্টর X উপাদান",
  T_48_META_API_3243_D: "2D ভেক্টর Y উপাদান সেট করে",
  T_48_META_API_3243_P0_D: "2D ভেক্টর",
  T_48_META_API_3243_P1_D: "দ্বি-মাত্রিক ভেক্টর Y উপাদান",
  T_48_META_API_3244_D: "দুটি 2D ভেক্টর যোগ করুন",
  T_48_META_API_3244_P0_D: "বাম অপারেন্ড",
  T_48_META_API_3244_P1_D: "ডান অপারেন্ড",
  T_48_META_API_3244_R_D: "দ্বি-মাত্রিক ভেক্টর সংযোজন ফলাফল",
  T_48_META_API_3245_D: "দুটি 2D ভেক্টর বিয়োগ করুন",
  T_48_META_API_3245_P0_D: "বাম অপারেন্ড",
  T_48_META_API_3245_P1_D: "ডান অপারেন্ড",
  T_48_META_API_3245_R_D: "দ্বি-মাত্রিক ভেক্টর বিয়োগের ফলাফল",
  T_48_META_API_3246_D: "দ্বি-মাত্রিক ভেক্টর গুণ করুন",
  T_48_META_API_3246_P0_D: "2D ভেক্টর",
  T_48_META_API_3246_P1_D: "2D ভেক্টর স্কেলিং মান",
  T_48_META_API_3246_R_D: "দ্বি-মাত্রিক ভেক্টর গুণের ফলাফল",
  T_48_META_API_3247_D: "ডট পণ্য দুটি দ্বি-মাত্রিক ভেক্টর ডট পণ্যের ফলাফল একটি স্কেলার, যা দুটি ভেক্টরের মধ্যে কোণকে উপস্থাপন করে।",
  T_48_META_API_3247_P0_D: "বাম অপারেন্ড",
  T_48_META_API_3247_P1_D: "ডান অপারেন্ড",
  T_48_META_API_3247_R_D: "ডট গুণের ফলাফল",
  T_48_META_API_3248_D: "দুটি 2D ভেক্টরের ইউক্লিডীয় দূরত্ব গণনা করুন",
  T_48_META_API_3248_P0_D: "বাম অপারেন্ড",
  T_48_META_API_3248_P1_D: "ডান অপারেন্ড",
  T_48_META_API_3248_R_D: "দুটি ভেক্টর বিয়োগ করার পরে, ফলে ভেক্টরের মডিউল দৈর্ঘ্য",
  T_48_META_API_3249_D: "দুটি দ্বি-মাত্রিক ভেক্টরের মধ্যে কোণ গণনা করুন",
  T_48_META_API_3249_P0_D: "বাম অপারেন্ড",
  T_48_META_API_3249_P1_D: "ডান অপারেন্ড",
  T_48_META_API_3249_R_D: "ভেক্টর কোণ, কোণের পরিসীমা 0-180",
  T_48_META_API_3250_D: "একটি 2D ভেক্টরকে স্বাভাবিক করুন",
  T_48_META_API_3250_P0_D: "2D ভেক্টর",
  T_48_META_API_3250_R_D: "স্বাভাবিক ফলাফল হল একটি ভেক্টর যার দৈর্ঘ্য একই দিকে 1 মিটার।",
  T_48_META_API_3251_D: "একটি দ্বি-মাত্রিক ভেক্টর মডিউল",
  T_48_META_API_3251_P0_D: "2D ভেক্টর",
  T_48_META_API_3251_R_D: "মডিউল ফলাফল ভেক্টরের দৈর্ঘ্য",
  T_48_META_API_3252_D: "একটি সাধারণ উল্লম্ব সরলরেখা দ্বারা প্রতিফলিত একটি দ্বি-মাত্রিক ভেক্টরের ভেক্টর গণনা করুন",
  T_48_META_API_3252_P0_D: "ঘটনা 2D ভেক্টর",
  T_48_META_API_3252_P1_D: "সাধারণ 2D ভেক্টর",
  T_48_META_API_3252_R_D: "প্রতিফলন 2D ভেক্টর",
  T_48_META_API_3253_D: "একটি ত্রিমাত্রিক ভেক্টরের ভেক্টর গণনা করুন যা স্বাভাবিকের সাথে লম্বভাবে একটি সমতল দ্বারা প্রতিফলিত হয়",
  T_48_META_API_3253_P0_D: "ঘটনা ত্রিমাত্রিক ভেক্টর",
  T_48_META_API_3253_P1_D: "সাধারণ 3D ভেক্টর",
  T_48_META_API_3253_R_D: "প্রতিফলন 3D ভেক্টর",
  T_48_META_API_3254_D: "একটি ত্রিমাত্রিক ভেক্টরকে দ্বি-মাত্রিক ভেক্টরে রূপান্তর করুন এবং ত্রিমাত্রিক ভেক্টরের Z উপাদানটি মুছুন",
  T_48_META_API_3254_P0_D: "টার্গেট 3D ভেক্টর",
  T_48_META_API_3254_R_D: "রূপান্তরিত দ্বি-মাত্রিক ভেক্টর",
  T_48_META_API_3255_D: "একটি দ্বি-মাত্রিক ভেক্টরকে ত্রিমাত্রিক ভেক্টরে রূপান্তর করুন এবং ত্রিমাত্রিক ভেক্টরের Z উপাদানটিকে 0 এ সেট করুন",
  T_48_META_API_3255_P0_D: "টার্গেট 2D ভেক্টর",
  T_48_META_API_3255_R_D: "রূপান্তরিত ত্রিমাত্রিক ভেক্টর",
  T_48_META_API_3256_D: "একটি 2D ভেক্টর তৈরি করুন",
  T_48_META_API_3256_P0_D: "দ্বি-মাত্রিক ভেক্টরের X উপাদান",
  T_48_META_API_3256_P1_D: "দ্বি-মাত্রিক ভেক্টরের Y উপাদান",
  T_48_META_API_3256_R_D: "দ্বিমাত্রিক ভেক্টর তৈরি করেছে",
  T_48_META_API_3257_D: "ব্যবহারকারীর অভিজ্ঞতা ডেটা বিশ্লেষণের জন্য প্রতিযোগিতার পয়েন্ট লগ কাস্টমাইজ করুন",
  T_48_META_API_3257_P0_D: "লগ",
  T_48_META_API_3258_D: "ব্যবহারকারীর অভিজ্ঞতা ডেটা বিশ্লেষণের জন্য প্রতিযোগিতার পয়েন্ট লগ কাস্টমাইজ করুন",
  T_48_META_API_3258_P0_D: "খেলোয়াড়দের রিপোর্ট করা",
  T_48_META_API_3258_P1_D: "লগ",
  T_48_META_API_33_D: "নোংরা শব্দ ফিল্টার",
  T_48_META_API_33_P0_D: "মূল পাঠ্য যা নোংরা শব্দের জন্য ফিল্টার করা প্রয়োজন",
  T_48_META_API_33_R_D: "ফিল্টার করা পাঠ্য",
  T_48_META_API_3301_D: "একটি শিবির সত্তা তৈরি করুন",
  T_48_META_API_3301_P0_D: "উপদল সত্তা",
  T_48_META_API_3302_D: "লক্ষ্য সত্তা নির্দিষ্ট শিবিরে যোগদান করে",
  T_48_META_API_3302_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_3302_P1_D: "উপদল সত্তা",
  T_48_META_API_3303_D: "শিবিরের আক্রমণযোগ্য শিবির পান",
  T_48_META_API_3303_P0_D: "ক্যাম্প আক্রমণ করছে",
  T_48_META_API_3303_R_D: "দলগত সত্তা তালিকা",
  T_48_META_API_3304_D: "শিবিরের আক্রমণযোগ্য শিবির স্থাপন করুন",
  T_48_META_API_3304_P0_D: "ক্যাম্প আক্রমণ করছে",
  T_48_META_API_3304_P1_D: "লক্ষ্য শিবির",
  T_48_META_API_3304_P2_D: "এটা আক্রমণযোগ্য?",
  T_48_META_API_3305_D: "খেলোয়াড়দের আক্রমণ করার জন্য সেট আপ করুন",
  T_48_META_API_3305_P0_D: "খেলোয়াড়",
  T_48_META_API_3305_P1_D: "আক্রমণযোগ্য খেলোয়াড়",
  T_48_META_API_3305_P2_D: "এটা আক্রমণযোগ্য?",
  T_48_META_API_3306_D: "দলের আক্রমণযোগ্য দলগুলি সেট করুন",
  T_48_META_API_3306_P0_D: "আক্রমণকারী দল",
  T_48_META_API_3306_P1_D: "লক্ষ্য দল",
  T_48_META_API_3306_P2_D: "এটা আক্রমণযোগ্য?",
  T_48_META_API_3307_D: "অবচয়",
  T_48_META_API_3307_P0_D: "অবচয়",
  T_48_META_API_3307_R_D: "প্লেয়ার সত্তা তালিকা",
  T_48_META_API_3308_D: "নির্দিষ্ট সত্তা বর্তমান শিবির থেকে প্রস্থান করে",
  T_48_META_API_3308_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_3309_D: "লক্ষ্য এর উপদল পান",
  T_48_META_API_3309_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_3309_R_D: "উপদল সত্তা",
  T_48_META_API_3310_D: "লক্ষ্যবস্তু আক্রমণ করা যাবে কিনা তা নির্ধারণ করুন",
  T_48_META_API_3310_P0_D: "আক্রমণকারী",
  T_48_META_API_3310_P1_D: "লক্ষ্য সত্তা",
  T_48_META_API_3310_R_D: "এটা আক্রমণযোগ্য?",
  T_48_META_API_3311_D: "সত্তার জন্য আক্রমণযোগ্য লক্ষ্য নির্ধারণ করুন",
  T_48_META_API_3311_P0_D: "আক্রমণকারী",
  T_48_META_API_3311_P1_D: "লক্ষ্য সত্তা",
  T_48_META_API_3311_P2_D: "এটা আক্রমণযোগ্য?",
  T_48_META_API_3312_D: "একটি সত্তা আক্রমণযোগ্য লক্ষ্য পায়",
  T_48_META_API_3312_P0_D: "আক্রমণকারী",
  T_48_META_API_3312_R_D: "আক্রমণযোগ্য সত্তার তালিকা",
  T_48_META_API_34_D: "লক্ষ্য সত্তার উপাদান আছে কিনা তা নির্ধারণ করুন",
  T_48_META_API_34_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_34_P1_D: "উপাদান প্রকার",
  T_48_META_API_34_R_D: "বিদ্যমান আছে কি",
  T_48_META_API_35_D: "বট যোগ করুন",
  T_48_META_API_35_P0_D: "বট অসুবিধা স্তর",
  T_48_META_API_35_P1_D: "বট যে দলটির অন্তর্গত",
  T_48_META_API_35_P2_D: "তৈরি করা বট প্লেয়ার সত্তা",
  T_48_META_API_3500_D: "প্লেয়ার টোকেন ডেটা পান",
  T_48_META_API_3500_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3500_P1_D: "tokenID",
  T_48_META_API_3500_P2_D: "টোকেনের সংখ্যা",
  T_48_META_API_3500_P3_D: "এটা কি সফল?",
  T_48_META_API_3501_D: "খেলোয়াড়দের টোকেন ডেটা যোগ করুন",
  T_48_META_API_3501_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3501_P1_D: "tokenID",
  T_48_META_API_3501_P2_D: "টোকেনের সংখ্যা",
  T_48_META_API_3501_P3_D: "আদিম সফলভাবে বলা হয় কিনা",
  T_48_META_API_3502_D: "লক্ষ্য প্লেয়ার টোকেন গ্রাস",
  T_48_META_API_3502_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3502_P1_D: "tokenID",
  T_48_META_API_3502_P2_D: "টোকেনের সংখ্যা",
  T_48_META_API_3502_P3_D: "আদিম সফলভাবে বলা হয় কিনা",
  T_48_META_API_3503_D: "নির্দিষ্ট স্থানে টোকেন যোগ করুন",
  T_48_META_API_3503_P0_D: "অবস্থান",
  T_48_META_API_3503_P1_D: "tokenID",
  T_48_META_API_3503_P2_D: "টোকেনের সংখ্যা",
  T_48_META_API_3503_P3_D: "আদিম সফলভাবে বলা হয় কিনা",
  T_48_META_API_3504_D: "টার্গেট এআই নির্দিষ্ট দক্ষতা প্রকাশ করে",
  T_48_META_API_3504_P0_D: "লক্ষ্য AI",
  T_48_META_API_3504_P1_D: "দক্ষতা",
  T_48_META_API_3504_P2_D: "স্কিল টার্গেট",
  T_48_META_API_3504_P3_D: "দক্ষতা সফলভাবে মুক্তি পায় কিনা",
  T_48_META_API_3505_D: "প্রারম্ভিক বিন্দু থেকে শেষ বিন্দু পর্যন্ত একটি পাথফাইন্ডিং পাথ তৈরি করুন, যা বাধাগুলিকে বাইপাস করবে এবং এআই পাথফাইন্ডিংয়ের জন্য ব্যবহার করা যেতে পারে।",
  T_48_META_API_3505_P0_D: "শুরু বিন্দু স্থানাঙ্ক",
  T_48_META_API_3505_P1_D: "শেষ বিন্দু স্থানাঙ্ক",
  T_48_META_API_3505_P2_D: "পাথফাইন্ডিং পাথ সফলভাবে প্রতিষ্ঠিত হয়েছে কিনা",
  T_48_META_API_3505_P3_D: "ওয়েফাইন্ডিং পয়েন্ট সংগ্রহ",
  T_48_META_API_3506_D: "আচরণ ট্রি ব্ল্যাকবোর্ড ভেরিয়েবল সেট করুন",
  T_48_META_API_3506_P0_D: "লক্ষ্য আচরণ গাছ",
  T_48_META_API_3506_P1_D: "পরিবর্তনশীল নাম",
  T_48_META_API_3506_P2_D: "পরিবর্তনশীল মান",
  T_48_META_API_3507_D: "আচরণ গাছ ব্ল্যাকবোর্ড ভেরিয়েবল পান",
  T_48_META_API_3507_P0_D: "লক্ষ্য আচরণ গাছ",
  T_48_META_API_3507_P1_D: "পরিবর্তনশীল নাম",
  T_48_META_API_3507_P2_D: "পরিবর্তনশীল মান",
  T_48_META_API_3508_D: "আচরণ ট্রি নোড পরামিতি পান",
  T_48_META_API_3508_P0_D: "লক্ষ্য আচরণ গাছ নোড",
  T_48_META_API_3508_P1_D: "পরামিতি নাম",
  T_48_META_API_3508_P2_D: "পরামিতি মান",
  T_48_META_API_3509_D: "টার্গেট প্লেয়ারের গাড়ির চামড়া পান",
  T_48_META_API_3509_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3509_P1_D: "যানবাহন আইডি",
  T_48_META_API_3509_R_D: "গাড়ির চামড়া",
  T_48_META_API_3510_D: "টার্গেট প্লেয়ারের গাড়ির চামড়া সেট করুন",
  T_48_META_API_3510_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3510_P1_D: "গাড়ির চামড়া আইডি",
  T_48_META_API_3511_D: "লক্ষ্য কৃত গাড়ির স্কিন স্পষ্ট খেলার জন্য পরিষ্কার করুন",
  T_48_META_API_3511_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3511_P1_D: "যানবাহন আইডি",
  T_48_META_API_3512_D: "টার্গেট প্লেয়ারের ডিফল্ট গাড়ির ত্বক পুনরুদ্ধার করুন",
  T_48_META_API_3512_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_3512_P1_D: "যানবাহন আইডি",
  T_48_META_API_36_D: "স্লিপ টার্গেট, শুধুমাত্র ডাইনামিক টাইপ রিজিড বডির জন্য ব্যবহার করা যেতে পারে",
  T_48_META_API_36_P0_D: "লক্ষ্য অনমনীয় শরীর",
  T_48_META_API_37_D: "টার্গেট জাগিয়ে তুলুন, শুধুমাত্র ডাইনামিক টাইপ রিজিড বডির জন্য ব্যবহার করা যেতে পারে",
  T_48_META_API_37_P0_D: "লক্ষ্য অনমনীয় শরীর",
  T_48_META_API_38_D: "লক্ষ্য অনমনীয় শরীর ঘুমাচ্ছে কিনা তা পরীক্ষা করুন",
  T_48_META_API_38_P0_D: "লক্ষ্য অনমনীয় শরীর",
  T_48_META_API_38_R_D: "ঘুম আসছে নাকি",
  T_48_META_API_39_D: "ঘুমের থ্রেশহোল্ড সেট করুন",
  T_48_META_API_39_P0_D: "লক্ষ্য অনমনীয় শরীর",
  T_48_META_API_39_P1_D: "নিদ্রা থ্রেশহোল্ড তার গতিবিধি এবং ঘূর্ণন সময় একটি নির্দিষ্ট সময়ের জন্য এই মানের থেকে কম হলে ঘুমের অবস্থায় প্রবেশ করে।",
  T_48_META_API_4_D: "সমস্ত খেলোয়াড় সরাতে পারে কিনা তা সেট করুন",
  T_48_META_API_4_P0_D: `সত্য: সরানো যাবে
মিথ্যা: সরানো যাবে না`,
  T_48_META_API_40_D: "ঘুমের থ্রেশহোল্ড পান",
  T_48_META_API_40_P0_D: "লক্ষ্য অনমনীয় শরীর",
  T_48_META_API_40_R_D: "নিদ্রা থ্রেশহোল্ড তার গতিবিধি এবং ঘূর্ণন সময় একটি নির্দিষ্ট সময়ের জন্য এই মানের থেকে কম হলে ঘুমের অবস্থায় প্রবেশ করে।",
  T_48_META_API_4000_D: "পুরো টেবিলের বিষয়বস্তু পড়ুন এবং সারি ক্রমে একটি দ্বি-মাত্রিক অ্যারে ফেরত দিন।",
  T_48_META_API_4000_P0_D: "টেবিলের নাম",
  T_48_META_API_4000_R_D: "টেবিল বিষয়বস্তু",
  T_48_META_API_4001_D: "টেবিলের একটি সারির বিষয়বস্তু পড়ুন এবং একটি অ্যারে ফেরত দিন",
  T_48_META_API_4001_P0_D: "টেবিলের নাম",
  T_48_META_API_4001_P1_D: "পড়ার সারিগুলির সংখ্যা, 1 থেকে শুরু",
  T_48_META_API_4001_R_D: "সারণী একটি সারির বিষয়বস্তু নির্দিষ্ট করে",
  T_48_META_API_4002_D: "টেবিলের একটি কলামের বিষয়বস্তু পড়ুন এবং একটি অ্যারে ফেরত দিন",
  T_48_META_API_4002_P0_D: "টেবিলের নাম",
  T_48_META_API_4002_P1_D: "পড়ার জন্য কলামের সংখ্যা, 1 থেকে শুরু",
  T_48_META_API_4002_R_D: "সারণি একটি কলামের বিষয়বস্তু নির্দিষ্ট করে",
  T_48_META_API_4003_D: "একটি টেবিল ঘরের বিষয়বস্তু পড়ুন",
  T_48_META_API_4003_P0_D: "টেবিলের নাম",
  T_48_META_API_4003_P1_D: "পড়ার সারিগুলির সংখ্যা, 1 থেকে শুরু",
  T_48_META_API_4003_P2_D: "পড়ার জন্য কলামের সংখ্যা, 1 থেকে শুরু",
  T_48_META_API_4003_R_D: "সারণীতে নির্দিষ্ট ঘরের বিষয়বস্তু",
  T_48_META_API_4004_D: "সারি নম্বর এবং কলামের নাম দ্বারা টেবিলের একটি নির্দিষ্ট ঘরের বিষয়বস্তু পড়ুন",
  T_48_META_API_4004_P0_D: "টেবিলের নাম",
  T_48_META_API_4004_P1_D: "পড়ার সারিগুলির সংখ্যা, 1 থেকে শুরু",
  T_48_META_API_4004_P2_D: "পড়ার জন্য কলামের নাম",
  T_48_META_API_4004_R_D: "সারণীতে নির্দিষ্ট ঘরের বিষয়বস্তু",
  T_48_META_API_4005_D: "পুরো টেবিলের বিষয়বস্তু পড়ুন এবং একটি দ্বি-মাত্রিক অ্যারে ফেরত দিন",
  T_48_META_API_4005_P0_D: "টেবিলের নাম",
  T_48_META_API_4005_R_D: "টেবিলের বিষয়বস্তু, দ্বি-মাত্রিক অ্যারে",
  T_48_META_API_4006_D: "পুরো টেবিলের একটি নির্দিষ্ট সারির বিষয়বস্তু পড়ুন এবং একটি অ্যারে ফেরত দিন",
  T_48_META_API_4006_P0_D: "টেবিলের নাম",
  T_48_META_API_4006_P1_D: "পড়ার সারিগুলির সংখ্যা, 1 থেকে শুরু",
  T_48_META_API_4006_R_D: "টেবিল একটি সারির বিষয়বস্তু নির্দিষ্ট করে, একটি অ্যারের",
  T_48_META_API_4007_D: "পুরো টেবিলের একটি কলামের বিষয়বস্তু পড়ুন এবং একটি অ্যারে ফেরত দিন",
  T_48_META_API_4007_P0_D: "টেবিলের নাম",
  T_48_META_API_4007_P1_D: "পড়ার জন্য কলামের সংখ্যা, 1 থেকে শুরু",
  T_48_META_API_4007_R_D: "সারণি একটি কলাম, একটি অ্যারের বিষয়বস্তু নির্দিষ্ট করে",
  T_48_META_API_4008_D: "একটি টেবিল ঘরের বিষয়বস্তু পড়ুন",
  T_48_META_API_4008_P0_D: "টেবিলের নাম",
  T_48_META_API_4008_P1_D: "পড়ার সারিগুলির সংখ্যা, 1 থেকে শুরু",
  T_48_META_API_4008_P2_D: "পড়ার জন্য কলামের সংখ্যা, 1 থেকে শুরু",
  T_48_META_API_4008_R_D: "সারণীতে নির্দিষ্ট ঘরের বিষয়বস্তু",
  T_48_META_API_4009_D: "কলাম নম্বর এবং ঘরের মান দ্বারা নির্দিষ্ট সারি খুঁজুন",
  T_48_META_API_4009_P0_D: "টেবিলের নাম",
  T_48_META_API_4009_P1_D: "পড়ার জন্য কলামের সংখ্যা",
  T_48_META_API_4009_P2_D: "ঘরের মান খুঁজে বের করতে হবে",
  T_48_META_API_4009_R_D: "পাওয়া সারি, অ্যারের বিষয়বস্তু",
  T_48_META_API_4010_D: "কলামের নাম অনুসারে কলাম নম্বর পান",
  T_48_META_API_4010_P0_D: "টেবিলের নাম",
  T_48_META_API_4010_P1_D: "ক্রমিক নম্বর পরীক্ষা করতে কলামের নাম",
  T_48_META_API_4010_R_D: "কলামের সংখ্যা, 1 থেকে গণনা করা হচ্ছে",
  T_48_META_API_41_D: "গ্লোবাল স্লিপ থ্রেশহোল্ড সেট করুন, যেটি শুধুমাত্র নতুন জেনারেট করা ডায়নামিক টাইপ রিজিড বডির জন্য বৈধ।",
  T_48_META_API_41_P0_D: "নিদ্রা থ্রেশহোল্ড তার গতিবিধি এবং ঘূর্ণন সময় একটি নির্দিষ্ট সময়ের জন্য এই মানের থেকে কম হলে ঘুমের অবস্থায় প্রবেশ করে।",
  T_48_META_API_42_D: "গ্লোবাল স্লিপ থ্রেশহোল্ড পান",
  T_48_META_API_42_R_D: "স্লিপ থ্রেশহোল্ড, ডিফল্ট হল 0.005 নড়াচড়া এবং ঘূর্ণন সময়ের জন্য এই মানের থেকে কম হওয়ার পরে শারীরিক গণনা করা হবে না।",
  T_48_META_API_43_D: "প্রদত্ত কোয়াটার্নিয়নকে অয়লার কোণে রূপান্তর করুন YXZ যদি কোয়াটারনিয়ন বেআইনি হয় তাহলে ফেরত দিন (0,0,0)",
  T_48_META_API_43_P0_D: "ইনপুট quaternion",
  T_48_META_API_43_R_D: "অয়লার কোণ ফেরত দিয়েছে",
  T_48_META_API_44_D: "প্রদত্ত অয়লার কোণগুলিকে চতুর্ভুজে রূপান্তর করুন",
  T_48_META_API_44_P0_D: "ইনপুট অয়লার কোণ",
  T_48_META_API_44_R_D: "কোয়াটারনিয়ন ফিরে এসেছে",
  T_48_META_API_45_D: "অক্ষ কোণ দ্বারা উপস্থাপিত ঘূর্ণনকে কোয়াটারনিয়নে রূপান্তর করুন",
  T_48_META_API_45_P0_D: "ঘূর্ণনের অক্ষ",
  T_48_META_API_45_P1_D: "ঘূর্ণনের অক্ষের চারপাশে ঘড়ির কাঁটার দিকে ঘূর্ণনের কোণ",
  T_48_META_API_45_R_D: "কোয়াটারনিয়ন ফিরে এসেছে",
  T_48_META_API_46_D: "quaternion কে অক্ষ কোণ উপস্থাপনায় রূপান্তর করুন",
  T_48_META_API_46_P0_D: "ইনপুট quaternion",
  T_48_META_API_46_P1_D: "ঘূর্ণনের অক্ষ",
  T_48_META_API_46_P2_D: "ঘূর্ণনের অক্ষের চারপাশে ঘড়ির কাঁটার দিকে ঘূর্ণনের কোণ",
  T_48_META_API_47_D: "কাস্টম টাস্ক সমাপ্তির অগ্রগতি সেট করুন",
  T_48_META_API_47_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_47_P1_D: "টাস্ক আইডি",
  T_48_META_API_47_P2_D: "সমাপ্তির অগ্রগতি, নেতিবাচক সংখ্যা অনুমোদিত নয়",
  T_48_META_API_48_D: "একটি বেজিয়ার বক্ররেখা তৈরি করুন যা গতিকে ইন্টারপোলেট করতে ব্যবহার করা যেতে পারে",
  T_48_META_API_48_P0_D: "বক্ররেখা নিয়ন্ত্রণ পয়েন্ট",
  T_48_META_API_48_R_D: "বেজিয়ার কার্ভ",
  T_48_META_API_49_D: "দৃশ্য মানচিত্র আইডি পান",
  T_48_META_API_49_P0_D: "দৃশ্য আইডি",
  T_48_META_API_49_R_D: "মানচিত্র আইডি",
  T_48_META_API_5_D: "দৃশ্যে রাখা বস্তু মুছুন (অপ্রচলিত, অনুগ্রহ করে DeleteEntity ব্যবহার করুন)",
  T_48_META_API_5_P0_D: "অবজেক্ট সত্তা মুছে ফেলা হবে",
  T_48_META_API_50_D: "প্রতিটি ফ্রেমের সাথে আপেক্ষিক একটি গতি তৈরি করুন লক্ষ্য সত্তা প্রতিটি ফ্রেমে একবার তার নিজস্ব বৈশিষ্ট্যগুলি পরিবর্তন করে এবং প্রতিবার এটি তার বর্তমান বৈশিষ্ট্যের মানের সাথে পরিবর্তিত হয়।",
  T_48_META_API_50_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_50_P1_D: "গতি পরিবর্তন প্রয়োজন যে বৈশিষ্ট্য",
  T_48_META_API_50_P2_D: "আন্দোলন প্রতি পরিবর্তন পরিমাণ",
  T_48_META_API_50_P3_D: `কনফিগারেশন যখন অন্যান্য গতি মোডের সাথে সংমিশ্রণে ব্যবহার করা হয়
সত্য: আপেক্ষিক গতির সাথে সংমিশ্রণে ব্যবহার করা যেতে পারে
মিথ্যা: পরম গতির সাথে সংমিশ্রণে ব্যবহার করা যেতে পারে`,
  T_48_META_API_50_P4_D: "প্রতি ফ্রেমে নিজের সাপেক্ষে তৈরি গতি সত্তা",
  T_48_META_API_50_P5_D: "সৃষ্টির পর স্বয়ংক্রিয়ভাবে বাজানো শুরু হবে কিনা",
  T_48_META_API_5000_D: "ডাটাবেসের একটি টেবিলে একটি কী-এর সাথে সম্পর্কিত মানটি পড়ুন",
  T_48_META_API_5000_P0_D: "ডাটাবেসে টেবিলের নাম",
  T_48_META_API_5000_P1_D: "খেলোয়াড়দের চিহ্নিত করুন এবং সঙ্গতিপূর্ণ পরিস্থিতি পরিচালনা করুন",
  T_48_META_API_5000_P2_D: "ডেটা সনাক্ত করতে ব্যবহৃত একটি কাস্টম নাম",
  T_48_META_API_5000_P3_D: "পঠিত ফলাফল ফেরত দিন",
  T_48_META_API_5000_P4_D: "ডাটাবেসের সাথে যুক্তিযুক্ত বৈদ্যুতিক ক্ষেত্রের কোড",
  T_48_META_API_5001_D: "ডাটাবেসের একটি টেবিলে কী-এর সাথে সম্পর্কিত মানটি লিখুন",
  T_48_META_API_5001_P0_D: "ডাটাবেসে টেবিলের নাম",
  T_48_META_API_5001_P1_D: "খেলোয়াড়দের চিহ্নিত করুন এবং সঙ্গতিপূর্ণ পরিস্থিতি পরিচালনা করুন",
  T_48_META_API_5001_P2_D: "ডেটা সনাক্ত করতে ব্যবহৃত একটি কাস্টম নাম",
  T_48_META_API_5001_P3_D: "মান লিখিত",
  T_48_META_API_5001_P4_D: "ডাটাবেসের সাথে সম্পর্কিত যুদ্ধক্ষেত্রের কোড, যা শূন্যস্থান পূরণ করা যেতে পারে, বর্তমান মানচিত্রের যুদ্ধক্ষেত্রের কোডকে প্রতিনিধিত্ব করে।",
  T_48_META_API_5002_D: "ডাটাবেসের একটি নির্দিষ্ট টেবিলে একটি নির্দিষ্ট কী-এর সাথে সম্পর্কিত মানটি মুছুন",
  T_48_META_API_5002_P0_D: "ডাটাবেসে টেবিলের নাম",
  T_48_META_API_5002_P1_D: "খেলোয়াড়দের চিহ্নিত করুন এবং সঙ্গতিপূর্ণ পরিস্থিতি পরিচালনা করুন",
  T_48_META_API_5002_P2_D: "ডেটা সনাক্ত করতে ব্যবহৃত একটি কাস্টম নাম",
  T_48_META_API_5002_P3_D: "ডাটাবেসের সাথে যুক্তিযুক্ত বৈদ্যুতিক ক্ষেত্রের কোড",
  T_48_META_API_5003_D: "ডাটাবেসের র‌্যাঙ্কিং টেবিলে একটি কী-এর সাথে সম্পর্কিত মান পড়ুন",
  T_48_META_API_5003_P0_D: "ডাটাবেসে র‌্যাঙ্কিং টেবিলের নাম",
  T_48_META_API_5003_P1_D: "ডেটা সনাক্ত করতে ব্যবহৃত একটি কাস্টম নাম",
  T_48_META_API_5003_P2_D: "পঠিত ফলাফল ফেরত দিন",
  T_48_META_API_5003_P3_D: "ডাটাবেসের সাথে যুক্তিযুক্ত বৈদ্যুতিক ক্ষেত্রের কোড",
  T_48_META_API_5004_D: "ডাটাবেসের একটি র‌্যাঙ্কিং টেবিলে কী-এর সাথে সম্পর্কিত মানটি লিখুন",
  T_48_META_API_5004_P0_D: "ডাটাবেসে র‌্যাঙ্কিং টেবিলের নাম",
  T_48_META_API_5004_P1_D: "ডেটা সনাক্ত করতে ব্যবহৃত একটি কাস্টম নাম",
  T_48_META_API_5004_P2_D: "মান লিখিত",
  T_48_META_API_5004_P3_D: "ডাটাবেসের সাথে যুক্তিযুক্ত বৈদ্যুতিক ক্ষেত্রের কোড",
  T_48_META_API_5005_D: "ডাটাবেসের একটি র‌্যাঙ্কিং টেবিলের কী-এর সাথে সম্পর্কিত মানটি মুছুন",
  T_48_META_API_5005_P0_D: "ডাটাবেসে টেবিলের নাম",
  T_48_META_API_5005_P1_D: "ডেটা সনাক্ত করতে ব্যবহৃত একটি কাস্টম নাম",
  T_48_META_API_5005_P2_D: "ডাটাবেসের সাথে যুক্তিযুক্ত বৈদ্যুতিক ক্ষেত্রের কোড",
  T_48_META_API_5006_D: "ডাটাবেসের একটি র‌্যাঙ্কিং টেবিলে একটি নির্দিষ্ট র‌্যাঙ্কিংয়ের সাথে সম্পর্কিত মানটি মুছুন",
  T_48_META_API_5006_P0_D: "ডাটাবেসে টেবিলের নাম",
  T_48_META_API_5006_P1_D: "লিডারবোর্ডে অবস্থান",
  T_48_META_API_5006_P2_D: "ডাটাবেসের সাথে যুক্তিযুক্ত বৈদ্যুতিক ক্ষেত্রের কোড",
  T_48_META_API_5007_D: "ডাটাবেসের একটি র‌্যাঙ্কিং টেবিলে একটি নির্দিষ্ট র‌্যাঙ্কিং থেকে একটি নির্দিষ্ট র‌্যাঙ্কিং পর্যন্ত মানগুলি পড়ুন",
  T_48_META_API_5007_P0_D: "ডাটাবেসে টেবিলের নাম",
  T_48_META_API_5007_P1_D: "প্রারম্ভিক র্যাঙ্ক",
  T_48_META_API_5007_P2_D: "শেষ র‌্যাঙ্কিং",
  T_48_META_API_5007_P3_D: "পঠিত ফলাফল ফেরত দিন",
  T_48_META_API_5007_P4_D: "ডাটাবেসের সাথে যুক্তিযুক্ত বৈদ্যুতিক ক্ষেত্রের কোড",
  T_48_META_API_5008_D: "ক্রমবর্ধমান ডাটাবেসের একটি টেবিলের একটি কী-এর সাথে সম্পর্কিত মানটি পড়ুন",
  T_48_META_API_5008_P0_D: "ডাটাবেসে টেবিলের নাম",
  T_48_META_API_5008_P1_D: "ডেটা সনাক্ত করতে ব্যবহৃত একটি কাস্টম নাম",
  T_48_META_API_5008_P2_D: "পঠিত ফলাফল ফেরত দিন",
  T_48_META_API_5008_P3_D: "ডাটাবেসের সাথে যুক্তিযুক্ত বৈদ্যুতিক ক্ষেত্রের কোড",
  T_48_META_API_5009_D: "ক্রমবর্ধমান ডাটাবেসের একটি টেবিলে একটি কী এর সাথে সম্পর্কিত অফসেট মান লিখুন",
  T_48_META_API_5009_P0_D: "ডাটাবেসে টেবিলের নাম",
  T_48_META_API_5009_P1_D: "ডেটা সনাক্ত করতে ব্যবহৃত একটি কাস্টম নাম",
  T_48_META_API_5009_P2_D: "চার ধরনের গাণিতিক ক্রিয়াকলাপ বর্তমানে নিম্নলিখিত প্রকারগুলিকে সমর্থন করে: int টাইপ যোগ, বিয়োগ, গুণ, ভাগ এবং অবশিষ্টাংশ সমর্থন করে যোগ, বিয়োগ, গুণ এবং ভাগ;",
  T_48_META_API_5009_P3_D: "অফসেট মান লেখা",
  T_48_META_API_5009_P4_D: "ডাটাবেসের সাথে যুক্তিযুক্ত বৈদ্যুতিক ক্ষেত্রের কোড",
  T_48_META_API_51_D: "খেলার যোগ্য সত্তা রিসেট করুন এবং প্লেব্যাক অবস্থা পরিবর্তন না করেই খেলার যোগ্য সত্তাটিকে তার প্রাথমিক ফর্মে পুনরুদ্ধার করুন।",
  T_48_META_API_51_P0_D: "লক্ষ্য খেলার যোগ্য সত্তা",
  T_48_META_API_52_D: "দুটি চতুর্ভুজ A*B মানে প্রথমে A ঘোরানো এবং তারপর B ঘোরানো। বিভিন্ন ঘূর্ণন ক্রম ভিন্ন ফলাফলের দিকে নিয়ে যাবে।",
  T_48_META_API_52_P0_D: "lvalue quaternion",
  T_48_META_API_52_P1_D: "rvalue quaternion",
  T_48_META_API_52_R_D: "ফলাফল quaternion",
  T_48_META_API_53_D: "নির্দিষ্ট দিকের দিকে মুখ করে একটি ঘূর্ণায়মান চতুর্ভুজ তৈরি করে",
  T_48_META_API_53_P0_D: "দিক নির্দেশ করুন",
  T_48_META_API_53_P1_D: "ঊর্ধ্বমুখী দিক",
  T_48_META_API_53_R_D: "নির্দিষ্ট দিকে সারিবদ্ধ করার জন্য প্রয়োজনীয় ঘূর্ণনের পরিমাণ",
  T_48_META_API_54_D: "A থেকে B পর্যন্ত কোয়াটারনিয়ন গোলাকার ইন্টারপোলেশন",
  T_48_META_API_54_P0_D: "A এর মান",
  T_48_META_API_54_P1_D: "B এর মান",
  T_48_META_API_54_P2_D: "ইন্টারপোলেশন অগ্রগতি, মান পরিসীমা [0,1], যখন মান 0 হয়, তখন প্রারম্ভিক মান ফেরত দেওয়া হয়, যখন মান 1 হয়, লক্ষ্য মান ফেরত দেওয়া হয়",
  T_48_META_API_54_R_D: "ফলাফল quaternion",
  T_48_META_API_57_D: "একটি সতর্কতা হিসাবে কনসোলে লক্ষ্য ডেটা মুদ্রণ করুন",
  T_48_META_API_57_P0_D: "কি প্রিন্ট করা প্রয়োজন",
  T_48_META_API_58_D: "ত্রুটি আকারে কনসোলে লক্ষ্য ডেটা মুদ্রণ করুন",
  T_48_META_API_58_P0_D: "কি প্রিন্ট করা প্রয়োজন",
  T_48_META_API_59_D: "বক্ররেখার মান পান",
  T_48_META_API_59_P0_D: "বক্ররেখা",
  T_48_META_API_59_P1_D: "নমুনা বিন্দু, মান পরিসীমা [0,1]",
  T_48_META_API_59_R_D: "ফলাফল",
  T_48_META_API_6_D: "নির্দিষ্ট স্থানাঙ্কে দৃশ্য অবজেক্ট তৈরি করুন",
  T_48_META_API_6_P0_D: "দৃশ্য বস্তু সত্তা তৈরি",
  T_48_META_API_6_P1_D: "অবস্থান যেখানে বস্তু উৎপন্ন হয়",
  T_48_META_API_6_P2_D: "কোড স্ক্রিপ্টে তৈরি করা অবজেক্ট টাইপ আইডি ব্যবহার করার সময়, আপনাকে আগে থেকেই সম্পদ নিবন্ধনে লেভেল অবজেক্টের গণনা নিবন্ধন করতে হবে।",
  T_48_META_API_60_D: "বক্ররেখা থেকে ইন্টারপোলেট",
  T_48_META_API_60_P0_D: "মান প্রকার",
  T_48_META_API_60_P1_D: "প্রারম্ভিক মান",
  T_48_META_API_60_P2_D: "লক্ষ্য মান",
  T_48_META_API_60_P3_D: "বক্ররেখা",
  T_48_META_API_60_P4_D: "নমুনা বিন্দু, মান পরিসীমা [0,1]",
  T_48_META_API_60_R_D: "ফলাফল",
  T_48_META_API_6000_D: "লক্ষ্য সত্তার জন্য স্ক্রিপ্ট যোগ করুন",
  T_48_META_API_6000_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_6000_P1_D: "স্ক্রিপ্ট আইডি",
  T_48_META_API_6001_D: "লক্ষ্য সত্তার জন্য স্ক্রিপ্ট আনইনস্টল করুন",
  T_48_META_API_6001_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_6001_P1_D: "স্ক্রিপ্ট আইডি",
  T_48_META_API_6002_D: "লক্ষ্য সত্তায় নির্দিষ্ট স্ক্রিপ্ট বিদ্যমান কিনা তা পরীক্ষা করুন",
  T_48_META_API_6002_P0_D: "লক্ষ্য সত্তা",
  T_48_META_API_6002_P1_D: "স্ক্রিপ্ট আইডি",
  T_48_META_API_6002_R_D: "নির্দিষ্ট স্ক্রিপ্ট বিদ্যমান কিনা",
  T_48_META_API_61_D: "UI নিয়ন্ত্রণের মূল নোড সেট করুন",
  T_48_META_API_61_P0_D: "প্যারেন্ট নোড, আপনি UI নিয়ন্ত্রণ বা কাস্টম UI নির্দিষ্ট করতে পারেন",
  T_48_META_API_61_P1_D: "শিশু নোড",
  T_48_META_API_62_D: "অবচয়",
  T_48_META_API_62_P0_D: "অবচয়",
  T_48_META_API_62_P1_D: "অবচয়",
  T_48_META_API_62_P2_D: "অবচয়",
  T_48_META_API_62_P3_D: "অবচয়",
  T_48_META_API_62_P4_D: "অবচয়",
  T_48_META_API_63_D: "বর্তমান ক্যামেরা থেকে স্ক্রীন টাচ পয়েন্টে একটি রশ্মি তৈরি করে",
  T_48_META_API_63_P0_D: "পর্দা স্পর্শ পয়েন্ট",
  T_48_META_API_63_P1_D: "শুরু বিন্দু",
  T_48_META_API_63_P2_D: "রশ্মির দিক",
  T_48_META_API_64_D: "কাস্টম বিলিং তথ্য আপলোড করুন",
  T_48_META_API_64_P0_D: "খেলোয়াড় সত্তা",
  T_48_META_API_64_P1_D: "ম্যাচের ফলাফল",
  T_48_META_API_64_P2_D: "পয়েন্ট শিরোনাম",
  T_48_META_API_64_P3_D: "পয়েন্ট মান",
  T_48_META_API_65_D: "নির্দিষ্ট সাউন্ড ইফেক্ট চালান যদি আরও বেশি বৈশিষ্ট্য সেট করতে হয়, তাহলে আপনি এর সত্তা বৈশিষ্ট্য সেট করতে পারেন।",
  T_48_META_API_65_P0_D: "শব্দ প্রভাব সত্তা তৈরি",
  T_48_META_API_65_P1_D: "টার্গেট প্লেয়ার, শুধুমাত্র টার্গেট প্লেয়ার সাউন্ড ইফেক্ট শুনতে পারে",
  T_48_META_API_65_P2_D: "সাউন্ড এফেক্ট টাইপ",
  T_48_META_API_65_P3_D: "লুপ টাইপ",
  T_48_META_API_65_P4_D: "সাথে সাথে খেলতে হবে কিনা",
  T_48_META_API_66_D: "একটি নির্দিষ্ট ভিজ্যুয়াল এফেক্ট তৈরি করুন যদি আরও বেশি বৈশিষ্ট্য সেট করা প্রয়োজন হয়, তাহলে আপনি এর সত্তা বৈশিষ্ট্য সেট করতে পারেন।",
  T_48_META_API_66_P0_D: "বিশেষ প্রভাব সত্তা তৈরি",
  T_48_META_API_66_P1_D: "টার্গেট প্লেয়ার, শুধুমাত্র টার্গেট প্লেয়ারই দৃশ্যমান",
  T_48_META_API_66_P2_D: "বিশেষ প্রভাব টাইপ",
  T_48_META_API_66_P3_D: "লুপ টাইপ",
  T_48_META_API_66_P4_D: "সাথে সাথে খেলতে হবে কিনা",
  T_48_META_API_67_D: "নির্দিষ্ট সাউন্ড ইফেক্ট তৈরি করুন যদি আরও বেশি বৈশিষ্ট্য সেট করতে হয়, তাহলে আপনি এর সত্তা বৈশিষ্ট্য সেট করতে পারেন।",
  T_48_META_API_67_P0_D: "শব্দ প্রভাব সত্তা তৈরি",
  T_48_META_API_67_P1_D: "সাউন্ড এফেক্ট টাইপ",
  T_48_META_API_67_P2_D: "লুপ টাইপ",
  T_48_META_API_67_P3_D: "সাথে সাথে খেলতে হবে কিনা",
  T_48_META_API_68_D: "বিশ্বের স্থানাঙ্কগুলিকে পর্দা স্থানাঙ্কে রূপান্তর করুন",
  T_48_META_API_68_P0_D: "বিশ্বের স্থানাঙ্ক",
  T_48_META_API_68_P1_D: "স্ক্রিনে ম্যাপ করতে হবে কিনা",
  T_48_META_API_68_P2_D: "মানচিত্র অবস্থান",
  T_48_META_API_69_D: "স্ক্রিন স্থানাঙ্কগুলিকে বিশ্ব স্থানাঙ্কে রূপান্তর করুন",
  T_48_META_API_69_P0_D: "পর্দা স্থানাঙ্ক",
  T_48_META_API_69_P1_D: "পর্দা থেকে দূরত্ব",
  T_48_META_API_69_P2_D: "বিশ্বের স্থানাঙ্ক",
  T_48_META_API_7_D: "টার্গেট ভ্যালুকে স্ট্রিংয়ে কনভার্ট করুন",
  T_48_META_API_7_P0_D: "লক্ষ্য মান একটি স্ট্রিং এ রূপান্তরিত করা হবে",
  T_48_META_API_7_R_D: "স্ট্রিং",
  T_48_META_API_70_D: "স্ক্রিন টাচের মাধ্যমে রশ্মি সনাক্তকরণ সঞ্চালন করুন এবং প্রথম হিট সত্তাটি ফিরিয়ে দিন",
  T_48_META_API_70_P0_D: "হোম স্ক্রীন স্পর্শ",
  T_48_META_API_70_P1_D: "সনাক্তকরণ দূরত্ব",
  T_48_META_API_70_P2_D: "লেয়ার মাস্ক, শুধুমাত্র ভরা লেয়ারগুলোই স্ক্যানে অংশ নেবে, ফাঁকা রাখলে সব লেয়ার স্ক্যানে অংশগ্রহণ করবে",
  T_48_META_API_70_P3_D: "এটা কি ট্রিগার সনাক্ত করা সম্ভব?",
  T_48_META_API_70_P4_D: "আঘাত সত্তা",
  T_48_META_API_70_P5_D: "হিট পয়েন্ট স্থানাঙ্ক",
  T_48_META_API_70_P6_D: "হিট পয়েন্ট থেকে স্টার্ট পয়েন্ট পর্যন্ত দূরত্ব",
  T_48_META_API_70_P7_D: "হিট পৃষ্ঠ স্বাভাবিক",
  T_48_META_API_71_D: "স্ক্রীন টাচের মাধ্যমে রশ্মি সনাক্তকরণ, সমস্ত হিট সত্তা ফেরত দেয়",
  T_48_META_API_71_P0_D: "হোম স্ক্রীন স্পর্শ",
  T_48_META_API_71_P1_D: "সনাক্তকরণ দূরত্ব",
  T_48_META_API_71_P2_D: "লেয়ার মাস্ক, শুধুমাত্র ভরা লেয়ারগুলোই স্ক্যানে অংশ নেবে, ফাঁকা রাখলে সব লেয়ার স্ক্যানে অংশগ্রহণ করবে",
  T_48_META_API_71_P3_D: "এটা কি ট্রিগার সনাক্ত করা সম্ভব?",
  T_48_META_API_71_P4_D: "হিট সত্তা তালিকা",
  T_48_META_API_71_P5_D: "হিট পয়েন্ট স্থানাঙ্ক তালিকা",
  T_48_META_API_71_P6_D: "হিট পয়েন্ট এবং স্টার্ট পয়েন্টের মধ্যে দূরত্বের তালিকা",
  T_48_META_API_71_P7_D: "পৃষ্ঠের স্বাভাবিক তালিকায় আঘাত করুন",
  T_48_META_API_72_D: "একটি নির্দিষ্ট ভিজ্যুয়াল এফেক্ট তৈরি করুন যদি আরও বেশি বৈশিষ্ট্য সেট করা প্রয়োজন হয়, তাহলে আপনি এর সত্তা বৈশিষ্ট্য সেট করতে পারেন।",
  T_48_META_API_72_P0_D: "বিশেষ প্রভাব সত্তা তৈরি",
  T_48_META_API_72_P1_D: "বিশেষ প্রভাব টাইপ",
  T_48_META_API_72_P2_D: "লুপ টাইপ",
  T_48_META_API_72_P3_D: "সাথে সাথে খেলতে হবে কিনা",
  T_48_META_API_73_D: "একটি অন্তর্নির্মিত UI তৈরি করুন যা অন্য ক্লায়েন্টদের সাথে সিঙ্ক্রোনাইজ করা হয় না",
  T_48_META_API_73_P0_D: "বিল্ট-ইন UI সত্তা তৈরি করা হয়েছে",
  T_48_META_API_73_P1_D: "অন্তর্নির্মিত UI প্রকার",
  T_48_META_API_74_D: "একটি কাস্টম UI তৈরি করুন যা অন্য ক্লায়েন্টদের সাথে সিঙ্ক করা হবে না",
  T_48_META_API_74_P0_D: "কাস্টম UI সত্তা তৈরি করা হয়েছে",
  T_48_META_API_74_P1_D: "কাস্টম UI সূচক",
  T_48_META_API_75_D: "বর্তমান ক্লায়েন্টের সাথে সংশ্লিষ্ট প্লেয়ার পান",
  T_48_META_API_75_R_D: "খেলোয়াড় সত্তা",
  T_48_META_API_76_D: "এআই দানব তৈরি করুন",
  T_48_META_API_76_P0_D: "লক্ষ্য AI",
  T_48_META_API_76_P1_D: "অবস্থান তৈরি করুন",
  T_48_META_API_76_P2_D: "এআই টাইপ",
  T_48_META_API_76_P3_D: "দল",
  T_48_META_API_76_P4_D: "শত্রুদের জন্য স্বয়ংক্রিয়ভাবে অনুসন্ধান করতে হবে কিনা",
  T_48_META_API_76_P5_D: "আক্রমণ মোড",
  T_48_META_API_76_P6_D: "ভ্রমণের পথ",
  T_48_META_API_77_D: "ভেক্টরের প্রথম উপাদান সেট করুন",
  T_48_META_API_77_P0_D: "ভেক্টর",
  T_48_META_API_77_P1_D: "প্রথম উপাদান মান",
  T_48_META_API_77_R_D: "প্রথম উপাদান পরিবর্তন করার পর ভেক্টর",
  T_48_META_API_78_D: "ভেক্টরের দ্বিতীয় উপাদান সেট করে",
  T_48_META_API_78_P0_D: "ভেক্টর",
  T_48_META_API_78_P1_D: "দ্বিতীয় উপাদান মান",
  T_48_META_API_78_R_D: "দ্বিতীয় উপাদান পরিবর্তন করার পর ভেক্টর",
  T_48_META_API_79_D: "ভেক্টরের তৃতীয় উপাদান সেট করে",
  T_48_META_API_79_P0_D: "ভেক্টর",
  T_48_META_API_79_P1_D: "তৃতীয় উপাদান মান",
  T_48_META_API_79_R_D: "তৃতীয় উপাদান পরিবর্তন করার পর ভেক্টর",
  T_48_META_API_8_D: "নিরাপদ এলাকা চালু করুন যা কেন্দ্র স্থানাঙ্ক বিন্দুতে সঙ্কুচিত হবে",
  T_48_META_API_8_P0_D: "নিরাপদ অঞ্চলের কেন্দ্রবিন্দু",
  T_48_META_API_8_P1_D: "নিরাপদ অঞ্চলের ব্যাসার্ধ",
  T_48_META_API_8_P2_D: "অপেক্ষার সময়, সেকেন্ডের মধ্যে, যার পরে নিরাপদ অঞ্চল কেন্দ্র বিন্দুর দিকে সঙ্কুচিত হতে শুরু করবে",
  T_48_META_API_8_P3_D: "নিরাপদ এলাকা কেন্দ্র বিন্দুতে সঙ্কুচিত হওয়ার জন্য প্রয়োজনীয় সময়, সেকেন্ডে",
  T_48_META_API_8_P4_D: "নিরাপদ অঞ্চলের বাইরে প্রতি সেকেন্ডে নেওয়া ক্ষতির পরিমাণ",
  T_48_META_API_80_D: "দ্বি-মাত্রিক ভেক্টরের প্রথম উপাদান সেট করে",
  T_48_META_API_80_P0_D: "2D ভেক্টর",
  T_48_META_API_80_P1_D: "প্রথম উপাদান মান",
  T_48_META_API_80_R_D: "প্রথম উপাদান পরিবর্তন করার পর দ্বিমাত্রিক ভেক্টর",
  T_48_META_API_81_D: "একটি 2D ভেক্টরের দ্বিতীয় উপাদান সেট করে",
  T_48_META_API_81_P0_D: "2D ভেক্টর",
  T_48_META_API_81_P1_D: "দ্বিতীয় উপাদান মান",
  T_48_META_API_81_R_D: "দ্বিতীয় উপাদান পরিবর্তন করার পর দ্বিমাত্রিক ভেক্টর",
  T_48_META_API_82_D: "অক্ষর নিয়ন্ত্রককে নির্দিষ্ট অবস্থানে নিয়ে যান যদি এটি প্লেয়ারকে প্রভাবিত করে, প্লেয়ারকে অবশ্যই প্লেয়ার কন্ট্রোলার চালু করতে হবে যা কার্যকর করার জন্য শারীরিক প্রভাব ব্যবহার করে।",
  T_48_META_API_82_P0_D: "লক্ষ্য অক্ষর নিয়ামক",
  T_48_META_API_82_P1_D: "অবস্থান নির্দিষ্ট করুন",
  T_48_META_API_83_D: "টার্গেট প্যারেন্ট নোড এন্টিটির নামের উপর ভিত্তি করে নির্দিষ্ট চাইল্ড নোড পান",
  T_48_META_API_83_P0_D: "প্যারেন্ট নোড সত্তা",
  T_48_META_API_83_P1_D: "চাইল্ড নোডের নাম",
  T_48_META_API_83_R_D: "চাইল্ড নোড সত্তা",
  T_48_META_API_84_D: "AOI বিশেষ মনোযোগ যোগ করুন, দূরত্ব নির্বিশেষে সর্বদা সিঙ্ক্রোনাইজ করুন",
  T_48_META_API_84_P0_D: "বিশেষ উদ্বেগের লক্ষ্য",
  T_48_META_API_84_P1_D: "পর্যবেক্ষক",
  T_48_META_API_85_D: "AOI বিশেষ মনোযোগ সরান এবং দৃষ্টির বাইরে AOI সিঙ্ক্রোনাইজেশন বাতিল করুন",
  T_48_META_API_85_P0_D: "বিশেষ উদ্বেগের লক্ষ্য",
  T_48_META_API_85_P1_D: "পর্যবেক্ষক",
  T_48_META_API_86_D: "নির্দিষ্ট লক্ষ্যের সমস্ত AOI সাফ করুন",
  T_48_META_API_86_P0_D: "বিশেষ উদ্বেগের লক্ষ্য",
  T_48_META_API_87_D: "AOI বিশেষ উদ্বেগ আছে কিনা তা নির্ধারণ করুন",
  T_48_META_API_87_P0_D: "বিশেষ উদ্বেগের লক্ষ্য",
  T_48_META_API_87_P1_D: "অবচয়",
  T_48_META_API_87_R_D: "বিদ্যমান আছে কি",
  T_48_META_API_88_D: "প্লেয়ারের প্রক্সি পর্যবেক্ষক টগল করুন",
  T_48_META_API_88_P0_D: "খেলোয়াড়",
  T_48_META_API_88_P1_D: "প্রক্সি পর্যবেক্ষক",
  T_48_META_API_89_D: "অক্ষর নিয়ন্ত্রক একবার স্থানচ্যুত করুন যদি এটি প্লেয়ারকে প্রভাবিত করে, প্লেয়ারকে অবশ্যই প্লেয়ার কন্ট্রোলার চালু করতে হবে যা কার্যকর করার জন্য শারীরিক প্রভাব ব্যবহার করে।",
  T_48_META_API_89_P0_D: "টার্গেট অবজেক্ট, যদি এটি একটি প্লেয়ার হয়, প্লেয়ারকে অবশ্যই ফিজিক্স ব্যবহার করে প্লেয়ার কন্ট্রোলার চালু করতে হবে যাতে প্রভাব কার্যকর হয়",
  T_48_META_API_89_P1_D: "স্থানচ্যুতি ভেক্টর",
  T_48_META_API_9_D: "সেফ জোন মেকানিজম বন্ধ করুন যখন সেফ জোন মেকানিজম বন্ধ হয়ে যাবে, তখন সেফ জোনের বাইরে থাকা খেলোয়াড়রা আবার নিরাপদ থাকবে।",
  T_48_META_API_90_D: "খেলোয়াড়রা অবাধে প্রস্থান করতে পারে কিনা তা সেট করুন",
  T_48_META_API_90_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_90_P1_D: "এটা স্বাধীনভাবে প্রস্থান করা সম্ভব?",
  T_48_META_API_9000_D: "একটি অন্তর্নির্মিত UI তৈরি করুন যা শুধুমাত্র মনোনীত খেলোয়াড়রা দেখতে পারে",
  T_48_META_API_9000_P0_D: "বিল্ট-ইন UI সত্তা তৈরি করা হয়েছে",
  T_48_META_API_9000_P1_D: "UI যে প্লেয়ার সত্তার অন্তর্গত, শুধুমাত্র এই প্লেয়ারের কাছে দৃশ্যমান৷",
  T_48_META_API_9000_P2_D: "অন্তর্নির্মিত UI প্রকার",
  T_48_META_API_9001_D: "অন্তর্নির্মিত গেম UI সরান",
  T_48_META_API_9001_P0_D: "সরানোর জন্য অন্তর্নির্মিত UI সত্তা",
  T_48_META_API_9002_D: "নির্দিষ্ট আইকন টাইপ ব্যবহার করে একটি আইকন তৈরি করুন যদি আরও বেশি বৈশিষ্ট্য সেট করতে হয়, তাহলে সত্তার মাধ্যমে এর সত্তা বৈশিষ্ট্যগুলি সেট করুন (অপ্রচলিত, দয়া করে CreateLevelObject ব্যবহার করুন)",
  T_48_META_API_9002_P0_D: "কোডটি আনুষ্ঠানিক প্যারামিটারের নাম উপস্থাপন করতে ব্যবহৃত হয় যা আইকন সত্তা তৈরি করে, এবং এর সংশ্লিষ্ট স্থানীয় পরিবর্তনশীল মানটি আইকন তৈরি করে এমন সত্তা।",
  T_48_META_API_9002_P1_D: "এটি যে প্লেয়ার সত্তার, শুধুমাত্র এই প্লেয়ারের কাছে দৃশ্যমান৷",
  T_48_META_API_9002_P2_D: "রিসোর্স পাথ, প্লেয়ার দ্বারা নির্বাচিত আইকনের সাথে সম্পর্কিত রিসোর্স পাথ৷",
  T_48_META_API_9003_D: "নির্দিষ্ট আইকন সরান (অপ্রচলিত, অনুগ্রহ করে DeleteEntity ব্যবহার করুন)",
  T_48_META_API_9003_P0_D: "আইকন সত্তা সরাতে",
  T_48_META_API_9004_D: "নির্দিষ্ট টেক্সট কন্টেন্ট ব্যবহার করে একটি টেক্সট তৈরি করুন যদি আরও বেশি প্রোপার্টি সেট করতে হয়, তাহলে সত্তার মাধ্যমে এর এন্টিটি প্রোপার্টি সেট করুন (অপ্রচলিত, CreateLevelObject ব্যবহার করুন)",
  T_48_META_API_9004_P0_D: "কোডটি আনুষ্ঠানিক প্যারামিটারের নাম উপস্থাপন করতে ব্যবহৃত হয় যা পাঠ্য সত্তা তৈরি করে, এবং এর সংশ্লিষ্ট স্থানীয় পরিবর্তনশীল মান হল সেই সত্তা যা পাঠ্য তৈরি করে।",
  T_48_META_API_9004_P1_D: "এটি যে প্লেয়ার সত্তার, শুধুমাত্র এই প্লেয়ারের কাছে দৃশ্যমান৷",
  T_48_META_API_9004_P2_D: "পাঠ্য বিষয়বস্তু রেন্ডার করা হবে",
  T_48_META_API_9005_D: "নির্দিষ্ট টেক্সট সরান (অপ্রচলিত, অনুগ্রহ করে DeleteEntity ব্যবহার করুন)",
  T_48_META_API_9005_P0_D: "টেক্সট সত্তা অপসারণ",
  T_48_META_API_9006_D: "নির্দিষ্ট ইফেক্ট টাইপ ব্যবহার করে একটি আইকন তৈরি করুন যদি আরও বেশি প্রপার্টি সেট করতে হয়, তাহলে সত্তার মাধ্যমে এর সত্তা বৈশিষ্ট্য সেট করুন (অপ্রচলিত, ক্রিয়েট ইফেক্ট ব্যবহার করুন)",
  T_48_META_API_9006_P0_D: "কোডটি আনুষ্ঠানিক প্যারামিটারের নাম উপস্থাপন করতে ব্যবহৃত হয় যা বিশেষ প্রভাব সত্তা তৈরি করে, এবং এর সংশ্লিষ্ট স্থানীয় পরিবর্তনশীল মান হল সেই সত্তা যা বিশেষ প্রভাব তৈরি করে।",
  T_48_META_API_9006_P1_D: "এটি যে প্লেয়ার সত্তার, শুধুমাত্র এই প্লেয়ারের কাছে দৃশ্যমান৷",
  T_48_META_API_9006_P2_D: "স্পেশাল ইফেক্ট টাইপ, স্পেশাল ইফেক্টের ধরন যা খেলোয়াড়রা বেছে নিতে পারে",
  T_48_META_API_9007_D: "নির্দিষ্ট প্রভাব সরান (অপ্রচলিত, DeleteEntity ব্যবহার করুন)",
  T_48_META_API_9007_P0_D: "অপসারণ করার জন্য প্রভাব সত্তা",
  T_48_META_API_9008_D: "একটি কাস্টম UI তৈরি করুন যা শুধুমাত্র মনোনীত খেলোয়াড়রা দেখতে পারে",
  T_48_META_API_9008_P0_D: "কাস্টম UI সত্তা তৈরি করা হয়েছে",
  T_48_META_API_9008_P1_D: "UI যে প্লেয়ার সত্তার অন্তর্গত, শুধুমাত্র এই প্লেয়ারের কাছে দৃশ্যমান৷",
  T_48_META_API_9008_P2_D: "কাস্টম UI সূচক",
  T_48_META_API_9009_D: "কাস্টম গেম UI সরান",
  T_48_META_API_9009_P0_D: "সরানোর জন্য কাস্টম UI সত্তা",
  T_48_META_API_9010_D: "কাস্টম UI থেকে UI নিয়ন্ত্রণ পান",
  T_48_META_API_9010_P0_D: "UI যে প্লেয়ার সত্তার অন্তর্গত",
  T_48_META_API_9010_P1_D: "কাস্টম UI সত্তা",
  T_48_META_API_9010_P2_D: "অনন্য সূচক নিয়ন্ত্রণ",
  T_48_META_API_9010_R_D: "UI নিয়ন্ত্রণ সত্তা",
  T_48_META_API_9011_D: "নির্দিষ্ট সাউন্ড ইফেক্ট বাজান যদি আরও বেশি বৈশিষ্ট্য সেট করতে হয়, তাহলে সত্তার মাধ্যমে এর সত্তা বৈশিষ্ট্যগুলি সেট করুন (অপ্রচলিত, ক্রিয়েটসাউন্ড ব্যবহার করুন)",
  T_48_META_API_9011_P0_D: "কোডটি আনুষ্ঠানিক প্যারামিটারের নাম উপস্থাপন করতে ব্যবহৃত হয় যা শব্দ প্রভাব সত্তা তৈরি করে, এবং এর সংশ্লিষ্ট স্থানীয় পরিবর্তনশীল মান হল সেই সত্তা যা শব্দ প্রভাব তৈরি করে।",
  T_48_META_API_9011_P1_D: "এটি যে প্লেয়ার সত্তার, শুধুমাত্র এই প্লেয়ারের কাছে দৃশ্যমান৷",
  T_48_META_API_9011_P2_D: "সাউন্ড ইফেক্ট টাইপ, সাউন্ড ইফেক্টের ধরন যা প্লেয়াররা বেছে নিতে পারে",
  T_48_META_API_9012_D: "নির্দিষ্ট সাউন্ড ইফেক্ট সরান (অপ্রচলিত, অনুগ্রহ করে DeleteEntity ব্যবহার করুন)",
  T_48_META_API_9012_P0_D: "শব্দ সত্তা অপসারণ",
  T_48_META_API_9013_D: "কাস্টম UI থেকে পাথ ব্যবহার করে একটি UI নিয়ন্ত্রণ পান",
  T_48_META_API_9013_P0_D: "UI যে প্লেয়ার সত্তার অন্তর্গত",
  T_48_META_API_9013_P1_D: "কাস্টম UI",
  T_48_META_API_9013_P2_D: "নিয়ন্ত্রণ পথ",
  T_48_META_API_9013_R_D: "UI নিয়ন্ত্রণ সত্তা",
  T_48_META_API_9014_D: "বাজানো সাউন্ড এন্টিটি ব্যাহত করুন (অপ্রচলিত, অনুগ্রহ করে পজসাউন্ড ব্যবহার করুন)",
  T_48_META_API_9014_P0_D: "সাউন্ড ইফেক্ট এন্টিটি যা পজ করা দরকার",
  T_48_META_API_9015_D: "সাউন্ড ইফেক্ট বাজানো চালিয়ে যান, আপনি শুরু থেকে বাজানো শুরু করবেন কিনা তা বেছে নিতে পারেন (অপ্রচলিত, অনুগ্রহ করে ResumeSound ব্যবহার করুন)",
  T_48_META_API_9015_P0_D: "সাউন্ড এফেক্ট এন্টিটি যেগুলি বিরতির পরে বাজানো চালিয়ে যেতে হবে",
  T_48_META_API_9015_P1_D: "গোড়া থেকে শুরু করতে হবে কিনা",
  T_48_META_API_9016_D: "কাস্টম UI নিয়ন্ত্রণ তৈরি করুন",
  T_48_META_API_9016_P0_D: "কাস্টম নিয়ন্ত্রণ সত্তা তৈরি",
  T_48_META_API_9016_P1_D: "নিয়ন্ত্রণের ধরন তৈরি হয়েছে",
  T_48_META_API_9016_P2_D: "UI সত্তার অন্তর্গত",
  T_48_META_API_9016_P3_D: "যে প্যারেন্ট কন্ট্রোলটি এটির সাথে খালি রাখা হয়, UI সত্তা যেটির সাথে এটি প্যারেন্ট নোড হবে৷",
  T_48_META_API_9017_D: "লক্ষ্য ক্যামেরা স্তর মাস্ক সেট করুন",
  T_48_META_API_9017_P0_D: "লক্ষ্য ক্যামেরা সত্তা",
  T_48_META_API_9017_P1_D: "লেয়ার মাস্ক, টার্গেট ক্যামেরায় শুধু ভরা লেয়ারগুলোই প্রদর্শিত হবে, ফাঁকা রাখলে সবগুলো লেয়ার দেখা যাবে।",
  T_48_META_API_9018_D: "লক্ষ্য ক্যামেরা স্তর মাস্ক পান",
  T_48_META_API_9018_P0_D: "লক্ষ্য ক্যামেরা সত্তা",
  T_48_META_API_9018_R_D: "লেয়ার মাস্ক, শুধুমাত্র লেয়ার মাস্কের মধ্যে থাকা লেয়ারগুলো টার্গেট ক্যামেরায় প্রদর্শিত হবে",
  T_48_META_API_9019_D: "নির্দিষ্ট লেভেল টার্গেট ক্যামেরার কাছে দৃশ্যমান কিনা তা সেট করুন",
  T_48_META_API_9019_P0_D: "লক্ষ্য ক্যামেরা সত্তা",
  T_48_META_API_9019_P1_D: "দৃশ্যমানতা স্তর",
  T_48_META_API_9019_P2_D: "দৃশ্যমান বা না",
  T_48_META_API_9020_D: "টার্গেট প্লেয়ারের ডিফল্ট ইন্টারফেস দৃশ্যমান অবস্থা সেট করুন",
  T_48_META_API_9020_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_9020_P1_D: "প্লেয়ার ইন্টারফেস টাইপ প্লেয়ার ইন্টারফেস টাইপ একটি UI উপাদান যা প্লেয়ার এবং প্লেয়ার-সম্পর্কিত বিষয়বস্তু নিয়ন্ত্রণ করতে ব্যবহৃত হয়।",
  T_48_META_API_9020_P2_D: "সুইচের মান প্লেয়ার ইন্টারফেসের দৃশ্যমানতা নির্ধারণ করে।",
  T_48_META_API_9021_D: "একটি টাইমস্ট্যাম্প স্থানীয় স্ট্রিং তৈরি করুন",
  T_48_META_API_9021_P0_D: "টাইমস্ট্যাম্প",
  T_48_META_API_9021_P1_D: "বিন্যাস শৈলী",
  T_48_META_API_9021_R_D: "টাইমস্ট্যাম্প স্থানীয়করণ স্ট্রিং",
  T_48_META_API_9022_D: "মিনিম্যাপ আইকন তৈরি করুন",
  T_48_META_API_9022_P0_D: "মিনিম্যাপ আইকন সত্তা তৈরি করা হয়েছে",
  T_48_META_API_9022_P1_D: "প্লেয়ারের অন্তর্গত মিনিম্যাপ আইকনটি শুধুমাত্র সেই প্লেয়ারের কাছে দৃশ্যমান।",
  T_48_META_API_9022_P2_D: "মিনিম্যাপ আইকন রিসোর্স পাথ",
  T_48_META_API_9023_D: "নির্দিষ্ট স্পেশাল ইফেক্ট টাইপ ব্যবহার করে একটি আইকন তৈরি করুন যদি আরও বেশি প্রোপার্টি সেট করতে হয়, তাহলে সত্তার মাধ্যমে এর সত্তা বৈশিষ্ট্য সেট করুন।",
  T_48_META_API_9023_P0_D: "কোডটি আনুষ্ঠানিক প্যারামিটারের নাম উপস্থাপন করতে ব্যবহৃত হয় যা বিশেষ প্রভাব সত্তা তৈরি করে, এবং এর সংশ্লিষ্ট স্থানীয় পরিবর্তনশীল মান হল সেই সত্তা যা বিশেষ প্রভাব তৈরি করে।",
  T_48_META_API_9023_P1_D: "এটি যে প্লেয়ার সত্তার, শুধুমাত্র এই প্লেয়ারের কাছে দৃশ্যমান৷",
  T_48_META_API_9023_P2_D: "স্পেশাল ইফেক্ট টাইপ, স্পেশাল ইফেক্টের ধরন যা খেলোয়াড়রা বেছে নিতে পারে",
  T_48_META_API_9024_D: "নির্দিষ্ট প্রভাব সরান (অপ্রচলিত, DeleteEntity ব্যবহার করুন)",
  T_48_META_API_9024_P0_D: "অপসারণ করার জন্য প্রভাব সত্তা",
  T_48_META_API_9025_D: "টার্গেট অবজেক্টের জন্য ম্যাপে স্ট্যাটিক পিক্সেল তৈরি করুন স্ট্যাটিক পিক্সেল টার্গেট অবজেক্টের সাথে সরবে না।",
  T_48_META_API_9025_P0_D: "স্ট্যাটিক পিক্সেল সত্তা তৈরি করা হয়েছে",
  T_48_META_API_9025_P1_D: "প্লেয়ারের অন্তর্গত, তৈরি করা স্ট্যাটিক পিক্সেল শুধুমাত্র প্লেয়ারের কাছে দৃশ্যমান",
  T_48_META_API_9025_P2_D: "লক্ষ্য বস্তু সত্তা",
  T_48_META_API_9026_D: "টার্গেট প্লেয়ারের মিনিম্যাপ সত্তা পান",
  T_48_META_API_9026_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_9026_R_D: "বর্তমান প্লেয়ার মিনিম্যাপ",
  T_48_META_API_9027_D: "প্লেয়ার এর পতনের ক্ষতি সেট করুন উচ্চতা অনুযায়ী বিভিন্ন ক্ষতি সেট করা যেতে পারে.",
  T_48_META_API_9027_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_9027_P1_D: "অত্যন্ত খণ্ডিত তালিকা",
  T_48_META_API_9027_P2_D: "ক্ষতি সেগমেন্ট তালিকা",
  T_48_META_API_91_D: "নির্দিষ্ট দলে টার্গেট যোগ করলে টার্গেট মূল দল থেকে চলে যাবে।",
  T_48_META_API_91_P0_D: "যে গোলগুলো দলে যোগ করতে হবে",
  T_48_META_API_91_P1_D: "দলে যোগ দিতে",
  T_48_META_API_91_P2_D: "এটা কি সফল?",
  T_48_META_API_92_D: "নতুন দলে টার্গেট যোগ করলে টার্গেট মূল দল ছেড়ে চলে যাবে।",
  T_48_META_API_92_P0_D: "যে গোলগুলো দলে যোগ করতে হবে",
  T_48_META_API_92_P1_D: "নতুন দলের নাম",
  T_48_META_API_92_P2_D: "এটা কি সফল?",
  T_48_META_API_94_D: "সূচক দ্বারা একটি স্থানীয় চলকের মান সেট করুন; সেট করার আগে, বর্তমান কল প্রক্রিয়ায় ভেরিয়েবলকে অবশ্যই সংজ্ঞায়িত করতে হবে",
  T_48_META_API_94_P0: "সূচক",
  T_48_META_API_94_P0_D: "সূচক দ্বারা একটি পরিবর্তনশীল পান",
  T_48_META_API_94_P1: "পরিবর্তনশীল মান",
  T_48_META_API_94_P1_D: "লক্ষ্য পরিবর্তনশীল মান",
  T_48_META_API_94_P2: "পাটিগণিতের ধরন",
  T_48_META_API_94_P2_D: "অপারেশন পদ্ধতি; সব ধরনের অ্যাসাইনমেন্ট সমর্থন করে, এবং সংখ্যাসূচক প্রকারগুলি বৃদ্ধি, হ্রাস, গুণ, ভাগ এবং মডুলাস ক্রিয়াকলাপকেও সমর্থন করে",
  T_48_META_API_94_P3: "পরিবর্তনশীল নাম",
  T_48_META_API_94_P3_D: "লক্ষ্য পরিবর্তনশীল নাম। শুধুমাত্র ত্রুটি আউটপুট জন্য ব্যবহৃত",
  T_48_META_API_95: "সূচক দ্বারা স্থানীয় পরিবর্তনশীল পান",
  T_48_META_API_95_D: "একটি স্থানীয় ভেরিয়েবলের মান পান; পাওয়ার আগে, বর্তমান কল প্রক্রিয়ায় ভেরিয়েবলকে অবশ্যই সংজ্ঞায়িত করতে হবে",
  T_48_META_API_95_P0: "সূচক",
  T_48_META_API_95_P0_D: "পরিবর্তনশীল সূচক",
  T_48_META_API_95_P1: "পরিবর্তনশীল নাম",
  T_48_META_API_95_P1_D: "লক্ষ্য পরিবর্তনশীল নাম। শুধুমাত্র ত্রুটি আউটপুট জন্য ব্যবহৃত",
  T_48_META_API_9500_D: "টার্গেট প্লেয়ারের ক্লায়েন্টকে স্পেশাল এফেক্ট খেলতে জানান",
  T_48_META_API_9500_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_9500_P1_D: "বিশেষ প্রভাব সম্পদ পথ",
  T_48_META_API_9500_P2_D: "রঙ",
  T_48_META_API_9500_P3_D: "জুম সাইজ, ডিফল্ট হল 1",
  T_48_META_API_9500_P4_D: "বাঁধাই বস্তু, বিশেষ প্রভাব এর চাইল্ড নোড হিসাবে সংযুক্ত করা হবে",
  T_48_META_API_9500_P5_D: "আবদ্ধ বস্তুর সাপেক্ষে বিশ্ব স্থানাঙ্ক অফসেট",
  T_48_META_API_9501_D: "টার্গেট প্লেয়ারের ক্লায়েন্টকে সাউন্ড ইফেক্ট চালানোর জন্য অবহিত করে",
  T_48_META_API_9501_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_9501_P1_D: "সাউন্ড এফেক্ট টাইপ",
  T_48_META_API_9502_D: '"ভাসমান" শব্দটি প্রদর্শন করতে লক্ষ্য প্লেয়ারের ক্লায়েন্টকে অবহিত করুন',
  T_48_META_API_9502_P0_D: "লক্ষ্য খেলোয়াড়দের",
  T_48_META_API_9502_P1_D: "পিয়াওজি বিষয়বস্তু",
  T_48_META_API_9502_P2_D: "ভাসমান শব্দের রঙ, টাইপ হল রঙ",
  T_48_META_API_9502_P3_D: "মিলিসেকেন্ডে ভাসমান অক্ষরের সময়কাল",
  T_48_META_API_9503_D: "টার্গেট ইউনিটকে একবার ইমোট অ্যাকশন এক্সপ্রেশন খেলতে দেয়",
  T_48_META_API_9503_P0_D: "ইমোট খেলার লক্ষ্য",
  T_48_META_API_9503_P1_D: "ইমোট টাইপ",
  T_48_META_API_9504_D: "একটি ইউনিটের ইমোট অ্যাকশন এক্সপ্রেশন বিরতি/পুনরায় শুরু করুন",
  T_48_META_API_9504_P0_D: "ইমোট লক্ষ্যগুলিকে বিরতি/পুনরায় শুরু করুন",
  T_48_META_API_9504_P1_D: "সত্য: প্লেব্যাক বিরতি, মিথ্যা: প্লেব্যাক পুনরায় শুরু করুন",
  T_48_META_EVT_1_D: "গেমটি শুরু হলে ট্রিগার হয়, সার্ভারটি ক্লায়েন্টের চেয়ে কিছু সময় আগে প্রস্তুত হবে",
  T_48_META_EVT_10_D: "বর্তমান সত্তার ক্ষতি হওয়ার আগেই ট্রিগার হয়",
  T_48_META_EVT_10_P0_D: "আক্রমণকারী সত্তা, খালি হতে পারে",
  T_48_META_EVT_10_P1_D: "ক্ষতির ধরন",
  T_48_META_EVT_10_P2_D: "ক্ষয়ক্ষতির পরিমাণ",
  T_48_META_EVT_10_P3_D: "আহত অংশ",
  T_48_META_EVT_1000_D: "প্লেয়ার পয়েন্ট পরিবর্তন হলে ট্রিগার হয়",
  T_48_META_EVT_1000_P0_D: "যে খেলোয়াড়দের পয়েন্ট পরিবর্তন হয়েছে",
  T_48_META_EVT_1000_P1_D: "পরিবর্তন পয়েন্টের ধরন",
  T_48_META_EVT_1000_P2_D: "অবিচ্ছেদ্য পরিবর্তনের পর অবিচ্ছেদ্য মান",
  T_48_META_EVT_1001_D: "দলের পয়েন্ট পরিবর্তন হলে ট্রিগার হয়",
  T_48_META_EVT_1001_P0_D: "পয়েন্ট পরিবর্তন করে দল",
  T_48_META_EVT_1001_P1_D: "পরিবর্তন পয়েন্টের ধরন",
  T_48_META_EVT_1001_P2_D: "অবিচ্ছেদ্য পরিবর্তনের পর অবিচ্ছেদ্য মান",
  T_48_META_EVT_1002_D: "প্লেয়ার র‍্যাঙ্কিং পরিবর্তন হলে ট্রিগার হয়",
  T_48_META_EVT_1002_P0_D: "যে খেলোয়াড়দের র‍্যাঙ্কিং পরিবর্তন হয়",
  T_48_META_EVT_1002_P1_D: "র‌্যাঙ্কিংয়ের পর র‌্যাঙ্কিং পরিবর্তন",
  T_48_META_EVT_1003_D: "অবচয়",
  T_48_META_EVT_1003_P0_D: "অবচয়",
  T_48_META_EVT_1003_P1_D: "র‌্যাঙ্কিংয়ের পর র‌্যাঙ্কিং পরিবর্তন",
  T_48_META_EVT_11_D: "যখন একজন প্লেয়ার মিডওয়ে থেকে প্রস্থান করে তখন ট্রিগার হয়",
  T_48_META_EVT_11_P0_D: "যে প্লেয়ার মিডওয়ে থেকে প্রস্থান করেছে",
  T_48_META_EVT_12_D: "যখন প্লেয়ার কন্ট্রোলার কোনো সত্তাকে স্পর্শ করে তখনই ট্রিগার হয় যখন কন্ট্রোলার সক্রিয়ভাবে চলে।",
  T_48_META_EVT_12_P0_D: "সত্তা সম্মুখীন",
  T_48_META_EVT_13_D: "বর্তমান সত্তা ক্ষতির আগে ট্রিগার করে",
  T_48_META_EVT_13_P0_D: "সত্তা ক্ষতি গ্রহণ",
  T_48_META_EVT_13_P1_D: "ক্ষতির ধরন",
  T_48_META_EVT_13_P2_D: "ক্ষয়ক্ষতির পরিমাণ",
  T_48_META_EVT_13_P3_D: "আহত অংশ",
  T_48_META_EVT_14_D: "প্লে করার যোগ্য সত্তাটি লুপ হওয়ার সময় ট্রিগার করা হয় যখন একটি সাউন্ড ইফেক্ট, স্পেশাল ইফেক্ট ইত্যাদি হয়, এই ইভেন্টটি শুধুমাত্র ক্লায়েন্টের উপর প্রভাব ফেলে।",
  T_48_META_EVT_2_D: "লজিক্যাল ফ্রেম আপডেট করা হলে ট্রিগার করা হয় এই ইভেন্টের ট্রিগারিং ফ্রিকোয়েন্সি প্ল্যাটফর্ম এবং সেটিংসের উপর নির্ভর করে।",
  T_48_META_EVT_2002_D: "প্লেয়ার মারা গেলে ট্রিগার হয়",
  T_48_META_EVT_2002_P0_D: "মৃত খেলোয়াড়",
  T_48_META_EVT_2003_D: "একজন খেলোয়াড় সহায়তা করলে ট্রিগার হয়",
  T_48_META_EVT_2003_P0_D: "যে খেলোয়াড়রা সহায়তা পেয়েছেন",
  T_48_META_EVT_2003_P1_D: "নিহত খেলোয়াড়",
  T_48_META_EVT_2004_D: "ট্রিগার হয় যখন প্লেয়ারের ক্ষতি হয়",
  T_48_META_EVT_2004_P0_D: "যে খেলোয়াড় ক্ষতি করেছে",
  T_48_META_EVT_2004_P1_D: "ক্ষতিগ্রস্থ খেলোয়াড়রা",
  T_48_META_EVT_2004_P2_D: "ক্ষতির ধরন",
  T_48_META_EVT_2004_P3_D: "ক্ষতি",
  T_48_META_EVT_2004_P4_D: "আহত অংশ",
  T_48_META_EVT_2005_D: "ট্রিগার হয় যখন একজন খেলোয়াড় হত্যা করে",
  T_48_META_EVT_2005_P0_D: "যে খেলোয়াড় হত্যার ঘটনা ঘটিয়েছে",
  T_48_META_EVT_2005_P1_D: "নিহত খেলোয়াড়",
  T_48_META_EVT_2005_P2_D: "ক্ষতির ধরন",
  T_48_META_EVT_2006_D: "একজন খেলোয়াড় খেলায় যোগদান করলে ট্রিগার হয়",
  T_48_META_EVT_2006_P0_D: "খেলায় যোগদানকারী খেলোয়াড়রা",
  T_48_META_EVT_2007_D: "খেলোয়াড় পুনরুত্থিত হলে ট্রিগার হয়",
  T_48_META_EVT_2007_P0_D: "পুনরুত্থিত খেলোয়াড়",
  T_48_META_EVT_2007_P1_D: "পুনরুত্থানের উৎস",
  T_48_META_EVT_2008_D: "প্লেয়ার ছিটকে গেলে ট্রিগার হয়",
  T_48_META_EVT_2008_P0_D: "নামানো খেলোয়াড়",
  T_48_META_EVT_2008_P1_D: "আক্রমণকারী খেলোয়াড়",
  T_48_META_EVT_2009_D: "প্লেয়ার সংযোগ বিচ্ছিন্ন হলে আগুন",
  T_48_META_EVT_2009_P0_D: "সংযোগ বিচ্ছিন্ন প্লেয়ার",
  T_48_META_EVT_2010_D: "প্লেয়ার পুনরায় সংযোগ করলে ফায়ার হয়",
  T_48_META_EVT_2010_P0_D: "খেলোয়াড়রা পুনরায় সংযোগ করছে",
  T_48_META_EVT_2100_D: "দলকে সরানো হলে ট্রিগার হয়",
  T_48_META_EVT_2100_P0_D: "সরানো দল",
  T_48_META_EVT_2101_D: "একটি দল যোগ করার সময় ট্রিগার হয়",
  T_48_META_EVT_2101_P0_D: "দল যোগ করা হয়েছে",
  T_48_META_EVT_2102_D: "দলটি ধ্বংস হয়ে গেলে ট্রিগার হয়",
  T_48_META_EVT_2102_P0_D: "যে দল নিশ্চিহ্ন হয়ে গেল",
  T_48_META_EVT_3_D: "খেলা শেষ হলে ফায়ার হয় এই ইভেন্টটি সার্ভারে খেলা শেষ হওয়ার আগে।",
  T_48_META_EVT_30_D: "দৃশ্যটি সফলভাবে লোড হলে ট্রিগার হয়৷",
  T_48_META_EVT_30_P0_D: "দৃশ্যের নাম",
  T_48_META_EVT_3000_D: "বর্তমান সত্তা তৈরি হওয়ার পরে আগুন লাগে",
  T_48_META_EVT_3001_D: "বর্তমান সত্তা ধ্বংস হওয়ার আগে ট্রিগার করা হয়েছে",
  T_48_META_EVT_3002_D: "প্লেয়ার যখন ট্রিগারে প্রবেশ করে তখন ফায়ার করে",
  T_48_META_EVT_3002_P0_D: "প্লেয়ার প্রবেশ ট্রিগার",
  T_48_META_EVT_3003_D: "প্লেয়ার ট্রিগার ছেড়ে দিলে আগুন লাগে",
  T_48_META_EVT_3003_P0_D: "প্লেয়ার ট্রিগার ছেড়ে যাচ্ছে",
  T_48_META_EVT_3004_D: "UI বোতাম নিয়ন্ত্রণে ক্লিক করার পরে বহিস্কার করা হয়েছে",
  T_48_META_EVT_3004_P0_D: "যে প্লেয়ার ক্লিক করেছে",
  T_48_META_EVT_3005_D: "অন্তর্নির্মিত UI-তে একটি বোতাম ক্লিক করা হলে বহিস্কার করা হয়",
  T_48_META_EVT_3005_P0_D: "ক্লিক করা বোতাম নিয়ন্ত্রণের নাম",
  T_48_META_EVT_3006_D: "প্লেয়ার যখন ওয়েকবোর্ড ব্যবহার করে তখন ট্রিগার হয়",
  T_48_META_EVT_3007_D: "বর্তমান সত্তা উপলব্ধ হওয়ার পরে আগুন লাগে",
  T_48_META_EVT_3008_D: "বর্তমান সত্তা অনুপলব্ধ পরে আগুন",
  T_48_META_EVT_3009_D: "যখন কোনও সত্তা ট্রিগারে প্রবেশ করে তখন ট্রিগার হয়। যখন কোনও ট্রিগার ইভেন্ট ট্রিগার করা হয়, তখন উভয় পক্ষই ইভেন্টটি গ্রহণ করে। একটি পক্ষকে অবশ্যই একটি অনমনীয় বডি হতে হবে এবং অন্য পক্ষকে অবশ্যই একটি ট্রিগার হতে হবে। বিশেষ করে, যখন ট্রিগারটি একটি কাস্টম ট্রিগার অবজেক্ট হয়, তখন কেবল ট্রিগারটি ইভেন্টটি গ্রহণ করবে।",
  T_48_META_EVT_3009_P0_D: "ট্রিগার ঘটনা ঘটলে প্রতিপক্ষ সত্তা",
  T_48_META_EVT_3010_D: "যখন সত্তা ট্রিগার ছেড়ে যায় তখন ট্রিগার হয়। যখন ইভেন্টটি ট্রিগার করা হয়, তখন উভয় পক্ষই ইভেন্টটি গ্রহণ করে। একটি পক্ষকে অবশ্যই একটি অনমনীয় বডি হতে হবে এবং অন্য পক্ষকে অবশ্যই একটি ট্রিগার হতে হবে। বিশেষ করে, যখন ট্রিগারটি একটি কাস্টম ট্রিগার অবজেক্ট হয়, তখন শুধুমাত্র ট্রিগারটি ইভেন্টটি গ্রহণ করবে।",
  T_48_META_EVT_3010_P0_D: "ট্রিগার ঘটনা ঘটলে প্রতিপক্ষ সত্তা",
  T_48_META_EVT_3011_D: "বর্তমান সত্তা ধ্বংস হয়ে যাওয়ার পর ট্রিগার করা হয়",
  T_48_META_EVT_3011_P0_D: "আক্রমণকারী সত্তা, খালি হতে পারে",
  T_48_META_EVT_3011_P1_D: "ক্ষতির ধরন",
  T_48_META_EVT_3011_P2_D: "আহত অংশ",
  T_48_META_EVT_3012_D: "বর্তমান সত্তাকে আক্রমণ করার পর ট্রিগার করা হয়েছে",
  T_48_META_EVT_3012_P0_D: "আক্রমণকারী সত্তা, খালি হতে পারে",
  T_48_META_EVT_3012_P1_D: "ক্ষতির ধরন",
  T_48_META_EVT_3012_P2_D: "ক্ষয়ক্ষতির পরিমাণ",
  T_48_META_EVT_3012_P3_D: "আহত অংশ",
  T_48_META_EVT_3013_D: "বর্তমান সত্তার ক্ষতি হওয়ার পরে ট্রিগার হয়",
  T_48_META_EVT_3013_P0_D: "সত্তা ক্ষতি গ্রহণ",
  T_48_META_EVT_3013_P1_D: "ক্ষতির ধরন",
  T_48_META_EVT_3013_P2_D: "ক্ষয়ক্ষতির পরিমাণ",
  T_48_META_EVT_3013_P3_D: "আহত অংশ",
  T_48_META_EVT_3014_D: "বর্তমান সত্তা অন্যান্য সত্তাকে ধ্বংস করার পরে ট্রিগার হয়",
  T_48_META_EVT_3014_P0_D: "ধ্বংস সত্তা",
  T_48_META_EVT_3014_P1_D: "আহত অংশ",
  T_48_META_EVT_3015_D: "প্লেয়ার পুনরুত্থিত হলে ট্রিগার হয়",
  T_48_META_EVT_3015_P0_D: "প্লেয়ার পুনরুত্থান উত্স প্রকার",
  T_48_META_EVT_3016_D: "জেনারেটর একটি সত্তা তৈরি করলে আগুন লাগে",
  T_48_META_EVT_3016_P0_D: "উত্পন্ন সত্তা তালিকা",
  T_48_META_EVT_3016_P1_D: "তরঙ্গ সংখ্যা",
  T_48_META_EVT_3017_D: "যখন প্লেয়ার নকডাউন হাঁটুর অবস্থানে প্রবেশ করে তখন বলা হয়",
  T_48_META_EVT_3018_D: "দলের সকল সদস্য মারা গেলে ট্রিগার হয়",
  T_48_META_EVT_3019_D: "হেলমেট, বডি আর্মার বা ব্যাকপ্যাক দিয়ে সজ্জিত হলে ট্রিগার হয়",
  T_48_META_EVT_3019_P0_D: "সরঞ্জাম আইডি",
  T_48_META_EVT_3020_D: "একটি প্রাথমিক, মাধ্যমিক বা হাতাহাতি অস্ত্র ধরার সময় ট্রিগার হয়, যখন মুষ্টিতে স্যুইচ করা সহ",
  T_48_META_EVT_3020_P0_D: "ট্রিগার করা হলে সজ্জিত অস্ত্র সত্তা",
  T_48_META_EVT_3021_D: "একটি প্রপ ব্যবহার করার পরে ট্রিগার করা হয়েছে যেগুলির জন্য সময় প্রয়োজন তা ব্যবহার শেষ হওয়ার পরে এই ইভেন্টটিকে ট্রিগার করবে৷",
  T_48_META_EVT_3021_P0_D: "প্রপ আইডি",
  T_48_META_EVT_3021_P1_D: "prop সত্তা, খালি হতে পারে",
  T_48_META_EVT_3021_P2_D: "প্রপ ব্যবহার করে তৈরি করা নতুন প্রপ সত্তা, খালি হতে পারে",
  T_48_META_EVT_3022_D: "একটি আইটেম প্রাপ্ত হলে ট্রিগার করা হয়",
  T_48_META_EVT_3022_P0_D: "আইটেম টাইপ",
  T_48_META_EVT_3022_P1_D: "আইটেম সত্তা, খালি হতে পারে",
  T_48_META_EVT_3023_D: "সত্তা স্কোর পরিবর্তন হলে ট্রিগার হয়",
  T_48_META_EVT_3023_P0_D: "পরিবর্তন পয়েন্টের ধরন",
  T_48_META_EVT_3023_P1_D: "অবিচ্ছেদ্য পরিবর্তনের পর অবিচ্ছেদ্য মান",
  T_48_META_EVT_3024_D: "কোনো সত্তার র‍্যাঙ্ক পরিবর্তন হলে ট্রিগার হয়",
  T_48_META_EVT_3024_P0_D: "র‌্যাঙ্কিংয়ের পর র‌্যাঙ্কিং পরিবর্তন",
  T_48_META_EVT_3025_D: "সহায়তায় ট্রিগার করা হয়েছে",
  T_48_META_EVT_3025_P0_D: "যে বস্তুটিকে হত্যা করা হয়েছে",
  T_48_META_EVT_3026_D: "চালক এবং যাত্রী সহ একটি সত্তা একটি যানবাহনে প্রবেশ করলে ট্রিগার হয়",
  T_48_META_EVT_3026_P0_D: "সত্তা গাড়িতে প্রবেশ করছে",
  T_48_META_EVT_3026_P1_D: "যানবাহনে প্রবেশ করছে",
  T_48_META_EVT_3027_D: "সত্তা গাড়ি ছেড়ে দিলে ট্রিগার হয়",
  T_48_META_EVT_3027_P0_D: "সত্তা যানবাহন ছেড়ে যাচ্ছে",
  T_48_META_EVT_3027_P1_D: "প্রস্থানকারী যানবাহন",
  T_48_META_EVT_3028_D: "ট্রিগার হয় যখন সত্তা গাড়ি চালাচ্ছে এবং গাড়ির চালক।",
  T_48_META_EVT_3028_P0_D: "যে সত্তা গাড়ি চালায়",
  T_48_META_EVT_3028_P1_D: "ড্রাইভিং যানবাহন",
  T_48_META_EVT_3029_D: "কোনো সত্তা দ্বারা যানবাহন প্রবেশ করলে ট্রিগার হয়",
  T_48_META_EVT_3029_P0_D: "ট্রিগার সত্তা",
  T_48_META_EVT_3030_D: "গাড়ির সত্তা চলে গেলে ট্রিগার হয়",
  T_48_META_EVT_3030_P0_D: "ট্রিগার সত্তা",
  T_48_META_EVT_3031_D: "গাড়িটি যখন কোনো সত্তা দ্বারা চালিত হয় তখন ট্রিগার হয়",
  T_48_META_EVT_3031_P0_D: "ট্রিগার সত্তা",
  T_48_META_EVT_3032_D: "সত্তা টেলিপোর্ট করার জন্য পোর্টাল ব্যবহার করার পরে ট্রিগার করা হয়েছে (অপ্রচলিত, অনুগ্রহ করে OnBouncesOffTire ব্যবহার করুন)",
  T_48_META_EVT_3032_P0_D: "পোর্টাল ব্যবহার করে সত্তা",
  T_48_META_EVT_3032_P1_D: "পোর্টাল ব্যবহার করা হয়েছে",
  T_48_META_EVT_3033_D: "সত্তা বাউন্স হলে ট্রিগার হয়",
  T_48_META_EVT_3033_P0_D: "ট্রিগার সত্তা",
  T_48_META_EVT_3033_P1_D: "বাউন্সিং অবজেক্ট ব্যবহার করা হয়েছে",
  T_48_META_EVT_3034_D: "পোর্টালটি সত্তাটিকে টেলিপোর্ট করার পরে ট্রিগার হয়েছে৷",
  T_48_META_EVT_3034_P0_D: "প্রেরণকারী সত্তা",
  T_48_META_EVT_3035_D: "টায়ার সত্তা বাউন্স পরে ট্রিগার",
  T_48_META_EVT_3035_P0_D: "বাউন্সড সত্তা",
  T_48_META_EVT_3036_D: "ট্রিগার হয় যখন মেকানিজম সত্তাকে বাতাসে আঘাত করে",
  T_48_META_EVT_3036_P0_D: "দূরে ছিটকে গেছে যে সত্তা",
  T_48_META_EVT_3036_P1_D: "যান্ত্রিক বস্তু",
  T_48_META_EVT_3037_D: "কোনো সত্তা ট্রিগারে প্রবেশ করলে আগুন লাগে",
  T_48_META_EVT_3037_P0_D: "এন্ট্রি ট্রিগার",
  T_48_META_EVT_3038_D: "কোনো সত্তা ট্রিগার ছেড়ে দিলে আগুন লাগে",
  T_48_META_EVT_3038_P0_D: "প্রস্থান ট্রিগার",
  T_48_META_EVT_3039_D: "একটি অস্ত্র সত্তা প্রাপ্ত হলে ট্রিগার হয়",
  T_48_META_EVT_3039_P0_D: "অস্ত্র সত্তা",
  T_48_META_EVT_3040_D: "ট্রিগার হয় যখন সত্তা একটি প্রক্রিয়া দ্বারা ছিটকে যায়",
  T_48_META_EVT_3040_P0_D: "দূরে ছিটকে গেছে যে সত্তা",
  T_48_META_EVT_3040_P1_D: "যান্ত্রিক বস্তু",
  T_48_META_EVT_3041_D: "লক্ষ্যযোগ্য সত্তাকে লক্ষ্য করার সময় ট্রিগার করা হয়",
  T_48_META_EVT_3041_P0_D: "টার্গেটেড সত্তা",
  T_48_META_EVT_3042_D: "একজন খেলোয়াড় লক্ষ্য করলে ট্রিগার হয়",
  T_48_META_EVT_3042_P0_D: "লক্ষ্য নিচ্ছেন খেলোয়াড়",
  T_48_META_EVT_3043_D: "বুলেট লক্ষ্যবস্তুতে আঘাত করলে ট্রিগার হয়",
  T_48_META_EVT_3043_P0_D: "লক্ষ্য আঘাত",
  T_48_META_EVT_3043_P1_D: "বুলেট কোথায় আঘাত করেছে তার বিশ্ব সমন্বয় করে",
  T_48_META_EVT_3044_D: "একটি অস্ত্র দ্বারা আঘাত যখন ট্রিগার",
  T_48_META_EVT_3044_P0_D: "অস্ত্র",
  T_48_META_EVT_3044_P1_D: "হিট এলাকার বিশ্ব স্থানাঙ্ক",
  T_48_META_EVT_3045_D: "প্লেয়ার যখন এই স্তরে একটি বস্তুতে রূপান্তর করতে পছন্দ করে তখন ট্রিগার হয়",
  T_48_META_EVT_3045_P0_D: "প্লেয়ার একটি সত্তায় রূপান্তরিত হয়, দৃশ্য বস্তুতে নয়",
  T_48_META_EVT_3046_D: "প্লেয়ার যখন এই রেসপন পয়েন্টে পুনরুত্থিত হয় তখন ট্রিগার হয়",
  T_48_META_EVT_3046_P0_D: "খেলোয়াড়রা এই রেসপন পয়েন্টে পুনরুত্থিত হয়",
  T_48_META_EVT_3047_D: "প্লেয়ার অস্ত্র ফেলে দিলে ট্রিগার হয়",
  T_48_META_EVT_3047_P0_D: "বাতিল অস্ত্র সত্তা",
  T_48_META_EVT_3048_D: "প্লেয়ার অস্ত্র ছাড়া অন্য কোনো আইটেম ফেলে দিলে ট্রিগার হয়",
  T_48_META_EVT_3048_P0_D: "আইটেম টাইপ",
  T_48_META_EVT_3048_P1_D: "আইটেম সত্তা, খালি হতে পারে",
  T_48_META_EVT_3049_D: "ফুটবল বন্দুক দ্বারা আঘাত যখন ট্রিগার",
  T_48_META_EVT_3049_P0_D: "খেলোয়াড়",
  T_48_META_EVT_3049_P1_D: "আঘাতের পর গতি",
  T_48_META_EVT_3050_D: "ট্রিগার হয় যখন ফুটবল কোন সত্তার সাথে সংঘর্ষ হয়",
  T_48_META_EVT_3050_P0_D: "সংঘর্ষের বস্তু",
  T_48_META_EVT_3050_P1_D: "সংঘর্ষের পর গতি",
  T_48_META_EVT_3051_D: "প্লেয়ার সফলভাবে ভয়েস চ্যানেলে যোগদান করলে ট্রিগার হয়",
  T_48_META_EVT_3051_P0_D: "ভয়েস চ্যানেল সত্তা",
  T_48_META_EVT_3052_D: "একজন খেলোয়াড় ভয়েস চ্যানেলে যোগদান করতে ব্যর্থ হলে ট্রিগার হয়",
  T_48_META_EVT_3052_P0_D: "ভয়েস চ্যানেল সত্তা",
  T_48_META_EVT_3053_D: "প্লেয়ার ভয়েস চ্যানেল থেকে প্রস্থান করলে ট্রিগার হয়",
  T_48_META_EVT_3053_P0_D: "ভয়েস চ্যানেল সত্তা",
  T_48_META_EVT_3054_D: "একটি ফুটবল গোলে প্রবেশ করলে ট্রিগার হয়",
  T_48_META_EVT_3054_P0_D: "লক্ষ্য",
  T_48_META_EVT_3054_P1_D: "স্কোরার, গোল করার আগে বল স্পর্শ করা শেষ খেলোয়াড়",
  T_48_META_EVT_3054_P2_D: "অ্যাসিস্টার, পেনাল্টিমেট প্লেয়ার যে গোলে ঢোকার আগে বল স্পর্শ করে",
  T_48_META_EVT_3055_D: "প্লেয়ার যখন ফায়ার বোতাম টিপে তখন ট্রিগার হয়",
  T_48_META_EVT_3056_D: "প্লেয়ার লাফ দিলে ট্রিগার হয়",
  T_48_META_EVT_3057_D: "প্লেয়ার ক্রুচিং হলে ট্রিগার হয়",
  T_48_META_EVT_3058_D: "প্লেয়ার প্রবণ হলে ট্রিগার হয়",
  T_48_META_EVT_3059_D: "প্লেয়ার স্প্রিন্ট করার সময় ট্রিগার হয়",
  T_48_META_EVT_3060_D: "স্টোরে একটি আইটেম সফলভাবে কেনা হলে ট্রিগার হয়",
  T_48_META_EVT_3060_P0_D: "খেলোয়াড় যারা পণ্য ক্রয়",
  T_48_META_EVT_3060_P1_D: "পণ্য",
  T_48_META_EVT_3061_D: "প্লেয়ার দ্বারা অস্ত্র সজ্জিত হলে ট্রিগার হয়",
  T_48_META_EVT_3061_P0_D: "খেলোয়াড়রা অস্ত্রে সজ্জিত",
  T_48_META_EVT_3062_D: "এই অস্ত্র দিয়ে একটি ইউনিট নিহত হলে ট্রিগার হয়",
  T_48_META_EVT_3062_P0_D: "নিহত সত্তা",
  T_48_META_EVT_3063_D: "ট্রিগার হয় যখন এই অস্ত্রটি একটি ইউনিটের ক্ষতি করতে ব্যবহার করা হয়",
  T_48_META_EVT_3063_P0_D: "ক্ষতিগ্রস্থ সত্তা",
  T_48_META_EVT_3063_P1_D: "ক্ষতি",
  T_48_META_EVT_3064_D: "অস্ত্র গুলি পরিবর্তন হলে ট্রিগার হয়",
  T_48_META_EVT_3065_D: "যখন একটি সত্তা গাড়িতে প্রবেশ করে তখন ট্রিগার হয় এই ইভেন্টটি ড্রাইভার বা যাত্রী হিসাবে ট্রিগার হতে পারে৷",
  T_48_META_EVT_3065_P0_D: "যানবাহনে প্রবেশ করছে",
  T_48_META_EVT_3066_D: "সত্তা গাড়ি ছেড়ে দিলে ট্রিগার হয়",
  T_48_META_EVT_3066_P0_D: "প্রস্থানকারী যানবাহন",
  T_48_META_EVT_3067_D: "কোনো সত্তা যখন গাড়ি চালায় তখন ট্রিগার হয়",
  T_48_META_EVT_3067_P0_D: "ড্রাইভিং যানবাহন",
  T_48_META_EVT_3068_D: "একটি পোর্টাল ব্যবহার করে একটি সত্তা টেলিপোর্ট করার পরে ট্রিগার করা হয়েছে৷",
  T_48_META_EVT_3068_P0_D: "পোর্টাল ব্যবহার করা হয়েছে",
  T_48_META_EVT_3069_D: "সত্তাটি টায়ার দ্বারা বাউন্স হওয়ার পরে ট্রিগার হয়",
  T_48_META_EVT_3069_P0_D: "টায়ার ব্যবহার করা হয়েছে",
  T_48_META_EVT_3070_D: "ট্রিগার হয় যখন সত্তা একটি প্রক্রিয়া দ্বারা ছিটকে যায়",
  T_48_META_EVT_3070_P0_D: "যান্ত্রিক বস্তু",
  T_48_META_EVT_3071_D: "প্লেয়ার দ্বারা UI বোতাম নিয়ন্ত্রণ চাপার পরে ট্রিগার হয়",
  T_48_META_EVT_3071_P0_D: "ট্রিগার প্লেয়ার",
  T_48_META_EVT_3072_D: "UI বোতাম নিয়ন্ত্রণ উত্থাপিত হওয়ার পরে আগুন লাগে",
  T_48_META_EVT_3072_P0_D: "ট্রিগার প্লেয়ার",
  T_48_META_EVT_3073_D: "UI বোতাম নিয়ন্ত্রণ প্লেয়ার দ্বারা ডাবল-ক্লিক করার পরে ট্রিগার হয়",
  T_48_META_EVT_3073_P0_D: "ট্রিগার প্লেয়ার",
  T_48_META_EVT_3074_D: "জেলব্রেক এলাকা শুরু হয়",
  T_48_META_EVT_3075_D: "জেলব্রেক এলাকা শেষ",
  T_48_META_EVT_3076_D: "প্লেয়ার যখন ওয়েকবোর্ড ব্যবহার করা বন্ধ করে তখন ট্রিগার হয়",
  T_48_META_EVT_3077_D: "UI ইনপুট বক্স নিয়ন্ত্রণের পাঠ্য বিষয়বস্তু প্লেয়ার দ্বারা পরিবর্তিত হলে ট্রিগার হয়৷",
  T_48_META_EVT_3077_P0_D: "ট্রিগার প্লেয়ার",
  T_48_META_EVT_3077_P1_D: "পরিবর্তিত পাঠ্য বিষয়বস্তু",
  T_48_META_EVT_3078_D: "কোনো খেলার যোগ্য সত্তা খেলা শুরু করলে আগুন লাগে",
  T_48_META_EVT_3078_P0_D: "খেলার যোগ্য সত্তা",
  T_48_META_EVT_3079_D: "যখন খেলার যোগ্য সত্তাটি বাজানো শেষ হয় তখন ট্রিগার হয় যখন একটি সাউন্ড ইফেক্ট, স্পেশাল ইফেক্ট ইত্যাদি হয়, এই ইভেন্টটি শুধুমাত্র ক্লায়েন্টের উপর প্রভাব ফেলে৷",
  T_48_META_EVT_3079_P0_D: "খেলার যোগ্য সত্তা",
  T_48_META_EVT_3080_D: "যখন খেলার যোগ্য সত্তা বাজতে থাকে তখন আগুন জ্বলে",
  T_48_META_EVT_3080_P0_D: "খেলার যোগ্য সত্তা",
  T_48_META_EVT_3081_D: "যখন প্লেযোগ্য সত্তা প্লেব্যাক পজ করে তখন ট্রিগার হয়",
  T_48_META_EVT_3081_P0_D: "খেলার যোগ্য সত্তা",
  T_48_META_EVT_3082_D: "জেলব্রোকেন খেলোয়াড়রা যোগ দেয়",
  T_48_META_EVT_3082_P0_D: "ট্রিগার প্লেয়ার",
  T_48_META_EVT_3083_D: "জেলব্রোকেন খেলোয়াড়রা প্রস্থান করে",
  T_48_META_EVT_3083_P0_D: "ট্রিগার প্লেয়ার",
  T_48_META_EVT_3084_D: "কাউন্টডাউন শেষে আগুন",
  T_48_META_EVT_3084_P0_D: "মালিকানাধীন সত্তা",
  T_48_META_EVT_3085_D: "কোনো আইটেম তোলা হলে ট্রিগার হয়",
  T_48_META_EVT_3085_P0_D: "যে খেলোয়াড় আইটেমটি তুলেছে",
  T_48_META_EVT_3086_D: "কোনো আইটেম বাদ দিলে ট্রিগার হয়",
  T_48_META_EVT_3086_P0_D: "যে খেলোয়াড় আইটেমটি ফেলে দিয়েছে",
  T_48_META_EVT_3087_D: "এই আইটেমটি সজ্জিত হলে ট্রিগার করে",
  T_48_META_EVT_3088_D: "খনি তৈরি হওয়ার পর বস্তুটি শুরু হলে আগুন লাগে",
  T_48_META_EVT_3089_D: "খনি তৈরি হওয়ার পর বস্তুটি ট্রিগার করলে আগুন লাগে",
  T_48_META_EVT_3089_P0_D: "মাইন তৈরি হওয়ার পর বস্তুর লক্ষ্য ট্রিগার করুন",
  T_48_META_EVT_3090_D: "দোকানে আইটেম কেনার আগে ট্রিগার হয়",
  T_48_META_EVT_3090_P0_D: "খেলোয়াড় যারা পণ্য ক্রয়",
  T_48_META_EVT_3090_P1_D: "পণ্য",
  T_48_META_EVT_3091_D: "এই ডিভাইসটি ব্যবহার করা হলে আগুন লাগে",
  T_48_META_EVT_3092_D: "গ্র্যাপল বন্দুক থেকে গুলি চালানো হলে ট্রিগার হয়",
  T_48_META_EVT_3093_D: "প্রজেক্টাইল নিক্ষেপ করার পরে বিস্ফোরিত হলে ট্রিগার হয়",
  T_48_META_EVT_3093_P0_D: "বিস্ফোরণ পয়েন্ট",
  T_48_META_EVT_3094_D: "একটি স্প্রে বন্দুক দ্বারা আঘাত যখন ট্রিগার",
  T_48_META_EVT_3094_P0_D: "স্প্রে বন্দুক সত্তা",
  T_48_META_EVT_3094_P1_D: "আঘাত বিন্দু",
  T_48_META_EVT_3094_P2_D: "স্বাভাবিক আঘাত",
  T_48_META_EVT_3095_D: "একটি পেইন্ট বন্দুক দিয়ে আঘাত যখন ট্রিগার",
  T_48_META_EVT_3095_P0_D: "আঘাত বস্তু",
  T_48_META_EVT_3095_P1_D: "আঘাত বিন্দু",
  T_48_META_EVT_3095_P2_D: "স্বাভাবিক আঘাত",
  T_48_META_EVT_3096_D: "একটি যানবাহন বা ডাই ব্যারেল বিস্ফোরিত হলে ট্রিগার হয়",
  T_48_META_EVT_3096_P0_D: "যে খেলোয়াড় বিস্ফোরণ ঘটিয়েছে",
  T_48_META_EVT_3096_P1_D: "বিস্ফোরণে ক্ষতিগ্রস্ত খেলোয়াড়দের তালিকা",
  T_48_META_EVT_3097_D: "অস্ত্র গুলি ছুড়তে থামলে গুলি চলে",
  T_48_META_EVT_3097_P0_D: "গুলি চালানো বন্ধ করার সময় বর্তমান পত্রিকায় যে পরিমাণ গোলাবারুদ অবশিষ্ট থাকে",
  T_48_META_EVT_3098_D: "ট্রিগার হয় যখন সাধনা লক্ষ্য সাধনা পরিসরে প্রবেশ করে",
  T_48_META_EVT_3099_D: "ট্রিগার হয় যখন সাধনা লক্ষ্য সাধনা পরিসীমা ছেড়ে যায়",
  T_48_META_EVT_31_D: "দৃশ্য স্যুইচ সফল হলে ট্রিগার হয়",
  T_48_META_EVT_31_P0_D: "দৃশ্যের নাম",
  T_48_META_EVT_3100_D: "আক্রমণের লক্ষ্য আক্রমণের পরিসরে প্রবেশ করলে ট্রিগার হয়",
  T_48_META_EVT_3101_D: "আক্রমণের লক্ষ্যবস্তু আক্রমণ পরিসীমা ছেড়ে গেলে ট্রিগার হয়",
  T_48_META_EVT_3102_D: "ক্লায়েন্ট ক্লিক ইভেন্টের মাধ্যমে ক্যামেরা রশ্মি সনাক্তকরণ ট্রিগার হলে এই ইভেন্টটি ট্রিগার হয়",
  T_48_META_EVT_3102_P0_D: "ট্রিগার প্লেয়ার",
  T_48_META_EVT_3102_P1_D: "ক্যামেরার রশ্মি বস্তুতে আঘাত করে কিনা",
  T_48_META_EVT_3102_P2_D: "ক্যামেরার রশ্মি অবস্থানে আঘাত করে",
  T_48_META_EVT_3102_P3_D: "ক্লায়েন্ট ক্যামেরা অভিযোজন",
  T_48_META_EVT_3102_P4_D: "ক্লায়েন্ট ক্যামেরা অবস্থান",
  T_48_META_EVT_3102_P5_D: "আঘাত সত্তা",
  T_48_META_EVT_3103_D: "স্টোর ইন্টারফেস খোলা হলে ট্রিগার হয়",
  T_48_META_EVT_3103_P0_D: "ট্রিগার প্লেয়ার",
  T_48_META_EVT_3104_D: "স্টোর ইন্টারফেস বন্ধ হলে ট্রিগার হয়",
  T_48_META_EVT_3104_P0_D: "ট্রিগার প্লেয়ার",
  T_48_META_EVT_3105_D: "যখন আচরণ ট্রি লজিক এই নোডে প্রবেশ করে তখন ট্রিগার হয়",
  T_48_META_EVT_3105_P0_D: "নোডের নাম",
  T_48_META_EVT_3105_P1_D: "মালিকানাধীন সত্তা",
  T_48_META_EVT_3106_D: "যখন আচরণ ট্রি লজিক নোড থেকে প্রস্থান করে তখন ট্রিগার হয়",
  T_48_META_EVT_3106_P0_D: "নোডের নাম",
  T_48_META_EVT_3106_P1_D: "মালিকানাধীন সত্তা",
  T_48_META_EVT_3107_D: "অনমনীয় শরীর জাগ্রত হলে ট্রিগার হয়",
  T_48_META_EVT_3108_D: "অনমনীয় শরীর ঘুমাতে গেলে ট্রিগার হয়",
  T_48_META_EVT_3109_D: "প্লেয়ার সরে গেলে ট্রিগার হয়",
  T_48_META_EVT_3109_P0_D: "মনোভাব",
  T_48_META_EVT_3110_D: "যখন প্লেয়ার নিষ্ক্রিয় থাকে তখন ট্রিগার হয়",
  T_48_META_EVT_3110_P0_D: "মনোভাব",
  T_48_META_EVT_3111_D: "প্লেয়ার যখন একটি দক্ষতা ব্যবহার করে তখন ট্রিগার হয়",
  T_48_META_EVT_3111_P0_D: "ব্যবহার করা দক্ষতা",
  T_48_META_EVT_3112_D: "প্লেয়ার যখন স্প্রিন্টিং শেষ করে তখন ট্রিগার হয়",
  T_48_META_EVT_3113_D: "SwitchEquipSlot গণনার অধীনে স্লটের সাথে সম্পর্কিত আইটেমটি পাওয়ার সময় ট্রিগার করা হয়",
  T_48_META_EVT_3113_P0_D: "আইটেম সত্তা প্রাপ্ত",
  T_48_META_EVT_3114_D: "মুষ্টিতে স্যুইচ করার সময় সহ হ্যান্ডহেল্ড আইটেমগুলি স্যুইচ করার সময় ট্রিগার হয়",
  T_48_META_EVT_3114_P0_D: "স্যুইচ করার পরে আইটেমটির সত্তা",
  T_48_META_EVT_3115_D: "দোকানের একজন খেলোয়াড় যখন অন্যদেরকে পণ্য কেনার জন্য অনুরোধ করে তখন ট্রিগার হয়",
  T_48_META_EVT_3115_P0_D: "যে খেলোয়াড় পণ্যটির জন্য অনুরোধ করেছিল",
  T_48_META_EVT_3115_P1_D: "পণ্য",
  T_48_META_EVT_3116_D: "ট্রিগার হয় যখন দোকানের একজন খেলোয়াড় অন্যদেরকে পণ্য কেনার জন্য অনুরোধ করে এবং অনুরোধ গৃহীত হয়।",
  T_48_META_EVT_3116_P0_D: "খেলোয়াড় যারা কিনতে সাহায্য করে",
  T_48_META_EVT_3116_P1_D: "খেলোয়াড়রা ক্রয় করতে সাহায্যের জন্য অনুরোধ করছে",
  T_48_META_EVT_3116_P2_D: "পণ্য",
  T_48_META_EVT_3117_D: "একটি নির্দিষ্ট ফ্রেম আপডেট করা হলে ট্রিগার হয়, ফ্রিকোয়েন্সি প্রতি সেকেন্ডে 30 বার স্থির হয়",
  T_48_META_EVT_3118_D: "বিরতি গেম API কল করার পরে ট্রিগার করা হয়েছে৷",
  T_48_META_EVT_3119_D: "রিজিউম গেম API কল করার পরে ট্রিগার করা হয়েছে",
  T_48_META_EVT_3120_D: "একজন খেলোয়াড় বন্ধুদের যোগ বা মুছে দিলে ট্রিগার হয়",
  T_48_META_EVT_3121_D: "ব্যক্তিত্বের তথ্য পাওয়ার সময় ট্রিগার করা হয়েছে",
  T_48_META_EVT_3121_P0_D: "তথ্য বিষয়বস্তু",
  T_48_META_EVT_3121_P1_D: "প্রেরক ব্যক্তিত্ব",
  T_48_META_EVT_3122_D: "খেলোয়াড়ের লাফের শেষে আগুন",
  T_48_META_EVT_3123_D: "প্লেয়ার পড়ে গেলে ট্রিগার হয়",
  T_48_META_EVT_3124_D: "প্লেয়ার পতন শেষ হলে ট্রিগার হয়",
  T_48_META_EVT_3125_D: "ব্যক্তিত্ব আচরণ গ্রহণ করার সময় ট্রিগার করা হয়েছে৷",
  T_48_META_EVT_3125_P0_D: "আচরণ",
  T_48_META_EVT_3125_P1_D: "প্রেরক ব্যক্তিত্ব",
  T_48_META_EVT_3126_D: "সদস্য তথ্য পরিবর্তন হলে ট্রিগার হয়",
  T_48_META_EVT_3126_P0_D: "পরিবর্তনের পরে সদস্যের অবস্থা",
  T_48_META_EVT_3127_D: "সদস্য কেন্দ্রে প্রবেশ করার সময় ট্রিগার হয়",
  T_48_META_EVT_3128_D: "সদস্য কেন্দ্র ত্যাগ করার সময় ট্রিগার হয়",
  T_48_META_EVT_3129_D: "ট্রিগার হয় যখন প্লেয়ার একটি ডাউন অবস্থায় প্রবেশ করে",
  T_48_META_EVT_3129_P0_D: "আক্রমণকারী সত্তা, খালি হতে পারে",
  T_48_META_EVT_3130_D: "পারসোনা স্ট্যাটাস পাওয়া গেলে ট্রিগার হয়",
  T_48_META_EVT_3130_P0_D: "প্রেরক ব্যক্তিত্ব",
  T_48_META_EVT_3130_P1_D: "ত্রুটি কোড",
  T_48_META_EVT_3131_D: "UI এর মাধ্যমে Persona-এ তথ্য পাঠানোর সময় ট্রিগার হয়",
  T_48_META_EVT_3131_P0_D: "তথ্য বিষয়বস্তু",
  T_48_META_EVT_3131_P1_D: "প্রেরক ব্যক্তিত্ব",
  T_48_META_EVT_3132_D: "পারসোনার শেষ প্রাপ্তির সময় ট্রিগার হয়",
  T_48_META_EVT_3132_P0_D: "প্রেরক ব্যক্তিত্ব",
  T_48_META_EVT_3132_P1_D: "ত্রুটি কোড",
  T_48_META_EVT_32_D: "প্লেয়ার যখন দৃশ্য পরিবর্তন করে তখন ট্রিগার হয়",
  T_48_META_EVT_32_P0_D: "দৃশ্যের নাম",
  T_48_META_EVT_3200_D: "অ্যানিমেশন ক্লিপটি চালানো শেষ হলে আগুন লাগে",
  T_48_META_EVT_3200_P0_D: "অ্যানিমেশন ক্লিপের নাম",
  T_48_META_EVT_3201_D: "অ্যানিমেশন স্টেট প্লেব্যাক সম্পূর্ণ হলে ট্রিগার হয়",
  T_48_META_EVT_3201_P0_D: "অ্যানিমেশন রাজ্যের নাম",
  T_48_META_EVT_3204_D: "টগল কন্ট্রোলের অবস্থা পরিবর্তিত হলে ট্রিগার হয়",
  T_48_META_EVT_3204_P0_D: "ট্রিগার প্লেয়ার",
  T_48_META_EVT_3204_P1_D: "রাষ্ট্র",
  T_48_META_EVT_3260_D: "প্লেয়ার দ্বারা টাচপ্যাড চাপলে আগুন জ্বলে",
  T_48_META_EVT_3260_P0_D: "ট্রিগার প্লেয়ার",
  T_48_META_EVT_3260_P1_D: "প্রেস অবস্থান",
  T_48_META_EVT_3261_D: "টাচপ্যাড উত্থাপিত হলে আগুন লাগে",
  T_48_META_EVT_3261_P0_D: "ট্রিগার প্লেয়ার",
  T_48_META_EVT_3261_P1_D: "উত্থাপিত অবস্থান",
  T_48_META_EVT_3262_D: "টাচপ্যাড স্লাইডিং শুরু করলে আগুন লাগে",
  T_48_META_EVT_3262_P0_D: "ট্রিগার প্লেয়ার",
  T_48_META_EVT_3262_P1_D: "স্লাইডিং অবস্থান শুরু করুন",
  T_48_META_EVT_3263_D: "টাচপ্যাড স্লাইডিংয়ের সময় ট্রিগার হয়, এই ইভেন্টটি প্রতি ফ্রেমে একবার ট্রিগার হবে।",
  T_48_META_EVT_3263_P0_D: "ট্রিগার প্লেয়ার",
  T_48_META_EVT_3263_P1_D: "স্লাইডিং অবস্থান শুরু করুন",
  T_48_META_EVT_3263_P2_D: "স্থানচ্যুতি",
  T_48_META_EVT_3264_D: "একটি টাচপ্যাড স্লাইডের শেষে আগুন",
  T_48_META_EVT_3264_P0_D: "ট্রিগার প্লেয়ার",
  T_48_META_EVT_3264_P1_D: "স্লাইডিং অবস্থান শেষ করুন",
  T_48_META_EVT_3265_D: "জয়স্টিক চাপলে আগুন জ্বলে",
  T_48_META_EVT_3265_P0_D: "ট্রিগার প্লেয়ার",
  T_48_META_EVT_3266_D: "জয়স্টিক তোলা হলে আগুন জ্বলে",
  T_48_META_EVT_3266_P0_D: "ট্রিগার প্লেয়ার",
  T_48_META_EVT_3267_D: "জয়স্টিক ব্যবহার করার সময় ট্রিগার হয়",
  T_48_META_EVT_3267_P0_D: "ট্রিগার প্লেয়ার",
  T_48_META_EVT_3267_P1_D: "আউটপুট স্থানচ্যুতি",
  T_48_META_EVT_3268_D: "খেলোয়াড় যখন অন্য অবস্থান থেকে উঠে দাঁড়ায় তখন ট্রিগার হয়",
  T_48_META_EVT_3268_P0_D: "দাঁড়ানোর আগে খেলোয়াড়ের ভঙ্গি",
  T_48_META_EVT_3269_D: "অস্ত্র থেকে গুলি ছুড়লেই ট্রিগার হয়",
  T_48_META_EVT_4_D: "প্রতিটি রাউন্ডের শুরুতে ট্রিগার করা হয়",
  T_48_META_EVT_4_P0_D: "বৃত্তাকার সূচক, 0 থেকে শুরু",
  T_48_META_EVT_5_D: "প্রতিটি রাউন্ডের শেষে ট্রিগার",
  T_48_META_EVT_5_P0_D: "বৃত্তাকার সূচক, 0 থেকে শুরু",
  T_48_META_EVT_6_D: "ট্রিগার হয় যখন কোনো সত্তার সাথে সংঘর্ষ হয় শুধুমাত্র মাউন্ট করা শক্ত বডির উপাদানগুলি এই ইভেন্টটিকে সমর্থন করে৷",
  T_48_META_EVT_6_P0_D: "সত্তা সম্মুখীন",
  T_48_META_EVT_7_D: "প্রতিটি পর্বের শুরুতে ট্রিগার করা হয়",
  T_48_META_EVT_7_P0_D: "মঞ্চ সত্তা",
  T_48_META_EVT_8_D: "প্রতিটি পর্বের শেষে ট্রিগার করা হয়",
  T_48_META_EVT_8_P0_D: "মঞ্চ সত্তা",
  T_48_META_EVT_9_D: "সত্তা সংঘর্ষের শেষে ট্রিগার করা হয়েছে শুধুমাত্র মাউন্ট করা শক্ত বডি কম্পোনেন্ট সহ এই ইভেন্টকে সমর্থন করে৷",
  T_48_META_EVT_9_P0_D: "সত্তা সম্মুখীন",
  T_49_META_TYP_10_I1_D: "ট্যাগ লিস্ট",
  T_49_META_TYP_10_I2_D: "এটা কি পাওয়া যায়?",
  T_49_META_TYP_10_I3_D: "সব প্যারেন্ট নোড কি পাওয়া যায়?",
  T_49_META_TYP_10_I4_D: "এটা কি দৃশ্যে পাওয়া যাবে?",
  T_49_META_TYP_10_I5_D: "লজিক আপডেট সক্ষম করবেন কিনা। অক্ষম করা হলে, সত্তার স্ক্রিপ্ট প্রতিটি ফ্রেম আপডেট করা বন্ধ করে দেবে।",
  T_49_META_TYP_10_I6_D: "সত্তার নাম",
  T_49_META_TYP_10_I7_D: "এরিয়া ফিল্টার বিকল্প, 0 মানে স্বয়ংক্রিয় গণনা নিয়ন্ত্রিত কিনা, 1 মানে এটি নিয়ন্ত্রিত নয় এবং সর্বদা সিঙ্ক্রোনাইজ করা হয়, 2 মানে এটি নিয়ন্ত্রিত হয়",
  T_49_META_TYP_100_I0_D: "ট্রিগার রেঞ্জ সেট করুন",
  T_49_META_TYP_100_I1_D: "মডেল দৃশ্যমানতা",
  T_49_META_TYP_101_I0_D: "প্লেয়ার",
  T_49_META_TYP_101_I1_D: "লক্ষ্য আইটেম আইডি",
  T_49_META_TYP_101_I2_D: "লক্ষ্য ঘূর্ণন",
  T_49_META_TYP_101_I3_D: "লক্ষ্য স্কেল",
  T_49_META_TYP_1010_I1_D: "সময়ের সময়কাল, সেকেন্ডে",
  T_49_META_TYP_1010_I2_D: "কাউন্টডাউন শুরুর সময়, খেলার সেকেন্ডে",
  T_49_META_TYP_1010_I3_D: "টাইমিংয়ের আপডেটের ধরণ, `EUITimeUpdateType` দেখুন, ঐচ্ছিক: স্ট্যাটিক, টাইমিং, কাউন্টডাউন",
  T_49_META_TYP_1010_I4_D: "যখন কোনও লক্ষ্য অনুসরণ করার থাকে, তখন প্রদর্শনের অবস্থান লক্ষ্য উৎপত্তির সাপেক্ষে অফসেট, যখন কোনও লক্ষ্য অনুসরণ করার থাকে না, তখন এটি স্ক্রিন স্থানাঙ্ক।",
  T_49_META_TYP_1011_I10_D: "অগ্রগতি আইকন নাম",
  T_49_META_TYP_1011_I2_D: "থিম কালার",
  T_49_META_TYP_1011_I3_D: "স্থানীয় প্রদর্শন সক্ষম করবেন কিনা",
  T_49_META_TYP_1011_I4_D: "শিরোনাম",
  T_49_META_TYP_1011_I5_D: "বর্ণনা",
  T_49_META_TYP_1011_I6_D: "আইকন রিসোর্সের নাম",
  T_49_META_TYP_1011_I7_D: "সর্বোচ্চ অগ্রগতি",
  T_49_META_TYP_1011_I8_D: "বর্তমান অগ্রগতি",
  T_49_META_TYP_1011_I9_D: "অগ্রগতি আইকন",
  T_49_META_TYP_1012_I1_D: "স্থানীয়করণ সক্ষম করবেন কিনা",
  T_49_META_TYP_1012_I2_D: "রাউন্ড নম্বর টেক্সট",
  T_49_META_TYP_1012_I3_D: "রাউন্ড নম্বর লোক্যাল কী প্যারামিটার",
  T_49_META_TYP_1012_I5_D: "বামপাশের রঙ",
  T_49_META_TYP_1012_I6_D: "ডানপাশের রঙ",
  T_49_META_TYP_1013_I2_D: "রাউন্ড নম্বর টেক্সট",
  T_49_META_TYP_1013_I3_D: "রাউন্ড নম্বর লোক্যাল কী প্যারামিটার",
  T_49_META_TYP_1014_I2_D: "প্রথম স্কোরের শিরোনামের টেক্সট",
  T_49_META_TYP_1014_I3_D: "প্রথম স্কোরের মান",
  T_49_META_TYP_1014_I4_D: "প্রথম স্কোর প্যারামিটার",
  T_49_META_TYP_1014_I5_D: "দ্বিতীয় স্কোরের শিরোনামের টেক্সট",
  T_49_META_TYP_1014_I6_D: "দ্বিতীয় স্কোরের মান",
  T_49_META_TYP_1014_I7_D: "দ্বিতীয় স্কোর প্যারামিটার",
  T_49_META_TYP_1016_I1_D: "মান অনুসারে সংশ্লিষ্ট অবস্থা প্রদর্শন করুন, জয় (1), পরাজয় (2), ড্র (3), বুয়াহ (4)",
  T_49_META_TYP_1016_I2_D: "২টি দলের স্কোর দেখান। যদি সত্য হয়, তাহলে এটি প্রদর্শিত হবে, অন্যথায় এটি লুকানো থাকবে।",
  T_49_META_TYP_1016_I3_D: "বামপাশের দলের স্কোর",
  T_49_META_TYP_1016_I4_D: "ডানপাশের দলের স্কোর",
  T_49_META_TYP_1016_I5_D: "ফেজ শেষ টাইমস্ট্যাম্প",
  T_49_META_TYP_1017_I1_D: "বামপাশের দলের নাম",
  T_49_META_TYP_1017_I2_D: "বামপাশের বর্ণনা",
  T_49_META_TYP_1017_I3_D: "ডানপাশের দলের নাম",
  T_49_META_TYP_1017_I4_D: "ডানপাশের বর্ণনা",
  T_49_META_TYP_1018_I1_D: "রাউন্ড নম্বর",
  T_49_META_TYP_1018_I4_D: "বাম দলের স্কোর",
  T_49_META_TYP_1018_I6_D: "ডান দলের স্কোর",
  T_49_META_TYP_1019_I1_D: "জয়, পরাজয় এবং ড্র যথাক্রমে ১ ২ ৩ এর সাথে মিলে যায়।",
  T_49_META_TYP_102_I0_D: "পুনরুত্থানের উৎসের ধরণ, মৃত্যু থেকে পুনরুত্থিত খেলোয়াড়",
  T_49_META_TYP_102_I1_D: "পুনরুত্থানের উৎসের ধরণ, খেলোয়াড় ছিটকে পড়া অবস্থা থেকে পুনরুত্থিত হয়",
  T_49_META_TYP_1020_I2_D: "প্রদর্শিত টেক্সট কী",
  T_49_META_TYP_1020_I3_D: "টেক্সট কী-এর সাথে সম্পর্কিত প্যারামিটার অ্যারে",
  T_49_META_TYP_1021_I1_D: "সেকেন্ডে বেস টাইম",
  T_49_META_TYP_1021_I2_D: "সেকেন্ডে সময়কাল",
  T_49_META_TYP_1021_I3_D: "ডিসপ্লে পজিশন। যখন কোন টার্গেট ফলো করার থাকে, তখন এটি টার্গেট অরিজিনের সাপেক্ষে অফসেট। যখন কোন টার্গেট ফলো করার থাকে না, তখন এটি স্ক্রিন কোঅর্ডিনেট। ডিফল্ট মান হল Vector3(0)",
  T_49_META_TYP_1022_I2_D: "প্রদর্শিত টেক্সট কী",
  T_49_META_TYP_1022_I3_D: "টেক্সট কী-এর সাথে সম্পর্কিত প্যারামিটার অ্যারে",
  T_49_META_TYP_1023_I1_D: "টিম স্কোর দেখান সত্য হলে প্রদর্শিত হয়, অন্যথায় বন্ধ হলে",
  T_49_META_TYP_1023_I4_D: "প্লেয়ারের অবস্থা সত্য হলে প্রদর্শন করুন, অন্যথায় বন্ধ করুন",
  T_49_META_TYP_1023_I5_D: "বাম দিকের খেলোয়াড়ের স্ট্যাটাস অ্যারে, ০: জীবিত খেলোয়াড়ের সংখ্যা, ১: মৃত খেলোয়াড়ের সংখ্যা, ২: অবনমিত খেলোয়াড়ের সংখ্যা",
  T_49_META_TYP_1023_I6_D: "সঠিক খেলোয়াড়ের স্ট্যাটাস অ্যারে, ০: জীবিত খেলোয়াড়ের সংখ্যা, ১: মৃত খেলোয়াড়ের সংখ্যা, ২: খেলোয়াড়ের সংখ্যা কমে গেছে",
  T_49_META_TYP_1023_I7_D: "বামপাশের দলের পতাকা সংখ্যা",
  T_49_META_TYP_1023_I8_D: "ডানদিকের সহকর্মীর পতাকা সংখ্যা",
  T_49_META_TYP_1024_I2_D: "অফসেট",
  T_49_META_TYP_1024_I3_D: "র‌্যাংক",
  T_49_META_TYP_1024_I4_D: "দলের রঙ",
  T_49_META_TYP_1024_I5_D: "আইকনের নাম",
  T_49_META_TYP_1024_I6_D: "যদি সীমানা সত্য হয়, তাহলে এটি প্রদর্শিত হবে, অন্যথায় এটি বন্ধ হয়ে যাবে।",
  T_49_META_TYP_1024_I7_D: "স্কোর টেক্সট কী",
  T_49_META_TYP_1024_I8_D: "স্কোর টেক্সট কী প্যারামিটার",
  T_49_META_TYP_1028_I1_D: "বাম দলের বেঁচে থাকা সংখ্যা",
  T_49_META_TYP_1028_I2_D: "ডান দলের বেঁচে থাকা সংখ্যা",
  T_49_META_TYP_1028_I3_D: "বামের পটভূমির রঙ",
  T_49_META_TYP_1028_I4_D: "ডানের পটভূমির রঙ",
  T_49_META_TYP_1028_I5_D: "বামের আইকনের নাম",
  T_49_META_TYP_1028_I6_D: "ডানের আইকনের নাম",
  T_49_META_TYP_1029_I1_D: "আইকনের নাম",
  T_49_META_TYP_1029_I2_D: "পটভূমি আইকনের নাম",
  T_49_META_TYP_103_I0_D: "প্রাথমিক অস্ত্র A",
  T_49_META_TYP_103_I1_D: "প্রাথমিক অস্ত্র B",
  T_49_META_TYP_103_I10_D: "হিমায়িত বোমা",
  T_49_META_TYP_103_I11_D: "বরফ প্রাচীর",
  T_49_META_TYP_103_I12_D: "Landmine",
  T_49_META_TYP_103_I13_D: "স্বয়ংক্রিয় বুরুজ",
  T_49_META_TYP_103_I14_D: "ডামি গ্রেনেড",
  T_49_META_TYP_103_I16_D: "স্কেটবোর্ড, ছদ্মবেশ...",
  T_49_META_TYP_103_I2_D: "গৌণ অস্ত্র",
  T_49_META_TYP_103_I3_D: "বিস্ফোরক অস্ত্র",
  T_49_META_TYP_103_I5_D: "ভারী অস্ত্র",
  T_49_META_TYP_1030_I3_D: "বাম দলের বেঁচে থাকা সংখ্যা",
  T_49_META_TYP_1030_I4_D: "ডান দলের বেঁচে থাকা সংখ্যা",
  T_49_META_TYP_1030_I5_D: "বাম দিকে টিম আইকনের নাম",
  T_49_META_TYP_1030_I6_D: "ডানদিকে টিম আইকনের নাম",
  T_49_META_TYP_1031_I2_D: "তাৎক্ষণিক তথ্যের বিবরণ",
  T_49_META_TYP_1031_I3_D: "সেকেন্ডে কাউন্টডাউন শুরুর টাইমস্ট্যাম্প",
  T_49_META_TYP_1031_I4_D: "টিপস বর্ণনা প্যারামিটার",
  T_49_META_TYP_1032_I1_D: "টিপস প্রকার",
  T_49_META_TYP_1032_I3_D: "প্যারামিটার",
  T_49_META_TYP_1033_I1_D: "স্যুইচিং ফেজ, 0 মানে বর্তমান রাউন্ডটি স্থির হয়েছে, 1 মানে পরবর্তী রাউন্ড শুরু হচ্ছে",
  T_49_META_TYP_1033_I10_D: "প্রম্পট টেক্সট ব্যর্থ হয়েছে, ডিফল্ট হিসেবে এটি ফাঁকা রাখুন",
  T_49_META_TYP_1033_I11_D: "রাউন্ড আয় শিরোনাম",
  T_49_META_TYP_1033_I12_D: "রাউন্ড আয়",
  T_49_META_TYP_1033_I13_D: "রাউন্ড আয়ের বিস্তারিত শিরোনাম",
  T_49_META_TYP_1033_I14_D: "রাউন্ড আয়ের মূল্যের বিস্তারিত তালিকা উপরে বর্ণিত বিস্তারিত শিরোনাম তালিকার সাথে মিলে যায়।",
  T_49_META_TYP_1033_I15_D: "এমভিপি খেলোয়াড়ের ডাকনাম",
  T_49_META_TYP_1033_I16_D: "পরবর্তী রাউন্ড সূচক",
  T_49_META_TYP_1033_I17_D: "ম্যাচ পয়েন্ট কি",
  T_49_META_TYP_1033_I18_D: "শেষ রাউন্ড কি",
  T_49_META_TYP_1033_I6_D: "বাম দিকে টিম আইকনের নাম",
  T_49_META_TYP_1033_I7_D: "ডানদিকে টিম আইকনের নাম",
  T_49_META_TYP_1033_I8_D: "মান, বিজয় (1), ব্যর্থতা (2) অনুসারে সংশ্লিষ্ট অবস্থা প্রদর্শন করুন।",
  T_49_META_TYP_1033_I9_D: "বিজয় প্রম্পট টেক্সট, ডিফল্ট হিসেবে ফাঁকা রাখুন",
  T_49_META_TYP_1036_I1_D: "কতগুলি স্তর আছে তা নির্দেশ করে",
  T_49_META_TYP_1036_I2_D: "বর্তমান জম্বি স্তর নির্দেশ করে",
  T_49_META_TYP_1037_I1_D: "কতগুলি পয়েন্ট প্রদর্শিত হবে তা নির্দেশ করে",
  T_49_META_TYP_1039_I3_D: "সেকেন্ডে কাউন্টডাউন শুরুর টাইমস্ট্যাম্প",
  T_49_META_TYP_104_I0_D: "স্টাইল A",
  T_49_META_TYP_104_I1_D: "স্টাইল B",
  T_49_META_TYP_104_I2_D: "স্টাইল C",
  T_49_META_TYP_1040_I10_D: "আইটেম বর্ণনা",
  T_49_META_TYP_1040_I11_D: "নির্বাচিত আইটেমের সূচী, ০ থেকে শুরু। যদি এটি ০ এর কম হয়, তাহলে এর অর্থ হল নির্বাচন বাতিল করা।",
  T_49_META_TYP_1040_I12_D: "বোতামের নাম",
  T_49_META_TYP_1040_I13_D: "বোতামের রঙ",
  T_49_META_TYP_1040_I2_D: "কাউন্টডাউন কী",
  T_49_META_TYP_1040_I3_D: "কাউন্টডাউন সময়",
  T_49_META_TYP_1040_I4_D: "বর্ণনা কী",
  T_49_META_TYP_1040_I5_D: "বর্ণনা তথ্য প্যারামিটার অ্যারে",
  T_49_META_TYP_1040_I6_D: "আইটেম ব্যাকগ্রাউন্ডস",
  T_49_META_TYP_1040_I7_D: "আইটেম ব্যাকগ্রাউন্ড রঙ",
  T_49_META_TYP_1040_I8_D: "আইটেম আইকনস",
  T_49_META_TYP_1040_I9_D: "আইটেম নাম",
  T_49_META_TYP_1041_I2_D: "পজিশন",
  T_49_META_TYP_1041_I3_D: "আইকনের ছবি",
  T_49_META_TYP_1041_I4_D: "লেবেল",
  T_49_META_TYP_1041_I5_D: "পটভূমির রঙ",
  T_49_META_TYP_1042_I1_D: "স্থানীয় অবস্থান",
  T_49_META_TYP_1043_I4_D: "রঙ",
  T_49_META_TYP_1043_I5_D: "লেবেল কী",
  T_49_META_TYP_1043_I6_D: "লেবেল প্যারামিটার",
  T_49_META_TYP_1045_I2_D: "বোতাম আইকন",
  T_49_META_TYP_1045_I3_D: "আইকনের রঙ",
  T_49_META_TYP_1045_I4_D: "আকার, প্রস্থ এবং উচ্চতা একই",
  T_49_META_TYP_1045_I5_D: "নীচের ডানদিকের অ্যাঙ্কর পয়েন্টের সাপেক্ষে অবস্থান",
  T_49_META_TYP_1045_I6_D: "চার্জের পরিমাণ, ০ এর কম হলে লুকানো",
  T_49_META_TYP_1045_I7_D: "সিডি শুরুর সময়, মিলিসেকেন্ডে",
  T_49_META_TYP_1045_I8_D: "সিডির সময়কাল মিলিসেকেন্ডে",
  T_49_META_TYP_1045_I9_D: "যদি সত্য হয়, তাহলে বোতামটি ধূসর হয়ে যাবে, এবং যদি মিথ্যা হয়, তাহলে এটি পুনরুদ্ধার করা হবে।",
  T_49_META_TYP_106_I1_D: "সক্রিয় করুন",
  T_49_META_TYP_106_I2_D: "নিষ্ক্রিয় করুন",
  T_49_META_TYP_109_I0_D: "চ্যাট চ্যানেল আইডি",
  T_49_META_TYP_109_I1_D: "খেলোয়াড় তালিকা",
  T_49_META_TYP_11_I0_D: "বর্তমান খেলাটি কি অবৈধ অবস্থায় আছে? যদি এটি অবৈধ অবস্থায় থাকে, তাহলে এর অর্থ হল খেলাটি সংঘর্ষের জন্য তার মূল্য হারিয়ে ফেলেছে। খেলাটি সরাসরি শেষ করার পরামর্শ দেওয়া হচ্ছে।",
  T_49_META_TYP_11_I1_D: "বর্তমান খেলার সময়কাল, মিলিসেকেন্ডে",
  T_49_META_TYP_11_I10_D: "প্রতি রাউন্ডে সরঞ্জাম রিসেট করতে হবে কিনা",
  T_49_META_TYP_11_I11_D: "বিষ বৃত্ত প্রক্রিয়া সক্রিয় করা হবে কিনা",
  T_49_META_TYP_11_I12_D: "সেইফ জোন সাইজ",
  T_49_META_TYP_11_I13_D: "সংকোচনের প্রারম্ভ সময়",
  T_49_META_TYP_11_I14_D: "সংকোচনের স্থায়ীত্ব",
  T_49_META_TYP_11_I15_D: "আউট-অফ-জোন ড্যামেজ",
  T_49_META_TYP_11_I18_D: "রিভাইভাল টাইপ",
  T_49_META_TYP_11_I2_D: "বর্তমান রাউন্ড সূচক, যার মাধ্যমে বর্তমান রাউন্ড সত্তা পাওয়া যেতে পারে",
  T_49_META_TYP_11_I27_D: "সর্বমোট রাউন্ড কাউন্ট",
  T_49_META_TYP_11_I3_D: "বর্তমান পর্যায় সূচক, যার মাধ্যমে বর্তমান পর্যায় সত্তা পাওয়া যেতে পারে",
  T_49_META_TYP_11_I32_D: "রাউন্ডের শুরুতে প্রাপ্ত সোনার মুদ্রার পরিমাণ",
  T_49_META_TYP_11_I33_D: "হত্যা করার সময় অর্জিত স্বর্ণমুদ্রার পরিমাণ",
  T_49_META_TYP_11_I34_D: "জেতার সময় অর্জিত সোনার কয়েনের পরিমাণ",
  T_49_META_TYP_11_I35_D: "ওয়ালেট UI প্রদর্শন করা হবে কিনা",
  T_49_META_TYP_11_I36_D: "স্কাইবক্স সত্তা",
  T_49_META_TYP_11_I37_D: "খেলা শুরু হওয়ার পর থেকে চলমান ফ্রেমের ক্রমবর্ধমান সংখ্যা",
  T_49_META_TYP_11_I38_D: "চলতে পারে",
  T_49_META_TYP_11_I39_D: "নিষ্পত্তি কাস্টমাইজ করা হবে কিনা",
  T_49_META_TYP_11_I4_D: "প্রিসেট UGC মোডের টেমপ্লেট আইডি",
  T_49_META_TYP_11_I40_D: "মাঝপথে যোগদান করা কি জায়গা?",
  T_49_META_TYP_11_I41_D: "কম ফ্রেম রেট মোড চালু করুন, গেমটি ১৫FPS এ চলবে, অন্যথায় ৩০FPS",
  T_49_META_TYP_11_I42_D: "গেম সার্ভারের দুটি লজিক্যাল ফ্রেম আপডেটের মধ্যে ব্যবধান",
  T_49_META_TYP_11_I43_D: "মিলিসেকেন্ডে স্থির ফ্রেম আপডেট ব্যবধান",
  T_49_META_TYP_11_I5_D: "যদি বন্ধ থাকে, তাহলে খেলোয়াড়দের পুনরুত্থান অক্ষম করা হবে।",
  T_49_META_TYP_11_I6_D: "বন্ধ থাকলে, বট পুনরুত্থান অক্ষম করা হয়",
  T_49_META_TYP_11_I7_D: "পুনরুত্থানের সময়, সেকেন্ডে",
  T_49_META_TYP_11_I8_D: "খেলায় মোট দলের সংখ্যা",
  T_49_META_TYP_11_I9_D: "প্রতি দলে সদস্য সংখ্যা",
  T_49_META_TYP_110_I0_D: "চ্যানেল A",
  T_49_META_TYP_110_I1_D: "চ্যানেল B",
  T_49_META_TYP_110_I2_D: "চ্যানেল C",
  T_49_META_TYP_110_I3_D: "চ্যানেল D",
  T_49_META_TYP_110_I4_D: "চ্যানেল E",
  T_49_META_TYP_110_I5_D: "চ্যানেল F",
  T_49_META_TYP_111_I1_D: "স্প্রিন্ট",
  T_49_META_TYP_111_I2_D: "আক্রমণ",
  T_49_META_TYP_111_I3_D: "লাফ",
  T_49_META_TYP_111_I4_D: "টপকে যাওয়া",
  T_49_META_TYP_111_I5_D: "ড্রাইভ",
  T_49_META_TYP_111_I6_D: "যানবাহনে প্রবেশ করুন",
  T_49_META_TYP_111_I7_D: "যানবাহন থেকে বেরিয়ে আসুন",
  T_49_META_TYP_111_I8_D: "যানবাহন চালান",
  T_49_META_TYP_112_I0_D: "সক্রিয় করুন",
  T_49_META_TYP_112_I1_D: "নিষ্ক্রিয় করুন",
  T_49_META_TYP_112_I2_D: "অদৃশ্য",
  T_49_META_TYP_117_I0_D: "হাততালি",
  T_49_META_TYP_117_I1_D: "হাইহ্যাট",
  T_49_META_TYP_117_I2_D: "বেস ড্রাম",
  T_49_META_TYP_117_I3_D: "ওপেন হাইহ্যাট",
  T_49_META_TYP_117_I4_D: "রাইড",
  T_49_META_TYP_117_I5_D: "স্নেয়ার ড্রাম",
  T_49_META_TYP_118_I0_D: "শিবিরের সকল সদস্য মারা গেছে কিনা",
  T_49_META_TYP_118_I1_D: "সকল খেলোয়াড়ের তালিকা",
  T_49_META_TYP_118_I2_D: "মিত্র গোষ্ঠী",
  T_49_META_TYP_118_I3_D: "আক্রমণযোগ্য গোষ্ঠী",
  T_49_META_TYP_118_I4_D: "UI নামটি প্রদর্শন করা হবে কিনা",
  T_49_META_TYP_118_I5_D: "মানচিত্রের তথ্য প্রদর্শন করা হবে কিনা",
  T_49_META_TYP_118_I6_D: "প্রদর্শন করা হবে কিনা",
  T_49_META_TYP_118_I7_D: "প্রদর্শন করা হবে কিনা",
  T_49_META_TYP_118_I8_D: "সকল সদস্য",
  T_49_META_TYP_118_I9_D: "দ্রুত বার্তা দেখান",
  T_49_META_TYP_119_I0_D: "হ্যাঁ",
  T_49_META_TYP_119_I1_D: "না",
  T_49_META_TYP_120_I1_D: "অনুসরণ করার জন্য লক্ষ্য সত্তা, ডিফল্ট খালি",
  T_49_META_TYP_120_I2_D: "UI রঙ",
  T_49_META_TYP_120_I3_D: "UI দৈর্ঘ্য",
  T_49_META_TYP_120_I4_D: "বর্তমান অগ্রগতির মান, ০ থেকে ১.০",
  T_49_META_TYP_120_I5_D: "ডিসপ্লে পজিশন। যখন কোন টার্গেট ফলো করার থাকে, তখন এটি টার্গেট অরিজিনের সাপেক্ষে অফসেট। যখন কোন টার্গেট ফলো করার থাকে না, তখন এটি স্ক্রিন কোঅর্ডিনেট। ডিফল্ট মান হল Vector3(0)",
  T_49_META_TYP_121_I0_D: "3 সেকেন্ড",
  T_49_META_TYP_121_I1_D: "5 সেকেন্ড",
  T_49_META_TYP_121_I2_D: "10 সেকেন্ড",
  T_49_META_TYP_121_I3_D: "15 সেকেন্ড",
  T_49_META_TYP_121_I4_D: "30 সেকেন্ড",
  T_49_META_TYP_121_I5_D: "9999 সেকেন্ড",
  T_49_META_TYP_122_I0_D: "Skybox সম্পদ",
  T_49_META_TYP_122_I1_D: "হাল্কা কালার",
  T_49_META_TYP_122_I10_D: "উপ-দৃশ্য GUID",
  T_49_META_TYP_122_I11_D: "মিস্ট ইফেক্ট সুইচ",
  T_49_META_TYP_122_I12_D: "কুয়াশা প্রভাব মোড",
  T_49_META_TYP_122_I13_D: "সূচকীয় কুয়াশার ঘনত্ব",
  T_49_META_TYP_122_I14_D: "রৈখিক কুয়াশার শুরুর দূরত্ব",
  T_49_META_TYP_122_I15_D: "রৈখিক কুয়াশার শেষ দূরত্ব",
  T_49_META_TYP_122_I16_D: "কুয়াশা প্রভাব বৈশিষ্ট্যটি সক্ষম করুন",
  T_49_META_TYP_122_I17_D: "প্রধান আলোক উৎসের ঘূর্ণন কোণ",
  T_49_META_TYP_122_I18_D: "প্রধান আলোর উৎসের ঘূর্ণন কোণ বৈশিষ্ট্যটি সক্ষম করুন",
  T_49_META_TYP_122_I2_D: "আলোর তীব্রতা",
  T_49_META_TYP_122_I3_D: "অন্ধকার",
  T_49_META_TYP_122_I4_D: "ছায়া শক্তি",
  T_49_META_TYP_122_I5_D: "ভূখণ্ডের আর্দ্রতা",
  T_49_META_TYP_122_I6_D: "লেন্স ফ্লেয়ার",
  T_49_META_TYP_122_I7_D: "ফগ কালার",
  T_49_META_TYP_122_I8_D: "অ্যাম্বিয়েন্ট কালার",
  T_49_META_TYP_123_I0_D: "দিন",
  T_49_META_TYP_123_I1_D: "রাত",
  T_49_META_TYP_123_I2_D: "ডাস্ক",
  T_49_META_TYP_123_I3_D: "সিটি ভিউ",
  T_49_META_TYP_123_I4_D: "বর্ণিল আকাশ",
  T_49_META_TYP_123_I5_D: "ফ্রস্ট মুন",
  T_49_META_TYP_124_I0_D: "বন্ধ পরিসর",
  T_49_META_TYP_124_I1_D: "মধ্যম দূরত্ব",
  T_49_META_TYP_124_I2_D: "দীর্ঘ দূরত্ব",
  T_49_META_TYP_125_I0_D: "কালার ডিফিউজ করুন",
  T_49_META_TYP_125_I2_D: "ডিফিউজ টেক্সচার",
  T_49_META_TYP_125_I4_D: "ডিফিউজ আলফা",
  T_49_META_TYP_126_I1_D: "নাম",
  T_49_META_TYP_126_I2_D: "বর্তমান অগ্রগতির মান",
  T_49_META_TYP_126_I3_D: "সর্বোচ্চ অগ্রগতির মান",
  T_49_META_TYP_126_I4_D: "স্ক্রিন স্থানাঙ্ক, ডিফল্ট হল Vector3(0)",
  T_49_META_TYP_126_I5_D: "প্রগতি বারের দৈর্ঘ্য। বর্তমান ডিফল্ট মান হল প্রিফ্যাবের UI এর দৈর্ঘ্য।",
  T_49_META_TYP_127_I0_D: "একটি নির্দিষ্ট অক্ষ বরাবর অনুবাদ, তিনটি অক্ষ একত্রিত করা যেতে পারে",
  T_49_META_TYP_127_I1_D: "একটি নির্দিষ্ট অক্ষ বরাবর ঘোরান, তিনটি অক্ষ একত্রিত করা যেতে পারে",
  T_49_META_TYP_127_I2_D: "একটি নির্দিষ্ট অক্ষ বরাবর জুম করুন, আপনি তিনটি অক্ষ একত্রিত করতে পারেন",
  T_49_META_TYP_128_I0_D: "গুল্ম",
  T_49_META_TYP_128_I1_D: "কুমড়া",
  T_49_META_TYP_128_I2_D: "পুতুল",
  T_49_META_TYP_128_I3_D: "ক্যাবিনেট",
  T_49_META_TYP_129_I0_D: "এলোমেলো লুট",
  T_49_META_TYP_129_I1_D: "AR গুলি",
  T_49_META_TYP_129_I2_D: "SMG গুলি",
  T_49_META_TYP_129_I3_D: "SN গুলি",
  T_49_META_TYP_129_I4_D: "HG গুলি",
  T_49_META_TYP_129_I5_D: "এসজি বুলেট",
  T_49_META_TYP_129_I6_D: "ধনুকের গুলি",
  T_49_META_TYP_13_I1_D: "প্যারেন্ট নোডের সাপেক্ষে অ্যাঙ্কর স্থানাঙ্ক",
  T_49_META_TYP_13_I10_D: "উইজেট এবং অ্যাঙ্কর বক্সের আকারের পার্থক্য",
  T_49_META_TYP_13_I11_D: "পিভট",
  T_49_META_TYP_13_I12_D: "গভীরতা",
  T_49_META_TYP_13_I14_D: "একই প্যারেন্ট নোডের অধীনে সকল চাইল্ড নোডের ক্রম",
  T_49_META_TYP_13_I15_D: "পিতামাতা আইডি",
  T_49_META_TYP_13_I16_D: "ইউনিক আইডি",
  T_49_META_TYP_13_I17_D: "অগ্রাধিকার",
  T_49_META_TYP_13_I18_D: "আসল অবস্থান",
  T_49_META_TYP_13_I2_D: "প্রস্থ",
  T_49_META_TYP_13_I4_D: "Z-অক্ষের ঘূর্ণন কোণ",
  T_49_META_TYP_13_I6_D: "প্রিফ্যাবের নিয়ন্ত্রণের অভ্যন্তরীণ আইডি",
  T_49_META_TYP_13_I7_D: "UI সত্তা",
  T_49_META_TYP_13_I8_D: "অ্যাঙ্কর মিন",
  T_49_META_TYP_13_I9_D: "অ্যাঙ্কর ম্যাক্স",
  T_49_META_TYP_130_I0_D: "এলোমেলো ভোগ্যপণ্য লুট",
  T_49_META_TYP_130_I1_D: "মেড কিট",
  T_49_META_TYP_130_I2_D: "মেরামতের কিট",
  T_49_META_TYP_130_I3_D: "হরিজেন্টাল",
  T_49_META_TYP_130_I4_D: "ইনহেলার",
  T_49_META_TYP_131_I0_D: "র‍্যান্ডম আর্মার লুট",
  T_49_META_TYP_131_I1_D: "লেভেল ১ আর্মার",
  T_49_META_TYP_131_I2_D: "দ্বিতীয় স্তরের বর্ম",
  T_49_META_TYP_131_I3_D: "লেভেল ৩ আর্মার",
  T_49_META_TYP_132_I0_D: "এলোমেলোভাবে লুটপাট",
  T_49_META_TYP_132_I1_D: "গ্রেনেড",
  T_49_META_TYP_132_I4_D: "ফ্ল্যাশ ফ্রিজ",
  T_49_META_TYP_133_I0_D: "র‍্যান্ডম স্কোপ লুট",
  T_49_META_TYP_133_I1_D: "2x স্কোপ",
  T_49_META_TYP_133_I2_D: "4x স্কোপ",
  T_49_META_TYP_133_I3_D: "থার্মাল স্কোপ",
  T_49_META_TYP_134_I0_D: "র্যান্ডম অস্ত্র লুট",
  T_49_META_TYP_134_I5_D: "শটগান",
  T_49_META_TYP_134_I8_D: "ফুটবল গান",
  T_49_META_TYP_135_I0_D: "লুট বুলেট পয়েন্ট",
  T_49_META_TYP_136_I0_D: "লুট ভোগ্যপণ্যের পয়েন্ট",
  T_49_META_TYP_137_I0_D: "লুট ভোগ্যপণ্যের পয়েন্ট",
  T_49_META_TYP_138_I0_D: "লুট জুম পয়েন্ট",
  T_49_META_TYP_139_I0_D: "লুট আর্মার পয়েন্ট",
  T_49_META_TYP_14_I0_D: "খেলোয়াড়ের বর্তমান স্বাস্থ্য",
  T_49_META_TYP_14_I1_D: "খেলোয়াড়ের বর্তমান সর্বোচ্চ স্বাস্থ্য",
  T_49_META_TYP_14_I11_D: "খেলোয়াড়ের দল",
  T_49_META_TYP_14_I12_D: "খেলোয়াড়ের ক্ষতির গুণক, যেমন 2x হল 2.0",
  T_49_META_TYP_14_I13_D: "পুরুষ বা মহিলা চরিত্রের মতো একই কঙ্কাল ব্যবহার করুন। 0 মানে মডেলটি প্রতিস্থাপন করবেন না।",
  T_49_META_TYP_14_I14_D: "বিদ্যমান গতি স্কেলিংয়ের সাথে বিরোধ করবে না",
  T_49_META_TYP_14_I15_D: "বিদ্যমান জাম্প উচ্চতা স্কেলিংয়ের সাথে বিরোধ করবে না",
  T_49_META_TYP_14_I16_D: "পরিচয়, ০ জন সাধারণ খেলোয়াড়, ১ জন শিকারী, ২ জন মাদার জম্বি, ৩ জন সাধারণ জম্বি, ৪ জন বিবর্তিত জম্বি টাইপ ১, ৫ জন বিবর্তিত জম্বি টাইপ ২, ৬ জন বিবর্তিত জম্বি টাইপ ৩",
  T_49_META_TYP_14_I17_D: "জম্বি লেভেল, ১~৩",
  T_49_META_TYP_14_I19_D: "খেলোয়াড়ের ডাকনাম",
  T_49_META_TYP_14_I2_D: "বর্তমান খেলোয়াড়টি একজন AI খেলোয়াড় কিনা তা নির্ধারণ করুন। AI সাধারণত একটি NPC নাকি একটি PVE দানব।",
  T_49_META_TYP_14_I20_D: "ক্ষতি গ্রহণের সময়, ক্ষতির শতাংশ হ্রাস বা বৃদ্ধি করা যেতে পারে।",
  T_49_META_TYP_14_I21_D: "খেলোয়াড়ের বর্তমান EP",
  T_49_META_TYP_14_I22_D: "সর্বোচ্চ প্লেয়ার EP",
  T_49_META_TYP_14_I23_D: "বর্তমানে হাতে থাকা প্রধান অস্ত্র",
  T_49_META_TYP_14_I24_D: "মৃত্যুর সময় হারিয়ে যাওয়া সামগ্রী",
  T_49_META_TYP_14_I26_D: "লক্ষ্য সহায়তা প্রকার",
  T_49_META_TYP_14_I27_D: "লক্ষ্য সহায়তা দ্বারা লক করা",
  T_49_META_TYP_14_I28_D: "ভয়েস চ্যাট টগল করুন: সত্য ভয়েস বন্ধ করে, মিথ্যা ভয়েস চালু করে",
  T_49_META_TYP_14_I29_D: "দ্রুত চ্যাট টগল করুন: সত্য ভয়েস বন্ধ করে, মিথ্যা ভয়েস চালু করে",
  T_49_META_TYP_14_I3_D: "খেলোয়াড়ের অবস্থা",
  T_49_META_TYP_14_I30_D: "চ্যানেল",
  T_49_META_TYP_14_I35_D: "আইটেম পিকআপ টগল করুন: পিকআপ বন্ধ করতে true, পিকআপ চালু করতে false",
  T_49_META_TYP_14_I36_D: "আইটেম বাতিলকরণ টগল করুন: আইটেম বাতিল করা থেকে বিরত রাখতে সত্য, আইটেম বাতিল করার অনুমতি দিতে মিথ্যা",
  T_49_META_TYP_14_I37_D: "আক্রমণযোগ্য লক্ষ্য",
  T_49_META_TYP_14_I38_D: "বন্ধুদের খেলোয়াড়",
  T_49_META_TYP_14_I39_D: "গোষ্ঠী",
  T_49_META_TYP_14_I4_D: "খেলোয়াড়ের বেঁচে থাকার সময়। যদি খেলোয়াড় মারা যায়, তাহলে সময়টি পুনরায় গণনা করা হয়।",
  T_49_META_TYP_14_I40_D: "ফ্র্যাকশনে নম্বর",
  T_49_META_TYP_14_I41_D: "প্লেয়ারটি যে ক্যামেরাটি ব্যবহার করছে",
  T_49_META_TYP_14_I42_D: "কাস্টম গ্র্যাভিটি",
  T_49_META_TYP_14_I43_D: "মাথাপত্র",
  T_49_META_TYP_14_I44_D: "বুলেটপ্রুফ ভেস্ট",
  T_49_META_TYP_14_I5_D: "খেলোয়াড়ের অজেয়তা",
  T_49_META_TYP_14_I52_D: "ব্যবহারকারীর ইউআইডি",
  T_49_META_TYP_14_I53_D: "মাথায় আঘাতের ক্ষতি হ্রাস",
  T_49_META_TYP_14_I54_D: "প্লেয়ার-বাউন্ড AVATAR",
  T_49_META_TYP_14_I55_D: "লিঙ্গ",
  T_49_META_TYP_14_I56_D: "অস্ত্রের স্কিন আইডি",
  T_49_META_TYP_14_I57_D: "খেলোয়াড়ের স্পন পয়েন্ট",
  T_49_META_TYP_14_I58_D: "খেলোয়াড়ের পুনরুত্থান বিন্দু। যদি কোন চেকপয়েন্ট রেকর্ড না থাকে, তাহলে জন্ম বিন্দু ব্যবহার করা হয়, অন্যথায় চেকপয়েন্ট ব্যবহার করা হয়।",
  T_49_META_TYP_14_I59_D: "খেলোয়াড়ের বর্তমান অবস্থান",
  T_49_META_TYP_14_I6_D: "খেলোয়াড়টি যে সত্তার অন্তর্ভুক্ত",
  T_49_META_TYP_14_I60_D: "খেলোয়াড়ের বর্তমান দিকনির্দেশনা",
  T_49_META_TYP_14_I61_D: "ত্বকের হাড় অ্যাক্সেস করতে ব্যবহৃত নোড",
  T_49_META_TYP_14_I62_D: "খেলোয়াড়ের রুকসাক",
  T_49_META_TYP_14_I63_D: "অস্থায়ী শিল্ড পয়েন্ট",
  T_49_META_TYP_14_I64_D: "গাড়ির স্কিন আইডি",
  T_49_META_TYP_14_I65_D: "পতনের অ্যানিমেশন বাইপাস করুন",
  T_49_META_TYP_14_I66_D: "গরাণের ক্ষতি নিষ্ক্রিয় করুন",
  T_49_META_TYP_14_I67_D: "বর্তমান হাতে থাকা আইটেম",
  T_49_META_TYP_14_I68_D: "নিষিদ্ধ আইটেম তালিকা",
  T_49_META_TYP_14_I69_D: "প্লেয়ার রিসোর্স আইডি",
  T_49_META_TYP_14_I7_D: "বর্তমান চেকপয়েন্ট আইডি",
  T_49_META_TYP_14_I70_D: "কেনার জন্য অনুরোধ বার্তা পাঠানোর লক্ষ্য",
  T_49_META_TYP_14_I71_D: "বর্তমানে যে ইমোট রিসোর্সটি চালানো হচ্ছে তার আইডি",
  T_49_META_TYP_14_I72_D: "বর্তমানে চলমান ইমোটটি লুপিং করছে কিনা",
  T_49_META_TYP_14_I73_D: "নকডাউন অবস্থা মোকাবেলা করা",
  T_49_META_TYP_14_I74_D: "ড্যামেজ জাম্প সক্ষম করবেন কিনা, ডিফল্ট হল True, যার অর্থ এটি সক্ষম",
  T_49_META_TYP_14_I76_D: "আমি কি মাঝপথে ছেড়ে দিতে পারি?",
  T_49_META_TYP_14_I77_D: "অন্য চরিত্রে রূপান্তরিত হওয়ার সময় খেলোয়াড়কে যে পোশাকের তথ্য রাখতে হবে",
  T_49_META_TYP_14_I8_D: "লক্ষ্যবস্তু যে চেকপয়েন্টে যাচ্ছে সেই চেকপয়েন্ট আইডি",
  T_49_META_TYP_140_I0_D: "তরঙ্গ ১",
  T_49_META_TYP_140_I1_D: "তরঙ্গ ২",
  T_49_META_TYP_140_I2_D: "তরঙ্গ ৩",
  T_49_META_TYP_140_I3_D: "ধারাবাহিক",
  T_49_META_TYP_141_I0_D: "এলোমেলো ফুটবল লুট",
  T_49_META_TYP_141_I1_D: "ফুটবল শিল্ড লুট",
  T_49_META_TYP_141_I2_D: "জমে যাওয়া গ্রেনেড",
  T_49_META_TYP_142_I0_D: "লুট ফুটবল",
  T_49_META_TYP_143_I0_D: "Lead1C2",
  T_49_META_TYP_143_I1_D: "Lead1C2#",
  T_49_META_TYP_143_I10_D: "Lead1A2#",
  T_49_META_TYP_143_I11_D: "Lead1B2",
  T_49_META_TYP_143_I2_D: "Lead1D2",
  T_49_META_TYP_143_I3_D: "Lead1D2#",
  T_49_META_TYP_143_I4_D: "Lead1E2",
  T_49_META_TYP_143_I5_D: "Lead1F2",
  T_49_META_TYP_143_I6_D: "Lead1F2#",
  T_49_META_TYP_143_I7_D: "Lead1G2",
  T_49_META_TYP_143_I8_D: "Lead1G2#",
  T_49_META_TYP_143_I9_D: "Lead1A2",
  T_49_META_TYP_144_I0_D: "Lead2C2",
  T_49_META_TYP_144_I1_D: "Lead2C2#",
  T_49_META_TYP_144_I10_D: "Lead2A2#",
  T_49_META_TYP_144_I11_D: "Lead2B2",
  T_49_META_TYP_144_I2_D: "Lead2D2",
  T_49_META_TYP_144_I3_D: "Lead2D2#",
  T_49_META_TYP_144_I4_D: "Lead2E2",
  T_49_META_TYP_144_I5_D: "Lead2F2",
  T_49_META_TYP_144_I6_D: "Lead2F2#",
  T_49_META_TYP_144_I7_D: "Lead2G2",
  T_49_META_TYP_144_I8_D: "Lead2G2#",
  T_49_META_TYP_144_I9_D: "Lead2A2",
  T_49_META_TYP_145_I0_D: "Lead3C2",
  T_49_META_TYP_145_I1_D: "Lead3C2#",
  T_49_META_TYP_145_I10_D: "Lead3A2#",
  T_49_META_TYP_145_I11_D: "Lead3B2",
  T_49_META_TYP_145_I2_D: "Lead3D2",
  T_49_META_TYP_145_I3_D: "Lead3D2#",
  T_49_META_TYP_145_I4_D: "Lead3E2",
  T_49_META_TYP_145_I5_D: "Lead3F2",
  T_49_META_TYP_145_I6_D: "Lead3F2#",
  T_49_META_TYP_145_I7_D: "Lead3G2",
  T_49_META_TYP_145_I8_D: "Lead3G2#",
  T_49_META_TYP_145_I9_D: "Lead3A2",
  T_49_META_TYP_146_I0_D: "PianoC3",
  T_49_META_TYP_146_I1_D: "PianoC3#",
  T_49_META_TYP_146_I10_D: "PianoA3#",
  T_49_META_TYP_146_I11_D: "PianoB3",
  T_49_META_TYP_146_I12_D: "PianoC4",
  T_49_META_TYP_146_I13_D: "PianoC4#",
  T_49_META_TYP_146_I14_D: "PianoD4",
  T_49_META_TYP_146_I15_D: "PianoD4#",
  T_49_META_TYP_146_I16_D: "PianoE4",
  T_49_META_TYP_146_I17_D: "PianoF4",
  T_49_META_TYP_146_I18_D: "PianoF4#",
  T_49_META_TYP_146_I19_D: "PianoG4",
  T_49_META_TYP_146_I2_D: "PianoD3",
  T_49_META_TYP_146_I20_D: "PianoG4#",
  T_49_META_TYP_146_I21_D: "PianoA4",
  T_49_META_TYP_146_I22_D: "PianoA4#",
  T_49_META_TYP_146_I23_D: "PianoB4",
  T_49_META_TYP_146_I3_D: "PianoD3#",
  T_49_META_TYP_146_I4_D: "PianoE3",
  T_49_META_TYP_146_I5_D: "PianoF3",
  T_49_META_TYP_146_I6_D: "PianoF3#",
  T_49_META_TYP_146_I7_D: "PianoG3",
  T_49_META_TYP_146_I8_D: "PianoG3#",
  T_49_META_TYP_146_I9_D: "PianoA3",
  T_49_META_TYP_147_I0_D: "এফএফ ক্লাসিক (শুটিং)",
  T_49_META_TYP_147_I1_D: "তৃতীয় ব্যক্তি",
  T_49_META_TYP_147_I2_D: "প্রথম ব্যক্তি (শুটার)",
  T_49_META_TYP_147_I3_D: "উপরের দৃশ্য",
  T_49_META_TYP_147_I4_D: "অনুভূমিক স্ক্রোল",
  T_49_META_TYP_147_I5_D: "কাস্টম ক্যামেরা",
  T_49_META_TYP_147_I6_D: "তাড়া",
  T_49_META_TYP_147_I7_D: "খেলোয়াড়-নিয়ন্ত্রিত, অবাধে চলমান ক্যামেরা",
  T_49_META_TYP_147_I8_D: "নতুন প্রথম-ব্যক্তি ক্যামেরা",
  T_49_META_TYP_148_I0_D: "বিভিন্ন ধরণের প্রিসেট ক্যামেরার ধরণ, সেইসাথে কাস্টম ক্যামেরার ধরণ প্রদান করে",
  T_49_META_TYP_148_I1_D: "দৃশ্য ক্ষেত্র হল ক্যামেরার দেখার কোণ",
  T_49_META_TYP_148_I10_D: "ক্যামেরা সুইচিং অ্যানিমেশনের ধরণ",
  T_49_META_TYP_148_I11_D: "শুধুমাত্র তখনই কার্যকর হয় যখন সুইচের ধরণটি মসৃণ থাকে। এই ক্যামেরায় স্যুইচ করার জন্য রূপান্তর সময় মিলিসেকেন্ডে।",
  T_49_META_TYP_148_I12_D: "যখন ক্যামেরা এবং অনুসরণ করা বস্তুর মধ্যে কোনও বাধা থাকে, তখন ক্যামেরার চলাচল মোড",
  T_49_META_TYP_148_I13_D: "ক্যামেরা কীভাবে ছবি তোলে",
  T_49_META_TYP_148_I14_D: "অবজেক্ট অফসেট রেফারেন্স স্থানাঙ্ক সিস্টেম অনুসরণ করুন",
  T_49_META_TYP_148_I15_D: "অবজেক্ট অফসেট রেফারেন্স স্থানাঙ্ক সিস্টেম পর্যবেক্ষণ করুন",
  T_49_META_TYP_148_I16_D: "ক্যামেরার রেন্ডার লেয়ার মাস্ক দৃশ্যমানতার স্তর অনুসারে ক্যামেরার রেন্ডার করা বস্তুগুলিকে ফিল্টার করতে পারে।",
  T_49_META_TYP_148_I17_D: "দর্শন কোণ সীমাবদ্ধতা",
  T_49_META_TYP_148_I2_D: "সাধারণত প্লেয়ারের মূল অবস্থানের সাপেক্ষে ক্যামেরার অবস্থানের অফসেট বোঝায়। বিভিন্ন ধরণের ক্যামেরার জন্য নির্দিষ্ট অর্থ পরিবর্তিত হয়।",
  T_49_META_TYP_148_I3_D: "সাধারণত প্লেয়ারের মূল অবস্থানের সাপেক্ষে ক্যামেরার ফোকাস পয়েন্টের অফসেটকে বোঝায়। বিভিন্ন ধরণের ক্যামেরার জন্য নির্দিষ্ট অর্থ পরিবর্তিত হয়।",
  T_49_META_TYP_148_I4_D: "ক্যামেরার উল্লম্ব ঘূর্ণন কোণ",
  T_49_META_TYP_148_I5_D: "ক্যামেরার অনুভূমিক ঘূর্ণন কোণ",
  T_49_META_TYP_148_I7_D: "ক্যামেরা যে লক্ষ্য অনুসরণ করে",
  T_49_META_TYP_148_I8_D: "ক্যামেরা কী দেখছে",
  T_49_META_TYP_148_I9_D: "বর্তমানে ক্যামেরা ব্যবহার করা প্লেয়ার",
  T_49_META_TYP_15_I0_D: "দলের সকল সদস্য বর্তমানে মৃত কিনা",
  T_49_META_TYP_15_I1_D: "সকল দলের সদস্যদের তালিকা",
  T_49_META_TYP_15_I3_D: "শত্রু দলের তালিকা",
  T_49_META_TYP_15_I4_D: "বন্ধুত্বপূর্ণ দলের তালিকা",
  T_49_META_TYP_15_I5_D: "দল নং",
  T_49_META_TYP_150_I0_D: "টেকসইতা",
  T_49_META_TYP_150_I1_D: "ক্যাপসুলের উভয় প্রান্তে গোলার্ধের ব্যাসার্ধ",
  T_49_META_TYP_150_I2_D: "ক্ষতির গুণফল",
  T_49_META_TYP_152_I1_D: "কাস্টম গ্র্যাভিটি",
  T_49_META_TYP_152_I2_D: "ট্রিগার প্রদর্শন করা হবে কিনা, True মানে প্রদর্শন",
  T_49_META_TYP_154_I0_D: "দ্বৈত চালনা করা যাবে না",
  T_49_META_TYP_154_I1_D: "একই ধরণের বন্দুক দিয়ে কেবল দুবার চালানো যাবে",
  T_49_META_TYP_154_I2_D: "অন্য অস্ত্র দিয়ে অথবা নিজের সাথে দ্বৈতভাবে চালানো যেতে পারে",
  T_49_META_TYP_155_I0_D: "গ্রেড",
  T_49_META_TYP_155_I1_D: "সর্বাধিক স্থায়িত্ব",
  T_49_META_TYP_155_I2_D: "বর্তমান স্থায়িত্ব",
  T_49_META_TYP_155_I3_D: "ক্ষতির হ্রাস সহগ",
  T_49_META_TYP_155_I4_D: "বিস্ফোরক ক্ষতির হ্রাস সহগ",
  T_49_META_TYP_155_I5_D: "টেকসইতার জন্য খরচ হতে পারে",
  T_49_META_TYP_155_I6_D: "ধ্বংস করতে পারে",
  T_49_META_TYP_156_I1_D: "সর্বাধিক স্থায়িত্ব",
  T_49_META_TYP_156_I2_D: "বর্তমান স্থায়িত্ব",
  T_49_META_TYP_156_I3_D: "ক্ষতির হ্রাস সহগ",
  T_49_META_TYP_156_I4_D: "বিস্ফোরক ক্ষতির হ্রাস সহগ",
  T_49_META_TYP_156_I5_D: "টেকসইতার জন্য খরচ হতে পারে",
  T_49_META_TYP_156_I6_D: "ধ্বংস করতে পারে",
  T_49_META_TYP_157_I0_D: "কোনও অ্যানিমেশন নেই",
  T_49_META_TYP_157_I1_D: "মসৃণ",
  T_49_META_TYP_158_I2_D: "UI অ্যাঙ্কর টাইপ গণনা, ডিফল্ট মান হল 9 (কেন্দ্র)",
  T_49_META_TYP_158_I6_D: "লেবেল কী",
  T_49_META_TYP_158_I7_D: "লেবেল প্যারামিটার",
  T_49_META_TYP_158_I8_D: "বাম দল",
  T_49_META_TYP_16_I1_D: "সত্তার সাথে সম্পর্কিত আইটেম আইডি",
  T_49_META_TYP_16_I2_D: "NavMesh স্ট্যাটিকভাবে তৈরি হয়েছে কিনা তা নির্ধারণের জন্য শুধুমাত্র স্ট্যাটিকভাবে বস্তু লোড করার সময় ব্যবহৃত হয়।",
  T_49_META_TYP_16_I3_D: "এটি NavMesh এর গতিশীল ব্লকিং কিনা",
  T_49_META_TYP_16_I4_D: "অ্যাসিঙ্ক্রোনাস লোডিং",
  T_49_META_TYP_160_I0_D: "ইট A",
  T_49_META_TYP_160_I1_D: "টাইল A",
  T_49_META_TYP_160_I10_D: "বালি A",
  T_49_META_TYP_160_I11_D: "তুষার A",
  T_49_META_TYP_160_I12_D: "কাঠ A",
  T_49_META_TYP_160_I13_D: "পাথর A",
  T_49_META_TYP_160_I14_D: "লন B",
  T_49_META_TYP_160_I15_D: "ইট B",
  T_49_META_TYP_160_I16_D: "ইট C",
  T_49_META_TYP_160_I17_D: "পরিষ্কার",
  T_49_META_TYP_160_I2_D: "টাইল B",
  T_49_META_TYP_160_I3_D: "টাইল C",
  T_49_META_TYP_160_I4_D: "বাঁশ A",
  T_49_META_TYP_160_I5_D: "সিমেন্ট A",
  T_49_META_TYP_160_I6_D: "কন্টেইনার A",
  T_49_META_TYP_160_I7_D: "লন A",
  T_49_META_TYP_160_I8_D: "বরফ A",
  T_49_META_TYP_160_I9_D: "ম্যাগমা A",
  T_49_META_TYP_165_I0_D: "সংঘর্ষ সক্ষম করা হবে কিনা",
  T_49_META_TYP_165_I1_D: "ট্রিগার হিসেবে কাজ করবে কিনা",
  T_49_META_TYP_165_I2_D: "ভৌত স্তর, ভৌত মডিউলে স্তরটি কনফিগার করুন, সর্বোচ্চ ১৬ পর্যন্ত",
  T_49_META_TYP_166_I0_D: "ইমোট১",
  T_49_META_TYP_166_I1_D: "Emote2 সম্পর্কে",
  T_49_META_TYP_166_I2_D: "Emote3 সম্পর্কে",
  T_49_META_TYP_166_I3_D: "Emote4 সম্পর্কে",
  T_49_META_TYP_166_I4_D: "ইমোট৫",
  T_49_META_TYP_167_I0_D: "VFX টেক্সচার টাইপ",
  T_49_META_TYP_170_I0_D: "এটি কি দৃশ্যমান? যদি এটি দৃশ্যমান না হয়, তাহলে ক্লায়েন্ট লক্ষ্য রেন্ডার করা বন্ধ করে দেয়।",
  T_49_META_TYP_170_I1_D: "দৃশ্যমান স্তর, মান পরিসীমা [0,15], ক্যামেরায় দৃশ্যমানতাকে প্রভাবিত করে",
  T_49_META_TYP_171_I0_D: "শক্তি",
  T_49_META_TYP_172_I0_D: "বুলেটের সংখ্যা",
  T_49_META_TYP_173_I0_D: "অতিরিক্ত ব্যাকপ্যাক ক্ষমতা",
  T_49_META_TYP_173_I1_D: "খেলার বাইরের খেলোয়াড়দের স্কিন কনফিগারেশন অগ্রাধিকার পায়",
  T_49_META_TYP_173_I2_D: "ব্যাকপ্যাক স্কিন আইডি, ব্যাকপ্যাক স্কিন কনফিগারেশন",
  T_49_META_TYP_174_I2_D: "সর্বাধিক ক্ষতি",
  T_49_META_TYP_174_I4_D: "নিক্ষেপের গতি",
  T_49_META_TYP_174_I5_D: "বিস্ফোরণ বিলম্ব, সেকেন্ডে",
  T_49_META_TYP_174_I6_D: "স্ব-ক্ষতির অনুপাত",
  T_49_META_TYP_174_I7_D: "সহকর্মী ক্ষতির অনুপাত",
  T_49_META_TYP_174_I8_D: "যানবাহন ক্ষতির অনুপাত",
  T_49_META_TYP_174_I9_D: "جلد",
  T_49_META_TYP_175_I0_D: "জমে যাওয়া এলাকা ব্যাসার্ধ",
  T_49_META_TYP_175_I1_D: "হিমায়িত এলাকার সময়কাল, সেকেন্ডে",
  T_49_META_TYP_176_I0_D: "প্রধান ধরণের অস্ত্র",
  T_49_META_TYP_176_I1_D: "অস্ত্র উপ প্রকার",
  T_49_META_TYP_177_I0_D: "যখন ক্যামেরা এবং অনুসরণ করা বস্তুর মধ্যে কোনও বাধা থাকে, তখন ক্যামেরা কোনও পরিবর্তন করে না।",
  T_49_META_TYP_177_I1_D: "যখন ক্যামেরা এবং অনুসরণ করা বস্তুর মধ্যে কোনও বাধা থাকে, তখন ক্যামেরাটি অনুসরণ করা বস্তুর কাছাকাছি চলে যাবে।",
  T_49_META_TYP_177_I2_D: "যখন ক্যামেরা এবং ফলো অবজেক্টের মধ্যে একটি অক্লুডার থাকে, তখন অক্লুডারটি আধা-স্বচ্ছ হয়ে যাবে।",
  T_49_META_TYP_178_I0_D: "ক্যামেরা যখন কোন বস্তু পর্যবেক্ষণ করে, তখন কাছের বস্তুগুলো বড় দেখায় এবং দূরে থাকা বস্তুগুলো ছোট দেখায়।",
  T_49_META_TYP_178_I1_D: "যখন ক্যামেরা কোন বস্তু পর্যবেক্ষণ করে, তখন কাছের এবং দূরের বস্তুর আকার একই হয়।",
  T_49_META_TYP_184_I0_D: "রেন্ডার করার জন্য রিসোর্সের UUID উল্লেখ করুন।",
  T_49_META_TYP_185_I0_D: "মডেল মেশ ব্যবহার করার জন্য রেন্ডার করুন",
  T_49_META_TYP_185_I1_D: "রেন্ডারিংয়ের জন্য ব্যবহৃত উপকরণের তালিকা",
  T_49_META_TYP_187_I0_D: "আইটেম আইডি",
  T_49_META_TYP_190_I0_D: "খোলা অবস্থা",
  T_49_META_TYP_190_I1_D: "খেলার ফলাফল",
  T_49_META_TYP_190_I10_D: "পয়েন্ট তালিকা 1",
  T_49_META_TYP_190_I11_D: "পয়েন্ট তালিকা 2",
  T_49_META_TYP_190_I12_D: "পয়েন্ট তালিকা 3",
  T_49_META_TYP_190_I13_D: "বিজয়ী MVP তালিকা",
  T_49_META_TYP_190_I14_D: "পরাজিত MVP তালিকা",
  T_49_META_TYP_190_I15_D: "ম্যাচের বিস্তারিত দেখান",
  T_49_META_TYP_190_I16_D: "মানচিত্র মূল্যায়ন দেখান",
  T_49_META_TYP_190_I17_D: "উপহার দেখান",
  T_49_META_TYP_190_I18_D: "প্রতিবেদন দেখান",
  T_49_META_TYP_190_I19_D: "পুনঃপ্লে দেখান",
  T_49_META_TYP_190_I20_D: "শেয়ার দেখান",
  T_49_META_TYP_190_I21_D: "লবি দেখান",
  T_49_META_TYP_190_I22_D: "লাইক দেখান",
  T_49_META_TYP_190_I23_D: "বন্ধু যোগ করুন দেখান",
  T_49_META_TYP_190_I24_D: "অর্থনীতি দেখান",
  T_49_META_TYP_190_I4_D: "ডান দল",
  T_49_META_TYP_190_I5_D: "শিরোনাম",
  T_49_META_TYP_190_I6_D: "প্লেয়ার র্যাঙ্ক",
  T_49_META_TYP_190_I9_D: "শিরোনাম",
  T_49_META_TYP_191_I0_D: "কেন্দ্রীয় পরিসীমা",
  T_49_META_TYP_191_I4_D: "সেন্টার ফ্ল্যাশ টাইম, মিলিসেকেন্ডে",
  T_49_META_TYP_191_I5_D: "এজ ফ্ল্যাশ টাইম, মিলিসেকেন্ডে",
  T_49_META_TYP_191_I6_D: "প্রভাবের সময়কাল",
  T_49_META_TYP_192_I3_D: "স্পেশাল এফেক্টের সময়কাল, সেকেন্ডে",
  T_49_META_TYP_193_I1_D: "ম্যাচ শিরোনাম বাম",
  T_49_META_TYP_193_I10_D: "পয়েন্ট তালিকা 1",
  T_49_META_TYP_193_I11_D: "পয়েন্ট তালিকা 2",
  T_49_META_TYP_193_I12_D: "পয়েন্ট তালিকা 3",
  T_49_META_TYP_193_I13_D: "স্কোর তালিকা 4",
  T_49_META_TYP_193_I14_D: "স্কোর তালিকা 5",
  T_49_META_TYP_193_I15_D: "বিজয়ী MVP তালিকা",
  T_49_META_TYP_193_I16_D: "পরাজিত MVP তালিকা",
  T_49_META_TYP_193_I17_D: "ম্যাচের বিস্তারিত দেখান",
  T_49_META_TYP_193_I18_D: "মানচিত্র মূল্যায়ন দেখান",
  T_49_META_TYP_193_I19_D: "উপহার দেখান",
  T_49_META_TYP_193_I2_D: "ম্যাচ শিরোনাম ডান",
  T_49_META_TYP_193_I20_D: "প্রতিবেদন দেখান",
  T_49_META_TYP_193_I21_D: "পুনঃপ্লে দেখান",
  T_49_META_TYP_193_I22_D: "শেয়ার দেখান",
  T_49_META_TYP_193_I23_D: "লবি দেখান",
  T_49_META_TYP_193_I24_D: "লাইক দেখান",
  T_49_META_TYP_193_I25_D: "বন্ধু যোগ করুন দেখান",
  T_49_META_TYP_193_I26_D: "অর্থনীতি দেখান",
  T_49_META_TYP_193_I3_D: "খেলার ফলাফল",
  T_49_META_TYP_193_I4_D: "টিম র্যাঙ্ক",
  T_49_META_TYP_193_I5_D: "প্লেয়ার র্যাঙ্ক",
  T_49_META_TYP_193_I6_D: "দলের র‍্যাঙ্কিং",
  T_49_META_TYP_193_I7_D: "মূল স্কোর শিরোনাম",
  T_49_META_TYP_193_I8_D: "মূল স্কোর",
  T_49_META_TYP_193_I9_D: "শিরোনাম",
  T_49_META_TYP_194_I0_D: "মাইন কার্যকর হওয়ার সময় সেকেন্ডে",
  T_49_META_TYP_194_I1_D: "ট্রিগার ব্যাসার্ধ",
  T_49_META_TYP_194_I2_D: "মাইন রেঞ্জের মধ্যে একটি মাইন চালু করতে যে সময় লাগে, সেকেন্ডে",
  T_49_META_TYP_194_I3_D: "নিজে সক্রিয় করা যায়",
  T_49_META_TYP_194_I4_D: "দল দ্বারা সক্রিয় করা যায়",
  T_49_META_TYP_194_I5_D: "যানবাহন দ্বারা ট্রিগার করা যেতে পারে",
  T_49_META_TYP_194_I6_D: "খনিটির অস্তিত্বের সময়কাল, যা শেষ হওয়ার পরে স্বয়ংক্রিয়ভাবে বিস্ফোরিত হবে। খনি স্থাপনের সময় থেকে সময় শুরু হয়, সেকেন্ডে",
  T_49_META_TYP_194_I7_D: "আক্রমণযোগ্য",
  T_49_META_TYP_194_I8_D: "স্বাস্থ্য",
  T_49_META_TYP_195_I0_D: "একবার",
  T_49_META_TYP_195_I2_D: "পারস্পরিক",
  T_49_META_TYP_197_I0_D: "এটা কি বাজছে?",
  T_49_META_TYP_197_I1_D: "মার্ক বিট",
  T_49_META_TYP_197_I2_D: "তৈরি করার সময় স্বয়ংক্রিয়ভাবে চালানোর জন্য চেক করুন",
  T_49_META_TYP_198_I0_D: "সংযুক্তির সাথে সম্পর্কিত প্রপ আইডি",
  T_49_META_TYP_199_I0_D: "সর্বোচ্চ শক্তি",
  T_49_META_TYP_199_I1_D: "এনার্জি খরচ",
  T_49_META_TYP_199_I10_D: "পতনের ক্ষতি অনুপাত",
  T_49_META_TYP_199_I11_D: "বর্তমান শক্তি",
  T_49_META_TYP_199_I2_D: "উপরের শক্তির খরচ",
  T_49_META_TYP_199_I3_D: "স্প্রিন্ট শক্তির খরচ",
  T_49_META_TYP_199_I4_D: "রাশ শক্তির খরচ",
  T_49_META_TYP_199_I5_D: "বেস অনুভূমিক গতি",
  T_49_META_TYP_199_I6_D: "স্প্রিন্ট অনুভূমিক গতি",
  T_49_META_TYP_199_I7_D: "বেস উল্লম্ব গতি",
  T_49_META_TYP_199_I8_D: "স্প্রিন্ট উল্লম্ব গতি",
  T_49_META_TYP_199_I9_D: "রাশ দূরত্ব",
  T_49_META_TYP_200_I0_D: "অঞ্চল আইডি",
  T_49_META_TYP_200_I1_D: "গেম আইডি",
  T_49_META_TYP_201_I0_D: "ধীরগতির শতাংশ: খোলা জলে জলজ বস্তুর গতি কত শতাংশ কমানো হয়",
  T_49_META_TYP_203_I0_D: "লক্ষ্য সত্তা",
  T_49_META_TYP_203_I1_D: "প্রোপ আইডি",
  T_49_META_TYP_203_I10_D: "যে সময় গেম সার্ভার টিক টিক শুরু করে",
  T_49_META_TYP_203_I11_D: "শুরু মান",
  T_49_META_TYP_203_I12_D: "শেষ মান",
  T_49_META_TYP_203_I13_D: "পাসের শতাংশ",
  T_49_META_TYP_203_I4_D: "টুইন স্টাইল",
  T_49_META_TYP_203_I6_D: "সময়কাল (গুলি)",
  T_49_META_TYP_203_I7_D: "বিপরীত",
  T_49_META_TYP_203_I8_D: "নিয়ন্ত্রণ পয়েন্ট",
  T_49_META_TYP_203_I9_D: "জোর করে সিঙ্ক গেম সার্ভারের অবস্থা",
  T_49_META_TYP_204_I0_D: "সর্বাধিক লাফ উচ্চতা",
  T_49_META_TYP_204_I1_D: "পতনের ক্ষতির শতাংশ",
  T_49_META_TYP_204_I2_D: "শক্তি পুনরুদ্ধার",
  T_49_META_TYP_204_I3_D: "শক্তি খরচ করুন",
  T_49_META_TYP_204_I4_D: "সর্বাধিক শক্তি",
  T_49_META_TYP_205_I0_D: "ন্যূনতম উড়ন্ত উচ্চতা",
  T_49_META_TYP_205_I1_D: "ন্যূনতম শেষ উচ্চতা",
  T_49_META_TYP_205_I2_D: "অনুভূমিক ফ্লাই স্পিড",
  T_49_META_TYP_205_I3_D: "উল্লম্ব ফ্লাই স্পিড",
  T_49_META_TYP_205_I4_D: "পতন গতি",
  T_49_META_TYP_205_I5_D: "বাঁকানো গতি",
  T_49_META_TYP_205_I6_D: "সর্বাধিক উড্ডয়ন উচ্চতা",
  T_49_META_TYP_205_I7_D: "উচ্চতা অতিক্রমের পর পতন গতি",
  T_49_META_TYP_205_I8_D: "পরিবর্তনশীল গতি ত্বরণ",
  T_49_META_TYP_206_I0_D: "কেন্দ্র",
  T_49_META_TYP_206_I1_D: "ট্রিগার",
  T_49_META_TYP_206_I10_D: "উচ্চ গতিতে, সর্বোচ্চ স্টিয়ারিং কোণ",
  T_49_META_TYP_206_I11_D: "উচ্চ-গতির স্টিয়ারিং কোণ ইন্টারপোলেশন বেস রেট",
  T_49_META_TYP_206_I2_D: "বুস্ট গতি",
  T_49_META_TYP_206_I3_D: "স্প্রিন্টের সময়কাল সেকেন্ডে",
  T_49_META_TYP_206_I4_D: "স্প্রিন্টের কুলডাউন সময়, সেকেন্ডে",
  T_49_META_TYP_206_I6_D: "সেকেন্ডের মধ্যে সিডি জাম্প করুন",
  T_49_META_TYP_206_I7_D: "স্কেটবোর্ডে ওঠার পর স্প্রিন্ট সিডি, ইউনিট: সেকেন্ড",
  T_49_META_TYP_206_I8_D: "বুস্টে ওঠার কুলডাউন সুইচ",
  T_49_META_TYP_206_I9_D: "স্কেটবোর্ডে স্লাইডিংয়ের সিডি, কয়েক সেকেন্ডে",
  T_49_META_TYP_207_I1_D: "শুরু সূচক",
  T_49_META_TYP_207_I2_D: "শেষ অবস্থান",
  T_49_META_TYP_207_I3_D: "জিপলাইন আইডি",
  T_49_META_TYP_207_I4_D: "গ্রুপ আইডি",
  T_49_META_TYP_207_I5_D: "এটা কি শেষ?",
  T_49_META_TYP_21_I0_D: "UI এর মৌলিক স্তর",
  T_49_META_TYP_210_I1_D: "অফসেট",
  T_49_META_TYP_210_I2_D: "ট্রিগার",
  T_49_META_TYP_210_I3_D: "আক্রমণকারী",
  T_49_META_TYP_210_I4_D: "প্রাথমিক বিশ্ব অবস্থান",
  T_49_META_TYP_210_I5_D: "গেম সার্ভার লোকেশন তথ্য জোর করে সিঙ্ক্রোনাইজ করেছে",
  T_49_META_TYP_211_I0_D: "স্থানীয় স্থানাঙ্ক",
  T_49_META_TYP_211_I1_D: "বিশ্বের অবস্থান",
  T_49_META_TYP_212_I0_D: "নিজ",
  T_49_META_TYP_212_I2_D: "অফসেট স্থানাঙ্ক",
  T_49_META_TYP_213_I0_D: "নিজ",
  T_49_META_TYP_213_I2_D: "অফসেট স্থানাঙ্ক",
  T_49_META_TYP_215_I0_D: "বিজয়",
  T_49_META_TYP_215_I1_D: "পরাজয়",
  T_49_META_TYP_215_I2_D: "বুয়াহ",
  T_49_META_TYP_215_I3_D: "ড্র",
  T_49_META_TYP_218_I0_D: "তীব্রতা",
  T_49_META_TYP_218_I1_D: "পরিসর",
  T_49_META_TYP_218_I2_D: "হালকা রঙ",
  T_49_META_TYP_22_I0_D: "যদি খোলা অবস্থা সত্য হয়, তাহলে এটি প্রদর্শিত হবে, অন্যথায় এটি বন্ধ হয়ে যাবে।",
  T_49_META_TYP_22_I1_D: "প্রিফ্যাব আইডি",
  T_49_META_TYP_22_I2_D: "বর্তমান সর্বোচ্চ নিয়ন্ত্রণ আইডি",
  T_49_META_TYP_22_I3_D: "UI এর মৌলিক স্তর",
  T_49_META_TYP_22_I4_D: "প্লেয়ার ভিউ সক্ষম করুন",
  T_49_META_TYP_22_I5_D: "বিশ্বের অবস্থান",
  T_49_META_TYP_22_I6_D: "এটা কি দৃশ্যে আছে?",
  T_49_META_TYP_22_I7_D: "বিশ্ব স্থানাঙ্কে ঘূর্ণন",
  T_49_META_TYP_22_I8_D: "বিশ্ব স্থানাঙ্কে স্কেলিং",
  T_49_META_TYP_221_I0_D: "গিয়ার শিফট বিলম্ব, মান যত বেশি হবে, গিয়ার পরিবর্তনের গতি তত কম হবে",
  T_49_META_TYP_222_I0_D: "গিয়ার শিফট বিলম্ব, মান যত বেশি হবে, গিয়ার পরিবর্তনের গতি তত কম হবে",
  T_49_META_TYP_225_I0_D: "টারেটের ক্ষতি",
  T_49_META_TYP_225_I1_D: "ক্ষতির অন্তর্বর্তীকাল (স)",
  T_49_META_TYP_225_I10_D: "কোণের মধ্যে আগুন",
  T_49_META_TYP_225_I11_D: "ক্ষতি হ্রাসের হার",
  T_49_META_TYP_225_I12_D: "আর্মার পেনিট্রেশন",
  T_49_META_TYP_225_I2_D: "সঠিকতা",
  T_49_META_TYP_225_I3_D: "পরিসর",
  T_49_META_TYP_225_I4_D: "কোণীয় গতি",
  T_49_META_TYP_225_I5_D: "কোণ উপরে",
  T_49_META_TYP_225_I6_D: "কোণ নিচে",
  T_49_META_TYP_225_I7_D: "সর্বোচ্চ HP",
  T_49_META_TYP_225_I8_D: "লাইফ টাইম (স)",
  T_49_META_TYP_225_I9_D: "সর্বোচ্চ টারেট সংখ্যা",
  T_49_META_TYP_226_I0_D: "বুরুজের বর্তমান অবস্থা",
  T_49_META_TYP_226_I1_D: "আক্রমণ সক্ষম করুন",
  T_49_META_TYP_227_I0_D: "সহজ উইজেট",
  T_49_META_TYP_227_I1_D: "ইমেজ উইজেট",
  T_49_META_TYP_227_I10_D: "টেক্সচার উইজেট",
  T_49_META_TYP_227_I11_D: "প্রোফাইল উইজেট",
  T_49_META_TYP_227_I12_D: "টোগল উইজেট",
  T_49_META_TYP_227_I13_D: "টাচ প্যাড উইজেট",
  T_49_META_TYP_227_I14_D: "জয়স্টিক উইজেট",
  T_49_META_TYP_227_I15_D: "সোশ্যাল বাটন উইজেট",
  T_49_META_TYP_227_I2_D: "লেবেল উইজেট",
  T_49_META_TYP_227_I3_D: "বোতাম উইজেট",
  T_49_META_TYP_227_I4_D: "ইনপুট লেবেল উইজেট",
  T_49_META_TYP_227_I5_D: "প্যানেল",
  T_49_META_TYP_227_I6_D: "স্ক্রোল প্যানেল",
  T_49_META_TYP_227_I7_D: "গ্রিড",
  T_49_META_TYP_227_I8_D: "লেআউট উইজেট",
  T_49_META_TYP_227_I9_D: "কনটেইনার উইজেট",
  T_49_META_TYP_231_I0_D: "স্থায়িত্ব পুনরুদ্ধার",
  T_49_META_TYP_231_I1_D: "কার্যকর হওয়ার জন্য সময়ের ব্যবধান, সেকেন্ডে",
  T_49_META_TYP_233_I2_D: "টাইমিংয়ের শেষ সময়, সেকেন্ডে",
  T_49_META_TYP_233_I4_D: "আইকন রিসোর্সের নাম",
  T_49_META_TYP_234_I0_D: "ট্রিগার সময়, সেকেন্ডে",
  T_49_META_TYP_234_I1_D: "নিজে সক্রিয় করা যায়",
  T_49_META_TYP_234_I10_D: "বর্তমান স্বাস্থ্য",
  T_49_META_TYP_234_I2_D: "দল দ্বারা সক্রিয় করা যায়",
  T_49_META_TYP_234_I3_D: "যানবাহন দ্বারা ট্রিগার করা যেতে পারে",
  T_49_META_TYP_234_I4_D: "সময়কাল, সেকেন্ডে",
  T_49_META_TYP_234_I5_D: "আক্রমণযোগ্য",
  T_49_META_TYP_234_I6_D: "স্বাস্থ্য",
  T_49_META_TYP_235_I0_D: "ম্যাক্স হেলথ",
  T_49_META_TYP_235_I2_D: "সর্বাধিক সংখ্যা",
  T_49_META_TYP_237_I0_D: "নিক্ষেপের গতি",
  T_49_META_TYP_237_I1_D: "খেলোয়াড়ের টানের গতি",
  T_49_META_TYP_238_I0_D: "স্প্রে রঙ",
  T_49_META_TYP_239_I0_D: "প্রাথমিক গতি",
  T_49_META_TYP_239_I1_D: "ত্বরণ (যেমন মাধ্যাকর্ষণ)",
  T_49_META_TYP_24_I0_D: "হাতাহাতি",
  T_49_META_TYP_24_I1_D: "বন্দুক",
  T_49_META_TYP_24_I10_D: "এয়ারড্রপের ক্ষতি, দানবীয় আত্মহত্যার ক্ষতি",
  T_49_META_TYP_24_I11_D: "যানবাহন বিস্ফোরণের পর পোড়ানোর ক্ষতি",
  T_49_META_TYP_24_I12_D: "তেলের ড্রাম বিস্ফোরণ",
  T_49_META_TYP_24_I13_D: "ক্ষেপণাস্ত্র ধরনের অস্ত্র",
  T_49_META_TYP_24_I14_D: "দানব",
  T_49_META_TYP_24_I15_D: "ক্ষতির অঞ্চল",
  T_49_META_TYP_24_I17_D: "চরিত্রের দক্ষতা",
  T_49_META_TYP_24_I2_D: "গ্রেনেড ছোড়া",
  T_49_META_TYP_24_I3_D: "সেফ জোন",
  T_49_META_TYP_24_I4_D: "যানবাহন",
  T_49_META_TYP_24_I5_D: "পড়ে যাওয়া",
  T_49_META_TYP_24_I6_D: "মৃত্যু অঞ্চল",
  T_49_META_TYP_24_I7_D: "প্রস্থান",
  T_49_META_TYP_24_I8_D: "সংযোগ বিচ্ছিন্ন",
  T_49_META_TYP_24_I9_D: "যানবাহন বিস্ফোরণ",
  T_49_META_TYP_241_I0_D: "ট্র্যাকশন গতি",
  T_49_META_TYP_241_I1_D: "সুইং গতি",
  T_49_META_TYP_241_I2_D: "ট্র্যাকশন বোতামটি চালু করুন",
  T_49_META_TYP_241_I3_D: "সুইং বোতামটি চালু করুন",
  T_49_META_TYP_241_I4_D: "মোশন অ্যাঙ্কর",
  T_49_META_TYP_241_I5_D: "দোল থেকে বের হওয়ার ত্বরণ",
  T_49_META_TYP_242_I2_D: "বাম পাশের প্রভাব সক্রিয়",
  T_49_META_TYP_242_I3_D: "ডান পাশের প্রভাব সক্রিয়",
  T_49_META_TYP_242_I4_D: "কেন্দ্রীয় লাইন সক্রিয়",
  T_49_META_TYP_242_I5_D: "মান",
  T_49_META_TYP_242_I7_D: "UI অবস্থান, শুধুমাত্র XY উপাদানগুলি বৈধ",
  T_49_META_TYP_242_I8_D: "মাঝের রেখার অবস্থান [0,1]",
  T_49_META_TYP_243_I0_D: "উপরের পোশাক",
  T_49_META_TYP_243_I1_D: "নিচের পোশাক",
  T_49_META_TYP_243_I2_D: "জুতো",
  T_49_META_TYP_243_I3_D: "মুখের রঙ",
  T_49_META_TYP_243_I4_D: "মাথার আচ্ছাদন",
  T_49_META_TYP_243_I5_D: "পুরো শরীরের পোশাক",
  T_49_META_TYP_243_I6_D: "মুখের সাজ",
  T_49_META_TYP_244_I0_D: "প্রদর্শিত হবে এমন লেখা",
  T_49_META_TYP_244_I10_D: "এই সত্তাটি দেখতে পারেন এমন খেলোয়াড়দের তালিকা",
  T_49_META_TYP_244_I11_D: "প্রদর্শন শ্রেণিবিন্যাস",
  T_49_META_TYP_244_I2_D: "লক্ষ্য অনুসরণ করুন",
  T_49_META_TYP_244_I3_D: "যখন গভীরতা উপেক্ষা করা হয়, তখন এটি প্রাচীরের মধ্য দিয়ে প্রদর্শিত হতে পারে, অন্যথায় এটি প্রদর্শিত হতে পারে না",
  T_49_META_TYP_244_I4_D: "সর্বদা ভিডিও ক্যামেরায়",
  T_49_META_TYP_244_I5_D: "যখন সত্য হিসেবে সেট করা হয়, তখন অবস্থানটি স্ক্রিনের বাইরে থাকা অবস্থায় স্ক্রিনে প্রদর্শিত হবে।",
  T_49_META_TYP_244_I6_D: "ফন্টের ধরন",
  T_49_META_TYP_244_I7_D: "ফন্টের ধরণ",
  T_49_META_TYP_244_I8_D: "ফন্ট সাইজ",
  T_49_META_TYP_245_I0_D: "প্রভাব রিসোর্স পাথ",
  T_49_META_TYP_245_I11_D: "প্রদর্শন শ্রেণিবিন্যাস",
  T_49_META_TYP_245_I3_D: "যখন গভীরতা উপেক্ষা করা হয়, তখন এটি প্রাচীরের মধ্য দিয়ে প্রদর্শিত হতে পারে, অন্যথায় এটি প্রদর্শিত হতে পারে না",
  T_49_META_TYP_245_I4_D: "যখন সত্য হিসেবে সেট করা হয়, তখন অবস্থানটি স্ক্রিনের বাইরে থাকা অবস্থায় স্ক্রিনে প্রদর্শিত হবে।",
  T_49_META_TYP_245_I5_D: "সর্বদা ভিডিও ক্যামেরায়",
  T_49_META_TYP_245_I6_D: "রেন্ডার টাইপ",
  T_49_META_TYP_245_I7_D: "প্রস্থ",
  T_49_META_TYP_246_I0_D: "কমলা",
  T_49_META_TYP_246_I1_D: "বেগুনি",
  T_49_META_TYP_246_I2_D: "লাল",
  T_49_META_TYP_246_I3_D: "সবুজ",
  T_49_META_TYP_246_I4_D: "নীল",
  T_49_META_TYP_247_I1_D: "স্প্রিন্ট",
  T_49_META_TYP_247_I14_D: "অভিব্যক্তি",
  T_49_META_TYP_247_I15_D: "দ্রুত চ্যাট",
  T_49_META_TYP_247_I16_D: "জিনিসপত্র",
  T_49_META_TYP_247_I17_D: "দ্রুত চ্যাট প্রদর্শন",
  T_49_META_TYP_247_I18_D: "HP (স্বাস্থ্য)",
  T_49_META_TYP_247_I19_D: "EP (এনার্জি পয়েন্ট)",
  T_49_META_TYP_247_I2_D: "আক্রমণ",
  T_49_META_TYP_247_I20_D: "বর্ম",
  T_49_META_TYP_247_I21_D: "রিলোড",
  T_49_META_TYP_247_I22_D: "দ্রুত বন্দুক পরিবর্তন বোতাম",
  T_49_META_TYP_247_I23_D: "গাড়ির হর্ন বোতামটি চালু/বন্ধ করা যেতে পারে",
  T_49_META_TYP_247_I24_D: "চালু/বন্ধ করার জন্য ভয়েস (মাইক্রোফোন) বোতাম",
  T_49_META_TYP_247_I25_D: "টগল মার্ক বোতাম চালু/বন্ধ করুন",
  T_49_META_TYP_247_I27_D: "নেটওয়ার্ক সিগন্যাল বোতামটি চালু/বন্ধ করা যেতে পারে",
  T_49_META_TYP_247_I28_D: "সক্রিয় দক্ষতা",
  T_49_META_TYP_247_I29_D: "ক্রসহেয়ার",
  T_49_META_TYP_247_I3_D: "লাফ",
  T_49_META_TYP_247_I30_D: "নিষ্ক্রিয় দক্ষতা",
  T_49_META_TYP_247_I4_D: "হত্যার টিপস",
  T_49_META_TYP_247_I5_D: "অস্ত্রের স্লট",
  T_49_META_TYP_247_I6_D: "মিনি ম্যাপ",
  T_49_META_TYP_247_I7_D: "ব্যাকপ্যাক UI",
  T_49_META_TYP_247_I8_D: "চিকিৎসা সামগ্রী",
  T_49_META_TYP_247_I9_D: "যদি সত্য হয়, তাহলে এটি প্রদর্শিত হবে, অন্যথায় এটি বন্ধ হয়ে যাবে।",
  T_49_META_TYP_249_I3_D: "বিস্ফোরক অস্ত্র",
  T_49_META_TYP_249_I5_D: "ভারী অস্ত্র",
  T_49_META_TYP_249_I8_D: "হিমায়িত বোমা",
  T_49_META_TYP_249_I9_D: "ডামি গ্রেনেড",
  T_49_META_TYP_25_I0_D: "বর্তমান পর্যায়ের সূচক, প্রক্রিয়া সম্পাদকের সূচকের সাথে সম্পর্কিত",
  T_49_META_TYP_25_I1_D: "বর্তমান পর্যায়ের শুরুর সময়, ms-এ",
  T_49_META_TYP_25_I2_D: "বর্তমান পর্যায়ের শেষ সময়, মিলিসেকেন্ডে",
  T_49_META_TYP_25_I3_D: "বর্তমান পর্বের সময়কাল, ms-এ",
  T_49_META_TYP_250_I1_D: "স্পেশাল এফেক্ট রঙ, RGBA চারটি চ্যানেল, একক চ্যানেল মান পরিসীমা 0~255, একটি Int32-তে সংরক্ষিত",
  T_49_META_TYP_250_I3_D: "VFX টেক্সচার টাইপ",
  T_49_META_TYP_250_I4_D: "ডিফিউজ আলফা",
  T_49_META_TYP_2500_I1_D: "ডিফল্ট স্পন পয়েন্ট কি না",
  T_49_META_TYP_2500_I3_D: "এই স্পন এলাকায় কি ইতিমধ্যেই কোনও খেলোয়াড় জন্মগ্রহণ করেছেন?",
  T_49_META_TYP_2500_I4_D: "বর্তমানে নির্ধারিত জন্মবিন্দুর স্থানাঙ্ক",
  T_49_META_TYP_2502_I0_D: "এটি একটি মৃত্যু ট্রিগার হোক বা না হোক, এটি একটি অজেয় ট্রিগার। (এটি OB32 থেকে একটি লিগ্যাসি সমস্যা, ভবিষ্যতে কার্যকারিতাটি ভাগ করে নিন!)",
  T_49_META_TYP_2502_I1_D: "ট্রিগার বর্ডার প্রদর্শন করা হবে কিনা, সত্য মানে প্রদর্শন",
  T_49_META_TYP_2503_I0_D: "চেকপয়েন্ট আইডি",
  T_49_META_TYP_2503_I2_D: "চেকপয়েন্টের অবস্থান",
  T_49_META_TYP_2507_I0_D: "প্রতিরক্ষা টাওয়ারটি কোন শিবিরের অন্তর্গত? যদি এটি খেলোয়াড়ের মতো একই শিবিরের হয়, তবে এটি খেলোয়াড়কে আক্রমণ করবে না।",
  T_49_META_TYP_2507_I1_D: "HP",
  T_49_META_TYP_2507_I10_D: "অবজেক্ট আইডি",
  T_49_META_TYP_2507_I2_D: "সর্বাধিক HP",
  T_49_META_TYP_2507_I3_D: "আক্রমণের ক্ষতি, একটি একক আক্রমণ খেলোয়াড়ের যে ক্ষতি করতে পারে",
  T_49_META_TYP_2507_I4_D: "দুটি আক্রমণের মধ্যবর্তী ব্যবধান, সেকেন্ডে",
  T_49_META_TYP_2507_I5_D: "কেন্দ্রস্থল এবং যেকোনো আকারের ব্যাসার্ধ সহ এলাকা আক্রমণ করা যেতে পারে",
  T_49_META_TYP_2507_I6_D: "ক্ষতি হ্রাসের হার, ১ এর চেয়ে এক দশমিক কম। চূড়ান্ত ক্ষতি হল ক্ষতিকে (১-ক্ষতি হ্রাসের হার) দ্বারা গুণিত করা।",
  T_49_META_TYP_2507_I7_D: "আক্রমণ লক্ষ্য",
  T_49_META_TYP_2507_I8_D: "কোণ",
  T_49_META_TYP_2507_I9_D: "মিনি সেন্ত্রি অবস্থান",
  T_49_META_TYP_2508_I0_D: "প্রতিটি তরঙ্গে কতগুলি জম্বি জন্মাবে",
  T_49_META_TYP_2508_I1_D: "জম্বির কত তরঙ্গ তৈরি হবে?",
  T_49_META_TYP_2508_I2_D: "ক্রমাগত জেনারেট করতে হবে কিনা, কিন্তু একই স্ক্রিনে একটি সীমা থাকবে",
  T_49_META_TYP_2508_I3_D: "বর্তমানে কোন তরঙ্গ উৎপন্ন হয়?",
  T_49_META_TYP_2508_I5_D: "বর্তমান তরঙ্গে কোন ধরণের জম্বি জন্মায়?",
  T_49_META_TYP_2508_I6_D: "এআই কি মারা গেলে সরঞ্জাম বা জিনিসপত্র ফেলে দেবে?",
  T_49_META_TYP_2508_I7_D: "স্পন শুরু সময় (সেকেন্ড)",
  T_49_META_TYP_2508_I8_D: "পরবর্তী তরঙ্গ এবং পূর্ববর্তী তরঙ্গের মধ্যে সময়ের ব্যবধান",
  T_49_META_TYP_2509_I0_D: "প্রতিটি তরঙ্গে কতগুলি ইউনিট তৈরি হবে",
  T_49_META_TYP_2509_I1_D: "ইউনিট জেনারেটরের মোট কত তরঙ্গ উৎপন্ন হবে?",
  T_49_META_TYP_2509_I2_D: "বর্তমানে কোন তরঙ্গ উৎপন্ন হয়?",
  T_49_META_TYP_2509_I4_D: "প্রতিটি তরঙ্গ তৈরির জন্য কোন সত্তাটি টেমপ্লেট হিসেবে ব্যবহার করা হবে?",
  T_49_META_TYP_2509_I5_D: "ইউনিট স্পন সময়",
  T_49_META_TYP_2509_I6_D: "ক্রমাগত জেনারেট করতে হবে কিনা, কিন্তু একই স্ক্রিনে একটি সীমা থাকবে",
  T_49_META_TYP_2509_I7_D: "পরবর্তী তরঙ্গ এবং পূর্ববর্তী তরঙ্গের মধ্যে সময়ের ব্যবধান",
  T_49_META_TYP_2509_I8_D: "টেমপ্লেটের প্রিফ্যাবিড",
  T_49_META_TYP_2510_I0_D: "স্পন পয়েন্ট সংখ্যা",
  T_49_META_TYP_252_I1_D: "বাম আইকন",
  T_49_META_TYP_252_I2_D: "বাম টেক্সট",
  T_49_META_TYP_252_I3_D: "বাম স্কোর",
  T_49_META_TYP_252_I5_D: "ডান আইকন",
  T_49_META_TYP_252_I6_D: "ডান টেক্সট",
  T_49_META_TYP_252_I7_D: "ডান স্কোর",
  T_49_META_TYP_252_I8_D: "প্রগ্রেস [0,1]",
  T_49_META_TYP_253_I0_D: "আইকন নির্বাচন করুন",
  T_49_META_TYP_253_I1_D: "টেক্সট",
  T_49_META_TYP_253_I2_D: "প্রভাব সক্রিয়",
  T_49_META_TYP_253_I3_D: "UI অবস্থান",
  T_49_META_TYP_254_I1_D: "উদাহরণস্বরূপ, ১.২৫ মানে স্বাভাবিক গতির ১.২৫ গুণ।",
  T_49_META_TYP_254_I2_D: "কালার",
  T_49_META_TYP_256_I0_D: "সম্পূর্ণ স্থির। সবচেয়ে লাভজনক কর্মক্ষমতা",
  T_49_META_TYP_256_I1_D: "স্বাভাবিকভাবে বল প্রয়োগ করুন। সর্বাধিক কর্মক্ষমতা গ্রাসকারী",
  T_49_META_TYP_256_I2_D: "স্ক্রিপ্ট দ্বারা গতি নিয়ন্ত্রণ করা যেতে পারে, এবং ভরকে অসীম বলে বিবেচনা করা যেতে পারে",
  T_49_META_TYP_257_I0_D: "বিভিন্ন ধরণের অনমনীয় দেহের বিভিন্ন কাজ থাকে",
  T_49_META_TYP_257_I1_D: "গ্র্যাভিটি ব্যবহার করুন",
  T_49_META_TYP_257_I2_D: "ভর (কেজি), সর্বনিম্ন কার্যকর ভর 0.001 কেজি। যদি এটি 0 হয়, তাহলে এর অর্থ অসীম ভর এবং বল প্রয়োগের অধীনে এটি চলাচল করবে না।",
  T_49_META_TYP_257_I3_D: "মাধ্যাকর্ষণ কেন্দ্রের অবস্থান, স্থানীয় স্থানাঙ্ক ব্যবস্থা",
  T_49_META_TYP_257_I4_D: "অনমনীয় বস্তুর গতির রৈখিক বেগ",
  T_49_META_TYP_257_I5_D: "একটি অনমনীয় বস্তুর কৌণিক বেগ",
  T_49_META_TYP_257_I6_D: "রৈখিক গতির প্রাকৃতিক ক্ষয় সহগ। সহগ যত বড় হবে, চলাচলের গতি তত দ্রুত ক্ষয় হবে।",
  T_49_META_TYP_257_I7_D: "কৌণিক বেগের প্রাকৃতিক ক্ষয় সহগ। সহগ যত বড় হবে, চলাচলের গতি তত দ্রুত ক্ষয় হবে।",
  T_49_META_TYP_257_I8_D: "অনমনীয় শরীরের উপর আরোপিত সীমাবদ্ধতাগুলি হল RigidbodyConstrainType এর একটি সংগ্রহ",
  T_49_META_TYP_258_I0_D: "2017-10-10 13:38:10 ",
  T_49_META_TYP_258_I1_D: "13:45 ",
  T_49_META_TYP_258_I2_D: "10/10/2017 1:45 PM ",
  T_49_META_TYP_258_I3_D: "10/10/2017",
  T_49_META_TYP_259_I0_D: "পটভূমি",
  T_49_META_TYP_259_I1_D: "টেক্সট",
  T_49_META_TYP_259_I2_D: "UI অবস্থান",
  T_49_META_TYP_259_I4_D: "টেক্সটের রঙ",
  T_49_META_TYP_260_I0_D: "আইকন নির্বাচন করুন",
  T_49_META_TYP_260_I1_D: "প্রগতি বারের রঙ",
  T_49_META_TYP_260_I2_D: "মান",
  T_49_META_TYP_260_I3_D: "গতি, মি/সেকেন্ড",
  T_49_META_TYP_260_I4_D: "বিশেষ প্রভাব প্রদর্শন করা হবে কিনা",
  T_49_META_TYP_260_I5_D: "UI অবস্থান [0,1]",
  T_49_META_TYP_260_I6_D: "দক্ষতার প্রাথমিক অগ্রগতি, মান হল [0, 1]। UI তৈরি হওয়ার পরে, অগ্রগতি তাৎক্ষণিকভাবে বর্তমান অগ্রগতির সাথে সিঙ্ক্রোনাইজ করা হবে।",
  T_49_META_TYP_260_I7_D: "প্রভাবের রঙ",
  T_49_META_TYP_260_I8_D: "বস্তুর স্কেল মান সেট করুন",
  T_49_META_TYP_265_I1_D: "ব্যাকগ্রাউন্ড ফিলিং করা হবে কিনা",
  T_49_META_TYP_265_I2_D: "ব্যাকগ্রাউন্ড নাম",
  T_49_META_TYP_265_I3_D: "পটভূমির রঙ",
  T_49_META_TYP_265_I5_D: "বিজিআলফা",
  T_49_META_TYP_265_I6_D: "কাটার ধরণ",
  T_49_META_TYP_265_I7_D: "মাস্ক টাইপ হলো মাস্কিং করার সময় নির্বাচিত ছবির নাম।",
  T_49_META_TYP_265_I8_D: "এজ সফটনিং ইউনিট",
  T_49_META_TYP_267_I0_D: "স্ক্রলিং শুরুর বিন্দু, ডিফল্ট হল উপরের বাম কোণা",
  T_49_META_TYP_267_I1_D: "একাধিক স্ক্রোল দিকনির্দেশনা সমর্থন করে",
  T_49_META_TYP_267_I10_D: "অনুভূমিক বার",
  T_49_META_TYP_267_I11_D: "প্রদর্শনের অবস্থান",
  T_49_META_TYP_267_I2_D: "কম্পোনেন্টটিকে XY দিকে টেনে আনুন",
  T_49_META_TYP_267_I3_D: "একাধিক ড্র্যাগ প্রভাব সমর্থন করে",
  T_49_META_TYP_267_I4_D: "স্ক্রোল ফ্যাক্টর, মান যত বড় হবে, স্ক্রোলিং তত দ্রুত হবে",
  T_49_META_TYP_267_I5_D: "জড়তা গুণক, মান যত বড় হবে, ঘূর্ণায়মান অবস্থায় জড়তা তত বেশি হবে।",
  T_49_META_TYP_267_I6_D: "ডিফল্টরূপে নির্বাচিত, ড্র্যাগিং ভিউপোর্টে সীমাবদ্ধ কিনা",
  T_49_META_TYP_267_I7_D: "চেক করা হলে, ড্র্যাগিং ধীর গতিতে শুরু হবে, যদি চেক না করা হয়, তাহলে মাউসের গতিতে ড্র্যাগিং শুরু হবে।",
  T_49_META_TYP_267_I8_D: "যখন এটি ভিউপোর্টে ফিট করে, তখন টেনে বের করে আনুন",
  T_49_META_TYP_267_I9_D: "উল্লম্ব বার",
  T_49_META_TYP_268_I0_D: "ডিফল্ট",
  T_49_META_TYP_268_I1_D: "বন্ধ করুন",
  T_49_META_TYP_268_I2_D: "প্রদর্শন করুন",
  T_49_META_TYP_269_I0_D: "মালিক",
  T_49_META_TYP_269_I1_D: "আইডি সেট করুন",
  T_49_META_TYP_269_I2_D: "হেডড্রেস আইডি",
  T_49_META_TYP_269_I3_D: "ফেস আইডি",
  T_49_META_TYP_269_I4_D: "মেকআপ আইডি",
  T_49_META_TYP_269_I5_D: "উপরের অংশের আইডি",
  T_49_META_TYP_269_I6_D: "নিচের অংশের আইডি",
  T_49_META_TYP_269_I7_D: "জুতার আইডি",
  T_49_META_TYP_272_I0_D: "নারী",
  T_49_META_TYP_272_I1_D: "পুরুষ",
  T_49_META_TYP_273_I0_D: "ছোট মানচিত্রের কেন্দ্রের সাথে সম্পর্কিত বিশ্ব স্থানাঙ্ক",
  T_49_META_TYP_273_I1_D: "ছোট মানচিত্রের আকার, প্রস্থ এবং উচ্চতা একই",
  T_49_META_TYP_273_I2_D: "মিনিম্যাপ ডেপথ ম্যাপ ডিসপ্লে মোড সক্রিয় করা হবে কিনা",
  T_49_META_TYP_274_I1_D: "স্কেলিং",
  T_49_META_TYP_274_I4_D: "আইকন প্রদর্শন স্তর",
  T_49_META_TYP_275_I0_D: "হাড়ের স্কেলিং",
  T_49_META_TYP_275_I1_D: "হাড়ের নোডের বিশ্ব স্থানাঙ্ক",
  T_49_META_TYP_276_I0_D: "মাথা",
  T_49_META_TYP_276_I1_D: "বাম হাত",
  T_49_META_TYP_276_I2_D: "বাম হাতের তালু",
  T_49_META_TYP_276_I3_D: "ডান হাত",
  T_49_META_TYP_276_I4_D: "ডান হাতের তালু",
  T_49_META_TYP_276_I5_D: "ধড়",
  T_49_META_TYP_276_I6_D: "বাম পা",
  T_49_META_TYP_276_I7_D: "বাম পায়ের পাতার নিচে",
  T_49_META_TYP_276_I8_D: "ডান পা",
  T_49_META_TYP_276_I9_D: "ডান পায়ের পাতার নিচে",
  T_49_META_TYP_277_I1_D: "ক্যামেরা রশ্মি সনাক্তকরণের দূরত্ব",
  T_49_META_TYP_277_I2_D: "ক্যামেরা রশ্মি সনাক্তকরণের জন্য সংঘর্ষ স্তরের মুখোশ",
  T_49_META_TYP_277_I3_D: "বোতামের অবস্থান অফসেট",
  T_49_META_TYP_277_I4_D: "আইকন রিসোর্স আইডি",
  T_49_META_TYP_277_I5_D: "এলাকার আকারে ক্লিক করুন",
  T_49_META_TYP_277_I6_D: "লক্ষ্য বিন্দুতে বস্তুটি প্রদর্শন করা হবে কিনা",
  T_49_META_TYP_277_I7_D: "টার্গেট পয়েন্ট ডিসপ্লে অবজেক্ট",
  T_49_META_TYP_278_I0_D: "মানচিত্র পিক্সেল তৈরি করার লক্ষ্য সত্তা",
  T_49_META_TYP_28_I0_D: "এটা কি প্রতি রাউন্ডে রিসেট করা যাবে?",
  T_49_META_TYP_280_I0_D: "গোলকের ব্যাসার্ধ",
  T_49_META_TYP_281_I0_D: "ক্যাপসুলের উভয় প্রান্তে গোলার্ধের ব্যাসার্ধ",
  T_49_META_TYP_29_I0_D: "গোলক",
  T_49_META_TYP_29_I1_D: "আলো রশ্মি",
  T_49_META_TYP_29_I10_D: "শেষ রেখায় প্রবেশের সময় এখন পায়ের তলার হালকা কলামটি প্রতিক্রিয়া জানাতে ব্যবহৃত হয়।",
  T_49_META_TYP_29_I11_D: "জমে যাওয়া",
  T_49_META_TYP_29_I12_D: "আলো",
  T_49_META_TYP_29_I13_D: "উত্তরণ বাতাস",
  T_49_META_TYP_29_I14_D: "গ্যাস বিস্ফোরণ",
  T_49_META_TYP_29_I15_D: "লুকানো ব্যক্তি মারা গেছে",
  T_49_META_TYP_29_I16_D: "রঙ্গিন",
  T_49_META_TYP_29_I17_D: "কপির মৃত্য",
  T_49_META_TYP_29_I18_D: "গুলি প্রতিক্রিয়া",
  T_49_META_TYP_29_I19_D: "কপির মৃত্য",
  T_49_META_TYP_29_I2_D: "বিস্ফোরণ",
  T_49_META_TYP_29_I20_D: "কপির",
  T_49_META_TYP_29_I21_D: "পোর্টাল",
  T_49_META_TYP_29_I22_D: "ফ্ল্যাশব্যাংক ধোঁয়া",
  T_49_META_TYP_29_I23_D: "আগুনের বল",
  T_49_META_TYP_29_I24_D: "লুপে জ্বলন",
  T_49_META_TYP_29_I25_D: "বিষাক্ত গ্যাস",
  T_49_META_TYP_29_I26_D: "হৃদয়",
  T_49_META_TYP_29_I29_D: "দরজা",
  T_49_META_TYP_29_I30_D: "আতশবাজি",
  T_49_META_TYP_29_I31_D: "রানিং জুতো VFX",
  T_49_META_TYP_29_I32_D: "বিস্ফোরণ VFX",
  T_49_META_TYP_29_I33_D: "স্পন পয়েন্ট VFX",
  T_49_META_TYP_29_I34_D: "লেজার VFX",
  T_49_META_TYP_29_I35_D: "দক্ষতার মুক্তি VFX",
  T_49_META_TYP_29_I36_D: "বুলেট VFX",
  T_49_META_TYP_29_I37_D: "বুলেট আঘাত VFX",
  T_49_META_TYP_29_I38_D: "গুলি VFX",
  T_49_META_TYP_29_I39_D: "দক্ষতা VFX",
  T_49_META_TYP_29_I40_D: "হ্যালো",
  T_49_META_TYP_29_I41_D: "বুদ্বুদ",
  T_49_META_TYP_29_I42_D: "ধোঁয়া এবং ধূলা",
  T_49_META_TYP_29_I43_D: "উড়ন্ত কঙ্কাল",
  T_49_META_TYP_29_I44_D: "লাইন",
  T_49_META_TYP_29_I45_D: "ঝলকানি",
  T_49_META_TYP_29_I47_D: "উর্ধ্বমুখী কণাগুলি",
  T_49_META_TYP_29_I48_D: "ধোঁয়া",
  T_49_META_TYP_29_I49_D: "তাবিজ",
  T_49_META_TYP_29_I50_D: "জমে যাওয়া এলাকা",
  T_49_META_TYP_29_I51_D: "কুয়াশা",
  T_49_META_TYP_29_I52_D: "তুষারফ্লেক",
  T_49_META_TYP_29_I53_D: "আগুন",
  T_49_META_TYP_29_I54_D: "আলো রশ্মি",
  T_49_META_TYP_29_I55_D: "বিষাক্ত গ্যাস বিস্তার",
  T_49_META_TYP_29_I56_D: "বিষাক্ত গ্যাস",
  T_49_META_TYP_29_I57_D: "বিস্ফোরণ অগ্নি",
  T_49_META_TYP_29_I58_D: "আলো প্রভাব",
  T_49_META_TYP_29_I59_D: "তারা",
  T_49_META_TYP_29_I6_D: "তোমার পায়ের নিচে হ্যালো",
  T_49_META_TYP_29_I60_D: "জ্বলন্ত আগুন",
  T_49_META_TYP_29_I61_D: "জল ছিটানো",
  T_49_META_TYP_29_I62_D: "বিদ্যুৎ শক",
  T_49_META_TYP_29_I63_D: "স্যুভেনির VFX",
  T_49_META_TYP_29_I64_D: "ব্ল্যাকহোল VFX",
  T_49_META_TYP_29_I65_D: "ব্ল্যাকহোল বিস্ফোরণ VFX",
  T_49_META_TYP_29_I66_D: "ক্রিস্টাল বল VFX",
  T_49_META_TYP_29_I67_D: "লেজার বুলেটের বিশেষ প্রভাব",
  T_49_META_TYP_29_I68_D: "ট্রেইলিং এফেক্ট",
  T_49_META_TYP_29_I69_D: "ক্লাউড এফেক্টস",
  T_49_META_TYP_29_I7_D: "মাটির চিহ্ন",
  T_49_META_TYP_29_I8_D: "ধোঁয়া",
  T_49_META_TYP_29_I9_D: "তাবিজ বিস্ফোরণ",
  T_49_META_TYP_290_I0_D: "রিফ্রেশ ব্যবধান, সংখ্যাটি যত বড় হবে, রিফ্রেশ তত ধীর হবে, মিলিসেকেন্ডে",
  T_49_META_TYP_290_I1_D: "ডিবাগিং সক্ষম করবেন কিনা",
  T_49_META_TYP_291_I0_D: "শর্ত নোড",
  T_49_META_TYP_291_I1_D: "কার্যকলাপ নোড",
  T_49_META_TYP_293_I0_D: "বিহেভিয়ার ট্রি আইডি",
  T_49_META_TYP_293_I1_D: "অ্যাটাচ টার্গেট",
  T_49_META_TYP_294_I1_D: "লেআউটের ধরণ",
  T_49_META_TYP_294_I10_D: "সর্ট টাইপ",
  T_49_META_TYP_294_I2_D: "কনটেন্ট অরিজিন",
  T_49_META_TYP_294_I3_D: "ব্যবস্থার দিকনির্দেশনা",
  T_49_META_TYP_294_I4_D: "সাব-আইটেম গ্রিডের প্রস্থ এবং উচ্চতা",
  T_49_META_TYP_294_I5_D: "সেল স্পেস",
  T_49_META_TYP_294_I6_D: "কনস্ট্রেইন্ট",
  T_49_META_TYP_294_I7_D: "কনস্ট্রেইন্ট কাউন্ট",
  T_49_META_TYP_294_I8_D: "উল্লম্ব অফসেট",
  T_49_META_TYP_294_I9_D: "অনুভূমিক অফসেট",
  T_49_META_TYP_295_I2_D: "সময়কাল (s)",
  T_49_META_TYP_296_I1_D: "ক্লিপ দৈর্ঘ্য",
  T_49_META_TYP_297_I0_D: "আবদ্ধ বস্তু",
  T_49_META_TYP_297_I4_D: "রিসোর্স আইডি",
  T_49_META_TYP_298_I0_D: "ডিফল্ট",
  T_49_META_TYP_298_I2_D: "একবার",
  T_49_META_TYP_30_I0_D: "বর্গক্ষেত্র",
  T_49_META_TYP_30_I1_D: "চতুর্ভুজ",
  T_49_META_TYP_30_I10_D: "তীর",
  T_49_META_TYP_30_I11_D: "মন্তব্য",
  T_49_META_TYP_30_I12_D: "পাথর",
  T_49_META_TYP_30_I13_D: "কাঁচি",
  T_49_META_TYP_30_I14_D: "কাগজ",
  T_49_META_TYP_30_I15_D: "লাইক",
  T_49_META_TYP_30_I16_D: "সঠিক",
  T_49_META_TYP_30_I17_D: "ভুল",
  T_49_META_TYP_30_I18_D: "যোগ",
  T_49_META_TYP_30_I19_D: "বজ্রপাত",
  T_49_META_TYP_30_I2_D: "সোজা কোণ ট্রাপিজিয়াম",
  T_49_META_TYP_30_I20_D: "হৃদয়",
  T_49_META_TYP_30_I21_D: "তারকা",
  T_49_META_TYP_30_I22_D: "চাঁদ",
  T_49_META_TYP_30_I23_D: "সূর্য",
  T_49_META_TYP_30_I24_D: "চশমা",
  T_49_META_TYP_30_I25_D: "চাবি",
  T_49_META_TYP_30_I26_D: "ট্রফি",
  T_49_META_TYP_30_I27_D: "পতাকা",
  T_49_META_TYP_30_I28_D: "বালু ঘড়ি",
  T_49_META_TYP_30_I29_D: "ফোল্ডার",
  T_49_META_TYP_30_I3_D: "ট্রাপিজিয়াম",
  T_49_META_TYP_30_I30_D: "খোলা ফোল্ডার",
  T_49_META_TYP_30_I31_D: "বাড়ি",
  T_49_META_TYP_30_I32_D: "বিশ্রাম",
  T_49_META_TYP_30_I33_D: "রিফ্রেশ",
  T_49_META_TYP_30_I34_D: "লুপ",
  T_49_META_TYP_30_I35_D: "মাইক্রোস্কোপ",
  T_49_META_TYP_30_I36_D: "আবর্জনার বাক্স",
  T_49_META_TYP_30_I37_D: "ফিরে আসা",
  T_49_META_TYP_30_I38_D: "হীরক",
  T_49_META_TYP_30_I39_D: "সাঁতার কাটার রিং",
  T_49_META_TYP_30_I4_D: "ষড়ভুজ",
  T_49_META_TYP_30_I40_D: "টাকা",
  T_49_META_TYP_30_I41_D: "তালা",
  T_49_META_TYP_30_I42_D: "সেটিংস",
  T_49_META_TYP_30_I43_D: "প্রস্থান",
  T_49_META_TYP_30_I44_D: "সংলাপ",
  T_49_META_TYP_30_I45_D: "ক্রসহেয়ার",
  T_49_META_TYP_30_I46_D: "বন্দুক",
  T_49_META_TYP_30_I47_D: "তরবারি",
  T_49_META_TYP_30_I48_D: "বিস্ফোরণ",
  T_49_META_TYP_30_I49_D: "লক্ষ্য করা",
  T_49_META_TYP_30_I5_D: "গোলাকার",
  T_49_META_TYP_30_I50_D: "ক্রস",
  T_49_META_TYP_30_I51_D: "রক্ষা",
  T_49_META_TYP_30_I52_D: "দৈত্য",
  T_49_META_TYP_30_I53_D: "পুনর্ব্যবহার",
  T_49_META_TYP_30_I54_D: "উপহার",
  T_49_META_TYP_30_I55_D: "কাপড়",
  T_49_META_TYP_30_I56_D: "খেলা",
  T_49_META_TYP_30_I57_D: "অবস্থান",
  T_49_META_TYP_30_I58_D: "দোকান",
  T_49_META_TYP_30_I59_D: "প্রস্থান",
  T_49_META_TYP_30_I6_D: "ত্রিভুজ",
  T_49_META_TYP_30_I60_D: "সতর্কতা",
  T_49_META_TYP_30_I61_D: "পাঠ্য",
  T_49_META_TYP_30_I62_D: "টাইমার অবজেক্ট",
  T_49_META_TYP_30_I63_D: "ঘণ্টা",
  T_49_META_TYP_30_I64_D: "পোষা প্রাণী",
  T_49_META_TYP_30_I65_D: "বোমা",
  T_49_META_TYP_30_I66_D: "মেরামত",
  T_49_META_TYP_30_I67_D: "হাস্যোজ্জ্বল মুখ",
  T_49_META_TYP_30_I68_D: "স্পিকার",
  T_49_META_TYP_30_I7_D: "বিস্ময়বোধক চিহ্ন",
  T_49_META_TYP_30_I70_D: "মুকুট",
  T_49_META_TYP_30_I71_D: "যুদ্ধ",
  T_49_META_TYP_30_I72_D: "গিল্ড",
  T_49_META_TYP_30_I73_D: "হৃদস্পন্দন",
  T_49_META_TYP_30_I74_D: "সঙ্গীত",
  T_49_META_TYP_30_I75_D: "যানবাহন",
  T_49_META_TYP_30_I76_D: "মেলি অস্ত্র",
  T_49_META_TYP_30_I77_D: "পিস্তল",
  T_49_META_TYP_30_I78_D: "রাইফেল",
  T_49_META_TYP_30_I79_D: "স্নাইপার রাইফেল",
  T_49_META_TYP_30_I8_D: "প্রশ্নবোধক চিহ্ন",
  T_49_META_TYP_30_I80_D: "শর্টগান",
  T_49_META_TYP_30_I81_D: "SMG",
  T_49_META_TYP_30_I82_D: "হিলিং গান",
  T_49_META_TYP_30_I83_D: "আর্মর ভাঙ্গা",
  T_49_META_TYP_30_I84_D: "হেডশট",
  T_49_META_TYP_30_I85_D: "দক্ষতা ১",
  T_49_META_TYP_30_I86_D: "দক্ষতা ২",
  T_49_META_TYP_30_I87_D: "দক্ষতা ৩",
  T_49_META_TYP_30_I88_D: "দক্ষতা ৪",
  T_49_META_TYP_30_I89_D: "দক্ষতা ৫",
  T_49_META_TYP_30_I9_D: "চিহ্ন",
  T_49_META_TYP_30_I90_D: "দক্ষতা ৬",
  T_49_META_TYP_30_I91_D: "দক্ষতা ৭",
  T_49_META_TYP_30_I92_D: "দক্ষতা ৮",
  T_49_META_TYP_30_I93_D: "দক্ষতা ৯",
  T_49_META_TYP_30_I94_D: "দক্ষতা ১০",
  T_49_META_TYP_300_I0_D: "রিসোর্স আইডি",
  T_49_META_TYP_300_I2_D: "ঘূর্ণন",
  T_49_META_TYP_300_I3_D: "তৈরি করা সত্তা",
  T_49_META_TYP_301_I1_D: "আত্ম-বিস্ফোরণ",
  T_49_META_TYP_301_I2_D: "ড্যাশ অ্যাটাক",
  T_49_META_TYP_301_I3_D: "শক ওয়েভ",
  T_49_META_TYP_301_I4_D: "বাতাসের আক্রমণ",
  T_49_META_TYP_301_I5_D: "লাফানোর আক্রমণ",
  T_49_META_TYP_301_I6_D: "ঢাল উপরে",
  T_49_META_TYP_301_I7_D: "ঢাল ভাঙা",
  T_49_META_TYP_302_I5_D: "ব্যাগ",
  T_49_META_TYP_302_I7_D: "স্কেটবোর্ড, ছদ্মবেশ...",
  T_49_META_TYP_303_I0_D: "ম্যাক্স. প্লেয়ার HP যোগ করুন",
  T_49_META_TYP_303_I1_D: "প্লেয়ার HP ক্রমাগত রিস্টোর করুন",
  T_49_META_TYP_305_I0_D: "সম্পন্ন",
  T_49_META_TYP_305_I1_D: "চলমান",
  T_49_META_TYP_307_I0_D: "প্রতি ক্ষতিতে EXP",
  T_49_META_TYP_307_I1_D: "প্রতি চলাচল মাইলে EXP",
  T_49_META_TYP_307_I2_D: "প্রতি সেকেন্ডে EXP",
  T_49_META_TYP_307_I3_D: "চিপ অভিজ্ঞতা",
  T_49_META_TYP_307_I4_D: "সর্বাধিক চার্জ",
  T_49_META_TYP_308_I0_D: "জেল মেকার",
  T_49_META_TYP_31_I0_D: "গ্রেনেড বিস্ফোরণ",
  T_49_META_TYP_31_I1_D: "বন্দুকের গুলি",
  T_49_META_TYP_31_I10_D: "আঘাতের ফলে ক্ষতি হওয়া শব্দের প্রভাব",
  T_49_META_TYP_31_I11_D: "আপগ্রেড করা সাউন্ড এফেক্টস",
  T_49_META_TYP_31_I12_D: "দুর্বল ক্লিক সাউন্ড এফেক্ট",
  T_49_META_TYP_31_I13_D: "প্লেয়ারের মেকানিজম সাউন্ড এফেক্টের উপর পদক্ষেপ",
  T_49_META_TYP_31_I14_D: "সরঞ্জাম মেরামতের শব্দ প্রভাব",
  T_49_META_TYP_31_I15_D: "সরঞ্জাম মেরামতের শব্দ প্রভাব",
  T_49_META_TYP_31_I16_D: "ত্রুটিপূর্ণ বা অনুপস্থিত শব্দ প্রভাব",
  T_49_META_TYP_31_I17_D: "রিমাইন্ডার সাউন্ড এফেক্ট",
  T_49_META_TYP_31_I18_D: "ফুটবল অবতরণের শব্দ প্রভাব",
  T_49_META_TYP_31_I19_D: "চিয়ার সাউন্ড এফেক্ট",
  T_49_META_TYP_31_I2_D: "কাউন্টডাউন বি",
  T_49_META_TYP_31_I20_D: "বোমা সতর্কীকরণ শব্দ প্রভাব",
  T_49_META_TYP_31_I21_D: "বোমা বিস্ফোরণের শব্দ প্রভাব",
  T_49_META_TYP_31_I22_D: "হান্টার শব্দের প্রভাব দেখাচ্ছে",
  T_49_META_TYP_31_I23_D: "ফাইনাল বিজিএম সাউন্ড এফেক্ট",
  T_49_META_TYP_31_I24_D: "সাপ্লাই বক্স রিফ্রেশ সাউন্ড এফেক্ট",
  T_49_META_TYP_31_I25_D: "অ্যাক্সিলারেটরের শব্দ প্রভাব",
  T_49_META_TYP_31_I26_D: "অন্তর্ধানের অনুস্মারক শব্দ প্রভাব",
  T_49_META_TYP_31_I27_D: "ভিজ্যুয়াল এফেক্টস সাউন্ড এফেক্টস",
  T_49_META_TYP_31_I28_D: "রাতের পোকামাকড়ের শব্দ প্রভাব",
  T_49_META_TYP_31_I29_D: "নিস্তেজ আঘাতের শব্দ প্রভাব",
  T_49_META_TYP_31_I3_D: "ইউআই ট্যাপ",
  T_49_META_TYP_31_I30_D: "প্রতিক্রিয়াশীল শব্দ প্রভাব",
  T_49_META_TYP_31_I31_D: "আশ্চর্যজনক শব্দ প্রভাব আবিষ্কার করুন",
  T_49_META_TYP_31_I32_D: "ছোট্ট ভূত শব্দের প্রভাব বাজাচ্ছে",
  T_49_META_TYP_31_I33_D: "ফেজ শুরুর শব্দ প্রভাব",
  T_49_META_TYP_31_I34_D: "জম্বি সাউন্ড এফেক্টস",
  T_49_META_TYP_31_I35_D: "ভৌতিক শব্দ প্রভাব",
  T_49_META_TYP_31_I36_D: "রূপান্তরের শব্দ প্রভাব",
  T_49_META_TYP_31_I37_D: "দ্রুত হৃদস্পন্দনের শব্দ প্রভাব",
  T_49_META_TYP_31_I38_D: "মাঝারি গতির হৃদস্পন্দনের শব্দ প্রভাব",
  T_49_META_TYP_31_I39_D: "ধীর হৃদস্পন্দনের শব্দ প্রভাব",
  T_49_META_TYP_31_I4_D: "আঘাতে মহিলা চিৎকার",
  T_49_META_TYP_31_I40_D: "রাগের শব্দ প্রভাব",
  T_49_META_TYP_31_I41_D: "ক্লিক সাউন্ড এফেক্ট",
  T_49_META_TYP_31_I42_D: "দক্ষতা পুনরুদ্ধারের শব্দ প্রভাব",
  T_49_META_TYP_31_I43_D: "গেমের সাউন্ড এফেক্ট যোগ করা হয়েছে",
  T_49_META_TYP_31_I44_D: "যান্ত্রিক প্রতিধ্বনি শব্দ প্রভাব",
  T_49_META_TYP_31_I45_D: "মশার শব্দের প্রভাব",
  T_49_META_TYP_31_I46_D: "নিবিড় ডিং ডিং ডিং ১ শব্দ প্রভাব",
  T_49_META_TYP_31_I47_D: "ইনটেনসিভ ডিং ডিং ডিং ২ সাউন্ড এফেক্টস",
  T_49_META_TYP_31_I48_D: "মেকানিজম খোলার শব্দ প্রভাব",
  T_49_META_TYP_31_I49_D: "চার্জিং সাউন্ড এফেক্ট ১",
  T_49_META_TYP_31_I5_D: "আঘাতে পুরুষ চিৎকার",
  T_49_META_TYP_31_I50_D: "পদধ্বনি প্রম্পট শব্দ প্রভাব",
  T_49_META_TYP_31_I51_D: "মিশন সাকসেস প্রম্পট ১ সাউন্ড এফেক্ট",
  T_49_META_TYP_31_I52_D: "বিপদ সতর্কীকরণ শব্দ ১ শব্দ প্রভাব",
  T_49_META_TYP_31_I53_D: "বিপদ সতর্কীকরণ শব্দ ২ শব্দ প্রভাব",
  T_49_META_TYP_31_I54_D: "কাউন্টডাউন ৩ সাউন্ড এফেক্ট",
  T_49_META_TYP_31_I55_D: "টিপস সাউন্ড এফেক্ট দেখান",
  T_49_META_TYP_31_I56_D: "কাকের ডাকের পরিবেষ্টিত শব্দের প্রভাব",
  T_49_META_TYP_31_I57_D: "টেলিপোর্টার ব্যবহার করে ভুল এলাকায় টেলিপোর্ট করার শব্দ প্রভাব",
  T_49_META_TYP_31_I58_D: "টেলিপোর্ট পয়েন্ট ব্যবহার করে সঠিক এলাকায় টেলিপোর্ট করার শব্দ প্রভাব",
  T_49_META_TYP_31_I59_D: "শব্দ প্রেরণ করুন",
  T_49_META_TYP_31_I6_D: "সোনার কয়েন তোলার শব্দ প্রভাব",
  T_49_META_TYP_31_I60_D: "বৈদ্যুতিক শক শব্দ প্রভাব",
  T_49_META_TYP_31_I61_D: "প্রপ সাউন্ড এফেক্ট পান",
  T_49_META_TYP_31_I62_D: "ইলেকট্রনিক স্বপ্নময় সুন্দর ব্যাকগ্রাউন্ড মিউজিক সাউন্ড এফেক্ট",
  T_49_META_TYP_31_I63_D: "নৈমিত্তিক গেমের ব্যাকগ্রাউন্ড মিউজিক সাউন্ড এফেক্ট",
  T_49_META_TYP_31_I64_D: "বাক্স খোলা",
  T_49_META_TYP_31_I65_D: "র‍্যাঙ্ক আপ",
  T_49_META_TYP_31_I66_D: "সর্বাধিক স্তর",
  T_49_META_TYP_31_I67_D: "ট্যাপ বোতাম",
  T_49_META_TYP_31_I68_D: "কাউন্টডাউন",
  T_49_META_TYP_31_I69_D: "শত্রু পরাজিত",
  T_49_META_TYP_31_I7_D: "দৌড়ে শেষ রেখা অতিক্রম করার জন্য ট্রিগার সাউন্ড এফেক্ট",
  T_49_META_TYP_31_I70_D: "শেষ",
  T_49_META_TYP_31_I71_D: "এগিয়ে যান",
  T_49_META_TYP_31_I72_D: "বিজয়",
  T_49_META_TYP_31_I73_D: "প্রশিক্ষণ বেস চেকপয়েন্ট",
  T_49_META_TYP_31_I74_D: "কাউন্টডাউন",
  T_49_META_TYP_31_I75_D: "খেলা শুরু",
  T_49_META_TYP_31_I76_D: "বড় সোনার প্রাপ্তি",
  T_49_META_TYP_31_I77_D: "মাঝারি সোনার প্রাপ্তি",
  T_49_META_TYP_31_I78_D: "ছোট সোনার প্রাপ্তি",
  T_49_META_TYP_31_I79_D: "যুদ্ধের মধ্যে যোগদান",
  T_49_META_TYP_31_I8_D: "ট্রিগার সাউন্ড এফেক্ট",
  T_49_META_TYP_31_I80_D: "গিল্ড সরবরাহ",
  T_49_META_TYP_31_I81_D: "স্পিকার",
  T_49_META_TYP_31_I82_D: "গিল্ড নেতা অপসারণ",
  T_49_META_TYP_31_I83_D: "গুদাম সংরক্ষণ",
  T_49_META_TYP_31_I84_D: "বিশেষ বন্দুকের শব্দ",
  T_49_META_TYP_31_I85_D: "বুলেটের আঘাত",
  T_49_META_TYP_31_I86_D: "সরানো",
  T_49_META_TYP_31_I87_D: "ট্যাপ নিষ্ক্রিয় বোতাম",
  T_49_META_TYP_31_I88_D: "দক্ষতা চার্জ সম্পন্ন",
  T_49_META_TYP_31_I89_D: "লেজার দক্ষতা",
  T_49_META_TYP_31_I9_D: "অবনমিত শব্দ প্রভাব",
  T_49_META_TYP_31_I90_D: "ভোক্তা ২ প্রাপ্তি",
  T_49_META_TYP_31_I91_D: "কাউন্টডাউন ৩",
  T_49_META_TYP_31_I92_D: "গেম ওভার ২",
  T_49_META_TYP_31_I93_D: "হত্যা সতর্কতা",
  T_49_META_TYP_31_I94_D: "বিস্ফোরণ",
  T_49_META_TYP_31_I95_D: "এনার্জি অরব দক্ষতা",
  T_49_META_TYP_31_I96_D: "ব্লাড পুল দক্ষতা",
  T_49_META_TYP_311_I1_D: "সর্বাধিক ক্ষতি",
  T_49_META_TYP_311_I3_D: "হাত থেকে বের হওয়ার পর নিক্ষিপ্ত বস্তুর উড়ানের গতি, m/s এ",
  T_49_META_TYP_311_I4_D: "নিক্ষিপ্ত বস্তুটি মুক্তি পাওয়ার পর থেকে কার্যকর হওয়ার সময় পর্যন্ত সময়ের ব্যবধান, সেকেন্ডে",
  T_49_META_TYP_313_I0_D: "জোনের ব্যাসার্ধ",
  T_49_META_TYP_313_I1_D: "কাউন্টার জোনের সময়কাল, সেকেন্ডে",
  T_49_META_TYP_314_I0_D: "অ্যানিমেশন কন্ট্রোলার রিসোর্স আইডি",
  T_49_META_TYP_314_I1_D: "অ্যানিমেশন কন্ট্রোলার",
  T_49_META_TYP_315_I0_D: "ব্যাকপ্যাকের মালিক",
  T_49_META_TYP_315_I1_D: "ব্যাকপ্যাকের জায়গা",
  T_49_META_TYP_315_I2_D: "ব্যবহৃত ক্যাপাসিটি",
  T_49_META_TYP_315_I3_D: "সকল সাপ্লাই",
  T_49_META_TYP_316_I0_D: "টেক্সচার রিসোর্স",
  T_49_META_TYP_316_I1_D: "শেডার নাম",
  T_49_META_TYP_316_I11_D: "উল্টানোর পদ্ধতি",
  T_49_META_TYP_316_I2_D: "UV অফসেট",
  T_49_META_TYP_316_I3_D: "UV সাইজ",
  T_49_META_TYP_316_I4_D: "পূরণের প্রকার",
  T_49_META_TYP_316_I5_D: "বর্ডার বাম ডান",
  T_49_META_TYP_316_I6_D: "বর্ডার উপরের নীচের",
  T_49_META_TYP_317_I0_D: "কোনোটাই নয়",
  T_49_META_TYP_317_I1_D: "ফ্রিজ পজিশন X",
  T_49_META_TYP_317_I2_D: "ফ্রিজ পজিশন Y",
  T_49_META_TYP_317_I3_D: "ফ্রিজ পজিশন Z",
  T_49_META_TYP_317_I4_D: "X অক্ষের চারপাশে ঘূর্ণন সীমিত করুন",
  T_49_META_TYP_317_I5_D: "Y অক্ষের চারপাশে ঘূর্ণন সীমিত করুন",
  T_49_META_TYP_317_I6_D: "Z অক্ষের চারপাশে ঘূর্ণন সীমিত করুন",
  T_49_META_TYP_317_I7_D: "ফ্রিজ পজিশন",
  T_49_META_TYP_317_I8_D: "ফ্রিজ রোটেশন",
  T_49_META_TYP_317_I9_D: "সবকিছু ফ্রিজ করুন",
  T_49_META_TYP_318_I0_D: "পরিসর",
  T_49_META_TYP_318_I1_D: "পূর্ণ ক্ষতির দূরত্ব",
  T_49_META_TYP_318_I10_D: "খেলোয়াড়ের লক্ষ্যগত গতি গুণক",
  T_49_META_TYP_318_I11_D: "দৃষ্টির প্রশস্ততার গুণক",
  T_49_META_TYP_318_I12_D: "FOV বৃদ্ধি",
  T_49_META_TYP_318_I13_D: "ADS বৃদ্ধির হার",
  T_49_META_TYP_318_I14_D: "ADS বৃদ্ধির সময় (সেকেন্ড)",
  T_49_META_TYP_318_I15_D: "ADS পুনরুদ্ধারের সময় (সেকেন্ড)",
  T_49_META_TYP_318_I16_D: "সুযোগের জন্য ন্যূনতম ক্ষতি দূরত্ব সংশোধন ফ্যাক্টর",
  T_49_META_TYP_318_I17_D: "ADS লক্ষ্য সহায়তা অনুমোদন করুন",
  T_49_META_TYP_318_I18_D: "লক্ষ্য সহায়তা ক্রসহেয়ারের স্ক্রীন আকর্ষণ অনুপাত (0-1)",
  T_49_META_TYP_318_I19_D: "লক্ষ্য সহায়তার দূরত্ব ক্ষয় সহগ (0-1)",
  T_49_META_TYP_318_I2_D: "ন্যূনতম ক্ষতি দূরত্ব",
  T_49_META_TYP_318_I20_D: "লক্ষ্য সহায়তার দূরত্ব প্রথমে অনুমোদন করুন",
  T_49_META_TYP_318_I21_D: "লক্ষ্য সহায়তার জন্য সর্বনিম্ন দূরত্ব অগ্রাধিকার",
  T_49_META_TYP_318_I22_D: "লক্ষ্য সহায়তার জন্য সর্বাধিক দূরত্ব অগ্রাধিকার",
  T_49_META_TYP_318_I23_D: "লক্ষ্য সহায়তার দূরত্ব প্রভাব সহগ (>=1)",
  T_49_META_TYP_318_I24_D: "ADS ঘূর্ণন সংবেদনশীলতা",
  T_49_META_TYP_318_I25_D: "একত্রীকরণের হার",
  T_49_META_TYP_318_I3_D: "গোলাবারুদের আকার",
  T_49_META_TYP_318_I4_D: "আক্রমণের সময়সীমা",
  T_49_META_TYP_318_I5_D: "পুনরায় লোডের গতি",
  T_49_META_TYP_318_I6_D: "স্বয়ংক্রিয় পুনরায় লোডের গতি",
  T_49_META_TYP_318_I7_D: "স্ক্যাটার গতি",
  T_49_META_TYP_318_I8_D: "শুয়ে থাকা বা শুয়ে থাকার সময় ছড়িয়ে পড়ার হার। প্রতি 0.1 এর অর্থ হল প্রতিটি বুলেটের জন্য ক্রসহেয়ার রেঞ্জ 10% বৃদ্ধি পায়।",
  T_49_META_TYP_318_I9_D: "সর্বাধিক স্ক্যাটার",
  T_49_META_TYP_319_I0_D: "সহজ",
  T_49_META_TYP_319_I1_D: "স্লাইসড",
  T_49_META_TYP_319_I2_D: "টাইল্ড",
  T_49_META_TYP_319_I3_D: "পূর্ণ",
  T_49_META_TYP_319_I4_D: "ফিট",
  T_49_META_TYP_32_I0_D: "খেলোয়াড়টি স্বাভাবিক সক্রিয় অবস্থায় আছে।",
  T_49_META_TYP_32_I1_D: "খেলোয়াড়টি ছিটকে পড়েছে।",
  T_49_META_TYP_32_I2_D: "খেলোয়াড়টি মৃত অবস্থায় আছে।",
  T_49_META_TYP_320_I0_D: "অনুভূমিক",
  T_49_META_TYP_320_I1_D: "উল্লম্ব",
  T_49_META_TYP_320_I2_D: "রেডিয়াল 90°",
  T_49_META_TYP_320_I3_D: "রেডিয়াল 180°",
  T_49_META_TYP_320_I4_D: "রেডিয়াল 360°",
  T_49_META_TYP_321_I0_D: "লক্ষ্য সহায়তা ট্রিগার করার সর্বোচ্চ দূরত্ব",
  T_49_META_TYP_321_I1_D: "অ্যাসিস্টেড অ্যাশাইং ট্রিগার হলে ক্রসহেয়ার অফসেট হয়। যদি অফসেট পয়েন্টটি সত্তায় না থাকে, তাহলে অ্যাসিস্টেড অ্যাশাইং ব্যর্থ হবে।",
  T_49_META_TYP_322_I0_D: "কেউ না",
  T_49_META_TYP_322_I1_D: "মাথা",
  T_49_META_TYP_322_I2_D: "দেহ",
  T_49_META_TYP_322_I3_D: "অঙ্গ",
  T_49_META_TYP_323_I0_D: "স্কেল",
  T_49_META_TYP_323_I1_D: "অ্যাকাউন্ট আইডি",
  T_49_META_TYP_323_I2_D: "খেলোয়াড়ের প্রোফাইল তথ্য",
  T_49_META_TYP_323_I3_D: "স্টাইল",
  T_49_META_TYP_323_I4_D: "র‌্যাংক দেখান",
  T_49_META_TYP_323_I5_D: "পিন দেখান",
  T_49_META_TYP_323_I6_D: "নিকনেম দেখান",
  T_49_META_TYP_324_I0_D: "নির্দিষ্ট মাত্রার বল উৎপন্ন করে",
  T_49_META_TYP_324_I1_D: "নির্দিষ্ট মাত্রার ত্বরণ উৎপন্ন করে",
  T_49_META_TYP_324_I2_D: "একটি নির্দিষ্ট আকারের একটি আবেগ উৎপন্ন করে",
  T_49_META_TYP_324_I3_D: "নির্দিষ্ট আকারের গতি তৈরি করে",
  T_49_META_TYP_326_I0_D: "অ্যাকাউন্ট আইডি",
  T_49_META_TYP_326_I1_D: "অ্যাভাটার আইডি",
  T_49_META_TYP_326_I2_D: "ব্যানার আইডি",
  T_49_META_TYP_326_I3_D: "পিন আইডি",
  T_49_META_TYP_326_I4_D: "খেলোয়াড়ের ডাকনাম",
  T_49_META_TYP_326_I5_D: "BR র‌্যাংক",
  T_49_META_TYP_326_I6_D: "সর্বোচ্চ BR র‌্যাংক",
  T_49_META_TYP_326_I7_D: "CS র‌্যাংক",
  T_49_META_TYP_326_I8_D: "সর্বোচ্চ CS র‌্যাংক",
  T_49_META_TYP_327_I0_D: "রিসোর্স আইডি",
  T_49_META_TYP_327_I1_D: "পার্ট মাস্ক 1",
  T_49_META_TYP_327_I2_D: "পার্ট মাস্ক 2",
  T_49_META_TYP_327_I3_D: "পার্ট মাস্ক 3",
  T_49_META_TYP_327_I4_D: "পার্ট মাস্ক 4",
  T_49_META_TYP_329_I0_D: "চালক",
  T_49_META_TYP_329_I1_D: "যাত্রী A",
  T_49_META_TYP_329_I2_D: "যাত্রী B",
  T_49_META_TYP_329_I3_D: "যাত্রী C",
  T_49_META_TYP_33_I0_D: "ঊর্ধ্বমুখী ক্রমে, শূন্য মান উপেক্ষা করা হয় এবং শেষে সাজানো হয়।",
  T_49_META_TYP_33_I1_D: "ছোট থেকে বড়, অবরোহী",
  T_49_META_TYP_33_I2_D: "ঊর্ধ্বমুখী, ছোট থেকে বড়",
  T_49_META_TYP_330_I4_D: "অজেয়তার প্রভাবের সময়কাল (একক: গুলি)",
  T_49_META_TYP_330_I5_D: "নিয়ন্ত্রণ পয়েন্ট",
  T_49_META_TYP_330_I8_D: "ডেল্টা মান",
  T_49_META_TYP_332_I0_D: "প্রারম্ভিক অবস্থান",
  T_49_META_TYP_333_I0_D: "এফজেডলানটিংহেই",
  T_49_META_TYP_333_I1_D: "সরল আরবী",
  T_49_META_TYP_333_I2_D: "নোটো নাস্তালিক উর্দু",
  T_49_META_TYP_333_I3_D: "জিএফএফ ল্যাটিন",
  T_49_META_TYP_333_I4_D: "এজেন্সি এফবি",
  T_49_META_TYP_333_I5_D: "সুপারমার্কেট",
  T_49_META_TYP_333_I6_D: "হিন্দ সিলিগুড়ি ",
  T_49_META_TYP_335_I0_D: "রিসোর্স পাথ, ডিফল্টরূপে খালি",
  T_49_META_TYP_335_I1_D: "প্লে সংখ্যা, ডিফল্ট হল ১",
  T_49_META_TYP_335_I2_D: "ভলিউম, ডিফল্ট ৫০",
  T_49_META_TYP_335_I3_D: "সর্বাধিক দূরত্ব",
  T_49_META_TYP_335_I4_D: "ন্যূনতম দূরত্ব",
  T_49_META_TYP_335_I5_D: "এটা কি 3D সঙ্গীত?",
  T_49_META_TYP_335_I6_D: "অগ্রাধিকার",
  T_49_META_TYP_335_I7_D: "শুরু করার আগে অপেক্ষার সময়, সেকেন্ডে",
  T_49_META_TYP_335_I8_D: "প্লেয়িং অবস্থায় আছে",
  T_49_META_TYP_338_I0_D: "মোবাইল স্ট্যাটাস",
  T_49_META_TYP_338_I1_D: "স্প্রিন্ট স্ট্যাটাস",
  T_49_META_TYP_338_I2_D: "আক্রমণের অবস্থা",
  T_49_META_TYP_338_I3_D: "লাফানোর অবস্থা",
  T_49_META_TYP_338_I4_D: "আরোহণের অবস্থা",
  T_49_META_TYP_338_I5_D: "গাড়ি (চালক) প্রবেশ করুন",
  T_49_META_TYP_338_I6_D: "গাড়িতে প্রবেশ করা (যাত্রী)",
  T_49_META_TYP_338_I7_D: "যানবাহন থেকে বেরিয়ে আসুন",
  T_49_META_TYP_338_I8_D: "ড্রাইভ",
  T_49_META_TYP_339_I0_D: "অঙ্গ ক্ষতির অনুপাত",
  T_49_META_TYP_339_I1_D: "মাথার ক্ষতির অনুপাত",
  T_49_META_TYP_339_I2_D: "সর্বাধিক স্থায়িত্ব অনুপাত",
  T_49_META_TYP_339_I3_D: "অতিরিক্ত HP অনুপাত",
  T_49_META_TYP_339_I4_D: "অতিরিক্ত বিস্ফোরণ ক্ষতি হ্রাস ফ্যাক্টর (%)",
  T_49_META_TYP_339_I5_D: "অতিরিক্ত ব্যাকপ্যাক ক্ষমতা",
  T_49_META_TYP_339_I6_D: "প্রতিস্থাপনের অগ্রাধিকার",
  T_49_META_TYP_34_I0_D: "ডিফল্ট মুষ্টি",
  T_49_META_TYP_34_I1_D: "Kar98K",
  T_49_META_TYP_34_I10_D: "AWM2",
  T_49_META_TYP_34_I100_D: "ফামাস-১",
  T_49_META_TYP_34_I101_D: "গ্রোজা-এক্স",
  T_49_META_TYP_34_I102_D: "এসভিডি-ওয়াই",
  T_49_META_TYP_34_I103_D: "G36",
  T_49_META_TYP_34_I104_D: "M24",
  T_49_META_TYP_34_I105_D: "M4A1-I সম্পর্কে",
  T_49_META_TYP_34_I106_D: "M4A1-II সম্পর্কে",
  T_49_META_TYP_34_I107_D: "M4A1-III সম্পর্কে",
  T_49_META_TYP_34_I108_D: "M4A1-III সম্পর্কে",
  T_49_META_TYP_34_I109_D: "চার্জড শটগান",
  T_49_META_TYP_34_I11_D: "M1014",
  T_49_META_TYP_34_I110_D: "MAC10",
  T_49_META_TYP_34_I111_D: "হাত কামান",
  T_49_META_TYP_34_I112_D: "IceGun",
  T_49_META_TYP_34_I113_D: "ঢাল বন্দুক",
  T_49_META_TYP_34_I114_D: "MP5-II সম্পর্কে",
  T_49_META_TYP_34_I115_D: "MP5-III সম্পর্কে",
  T_49_META_TYP_34_I116_D: "MP5-III সম্পর্কে",
  T_49_META_TYP_34_I117_D: "M60-II সম্পর্কে",
  T_49_META_TYP_34_I118_D: "এম৬০-তৃতীয়",
  T_49_META_TYP_34_I119_D: "এম৬০-তৃতীয়",
  T_49_META_TYP_34_I12_D: "M10142",
  T_49_META_TYP_34_I120_D: "ভিএসএস-II",
  T_49_META_TYP_34_I121_D: "ভিএসএস-III",
  T_49_META_TYP_34_I122_D: "M14-II সম্পর্কে",
  T_49_META_TYP_34_I123_D: "এম১৪-তৃতীয়",
  T_49_META_TYP_34_I124_D: "এম১৪-তৃতীয়",
  T_49_META_TYP_34_I125_D: "Kar98K-II সম্পর্কে",
  T_49_META_TYP_34_I126_D: "Kar98K-III সম্পর্কে",
  T_49_META_TYP_34_I127_D: "Kar98K-III সম্পর্কে",
  T_49_META_TYP_34_I128_D: "ফামাস-২",
  T_49_META_TYP_34_I129_D: "ফামাস-III",
  T_49_META_TYP_34_I13_D: "শিখা গ্রেনেড",
  T_49_META_TYP_34_I133_D: "ফ্ল্যাশব্যাং",
  T_49_META_TYP_34_I134_D: "ধোঁয়া গ্রেনেড",
  T_49_META_TYP_34_I135_D: "জমে যাওয়া গ্রেনেড",
  T_49_META_TYP_34_I136_D: "বুলেটপ্রুফ ভেস্ট Lv1",
  T_49_META_TYP_34_I137_D: "বুলেটপ্রুফ ভেস্ট Lv2",
  T_49_META_TYP_34_I138_D: "বুলেটপ্রুফ ভেস্ট Lv3",
  T_49_META_TYP_34_I139_D: "হেলমেট Lv1",
  T_49_META_TYP_34_I14_D: "AK",
  T_49_META_TYP_34_I140_D: "হেলমেট Lv2",
  T_49_META_TYP_34_I141_D: "হেলমেট Lv3",
  T_49_META_TYP_34_I142_D: "বিস্ফোরণ-প্রমাণ বর্ম",
  T_49_META_TYP_34_I143_D: "ব্যাকপ্যাক Lv1",
  T_49_META_TYP_34_I144_D: "ব্যাকপ্যাক Lv2",
  T_49_META_TYP_34_I145_D: "ব্যাকপ্যাক Lv3",
  T_49_META_TYP_34_I146_D: "মুখবন্ধ Lv1",
  T_49_META_TYP_34_I147_D: "মুখবন্ধ Lv2",
  T_49_META_TYP_34_I148_D: "মুখবন্ধ Lv3",
  T_49_META_TYP_34_I149_D: "মাফলার",
  T_49_META_TYP_34_I15_D: "AK2",
  T_49_META_TYP_34_I150_D: "আক্রমণ মুখবন্ধন",
  T_49_META_TYP_34_I151_D: "প্রশস্ত মুখবন্ধ",
  T_49_META_TYP_34_I152_D: "ম্যাগাজিন Lv1",
  T_49_META_TYP_34_I153_D: "ম্যাগাজিন Lv2",
  T_49_META_TYP_34_I154_D: "ম্যাগাজিন Lv3",
  T_49_META_TYP_34_I155_D: "ডাবল বান্ডিল ম্যাগাজিন",
  T_49_META_TYP_34_I156_D: "চেইন ম্যাগাজিন",
  T_49_META_TYP_34_I157_D: "গ্রিপ Lv1",
  T_49_META_TYP_34_I158_D: "গ্রিপ Lv2",
  T_49_META_TYP_34_I159_D: "গ্রিপ Lv3",
  T_49_META_TYP_34_I16_D: "UMP",
  T_49_META_TYP_34_I160_D: "ভাঁজ করা স্ট্যান্ড",
  T_49_META_TYP_34_I161_D: "মার্কসম্যান রাইফেল গ্রিপ",
  T_49_META_TYP_34_I162_D: "শটগান স্টক",
  T_49_META_TYP_34_I163_D: "স্নাইপার রাইফেলের বাটস্টক",
  T_49_META_TYP_34_I164_D: "থার্মাল ইমেজিং সুযোগ",
  T_49_META_TYP_34_I165_D: "স্টক Lv1",
  T_49_META_TYP_34_I166_D: "স্টক Lv2",
  T_49_META_TYP_34_I167_D: "স্টক Lv3",
  T_49_META_TYP_34_I168_D: "শিল্ড এক্সটেন্ডার",
  T_49_META_TYP_34_I169_D: "সম্পূর্ণ বডি আর্মার",
  T_49_META_TYP_34_I17_D: "UMP2",
  T_49_META_TYP_34_I170_D: "অতিরিক্ত স্তর",
  T_49_META_TYP_34_I171_D: "বিস্ফোরণ-প্রমাণ স্তর",
  T_49_META_TYP_34_I172_D: "ব্যাকপ্যাক সম্প্রসারণ",
  T_49_META_TYP_34_I173_D: "চিকিৎসা শ্বাসযন্ত্র",
  T_49_META_TYP_34_I174_D: "হরিজেন্টাল",
  T_49_META_TYP_34_I175_D: "মেড কিট",
  T_49_META_TYP_34_I176_D: "বর্ম মেরামতের কিট",
  T_49_META_TYP_34_I177_D: "উচ্চ প্রযুক্তির উপকরণ দিয়ে তৈরি কৃত্রিম বুদ্ধিমত্তার সেন্ট্রি টাওয়ারটি একটি নির্দিষ্ট সীমার মধ্যে সক্রিয়ভাবে শত্রুদের অনুসন্ধান এবং আক্রমণ করবে।",
  T_49_META_TYP_34_I178_D: "লেভেল ১ মাশরুম",
  T_49_META_TYP_34_I179_D: "লেভেল ২ মাশরুম",
  T_49_META_TYP_34_I18_D: "MP5",
  T_49_META_TYP_34_I180_D: "লেভেল ৩ মাশরুম",
  T_49_META_TYP_34_I181_D: "লেভেল ৪ মাশরুম",
  T_49_META_TYP_34_I182_D: "ব্যক্তিগত UAV",
  T_49_META_TYP_34_I184_D: "প্রক্সিমিটি মাইন",
  T_49_META_TYP_34_I185_D: "জেট উড়ন্ত জুতা",
  T_49_META_TYP_34_I186_D: "বাউন্স পাওয়ার বুট",
  T_49_META_TYP_34_I187_D: "হ্যাং গ্লাইডিং",
  T_49_META_TYP_34_I188_D: "ডিকয় গ্রেনেড",
  T_49_META_TYP_34_I189_D: "চৌম্বকীয় হোভারবোর্ড",
  T_49_META_TYP_34_I19_D: "মরুভূমি ঈগল",
  T_49_META_TYP_34_I190_D: "বোমা নিষ্ক্রিয় করার প্লায়ার",
  T_49_META_TYP_34_I191_D: "বন্দুক আপগ্রেডার",
  T_49_META_TYP_34_I192_D: "রাইফেলের গোলাবারুদ",
  T_49_META_TYP_34_I193_D: "পিস্তল গোলাবারুদ",
  T_49_META_TYP_34_I194_D: "স্নাইপার রাইফেলের গুলি",
  T_49_META_TYP_34_I195_D: "শটগানের গুলি",
  T_49_META_TYP_34_I196_D: "এসএমজি গুলি",
  T_49_META_TYP_34_I197_D: "তীর",
  T_49_META_TYP_34_I198_D: "এম৭৯ গ্রেনেড",
  T_49_META_TYP_34_I199_D: "অগ্নিনির্বাপক বুলেট",
  T_49_META_TYP_34_I2_D: "ক্রসবো",
  T_49_META_TYP_34_I20_D: "G18",
  T_49_META_TYP_34_I200_D: "ছুরি ছুঁড়ে ফেলা2",
  T_49_META_TYP_34_I201_D: "হুক",
  T_49_META_TYP_34_I202_D: "ফুটবল গান",
  T_49_META_TYP_34_I203_D: "বক্সিং",
  T_49_META_TYP_34_I204_D: "ফ্লেমথ্রোয়ার",
  T_49_META_TYP_34_I205_D: "MonkeygodCard সম্পর্কে",
  T_49_META_TYP_34_I206_D: "MadeManACard সম্পর্কে",
  T_49_META_TYP_34_I207_D: "DjmaleCard সম্পর্কে",
  T_49_META_TYP_34_I208_D: "গ্রাফিটিস্টকার্ড",
  T_49_META_TYP_34_I209_D: "ডিটেকটিভকার্ড",
  T_49_META_TYP_34_I21_D: "M14",
  T_49_META_TYP_34_I210_D: "প্রফেসরকার্ড",
  T_49_META_TYP_34_I211_D: "বাউন্টিহান্টারকার্ড",
  T_49_META_TYP_34_I212_D: "সুপারস্টারকার্ড",
  T_49_META_TYP_34_I213_D: "এক্সট্রিমকার্ড",
  T_49_META_TYP_34_I214_D: "MusicBroCard সম্পর্কে",
  T_49_META_TYP_34_I215_D: "কেন্টাকার্ড",
  T_49_META_TYP_34_I216_D: "ট্র্যাকারকার্ড",
  T_49_META_TYP_34_I217_D: "CrazygirlCard সম্পর্কে",
  T_49_META_TYP_34_I218_D: "রানস্পিডআপকার্ড",
  T_49_META_TYP_34_I219_D: "স্যান্টিনোকার্ড",
  T_49_META_TYP_34_I22_D: "SCAR",
  T_49_META_TYP_34_I220_D: "ভিলেনকার্ড",
  T_49_META_TYP_34_I23_D: "SCAR",
  T_49_META_TYP_34_I24_D: "SCAR-I সম্পর্কে",
  T_49_META_TYP_34_I25_D: "SCAR-II সম্পর্কে",
  T_49_META_TYP_34_I26_D: "SCAR-III সম্পর্কে",
  T_49_META_TYP_34_I27_D: "M1014-I সম্পর্কে",
  T_49_META_TYP_34_I28_D: "M1014-II সম্পর্কে",
  T_49_META_TYP_34_I29_D: "M1014-III এর বিবরণ",
  T_49_META_TYP_34_I3_D: "ফুটবল শিল্ড লুট",
  T_49_META_TYP_34_I30_D: "সুপারহিট এনার্জি গান",
  T_49_META_TYP_34_I31_D: "ওভারহিট গান-আই",
  T_49_META_TYP_34_I32_D: "সুপারহিট গান-২",
  T_49_META_TYP_34_I33_D: "সুপারহিট গান-III",
  T_49_META_TYP_34_I34_D: "প্লাজমা-এক্স",
  T_49_META_TYP_34_I35_D: "হিলিং পিস্তল-ওয়াই",
  T_49_META_TYP_34_I36_D: "হিল স্নাইপার",
  T_49_META_TYP_34_I37_D: "হিলিং পিস্তল",
  T_49_META_TYP_34_I38_D: "VSS",
  T_49_META_TYP_34_I39_D: "GROZA",
  T_49_META_TYP_34_I4_D: "FootballIce",
  T_49_META_TYP_34_I40_D: "GROZA",
  T_49_META_TYP_34_I41_D: "MP40",
  T_49_META_TYP_34_I42_D: "MP40",
  T_49_META_TYP_34_I43_D: "ফ্রাইং প্যান",
  T_49_META_TYP_34_I44_D: "ছুরি",
  T_49_META_TYP_34_I45_D: "SKS",
  T_49_META_TYP_34_I46_D: "M249",
  T_49_META_TYP_34_I47_D: "M249-X সম্পর্কে",
  T_49_META_TYP_34_I48_D: "M1873",
  T_49_META_TYP_34_I49_D: "M79",
  T_49_META_TYP_34_I5_D: "Bizon",
  T_49_META_TYP_34_I50_D: "FAMAS",
  T_49_META_TYP_34_I51_D: "M500",
  T_49_META_TYP_34_I52_D: "SVD",
  T_49_META_TYP_34_I53_D: "SVD",
  T_49_META_TYP_34_I54_D: "AC80",
  T_49_META_TYP_34_I55_D: "বেসবল ব্যাট",
  T_49_META_TYP_34_I56_D: "XM8",
  T_49_META_TYP_34_I57_D: "XM8",
  T_49_META_TYP_34_I58_D: "SPAS12",
  T_49_META_TYP_34_I59_D: "SPAS12",
  T_49_META_TYP_34_I6_D: "VSK94",
  T_49_META_TYP_34_I60_D: "M60",
  T_49_META_TYP_34_I61_D: "MGL140",
  T_49_META_TYP_34_I62_D: "P90",
  T_49_META_TYP_34_I63_D: "P90",
  T_49_META_TYP_34_I64_D: "AN94",
  T_49_META_TYP_34_I65_D: "কাতানা",
  T_49_META_TYP_34_I66_D: "CG15",
  T_49_META_TYP_34_I67_D: "RG550",
  T_49_META_TYP_34_I68_D: "গ্যাটলিং",
  T_49_META_TYP_34_I7_D: "M4A1",
  T_49_META_TYP_34_I70_D: "শক্তিশালী হুক বন্দুক",
  T_49_META_TYP_34_I71_D: "এফএফ ছুরি",
  T_49_META_TYP_34_I72_D: "M1887",
  T_49_META_TYP_34_I73_D: "১৮৮৭ সালে ৩টি বুলেট",
  T_49_META_TYP_34_I74_D: "M18872",
  T_49_META_TYP_34_I75_D: "THOMPSON",
  T_49_META_TYP_34_I76_D: "THOMPSON",
  T_49_META_TYP_34_I77_D: "এম৮২বি",
  T_49_META_TYP_34_I78_D: "এম৮২বি",
  T_49_META_TYP_34_I79_D: "AUG",
  T_49_META_TYP_34_I8_D: "USP",
  T_49_META_TYP_34_I80_D: "PARAFAL",
  T_49_META_TYP_34_I81_D: "PARAFAL",
  T_49_META_TYP_34_I82_D: "কাঠঠোকরা",
  T_49_META_TYP_34_I83_D: "VECTOR",
  T_49_META_TYP_34_I84_D: "এমএজি-৭",
  T_49_META_TYP_34_I85_D: "এমএজি-৭",
  T_49_META_TYP_34_I86_D: "কাস্তে",
  T_49_META_TYP_34_I87_D: "হাতুড়ি",
  T_49_META_TYP_34_I88_D: "ছুরি ছুঁড়ে মারা (পিকআপ)",
  T_49_META_TYP_34_I89_D: "Kord",
  T_49_META_TYP_34_I9_D: "AWM",
  T_49_META_TYP_34_I90_D: "M1917",
  T_49_META_TYP_34_I91_D: "ইউএসপি-২",
  T_49_META_TYP_34_I92_D: "কিংফিশার",
  T_49_META_TYP_34_I93_D: "UZI",
  T_49_META_TYP_34_I94_D: "MP5-I সম্পর্কে",
  T_49_META_TYP_34_I95_D: "এম৬০-আই",
  T_49_META_TYP_34_I96_D: "ভিএসএস-আই",
  T_49_META_TYP_34_I97_D: "M14-I সম্পর্কে",
  T_49_META_TYP_34_I98_D: "Kar98K-I সম্পর্কে",
  T_49_META_TYP_34_I99_D: "AWM_Y সম্পর্কে",
  T_49_META_TYP_340_I0_D: "সহজ",
  T_49_META_TYP_340_I1_D: "সহজ",
  T_49_META_TYP_340_I2_D: "স্বাভাবিক",
  T_49_META_TYP_340_I3_D: "মাঝারি",
  T_49_META_TYP_340_I4_D: "কঠিন",
  T_49_META_TYP_340_I5_D: "নরক",
  T_49_META_TYP_342_I0_D: "ইভেন্ট শুরু করুন",
  T_49_META_TYP_342_I1_D: "ইভেন্ট বন্ধ করুন",
  T_49_META_TYP_342_I2_D: "ইভেন্ট বিরাম",
  T_49_META_TYP_342_I3_D: "তৈরি হওয়ার পর সময় শুরু করার জন্য কতক্ষণ অপেক্ষা করতে হবে, মিলিসেকেন্ডে",
  T_49_META_TYP_342_I4_D: "লুপ সংখ্যা",
  T_49_META_TYP_342_I5_D: "ইভেন্টসমূহ",
  T_49_META_TYP_342_I6_D: "কাউন্টডাউন বা কাউন্টডাউন",
  T_49_META_TYP_342_I7_D: "খেলোয়াড়ের অবস্থা",
  T_49_META_TYP_342_I8_D: "টাইমিংয়ের শেষ সময়, সেকেন্ডে",
  T_49_META_TYP_345_I10_D: "হাত কামান",
  T_49_META_TYP_345_I12_D: "আইস ওয়াল গান",
  T_49_META_TYP_345_I13_D: "ফ্লেমথ্রোয়ার",
  T_49_META_TYP_345_I4_D: "শটগান",
  T_49_META_TYP_345_I6_D: "বিশেষ অস্ত্র",
  T_49_META_TYP_345_I8_D: "চার্জ গান",
  T_49_META_TYP_346_I0_D: "রাইফেলের গোলাবারুদ",
  T_49_META_TYP_346_I1_D: "পিস্তল গোলাবারুদ",
  T_49_META_TYP_346_I2_D: "স্নাইপার রাইফেলের গুলি",
  T_49_META_TYP_346_I3_D: "শটগানের গুলি",
  T_49_META_TYP_346_I4_D: "এসএমজি গুলি",
  T_49_META_TYP_346_I5_D: "তীর",
  T_49_META_TYP_346_I6_D: "এম৭৯ গ্রেনেড",
  T_49_META_TYP_346_I7_D: "হুক",
  T_49_META_TYP_346_I8_D: "এম৭৯ বিশেষায়িত গ্রেনেড",
  T_49_META_TYP_347_I3_D: "যখন সত্য, তখন এটি আপেক্ষিক গতির সাথে মিলিত হতে পারে। যখন মিথ্যা, তখন এটিকে পরম গতির সাথে মিলিত করতে হবে, অন্যথায় বৈশিষ্ট্যটি সঠিকভাবে কার্যকর হবে না।",
  T_49_META_TYP_347_I6_D: "ডেল্টা মান",
  T_49_META_TYP_350_I0_D: "স্পোর্টস কার",
  T_49_META_TYP_350_I1_D: "মোটরবাইক",
  T_49_META_TYP_350_I2_D: "জিপ",
  T_49_META_TYP_350_I3_D: "এসইউভি",
  T_49_META_TYP_350_I4_D: "মনস্টার ট্রাক",
  T_49_META_TYP_350_I5_D: "টুক টুক",
  T_49_META_TYP_352_I1_D: "অদৃষ্টিত স্প্রাইট",
  T_49_META_TYP_352_I2_D: "কোনও ছবির ধরণ নির্বাচন করা হয়নি",
  T_49_META_TYP_352_I3_D: "অদৃষ্টিত রং",
  T_49_META_TYP_352_I4_D: "নির্বাচিত স্প্রাইট",
  T_49_META_TYP_352_I5_D: "ছবির ধরণ নির্বাচন করুন",
  T_49_META_TYP_352_I6_D: "নির্বাচিত রং",
  T_49_META_TYP_353_I0_D: "HP পুনরুদ্ধার পরিমাণ",
  T_49_META_TYP_353_I1_D: "HP পুনরুদ্ধারের গতি (মিলিসেকেন্ড)",
  T_49_META_TYP_353_I2_D: "প্রয়োজনীয় সময় (মিলিসেকেন্ড)",
  T_49_META_TYP_354_I0_D: "EP পুনরুদ্ধারের পরিমাণ",
  T_49_META_TYP_355_I0_D: "HP পুনরুদ্ধার পরিমাণ",
  T_49_META_TYP_355_I1_D: "EP পুনরুদ্ধারের পরিমাণ",
  T_49_META_TYP_355_I2_D: "প্রয়োজনীয় সময় (মিলিসেকেন্ড)",
  T_49_META_TYP_356_I0_D: "ড্রপ আইটেম",
  T_49_META_TYP_356_I1_D: "এয়ারড্রপ বক্স ড্রপ টাইম এমএস",
  T_49_META_TYP_356_I2_D: "এয়ার ড্রপ অবস্থা",
  T_49_META_TYP_357_I0_D: "পৃষ্ঠতল",
  T_49_META_TYP_357_I1_D: "সীমানা",
  T_49_META_TYP_359_I0_D: "পদার্থবিদ্যার সাথে প্লেয়ার কন্ট্রোলার ব্যবহার করবেন কিনা",
  T_49_META_TYP_359_I1_D: "এই কোণের বেশি ঢালের উপর স্থাপন করলে, এটি নিচের দিকে পিছলে যাবে",
  T_49_META_TYP_359_I10_D: "এই মাধ্যাকর্ষণ ত্বরণ শুধুমাত্র প্লেয়ার কন্ট্রোলারের ক্ষেত্রে প্রযোজ্য।",
  T_49_META_TYP_359_I11_D: "ভর, কেজি",
  T_49_META_TYP_359_I12_D: "যদি ঢাল সর্বোচ্চ চড়াই কোণ অতিক্রম করে, তাহলে এটি নীচের দিকে পিছলে যাবে।",
  T_49_META_TYP_359_I16_D: "খোলার পর, সার্ভার-সাইড প্রিমিটিভ বা স্ক্রিপ্টগুলি চলাচল নিয়ন্ত্রণ করে",
  T_49_META_TYP_359_I17_D: "সক্রিয় থাকাকালীন, অনমনীয় বডি ঠেলে দেওয়ার সময় চরিত্র দ্বারা প্রয়োগ করা বল কাস্টমাইজ করা যেতে পারে",
  T_49_META_TYP_359_I18_D: "চরিত্রটি যখন অনমনীয় বস্তুটিকে ধাক্কা দেয় তখন যে পরিমাণ বল প্রয়োগ করা হয়",
  T_49_META_TYP_359_I19_D: "যখন নিচের অংশটি কলাইডারকে স্পর্শ করে তখন সত্য, সাধারণত খেলোয়াড় মাটিতে আছে কিনা তা নির্ধারণ করতে ব্যবহৃত হয়",
  T_49_META_TYP_359_I2_D: "শুধুমাত্র এই উচ্চতা অতিক্রমকারী বাধাগুলির একটি ব্লকিং প্রভাব থাকবে। মানের পরিসর হল [0, উচ্চতা]",
  T_49_META_TYP_359_I20_D: "কাস্টম ভৌত স্তর, মান [0,15]",
  T_49_META_TYP_359_I21_D: "গ্রাভিটির সাথে রোটেট সক্ষম করুন",
  T_49_META_TYP_359_I3_D: "ক্যাপসুলের গভীরতা যা এম্বেড করা যেতে পারে। এটি চরিত্রটিকে আটকে যাওয়া বা কাঁপতে বাধা দিতে পারে। বিশেষ প্রয়োজন না হলে এটি পরিবর্তন করার পরামর্শ দেওয়া হয় না। মান পরিসীমা (০, ব্যাসার্ধ]",
  T_49_META_TYP_359_I4_D: "সর্বনিম্ন চলমান দূরত্ব। এই মানের চেয়ে কম চলমান দূরত্ব কার্যকর করা হবে না। যদি কোন বিশেষ প্রয়োজন না থাকে, তাহলে এটি 0 হিসাবে রাখার পরামর্শ দেওয়া হচ্ছে।",
  T_49_META_TYP_359_I5_D: "স্থানীয় স্থানাঙ্ক উৎপত্তি থেকে সংঘর্ষ বাক্স কেন্দ্রের অফসেট",
  T_49_META_TYP_359_I6_D: "ক্যাপসুলের ব্যাসার্ধ, সর্বনিম্ন মান 0.01",
  T_49_META_TYP_359_I7_D: "ক্যাপসুলের মোট উচ্চতা, উপরের এবং নীচের গোলার্ধ সহ, যার সর্বনিম্ন মান 2*ব্যাসার্ধ",
  T_49_META_TYP_359_I8_D: "বর্তমান রৈখিক গতি, মি/সেকেন্ডে",
  T_49_META_TYP_360_I0_D: "বাম দিকের ফায়ারিং আর্ক কোণ",
  T_49_META_TYP_360_I1_D: "ডান দিকের ফায়ারিং আর্ক কোণ",
  T_49_META_TYP_360_I2_D: "সর্বনিম্ন উচ্চতা কোণ",
  T_49_META_TYP_360_I3_D: "সর্বাধিক নিম্ন কোণ",
  T_49_META_TYP_360_I4_D: "নল থেকে বেরোনোর গতি",
  T_49_META_TYP_362_I0_D: "প্লেয়ারকে আঘাত করার পর জমাট বাঁধার সময়, সেকেন্ডে",
  T_49_META_TYP_363_I0_D: "HUD অনুরোধ ক্রয় অক্ষম করুন",
  T_49_META_TYP_363_I1_D: "ক্রয়ের ক্ষেত্রে টিমের সাহায্য নিন",
  T_49_META_TYP_363_I2_D: "ক্রয়ের ক্ষেত্রে সাহায্যের জন্য দলটির কাছে জিজ্ঞাসা করুন।",
  T_49_META_TYP_364_I0_D: "কেন্দ্রীয় অবস্থান কি",
  T_49_META_TYP_364_I1_D: "লুপ করতে হবে কিনা",
  T_49_META_TYP_364_I2_D: "অ্যানিমেশনের নাম",
  T_49_META_TYP_364_I3_D: "স্বয়ংক্রিয়ভাবে চালানো হবে কিনা",
  T_49_META_TYP_364_I4_D: "কাস্টম রিসোর্স ব্যবহার করুন",
  T_49_META_TYP_366_I0_D: "রেন্ডার করা ব্যাচ রিসোর্সের UUID উল্লেখ করুন।",
  T_49_META_TYP_367_I1_D: "ট্যাগ প্রদর্শন করুন",
  T_49_META_TYP_367_I2_D: "লক্ষ্যবস্তু চিহ্নিত করার জন্য আইকন স্টাইল",
  T_49_META_TYP_367_I3_D: "লক্ষ্য চিহ্নিত করার সময় প্রদর্শিত আইকনের ওভারলে রঙ",
  T_49_META_TYP_367_I4_D: "আইকন স্টাইলটি একটি স্কেলে প্রদর্শিত হবে",
  T_49_META_TYP_367_I5_D: "আইকন ওভারলে রঙটি একটি স্কেলে প্রদর্শিত হবে",
  T_49_META_TYP_367_I6_D: "সর্বদা মার্ক দেখান",
  T_49_META_TYP_370_I0_D: "প্রধান শিরোনাম",
  T_49_META_TYP_370_I1_D: "সাবটাইটেল",
  T_49_META_TYP_370_I2_D: "উপরের পটভূমির রঙ",
  T_49_META_TYP_370_I3_D: "নিচে পটভূমির রঙ",
  T_49_META_TYP_371_I2_D: "বাম স্কোর",
  T_49_META_TYP_371_I3_D: "ডান স্কোর",
  T_49_META_TYP_371_I4_D: "বাম দিকের শেষ স্কোর, স্কোর স্যুইচিং অ্যানিমেশন চালানোর জন্য ব্যবহৃত হয়",
  T_49_META_TYP_371_I5_D: "ডানদিকের শেষ স্কোরটি স্কোর স্যুইচিং অ্যানিমেশন চালানোর জন্য ব্যবহৃত হয়।",
  T_49_META_TYP_372_I0_D: "দাঁড়ানো",
  T_49_META_TYP_372_I1_D: "বসা দেখান",
  T_49_META_TYP_372_I10_D: "উচ্চ উচ্চতায় পতন",
  T_49_META_TYP_372_I11_D: "কম উচ্চতা থেকে পড়ে যাওয়া, যেমন লাফ দেওয়া",
  T_49_META_TYP_372_I12_D: "উড়ন্ত জুতা",
  T_49_META_TYP_372_I13_D: "ডাবল জাম্প",
  T_49_META_TYP_372_I14_D: "চেয়ারে বসো।",
  T_49_META_TYP_372_I15_D: "ক্যাটাপল্ট দ্বারা বের করে দেওয়া হচ্ছে",
  T_49_META_TYP_372_I16_D: "ক্যাটাপল্ট প্রস্তুতির পর্যায়",
  T_49_META_TYP_372_I17_D: "গ্লাইডিং প্রপস গ্লাইডিং",
  T_49_META_TYP_372_I18_D: "গ্লাইডিং প্রপ ড্রপ",
  T_49_META_TYP_372_I19_D: "টায়ারে ধাক্কা লেগেছে",
  T_49_META_TYP_372_I2_D: "দৌড়",
  T_49_META_TYP_372_I20_D: "মানুষের টায়ারে লাফিয়ে উঠল",
  T_49_META_TYP_372_I21_D: "পার্টি এলাকায় একটি অ্যাকশন",
  T_49_META_TYP_372_I22_D: "বিমান ধরো।",
  T_49_META_TYP_372_I23_D: "কামানে প্রবেশ করুন",
  T_49_META_TYP_372_I24_D: "কামান, যানবাহন ইত্যাদি থেকে বের হওয়ার সময়, যদি আপনি যে বস্তুটিতে চড়ছেন তা উড়ন্ত অবস্থায় থাকে, তাহলে এই অবস্থাটি",
  T_49_META_TYP_372_I25_D: "স্প্রিংবোর্ড থেকে লাফ দেওয়ার পর",
  T_49_META_TYP_372_I26_D: "জিপলাইন থেকে নেমে যাও।",
  T_49_META_TYP_372_I27_D: "ব্যবহৃত হয়নি",
  T_49_META_TYP_372_I3_D: "ক্রল",
  T_49_META_TYP_372_I4_D: "দ্রুত সাঁতার",
  T_49_META_TYP_372_I5_D: "উল্লম্ব ড্রপ",
  T_49_META_TYP_372_I6_D: "ওয়াল পেরিয়ে",
  T_49_META_TYP_372_I7_D: "ব্যবহৃত হয়নি",
  T_49_META_TYP_372_I8_D: "ছিটকে পড়েছি কিন্তু মরেনি",
  T_49_META_TYP_372_I9_D: "একটি ওয়াটার বোর্ড ব্যবহার করুন",
  T_49_META_TYP_374_I0_D: "স্বাস্থ্য, স্তর এবং স্ট্রোকের রঙ",
  T_49_META_TYP_374_I1_D: "স্বাস্থ্যের অবনতি হলে, অনুপস্থিত অংশটি সংক্ষেপে এই রঙটি প্রদর্শন করে",
  T_49_META_TYP_374_I10_D: "অনুসরণ করা লক্ষ্যের সাপেক্ষে অফসেট",
  T_49_META_TYP_374_I11_D: "প্রতিটি দুটি বিভাজক রেখার মধ্যে স্বাস্থ্য মান 0 এর কম বা সমান হলে প্রদর্শিত হবে না।",
  T_49_META_TYP_374_I12_D: "মোট HP",
  T_49_META_TYP_374_I13_D: "বর্তমান HP",
  T_49_META_TYP_374_I14_D: "সক্রিয় করা হলে, স্বাস্থ্য পরিবর্তনগুলি বিভিন্ন রঙে প্রদর্শিত হবে",
  T_49_META_TYP_374_I15_D: "সক্রিয় করা হলে, স্থানীয় স্থানাঙ্ক সিস্টেম ব্যবহার করে অফসেট বৈশিষ্ট্যগুলি বিশ্ব স্থানাঙ্কে রূপান্তরিত হয়।",
  T_49_META_TYP_374_I2_D: "যখন স্বাস্থ্য বৃদ্ধি পায়, তখন বর্ধিত অংশটি সংক্ষিপ্তভাবে এই রঙটি প্রদর্শন করে",
  T_49_META_TYP_374_I3_D: "স্বাস্থ্য সীমানা এবং ঝাপসা নীচের রঙ",
  T_49_META_TYP_374_I4_D: "পরিসর ০~১, সামগ্রিক UI এর স্বচ্ছতা",
  T_49_META_TYP_374_I5_D: "সামগ্রিক UI স্কেলিং নির্ধারণ করে এবং ফন্টগুলি একসাথে স্কেল করা হয়",
  T_49_META_TYP_374_I6_D: "বর্তমান স্বাস্থ্য বারের মালিকের নাম নির্দেশ করে",
  T_49_META_TYP_374_I8_D: "স্ক্রিনে প্রদর্শিত হেলথ বারের দৈর্ঘ্য",
  T_49_META_TYP_374_I9_D: "ট্রান্সফর্ম কম্পোনেন্ট সহ একটি সত্তা অনুসরণ করতে হবে",
  T_49_META_TYP_375_I1_D: "যুদ্ধ সত্তা",
  T_49_META_TYP_376_I1_D: "যুদ্ধ সত্তা",
  T_49_META_TYP_38_I0_D: "আলফা",
  T_49_META_TYP_382_I0_D: "ডিফল্ট",
  T_49_META_TYP_382_I1_D: "নকডাউন অবস্থা এড়িয়ে যান এবং সরাসরি মারা যান",
  T_49_META_TYP_382_I2_D: "পড়ে যাওয়া মঞ্জুর নয়",
  T_49_META_TYP_387_I1_D: "বাহিরে প্রেস অনুমতি",
  T_49_META_TYP_389_I0_D: "বেসের ডিফল্ট অফসেট",
  T_49_META_TYP_389_I1_D: "ব্যাকগ্রাউন্ড স্প্রাইট",
  T_49_META_TYP_389_I10_D: "নিষ্ক্রিয় আলফা",
  T_49_META_TYP_389_I2_D: "ব্যাকগ্রাউন্ড রেডিয়াস",
  T_49_META_TYP_389_I3_D: "জয়স্টিক ক্যাপ ইমেজ",
  T_49_META_TYP_389_I4_D: "জয়স্টিক ক্যাপ রেডিয়াস",
  T_49_META_TYP_389_I5_D: "জয়স্টিক ক্যাপ ড্র্যাগ রেডিয়াস",
  T_49_META_TYP_389_I6_D: "তীর স্প্রাইট",
  T_49_META_TYP_389_I7_D: "তীর আকার",
  T_49_META_TYP_389_I8_D: "তীর অফসেট",
  T_49_META_TYP_389_I9_D: "সক্রিয় আলফা",
  T_49_META_TYP_39_I1_D: "স্প্রাইট আকার",
  T_49_META_TYP_39_I10_D: "শীর্ষ গ্রেডিয়েন্ট",
  T_49_META_TYP_39_I11_D: "নীচের গ্রেডিয়েন্ট",
  T_49_META_TYP_39_I12_D: "শীর্ষ আলফা",
  T_49_META_TYP_39_I13_D: "নীচের আলফা",
  T_49_META_TYP_39_I3_D: "ফ্লিপ",
  T_49_META_TYP_39_I4_D: "পূর্ণ",
  T_49_META_TYP_39_I5_D: "কেন্দ্র অদৃশ্য",
  T_49_META_TYP_39_I6_D: "পূরণ দিক",
  T_49_META_TYP_39_I7_D: "পূরণের মান",
  T_49_META_TYP_39_I8_D: "বিপরীত পূরণ",
  T_49_META_TYP_39_I9_D: "গ্রেডিয়েন্ট",
  T_49_META_TYP_392_I0_D: "খেলার প্রতিটি রাউন্ডে নিরাপদ অঞ্চলটি যে সময় প্রদর্শিত হয়, তার ডিফল্ট মান 0, ইউনিটটি ms",
  T_49_META_TYP_392_I1_D: "বৃত্তটি সঙ্কুচিত করতে যে সময় লাগে, ms-এ",
  T_49_META_TYP_392_I10_D: "সঙ্কুচিত বৃত্তের শেষ সময়, ms-এ",
  T_49_META_TYP_392_I12_D: "বিষ বৃত্তের শেষ ব্যাসার্ধ",
  T_49_META_TYP_392_I13_D: "সংকোচনের প্রারম্ভ সময়",
  T_49_META_TYP_392_I14_D: "ক্ষতির সময় অন্তর (ms)",
  T_49_META_TYP_392_I3_D: "বিষ চক্রের খেলোয়াড়দের ক্ষতির পরিমাণ।",
  T_49_META_TYP_392_I4_D: "নিরাপদ অঞ্চলে থাকা খেলোয়াড়দের তালিকা",
  T_49_META_TYP_392_I5_D: "নিরাপদ অঞ্চলের অন্তর্ধানের সময়। যদি নিরাপদ অঞ্চলের অন্তর্ধানের সময় কার্যকর সময়ের চেয়ে কম হয়, তাহলে কোনও নিরাপদ অঞ্চল তৈরি হবে না।",
  T_49_META_TYP_392_I6_D: "গ্রুপ আইডি",
  T_49_META_TYP_392_I7_D: "বিষ বৃত্তের শুরুর ব্যাসার্ধ",
  T_49_META_TYP_392_I8_D: "শেষ অবস্থা",
  T_49_META_TYP_392_I9_D: "স্থিতি",
  T_49_META_TYP_394_I0_D: "মান প্রায় 3.1416",
  T_49_META_TYP_394_I1_D: "মান প্রায় 2.7183",
  T_49_META_TYP_396_I0_D: "শিরোনাম",
  T_49_META_TYP_396_I1_D: "বিষয়বস্তু",
  T_49_META_TYP_396_I2_D: "বিকল্প",
  T_49_META_TYP_396_I3_D: "ব্যাকগ্রাউন্ড দেখান",
  T_49_META_TYP_399_I0_D: "লাফের উচ্চতা",
  T_49_META_TYP_399_I1_D: "অবতরণের আগে আপনি পরপর কত লাফ দিতে পারবেন",
  T_49_META_TYP_399_I2_D: "অবতরণের আগে আপনি বেশ কয়েকটি লাফ দিতে পারেন।",
  T_49_META_TYP_399_I3_D: "এয়ারবর্ন মোভমেন্ট সক্ষম করুন",
  T_49_META_TYP_40_I1_D: "লেবেল",
  T_49_META_TYP_40_I10_D: "লাইন স্পেসিং",
  T_49_META_TYP_40_I11_D: "ওভারফ্লো পদ্ধতি",
  T_49_META_TYP_40_I12_D: "ফন্টের ধরন",
  T_49_META_TYP_40_I13_D: "ছায়া প্রয়োগ",
  T_49_META_TYP_40_I14_D: "ছায়া রং",
  T_49_META_TYP_40_I15_D: "ছায়া অফসেট",
  T_49_META_TYP_40_I3_D: "স্থানীয়করণ কী, একাধিক ভাষায় ব্যবহার করা যেতে পারে",
  T_49_META_TYP_40_I5_D: "সারিবদ্ধকরণ",
  T_49_META_TYP_40_I6_D: "উল্লম্ব অ্যালাইনমেন্ট",
  T_49_META_TYP_40_I7_D: "বোল্ড",
  T_49_META_TYP_40_I8_D: "ইটালিক",
  T_49_META_TYP_40_I9_D: "আন্ডারলাইন",
  T_49_META_TYP_400_I0_D: "সক্রিয়",
  T_49_META_TYP_400_I1_D: "নিষ্ক্রিয়",
  T_49_META_TYP_400_I2_D: "আক্রমণ নয়",
  T_49_META_TYP_401_I0_D: "গুলি চালানো যাবে না",
  T_49_META_TYP_401_I1_D: "একটানা আগুন জ্বালাতে পারে",
  T_49_META_TYP_401_I2_D: "প্রতি আক্রমণ কমান্ডে একবার গুলি চালানো হয়",
  T_49_META_TYP_401_I3_D: "প্রতিটি আক্রমণ কমান্ড তিনবার গুলি চালায়",
  T_49_META_TYP_401_I4_D: "প্রতিটি আক্রমণ কমান্ড দুবার গুলি চালায়",
  T_49_META_TYP_401_I5_D: "প্রক্ষিপ্ত",
  T_49_META_TYP_402_I0_D: "বন্ধু হিসেবে যোগ করার লক্ষ্য",
  T_49_META_TYP_402_I1_D: "ফাংশন প্রকার",
  T_49_META_TYP_402_I2_D: "স্টাইল",
  T_49_META_TYP_403_I0_D: "বন্ধু যোগ করুন",
  T_49_META_TYP_403_I1_D: "রিপোর্ট",
  T_49_META_TYP_404_I0_D: "হালকা",
  T_49_META_TYP_404_I1_D: "অন্ধকার",
  T_49_META_TYP_405_I0_D: "স্তরের দ্বারা",
  T_49_META_TYP_405_I1_D: "উচ্চ থেকে নিম্ন অগ্রাধিকার",
  T_49_META_TYP_405_I2_D: "নিম্ন থেকে উচ্চ অগ্রাধিকার",
  T_49_META_TYP_406_I0_D: "খেলোয়াড়ের ভল্টিং অ্যাকশনের দূরত্ব নিয়ন্ত্রণ করে",
  T_49_META_TYP_406_I1_D: "উপরে ওঠার সময় এবং নিচে নামার সময় খেলোয়াড়ের শরীরের উচ্চতা নিয়ন্ত্রণ করে",
  T_49_META_TYP_407_I0_D: "স্থানীয়",
  T_49_META_TYP_407_I1_D: "ক্লায়েন্ট",
  T_49_META_TYP_407_I2_D: "সার্ভার",
  T_49_META_TYP_407_I3_D: "উভয়",
  T_49_META_TYP_409_I0_D: "কোন ত্রুটি নেই",
  T_49_META_TYP_409_I1_D: "ডেটা স্টোরেজ টাইমআউট, মূলত রিড অপারেশনের জন্য",
  T_49_META_TYP_409_I10_D: "দল পরিবর্তন ব্যর্থ হয়েছে - অবৈধ লক্ষ্য দল",
  T_49_META_TYP_409_I11_D: "দল পরিবর্তন ব্যর্থ - মৃত খেলোয়াড়দের দল পরিবর্তন করার অনুমতি নেই।",
  T_49_META_TYP_409_I12_D: "দল পরিবর্তন ব্যর্থ হয়েছে - যানবাহনে দল পরিবর্তন অনুমোদিত নয়।",
  T_49_META_TYP_409_I2_D: "ডেটা স্টোরেজ পঠন এবং লেখার ফ্রিকোয়েন্সি সীমা অতিক্রম করে",
  T_49_META_TYP_409_I3_D: "প্যারামিটার অস্বাভাবিকতা",
  T_49_META_TYP_409_I4_D: "রুম তৈরি করা যায়নি: কোনও বৈধ PersonaID নেই",
  T_49_META_TYP_409_I5_D: "অনির্ধারিত ত্রুটির অবস্থা",
  T_49_META_TYP_409_I6_D: "বাণিজ্যিক পরিষেবা বন্ধ রয়েছে এবং ব্যবহারকারীরা আর ডেভেলপারের পরিষেবা ব্যবহার করতে পারবেন না।",
  T_49_META_TYP_409_I7_D: "টিম পরিবর্তন ব্যর্থ হয়েছে - মোড সমর্থিত নয়",
  T_49_META_TYP_409_I8_D: "দল পরিবর্তন ব্যর্থ হয়েছে - বর্তমানে ইতিমধ্যেই লক্ষ্য দলে রয়েছে",
  T_49_META_TYP_409_I9_D: "দল পরিবর্তন ব্যর্থ হয়েছে - অবৈধ বস্তু",
  T_49_META_TYP_41_I0_D: "স্প্রাইট আকার",
  T_49_META_TYP_41_I19_D: "সংঘর্ষ বাক্স অক্ষম করুন",
  T_49_META_TYP_41_I3_D: "নিষ্ক্রিয় রং",
  T_49_META_TYP_41_I4_D: "প্রেসড রং",
  T_49_META_TYP_41_I5_D: "পূরণের প্রকার",
  T_49_META_TYP_41_I6_D: "FE বোতাম কিনা",
  T_49_META_TYP_41_I7_D: "প্রেসড স্প্রাইট",
  T_49_META_TYP_41_I8_D: "প্রেসড স্প্রাইট টাইপ",
  T_49_META_TYP_41_I9_D: "ফ্লিপ টাইপ",
  T_49_META_TYP_411_I0_D: "সামনের দিকে গতি",
  T_49_META_TYP_411_I1_D: "পিছনে গতি",
  T_49_META_TYP_411_I2_D: "উপরের দিকে গতি",
  T_49_META_TYP_411_I3_D: "নিচের দিকে গতি",
  T_49_META_TYP_411_I4_D: "গ্রেনেড ন্যূনতম ক্ষতি",
  T_49_META_TYP_411_I5_D: "গ্রেনেড সর্বাধিক ক্ষতি",
  T_49_META_TYP_411_I6_D: "গ্রেনেড পরিসীমা",
  T_49_META_TYP_412_I0_D: "থ্রটল বোতাম ব্যবহার করলে গাড়ির অশ্বশক্তির পরিমাণ কত বৃদ্ধি পায়",
  T_49_META_TYP_412_I1_D: "রিভার্স/ব্রেক বোতাম ব্যবহার করলে গাড়ির হর্সপাওয়ারের পরিমাণ কত বৃদ্ধি পায়",
  T_49_META_TYP_412_I2_D: "উচ্চ গতিতে, সর্বোচ্চ স্টিয়ারিং কোণ",
  T_49_META_TYP_412_I3_D: "উচ্চ গতির সর্বোচ্চ স্টিয়ারিং কোণ প্রয়োগের জন্য গতির সীমা",
  T_49_META_TYP_412_I4_D: "সর্বোচ্চ গতিতে পৌঁছানোর পর, গাড়িটি আর কোনও অশ্বশক্তি সরবরাহ করবে না, তবে গাড়িটি এই সর্বোচ্চ গতি অতিক্রম করতে পারে (উদাহরণস্বরূপ, উতরাইয়ের মাধ্যমে)",
  T_49_META_TYP_412_I5_D: "যখন গাড়িটি নিয়ন্ত্রণ করা হচ্ছে না, তখন IdleBrakeInput কে BrakeTorque দিয়ে গুণ করে গাড়ির গতি কমানো হয়।",
  T_49_META_TYP_412_I6_D: "ক্ষতির সূত্রের পরামিতি ব্যবহার করে মানুষের আঘাতের ক্ষতি গণনা করতে ব্যবহৃত হয়",
  T_49_META_TYP_412_I7_D: "মানুষকে আঘাত করার ক্ষতি গণনা করতে ব্যবহৃত হয়। এই গতি অতিক্রম করার পরে, ক্ষতি বাড়বে না।",
  T_49_META_TYP_412_I8_D: "সংঘর্ষের ক্ষতি গণনার জন্য ব্যবহৃত হয়, সর্বনিম্ন ক্ষতি",
  T_49_META_TYP_412_I9_D: "সংঘর্ষ, সর্বোচ্চ ক্ষতির ক্ষতি গণনার জন্য ব্যবহৃত হয়",
  T_49_META_TYP_413_I0_D: "খেলোয়াড় (এনপিসি) পরিবর্তিত পোশাক",
  T_49_META_TYP_414_I1_D: "প্রশস্ত পরিসর",
  T_49_META_TYP_415_I0_D: "পারসোনা আইডি",
  T_49_META_TYP_415_I1_D: "ডাকনাম",
  T_49_META_TYP_415_I2_D: "অবতার",
  T_49_META_TYP_416_I1_D: "বাউন্ড পারসোনা",
  T_49_META_TYP_416_I2_D: "অফসেট",
  T_49_META_TYP_416_I3_D: "উচ্চতা",
  T_49_META_TYP_416_I4_D: "সিস্টেম বার্তাগুলির উত্তর দেওয়া হবে কিনা",
  T_49_META_TYP_416_I5_D: "পারসোনা ডাকনাম",
  T_49_META_TYP_416_I6_D: "পারসোনাঅবতার",
  T_49_META_TYP_416_I7_D: "ব্যবহারকারীর ডাকনাম",
  T_49_META_TYP_416_I8_D: "ব্যবহারকারীর অবতার",
  T_49_META_TYP_417_I0_D: "রিসোর্স আইডি",
  T_49_META_TYP_418_I0_D: "সদস্যপদ মেয়াদ শেষ",
  T_49_META_TYP_418_I1_D: "সদস্য হোন",
  T_49_META_TYP_418_I2_D: "সদস্যপদ নবায়ন",
  T_49_META_TYP_42_I0_D: "ডিফল্ট টেক্সট",
  T_49_META_TYP_42_I1_D: "অ্যাক্টিভ টেক্সট",
  T_49_META_TYP_42_I10_D: "সর্বাধিক দৈর্ঘ্য",
  T_49_META_TYP_42_I14_D: "প্রেসড রং",
  T_49_META_TYP_42_I16_D: "স্থানীয়করণ কী, একাধিক ভাষায় ব্যবহার করা যেতে পারে",
  T_49_META_TYP_42_I3_D: "সারিবদ্ধকরণ",
  T_49_META_TYP_42_I4_D: "উল্লম্ব অ্যালাইনমেন্ট",
  T_49_META_TYP_42_I5_D: "বোল্ড",
  T_49_META_TYP_42_I6_D: "ইটালিক",
  T_49_META_TYP_42_I7_D: "আন্ডারলাইন",
  T_49_META_TYP_42_I8_D: "লাইন স্পেসিং",
  T_49_META_TYP_42_I9_D: "ওয়ার্ড ওয়ার্প",
  T_49_META_TYP_424_I0_D: "রৈখিক কুয়াশার প্রভাব",
  T_49_META_TYP_424_I1_D: "সূচক কুয়াশার প্রভাব",
  T_49_META_TYP_424_I2_D: "সূচকীয় বর্গাকার কুয়াশার প্রভাব",
  T_49_META_TYP_426_I0_D: "তীব্রতা",
  T_49_META_TYP_426_I1_D: "পরিসর",
  T_49_META_TYP_426_I2_D: "স্পটলাইট কোনের কোণ ডিগ্রীতে",
  T_49_META_TYP_426_I3_D: "হালকা রঙ",
  T_49_META_TYP_428_I0_D: "অস্ত্রের স্কিন আইডি",
  T_49_META_TYP_428_I2_D: "আইডি সেট করুন",
  T_49_META_TYP_428_I3_D: "হেডড্রেস আইডি",
  T_49_META_TYP_428_I4_D: "ফেস আইডি",
  T_49_META_TYP_428_I5_D: "মেকআপ আইডি",
  T_49_META_TYP_428_I6_D: "উপরের অংশের আইডি",
  T_49_META_TYP_428_I7_D: "নিচের অংশের আইডি",
  T_49_META_TYP_428_I8_D: "জুতার আইডি",
  T_49_META_TYP_431_I1_D: "লক্ষ্য সত্তার গতিপথ",
  T_49_META_TYP_431_I3_D: "চলাচলের গতি, একক: মি/সেকেন্ড",
  T_49_META_TYP_431_I4_D: `পথের ট্যানজেন্টের দিকে অগ্রসর হবে কিনা
ডিফল্ট মান হল False, যার অর্থ চলমান বস্তুর দিক অপরিবর্তিত থাকে।
যখন সত্য হয়, তখন চলমান বস্তুটি পথের দিকে মুখ করবে।`,
  T_49_META_TYP_431_I5_D: "খেলার শতাংশ",
  T_49_META_TYP_432_I0_D: "ঘূর্ণন কোণ, যা এই বিন্দুর উভয় পাশে পথের রেডিয়াল ঘূর্ণনকে প্রভাবিত করে",
  T_49_META_TYP_432_I1_D: "ট্যানজেন্ট নিয়ন্ত্রণ বিন্দু এবং ওয়েপয়েন্টের আপেক্ষিক অবস্থান পথের ট্যানজেন্ট নির্ধারণ করে",
  T_49_META_TYP_433_I0_D: "পথ বিন্দুর মধ্যে সরলরেখাগুলিকে প্রক্ষেপণ করো",
  T_49_META_TYP_433_I1_D: "মসৃণ গতির জন্য পথ বিন্দুগুলির মধ্যে বাঁকা ইন্টারপোলেশন",
  T_49_META_TYP_433_I2_D: "বক্ররেখার ট্যানজেন্টের ম্যানুয়াল সমন্বয় সমর্থন করে",
  T_49_META_TYP_434_I0_D: "পথের ধরণ",
  T_49_META_TYP_434_I1_D: "পথের মোট দৈর্ঘ্য",
  T_49_META_TYP_434_I2_D: "শুরু এবং শেষ সংযুক্ত কিনা",
  T_49_META_TYP_434_I3_D: "ওয়েপয়েন্ট সংগ্রহ",
  T_49_META_TYP_437_I3_D: "বাম খেলোয়াড়",
  T_49_META_TYP_437_I4_D: "ডান খেলোয়াড়",
  T_49_META_TYP_437_I5_D: "ইন্টিগ্রাল টাইপ নামের অ্যারে",
  T_49_META_TYP_437_I6_D: "বাম দিকের পয়েন্ট অ্যারে (এক মাত্রা তালিকাভুক্ত করুন: খেলোয়াড়; দুটি মাত্রা তালিকাভুক্ত করুন: কাস্টম পয়েন্টের ধরণ অনুসারে পূরণ করা পয়েন্ট ডেটা)",
  T_49_META_TYP_437_I7_D: "ডানদিকের পয়েন্ট অ্যারে (এক মাত্রা তালিকাভুক্ত করুন: খেলোয়াড়; দুটি মাত্রা তালিকাভুক্ত করুন: কাস্টম পয়েন্টের ধরণ অনুসারে পূরণ করা পয়েন্ট ডেটা)",
  T_49_META_TYP_438_I1_D: "খেলোয়াড়দের অ্যারে গ্রুপ করা",
  T_49_META_TYP_438_I2_D: "গ্রুপ র‍্যাঙ্কিং অ্যারে",
  T_49_META_TYP_438_I3_D: "গ্রুপ স্কোর অ্যারে",
  T_49_META_TYP_438_I4_D: "ইন্টিগ্রাল টাইপ নামের অ্যারে",
  T_49_META_TYP_438_I5_D: "গোষ্ঠীবদ্ধ রঙের অ্যারে",
  T_49_META_TYP_438_I6_D: "প্লেয়ার পয়েন্ট অ্যারে (গ্রুপ না করা অবস্থায় ক্রমের সাথে সঙ্গতিপূর্ণ)",
  T_49_META_TYP_442_I1_D: "বাম স্কোর",
  T_49_META_TYP_442_I10_D: "ডানদিকে মৃত্যু আইকন",
  T_49_META_TYP_442_I2_D: "ডান স্কোর",
  T_49_META_TYP_442_I3_D: "বাম দিকে বেঁচে থাকাদের সংখ্যা",
  T_49_META_TYP_442_I4_D: "ডানদিকে বেঁচে থাকাদের সংখ্যা",
  T_49_META_TYP_442_I5_D: "বাম দিকে মৃতের সংখ্যা",
  T_49_META_TYP_442_I6_D: "ডানদিকে মৃতের সংখ্যা",
  T_49_META_TYP_442_I7_D: "বাম দিকে বেঁচে থাকার আইকন",
  T_49_META_TYP_442_I8_D: "ডানদিকে বেঁচে থাকার আইকন",
  T_49_META_TYP_442_I9_D: "বাম দিকে মৃত্যু আইকন",
  T_49_META_TYP_444_I0_D: "ইংরেজী",
  T_49_META_TYP_444_I1_D: "সরলীকৃত চীনা",
  T_49_META_TYP_444_I10_D: "ফরাসি",
  T_49_META_TYP_444_I11_D: "জার্মান",
  T_49_META_TYP_444_I12_D: "তুর্কী",
  T_49_META_TYP_444_I13_D: "হিন্দি",
  T_49_META_TYP_444_I14_D: "জাপানি",
  T_49_META_TYP_444_I15_D: "রোমানীয়",
  T_49_META_TYP_444_I16_D: "আরবি",
  T_49_META_TYP_444_I17_D: "বার্মিজ",
  T_49_META_TYP_444_I18_D: "উর্দু",
  T_49_META_TYP_444_I19_D: "বাংলা",
  T_49_META_TYP_444_I2_D: "ঐতিহ্যবাহী চীনা",
  T_49_META_TYP_444_I3_D: "থাই",
  T_49_META_TYP_444_I4_D: "ভিয়েতনামী",
  T_49_META_TYP_444_I5_D: "ইন্দোনেশীয়",
  T_49_META_TYP_444_I6_D: "পর্তুগীজ",
  T_49_META_TYP_444_I7_D: "স্পেনীয়",
  T_49_META_TYP_444_I8_D: "রুশ",
  T_49_META_TYP_444_I9_D: "কোরিয়ান",
  T_49_META_TYP_51_I0_D: "সাধারণ জম্বি",
  T_49_META_TYP_51_I1_D: "কাঠ কাটার জম্বি",
  T_49_META_TYP_51_I10_D: "উড়ন্ত বোমা মৌমাছি",
  T_49_META_TYP_51_I11_D: "জম্বি ড্রাগন",
  T_49_META_TYP_51_I2_D: "থ্রো জম্বি",
  T_49_META_TYP_51_I3_D: "বিস্ফোরক জম্বি",
  T_49_META_TYP_51_I4_D: "অত্যাচারী জম্বি",
  T_49_META_TYP_51_I5_D: "লাল থ্রো জম্বি",
  T_49_META_TYP_51_I6_D: "মিস্টার ভি",
  T_49_META_TYP_51_I7_D: "ট্যাঙ্ক জম্বি",
  T_49_META_TYP_51_I8_D: "ড্রিল জম্বি",
  T_49_META_TYP_51_I9_D: "সামুরাই",
  T_49_META_TYP_56_I10_D: "বিস্ফোরণ বিলম্ব",
  T_49_META_TYP_56_I11_D: "বিস্ফোরণ পরিসর",
  T_49_META_TYP_56_I12_D: "বিস্ফোরণ ক্ষতি",
  T_49_META_TYP_56_I13_D: "জ্বলন্ত সময়",
  T_49_META_TYP_56_I14_D: "জ্বলন্ত ক্ষতি",
  T_49_META_TYP_56_I15_D: "জ্বলন্ত ক্ষতি মধ্যবর্তী সময়",
  T_49_META_TYP_56_I17_D: "যানবাহন চালক",
  T_49_META_TYP_56_I18_D: "জাহাজে থাকা সকল যাত্রী",
  T_49_META_TYP_56_I19_D: "গাড়ির স্কিন আইডি",
  T_49_META_TYP_56_I20_D: "খেলোয়াড় কনফিগারেশন অগ্রাধিকার",
  T_49_META_TYP_56_I21_D: "সর্বাধিক HP",
  T_49_META_TYP_56_I22_D: "HP",
  T_49_META_TYP_57_I0_D: "ম্যানুয়ালি ট্রান্সফার করবেন নাকি অটোমেটিক (ডিফল্টভাবে ম্যানুয়াল)",
  T_49_META_TYP_58_I0_D: "তৈরি করা BUFF টাইপ",
  T_49_META_TYP_58_I1_D: "একটি BUFF তোলার পর থেকে পরবর্তী BUFF তৈরি হওয়া পর্যন্ত সময়, সেকেন্ডে",
  T_49_META_TYP_59_I0_D: "মুভমেন্ট প্রকার",
  T_49_META_TYP_59_I1_D: "মুভমেন্ট মান X",
  T_49_META_TYP_59_I2_D: "মুভমেন্ট মান Y",
  T_49_META_TYP_59_I3_D: "মুভমেন্ট মান Z",
  T_49_META_TYP_59_I4_D: "চলাচলের সময়কাল",
  T_49_META_TYP_59_I5_D: "থামানোর সময়কাল",
  T_49_META_TYP_59_I6_D: "প্রতিরোধক না ব্যবহার করা",
  T_49_META_TYP_60_I0_D: "লুট অস্ত্র পয়েন্ট",
  T_49_META_TYP_61_I0_D: "সংযুক্ত মুদ্রা",
  T_49_META_TYP_61_I1_D: "ট্রিগার রেঞ্জ সেট করুন",
  T_49_META_TYP_61_I2_D: "মডেল দৃশ্যমানতা",
  T_49_META_TYP_62_I0_D: "ভেলোসিটি XZ",
  T_49_META_TYP_62_I1_D: "ভেলোসিটি Y",
  T_49_META_TYP_64_I0_D: "সঙ্গীত উপাদানের ধরণ",
  T_49_META_TYP_66_I0_D: "ইনস্ট্যান্সআইডি",
  T_49_META_TYP_66_I1_D: "পথের পয়েন্ট",
  T_49_META_TYP_68_I0_D: "এআই-এর বর্তমান স্বাস্থ্য",
  T_49_META_TYP_68_I1_D: "AI এর বর্তমান সর্বোচ্চ স্বাস্থ্য",
  T_49_META_TYP_68_I10_D: "এআই কি মারা গেলে সরঞ্জাম বা জিনিসপত্র ফেলে দেবে?",
  T_49_META_TYP_68_I11_D: "এআই বর্তমানে অজেয় অবস্থায় আছে কিনা",
  T_49_META_TYP_68_I12_D: "ক্ষতি গ্রহণের সময়, ক্ষতির শতাংশ হ্রাস বা বৃদ্ধি করা যেতে পারে।",
  T_49_META_TYP_68_I13_D: "এআই এর প্রকারভেদ",
  T_49_META_TYP_68_I14_D: "শত্রুদের জন্য স্বয়ংক্রিয়ভাবে অনুসন্ধান করতে হবে কিনা",
  T_49_META_TYP_68_I15_D: "০ মানে স্বয়ংক্রিয় আক্রমণ, ১ মানে প্রতিরক্ষামূলক আক্রমণ, ২ মানে কোনও আক্রমণ নয়",
  T_49_META_TYP_68_I16_D: "পথ আইডি",
  T_49_META_TYP_68_I17_D: "লক্ষ্য লক্ষ্য",
  T_49_META_TYP_68_I18_D: "আক্রমণ লক্ষ্য",
  T_49_META_TYP_68_I19_D: "AI এর স্পন পয়েন্ট স্থানাঙ্ক",
  T_49_META_TYP_68_I2_D: "AI যে দলের সাথে সম্পর্কিত তার সত্তাটি পান",
  T_49_META_TYP_68_I20_D: "দলের উপদল সংখ্যা",
  T_49_META_TYP_68_I4_D: "শুধুমাত্র স্বাভাবিক আক্রমণের আক্রমণ শক্তি পরিবর্তন করা যেতে পারে, এবং দক্ষতার আক্রমণ শক্তি গণনা করা হয় না।",
  T_49_META_TYP_68_I7_D: "AI এর অবাধ চলাচলের পরিসর। আপনি কেবল মৌলিক মান পরিবর্তন করতে পারবেন। যদি অতিরিক্ত বোনাস থাকে, তাহলে তা মানের ভিত্তিতে যোগ করা হবে।",
  T_49_META_TYP_68_I8_D: "AI শত্রুর পরিসর সনাক্ত করে এবং শুধুমাত্র মৌলিক মান পরিবর্তন করতে পারে। যদি অতিরিক্ত বোনাস থাকে, তাহলে তা মানের ভিত্তিতে যোগ করা হবে।",
  T_49_META_TYP_68_I9_D: "প্রকৃত চলাচলের গতি। যদি দক্ষতার ত্বরণ থাকে, তাহলে তা দিয়ে গুণ করা হবে।",
  T_49_META_TYP_70_I0_D: "সূত্রের টার্গেট এন্টিটি আইডি, যা অভ্যন্তরীণভাবে ব্যবহৃত হয় এবং প্লেয়ারের কাছে দৃশ্যমান নয়।",
  T_49_META_TYP_70_I1_D: "সূত্রের টার্গেট এন্টিটি অ্যাট্রিবিউট আইডি, যা অভ্যন্তরীণভাবে ব্যবহৃত হয় এবং প্লেয়ারের কাছে দৃশ্যমান নয়।",
  T_49_META_TYP_70_I2_D: "অনুমোদিত সর্বনিম্ন মান",
  T_49_META_TYP_70_I3_D: "সর্বোচ্চ অনুমোদিত মান",
  T_49_META_TYP_70_I4_D: "বেস সহগ",
  T_49_META_TYP_70_I5_D: "পূর্ব-অ্যাকুমুলেটর",
  T_49_META_TYP_70_I6_D: "গুণক",
  T_49_META_TYP_70_I7_D: "গুণ এবং সঞ্চয়",
  T_49_META_TYP_70_I8_D: "পোস্ট-অ্যাকুমুলেটর",
  T_49_META_TYP_71_I0_D: "পণ্য নম্বর",
  T_49_META_TYP_71_I1_D: "মূল্য",
  T_49_META_TYP_71_I10_D: "দোকানের আইটেম",
  T_49_META_TYP_71_I2_D: "মুদ্রার প্রকার",
  T_49_META_TYP_71_I3_D: "মোট ক্রয়ের সীমা",
  T_49_META_TYP_71_I4_D: "বর্তমান সামগ্রিক ক্রয় বিধিনিষেধ",
  T_49_META_TYP_71_I5_D: "পণ্যের নাম",
  T_49_META_TYP_71_I6_D: "পণ্যের বর্ণনা",
  T_49_META_TYP_71_I7_D: "পণ্য আইটেম তালিকা",
  T_49_META_TYP_71_I8_D: "কেনা যায় কি না",
  T_49_META_TYP_71_I9_D: "রিসোর্স পাথ, ডিফল্টরূপে খালি",
  T_49_META_TYP_72_I1_D: "শেলফ",
  T_49_META_TYP_73_I1_D: "ম্যানুয়াল বন্ধ নিষ্ক্রিয়",
  T_49_META_TYP_74_I0_D: "বিভাজক",
  T_49_META_TYP_74_I1_D: "হেলমেট",
  T_49_META_TYP_74_I2_D: "বডি আর্মার",
  T_49_META_TYP_74_I3_D: "গ্রেনেড",
  T_49_META_TYP_75_I0_D: "একমুখী",
  T_49_META_TYP_75_I1_D: "পিছনে ফিরে আসা",
  T_49_META_TYP_76_I0_D: "শুধু টহল দিন, পথে লক্ষ্যবস্তুতে আক্রমণ করবেন না",
  T_49_META_TYP_76_I1_D: "টহল ও আক্রমণ",
  T_49_META_TYP_79_I0_D: "অস্ত্র আক্রমণ শক্তি",
  T_49_META_TYP_79_I1_D: "আক্রমণ পরিসর",
  T_49_META_TYP_79_I10_D: "বুলেট ছড়িয়ে শুরু সংখ্যা",
  T_49_META_TYP_79_I11_D: "আইটেম আইডি",
  T_49_META_TYP_79_I12_D: "দুটি শটের মধ্যে সর্বনিম্ন অপেক্ষার সময়, সেকেন্ডে। প্রতিটি শট গুলি চালানোর ধরণের উপর নির্ভর করে একাধিক গুলি চালাতে পারে।",
  T_49_META_TYP_79_I13_D: "এই অস্ত্রের মালিক খেলোয়াড়রা",
  T_49_META_TYP_79_I14_D: "গুলি খরচ",
  T_49_META_TYP_79_I15_D: "দ্বৈত চালিতের ধরণ (০: দ্বৈত চালিত নয়, ১: নিজস্ব, ২: যেকোনো অস্ত্র)",
  T_49_META_TYP_79_I16_D: "বর্ম ক্ষতি সহগ",
  T_49_META_TYP_79_I17_D: "খেলোয়াড়ের চলাচলের গতি",
  T_49_META_TYP_79_I18_D: "ধড়ের আঘাতের জন্য ক্ষতির অনুপাত",
  T_49_META_TYP_79_I19_D: "হেডশটের জন্য ক্ষতির অনুপাত",
  T_49_META_TYP_79_I2_D: "দুটি বুলেটের মধ্যে সর্বনিম্ন অপেক্ষার সময়, সেকেন্ডে",
  T_49_META_TYP_79_I20_D: "অঙ্গ-প্রত্যঙ্গের ক্ষতির অনুপাত",
  T_49_META_TYP_79_I21_D: "অতিরিক্ত ক্ষতির অনুপাত (গাড়ি, তেলের ব্যারেল বরফের প্রাচীর)",
  T_49_META_TYP_79_I22_D: "পিঠে দৃশ্যমান",
  T_49_META_TYP_79_I23_D: "অতিরিক্ত ক্ষতির জন্য মাটিতে আঘাত করো",
  T_49_META_TYP_79_I24_D: "প্রতি শটের গুলি",
  T_49_META_TYP_79_I25_D: "পুনরায় লোডের গতি (বেস গতি * সহগ)",
  T_49_META_TYP_79_I26_D: "বর্তমান গুলির সংখ্যা",
  T_49_META_TYP_79_I27_D: "বন্দুকের চামড়ার আইডি",
  T_49_META_TYP_79_I28_D: "যখন খেলোয়াড়ের কনফিগারেশনকে অগ্রাধিকার দেওয়া হয়, তখন খেলোয়াড়ের বন্দুকের ত্বকের কনফিগারেশন অস্ত্রের নিজস্ব বন্দুকের ত্বকের বৈশিষ্ট্যগুলিকে ওভাররাইড করবে।",
  T_49_META_TYP_79_I29_D: "অস্ত্রের উপর বন্দুকের চামড়ার বৈশিষ্ট্য লেখার সময়, অস্ত্রের মৌলিক মূল্য বন্দুকের চামড়া দ্বারা প্রভাবিত হবে",
  T_49_META_TYP_79_I3_D: "গুলি ম্যাগ সাইজ",
  T_49_META_TYP_79_I30_D: "স্প্রেড বৃদ্ধির হার (০.১ = প্রতিটি অতিরিক্ত শট বার্স্ট করলে ক্রসহেয়ার ১০% বৃদ্ধি পায়)",
  T_49_META_TYP_79_I31_D: "পুনরুদ্ধারের গতি ছড়িয়ে ছিটিয়ে থাকা",
  T_49_META_TYP_79_I32_D: "শুটিংয়ের সময় খেলোয়াড়ের গতি প্রভাবিত করে",
  T_49_META_TYP_79_I33_D: "নড়াচড়া করার সময় স্প্রেড সাইজ (১.৫ = ১.৫ * বেস ক্রসহেয়ার সাইজ)",
  T_49_META_TYP_79_I34_D: "অস্ত্রের প্রকার",
  T_49_META_TYP_79_I36_D: "আগুনের ধরন",
  T_49_META_TYP_79_I37_D: "একক শট",
  T_49_META_TYP_79_I38_D: "নিরব",
  T_49_META_TYP_79_I39_D: "एडीएस गति दर",
  T_49_META_TYP_79_I4_D: "প্রাথমিক ম্যাগ সংখ্যা",
  T_49_META_TYP_79_I5_D: "আর্মার পেনিট্রেশন",
  T_49_META_TYP_79_I6_D: "পূর্ণ ক্ষতির দূরত্ব",
  T_49_META_TYP_79_I7_D: "ন্যূনতম ক্ষতি দূরত্ব",
  T_49_META_TYP_79_I8_D: "সর্বনিম্ন ক্ষতি",
  T_49_META_TYP_79_I9_D: "ছড়িয়ে ছিটিয়ে থাকা শুরু হওয়ার আগে কতগুলি গুলি ছোড়া যেতে পারে",
  T_49_META_TYP_80_I1_D: "যখন সত্য, তখন ম্যানুয়াল বন্ধ করা নিষিদ্ধ",
  T_49_META_TYP_80_I2_D: "বাউন্ড স্টোর এন্টিটি",
  T_49_META_TYP_80_I4_D: "সংযুক্ত ওয়ালেট আইডি",
  T_49_META_TYP_80_I5_D: "অনুরোধ প্রকার",
  T_49_META_TYP_80_I6_D: "বর্তমান UI প্লেয়ারের অনুরোধ করা টার্গেটের ধরণ",
  T_49_META_TYP_80_I7_D: "ট্রিগার প্লেয়ার আইডি",
  T_49_META_TYP_81_I0_D: "র্যান্ডম বাফ",
  T_49_META_TYP_81_I1_D: "HP বাফ",
  T_49_META_TYP_81_I2_D: "বুলেট বাফ",
  T_49_META_TYP_81_I3_D: "আর্মার বাফ",
  T_49_META_TYP_82_I1_D: "বোতাম আইকন",
  T_49_META_TYP_82_I3_D: "অ্যাঙ্কর পয়েন্টের সাপেক্ষে অবস্থান",
  T_49_META_TYP_83_I1_D: "মুদ্রা",
  T_49_META_TYP_83_I2_D: "পাসিং প্যারামিটার",
  T_49_META_TYP_86_I0_D: "সর্বনিম্ন",
  T_49_META_TYP_86_I1_D: "সর্বাধিক",
  T_49_META_TYP_86_I2_D: "সমস্ত গণনার আগে মূল মান দিয়ে গুণিত ভিত্তি সহগ",
  T_49_META_TYP_86_I3_D: "প্রাক-সঞ্চয়কারী, গুণের আগে সঞ্চিত হয় এবং গুণ গণনায় অংশগ্রহণ করে",
  T_49_META_TYP_86_I4_D: "ক্রমাগত গুণক, ক্রমাগত গুণ, উদাহরণস্বরূপ (90% এ কমিয়ে, 110% এ শক্তিশালী করুন) এর প্রভাব হল মান*90%*110%",
  T_49_META_TYP_86_I5_D: "উদাহরণস্বরূপ, গুণন সঞ্চয়কারীর (১০% যোগ করুন, ৫% যোগ করুন) মান*(১+১০%+৫%) এর প্রভাব রয়েছে",
  T_49_META_TYP_86_I6_D: "পোস্ট-অ্যাকিউমুলেটর, গুণ গণনায় অংশগ্রহণ করে না এবং শেষে যোগ করা হয়",
  T_49_META_TYP_88_I0_D: "মৌলিক ধরণ, সবচেয়ে মৌলিক খেলার মুদ্রা, বর্তমান সংস্করণে সাধারণ পণ্যের মূল্য নির্ধারণের ধরণ",
  T_49_META_TYP_89_I0_D: "বর্তমানে, সংস্করণে শুধুমাত্র বেস মুদ্রা রয়েছে",
  T_49_META_TYP_89_I1_D: "মুদ্রার পরিমাণ",
  T_49_META_TYP_89_I2_D: "মুদ্রা আইকন",
  T_49_META_TYP_89_I3_D: "মুদ্রা আইকনের রঙ",
  T_49_META_TYP_90_I0_D: "মানিব্যাগের জিনিসপত্রে একগুচ্ছ মুদ্রা আছে",
  T_49_META_TYP_92_I0_D: "স্কোয়ার কাঠের বাক্স",
  T_49_META_TYP_92_I1_D: "লম্বা কাঠের বাক্স",
  T_49_META_TYP_92_I10_D: "ওয়াচটাওয়ার",
  T_49_META_TYP_92_I100_D: "সিঁড়ি",
  T_49_META_TYP_92_I101_D: "সিঁড়ির স্তর B",
  T_49_META_TYP_92_I102_D: "সিঁড়ির স্তর A",
  T_49_META_TYP_92_I103_D: "টেলিফোন বুথ",
  T_49_META_TYP_92_I104_D: "BIS থিমওয়াল",
  T_49_META_TYP_92_I105_D: "BIS থিম ফুলের বিছানা",
  T_49_META_TYP_92_I106_D: "বিক্রয় মেশিন",
  T_49_META_TYP_92_I107_D: "দানব সত্তা",
  T_49_META_TYP_92_I108_D: "ইউনিট জেনারেটর",
  T_49_META_TYP_92_I109_D: "স্পোর্টস কার",
  T_49_META_TYP_92_I11_D: "গার্ডহাউস",
  T_49_META_TYP_92_I110_D: "টুক টুক",
  T_49_META_TYP_92_I111_D: "ধ্বংসযোগ্য কাঠের বাক্স",
  T_49_META_TYP_92_I112_D: "এসইউভি",
  T_49_META_TYP_92_I113_D: "মোটরবাইক",
  T_49_META_TYP_92_I114_D: "মনস্টার ট্রাক",
  T_49_META_TYP_92_I115_D: "সোনার জেনারেটর",
  T_49_META_TYP_92_I116_D: "সিঁড়ির স্তর C",
  T_49_META_TYP_92_I117_D: "চিহ্ন",
  T_49_META_TYP_92_I118_D: "বেড়া",
  T_49_META_TYP_92_I119_D: "জার্সি মেশিন",
  T_49_META_TYP_92_I12_D: "দুইতলা বাড়ি",
  T_49_META_TYP_92_I121_D: "কংক্রিটের স্তম্ভ",
  T_49_META_TYP_92_I122_D: "লুট ফুটবল আইটেম বক্স",
  T_49_META_TYP_92_I123_D: "তেল ড্রাম",
  T_49_META_TYP_92_I124_D: "কম-গ্র্যাভিটি এলাকা",
  T_49_META_TYP_92_I125_D: "অস্ত্র",
  T_49_META_TYP_92_I126_D: "বেড়া B",
  T_49_META_TYP_92_I127_D: "ছোট বাড়ি A",
  T_49_META_TYP_92_I128_D: "ক্ষতিগ্রস্ত ট্রাক",
  T_49_META_TYP_92_I129_D: "মৌলিক গোলক",
  T_49_META_TYP_92_I13_D: "বালির ভাস্কর্য",
  T_49_META_TYP_92_I130_D: "মৌলিক শঙ্কু",
  T_49_META_TYP_92_I131_D: "মৌলিক সিলিন্ডার",
  T_49_META_TYP_92_I132_D: "ব্যবহৃত পদার্থ জেনারেটর",
  T_49_META_TYP_92_I133_D: "কাস্টম জল দেহ",
  T_49_META_TYP_92_I134_D: "তীর",
  T_49_META_TYP_92_I135_D: "রঙিন ব্লক",
  T_49_META_TYP_92_I136_D: "রঙিন তেল ড্রাম",
  T_49_META_TYP_92_I137_D: "টেক্সট",
  T_49_META_TYP_92_I138_D: "আইকন",
  T_49_META_TYP_92_I139_D: "বরফের পুতুল",
  T_49_META_TYP_92_I14_D: "ফোয়ারা",
  T_49_META_TYP_92_I140_D: "ক্যাপসুল ট্রিগার",
  T_49_META_TYP_92_I141_D: "গোলাকার সংঘর্ষ ট্রিগার",
  T_49_META_TYP_92_I142_D: "প্রতিফলিত কঠিন রঙের মৌলিক ব্লক 1",
  T_49_META_TYP_92_I143_D: "বাম্পার গাড়ি প্রস্তুতকারক",
  T_49_META_TYP_92_I144_D: "চেকারড পার্ক ব্লক",
  T_49_META_TYP_92_I145_D: "বড় স্ক্রীন",
  T_49_META_TYP_92_I146_D: "মঞ্চ",
  T_49_META_TYP_92_I147_D: "বিশাল ললিপপ",
  T_49_META_TYP_92_I148_D: "খাবার ট্রাক B",
  T_49_META_TYP_92_I15_D: "চেরি ব্লসোম গাছ",
  T_49_META_TYP_92_I16_D: "একতলা বাড়ি",
  T_49_META_TYP_92_I17_D: "তিন তলা বাড়ি",
  T_49_META_TYP_92_I18_D: "কলার গাছ",
  T_49_META_TYP_92_I19_D: "টয়লেট",
  T_49_META_TYP_92_I2_D: "গুল্ম-আবৃত লম্বা কাঠের বাক্স",
  T_49_META_TYP_92_I20_D: "বেড়া",
  T_49_META_TYP_92_I21_D: "ধ্বংসযোগ্য কনটেইনার",
  T_49_META_TYP_92_I22_D: "ধ্বংসযোগ্য বেড়া",
  T_49_META_TYP_92_I23_D: "টায়ার",
  T_49_META_TYP_92_I24_D: "বাম্পার কার",
  T_49_META_TYP_92_I25_D: "অ্যাম্ফিবিয়ান গাড়ি",
  T_49_META_TYP_92_I26_D: "জিপ",
  T_49_META_TYP_92_I27_D: "আবর্জনার বাক্স",
  T_49_META_TYP_92_I28_D: "মেডিক্যাল টেন্ট",
  T_49_META_TYP_92_I29_D: "গ্যারেজ",
  T_49_META_TYP_92_I3_D: "ঘাসের গাদ",
  T_49_META_TYP_92_I30_D: "আঁকা দেওয়াল",
  T_49_META_TYP_92_I31_D: "তোরি",
  T_49_META_TYP_92_I32_D: "লোহার প্ল্যাটফর্ম",
  T_49_META_TYP_92_I33_D: "কনটেইনার বাড়ি",
  T_49_META_TYP_92_I34_D: "ট্রেলার",
  T_49_META_TYP_92_I35_D: "প্রাচীর A",
  T_49_META_TYP_92_I36_D: "সঙ্গীতের নোট - পিয়ানো",
  T_49_META_TYP_92_I37_D: "সঙ্গীতের নোট - পিয়ানো",
  T_49_META_TYP_92_I38_D: "সঙ্গীতের নোট - ড্রাম",
  T_49_META_TYP_92_I39_D: "সঙ্গীতের নোট - ড্রাম",
  T_49_META_TYP_92_I4_D: "বিধ্বস্ত গাড়ি",
  T_49_META_TYP_92_I40_D: "সঙ্গীতের নোট - সিনথেসাইজার A",
  T_49_META_TYP_92_I41_D: "সঙ্গীতের নোট - সিনথেসাইজার A",
  T_49_META_TYP_92_I42_D: "সঙ্গীতের নোট - সিনথেসাইজার B",
  T_49_META_TYP_92_I43_D: "সঙ্গীতের নোট - সিনথেসাইজার B",
  T_49_META_TYP_92_I44_D: "সঙ্গীতের নোট - সিনথেসাইজার C",
  T_49_META_TYP_92_I45_D: "সঙ্গীতের নোট - সিনথেসাইজার C",
  T_49_META_TYP_92_I46_D: "বাফ জেনারেটর",
  T_49_META_TYP_92_I47_D: "প্রোপেলার প্রক্রিয়া",
  T_49_META_TYP_92_I48_D: "ফ্রাইং প্যান মেকানিজম",
  T_49_META_TYP_92_I49_D: "ব্লক ট্র্যাপ",
  T_49_META_TYP_92_I5_D: "বিধ্বস্ত বাস",
  T_49_META_TYP_92_I50_D: "রিং মেকানিজম",
  T_49_META_TYP_92_I51_D: "জায়ান্ট হ্যামার ট্র্যাপ",
  T_49_META_TYP_92_I52_D: "মোবাইল বোর্ড",
  T_49_META_TYP_92_I53_D: "লক্ষ্য পরিবর্তন",
  T_49_META_TYP_92_I54_D: "টেলিস্কোপিক ওয়াল",
  T_49_META_TYP_92_I55_D: "লুট পয়েন্ট অস্ত্রের উপাদান",
  T_49_META_TYP_92_I56_D: "লুট পয়েন্ট বুলেট কম্পোনেন্ট",
  T_49_META_TYP_92_I57_D: "লুট পয়েন্ট ভোগ্যপণ্যের উপাদান",
  T_49_META_TYP_92_I58_D: "লুট পয়েন্ট থ্রোয়িং আইটেম কম্পোনেন্ট",
  T_49_META_TYP_92_I59_D: "লুট পয়েন্ট জুম কম্পোনেন্ট",
  T_49_META_TYP_92_I6_D: "কন্টেইনার A",
  T_49_META_TYP_92_I60_D: "লুট পয়েন্ট আর্মার উপাদান",
  T_49_META_TYP_92_I61_D: "পাইপ I",
  T_49_META_TYP_92_I62_D: "পাইপ T",
  T_49_META_TYP_92_I63_D: "ক্রস পাইপ",
  T_49_META_TYP_92_I64_D: "কোণ পাইপ",
  T_49_META_TYP_92_I65_D: "বিশাল মাশরুম ক্লাস্টার",
  T_49_META_TYP_92_I66_D: "শুকানোর র্যাক",
  T_49_META_TYP_92_I67_D: "কাঠের সেতু",
  T_49_META_TYP_92_I68_D: "পর্দা",
  T_49_META_TYP_92_I69_D: "কংক্রিট স্তম্ভ",
  T_49_META_TYP_92_I7_D: "শিপিং কনটেইনার বি",
  T_49_META_TYP_92_I70_D: "ক্যাকটাস",
  T_49_META_TYP_92_I71_D: "মৃত গাছ",
  T_49_META_TYP_92_I72_D: "রাজকীয় লণ্ঠন",
  T_49_META_TYP_92_I73_D: "রাস্তায় আলো",
  T_49_META_TYP_92_I74_D: "সোলার প্যানেল",
  T_49_META_TYP_92_I75_D: "এয়ার কন্ডিশনার",
  T_49_META_TYP_92_I76_D: "বর্গক্ষেত্র",
  T_49_META_TYP_92_I77_D: "ঢাল",
  T_49_META_TYP_92_I78_D: "খাদ্য ট্রাক",
  T_49_META_TYP_92_I79_D: "মৃত্যু বা অক্ষুন্নতা ট্রিগার",
  T_49_META_TYP_92_I8_D: "শিপিং কনটেইনার সি",
  T_49_META_TYP_92_I80_D: "চেকপয়েন্ট",
  T_49_META_TYP_92_I81_D: "শেষ অবস্থান",
  T_49_META_TYP_92_I82_D: "ডাইস",
  T_49_META_TYP_92_I83_D: "বেঞ্চ",
  T_49_META_TYP_92_I84_D: "বাস স্টেশন",
  T_49_META_TYP_92_I85_D: "কুকুরের ঘর",
  T_49_META_TYP_92_I86_D: "বিলবোর্ড",
  T_49_META_TYP_92_I87_D: "জলজগ",
  T_49_META_TYP_92_I88_D: "গ্রাফিতি ওয়াল",
  T_49_META_TYP_92_I89_D: "গাছের ঘর",
  T_49_META_TYP_92_I9_D: "কেবিন",
  T_49_META_TYP_92_I90_D: "পাথরের আর্ক ব্রিজ",
  T_49_META_TYP_92_I91_D: "প্যাটিও সেট সঙ্গে ছাতা",
  T_49_META_TYP_92_I92_D: "ফিনিশ ব্যানার",
  T_49_META_TYP_92_I93_D: "দুর্গ",
  T_49_META_TYP_92_I94_D: "দানবের স্পন পয়েন্ট",
  T_49_META_TYP_92_I95_D: "চিহ্ন",
  T_49_META_TYP_92_I97_D: "কাস্টম ট্রিগার",
  T_49_META_TYP_92_I98_D: "ডাবল দরজা",
  T_49_META_TYP_92_I99_D: "ব্যারিকেড",
  T_49_META_TYP_94_I0_D: "যোগ করুন",
  T_49_META_TYP_94_I1_D: "গুননা",
  T_49_META_TYP_95_I0_D: "মুদ্রার প্রকার",
  T_49_META_TYP_95_I1_D: "মুদ্রার পরিমাণ",
  T_49_META_TYP_96_I0_D: "ওয়ালেট পান",
  T_49_META_TYP_96_I1_D: "প্রদর্শনের অবস্থান (নোঙ্গর বিন্দু উপরের ডান কোণে)",
  T_49_META_TYP_97_I0_D: "বিশ্ব স্থানাঙ্কে অবস্থান",
  T_49_META_TYP_97_I1_D: "বিশ্ব স্থানাঙ্ক ব্যবস্থায় ঘূর্ণন কোণ, XYZ উপাদানগুলি হল পিচ কোণ, ইয়াও কোণ এবং রোল কোণ, এবং ঘূর্ণনের ক্রম হল YXZ।",
  T_49_META_TYP_97_I10_D: "স্থানীয় স্থানাঙ্ক অক্ষের দিক x",
  T_49_META_TYP_97_I11_D: "স্থানীয় স্থানাঙ্ক অক্ষ z এর দিক",
  T_49_META_TYP_97_I2_D: "বিশ্ব স্থানাঙ্কে স্কেলিং",
  T_49_META_TYP_97_I3_D: "এই নোডের প্যারেন্ট নোড",
  T_49_META_TYP_97_I4_D: "বিশ্ব স্থানাঙ্কে ঘূর্ণন, চতুর্ভুজ হিসাবে প্রকাশ করা হয়",
  T_49_META_TYP_97_I5_D: "স্থানীয় স্থানাঙ্ক ব্যবস্থায় অবস্থান",
  T_49_META_TYP_97_I6_D: "স্থানীয় স্থানাঙ্ক ব্যবস্থায় ঘূর্ণন, যাকে চতুর্ভুজ হিসেবে প্রকাশ করা হয়",
  T_49_META_TYP_97_I7_D: "স্থানীয় স্থানাঙ্ক ব্যবস্থায় ঘূর্ণন কোণ, XYZ উপাদানগুলি হল পিচ কোণ, ইয়াও কোণ এবং রোল কোণ, এবং ঘূর্ণনের ক্রম হল YXZ।",
  T_49_META_TYP_97_I8_D: "স্থানীয় স্থানাঙ্ক ব্যবস্থায় স্কেলিং আকার",
  T_49_META_TYP_97_I9_D: "স্থানীয় স্থানাঙ্ক অক্ষ y এর দিক",
  T_49_META_TYP_99_I0_D: "ফুটবল ব্যাসার্ধ",
  T_49_META_TYP_99_I1_D: "স্বাভাবিক অবস্থায় ঘর্ষণ সহগ",
  T_49_META_TYP_99_I2_D: "প্রভাবের অধীনে ঘর্ষণ সহগ",
  T_49_META_TYP_99_I3_D: "সর্বনিম্ন শুটিং কোণ",
  T_49_META_TYP_99_I4_D: "সর্বনিম্ন উত্থান কোণ",
  T_49_META_TYP_99_I5_D: "রিসেট সময়",
  T_49_META_TYP_99_I6_D: "সর্বাধিক শুটিং কোণ",
  T_49_META_TYP_99_I7_D: "রিসেট অবস্থান",
  T_49_META_TYPE_0_D: "বস্তু, প্রকার অনুক্রমের মূল",
  T_49_META_TYPE_1_D: "তালিকা হলো ডেটা সেটের জন্য একটি ধারক",
  T_49_META_TYPE_10_D: "সত্তার ভিত্তি উপাদান, সমস্ত উপাদান এই উপাদানটিকে একত্রিত করবে",
  T_49_META_TYPE_100_D: "জার্সি মেশিন",
  T_49_META_TYPE_101_D: "মর্ফযোগ্য বস্তু",
  T_49_META_TYPE_1010_D: "টাইমার তথ্য",
  T_49_META_TYPE_1011_D: "উদ্বোধনী ব্যানার",
  T_49_META_TYPE_1012_D: "দুই দলের রাউন্ডের শুরুতে ব্যানার এন্টিটি। এন্টিটির বৈশিষ্ট্য পরিবর্তন করলে সংশ্লিষ্ট UI-তে ডিসপ্লে কন্টেন্ট প্রভাবিত হবে।",
  T_49_META_TYPE_1013_D: "সাধারণত, রাউন্ডের শুরুতে ব্যানার এন্টিটি, এন্টিটির বৈশিষ্ট্যগুলি পরিবর্তন করলে সংশ্লিষ্ট UI-তে প্রদর্শনের বিষয়বস্তু প্রভাবিত হবে।",
  T_49_META_TYPE_1014_D: "টিম রাউন্ড স্কোর ব্যানার এন্টিটি। এন্টিটি অ্যাট্রিবিউট পরিবর্তন করলে সংশ্লিষ্ট UI-তে ডিসপ্লে কন্টেন্ট প্রভাবিত হবে।",
  T_49_META_TYPE_1015_D: "চেকপয়েন্ট ম্যানেজার এন্টিটি। এন্টিটি অ্যাট্রিবিউট পরিবর্তন করলে সংশ্লিষ্ট UI-তে ডিসপ্লে কন্টেন্ট প্রভাবিত হবে।",
  T_49_META_TYPE_1016_D: "রাউন্ডের শেষে এন্টিটি প্রদর্শিত হয়। এন্টিটি অ্যাট্রিবিউট পরিবর্তন করলে সংশ্লিষ্ট UI-তে ডিসপ্লে কন্টেন্ট প্রভাবিত হবে।",
  T_49_META_TYPE_1017_D: "যদি শুরুতে দুটি দল থাকে, তাহলে দুটি দলের একে অপরের বিরুদ্ধে লড়াইয়ের ব্যানার প্রদর্শন করুন।",
  T_49_META_TYPE_1018_D: "উভয় দলের স্কোর",
  T_49_META_TYPE_1019_D: "চূড়ান্ত ফলাফল: জয়, পরাজয়, ড্র",
  T_49_META_TYPE_102_D: "পুনরুত্থান উৎসের ধরণ: মৃত্যু, পতন",
  T_49_META_TYPE_1020_D: "টার্ন নম্বর এন্টিটি, এন্টিটি অ্যাট্রিবিউট পরিবর্তন করলে সংশ্লিষ্ট UI-তে ডিসপ্লে কন্টেন্ট প্রভাবিত হবে",
  T_49_META_TYPE_1021_D: "ফেজ কাউন্টডাউন এন্টিটি। এন্টিটি অ্যাট্রিবিউট পরিবর্তন করলে সংশ্লিষ্ট UI-তে ডিসপ্লে কন্টেন্ট প্রভাবিত হবে।",
  T_49_META_TYPE_1022_D: "গেমের তথ্য সাবটাইটেল সত্তা। সত্তার বৈশিষ্ট্যগুলি পরিবর্তন করলে সংশ্লিষ্ট UI-তে প্রদর্শনের বিষয়বস্তু প্রভাবিত হবে।",
  T_49_META_TYPE_1023_D: "দুটি দলের খেলার তথ্য সত্তা। সত্তার বৈশিষ্ট্য পরিবর্তন করলে সংশ্লিষ্ট UI-তে প্রদর্শনের বিষয়বস্তু প্রভাবিত হবে।",
  T_49_META_TYPE_1024_D: "টিম ম্যাচ তথ্য UI সত্তা। সত্তার বৈশিষ্ট্যগুলি পরিবর্তন করলে সংশ্লিষ্ট UI-তে প্রদর্শন সামগ্রী প্রভাবিত হবে।",
  T_49_META_TYPE_1027_D: "Typeof ব্যবহার করলে কোন ধরণের টাইপ ফেরত আসে তা বর্ণনা করে।",
  T_49_META_TYPE_1028_D: "উপদলীয় তথ্য সত্তা। সত্তার বৈশিষ্ট্য পরিবর্তন করলে সংশ্লিষ্ট UI-তে প্রদর্শনের বিষয়বস্তু প্রভাবিত হবে।",
  T_49_META_TYPE_1029_D: "আইকনটি সত্তার তথ্য প্রম্পট করে, সত্তার বৈশিষ্ট্যগুলি পরিবর্তন করলে সংশ্লিষ্ট UI-তে প্রদর্শনের বিষয়বস্তু প্রভাবিত হবে",
  T_49_META_TYPE_103_D: "আইটেম স্লটের ধরণ গণনা",
  T_49_META_TYPE_1030_D: "দুটি দলের খেলার তথ্যের একটি সরলীকৃত সত্তা। সত্তার বৈশিষ্ট্যগুলি পরিবর্তন করলে সংশ্লিষ্ট UI-তে প্রদর্শনের বিষয়বস্তু প্রভাবিত হবে।",
  T_49_META_TYPE_1031_D: "টাইমিং প্রম্পট ইন্টারফেস এন্টিটি, এন্টিটি অ্যাট্রিবিউট পরিবর্তন করলে সংশ্লিষ্ট UI-তে ডিসপ্লে কন্টেন্ট প্রভাবিত হবে",
  T_49_META_TYPE_1032_D: "ভাসমান টেক্সট সত্তাকে প্রম্পট করে। সত্তার বৈশিষ্ট্যগুলি পরিবর্তন করলে সংশ্লিষ্ট UI-তে প্রদর্শনের বিষয়বস্তু প্রভাবিত হবে।",
  T_49_META_TYPE_1033_D: "টার্ন সুইচিং এন্টিটিতে বর্তমান টার্ন সেটেলমেন্ট এবং পরবর্তী টার্ন শুরুর তথ্য অন্তর্ভুক্ত থাকে। এন্টিটি অ্যাট্রিবিউট পরিবর্তন করলে সংশ্লিষ্ট UI-তে ডিসপ্লে কন্টেন্ট প্রভাবিত হবে।",
  T_49_META_TYPE_1035_D: "স্কোরবোর্ড বোতাম UI সত্তা খুলুন। সত্তার বৈশিষ্ট্যগুলি পরিবর্তন করলে সংশ্লিষ্ট UI-তে প্রদর্শনের বিষয়বস্তু প্রভাবিত হবে।",
  T_49_META_TYPE_1036_D: "সংক্রমণ মোড, UI বর্তমান জম্বি স্তর দেখাচ্ছে",
  T_49_META_TYPE_1037_D: "একটি পয়েন্ট ডায়নামিক এফেক্ট UI এন্টিটি যোগ করুন। এন্টিটি অ্যাট্রিবিউট পরিবর্তন করলে সংশ্লিষ্ট UI-তে ডিসপ্লে কন্টেন্ট প্রভাবিত হবে।",
  T_49_META_TYPE_1038_D: "ইনফেকশন মোড জম্বি UI প্রভাব",
  T_49_META_TYPE_1039_D: "কাউন্টডাউন ফ্লোটিং টেক্সট প্রম্পট এন্টিটি, এন্টিটি অ্যাট্রিবিউট পরিবর্তন করলে সংশ্লিষ্ট UI-তে ডিসপ্লে কন্টেন্ট প্রভাবিত হবে।",
  T_49_META_TYPE_104_D: "জার্সি স্টাইল",
  T_49_META_TYPE_1040_D: "UI কার্ড নির্বাচন প্যানেল",
  T_49_META_TYPE_1041_D: "UI পরিচয় বিজ্ঞপ্তি",
  T_49_META_TYPE_1042_D: "UI ৫-সেকেন্ড কাউন্টডাউন",
  T_49_META_TYPE_1043_D: "UI শিরোনাম ব্যানার",
  T_49_META_TYPE_1044_D: "UI বিল্ট-ইন সুইচ",
  T_49_META_TYPE_1045_D: "UI স্কিল বোতাম",
  T_49_META_TYPE_105_D: "ফুটবল গোল",
  T_49_META_TYPE_106_D: "লক্ষ্য সহায়তার ধরণ",
  T_49_META_TYPE_107_D: "লক্ষ্যবস্তুতে আঘাত করা যেতে পারে, কিন্তু ক্ষতি করতে হবে না।",
  T_49_META_TYPE_108_D: "পূর্ণসংখ্যার ধরণ, ৬৪-বিট স্বাক্ষরিত পূর্ণসংখ্যা",
  T_49_META_TYPE_109_D: "চ্যাট চ্যানেল সত্তা হল একটি ধারক যার নিজস্ব চ্যানেল আইডি এবং প্লেয়ার থাকে।",
  T_49_META_TYPE_11_D: "বিশ্বব্যাপী সত্তা, পুরো গেমটিতে অনন্য",
  T_49_META_TYPE_110_D: "আইডল ভয়েস চ্যানেল",
  T_49_META_TYPE_111_D: "আচরণের ধরণ",
  T_49_META_TYPE_112_D: "প্লেয়ার আচরণ অবস্থার প্রকার",
  T_49_META_TYPE_113_D: "ড্রাম মিউজিক",
  T_49_META_TYPE_114_D: "লিড1 মিউজিক",
  T_49_META_TYPE_115_D: "লিড2 মিউজিক",
  T_49_META_TYPE_116_D: "লিড3 মিউজিক",
  T_49_META_TYPE_117_D: "ড্রাম সঙ্গীতের উপাদানের ধরণ",
  T_49_META_TYPE_118_D: "গোষ্ঠী",
  T_49_META_TYPE_119_D: "আক্রমণের বিকল্পগুলি",
  T_49_META_TYPE_12_D: "একটি যুদ্ধ সত্তা যা আক্রমণ করতে পারে, আক্রমণ করা যেতে পারে, হত্যা করতে পারে ইত্যাদি।",
  T_49_META_TYPE_120_D: "UI প্রগ্রেস বার",
  T_49_META_TYPE_121_D: "প্রতিটি তরঙ্গ ব্যবধানের সময়",
  T_49_META_TYPE_122_D: "স্কাইবক্স",
  T_49_META_TYPE_123_D: "স্কাইবক্স বেস টাইপ গণনা",
  T_49_META_TYPE_124_D: "অনুসন্ধান পরিসর",
  T_49_META_TYPE_125_D: "আপনি বস্তুর মৌলিক চেহারা পরিবর্তন করতে পারেন, যেমন টেক্সচার এবং স্বচ্ছতা",
  T_49_META_TYPE_126_D: "স্বাস্থ্য বার",
  T_49_META_TYPE_127_D: "কিভাবে বস্তু সরাতে হয়",
  T_49_META_TYPE_128_D: "মর্ফযোগ্য বস্তু",
  T_49_META_TYPE_129_D: "লুটের গুলির প্রকার",
  T_49_META_TYPE_13_D: "UI নিয়ন্ত্রণ সত্তা",
  T_49_META_TYPE_130_D: "লুটের ভোগ্যপণ্যের প্রকার",
  T_49_META_TYPE_131_D: "লুটের বর্মের প্রকার",
  T_49_META_TYPE_132_D: "লুটের নিক্ষেপযোগ্য প্রকার",
  T_49_META_TYPE_133_D: "লুটের স্কোপের প্রকার",
  T_49_META_TYPE_134_D: "লুটের অস্ত্রের প্রকার",
  T_49_META_TYPE_135_D: "নির্বাচিত ধরণের গোলাবারুদ ফেলে দেবে",
  T_49_META_TYPE_136_D: "নির্বাচিত ধরণের প্রপস ড্রপ তৈরি করবে",
  T_49_META_TYPE_137_D: "নির্বাচিত ধরণের একটি প্রজেক্টাইল পড়ে যাবে",
  T_49_META_TYPE_138_D: "নির্বাচিত ধরণের একটি স্কোপ বাদ দেবে",
  T_49_META_TYPE_139_D: "নির্বাচিত ধরণের বর্মটি পড়ে যাবে",
  T_49_META_TYPE_14_D: "গেমটিতে খেলোয়াড় সত্তা, প্রতি ব্যবহারকারীর জন্য একটি",
  T_49_META_TYPE_140_D: "তরঙ্গ",
  T_49_META_TYPE_141_D: "লুট ফুটবল প্রকার",
  T_49_META_TYPE_142_D: "লুট ফুটবল আইটেম বক্স",
  T_49_META_TYPE_143_D: "লিড১ সঙ্গীত উপাদানের ধরণ",
  T_49_META_TYPE_144_D: "লিড২ মিউজিক কম্পোনেন্টের ধরণ",
  T_49_META_TYPE_145_D: "লিড৩ মিউজিক কম্পোনেন্টের ধরণ",
  T_49_META_TYPE_146_D: "কীবোর্ড সঙ্গীত উপাদানের ধরণ",
  T_49_META_TYPE_147_D: "বিভিন্ন ধরণের প্রিসেট ক্যামেরার ধরণ, সেইসাথে কাস্টম ক্যামেরার ধরণ প্রদান করে",
  T_49_META_TYPE_148_D: "ক্যামেরার উপাদান",
  T_49_META_TYPE_149_D: "স্থানীয়করণ কী",
  T_49_META_TYPE_15_D: "খেলার দলগত সত্তা, প্রতিটি দলের জন্য একটি করে",
  T_49_META_TYPE_150_D: "তেল ড্রাম",
  T_49_META_TYPE_151_D: "কোয়াটারনিয়ন হলো একটি বিশেষ চার-মাত্রিক ভেক্টর যা শুধুমাত্র ঘূর্ণন বোঝাতে ব্যবহৃত হয়।",
  T_49_META_TYPE_152_D: "কম-গ্র্যাভিটি এলাকা",
  T_49_META_TYPE_153_D: "সত্তার ধারক, যা অবস্থানে সংশ্লিষ্ট ধরণের সত্তা তৈরি করবে",
  T_49_META_TYPE_154_D: "দ্বৈত অস্ত্র টাইপ",
  T_49_META_TYPE_155_D: "হেলমেট সত্তা",
  T_49_META_TYPE_156_D: "বডি আর্মার সত্তা",
  T_49_META_TYPE_157_D: "ক্যামেরা স্থানান্তর প্রকার",
  T_49_META_TYPE_158_D: "টেক্সট প্রম্পট ইন্টারফেস",
  T_49_META_TYPE_159_D: "ভেক্টর2",
  T_49_META_TYPE_16_D: "লেভেল অবজেক্ট এন্টিটি",
  T_49_META_TYPE_160_D: "মানচিত্রের ধরণ",
  T_49_META_TYPE_161_D: "প্রতিস্থাপনযোগ্য টেক্সচার VFX",
  T_49_META_TYPE_162_D: "টাইপ লিস্ট",
  T_49_META_TYPE_163_D: "টাইপ নাকি টাইপ লিস্ট",
  T_49_META_TYPE_164_D: "কম্পোনেন্ট হলো সকল সত্তা উপাদান অথবা নির্দিষ্ট কম্পোনেন্ট শ্রেণীর বেস ক্লাস।",
  T_49_META_TYPE_165_D: "সংঘর্ষ বাক্স উপাদান",
  T_49_META_TYPE_166_D: "ইমোট",
  T_49_META_TYPE_167_D: "স্পেশাল এফেক্ট সত্তাটি একটি প্রদর্শিত স্পেশাল এফেক্টকে প্রতিনিধিত্ব করে (মুছে ফেলা, পুনর্ব্যবহারযোগ্য এবং পুনঃব্যবহারযোগ্য)",
  T_49_META_TYPE_17_D: "লেভেল অবজেক্ট তালিকা",
  T_49_META_TYPE_170_D: "দৃশ্যমানতা সেট করা যাবে কিনা তা নির্দেশ করে",
  T_49_META_TYPE_171_D: "মাশরুম",
  T_49_META_TYPE_172_D: "গোলাবারুদ",
  T_49_META_TYPE_173_D: "ব্যাকপ্যাক",
  T_49_META_TYPE_174_D: "গ্রেনেডের উপাদান",
  T_49_META_TYPE_175_D: "বরফে গুলি",
  T_49_META_TYPE_176_D: "অস্ত্র জেনারেটর",
  T_49_META_TYPE_177_D: "যখন ক্যামেরা এবং অনুসরণ করা বস্তুর মধ্যে কোনও বাধা থাকে, তখন ক্যামেরার চলাচল মোড",
  T_49_META_TYPE_178_D: "ক্যামেরা কীভাবে ছবি তোলে",
  T_49_META_TYPE_179_D: "মৌলিক গোলক",
  T_49_META_TYPE_18_D: "(অপ্রচলিত, ব্যবহার করবেন না)",
  T_49_META_TYPE_180_D: "একটি উপাদানের একটি বৈশিষ্ট্য বোঝায়",
  T_49_META_TYPE_181_D: "মেশ অ্যাসেটের ধরণ বর্ণনা করতে ব্যবহৃত হয়",
  T_49_META_TYPE_182_D: "বস্তুগত সম্পদের ধরণ বর্ণনা করতে ব্যবহৃত হয়",
  T_49_META_TYPE_183_D: "টেক্সচার অ্যাসেটের ধরণ বর্ণনা করতে ব্যবহৃত হয়",
  T_49_META_TYPE_184_D: "বিল্ট-ইন মডেল রিসোর্স ব্যবহার করে রেন্ডারিংয়ের জন্য একটি ব্রিজ রেন্ডারিং কম্পোনেন্ট",
  T_49_META_TYPE_185_D: "কাস্টম মডেল রিসোর্স সহ রেন্ডারিংয়ের জন্য কাস্টম রেন্ডারিং কম্পোনেন্ট",
  T_49_META_TYPE_186_D: "একটি ফাঁকা বস্তু উপাদান যা রেন্ডারার উপাদান, কোলাইডার উপাদান ইত্যাদির সাথে ব্যবহার করা যেতে পারে।",
  T_49_META_TYPE_187_D: "কন্টেনার",
  T_49_META_TYPE_188_D: "মৌলিক সিলিন্ডার",
  T_49_META_TYPE_189_D: "স্থানীয় স্ট্রিংগুলির তালিকা",
  T_49_META_TYPE_19_D: "তালিকা টেমপ্লেট, আপনি T এর মাধ্যমে বিষয়বস্তুর ধরণ নির্দিষ্ট করতে পারেন",
  T_49_META_TYPE_190_D: "দুই দলের স্কোর প্যানেল",
  T_49_META_TYPE_191_D: "একটি কৌশলগত নিক্ষেপকারী অস্ত্র যা একটি নির্দিষ্ট পরিসরের মধ্যে শত্রুদের সাময়িকভাবে অন্ধ করে দিতে পারে।",
  T_49_META_TYPE_192_D: "ব্যবহারের পর, এটি ধোঁয়া উৎপন্ন করতে পারে যা ঘটনাটিকে আড়াল করে, যা শত্রুর আক্রমণ ব্যাহত করার জন্য একটি শক্তিশালী অস্ত্র।",
  T_49_META_TYPE_193_D: "বহু দলের ফলাফল প্যানেল",
  T_49_META_TYPE_194_D: "ইন্ডাকশন মাইনগুলি মাটিতে স্থাপন করা যেতে পারে। শত্রু যখন এগিয়ে আসবে তখন এগুলি বিস্ফোরিত হবে। সাবধান থাকুন যাতে তাদের উপর পা না পড়ে।",
  T_49_META_TYPE_195_D: "ইন্টারপোলেটেড মোশন কীভাবে বাজানো হয়",
  T_49_META_TYPE_197_D: "খেলার যোগ্য উপাদান",
  T_49_META_TYPE_198_D: "আইটেম বেস",
  T_49_META_TYPE_199_D: "বিমান যুদ্ধের জন্য সহায়ক সরঞ্জাম, তবে আপনাকে সর্বদা শক্তি ব্যবহারের দিকে মনোযোগ দিতে হবে",
  T_49_META_TYPE_2_D: "বুলিয়ান টাইপ, যা সত্য, মিথ্যা, অথবা হ্যাঁ বা না বোঝাতে ব্যবহৃত হয়।",
  T_49_META_TYPE_20_D: "অন্তর্নির্মিত ইন্টারফেস টাইপ গণনা, যা টাইপ সিস্টেমের উপর ভিত্তি করে স্বয়ংক্রিয়ভাবে তৈরি হয়",
  T_49_META_TYPE_200_D: "জেলব্রেক এলাকা",
  T_49_META_TYPE_201_D: "যেসব জায়গায় প্রবেশের পর আপনি সাঁতার কাটতে পারবেন",
  T_49_META_TYPE_202_D: "কলাইডার আইডি",
  T_49_META_TYPE_203_D: "ইন্টারপোলেশন মোশন",
  T_49_META_TYPE_204_D: "জুতাগুলিতে একটি প্রযুক্তিগত পাওয়ার ডিভাইস রয়েছে যা আপনাকে বাতাসে দ্বিগুণ লাফ দিতে দেয়",
  T_49_META_TYPE_205_D: "একটি হ্যাং গ্লাইডার যা আকাশে উড়তে পারে। এটি উচ্চ উচ্চতা থেকে অবতরণ করতে এবং আরও দূরে যেতে ব্যবহার করা যেতে পারে।",
  T_49_META_TYPE_206_D: "স্কেটবোর্ড",
  T_49_META_TYPE_207_D: "জিপলাইন",
  T_49_META_TYPE_208_D: "খেলার যোগ্যদের তালিকা",
  T_49_META_TYPE_209_D: "খেলার যোগ্য অথবা খেলার যোগ্যদের তালিকা",
  T_49_META_TYPE_21_D: "অন্তর্নির্মিত ইন্টারফেস সত্তা, নির্দিষ্ট ফাংশনের ইন্টারফেসকে ধারণ করে",
  T_49_META_TYPE_210_D: "ব্যালিস্টিক অ্যানিমেশন হলো ব্যালিস্টিক গতির একটি অনুকরণ।",
  T_49_META_TYPE_211_D: "ফিল্টার প্রকার",
  T_49_META_TYPE_212_D: "একটি বস্তু অন্য বস্তুর পরে আসে",
  T_49_META_TYPE_213_D: "একটি বস্তুর সামনের অংশ সর্বদা অন্য বস্তুর দিকে মুখ করে থাকে",
  T_49_META_TYPE_214_D: "অ্যাটলাস স্প্রাইট সম্পদ বর্ণনা করতে ব্যবহৃত আইডি",
  T_49_META_TYPE_215_D: "ম্যাচের ফলাফল",
  T_49_META_TYPE_216_D: "অভিধানের ডেটা ধারক, ডেটা উপাদান হল একজোড়া কী, মান",
  T_49_META_TYPE_217_D: "অভিধান ডেটা টেমপ্লেট, বিষয়বস্তুর ধরণ T1 এবং T2 দ্বারা নির্দিষ্ট করা যেতে পারে",
  T_49_META_TYPE_218_D: "এক ধরণের আলোক উৎস যা তার অবস্থান থেকে সকল দিকে সমান তীব্রতার আলো নির্গত করে।",
  T_49_META_TYPE_219_D: "মোটরসাইকেল যানবাহন",
  T_49_META_TYPE_22_D: "কাস্টম ইন্টারফেস, ইন্টারফেস এডিটরের মাধ্যমে প্লেয়ার দ্বারা তৈরি ইন্টারফেস",
  T_49_META_TYPE_220_D: "টুক-টুক (তিন চাকার) যানবাহন",
  T_49_META_TYPE_221_D: "উভচর/মেশিনগান মোটরসাইকেল যান",
  T_49_META_TYPE_222_D: "চার চাকার যানবাহন",
  T_49_META_TYPE_224_D: "স্কিল টাইপ লিস্ট",
  T_49_META_TYPE_225_D: "উচ্চ প্রযুক্তির উপকরণ দিয়ে তৈরি কৃত্রিম বুদ্ধিমত্তার এই বুরুজটি একটি নির্দিষ্ট পরিসরের মধ্যে সক্রিয়ভাবে শত্রুদের অনুসন্ধান এবং আক্রমণ করবে।",
  T_49_META_TYPE_226_D: "টারেট প্রপ ব্যবহারের পর তৈরি টারেট",
  T_49_META_TYPE_227_D: "কাস্টম UI নিয়ন্ত্রণের ধরণ গণনা",
  T_49_META_TYPE_23_D: "লেভেল অবজেক্ট টাইপ গণনা, যা টাইপ সিস্টেমের উপর ভিত্তি করে স্বয়ংক্রিয়ভাবে তৈরি হবে",
  T_49_META_TYPE_231_D: "মেরামতের কিট",
  T_49_META_TYPE_233_D: "প্রোগ্রেস বৃত্ত",
  T_49_META_TYPE_234_D: "তৈরি করা মাইন",
  T_49_META_TYPE_235_D: "গ্লু ওয়াল",
  T_49_META_TYPE_236_D: "তৈরি করা বরফের প্রাচীর",
  T_49_META_TYPE_237_D: "হুক গান",
  T_49_META_TYPE_238_D: "রেইনবো স্প্রে বন্দুক",
  T_49_META_TYPE_239_D: "স্প্রে রাইফেল",
  T_49_META_TYPE_24_D: "সিস্টেম দ্বারা বর্তমানে সংজ্ঞায়িত ক্ষতির ধরণ",
  T_49_META_TYPE_240_D: "সত্তা হল সকল উপাদানের বাহক। ইনস্ট্যান্স তৈরি করতে উপাদানগুলিকে সত্তার সাথে সংযুক্ত করতে হবে।",
  T_49_META_TYPE_241_D: "শক্তিশালী হুক বন্দুক",
  T_49_META_TYPE_242_D: "স্কোর বার",
  T_49_META_TYPE_243_D: "পোশাকের স্লট",
  T_49_META_TYPE_244_D: "একটি টেক্সট এন্টিটি একটি প্রদর্শিত টেক্সটকে প্রতিনিধিত্ব করে।",
  T_49_META_TYPE_245_D: "আইকন সত্তাটি একটি প্রদর্শিত আইকনকে প্রতিনিধিত্ব করে",
  T_49_META_TYPE_246_D: "স্প্রে রঙ",
  T_49_META_TYPE_247_D: "প্লেয়ার UI টাইপ",
  T_49_META_TYPE_248_D: "জেনেরিক UI সুইচ সত্তা",
  T_49_META_TYPE_249_D: "স্যুইচিং সরঞ্জাম স্লট",
  T_49_META_TYPE_25_D: "খেলা প্রক্রিয়ার পর্যায়গুলি, যেমন খেলা শুরু, খেলার প্রস্তুতি, খেলার সমাপ্তি ইত্যাদি।",
  T_49_META_TYPE_250_D: "প্রভাব সত্তা একটি প্রদর্শিত প্রভাব প্রতিনিধিত্ব করে",
  T_49_META_TYPE_2500_D: "খেলোয়াড়ের স্পন পয়েন্ট",
  T_49_META_TYPE_2501_D: "খেলোয়াড়দের (অথবা অন্যান্য বস্তুর) প্রবেশ এবং প্রস্থান ইভেন্টগুলিকে ট্রিগার করতে ট্রিগার ব্যবহার করা হয়।",
  T_49_META_TYPE_2502_D: "মৃত্যু বা অজেয়তা ট্রিগার, যখন খেলোয়াড় প্রবেশ করে, তখন এটি বৈশিষ্ট্য অনুসারে মৃত্যু বা অজেয়তা প্রভাব কিনা তা নিয়ন্ত্রণ করে।",
  T_49_META_TYPE_2503_D: "রেস মোড চেকপয়েন্ট",
  T_49_META_TYPE_2504_D: "সাধারণত রেসিং মোডে নির্ধারিত ফিনিশ লাইনে প্রবেশকারী খেলোয়াড়কে শনাক্ত করার জন্য ব্যবহৃত হয়। এটি একটি নির্দিষ্ট ট্রিগার। কাস্টম ট্রিগারগুলি পরে খোলা হবে। এই এন্ডপয়েন্টটি কাস্টম ট্রিগারের একটি মোড়ক মাত্র।",
  T_49_META_TYPE_2505_D: "স্পন পয়েন্টের চারপাশের বেড়া, এটি বন্ধ করার পরে, আপনি স্পন পয়েন্টটি ছেড়ে যেতে পারেন",
  T_49_META_TYPE_2507_D: "টারেট",
  T_49_META_TYPE_2508_D: "মনস্টার স্পন",
  T_49_META_TYPE_2509_D: "চাহিদা অনুযায়ী সংশ্লিষ্ট ধরণের উদাহরণ তৈরি করা যেতে পারে",
  T_49_META_TYPE_251_D: "এফেক্ট কনটেইনার",
  T_49_META_TYPE_2510_D: "খেলোয়াড়ের স্পন এরিয়া (আয়তক্ষেত্র)",
  T_49_META_TYPE_252_D: "স্প্রে ফলাফলের UI",
  T_49_META_TYPE_253_D: "টিপ বোতাম",
  T_49_META_TYPE_254_D: "হার্টবিট এফেক্ট",
  T_49_META_TYPE_255_D: "টাইমস্ট্যাম্প লোকালাইজেশন স্ট্রিং",
  T_49_META_TYPE_256_D: "রিজিডবডি টাইপ",
  T_49_META_TYPE_257_D: "রিজিডবডি কম্পোনেন্ট",
  T_49_META_TYPE_258_D: "টাইমস্ট্যাম্প ফরম্যাট স্টাইল টাইপ",
  T_49_META_TYPE_259_D: "পরামর্শ",
  T_49_META_TYPE_26_D: "খেলার একটি রাউন্ড সাধারণত একটি ছোট রাউন্ড, যা বেশ কয়েকটি ধাপ নিয়ে গঠিত।",
  T_49_META_TYPE_260_D: "প্রোগ্রেস স্কিল বোতাম",
  T_49_META_TYPE_261_D: "অনন্য আইডি",
  T_49_META_TYPE_262_D: "ওয়েপন স্কিন আইডি",
  T_49_META_TYPE_263_D: "পোশাকের আইডি",
  T_49_META_TYPE_264_D: "আইটেম আইডি, যখন সংস্করণে শুধুমাত্র অস্ত্র আইডি থাকে",
  T_49_META_TYPE_265_D: "UI প্যানেল সত্তা",
  T_49_META_TYPE_267_D: "UI স্ক্রল ভিউ এন্টিটি, প্লেয়ার UI এডিটরের মাধ্যমে যে UI সম্পাদনা করে",
  T_49_META_TYPE_268_D: "তিনটি অবস্থা সহ একটি সুইচ, চালু এবং বন্ধ করার পাশাপাশি, আপনি মূল যুক্তিটি রাখতে বেছে নিতে পারেন",
  T_49_META_TYPE_269_D: "খেলোয়াড়দের সরঞ্জাম",
  T_49_META_TYPE_270_D: "এনটিটি অথবা প্রিফেব আইডি",
  T_49_META_TYPE_271_D: "UI প্যানেল সত্তা, প্লেয়ার UI এডিটরের মাধ্যমে যে UI সম্পাদনা করে",
  T_49_META_TYPE_272_D: "লিঙ্গ গণনা",
  T_49_META_TYPE_273_D: "মিনি-ম্যাপ",
  T_49_META_TYPE_274_D: "মিনি-ম্যাপে প্রদর্শিত আইকনটি লক্ষ্যবস্তু অনুসরণ করতে পারে",
  T_49_META_TYPE_275_D: "একটি কঙ্কালের নোডের পৃথক অংশ",
  T_49_META_TYPE_276_D: "ত্বকের হাড় অ্যাক্সেস করতে ব্যবহৃত নোড",
  T_49_META_TYPE_277_D: "ক্লায়েন্ট-সাইড ক্যামেরা রশ্মি সনাক্তকরণ",
  T_49_META_TYPE_278_D: "ছোট মানচিত্রে প্রদর্শিত পিক্সেল ব্লকটি সেই স্থানে বস্তুর সংঘর্ষের আকারকে প্রতিনিধিত্ব করে।",
  T_49_META_TYPE_279_D: "রঙিন ড্রাম",
  T_49_META_TYPE_28_D: "প্রতিটি রাউন্ডের শুরুতে, স্থিতি পুনরায় সেট করা হবে",
  T_49_META_TYPE_280_D: "গোলক ট্রিগার",
  T_49_META_TYPE_281_D: "ক্যাপসুল ট্রিগার",
  T_49_META_TYPE_282_D: "প্যারেন্ট প্যাকেজের সাথে আসা অ্যাসেট কনফিগারেশন আইডি নির্দেশ করতে ব্যবহৃত অ্যাসেট কনফিগারেশন আইডির ধরণ বর্ণনা করে, যা লোড করার আগে কনফিগারেশন টেবিলের মাধ্যমে পার্স করা প্রয়োজন।",
  T_49_META_TYPE_283_D: "সম্পদ শনাক্তকারী প্রতিনিধিত্ব করতে ব্যবহৃত সম্পদের ধরণ বর্ণনা করে এবং সরাসরি লোড করা যেতে পারে",
  T_49_META_TYPE_284_D: "একটি হিউম্যানয়েড মডেল রিসোর্স প্রতিনিধিত্ব করে যা একটি খেলোয়াড় চরিত্র দিয়ে প্রতিস্থাপন করা যেতে পারে",
  T_49_META_TYPE_285_D: "তালিকা বা অভিধান, লুপ করা যেতে পারে",
  T_49_META_TYPE_286_D: "স্ক্রিপ্ট সম্পদ বর্ণনা করে এমন একটি আইডি।",
  T_49_META_TYPE_287_D: "একটি স্ট্যাটিক স্ক্রিপ্ট সম্পদ বর্ণনা করে এমন একটি আইডি।",
  T_49_META_TYPE_288_D: "একটি আইডি যা একটি কাস্টম UI সম্পদ বর্ণনা করে।",
  T_49_META_TYPE_289_D: "প্রিসেট অ্যাসেট বর্ণনা করতে ব্যবহৃত আইডি",
  T_49_META_TYPE_29_D: "বিশেষ প্রভাব",
  T_49_META_TYPE_290_D: "আচরণ গাছ",
  T_49_META_TYPE_291_D: "বিহেভিয়ার ট্রি নোড টাইপ",
  T_49_META_TYPE_292_D: "বিহেভিয়ার ট্রি কাস্টম নোড",
  T_49_META_TYPE_293_D: "বিহেভিয়ার ট্রি সংযুক্ত করা যাবে",
  T_49_META_TYPE_294_D: "UI লেআউট সত্তা, UI যা প্লেয়াররা UI এডিটরের মাধ্যমে সম্পাদনা করে",
  T_49_META_TYPE_295_D: "অপেক্ষা সময় (s)",
  T_49_META_TYPE_296_D: "অ্যানিমেশন ক্লিপ",
  T_49_META_TYPE_297_D: "অ্যানিমেশন কন্ট্রোলার",
  T_49_META_TYPE_298_D: "ক্ষতি",
  T_49_META_TYPE_3_D: "পূর্ণসংখ্যার ধরণ, ৩২-বিট স্বাক্ষরিত পূর্ণসংখ্যা",
  T_49_META_TYPE_30_D: "আইকন",
  T_49_META_TYPE_300_D: "UI3DContainer সত্তা, UI যা প্লেয়াররা UI এডিটরের মাধ্যমে সম্পাদনা করে",
  T_49_META_TYPE_301_D: "এআই দক্ষতা প্রকার",
  T_49_META_TYPE_302_D: "সরঞ্জাম স্লট গণনা",
  T_49_META_TYPE_303_D: "BuffData.csv-এর আইডি কলামের সাথে সামঞ্জস্য রেখে, নতুন আইটেম যোগ করার আগে দয়া করে GPP-এর সাথে নিশ্চিত করুন যে এটি প্রযোজ্য কিনা।",
  T_49_META_TYPE_304_D: "বাফ টাইপ লিস্ট",
  T_49_META_TYPE_305_D: "বিহেভিয়ার ট্রি নোড স্ট্যাটাস",
  T_49_META_TYPE_306_D: "আপনি বাফ যোগ করতে পারেন, বাফ অপসারণ করতে পারেন এবং যোগ করা বাফের একটি তালিকা পেতে পারেন।",
  T_49_META_TYPE_307_D: "আইস ওয়াল মেকার",
  T_49_META_TYPE_308_D: "বিশেষ আইটেম আইডি টাইপ",
  T_49_META_TYPE_309_D: "প্রপস নিক্ষেপ",
  T_49_META_TYPE_31_D: "শব্দ",
  T_49_META_TYPE_310_D: "ক্রসবো",
  T_49_META_TYPE_311_D: "গ্রেনেড বেস",
  T_49_META_TYPE_312_D: "প্রপস নিক্ষেপ",
  T_49_META_TYPE_313_D: "আইস ওয়াল ডি-গ্রেনেড",
  T_49_META_TYPE_314_D: "অ্যানিমেশন কন্ট্রোলার এবং রিসোর্স পরিচালনা করা",
  T_49_META_TYPE_315_D: "প্লেয়ার ব্যাকপ্যাক",
  T_49_META_TYPE_316_D: "UITexture সত্তা, UI এডিটরের মাধ্যমে প্লেয়ার দ্বারা সম্পাদিত UI",
  T_49_META_TYPE_317_D: "অনমনীয় শরীরের গতির সীমাবদ্ধতা, প্রতিটি সীমাবদ্ধতা একসাথে ব্যবহার করা যেতে পারে",
  T_49_META_TYPE_318_D: "সংযোজন",
  T_49_META_TYPE_319_D: "পূরণের ধরণ গণনা",
  T_49_META_TYPE_32_D: "খেলোয়াড়ের স্থিতির ধরণ",
  T_49_META_TYPE_320_D: "দিকনির্দেশনা পূরণ করুন",
  T_49_META_TYPE_321_D: "যেসব সত্তাকে লক্ষ্যবস্তু করা যেতে পারে",
  T_49_META_TYPE_322_D: "ক্ষতিগ্রস্ত শরীরের অংশের প্রকার",
  T_49_META_TYPE_323_D: "UIProfileInfo সত্তা, UI যা প্লেয়াররা UI এডিটরের মাধ্যমে সম্পাদনা করে",
  T_49_META_TYPE_324_D: "অনমনীয় বস্তুর উপর বলের বিভিন্ন প্রভাব। মনে রাখবেন যে এটি শুধুমাত্র গতিশীল অনমনীয় বস্তুর জন্য বৈধ।",
  T_49_META_TYPE_325_D: "কাস্টম ইন্টারফেস অ্যাসেটে নিয়ন্ত্রণ বর্ণনা করতে ব্যবহৃত আইডি",
  T_49_META_TYPE_326_D: "খেলোয়াড়ের প্রোফাইল তথ্য",
  T_49_META_TYPE_327_D: "প্রতিটি উপাদানের কনফিগারেশন অনুসারে প্রতিস্থাপন",
  T_49_META_TYPE_328_D: "বিহেভিয়ার ট্রি আইডি",
  T_49_META_TYPE_329_D: "সিট টাইপ",
  T_49_META_TYPE_33_D: "সাজান: আরোহী শূন্য মান উপেক্ষা করুন, অবরোহী, আরোহী",
  T_49_META_TYPE_330_D: "নিজের সাপেক্ষে নড়াচড়া",
  T_49_META_TYPE_331_D: "বেজিয়ার কার্ভ",
  T_49_META_TYPE_332_D: "পুনর্ব্যবহারযোগ্য উপাদান",
  T_49_META_TYPE_333_D: "ফন্ট প্রকার",
  T_49_META_TYPE_334_D: "ভেহিক্যাল স্কিন আইডি",
  T_49_META_TYPE_335_D: "শব্দ প্রভাব সত্তাটি বাজানো একটি শব্দ প্রভাবকে প্রতিনিধিত্ব করে।",
  T_49_META_TYPE_336_D: "শব্দ প্রভাবের তালিকা",
  T_49_META_TYPE_337_D: "শব্দ প্রভাব বা শব্দ প্রভাবের তালিকা",
  T_49_META_TYPE_338_D: "প্লেয়ার আচরণ বৈশিষ্ট্য সিঙ্ক্রোনাইজেশন সত্তা",
  T_49_META_TYPE_339_D: "যন্ত্রপাতি আনুষাঙ্গিক",
  T_49_META_TYPE_34_D: "আইটেম আইডি",
  T_49_META_TYPE_340_D: "বটের কঠিনতা প্রকার",
  T_49_META_TYPE_341_D: "পূর্ণসংখ্যা অভিধান",
  T_49_META_TYPE_342_D: "টাইমার অবজেক্ট",
  T_49_META_TYPE_343_D: "ছুরি ছুঁড়ে মারা (পিকআপ)",
  T_49_META_TYPE_344_D: "থ্রোয়িং নাইফ",
  T_49_META_TYPE_345_D: "অস্ত্রের প্রকার",
  T_49_META_TYPE_346_D: "গোলাবারুদ টাইপ",
  T_49_META_TYPE_347_D: "ফ্রেম স্ব-সম্পর্কিত",
  T_49_META_TYPE_348_D: "ফাংশন পয়েন্টারটি একটি ভার্চুয়াল ফাংশন বা ডেলিগেশন মেকানিজম বাস্তবায়নের জন্য একটি ফাংশন ইনস্ট্যান্সকে নির্দেশ করে।",
  T_49_META_TYPE_349_D: "একটি কোরোটিনের হাতলকে বোঝায় এবং কিছু হাতল অপারেশন সম্পাদন করতে পারে",
  T_49_META_TYPE_350_D: "যানবাহন গণনা",
  T_49_META_TYPE_351_D: "বস্তুর ধরণ বর্ণনা করে",
  T_49_META_TYPE_352_D: "UITtoggle সত্তা, UI যা প্লেয়ার UI এডিটরের মাধ্যমে সম্পাদনা করে",
  T_49_META_TYPE_353_D: "মেডকিট",
  T_49_META_TYPE_354_D: "ইনহেলার",
  T_49_META_TYPE_355_D: "অনুভূমিক লাইন",
  T_49_META_TYPE_356_D: "প্রস্তুতির সময় শেষ হওয়ার পর, এয়ারড্রপটি উঁচু জায়গা থেকে পড়তে শুরু করবে।",
  T_49_META_TYPE_357_D: "সীমানা, পৃষ্ঠ ইত্যাদির মতো বস্তুর বর্ণনামূলক রঙ (মুছে ফেলা, পুনর্ব্যবহারযোগ্য)",
  T_49_META_TYPE_358_D: "একটি ইভেন্টের কথা উল্লেখ করে",
  T_49_META_TYPE_359_D: "পদার্থবিদ্যার প্রভাব সহ প্লেয়ার কন্ট্রোলার, বল প্রয়োগ করতে এবং বল গ্রহণ করতে পারে",
  T_49_META_TYPE_360_D: "লঞ্চ প্যাড",
  T_49_META_TYPE_361_D: "ভাঁজ করা কামানটি খোলা অবস্থায় মানুষকে ছোঁড়ার জন্য ব্যবহার করা যেতে পারে। নিরাপদ অঞ্চল থেকে নিজেকে বের করে না দেওয়ার ব্যাপারে সতর্ক থাকুন!",
  T_49_META_TYPE_362_D: "তুষারগোলকের লড়াই! চার্জ!",
  T_49_META_TYPE_363_D: "দোকান থেকে ক্রয়ের অনুরোধ",
  T_49_META_TYPE_364_D: "অ্যানিমেশন ট্রিগার",
  T_49_META_TYPE_365_D: "অ্যানিমেশন ট্রিগার ইন্টারফেস উপাদান",
  T_49_META_TYPE_366_D: "ব্যাচ কম্বাইন রেন্ডার",
  T_49_META_TYPE_367_D: "শীর্ষ কম্পাস",
  T_49_META_TYPE_368_D: "কাস্টম রোল রিসোর্স আইডি",
  T_49_META_TYPE_369_D: "কাস্টম অ্যানিমেশন রিসোর্স আইডি",
  T_49_META_TYPE_370_D: "রাউন্ডের শুরুতে প্রদর্শিত তথ্য",
  T_49_META_TYPE_371_D: "প্রতিটি রাউন্ডের শেষে, ফলাফলগুলি প্রদর্শন করুন",
  T_49_META_TYPE_372_D: "খেলোয়াড়ের অবস্থানের ধরণ",
  T_49_META_TYPE_373_D: "সংগ্রহ আইডি, সম্পদ তথ্য সংগ্রহের জন্য ব্যবহৃত",
  T_49_META_TYPE_374_D: "ফলো হেলথ বার",
  T_49_META_TYPE_375_D: "দানব আক্রমণ লক্ষ্য ধরণের গণনা",
  T_49_META_TYPE_376_D: "প্রতিরক্ষা টাওয়ার আক্রমণ লক্ষ্যবস্তুর ধরণ গণনা",
  T_49_META_TYPE_377_D: "প্লেয়ার সত্তা এবং যানবাহন সত্তার ধরণের জন্য উপনাম",
  T_49_META_TYPE_378_D: "অডিও অ্যাসেটের বর্ণনা দেওয়া একটি আইডি।",
  T_49_META_TYPE_379_D: "কনফিগারেশন টেবিল অ্যাসেট বর্ণনা করতে ব্যবহৃত আইডি",
  T_49_META_TYPE_38_D: "UI খালি উইজেট সত্তা, UI এডিটরের মাধ্যমে প্লেয়ার দ্বারা সম্পাদিত UI",
  T_49_META_TYPE_380_D: "স্পেশাল এফেক্ট অ্যাসেট বর্ণনা করে এমন একটি আইডি।",
  T_49_META_TYPE_381_D: "অ্যানিমেশন কন্ট্রোলার অ্যাসেট বর্ণনা করে এমন একটি আইডি।",
  T_49_META_TYPE_382_D: "নকডাউন স্ট্যাটাস হ্যান্ডলিং পদ্ধতি",
  T_49_META_TYPE_383_D: "মানচিত্রের পৃষ্ঠ বা সাজসজ্জা",
  T_49_META_TYPE_384_D: "আইটেম",
  T_49_META_TYPE_385_D: "চরিত্র দক্ষতা আইডি",
  T_49_META_TYPE_386_D: "স্কিল আইডি লিস্ট",
  T_49_META_TYPE_387_D: "UITouchPad সত্তা, UI যা প্লেয়ার UI এডিটরের মাধ্যমে সম্পাদনা করে",
  T_49_META_TYPE_388_D: "ব্যাকপ্যাক স্কিন আইডি",
  T_49_META_TYPE_389_D: "জয়স্টিক সত্তা, UI এডিটরের মাধ্যমে প্লেয়ার দ্বারা সম্পাদিত UI",
  T_49_META_TYPE_39_D: "UI ছবির সত্তা, UI সম্পাদকের মাধ্যমে প্লেয়ার দ্বারা সম্পাদিত UI",
  T_49_META_TYPE_390_D: "শ্রেণীবদ্ধ",
  T_49_META_TYPE_391_D: "কাস্টম UI বা উইজেট",
  T_49_META_TYPE_392_D: "বিষ বৃত্তের বস্তু যা স্থাপন করা যেতে পারে",
  T_49_META_TYPE_393_D: "PhysicalCCT বা Rigidbody উপাদান সহ সত্তা",
  T_49_META_TYPE_394_D: "গাণিতিক ধ্রুবক",
  T_49_META_TYPE_395_D: "PhysicalCCT বা PlayerCCT উপাদানযুক্ত সত্তাগুলি তাদের সাথে চলাচল করতে পারে",
  T_49_META_TYPE_396_D: "মাঝারি খেলোয়াড়ের কনফিগারেশন",
  T_49_META_TYPE_397_D: "সংঘর্ষের আকৃতি বর্ণনা করতে ব্যবহৃত উপাদান",
  T_49_META_TYPE_398_D: "স্ট্রিং বা লোকালাইজড স্ট্রিং",
  T_49_META_TYPE_399_D: "শুধুমাত্র FF অক্ষরের জন্য, শারীরিক প্রভাব সহ চরিত্র নিয়ন্ত্রক",
  T_49_META_TYPE_4_D: "ফ্লোটিং পয়েন্ট টাইপ, 32-বিট একক-নির্ভুল ফ্লোটিং পয়েন্ট নম্বর",
  T_49_META_TYPE_40_D: "UI টেক্সট এন্টিটি, UI এডিটরের মাধ্যমে প্লেয়ার দ্বারা সম্পাদিত UI",
  T_49_META_TYPE_400_D: "আক্রমণাত্মক আচরণে কীভাবে জড়িত হবেন",
  T_49_META_TYPE_401_D: "আগুনের ধরন",
  T_49_META_TYPE_402_D: "সামাজিক বোতাম উইজেট",
  T_49_META_TYPE_403_D: "সোশ্যাল বোতামের ধরণ",
  T_49_META_TYPE_404_D: "সোশ্যাল বোতাম স্টাইল",
  T_49_META_TYPE_405_D: "লেআউট সাজানোর প্রকার",
  T_49_META_TYPE_406_D: "বাধা অতিক্রম করে ট্রিগার করতে পারে",
  T_49_META_TYPE_407_D: "প্ল্যাটফর্ম প্রকার",
  T_49_META_TYPE_408_D: "বেস ডেটা উপনাম",
  T_49_META_TYPE_409_D: "ত্রুটি কোড গণনা",
  T_49_META_TYPE_41_D: "UI বোতাম সত্তা, UI এডিটরের মাধ্যমে প্লেয়ার যে UI সম্পাদনা করে",
  T_49_META_TYPE_410_D: "প্লেয়ার এন্টিটি বা ট্রান্সফর্ম এন্টিটি টাইপের জন্য উপনাম।",
  T_49_META_TYPE_411_D: "হেলিকপ্টার যানবাহন",
  T_49_META_TYPE_412_D: "গাড়ির উপাদান হল গাড়ির উপাদানের কার্যকরী প্রসারণ",
  T_49_META_TYPE_413_D: "NPC",
  T_49_META_TYPE_414_D: "ক্যামেরার ঘূর্ণন কোণ সীমিত করুন",
  T_49_META_TYPE_415_D: "পারসোনা",
  T_49_META_TYPE_416_D: "পারসোনা চ্যাট উইন্ডো ইন্টারফেস",
  T_49_META_TYPE_417_D: "কণা সত্তা উপাদান",
  T_49_META_TYPE_418_D: "সদস্যের অবস্থা গণনা",
  T_49_META_TYPE_419_D: "বন্দুকের ত্বকের ধরণ",
  T_49_META_TYPE_42_D: "UI ইনপুট সত্তা, প্লেয়ার UI এডিটরের মাধ্যমে যে UI সম্পাদনা করে",
  T_49_META_TYPE_420_D: "যানবাহনের ত্বকের ধরণ",
  T_49_META_TYPE_421_D: "ত্বকের ধরণ",
  T_49_META_TYPE_422_D: "ব্যাকপ্যাকের ত্বকের ধরণ",
  T_49_META_TYPE_423_D: "পারসোনা আইডি",
  T_49_META_TYPE_424_D: "কুয়াশার প্রভাবের মৌলিক ধরণ",
  T_49_META_TYPE_425_D: "পার্টিকেল অ্যাসেট আইডি",
  T_49_META_TYPE_426_D: "এক ধরণের আলোক উৎস যা আলোক উৎস থেকে আলোক উৎসের ঋণাত্মক Y অক্ষে শঙ্কুযুক্ত আলো নির্গত করে, যা পূর্বনির্ধারিতভাবে ভূমিকে আলোকিত করে।",
  T_49_META_TYPE_427_D: "NPC",
  T_49_META_TYPE_428_D: "অন্য চরিত্রে রূপান্তরিত হওয়ার সময় খেলোয়াড়কে যে পোশাকের তথ্য রাখতে হবে",
  T_49_META_TYPE_429_D: "খেলোয়াড় বা NPC সত্তা",
  T_49_META_TYPE_43_D: "এলিমেন্টের ধরণটি অবশ্যই প্লেয়ার এন্টিটির একটি তালিকা হতে হবে",
  T_49_META_TYPE_430_D: "র্যান্ডম নম্বর জেনারেটর",
  T_49_META_TYPE_431_D: "চলমান বস্তুটি একটি কাস্টম পথ ধরে চলে",
  T_49_META_TYPE_432_D: "কার্ভ পাথ ওয়েপয়েন্ট কাস্টমাইজ করুন",
  T_49_META_TYPE_433_D: "কার্ভ পাথ ওয়েপয়েন্ট টাইপ কাস্টমাইজ করুন",
  T_49_META_TYPE_434_D: "কাস্টম বক্ররেখা পথ",
  T_49_META_TYPE_435_D: "খেলোয়াড়ের অনন্য শনাক্তকারী তালিকা",
  T_49_META_TYPE_436_D: "ত্রুটি কোড তালিকা",
  T_49_META_TYPE_437_D: "উভয় দলের জন্য UI সত্তার বিশদ বিবরণ মিলান। সত্তার বৈশিষ্ট্যগুলি পরিবর্তন করলে সংশ্লিষ্ট UI-তে প্রদর্শনের বিষয়বস্তু প্রভাবিত হবে।",
  T_49_META_TYPE_438_D: "একাধিক দলের মিলের বিবরণ UI সত্তা, সত্তার বৈশিষ্ট্যগুলি পরিবর্তন করলে সংশ্লিষ্ট UI-তে প্রদর্শনের বিষয়বস্তু প্রভাবিত হবে",
  T_49_META_TYPE_439_D: "ধারণক্ষমতা",
  T_49_META_TYPE_44_D: "এলিমেন্টের ধরণটি অবশ্যই টিম এন্টিটির একটি তালিকা হতে হবে",
  T_49_META_TYPE_440_D: "সময়রেখা",
  T_49_META_TYPE_441_D: "টাইমলাইন রিসোর্স আইডি",
  T_49_META_TYPE_442_D: "দুই দলের ম্যাচের তথ্যের জন্য নতুন সরলীকৃত সত্তা উপাদান, সম্পূর্ণ কাস্টমাইজড নম্বর প্রদর্শন সমর্থন করে",
  T_49_META_TYPE_443_D: "ডায়ালগ ফ্লো অ্যাসেট আইডি",
  T_49_META_TYPE_444_D: "ভাষার ধরণ",
  T_49_META_TYPE_45_D: "বুল লিস্ট",
  T_49_META_TYPE_46_D: "ইন্ট লিস্ট",
  T_49_META_TYPE_47_D: "ফ্লোট লিস্ট",
  T_49_META_TYPE_48_D: "স্ট্রিন লিস্ট",
  T_49_META_TYPE_49_D: "ভেক্টর3 লিস্ট",
  T_49_META_TYPE_5_D: "স্ট্রিং টাইপ, মান হল টেক্সট কন্টেন্ট",
  T_49_META_TYPE_50_D: "এলিমেন্টের ধরণটি অবশ্যই সত্তার একটি তালিকা হতে হবে",
  T_49_META_TYPE_51_D: "জম্বি টাইপ",
  T_49_META_TYPE_53_D: "সাধারণ স্তরের বস্তু",
  T_49_META_TYPE_54_D: "ধ্বংসযোগ্য বস্তু",
  T_49_META_TYPE_55_D: "সাধারণ স্পাউন পয়েন্ট",
  T_49_META_TYPE_56_D: "যানবাহন",
  T_49_META_TYPE_57_D: "খেলোয়াড়দের প্রবেশের সময় একটি নির্দিষ্ট স্থানে টেলিপোর্ট করা যেতে পারে",
  T_49_META_TYPE_58_D: "চাহিদা অনুযায়ী বাফ তৈরি করা যেতে পারে",
  T_49_META_TYPE_59_D: "মুভ প্ল্যাটফর্ম",
  T_49_META_TYPE_6_D: "ত্রিমাত্রিক ভেক্টর, যা স্থানিক স্থানাঙ্ক বা স্থানিক দিক নির্দেশ করতে পারে",
  T_49_META_TYPE_60_D: "নির্বাচিত ধরণের অস্ত্র পড়ে যাবে",
  T_49_META_TYPE_61_D: "ট্রিগার রেঞ্জে প্রবেশ করলে বাউন্ড স্টোরটি খুলবে",
  T_49_META_TYPE_62_D: "চমৎকার বাউন্স সহ পাশা",
  T_49_META_TYPE_63_D: "খেলোয়াড়রা যখন এতে পা রাখবে তখন তাদের নির্ধারিত স্থানে নিয়ে যাওয়া হবে।",
  T_49_META_TYPE_64_D: "যখন প্লেয়ার এটিতে পা রাখবে, তখন এটি একটি শব্দ করবে",
  T_49_META_TYPE_65_D: "মৌলিক স্কেলযোগ্য",
  T_49_META_TYPE_66_D: "কাস্টম পাথ",
  T_49_META_TYPE_67_D: "পথের পয়েন্ট",
  T_49_META_TYPE_68_D: "জম্বিদের মতো AI দানব সত্তা",
  T_49_META_TYPE_69_D: "বৃহৎ সংখ্যা হলো উচ্চ-নির্ভুল ভাসমান বিন্দু সংখ্যা",
  T_49_META_TYPE_7_D: "সংখ্যা হল পূর্ণসংখ্যা, ৬৪-বিট পূর্ণসংখ্যা, অথবা ভাসমান বিন্দু প্রকারের জন্য একটি প্রকার উপনাম।",
  T_49_META_TYPE_70_D: "সত্তা বৈশিষ্ট্যের মান গণনা করার জন্য অ্যাট্রিবিউট সূত্র ব্যবহার করা হয়। বর্তমানে শুধুমাত্র কিছু খেলোয়াড় বৈশিষ্ট্য এবং অস্ত্র বৈশিষ্ট্য সমর্থিত।",
  T_49_META_TYPE_71_D: "শুধুমাত্র দোকানে বিক্রি হওয়া সত্তার জন্য ব্যবহৃত হয়। পণ্য ক্রয় করে প্রাপ্ত আইটেমের ধারণা থেকে পণ্য ভিন্ন।",
  T_49_META_TYPE_72_D: "বেশ কয়েকটি পণ্য রয়েছে",
  T_49_META_TYPE_73_D: "বেশ কয়েকটি তাক রয়েছে",
  T_49_META_TYPE_74_D: "আইটেম আইডি",
  T_49_META_TYPE_75_D: "ফিরে আসুন",
  T_49_META_TYPE_76_D: "প্যাট্রোল স্টাইল",
  T_49_META_TYPE_77_D: "একটি জেনারেটর সত্তা যা বস্তু তৈরি এবং রিফ্রেশ করতে পারে",
  T_49_META_TYPE_78_D: "একটি ইউনিট সত্তা যা ইউনিট জেনারেটর দ্বারা শোষিত হতে পারে এবং ব্যাচে জন্মাতে পারে",
  T_49_META_TYPE_79_D: "অস্ত্র",
  T_49_META_TYPE_8_D: "শর্তগুলি বিশেষ বুল ধরণের।",
  T_49_META_TYPE_80_D: "দোকান ইন্টারফেস",
  T_49_META_TYPE_81_D: "বাফ প্রকার",
  T_49_META_TYPE_82_D: "UI হার্টবিট",
  T_49_META_TYPE_83_D: "মিথস্ক্রিয়া বোতাম",
  T_49_META_TYPE_84_D: "র‍্যাঙ্কযোগ্য সত্তা, র‍্যাঙ্ক করা সম্ভব",
  T_49_META_TYPE_85_D: "ইন্টিগ্রেবল সত্তার নিজস্ব ইন্টিগ্রেল থাকে",
  T_49_META_TYPE_86_D: "অ্যাট্রিবিউট সূত্র ফ্যাক্টরের ধরণ",
  T_49_META_TYPE_87_D: "RGBA রঙের ধরণ বর্ণনা করে, প্রতিটি চ্যানেলের মান পরিসীমা 0~255",
  T_49_META_TYPE_88_D: "মুদ্রার ধরণ, বর্তমানে শুধুমাত্র মূল মুদ্রার ধরণ",
  T_49_META_TYPE_89_D: "মুদ্রার ধরণ এবং পরিমাণ বর্ণনা করতে ব্যবহৃত মুদ্রা সত্তা",
  T_49_META_TYPE_9_D: "শর্তের একটি সেট",
  T_49_META_TYPE_90_D: "ওয়ালেট সত্তা হল একগুচ্ছ মুদ্রা সত্তার জন্য একটি ধারক",
  T_49_META_TYPE_91_D: "পূর্ণসংখ্যা বা পূর্ণসংখ্যা অ্যারে টাইপ বোঝায়",
  T_49_META_TYPE_92_D: "গতিশীলভাবে তৈরি করা স্তরের বস্তু প্রকার",
  T_49_META_TYPE_93_D: "সূত্রযোগ্য বৈশিষ্ট্য সহ সত্তা",
  T_49_META_TYPE_94_D: "বৈশিষ্ট্য পরিবর্তন পদ্ধতি",
  T_49_META_TYPE_95_D: "সোনার জেনারেটর",
  T_49_META_TYPE_96_D: "ওয়ালেট",
  T_49_META_TYPE_97_D: "অবস্থান, ঘূর্ণন এবং স্কেলিং, পিতামাতা-সন্তানের কাঠামো সমর্থন করে",
  T_49_META_TYPE_98_D: "সমস্ত উপলব্ধ প্রকারের তালিকা তৈরি করুন",
  T_49_META_TYPE_99_D: "স্তরের বস্তু"
};
export {
  _ as default
};
